/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 465);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(472);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(477)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoControlledComponent__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoControlledComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__childMapping__ = __webpack_require__(593);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__childMapping__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__childMapping__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__childrenUtils__ = __webpack_require__(604);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__childrenUtils__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__ = __webpack_require__(607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_3__classNameBuilders__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__customPropTypes__ = __webpack_require__(608);
/* unused harmony reexport customPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__debug__ = __webpack_require__(688);
/* unused harmony reexport debug */
/* unused harmony reexport makeDebugger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__eventStack__ = __webpack_require__(689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_6__eventStack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__factories__ = __webpack_require__(695);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_7__factories__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getUnhandledProps__ = __webpack_require__(697);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_8__getUnhandledProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getElementType__ = __webpack_require__(698);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_9__getElementType__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__htmlPropsUtils__ = __webpack_require__(699);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_10__htmlPropsUtils__["a"]; });
/* unused harmony reexport htmlInputEvents */
/* unused harmony reexport htmlInputProps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_10__htmlPropsUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isBrowser__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_11__isBrowser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__doesNodeContainClick__ = __webpack_require__(701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__doesNodeContainClick__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__leven__ = __webpack_require__(328);
/* unused harmony reexport leven */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__META__ = __webpack_require__(332);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_14__META__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__createPaginationItems__ = __webpack_require__(712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_15__createPaginationItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SUI__ = __webpack_require__(720);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_16__SUI__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__keyboardKey__ = __webpack_require__(721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_17__keyboardKey__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__numberToWord__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_18__numberToWord__["b"]; });
/* unused harmony reexport numberToWord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__normalizeOffset__ = __webpack_require__(722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_19__normalizeOffset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__normalizeTransitionDuration__ = __webpack_require__(723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_20__normalizeTransitionDuration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__objectDiff__ = __webpack_require__(724);
/* unused harmony reexport objectDiff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__shallowEqual__ = __webpack_require__(726);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_22__shallowEqual__["a"]; });













































/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(494);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addons_Confirm__ = __webpack_require__(492);
/* unused harmony reexport Confirm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addons_MountNode__ = __webpack_require__(348);
/* unused harmony reexport MountNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addons_Pagination__ = __webpack_require__(751);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addons_Pagination_PaginationItem__ = __webpack_require__(358);
/* unused harmony reexport PaginationItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_Portal__ = __webpack_require__(94);
/* unused harmony reexport Portal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addons_Radio__ = __webpack_require__(201);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addons_Ref__ = __webpack_require__(199);
/* unused harmony reexport Ref */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addons_Responsive__ = __webpack_require__(765);
/* unused harmony reexport Responsive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addons_Select__ = __webpack_require__(359);
/* unused harmony reexport Select */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addons_TextArea__ = __webpack_require__(368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_9__addons_TextArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__addons_TransitionablePortal__ = __webpack_require__(788);
/* unused harmony reexport TransitionablePortal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__behaviors_Visibility__ = __webpack_require__(790);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_11__behaviors_Visibility__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__collections_Breadcrumb__ = __webpack_require__(792);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__collections_Breadcrumb_BreadcrumbDivider__ = __webpack_require__(373);
/* unused harmony reexport BreadcrumbDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__collections_Breadcrumb_BreadcrumbSection__ = __webpack_require__(374);
/* unused harmony reexport BreadcrumbSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_Form__ = __webpack_require__(794);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_15__collections_Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__collections_Form_FormButton__ = __webpack_require__(375);
/* unused harmony reexport FormButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__collections_Form_FormCheckbox__ = __webpack_require__(376);
/* unused harmony reexport FormCheckbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__collections_Form_FormDropdown__ = __webpack_require__(377);
/* unused harmony reexport FormDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__collections_Form_FormField__ = __webpack_require__(42);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_19__collections_Form_FormField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__collections_Form_FormGroup__ = __webpack_require__(378);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__collections_Form_FormInput__ = __webpack_require__(379);
/* unused harmony reexport FormInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__collections_Form_FormRadio__ = __webpack_require__(380);
/* unused harmony reexport FormRadio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__collections_Form_FormSelect__ = __webpack_require__(381);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_23__collections_Form_FormSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__collections_Form_FormTextArea__ = __webpack_require__(382);
/* unused harmony reexport FormTextArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__collections_Grid__ = __webpack_require__(797);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_25__collections_Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__collections_Grid_GridColumn__ = __webpack_require__(204);
/* unused harmony reexport GridColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__collections_Grid_GridRow__ = __webpack_require__(384);
/* unused harmony reexport GridRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__collections_Menu__ = __webpack_require__(353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_28__collections_Menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__collections_Menu_MenuHeader__ = __webpack_require__(355);
/* unused harmony reexport MenuHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__collections_Menu_MenuItem__ = __webpack_require__(200);
/* unused harmony reexport MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__collections_Menu_MenuMenu__ = __webpack_require__(357);
/* unused harmony reexport MenuMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__collections_Message__ = __webpack_require__(798);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_32__collections_Message__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__collections_Message_MessageContent__ = __webpack_require__(385);
/* unused harmony reexport MessageContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__collections_Message_MessageHeader__ = __webpack_require__(386);
/* unused harmony reexport MessageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__collections_Message_MessageItem__ = __webpack_require__(205);
/* unused harmony reexport MessageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__collections_Message_MessageList__ = __webpack_require__(387);
/* unused harmony reexport MessageList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__collections_Table__ = __webpack_require__(800);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_37__collections_Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__collections_Table_TableBody__ = __webpack_require__(388);
/* unused harmony reexport TableBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__collections_Table_TableCell__ = __webpack_require__(141);
/* unused harmony reexport TableCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__collections_Table_TableFooter__ = __webpack_require__(389);
/* unused harmony reexport TableFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__collections_Table_TableHeader__ = __webpack_require__(206);
/* unused harmony reexport TableHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__collections_Table_TableHeaderCell__ = __webpack_require__(390);
/* unused harmony reexport TableHeaderCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__collections_Table_TableRow__ = __webpack_require__(391);
/* unused harmony reexport TableRow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__elements_Button_Button__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_44__elements_Button_Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__elements_Button_ButtonContent__ = __webpack_require__(343);
/* unused harmony reexport ButtonContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__elements_Button_ButtonGroup__ = __webpack_require__(344);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__elements_Button_ButtonOr__ = __webpack_require__(345);
/* unused harmony reexport ButtonOr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__elements_Container__ = __webpack_require__(802);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_48__elements_Container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__elements_Divider__ = __webpack_require__(804);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_49__elements_Divider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__elements_Flag__ = __webpack_require__(364);
/* unused harmony reexport Flag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__elements_Header__ = __webpack_require__(806);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_51__elements_Header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__elements_Header_HeaderContent__ = __webpack_require__(393);
/* unused harmony reexport HeaderContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__elements_Header_HeaderSubheader__ = __webpack_require__(392);
/* unused harmony reexport HeaderSubheader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__elements_Icon__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_54__elements_Icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__elements_Icon_IconGroup__ = __webpack_require__(336);
/* unused harmony reexport IconGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__elements_Image__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_56__elements_Image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__elements_Image_ImageGroup__ = __webpack_require__(340);
/* unused harmony reexport ImageGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__elements_Input__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_58__elements_Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__elements_Label__ = __webpack_require__(140);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_59__elements_Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__elements_Label_LabelDetail__ = __webpack_require__(341);
/* unused harmony reexport LabelDetail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__elements_Label_LabelGroup__ = __webpack_require__(342);
/* unused harmony reexport LabelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__elements_List__ = __webpack_require__(808);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_62__elements_List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__elements_List_ListContent__ = __webpack_require__(207);
/* unused harmony reexport ListContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__elements_List_ListDescription__ = __webpack_require__(142);
/* unused harmony reexport ListDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__elements_List_ListHeader__ = __webpack_require__(143);
/* unused harmony reexport ListHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__elements_List_ListIcon__ = __webpack_require__(208);
/* unused harmony reexport ListIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__elements_List_ListItem__ = __webpack_require__(394);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_67__elements_List_ListItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__elements_List_ListList__ = __webpack_require__(395);
/* unused harmony reexport ListList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__elements_Loader__ = __webpack_require__(810);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_69__elements_Loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__elements_Rail__ = __webpack_require__(812);
/* unused harmony reexport Rail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__elements_Reveal__ = __webpack_require__(814);
/* unused harmony reexport Reveal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__elements_Reveal_RevealContent__ = __webpack_require__(396);
/* unused harmony reexport RevealContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__elements_Segment__ = __webpack_require__(816);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_73__elements_Segment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__elements_Segment_SegmentGroup__ = __webpack_require__(398);
/* unused harmony reexport SegmentGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__elements_Step__ = __webpack_require__(817);
/* unused harmony reexport Step */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__elements_Step_StepContent__ = __webpack_require__(400);
/* unused harmony reexport StepContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__elements_Step_StepDescription__ = __webpack_require__(209);
/* unused harmony reexport StepDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__elements_Step_StepGroup__ = __webpack_require__(401);
/* unused harmony reexport StepGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__elements_Step_StepTitle__ = __webpack_require__(210);
/* unused harmony reexport StepTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__modules_Accordion_Accordion__ = __webpack_require__(819);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_80__modules_Accordion_Accordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__modules_Accordion_AccordionAccordion__ = __webpack_require__(402);
/* unused harmony reexport AccordionAccordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__modules_Accordion_AccordionContent__ = __webpack_require__(211);
/* unused harmony reexport AccordionContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__modules_Accordion_AccordionTitle__ = __webpack_require__(212);
/* unused harmony reexport AccordionTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__modules_Checkbox__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_84__modules_Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__modules_Dimmer__ = __webpack_require__(338);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_85__modules_Dimmer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__modules_Dimmer_DimmerDimmable__ = __webpack_require__(339);
/* unused harmony reexport DimmerDimmable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__modules_Dropdown__ = __webpack_require__(202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_87__modules_Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__modules_Dropdown_DropdownDivider__ = __webpack_require__(362);
/* unused harmony reexport DropdownDivider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__modules_Dropdown_DropdownHeader__ = __webpack_require__(365);
/* unused harmony reexport DropdownHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__modules_Dropdown_DropdownItem__ = __webpack_require__(363);
/* unused harmony reexport DropdownItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__modules_Dropdown_DropdownMenu__ = __webpack_require__(366);
/* unused harmony reexport DropdownMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__modules_Dropdown_DropdownSearchInput__ = __webpack_require__(367);
/* unused harmony reexport DropdownSearchInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__modules_Embed__ = __webpack_require__(820);
/* unused harmony reexport Embed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__modules_Modal__ = __webpack_require__(346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_94__modules_Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__modules_Modal_ModalActions__ = __webpack_require__(351);
/* unused harmony reexport ModalActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__modules_Modal_ModalContent__ = __webpack_require__(350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_96__modules_Modal_ModalContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__modules_Modal_ModalDescription__ = __webpack_require__(352);
/* unused harmony reexport ModalDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__modules_Modal_ModalHeader__ = __webpack_require__(349);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__modules_Popup__ = __webpack_require__(822);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_99__modules_Popup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__modules_Popup_PopupContent__ = __webpack_require__(403);
/* unused harmony reexport PopupContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__modules_Popup_PopupHeader__ = __webpack_require__(404);
/* unused harmony reexport PopupHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__modules_Progress__ = __webpack_require__(826);
/* unused harmony reexport Progress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__modules_Rating__ = __webpack_require__(831);
/* unused harmony reexport Rating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__modules_Rating_RatingIcon__ = __webpack_require__(405);
/* unused harmony reexport RatingIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__modules_Search__ = __webpack_require__(833);
/* unused harmony reexport Search */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__modules_Search_SearchCategory__ = __webpack_require__(406);
/* unused harmony reexport SearchCategory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__modules_Search_SearchResult__ = __webpack_require__(407);
/* unused harmony reexport SearchResult */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__modules_Search_SearchResults__ = __webpack_require__(408);
/* unused harmony reexport SearchResults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__modules_Sidebar__ = __webpack_require__(836);
/* unused harmony reexport Sidebar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__modules_Sidebar_SidebarPushable__ = __webpack_require__(409);
/* unused harmony reexport SidebarPushable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__modules_Sidebar_SidebarPusher__ = __webpack_require__(410);
/* unused harmony reexport SidebarPusher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__modules_Sticky__ = __webpack_require__(838);
/* unused harmony reexport Sticky */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__modules_Tab__ = __webpack_require__(840);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_113__modules_Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__modules_Tab_TabPane__ = __webpack_require__(411);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__modules_Transition__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_115__modules_Transition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__modules_Transition_TransitionGroup__ = __webpack_require__(371);
/* unused harmony reexport TransitionGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__views_Advertisement__ = __webpack_require__(842);
/* unused harmony reexport Advertisement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__views_Card_Card__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_118__views_Card_Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__views_Card_CardContent__ = __webpack_require__(413);
/* unused harmony reexport CardContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__views_Card_CardDescription__ = __webpack_require__(213);
/* unused harmony reexport CardDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__views_Card_CardGroup__ = __webpack_require__(414);
/* unused harmony reexport CardGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__views_Card_CardHeader__ = __webpack_require__(214);
/* unused harmony reexport CardHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__views_Card_CardMeta__ = __webpack_require__(215);
/* unused harmony reexport CardMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__views_Comment__ = __webpack_require__(844);
/* unused harmony reexport Comment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__views_Comment_CommentAction__ = __webpack_require__(415);
/* unused harmony reexport CommentAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_Comment_CommentActions__ = __webpack_require__(416);
/* unused harmony reexport CommentActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_Comment_CommentAuthor__ = __webpack_require__(417);
/* unused harmony reexport CommentAuthor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_Comment_CommentAvatar__ = __webpack_require__(418);
/* unused harmony reexport CommentAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_Comment_CommentContent__ = __webpack_require__(419);
/* unused harmony reexport CommentContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_Comment_CommentGroup__ = __webpack_require__(420);
/* unused harmony reexport CommentGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_Comment_CommentMetadata__ = __webpack_require__(421);
/* unused harmony reexport CommentMetadata */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_Comment_CommentText__ = __webpack_require__(422);
/* unused harmony reexport CommentText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_Feed__ = __webpack_require__(846);
/* unused harmony reexport Feed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_Feed_FeedContent__ = __webpack_require__(216);
/* unused harmony reexport FeedContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_Feed_FeedDate__ = __webpack_require__(145);
/* unused harmony reexport FeedDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_Feed_FeedEvent__ = __webpack_require__(423);
/* unused harmony reexport FeedEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__views_Feed_FeedExtra__ = __webpack_require__(217);
/* unused harmony reexport FeedExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_Feed_FeedLabel__ = __webpack_require__(222);
/* unused harmony reexport FeedLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_Feed_FeedLike__ = __webpack_require__(219);
/* unused harmony reexport FeedLike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__views_Feed_FeedMeta__ = __webpack_require__(218);
/* unused harmony reexport FeedMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__views_Feed_FeedSummary__ = __webpack_require__(220);
/* unused harmony reexport FeedSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__views_Feed_FeedUser__ = __webpack_require__(221);
/* unused harmony reexport FeedUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__views_Item__ = __webpack_require__(848);
/* unused harmony reexport Item */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__views_Item_ItemContent__ = __webpack_require__(425);
/* unused harmony reexport ItemContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__views_Item_ItemDescription__ = __webpack_require__(224);
/* unused harmony reexport ItemDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__views_Item_ItemExtra__ = __webpack_require__(225);
/* unused harmony reexport ItemExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__views_Item_ItemGroup__ = __webpack_require__(426);
/* unused harmony reexport ItemGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__views_Item_ItemHeader__ = __webpack_require__(223);
/* unused harmony reexport ItemHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__views_Item_ItemImage__ = __webpack_require__(427);
/* unused harmony reexport ItemImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__views_Item_ItemMeta__ = __webpack_require__(226);
/* unused harmony reexport ItemMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__views_Statistic__ = __webpack_require__(849);
/* unused harmony reexport Statistic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__views_Statistic_StatisticGroup__ = __webpack_require__(429);
/* unused harmony reexport StatisticGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__views_Statistic_StatisticLabel__ = __webpack_require__(430);
/* unused harmony reexport StatisticLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__views_Statistic_StatisticValue__ = __webpack_require__(431);
/* unused harmony reexport StatisticValue */
// Addons












// Behaviors


// Collections






































// Elements



















































// Modules



















































// Views












































/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(265);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(73);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(522);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(526);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(73);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var baseInvoke = __webpack_require__(555),
    baseRest = __webpack_require__(52);

/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = baseRest(baseInvoke);

module.exports = invoke;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(279),
    baseRest = __webpack_require__(52),
    isArrayLikeObject = __webpack_require__(116);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(617),
    util = __webpack_require__(619);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(476);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(479);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(480);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(481);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(483);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(484);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(485);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(487);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(488);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(489);
/* unused harmony reexport withRouter */





























/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38),
    baseIteratee = __webpack_require__(27),
    baseMap = __webpack_require__(325),
    isArray = __webpack_require__(15);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
/* unused harmony export TUTORIAL_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ICON_URL; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SearchPage_js__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_YupikDetails_js__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WordBuilder_js__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SentenceBuilder_js__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SentenceGlossary_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_About_js__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Dialogues_js__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_DialogueMenu_js__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Lksdreader_js__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Support_js__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Privacy_js__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Symbols_js__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_SpeechToText_js__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Validate_js__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_yupikModify_YupikModifyLayout_js__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_performance_now__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_performance_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_performance_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_ga__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_SearchPageHelpers_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_TTS_ASR_TTSComponent_js__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_TTS_ASR_ASRComponent_js__ = __webpack_require__(962);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Recorder from './components/Recorder.js';
// export const API_URL = "https://yugtun-api.herokuapp.com";
// export const API_URL = "http://127.0.0.1:5000";
// export const API_URL = "https://inupiaqonline.com/api";
var API_URL="https://www.inupiaqonline.com/fastapi";// export const API_URL = "http://127.0.0.1:5001";
var TUTORIAL_URL='https://youtu.be/8xW36PYaZHo';var ICON_URL="https://yuarcuun.inupiaqonline.com/images/logo_final_1.jpeg";var dictionarylite=[];var dictionary_dictlite={};var dictionary=[];var audiolibrary=[];var dictionary_dict={};var usageDictionary=[];var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.loadRemaining=function(){if(audiolibrary.length===0){__WEBPACK_IMPORTED_MODULE_20_axios___default.a.get(API_URL+"/audiolibrary/all").then(function(response){// let end = now();
// ReactGA.timing({
//   category: 'Loading',
//   variable: 'dictionary',
//   value: (end-start).toFixed(3),
//   label: 'Dictionary loading'
// });
// console.log(response.data)
audiolibrary=response.data;// fuse.setCollection(dictionary);
// fuse1.setCollection(dictionary);
console.log('Fetched AudioLibrary');// dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
// dictionary_prepared = fuzzysort.prepare(dictionary)
_this.setState({audiolibrary:audiolibrary});});}else{_this.setState({audiolibrary:audiolibrary});}if(usageDictionary.length===0){__WEBPACK_IMPORTED_MODULE_20_axios___default.a.get(API_URL+"/yupiksearchableusagelist/all").then(function(response){var end=__WEBPACK_IMPORTED_MODULE_21_performance_now___default()();// ReactGA.timing({
//   category: 'Loading',
//   variable: 'dictionary',
//   value: (end-start).toFixed(3),
//   label: 'Dictionary loading'
// });
usageDictionary=response.data;// console.log(usageDictionary)
console.log('Fetched usage dictionary');// let filteredDictV = usageDictionary.filter(entry => (entry.type.includes('i')||entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]')||entry.type.includes('[V→V]')) )
// let filteredDictN = usageDictionary.filter(entry => (entry.type.includes('n')||entry.type.includes('[V→N]')||entry.type.includes('[N→N]')))
// let filteredDictVit = usageDictionary.filter(entry => (entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]')||entry.type.includes('[V→V]')))
// this.setState({ usageDictionary: usageDictionary});
var filteredDictV=usageDictionary.filter(function(entry){return entry.type.includes('i')||entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]')||entry.type.includes('[V→V]');});var filteredDictN=usageDictionary.filter(function(entry){return entry.type.includes('n')||entry.type.includes('[V→N]')||entry.type.includes('[N→N]');});var filteredDictVit=usageDictionary.filter(function(entry){return entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]')||entry.type.includes('[V→V]');});_this.setState({usageDictionary:usageDictionary,filteredDictV:filteredDictV,filteredDictVit:filteredDictVit,filteredDictN:filteredDictN});});}else{_this.setState({usageDictionary:usageDictionary});}};_this.updateCompleted=function(lessonIndex,exerciseNumber,data,value){// console.log(lessonIndex, exerciseNumber, data,value)
var completedExercises=_this.state.completedExercises;var lessonsStarted=_this.state.lessonsStarted;var newentry=lessonIndex.toString()+'%'+exerciseNumber.toString();// console.log(completed, newentry, !completed.includes(newentry),completed.concat([newentry]))
if(!completedExercises.includes(newentry)){_this.setState({completedExercises:completedExercises.concat([newentry])});}if(!lessonsStarted.includes(lessonIndex)&&exerciseNumber!==-1){_this.setState({lessonsStarted:lessonsStarted.concat([lessonIndex])});}};_this.state={dictionary:[],dictionary_dict:{},audiolibrary:[],usageDictionary:[],filteredDictV:[],filteredDictVit:[],filteredDictN:[],completedExercises:[],lessonsStarted:[]};return _this;}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var start=__WEBPACK_IMPORTED_MODULE_21_performance_now___default()();if(dictionary.length===0){__WEBPACK_IMPORTED_MODULE_20_axios___default.a.get(API_URL+"/word/all2021").then(function(response){var end=__WEBPACK_IMPORTED_MODULE_21_performance_now___default()();__WEBPACK_IMPORTED_MODULE_22_react_ga__["a" /* default */].timing({category:'Loading',variable:'dictionary',value:(end-start).toFixed(3),label:'Dictionary loading'});dictionary=response.data;// console.log(dictionary)
// fuse.setCollection(dictionary);
// fuse1.setCollection(dictionary);
console.log('Fetched dictionary');dictionary.forEach(function(entry){return dictionary_dict[entry.keyString]=entry.definitionString;});// create dictionary_dict dictionary
// dictionary_prepared = fuzzysort.prepare(dictionary)
_this2.setState({dictionary:dictionary,dictionary_dict:dictionary_dict},function(){_this2.loadRemaining();});});}else{// fuse.setCollection(dictionary);
this.setState({dictionary:dictionary,dictionary_dict:dictionary_dict},function(){_this2.loadRemaining();});}}},{key:'render',value:function render(){var _this3=this;// console.log(this.state)
// this.state.audiolibrary.length !== 0 && this.state.dictionary.length !== 0 && this.state.usageDictionary !== 0 && this.state.filteredDictV !== 0 && this.state.filteredDictVit !== 0 && this.state.filteredDictN !== 0 ?
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:0,padding:0}},this.state.dictionary.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SearchPage_js__["a" /* default */],Object.assign({audiolibrary:_this3.state.audiolibrary,dictionary_dict:_this3.state.dictionary_dict,usageDictionary:_this3.state.usageDictionary,dictionary:_this3.state.dictionary,filteredDictV:_this3.state.filteredDictV,filteredDictVit:_this3.state.filteredDictVit,filteredDictN:_this3.state.filteredDictN},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/about',component:__WEBPACK_IMPORTED_MODULE_10__components_About_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/dialogues/:num',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Dialogues_js__["a" /* default */],Object.assign({updateCompleted:_this3.updateCompleted},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/dialogues',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_DialogueMenu_js__["a" /* default */],Object.assign({completedExercises:_this3.state.completedExercises,lessonsStarted:_this3.state.lessonsStarted},props));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/lksdreader',component:__WEBPACK_IMPORTED_MODULE_13__components_Lksdreader_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/support',component:__WEBPACK_IMPORTED_MODULE_14__components_Support_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/validate',component:__WEBPACK_IMPORTED_MODULE_18__components_Validate_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/privacy',component:__WEBPACK_IMPORTED_MODULE_15__components_Privacy_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/symbols',component:__WEBPACK_IMPORTED_MODULE_16__components_Symbols_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/sentenceglossary',component:__WEBPACK_IMPORTED_MODULE_9__components_SentenceGlossary_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/tts',component:__WEBPACK_IMPORTED_MODULE_24__components_TTS_ASR_TTSComponent_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/asr',component:__WEBPACK_IMPORTED_MODULE_25__components_TTS_ASR_ASRComponent_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{path:'/:word/:entry_id/:usage_id/modify',component:__WEBPACK_IMPORTED_MODULE_19__components_yupikModify_YupikModifyLayout_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/:word',component:__WEBPACK_IMPORTED_MODULE_6__components_YupikDetails_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/sentencebuilder/:num',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_SentenceBuilder_js__["a" /* default */],Object.assign({audiolibrary:_this3.state.audiolibrary,usageDictionary:_this3.state.usageDictionary,dictionary_dict:_this3.state.dictionary_dict,dictionary:_this3.state.dictionary,filteredDictV:_this3.state.filteredDictV,filteredDictVit:_this3.state.filteredDictVit,filteredDictN:_this3.state.filteredDictN},props));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["f" /* Dimmer */],{className:'overlay',active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_semantic_ui_react__["t" /* Loader */],{size:'massive'},'Yugtun is loading...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */],{exact:true,path:'/',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_SearchPage_js__["a" /* default */],Object.assign({audiolibrary:_this3.state.audiolibrary,dictionary_dict:_this3.state.dictionary_dict,usageDictionary:_this3.state.usageDictionary,dictionary:_this3.state.dictionary,filteredDictV:_this3.state.filteredDictV,filteredDictVit:_this3.state.filteredDictVit,filteredDictN:_this3.state.filteredDictN},props));}}))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["c"] = (App);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["a"]; });



/***/ }),
/* 22 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(271);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(851);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(285),
    baseKeys = __webpack_require__(123),
    isArrayLike = __webpack_require__(28);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(573),
    baseMatchesProperty = __webpack_require__(586),
    identity = __webpack_require__(39),
    isArray = __webpack_require__(15),
    property = __webpack_require__(588);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(61),
    isLength = __webpack_require__(172);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(85);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(432);
var isBuffer = __webpack_require__(852);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(473);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(160)('wks');
var uid = __webpack_require__(101);
var Symbol = __webpack_require__(48).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59),
    getRawTag = __webpack_require__(530),
    objectToString = __webpack_require__(531);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(609);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReactGAImplementation = void 0;
var _ga = _interopRequireWildcard(__webpack_require__(871));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ReactGAImplementation = _ga.GA4;
exports.ReactGAImplementation = ReactGAImplementation;
var _default = _ga["default"];
exports["default"] = _default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(108);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(177);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(114),
    isArrayLike = __webpack_require__(28),
    isString = __webpack_require__(135),
    toInteger = __webpack_require__(40),
    values = __webpack_require__(76);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_Checkbox__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addons_Radio__ = __webpack_require__(201);












/**
 * A field is a form element containing a label and an input.
 * @see Form
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Radio
 * @see Select
 * @see Visibility
 */
function FormField(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      control = props.control,
      disabled = props.disabled,
      error = props.error,
      inline = props.inline,
      label = props.label,
      required = props.required,
      type = props.type,
      width = props.width;


  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(inline, 'inline'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(required, 'required'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* useWidthProp */])(width, 'wide'), 'field', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["r" /* getUnhandledProps */])(FormField, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getElementType */])(FormField, props);

  // ----------------------------------------
  // No Control
  // ----------------------------------------

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(control)) {
    if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(label)) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
        __WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children) ? content : children
      );
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      Object(__WEBPACK_IMPORTED_MODULE_6__lib__["i" /* createHTMLLabel */])(label)
    );
  }

  // ----------------------------------------
  // Checkbox/Radio Control
  // ----------------------------------------
  var controlProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { content: content, children: children, disabled: disabled, required: required, type: type

    // wrap HTML checkboxes/radios in the label
  });if (control === 'input' && (type === 'checkbox' || type === 'radio')) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      ElementType,
      { className: classes },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'label',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(control, controlProps),
        ' ',
        label
      )
    );
  }

  // pass label prop to controls that support it
  if (control === __WEBPACK_IMPORTED_MODULE_7__modules_Checkbox__["a" /* default */] || control === __WEBPACK_IMPORTED_MODULE_8__addons_Radio__["a" /* default */]) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      ElementType,
      { className: classes },
      Object(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(control, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, controlProps, { label: label }))
    );
  }

  // ----------------------------------------
  // Other Control
  // ----------------------------------------

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    { className: classes },
    Object(__WEBPACK_IMPORTED_MODULE_6__lib__["i" /* createHTMLLabel */])(label, { defaultProps: {
        htmlFor: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(controlProps, 'id') }
    }),
    Object(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(control, controlProps)
  );
}

FormField.handledProps = ['as', 'children', 'className', 'content', 'control', 'disabled', 'error', 'inline', 'label', 'required', 'type', 'width'];
FormField._meta = {
  name: 'FormField',
  parent: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.COLLECTION
};

FormField.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /**
   * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
   * Extra FormField props are passed to the control component.
   * Mutually exclusive with children.
   */
  control: customPropTypes.some([PropTypes.func, PropTypes.oneOf(['button', 'input', 'select', 'textarea'])]),

  /** Individual fields may be disabled. */
  disabled: PropTypes.bool,

  /** Individual fields may display an error state. */
  error: PropTypes.bool,

  /** A field can have its label next to instead of above it. */
  inline: PropTypes.bool,

  // Heads Up!
  // Do not disallow children with `label` shorthand
  // The `control` might accept a `label` prop and `children`
  /** Mutually exclusive with children. */
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** A field can show that input is mandatory. */
  required: PropTypes.bool,

  /** Passed to the control component (i.e. <input type='password' />) */
  type: customPropTypes.every([customPropTypes.demand(['control'])]
  // don't strictly validate HTML types
  // a control might be passed that uses a `type` prop with unknown values
  // let the control validate if for us
  ),

  /** A field can specify its width in grid columns */
  width: PropTypes.oneOf(SUI.WIDTHS)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FormField);

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(252);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(255);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(256);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(152);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(97);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(257);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(258);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(153);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(98);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(48);
var core = __webpack_require__(22);
var ctx = __webpack_require__(154);
var hide = __webpack_require__(70);
var has = __webpack_require__(56);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(55);
var IE8_DOM_DEFINE = __webpack_require__(260);
var toPrimitive = __webpack_require__(155);
var dP = Object.defineProperty;

exports.f = __webpack_require__(50) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(72)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(529),
    hasPath = __webpack_require__(270);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(39),
    overRest = __webpack_require__(276),
    setToString = __webpack_require__(173);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(583),
    Map = __webpack_require__(171),
    Promise = __webpack_require__(584),
    Set = __webpack_require__(295),
    WeakMap = __webpack_require__(296),
    baseGetTag = __webpack_require__(34),
    toSource = __webpack_require__(274);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(71);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(263);
var defined = __webpack_require__(157);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(536),
    getValue = __webpack_require__(539);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObject = __webpack_require__(25);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(58);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(178),
    createBaseEach = __webpack_require__(572);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(90),
    baseEach = __webpack_require__(64),
    castFunction = __webpack_require__(301),
    isArray = __webpack_require__(15);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(594);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(597);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return YugtunLoader; });
/* unused harmony export YugtunFooter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagColors; });
/* unused harmony export AudioItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WordItemLikeInup; });
/* unused harmony export WordItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
var YugtunLoader=function YugtunLoader(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["f" /* Dimmer */],{active:props.criteria},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["t" /* Loader */],{size:'massive'},'Yugtun is loading...'));};var YugtunFooter=function YugtunFooter(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["e" /* Container */],{textAlign:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],{fluid:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{horizontal:true,bulleted:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,null,' \xA9 Yuarcuun '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/about'},'About'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'mailto:yuarcuun@gmail.com'},'Contact'),' ')));};var TagColors=function TagColors(props){// console.log('hi',props.word)
var isNoun=props.word=='noun';var isVerb=props.word=='verb';var isParticle=props.word=='particle';var isRoot=props.word=='root';var isExclamation=props.word=='exclamation';var isConjunction=props.word=='conjunction';var isAdverb=props.word=='adverb';var isPredicate=props.word=='predicate';var isDemonstrative=props.word=='demonstrative';var isInterjection=props.word=='interjection';var isPostbase=props.word=='postbase';var isEnclitic=props.word=='enclitic';var isTransitive=props.word=='t';var isIntransitive=props.word=='i';var isNoun2=props.word=='n';var isAge=props.word=='age';var isGender=props.word=='gender';var isVillage=props.word=='village';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'flex',height:'20px','marginLeft':props.padding}},isAge?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{basic:true,size:'mini',style:{color:'#5f5f5f',whiteSpace:'nowrap'}},props.content):'',isGender?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{basic:true,size:'mini',style:{color:'#5f5f5f',whiteSpace:'nowrap'}},props.content):'',isVillage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{basic:true,size:'mini',style:{color:'#5f5f5f',whiteSpace:'nowrap'}},props.content):'',isNoun?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#7F90B0',color:'white'}},'NOUN'):'',isNoun2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#7F90B0',color:'white'}},'NOUN'):'',isVerb?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#B07F7F',color:'white'}},'VERB'):'',isIntransitive?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#B07F7F',color:'white'}},'INTRANSITIVE VERB'):'',isTransitive?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#B07F7F',color:'white'}},'TRANSITIVE VERB'):'',isParticle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'PARTICLE'):'',isRoot?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'ROOT'):'',isExclamation?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'EXCLAMATION'):'',isConjunction?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'CONJUNCTION'):'',isAdverb?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'ADVERB'):'',isPredicate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'PREDICATE'):'',isDemonstrative?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'DEMONSTRATIVE'):'',isInterjection?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'INTERJECTION'):'',isPostbase?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#d56ea8',color:'white'}},'POSTBASE'):'',isEnclitic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#60bf76',color:'white'}},'ENCLITIC'):'');};var AudioItem=function AudioItem(props){// console.log(props)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Header,{style:{display:'flex',fontFamily:'Lato,Arial,Helvetica,sans-serif',fontSize:'16px',paddingBottom:'4px'}},props.word.y),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Description,{style:{fontSize:'16px',fontWeight:'400'}},props.word.e));};var WordItemLikeInup=function WordItemLikeInup(props){// console.log("WordItemLikeInup", props)
var verbkeyStringbool=false;if('verbkeyString'in props.word){if(props.word.verbkeyString.keyString.length!==0&&props.word.pos=='noun'){props.word.pos.push('verb');props.word.keyString=props.word.keyString.replace(',',', ');verbkeyStringbool=true;}}var isNoun=props.word.pos.includes('noun');var isVerb=props.word.pos.includes('verb');var isParticle=props.word.pos.includes('particle');var isRoot=props.word.pos.includes('root');var isExclamation=props.word.pos.includes('exclamation');var isConjunction=props.word.pos.includes('conjunction');var isAdverb=props.word.pos.includes('adverb');var isPredicate=props.word.pos.includes('predicate');var isDemonstrative=props.word.pos.includes('demonstrative');var isInterjection=props.word.pos.includes('interjection');var isPostbase=props.word.pos.includes('postbase');var isEnclitic=props.word.pos.includes('enclitic');var isUnlinked=props.word.pos.includes('unlinked');if(isUnlinked){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{style:{'paddingLeft':props.paddingLeft,paddingTop:5,paddingBottom:8},key:props.word.keyString},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Header,{style:{display:'flex',fontFamily:'Lato,Arial,Helvetica,sans-serif',fontSize:'18px'}},props.word.keyString,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{'marginLeft':'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'UNLINKED')))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{style:{'paddingLeft':props.paddingLeft,paddingTop:5,paddingBottom:8},key:props.word.keyString},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'/'+props.word.url,state:{entry:props.entry,word:props.word,search:props.search,wordsList:props.wordsList,yugtunAnalyzer:false,parses:[],segments:[],endingrule:[]}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,style:{marginTop:'5px',marginRight:'5px',color:'#8f8f8f',fontSize:'22px'},size:'large',name:'chevron right'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Header,{style:{lineHeight:'28px',fontFamily:'Lato,Arial,Helvetica,sans-serif',fontSize:'18px',paddingBottom:'10px',paddingTop:'5px'}},props.word.keySplit.map(function(w,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{style:{fontSize:'18px',color:'#306190',fontWeight:'400'},to:{pathname:'/'+props.word.url,state:{entry:props.entry,word:props.word,search:props.search,wordsList:props.wordsList,yugtunAnalyzer:false,parses:[],segments:[],endingrule:[]}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{borderBottom:'1px solid #306190',paddingBottom:'1px'}},w[0]),w[1][0]!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{style:{'marginLeft':'5px',marginRight:index===props.word.keySplit.length-1?'0px':'5px'},size:'mini',color:'white'},w[1].join(', ')):index==props.word.keySplit.length-1?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{borderBottom:'1px solid #306190',paddingBottom:'1px','paddingRight':'3px'}},',\xa0'));}),'audio'in props.word?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,size:'small',onClick:function onClick(){return props.repeatAudio(props.word.audio);},style:{cursor:'pointer',color:'#8a8a8a','marginLeft':'9px'},name:'volume up'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{height:'20px','marginLeft':'audio'in props.word?'9px':'18px'}},isNoun?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#7F90B0',color:'white'}},'NOUN'):'',isVerb?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#B07F7F',color:'white'}},'VERB'):'',isParticle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'PARTICLE'):'',isRoot?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'ROOT'):'',isExclamation?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'EXCLAMATION'):'',isConjunction?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'CONJUNCTION'):'',isAdverb?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'ADVERB'):'',isPredicate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'PREDICATE'):'',isDemonstrative?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'DEMONSTRATIVE'):'',isInterjection?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'INTERJECTION'):'',isUnlinked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'UNLINKED'):'',isPostbase?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#d56ea8',color:'white'}},'POSTBASE'):'',isEnclitic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#60bf76',color:'white'}},'ENCLITIC'):''),props.word.entryDialect.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{style:{'marginLeft':'5px',marginRight:'5px'},size:'mini',color:'white'},props.word.entryDialect.join(', ')):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Description,{style:{fontSize:'16px',fontWeight:'400',lineHeight:'22px',color:'#000000b3'}},props.word.definitionString)));}};var WordItem=function WordItem(props){// console.log(props)
var verbkeyStringbool=false;// console.log(props.word.verbkeyString.pos)
if('verbkeyString'in props.word){if(props.word.verbkeyString.keyString.length!==0&&props.word.pos=='noun'){props.word.pos.push('verb');props.word.keyString=props.word.keyString.replace(',',', ');verbkeyStringbool=true;}}// let word = props.word;
var isNoun=props.word.pos.includes('noun');var isVerb=props.word.pos.includes('verb');var isParticle=props.word.pos.includes('particle');var isRoot=props.word.pos.includes('root');var isExclamation=props.word.pos.includes('exclamation');var isConjunction=props.word.pos.includes('conjunction');var isAdverb=props.word.pos.includes('adverb');var isPredicate=props.word.pos.includes('predicate');var isDemonstrative=props.word.pos.includes('demonstrative');var isInterjection=props.word.pos.includes('interjection');var isPostbase=props.word.pos.includes('postbase');var isEnclitic=props.word.pos.includes('enclitic');var isUnlinked=props.word.pos.includes('unlinked');// let isExpression = props.word.pos.includes('expression');
// let isCommon = props.word.pos.includes('grammar');
// let isHBC = props.word.pos.includes('Hooper Bay Chevak');
// console.log(props.word)
if(isUnlinked){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{key:props.word.keyString},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Header,{style:{display:'flex',fontFamily:'Lato,Arial,Helvetica,sans-serif',fontSize:'16px',paddingBottom:'4px'}},props.word.keyString,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{'marginLeft':'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'UNLINKED')))));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{style:{'paddingLeft':8+props.paddingLeft},key:props.word.keyString},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'/'+props.word.url,state:{entry:props.entry,word:props.word,search:props.search,wordsList:props.wordsList,yugtunAnalyzer:false,parses:[],segments:[],endingrule:[]}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Header,{style:{display:'flex',fontFamily:'Lato,Arial,Helvetica,sans-serif',fontSize:'16px',paddingBottom:'4px'}},props.word.keySplit.map(function(w,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,w[0],w[1][0]!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{style:{'marginLeft':'5px',marginRight:'5px'},size:'mini',color:'white'},w[1].join(', ')):index==props.word.keySplit.length-1?'':',\xa0');}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{'marginLeft':'18px'}},isNoun?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#7F90B0',color:'white'}},'NOUN'):'',isVerb?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#B07F7F',color:'white'}},'VERB'):'',isParticle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'PARTICLE'):'',isRoot?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'ROOT'):'',isExclamation?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'EXCLAMATION'):'',isConjunction?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'CONJUNCTION'):'',isAdverb?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'ADVERB'):'',isPredicate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'PREDICATE'):'',isDemonstrative?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'DEMONSTRATIVE'):'',isInterjection?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'INTERJECTION'):'',isUnlinked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'UNLINKED'):'',isPostbase?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#d56ea8',color:'white'}},'POSTBASE'):'',isEnclitic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{backgroundColor:'#60bf76',color:'white'}},'ENCLITIC'):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Description,{style:{fontSize:'16px',fontWeight:'400'}},props.word.definitionString))));}};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return options1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return options2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return options3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return retrieveSubjectObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return postbases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return nounPostbases; });
var options1=[{id:0,value:'11(1)',text:'I',otext:'me'},{id:1,value:'21(1)',text:'you',otext:'you'},{id:2,value:'31-1(1)',text:'he',otext:'him'},{id:3,value:'31-2(1)',text:'she',otext:'her'},{id:4,value:'31-3(1)',text:'it',otext:'it'},{id:5,value:'41(1)',text:'its own',otext:'its own'},{id:6,value:'12(1)',text:'the two of us',otext:'the two of us'},{id:7,value:'22(1)',text:'the two of you',otext:'the two of you'},{id:8,value:'32(1)',text:'the two of them',otext:'the two of them'},{id:9,value:'42(1)',text:'their own (two)',otext:'their own (two)'},{id:10,value:'13(1)',text:'we all (3+)',otext:'us all (3+)'},{id:11,value:'23(1)',text:'you all (3+)',otext:'you all (3+)'},{id:12,value:'33(1)',text:'they all (3+)',otext:'them all (3+)'},{id:13,value:'43(1)',text:'their own (3+)',otext:'their own (3+)'}];var options2=[{id:0,value:'11(2)',text:'me',ptext:'my'},{id:1,value:'21(2)',text:'you',ptext:'your'},{id:2,value:'31-1(2)',text:'him',ptext:'his'},{id:3,value:'31-2(2)',text:'her',ptext:'her'},{id:4,value:'31-3(2)',text:'it',ptext:'its'},{id:5,value:'41(2)',text:'its own',ptext:'its own'},{id:6,value:'12(2)',text:'the two of us',ptext:'our (two)'},{id:7,value:'22(2)',text:'the two of you',ptext:'your (two)'},{id:8,value:'32(2)',text:'the two of them',ptext:'their (two)'},{id:9,value:'42(2)',text:'their own (two)',ptext:'their own (two)'},{id:10,value:'13(2)',text:'us all (3+)',ptext:'our (3+)'},{id:11,value:'23(2)',text:'you all (3+)',ptext:'your (3+)'},{id:12,value:'33(2)',text:'them all (3+)',ptext:'their (3+)'},{id:13,value:'43(2)',text:'their own (3+)',ptext:'their own (3+)'}];var options3=[{id:0,value:'11(3)',text:'my'},{id:1,value:'21(3)',text:'your'},{id:2,value:'31-1(3)',text:'his'},{id:3,value:'31-2(3)',text:'her'},{id:4,value:'31-3(3)',text:'its'},{id:5,value:'41(3)',text:'its own'},{id:6,value:'12(3)',text:'our (two)'},{id:7,value:'22(3)',text:'your (two)'},{id:8,value:'32(3)',text:'their (two)'},{id:9,value:'42(3)',text:'their own (two)'},{id:10,value:'13(3)',text:'our (3+)'},{id:11,value:'23(3)',text:'your (3+)'},{id:12,value:'33(3)',text:'their (3+)'},{id:13,value:'43(3)',text:'their own (3+)'}];var retrieveSubjectObject={'11(1)':'I','21(1)':'you','31-1(1)':'he','31-2(1)':'she','31-3(1)':'it','41(1)':'its own','12(1)':'the two of us','22(1)':'the two of you','32(1)':'the two of them','42(1)':'their own (two)','13(1)':'we all (3+)','23(1)':'you all (3+)','33(1)':'they all (3+)','43(1)':'their own (3+)','11(2)':'me','21(2)':'you','31-1(2)':'him','31-2(2)':'her','31-3(2)':'it','41(2)':'its own','12(2)':'the two of us','22(2)':'the two of you','32(2)':'the two of them','42(2)':'their own (two)','13(2)':'us all (3+)','23(2)':'you all (3+)','33(2)':'them all (3+)','43(2)':'their own (3+)','11(3)':'my','21(3)':'your','31-1(3)':'his','31-2(3)':'her','31-3(3)':'its','41(3)':'its own','12(3)':'our (two)','22(3)':'your (two)','32(3)':'their (two)','42(3)':'their own (two)','13(3)':'our (3+)','23(3)':'your (3+)','33(3)':'their (3+)','43(3)':'their own (3+)'};var postbases=[{id:0,description:'is probably',englishModifier:function englishModifier(english){return' probably'+english;},expression:'@~+yugnarqe\\',expression_conditional:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[1]},{id:1,description:'is evidently (without being observed)',englishModifier:function englishModifier(english){return' evidently'+english;},expression:'-2ini\\',expression_conditional:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[0]},{id:2,description:'is no longer able to',englishModifier:function englishModifier(english){return' no longer able to'+english;},expression:'+(s)ciigali\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[1,3]},{id:3,description:'is not able to',englishModifier:function englishModifier(english){return' not able to'+english;},expression:'+(s)ciigate\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[1,2]},{id:4,description:'is able to',englishModifier:function englishModifier(english){return' able to'+english;},expression:'@~+yug6a\\',expression_conditional:'',conditional_rule:'',tense:'',allowable_next_ids:[0,1,6,7,8]},{id:5,description:'past tense',englishModifier:function englishModifier(english){return''+english;},expression:'-2ru\\',expression_conditional:'',priority:3,conditional_rule:'',tense:'past',allowable_next_ids:[7]},{id:6,description:'not yet',englishModifier:function englishModifier(english){return' not yet'+english;},expression:'-ksaite\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,7]},{id:7,description:'future tense',englishModifier:function englishModifier(english){return''+english;},expression:'+ciqe\\',expression_conditional:'@ciiqe\\',// conditional te_ending
priority:3,conditional_rule:'attaching_to_te',// defined later and if satisfied display expression_conditional
tense:'future',allowable_next_ids:[0,1,5,10]},{id:8,description:'will not',englishModifier:function englishModifier(english){return' not'+english;},expression:'@~+6aite\\',expression_conditional:'',priority:3,conditional_rule:'',tense:'future',allowable_next_ids:[0,1,7,10]},{id:9,description:'will soon',englishModifier:function englishModifier(english){return' soon'+english;},expression:'@~+niarar\\',expression_conditional:'',priority:3,conditional_rule:'',tense:'future',allowable_next_ids:[0,1,5,6,7,10]},{id:10,description:'about to',englishModifier:function englishModifier(english){return' about to'+english;},expression:'-qatar\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[1,7]},{id:11,description:'repeatedly',englishModifier:function englishModifier(english){return' repeatedly'+english;},expression:'-lar\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[1]},{id:12,description:'doing it again',englishModifier:function englishModifier(english){return' (again)'+english;},expression:'-nqigte\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[1]},{id:13,description:'almost',englishModifier:function englishModifier(english){return' almost'+english;},expression:'@~+yarpiar\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[1]},{id:14,description:'never',englishModifier:function englishModifier(english){return' never'+english;},expression:'@-~yuite\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[1]},{id:15,description:'no longer',englishModifier:function englishModifier(english){return' no longer'+english;},expression:'-nrir\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,27]},{id:16,description:'trying (unsuccessfully) to',englishModifier:function englishModifier(english){return' trying (unsuccessfully) to'+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return' try (unsuccessfully) to'+english;},englishModifierGerund:function englishModifierGerund(english){return' trying (unsuccessfully) to'+english;},expression:'@~+yaaqe\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,17,19]},{id:17,description:'trying despite difficulties to',englishModifier:function englishModifier(english){return' trying despite difficulties to'+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return' try despite difficulties to'+english;},englishModifierGerund:function englishModifierGerund(english){return' trying despite difficulties to'+english;},expression:'-qcaar(ar)\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,16,18]},{id:18,description:'trying to',englishModifier:function englishModifier(english){return' trying to'+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return' try to'+english;},englishModifierGerund:function englishModifierGerund(english){return' trying to'+english;},expression:'-6naqe\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,16,17]},{id:19,description:'excessively (too much)',englishModifier:function englishModifier(english){return' excessively'+english;},expression:'-3iyaag\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[1]},{id:20,description:'to be more or better at',englishModifier:function englishModifier(english){return' (being more or better at)'+english;},expression:'-nru\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[1]},{id:21,description:'loves to',englishModifier:function englishModifier(english){return' loves to'+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return' love to'+english;},englishModifierGerund:function englishModifierGerund(english){return' loving to'+english;},expression:'@~+yunqe4\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,7,8]},{id:22,description:'no longer wants to',englishModifier:function englishModifier(english){return' no longer wants to'+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return' no longer want to'+english;},englishModifierGerund:function englishModifierGerund(english){return' no longer wanting to'+english;},expression:'@~+yuumiir(ar)te\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,7,8]},{id:23,description:'not care to',englishModifier:function englishModifier(english){return' not care to'+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return' not care to'+english;},englishModifierGerund:function englishModifierGerund(english){return' not caring to'+english;},expression:'@~+yuumiite\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,7,8]},{id:24,description:'yearns to',englishModifier:function englishModifier(english){return' yearns to'+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return' yearn to'+english;},englishModifierGerund:function englishModifierGerund(english){return' yearning to'+english;},expression:'@~+yuumir\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,7,8]},{id:25,description:'wants to',englishModifier:function englishModifier(english){return' wants to'+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return' want to'+english;},englishModifierGerund:function englishModifierGerund(english){return' wanting to'+english;},expression:'@~+yug\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,7,8]},{id:26,description:'enjoys doing',englishModifier:function englishModifier(english){return' enjoying'+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return' enjoy'+english;},englishModifierGerund:function englishModifierGerund(english){return' enjoying'+english;},expression:'@~+yugar\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,7,8]},{id:27,description:'not',englishModifier:function englishModifier(english){return' not'+english;},expression:'-nrite\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1]},// {
//   id: 28,
//   description: 'to ask one to',
//   englishModifier: (english) => { return 'to ask one to' + english; },
//   expression: 'sqe-\\',
//   expression_conditional: '',
//   conditional_rule: '',
//   tense:'',
//   allowable_next_ids: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
// },
{id:28,description:'in the process of',englishModifier:function englishModifier(english){return' in the process of'+english;},expression:'@~+yartur\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,2,3,4,5,6,7,8,9,10,19]},{id:29,description:'definitely no longer going to',englishModifier:function englishModifier(english){return' definitely no longer going to'+english;},expression:'@~+yugnairute\\',expression_conditional:'',priority:1,conditional_rule:'',tense:'',allowable_next_ids:[0,1,3,4,8,10]// only refers to the postbases, not the endings
}];var nounPostbases=[{id:0,description:'large',englishModifier:function englishModifier(english){return'large'+english;},expression_end:'-rpak',expression_postbase:'-rpag\\',expression_conditional_end:'',expression_conditional_postbase:'',conditional_rule:'',priority:4,tense:'',allowable_next_ids:[1]},{id:1,description:'small',englishModifier:function englishModifier(english){return'small'+english;},expression_end:'-cuar',expression_postbase:'-cuar\\',expression_conditional_end:'-kcuar',expression_conditional_postbase:'-kcuar(ar)\\',conditional_rule:'',priority:4,tense:'',allowable_next_ids:[0]},{id:2,description:'baby/little',englishModifier:function englishModifier(english){return'baby/little'+english;},expression_end:'-yagaq',expression_postbase:'-yagar\\',expression_conditional_end:'-yagaq',expression_conditional_postbase:'-yagar\\',conditional_rule:'',priority:4,tense:'',allowable_next_ids:[]},{id:3,description:'good',englishModifier:function englishModifier(english){return'good'+english;},expression_end:'-kegtaar',expression_postbase:'-kegtaar\\',expression_conditional_end:'',expression_conditional_postbase:'',conditional_rule:'',priority:4,tense:'',allowable_next_ids:[]},{id:4,description:'shabby',englishModifier:function englishModifier(english){return'shabby'+english;},expression_end:'-2er',expression_postbase:'-2er\\',expression_conditional_end:'-2er',expression_conditional_postbase:'-2er\\',conditional_rule:'',priority:4,tense:'',allowable_next_ids:[]},{id:5,description:'genuine',englishModifier:function englishModifier(english){return'genuine'+english;},expression_end:'-piaq',expression_postbase:'-piar\\',expression_conditional_end:'-pik',expression_conditional_postbase:'-pig\\',conditional_rule:'',priority:4,tense:'past',allowable_next_ids:[]},{id:6,description:'fake',englishModifier:function englishModifier(english){return'fake'+english;},expression_end:'-(6)uaq',expression_postbase:'-(6)uar\\',expression_conditional_end:'',expression_conditional_postbase:'',conditional_rule:'',priority:4,tense:'',allowable_next_ids:[]},{id:7,description:'many Ns',englishModifier:function englishModifier(english){return'many of them'+english;},expression_end:'-rugaq',expression_postbase:'-rugar\\',expression_conditional_end:'',expression_conditional_postbase:'',conditional_rule:'',priority:2,tense:'noun_end',allowable_next_ids:[]},{id:8,description:'just a little',englishModifier:function englishModifier(english){return'just a little'+english;},expression_end:'-5aq',expression_postbase:'-5ar\\',expression_conditional_end:'',expression_conditional_postbase:'',conditional_rule:'',priority:2,tense:'noun_end',allowable_next_ids:[]},{id:9,description:'N and other',englishModifier:function englishModifier(english){return'and another - only applies to people or animals'+english;},expression_end:':(e)nkuk',expression_postbase:':(e)nkug\\',expression_conditional_end:'',expression_conditional_postbase:'',conditional_rule:'',priority:2,tense:'noun_end',allowable_next_ids:[]},{id:10,description:'N and others',englishModifier:function englishModifier(english){return'and others - only applies to people or animals'+english;},expression_end:':(e)nkut',expression_postbase:':(e)nkur\\',expression_conditional_end:'',expression_conditional_postbase:'',conditional_rule:'',priority:2,tense:'noun_end',allowable_next_ids:[]},{id:11,description:'to hunt',englishModifier:function englishModifier(english){return'hunting'+english;},expression_postbase:'+cur\\',expression_conditional_postbase:'+ssur\\',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:12,description:'to make',englishModifier:function englishModifier(english){return'making'+english;},expression_postbase:'-li\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:13,description:'to catch lots of',englishModifier:function englishModifier(english){return'catching lots of'+english;},expression_postbase:'-liqe\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:14,description:'to have lots of',englishModifier:function englishModifier(english){return'lots of'+english;},expression_postbase:'-lir\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:15,description:'to be occupied with',englishModifier:function englishModifier(english){return'occupied with'+english;},expression_postbase:'-liur\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:16,description:'to acquire',englishModifier:function englishModifier(english){return'acquiring'+english;},expression_postbase:'-6e\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:17,description:'to have',englishModifier:function englishModifier(english){return''+english;},expression_postbase:'-ngqerr\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:18,description:'the place does not have',englishModifier:function englishModifier(english){return'(location) does not have'+english;},expression_postbase:'+taite\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:19,description:'the place has',englishModifier:function englishModifier(english){return'(location) has'+english;},expression_postbase:'+ta6qe5\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:20,description:'to eat',englishModifier:function englishModifier(english){return'eating'+english;},expression_postbase:'+tur\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]},{id:21,description:'to become',englishModifier:function englishModifier(english){return'become'+english;},expression_postbase:'~:(6)urte\\',expression_conditional_postbase:'',conditional_rule:'',priority:1,tense:'',allowable_next_ids:[]}];

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(250);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(49);
var createDesc = __webpack_require__(80);
module.exports = __webpack_require__(50) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(503);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(512);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(83),
    isArrayLike = __webpack_require__(28),
    isIndex = __webpack_require__(84),
    isObject = __webpack_require__(25);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(700),
    keys = __webpack_require__(26);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Image__ = __webpack_require__(337);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Image__["a"]; });



/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(228)))

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export speakerColors */
/* unused harmony export inupiaqSpeakerIDs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return popularVerbsOptative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return popularNounsDescriptors; });
/* unused harmony export popularVerbs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return popularVerbsIT; });
/* unused harmony export popularVerbsI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return popularVerbsT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return popularNounsBeings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return popularNounsThings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return popularNounsPlaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return popularNounsVialis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return popularVPostbasesSub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return popularOptPostbases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return popularNPostbases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return popularVPostbasesNOTIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return popularVPostbasesPAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return popularVPostbasesFUTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return colorsList; });
/* unused harmony export retrieveMoodEnglish */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return nounoptions1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return nounoptionsmodalis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return nounoptions2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return nounOptionsPossessorsNo4th; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return nounOptionsMVPossessorsThe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return nounOptionsMVPossessors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return nounOptionsNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return mvSubjectOptionsEnglish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mvObjectOptionsEnglish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return npnEnglish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return npnEnglishself; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return mvSubject4thPersonCalls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mvObject4thPersonCalls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return nObject4thPersonCalls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return mvSubjectOptionsOnly2nd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mvSubjectOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mvObjectOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return mvSubjectOptionsWho; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return mvObjectOptionsWhom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return mvSubjectOptionsWhat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return mvObjectOptionsWhat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return mvObjectOptionsWhomAbl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return mvObjectOptionsWhatAbl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return options1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return options2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return options3; });
/* unused harmony export retrieveSubjectObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return retrieveReflexiveSubjectPronoun; });
/* unused harmony export NNpostbases */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VVpostbases; });
/* unused harmony export verbPostbases */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return nounPostbases; });
var speakerColors={0:'red',1:'orange',2:'yellow',3:'green',4:'#2e2eb9',5:'purple',6:'purple',7:'black',8:'gold'};var inupiaqSpeakerIDs={"Aglu (Whittier Williams Jr.)":0,"I'yiiqpak (Gladys Pungowiyi)":1,"Kapniaq (Lorena Williams)":2,"Maqik (Mary Schaeffer)":3,"Mumigaaluk (James Nageak)":4,"Paniattaaq (Dr. Edna Ahgeak MacLean)":5,"Taġġaq (Lawrence Kaplan)":6,"Uyuġuluk (Marilyn Koezuna-Irelan)":7,"Yaayuk (Bernadette Alvanna-Stimpfle)":8};var popularVerbsOptative=[{'englishnorm':'eat','yupikword':"ner'uq",'inf_preverb':'eat','past_preverb':'ate','fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating','englishraw':'\u27E8eat\u27E9','base_case':'is eating','ger_preverb':'eating','usageIndex':0,'type':'i'},{'englishnorm':'come in','yupikword':'itertuq','inf_preverb':'come in','past_preverb':'came in','fsts':['iter'],'fstsDisplay':'iter-','key':'iter-','englishtenses':['come','came','comes','coming','come'],'properties':[],'englishmain':'came in','englishraw':'\u27E8come\u27E9 in','base_case':'came in','ger_preverb':'coming in','usageIndex':0,'type':'i'},{'englishnorm':'go out','yupikword':"an'uq",'inf_preverb':'go out','past_preverb':'went out','fsts':['ane'],'fstsDisplay':'ane-','key':'ane-','englishtenses':['go','went','goes','going','gone'],'properties':[],'englishmain':'went out','englishraw':'\u27E8go\u27E9 out','base_case':'went out','ger_preverb':'going out','usageIndex':0,'type':'i'},{'englishnorm':'sit down','yupikword':'aqumuq','inf_preverb':'sit down','past_preverb':'sat down','fsts':['aqume'],'fstsDisplay':'aqume-','key':'aqume-','englishtenses':['sit','sat','sits','sitting','sat'],'properties':[],'englishmain':'sat down','englishraw':'\u27E8sit\u27E9 down','base_case':'sat down','ger_preverb':'sitting down','usageIndex':0,'type':'i'},{'englishnorm':'lay down','yupikword':'inartuq','inf_preverb':'lay down','past_preverb':'laid down','fsts':['inarte'],'fstsDisplay':'inarte-','key':'inarte-','englishtenses':['lay','laid','lays','laying','laid'],'properties':[],'englishmain':'lay down','englishraw':'\u27E8lay\u27E9 down','base_case':'lay down','ger_preverb':'laying down','usageIndex':0,'type':'i'},{'englishnorm':'work','yupikword':'caliuq','inf_preverb':'work','past_preverb':'worked','fsts':['cali'],'fstsDisplay':'cali-','key':'cali-','englishtenses':['work','worked','works','working','worked'],'properties':[],'englishmain':'!is! working','englishraw':'\u27E8work\u27E9','base_case':'is working','ger_preverb':'working','usageIndex':0,'type':'i'},{'englishnorm':'get up','yupikword':'maktuq','inf_preverb':'get up','past_preverb':'got up','fsts':['makte'],'fstsDisplay':'makte-','key':'makte-','englishtenses':['get','got','gets','getting','got'],'properties':[],'englishmain':'got up','englishraw':'\u27E8get\u27E9 up','base_case':'got up','ger_preverb':'getting up','usageIndex':0,'type':'i'},{'englishnorm':'listen','yupikword':'niicugniuq','inf_preverb':'listen','past_preverb':'listened','fsts':['niicugni'],'fstsDisplay':'niicugni-','key':'niicugni-','englishtenses':['listen','listened','listens','listening','listened'],'properties':[],'englishmain':'!is! listening','englishraw':'\u27E8listen\u27E9','base_case':'is listening','ger_preverb':'listening','usageIndex':0,'type':'i'},{'englishnorm':'answer','yupikword':'kiugaa','inf_preverb':'answer <him>','past_preverb':'answered <him>','fsts':['ki'],'fstsDisplay':'kiu-','key':'kiu-','englishtenses':['answer','answered','answers','answering','answered'],'properties':[],'englishmain':'answered <him>','englishraw':'\u27E8answer\u27E9 <him>','base_case':'answered him','ger_preverb':'answering <him>','usageIndex':2,'type':'t'},{'englishnorm':'try','yupikword':'naspaagaa','inf_preverb':'try <it>','past_preverb':'tried <it>','fsts':['naspaa'],'fstsDisplay':'naspaa-','key':'naspaa-','englishtenses':['try','tried','tries','trying','tried'],'properties':[],'englishmain':'!is! trying <it>','englishraw':'\u27E8try\u27E9 <it>','base_case':'is trying it','ger_preverb':'trying <it>','usageIndex':2,'type':'t'},{'englishnorm':'own','yupikword':'pikaa','inf_preverb':'own <it>','past_preverb':'owned <it>','fsts':['pike'],'fstsDisplay':'pike-','key':'pike-','englishtenses':['own','owned','owns','owning','owned'],'properties':[],'englishmain':'owns <it>','englishraw':'\u27E8own\u27E9 <it>','base_case':'owns it','ger_preverb':'owning <it>','usageIndex':0,'type':'t'},{'englishnorm':'give to someone','yupikword':'tunaa','inf_preverb':'give <it> to someone','past_preverb':'gave <it> to someone','fsts':['tune'],'fstsDisplay':'tune-','key':'tune-','englishtenses':['give','gave','gives','giving','given'],'properties':[],'englishmain':'gave <it> to someone','englishraw':'\u27E8give\u27E9 <it> to someone','base_case':'gave it to someone','ger_preverb':'giving <it> to someone','usageIndex':4,'type':'t'},{'englishnorm':'use','yupikword':'aturaa','inf_preverb':'use <it>','past_preverb':'used <it>','fsts':['atur'],'fstsDisplay':'atur-','key':'atuq,atur-','englishtenses':['use','used','uses','using','used'],'properties':[],'englishmain':'!is! using <it>','englishraw':'\u27E8use\u27E9 <it>','base_case':'is using it','ger_preverb':'using <it>','usageIndex':3,'type':'t'},{'englishnorm':'open','yupikword':'ikirtaa','inf_preverb':'open <it>','past_preverb':'opened <it>','fsts':['ikirte'],'fstsDisplay':'ikirte-','key':'ikirte-','englishtenses':['open','opened','opens','opening','opened'],'properties':[],'englishmain':'opened <it>','englishraw':'\u27E8open\u27E9 <it>','base_case':'opened it','ger_preverb':'opening <it>','usageIndex':2,'type':'t'},{'englishnorm':'buy','yupikword':'kiputaa','inf_preverb':'buy <it>','past_preverb':'bought <it>','fsts':['kipute'],'fstsDisplay':'kipute-','key':'kipute-','englishtenses':['buy','bought','buys','buying','bought'],'properties':[],'englishmain':'bought <it>','englishraw':'\u27E8buy\u27E9 <it>','base_case':'bought it','ger_preverb':'buying <it>','usageIndex':2,'type':'t'},{'englishnorm':'wash','yupikword':'eruraa','inf_preverb':'wash <it>','past_preverb':'washed <it>','fsts':['erur'],'fstsDisplay':'erur-','key':'erur-','englishtenses':['wash','washed','washes','washing','washed'],'properties':[],'englishmain':'!is! washing <it>','englishraw':'\u27E8wash\u27E9 <it>','base_case':'is washing it','ger_preverb':'washing <it>','usageIndex':2,'type':'t'},{'englishnorm':'pass over','yupikword':'taitaa','inf_preverb':'pass <it> over','past_preverb':'passed <it> over','fsts':['taite\xb9'],'fstsDisplay':'taite\xb9-','key':'taite\xb9-','englishtenses':['pass','passed','passes','passing','passed'],'properties':[],'englishmain':'passed <it> over','englishraw':'\u27E8pass\u27E9 <it> over','base_case':'passed it over','ger_preverb':'passing <it> over','usageIndex':2,'type':'t'},{'englishnorm':'go with','yupikword':'maligtaa','inf_preverb':'go with <her*>','past_preverb':'went with <her*>','fsts':['maligte'],'fstsDisplay':'maligte-','key':'maligte-','englishtenses':['go','went','goes','going','gone'],'properties':[],'englishmain':'!is! going with <her*>','englishraw':'\u27E8go\u27E9 with <her*>','base_case':'is going with her*','ger_preverb':'going with <her*>','usageIndex':0,'type':'t'},{'englishnorm':'eat','yupikword':'neraa','inf_preverb':'eat <it>','past_preverb':'ate <it>','fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating <it>','englishraw':'\u27E8eat\u27E9 <it>','base_case':'is eating it','ger_preverb':'eating <it>','usageIndex':2,'type':'t'},{'englishnorm':'ask','yupikword':'aptaa','inf_preverb':'ask <her*>','past_preverb':'asked <her*>','fsts':['apte'],'fstsDisplay':'apte-','key':'apte-','englishtenses':['ask','asked','asks','asking','asked'],'properties':[],'englishmain':'asked <her*>','englishraw':'\u27E8ask\u27E9 <her*>','base_case':'asked her*','ger_preverb':'asking <her*>','usageIndex':2,'type':'t'}];var popularNounsDescriptors=[{'englishnorm':'new thing, fresh thing, fresh fish','yupikword':'nutaraq','fsts':['nutarar'],'fstsDisplay':'nutarar-','key':'nutaraq','englishtenses':[['thing','things'],['thing','things'],['fish','fish']],'properties':[],'englishmain':['new \u27E8thing\u27E9','fresh \u27E8thing\u27E9','fresh \u27E8fish\u27E9'],'englishraw':'new \u27E8thing\u27E9, fresh \u27E8thing\u27E9, fresh \u27E8fish\u27E9','base_case':'new thing, fresh thing, fresh fish','usageIndex':0,'type':'n'},{'englishnorm':'old thing, thing of the past','yupikword':"ak'allaq",'fsts':["ak'allar"],'fstsDisplay':"ak'allar-",'key':"ak'allaq",'englishtenses':[['thing','things'],['thing','things']],'properties':[],'englishmain':['old \u27E8thing\u27E9','\u27E8thing\u27E9 of the past'],'englishraw':'old \u27E8thing\u27E9, \u27E8thing\u27E9 of the past','base_case':'old thing, thing of the past','usageIndex':0,'type':'n'},{'englishnorm':'big thing','yupikword':'angtuaq','fsts':['angtuar'],'fstsDisplay':'angtuar-','key':'angtuaq','englishtenses':[['thing','things']],'properties':[],'englishmain':['big \u27E8thing\u27E9'],'englishraw':'big \u27E8thing\u27E9','base_case':'big thing','usageIndex':0,'type':'n'},{'englishnorm':'white person, Caucasian, priest, especially Russian Orthodox priest','yupikword':"kass'aq",'fsts':["kass'ar"],'fstsDisplay':"kass'ar-",'key':"kass'aq",'englishtenses':[['person','people'],['Caucasian','Caucasians'],['priest','priests'],['priest','priests']],'properties':[],'englishmain':['white \u27E8person\u27E9','\u27E8Caucasian\u27E9','\u27E8priest\u27E9','especially Russian Orthodox \u27E8priest\u27E9'],'englishraw':'white \u27E8person\u27E9, \u27E8Caucasian\u27E9, \u27E8priest\u27E9, especially Russian Orthodox \u27E8priest\u27E9','base_case':'white person, Caucasian, priest, especially Russian Orthodox priest','usageIndex':0,'type':'n'},{'englishnorm':'red thing, low-bush cranberry (Vaccinium vitis-idaea)','yupikword':'kavirliq','fsts':['kavirlir'],'fstsDisplay':'kavirlir-','key':'kavirliq','englishtenses':[['thing','things'],['cranberry','cranberries']],'properties':[],'englishmain':['red \u27E8thing\u27E9','low-bush \u27E8cranberry\u27E9 (Vaccinium vitis-idaea)'],'englishraw':'red \u27E8thing\u27E9, low-bush \u27E8cranberry\u27E9 (Vaccinium vitis-idaea)','base_case':'red thing, low-bush cranberry (Vaccinium vitis-idaea)','usageIndex':0,'type':'n'},{'englishnorm':'black thing','yupikword':'tungulria','fsts':['tungulria'],'fstsDisplay':'tungulria-','key':'tungulria','englishtenses':[['thing','things']],'properties':[],'englishmain':['black \u27E8thing\u27E9'],'englishraw':'black \u27E8thing\u27E9','base_case':'black thing','usageIndex':0,'type':'n'},{'englishnorm':'white thing, the color white','yupikword':'qatellria','fsts':['qatellria','qatelria'],'fstsDisplay':'qatellria-, qatelria-','key':'qatellria,qatelria','englishtenses':[['thing','things']],'properties':[],'englishmain':['white \u27E8thing\u27E9, the color white'],'englishraw':'white \u27E8thing\u27E9, the color white','base_case':'white thing, the color white','usageIndex':0,'type':'n'},{'englishnorm':'green thing','yupikword':'cungagliq','fsts':['cungaglir'],'fstsDisplay':'cungaglir-','key':'cungagliq','englishtenses':[['thing','things']],'properties':[],'englishmain':['green \u27E8thing\u27E9'],'englishraw':'green \u27E8thing\u27E9','base_case':'green thing','usageIndex':0,'type':'n'},{'englishnorm':'yellow thing','yupikword':'esirliq','fsts':['esirlir','esirngalngur*'],'fstsDisplay':'esirlir-, esirngalngur*-','key':'esirliq,esirngalnguq*','englishtenses':[['thing','things']],'properties':[],'englishmain':['yellow \u27E8thing\u27E9'],'englishraw':'yellow \u27E8thing\u27E9','base_case':'yellow thing','usageIndex':0,'type':'n'}];var popularVerbs=[{'englishnorm':'eat','yupikword':"ner'uq",'fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating','englishraw':'\u27E8eat\u27E9','base_case':'eat','usageIndex':0,'type':'i'},{'englishnorm':'eat','yupikword':"ner'uq",'fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating <something>','englishraw':'\u27E8eat\u27E9 <something>','base_case':'eat','usageIndex':1,'type':'it'},{'englishnorm':'eat','yupikword':'neraa','fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating <it>','englishraw':'\u27E8eat\u27E9 <it>','base_case':'eat','usageIndex':2,'type':'t'},{'englishnorm':'hunt','yupikword':'pissurtuq','fsts':['pissur'],'fstsDisplay':'pissur-','key':'pissur-','englishtenses':['hunt','hunted','hunts','hunting','hunted'],'properties':[],'englishmain':'!is! hunting <something>','englishraw':'\u27E8hunt\u27E9 <something>','base_case':'hunt','usageIndex':1,'type':'it'},{'englishnorm':'hunt','yupikword':'pissuraa','fsts':['pissur'],'fstsDisplay':'pissur-','key':'pissur-','englishtenses':['hunt','hunted','hunts','hunting','hunted'],'properties':[],'englishmain':'!is! hunting <it>','englishraw':'\u27E8hunt\u27E9 <it>','base_case':'hunt','usageIndex':2,'type':'t'},{'englishnorm':'leave','yupikword':'ayagtuq','fsts':['ayag\xb9'],'fstsDisplay':'ayag\xb9-','key':'ayag\xb9-','englishtenses':['leave','left','leaves','leaving','left'],'properties':[],'englishmain':'left','englishraw':'\u27E8leave\u27E9','base_case':'leave','usageIndex':0,'type':'i'},{'englishnorm':'come here','yupikword':'taiguq','fsts':['tai'],'fstsDisplay':'tai-','key':'tai-','englishtenses':['come','came','comes','coming','come'],'properties':[],'englishmain':'came here','englishraw':'\u27E8come\u27E9 here','base_case':'come here','usageIndex':0,'type':'i'},{'englishnorm':'come in','yupikword':'itertuq','fsts':['iter'],'fstsDisplay':'iter-','key':'iter-','englishtenses':['come','came','comes','coming','come'],'properties':[],'englishmain':'came in','englishraw':'\u27E8come\u27E9 in','base_case':'come in','usageIndex':0,'type':'i'},{'englishnorm':'go out','yupikword':"an'uq",'fsts':['ane'],'fstsDisplay':'ane-','key':'ane-','englishtenses':['go','went','goes','going','gone'],'properties':[],'englishmain':'went out','englishraw':'\u27E8go\u27E9 out','base_case':'go out','usageIndex':0,'type':'i'},{'englishnorm':'buy','yupikword':'kiputaa','fsts':['kipute'],'fstsDisplay':'kipute-','key':'kipute-','englishtenses':['buy','bought','buys','buying','bought'],'properties':[],'englishmain':'bought <it>','englishraw':'\u27E8buy\u27E9 <it>','base_case':'buy','usageIndex':2,'type':'t'},{'englishnorm':'open','yupikword':'ikirtaa','fsts':['ikirte'],'fstsDisplay':'ikirte-','key':'ikirte-','englishtenses':['open','opened','opens','opening','opened'],'properties':[],'englishmain':'opened <it>','englishraw':'\u27E8open\u27E9 <it>','base_case':'open','usageIndex':2,'type':'t'},{'englishnorm':'sit down','yupikword':'aqumuq','fsts':['aqume'],'fstsDisplay':'aqume-','key':'aqume-','englishtenses':['sit','sat','sits','sitting','sat'],'properties':[],'englishmain':'sat down','englishraw':'\u27E8sit\u27E9 down','base_case':'sit down','usageIndex':0,'type':'i'},{'englishnorm':'stand up','yupikword':'nangertuq','fsts':['nangerte'],'fstsDisplay':'nangerte-','key':'nangerte-','englishtenses':['stand','stood','stands','standing','stood'],'properties':[],'englishmain':'stood up','englishraw':'\u27E8stand\u27E9 up','base_case':'stand up','usageIndex':0,'type':'i'},{'englishnorm':'be well','yupikword':'assirtuq','fsts':['assir'],'fstsDisplay':'assir-','key':'assir-','englishtenses':['be','was','is','being','been'],'properties':[],'englishmain':'!is! well','englishraw':'\u27E8be\u27E9 well','base_case':'be well','usageIndex':0,'type':'i'},{'englishnorm':'be bad','yupikword':'assiituq','fsts':['assiite'],'fstsDisplay':'assiite-','key':'assiite-','englishtenses':['be','was','is','being','been'],'properties':[],'englishmain':'!is! bad','englishraw':'\u27E8be\u27E9 bad','base_case':'be bad','usageIndex':0,'type':'i'},{'englishnorm':'be thankful, glad','yupikword':'quyauq','fsts':['quya'],'fstsDisplay':'quya-','key':'quya-','englishtenses':['be','was','is','being','been'],'properties':[],'englishmain':'!is! thankful, glad','englishraw':'\u27E8be\u27E9 thankful, glad','base_case':'be thankful, glad','usageIndex':0,'type':'i'},{'englishnorm':'act','yupikword':'piuq','fsts':['pi'],'fstsDisplay':'pi-','key':'pi,pi-','englishtenses':['act','acted','acts','acting','acted'],'properties':[],'englishmain':'!is! acting','englishraw':'\u27E8act\u27E9','base_case':'act','usageIndex':1,'type':'i'},{'englishnorm':'drink coffee','yupikword':'kuuvviartuq','fsts':['kuuvviar'],'fstsDisplay':'kuuvviar-','key':'kuuvviaq,kuuvviar-','englishtenses':['drink','drank','drinks','drinking','drunk'],'properties':[],'englishmain':'!is! drinking coffee','englishraw':'\u27E8drink\u27E9 coffee','base_case':'drink coffee','usageIndex':1,'type':'i'},{'englishnorm':'speak','yupikword':'qanertuq','fsts':['qaner'],'fstsDisplay':'qaner-','key':'qaneq,qaner-','englishtenses':['speak','spoke','speaks','speaking','spoken'],'properties':[],'englishmain':'!is! speaking','englishraw':'\u27E8speak\u27E9','base_case':'speak','usageIndex':1,'type':'i'},{'englishnorm':'tell','yupikword':'qanrutaa','fsts':['qanrute'],'fstsDisplay':'qanrute-','key':'qanrute-','englishtenses':['tell','told','tells','telling','told'],'properties':[],'englishmain':'told <him>','englishraw':'\u27E8tell\u27E9 <him>','base_case':'tell','usageIndex':2,'type':'t'},{'englishnorm':'ask','yupikword':'aptuq','fsts':['apte'],'fstsDisplay':'apte-','key':'apte-','englishtenses':['ask','asked','asks','asking','asked'],'properties':[],'englishmain':'asked','englishraw':'\u27E8ask\u27E9','base_case':'ask','usageIndex':0,'type':'i'},{'englishnorm':'sleep','yupikword':'qavartuq','fsts':['qavar'],'fstsDisplay':'qavar-','key':'qavaq,qavar-','englishtenses':['sleep','slept','sleeps','sleeping','slept'],'properties':[],'englishmain':'!is! sleeping','englishraw':'\u27E8sleep\u27E9','base_case':'sleep','usageIndex':1,'type':'i'},{'englishnorm':'lay down','yupikword':'inartuq','fsts':['inarte'],'fstsDisplay':'inarte-','key':'inarte-','englishtenses':['lay','laid','lays','laying','laid'],'properties':[],'englishmain':'lay down','englishraw':'\u27E8lay\u27E9 down','base_case':'lay down','usageIndex':0,'type':'i'},{'englishnorm':'get up','yupikword':'maktuq','fsts':['makte'],'fstsDisplay':'makte-','key':'makte-','englishtenses':['get','got','gets','getting','got'],'properties':[],'englishmain':'got up','englishraw':'\u27E8get\u27E9 up','base_case':'get up','usageIndex':0,'type':'i'},{'englishnorm':'hear','yupikword':'niituq','fsts':['niite'],'fstsDisplay':'niite-','key':'niite-','englishtenses':['hear','heard','hears','hearing','heard'],'properties':[],'englishmain':'hears <someone or something>','englishraw':'\u27E8hear\u27E9 <someone or something>','base_case':'hear','usageIndex':1,'type':'it'},{'englishnorm':'listen','yupikword':'niicugniuq','fsts':['niicugni'],'fstsDisplay':'niicugni-','key':'niicugni-','englishtenses':['listen','listened','listens','listening','listened'],'properties':[],'englishmain':'!is! listening','englishraw':'\u27E8listen\u27E9','base_case':'listen','usageIndex':0,'type':'i'},{'englishnorm':'wash','yupikword':'eruraa','fsts':['erur'],'fstsDisplay':'erur-','key':'erur-','englishtenses':['wash','washed','washes','washing','washed'],'properties':[],'englishmain':'!is! washing <it>','englishraw':'\u27E8wash\u27E9 <it>','base_case':'wash','usageIndex':2,'type':'t'},{'englishnorm':'walk','yupikword':'piyuaguq','fsts':['piyua'],'fstsDisplay':'piyua-','key':'piyua-','englishtenses':['walk','walked','walks','walking','walked'],'properties':[],'englishmain':'!is! walking','englishraw':'\u27E8walk\u27E9','base_case':'walk','usageIndex':0,'type':'i'},{'englishnorm':'run','yupikword':'aqvaqurtuq','fsts':['aqvaqur'],'fstsDisplay':'aqvaqur-','key':'aqvaqur-','englishtenses':['run','ran','runs','running','run'],'properties':[],'englishmain':'!is! running','englishraw':'\u27E8run\u27E9','base_case':'run','usageIndex':0,'type':'i'},{'englishnorm':'dance','yupikword':'yurartuq','fsts':['yurar\xb9'],'fstsDisplay':'yurar\xb9-','key':'yuraq,yurar\xb9-','englishtenses':['dance','danced','dances','dancing','danced'],'properties':[],'englishmain':'!is! dancing','englishraw':'\u27E8dance\u27E9','base_case':'dance','usageIndex':1,'type':'i'},{'englishnorm':'hook for fish','yupikword':'manartuq','fsts':['manar'],'fstsDisplay':'manar-','key':'manaq,manar-','englishtenses':['hook','hooked','hooks','hooking','hooked'],'properties':[],'englishmain':'!is! hooking for fish','englishraw':'\u27E8hook\u27E9 for fish','base_case':'hook for fish','usageIndex':1,'type':'i'}];var popularVerbsIT=[{'englishnorm':'eat','yupikword':"ner'uq",'fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating','englishraw':'\u27E8eat\u27E9','base_case':'eat','usageIndex':0,'type':'i'},{'englishnorm':'eat','yupikword':"ner'uq",'fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating <something>','englishraw':'\u27E8eat\u27E9 <something>','base_case':'eat','usageIndex':1,'type':'it'},{'englishnorm':'eat','yupikword':'neraa','fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating <it>','englishraw':'\u27E8eat\u27E9 <it>','base_case':'eat','usageIndex':2,'type':'t'},{'englishnorm':'hunt','yupikword':'pissurtuq','fsts':['pissur'],'fstsDisplay':'pissur-','key':'pissur-','englishtenses':['hunt','hunted','hunts','hunting','hunted'],'properties':[],'englishmain':'!is! hunting <something>','englishraw':'\u27E8hunt\u27E9 <something>','base_case':'hunt','usageIndex':1,'type':'it'},{'englishnorm':'hunt','yupikword':'pissuraa','fsts':['pissur'],'fstsDisplay':'pissur-','key':'pissur-','englishtenses':['hunt','hunted','hunts','hunting','hunted'],'properties':[],'englishmain':'!is! hunting <it>','englishraw':'\u27E8hunt\u27E9 <it>','base_case':'hunt','usageIndex':2,'type':'t'},{'englishnorm':'leave','yupikword':'ayagtuq','fsts':['ayag\xb9'],'fstsDisplay':'ayag\xb9-','key':'ayag\xb9-','englishtenses':['leave','left','leaves','leaving','left'],'properties':[],'englishmain':'left','englishraw':'\u27E8leave\u27E9','base_case':'leave','usageIndex':0,'type':'i'},{'englishnorm':'come here','yupikword':'taiguq','fsts':['tai'],'fstsDisplay':'tai-','key':'tai-','englishtenses':['come','came','comes','coming','come'],'properties':[],'englishmain':'came here','englishraw':'\u27E8come\u27E9 here','base_case':'come here','usageIndex':0,'type':'i'},{'englishnorm':'come in','yupikword':'itertuq','fsts':['iter'],'fstsDisplay':'iter-','key':'iter-','englishtenses':['come','came','comes','coming','come'],'properties':[],'englishmain':'came in','englishraw':'\u27E8come\u27E9 in','base_case':'come in','usageIndex':0,'type':'i'},{'englishnorm':'go out','yupikword':"an'uq",'fsts':['ane'],'fstsDisplay':'ane-','key':'ane-','englishtenses':['go','went','goes','going','gone'],'properties':[],'englishmain':'went out','englishraw':'\u27E8go\u27E9 out','base_case':'go out','usageIndex':0,'type':'i'},{'englishnorm':'buy','yupikword':'kiputaa','fsts':['kipute'],'fstsDisplay':'kipute-','key':'kipute-','englishtenses':['buy','bought','buys','buying','bought'],'properties':[],'englishmain':'bought <it>','englishraw':'\u27E8buy\u27E9 <it>','base_case':'buy','usageIndex':2,'type':'t'},{'englishnorm':'open','yupikword':'ikirtaa','fsts':['ikirte'],'fstsDisplay':'ikirte-','key':'ikirte-','englishtenses':['open','opened','opens','opening','opened'],'properties':[],'englishmain':'opened <it>','englishraw':'\u27E8open\u27E9 <it>','base_case':'open','usageIndex':2,'type':'t'},{'englishnorm':'sit down','yupikword':'aqumuq','fsts':['aqume'],'fstsDisplay':'aqume-','key':'aqume-','englishtenses':['sit','sat','sits','sitting','sat'],'properties':[],'englishmain':'sat down','englishraw':'\u27E8sit\u27E9 down','base_case':'sit down','usageIndex':0,'type':'i'},{'englishnorm':'stand up','yupikword':'nangertuq','fsts':['nangerte'],'fstsDisplay':'nangerte-','key':'nangerte-','englishtenses':['stand','stood','stands','standing','stood'],'properties':[],'englishmain':'stood up','englishraw':'\u27E8stand\u27E9 up','base_case':'stand up','usageIndex':0,'type':'i'},{'englishnorm':'be well','yupikword':'assirtuq','fsts':['assir'],'fstsDisplay':'assir-','key':'assir-','englishtenses':['be','was','is','being','been'],'properties':[],'englishmain':'!is! well','englishraw':'\u27E8be\u27E9 well','base_case':'be well','usageIndex':0,'type':'i'},{'englishnorm':'be bad','yupikword':'assiituq','fsts':['assiite'],'fstsDisplay':'assiite-','key':'assiite-','englishtenses':['be','was','is','being','been'],'properties':[],'englishmain':'!is! bad','englishraw':'\u27E8be\u27E9 bad','base_case':'be bad','usageIndex':0,'type':'i'},{'englishnorm':'be thankful, glad','yupikword':'quyauq','fsts':['quya'],'fstsDisplay':'quya-','key':'quya-','englishtenses':['be','was','is','being','been'],'properties':[],'englishmain':'!is! thankful, glad','englishraw':'\u27E8be\u27E9 thankful, glad','base_case':'be thankful, glad','usageIndex':0,'type':'i'},{'englishnorm':'act','yupikword':'piuq','fsts':['pi'],'fstsDisplay':'pi-','key':'pi,pi-','englishtenses':['act','acted','acts','acting','acted'],'properties':[],'englishmain':'!is! acting','englishraw':'\u27E8act\u27E9','base_case':'act','usageIndex':1,'type':'i'},{'englishnorm':'drink coffee','yupikword':'kuuvviartuq','fsts':['kuuvviar'],'fstsDisplay':'kuuvviar-','key':'kuuvviaq,kuuvviar-','englishtenses':['drink','drank','drinks','drinking','drunk'],'properties':[],'englishmain':'!is! drinking coffee','englishraw':'\u27E8drink\u27E9 coffee','base_case':'drink coffee','usageIndex':1,'type':'i'},{'englishnorm':'speak','yupikword':'qanertuq','fsts':['qaner'],'fstsDisplay':'qaner-','key':'qaneq,qaner-','englishtenses':['speak','spoke','speaks','speaking','spoken'],'properties':[],'englishmain':'!is! speaking','englishraw':'\u27E8speak\u27E9','base_case':'speak','usageIndex':1,'type':'i'},{'englishnorm':'tell','yupikword':'qanrutaa','fsts':['qanrute'],'fstsDisplay':'qanrute-','key':'qanrute-','englishtenses':['tell','told','tells','telling','told'],'properties':[],'englishmain':'told <him>','englishraw':'\u27E8tell\u27E9 <him>','base_case':'tell','usageIndex':2,'type':'t'},{'englishnorm':'ask','yupikword':'aptuq','fsts':['apte'],'fstsDisplay':'apte-','key':'apte-','englishtenses':['ask','asked','asks','asking','asked'],'properties':[],'englishmain':'asked','englishraw':'\u27E8ask\u27E9','base_case':'ask','usageIndex':0,'type':'i'},{'englishnorm':'sleep','yupikword':'qavartuq','fsts':['qavar'],'fstsDisplay':'qavar-','key':'qavaq,qavar-','englishtenses':['sleep','slept','sleeps','sleeping','slept'],'properties':[],'englishmain':'!is! sleeping','englishraw':'\u27E8sleep\u27E9','base_case':'sleep','usageIndex':1,'type':'i'},{'englishnorm':'lay down','yupikword':'inartuq','fsts':['inarte'],'fstsDisplay':'inarte-','key':'inarte-','englishtenses':['lay','laid','lays','laying','laid'],'properties':[],'englishmain':'lay down','englishraw':'\u27E8lay\u27E9 down','base_case':'lay down','usageIndex':0,'type':'i'},{'englishnorm':'get up','yupikword':'maktuq','fsts':['makte'],'fstsDisplay':'makte-','key':'makte-','englishtenses':['get','got','gets','getting','got'],'properties':[],'englishmain':'got up','englishraw':'\u27E8get\u27E9 up','base_case':'get up','usageIndex':0,'type':'i'},{'englishnorm':'hear','yupikword':'niituq','fsts':['niite'],'fstsDisplay':'niite-','key':'niite-','englishtenses':['hear','heard','hears','hearing','heard'],'properties':[],'englishmain':'hears <someone or something>','englishraw':'\u27E8hear\u27E9 <someone or something>','base_case':'hear','usageIndex':1,'type':'it'},{'englishnorm':'listen','yupikword':'niicugniuq','fsts':['niicugni'],'fstsDisplay':'niicugni-','key':'niicugni-','englishtenses':['listen','listened','listens','listening','listened'],'properties':[],'englishmain':'!is! listening','englishraw':'\u27E8listen\u27E9','base_case':'listen','usageIndex':0,'type':'i'},{'englishnorm':'wash','yupikword':'eruraa','fsts':['erur'],'fstsDisplay':'erur-','key':'erur-','englishtenses':['wash','washed','washes','washing','washed'],'properties':[],'englishmain':'!is! washing <it>','englishraw':'\u27E8wash\u27E9 <it>','base_case':'wash','usageIndex':2,'type':'t'},{'englishnorm':'walk','yupikword':'piyuaguq','fsts':['piyua'],'fstsDisplay':'piyua-','key':'piyua-','englishtenses':['walk','walked','walks','walking','walked'],'properties':[],'englishmain':'!is! walking','englishraw':'\u27E8walk\u27E9','base_case':'walk','usageIndex':0,'type':'i'},{'englishnorm':'run','yupikword':'aqvaqurtuq','fsts':['aqvaqur'],'fstsDisplay':'aqvaqur-','key':'aqvaqur-','englishtenses':['run','ran','runs','running','run'],'properties':[],'englishmain':'!is! running','englishraw':'\u27E8run\u27E9','base_case':'run','usageIndex':0,'type':'i'},{'englishnorm':'dance','yupikword':'yurartuq','fsts':['yurar\xb9'],'fstsDisplay':'yurar\xb9-','key':'yuraq,yurar\xb9-','englishtenses':['dance','danced','dances','dancing','danced'],'properties':[],'englishmain':'!is! dancing','englishraw':'\u27E8dance\u27E9','base_case':'dance','usageIndex':1,'type':'i'},{'englishnorm':'hook for fish','yupikword':'manartuq','fsts':['manar'],'fstsDisplay':'manar-','key':'manaq,manar-','englishtenses':['hook','hooked','hooks','hooking','hooked'],'properties':[],'englishmain':'!is! hooking for fish','englishraw':'\u27E8hook\u27E9 for fish','base_case':'hook for fish','usageIndex':1,'type':'i'}];var popularVerbsI=[{'englishnorm':'eat','yupikword':"ner'uq",'fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating','englishraw':'\u27E8eat\u27E9','base_case':'eat','usageIndex':0,'type':'i'},{'englishnorm':'leave','yupikword':'ayagtuq','fsts':['ayag\xb9'],'fstsDisplay':'ayag\xb9-','key':'ayag\xb9-','englishtenses':['leave','left','leaves','leaving','left'],'properties':[],'englishmain':'left','englishraw':'\u27E8leave\u27E9','base_case':'leave','usageIndex':0,'type':'i'},{'englishnorm':'come here','yupikword':'taiguq','fsts':['tai'],'fstsDisplay':'tai-','key':'tai-','englishtenses':['come','came','comes','coming','come'],'properties':[],'englishmain':'came here','englishraw':'\u27E8come\u27E9 here','base_case':'come here','usageIndex':0,'type':'i'},{'englishnorm':'come in','yupikword':'itertuq','fsts':['iter'],'fstsDisplay':'iter-','key':'iter-','englishtenses':['come','came','comes','coming','come'],'properties':[],'englishmain':'came in','englishraw':'\u27E8come\u27E9 in','base_case':'come in','usageIndex':0,'type':'i'},{'englishnorm':'go out','yupikword':"an'uq",'fsts':['ane'],'fstsDisplay':'ane-','key':'ane-','englishtenses':['go','went','goes','going','gone'],'properties':[],'englishmain':'went out','englishraw':'\u27E8go\u27E9 out','base_case':'go out','usageIndex':0,'type':'i'},{'englishnorm':'sit down','yupikword':'aqumuq','fsts':['aqume'],'fstsDisplay':'aqume-','key':'aqume-','englishtenses':['sit','sat','sits','sitting','sat'],'properties':[],'englishmain':'sat down','englishraw':'\u27E8sit\u27E9 down','base_case':'sit down','usageIndex':0,'type':'i'},{'englishnorm':'stand up','yupikword':'nangertuq','fsts':['nangerte'],'fstsDisplay':'nangerte-','key':'nangerte-','englishtenses':['stand','stood','stands','standing','stood'],'properties':[],'englishmain':'stood up','englishraw':'\u27E8stand\u27E9 up','base_case':'stand up','usageIndex':0,'type':'i'},{'englishnorm':'be well','yupikword':'assirtuq','fsts':['assir'],'fstsDisplay':'assir-','key':'assir-','englishtenses':['be','was','is','being','been'],'properties':[],'englishmain':'!is! well','englishraw':'\u27E8be\u27E9 well','base_case':'be well','usageIndex':0,'type':'i'},{'englishnorm':'be bad','yupikword':'assiituq','fsts':['assiite'],'fstsDisplay':'assiite-','key':'assiite-','englishtenses':['be','was','is','being','been'],'properties':[],'englishmain':'!is! bad','englishraw':'\u27E8be\u27E9 bad','base_case':'be bad','usageIndex':0,'type':'i'},{'englishnorm':'be thankful, glad','yupikword':'quyauq','fsts':['quya'],'fstsDisplay':'quya-','key':'quya-','englishtenses':['be','was','is','being','been'],'properties':[],'englishmain':'!is! thankful, glad','englishraw':'\u27E8be\u27E9 thankful, glad','base_case':'be thankful, glad','usageIndex':0,'type':'i'},{'englishnorm':'act','yupikword':'piuq','fsts':['pi'],'fstsDisplay':'pi-','key':'pi,pi-','englishtenses':['act','acted','acts','acting','acted'],'properties':[],'englishmain':'!is! acting','englishraw':'\u27E8act\u27E9','base_case':'act','usageIndex':1,'type':'i'},{'englishnorm':'drink coffee','yupikword':'kuuvviartuq','fsts':['kuuvviar'],'fstsDisplay':'kuuvviar-','key':'kuuvviaq,kuuvviar-','englishtenses':['drink','drank','drinks','drinking','drunk'],'properties':[],'englishmain':'!is! drinking coffee','englishraw':'\u27E8drink\u27E9 coffee','base_case':'drink coffee','usageIndex':1,'type':'i'},{'englishnorm':'speak','yupikword':'qanertuq','fsts':['qaner'],'fstsDisplay':'qaner-','key':'qaneq,qaner-','englishtenses':['speak','spoke','speaks','speaking','spoken'],'properties':[],'englishmain':'!is! speaking','englishraw':'\u27E8speak\u27E9','base_case':'speak','usageIndex':1,'type':'i'},{'englishnorm':'ask','yupikword':'aptuq','fsts':['apte'],'fstsDisplay':'apte-','key':'apte-','englishtenses':['ask','asked','asks','asking','asked'],'properties':[],'englishmain':'asked','englishraw':'\u27E8ask\u27E9','base_case':'ask','usageIndex':0,'type':'i'},{'englishnorm':'sleep','yupikword':'qavartuq','fsts':['qavar'],'fstsDisplay':'qavar-','key':'qavaq,qavar-','englishtenses':['sleep','slept','sleeps','sleeping','slept'],'properties':[],'englishmain':'!is! sleeping','englishraw':'\u27E8sleep\u27E9','base_case':'sleep','usageIndex':1,'type':'i'},{'englishnorm':'lay down','yupikword':'inartuq','fsts':['inarte'],'fstsDisplay':'inarte-','key':'inarte-','englishtenses':['lay','laid','lays','laying','laid'],'properties':[],'englishmain':'lay down','englishraw':'\u27E8lay\u27E9 down','base_case':'lay down','usageIndex':0,'type':'i'},{'englishnorm':'get up','yupikword':'maktuq','fsts':['makte'],'fstsDisplay':'makte-','key':'makte-','englishtenses':['get','got','gets','getting','got'],'properties':[],'englishmain':'got up','englishraw':'\u27E8get\u27E9 up','base_case':'get up','usageIndex':0,'type':'i'},{'englishnorm':'listen','yupikword':'niicugniuq','fsts':['niicugni'],'fstsDisplay':'niicugni-','key':'niicugni-','englishtenses':['listen','listened','listens','listening','listened'],'properties':[],'englishmain':'!is! listening','englishraw':'\u27E8listen\u27E9','base_case':'listen','usageIndex':0,'type':'i'},{'englishnorm':'walk','yupikword':'piyuaguq','fsts':['piyua'],'fstsDisplay':'piyua-','key':'piyua-','englishtenses':['walk','walked','walks','walking','walked'],'properties':[],'englishmain':'!is! walking','englishraw':'\u27E8walk\u27E9','base_case':'walk','usageIndex':0,'type':'i'},{'englishnorm':'run','yupikword':'aqvaqurtuq','fsts':['aqvaqur'],'fstsDisplay':'aqvaqur-','key':'aqvaqur-','englishtenses':['run','ran','runs','running','run'],'properties':[],'englishmain':'!is! running','englishraw':'\u27E8run\u27E9','base_case':'run','usageIndex':0,'type':'i'},{'englishnorm':'dance','yupikword':'yurartuq','fsts':['yurar\xb9'],'fstsDisplay':'yurar\xb9-','key':'yuraq,yurar\xb9-','englishtenses':['dance','danced','dances','dancing','danced'],'properties':[],'englishmain':'!is! dancing','englishraw':'\u27E8dance\u27E9','base_case':'dance','usageIndex':1,'type':'i'},{'englishnorm':'hook for fish','yupikword':'manartuq','fsts':['manar'],'fstsDisplay':'manar-','key':'manaq,manar-','englishtenses':['hook','hooked','hooks','hooking','hooked'],'properties':[],'englishmain':'!is! hooking for fish','englishraw':'\u27E8hook\u27E9 for fish','base_case':'hook for fish','usageIndex':1,'type':'i'}];var popularVerbsT=[{'englishnorm':'eat','yupikword':"ner'uq",'fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating <something>','englishraw':'\u27E8eat\u27E9 <something>','base_case':'eat','usageIndex':1,'type':'it'},{'englishnorm':'eat','yupikword':'neraa','fsts':['nere'],'fstsDisplay':'nere-','key':'nere-','englishtenses':['eat','ate','eats','eating','eaten'],'properties':[],'englishmain':'!is! eating <it>','englishraw':'\u27E8eat\u27E9 <it>','base_case':'eat','usageIndex':2,'type':'t'},{'englishnorm':'hunt','yupikword':'pissurtuq','fsts':['pissur'],'fstsDisplay':'pissur-','key':'pissur-','englishtenses':['hunt','hunted','hunts','hunting','hunted'],'properties':[],'englishmain':'!is! hunting <something>','englishraw':'\u27E8hunt\u27E9 <something>','base_case':'hunt','usageIndex':1,'type':'it'},{'englishnorm':'hunt','yupikword':'pissuraa','fsts':['pissur'],'fstsDisplay':'pissur-','key':'pissur-','englishtenses':['hunt','hunted','hunts','hunting','hunted'],'properties':[],'englishmain':'!is! hunting <it>','englishraw':'\u27E8hunt\u27E9 <it>','base_case':'hunt','usageIndex':2,'type':'t'},{'englishnorm':'buy','yupikword':'kiputaa','fsts':['kipute'],'fstsDisplay':'kipute-','key':'kipute-','englishtenses':['buy','bought','buys','buying','bought'],'properties':[],'englishmain':'bought <it>','englishraw':'\u27E8buy\u27E9 <it>','base_case':'buy','usageIndex':2,'type':'t'},{'englishnorm':'open','yupikword':'ikirtaa','fsts':['ikirte'],'fstsDisplay':'ikirte-','key':'ikirte-','englishtenses':['open','opened','opens','opening','opened'],'properties':[],'englishmain':'opened <it>','englishraw':'\u27E8open\u27E9 <it>','base_case':'open','usageIndex':2,'type':'t'},{'englishnorm':'tell','yupikword':'qanrutaa','fsts':['qanrute'],'fstsDisplay':'qanrute-','key':'qanrute-','englishtenses':['tell','told','tells','telling','told'],'properties':[],'englishmain':'told <him>','englishraw':'\u27E8tell\u27E9 <him>','base_case':'tell','usageIndex':2,'type':'t'},{'englishnorm':'hear','yupikword':'niituq','fsts':['niite'],'fstsDisplay':'niite-','key':'niite-','englishtenses':['hear','heard','hears','hearing','heard'],'properties':[],'englishmain':'hears <someone or something>','englishraw':'\u27E8hear\u27E9 <someone or something>','base_case':'hear','usageIndex':1,'type':'it'},{'englishnorm':'wash','yupikword':'eruraa','fsts':['erur'],'fstsDisplay':'erur-','key':'erur-','englishtenses':['wash','washed','washes','washing','washed'],'properties':[],'englishmain':'!is! washing <it>','englishraw':'\u27E8wash\u27E9 <it>','base_case':'wash','usageIndex':2,'type':'t'}];var popularNounsBeings=[{'englishnorm':'woman, female human, queen in cards','yupikword':'arnaq','fsts':['arnar'],'fstsDisplay':'arnar-','key':'arnaq','englishtenses':[['woman','women'],['human','humans'],['queen','queens']],'properties':[],'englishmain':['\u27E8woman\u27E9','female \u27E8human\u27E9','\u27E8queen\u27E9 in cards'],'englishraw':'\u27E8woman\u27E9, female \u27E8human\u27E9, \u27E8queen\u27E9 in cards','base_case':'woman, female human, queen in cards','usageIndex':0,'type':'n'},{'englishnorm':'male human, man','yupikword':'angun','fsts':['angute'],'fstsDisplay':'angute-','key':'angun','englishtenses':[['human','humans'],['man','men']],'properties':[],'englishmain':['male \u27E8human\u27E9','\u27E8man\u27E9'],'englishraw':'male \u27E8human\u27E9, \u27E8man\u27E9','base_case':'male human, man','usageIndex':0,'type':'n'},{'englishnorm':'mother','yupikword':'aana','fsts':['aana'],'fstsDisplay':'aana-','key':'aana','englishtenses':[['mother','mothers']],'properties':[],'englishmain':['\u27E8mother\u27E9'],'englishraw':'\u27E8mother\u27E9','base_case':'mother','usageIndex':0,'type':'n'},{'englishnorm':'father','yupikword':'aata','fsts':['aate'],'fstsDisplay':'aate-','key':'aata','englishtenses':[['father','fathers']],'properties':[],'englishmain':['\u27E8father\u27E9'],'englishraw':'\u27E8father\u27E9','base_case':'father','usageIndex':0,'type':'n'},{'englishnorm':'elder','yupikword':'tegganeq','fsts':['tegganer'],'fstsDisplay':'tegganer-','key':'tegganeq','englishtenses':[['elder','elders']],'properties':[],'englishmain':['\u27E8elder\u27E9'],'englishraw':'\u27E8elder\u27E9','base_case':'elder','usageIndex':0,'type':'n'},{'englishnorm':'child, little one','yupikword':'mikelnguq','fsts':['mikelngur*'],'fstsDisplay':'mikelngur*-','key':'mikelnguq*','englishtenses':[['child','children'],['little','littles']],'properties':[],'englishmain':['\u27E8child\u27E9','\u27E8little\u27E9 one'],'englishraw':'\u27E8child\u27E9, \u27E8little\u27E9 one','base_case':'child, little one','usageIndex':0,'type':'n'},{'englishnorm':'baby','yupikword':'piipiq','fsts':['piipir'],'fstsDisplay':'piipir-','key':'piipiq','englishtenses':[['baby','babies']],'properties':[],'englishmain':['\u27E8baby\u27E9'],'englishraw':'\u27E8baby\u27E9','base_case':'baby','usageIndex':0,'type':'n'},{'englishnorm':'bird, duck, fowl, angel','yupikword':'yaqulek','fsts':['yaquleg'],'fstsDisplay':'yaquleg-','key':'yaqulek','englishtenses':[['bird','birds'],['duck','ducks'],['fowl','fowls'],['angel','angels']],'properties':[],'englishmain':['\u27E8bird\u27E9','\u27E8duck\u27E9','\u27E8fowl\u27E9','\u27E8angel\u27E9'],'englishraw':'\u27E8bird\u27E9, \u27E8duck\u27E9, \u27E8fowl\u27E9, \u27E8angel\u27E9','base_case':'bird, duck, fowl, angel','usageIndex':0,'type':'n'},{'englishnorm':'caribou (Rangifer tarandus), reindeer','yupikword':'tuntu','fsts':['tuntu'],'fstsDisplay':'tuntu-','key':'tuntu','englishtenses':[['caribou','caribous'],['reindeer','reindeers']],'properties':[],'englishmain':['\u27E8caribou\u27E9 (Rangifer tarandus)','\u27E8reindeer\u27E9'],'englishraw':'\u27E8caribou\u27E9 (Rangifer tarandus), \u27E8reindeer\u27E9','base_case':'caribou (Rangifer tarandus), reindeer','usageIndex':0,'type':'n'},{'englishnorm':'moose (Alces alces)','yupikword':'tuntuvak','fsts':['tuntuvag'],'fstsDisplay':'tuntuvag-','key':'tuntuvak','englishtenses':[['moose','moose']],'properties':[],'englishmain':['\u27E8moose\u27E9 (Alces alces)'],'englishraw':'\u27E8moose\u27E9 (Alces alces)','base_case':'moose (Alces alces)','usageIndex':0,'type':'n'},{'englishnorm':'bearded seal in its first year','yupikword':'maklaaq','fsts':['maklaar'],'fstsDisplay':'maklaar-','key':'maklaaq','englishtenses':[['seal','seals']],'properties':[],'englishmain':['bearded \u27E8seal\u27E9 in its first year'],'englishraw':'bearded \u27E8seal\u27E9 in its first year','base_case':'bearded seal in its first year','usageIndex':0,'type':'n'},{'englishnorm':'spotted seal (Phoca largha), harbor seal (Phoca vitulina)','yupikword':'issuriq','fsts':['issurir','issuri'],'fstsDisplay':'issurir-, issuri-','key':'issuriq,issuri','englishtenses':[['seal','seals'],['seal','seals']],'properties':[],'englishmain':['spotted \u27E8seal\u27E9 (Phoca largha)','harbor \u27E8seal\u27E9 (Phoca vitulina)'],'englishraw':'spotted \u27E8seal\u27E9 (Phoca largha), harbor \u27E8seal\u27E9 (Phoca vitulina)','base_case':'spotted seal (Phoca largha), harbor seal (Phoca vitulina)','usageIndex':0,'type':'n'},{'englishnorm':'food, fish','yupikword':'neqa\u1D49','fsts':['neqe'],'fstsDisplay':'neqe-','key':'neqa\u1D49','englishtenses':[['food','food'],['fish','fish']],'properties':[],'englishmain':['\u27E8food\u27E9','\u27E8fish\u27E9'],'englishraw':'\u27E8food\u27E9, \u27E8fish\u27E9','base_case':'food, fish','usageIndex':0,'type':'n'}];var popularNounsThings=[{'englishnorm':'coffee','yupikword':'kuuvviaq','fsts':['kuuvviar'],'fstsDisplay':'kuuvviar-','key':'kuuvviaq,kuuvviar-','englishtenses':[['coffee','coffees']],'properties':[],'englishmain':['\u27E8coffee\u27E9'],'englishraw':'\u27E8coffee\u27E9','base_case':'coffee','usageIndex':0,'type':'n'},{'englishnorm':'tea (either the leaves or the liquid)','yupikword':'saayuq','fsts':['saayur'],'fstsDisplay':'saayur-','key':'saayuq,saayur-','englishtenses':[['tea','tea']],'properties':[],'englishmain':['\u27E8tea\u27E9 (either the leaves or the liquid)'],'englishraw':'\u27E8tea\u27E9 (either the leaves or the liquid)','base_case':'tea (either the leaves or the liquid)','usageIndex':0,'type':'n'},{'englishnorm':'table','yupikword':'estuuluq','fsts':['estuulur'],'fstsDisplay':'estuulur-','key':'estuuluq','englishtenses':[['table','tables']],'properties':[],'englishmain':['\u27E8table\u27E9'],'englishraw':'\u27E8table\u27E9','base_case':'table','usageIndex':0,'type':'n'},{'englishnorm':'chair, seat','yupikword':'aqumlleq','fsts':['aqumller'],'fstsDisplay':'aqumller-','key':'aqumlleq','englishtenses':[['chair','chairs'],['seat','seats']],'properties':[],'englishmain':['\u27E8chair\u27E9','\u27E8seat\u27E9'],'englishraw':'\u27E8chair\u27E9, \u27E8seat\u27E9','base_case':'chair, seat','usageIndex':0,'type':'n'},{'englishnorm':'door, entranceway','yupikword':'amiik','fsts':['amiig'],'fstsDisplay':'amiig-','key':'amiik','englishtenses':[['door','doors'],['entranceway','entranceways']],'properties':[],'englishmain':['\u27E8door\u27E9','\u27E8entranceway\u27E9'],'englishraw':'\u27E8door\u27E9, \u27E8entranceway\u27E9','base_case':'door, entranceway','usageIndex':0,'type':'n'},{'englishnorm':'floor, flooring','yupikword':'nateq','fsts':['nater'],'fstsDisplay':'nater-','key':'nateq','englishtenses':[['floor','floors'],['flooring','floorings']],'properties':[],'englishmain':['\u27E8floor\u27E9','\u27E8flooring\u27E9'],'englishraw':'\u27E8floor\u27E9, \u27E8flooring\u27E9','base_case':'floor, flooring','usageIndex':0,'type':'n'},{'englishnorm':'clothing, bedding, merchandise, fitting(s), accouterment, possession(s)','yupikword':'akl','fsts':['akl','aklur'],'fstsDisplay':'aklu-, aklur-','key':'aklu,akluq,aklu-','englishtenses':[['clothing','clothings'],['bedding','beddings'],['merchandise','merchandises'],['fitting','fittings'],['accouterment','accouterments'],['possession','possessions']],'properties':[],'englishmain':['\u27E8clothing\u27E9','\u27E8bedding\u27E9','\u27E8merchandise\u27E9','\u27E8fitting\u27E9(s)','\u27E8accouterment\u27E9','\u27E8possession\u27E9(s)'],'englishraw':'\u27E8clothing\u27E9, \u27E8bedding\u27E9, \u27E8merchandise\u27E9, \u27E8fitting\u27E9(s), \u27E8accouterment\u27E9, \u27E8possession\u27E9(s)','base_case':'clothing, bedding, merchandise, fitting(s), accouterment, possession(s)','usageIndex':0,'type':'n'},{'englishnorm':'mixture, \u201CEskimo ice cream\u201D','yupikword':'akutaq','fsts':['akutar'],'fstsDisplay':'akutar-','key':'akutaq','englishtenses':[['mixture','mixtures'],['cream','creams']],'properties':[],'englishmain':['\u27E8mixture\u27E9','\u201CEskimo ice \u27E8cream\u27E9\u201D'],'englishraw':'\u27E8mixture\u27E9, \u201CEskimo ice \u27E8cream\u27E9\u201D','base_case':'mixture, \u201CEskimo ice cream\u201D','usageIndex':0,'type':'n'},{'englishnorm':'soup, stew-like soup served as a main course','yupikword':'suupaq','fsts':['suupar'],'fstsDisplay':'suupar-','key':'suupaq','englishtenses':[['soup','soup'],['soup','soup']],'properties':[],'englishmain':['\u27E8soup\u27E9','stew-like \u27E8soup\u27E9 served as a main course'],'englishraw':'\u27E8soup\u27E9, stew-like \u27E8soup\u27E9 served as a main course','base_case':'soup, stew-like soup served as a main course','usageIndex':0,'type':'n'},{'englishnorm':'smoked dried fish (particularly salmon)','yupikword':'neqerrluk','fsts':['neqerrlug','neqerrluar'],'fstsDisplay':'neqerrlug-, neqerrluar-','key':'neqerrluk,neqerrluaq','englishtenses':[['fish','fish']],'properties':[],'englishmain':['smoked dried \u27E8fish\u27E9 (particularly salmon)'],'englishraw':'smoked dried \u27E8fish\u27E9 (particularly salmon)','base_case':'smoked dried fish (particularly salmon)','usageIndex':0,'type':'n'},{'englishnorm':'berry, fruit, nut, cloudberry (Rubus chamaemorus)','yupikword':'atsaq','fsts':['atsar'],'fstsDisplay':'atsar-','key':'atsaq','englishtenses':[['berry','berries'],['fruit','fruit'],['nut','nuts'],['cloudberry','cloudberries']],'properties':[],'englishmain':['\u27E8berry\u27E9','\u27E8fruit\u27E9','\u27E8nut\u27E9','\u27E8cloudberry\u27E9 (Rubus chamaemorus)'],'englishraw':'\u27E8berry\u27E9, \u27E8fruit\u27E9, \u27E8nut\u27E9, \u27E8cloudberry\u27E9 (Rubus chamaemorus)','base_case':'berry, fruit, nut, cloudberry (Rubus chamaemorus)','usageIndex':0,'type':'n'},{'englishnorm':'boat','yupikword':'angyaq','fsts':['angyar'],'fstsDisplay':'angyar-','key':'angyaq,angyar-','englishtenses':[['boat','boats']],'properties':[],'englishmain':['\u27E8boat\u27E9'],'englishraw':'\u27E8boat\u27E9','base_case':'boat','usageIndex':0,'type':'n'},{'englishnorm':'sled, dogsled, by extension: snow machine, automobile, truck, taxi','yupikword':'ikamraq','fsts':['ikamrar'],'fstsDisplay':'ikamrar-','key':'ikamraq,ikamrar-','englishtenses':[['sled','sleds'],['dogsled','dogsleds'],['extension','extensions'],['automobile','automobiles'],['truck','trucks'],['taxi','taxis']],'properties':[],'englishmain':['\u27E8sled\u27E9','\u27E8dogsled\u27E9','by \u27E8extension\u27E9: snow machine','\u27E8automobile\u27E9','\u27E8truck\u27E9','\u27E8taxi\u27E9'],'englishraw':'\u27E8sled\u27E9, \u27E8dogsled\u27E9, by \u27E8extension\u27E9: snow machine, \u27E8automobile\u27E9, \u27E8truck\u27E9, \u27E8taxi\u27E9','base_case':'sled, dogsled, by extension: snow machine, automobile, truck, taxi','usageIndex':0,'type':'n'},{'englishnorm':'world, outdoor, weather, sky, universe, awareness, sense','yupikword':'ella','fsts':['ella'],'fstsDisplay':'ella-','key':'ella','englishtenses':[['world','worlds'],['outdoor','outdoors'],['weather','weather'],['sky','skies'],['universe','universes'],['awareness','awarenesses'],['sense','senses']],'properties':[],'englishmain':['\u27E8world\u27E9','\u27E8outdoor\u27E9','\u27E8weather\u27E9','\u27E8sky\u27E9','\u27E8universe\u27E9','\u27E8awareness\u27E9','\u27E8sense\u27E9'],'englishraw':'\u27E8world\u27E9, \u27E8outdoor\u27E9, \u27E8weather\u27E9, \u27E8sky\u27E9, \u27E8universe\u27E9, \u27E8awareness\u27E9, \u27E8sense\u27E9','base_case':'world, outdoor, weather, sky, universe, awareness, sense','usageIndex':0,'type':'n'},{'englishnorm':'ocean, sea','yupikword':'imarpik','fsts':['imarpig','imarpag'],'fstsDisplay':'imarpig-, imarpag-','key':'imarpik,imarpak','englishtenses':[['ocean','oceans']],'properties':[],'englishmain':['\u27E8ocean\u27E9, sea'],'englishraw':'\u27E8ocean\u27E9, sea','base_case':'ocean, sea','usageIndex':0,'type':'n'},{'englishnorm':'maxim, saying, proverb, wise word, teaching','yupikword':'qanruyun','fsts':['qanruyute'],'fstsDisplay':'qanruyute-','key':'qanruyun','englishtenses':[['maxim','maxims'],['saying','sayings'],['proverb','proverbs'],['word','words'],['teaching','teachings']],'properties':[],'englishmain':['\u27E8maxim\u27E9','\u27E8saying\u27E9','\u27E8proverb\u27E9','wise \u27E8word\u27E9','\u27E8teaching\u27E9'],'englishraw':'\u27E8maxim\u27E9, \u27E8saying\u27E9, \u27E8proverb\u27E9, wise \u27E8word\u27E9, \u27E8teaching\u27E9','base_case':'maxim, saying, proverb, wise word, teaching','usageIndex':0,'type':'n'},{'englishnorm':'story, factual account','yupikword':'qanemci','fsts':['qanemci','qanemcir'],'fstsDisplay':'qanemci-, qanemcir-','key':'qanemci,qanemciq,qanemci-','englishtenses':[['story','stories'],['account','accounts']],'properties':[],'englishmain':['\u27E8story\u27E9','factual \u27E8account\u27E9'],'englishraw':'\u27E8story\u27E9, factual \u27E8account\u27E9','base_case':'story, factual account','usageIndex':0,'type':'n'}];var popularNounsPlaces=[{'englishnorm':'school, schoolhouse','yupikword':'elitnaurvik','fsts':['elitnaurvig'],'fstsDisplay':'elitnaurvig-','key':'elitnaurvik','englishtenses':[['school','schools'],['schoolhouse','schoolhouses']],'properties':[],'englishmain':['\u27E8school\u27E9','\u27E8schoolhouse\u27E9'],'englishraw':'\u27E8school\u27E9, \u27E8schoolhouse\u27E9','base_case':'school, schoolhouse','usageIndex':0,'type':'n'},{'englishnorm':'land, place, soil, earth, ground, village, country, vicinity (in space or time)','yupikword':'nuna','fsts':['nuna'],'fstsDisplay':'nuna-','key':'nuna','englishtenses':[['land','lands'],['place','places'],['soil','soil'],['earth','earths'],['ground','grounds'],['village','villages'],['country','countries'],['vicinity','vicinities']],'properties':[],'englishmain':['\u27E8land\u27E9','\u27E8place\u27E9','\u27E8soil\u27E9','\u27E8earth\u27E9','\u27E8ground\u27E9','\u27E8village\u27E9','\u27E8country\u27E9','\u27E8vicinity\u27E9 (in space or time)'],'englishraw':'\u27E8land\u27E9, \u27E8place\u27E9, \u27E8soil\u27E9, \u27E8earth\u27E9, \u27E8ground\u27E9, \u27E8village\u27E9, \u27E8country\u27E9, \u27E8vicinity\u27E9 (in space or time)','base_case':'land, place, soil, earth, ground, village, country, vicinity (in space or time)','usageIndex':0,'type':'n'},{'englishnorm':'store','yupikword':'kipusvik','fsts':['kipusvig','kipuyvig'],'fstsDisplay':'kipusvig-, kipuyvig-','key':'kipusvik,kipuyvik','englishtenses':[['store','stores']],'properties':[],'englishmain':['\u27E8store\u27E9'],'englishraw':'\u27E8store\u27E9','base_case':'store','usageIndex':0,'type':'n'},{'englishnorm':'steambath house','yupikword':'maqivik','fsts':['maqivig'],'fstsDisplay':'maqivig-','key':'maqivik','englishtenses':[['house','houses']],'properties':[],'englishmain':['steambath \u27E8house\u27E9'],'englishraw':'steambath \u27E8house\u27E9','base_case':'steambath house','usageIndex':0,'type':'n'},{'englishnorm':'house, place','yupikword':'[e]na\u1D49','fsts':['[e]ne','ene'],'fstsDisplay':'[e]ne-, ene-','key':'[e]na\u1D49,ena\u1D49','englishtenses':[['house','houses'],['place','places']],'properties':[],'englishmain':['\u27E8house\u27E9','\u27E8place\u27E9'],'englishraw':'\u27E8house\u27E9, \u27E8place\u27E9','base_case':'house, place','usageIndex':0,'type':'n'},{'englishnorm':'river','yupikword':'kuik','fsts':['kuig'],'fstsDisplay':'kuig-','key':'kuik','englishtenses':[['river','rivers']],'properties':[],'englishmain':['\u27E8river\u27E9'],'englishraw':'\u27E8river\u27E9','base_case':'river','usageIndex':0,'type':'n'},{'englishnorm':'lake, pond','yupikword':'nanvaq','fsts':['nanvar'],'fstsDisplay':'nanvar-','key':'nanvaq','englishtenses':[['lake','lakes'],['pond','ponds']],'properties':[],'englishmain':['\u27E8lake\u27E9','\u27E8pond\u27E9'],'englishraw':'\u27E8lake\u27E9, \u27E8pond\u27E9','base_case':'lake, pond','usageIndex':0,'type':'n'},{'englishnorm':'ocean, sea','yupikword':'imarpik','fsts':['imarpig','imarpag'],'fstsDisplay':'imarpig-, imarpag-','key':'imarpik,imarpak','englishtenses':[['ocean','oceans']],'properties':[],'englishmain':['\u27E8ocean\u27E9, sea'],'englishraw':'\u27E8ocean\u27E9, sea','base_case':'ocean, sea','usageIndex':0,'type':'n'},{'englishnorm':'tundra, patch of tundra, flat mound on tundra','yupikword':'nunapik','fsts':['nunapig'],'fstsDisplay':'nunapig-','key':'nunapik','englishtenses':[['tundra','tundras'],['patch','patches'],['mound','mounds']],'properties':[],'englishmain':['\u27E8tundra\u27E9','\u27E8patch\u27E9 of tundra','flat \u27E8mound\u27E9 on tundra'],'englishraw':'\u27E8tundra\u27E9, \u27E8patch\u27E9 of tundra, flat \u27E8mound\u27E9 on tundra','base_case':'tundra, patch of tundra, flat mound on tundra','usageIndex':0,'type':'n'},{'englishnorm':'mountain','yupikword':'ingriq','fsts':['ingrir','ingri'],'fstsDisplay':'ingrir-, ingri-','key':'ingriq,ingri','englishtenses':[['mountain','mountains']],'properties':[],'englishmain':['\u27E8mountain\u27E9'],'englishraw':'\u27E8mountain\u27E9','base_case':'mountain','usageIndex':0,'type':'n'},{'englishnorm':'Bethel','yupikword':'Mamterilleq','fsts':['Mamteriller'],'fstsDisplay':'Mamteriller-','key':'Mamterilleq','englishtenses':[['Bethel','Bethels']],'properties':[],'englishmain':['\u27E8Bethel\u27E9'],'englishraw':'\u27E8Bethel\u27E9','base_case':'Bethel','usageIndex':0,'type':'n'},{'englishnorm':'Dillingham','yupikword':'Curyuk','fsts':['Curyug','Curyung'],'fstsDisplay':'Curyug-, Curyung-','key':'Curyuk,Curyung','englishtenses':[['Dillingham','Dillinghams']],'properties':[],'englishmain':['\u27E8Dillingham\u27E9'],'englishraw':'\u27E8Dillingham\u27E9','base_case':'Dillingham','usageIndex':0,'type':'n'}];var popularNounsVialis=[{'englishnorm':'boat','yupikword':'angyaq','fsts':['angyar'],'fstsDisplay':'angyar-','key':'angyaq,angyar-','englishtenses':[['boat','boats']],'properties':[],'englishmain':['\u27E8boat\u27E9'],'englishraw':'\u27E8boat\u27E9','base_case':'boat','usageIndex':0,'type':'n'},{'englishnorm':'sled, dogsled, by extension: snow machine, automobile, truck, taxi','yupikword':'ikamraq','fsts':['ikamrar'],'fstsDisplay':'ikamrar-','key':'ikamraq,ikamrar-','englishtenses':[['sled','sleds'],['dogsled','dogsleds'],['extension','extensions'],['automobile','automobiles'],['truck','trucks'],['taxi','taxis']],'properties':[],'englishmain':['\u27E8sled\u27E9','\u27E8dogsled\u27E9','by \u27E8extension\u27E9: snow machine','\u27E8automobile\u27E9','\u27E8truck\u27E9','\u27E8taxi\u27E9'],'englishraw':'\u27E8sled\u27E9, \u27E8dogsled\u27E9, by \u27E8extension\u27E9: snow machine, \u27E8automobile\u27E9, \u27E8truck\u27E9, \u27E8taxi\u27E9','base_case':'sled, dogsled, by extension: snow machine, automobile, truck, taxi','usageIndex':0,'type':'n'},{'englishnorm':'airplane','yupikword':'tengssuun','fsts':['tengssuute'],'fstsDisplay':'tengssuute-','key':'tengssuun','englishtenses':[['airplane','airplanes']],'properties':[],'englishmain':['\u27E8airplane\u27E9'],'englishraw':'\u27E8airplane\u27E9','base_case':'airplane','usageIndex':0,'type':'n'},{'englishnorm':'river','yupikword':'kuik','fsts':['kuig'],'fstsDisplay':'kuig-','key':'kuik','englishtenses':[['river','rivers']],'properties':[],'englishmain':['\u27E8river\u27E9'],'englishraw':'\u27E8river\u27E9','base_case':'river','usageIndex':0,'type':'n'},{'englishnorm':'land, place, soil, earth, ground, village, country, vicinity (in space or time)','yupikword':'nuna','fsts':['nuna'],'fstsDisplay':'nuna-','key':'nuna','englishtenses':[['land','lands'],['place','places'],['soil','soil'],['earth','earths'],['ground','grounds'],['village','villages'],['country','countries'],['vicinity','vicinities']],'properties':[],'englishmain':['\u27E8land\u27E9','\u27E8place\u27E9','\u27E8soil\u27E9','\u27E8earth\u27E9','\u27E8ground\u27E9','\u27E8village\u27E9','\u27E8country\u27E9','\u27E8vicinity\u27E9 (in space or time)'],'englishraw':'\u27E8land\u27E9, \u27E8place\u27E9, \u27E8soil\u27E9, \u27E8earth\u27E9, \u27E8ground\u27E9, \u27E8village\u27E9, \u27E8country\u27E9, \u27E8vicinity\u27E9 (in space or time)','base_case':'land, place, soil, earth, ground, village, country, vicinity (in space or time)','usageIndex':0,'type':'n'},{'englishnorm':'ocean, sea','yupikword':'imarpik','fsts':['imarpig','imarpag'],'fstsDisplay':'imarpig-, imarpag-','key':'imarpik,imarpak','englishtenses':[['ocean','oceans']],'properties':[],'englishmain':['\u27E8ocean\u27E9, sea'],'englishraw':'\u27E8ocean\u27E9, sea','base_case':'ocean, sea','usageIndex':0,'type':'n'},{'englishnorm':'door, entranceway','yupikword':'amiik','fsts':['amiig'],'fstsDisplay':'amiig-','key':'amiik','englishtenses':[['door','doors'],['entranceway','entranceways']],'properties':[],'englishmain':['\u27E8door\u27E9','\u27E8entranceway\u27E9'],'englishraw':'\u27E8door\u27E9, \u27E8entranceway\u27E9','base_case':'door, entranceway','usageIndex':0,'type':'n'},{'englishnorm':"window, formerly smokehole/skylight of traditional Yup'ik house",'yupikword':'egaleq','fsts':['egaler'],'fstsDisplay':'egaler-','key':'egaleq','englishtenses':[['window','windows'],['smokehole/skylight','smokehole/skylights']],'properties':[],'englishmain':['\u27E8window\u27E9','formerly \u27E8smokehole/skylight\u27E9 of traditional Yup\'ik house'],'englishraw':'\u27E8window\u27E9, formerly \u27E8smokehole/skylight\u27E9 of traditional Yup\'ik house','base_case':"window, formerly smokehole/skylight of traditional Yup'ik house",'usageIndex':0,'type':'n'},{'englishnorm':'spoon','yupikword':'luuskaaq','fsts':['luuskaar'],'fstsDisplay':'luuskaar-','key':'luuskaaq','englishtenses':[['spoon','spoons']],'properties':[],'englishmain':['\u27E8spoon\u27E9'],'englishraw':'\u27E8spoon\u27E9','base_case':'spoon','usageIndex':0,'type':'n'},{'englishnorm':'axe','yupikword':'piqertuutaq','fsts':['piqertuutar'],'fstsDisplay':'piqertuutar-','key':'piqertuutaq','englishtenses':[['axe','axes']],'properties':[],'englishmain':['\u27E8axe\u27E9'],'englishraw':'\u27E8axe\u27E9','base_case':'axe','usageIndex':0,'type':'n'},{'englishnorm':'cutting knife','yupikword':'nuussiq','fsts':['nuussir'],'fstsDisplay':'nuussir-','key':'nuussiq','englishtenses':[['knife','knives']],'properties':[],'englishmain':['cutting \u27E8knife\u27E9'],'englishraw':'cutting \u27E8knife\u27E9','base_case':'cutting knife','usageIndex':0,'type':'n'}];var popularVPostbasesSub=[{id:0,// description: 'probably',
allowable_next_ids:[1,0],expression:'–qaqe¹[V→V]'},{id:1,// description: 'evidently',
allowable_next_ids:[0,1],expression:'+peke|.vke[V→V]'},{id:2,// description: 'no longer able to',
expression:"+pege|.vke[V→V]",allowable_next_ids:[1,3,2]},// {
//   id: 0,
//   // description: 'probably',
//   allowable_next_ids: [1,0],
//   expression:'@~+yugnarqe¹[V→V]',
// },
// {
//   id: 1,
//   // description: 'evidently',
//   allowable_next_ids: [0,1],
//   expression: '–llini[V→V]',
// },
// {
//   id: 2,
//   // description: 'no longer able to',
//   expression: "+(s)ciigali[V→V]",
//   allowable_next_ids: [1,3,2],
// },
// {
//   id: 3,
//   // description: 'not able to',
//   expression: '+(s)ciigate[V→V]',
//   allowable_next_ids: [1,2,3]
// },
{id:4,// description: 'is able to',
expression:'@~+yugnga[V→V]',allowable_next_ids:[0,1,6,7,8,4]},{id:11,// description: 'repeatedly',
expression:"–lar[V→V]",allowable_next_ids:[1,11]},{id:12,// description: 'doing it again',
expression:'–nqigte[V→V]',allowable_next_ids:[1,12]},{id:13,// description: 'almost',
expression:'@~+yarpiar[V→V]',allowable_next_ids:[1,13]},{id:14,// description: 'never',
expression:'@~–yuite[V→V]',allowable_next_ids:[1,14]},{id:15,// description: 'no longer',
expression:'–nrir[V→V]',allowable_next_ids:[0,1,27,15]},{id:16,// description: 'trying (unsuccessfully) to',
expression:'@~+yaaqe[V→V]',allowable_next_ids:[0,1,17,19,16]},{id:17,// description: 'trying despite difficulties to',
expression:'–qcaar(ar)[V→V]',allowable_next_ids:[0,1,16,18,17]},{id:18,// description: 'trying to',
expression:'–ngnaqe[V→V]',allowable_next_ids:[0,1,16,17,18]},{id:19,// description: 'excessively (too much)',
expression:'–ssiyaag[V→V]',allowable_next_ids:[1,19]},{id:20,// description: 'to be more or better at',
expression:'–nru[V→V]',allowable_next_ids:[1,20]},{id:21,// description: 'loves to',
expression:'@~+yunqegg[V→V]',allowable_next_ids:[0,1,7,8,21]},{id:22,// description: 'no longer wants to',
expression:'@~+yuumiir(ar)te[V→V]',allowable_next_ids:[0,1,7,8,22]},{id:23,// description: 'not care to',
expression:'@~+yuumiite[V→V]',allowable_next_ids:[0,1,7,8,23]},{id:24,// description: 'yearns to',
expression:'@~+yuumir[V→V]',allowable_next_ids:[0,1,7,8,24]},{id:25,// description: 'wants to',
expression:'@~+yug[V→V]',allowable_next_ids:[0,1,7,8,25]},{id:26,// description: 'enjoys doing',
expression:'@~+yugar[V→V]',allowable_next_ids:[0,1,7,8,26]},{id:27,// description: 'not',
expression:'–nrite[V→V]',allowable_next_ids:[0,1,27]},{id:28,// description: 'in the process of',
expression:'@~+yartur[V→V]',allowable_next_ids:[0,1,2,3,4,5,6,7,8,9,10,19,28]},{id:29,// description: 'definitely no longer going to',
expression:'@~+yugnairute[V→V]',allowable_next_ids:[0,1,3,4,8,10,29]// only refers to the postbases, not the endings
}];var popularOptPostbases=[{id:0,// description: 'please',
expression:'\u2013qar[V\u2192V]',allowable_next_ids:[0]},{id:1,// description: 'trying despite difficulties to',
expression:'–qcaar(ar)[V→V]',allowable_next_ids:[1,0,2]},{id:2,// description: "first", 
expression:'\u2013rraar[V\u2192V]',allowable_next_ids:[2,0]},{id:3,// description: "quickly", 
expression:'\u2013laag[V\u2192V]',allowable_next_ids:[2,0,3]}];var popularNPostbases=[{id:0,// description: 'large',
// englishModifier: (english) => { return 'large '+ english; },
expression:'\u2013rpag|@vag[N\u2192N]',allowable_next_ids:[1,0]},{id:1,expression:'\u2013cuar(ar*)[N\u2192N]',// description: 'small',
// englishModifier: (english) => { return 'small '+ english; },
// expression_end: '-cuar',
// expression_postbase: '-cuar\\',
// expression_conditional_end: '-kcuar',
// expression_conditional_postbase: '-kcuar(ar)\\',
// conditional_rule: '',
// priority:4,
// tense:'',
allowable_next_ids:[0,1]},{id:2,expression:'\u2013yagar*[N\u2192N]',// description: 'baby/little',
// englishModifier: (english) => { return 'baby/little '+ english; },
// expression_end: '-yagaq',
// expression_postbase: '-yagar\\',
// expression_conditional_end: '-yagaq',
// expression_conditional_postbase: '-yagar\\',
// conditional_rule: '',
// priority:4,
// tense:'',
allowable_next_ids:[2]},{id:3,expression:'\u2013kegtaar(ar*)[N\u2192N]',// description: 'good',
// englishModifier: (english) => { return 'good '+ english; },
// expression_end: '-kegtaar',
// expression_postbase: '-kegtaar\\',
// expression_conditional_end: '',
// expression_conditional_postbase: '',
// conditional_rule: '',
// priority:4,
// tense:'',
allowable_next_ids:[3]},{id:4,expression:'\u2013ller(ar*)[N\u2192N]',// description: 'shabby',
// englishModifier: (english) => { return 'shabby '+ english; },
// expression_end: '-2er',
// expression_postbase: '-2er\\',
// expression_conditional_end: '-2er',
// expression_conditional_postbase: '-2er\\',
// conditional_rule: '',
// priority:4,
// tense:'',
allowable_next_ids:[4]},{id:5,expression:'\u2013pig\xB9[N\u2192N]',// description: 'genuine',
// englishModifier: (english) => { return 'genuine '+ english; },
// expression_end: '-piaq',
// expression_postbase: '-piar\\',
// expression_conditional_end: '-pik',
// expression_conditional_postbase: '-pig\\',
// conditional_rule: '',
// priority:4,
// tense:'past',
allowable_next_ids:[5]},{id:6,expression:'\u2013nguar[N\u2192N]',// description: 'fake',
// englishModifier: (english) => { return 'fake '+ english; },
// expression_end: '-(6)uaq',
// expression_postbase: '-(6)uar\\',
// expression_conditional_end: '',
// expression_conditional_postbase: '',
// conditional_rule: '',
// priority:4,
// tense:'',
allowable_next_ids:[6]},// {
//   id: 7,
//   expression:'',
//   // description: 'many Ns',
//   // englishModifier: (english) => { return 'many of them'+ english},
//   // expression_end: '-rugaq',
//   // expression_postbase: '-rugar\\',
//   // expression_conditional_end: '',
//   // expression_conditional_postbase: '',
//   // conditional_rule: '',
//   // priority:2,
//   // tense:'noun_end',
//   allowable_next_ids: [7]
// },
{id:8,expression:'\u2013rrar*[N\u2192N]',// description: 'just a little',
// englishModifier: (english) => { return 'just a little'+ english},
// expression_end: '-5aq',
// expression_postbase: '-5ar\\',
// expression_conditional_end: '',
// expression_conditional_postbase: '',
// conditional_rule: '',
// priority:2,
// tense:'noun_end',
allowable_next_ids:[8]}];var popularVPostbasesNOTIME=[{id:0,// description: 'probably',
allowable_next_ids:[1,0],expression:'@~+yugnarqe¹[V→V]'},{id:1,// description: 'evidently',
allowable_next_ids:[0,1],expression:'–llini[V→V]'},{id:2,// description: 'no longer able to',
expression:"+(s)ciigali[V→V]",allowable_next_ids:[1,3,2]},{id:3,// description: 'not able to',
expression:'+(s)ciigate[V→V]',allowable_next_ids:[1,2,3]},{id:4,// description: 'is able to',
expression:'@~+yugnga[V→V]',allowable_next_ids:[0,1,6,7,8,4]},{id:11,// description: 'repeatedly',
expression:"–lar[V→V]",allowable_next_ids:[1,11]},{id:12,// description: 'doing it again',
expression:'–nqigte[V→V]',allowable_next_ids:[1,12]},{id:13,// description: 'almost',
expression:'@~+yarpiar[V→V]',allowable_next_ids:[1,13]},{id:14,// description: 'never',
expression:'@~–yuite[V→V]',allowable_next_ids:[1,14]},{id:15,// description: 'no longer',
expression:'–nrir[V→V]',allowable_next_ids:[0,1,27,15]},{id:16,// description: 'trying (unsuccessfully) to',
expression:'@~+yaaqe[V→V]',allowable_next_ids:[0,1,17,19,16]},{id:17,// description: 'trying despite difficulties to',
expression:'–qcaar(ar)[V→V]',allowable_next_ids:[0,1,16,18,17]},{id:18,// description: 'trying to',
expression:'–ngnaqe[V→V]',allowable_next_ids:[0,1,16,17,18]},{id:19,// description: 'excessively (too much)',
expression:'–ssiyaag[V→V]',allowable_next_ids:[1,19]},{id:20,// description: 'to be more or better at',
expression:'–nru[V→V]',allowable_next_ids:[1,20]},{id:21,// description: 'loves to',
expression:'@~+yunqegg[V→V]',allowable_next_ids:[0,1,7,8,21]},{id:22,// description: 'no longer wants to',
expression:'@~+yuumiir(ar)te[V→V]',allowable_next_ids:[0,1,7,8,22]},{id:23,// description: 'not care to',
expression:'@~+yuumiite[V→V]',allowable_next_ids:[0,1,7,8,23]},{id:24,// description: 'yearns to',
expression:'@~+yuumir[V→V]',allowable_next_ids:[0,1,7,8,24]},{id:25,// description: 'wants to',
expression:'@~+yug[V→V]',allowable_next_ids:[0,1,7,8,25]},{id:26,// description: 'enjoys doing',
expression:'@~+yugar[V→V]',allowable_next_ids:[0,1,7,8,26]},{id:27,// description: 'not',
expression:'–nrite[V→V]',allowable_next_ids:[0,1,27]},{id:28,// description: 'in the process of',
expression:'@~+yartur[V→V]',allowable_next_ids:[0,1,2,3,4,5,6,7,8,9,10,19,28]},{id:29,// description: 'definitely no longer going to',
expression:'@~+yugnairute[V→V]',allowable_next_ids:[0,1,3,4,8,10,29]// only refers to the postbases, not the endings
}];var popularVPostbasesPAST=[{id:5,// description: 'past tense',
expression:'–llru¹[V→V]',allowable_next_ids:[7,5,8,9]},{id:6,// description: 'not yet',
expression:"–ksaite[V→V]",allowable_next_ids:[0,1,7,6]}];var popularVPostbasesFUTURE=[{id:7,// description: 'future tense',
expression:'+ciqe|@ciiqe[V→V]',allowable_next_ids:[0,1,5,10,7]},{id:8,// description: 'will not',
expression:'@~+ngaite[V→V]',allowable_next_ids:[0,1,7,10,8]},{id:9,// description: 'will soon',
expression:'@~+niarar[V→V]',allowable_next_ids:[0,1,5,6,7,10,9]},{id:10,// description: 'about to',
expression:'–qatar[V→V]',allowable_next_ids:[1,7,10]}];var colorsList=[{'mvv.s':'#852828','mvv.o':'#C84141','mvv.b':'#000000',// 'mvv.m':'#838383',
'mvv.m':'#000000','mvv.1':'#000000','mvv.2':'#000000','mvv.3':'#000000','mvqWord':'#47995f',// 'past':'#dd9221',
// 'future':'#dd9221',
'past':'#000000','future':'#000000','mvns00.b':'#852828','mvns00.pd':'#852828','mvns10.ps':'#9c9c9c','mvns20.ps':'#9c9c9c',// 'mvns00.ps':'#000000',
// 'mvns10.b':'#000000',
// 'mvns10.pd':'#000000',
// 'mvns20.b':'#000000',
// 'mvns20.pd':'#000000',
// 'mvns10.b':'#852828',
// 'mvns10.pd':'#852828',
'mvns00.c':'#663782','mvns00.1':'#852828','mvns00.2':'#852828','mvns00.3':'#852828','mvno00.b':'#C84141','mvno00.pd':'#C84141','mvno10.ps':'#9c9c9c','mvno20.ps':'#9c9c9c','mvno00.c':'#663782',// 'mvno10.b':'#000000',
// 'mvno20.b':'#000000',
// 'mvno10.b':'#C84141',
// 'mvno10.pd':'#C84141', 
'mvno00.1':'#C84141','mvno00.2':'#C84141','mvno00.3':'#C84141','cvv.b':'#000000','cvv.s':'#287485','cvv.o':'#565994','cvv.m':'#c27db0','cvv.1':'#000000','cvv.2':'#000000','cvv.3':'#000000','cvns00.b':'#287485','cvns00.pd':'#287485','cvns10.ps':'#9c9c9c','cvns20.ps':'#9c9c9c','cvns00.c':'#663782',// 'cvns10.b':'#000000',
// 'cvns20.b':'#000000',
// 'cvns10.pd':'#287485',
'cvns00.1':'#287485','cvns00.2':'#287485','cvns00.3':'#287485','cvno00.b':'#565994','cvno00.pd':'#565994','cvno10.ps':'#9c9c9c','cvno20.ps':'#9c9c9c','cvno00.c':'#663782',// 'cvno10.b':'#000000',
// 'cvno20.b':'#000000',
// 'cvno10.b':'#565994',
// 'cvno10.pd':'#565994', 
'cvno00.1':'#565994','cvno00.2':'#565994','cvno00.3':'#565994','svv.b':'#000000','svv.o':'#565994','svv.s':'#852828','svv.e':'#565994','svv.m':'#000000','svv.1':'#000000','svv.2':'#000000','svv.3':'#000000','svno00.b':'#565994','svno00.pd':'#565994','svno10.ps':'#9c9c9c','svno20.ps':'#9c9c9c','svno00.c':'#663782',// 'svno10.b':'#000000',
// 'svno20.b':'#000000',
// 'svno10.b':'#565994',
// 'svno10.pd':'#565994', 
'svno00.1':'#565994','svno00.2':'#565994','svno00.3':'#565994','npn00.b':'#852828','npn00.pd':'#852828','npn00.ps':'#5c5c5c','npn00.c':'#663782','npn00.1':'#852828','npn00.2':'#852828','npn00.3':'#852828','mvnObliques000.b':'#000000','mvnObliques000.pd':'#000000','mvnObliques010.ps':'#9c9c9c','mvnObliques000.c':'#663782','mvnObliques000.1':'#000000','mvnObliques000.2':'#000000','mvnObliques000.3':'#000000','mvnObliques100.b':'#000000','mvnObliques100.pd':'#000000','mvnObliques110.ps':'#9c9c9c','mvnObliques100.c':'#663782','mvnObliques100.1':'#000000','mvnObliques100.2':'#000000','mvnObliques100.3':'#000000','cvnObliques000.b':'#000000','cvnObliques000.pd':'#000000','cvnObliques010.ps':'#9c9c9c','cvnObliques000.c':'#663782','cvnObliques000.1':'#000000','cvnObliques000.2':'#000000','cvnObliques000.3':'#000000','cvnObliques100.b':'#000000','cvnObliques100.pd':'#000000','cvnObliques110.ps':'#9c9c9c','cvnObliques100.c':'#663782','cvnObliques100.1':'#000000','cvnObliques100.2':'#000000','cvnObliques100.3':'#000000','svnObliques000.b':'#000000','svnObliques000.pd':'#000000','svnObliques010.ps':'#9c9c9c','svnObliques000.c':'#663782','svnObliques000.1':'#000000','svnObliques000.2':'#000000','svnObliques000.3':'#000000','svnObliques100.b':'#000000','svnObliques100.pd':'#000000','svnObliques110.ps':'#9c9c9c','svnObliques100.c':'#663782','svnObliques100.1':'#000000','svnObliques100.2':'#000000','svnObliques100.3':'#000000'// #287485
// #565994
},{'npn00.c':'#663782','npn00.1':'#852828','mvv.1b':'#d3741e','mvv.1':'#000000','mvnObliques000.c':'#663782','mvqWord':'#47995f',"qaa":"#47995f",'past':'#000000','future':'#000000','mvns00.b':'#852828','mvns00.ps':'#852828',"mvns00.pd":'#852828','mvns00.c':'#852828',"1stperson":"#dd9221","mvno00.1":'#c84141','mvno00.b':'#c84141','mvno00.ps':'#c84141',"mvno00.pd":'#c84141','mvno00.c':'#c84141','cvv.b':'#287485','cvv.s':'#287485','cvv.o':'#287485','cvv.m':'#287485','cvv.1':'#287485','cvv.2':'#287485','cvv.3':'#287485','svv.b':'#287485','svv.s':'#287485','svv.o':'#287485','svv.m':'#287485','svv.1':'#287485','svv.2':'#287485','svv.3':'#287485'},{'mvv.s':'#852828','mvv.o':'#287485','mvv.b':'#000000','mvnObliques000.b':'#000000','mvnObliques000.ps':'#000000','mvnObliques000.pd':'#000000','mvnObliques000.c':'#000000','mvnObliques000.1':'#000000','mvnObliques000.2':'#000000','mvnObliques000.3':'#000000','mvnObliques000.4':'#000000','mvnObliques000.5':'#000000','mvnObliques100.b':'#000000','mvnObliques100.ps':'#000000','mvnObliques100.pd':'#000000','mvnObliques100.c':'#000000','mvnObliques100.1':'#000000','mvnObliques100.2':'#000000','mvnObliques100.3':'#000000','mvnObliques100.4':'#000000','mvnObliques100.5':'#000000','cvv.b':'#000000','cvv.e':'#000000','cvv.s':'#000000','cvv.o':'#000000','cvv.m':'#000000','cvv.1':'#000000','cvv.2':'#000000','cvv.3':'#000000','cvv.4':'#000000','cvv.5':'#000000','npn00.b':'#852828','npn00.pd':'#852828','npn00.ps':'#C84141','npn00.1':'#000000','npn00.2':'#000000','npn00.3':'#000000','npn00.4':'#000000','npn00.5':'#000000','npn00.c':'#000000','npn10.b':'#C84141','npn10.pd':'#C84141','mvns00.b':'#852828','mvns00.ps':'#C84141','mvns00.pd':'#852828','mvns00.1':'#000000','mvns00.2':'#000000','mvns00.3':'#000000','mvns00.4':'#000000','mvns00.5':'#000000','mvns00.e':'#000000','mvno00.b':'#287485','mvno00.pd':'#287485','mvno00.ps':'#565994','mvno00.c':'#3e3e3e','mvno10.b':'#287485','mvno10.pd':'#287485','mvno00.1':'#000000','mvno00.2':'#000000','mvno00.3':'#000000','mvno00.4':'#000000','mvno00.5':'#000000','mvno00.e':'#000000'},{'1st-1':'purple','1st-2':'purple','mvv.b':'#000000','mvv.e':'#852828','mvv.s':'#852828','mvv.o':'#C84141','mvv.m':'#838383','mvv.1':'#d3741e','mvv.2':'#c062c3','mvv.3':'#008000','mvv.4':'#69b4b4','mvv.5':'#e02323','mvv.6':'#3455b5','mvnObliques000.b':'#000000','mvnObliques000.ps':'#c51818','mvnObliques000.pd':'#d23636','mvnObliques000.c':'#9c9c9c','mvnObliques000.1':'#69b4b4','mvnObliques100.b':'#000000','mvnObliques100.ps':'#c51818','mvnObliques100.pd':'#d23636','mvnObliques100.c':'#9c9c9c','cvv.b':'#000000','cvv.e':'#3070AB','cvv.s':'#3070AB','cvv.o':'#618EB8','cvv.m':'#75557e','npn00.b':'#000000','npn00.pd':'#d65c1e','npn00.ps':'#d28036','npn00.1':'#69b4b4','npn00.2':'#e02323','npn00.c':'#9c9c9c','mvns00.b':'#852828','mvns00.ps':'#c51818','mvns00.pd':'#d23636','mvns00.1':'#b53434','mvns00.2':'#578f7f','mvns00.e':'#f29090','mvno00.b':'#C84141','mvno00.1':'#b53434','mvno00.2':'#578f7f','mvno00.e':'#f29090'},{'mvv.b':'#000000','mvv.e':'#852828','mvv.s':'#852828','mvv.o':'#C84141','mvv.m':'#838383','mvv.1':'#d3741e','mvv.2':'#c062c3','mvv.3':'#008000','mvv.4':'#69b4b4','mvv.5':'#e02323','mvv.6':'#3455b5','mvnObliques000.b':'#000000','mvnObliques000.ps':'#c51818','mvnObliques000.pd':'#d23636','mvnObliques010.ps':'#c51818','mvnObliques010.pd':'#d23636','mvnObliques000.c':'#9c9c9c','mvnObliques000.1':'#69b4b4','mvnObliques100.b':'#000000','mvnObliques100.ps':'#c51818','mvnObliques100.pd':'#d23636','mvnObliques100.c':'#9c9c9c','cvv.b':'#000000','cvv.e':'#3070AB','cvv.s':'#3070AB','cvv.o':'#618EB8','cvv.m':'#75557e','npn00.b':'#000000','npn00.pd':'#d23636','npn00.ps':'#c51818','npn00.1':'#69b4b4','npn00.2':'#e02323','npn00.c':'#9c9c9c','mvns00.b':'#852828','mvns00.ps':'#c51818','mvns00.pd':'#d23636','mvns00.1':'#b53434','mvns00.2':'#578f7f','mvns00.e':'#f29090','mvno00.b':'#C84141','mvno00.1':'#b53434','mvno00.2':'#578f7f','mvno00.e':'#f29090'}];var retrieveMoodEnglish={'Prec':{english:'before',fst:'@~+(t)vaileg-'},'Cnsq':{english:'because',fst:'@~:(ng)a-'},'Cont':{english:'whenever',fst:"+'(g)aqa-"},'Conc':{english:'although, even though, even if',fst:'@+ngr(ar)-'},'Cond':{english:'if, when in the future',fst:'@~-ku-'},'CtmpI':{english:'when in the past',fst:'-ller-'},'CtmpII':{english:'while',fst:'@:(ng)inaner-'}};var nounoptions1=[{id:0,value:'00(3)',text:'the'},{id:1,value:'11(3)',text:'my'},{id:2,value:'21(3)',text:'your'},{id:3,value:'31-1(3)',text:'his'},{id:4,value:'31-2(3)',text:'her'},{id:5,value:'31-3(3)',text:'its'},// {id: 6, value: '41(3)', text:'its own'},
{id:7,value:'12(3)',text:'our (two)'},{id:8,value:'22(3)',text:'your (two)'},{id:9,value:'32(3)',text:'their (two)'},// {id: 10, value: '42(3)', text:'their own (two)'},
{id:11,value:'13(3)',text:'our (3+)'},{id:12,value:'23(3)',text:'your (3+)'},{id:13,value:'33(3)',text:'their (3+)'}];var nounoptionsmodalis=[{id:0,value:'00(3)',text:'a, some'},{id:1,value:'11(3)',text:'my'},{id:2,value:'21(3)',text:'your'},{id:3,value:'31-1(3)',text:'his'},{id:4,value:'31-2(3)',text:'her'},{id:5,value:'31-3(3)',text:'its'},// {id: 6, value: '41(3)', text:'its own'},
{id:7,value:'12(3)',text:'our (two)'},{id:8,value:'22(3)',text:'your (two)'},{id:9,value:'32(3)',text:'their (two)'},// {id: 10, value: '42(3)', text:'their own (two)'},
{id:11,value:'13(3)',text:'our (3+)'},{id:12,value:'23(3)',text:'your (3+)'},{id:13,value:'33(3)',text:'their (3+)'}];var nounoptions2=[{id:0,value:'1',text:'one'},{id:1,value:'2',text:'two'},{id:2,value:'3',text:'3+'}];var nounOptionsPossessorsNo4th=[{id:0,value:'000',text:'the'},{id:1,value:'110',text:'my'},{id:2,value:'210',text:'your'},{id:3,value:'311',text:'his'},{id:4,value:'312',text:'her'},{id:5,value:'313',text:'its'},// {id: 6, value: '41', text:'its own'},
{id:7,value:'120',text:'our (two)'},{id:8,value:'220',text:'your (two)'},{id:9,value:'320',text:'their (two)'},// {id: 10, value: '42', text:'their own (two)'},
{id:11,value:'130',text:'our (3+)'},{id:12,value:'230',text:'your (3+)'},{id:13,value:'330',text:'their (3+)'}];var nounOptionsMVPossessorsThe=[{id:0,value:'000',text:'the'},{id:1,value:'110',text:'my'},{id:2,value:'210',text:'your'},{id:3,value:'311',text:'his'},{id:4,value:'312',text:'her'},{id:5,value:'313',text:'its'},// {id: 6, value: '410', text: "mvsubject's"},
{id:7,value:'120',text:'our (two)'},{id:8,value:'220',text:'your (two)'},{id:9,value:'320',text:'their (two)'},// {id: 10, value: '420', text:'their own (two)'},
{id:11,value:'130',text:'our (3+)'},{id:12,value:'230',text:'your (3+)'},{id:13,value:'330',text:'their (3+)'}];var nounOptionsMVPossessors=[// {id: 0, value: '000', text:'the'},
{id:1,value:'110',text:'my'},{id:2,value:'210',text:'your'},{id:3,value:'311',text:'his'},{id:4,value:'312',text:'her'},{id:5,value:'313',text:'its'},// {id: 6, value: '410', text: "mvsubject's"},
{id:7,value:'120',text:'our (two)'},{id:8,value:'220',text:'your (two)'},{id:9,value:'320',text:'their (two)'},// {id: 10, value: '420', text:'their own (two)'},
{id:11,value:'130',text:'our (3+)'},{id:12,value:'230',text:'your (3+)'},{id:13,value:'330',text:'their (3+)'}];// export const nounOptionsMVAblPossessors = [
//   {id: 0, value: '000', text:'a, some'},
//   {id: 1, value: '110', text:'my'},
//   {id: 2, value: '210', text:'your'},
//   {id: 3, value: '311', text:'his'},
//   {id: 4, value: '312', text:'her'},
//   {id: 5, value: '313', text:'its'},
//   // {id: 6, value: '410', text: "mvsubject's"},
//   {id: 7, value: '120', text:'our (two)'},
//   {id: 8, value: '220', text:'your (two)'},
//   {id: 9, value: '320', text:'their (two)'},
//   // {id: 10, value: '420', text:'their own (two)'},
//   {id: 11, value: '130', text:'our (3+)'},
//   {id: 12, value: '230', text:'your (3+)'},
//   {id: 13, value: '330', text:'their (3+)'},
//   // {id: 14, value: '430', text:'their own (3+)'},
// ];
// export const nounOptionsCVAblPossessors = [
//   // {id: 0, value: '000', text:'a, some'},
//   {id: 1, value: '110', text:'my'},
//   {id: 2, value: '210', text:'your'},
//   {id: 3, value: '311', text:'his'},
//   {id: 4, value: '312', text:'her'},
//   {id: 5, value: '313', text:'its'},
//   // {id: 6, value: '411', text:"cvsubject's"},
//   {id: 7, value: '120', text:'our (two)'},
//   {id: 8, value: '220', text:'your (two)'},
//   {id: 9, value: '320', text:'their (two)'},
//   // {id: 10, value: '420', text:'their own (two)'},
//   {id: 11, value: '130', text:'our (3+)'},
//   {id: 12, value: '230', text:'your (3+)'},
//   {id: 13, value: '330', text:'their (3+)'},
//   // {id: 14, value: '430', text:'their own (3+)'},
// ];
// export const nounOptionsCVPossessors = [
//   // {id: 0, value: '000', text:'the'},
//   {id: 1, value: '110', text:'my'},
//   {id: 2, value: '210', text:'your'},
//   {id: 3, value: '311', text:'his'},
//   {id: 4, value: '312', text:'her'},
//   {id: 5, value: '313', text:'its'},
//   // {id: 6, value: '411', text:"cvsubject's"},
//   {id: 7, value: '120', text:'our (two)'},
//   {id: 8, value: '220', text:'your (two)'},
//   {id: 9, value: '320', text:'their (two)'},
//   // {id: 10, value: '420', text:'their own (two)'},
//   {id: 11, value: '130', text:'our (3+)'},
//   {id: 12, value: '230', text:'your (3+)'},
//   {id: 13, value: '330', text:'their (3+)'},
//   // {id: 14, value: '430', text:'their own (3+)'},
// ];
// export const nounOptionsSVPossessors = [
//   {id: 0, value: '000', text:'the'},
//   {id: 1, value: '110', text:'my'},
//   {id: 2, value: '210', text:'your'},
//   {id: 3, value: '311', text:'his'},
//   {id: 4, value: '312', text:'her'},
//   {id: 5, value: '313', text:'its'},
//   // {id: 6, value: '412', text:"svsubject's"},
//   {id: 7, value: '120', text:'our (two)'},
//   {id: 8, value: '220', text:'your (two)'},
//   {id: 9, value: '320', text:'their (two)'},
//   // {id: 10, value: '420', text:'their own (two)'},
//   {id: 11, value: '130', text:'our (3+)'},
//   {id: 12, value: '230', text:'your (3+)'},
//   {id: 13, value: '330', text:'their (3+)'},
//   // {id: 14, value: '430', text:'their own (3+)'},
// ];
var nounOptionsNumbers=[{id:0,value:'1',text:'one'},{id:1,value:'2',text:'two'},{id:2,value:'3',text:'3+'}];var mvSubjectOptionsEnglish={'110':'I','210':'you','310':'it','311':'he','312':'she','313':'it','410':'subject','120':'the two of us','220':'the two of you','320':'the two of them','420':'their own (two)','130':'we all (3+)','230':'you all (3+)','330':'they all (3+)','430':'their own (3+)'};var mvObjectOptionsEnglish={'110':'me','210':'you','310':'it','311':'him','312':'her','313':'it','410':'subject','120':'the two of us','220':'the two of you','320':'the two of them','420':'their own (two)','130':'us all (3+)','230':'you all (3+)','330':'them all (3+)','430':'their own (3+)'};var npnEnglish={'1':'one','2':'two','3':'3+','000':'the','110':'my','210':'your','311':'his','312':'her','313':'its','120':'our (two)','220':'your (two)','320':'their (two)','130':'our (3+)','230':'your (3+)','330':'their (3+)'};var npnEnglishself={'1':'itself','2':'themselves','3':'themselves','000':'itself','110':'myself','210':'yourself','311':'himself','312':'herself','313':'itself','120':'ourselves (two)','220':'yourself (two)','320':'themselves (two)','130':'ourselves (3+)','230':'yourselves (3+)','330':'themselves (3+)'};var mvSubject4thPersonCalls={'311':'he','312':'she','313':'it','320':'the two of them','330':'they all (3+)'};var mvObject4thPersonCalls={'311':'him','312':'her','313':'it','320':'the two of them','330':'them all (3+)'};var nObject4thPersonCalls={'310':'its','311':'his','312':'her','313':'its','320':'their (2)','321':'their (2)','330':'their (3+)','331':'their (3+)'// '410':'its',
// '420':'their (2)',
// '430':'their (3+)',
// '411':'its',
// '421':'their (2)',
// '431':'their (3+)',
};var mvSubjectOptionsOnly2nd=[{id:1,value:'210',text:'you',otext:'you'},{id:7,value:'220',text:'you two',otext:'you two'},{id:11,value:'230',text:'you all (3+)',otext:'you all (3+)'}];var mvSubjectOptions=[{id:0,value:'110',text:'I',otext:'me'},{id:1,value:'210',text:'you',otext:'you'},{id:2,value:'311',text:'he',otext:'him'},{id:3,value:'312',text:'she',otext:'her'},{id:4,value:'313',text:'it',otext:'it'},// {id: 999, value: '999', text:'add noun', otext:'it'},
// {id: 5, value: '410', text:'subject', otext:'subject'},
{id:6,value:'120',text:'the two of us',otext:'the two of us'},{id:7,value:'220',text:'the two of you',otext:'the two of you'},{id:8,value:'320',text:'the two of them',otext:'the two of them'},// {id: 9, value: '420', text:'their own (two)', otext:'their own (two)'},
{id:10,value:'130',text:'we all (3+)',otext:'us all (3+)'},{id:11,value:'230',text:'you all (3+)',otext:'you all (3+)'},{id:12,value:'330',text:'they all (3+)',otext:'them all (3+)'}];var mvObjectOptions=[{id:0,value:'110',text:'me',ptext:'my'},{id:1,value:'210',text:'you',ptext:'your'},{id:2,value:'311',text:'him',ptext:'his'},{id:3,value:'312',text:'her',ptext:'her'},{id:4,value:'313',text:'it',ptext:'its'},// {id: 5, value: '410', text:'subject', ptext:'subject'},
{id:6,value:'120',text:'the two of us',ptext:'our (two)'},{id:7,value:'220',text:'the two of you',ptext:'your (two)'},{id:8,value:'320',text:'the two of them',ptext:'their (two)'},// {id: 9, value: '420', text:'their own (two)', ptext:'their own (two)'},
{id:10,value:'130',text:'us all (3+)',ptext:'our (3+)'},{id:11,value:'230',text:'you all (3+)',ptext:'your (3+)'},{id:12,value:'330',text:'them all (3+)',ptext:'their (3+)'}];var mvSubjectOptionsWho=[// {id: 0, value: '110', text:'I', otext:'me'},
// {id: 1, value: '210', text:'you', otext:'you'},
{id:2,value:'311',text:'he',otext:'him'},{id:3,value:'312',text:'she',otext:'her'},{id:4,value:'313',text:'it',otext:'it'},// {id: 5, value: '410', text:'subject', otext:'subject'},
// {id: 6, value: '120', text:'the two of us', otext:'the two of us'},
// {id: 7, value: '220', text:'the two of you', otext:'the two of you'},
{id:8,value:'320',text:'the two of them',otext:'the two of them'},// {id: 9, value: '420', text:'their own (two)', otext:'their own (two)'},
// {id: 10, value: '130', text:'we all (3+)', otext:'us all (3+)'},
// {id: 11, value: '230', text:'you all (3+)', otext:'you all (3+)'},
{id:12,value:'330',text:'they all (3+)',otext:'them all (3+)'}];var mvObjectOptionsWhom=[// {id: 0, value: '110', text:'whom (me)', ptext:'my'},
// {id: 1, value: '210', text:'whom (you)', ptext:'your'},
{id:2,value:'311',text:'whom (him)',ptext:'his'},{id:3,value:'312',text:'whom (her)',ptext:'her'},{id:4,value:'313',text:'whom (it)',ptext:'its'},// {id: 5, value: '410', text:'whom (subject', ptext:'subject'},
// {id: 6, value: '120', text:'whom (the two of us)', ptext:'our (two)'},
// {id: 7, value: '220', text:'whom (the two of you)', ptext:'your (two)'},
{id:8,value:'320',text:'whom (the two of them)',ptext:'their (two)'},// {id: 9, value: '420', text:'whom (their own two)', ptext:'their own (two)'},
// {id: 10, value: '130', text:'whom (us all 3+)', ptext:'our (3+)'},
// {id: 11, value: '230', text:'whom (you all 3+)', ptext:'your (3+)'},
{id:12,value:'330',text:'whom (them all 3+)',ptext:'their (3+)'}];var mvSubjectOptionsWhat=[// {id: 0, value: '110', text:'I', otext:'me'},
// {id: 1, value: '210', text:'you', otext:'you'},
// {id: 2, value: '311', text:'he', otext:'him'},
// {id: 3, value: '312', text:'she', otext:'her'},
{id:4,value:'313',text:'it',otext:'it'},// {id: 5, value: '410', text:'subject', otext:'subject'},
// {id: 6, value: '120', text:'the two of us', otext:'the two of us'},
// {id: 7, value: '220', text:'the two of you', otext:'the two of you'},
{id:8,value:'320',text:'the two of them',otext:'the two of them'},// {id: 9, value: '420', text:'their own (two)', otext:'their own (two)'},
// {id: 10, value: '130', text:'we all (3+)', otext:'us all (3+)'},
// {id: 11, value: '230', text:'you all (3+)', otext:'you all (3+)'},
{id:12,value:'330',text:'they all (3+)',otext:'them all (3+)'}];var mvObjectOptionsWhat=[{id:0,value:'110',text:'what (me)',ptext:'my'},{id:1,value:'210',text:'what (you)',ptext:'your'},// {id: 2, value: '311', text:'what (him)', ptext:'his'},
// {id: 3, value: '312', text:'what (her)', ptext:'her'},
{id:4,value:'313',text:'what (it)',ptext:'its'},// {id: 5, value: '410', text:'whom (subject', ptext:'subject'},
{id:6,value:'120',text:'what (the two of us)',ptext:'our (two)'},{id:7,value:'220',text:'what (the two of you)',ptext:'your (two)'},{id:8,value:'320',text:'what (the two of them)',ptext:'their (two)'},// {id: 9, value: '420', text:'whom (their own two)', ptext:'their own (two)'},
{id:10,value:'130',text:'what (us all 3+)',ptext:'our (3+)'},{id:11,value:'230',text:'what (you all 3+)',ptext:'your (3+)'},{id:12,value:'330',text:'what (them all 3+)',ptext:'their (3+)'}];var mvObjectOptionsWhomAbl=[// {id: 0, value: '110', text:'whom (me)', ptext:'my'},
// {id: 1, value: '210', text:'whom (you)', ptext:'your'},
{id:2,value:'311',text:'whom (him)',ptext:'his'},{id:3,value:'312',text:'whom (her)',ptext:'her'},{id:4,value:'313',text:'whom (it)',ptext:'its'},// {id: 5, value: '410', text:'whom (subject', ptext:'subject'},
// {id: 6, value: '120', text:'whom (the two of us)', ptext:'our (two)'},
// {id: 7, value: '220', text:'whom (the two of you)', ptext:'your (two)'},
{id:8,value:'320',text:'whom (some 2 people)',ptext:'their (two)'},// {id: 9, value: '420', text:'whom (their own two)', ptext:'their own (two)'},
// {id: 10, value: '130', text:'whom (us all 3+)', ptext:'our (3+)'},
// {id: 11, value: '230', text:'whom (you all 3+)', ptext:'your (3+)'},
{id:12,value:'330',text:'whom (some 3+ people)',ptext:'their (3+)'}];var mvObjectOptionsWhatAbl=[// {id: 0, value: '110', text:'what (me)', ptext:'my'},
// {id: 1, value: '210', text:'what (you)', ptext:'your'},
// {id: 2, value: '311', text:'what (him)', ptext:'his'},
// {id: 3, value: '312', text:'what (her)', ptext:'her'},
{id:4,value:'313',text:'what (something)',ptext:'its'},// {id: 5, value: '410', text:'whom (subject', ptext:'subject'},
// {id: 6, value: '120', text:'what (the two of us)', ptext:'our (two)'},
// {id: 7, value: '220', text:'what (the two of you)', ptext:'your (two)'},
{id:8,value:'320',text:'what (some 2 things)',ptext:'their (two)'},// {id: 9, value: '420', text:'whom (their own two)', ptext:'their own (two)'},
// {id: 10, value: '130', text:'what (us all 3+)', ptext:'our (3+)'},
// {id: 11, value: '230', text:'what (you all 3+)', ptext:'your (3+)'},
{id:12,value:'330',text:'what (some 3+ things)',ptext:'their (3+)'}];var options1=[{id:0,value:'s11(1)',text:'I',otext:'me'},{id:1,value:'s21(1)',text:'you',otext:'you'},{id:2,value:'s31-1(1)',text:'he',otext:'him'},{id:3,value:'s31-2(1)',text:'she',otext:'her'},{id:4,value:'s31-3(1)',text:'it',otext:'it'},// {id: 5, value: 's41(1)', text:'its own', otext:'its own'},
{id:6,value:'s12(1)',text:'the two of us',otext:'the two of us'},{id:7,value:'s22(1)',text:'the two of you',otext:'the two of you'},{id:8,value:'s32(1)',text:'the two of them',otext:'the two of them'},// {id: 9, value: 's42(1)', text:'their own (two)', otext:'their own (two)'},
{id:10,value:'s13(1)',text:'we all (3+)',otext:'us all (3+)'},{id:11,value:'s23(1)',text:'you all (3+)',otext:'you all (3+)'},{id:12,value:'s33(1)',text:'they all (3+)',otext:'them all (3+)'}];var options2=[{id:0,value:'o11(2)',text:'me',ptext:'my'},{id:1,value:'o21(2)',text:'you',ptext:'your'},{id:2,value:'o31-1(2)',text:'him',ptext:'his'},{id:3,value:'o31-2(2)',text:'her',ptext:'her'},{id:4,value:'o31-3(2)',text:'it',ptext:'its'},// {id: 5, value: 'o41(2)', text:'its own', ptext:'its own'},
{id:6,value:'o12(2)',text:'the two of us',ptext:'our (two)'},{id:7,value:'o22(2)',text:'the two of you',ptext:'your (two)'},{id:8,value:'o32(2)',text:'the two of them',ptext:'their (two)'},// {id: 9, value: 'o42(2)', text:'their own (two)', ptext:'their own (two)'},
{id:10,value:'o13(2)',text:'us all (3+)',ptext:'our (3+)'},{id:11,value:'o23(2)',text:'you all (3+)',ptext:'your (3+)'},{id:12,value:'o33(2)',text:'them all (3+)',ptext:'their (3+)'}];var options3=[{id:0,value:'o11(3)',text:'my'},{id:1,value:'o21(3)',text:'your'},{id:2,value:'o31-1(3)',text:'his'},{id:3,value:'o31-2(3)',text:'her'},{id:4,value:'o31-3(3)',text:'its'},// {id: 5, value: 'o41(2)', text:'its own'},
{id:6,value:'o12(3)',text:'our (two)'},{id:7,value:'o22(3)',text:'your (two)'},{id:8,value:'o32(3)',text:'their (two)'},// {id: 9, value: 'o42(2)', text:'their own (two)'},
{id:10,value:'o13(3)',text:'our (3+)'},{id:11,value:'o23(3)',text:'your (3+)'},{id:12,value:'o33(3)',text:'their (3+)'}];var retrieveSubjectObject={'11(1)':'I','21(1)':'you','31-1(1)':'he','31-2(1)':'she','31-3(1)':'it','41(1)':'its own','12(1)':'the two of us','22(1)':'the two of you','32(1)':'the two of them','42(1)':'their own (two)','13(1)':'we all (3+)','23(1)':'you all (3+)','33(1)':'they all (3+)','43(1)':'their own (3+)','11(2)':'me','21(2)':'you','31-1(2)':'him','31-2(2)':'her','31-3(2)':'it','41(2)':'its own','12(2)':'the two of us','22(2)':'the two of you','32(2)':'the two of them','42(2)':'their own (two)','13(2)':'us all (3+)','23(2)':'you all (3+)','33(2)':'them all (3+)','43(2)':'their own (3+)','11(3)':'my','21(3)':'your','31-1(3)':'his','31-2(3)':'her','31-3(3)':'its','41(3)':'its own','12(3)':'our (two)','22(3)':'your (two)','32(3)':'their (two)','42(3)':'their own (two)','13(3)':'our (3+)','23(3)':'your (3+)','33(3)':'their (3+)','43(3)':'their own (3+)'};var retrieveReflexiveSubjectPronoun={'self':{'s11(1)':'myself','s21(1)':'yourself','s31-1(1)':'himself','s31-2(1)':'herself','s31-3(1)':'itself',// '41(1)':'its own',
's12(1)':'ourselves','s22(1)':'yourselves','s32(1)':'themselves',// '42(1)':'their own (two)',
's13(1)':'ourselves','s23(1)':'yourselves','s33(1)':'themselves'},'poss':{'s11(1)':'my','s21(1)':'your','s31-1(1)':'his','s31-2(1)':'her','s31-3(1)':'its',// '41(1)':'its own',
's12(1)':'our','s22(1)':'your','s32(1)':'their',// '42(1)':'their own (two)',
's13(1)':'our','s23(1)':'your','s33(1)':'their'},'regSub':{'s11(1)':'I','s21(1)':'you','s31-1(1)':'he','s31-2(1)':'she','s31-3(1)':'it',// '41(1)':'its own',
's12(1)':'we','s22(1)':'you two','s32(1)':'they',// '42(1)':'their own (two)',
's13(1)':'we all','s23(1)':'you all','s33(1)':'they all'},'regObj':{'s11(1)':'me','s21(1)':'you','s31-1(1)':'him','s31-2(1)':'her','s31-3(1)':'it',// '41(1)':'its own',
's12(1)':'the two of us','s22(1)':'the two of you','s32(1)':'the two of them',// '42(1)':'their own (two)',
's13(1)':'us all','s23(1)':'you all','s33(1)':'them all'}};// export const retrieveReflexiveSubjectPronounSelf =
//   {
//   's11(1)':'myself',
//   's21(1)':'yourself',
//   's31-1(1)':'himself',
//   's31-2(1)':'herself',
//   's31-3(1)':'itself',
//   // '41(1)':'its own',
//   's12(1)':'ourselves',
//   's22(1)':'yourselves',
//   's32(1)':'themselves',
//   // '42(1)':'their own (two)',
//   's13(1)':'ourselves',
//   's23(1)':'yourselves',
//   's33(1)':'themselves',
//   // '43(1)':'their own (3+)'
// }
// ;
var NNpostbases={"0":{"description":"little piece of","require":"singularize","pluralDefinition":"little pieces of","exp_display":'\u2013ar(ar*)',"exp":'\u2013ar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"little piece of"},"1":{"description":"with a small","require":"singularize","pluralDefinition":"with a small","exp_display":'\u2013cengar*',"exp":'\u2013cengar*[N\u2192N]',"postDefinition":"","singularDefinition":"with a small"},"2":{"description":"worthless","require":"","pluralDefinition":"worthless","exp_display":'\u2013ciller',"exp":'\u2013ciller[N\u2192N]',"postDefinition":"","singularDefinition":"worthless"},"3":{"description":"small","require":"","pluralDefinition":"small","exp_display":'\u2013cuar(ar*)',"exp":'\u2013cuar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"small"},"4":{"description":"unpleasing","require":"","pluralDefinition":"unpleasing","exp_display":'\u2013cug',"exp":'\u2013cug[N\u2192N]',"postDefinition":"","singularDefinition":"unpleasing"},"5":{"description":"cute little","require":"","pluralDefinition":"cute little","exp_display":'\u2013cungar',"exp":'\u2013cungar[N\u2192N]',"postDefinition":"","singularDefinition":"cute little"},"6":{"description":"mere (and nothing more)","require":"","pluralDefinition":"mere (and nothing more)","exp_display":"%:(ng)inar*","exp":'%:(ng)inar*[N\u2192N]',"postDefinition":"","singularDefinition":"mere (and nothing more)"},"8":{"description":"late (deceased)","require":"","pluralDefinition":"late (deceased)","exp_display":"%:(ng)i%:rute","exp":'%:(ng)i%:rute[N\u2192N]',"postDefinition":"","singularDefinition":"late (deceased)"},"9":{"description":"little bit of","require":"","pluralDefinition":"little bits of","exp_display":'\u2013kainer',"exp":'\u2013kainer[N\u2192N]',"postDefinition":"","singularDefinition":"little bit of"},"10":{"description":"future","require":"","pluralDefinition":"future","exp_display":"+kar","exp":'+kar[N\u2192N]',"postDefinition":"","singularDefinition":"future"},"11":{"description":"small","require":"","pluralDefinition":"small","exp_display":'@\u2075kar(ar*)',"exp":'@kar(ar*)1[N\u2192N]',"postDefinition":"","singularDefinition":"small"},"12":{"description":"thing that looks like","require":"pluralize","pluralDefinition":"things that looks like","exp_display":'\u2013kcag',"exp":'\u2013kcag[N\u2192N]',"postDefinition":"","singularDefinition":"thing that looks like"},"13":{"description":"small","require":"","pluralDefinition":"small","exp_display":'\u2013kcuar(ar*)',"exp":'\u2013kcuar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"small"},"14":{"description":"good","require":"","pluralDefinition":"good","exp_display":'\u2013k\u0332egtaar(ar*)',"exp":'\u2013kegtaar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"good"},"15":{"description":"good","require":"","pluralDefinition":"good","exp_display":'\u2013kegtaar(ar*)',"exp":'\u2013kegtaar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"good"},"16":{"description":"very ugly","require":"","pluralDefinition":"very ugly","exp_display":'@\u2075\u2013ksagar',"exp":'@\u2013ksagar[N\u2192N]',"postDefinition":"","singularDefinition":"very ugly"},"17":{"description":"small","require":"","pluralDefinition":"small","exp_display":'@\u2075ksuar(ar*)',"exp":'@ksuar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"small"},"18":{"description":"leftover","require":"","pluralDefinition":"leftover","exp_display":"+kuar","exp":'+kuar[N\u2192N]',"postDefinition":"","singularDefinition":"leftover"},"19":{"description":"of the same kind as","require":"pluralize","pluralDefinition":"of the same kind as","exp_display":'\u2013kucir',"exp":'\u2013kucir[N\u2192N]',"postDefinition":"","singularDefinition":"of the same kind as"},"20":{"description":"small amount of","require":"singularize","pluralDefinition":"small amounts of","exp_display":'\u2013kuiner(ar*)',"exp":'\u2013kuiner(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"small amount of"},"21":{"description":"small amount of","require":"singularize","pluralDefinition":"small amounts of","exp_display":'\u2013kuinr(ar*)',"exp":'\u2013kuinr(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"small amount of"},"22":{"description":"small amount of","require":"singularize","pluralDefinition":"small amounts of","exp_display":'\u2013kuiner',"exp":'\u2013kuiner[N\u2192N]',"postDefinition":"","singularDefinition":"small amount of"},"23":{"description":"thing to be used as one would with","require":"pluralize","pluralDefinition":"things to be used as one would with","exp_display":'\u2013k\u0332utar',"exp":'\u2013kutar[N\u2192N]',"postDefinition":"","singularDefinition":"thing to be used as one would with"},"24":{"description":"thing to be used as one would with","require":"pluralize","pluralDefinition":"things to be used as one would with","exp_display":'\u2013kute',"exp":'\u2013kute[N\u2192N]',"postDefinition":"","singularDefinition":"thing to be used as one would with"},"25":{"description":"small bit of","require":"singularize","pluralDefinition":"small bits of","exp_display":'\u2013kuyug',"exp":'\u2013kuyug[N\u2192N]',"postDefinition":"","singularDefinition":"small bit of"},"26":{"description":"small bit of","require":"singularize","pluralDefinition":"small bits of","exp_display":'\u2013kuyugar',"exp":'\u2013kuyugar[N\u2192N]',"postDefinition":"","singularDefinition":"small bit of"},"27":{"description":"with","require":"pluralize","pluralDefinition":"with","exp_display":'\u2013leg',"exp":'\u2013leg[N\u2192N]',"postDefinition":"","singularDefinition":"with"},"28":{"description":"sharer of","require":"pluralize","pluralDefinition":"sharers of","exp_display":'\u2013lgute',"exp":'\u2013lgute[N\u2192N]',"postDefinition":"","singularDefinition":"sharer of"},"29":{"description":"similar to","require":"pluralize","pluralDefinition":"similar to","exp_display":"+li","exp":'+li1[N\u2192N]',"postDefinition":"","singularDefinition":"similar to"},"30":{"description":"similar to","require":"pluralize","pluralDefinition":"similar to","exp_display":"+lir","exp":'+lir[N\u2192N]',"postDefinition":"","singularDefinition":"similar to"},"31":{"description":"made","require":"","pluralDefinition":"made","exp_display":'\u2013\u2013liar',"exp":'\u2013\u2013liar[N\u2192N]',"postDefinition":"","singularDefinition":"made"},"32":{"description":"product of","require":"singularize","pluralDefinition":"products of","exp_display":'\u2013\u2013linrar*',"exp":'\u2013\u2013linrar*[N\u2192N]',"postDefinition":"","singularDefinition":"product of"},"33":{"description":"product of","require":"singularize","pluralDefinition":"products of","exp_display":'\u2013\u2013linr(ar*)',"exp":'\u2013\u2013linr(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"product of"},"34":{"description":"no-good","require":"","pluralDefinition":"no-good","exp_display":'\u2013lkug',"exp":'\u2013lkug[N\u2192N]',"postDefinition":"","singularDefinition":"no-good"},"35":{"description":"(with reference to the past)","require":"","pluralDefinition":"","exp_display":'\u2013llar*',"exp":'\u2013llar*[N\u2192N]',"postDefinition":"(with reference to the past)","singularDefinition":""},"36":{"description":"former","require":"","pluralDefinition":"former","exp_display":'\u2013ller',"exp":'\u2013ller1[N\u2192N]',"postDefinition":"","singularDefinition":"former"},"37":{"description":"shabby old","require":"","pluralDefinition":"shabby old","exp_display":'\u2013ller(ar*)',"exp":'\u2013ller(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"shabby old"},"39":{"description":"bad","require":"","pluralDefinition":"bad","exp_display":'@\u2075\u2013llug',"exp":'@\u2013llug[N\u2192N]',"postDefinition":"","singularDefinition":"bad"},"40":{"description":"old broken piece of","require":"singularize","pluralDefinition":"old broken pieces of","exp_display":'\u2013lqur',"exp":'\u2013lqur[N\u2192N]',"postDefinition":"","singularDefinition":"old broken piece of"},"41":{"description":"good","require":"","pluralDefinition":"good","exp_display":'\u2013luatar',"exp":'\u2013luatar[N\u2192N]',"postDefinition":"","singularDefinition":"good"},"42":{"description":"original","require":"","pluralDefinition":"original","exp_display":'\u2013lugpiar',"exp":'\u2013lugpiar[N\u2192N]',"postDefinition":"","singularDefinition":"original"},"44":{"description":"thing held in ^one's^","require":"singularize","pluralDefinition":"things held in ^one's^","exp_display":"+mig","exp":'+mig[N\u2192N]',"postDefinition":"","singularDefinition":"thing held in ^one's^"},"45":{"description":"thing held in ^one's^","require":"singularize","pluralDefinition":"things held in ^one's^","exp_display":"+miar","exp":'+miar[N\u2192N]',"postDefinition":"","singularDefinition":"thing held in ^one's^"},"46":{"description":"inhabitant of","require":"singularize","pluralDefinition":"inhabitants of","exp_display":"~+miu","exp":'~+miu[N\u2192N]',"postDefinition":"","singularDefinition":"inhabitant of"},"47":{"description":"whose place is","require":"singularize","pluralDefinition":"whose place is","exp_display":"~+miutar*","exp":'~+miutar*[N\u2192N]',"postDefinition":"","singularDefinition":"whose place is"},"49":{"description":"area of","require":"singularize","pluralDefinition":"area of","exp_display":"+ner","exp":'+ner4[N\u2192N]',"postDefinition":"","singularDefinition":"area of"},"50":{"description":"new","require":"","pluralDefinition":"new","exp_display":'\u2013nerrar*',"exp":'\u2013nerrar*[N\u2192N]',"postDefinition":"","singularDefinition":"new"},"51":{"description":"new","require":"","pluralDefinition":"new","exp_display":'\u2013nerrar(ar*)',"exp":'\u2013nerrar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"new"},"52":{"description":"new","require":"","pluralDefinition":"new","exp_display":'\u2013nerar(ar*)',"exp":'\u2013nerar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"new"},"53":{"description":"good old (but perhaps decrepit)","require":"","pluralDefinition":"good old (but perhaps decrepit)","exp_display":'\u2013ngirta\'rrlugar*',"exp":'\u2013ngirta\'rrlugar*[N\u2192N]',"postDefinition":"","singularDefinition":"good old (but perhaps decrepit)"},"54":{"description":"poor quality","require":"","pluralDefinition":"poor quality","exp_display":'\u2013ngnagar',"exp":'\u2013ngnagar[N\u2192N]',"postDefinition":"","singularDefinition":"poor quality"},"55":{"description":"secret","require":"","pluralDefinition":"secret","exp_display":'\u2013ngssaar(ar*)',"exp":'\u2013ngssaar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"secret"},"56":{"description":"inauthentic","require":"","pluralDefinition":"inauthentic","exp_display":'\u2013nguar',"exp":'\u2013nguar[N\u2192N]',"postDefinition":"","singularDefinition":"inauthentic"},"57":{"description":"old (person)","require":"","pluralDefinition":"old (person)","exp_display":'\u2013ngyaar(ar*)',"exp":'\u2013ngyaar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"old (person)"},"58":{"description":"old (person)","require":"","pluralDefinition":"old (person)","exp_display":'\u2013ngiar(ar*)',"exp":'\u2013ngiar(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"old (person)"},"60":{"description":"smell of","require":"singularize","pluralDefinition":"smells of","exp_display":"+nir","exp":'+nir2[N\u2192N]',"postDefinition":"","singularDefinition":"smell of"},"61":{"description":"big","require":"","pluralDefinition":"big","exp_display":'\u2013paarrlug',"exp":'\u2013paarrlug[N\u2192N]',"postDefinition":"","singularDefinition":"big"},"62":{"description":"genuine","require":"","pluralDefinition":"genuine","exp_display":'\u2013pig',"exp":'\u2013pig1[N\u2192N]',"postDefinition":"","singularDefinition":"genuine"},"63":{"description":"genuine","require":"","pluralDefinition":"genuine","exp_display":'\u2013piar',"exp":'\u2013piar[N\u2192N]',"postDefinition":"","singularDefinition":"genuine"},"64":{"description":"genuine","require":"","pluralDefinition":"genuine","exp_display":'\u2013pigar',"exp":'\u2013pigar[N\u2192N]',"postDefinition":"","singularDefinition":"genuine"},"65":{"description":"mere","require":"","pluralDefinition":"mere","exp_display":'\u2013q\u0332ainar',"exp":'\u2013qainar[N\u2192N]',"postDefinition":"","singularDefinition":"mere"},"69":{"description":"weak helpless","require":"","pluralDefinition":"weak helpless","exp_display":'\u2013q\u0332tar*',"exp":'\u2013qtar*[N\u2192N]',"postDefinition":"","singularDefinition":"weak helpless"},"70":{"description":"area far in the direction of","require":"singularize","pluralDefinition":"areas far in the direction of","exp_display":'\u2013q\u0332va',"exp":'\u2013qva[N\u2192N]',"postDefinition":"","singularDefinition":"area far in the direction of"},"71":{"description":"area far in the direction of","require":"singularize","pluralDefinition":"areas far in the direction of","exp_display":'\u2013q\u0332vaar*',"exp":'\u2013qvaar*[N\u2192N]',"postDefinition":"","singularDefinition":"area far in the direction of"},"72":{"description":"multitude of","require":"pluralize","pluralDefinition":"multitudes of","exp_display":'\u2013r\u0332\'aya\'ar',"exp":'\u2013r\'aya\'ar[N\u2192N]',"postDefinition":"","singularDefinition":"multitude of"},"73":{"description":"great","require":"","pluralDefinition":"great","exp_display":'\u2013r\u0332paa(ar*)',"exp":'\u2013rpaa(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"great"},"74":{"description":"large","require":"","pluralDefinition":"large","exp_display":'\u2013r\u0332pag|@\xB2vag',"exp":'\u2013rpag|@vag[N\u2192N]',"postDefinition":"","singularDefinition":"large"},"75":{"description":"very large","require":"","pluralDefinition":"very large","exp_display":'\u2013r\u0332pallr(ar*)',"exp":'\u2013rpallr(ar*)[N\u2192N]',"postDefinition":"","singularDefinition":"very large"},"79":{"description":"little bit of","require":"singularize","pluralDefinition":"little bits of","exp_display":'\u2013r\u0332r\u0332ar*',"exp":'\u2013rrar*[N\u2192N]',"postDefinition":"","singularDefinition":"little bit of"},"80":{"description":"area with nothing but","require":"pluralize","pluralDefinition":"areas with nothing but","exp_display":'\u2013r\u0332r\u0332lainar*',"exp":'\u2013rrlainar*[N\u2192N]',"postDefinition":"","singularDefinition":"area with nothing but"},"81":{"description":"good old","require":"","pluralDefinition":"good old","exp_display":'\u2013r\u0332r\u0332lugar*',"exp":'\u2013rrlugar*[N\u2192N]',"postDefinition":"","singularDefinition":"good old"},"82":{"description":"that departed from a natural state (often undesirably)","require":"","pluralDefinition":"","exp_display":'\u2013r\u0332r\u0332lug',"exp":'\u2013rrlug[N\u2192N]',"postDefinition":"that departed from a natural state (often undesirably)","singularDefinition":""},"83":{"description":"multitudes of","require":"pluralize","pluralDefinition":"multitudes of","exp_display":'\u2013r\u0332ugar*',"exp":'\u2013rugar*[N\u2192N]',"postDefinition":"","singularDefinition":"multitudes of"},"84":{"description":"poor dear","require":"","pluralDefinition":"poor dear","exp_display":'\u2013r\u0332(ur)lur*',"exp":'\u2013r(ur)lur*[N\u2192N]',"postDefinition":"","singularDefinition":"poor dear"},"85":{"description":"old","require":"","pluralDefinition":"old","exp_display":'\u2013ssaarar',"exp":'\u2013ssaarar[N\u2192N]',"postDefinition":"","singularDefinition":"old"},"86":{"description":"place having","require":"pluralize","pluralDefinition":"places having","exp_display":"+taleg","exp":'+taleg[N\u2192N]',"postDefinition":"","singularDefinition":"place having"},"87":{"description":"thing pertaining to","require":"pluralize","pluralDefinition":"things pertaining to","exp_display":"+tar","exp":'+tar2[N\u2192N]',"postDefinition":"","singularDefinition":"thing pertaining to"},"88":{"description":"caught (game animal)","require":"","pluralDefinition":"caught (game animals)","exp_display":"+tar","exp":'+tar3[N\u2192N]',"postDefinition":"","singularDefinition":"caught (game animal)"},"90":{"description":"specifically","require":"","pluralDefinition":"","exp_display":"+tar","exp":'+tar5[N\u2192N]',"postDefinition":"specifically","singularDefinition":""},"91":{"description":"well endowed with","require":"pluralize","pluralDefinition":"well endowed with","exp_display":"+tuli","exp":'+tuli[N\u2192N]',"postDefinition":"","singularDefinition":"well endowed with"},"92":{"description":"imitation","require":"","pluralDefinition":"imitation","exp_display":"+(ng)uar","exp":'+(ng)uar[N\u2192N]',"postDefinition":"","singularDefinition":"imitation"},"93":{"description":"supply of","require":"pluralize","pluralDefinition":"supplies of","exp_display":"%:(ng)ute","exp":'%:(ng)ute[N\u2192N]',"postDefinition":"","singularDefinition":"supply of"},"94":{"description":"supply of","require":"pluralize","pluralDefinition":"supplies of","exp_display":"%:~(ng)ute","exp":'%:~(ng)ute[N\u2192N]',"postDefinition":"","singularDefinition":"supply of"},"95":{"description":"empty container that held","require":"pluralize","pluralDefinition":"empty containers that held","exp_display":"%:(ng)uteller","exp":'%:(ng)uteller[N\u2192N]',"postDefinition":"","singularDefinition":"empty container that held"},"96":{"description":"empty container that held","require":"pluralize","pluralDefinition":"empty containers that held","exp_display":"%:~(ng)uteller","exp":'%:~(ng)uteller[N\u2192N]',"postDefinition":"","singularDefinition":"empty container that held"},"97":{"description":"big","require":"","pluralDefinition":"big","exp_display":'\u2013vaarrlug',"exp":'\u2013vaarrlug[N\u2192N]',"postDefinition":"","singularDefinition":"big"},"98":{"description":"shabby","require":"","pluralDefinition":"shabby","exp_display":'\u2013vialug',"exp":'\u2013vialug[N\u2192N]',"postDefinition":"","singularDefinition":"shabby"},"99":{"description":"container for","require":"pluralize","pluralDefinition":"containers for","exp_display":'@\xB2~+viutar',"exp":'@~+viutar[N\u2192N]',"postDefinition":"","singularDefinition":"container for"},"100":{"description":"baby or little","require":"","pluralDefinition":"baby or little","exp_display":'\u2013ya\u0121ar*',"exp":'\u2013ya(g)ar*[N\u2192N]',"postDefinition":"","singularDefinition":"baby or little"},"101":{"description":"baby or little","require":"","pluralDefinition":"baby or little","exp_display":'\u2013yagar*',"exp":'\u2013yagar*[N\u2192N]',"postDefinition":"","singularDefinition":"baby or little"},"102":{"description":"thing similar to","require":"pluralize","pluralDefinition":"things similar to","exp_display":"+yag","exp":'+yag[N\u2192N]',"postDefinition":"","singularDefinition":"thing similar to"},"103":{"description":"way of or device dealing with","require":"pluralize","pluralDefinition":"ways of or devices dealing with","exp_display":'@\u02B8~+yarar',"exp":'@~+yarar[N\u2192N]',"postDefinition":"","singularDefinition":"way of or device dealing with"},"104":{"description":"little baby","require":"","pluralDefinition":"little baby","exp_display":'\u2013yaya\u0121ar*',"exp":'\u2013yaya(g)ar*[N\u2192N]',"postDefinition":"","singularDefinition":"little baby"}};var VVpostbases={"0":{"match_case":true,"exp_display":"+a|+aar","description":"repeatedly","exp":'\u2013a|\u2013ar|\u2013aa|+a|+aar[V\u2192V]',"postverb":"repeatedly"},"1":{"description":"repeatedly","ger_preverb":"repeatedly","is":true,"inf_preverb":"repeatedly","past_preverb":"repeatedly","exp_display":"+`(g)aqe","gen_preverb":"repeatedly","exp":'+`(g)aqe[V\u2192V]',"match_case":true,"subj":"he"},"2":{"description":"just barely","ger_preverb":"just barely","is":true,"inf_preverb":"just barely","past_preverb":"just barely","exp_display":"+`(g)ar(ar)","gen_preverb":"just barely","exp":'+`(g)ar(ar)[V\u2192V]',"match_case":true,"subj":"he"},"3":{"description":"suddenly","ger_preverb":"suddenly","is":true,"inf_preverb":"suddenly","past_preverb":"suddenly","exp_display":'@+\u2013`(g)ar(ar)te',"gen_preverb":"suddenly","exp":'@+(g)ar(ar)te1[V\u2192V]',"match_case":true,"subj":"he"},"5":{"description":"will eventually","ger_preverb":"will eventually","is":false,"inf_preverb":"will eventually","past_preverb":"will eventually","exp_display":"+`(g)arkau","gen_preverb":"will eventually","exp":'+`(g)arkau[V\u2192V]',"match_case":true,"subj":"he"},"6":{"description":"now unable to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be now unable to","past_preverb":"","exp_display":"+`(g)arkaunrir","gen_preverb":"now unable to","exp":'+`(g)arkaunrir[V\u2192V]',"match_case":false,"ger_preverb":"being able to now","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"7":{"description":"continuing (over a period of time) to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"continue (over a period of time) to","past_preverb":"","exp_display":"+aur(ar)","gen_preverb":"continuing (over a period of time) to","exp":'+aur(ar)[V\u2192V]',"match_case":false,"ger_preverb":"continuing (over a period of time) to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"8":{"description":"endeavoring to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"endeavor to","past_preverb":"","exp_display":'@\u2074~+caar(ar)',"gen_preverb":"endeavoring to","exp":'@~+caar(ar)[V\u2192V]',"match_case":false,"ger_preverb":"endeavoring to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"13":{"description":"no longer able to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be no longer able to","past_preverb":"","exp_display":"+(s)ciigali","gen_preverb":"no longer able to","exp":'+(s)ciigali[V\u2192V]',"match_case":false,"ger_preverb":"being no longer able to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"14":{"description":"no longer able to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be no longer able to","past_preverb":"","exp_display":"+(s)ciigalli","gen_preverb":"no longer able to","exp":'+(s)ciigalli[V\u2192V]',"match_case":false,"ger_preverb":"being no longer able to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"15":{"description":"not able to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be not able to","past_preverb":"","exp_display":'+(s)ciigate\xB0',"gen_preverb":"not able to","exp":'+(s)ciigate[V\u2192V]',"match_case":false,"ger_preverb":"being not able to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"18":{"description":"appears to have been","past_preverb_after":"g","ger_preverb_after":"g","is":false,"inf_preverb":"appear to have been","past_preverb":"appeared to have been","exp_display":'\u2013cilli',"gen_preverb":"appears to have been","exp":'\u2013cilli[V\u2192V]',"match_case":false,"ger_preverb":"appearing to have been","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"19":{"description":"will","ger_preverb":"will","is":false,"inf_preverb":"will","past_preverb":"will","exp_display":'+ciqe|@\u2075ciiqe',"gen_preverb":"will","exp":'+ciqe|@ciiqe[V\u2192V]',"match_case":true,"subj":"he"},"20":{"description":"about to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be about to","past_preverb":"","exp_display":'+ciqiar|@\u2075ciiqiar',"gen_preverb":"about to","exp":'+ciqiar|@ciiqiar[V\u2192V]',"match_case":false,"ger_preverb":"being about to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"22":{"description":"","past_preverb_after":"","ger_preverb_after":"g","is":false,"inf_preverb":"","past_preverb":"","exp_display":'@\u2075~+cir',"gen_preverb":"","exp":'@~+cir1[V\u2192V]',"match_case":false,"ger_preverb":"","subj":"","inf_preverb_after":"i","gen_preverb_after":""},"24":{"description":"easily","past_preverb_after":"","ger_preverb_after":"i","is":false,"inf_preverb":"be easily","past_preverb":"","exp_display":"+(s)ciryar","gen_preverb":"easily","exp":'+(s)ciryar[V\u2192V]',"match_case":false,"ger_preverb":"being easy to","subj":"he","inf_preverb_after":"i","gen_preverb_after":""},"27":{"description":"has the quality of","past_preverb_after":"g","ger_preverb_after":"g","is":false,"inf_preverb":"have the quality of","past_preverb":"had the quality of","exp_display":'+cite\xB0',"gen_preverb":"has the quality of","exp":'+cite2[V\u2192V]',"match_case":false,"ger_preverb":"having the quality of","subj":"it","inf_preverb_after":"g","gen_preverb_after":"g"},"31":{"match_case":true,"exp_display":'\u2013curlag',"description":"with unsatisfactory results","exp":'\u2013curlag[V\u2192V]',"postverb":"with unsatisfactory results"},"34":{"match_case":true,"exp_display":'@\xB2~+(ng)iinar',"description":"more and more","exp":'@~+(ng)iinar[V\u2192V]',"postverb":"more and more"},"35":{"description":"suffering from the lack of","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"suffer from the lack of","past_preverb":"","exp_display":"%:(ng)illiqe","gen_preverb":"suffering from the lack of","exp":'%:(ng)illiqe[V\u2192V]',"match_case":false,"ger_preverb":"suffering from the lack of","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"36":{"description":"finally","ger_preverb":"finally","is":true,"inf_preverb":"finally","past_preverb":"finally","exp_display":'\u2013inar',"gen_preverb":"finally","exp":'\u2013inar[V\u2192V]',"match_case":true,"subj":"he"},"39":{"description":"lacks","past_preverb_after":"g","ger_preverb_after":"g","is":false,"inf_preverb":"lack","past_preverb":"lacked","exp_display":'%:(ng)ite\xB0',"gen_preverb":"lacks","exp":'%:(ng)ite1[V\u2192V]',"match_case":false,"ger_preverb":"lacking","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"44":{"match_case":true,"exp_display":"+kanir","description":"more with greater intensity","exp":'+kanir[V\u2192V]',"postverb":"more with greater intensity"},"45":{"match_case":true,"exp_display":"+kanir(ar)","description":"more and more, with greater intensity","exp":'+kanir(ar)[V\u2192V]',"postverb":"more and more, with greater intensity"},"46":{"description":"unable to (due to an inhibiting factor)","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be unable to (due to an inhibiting factor)","past_preverb":"","exp_display":'\u2013@\u2074k\u0332aunrir',"gen_preverb":"unable to (due to an inhibiting factor)","exp":'\u2013@kaunrir[V\u2192V]',"match_case":false,"ger_preverb":"being unable to (due to an inhibiting factor)","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"51":{"description":"suddenly (in motion)","ger_preverb":"suddenly (in motion)","is":true,"inf_preverb":"suddenly (in motion)","past_preverb":"suddenly (in motion)","exp_display":'\u2013knig',"gen_preverb":"suddenly (in motion)","exp":'\u2013knig[V\u2192V]',"match_case":true,"subj":"he"},"52":{"match_case":true,"exp_display":'\u2013ksaar(ar)',"description":"in a small and unnoticeable way","exp":'\u2013ksaar(ar)[V\u2192V]',"postverb":"in a small and unnoticeable way"},"56":{"match_case":true,"exp_display":'\u2013k\u0332suar(ar)',"description":"in a small and not very noticeable way","exp":'\u2013ksuar(ar)[V\u2192V]',"postverb":"in a small and not very noticeable way"},"57":{"match_case":true,"exp_display":'\u2013ksuar(ar)',"description":"in a small and not very noticeable way","exp":'\u2013ksuar(ar)[V\u2192V]',"postverb":"in a small and not very noticeable way"},"58":{"description":"about to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be about to","past_preverb":"","exp_display":'\u2013kugte',"gen_preverb":"about to","exp":'\u2013kugte[V\u2192V]',"match_case":false,"ger_preverb":"being about to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"59":{"description":"planning to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"plan to","past_preverb":"","exp_display":'\u2013kuna',"gen_preverb":"planning to","exp":'\u2013kuna[V\u2192V]',"match_case":false,"ger_preverb":"planning to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"60":{"description":"considering","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"consider","past_preverb":"","exp_display":'\u2013kunayaaqe',"gen_preverb":"considering","exp":'\u2013kunayaaqe[V\u2192V]',"match_case":false,"ger_preverb":"considering","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"61":{"description":"probably","ger_preverb":"probably","is":false,"inf_preverb":"probably","past_preverb":"probably","exp_display":'\u2013kutag',"gen_preverb":"probably","exp":'\u2013kutag[V\u2192V]',"match_case":true,"subj":"he"},"62":{"description":"planning to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"plan to","past_preverb":"","exp_display":'\u2013kutar(ar)',"gen_preverb":"planning to","exp":'\u2013kutar(ar)[V\u2192V]',"match_case":false,"ger_preverb":"planning to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"63":{"match_case":true,"exp_display":'\u2013laag',"description":"quickly","exp":'\u2013laag[V\u2192V]',"postverb":"quickly"},"67":{"match_case":true,"exp_display":"~+lar","description":"regularly","exp":'~+lar[V\u2192V]',"postverb":"regularly"},"68":{"match_case":true,"exp_display":'@\u02E1~+lar',"description":"regularly","exp":'@~+lar[V\u2192V]',"postverb":"regularly"},"69":{"match_case":true,"exp_display":'\u2013lar',"description":"regularly","exp":'\u2013lar[V\u2192V]',"postverb":"regularly"},"70":{"description":"usually (though not at this time)","ger_preverb":"usually (though not at this time)","is":true,"inf_preverb":"usually (though not at this time)","past_preverb":"usually (though not at this time)","exp_display":"~+laryaaqe","gen_preverb":"usually (though not at this time)","exp":'~+laryaaqe[V\u2192V]',"match_case":true,"subj":"he"},"71":{"description":"usually (though not at this time)","ger_preverb":"usually (though not at this time)","is":true,"inf_preverb":"usually (though not at this time)","past_preverb":"usually (though not at this time)","exp_display":'@\u02E1~+laryaaqe',"gen_preverb":"usually (though not at this time)","exp":'@~+laryaaqe[V\u2192V]',"match_case":true,"subj":"he"},"72":{"description":"usually (though not at this time)","ger_preverb":"usually (though not at this time)","is":true,"inf_preverb":"usually (though not at this time)","past_preverb":"usually (though not at this time)","exp_display":'\u2013laryaaqe',"gen_preverb":"usually (though not at this time)","exp":'\u2013laryaaqe[V\u2192V]',"match_case":true,"subj":"he"},"73":{"match_case":true,"exp_display":'\u2013ler',"description":"suddenly and willfully","exp":'\u2013ler[V\u2192V]',"postverb":"suddenly and willfully"},"74":{"match_case":true,"exp_display":"~+ler","description":"suddenly and willfully","exp":'~+ler[V\u2192V]',"postverb":"suddenly and willfully"},"75":{"match_case":true,"exp_display":'\u2013leryag',"description":"abruptly","exp":'\u2013leryag[V\u2192V]',"postverb":"abruptly"},"76":{"match_case":true,"exp_display":"~+leryag","description":"abruptly","exp":'~+leryag[V\u2192V]',"postverb":"abruptly"},"77":{"description":"always","ger_preverb":"always","is":true,"inf_preverb":"always","past_preverb":"always","exp_display":'\u2013lgu',"gen_preverb":"always","exp":'\u2013lgu[V\u2192V]',"match_case":true,"subj":"he"},"78":{"description":"stopped being able to","past_preverb_after":"i","ger_preverb_after":"i","is":false,"inf_preverb":"have stopped being able to","past_preverb":"had stopped being able to","exp_display":'\u2013lguir',"gen_preverb":"stopped being able to","exp":'\u2013lguir[V\u2192V]',"match_case":false,"ger_preverb":"having stopped being able to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"79":{"description":"no longer able to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be no longer able to","past_preverb":"","exp_display":'\u2013lguirute',"gen_preverb":"no longer able to","exp":'\u2013lguirute[V\u2192V]',"match_case":false,"ger_preverb":"being no longer able to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"80":{"description":"unable to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be unable to","past_preverb":"","exp_display":'\u2013lguite\xB0',"gen_preverb":"unable to","exp":'\u2013lguite[V\u2192V]',"match_case":false,"ger_preverb":"being unable to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"83":{"description":"going to participate in","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"go participate in","past_preverb":"","exp_display":'\u2013\u2013liyar',"gen_preverb":"going to participate in","exp":'\u2013\u2013liyar[V\u2192V]',"match_case":false,"ger_preverb":"going to participate in","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"84":{"description":"going to participate in","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"go participate in","past_preverb":"","exp_display":'\u2013liar',"gen_preverb":"going to participate in","exp":'\u2013liar[V\u2192V]',"match_case":false,"ger_preverb":"going to participate in","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"86":{"description":"giving evidence of","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"give evidence of","past_preverb":"","exp_display":'\u2013lkia',"gen_preverb":"giving evidence of","exp":'\u2013lkia[V\u2192V]',"match_case":false,"ger_preverb":"giving evidence of","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"88":{"match_case":true,"exp_display":'\u2013llag',"description":"suddenly and surprisingly","exp":'\u2013llag[V\u2192V]',"postverb":"suddenly and surprisingly"},"89":{"description":"good at","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"be good at","past_preverb":"","exp_display":'\u2013llgu',"gen_preverb":"good at","exp":'\u2013llgu[V\u2192V]',"match_case":false,"ger_preverb":"being good at","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"90":{"description":"maybe","ger_preverb":"maybe","is":true,"inf_preverb":"maybe","past_preverb":"maybe","exp_display":'\u2013lli',"gen_preverb":"maybe","exp":'\u2013lli[V\u2192V]',"match_case":true,"subj":"he"},"91":{"match_case":true,"exp_display":'\u2013llini',"description":"evidently","exp":'\u2013llini[V\u2192V]',"postverb":"evidently"},"96":{"match_case":true,"exp_display":'\u2013llugtur',"description":"quickly","exp":'\u2013llugtur[V\u2192V]',"postverb":"quickly"},"97":{"description":"tired of","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"be tired of","past_preverb":"","exp_display":'\u2013lngu',"gen_preverb":"tired of","exp":'\u2013lngu[V\u2192V]',"match_case":false,"ger_preverb":"being tired of","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"99":{"match_case":true,"exp_display":'\u2013luaqar',"description":"well","exp":'\u2013luaqar[V\u2192V]',"postverb":"well"},"101":{"match_case":true,"exp_display":"%:(u|i)maar","description":"for a short duration or without making a big deal of it","exp":'%:(u|i)maar[V\u2192V]',"postverb":"for a short duration or without making a big deal of it"},"102":{"match_case":true,"exp_display":"%:(u|i)maar(ar)","description":"slowly","exp":'%:(u|i)maar(ar)[V\u2192V]',"postverb":"slowly"},"104":{"match_case":true,"exp_display":'\u2013mcaugar',"description":"in a small way","exp":'\u2013mcaugar[V\u2192V]',"postverb":"in a small way"},"105":{"match_case":true,"exp_display":'\u2013mciur(ar)',"description":"a little at a time","exp":'\u2013mciur(ar)[V\u2192V]',"postverb":"a little at a time"},"106":{"match_case":true,"exp_display":'\u2013mcuar(ar)',"description":"a little","exp":'\u2013mcuar(ar)[V\u2192V]',"postverb":"a little"},"107":{"match_case":true,"exp_display":'\u2013mcugte',"description":"to a small degree","exp":'\u2013mcugte[V\u2192V]',"postverb":"to a small degree"},"108":{"match_case":true,"exp_display":'\u2013mssugte',"description":"to a small degree","exp":'\u2013mssugte[V\u2192V]',"postverb":"to a small degree"},"109":{"match_case":true,"exp_display":'\u2013mcugte',"description":"to a small degree","exp":'\u2013mcugte[V\u2192V]',"postverb":"to a small degree"},"110":{"match_case":true,"exp_display":'@\xB2~+mi',"description":"also","exp":'@~+mi[V\u2192V]',"postverb":"also"},"111":{"description":"probably also","ger_preverb":"probably also","is":true,"inf_preverb":"probably also","past_preverb":"probably also","exp_display":"+milli","gen_preverb":"probably also","exp":'+milli[V\u2192V]',"match_case":true,"subj":"he"},"112":{"match_case":true,"exp_display":'\u2013mli',"description":"casually","exp":'\u2013mli[V\u2192V]',"postverb":"casually"},"113":{"match_case":true,"exp_display":'\u2013mssag',"description":"in a small way","exp":'\u2013mssag[V\u2192V]',"postverb":"in a small way"},"114":{"match_case":true,"exp_display":'\u2013mssugte',"description":"in a small way","exp":'\u2013mssugte[V\u2192V]',"postverb":"in a small way"},"116":{"match_case":true,"exp_display":'\u2013myugte',"description":"in a small way","exp":'\u2013myugte[V\u2192V]',"postverb":"in a small way"},"118":{"match_case":true,"exp_display":'@\xB9~+naciar',"description":"late","exp":'@~+naciar[V\u2192V]',"postverb":"late"},"121":{"description":"ceasing","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"cease","past_preverb":"","exp_display":'@\xB9~+nanrir',"gen_preverb":"ceasing","exp":'@~+nanrir[V\u2192V]',"match_case":false,"ger_preverb":"ceasing","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"122":{"description":"now feasible to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be now feasible to","past_preverb":"","exp_display":'@\xB9~+naqsaaqe',"gen_preverb":"now feasible to","exp":'@~+naqsaaqe[V\u2192V]',"match_case":false,"ger_preverb":"being now feasible to","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"124":{"description":"time to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be time to","past_preverb":"","exp_display":'@\xB9~+nari',"gen_preverb":"time to","exp":'@~+nari[V\u2192V]',"match_case":false,"ger_preverb":"being time to","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"127":{"description":"habitually","ger_preverb":"habitually","is":true,"inf_preverb":"habitually","past_preverb":"habitually","exp_display":'@\xB9~+naur',"gen_preverb":"habitually","exp":'@~+naur[V\u2192V]',"match_case":true,"subj":"he"},"130":{"description":"habitually (only a little bit)","ger_preverb":"habitually (only a little bit)","is":true,"inf_preverb":"habitually (only a little bit)","past_preverb":"habitually (only a little bit)","exp_display":'@\xB9\u2013nerkite\xB0',"gen_preverb":"habitually (only a little bit)","exp":'@\u2013nerkite[V\u2192V]',"match_case":true,"subj":"he"},"134":{"description":"having trouble with ^his^","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"have trouble with ^his^","past_preverb":"","exp_display":'@\xB9\u2013nerrlugte',"gen_preverb":"having trouble with ^his^","exp":'@\u2013nerrlugte[V\u2192V]',"match_case":false,"ger_preverb":"having trouble with ^his^","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"135":{"description":"habitually (a lot)","ger_preverb":"habitually (a lot)","is":true,"inf_preverb":"habitually (a lot)","past_preverb":"habitually (a lot)","exp_display":'@\xB9\u2013nertu',"gen_preverb":"habitually (a lot)","exp":'@\u2013nertu[V\u2192V]',"match_case":true,"subj":"he"},"137":{"description":"no longer going to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be no longer going to","past_preverb":"","exp_display":'@\xB2~+ngair(ar)te',"gen_preverb":"no longer going to","exp":'@~+ngair(ar)te[V\u2192V]',"match_case":false,"ger_preverb":"being no longer going to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"138":{"description":"will never again","ger_preverb":"will never again","is":false,"inf_preverb":"will never again","past_preverb":"will never again","exp_display":'@\xB2~+ngairute',"gen_preverb":"will never again","exp":'@~+ngairute[V\u2192V]',"match_case":true,"subj":"he"},"139":{"description":"will not","ger_preverb":"will not","is":false,"inf_preverb":"will not","past_preverb":"will not","exp_display":'@\xB2~+ngaite\xB0',"gen_preverb":"will not","exp":'@~+ngaite[V\u2192V]',"match_case":true,"subj":"he"},"141":{"description":"seems to be","past_preverb_after":"g","ger_preverb_after":"g","is":false,"inf_preverb":"seem to be","past_preverb":"seemed to be","exp_display":'@\xB2~+ngate\xB0',"gen_preverb":"seems to be","exp":'@~+ngate[V\u2192V]',"match_case":false,"ger_preverb":"seeming to be","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"143":{"description":"beginning to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"begin to","past_preverb":"","exp_display":'\u2013nge',"gen_preverb":"beginning to","exp":'\u2013nge[V\u2192V]',"match_case":false,"ger_preverb":"beginning to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"144":{"description":"inept at","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"be inept at","past_preverb":"","exp_display":'@\xB2~+ngiate\xB0',"gen_preverb":"inept at","exp":'@~+ngiate[V\u2192V]',"match_case":false,"ger_preverb":"being inept at","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"145":{"description":"adept at","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"be adept at","past_preverb":"","exp_display":'@\xB2~+ngig',"gen_preverb":"adept at","exp":'@~+ngig[V\u2192V]',"match_case":false,"ger_preverb":"being adept at","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"146":{"description":"merely (with no attendant complications)","ger_preverb":"merely (with no attendant complications)","is":true,"inf_preverb":"merely (with no attendant complications)","past_preverb":"merely (with no attendant complications)","exp_display":'@\xB2~+nginar',"gen_preverb":"merely (with no attendant complications)","exp":'@~+nginar[V\u2192V]',"match_case":true,"subj":"he"},"147":{"match_case":true,"exp_display":'\u2013ngnagar',"description":"in an irritating way","exp":'\u2013ngnagar[V\u2192V]',"postverb":"in an irritating way"},"148":{"description":"trying to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"try to","past_preverb":"","exp_display":'\u2013ngnaqe',"gen_preverb":"trying to","exp":'\u2013ngnaqe[V\u2192V]',"match_case":false,"ger_preverb":"trying to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"149":{"description":"trying unsuccessfully to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"try unsuccessfully to","past_preverb":"","exp_display":'\u2013ngnaqsaaqe',"gen_preverb":"trying unsuccessfully to","exp":'\u2013ngnaqsaaqe[V\u2192V]',"match_case":false,"ger_preverb":"trying unsuccessfully to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"150":{"description":"trying hard to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"try hard to","past_preverb":"","exp_display":'\u2013ngnatug',"gen_preverb":"trying hard to","exp":'\u2013ngnatug[V\u2192V]',"match_case":false,"ger_preverb":"trying hard to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"151":{"description":"in a state of","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"be in a state of","past_preverb":"","exp_display":'@\u2075\u2013ngqa',"gen_preverb":"in a state of","exp":'@\u2013ngqa[V\u2192V]',"match_case":false,"ger_preverb":"being in a state of","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"152":{"match_case":true,"exp_display":'\u2013ngssaar(ar)',"description":"secretively, unnoticeably","exp":'\u2013ngssaar(ar)[V\u2192V]',"postverb":"secretively, unnoticeably"},"153":{"match_case":true,"exp_display":'\u2013ngssag',"description":"to no particular end","exp":'\u2013ngssag[V\u2192V]',"postverb":"to no particular end"},"154":{"match_case":true,"exp_display":'\u2013ngssi',"description":"to no particular end","exp":'\u2013ngssi[V\u2192V]',"postverb":"to no particular end"},"155":{"description":"pretending to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"pretend to","past_preverb":"","exp_display":'@\xB2~\u2013nguar',"gen_preverb":"pretending to","exp":'@~\u2013nguar[V\u2192V]',"match_case":false,"ger_preverb":"pretending to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"158":{"match_case":true,"exp_display":'@\xB9~+niar',"description":"in the future","exp":'@~+niar[V\u2192V]',"postverb":"in the future"},"159":{"description":"soon going to","past_preverb_after":"i","ger_preverb_after":"g","is":true,"inf_preverb":"soon be going","past_preverb":"","exp_display":'@\xB9~+niarar',"gen_preverb":"soon going to","exp":'@~+niarar[V\u2192V]',"match_case":false,"ger_preverb":"soon being going","subj":"he","inf_preverb_after":"g","gen_preverb_after":"i"},"166":{"match_case":true,"exp_display":'\u2013nqegcaar(ar)',"description":"completely, thoroughly","exp":'\u2013nqegcaar(ar)[V\u2192V]',"postverb":"completely, thoroughly"},"167":{"match_case":true,"exp_display":'\u2013nqigte',"description":"again","exp":'\u2013nqigte[V\u2192V]',"postverb":"again"},"168":{"description":"not (having changed his mind)","ger_preverb":"not (having changed his mind)","is":true,"inf_preverb":"not (having changed his mind)","past_preverb":"not (having changed his mind)","exp_display":'\u2013nricen\u0304ar',"gen_preverb":"not (having changed his mind)","exp":'\u2013nricen\u0304ar[V\u2192V]',"match_case":true,"subj":"he"},"169":{"description":"keeping ^himself^ from","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"keep ^himself^ from","past_preverb":"","exp_display":'\u2013nrilkurte',"gen_preverb":"keeping ^himself^ from","exp":'\u2013nrilkurte[V\u2192V]',"match_case":false,"ger_preverb":"keeping ^himself^ from","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"170":{"description":"no longer","ger_preverb":"no longer","is":true,"inf_preverb":"no longer","past_preverb":"no longer","exp_display":'\u2013nrir',"gen_preverb":"no longer","exp":'\u2013nrir[V\u2192V]',"match_case":true,"subj":"he"},"171":{"description":"almost","ger_preverb":"almost","is":true,"inf_preverb":"almost","past_preverb":"almost","exp_display":'\u2013nritar(ar)',"gen_preverb":"almost","exp":'\u2013nritar(ar)[V\u2192V]',"match_case":true,"subj":"he"},"172":{"description":"not","ger_preverb":"not","is":true,"inf_preverb":"not","past_preverb":"not","exp_display":'\u2013nrite\xB0',"gen_preverb":"not","exp":'\u2013nrite[V\u2192V]',"match_case":true,"subj":"he"},"173":{"match_case":true,"exp_display":'\u2013nru',"description":"moreso","exp":'\u2013nru[V\u2192V]',"postverb":"moreso"},"174":{"match_case":true,"exp_display":'@\u2075+p|~vaalug',"description":"for the first time","exp":'@+paalug|~vaalug[V\u2192V]',"postverb":"for the first time"},"175":{"match_case":true,"exp_display":'@\u2075+p|~vailug',"description":"for the first time","exp":'@+pailug|~vailug[V\u2192V]',"postverb":"for the first time"},"176":{"match_case":true,"exp_display":'\u2013pacug',"description":"poorly, dearly","exp":'\u2013pacug[V\u2192V]',"postverb":"poorly, dearly"},"177":{"match_case":true,"exp_display":'@\u2075+p|~vag',"description":"so well","exp":'@+pag|~vag1[V\u2192V]',"postverb":"so well"},"178":{"match_case":true,"exp_display":'@\u2075+p|~vakar',"description":"so much","exp":'@+pakar|~vakar[V\u2192V]',"postverb":"so much"},"179":{"match_case":true,"exp_display":'\u2013qpakar',"description":"so much","exp":'\u2013qpakar[V\u2192V]',"postverb":"so much"},"180":{"match_case":true,"exp_display":'@\u2075+p|~vallag',"description":"intensely","exp":'@+pallag|~vallag[V\u2192V]',"postverb":"intensely"},"181":{"match_case":true,"exp_display":'@\u2075+p|~vallug',"description":"the most","exp":'@+pallug|~vallug[V\u2192V]',"postverb":"the most"},"182":{"match_case":true,"exp_display":'@\u2075+p|~vallur',"description":"the most","exp":'@+pallur|~vallur[V\u2192V]',"postverb":"the most"},"183":{"description":"not","ger_preverb":"not","is":true,"inf_preverb":"not","past_preverb":"not","exp_display":'+p|.vke\xB0',"gen_preverb":"not","exp":'+peke|.vke[V\u2192V]',"match_case":true,"subj":"he"},"184":{"description":"not","ger_preverb":"not","is":true,"inf_preverb":"not","past_preverb":"not","exp_display":'+p|.vge\xB0',"gen_preverb":"not","exp":'+pege|.vke[V\u2192V]',"match_case":true,"subj":"he"},"185":{"description":"actually (surprisingly)","ger_preverb":"actually (surprisingly)","is":true,"inf_preverb":"actually (surprisingly)","past_preverb":"actually (surprisingly)","exp_display":"+pigainar","gen_preverb":"actually (surprisingly)","exp":'+pigainar[V\u2192V]',"match_case":true,"subj":"he"},"186":{"description":"actually (surprisingly)","ger_preverb":"actually (surprisingly)","is":true,"inf_preverb":"actually (surprisingly)","past_preverb":"actually (surprisingly)","exp_display":'\u2013pigainar',"gen_preverb":"actually (surprisingly)","exp":'\u2013pigainar[V\u2192V]',"match_case":true,"subj":"he"},"187":{"description":"really","ger_preverb":"really","is":true,"inf_preverb":"really","past_preverb":"really","exp_display":'\u2013pig',"gen_preverb":"really","exp":'\u2013pig[V\u2192V]',"match_case":true,"subj":"he"},"188":{"description":"really","ger_preverb":"really","is":true,"inf_preverb":"really","past_preverb":"really","exp_display":'\u2013piar',"gen_preverb":"really","exp":'\u2013piar[V\u2192V]',"match_case":true,"subj":"he"},"189":{"match_case":true,"exp_display":'\u2013pigar',"description":"very much so","exp":'\u2013pigar[V\u2192V]',"postverb":"very much so"},"190":{"match_case":true,"exp_display":'\u2013q\u0332aci',"description":"in a minor way","exp":'\u2013qaci[V\u2192V]',"postverb":"in a minor way"},"191":{"description":"merely","ger_preverb":"merely","is":true,"inf_preverb":"merely","past_preverb":"merely","exp_display":'\u2013q\u0332ainar',"gen_preverb":"merely","exp":'\u2013qainar[V\u2192V]',"match_case":true,"subj":"he"},"192":{"description":"ready to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be ready to","past_preverb":"","exp_display":'\u2013q\u0332ainaurte',"gen_preverb":"ready to","exp":'\u2013qainaurte[V\u2192V]',"match_case":false,"ger_preverb":"being ready to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"193":{"match_case":true,"exp_display":'\u2013q\u0332apiar(ar)',"description":"very much so","exp":'\u2013qapiar(ar)[V\u2192V]',"postverb":"very much so"},"194":{"match_case":true,"exp_display":'\u2013q\u0332apigte',"description":"very much so","exp":'\u2013qapigte[V\u2192V]',"postverb":"very much so"},"195":{"match_case":true,"exp_display":'\u2013q\u0332araqe',"description":"intermittently","exp":'\u2013qaqe1[V\u2192V]',"postverb":"intermittently"},"196":{"match_case":true,"exp_display":'@\u2075qaqe',"description":"one after another","exp":'@qaqe2[V\u2192V]',"postverb":"one after another"},"197":{"match_case":true,"exp_display":'\u2013q\u0332aqu',"description":"now and then","exp":'\u2013qaqu[V\u2192V]',"postverb":"now and then"},"198":{"match_case":true,"exp_display":'\u2013q\u0332aqur(ar)',"description":"now and then","exp":'\u2013qaqur(ar)[V\u2192V]',"postverb":"now and then"},"199":{"match_case":true,"exp_display":'\u2013q\u0332ar',"description":"briefly","exp":'\u2013qar[V\u2192V]',"postverb":"briefly"},"201":{"description":"slowly starting to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"slowly start to","past_preverb":"","exp_display":'\u2013q\u0332ataar(ar)',"gen_preverb":"slowly starting to","exp":'\u2013qataar(ar)[V\u2192V]',"match_case":false,"ger_preverb":"slowly starting to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"202":{"description":"about to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be about to","past_preverb":"","exp_display":'\u2013q\u0332atar',"gen_preverb":"about to","exp":'\u2013qatar[V\u2192V]',"match_case":false,"ger_preverb":"being about to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"203":{"description":"trying (despite difficulties) to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"try (despite difficulties) to","past_preverb":"","exp_display":'\u2013q\u0332caar(ar)',"gen_preverb":"trying (despite difficulties) to","exp":'\u2013qcaar(ar)[V\u2192V]',"match_case":false,"ger_preverb":"trying (despite difficulties) to ","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"204":{"match_case":true,"exp_display":'\u2013qerte',"description":"suddenly, hurriedly","exp":'\u2013qerte[V\u2192V]',"postverb":"suddenly, hurriedly"},"205":{"match_case":true,"exp_display":'\u2013q\u0332etaar',"description":"repeatedly at intervals","exp":'\u2013qetaar[V\u2192V]',"postverb":"repeatedly at intervals"},"206":{"match_case":true,"exp_display":'@\u2013qtaar',"description":"repeatedly at intervals","exp":'@\u2013qtaar[V\u2192V]',"postverb":"repeatedly at intervals"},"207":{"match_case":true,"exp_display":'\u2013q\u0332tar',"description":"weakly, helplessly, dearly","exp":'\u2013qtar[V\u2192V]',"postverb":"weakly, helplessly, dearly"},"208":{"match_case":true,"exp_display":'\u2013q\u0332tarar(ar)',"description":"slowly and with difficulty because of disability","exp":'\u2013qtarar(ar)[V\u2192V]',"postverb":"slowly and with difficulty because of disability"},"209":{"match_case":true,"exp_display":'\u2013q\u0332u',"description":"one after another","exp":'\u2013qu1[V\u2192V]',"postverb":"one after another"},"210":{"match_case":true,"exp_display":'@\u2075\u2013qur',"description":"using repeated action to accomplish the act","exp":'@\u2013qur[V\u2192V]',"postverb":"using repeated action to accomplish the act"},"211":{"match_case":true,"exp_display":'\u2013r\u0332paga',"description":"hard at intervals","exp":'\u2013rpaga[V\u2192V]',"postverb":"hard at intervals"},"212":{"match_case":true,"exp_display":'\u2013r\u0332pag',"description":"hard","exp":'\u2013rpag[V\u2192V]',"postverb":"hard"},"213":{"match_case":true,"exp_display":'\u2013r\u0332pakar',"description":"so much, for so long","exp":'\u2013rpakar[V\u2192V]',"postverb":"so much, for so long"},"214":{"match_case":true,"exp_display":'@\u2075\u2013rqe',"description":"one after another","exp":'@\u2013rqe1[V\u2192V]',"postverb":"one after another"},"217":{"match_case":true,"exp_display":'\u2013r\u0332r\u0332ar',"description":"just barely","exp":'\u2013rrar[V\u2192V]',"postverb":"just barely"},"218":{"match_case":true,"exp_display":'\u2013r\u0332r\u0332aar',"description":"first","exp":'\u2013rraar[V\u2192V]',"postverb":"first"},"219":{"description":"constantly","ger_preverb":"constantly","is":true,"inf_preverb":"constantly","past_preverb":"constantly","exp_display":'\u2013r\u0332r\u0332lainar',"gen_preverb":"constantly","exp":'\u2013rrlainar[V\u2192V]',"match_case":true,"subj":"he"},"220":{"match_case":true,"exp_display":'\u2013r\u0332r\u0332luar(ar)',"description":"a little bit","exp":'\u2013rrluar(ar)[V\u2192V]',"postverb":"a little bit"},"221":{"description":"somewhat","ger_preverb":"somewhat","is":true,"inf_preverb":"somewhat","past_preverb":"somewhat","exp_display":'\u2013r\u0332r\u0332lug',"gen_preverb":"somewhat","exp":'\u2013rrlug[V\u2192V]',"match_case":true,"subj":"he"},"222":{"description":"somewhat","ger_preverb":"somewhat","is":true,"inf_preverb":"somewhat","past_preverb":"somewhat","exp_display":'\u2013r\u0332r\u0332lugte',"gen_preverb":"somewhat","exp":'\u2013rrlugte[V\u2192V]',"match_case":true,"subj":"he"},"223":{"match_case":true,"exp_display":'\u2013r\u0332(ur)lur',"description":"poorly, dearly","exp":'\u2013q(ur)lur[V\u2192V]',"postverb":"poorly, dearly"},"224":{"match_case":true,"exp_display":'\u2013r\u0332vaar',"description":"very much so","exp":'\u2013rvaar[V\u2192V]',"postverb":"very much so"},"225":{"match_case":true,"exp_display":'\u2013r\u0332vag',"description":"very much so","exp":'\u2013rvag[V\u2192V]',"postverb":"very much so"},"226":{"description":"unable to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be unable to","past_preverb":"","exp_display":'\u2013sciigate\xB0',"gen_preverb":"unable to","exp":'\u2013sciigate[V\u2192V]',"match_case":false,"ger_preverb":"being unable to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"231":{"description":"trying to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"try to","past_preverb":"","exp_display":'\u2013ssaag',"gen_preverb":"trying to","exp":'\u2013ssaag1[V\u2192V]',"match_case":false,"ger_preverb":"trying to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"232":{"match_case":true,"exp_display":'\u2013ssaag',"description":"too much","exp":'\u2013ssaag3[V\u2192V]',"postverb":"too much"},"233":{"match_case":true,"exp_display":'\u2013ssiyaag',"description":"too much","exp":'\u2013ssiyaag[V\u2192V]',"postverb":"too much"},"235":{"match_case":true,"exp_display":'@\xB2+ta',"description":"to a certain degree","exp":'@+ta2[V\u2192V]',"postverb":"to a certain degree"},"236":{"match_case":true,"exp_display":"+taagute","description":"back and forth","exp":'+taagute[V\u2192V]',"postverb":"back and forth"},"237":{"description":"acting so as to try to make others feel that ^he^ is","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"act so as to try to make others feel that ^he^ is","past_preverb":"","exp_display":'@\u2074+taar',"gen_preverb":"acting so as to try to make others feel that ^he^ is","exp":'@+taar1[V\u2192V]',"match_case":false,"ger_preverb":"acting so as to try to make others feel that ^he^ is","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"238":{"description":"tends to often","past_preverb_after":"i","ger_preverb_after":"i","is":false,"inf_preverb":"tend to often","past_preverb":"tended to often","exp_display":"+tar","gen_preverb":"tends to often","exp":'+tar[V\u2192V]',"match_case":false,"ger_preverb":"tending to often","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"245":{"match_case":true,"exp_display":"+ter","description":"suddenly and willfully","exp":'+ter[V\u2192V]',"postverb":"suddenly and willfully"},"246":{"match_case":true,"exp_display":'\u2013tngurte',"description":"unexpectedly","exp":'\u2013tngurte[V\u2192V]',"postverb":"unexpectedly"},"247":{"match_case":true,"exp_display":'\u2013tmurte',"description":"unexpectedly","exp":'\u2013tmurte2[V\u2192V]',"postverb":"unexpectedly"},"248":{"match_case":true,"exp_display":'\u2013tu',"description":"customarily","exp":'\u2013tu[V\u2192V]',"postverb":"customarily"},"249":{"description":"always","ger_preverb":"always","is":true,"inf_preverb":"always","past_preverb":"always","exp_display":"+tuinar","gen_preverb":"always","exp":'+tuinar[V\u2192V]',"match_case":true,"subj":"it"},"251":{"description":"proficiently able to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be proficiently able to","past_preverb":"","exp_display":'\u2013turnir',"gen_preverb":"proficiently able to","exp":'\u2013turnir[V\u2192V]',"match_case":false,"ger_preverb":"being proficiently able to","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"252":{"description":"pretending to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"pretend to","past_preverb":"","exp_display":'@\xB2~+(ng)uar',"gen_preverb":"pretending to","exp":'@~+(ng)uar[V\u2192V]',"match_case":false,"ger_preverb":"pretending to","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"253":{"description":"continuing to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"continue to","past_preverb":"","exp_display":'@\u02C1+`(g|t)ur(ar)',"gen_preverb":"continuing to","exp":'@+`(g|t)ur(ar)[V\u2192V]',"match_case":false,"ger_preverb":"continuing to","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"254":{"description":"finally (after desiring to but not being able to)","ger_preverb":"finally (after desiring to but not being able to)","is":true,"inf_preverb":"finally (after desiring to but not being able to)","past_preverb":"finally (after desiring to but not being able to)","exp_display":'@\u02C1+`(g|t)urainar',"gen_preverb":"finally (after desiring to but not being able to)","exp":'@+`(g|t)urainar[V\u2192V]',"match_case":true,"subj":"it"},"255":{"description":"always","ger_preverb":"always","is":true,"inf_preverb":"always","past_preverb":"always","exp_display":'@\u02C1+`(g|t)uralar',"gen_preverb":"always","exp":'@+`(g|t)uralar[V\u2192V]',"match_case":true,"subj":"it"},"256":{"description":"always","ger_preverb":"always","is":true,"inf_preverb":"always","past_preverb":"always","exp_display":'@\u02C1+`(g|t)ur(ar)lar',"gen_preverb":"always","exp":'@+`(g|t)ur(ar)lar[V\u2192V]',"match_case":true,"subj":"it"},"257":{"description":"always","ger_preverb":"always","is":true,"inf_preverb":"always","past_preverb":"always","exp_display":'@\u02C1+`(g|t)uratu',"gen_preverb":"always","exp":'@+`(g|t)uratu[V\u2192V]',"match_case":true,"subj":"it"},"258":{"match_case":true,"exp_display":'\u2013vguar(ar)',"description":"a little bit","exp":'\u2013vguar(ar)[V\u2192V]',"postverb":"a little bit"},"259":{"match_case":true,"exp_display":'\u2013vialug',"description":"clumsily","exp":'\u2013vialug[V\u2192V]',"postverb":"clumsily"},"260":{"description":"leaves no room or place to","past_preverb_after":"i","ger_preverb_after":"i","is":false,"inf_preverb":"leave no room or place to","past_preverb":"left no room or place to","exp_display":'\u2013viite',"gen_preverb":"leaves no room or place to","exp":'\u2013viite[V\u2192V]',"match_case":false,"ger_preverb":"leaving no room or place to","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"262":{"match_case":true,"exp_display":'\u2013vlaag',"description":"insufficiently","exp":'\u2013vlaag[V\u2192V]',"postverb":"insufficiently"},"263":{"match_case":true,"exp_display":'\u2013vlugte',"description":"sloppily","exp":'\u2013vlugte[V\u2192V]',"postverb":"sloppily"},"264":{"match_case":true,"exp_display":'\u2013vsiar',"description":"even more to completion","exp":'\u2013vsiar[V\u2192V]',"postverb":"even more to completion"},"265":{"match_case":true,"exp_display":'\u2013vyiar',"description":"even more to completion","exp":'\u2013vyiar[V\u2192V]',"postverb":"even more to completion"},"266":{"match_case":true,"exp_display":'\u2013vyirte',"description":"around here and there","exp":'\u2013vyirte[V\u2192V]',"postverb":"around here and there"},"267":{"match_case":true,"exp_display":'@\u02B8~+yaaqe',"description":"in vain (fruitlessly)","exp":'@~+yaaqe[V\u2192V]',"postverb":"in vain (fruitlessly)"},"268":{"description":"very cutely or dearly","ger_preverb":"very cutely or dearly","is":true,"inf_preverb":"very cutely or dearly","past_preverb":"very cutely or dearly","exp_display":'\u2013ya\u0121ar',"gen_preverb":"very cutely or dearly","exp":'\u2013ya(g)ar[V\u2192V]',"match_case":true,"subj":"it"},"269":{"description":"very cutely or dearly","ger_preverb":"very cutely or dearly","is":true,"inf_preverb":"very cutely or dearly","past_preverb":"very cutely or dearly","exp_display":'\u2013yagar',"gen_preverb":"very cutely or dearly","exp":'\u2013yagar[V\u2192V]',"match_case":true,"subj":"it"},"271":{"match_case":true,"exp_display":'@\u02B8~+yalqar',"description":"without recompense","exp":'@~+yalqar[V\u2192V]',"postverb":"without recompense"},"273":{"description":"finally","ger_preverb":"finally","is":true,"inf_preverb":"finally","past_preverb":"finally","exp_display":'@\u02B8~+yaqlir',"gen_preverb":"finally","exp":'@~+yaqlir[V\u2192V]',"match_case":true,"subj":"he"},"275":{"match_case":true,"exp_display":'@\u02B8~+yarar',"description":"early","exp":'@~+yarar[V\u2192V]',"postverb":"early"},"276":{"match_case":true,"exp_display":'@\u02B8~+yarar(ar)',"description":"very early","exp":'@~+yarar(ar)[V\u2192V]',"postverb":"very early"},"277":{"description":"almost","ger_preverb":"almost","is":true,"inf_preverb":"almost","past_preverb":"almost","exp_display":'@\u02B8~+yarpiar',"gen_preverb":"almost","exp":'@~+yarpiar[V\u2192V]',"match_case":true,"subj":"he"},"278":{"description":"almost","ger_preverb":"almost","is":true,"inf_preverb":"almost","past_preverb":"almost","exp_display":"~+yarpigar","gen_preverb":"almost","exp":'~+yarpigar[V\u2192V]',"match_case":true,"subj":"he"},"279":{"description":"going to","past_preverb_after":"i","ger_preverb_after":"g","is":true,"inf_preverb":"go","past_preverb":"","exp_display":'@\u02B8~+yartur',"gen_preverb":"going to","exp":'@~+yartur[V\u2192V]',"match_case":false,"ger_preverb":"going","subj":"he","inf_preverb_after":"g","gen_preverb_after":"i"},"280":{"description":"starting and continuing to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"start and continue to","past_preverb":"","exp_display":'@\u02B8~+yaurciiqe',"gen_preverb":"starting and continuing to","exp":'@~+yaurciiqe[V\u2192V]',"match_case":false,"ger_preverb":"starting and continuing to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"281":{"description":"now able to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be now able to","past_preverb":"","exp_display":'@\u02B8~+yaurte',"gen_preverb":"now able to","exp":'@~+yaurte[V\u2192V]',"match_case":false,"ger_preverb":"being now able to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"282":{"description":"well able to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be well able to","past_preverb":"","exp_display":'@\u02B8~\u2013yu',"gen_preverb":"well able to","exp":'@~\u2013yu[V\u2192V]',"match_case":false,"ger_preverb":"being well able to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"283":{"description":"","past_preverb_after":"","ger_preverb_after":"g","is":false,"inf_preverb":"","past_preverb":"","exp_display":'@\u02B8~+yuar',"gen_preverb":"","exp":'@~+yuar[V\u2192V]',"match_case":false,"ger_preverb":"","subj":"","inf_preverb_after":"i","gen_preverb_after":""},"284":{"description":"wants to","past_preverb_after":"i","ger_preverb_after":"i","is":false,"inf_preverb":"want to","past_preverb":"wanted to","exp_display":'@\u02B8~+yug',"gen_preverb":"wants to","exp":'@~+yug[V\u2192V]',"match_case":false,"ger_preverb":"wanting to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"285":{"description":"enjoys ^his^","past_preverb_after":"g","ger_preverb_after":"g","is":false,"inf_preverb":"enjoy ^his^","past_preverb":"enjoyed ^his^","exp_display":'@\u02B8~+yugar',"gen_preverb":"enjoys ^his^","exp":'@~+yugar[V\u2192V]',"match_case":false,"ger_preverb":"enjoying ^his^","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"286":{"match_case":true,"exp_display":'@\u02B8~+yugcali',"description":"heartily","exp":'@~+yugcali[V\u2192V]',"postverb":"heartily"},"288":{"description":"definitely no longer going to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be definitely no longer going to","past_preverb":"","exp_display":'@\u02B8~+yugnairute',"gen_preverb":"definitely no longer going to","exp":'@~+yugnairute[V\u2192V]',"match_case":false,"ger_preverb":"being definitely no longer going to","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"289":{"description":"definitely not going to ","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be definitely not going to ","past_preverb":"","exp_display":'@\u02B8~+yugnaite\xB0',"gen_preverb":"definitely not going to ","exp":'@~+yugnaite1[V\u2192V]',"match_case":false,"ger_preverb":"being definitely not going to ","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"291":{"description":"probably","ger_preverb":"probably","is":true,"inf_preverb":"probably","past_preverb":"probably","exp_display":'@\u02B8~+yugnarqe',"gen_preverb":"probably","exp":'@~+yugnarqe1[V\u2192V]',"match_case":true,"subj":"he"},"292":{"description":"such as to make one want to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be such as to make one want to","past_preverb":"","exp_display":'@\u02B8~+yugnarqe',"gen_preverb":"such as to make one want to","exp":'@~+yugnarqe2[V\u2192V]',"match_case":false,"ger_preverb":"being such as to make one want to","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"293":{"description":"able to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be able to","past_preverb":"","exp_display":'@\u02B8~+yugnga',"gen_preverb":"able to","exp":'@~+yugnga[V\u2192V]',"match_case":false,"ger_preverb":"being able to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"294":{"description":"wants (provided it is all right) to","past_preverb_after":"i","ger_preverb_after":"i","is":false,"inf_preverb":"want (provided it is all right) to","past_preverb":"wanted (provided it was all right) to","exp_display":'@\u02B8~+yugyaaqe',"gen_preverb":"wants (provided it is all right) to","exp":'@~+yugyaaqe[V\u2192V]',"match_case":false,"ger_preverb":"wanting (provided it is all right) to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"295":{"description":"no longer","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"be no longer","past_preverb":"","exp_display":'@\u02B8~\u2013yuirute',"gen_preverb":"no longer","exp":'@~\u2013yuirute[V\u2192V]',"match_case":false,"ger_preverb":"being no longer","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"296":{"description":"never","past_preverb_after":"g","ger_preverb_after":"g","is":true,"inf_preverb":"be never","past_preverb":"","exp_display":'@\u02B8~\u2013yuite\xB0',"gen_preverb":"never","exp":'@~\u2013yuite[V\u2192V]',"match_case":false,"ger_preverb":"being never","subj":"he","inf_preverb_after":"g","gen_preverb_after":"g"},"297":{"description":"ready to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"be ready to","past_preverb":"","exp_display":'@\u02B8~+yukaar(ar)',"gen_preverb":"ready to","exp":'@~+yukaar(ar)[V\u2192V]',"match_case":false,"ger_preverb":"being ready to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"300":{"description":"the proper time to","past_preverb_after":"i","ger_preverb_after":"g","is":true,"inf_preverb":"","past_preverb":"","exp_display":'@\u02B8~\u2013yunari',"gen_preverb":"the proper time to","exp":'@~\u2013yunari[V\u2192V]',"match_case":false,"ger_preverb":"","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"301":{"description":"possible to","past_preverb_after":"i","ger_preverb_after":"g","is":true,"inf_preverb":"","past_preverb":"","exp_display":'@\u02B8~\u2013yunarqe',"gen_preverb":"possible to","exp":'@~\u2013yunarqe[V\u2192V]',"match_case":false,"ger_preverb":"","subj":"it","inf_preverb_after":"i","gen_preverb_after":"i"},"302":{"description":"loves","past_preverb_after":"g","ger_preverb_after":"g","is":false,"inf_preverb":"","past_preverb":"loved","exp_display":'@\u02B8~+yunqegg',"gen_preverb":"loves","exp":'@~+yunqegg[V\u2192V]',"match_case":false,"ger_preverb":"","subj":"he","inf_preverb_after":"i","gen_preverb_after":"g"},"303":{"description":"continuing not to","past_preverb_after":"i","ger_preverb_after":"g","is":true,"inf_preverb":"","past_preverb":"","exp_display":'@\u02B8~+yunrite\xB0',"gen_preverb":"continuing not to","exp":'@~+yunrite[V\u2192V]',"match_case":false,"ger_preverb":"","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"304":{"description":"able to","past_preverb_after":"i","ger_preverb_after":"g","is":true,"inf_preverb":"","past_preverb":"","exp_display":'@\u02B8~+yuuma',"gen_preverb":"able to","exp":'@~+yuuma[V\u2192V]',"match_case":false,"ger_preverb":"","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"305":{"description":"no longer wants to","past_preverb_after":"i","ger_preverb_after":"g","is":false,"inf_preverb":"","past_preverb":"no longer wanted to","exp_display":'@\u02B8~+yuumiir(ar)te',"gen_preverb":"no longer wants to","exp":'@~+yuumiir(ar)te[V\u2192V]',"match_case":false,"ger_preverb":"","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"306":{"description":"not care to","past_preverb_after":"i","ger_preverb_after":"i","is":false,"inf_preverb":"not care to","past_preverb":"","exp_display":'@\u02B8~+yuumiite\xB0',"gen_preverb":"not care to","exp":'@~+yuumiite[V\u2192V]',"match_case":false,"ger_preverb":"not caring to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"},"307":{"description":"yearning to","past_preverb_after":"i","ger_preverb_after":"i","is":true,"inf_preverb":"yearn to","past_preverb":"","exp_display":'@\u02B8~+yuumir',"gen_preverb":"yearning to","exp":'@~+yuumir[V\u2192V]',"match_case":false,"ger_preverb":"yearning to","subj":"he","inf_preverb_after":"i","gen_preverb_after":"i"}};var verbPostbases={// '0':{
//   // id: 0,
//   description: 'is probably',
//   englishModifier: (english) => { return 'probably '+ english; },
//   expression: 'palliq',
//   expression_conditional: '',
//   conditional_rule: '',
//   priority: 1,
//   tense:'',
//   allowable_next_ids: [1]
// },
//   {
//     id: 1,
//     description: 'is evidently (without being observed)',
//     englishModifier: (english) => { return 'evidently '+ english; },
//     expression: '-2ini\\',
//     expression_conditional: '',
//     conditional_rule: '',
//     priority: 1,
//     tense:'',
//     allowable_next_ids: [0]
//   },
//   {
//     id: 2,
//     description: 'is no longer able to',
//     englishModifier: (english) => { return 'no longer able to '+ english; },
//     expression: '+(s)ciigali\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1,3]
//   },
//   {
//     id: 3,
//     description: 'is not able to',
//     englishModifier: (english) => { return 'not able to '+ english; },
//     expression: '+(s)ciigate\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1,2]
//   },
// notis = [1,2,6,7,10]
// future = [1,2]
// infinitive = [1,2,6,8,9,10,11]
// if not added second for notis, use does
1:{// id: 4,
description:'will',englishModifier:function englishModifier(english){return'will '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'will '+english;},englishModifierGerund:function englishModifierGerund(english){return'will '+english;},englishModifierPast:function englishModifierPast(english){return'will '+english;},expression:'+ciqe|@ciiqe[V→V]',// tense:'future',
allowable_next_ids:[10,11,5,6,8,7,12,9]},2:{// id: 4,
description:'will not',englishModifier:function englishModifier(english){return'will not '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'will not '+english;},englishModifierGerund:function englishModifierGerund(english){return'will not '+english;},englishModifierPast:function englishModifierPast(english){return"won't "+english;},expression:'@~+ngaite[V→V]',// tense:'future',
allowable_next_ids:[6,10,11,9,12,7,8]},3:{// id: 4,
description:'probably',englishModifier:function englishModifier(english){return'probably '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'probably '+english;},englishModifierGerund:function englishModifierGerund(english){return'probably '+english;},englishModifierPast:function englishModifierPast(english){return'probably '+english;},expression:'@~+yugnarqe2[V→V]',// tense:'',
allowable_next_ids:[1,2,6,4]},4:{// id: 4,
description:'not',englishModifier:function englishModifier(english){return'not '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'not '+english;},englishModifierGerund:function englishModifierGerund(english){return'not '+english;},englishModifierPast:function englishModifierPast(english){return'not '+english;},expression:'–nrite[V→V]',// tense:'',
allowable_next_ids:[6,5]},5:{// id: 4,
description:'deliberately (purposefully)',englishModifier:function englishModifier(english){return'deliberately (purposefully) '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'deliberately (purposefully) '+english;},englishModifierGerund:function englishModifierGerund(english){return'deliberately (purposefully) '+english;},englishModifierPast:function englishModifierPast(english){return'deliberately (purposefully) '+english;},expression:'saaġi',// tense:'',
allowable_next_ids:[4]},12:{// id: 4,
description:'always (regularly)',englishModifier:function englishModifier(english){return'always (regularly) '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'always (regularly) '+english;},englishModifierGerund:function englishModifierGerund(english){return'always (regularly) '+english;},englishModifierPast:function englishModifierPast(english){return'always (regularly) '+english;},expression:'–lar[V→V]',// tense:'',
allowable_next_ids:[6,11]},6:{// id: 4,
description:'wants to',englishModifier:function englishModifier(english){return'wanting to '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'want to '+english;},englishModifierGerund:function englishModifierGerund(english){return'wanting to '+english;},englishModifierPast:function englishModifierPast(english){return'wanted to '+english;},expression:'@~+yug[V→V]',// tense:'',
allowable_next_ids:[11,9]},11:{// id: 4,
description:'beginning to',englishModifier:function englishModifier(english){return'beginning to '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'begin to '+english;},englishModifierGerund:function englishModifierGerund(english){return'beginning to '+english;},englishModifierPast:function englishModifierPast(english){return'began to '+english;},expression:'rraqsi',// tense:'',
allowable_next_ids:[6]},10:{// id: 4,
description:'likes',englishModifier:function englishModifier(english){return'likes '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'like '+english;},englishModifierGerund:function englishModifierGerund(english){return'liking '+english;},englishModifierPast:function englishModifierPast(english){return'liked '+english;},expression:'llatu',// tense:'',
allowable_next_ids:[]},7:{// id: 4,
description:'dislikes',englishModifier:function englishModifier(english){return'dislikes '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'dislike '+english;},englishModifierGerund:function englishModifierGerund(english){return'disliking '+english;},englishModifierPast:function englishModifierPast(english){return'disliked '+english;},expression:'sulait',// tense:'',
allowable_next_ids:[]},8:{// id: 4,
description:'not able to',englishModifier:function englishModifier(english){return'unable to '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'be unable to '+english;},englishModifierGerund:function englishModifierGerund(english){return'being unable to '+english;},englishModifierPast:function englishModifierPast(english){return'unable to '+english;},expression:'+(s)ciigate[V→V]',// tense:'',
allowable_next_ids:[]},9:{// id: 4,
description:'able to',englishModifier:function englishModifier(english){return'able to '+english;},englishModifierInfinitive:function englishModifierInfinitive(english){return'be able to '+english;},englishModifierGerund:function englishModifierGerund(english){return'being able to '+english;},englishModifierPast:function englishModifierPast(english){return'able to '+english;},expression:'@~+yugnga[V→V]',// tense:'',
allowable_next_ids:[]}//   {
//     id: 5,
//     description: 'past tense',
//     englishModifier: (english) => { return ''+ english; },
//     expression: '-2ru\\',
//     expression_conditional: '',
//     priority: 3,
//     conditional_rule: '',
//     tense:'past',
//     allowable_next_ids: [7]
//   },
//   {
//     id: 6,
//     description: 'not yet',
//     englishModifier: (english) => { return 'not yet '+ english; },
//     expression: '-ksaite\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7]
//   },
//   {
//     id: 7,
//     description: 'future tense',
//     englishModifier: (english) => { return ''+ english},
//     expression: '+ciqe\\',
//     expression_conditional: '@ciiqe\\',  // conditional te_ending
//     priority: 3,
//     conditional_rule: 'attaching_to_te',  // defined later and if satisfied display expression_conditional
//     tense:'future',
//     allowable_next_ids: [0,1,5,10]
//   },
//   {
//     id: 8,
//     description: 'will not',
//     englishModifier: (english) => { return 'not '+  english; },
//     expression: '@~+6aite\\',
//     expression_conditional: '',
//     priority: 3,
//     conditional_rule: '',
//     tense:'future',
//     allowable_next_ids: [0,1,7,10]
//   },
//   {
//     id: 9,
//     description: 'will soon',
//     englishModifier: (english) => { return 'soon '+ english; },
//     expression: '@~+niarar\\',
//     expression_conditional: '',
//     priority: 3,
//     conditional_rule: '',
//     tense:'future',
//     allowable_next_ids: [0,1,5,6,7,10]
//   },
//   {
//     id: 10,
//     description: 'about to',
//     englishModifier: (english) => { return 'about to '+ english; },
//     expression: '-qatar\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1,7]
//   },
//   {
//     id: 11,
//     description: 'repeatedly',
//     englishModifier: (english) => { return 'repeatedly '+ english; },
//     expression: '-lar\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 12,
//     description: 'doing it again',
//     englishModifier: (english) => { return '(again) '+ english; },
//     expression: '-nqigte\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 13,
//     description: 'almost',
//     englishModifier: (english) => { return 'almost '+ english; },
//     expression: '@~+yarpiar\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 14,
//     description: 'never',
//     englishModifier: (english) => { return 'never '+ english; },
//     expression: '@-~yuite\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 15,
//     description: 'no longer',
//     englishModifier: (english) => { return 'no longer '+ english; },
//     expression: '-nrir\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,27]
//   },
//   {
//     id: 16,
//     description: 'trying (unsuccessfully) to',
//     englishModifier: (english) => { return 'trying (unsuccessfully) to '+ english; },
//     englishModifierInfinitive: (english) => { return 'try (unsuccessfully) to '+ english; },
//     englishModifierGerund: (english) => { return 'trying (unsuccessfully) to '+ english; },
//     expression: '@~+yaaqe\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,17,19]
//   },
//   {
//     id: 17,
//     description: 'trying despite difficulties to',
//     englishModifier: (english) => { return 'trying despite difficulties to '+ english; },
//     englishModifierInfinitive: (english) => { return 'try despite difficulties to '+ english; },
//     englishModifierGerund: (english) => { return 'trying despite difficulties to '+ english; },
//     expression: '-qcaar(ar)\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,16,18]
//   },
//   {
//     id: 18,
//     description: 'trying to',
//     englishModifier: (english) => { return 'trying to '+ english; },
//     englishModifierInfinitive: (english) => { return 'try to '+ english; },
//     englishModifierGerund: (english) => { return 'trying to '+ english; },
//     expression: '-6naqe\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,16,17]
//   },
//   {
//     id: 19,
//     description: 'excessively (too much)',
//     englishModifier: (english) => { return 'excessively '+ english; },
//     expression: '-3iyaag\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 20,
//     description: 'to be more or better at',
//     englishModifier: (english) => { return '(being more or better at) '+ english; },
//     expression: '-nru\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 21,
//     description: 'loves to',
//     englishModifier: (english) => { return 'loves to '+ english; },
//     englishModifierInfinitive: (english) => { return 'love to '+ english; },
//     englishModifierGerund: (english) => { return 'loving to '+ english; },
//     expression: '@~+yunqe4\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 22,
//     description: 'no longer wants to',
//     englishModifier: (english) => { return 'no longer wants to '+ english; },
//     englishModifierInfinitive: (english) => { return 'no longer want to '+ english; },
//     englishModifierGerund: (english) => { return 'no longer wanting to '+ english; },
//     expression: '@~+yuumiir(ar)te\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 23,
//     description: 'not care to',
//     englishModifier: (english) => { return 'not care to '+ english; },
//     englishModifierInfinitive: (english) => { return 'not care to '+ english; },
//     englishModifierGerund: (english) => { return 'not caring to '+ english; },
//     expression: '@~+yuumiite\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 24,
//     description: 'yearns to',
//     englishModifier: (english) => { return 'yearns to '+ english; },
//     englishModifierInfinitive: (english) => { return 'yearn to '+ english; },
//     englishModifierGerund: (english) => { return 'yearning to '+ english; },
//     expression: '@~+yuumir\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 25,
//     description: 'wants to',
//     englishModifier: (english) => { return 'wants to '+ english; },
//     englishModifierInfinitive: (english) => { return 'want to '+ english; },
//     englishModifierGerund: (english) => { return 'wanting to '+ english; },
//     expression: '@~+yug\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 26,
//     description: 'enjoys doing',
//     englishModifier: (english) => { return 'enjoying '+ english; },
//     englishModifierInfinitive: (english) => { return 'enjoy '+ english; },
//     englishModifierGerund: (english) => { return 'enjoying '+ english; },
//     expression: '@~+yugar\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 27,
//     description: 'not',
//     englishModifier: (english) => { return 'not '+ english; },
//     expression: '-nrite\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1]
//   },
//   // {
//   //   id: 28,
//   //   description: 'to ask one to',
//   //   englishModifier: (english) => { return 'to ask one to '+ english; },
//   //   expression: 'sqe-\\',
//   //   expression_conditional: '',
//   //   conditional_rule: '',
//   //   tense:'',
//   //   allowable_next_ids: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
//   // },
//   {
//     id: 28,
//     description: 'in the process of',
//     englishModifier: (english) => { return 'in the process of '+ english; },
//     expression: '@~+yartur\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,2,3,4,5,6,7,8,9,10,19]
//   },
//   {
//     id: 29,
//     description: 'definitely no longer going to',
//     englishModifier: (english) => { return 'definitely no longer going to '+ english; },
//     expression: '@~+yugnairute\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,3,4,8,10], // only refers to the postbases, not the endings
//   }
};var nounPostbases={13:{// id: 4,
description:'good',englishModifier:function englishModifier(english){return'good '+english;},englishModifierPlural:function englishModifierPlural(english){return'good '+english;},expression:'–kegtaar(ar*)[N→N]',// tense:'future',
allowable_next_ids:[17,18,19,20,21,22,23,24,25]},14:{// id: 4,
description:'big',englishModifier:function englishModifier(english){return'big '+english;},englishModifierPlural:function englishModifierPlural(english){return'big '+english;},expression:'qpak',// tense:'future',
allowable_next_ids:[17,18,19,20,21,22,23,24,25]},15:{// id: 4,
description:'bad',englishModifier:function englishModifier(english){return'bad '+english;},englishModifierPlural:function englishModifierPlural(english){return'bad '+english;},expression:'pałłuk',// tense:'',
allowable_next_ids:[17,18,19,20,21,22,23,24,25]},16:{// id: 4,
description:'small',englishModifier:function englishModifier(english){return'small '+english;},englishModifierPlural:function englishModifierPlural(english){return'small '+english;},expression:'ŋuluk',// tense:'',
allowable_next_ids:[17,18,19,20,21,22,23,24,25]},17:{// id: 4,
description:'it is a N',englishModifier:function englishModifier(english){return'a '+english;},englishModifierPlural:function englishModifierPlural(english){return''+english;},expression:'u',// tense:'',
allowable_next_ids:[13,14,15,16]},18:{// id: 4,
description:'it is making N',englishModifier:function englishModifier(english){return'making a '+english;},englishModifierPlural:function englishModifierPlural(english){return'making a '+english;},expression:'liuq',// tense:'',
allowable_next_ids:[13,14,15,16]},19:{// id: 4,
description:'it is eating or using N',englishModifier:function englishModifier(english){return'eating or using a '+english;},englishModifierPlural:function englishModifierPlural(english){return'eating or using a '+english;},expression:'tuq',// tense:'',
allowable_next_ids:[13,14,15,16]},20:{// id: 4,
description:'it has a N',englishModifier:function englishModifier(english){return'has a '+english;},englishModifierPlural:function englishModifierPlural(english){return'have a '+english;},expression:'qaq',// tense:'',
allowable_next_ids:[13,14,15,16]},21:{// id: 4,
description:'it has a small quantity of N',englishModifier:function englishModifier(english){return'has a small quantity of '+english;},englishModifierPlural:function englishModifierPlural(english){return'have a small quantity of '+english;},expression:'kit',// tense:'',
allowable_next_ids:[13,14,15,16]},22:{// id: 4,
description:'it lacks N',englishModifier:function englishModifier(english){return'lacks a '+english;},englishModifierPlural:function englishModifierPlural(english){return'lack a '+english;},expression:'it',// tense:'',
allowable_next_ids:[13,14,15,16]},23:{// id: 4,
description:'it is located at the N',englishModifier:function englishModifier(english){return'located at the '+english;},englishModifierPlural:function englishModifierPlural(english){return'located at the '+english;},expression:'+N+Loc+Sg>miit',// tense:'',
allowable_next_ids:[13,14,15,16]},24:{// id: 4,
description:'it is coming from the N',englishModifier:function englishModifier(english){return'coming from the '+english;},englishModifierPlural:function englishModifierPlural(english){return'coming from the '+english;},expression:'+N+Abl+Sg>miñŋaq',// tense:'',
allowable_next_ids:[13,14,15,16]},25:{// id: 4,
description:'it is going to the N',englishModifier:function englishModifier(english){return'going to the '+english;},englishModifierPlural:function englishModifierPlural(english){return'going to the '+english;},expression:'+N+Trm+Sg>muk',// tense:'',
allowable_next_ids:[13,14,15,16]}//   {
//     id: 0,
//     description: 'large',
//     englishModifier: (english) => { return 'large '+ english; },
//     expression_end: '-rpak',
//     expression_postbase: '-rpag\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 1,
//     description: 'small',
//     englishModifier: (english) => { return 'small '+ english; },
//     expression_end: '-cuar',
//     expression_postbase: '-cuar\\',
//     expression_conditional_end: '-kcuar',
//     expression_conditional_postbase: '-kcuar(ar)\\',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: [0]
//   },
//   {
//     id: 2,
//     description: 'baby/little',
//     englishModifier: (english) => { return 'baby/little '+ english; },
//     expression_end: '-yagaq',
//     expression_postbase: '-yagar\\',
//     expression_conditional_end: '-yagaq',
//     expression_conditional_postbase: '-yagar\\',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 3,
//     description: 'good',
//     englishModifier: (english) => { return 'good '+ english; },
//     expression_end: '-kegtaar',
//     expression_postbase: '-kegtaar\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 4,
//     description: 'shabby',
//     englishModifier: (english) => { return 'shabby '+ english; },
//     expression_end: '-2er',
//     expression_postbase: '-2er\\',
//     expression_conditional_end: '-2er',
//     expression_conditional_postbase: '-2er\\',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 5,
//     description: 'genuine',
//     englishModifier: (english) => { return 'genuine '+ english; },
//     expression_end: '-piaq',
//     expression_postbase: '-piar\\',
//     expression_conditional_end: '-pik',
//     expression_conditional_postbase: '-pig\\',
//     conditional_rule: '',
//     priority:4,
//     tense:'past',
//     allowable_next_ids: []
//   },
//   {
//     id: 6,
//     description: 'fake',
//     englishModifier: (english) => { return 'fake '+ english; },
//     expression_end: '-(6)uaq',
//     expression_postbase: '-(6)uar\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 7,
//     description: 'many Ns',
//     englishModifier: (english) => { return 'many of them'+ english},
//     expression_end: '-rugaq',
//     expression_postbase: '-rugar\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:2,
//     tense:'noun_end',
//     allowable_next_ids: []
//   },
//   {
//     id: 8,
//     description: 'just a little',
//     englishModifier: (english) => { return 'just a little'+ english},
//     expression_end: '-5aq',
//     expression_postbase: '-5ar\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:2,
//     tense:'noun_end',
//     allowable_next_ids: []
//   },
//   {
//     id: 9,
//     description: 'N and other',
//     englishModifier: (english) => { return 'and another - only applies to people or animals '+ english; },
//     expression_end: ':(e)nkuk',
//     expression_postbase: ':(e)nkug\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:2,
//     tense:'noun_end',
//     allowable_next_ids: []
//   },
//   {
//     id: 10,
//     description: 'N and others',
//     englishModifier: (english) => { return 'and others - only applies to people or animals '+ english; },
//     expression_end: ':(e)nkut',
//     expression_postbase: ':(e)nkur\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:2,
//     tense:'noun_end',
//     allowable_next_ids: []
//   },
//   {
//     id: 11,
//     description: 'to hunt',
//     englishModifier: (english) => { return 'hunting '+ english; },
//     expression_postbase: '+cur\\',
//     expression_conditional_postbase: '+ssur\\',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 12,
//     description: 'to make',
//     englishModifier: (english) => { return 'making '+ english; },
//     expression_postbase: '-li\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 13,
//     description: 'to catch lots of',
//     englishModifier: (english) => { return 'catching lots of '+ english; },
//     expression_postbase: '-liqe\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 14,
//     description: 'to have lots of',
//     englishModifier: (english) => { return 'lots of '+ english; },
//     expression_postbase: '-lir\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 15,
//     description: 'to be occupied with',
//     englishModifier: (english) => { return 'occupied with '+ english; },
//     expression_postbase: '-liur\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 16,
//     description: 'to acquire',
//     englishModifier: (english) => { return 'acquiring '+ english; },
//     expression_postbase: '-6e\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 17,
//     description: 'to have',
//     englishModifier: (english) => { return ''+ english; },
//     expression_postbase: '-ngqerr\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 18,
//     description: 'the place does not have',
//     englishModifier: (english) => { return '(location) does not have '+ english; },
//     expression_postbase: '+taite\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 19,
//     description: 'the place has',
//     englishModifier: (english) => { return '(location) has '+ english; },
//     expression_postbase: '+ta6qe5\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 20,
//     description: 'to eat',
//     englishModifier: (english) => { return 'eating '+ english; },
//     expression_postbase: '+tur\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 21,
//     description: 'to become',
//     englishModifier: (english) => { return 'become '+ english; },
//     expression_postbase: '~:(6)urte\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   }
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(157);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(15),
    isKey = __webpack_require__(169),
    stringToPath = __webpack_require__(272),
    toString = __webpack_require__(37);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(82),
    toKey = __webpack_require__(62);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(176),
    isFlattenable = __webpack_require__(564);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(23),
    stubFalse = __webpack_require__(569);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120)(module)))

/***/ }),
/* 88 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(123),
    getTag = __webpack_require__(53),
    isArguments = __webpack_require__(109),
    isArray = __webpack_require__(15),
    isArrayLike = __webpack_require__(28),
    isBuffer = __webpack_require__(87),
    isPrototype = __webpack_require__(88),
    isTypedArray = __webpack_require__(121);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(25);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(130),
    baseAssignValue = __webpack_require__(125);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });



/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return interrogative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return optative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dependent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return verb2noun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return postbaseButtons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return enclitics; });
var interrogative=[{group:'interrogative',mood:'who',text:'who'},{group:'interrogative',mood:'when (in past)',text:'when (in past)'},{group:'interrogative',mood:'when (in future)',text:'when (in future)'},{group:'interrogative',mood:'at where',text:'at where'},{group:'interrogative',mood:'from where',text:'from where'},{group:'interrogative',mood:'toward where',text:'toward where'},{group:'interrogative',mood:'why',text:'why'},{group:'interrogative',mood:'how',text:'how'}];var optative=[{group:'optative',mood:'do!',text:'do!'},{group:'optative',mood:'do (in the future)!',text:'do (in the future)!'},{group:'optative',mood:'You, do not!',text:'You, do not!'},{group:'optative',mood:'You, stop!',text:'You, stop!'}];var dependent=[{group:'connective_precessive',mood:'before...',text:'before'},{group:'connective_consequential',mood:'because...',text:'because'},{group:'connective_contingent',mood:'whenever...',text:'whenever'},{group:'connective_concessive',mood:'although...',text:'although'},{group:'connective_conditional',mood:'if...',text:'if'},{group:'connective_first_contemporative',mood:'when (past)...',text:'when'},{group:'connective_second_contemporative',mood:'when (future)...',text:'when'},{group:'subordinative',mood:'by or being that...',text:'by or being that'}];var verb2noun=[{ending:'the one who is',text:'the one who is'},{ending:'place for',text:'place for'},{ending:'device for',text:'device for'},{ending:'one that often or capably is',text:'one that often or capably is'},{ending:'how to/way of',text:'how to/way of'},{ending:'one who is good at',text:'one who is good at'},{ending:'act or state of',text:'act or state of'}];var postbaseButtons=[{text:'Not',indexes:[27,8,14],activeIndex:11,icon:'time'},{text:'Time',indexes:[5,7,6,8,9,10],activeIndex:6,icon:'time'},{text:'Desire',indexes:[25,21,24,22,23],activeIndex:10,icon:'child'},{text:'Ability',indexes:[4,3,2],activeIndex:5,icon:'football ball'},{text:'Trying',indexes:[18,16,17],activeIndex:8,icon:'cubes'},{text:'Habit/Frequency',indexes:[11,12,13,15,29,28],activeIndex:7,icon:'hourglass end'},{text:'Maybe',indexes:[0,1],activeIndex:4,icon:'thermometer half'},{text:'Comparison',indexes:[19,20],activeIndex:9,icon:'thumbs up'}];var enclitics={'indicative':{activeIndex:30,items:[{ending:'-qaa?',meaning:'(yes or no?)',text:'Yes or no?'},{ending:'-wa',meaning:'(indication of a complete thought)',text:'indication of a complete thought'},{ending:'-gguq',meaning:'(one says)',text:'one says'},{ending:'-llu',meaning:'(also)',text:'and, also'// {
//   ending: 'ataam',
//   meaning: '(again)',
//   text: 'again',
// }
}]},'interrogative':{activeIndex:31,items:[{ending:'-kiq',meaning:'(I wonder...)',text:'I wonder...'},{ending:'-tanem',meaning:'(emphasized)',text:'Add emphasis'}]}};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(262);
var enumBugKeys = __webpack_require__(161);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 102 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(505)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(266)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(544),
    listCacheDelete = __webpack_require__(545),
    listCacheGet = __webpack_require__(546),
    listCacheHas = __webpack_require__(547),
    listCacheSet = __webpack_require__(548);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(83);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(550);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59),
    arrayMap = __webpack_require__(38),
    isArray = __webpack_require__(15),
    isSymbol = __webpack_require__(58);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(554),
    isObjectLike = __webpack_require__(20);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(170),
    setCacheAdd = __webpack_require__(560),
    setCacheHas = __webpack_require__(561);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(114);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(280),
    baseIsNaN = __webpack_require__(562),
    strictIndexOf = __webpack_require__(563);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(28),
    isObjectLike = __webpack_require__(20);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(283),
    isObject = __webpack_require__(25),
    isSymbol = __webpack_require__(58);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(284),
    baseFilter = __webpack_require__(566),
    baseIteratee = __webpack_require__(27),
    isArray = __webpack_require__(15);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(570),
    baseUnary = __webpack_require__(63),
    nodeUtil = __webpack_require__(122);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(271);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120)(module)))

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(88),
    nativeKeys = __webpack_require__(571);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(277);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(289),
    baseIteratee = __webpack_require__(27),
    baseSome = __webpack_require__(606),
    isArray = __webpack_require__(15),
    isIterateeCall = __webpack_require__(75);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(306),
    createBind = __webpack_require__(621),
    createCurry = __webpack_require__(622),
    createHybrid = __webpack_require__(308),
    createPartial = __webpack_require__(631),
    getData = __webpack_require__(186),
    mergeData = __webpack_require__(632),
    setData = __webpack_require__(315),
    setWrapToString = __webpack_require__(316),
    toInteger = __webpack_require__(40);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(91),
    isObject = __webpack_require__(25);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(125),
    eq = __webpack_require__(83);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(287);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    getPrototype = __webpack_require__(131),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(661),
    hasUnicode = __webpack_require__(134),
    unicodeToArray = __webpack_require__(662);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isArray = __webpack_require__(15),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });



/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IconGroup__ = __webpack_require__(336);














/**
 * An icon is a glyph used to represent something else.
 * @see Image
 */

var Icon = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Icon, _Component);

  function Icon() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Icon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Icon, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !Object(__WEBPACK_IMPORTED_MODULE_9__lib__["A" /* shallowEqual */])(this.props, nextProps);
    }
  }, {
    key: 'getIconAriaOptions',
    value: function getIconAriaOptions() {
      var ariaOptions = {};
      var ariaLabel = this.props['aria-label'];


      if (!ariaLabel) {
        ariaOptions['aria-hidden'] = 'true';
      }

      return ariaOptions;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bordered = _props.bordered,
          circular = _props.circular,
          className = _props.className,
          color = _props.color,
          corner = _props.corner,
          disabled = _props.disabled,
          fitted = _props.fitted,
          flipped = _props.flipped,
          inverted = _props.inverted,
          link = _props.link,
          loading = _props.loading,
          name = _props.name,
          rotated = _props.rotated,
          size = _props.size;


      var classes = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(color, name, size, Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(bordered, 'bordered'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(corner, 'corner'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(fitted, 'fitted'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["F" /* useValueAndKey */])(flipped, 'flipped'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["F" /* useValueAndKey */])(rotated, 'rotated'), 'icon', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["r" /* getUnhandledProps */])(Icon, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["q" /* getElementType */])(Icon, this.props);
      var ariaOptions = this.getIconAriaOptions();

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, ariaOptions, { className: classes }));
    }
  }]);

  return Icon;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Icon.defaultProps = {
  as: 'i'
};
Icon._meta = {
  name: 'Icon',
  type: __WEBPACK_IMPORTED_MODULE_9__lib__["b" /* META */].TYPES.ELEMENT
};
Icon.Group = __WEBPACK_IMPORTED_MODULE_10__IconGroup__["a" /* default */];
Icon.handledProps = ['aria-label', 'as', 'bordered', 'circular', 'className', 'color', 'corner', 'disabled', 'fitted', 'flipped', 'inverted', 'link', 'loading', 'name', 'rotated', 'size'];
Icon.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Formatted to appear bordered. */
  bordered: PropTypes.bool,

  /** Icon can formatted to appear circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the icon. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Icons can display a smaller corner icon. */
  corner: PropTypes.bool,

  /** Show that the icon is inactive. */
  disabled: PropTypes.bool,

  /** Fitted, without space to left or right of Icon. */
  fitted: PropTypes.bool,

  /** Icon can flipped. */
  flipped: PropTypes.oneOf(['horizontally', 'vertically']),

  /** Formatted to have its colors inverted for contrast. */
  inverted: PropTypes.bool,

  /** Icon can be formatted as a link. */
  link: PropTypes.bool,

  /** Icon can be used as a simple loader. */
  loading: PropTypes.bool,

  /** Name of the icon. */
  name: customPropTypes.suggest(SUI.ALL_ICONS_IN_ALL_CONTEXTS),

  /** Icon can rotated. */
  rotated: PropTypes.oneOf(['clockwise', 'counterclockwise']),

  /** Size of the icon. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Icon can have an aria label. */
  'aria-label': PropTypes.string
} : {};


Icon.create = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["m" /* createShorthandFactory */])(Icon, function (value) {
  return { name: value };
});

/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(347),
    baseEach = __webpack_require__(64),
    baseIteratee = __webpack_require__(27),
    baseReduce = __webpack_require__(732),
    isArray = __webpack_require__(15);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(764);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Checkbox__["a"]; });



/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Label__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Label__["a"]; });



/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Icon__ = __webpack_require__(21);










/**
 * A table row can have cells.
 */
function TableCell(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      collapsing = props.collapsing,
      content = props.content,
      disabled = props.disabled,
      error = props.error,
      icon = props.icon,
      negative = props.negative,
      positive = props.positive,
      selectable = props.selectable,
      singleLine = props.singleLine,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      warning = props.warning,
      width = props.width;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(collapsing, 'collapsing'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(selectable, 'selectable'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(singleLine, 'single line'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["G" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["H" /* useWidthProp */])(width, 'wide'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(TableCell, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(TableCell, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_6__elements_Icon__["a" /* default */].create(icon),
    content
  );
}

TableCell.handledProps = ['active', 'as', 'children', 'className', 'collapsing', 'content', 'disabled', 'error', 'icon', 'negative', 'positive', 'selectable', 'singleLine', 'textAlign', 'verticalAlign', 'warning', 'width'];
TableCell._meta = {
  name: 'TableCell',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Table'
};

TableCell.defaultProps = {
  as: 'td'
};

TableCell.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A cell can be active or selected by a user. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A cell can be collapsing so that it only uses as much space as required. */
  collapsing: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A cell can be disabled. */
  disabled: PropTypes.bool,

  /** A cell may call attention to an error or a negative value. */
  error: PropTypes.bool,

  /** Add an Icon by name, props object, or pass an <Icon /> */
  icon: customPropTypes.itemShorthand,

  /** A cell may let a user know whether a value is bad. */
  negative: PropTypes.bool,

  /** A cell may let a user know whether a value is good. */
  positive: PropTypes.bool,

  /** A cell can be selectable. */
  selectable: PropTypes.bool,

  /** A cell can specify that its contents should remain on a single line and not wrap. */
  singleLine: PropTypes.bool,

  /** A table cell can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table cell can adjust its text alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A cell may warn a user. */
  warning: PropTypes.bool,

  /** A table can specify the width of individual columns independently. */
  width: PropTypes.oneOf(SUI.WIDTHS)
} : {};

TableCell.create = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["m" /* createShorthandFactory */])(TableCell, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (TableCell);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A list item can contain a description.
 */
function ListDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'description');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ListDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ListDescription, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ListDescription.handledProps = ['as', 'children', 'className', 'content'];
ListDescription._meta = {
  name: 'ListDescription',
  parent: 'List',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

ListDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

ListDescription.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ListDescription, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ListDescription);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A list item can contain a header.
 */
function ListHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ListHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ListHeader, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ListHeader.handledProps = ['as', 'children', 'className', 'content'];
ListHeader._meta = {
  name: 'ListHeader',
  parent: 'List',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

ListHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

ListHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ListHeader, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ListHeader);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * An event or an event summary can contain a date.
 */
function FeedDate(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('date', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(FeedDate, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(FeedDate, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

FeedDate.handledProps = ['as', 'children', 'className', 'content'];
FeedDate._meta = {
  name: 'FeedDate',
  parent: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

FeedDate.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FeedDate);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(869).setImmediate))

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_actions__ = __webpack_require__(447);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StickyMenu=function(_Component){_inherits(StickyMenu,_Component);function StickyMenu(){_classCallCheck(this,StickyMenu);return _possibleConstructorReturn(this,(StickyMenu.__proto__||Object.getPrototypeOf(StickyMenu)).apply(this,arguments));}_createClass(StickyMenu,[{key:'switchMode',value:function switchMode(event,data){this.props.switchMode();this.props.toggleAllPostbases();}},{key:'speak',value:function speak(event,data){var audio=new Audio(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/tts/"+this.props.word.replace('-',''));audio.play();}},{key:'render',value:function render(){var _this2=this;console.log(this.props.history);console.log(this.props.history.location.state===undefined);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{borderless:true,fixed:'top',widths:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */].Item,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{primary:true,icon:true,circular:true,onClick:function onClick(){_this2.props.history.location.state===undefined?_this2.props.history.push('/'):_this2.props.history.goBack();},floated:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'chevron left'})),this.props.displaySimple?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{icon:true,circular:true,onClick:function onClick(){_this2.props.history.push('/');},style:{marginLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'search'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */].Item,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Header */],{style:{fontFamily:'Lato,Arial,Helvetica,sans-serif'},as:'h1',textAlign:'center'},this.props.word)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */].Item,null,this.props.displaySimple?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{circular:true,size:'small',active:this.props.allPostbasesMode,onClick:this.switchMode.bind(this)},'All Options')));}}]);return StickyMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return Object.assign({},state.allPostbases);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,{toggleAllPostbases:__WEBPACK_IMPORTED_MODULE_5__redux_actions__["a" /* toggleAllPostbases */]})(StickyMenu));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(149);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(456);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(241);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports.default = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(97);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(98);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(497);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(71);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(160)('keys');
var uid = __webpack_require__(101);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(22);
var global = __webpack_require__(48);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(100) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 162 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(55);
var dPs = __webpack_require__(507);
var enumBugKeys = __webpack_require__(161);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(261)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(508).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(49).f;
var has = __webpack_require__(56);
var TAG = __webpack_require__(33)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(509);
var global = __webpack_require__(48);
var hide = __webpack_require__(70);
var Iterators = __webpack_require__(74);
var TO_STRING_TAG = __webpack_require__(33)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(33);


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(48);
var core = __webpack_require__(22);
var LIBRARY = __webpack_require__(100);
var wksExt = __webpack_require__(166);
var defineProperty = __webpack_require__(49).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(102);
var createDesc = __webpack_require__(80);
var toIObject = __webpack_require__(57);
var toPrimitive = __webpack_require__(155);
var has = __webpack_require__(56);
var IE8_DOM_DEFINE = __webpack_require__(260);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(50) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(15),
    isSymbol = __webpack_require__(58);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(533),
    mapCacheDelete = __webpack_require__(549),
    mapCacheGet = __webpack_require__(551),
    mapCacheHas = __webpack_require__(552),
    mapCacheSet = __webpack_require__(553);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(557),
    shortOut = __webpack_require__(278);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(279),
    baseFlatten = __webpack_require__(86),
    baseRest = __webpack_require__(52),
    isArrayLikeObject = __webpack_require__(116);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(118);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(567),
    keys = __webpack_require__(26);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(105),
    stackClear = __webpack_require__(575),
    stackDelete = __webpack_require__(576),
    stackGet = __webpack_require__(577),
    stackHas = __webpack_require__(578),
    stackSet = __webpack_require__(579);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(580),
    isObjectLike = __webpack_require__(20);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(284),
    stubArray = __webpack_require__(294);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(65);


/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return numberToWordMap; });
/* harmony export (immutable) */ __webpack_exports__["a"] = numberToWord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var numberToWordMap = {
  1: 'one',
  2: 'two',
  3: 'three',
  4: 'four',
  5: 'five',
  6: 'six',
  7: 'seven',
  8: 'eight',
  9: 'nine',
  10: 'ten',
  11: 'eleven',
  12: 'twelve',
  13: 'thirteen',
  14: 'fourteen',
  15: 'fifteen',
  16: 'sixteen'

  /**
   * Return the number word for numbers 1-16.
   * Returns strings or numbers as is if there is no corresponding word.
   * Returns an empty string if value is not a string or number.
   * @param {string|number} value The value to convert to a word.
   * @returns {string}
   */
};function numberToWord(value) {
  var type = typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
  if (type === 'string' || type === 'number') {
    return numberToWordMap[value] || value;
  }

  return '';
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(91),
    baseLodash = __webpack_require__(185);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(307),
    noop = __webpack_require__(313);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(91),
    baseLodash = __webpack_require__(185);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(285),
    baseKeysIn = __webpack_require__(635),
    isArrayLike = __webpack_require__(28);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(290);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(655),
    overRest = __webpack_require__(276),
    setToString = __webpack_require__(173);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(111);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(665),
    flatRest = __webpack_require__(191);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('flow', __webpack_require__(685));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);




var hasDocument = (typeof document === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(document)) === 'object' && document !== null;
var hasWindow = (typeof window === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(window)) === 'object' && window !== null && window.self === window;

// eslint-disable-next-line no-confusing-arrow
var isBrowser = function isBrowser() {
  return !__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(isBrowser.override) ? isBrowser.override : hasDocument && hasWindow;
};

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(329);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icon_Icon__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Label_Label__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ButtonContent__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ButtonGroup__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ButtonOr__ = __webpack_require__(345);




















/**
 * A Button indicates a possible user action.
 * @see Form
 * @see Icon
 * @see Label
 */

var Button = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Button, _Component);

  function Button() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.computeElementType = function () {
      var _this$props = _this.props,
          attached = _this$props.attached,
          label = _this$props.label;


      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default()(attached) || !__WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default()(label)) return 'div';
    }, _this.computeTabIndex = function (ElementType) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;


      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default()(tabIndex)) return tabIndex;
      if (disabled) return -1;
      if (ElementType === 'div') return 0;
    }, _this.focus = function () {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.ref, 'focus');
    }, _this.handleClick = function (e) {
      var disabled = _this.props.disabled;


      if (disabled) {
        e.preventDefault();
        return;
      }

      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    }, _this.handleRef = function (c) {
      return _this.ref = c;
    }, _this.hasIconClass = function () {
      var _this$props3 = _this.props,
          labelPosition = _this$props3.labelPosition,
          children = _this$props3.children,
          content = _this$props3.content,
          icon = _this$props3.icon;


      if (icon === true) return true;
      return icon && (labelPosition || __WEBPACK_IMPORTED_MODULE_11__lib__["d" /* childrenUtils */].isNil(children) && __WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default()(content));
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          animated = _props.animated,
          attached = _props.attached,
          basic = _props.basic,
          children = _props.children,
          circular = _props.circular,
          className = _props.className,
          color = _props.color,
          compact = _props.compact,
          content = _props.content,
          disabled = _props.disabled,
          floated = _props.floated,
          fluid = _props.fluid,
          icon = _props.icon,
          inverted = _props.inverted,
          label = _props.label,
          labelPosition = _props.labelPosition,
          loading = _props.loading,
          negative = _props.negative,
          positive = _props.positive,
          primary = _props.primary,
          secondary = _props.secondary,
          size = _props.size,
          toggle = _props.toggle;


      var baseClasses = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(color, size, Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(this.hasIconClass(), 'icon'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(primary, 'primary'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(secondary, 'secondary'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(toggle, 'toggle'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["C" /* useKeyOrValueAndKey */])(animated, 'animated'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["C" /* useKeyOrValueAndKey */])(attached, 'attached'));
      var labeledClasses = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_11__lib__["C" /* useKeyOrValueAndKey */])(labelPosition || !!label, 'labeled'));
      var wrapperClasses = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["F" /* useValueAndKey */])(floated, 'floated'));

      var rest = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["r" /* getUnhandledProps */])(Button, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["q" /* getElementType */])(Button, this.props, this.computeElementType);
      var tabIndex = this.computeTabIndex(ElementType);

      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default()(label)) {
        var buttonClasses = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ui', baseClasses, 'button', className);
        var containerClasses = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ui', labeledClasses, 'button', className, wrapperClasses);
        var labelElement = __WEBPACK_IMPORTED_MODULE_13__Label_Label__["a" /* default */].create(label, { defaultProps: {
            basic: true,
            pointing: labelPosition === 'left' ? 'right' : 'left'
          } });

        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: containerClasses, onClick: this.handleClick }),
          labelPosition === 'left' && labelElement,
          __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
            'button',
            { className: buttonClasses, disabled: disabled, ref: this.handleRef, tabIndex: tabIndex },
            __WEBPACK_IMPORTED_MODULE_12__Icon_Icon__["a" /* default */].create(icon),
            ' ',
            content
          ),
          (labelPosition === 'right' || !labelPosition) && labelElement
        );
      }

      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ui', baseClasses, wrapperClasses, labeledClasses, 'button', className);
      var hasChildren = !__WEBPACK_IMPORTED_MODULE_11__lib__["d" /* childrenUtils */].isNil(children);

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          disabled: disabled && ElementType === 'button' || undefined,
          onClick: this.handleClick,
          ref: this.handleRef,
          role: 'button',
          tabIndex: tabIndex
        }),
        hasChildren && children,
        !hasChildren && __WEBPACK_IMPORTED_MODULE_12__Icon_Icon__["a" /* default */].create(icon),
        !hasChildren && content
      );
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Button.defaultProps = {
  as: 'button'
};
Button._meta = {
  name: 'Button',
  type: __WEBPACK_IMPORTED_MODULE_11__lib__["b" /* META */].TYPES.ELEMENT
};
Button.Content = __WEBPACK_IMPORTED_MODULE_14__ButtonContent__["a" /* default */];
Button.Group = __WEBPACK_IMPORTED_MODULE_15__ButtonGroup__["a" /* default */];
Button.Or = __WEBPACK_IMPORTED_MODULE_16__ButtonOr__["a" /* default */];
Button.handledProps = ['active', 'animated', 'as', 'attached', 'basic', 'children', 'circular', 'className', 'color', 'compact', 'content', 'disabled', 'floated', 'fluid', 'icon', 'inverted', 'label', 'labelPosition', 'loading', 'negative', 'onClick', 'positive', 'primary', 'secondary', 'size', 'tabIndex', 'toggle'];
Button.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A button can show it is currently the active user selection. */
  active: PropTypes.bool,

  /** A button can animate to show hidden content. */
  animated: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['fade', 'vertical'])]),

  /** A button can be attached to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'bottom'])]),

  /** A basic button is less pronounced. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: customPropTypes.every([PropTypes.node, customPropTypes.disallow(['label']), customPropTypes.givenProps({
    icon: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired, PropTypes.element.isRequired])
  }, customPropTypes.disallow(['icon']))]),

  /** A button can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A button can have different colors */
  color: PropTypes.oneOf([].concat(_toConsumableArray(SUI.COLORS), ['facebook', 'google plus', 'instagram', 'linkedin', 'twitter', 'vk', 'youtube'])),

  /** A button can reduce its padding to fit into tighter spaces. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A button can show it is currently unable to be interacted with. */
  disabled: PropTypes.bool,

  /** A button can be aligned to the left or right of its container. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A button can take the width of its container. */
  fluid: PropTypes.bool,

  /** Add an Icon by name, props object, or pass an <Icon />. */
  icon: customPropTypes.some([PropTypes.bool, PropTypes.string, PropTypes.object, PropTypes.element]),

  /** A button can be formatted to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Add a Label by text, props object, or pass a <Label />. */
  label: customPropTypes.some([PropTypes.string, PropTypes.object, PropTypes.element]),

  /** A labeled button can format a Label or Icon to appear on the left or right. */
  labelPosition: PropTypes.oneOf(['right', 'left']),

  /** A button can show a loading indicator. */
  loading: PropTypes.bool,

  /** A button can hint towards a negative consequence. */
  negative: PropTypes.bool,

  /**
   * Called after user's click.
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A button can hint towards a positive consequence. */
  positive: PropTypes.bool,

  /** A button can be formatted to show different levels of emphasis. */
  primary: PropTypes.bool,

  /** A button can be formatted to show different levels of emphasis. */
  secondary: PropTypes.bool,

  /** A button can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** A button can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A button can be formatted to toggle on and off. */
  toggle: PropTypes.bool
} : {};


Button.create = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["m" /* createShorthandFactory */])(Button, function (value) {
  return { content: value };
});

/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icon_Icon__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Image_Image__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__LabelDetail__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__LabelGroup__ = __webpack_require__(342);


















/**
 * A label displays content classification.
 */

var Label = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Label, _Component);

  function Label() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Label);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Label.__proto__ || Object.getPrototypeOf(Label)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var onClick = _this.props.onClick;


      if (onClick) onClick(e, _this.props);
    }, _this.handleIconOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(predefinedProps, 'onClick', e);
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onRemove', e, _this.props);
        }
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Label, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          attached = _props.attached,
          basic = _props.basic,
          children = _props.children,
          circular = _props.circular,
          className = _props.className,
          color = _props.color,
          content = _props.content,
          corner = _props.corner,
          detail = _props.detail,
          empty = _props.empty,
          floating = _props.floating,
          horizontal = _props.horizontal,
          icon = _props.icon,
          image = _props.image,
          onRemove = _props.onRemove,
          pointing = _props.pointing,
          removeIcon = _props.removeIcon,
          ribbon = _props.ribbon,
          size = _props.size,
          tag = _props.tag;


      var pointingClass = pointing === true && 'pointing' || (pointing === 'left' || pointing === 'right') && pointing + ' pointing' || (pointing === 'above' || pointing === 'below') && 'pointing ' + pointing;

      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ui', color, pointingClass, size, Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(empty, 'empty'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(floating, 'floating'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(image === true, 'image'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(tag, 'tag'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["C" /* useKeyOrValueAndKey */])(corner, 'corner'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["C" /* useKeyOrValueAndKey */])(ribbon, 'ribbon'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["F" /* useValueAndKey */])(attached, 'attached'), 'label', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(Label, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(Label, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, onClick: this.handleClick }),
          children
        );
      }

      var removeIconShorthand = __WEBPACK_IMPORTED_MODULE_5_lodash_isUndefined___default()(removeIcon) ? 'delete' : removeIcon;

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: classes, onClick: this.handleClick }, rest),
        __WEBPACK_IMPORTED_MODULE_11__Icon_Icon__["a" /* default */].create(icon),
        typeof image !== 'boolean' && __WEBPACK_IMPORTED_MODULE_12__Image_Image__["a" /* default */].create(image),
        content,
        Object(__WEBPACK_IMPORTED_MODULE_10__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_13__LabelDetail__["a" /* default */], function (val) {
          return { content: val };
        }, detail),
        onRemove && __WEBPACK_IMPORTED_MODULE_11__Icon_Icon__["a" /* default */].create(removeIconShorthand, { overrideProps: this.handleIconOverrides })
      );
    }
  }]);

  return Label;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

Label._meta = {
  name: 'Label',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.ELEMENT
};
Label.Detail = __WEBPACK_IMPORTED_MODULE_13__LabelDetail__["a" /* default */];
Label.Group = __WEBPACK_IMPORTED_MODULE_14__LabelGroup__["a" /* default */];
Label.handledProps = ['active', 'as', 'attached', 'basic', 'children', 'circular', 'className', 'color', 'content', 'corner', 'detail', 'empty', 'floating', 'horizontal', 'icon', 'image', 'onClick', 'onRemove', 'pointing', 'removeIcon', 'ribbon', 'size', 'tag'];
/* harmony default export */ __webpack_exports__["a"] = (Label);
Label.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A label can be active. */
  active: PropTypes.bool,

  /** A label can attach to a content segment. */
  attached: PropTypes.oneOf(['top', 'bottom', 'top right', 'top left', 'bottom left', 'bottom right']),

  /** A label can reduce its complexity. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** A label can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the label. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A label can position itself in the corner of an element. */
  corner: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),

  /** Shorthand for LabelDetail. */
  detail: customPropTypes.itemShorthand,

  /** Formats the label as a dot. */
  empty: customPropTypes.every([PropTypes.bool, customPropTypes.demand(['circular'])]),

  /** Float above another element in the upper right corner. */
  floating: PropTypes.bool,

  /** A horizontal label is formatted to label content along-side it horizontally. */
  horizontal: PropTypes.bool,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** A label can be formatted to emphasize an image or prop can be used as shorthand for Image. */
  image: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Adds an "x" icon, called when "x" is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onRemove: PropTypes.func,

  /** A label can point to content next to it. */
  pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['above', 'below', 'left', 'right'])]),

  /** Shorthand for Icon to appear as the last child and trigger onRemove. */
  removeIcon: customPropTypes.itemShorthand,

  /** A label can appear as a ribbon attaching itself to an element. */
  ribbon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A label can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** A label can appear as a tag. */
  tag: PropTypes.bool
} : {};


Label.create = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["m" /* createShorthandFactory */])(Label, function (value) {
  return { content: value };
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ref__ = __webpack_require__(730);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Ref__["a"]; });



/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startCase__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_startCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_startCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_Icon__ = __webpack_require__(21);















/**
 * A menu can contain an item.
 */

var MenuItem = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItem, _Component);

  function MenuItem() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var disabled = _this.props.disabled;


      if (!disabled) __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          color = _props.color,
          content = _props.content,
          disabled = _props.disabled,
          fitted = _props.fitted,
          header = _props.header,
          icon = _props.icon,
          link = _props.link,
          name = _props.name,
          onClick = _props.onClick,
          position = _props.position;


      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(color, position, Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(icon === true || icon && !(name || content), 'icon'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(header, 'header'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["C" /* useKeyOrValueAndKey */])(fitted, 'fitted'), 'item', className);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(MenuItem, this.props, function () {
        if (onClick) return 'a';
      });
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(MenuItem, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, onClick: this.handleClick }),
          children
        );
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, onClick: this.handleClick }),
        __WEBPACK_IMPORTED_MODULE_11__elements_Icon__["a" /* default */].create(icon),
        __WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(content) ? __WEBPACK_IMPORTED_MODULE_5_lodash_startCase___default()(name) : content
      );
    }
  }]);

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

MenuItem._meta = {
  name: 'MenuItem',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Menu'
};
MenuItem.handledProps = ['active', 'as', 'children', 'className', 'color', 'content', 'disabled', 'fitted', 'header', 'icon', 'index', 'link', 'name', 'onClick', 'position'];
/* harmony default export */ __webpack_exports__["a"] = (MenuItem);
MenuItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A menu item can be active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Additional colors can be specified. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A menu item can be disabled. */
  disabled: PropTypes.bool,

  /** A menu item or menu can remove element padding, vertically or horizontally. */
  fitted: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontally', 'vertically'])]),

  /** A menu item may include a header or may itself be a header. */
  header: PropTypes.bool,

  /** MenuItem can be only icon. */
  icon: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** MenuItem index inside Menu. */
  index: PropTypes.number,

  /** A menu item can be link. */
  link: PropTypes.bool,

  /** Internal name of the MenuItem. */
  name: PropTypes.string,

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A menu item can take left or right position. */
  position: PropTypes.oneOf(['left', 'right'])
} : {};


MenuItem.create = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["m" /* createShorthandFactory */])(MenuItem, function (val) {
  return { content: val, name: val };
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(763);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Radio__["a"]; });



/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dropdown__["a"]; });



/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(796);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });



/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A column sub-component for Grid.
 */
function GridColumn(props) {
  var children = props.children,
      className = props.className,
      computer = props.computer,
      color = props.color,
      floated = props.floated,
      largeScreen = props.largeScreen,
      mobile = props.mobile,
      only = props.only,
      stretched = props.stretched,
      tablet = props.tablet,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      widescreen = props.widescreen,
      width = props.width;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(color, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(stretched, 'stretched'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["D" /* useMultipleProp */])(only, 'only'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["E" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["F" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["G" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["H" /* useWidthProp */])(computer, 'wide computer'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["H" /* useWidthProp */])(largeScreen, 'wide large screen'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["H" /* useWidthProp */])(mobile, 'wide mobile'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["H" /* useWidthProp */])(tablet, 'wide tablet'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["H" /* useWidthProp */])(widescreen, 'wide widescreen'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["H" /* useWidthProp */])(width, 'wide'), 'column', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(GridColumn, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(GridColumn, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
}

GridColumn.handledProps = ['as', 'children', 'className', 'color', 'computer', 'floated', 'largeScreen', 'mobile', 'only', 'stretched', 'tablet', 'textAlign', 'verticalAlign', 'widescreen', 'width'];
GridColumn._meta = {
  name: 'GridColumn',
  parent: 'Grid',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.COLLECTION
};

GridColumn.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A grid column can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A column can specify a width for a computer. */
  computer: PropTypes.oneOf(SUI.WIDTHS),

  /** A column can sit flush against the left or right edge of a row. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A column can specify a width for a large screen device. */
  largeScreen: PropTypes.oneOf(SUI.WIDTHS),

  /** A column can specify a width for a mobile device. */
  mobile: PropTypes.oneOf(SUI.WIDTHS),

  /** A column can appear only for a specific device, or screen sizes. */
  only: customPropTypes.multipleProp(SUI.VISIBILITY),

  /** A column can stretch its contents to take up the entire grid or row height. */
  stretched: PropTypes.bool,

  /** A column can specify a width for a tablet device. */
  tablet: PropTypes.oneOf(SUI.WIDTHS),

  /** A column can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A column can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A column can specify a width for a wide screen device. */
  widescreen: PropTypes.oneOf(SUI.WIDTHS),

  /** Represents width of column. */
  width: PropTypes.oneOf(SUI.WIDTHS)
} : {};

GridColumn.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(GridColumn, function (children) {
  return { children: children };
});

/* harmony default export */ __webpack_exports__["a"] = (GridColumn);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A message list can contain an item.
 */
function MessageItem(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(MessageItem, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(MessageItem, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

MessageItem.handledProps = ['as', 'children', 'className', 'content'];
MessageItem._meta = {
  name: 'MessageItem',
  parent: 'Message',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.COLLECTION
};

MessageItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

MessageItem.defaultProps = {
  as: 'li'
};

MessageItem.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(MessageItem, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (MessageItem);

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A table can have a header.
 */
function TableHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fullWidth = props.fullWidth;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(fullWidth, 'full-width'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(TableHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(TableHeader, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

TableHeader.handledProps = ['as', 'children', 'className', 'content', 'fullWidth'];
TableHeader._meta = {
  name: 'TableHeader',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Table'
};

TableHeader.defaultProps = {
  as: 'thead'
};

TableHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A definition table can have a full width header or footer, filling in the gap left by the first column. */
  fullWidth: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (TableHeader);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListDescription__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListHeader__ = __webpack_require__(143);









/**
 * A list item can contain a content.
 */
function ListContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      floated = props.floated,
      header = props.header,
      verticalAlign = props.verticalAlign;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["F" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["G" /* useVerticalAlignProp */])(verticalAlign), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ListContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ListContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_6__ListHeader__["a" /* default */].create(header),
    __WEBPACK_IMPORTED_MODULE_5__ListDescription__["a" /* default */].create(description),
    content
  );
}

ListContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'floated', 'header', 'verticalAlign'];
ListContent._meta = {
  name: 'ListContent',
  parent: 'List',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

ListContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ListDescription. */
  description: customPropTypes.itemShorthand,

  /** An list content can be floated left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Shorthand for ListHeader. */
  header: customPropTypes.itemShorthand,

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};

ListContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ListContent, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ListContent);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_Icon__ = __webpack_require__(137);








/**
 * A list item can contain an icon.
 */
function ListIcon(props) {
  var className = props.className,
      verticalAlign = props.verticalAlign;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["G" /* useVerticalAlignProp */])(verticalAlign), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ListIcon, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon_Icon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }));
}

ListIcon.handledProps = ['className', 'verticalAlign'];
ListIcon._meta = {
  name: 'ListIcon',
  parent: 'List',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

ListIcon.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};

ListIcon.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ListIcon, function (name) {
  return { name: name };
});

/* harmony default export */ __webpack_exports__["a"] = (ListIcon);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







function StepDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('description', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(StepDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(StepDescription, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

StepDescription.handledProps = ['as', 'children', 'className', 'content'];
StepDescription._meta = {
  name: 'StepDescription',
  parent: 'Step',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

StepDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

StepDescription.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(StepDescription, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (StepDescription);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A step can contain a title.
 */
function StepTitle(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('title', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(StepTitle, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(StepTitle, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

StepTitle.handledProps = ['as', 'children', 'className', 'content'];
StepTitle._meta = {
  name: 'StepTitle',
  parent: 'Step',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

StepTitle.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

StepTitle.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(StepTitle, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (StepTitle);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A content sub-component for Accordion component.
 */
function AccordionContent(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(active, 'active'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(AccordionContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(AccordionContent, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

AccordionContent.handledProps = ['active', 'as', 'children', 'className', 'content'];
AccordionContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Whether or not the content is visible. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

AccordionContent._meta = {
  name: 'AccordionContent',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Accordion'
};

AccordionContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(AccordionContent, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (AccordionContent);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_Icon__ = __webpack_require__(21);















/**
 * A title sub-component for Accordion component.
 */

var AccordionTitle = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AccordionTitle, _Component);

  function AccordionTitle() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AccordionTitle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AccordionTitle.__proto__ || Object.getPrototypeOf(AccordionTitle)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AccordionTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          content = _props.content;


      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(active, 'active'), 'title', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(AccordionTitle, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(AccordionTitle, this.props);

      if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(content)) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, onClick: this.handleClick }),
          children
        );
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, onClick: this.handleClick }),
        __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_Icon__["a" /* default */], { name: 'dropdown' }),
        content
      );
    }
  }]);

  return AccordionTitle;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

AccordionTitle._meta = {
  name: 'AccordionTitle',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Accordion'
};
AccordionTitle.handledProps = ['active', 'as', 'children', 'className', 'content', 'index', 'onClick'];
/* harmony default export */ __webpack_exports__["a"] = (AccordionTitle);
AccordionTitle.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Whether or not the title is in the open state. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** AccordionTitle index inside Accordion. */
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func
} : {};


AccordionTitle.create = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["m" /* createShorthandFactory */])(AccordionTitle, function (content) {
  return { content: content };
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);









/**
 * A card can contain a description with one or more paragraphs.
 */
function CardDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useTextAlignProp */])(textAlign), 'description', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(CardDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(CardDescription, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CardDescription.handledProps = ['as', 'children', 'className', 'content', 'textAlign'];
CardDescription._meta = {
  name: 'CardDescription',
  parent: 'Card',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.VIEW
};

CardDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card content can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CardDescription);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);









/**
 * A card can contain a header.
 */
function CardHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useTextAlignProp */])(textAlign), 'header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(CardHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(CardHeader, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CardHeader.handledProps = ['as', 'children', 'className', 'content', 'textAlign'];
CardHeader._meta = {
  name: 'CardHeader',
  parent: 'Card',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.VIEW
};

CardHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card header can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CardHeader);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);









/**
 * A card can contain content metadata.
 */
function CardMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useTextAlignProp */])(textAlign), 'meta', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(CardMeta, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(CardMeta, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CardMeta.handledProps = ['as', 'children', 'className', 'content', 'textAlign'];
CardMeta._meta = {
  name: 'CardMeta',
  parent: 'Card',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.VIEW
};

CardMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card meta can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CardMeta);

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedDate__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedExtra__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeedMeta__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeedSummary__ = __webpack_require__(220);











function FeedContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      extraImages = props.extraImages,
      extraText = props.extraText,
      date = props.date,
      meta = props.meta,
      summary = props.summary;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(FeedContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(FeedContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedDate__["a" /* default */], function (val) {
      return { content: val };
    }, date),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_8__FeedSummary__["a" /* default */], function (val) {
      return { content: val };
    }, summary),
    content,
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedExtra__["a" /* default */], function (val) {
      return { text: true, content: val };
    }, extraText),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedExtra__["a" /* default */], function (val) {
      return { images: val };
    }, extraImages),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_7__FeedMeta__["a" /* default */], function (val) {
      return { content: val };
    }, meta)
  );
}

FeedContent.handledProps = ['as', 'children', 'className', 'content', 'date', 'extraImages', 'extraText', 'meta', 'summary'];
FeedContent._meta = {
  name: 'FeedContent',
  parent: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

FeedContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain a date. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with images. */
  extraImages: FeedExtra.propTypes.images,

  /** Shorthand for FeedExtra with text. */
  extraText: customPropTypes.itemShorthand,

  /** Shorthand for FeedMeta. */
  meta: customPropTypes.itemShorthand,

  /** Shorthand for FeedSummary. */
  summary: customPropTypes.itemShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FeedContent);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);









/**
 * A feed can contain an extra content.
 */
function FeedExtra(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      images = props.images,
      text = props.text;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(images, 'images'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(content || text, 'text'), 'extra', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(FeedExtra, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(FeedExtra, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  // TODO need a "collection factory" to handle creating multiple image elements and their keys
  var imageElements = __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(images, function (image, index) {
    var key = [index, image].join('-');
    return Object(__WEBPACK_IMPORTED_MODULE_5__lib__["g" /* createHTMLImage */])(image, { key: key });
  });

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content,
    imageElements
  );
}

FeedExtra.handledProps = ['as', 'children', 'className', 'content', 'images', 'text'];
FeedExtra._meta = {
  name: 'FeedExtra',
  parent: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.VIEW
};

FeedExtra.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain additional information like a set of images. */
  images: customPropTypes.every([customPropTypes.disallow(['text']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.collectionShorthand])]),

  /** An event can contain additional text information. */
  text: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FeedExtra);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedLike__ = __webpack_require__(219);








/**
 * A feed can contain a meta.
 */
function FeedMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      like = props.like;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('meta', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(FeedMeta, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(FeedMeta, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedLike__["a" /* default */], function (val) {
      return { content: val };
    }, like),
    content
  );
}

FeedMeta.handledProps = ['as', 'children', 'className', 'content', 'like'];
FeedMeta._meta = {
  name: 'FeedMeta',
  parent: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

FeedMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for FeedLike. */
  like: customPropTypes.itemShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FeedMeta);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(21);








/**
 * A feed can contain a like element.
 */
function FeedLike(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('like', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(FeedLike, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(FeedLike, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon),
    content
  );
}

FeedLike.handledProps = ['as', 'children', 'className', 'content', 'icon'];
FeedLike._meta = {
  name: 'FeedLike',
  parent: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

FeedLike.defaultProps = {
  as: 'a'
};

FeedLike.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for icon. Mutually exclusive with children. */
  icon: customPropTypes.itemShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FeedLike);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedDate__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedUser__ = __webpack_require__(221);









/**
 * A feed can contain a summary.
 */
function FeedSummary(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      date = props.date,
      user = props.user;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('summary', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(FeedSummary, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(FeedSummary, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedUser__["a" /* default */], function (val) {
      return { content: val };
    }, user),
    content,
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedDate__["a" /* default */], function (val) {
      return { content: val };
    }, date)
  );
}

FeedSummary.handledProps = ['as', 'children', 'className', 'content', 'date', 'user'];
FeedSummary._meta = {
  name: 'FeedSummary',
  parent: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

FeedSummary.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for FeedDate. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedUser. */
  user: customPropTypes.itemShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FeedSummary);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A feed can contain a user element.
 */
function FeedUser(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('user', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(FeedUser, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(FeedUser, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

FeedUser.handledProps = ['as', 'children', 'className', 'content'];
FeedUser._meta = {
  name: 'FeedUser',
  parent: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

FeedUser.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

FeedUser.defaultProps = {
  as: 'a'
};

/* harmony default export */ __webpack_exports__["a"] = (FeedUser);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(21);








/**
 * An event can contain an image or icon label.
 */
function FeedLabel(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon,
      image = props.image;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('label', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(FeedLabel, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(FeedLabel, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content,
    __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["g" /* createHTMLImage */])(image)
  );
}

FeedLabel.handledProps = ['as', 'children', 'className', 'content', 'icon', 'image'];
FeedLabel._meta = {
  name: 'FeedLabel',
  parent: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

FeedLabel.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain icon label. */
  icon: customPropTypes.itemShorthand,

  /** An event can contain image label. */
  image: customPropTypes.itemShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FeedLabel);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * An item can contain a header.
 */
function ItemHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ItemHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ItemHeader, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ItemHeader.handledProps = ['as', 'children', 'className', 'content'];
ItemHeader._meta = {
  name: 'ItemHeader',
  parent: 'Item',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

ItemHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

ItemHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ItemHeader, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ItemHeader);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * An item can contain a description with a single or multiple paragraphs.
 */
function ItemDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('description', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ItemDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ItemDescription, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ItemDescription.handledProps = ['as', 'children', 'className', 'content'];
ItemDescription._meta = {
  name: 'ItemDescription',
  parent: 'Item',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

ItemDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

ItemDescription.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ItemDescription, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ItemDescription);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * An item can contain extra content meant to be formatted separately from the main content.
 */
function ItemExtra(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('extra', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ItemExtra, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ItemExtra, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ItemExtra.handledProps = ['as', 'children', 'className', 'content'];
ItemExtra._meta = {
  name: 'ItemExtra',
  parent: 'Item',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

ItemExtra.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

ItemExtra.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ItemExtra, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ItemExtra);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * An item can contain content metadata.
 */
function ItemMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('meta', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ItemMeta, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ItemMeta, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ItemMeta.handledProps = ['as', 'children', 'className', 'content'];
ItemMeta._meta = {
  name: 'ItemMeta',
  parent: 'Item',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

ItemMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

ItemMeta.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ItemMeta, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ItemMeta);

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(31);
var normalizeHeaderName = __webpack_require__(854);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(433);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(433);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(228)))

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SearchPageHelpers_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SimpleWordBuilder_js__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Recorder_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SimpleWordBuilderUpdated_js__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_DialectDictionary_js__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_ga4__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_13_react_ga4___default.a.initialize("G-WDEJDCK7QT");var customFontFam="Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif";var YupikEntry=function(_Component){_inherits(YupikEntry,_Component);function YupikEntry(props){_classCallCheck(this,YupikEntry);var _this=_possibleConstructorReturn(this,(YupikEntry.__proto__||Object.getPrototypeOf(YupikEntry)).call(this,props));_this.retrieveDialect=function(dialect){console.log(dialect);if(dialect in __WEBPACK_IMPORTED_MODULE_12__constants_DialectDictionary_js__["a" /* DialectDictionary */]){return __WEBPACK_IMPORTED_MODULE_12__constants_DialectDictionary_js__["a" /* DialectDictionary */][dialect];}};_this.retrieveDialects=function(dialects){console.log(dialects);var dialectList=[];dialects.map(function(dialect){if(dialect in __WEBPACK_IMPORTED_MODULE_12__constants_DialectDictionary_js__["a" /* DialectDictionary */]){dialectList.push(__WEBPACK_IMPORTED_MODULE_12__constants_DialectDictionary_js__["a" /* DialectDictionary */][dialect]);}});return dialectList.join(', ');};_this.processStyledText=function(sentence){sentence=sentence.replace("⟨","").replace("⟩","");var matches=sentence.match(/⎡.*?⎤/g);if(matches!==null){matches.map(function(m){return sentence=sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>');});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:sentence}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence);}};_this.processPostbaseExampleRow=function(sentence){sentence=sentence.replaceAll(/{(.*?)}⟨.*?⟩/g,"$1");var matches=sentence.match(/`.*(`|')/g);var matches2=sentence.match(/\(.*?\)/g);console.log(matches2);if(matches!==null){matches.map(function(m){return sentence='<b>'+sentence.replace(m,'<span style="font-weight:normal">'+m.slice(1,-1)+'</span>');})+'</b>';}if(matches2!==null){matches2.map(function(m){return sentence=sentence.replace(m,'<span style="font-weight:normal"><i>'+m+'</i></span>');});}if(matches!==null||matches2!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:sentence}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence);}};_this.recordClip=function(sentenceid,sentence,siteLocation,english){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["w" /* Modal */],{on:'click',open:_this.state.showModal==sentenceid,style:{maxWidth:500,marginTop:window.innerWidth<480?10:10},closeOnDimmerClick:false,onOpen:function onOpen(){},onClose:function onClose(){_this.setState({showModal:-1});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["x" /* ModalContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,style:{margin:0,color:'#929292',cursor:'pointer',position:'relative',float:'right'},size:'large',onClick:function onClick(){_this.setState({showModal:-1});},name:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Recorder_js__["a" /* default */],{english:english,sentence:sentence,siteLocation:siteLocation})));};_this.displayAudioMic=function(audioRetrieved,sentenceid){// console.log(audioRetrieved)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["y" /* Popup */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{style:{fontFamily:customFontFam},divided:true,verticalAlign:'middle'},audioRetrieved.map(function(k,kindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["s" /* ListItem */],{style:{display:'flex',flexDirection:'row',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{float:'left',border:_this.state.playingAudio&&_this.state.clickedAudioIndex===kindex?'solid 1px #4a80b5':'solid 1px #dededf',marginLeft:5,backgroundColor:'white',color:k['village']=='computer generated'?'#929292':'#106181',cursor:'pointer'},circular:true,icon:'volume up',onClick:function onClick(){return _this.repeatAudio(k['filename'],kindex);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',marginLeft:10,padding:'5px 0px'}},k['gender']!='do_not_wish_to_say'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,k['gender'].replaceAll('_',' / ')):null,k['age']!='do_not_wish_to_say'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,k['age']):null,k['village']!='do_not_wish_to_say'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,k['village']):null,(k['gender']=='do_not_wish_to_say'||k['gender']=='')&&(k['age']=='do_not_wish_to_say'||k['age']=='')&&(k['village']=='do_not_wish_to_say'||k['village']=='')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Anonymous'):null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["s" /* ListItem */],{style:{display:'flex',flexDirection:'row',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{circular:true,basic:true,style:{opacity:0.9,marginLeft:5,fontSize:'14px'},onClick:function onClick(){_this.setState({openPopup:-1},function(){_this.setState({showModal:sentenceid});});},icon:'microphone'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:10,padding:'5px 0px'}},'Submit a Recording for Yugtun.com'))),on:'click',open:_this.state.openPopup==sentenceid,onClose:function onClose(){return _this.setState({openPopup:-1});},style:{padding:8},position:'bottom center',trigger:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({openPopup:sentenceid});},style:{paddingRight:15,marginLeft:10,marginTop:1},circular:true,basic:true,icon:true},audioRetrieved.length==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:'#929292'},name:'microphone'}):audioRetrieved.length==1&&audioRetrieved[0]['village']=='computer generated'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:'#929292',fontSize:'16px'},name:'volume up'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:'#106181',fontSize:'16px'},name:'volume up'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:'#d2d2d2',paddingLeft:'6px',fontSize:'11px'},name:'chevron down'}),' ')});};_this.displayIfClipExists=function(sentence){// console.log(sentence)
// axios
//   .get(API_URL + "/yugtunCrowdsourceAudioLookup/" + sentence)
//   .then(response => {
//     // console.log(response.data);
//     this.setState({audioRetrieved:response.data})
//   });
};_this.processPostbaseTableRowHTML=function(sentence){var matchesNormal=sentence.match(/‘.*?’(?!\w)/g);var matchesItalics=sentence.match(/\s\(.*?\)/g);if(matchesNormal!==null||matchesItalics!==null){if(matchesNormal!==null){matchesNormal.map(function(m){return sentence='<b style="color:black">'+sentence.replaceAll(m,'<span style="font-weight:normal;color:#000000b3">'+m+'</span>')+'</b>';});}if(matchesItalics!==null){matchesItalics.map(function(m){return sentence=sentence.replaceAll(m,'<span style="font-weight:normal"><i>'+m+'</i></span>');});}return sentence;}else{return sentence;}};_this.processPostbaseTableRow=function(sentence){var matchesBnL=sentence.match(/\{(.*?)\}⟨(.*?)⟩/g);var splitSentence=[];var sentenceBank=[];var restOfSentence=sentence;if(matchesBnL!==null){var before='';var after='';matchesBnL.map(function(m){before=restOfSentence.slice(0,restOfSentence.indexOf(m));after=restOfSentence.slice(restOfSentence.indexOf(m)+m.length+1);sentenceBank.push(before);restOfSentence=after;});sentenceBank.push(after);splitSentence=sentence.split(matchesBnL[0]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:_this.processPostbaseTableRowHTML(sentenceBank[0])}}),matchesBnL.map(function(k,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],{style:{color:'#306190'},to:{pathname:k.match(/⟨.*?⟩/g)[0].slice(1,-1)},onClick:function onClick(){_this.setState({key:k.match(/⟨.*?⟩/g)[0].slice(1,-1),from:_this.props.location.pathname});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,k.match(/\{.*?\}/g)[0].slice(1,-1))),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:_this.processPostbaseTableRowHTML(sentenceBank[index+1])}}));}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:_this.processPostbaseTableRowHTML(sentence)}});}};_this.processAdditionalInformationRow=function(sentence){var matchesBnL=sentence.match(/⎡(.*?)⎤⟨(.*?)⟩/g);var splitSentence=[];var sentenceBank=[];var restOfSentence=sentence;if(matchesBnL!==null){var before='';var after='';matchesBnL.map(function(m){before=restOfSentence.slice(0,restOfSentence.indexOf(m));after=restOfSentence.slice(restOfSentence.indexOf(m)+m.length+1);sentenceBank.push(before);restOfSentence=after;});sentenceBank.push(after);splitSentence=sentence.split(matchesBnL[0]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:_this.processPostbaseTableRowHTML(sentenceBank[0])}}),matchesBnL.map(function(k,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],{style:{color:'#306190'},to:{pathname:k.match(/⟨.*?⟩/g)[0].slice(1,-1)},onClick:function onClick(){_this.setState({key:k.match(/⟨.*?⟩/g)[0].slice(1,-1),from:_this.props.location.pathname});}},k.match(/⎡.*?⎤/g)[0].slice(1,-1)),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:_this.processPostbaseTableRowHTML(sentenceBank[index+1])}}));}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:_this.processPostbaseTableRowHTML(sentence)}});}};_this.unlinked=function(word){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{key:word.keyString,style:{marginLeft:'15px',marginTop:'12px',marginBottom:'12px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Header,{style:{display:'flex',fontFamily:'Lato,Arial,Helvetica,sans-serif',fontSize:'18px',fontWeight:400,paddingBottom:'4px'}},word,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{'marginLeft':'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini'},'UNLINKED')))));};console.log("YupikEntry props: ",props);var queryString=window.location.search;var urlParams=new URLSearchParams(queryString);var record=urlParams.get('record');_this.state={entry:props.entry,word:props.word,audioRetrieved:[],showModal:-1,openPopup:-1,audioParameterBool:record!==null||true?true:false,playingAudio:false,clickedAudioUrl:"",clickedAudio:null,clickedAudioIndex:-1};return _this;}_createClass(YupikEntry,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.word!==this.props.word){this.setState({entry:this.props.entry,word:this.props.word});}}},{key:'fontUsage',value:function fontUsage(word){if(this.state.entry.descriptor[0]==='noun'){return['(root form)','','','',''];}var text1='';var sub='';var text2='';var obj='';var text3='';var res=word.replace(/\^/g,"");var rx1=/\[([^\]]+)]/;var rx2=/<([^\]]+)>/;var subject=word.match(rx1);var object=word.match(rx2);if(subject!==null){res=res.split(rx1);text1=res[0];sub=res[1];text2=res[2];res=res[2];}if(object!==null){res=res.split(rx2);text2=res[0];obj=res[1];text3=res[2];}return[text1,sub,text2,obj,text3];}},{key:'repeatAudio',// recordClip = (sentenceid, sentence, siteLocation) => {
//   console.log(sentence)
//       return <Modal
//           trigger={<Button circular basic style={{marginLeft:10}} onClick={()=>{this.setState({showModal:sentenceid})}} icon='microphone' />}
//           on='click'
//           open={this.state.showModal==sentenceid}
//           style={{
//             maxWidth:500,
//             marginTop:(window.innerWidth < 480 ? 10 : 10),
//           }}
//           closeOnDimmerClick={false}
//           onOpen={()=>{
//           }}
//           onClose={()=>{
//             this.setState({showModal:-1,wordsList:[],searchQuery:''})
//           }}
//         >
//         <ModalContent>
//           <Icon circular style={{margin:0,color:'#B1B1B1',cursor:'pointer',position:'relative',float:'right'}} size='large' onClick={()=>{this.setState({showModal:-1})}} name='x' />
//           <Recorder sentence={sentence} siteLocation={siteLocation} />          
//         </ModalContent>
//         </Modal>
// }
// repeatAudio(audio, event, data) {
//   // console.log(audio)
//   if (!this.state.playingAudio) {
//     let sound = new Audio(API_URL + "/yugtunCrowdsourceAudio/" + audio);
//     this.setState({playingAudio: true});
//     sound.play()
//     sound.onended=()=>{
//       this.setState({playingAudio: false});
//     }
//   }
// }
value:function repeatAudio(audio,index,event,data){var _this2=this;var audioURL=__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/yugtunCrowdsourceAudio/"+audio;console.log(audioURL);// stop audio on double click
if(this.state.playingAudio===true&&this.state.clickedAudioUrl===audioURL){var _audio=this.state.clickedAudio;_audio.pause();_audio.currentTime=0;this.setState({clickedAudio:_audio,clickedAudioIndex:-1,playingAudio:false});}// stop first audio then play new one
if(this.state.playingAudio===true&&this.state.clickedAudioUrl!==audioURL){var firstAudio=this.state.clickedAudio;firstAudio.pause();firstAudio.currentTime=0;this.setState({playingAudio:true});var secondAudio=new Audio(audioURL);secondAudio.play();this.setState({clickedAudioUrl:audioURL,clickedAudioIndex:index,clickedAudio:secondAudio});secondAudio.onended=function(){_this2.setState({playingAudio:false,clickedAudioIndex:-1});};}// play audio again
if(this.state.playingAudio===false&&this.state.clickedAudioUrl===audioURL){var _audio2=this.state.clickedAudio;this.setState({playingAudio:true,clickedAudioIndex:index});_audio2.play();_audio2.onended=function(){_this2.setState({playingAudio:false,clickedAudioIndex:-1});};}// play new audio
if(this.state.playingAudio===false&&this.state.clickedAudioUrl!==audioURL){this.setState({playingAudio:true});var _audio3=new Audio(audioURL);_audio3.play();this.setState({clickedAudioUrl:audioURL,clickedAudioIndex:index,clickedAudio:_audio3});_audio3.onended=function(){_this2.setState({playingAudio:false,clickedAudioIndex:-1});};}}// processPostbaseTableRowHTML = (sentence) => {     
// sentence = sentence.trim()
// let words = sentence.trim().split(' ')
// console.log(words)
// if (words.length > 2 && words[1] === 'or') {
//    return <div>
//       <span style={{fontWeight:'bold',paddingRight:'5px'}}>{words.slice(0,3)}</span>
//       <span>{words.slice(3,).join(' ')}</span>
//     </div>     
// } else {
//  return <div>
//     <span style={{fontWeight:'bold',paddingRight:'5px'}}>{words[0]}</span>
//     <span>{words.slice(1,).join(' ')}</span>
//   </div>
// }
//   let matches = sentence.match(/‘.*?’(?!\w)/g)
//   let matches2 = sentence.match(/\s\(.*?\)/g)
//   console.log(matches)
//   if (matches !== null) {
//     matches.map((m) => sentence = '<b style="color:black">'+sentence.replace(m,'<span style="font-weight:normal;color:#000000b3">'+m+'</span>'))+'</b>'
//   }
//   if (matches2 !== null) {
//     matches2.map((m) => sentence = sentence.replace(m,'<span style="font-weight:normal"><i>'+m+'</i></span>'))      
//   }
//   if (matches !== null || matches2 !== null) {
//     return <span dangerouslySetInnerHTML={{__html: sentence}} />          
//   } else {
//     return <span>{sentence}</span>
//   }
// }
},{key:'render',value:function render(){var _this3=this;console.log(this.state);var postbaseTableOn=false;var postbaseExampleOn=false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:0,margin:0,fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["D" /* Transition */],{visible:this.state.loaded,animation:'fade',duration:300},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */],{textAlign:'center'},this.state.entry!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Row,{style:{height:40,paddingBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Column,{style:{maxWidth:800,padding:0,margin:0},textAlign:'left'},this.state.from==='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],{to:{pathname:"/",state:{history:this.state.history}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,style:{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'chevron left'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){_this3.props.history.goBack();},circular:true,style:{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'chevron left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],{to:{pathname:"/"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,style:{margin:0,marginLeft:5,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'search'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'25px',marginTop:'20px',fontFamily:customFontFam}},this.state.entry.keySplit.map(function(key,keyid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'500',marginRight:'keySplitAudio'in _this3.state.entry?'0px':'10px'}},key[0]),'keySplitAudio'in _this3.state.entry?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:3}},_this3.state.audioParameterBool?_this3.displayAudioMic(_this3.state.entry.keySplitAudio[keyid],'a'+keyid.toString()):null,_this3.state.showModal!=-1?_this3.recordClip('a'+keyid.toString(),key[0],'entryKeySplit',_this3.state.entry.definitionString):null):null,key[1][0]!==''?key[1].map(function(dialect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{size:'mini',style:{marginLeft:'5px'}},dialect);}):null,_this3.state.entry.pos.map(function(descriptor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SearchPageHelpers_js__["a" /* TagColors */],{key:descriptor,word:descriptor,padding:3}));}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Definition')),this.state.entry.definition.map(function(entry,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row',alignItems:'center',marginTop:'8px',marginBottom:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:'10px',color:'#000000',fontSize:'18px','fontWeight':'300'}},'○'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:'20px',marginRight:'15px',color:'#000000',fontSize:'18px',lineHeight:'27px'}},_this3.processStyledText(entry[0])),entry[1][0]!==''?entry[1].map(function(dialect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{style:{height:'20px',fontSize:'10px'},horizontal:true},dialect);}):null);})),this.state.entry.verbkeyString.keyString.length!==0&&this.state.entry.usage.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'10px'}},this.state.entry.usage.map(function(entry,i){if(entry[3].constructor===Array){return entry[3].map(function(k,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,index===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Usage')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SimpleWordBuilderUpdated_js__["a" /* default */],{usageStartingAudio:_this3.state.entry.usageStartingAudio[i],entry:entry,index:i,definitionIndex:index,word:_this3.state.word}),entry[3].length-1!=index&&k[2].length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],{style:{margin:0}}):null);});}})):this.state.entry.usage.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'10px'}},this.state.entry.usage.map(function(entry,i){if(entry[3].constructor===Array){return entry[3].map(function(k,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,index===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Usage')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SimpleWordBuilderUpdated_js__["a" /* default */],{usageStartingAudio:_this3.state.entry.usageStartingAudio[i],entry:entry,index:i,definitionIndex:index,word:_this3.state.word}),entry[3].length-1!=index&&k[2].length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],{style:{margin:0}}):null);});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,i===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Usage')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SimpleWordBuilderUpdated_js__["a" /* default */],{usageStartingAudio:_this3.state.entry.usageStartingAudio[i],entry:entry,index:i,word:_this3.state.word}),_this3.state.entry.usage.length-1!=i?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],{style:{margin:0}}):null);}})):null,this.state.entry.verbkeyString.keyString.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'25px',marginTop:'20px',fontFamily:customFontFam}},this.state.entry.verbkeyString.keySplit.map(function(key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'500',marginRight:'15px'}},key[0]),key[1][0]!==''?key[1].map(function(dialect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{horizontal:true},dialect);}):null,_this3.state.entry.verbkeyString.pos.map(function(descriptor){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SearchPageHelpers_js__["a" /* TagColors */],{key:descriptor,word:descriptor,padding:3});}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Definition')),this.state.entry.verbkeyString.definition.map(function(entry,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'8px',marginBottom:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'10px',color:'#777777',fontSize:'18px','fontWeight':'300'}},'○'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:'20px',color:'#000000',fontSize:'18px',lineHeight:'24px',marginRight:'15px'}},_this3.processStyledText(entry[0])),entry[1][0]!==''?entry[1].map(function(dialect){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{style:{fontSize:'10px'},horizontal:true},dialect);}):null);})),this.state.entry.usage.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Usage')),this.state.entry.usage.map(function(entry,i){if(entry[3].constructor!==Array){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SimpleWordBuilderUpdated_js__["a" /* default */],{usageStartingAudio:_this3.state.entry.usageStartingAudio[i],entry:entry,index:i,word:_this3.state.word}),_this3.state.entry.usage.length-1!=i?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],{style:{margin:0}}):null);}})):null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'10px'}},this.state.entry.entryDialect.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Dialect')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:15,fontSize:'16px',color:'#000000b3'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.retrieveDialects(this.state.entry.entryDialect)))):null,this.state.entry.additionalInfoNearDefinition.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Additional Information')),this.state.entry.additionalInfoNearDefinition.map(function(entry,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:15,fontSize:'16px',color:'#000000b3'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,entry));})):null,this.state.entry.baseExamples.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Example Sentences')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'5px',paddingBottom:'5px'}},this.state.entry.baseExamples.map(function(sentence,sentenceid){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{style:{paddingTop:'10px',paddingBottom:'10px',paddingLeft:'15px',paddingRight:'10px'},key:sentence[0]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Header,{style:{paddingBottom:'7px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["a" /* Link */],{to:{pathname:'/',state:Object.assign({},_this3.props.location.state,{updateSearchEntry:true,search:sentence[0],newSearchList:sentence[0].split(" "),activeTabIndex:1})}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:_defineProperty({fontSize:'18px',color:'black',fontWeight:'400',borderBottom:'1px solid #858585',paddingBottom:'2px'},'fontWeight','400')},sentence[0])),_this3.state.audioParameterBool?_this3.displayAudioMic(_this3.state.entry.baseExamplesAudio[sentenceid],'b'+sentenceid.toString()):null,_this3.state.showModal!=-1?_this3.recordClip('b'+sentenceid.toString(),sentence[0],'exampleSentence',sentence[1]):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Description,{style:{fontSize:'16px',fontWeight:'400',color:'#000000b3'}},sentence[1]));}))):null,this.state.entry.postbaseExamples.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Postbase Examples')),this.state.entry.postbaseExamples.map(function(entry,i){if(postbaseTableOn){if(entry==='</table>'){postbaseTableOn=false;}else{var items=[];if(entry.split("\"").length>1){entry=entry.replace("\",\"","@@").replace(",\"","@@").replace("\",","@@").replaceAll("\"","");items=entry.split('@@');}else{items=entry.split(',');}var rightside=items[1].split(';');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:15,color:'#000000cc',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1}},_this3.processPostbaseTableRow(items[0])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1}},rightside.map(function(k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this3.processPostbaseTableRow(k));})));}}else if(postbaseExampleOn){if(entry==='</example>'){postbaseExampleOn=false;}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',marginBottom:'5px',marginLeft:'15px',marginRight:'15px'}},_this3.processPostbaseExampleRow(entry));}}else{if(entry==='<table>'){postbaseTableOn=true;}else if(entry==='<example>'){postbaseExampleOn=true;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'20px',marginBottom:'20px',marginLeft:'15px',marginRight:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontStyle:'italic'}},'Example Sentences'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'20px',marginBottom:'20px',marginLeft:'15px',marginRight:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontStyle:'italic'}},_this3.processAdditionalInformationRow(entry)));}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'20px'}})):null,this.state.entry.additionalInfo.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Additional Information')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:5}},this.state.entry.additionalInfo.map(function(entry,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:10,fontSize:'16px',color:'#000000b3'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'- ',_this3.processAdditionalInformationRow(entry)));}))):null,Object.keys(this.state.entry.childrenEntries).length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Related Entries')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{style:{marginTop:'5px',marginBottom:'5px'}},Object.keys(this.state.entry.childrenEntries).map(function(word,index){return Object.keys(_this3.state.entry.childrenEntries[word]).length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SearchPageHelpers_js__["b" /* WordItemLikeInup */],{paddingLeft:15,key:word,word:_this3.state.entry.childrenEntries[word],repeatAudio:_this3.repeatAudio.bind(_this3)}):_this3.unlinked(word);}))):null,Object.keys(this.state.entry.synonyms).length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Synonyms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{style:{marginTop:'5px',marginBottom:'5px'}},Object.keys(this.state.entry.synonyms).map(function(word,index){return Object.keys(_this3.state.entry.synonyms[word]).length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SearchPageHelpers_js__["b" /* WordItemLikeInup */],{paddingLeft:15,key:word,word:_this3.state.entry.synonyms[word],repeatAudio:_this3.repeatAudio.bind(_this3)}):_this3.unlinked(word);}))):null,Object.keys(this.state.entry.questionablyrelated).length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Possibly Related')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{style:{marginTop:'5px',marginBottom:'5px'}},Object.keys(this.state.entry.questionablyrelated).map(function(word,index){return Object.keys(_this3.state.entry.questionablyrelated[word]).length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SearchPageHelpers_js__["b" /* WordItemLikeInup */],{paddingLeft:15,key:word,word:_this3.state.entry.questionablyrelated[word],repeatAudio:_this3.repeatAudio.bind(_this3)}):_this3.unlinked(word);}))):null,this.state.entry.fromLanguage.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Language Origin')),this.state.entry.fromLanguage.map(function(entry){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:15,fontSize:'16px',color:'#000000b3'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,entry));})):null,Object.keys(this.state.entry.etymology).length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Etymology')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{style:{marginTop:'5px',marginBottom:'5px'}},Object.keys(this.state.entry.etymology).map(function(key,index){return _this3.state.entry.etymology[key].map(function(word,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SearchPageHelpers_js__["b" /* WordItemLikeInup */],{paddingLeft:15*i+15,key:word,word:_this3.state.entry.etymology[key][i],repeatAudio:_this3.repeatAudio.bind(_this3)});});}))):null,this.state.entry.protolessthan.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Proto-Etymology')),this.state.entry.protolessthan.map(function(entry){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:15,fontSize:'16px',color:'#000000b3'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,entry));})):null,this.state.entry.extra.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Extra Information')),this.state.entry.extra.map(function(entry){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:15,fontSize:'16px',color:'#000000b3'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,entry));})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://goo.gl/forms/be5L5cgSQmCJeVDl1',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{marginBottom:'2px'},inverted:true,name:'exclamation circle',color:'grey',size:'large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'grey'}},'Report a mistake'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-evenly',alignItems:'center',height:60,paddingBottom:16,paddingTop:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}))))):null)));}}]);return YupikEntry;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* withRouter */])(YupikEntry));

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(883);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* unused harmony export applyMiddleware */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return combineReducers; });
/* unused harmony export compose */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(886);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_device_detect__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_ga4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_google_recaptcha__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__useRecorderEdited_js__ = __webpack_require__(904);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// import {YouTubeLinks} from './info/YouTubeLinks.js';
// import {summaries} from './info/summaries.js';
// import {categories} from './info/categories.js';
// import { FeaturedVideos } from './Helpers.js';
// import RecordingStorageHook from './RecordingStorageHook.js';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import 'react-lazy-load-image-component/src/effects/blur.css';
// import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import { ReactMediaRecorder } from "react-media-recorder";
// import Mirt from 'react-mirt';
// import 'react-mirt/dist/css/react-mirt.css';
// import vmsg from "vmsg";
// import { MultiRecorder, type AudioFormat } from "react-ts-audio-recorder";
// import vmsgWasm from "react-ts-audio-recorder/assets/vmsg.wasm?url";
// import Dropzone from 'react-dropzone'
var RecorderHook=function RecorderHook(props){// console.log('props',props)
var _useRecorder=Object(__WEBPACK_IMPORTED_MODULE_10__useRecorderEdited_js__["a" /* default */])(),startRecording=_useRecorder.startRecording,pauseRecording=_useRecorder.pauseRecording,stopRecording=_useRecorder.stopRecording,resetRecording=_useRecorder.resetRecording,resumeRecording=_useRecorder.resumeRecording,audioLevel=_useRecorder.audioLevel,timeElapsed=_useRecorder.timeElapsed,recordingState=_useRecorder.recordingState,audioURL=_useRecorder.audioURL,audioFile=_useRecorder.audioFile,isRecording=_useRecorder.isRecording;var sentence=props.sentence;var english=props.english;var siteLocation=props.siteLocation;var maximumClipSeconds=20;var _useState=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),recaptchaAllowed=_useState2[0],setrecaptchaAllowed=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState4=_slicedToArray(_useState3,2),ageProvided=_useState4[0],setageProvided=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState6=_slicedToArray(_useState5,2),genderProvided=_useState6[0],setgenderProvided=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState8=_slicedToArray(_useState7,2),villageProvided=_useState8[0],setvillageProvided=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(''),_useState10=_slicedToArray(_useState9,2),nameProvided=_useState10[0],setnameProvided=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),donateCommonVoiceProvided=_useState12[0],setdonateCommonVoiceProvided=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),recordingSent=_useState14[0],setrecordingSent=_useState14[1];// var recaptchaAllowed = false
// var ageProvided = 'do_not_wish_to_say'
// var genderProvided = 'do_not_wish_to_say'
// var nameProvided = ''
// var villageProvided = 'do_not_wish_to_say'
// var donateCommonVoiceProvided = false
// var recordingSent = false
var genderOptions=[{key:'male_masculine',text:'Male / Masculine',value:'male_masculine'},{key:'female_feminine',text:'Female / Feminine',value:'female_feminine'},{key:"'non-binary'",text:'Non-Binary',value:"'non-binary'"},{key:"do_not_wish_to_say",text:'I prefer not to say',value:"do_not_wish_to_say"}];var hometownOptions=[{key:'Akiacuar (Akiachak)',text:'Akiacuar (Akiachak)',value:'Akiacuar (Akiachak)'},{key:'Akiaq (Akiak)',text:'Akiaq (Akiak)',value:'Akiaq (Akiak)'},{key:'Alaqnaqiq (Aleknagik)',text:'Alaqnaqiq (Aleknagik)',value:'Alaqnaqiq (Aleknagik)'},{key:'Alarneq (Alakanuk)',text:'Alarneq (Alakanuk)',value:'Alarneq (Alakanuk)'},{key:'Anyaraq (Aniak)',text:'Anyaraq (Aniak)',value:'Anyaraq (Aniak)'},{key:'Arviiq (Platinum)',text:'Arviiq (Platinum)',value:'Arviiq (Platinum)'},{key:'Asaacarsaq (Mountain Village)',text:'Asaacarsaq (Mountain Village)',value:'Asaacarsaq (Mountain Village)'},{key:'Atmaulluaq (Atmautluak)',text:'Atmaulluaq (Atmautluak)',value:'Atmaulluaq (Atmautluak)'},{key:'Cellitemiut (Sleetmute)',text:'Cellitemiut (Sleetmute)',value:'Cellitemiut (Sleetmute)'},{key:'Cetuyaraq (New Stuyahok)',text:'Cetuyaraq (New Stuyahok)',value:'Cetuyaraq (New Stuyahok)'},{key:'Cev\'aq (Chevak)',text:'Cev\'aq (Chevak)',value:'Cev\'aq (Chevak)'},{key:'Cevv\'arneq (Chefornak)',text:'Cevv\'arneq (Chefornak)',value:'Cevv\'arneq (Chefornak)'},{key:'Cingik (Golovin)',text:'Cingik (Golovin)',value:'Cingik (Golovin)'},{key:'Curarpalek (Chuathbaluk)',text:'Curarpalek (Chuathbaluk)',value:'Curarpalek (Chuathbaluk)'},{key:'Curyung (Dillingham)',text:'Curyung (Dillingham)',value:'Curyung (Dillingham)'},{key:'Evicuarmiut (Eek)',text:'Evicuarmiut (Eek)',value:'Evicuarmiut (Eek)'},{key:'Igyagiiq (Egegik)',text:'Igyagiiq (Egegik)',value:'Igyagiiq (Egegik)'},{key:'Igyaraq (Igiugig)',text:'Igyaraq (Igiugig)',value:'Igyaraq (Igiugig)'},{key:'Imangaq (Emmonak)',text:'Imangaq (Emmonak)',value:'Imangaq (Emmonak)'},{key:'Ingricuar (Twin Hills)',text:'Ingricuar (Twin Hills)',value:'Ingricuar (Twin Hills)'},{key:'Ingrirraller (Holy Cross)',text:'Ingrirraller (Holy Cross)',value:'Ingrirraller (Holy Cross)'},{key:'Iquaq (Ekwok)',text:'Iquaq (Ekwok)',value:'Iquaq (Ekwok)'},{key:'Iqugmiut (Russian Mission)',text:'Iqugmiut (Russian Mission)',value:'Iqugmiut (Russian Mission)'},{key:'Kangirnaq (Kongiganak)',text:'Kangirnaq (Kongiganak)',value:'Kangirnaq (Kongiganak)'},{key:'Kassigluq (Kasigluk)',text:'Kassigluq (Kasigluk)',value:'Kassigluq (Kasigluk)'},{key:'Kuiggayagaq (Oscarville)',text:'Kuiggayagaq (Oscarville)',value:'Kuiggayagaq (Oscarville)'},{key:'Kuiggluk (Kwethluk)',text:'Kuiggluk (Kwethluk)',value:'Kuiggluk (Kwethluk)'},{key:'Kuigilnguq (Kwigillingok)',text:'Kuigilnguq (Kwigillingok)',value:'Kuigilnguq (Kwigillingok)'},{key:'Kuinerraq (Quinhagak)',text:'Kuinerraq (Quinhagak)',value:'Kuinerraq (Quinhagak)'},{key:'Liivlek (Levelock)',text:'Liivlek (Levelock)',value:'Liivlek (Levelock)'},{key:'Mamterat (Goodnews Bay)',text:'Mamterat (Goodnews Bay)',value:'Mamterat (Goodnews Bay)'},{key:'Mamterilleq (Bethel)',text:'Mamterilleq (Bethel)',value:'Mamterilleq (Bethel)'},{key:'Manuquutaq (Manakotak)',text:'Manuquutaq (Manakotak)',value:'Manuquutaq (Manakotak)'},{key:'Marayaarmiut (Scammon Bay)',text:'Marayaarmiut (Scammon Bay)',value:'Marayaarmiut (Scammon Bay)'},{key:'Masserculleq (Marshall)',text:'Masserculleq (Marshall)',value:'Masserculleq (Marshall)'},{key:'Mikuryaq (Mekoryuk)',text:'Mikuryaq (Mekoryuk)',value:'Mikuryaq (Mekoryuk)'},{key:'Nakniq (Naknek)',text:'Nakniq (Naknek)',value:'Nakniq (Naknek)'},{key:'Napamiut (Napaimiut)',text:'Napamiut (Napaimiut)',value:'Napamiut (Napaimiut)'},{key:'Naparyaarmiut (Hooper Bay)',text:'Naparyaarmiut (Hooper Bay)',value:'Naparyaarmiut (Hooper Bay)'},{key:'Naparyarraq (Napakiak)',text:'Naparyarraq (Napakiak)',value:'Naparyarraq (Napakiak)'},{key:'Napaskiaq (Napaskiak)',text:'Napaskiaq (Napaskiak)',value:'Napaskiaq (Napaskiak)'},{key:'Negeqliim Painga (Pitka\'s Point)',text:'Negeqliim Painga (Pitka\'s Point)',value:'Negeqliim Painga (Pitka\'s Point)'},{key:'Negeqliq (St. Mary\'s)',text:'Negeqliq (St. Mary\'s)',value:'Negeqliq (St. Mary\'s)'},{key:'Negtemiut (Nightmute)',text:'Negtemiut (Nightmute)',value:'Negtemiut (Nightmute)'},{key:'Neviarcaurluq (Elim)',text:'Neviarcaurluq (Elim)',value:'Neviarcaurluq (Elim)'},{key:'Niugtaq (Newtok)',text:'Niugtaq (Newtok)',value:'Niugtaq (Newtok)'},{key:'Nunakauyaq (Toksook Bay)',text:'Nunakauyaq (Toksook Bay)',value:'Nunakauyaq (Toksook Bay)'},{key:'Nunam Iqua (Nunam Iqua)',text:'Nunam Iqua (Nunam Iqua)',value:'Nunam Iqua (Nunam Iqua)'},{key:'Nunapicuaq (Nunapitchuk)',text:'Nunapicuaq (Nunapitchuk)',value:'Nunapicuaq (Nunapitchuk)'},{key:'Nuuriileng (Newhalen)',text:'Nuuriileng (Newhalen)',value:'Nuuriileng (Newhalen)'},{key:'Paimiut (Paimiut)',text:'Paimiut (Paimiut)',value:'Paimiut (Paimiut)'},{key:'Qalirneq (Koliganek)',text:'Qalirneq (Koliganek)',value:'Qalirneq (Koliganek)'},{key:'Qalqaq (Kalskag)',text:'Qalqaq (Kalskag)',value:'Qalqaq (Kalskag)'},{key:'Qarr\'unaq (Kokhanok)',text:'Qarr\'unaq (Kokhanok)',value:'Qarr\'unaq (Kokhanok)'},{key:'Qerrulliik (Kotlik)',text:'Qerrulliik (Kotlik)',value:'Qerrulliik (Kotlik)'},{key:'Qinuyang (South Naknek)',text:'Qinuyang (South Naknek)',value:'Qinuyang (South Naknek)'},{key:'Qipneq (Kipnuk)',text:'Qipneq (Kipnuk)',value:'Qipneq (Kipnuk)'},{key:'Saguyaq (Clark\'s Point)',text:'Saguyaq (Clark\'s Point)',value:'Saguyaq (Clark\'s Point)'},{key:'Taciq (St. Michael)',text:'Taciq (St. Michael)',value:'Taciq (St. Michael)'},{key:'Tapraq (Stebbins)',text:'Tapraq (Stebbins)',value:'Tapraq (Stebbins)'},{key:'Tevyaraq (Crooked Creek)',text:'Tevyaraq (Crooked Creek)',value:'Tevyaraq (Crooked Creek)'},{key:'Tuntutuliaq (Tuntutuliak)',text:'Tuntutuliaq (Tuntutuliak)',value:'Tuntutuliaq (Tuntutuliak)'},{key:'Tununeq (Tununak)',text:'Tununeq (Tununak)',value:'Tununeq (Tununak)'},{key:'Tuulkessaaq (Tuluksak)',text:'Tuulkessaaq (Tuluksak)',value:'Tuulkessaaq (Tuluksak)'},{key:'Tuutalgarmiut (Pilot Station)',text:'Tuutalgarmiut (Pilot Station)',value:'Tuutalgarmiut (Pilot Station)'},{key:'Tuyuryaq (Togiak)',text:'Tuyuryaq (Togiak)',value:'Tuyuryaq (Togiak)'},{key:'Uksurnarli (Portage Creek)',text:'Uksurnarli (Portage Creek)',value:'Uksurnarli (Portage Creek)'},{key:'Ungalaqliit (Unalakleet)',text:'Ungalaqliit (Unalakleet)',value:'Ungalaqliit (Unalakleet)'},{key:'do_not_wish_to_say',text:'I prefer not to say',value:'do_not_wish_to_say'}];var ageOptions=[{key:'teens',text:'0-19',value:'teens'},{key:'twenties',text:'20-29',value:'twenties'},{key:'thirties',text:'30-39',value:'thirties'},{key:'forties',text:'40-49',value:'forties'},{key:'fifties',text:'50-59',value:'fifties'},{key:'sixties',text:'60-69',value:'sixties'},{key:'seventies',text:'70-79',value:'seventies'},{key:'eighties',text:'80-89',value:'eighties'},{key:'nineties',text:'90 or above',value:'nineties'},{key:'do_not_wish_to_say',text:'I prefer not to say',value:'do_not_wish_to_say'}];var onButtonClick=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(audioURL){var audioBlob,audioFile,formData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return fetch(audioURL).then(function(r){return r.blob();});case 2:audioBlob=_context.sent;audioFile=new File([audioBlob],'voice.mp3',{type:'audio/mp3'});formData=new FormData();// preparing to send to the server
formData.append('file',audioFile);// preparing to send to the server
formData.append("data",JSON.stringify({"sentence":sentence,"english":english,"name":nameProvided,"isSafari":__WEBPACK_IMPORTED_MODULE_5_react_device_detect__["isSafari"],"gender":genderProvided,"age":ageProvided,"village":villageProvided,"donate":donateCommonVoiceProvided,"siteLocation":siteLocation}));// console.log(formData)
// console.log(localStorage.getItem('age'))
__WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__App_js__["a" /* API_URL */]+"yugtunCrowdsource",formData).then(function(response){console.log(response);setrecordingSent(true);// if (response.data) {
// this.setState({returnedTranscript:response.data.transcription, retrievingRecording:false})
// }
});// send audio file to server or process it here
case 8:case'end':return _context.stop();}}},_callee,_this);}));return function onButtonClick(_x){return _ref.apply(this,arguments);};}();Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function(){// console.log('mounted')
if(localStorage.getItem('ageProvided')!=null){setageProvided(localStorage.getItem('ageProvided'));}if(localStorage.getItem('genderProvided')!=null){setgenderProvided(localStorage.getItem('genderProvided'));}if(localStorage.getItem('villageProvided')!=null){setvillageProvided(localStorage.getItem('villageProvided'));}if(localStorage.getItem('nameProvided')!=null){setnameProvided(localStorage.getItem('nameProvided'));}// Your code here
},[]);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{textAlign:'center'}},recordingSent?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontSize:'18px',fontStyle:'italic',margin:10}},' Recording Sent. Quyana! '):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontSize:'14px',marginLeft:'42px'}},'Submit a Recording for Yugtun.com'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontSize:'25px',margin:sentence.length>20?'10px':'25px',marginBottom:'7px'}},sentence),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{textAlign:'center',height:'85px'}},recordingState==="stopped"&&audioFile&&timeElapsed<=maximumClipSeconds?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('audio',{controls:true,style:{height:40},src:audioURL}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],{basic:true,onClick:resetRecording},'Reset'))):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{height:'85px'}},audioFile&&timeElapsed>maximumClipSeconds&&recordingState=='stopped'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{color:'red'}},'Recording was too long (>20 seconds)'):null,recordingState=='stopped'||recordingState=='idle'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{size:'big',color:'grey',style:{cursor:'pointer',marginTop:7},circular:true,name:'microphone',onClick:startRecording}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{size:'big',color:'red',style:{cursor:'pointer',marginTop:7},circular:true,name:'stop',onClick:stopRecording}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["i" /* Form */],{style:{width:'350px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["k" /* FormSelect */],{style:{fontWeight:'normal'},label:'Qavcircit? (optional)',onChange:function onChange(event,data){setageProvided(data.value);localStorage.setItem('ageProvided',data.value);},options:ageOptions,value:ageProvided,placeholder:'20-29'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["k" /* FormSelect */],{label:'Yuurucimikun naliucia? (optional)',onChange:function onChange(event,data){setgenderProvided(data.value);localStorage.setItem('genderProvided',data.value);},options:genderOptions,value:genderProvided,placeholder:'Male'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["j" /* FormField */],{style:{marginBottom:4}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',null,'Kituusit? (optional)'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{maxlength:'40',onChange:function onChange(data){setnameProvided(data.target.value);localStorage.setItem('nameProvided',data.target.value);},value:nameProvided,placeholder:'Name'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginBottom:10,color:'#bbbbbb',fontSize:'13px'}},'Your name will never be shared online.'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["k" /* FormSelect */],{label:'Camiungusit? (optional)',onChange:function onChange(event,data){setvillageProvided(data.value);localStorage.setItem('villageProvided',data.value);},options:hometownOptions,value:villageProvided,placeholder:'Village or Dialect'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["j" /* FormField */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["d" /* Checkbox */],{onChange:function onChange(event,data){setdonateCommonVoiceProvided(data.checked);localStorage.setItem('donateCommonVoiceProvided',data.checked);},style:{paddingTop:'3px',marginRight:'6px',fontSize:'13px'}}),' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'I would also like to submit this clip to the '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{target:'_blank',href:'https://commonvoice.mozilla.org/en'},'Mozilla Data Collective'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,' (optional)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_google_recaptcha__["a" /* default */],{style:{margin:window.innerWidth<480?0:22,marginBottom:15},sitekey:'6LekfyIsAAAAAMwm2_wOCDIlJ8i8YYrnZd0fYypu',onChange:function onChange(){setrecaptchaAllowed(true);},onErrored:function onErrored(){setrecaptchaAllowed(false);},onExpired:function onExpired(){setrecaptchaAllowed(false);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */]// disabled={this.state.newBlobUrl === null}
,{disabled:!recaptchaAllowed||audioFile==null||timeElapsed>maximumClipSeconds,onClick:function onClick(){return onButtonClick(audioURL);}},'Submit')))));};/* harmony default export */ __webpack_exports__["a"] = (RecorderHook);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license
 *
 *     Colour Palette Generator script.
 *     Copyright (c) 2014 Google Inc.
 *
 *     Licensed under the Apache License, Version 2.0 (the "License"); you may
 *     not use this file except in compliance with the License.  You may
 *     obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 *     Unless required by applicable law or agreed to in writing, software
 *     distributed under the License is distributed on an "AS IS" BASIS,
 *     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
 *     implied.  See the License for the specific language governing
 *     permissions and limitations under the License.
 *
 * Furthermore, ColorBrewer colour schemes are covered by the following:
 *
 *     Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and
 *                        The Pennsylvania State University.
 *
 *     Licensed under the Apache License, Version 2.0 (the "License"); you may
 *     not use this file except in compliance with the License. You may obtain
 *     a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 *     Unless required by applicable law or agreed to in writing, software
 *     distributed under the License is distributed on an "AS IS" BASIS,
 *     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
 *     implied. See the License for the specific language governing
 *     permissions and limitations under the License.
 *
 *     Redistribution and use in source and binary forms, with or without
 *     modification, are permitted provided that the following conditions are
 *     met:
 *
 *     1. Redistributions as source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *
 *     2. The end-user documentation included with the redistribution, if any,
 *     must include the following acknowledgment: "This product includes color
 *     specifications and designs developed by Cynthia Brewer
 *     (http://colorbrewer.org/)." Alternately, this acknowledgment may appear
 *     in the software itself, if and wherever such third-party
 *     acknowledgments normally appear.
 *
 *     4. The name "ColorBrewer" must not be used to endorse or promote products
 *     derived from this software without prior written permission. For written
 *     permission, please contact Cynthia Brewer at cbrewer@psu.edu.
 *
 *     5. Products derived from this software may not be called "ColorBrewer",
 *     nor may "ColorBrewer" appear in their name, without prior written
 *     permission of Cynthia Brewer.
 *
 * Furthermore, Solarized colour schemes are covered by the following:
 *
 *     Copyright (c) 2011 Ethan Schoonover
 *
 *     Permission is hereby granted, free of charge, to any person obtaining
 *     a copy of this software and associated documentation files (the
 *     "Software"), to deal in the Software without restriction, including
 *     without limitation the rights to use, copy, modify, merge, publish,
 *     distribute, sublicense, and/or sell copies of the Software, and to
 *     permit persons to whom the Software is furnished to do so, subject to
 *     the following conditions:
 *
 *     The above copyright notice and this permission notice shall be included
 *     in all copies or substantial portions of the Software.
 *
 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 *     OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 *     MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 *     NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 *     LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 *     OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 *     WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



var palette = (function() {

  var proto = Array.prototype;
  var slice = function(arr, opt_begin, opt_end) {
    return proto.slice.apply(arr, proto.slice.call(arguments, 1));
  };

  var extend = function(arr, arr2) {
    return proto.push.apply(arr, arr2);
  };

  var function_type = typeof function() {};

  var INF = 1000000000;  // As far as we're concerned, that's infinity. ;)


  /**
   * Generate a colour palette from given scheme.
   *
   * If scheme argument is not a function it is passed to palettes.listSchemes
   * function (along with the number argument).  This may result in an array
   * of more than one available scheme.  If that is the case, scheme at
   * opt_index position is taken.
   *
   * This allows using different palettes for different data without having to
   * name the schemes specifically, for example:
   *
   *     palette_for_foo = palette('sequential', 10, 0);
   *     palette_for_bar = palette('sequential', 10, 1);
   *     palette_for_baz = palette('sequential', 10, 2);
   *
   * @param {!palette.SchemeType|string|palette.Palette} scheme Scheme to
   *     generate palette for.  Either a function constructed with
   *     palette.Scheme object, or anything that palette.listSchemes accepts
   *     as name argument.
   * @param {number} number Number of colours to return.  If negative, absolute
   *     value is taken and colours will be returned in reverse order.
   * @param {number=} opt_index If scheme is a name of a group or an array and
   *     results in more than one scheme, index of the scheme to use.  The
   *     index wraps around.
   * @param {...*} varargs Additional arguments to pass to palette or colour
   *     generator (if the chosen scheme uses those).
   * @return {Array<string>} Array of abs(number) 'RRGGBB' strings or null if
   *     no matching scheme was found.
   */
  var palette = function(scheme, number, opt_index, varargs) {
    number |= 0;
    if (number == 0) {
      return [];
    }

    if (typeof scheme !== function_type) {
      var arr = palette.listSchemes(
          /** @type {string|palette.Palette} */ (scheme), number);
      if (!arr.length) {
        return null;
      }
      scheme = arr[(opt_index || 0) % arr.length];
    }

    var args = slice(arguments, 2);
    args[0] = number;
    return scheme.apply(scheme, args);
  };


  /**
   * Returns a callable colour scheme object.
   *
   * Just after being created, the scheme has no colour palettes and no way of
   * generating any, thus generate method will return null.  To turn scheme
   * into a useful object, addPalette, addPalettes or setColorFunction methods
   * need to be used.
   *
   * To generate a colour palette with given number colours using function
   * returned by this method, just call it with desired number of colours.
   *
   * Since this function *returns* a callable object, it must *not* be used
   * with the new operator.
   *
   * @param {string} name Name of the scheme.
   * @param {string|!Array<string>=} opt_groups A group name or list of
   *     groups the scheme should be categorised under.  Three typical groups
   *     to use are 'qualitative', 'sequential' and 'diverging', but any
   *     groups may be created.
   * @return {!palette.SchemeType} A colour palette generator function, which
   *     in addition has methods and properties like a regular object.  Think
   *     of it as a callable object.
   */
  palette.Scheme = function(name, opt_groups) {
    /**
     * A map from a number to a colour palettes with given number of colours.
     * @type {!Object<number, palette.Palette>}
     */
    var palettes = {};

    /**
     * The biggest palette in palettes map.
     * @type {number}
     */
    var palettes_max = 0;

    /**
     * The smallest palette in palettes map.
     * @type {number}
     */
    var palettes_min = INF;

    var makeGenerator = function() {
      if (arguments.length <= 1) {
        return self.color_func.bind(self);
      } else {
        var args = slice(arguments);
        return function(x) {
          args[0] = x;
          return self.color_func.apply(self, args);
        };
      }
    };

    /**
     * Generate a colour palette from the scheme.
     *
     * If there was a palette added with addPalette (or addPalettes) with
     * enough colours, that palette will be used.  Otherwise, if colour
     * function has been set using setColorFunction method, that function will
     * be used to generate the palette.  Otherwise null is returned.
     *
     * @param {number} number Number of colours to return.  If negative,
     *     absolute value is taken and colours will be returned in reverse
     *     order.
     * @param {...*} varargs Additional arguments to pass to palette or colour
     *     generator (if the chosen scheme uses those).
     */
    var self = function(number, varargs) {
      number |= 0;
      if (!number) {
        return [];
      }

      var _number = number;
      number = Math.abs(number);

      if (number <= palettes_max) {
        for (var i = Math.max(number, palettes_min); !(i in palettes); ++i) {
          /* nop */
        }
        var colors = palettes[i];
        if (i > number) {
          var take_head =
              'shrinking_takes_head' in colors ?
              colors.shrinking_takes_head : self.shrinking_takes_head;
          if (take_head) {
            colors = colors.slice(0, number);
            i = number;
          } else {
            return palette.generate(
                function(x) { return colors[Math.round(x)]; },
                _number, 0, colors.length - 1);
          }
        }
        colors = colors.slice();
        if (_number < 0) {
          colors.reverse();
        }
        return colors;

      } else if (self.color_func) {
        return palette.generate(makeGenerator.apply(self, arguments),
                                _number, 0, 1, self.color_func_cyclic);

      } else {
        return null;
      }
    };

    /**
     * The name of the palette.
     * @type {string}
     */
    self.scheme_name = name;

    /**
     * A list of groups the palette belongs to.
     * @type {!Array<string>}
     */
    self.groups = opt_groups ?
      typeof opt_groups === 'string' ? [opt_groups] : opt_groups : [];

    /**
     * The biggest palette this scheme can generate.
     * @type {number}
     */
    self.max = 0;

    /**
     * The biggest palette this scheme can generate that is colour-blind
     * friendly.
     * @type {number}
     */
    self.cbf_max = INF;


    /**
     * Adds a colour palette to the colour scheme.
     *
     * @param {palette.Palette} palette An array of 'RRGGBB' strings
     *     representing the palette to add.
     * @param {boolean=} opt_is_cbf Whether the palette is colourblind friendly.
     */
    self.addPalette = function(palette, opt_is_cbf) {
      var len = palette.length;
      if (len) {
        palettes[len] = palette;
        palettes_min = Math.min(palettes_min, len);
        palettes_max = Math.max(palettes_max, len);
        self.max = Math.max(self.max, len);
        if (!opt_is_cbf && len != 1) {
          self.cbf_max = Math.min(self.cbf_max, len - 1);
        }
      }
    };

    /**
     * Adds number of colour palettes to the colour scheme.
     *
     * @param {palette.PalettesList} palettes A map or an array of colour
     *     palettes to add.  If map, i.e.  object, is used, properties should
     *     use integer property names.
     * @param {number=} opt_max Size of the biggest palette in palettes set.
     *     If not set, palettes must have a length property which will be used.
     * @param {number=} opt_cbf_max Size of the biggest palette which is still
     *     colourblind friendly.  1 by default.
     */
    self.addPalettes = function(palettes, opt_max, opt_cbf_max) {
      opt_max = opt_max || palettes.length;
      for (var i = 0; i < opt_max; ++i) {
        if (i in palettes) {
          self.addPalette(palettes[i], true);
        }
      }
      self.cbf_max = Math.min(self.cbf_max, opt_cbf_max || 1);
    };

    /**
     * Enable shrinking palettes taking head of the list of colours.
     *
     * When user requests n-colour palette but the smallest palette added with
     * addPalette (or addPalettes) is m-colour one (where n < m), n colours
     * across the palette will be returned.  For example:
     *     var ex = palette.Scheme('ex');
     *     ex.addPalette(['000000', 'bcbcbc', 'ffffff']);
     *     var pal = ex(2);
     *     // pal == ['000000', 'ffffff']
     *
     * This works for palettes where the distance between colours is
     * correlated to distance in the palette array, which is true in gradients
     * such as the one above.
     *
     * To turn this feature off shrinkByTakingHead can be set to true either
     * for all palettes in the scheme (if opt_idx is not given) or for palette
     * with given number of colours only.  In general, setting the option for
     * given palette overwrites whatever has been set for the scheme.  The
     * default, as described above, is false.
     *
     * Alternatively, the feature can be enabled by setting shrinking_takes_head
     * property for the palette Array or the scheme object.
     *
     * For example, all of the below give equivalent results:
     *     var pal = ['ff0000', '00ff00', '0000ff'];
     *
     *     var ex = palette.Scheme('ex');
     *     ex.addPalette(pal);               // ex(2) == ['ff0000', '0000ff']
     *     ex.shrinkByTakingHead(true);      // ex(2) == ['ff0000', '00ff00']
     *
     *     ex = palette.Scheme('ex');
     *     ex.addPalette(pal);               // ex(2) == ['ff0000', '0000ff']
     *     ex.shrinkByTakingHead(true, 3);   // ex(2) == ['ff0000', '00ff00']
     *
     *     ex = palette.Scheme('ex');
     *     ex.addPalette(pal);
     *     ex.addPalette(pal);               // ex(2) == ['ff0000', '0000ff']
     *     pal.shrinking_takes_head = true;  // ex(2) == ['ff0000', '00ff00']
     *
     * @param {boolean} enabled Whether to enable or disable the “shrinking
     *     takes head” feature.  It is disabled by default.
     * @param {number=} opt_idx If given, the “shrinking takes head” option
     *     for palette with given number of colours is set.  If such palette
     *     does not exist, nothing happens.
     */
    self.shrinkByTakingHead = function(enabled, opt_idx) {
      if (opt_idx !== void(0)) {
        if (opt_idx in palettes) {
          palettes[opt_idx].shrinking_takes_head = !!enabled;
        }
      } else {
        self.shrinking_takes_head = !!enabled;
      }
    };

    /**
     * Sets a colour generation function of the colour scheme.
     *
     * The function must accept a singe number argument whose value can be from
     * 0.0 to 1.0, and return a colour as an 'RRGGBB' string.  This function
     * will be used when generating palettes, i.e. if 11-colour palette is
     * requested, this function will be called with arguments 0.0, 0.1, …, 1.0.
     *
     * If the palette generated by the function is colourblind friendly,
     * opt_is_cbf should be set to true.
     *
     * In some cases, it is not desirable to reach 1.0 when generating
     * a palette.  This happens for hue-rainbows where the 0–1 range corresponds
     * to a 0°–360° range in hues, and since hue at 0° is the same as at 360°,
     * it's desired to stop short the end of the range when generating
     * a palette.  To accomplish this, opt_cyclic should be set to true.
     *
     * @param {palette.ColorFunction} func A colour generator function.
     * @param {boolean=} opt_is_cbf Whether palette generate with the function
     *     is colour-blind friendly.
     * @param {boolean=} opt_cyclic Whether colour at 0.0 is the same as the
     *     one at 1.0.
     */
    self.setColorFunction = function(func, opt_is_cbf, opt_cyclic) {
      self.color_func = func;
      self.color_func_cyclic = !!opt_cyclic;
      self.max = INF;
      if (!opt_is_cbf && self.cbf_max === INF) {
        self.cbf_max = 1;
      }
    };

    self.color = function(x, varargs) {
      if (self.color_func) {
        return self.color_func.apply(this, arguments);
      } else {
        return null;
      }
    };

    return self;
  };


  /**
   * Creates a new palette.Scheme and initialises it by calling addPalettes
   * method with the rest of the arguments.
   *
   * @param {string} name Name of the scheme.
   * @param {string|!Array<string>} groups A group name or list of group
   *     names the scheme belongs to.
   * @param {!Object<number, palette.Palette>|!Array<palette.Palette>}
   *     palettes A map or an array of colour palettes to add.  If map, i.e.
   *     object, is used, properties should use integer property names.
   * @param {number=} opt_max Size of the biggest palette in palettes set.
   *     If not set, palettes must have a length property which will be used.
   * @param {number=} opt_cbf_max Size of the biggest palette which is still
   *     colourblind friendly.  1 by default.
   * @return {!palette.SchemeType} A colour palette generator function, which
   *     in addition has methods and properties like a regular object.  Think
   *     of it as a callable object.
   */
  palette.Scheme.fromPalettes = function(name, groups,
                                         palettes, opt_max, opt_cbf_max) {
    var scheme = palette.Scheme(name, groups);
    scheme.addPalettes.apply(scheme, slice(arguments, 2));
    return scheme;
  };


  /**
   * Creates a new palette.Scheme and initialises it by calling
   * setColorFunction method with the rest of the arguments.
   *
   * @param {string} name Name of the scheme.
   * @param {string|!Array<string>} groups A group name or list of group
   *     names the scheme belongs to.
   * @param {palette.ColorFunction} func A colour generator function.
   * @param {boolean=} opt_is_cbf Whether palette generate with the function
   *     is colour-blind friendly.
   * @param {boolean=} opt_cyclic Whether colour at 0.0 is the same as the
   *     one at 1.0.
   * @return {!palette.SchemeType} A colour palette generator function, which
   *     in addition has methods and properties like a regular object.  Think
   *     of it as a callable object.
   */
  palette.Scheme.withColorFunction = function(name, groups,
                                              func, opt_is_cbf, opt_cyclic) {
    var scheme = palette.Scheme(name, groups);
    scheme.setColorFunction.apply(scheme, slice(arguments, 2));
    return scheme;
  };


  /**
   * A map of registered schemes.  Maps a scheme or group name to a list of
   * scheme objects.  Property name is either 'n-<name>' for single scheme
   * names or 'g-<name>' for scheme group names.
   *
   * @type {!Object<string, !Array<!Object>>}
   */
  var registered_schemes = {};


  /**
   * Registers a new colour scheme.
   *
   * @param {!palette.SchemeType} scheme The scheme to add.
   */
  palette.register = function(scheme) {
    registered_schemes['n-' + scheme.scheme_name] = [scheme];
    scheme.groups.forEach(function(g) {
      (registered_schemes['g-' + g] =
       registered_schemes['g-' + g] || []).push(scheme);
    });
    (registered_schemes['g-all'] =
       registered_schemes['g-all'] || []).push(scheme);
  };


  /**
   * List all schemes that match given name and number of colours.
   *
   * name argument can be either a string or an array of strings.  In the
   * former case, the function acts as if the argument was an array with name
   * as a single argument (i.e. “palette.listSchemes('foo')” is exactly the same
   * as “palette.listSchemes(['foo'])”).
   *
   * Each name can be either name of a palette (e.g. 'tol-sq' for Paul Tol's
   * sequential palette), or a name of a group (e.g. 'sequential' for all
   * sequential palettes).  Name can therefore map to a single scheme or
   * several schemes.
   *
   * Furthermore, name can be suffixed with '-cbf' to indicate that only
   * schemes that are colourblind friendly should be returned.  For example,
   * 'rainbow' returns a HSV rainbow scheme, but because it is not colourblind
   * friendly, 'rainbow-cbf' returns no schemes.
   *
   * Some schemes may produce colourblind friendly palettes for some number of
   * colours.  For example ColorBrewer's Dark2 scheme is colourblind friendly
   * if no more than 3 colours are generated.  If opt_number is not specified,
   * 'qualitative-cbf' will include 'cb-Dark2' but if opt_number is given as,
   * say, 5 it won't.
   *
   * Name can also be 'all' which will return all registered schemes.
   * Naturally, 'all-cbf' will return all colourblind friendly schemes.
   *
   * Schemes are added to the library using palette.register.  Schemes are
   * created using palette.Scheme function.  By default, the following schemes
   * are available:
   *
   *     Name            Description
   *     --------------  -----------------------------------------------------
   *     tol             Paul Tol's qualitative scheme, cbf, max 12 colours.
   *     tol-dv          Paul Tol's diverging scheme, cbf.
   *     tol-sq          Paul Tol's sequential scheme, cbf.
   *     tol-rainbow     Paul Tol's qualitative scheme, cbf.
   *
   *     rainbow         A rainbow palette.
   *
   *     cb-YlGn         ColorBrewer sequential schemes.
   *     cb-YlGnBu
   *     cb-GnBu
   *     cb-BuGn
   *     cb-PuBuGn
   *     cb-PuBu
   *     cb-BuPu
   *     cb-RdPu
   *     cb-PuRd
   *     cb-OrRd
   *     cb-YlOrRd
   *     cb-YlOrBr
   *     cb-Purples
   *     cb-Blues
   *     cb-Greens
   *     cb-Oranges
   *     cb-Reds
   *     cb-Greys
   *
   *     cb-PuOr         ColorBrewer diverging schemes.
   *     cb-BrBG
   *     cb-PRGn
   *     cb-PiYG
   *     cb-RdBu
   *     cb-RdGy
   *     cb-RdYlBu
   *     cb-Spectral
   *     cb-RdYlGn
   *
   *     cb-Accent       ColorBrewer qualitative schemes.
   *     cb-Dark2
   *     cb-Paired
   *     cb-Pastel1
   *     cb-Pastel2
   *     cb-Set1
   *     cb-Set2
   *     cb-Set3
   *
   *     sol-base        Solarized base colours.
   *     sol-accent      Solarized accent colours.
   *
   * The following groups are also available by default:
   *
   *     Name            Description
   *     --------------  -----------------------------------------------------
   *     all             All registered schemes.
   *     sequential      All sequential schemes.
   *     diverging       All diverging schemes.
   *     qualitative     All qualitative schemes.
   *     cb-sequential   All ColorBrewer sequential schemes.
   *     cb-diverging    All ColorBrewer diverging schemes.
   *     cb-qualitative  All ColorBrewer qualitative schemes.
   *
   * You can read more about Paul Tol's palettes at http://www.sron.nl/~pault/.
   * You can read more about ColorBrewer at http://colorbrewer2.org.
   *
   * @param {string|!Array<string>} name A name of a colour scheme, of
   *     a group of colour schemes, or an array of any of those.
   * @param {number=} opt_number When requesting only colourblind friendly
   *     schemes, number of colours the scheme must provide generating such
   *     that the palette is still colourblind friendly.  2 by default.
   * @return {!Array<!palette.SchemeType>} An array of colour scheme objects
   *     matching the criteria.  Sorted by scheme name.
   */
  palette.listSchemes = function(name, opt_number) {
    if (!opt_number) {
      opt_number = 2;
    } else if (opt_number < 0) {
      opt_number = -opt_number;
    }

    var ret = [];
    (typeof name === 'string' ? [name] : name).forEach(function(n) {
      var cbf = n.substring(n.length - 4) === '-cbf';
      if (cbf) {
        n = n.substring(0, n.length - 4);
      }
      var schemes =
          registered_schemes['g-' + n] ||
          registered_schemes['n-' + n] ||
          [];
      for (var i = 0, scheme; (scheme = schemes[i]); ++i) {
        if ((cbf ? scheme.cbf : scheme.max) >= opt_number) {
          ret.push(scheme);
        }
      }
    });

    ret.sort(function(a, b) {
      return a.scheme_name >= b.scheme_name ?
        a.scheme_name > b.scheme_name ? 1 : 0 : -1;
    });
    return ret;
  };


  /**
   * Generates a palette using given colour generating function.
   *
   * The color_func callback must accept a singe number argument whose value
   * can vary from 0.0 to 1.0 (or in general from opt_start to opt_end), and
   * return a colour as an 'RRGGBB' string.  This function will be used when
   * generating palettes, i.e. if 11-colour palette is requested, this
   * function will be called with arguments 0.0, 0.1, …, 1.0.
   *
   * In some cases, it is not desirable to reach 1.0 when generating
   * a palette.  This happens for hue-rainbows where the 0–1 range corresponds
   * to a 0°–360° range in hues, and since hue at 0° is the same as at 360°,
   * it's desired to stop short the end of the range when generating
   * a palette.  To accomplish this, opt_cyclic should be set to true.
   *
   * opt_start and opt_end may be used to change the range the colour
   * generation function is called with.  opt_end may be less than opt_start
   * which will case to traverse the range in reverse.  Another way to reverse
   * the palette is requesting negative number of colours.  The two methods do
   * not always lead to the same results (especially if opt_cyclic is set).
   *
   * @param {palette.ColorFunction} color_func A colours generating callback
   *     function.
   * @param {number} number Number of colours to generate in the palette.  If
   *     number is negative, colours in the palette will be reversed.  If only
   *     one colour is requested, colour at opt_start will be returned.
   * @param {number=} opt_start Optional starting point for the palette
   *     generation function.  Zero by default.
   * @param {number=} opt_end Optional ending point for the palette generation
   *     function.  One by default.
   * @param {boolean=} opt_cyclic If true, function will assume colour at
   *     point opt_start is the same as one at opt_end.
   * @return {palette.Palette} An array of 'RRGGBB' colours.
   */
  palette.generate = function(color_func, number, opt_start, opt_end,
                              opt_cyclic) {
    if (Math.abs(number) < 1) {
      return [];
    }

    opt_start = opt_start === void(0) ? 0 : opt_start;
    opt_end = opt_end === void(0) ? 1 : opt_end;

    if (Math.abs(number) < 2) {
      return [color_func(opt_start)];
    }

    var i = Math.abs(number);
    var x = opt_start;
    var ret = [];
    var step = (opt_end - opt_start) / (opt_cyclic ? i : (i - 1));

    for (; --i >= 0; x += step) {
      ret.push(color_func(x));
    }
    if (number < 0) {
      ret.reverse();
    }
    return ret;
  };


  /**
   * Clamps value to [0, 1] range.
   * @param {number} v Number to limit value of.
   * @return {number} If v is inside of [0, 1] range returns v, otherwise
   *     returns 0 or 1 depending which side of the range v is closer to.
   */
  var clamp = function(v) {
    return v > 0 ? (v < 1 ? v : 1) : 0;
  };

  /**
   * Converts r, g, b triple into RRGGBB hex representation.
   * @param {number} r Red value of the colour in the range [0, 1].
   * @param {number} g Green value of the colour in the range [0, 1].
   * @param {number} b Blue value of the colour in the range [0, 1].
   * @return {string} A lower-case RRGGBB representation of the colour.
   */
  palette.rgbColor = function(r, g, b) {
    return [r, g, b].map(function(v) {
      v = Number(Math.round(clamp(v) * 255)).toString(16);
      return v.length == 1 ? '0' + v : v;
    }).join('');
  };

  /**
   * Converts a linear r, g, b triple into RRGGBB hex representation.
   * @param {number} r Linear red value of the colour in the range [0, 1].
   * @param {number} g Linear green value of the colour in the range [0, 1].
   * @param {number} b Linear blue value of the colour in the range [0, 1].
   * @return {string} A lower-case RRGGBB representation of the colour.
   */
  palette.linearRgbColor = function(r, g, b) {
    // http://www.brucelindbloom.com/index.html?Eqn_XYZ_to_RGB.html
    return [r, g, b].map(function(v) {
      v = clamp(v);
      if (v <= 0.0031308) {
        v = 12.92 * v;
      } else {
        v = 1.055 * Math.pow(v, 1 / 2.4) - 0.055;
      }
      v = Number(Math.round(v * 255)).toString(16);
      return v.length == 1 ? '0' + v : v;
    }).join('');
  };

  /**
   * Converts an HSV colours to RRGGBB hex representation.
   * @param {number} h Hue in the range [0, 1].
   * @param {number=} opt_s Saturation in the range [0, 1].  One by default.
   * @param {number=} opt_v Value in the range [0, 1].  One by default.
   * @return {string} An RRGGBB representation of the colour.
   */
  palette.hsvColor = function(h, opt_s, opt_v) {
    h *= 6;
    var s = opt_s === void(0) ? 1 : clamp(opt_s);
    var v = opt_v === void(0) ? 1 : clamp(opt_v);
    var x = v * (1 - s * Math.abs(h % 2 - 1));
    var m = v * (1 - s);
    switch (Math.floor(h) % 6) {
    case 0: return palette.rgbColor(v, x, m);
    case 1: return palette.rgbColor(x, v, m);
    case 2: return palette.rgbColor(m, v, x);
    case 3: return palette.rgbColor(m, x, v);
    case 4: return palette.rgbColor(x, m, v);
    default: return palette.rgbColor(v, m, x);
    }
  };

  palette.register(palette.Scheme.withColorFunction(
    'rainbow', 'qualitative', palette.hsvColor, false, true));

  return palette;
})();


/** @typedef {function(number): string} */
palette.ColorFunction;

/** @typedef {!Array<string>} */
palette.Palette;

/** @typedef {!Object<number, palette.Palette>|!Array<palette.Palette>} */
palette.PalettesList;

/**
 * @typedef {
 *   function(number, ...?): Array<string>|
 *   {
 *     scheme_name: string,
 *     groups: !Array<string>,
 *     max: number,
 *     cbf_max: number,
 *     addPalette: function(!Array<string>, boolean=),
 *     addPalettes: function(palette.PalettesList, number=, number=),
 *     shrinkByTakingHead: function(boolean, number=),
 *     setColorFunction: function(palette.ColorFunction, boolean=, boolean=),
 *     color: function(number, ...?): ?string}}
 */
palette.SchemeType;


/* mpn65 palette start here. ************************************************/

/* The ‘mpn65’ palette is designed for systems which show many graphs which
   don’t have custom colour palettes chosen by humans or if number of necessary
   colours isn’t know a priori. */

(function() {
  var scheme = palette.Scheme.fromPalettes('mpn65', 'qualitative', [[
    'ff0029', '377eb8', '66a61e', '984ea3', '00d2d5', 'ff7f00', 'af8d00',
    '7f80cd', 'b3e900', 'c42e60', 'a65628', 'f781bf', '8dd3c7', 'bebada',
    'fb8072', '80b1d3', 'fdb462', 'fccde5', 'bc80bd', 'ffed6f', 'c4eaff',
    'cf8c00', '1b9e77', 'd95f02', 'e7298a', 'e6ab02', 'a6761d', '0097ff',
    '00d067', '000000', '252525', '525252', '737373', '969696', 'bdbdbd',
    'f43600', '4ba93b', '5779bb', '927acc', '97ee3f', 'bf3947', '9f5b00',
    'f48758', '8caed6', 'f2b94f', 'eff26e', 'e43872', 'd9b100', '9d7a00',
    '698cff', 'd9d9d9', '00d27e', 'd06800', '009f82', 'c49200', 'cbe8ff',
    'fecddf', 'c27eb6', '8cd2ce', 'c4b8d9', 'f883b0', 'a49100', 'f48800',
    '27d0df', 'a04a9b'
  ]]);
  scheme.shrinkByTakingHead(true);
  palette.register(scheme);
})();

/* Paul Tol's schemes start here. *******************************************/
/* See http://www.sron.nl/~pault/ */

(function() {
  var rgb = palette.rgbColor;

  /**
   * Calculates value of a polynomial at given point.
   * For example, poly(x, 1, 2, 3) calculates value of “1 + 2*x + 3*X²”.
   * @param {number} x Value to calculate polynomial for.
   * @param {...number} varargs Coefficients of the polynomial specified in
   *     the order of rising powers of x including constant as the first
   *     variable argument.
   */
  var poly = function(x, varargs) {
    var i = arguments.length - 1, n = arguments[i];
    while (i > 1) {
      n = n * x + arguments[--i];
    }
    return n;
  };

  /**
   * Calculate approximate value of error function with maximum error of 0.0005.
   * See <https://en.wikipedia.org/wiki/Error_function>.
   * @param {number} x Argument of the error function.
   * @return {number} Value of error function for x.
   */
  var erf = function(x) {
    // https://en.wikipedia.org/wiki/Error_function#Approximation_with_elementary_functions
    // This produces a maximum error of 0.0005 which is more then we need.  In
    // the worst case, that error is multiplied by four and then divided by two
    // before being multiplied by 255, so in the end, the error is multiplied by
    // 510 which produces 0.255 which is less than a single colour step.
    var y = poly(Math.abs(x), 1, 0.278393, 0.230389, 0.000972, 0.078108);
    y *= y; // y^2
    y *= y; // y^4
    y = 1 - 1 / y;
    return x < 0 ? -y : y;
  };

  palette.register(palette.Scheme.fromPalettes('tol', 'qualitative', [
    ['4477aa'],
    ['4477aa', 'cc6677'],
    ['4477aa', 'ddcc77', 'cc6677'],
    ['4477aa', '117733', 'ddcc77', 'cc6677'],
    ['332288', '88ccee', '117733', 'ddcc77', 'cc6677'],
    ['332288', '88ccee', '117733', 'ddcc77', 'cc6677', 'aa4499'],
    ['332288', '88ccee', '44aa99', '117733', 'ddcc77', 'cc6677', 'aa4499'],
    ['332288', '88ccee', '44aa99', '117733', '999933', 'ddcc77', 'cc6677',
     'aa4499'],
    ['332288', '88ccee', '44aa99', '117733', '999933', 'ddcc77', 'cc6677',
     '882255', 'aa4499'],
    ['332288', '88ccee', '44aa99', '117733', '999933', 'ddcc77', '661100',
     'cc6677', '882255', 'aa4499'],
    ['332288', '6699cc', '88ccee', '44aa99', '117733', '999933', 'ddcc77',
     '661100', 'cc6677', '882255', 'aa4499'],
    ['332288', '6699cc', '88ccee', '44aa99', '117733', '999933', 'ddcc77',
     '661100', 'cc6677', 'aa4466', '882255', 'aa4499']
  ], 12, 12));

  /**
   * Calculates a colour along Paul Tol's sequential colours axis.
   * See <http://www.sron.nl/~pault/colourschemes.pdf> figure 7 and equation 1.
   * @param {number} x Position of the colour on the axis in the [0, 1] range.
   * @return {string} An RRGGBB representation of the colour.
   */
  palette.tolSequentialColor = function(x) {
    return rgb(1 - 0.392 * (1 + erf((x - 0.869) / 0.255)),
               1.021 - 0.456 * (1 + erf((x - 0.527) / 0.376)),
               1 - 0.493 * (1 + erf((x - 0.272) / 0.309)));
  };

  palette.register(palette.Scheme.withColorFunction(
    'tol-sq', 'sequential', palette.tolSequentialColor, true));

  /**
   * Calculates a colour along Paul Tol's diverging colours axis.
   * See <http://www.sron.nl/~pault/colourschemes.pdf> figure 8 and equation 2.
   * @param {number} x Position of the colour on the axis in the [0, 1] range.
   * @return {string} An RRGGBB representation of the colour.
   */
  palette.tolDivergingColor = function(x) {
    var g = poly(x, 0.572, 1.524, -1.811) / poly(x, 1, -0.291, 0.1574);
    return rgb(poly(x, 0.235, -2.13, 26.92, -65.5, 63.5, -22.36),
               g * g,
               1 / poly(x, 1.579, -4.03, 12.92, -31.4, 48.6, -23.36));
  };

  palette.register(palette.Scheme.withColorFunction(
    'tol-dv', 'diverging', palette.tolDivergingColor, true));

  /**
   * Calculates a colour along Paul Tol's rainbow colours axis.
   * See <http://www.sron.nl/~pault/colourschemes.pdf> figure 13 and equation 3.
   * @param {number} x Position of the colour on the axis in the [0, 1] range.
   * @return {string} An RRGGBB representation of the colour.
   */
  palette.tolRainbowColor = function(x) {
    return rgb(poly(x, 0.472, -0.567, 4.05) / poly(x, 1, 8.72, -19.17, 14.1),
               poly(x, 0.108932, -1.22635, 27.284, -98.577, 163.3, -131.395,
                    40.634),
               1 / poly(x, 1.97, 3.54, -68.5, 243, -297, 125));
  };

  palette.register(palette.Scheme.withColorFunction(
    'tol-rainbow', 'qualitative', palette.tolRainbowColor, true));
})();


/* Solarized colour schemes start here. *************************************/
/* See http://ethanschoonover.com/solarized */

(function() {
  /*
   * Those are not really designed to be used in graphs, but we're keeping
   * them here in case someone cares.
   */
  palette.register(palette.Scheme.fromPalettes('sol-base', 'sequential', [
    ['002b36', '073642', '586e75', '657b83', '839496', '93a1a1', 'eee8d5',
     'fdf6e3']
  ], 1, 8));
  palette.register(palette.Scheme.fromPalettes('sol-accent', 'qualitative', [
    ['b58900', 'cb4b16', 'dc322f', 'd33682', '6c71c4', '268bd2', '2aa198',
     '859900']
  ]));
})();


/* ColorBrewer colour schemes start here. ***********************************/
/* See http://colorbrewer2.org/ */

(function() {
  var schemes = {
    YlGn: {
      type: 'sequential',
      cbf: 42,
      3: ['f7fcb9', 'addd8e', '31a354'],
      4: ['ffffcc', 'c2e699', '78c679', '238443'],
      5: ['ffffcc', 'c2e699', '78c679', '31a354', '006837'],
      6: ['ffffcc', 'd9f0a3', 'addd8e', '78c679', '31a354', '006837'],
      7: ['ffffcc', 'd9f0a3', 'addd8e', '78c679', '41ab5d', '238443',
          '005a32'],
      8: ['ffffe5', 'f7fcb9', 'd9f0a3', 'addd8e', '78c679', '41ab5d',
          '238443', '005a32'],
      9: ['ffffe5', 'f7fcb9', 'd9f0a3', 'addd8e', '78c679', '41ab5d',
          '238443', '006837', '004529']
    },
    YlGnBu: {
      type: 'sequential',
      cbf: 42,
      3: ['edf8b1', '7fcdbb', '2c7fb8'],
      4: ['ffffcc', 'a1dab4', '41b6c4', '225ea8'],
      5: ['ffffcc', 'a1dab4', '41b6c4', '2c7fb8', '253494'],
      6: ['ffffcc', 'c7e9b4', '7fcdbb', '41b6c4', '2c7fb8', '253494'],
      7: ['ffffcc', 'c7e9b4', '7fcdbb', '41b6c4', '1d91c0', '225ea8',
          '0c2c84'],
      8: ['ffffd9', 'edf8b1', 'c7e9b4', '7fcdbb', '41b6c4', '1d91c0',
          '225ea8', '0c2c84'],
      9: ['ffffd9', 'edf8b1', 'c7e9b4', '7fcdbb', '41b6c4', '1d91c0',
          '225ea8', '253494', '081d58']
    },
    GnBu: {
      type: 'sequential',
      cbf: 42,
      3: ['e0f3db', 'a8ddb5', '43a2ca'],
      4: ['f0f9e8', 'bae4bc', '7bccc4', '2b8cbe'],
      5: ['f0f9e8', 'bae4bc', '7bccc4', '43a2ca', '0868ac'],
      6: ['f0f9e8', 'ccebc5', 'a8ddb5', '7bccc4', '43a2ca', '0868ac'],
      7: ['f0f9e8', 'ccebc5', 'a8ddb5', '7bccc4', '4eb3d3', '2b8cbe',
          '08589e'],
      8: ['f7fcf0', 'e0f3db', 'ccebc5', 'a8ddb5', '7bccc4', '4eb3d3',
          '2b8cbe', '08589e'],
      9: ['f7fcf0', 'e0f3db', 'ccebc5', 'a8ddb5', '7bccc4', '4eb3d3',
          '2b8cbe', '0868ac', '084081']
    },
    BuGn: {
      type: 'sequential',
      cbf: 42,
      3: ['e5f5f9', '99d8c9', '2ca25f'],
      4: ['edf8fb', 'b2e2e2', '66c2a4', '238b45'],
      5: ['edf8fb', 'b2e2e2', '66c2a4', '2ca25f', '006d2c'],
      6: ['edf8fb', 'ccece6', '99d8c9', '66c2a4', '2ca25f', '006d2c'],
      7: ['edf8fb', 'ccece6', '99d8c9', '66c2a4', '41ae76', '238b45',
          '005824'],
      8: ['f7fcfd', 'e5f5f9', 'ccece6', '99d8c9', '66c2a4', '41ae76',
          '238b45', '005824'],
      9: ['f7fcfd', 'e5f5f9', 'ccece6', '99d8c9', '66c2a4', '41ae76',
          '238b45', '006d2c', '00441b']
    },
    PuBuGn: {
      type: 'sequential',
      cbf: 42,
      3: ['ece2f0', 'a6bddb', '1c9099'],
      4: ['f6eff7', 'bdc9e1', '67a9cf', '02818a'],
      5: ['f6eff7', 'bdc9e1', '67a9cf', '1c9099', '016c59'],
      6: ['f6eff7', 'd0d1e6', 'a6bddb', '67a9cf', '1c9099', '016c59'],
      7: ['f6eff7', 'd0d1e6', 'a6bddb', '67a9cf', '3690c0', '02818a',
          '016450'],
      8: ['fff7fb', 'ece2f0', 'd0d1e6', 'a6bddb', '67a9cf', '3690c0',
          '02818a', '016450'],
      9: ['fff7fb', 'ece2f0', 'd0d1e6', 'a6bddb', '67a9cf', '3690c0',
          '02818a', '016c59', '014636']
    },
    PuBu: {
      type: 'sequential',
      cbf: 42,
      3: ['ece7f2', 'a6bddb', '2b8cbe'],
      4: ['f1eef6', 'bdc9e1', '74a9cf', '0570b0'],
      5: ['f1eef6', 'bdc9e1', '74a9cf', '2b8cbe', '045a8d'],
      6: ['f1eef6', 'd0d1e6', 'a6bddb', '74a9cf', '2b8cbe', '045a8d'],
      7: ['f1eef6', 'd0d1e6', 'a6bddb', '74a9cf', '3690c0', '0570b0',
          '034e7b'],
      8: ['fff7fb', 'ece7f2', 'd0d1e6', 'a6bddb', '74a9cf', '3690c0',
          '0570b0', '034e7b'],
      9: ['fff7fb', 'ece7f2', 'd0d1e6', 'a6bddb', '74a9cf', '3690c0',
          '0570b0', '045a8d', '023858']
    },
    BuPu: {
      type: 'sequential',
      cbf: 42,
      3: ['e0ecf4', '9ebcda', '8856a7'],
      4: ['edf8fb', 'b3cde3', '8c96c6', '88419d'],
      5: ['edf8fb', 'b3cde3', '8c96c6', '8856a7', '810f7c'],
      6: ['edf8fb', 'bfd3e6', '9ebcda', '8c96c6', '8856a7', '810f7c'],
      7: ['edf8fb', 'bfd3e6', '9ebcda', '8c96c6', '8c6bb1', '88419d',
          '6e016b'],
      8: ['f7fcfd', 'e0ecf4', 'bfd3e6', '9ebcda', '8c96c6', '8c6bb1',
          '88419d', '6e016b'],
      9: ['f7fcfd', 'e0ecf4', 'bfd3e6', '9ebcda', '8c96c6', '8c6bb1',
          '88419d', '810f7c', '4d004b']
    },
    RdPu: {
      type: 'sequential',
      cbf: 42,
      3: ['fde0dd', 'fa9fb5', 'c51b8a'],
      4: ['feebe2', 'fbb4b9', 'f768a1', 'ae017e'],
      5: ['feebe2', 'fbb4b9', 'f768a1', 'c51b8a', '7a0177'],
      6: ['feebe2', 'fcc5c0', 'fa9fb5', 'f768a1', 'c51b8a', '7a0177'],
      7: ['feebe2', 'fcc5c0', 'fa9fb5', 'f768a1', 'dd3497', 'ae017e',
          '7a0177'],
      8: ['fff7f3', 'fde0dd', 'fcc5c0', 'fa9fb5', 'f768a1', 'dd3497',
          'ae017e', '7a0177'],
      9: ['fff7f3', 'fde0dd', 'fcc5c0', 'fa9fb5', 'f768a1', 'dd3497',
          'ae017e', '7a0177', '49006a']
    },
    PuRd: {
      type: 'sequential',
      cbf: 42,
      3: ['e7e1ef', 'c994c7', 'dd1c77'],
      4: ['f1eef6', 'd7b5d8', 'df65b0', 'ce1256'],
      5: ['f1eef6', 'd7b5d8', 'df65b0', 'dd1c77', '980043'],
      6: ['f1eef6', 'd4b9da', 'c994c7', 'df65b0', 'dd1c77', '980043'],
      7: ['f1eef6', 'd4b9da', 'c994c7', 'df65b0', 'e7298a', 'ce1256',
          '91003f'],
      8: ['f7f4f9', 'e7e1ef', 'd4b9da', 'c994c7', 'df65b0', 'e7298a',
          'ce1256', '91003f'],
      9: ['f7f4f9', 'e7e1ef', 'd4b9da', 'c994c7', 'df65b0', 'e7298a',
          'ce1256', '980043', '67001f']
    },
    OrRd: {
      type: 'sequential',
      cbf: 42,
      3: ['fee8c8', 'fdbb84', 'e34a33'],
      4: ['fef0d9', 'fdcc8a', 'fc8d59', 'd7301f'],
      5: ['fef0d9', 'fdcc8a', 'fc8d59', 'e34a33', 'b30000'],
      6: ['fef0d9', 'fdd49e', 'fdbb84', 'fc8d59', 'e34a33', 'b30000'],
      7: ['fef0d9', 'fdd49e', 'fdbb84', 'fc8d59', 'ef6548', 'd7301f',
          '990000'],
      8: ['fff7ec', 'fee8c8', 'fdd49e', 'fdbb84', 'fc8d59', 'ef6548',
          'd7301f', '990000'],
      9: ['fff7ec', 'fee8c8', 'fdd49e', 'fdbb84', 'fc8d59', 'ef6548',
          'd7301f', 'b30000', '7f0000']
    },
    YlOrRd: {
      type: 'sequential',
      cbf: 42,
      3: ['ffeda0', 'feb24c', 'f03b20'],
      4: ['ffffb2', 'fecc5c', 'fd8d3c', 'e31a1c'],
      5: ['ffffb2', 'fecc5c', 'fd8d3c', 'f03b20', 'bd0026'],
      6: ['ffffb2', 'fed976', 'feb24c', 'fd8d3c', 'f03b20', 'bd0026'],
      7: ['ffffb2', 'fed976', 'feb24c', 'fd8d3c', 'fc4e2a', 'e31a1c',
          'b10026'],
      8: ['ffffcc', 'ffeda0', 'fed976', 'feb24c', 'fd8d3c', 'fc4e2a',
          'e31a1c', 'b10026'],
      9: ['ffffcc', 'ffeda0', 'fed976', 'feb24c', 'fd8d3c', 'fc4e2a',
          'e31a1c', 'bd0026', '800026']
    },
    YlOrBr: {
      type: 'sequential',
      cbf: 42,
      3: ['fff7bc', 'fec44f', 'd95f0e'],
      4: ['ffffd4', 'fed98e', 'fe9929', 'cc4c02'],
      5: ['ffffd4', 'fed98e', 'fe9929', 'd95f0e', '993404'],
      6: ['ffffd4', 'fee391', 'fec44f', 'fe9929', 'd95f0e', '993404'],
      7: ['ffffd4', 'fee391', 'fec44f', 'fe9929', 'ec7014', 'cc4c02',
          '8c2d04'],
      8: ['ffffe5', 'fff7bc', 'fee391', 'fec44f', 'fe9929', 'ec7014',
          'cc4c02', '8c2d04'],
      9: ['ffffe5', 'fff7bc', 'fee391', 'fec44f', 'fe9929', 'ec7014',
          'cc4c02', '993404', '662506']
    },
    Purples: {
      type: 'sequential',
      cbf: 42,
      3: ['efedf5', 'bcbddc', '756bb1'],
      4: ['f2f0f7', 'cbc9e2', '9e9ac8', '6a51a3'],
      5: ['f2f0f7', 'cbc9e2', '9e9ac8', '756bb1', '54278f'],
      6: ['f2f0f7', 'dadaeb', 'bcbddc', '9e9ac8', '756bb1', '54278f'],
      7: ['f2f0f7', 'dadaeb', 'bcbddc', '9e9ac8', '807dba', '6a51a3',
          '4a1486'],
      8: ['fcfbfd', 'efedf5', 'dadaeb', 'bcbddc', '9e9ac8', '807dba',
          '6a51a3', '4a1486'],
      9: ['fcfbfd', 'efedf5', 'dadaeb', 'bcbddc', '9e9ac8', '807dba',
          '6a51a3', '54278f', '3f007d']
    },
    Blues: {
      type: 'sequential',
      cbf: 42,
      3: ['deebf7', '9ecae1', '3182bd'],
      4: ['eff3ff', 'bdd7e7', '6baed6', '2171b5'],
      5: ['eff3ff', 'bdd7e7', '6baed6', '3182bd', '08519c'],
      6: ['eff3ff', 'c6dbef', '9ecae1', '6baed6', '3182bd', '08519c'],
      7: ['eff3ff', 'c6dbef', '9ecae1', '6baed6', '4292c6', '2171b5',
          '084594'],
      8: ['f7fbff', 'deebf7', 'c6dbef', '9ecae1', '6baed6', '4292c6',
          '2171b5', '084594'],
      9: ['f7fbff', 'deebf7', 'c6dbef', '9ecae1', '6baed6', '4292c6',
          '2171b5', '08519c', '08306b']
    },
    Greens: {
      type: 'sequential',
      cbf: 42,
      3: ['e5f5e0', 'a1d99b', '31a354'],
      4: ['edf8e9', 'bae4b3', '74c476', '238b45'],
      5: ['edf8e9', 'bae4b3', '74c476', '31a354', '006d2c'],
      6: ['edf8e9', 'c7e9c0', 'a1d99b', '74c476', '31a354', '006d2c'],
      7: ['edf8e9', 'c7e9c0', 'a1d99b', '74c476', '41ab5d', '238b45',
          '005a32'],
      8: ['f7fcf5', 'e5f5e0', 'c7e9c0', 'a1d99b', '74c476', '41ab5d',
          '238b45', '005a32'],
      9: ['f7fcf5', 'e5f5e0', 'c7e9c0', 'a1d99b', '74c476', '41ab5d',
          '238b45', '006d2c', '00441b']
    },
    Oranges: {
      type: 'sequential',
      cbf: 42,
      3: ['fee6ce', 'fdae6b', 'e6550d'],
      4: ['feedde', 'fdbe85', 'fd8d3c', 'd94701'],
      5: ['feedde', 'fdbe85', 'fd8d3c', 'e6550d', 'a63603'],
      6: ['feedde', 'fdd0a2', 'fdae6b', 'fd8d3c', 'e6550d', 'a63603'],
      7: ['feedde', 'fdd0a2', 'fdae6b', 'fd8d3c', 'f16913', 'd94801',
          '8c2d04'],
      8: ['fff5eb', 'fee6ce', 'fdd0a2', 'fdae6b', 'fd8d3c', 'f16913',
          'd94801', '8c2d04'],
      9: ['fff5eb', 'fee6ce', 'fdd0a2', 'fdae6b', 'fd8d3c', 'f16913',
          'd94801', 'a63603', '7f2704']
    },
    Reds: {
      type: 'sequential',
      cbf: 42,
      3: ['fee0d2', 'fc9272', 'de2d26'],
      4: ['fee5d9', 'fcae91', 'fb6a4a', 'cb181d'],
      5: ['fee5d9', 'fcae91', 'fb6a4a', 'de2d26', 'a50f15'],
      6: ['fee5d9', 'fcbba1', 'fc9272', 'fb6a4a', 'de2d26', 'a50f15'],
      7: ['fee5d9', 'fcbba1', 'fc9272', 'fb6a4a', 'ef3b2c', 'cb181d',
          '99000d'],
      8: ['fff5f0', 'fee0d2', 'fcbba1', 'fc9272', 'fb6a4a', 'ef3b2c',
          'cb181d', '99000d'],
      9: ['fff5f0', 'fee0d2', 'fcbba1', 'fc9272', 'fb6a4a', 'ef3b2c',
          'cb181d', 'a50f15', '67000d']
    },
    Greys: {
      type: 'sequential',
      cbf: 42,
      3: ['f0f0f0', 'bdbdbd', '636363'],
      4: ['f7f7f7', 'cccccc', '969696', '525252'],
      5: ['f7f7f7', 'cccccc', '969696', '636363', '252525'],
      6: ['f7f7f7', 'd9d9d9', 'bdbdbd', '969696', '636363', '252525'],
      7: ['f7f7f7', 'd9d9d9', 'bdbdbd', '969696', '737373', '525252',
          '252525'],
      8: ['ffffff', 'f0f0f0', 'd9d9d9', 'bdbdbd', '969696', '737373',
          '525252', '252525'],
      9: ['ffffff', 'f0f0f0', 'd9d9d9', 'bdbdbd', '969696', '737373',
          '525252', '252525', '000000']
    },
    PuOr: {
      type: 'diverging',
      cbf: 42,
      3: ['f1a340', 'f7f7f7', '998ec3'],
      4: ['e66101', 'fdb863', 'b2abd2', '5e3c99'],
      5: ['e66101', 'fdb863', 'f7f7f7', 'b2abd2', '5e3c99'],
      6: ['b35806', 'f1a340', 'fee0b6', 'd8daeb', '998ec3', '542788'],
      7: ['b35806', 'f1a340', 'fee0b6', 'f7f7f7', 'd8daeb', '998ec3',
          '542788'],
      8: ['b35806', 'e08214', 'fdb863', 'fee0b6', 'd8daeb', 'b2abd2',
          '8073ac', '542788'],
      9: ['b35806', 'e08214', 'fdb863', 'fee0b6', 'f7f7f7', 'd8daeb',
          'b2abd2', '8073ac', '542788'],
      10: ['7f3b08', 'b35806', 'e08214', 'fdb863', 'fee0b6', 'd8daeb',
           'b2abd2', '8073ac', '542788', '2d004b'],
      11: ['7f3b08', 'b35806', 'e08214', 'fdb863', 'fee0b6', 'f7f7f7',
           'd8daeb', 'b2abd2', '8073ac', '542788', '2d004b']
    },
    BrBG: {
      type: 'diverging',
      cbf: 42,
      3: ['d8b365', 'f5f5f5', '5ab4ac'],
      4: ['a6611a', 'dfc27d', '80cdc1', '018571'],
      5: ['a6611a', 'dfc27d', 'f5f5f5', '80cdc1', '018571'],
      6: ['8c510a', 'd8b365', 'f6e8c3', 'c7eae5', '5ab4ac', '01665e'],
      7: ['8c510a', 'd8b365', 'f6e8c3', 'f5f5f5', 'c7eae5', '5ab4ac',
          '01665e'],
      8: ['8c510a', 'bf812d', 'dfc27d', 'f6e8c3', 'c7eae5', '80cdc1',
          '35978f', '01665e'],
      9: ['8c510a', 'bf812d', 'dfc27d', 'f6e8c3', 'f5f5f5', 'c7eae5',
          '80cdc1', '35978f', '01665e'],
      10: ['543005', '8c510a', 'bf812d', 'dfc27d', 'f6e8c3', 'c7eae5',
           '80cdc1', '35978f', '01665e', '003c30'],
      11: ['543005', '8c510a', 'bf812d', 'dfc27d', 'f6e8c3', 'f5f5f5',
           'c7eae5', '80cdc1', '35978f', '01665e', '003c30']
    },
    PRGn: {
      type: 'diverging',
      cbf: 42,
      3: ['af8dc3', 'f7f7f7', '7fbf7b'],
      4: ['7b3294', 'c2a5cf', 'a6dba0', '008837'],
      5: ['7b3294', 'c2a5cf', 'f7f7f7', 'a6dba0', '008837'],
      6: ['762a83', 'af8dc3', 'e7d4e8', 'd9f0d3', '7fbf7b', '1b7837'],
      7: ['762a83', 'af8dc3', 'e7d4e8', 'f7f7f7', 'd9f0d3', '7fbf7b',
          '1b7837'],
      8: ['762a83', '9970ab', 'c2a5cf', 'e7d4e8', 'd9f0d3', 'a6dba0',
          '5aae61', '1b7837'],
      9: ['762a83', '9970ab', 'c2a5cf', 'e7d4e8', 'f7f7f7', 'd9f0d3',
          'a6dba0', '5aae61', '1b7837'],
      10: ['40004b', '762a83', '9970ab', 'c2a5cf', 'e7d4e8', 'd9f0d3',
           'a6dba0', '5aae61', '1b7837', '00441b'],
      11: ['40004b', '762a83', '9970ab', 'c2a5cf', 'e7d4e8', 'f7f7f7',
           'd9f0d3', 'a6dba0', '5aae61', '1b7837', '00441b']
    },
    PiYG: {
      type: 'diverging',
      cbf: 42,
      3: ['e9a3c9', 'f7f7f7', 'a1d76a'],
      4: ['d01c8b', 'f1b6da', 'b8e186', '4dac26'],
      5: ['d01c8b', 'f1b6da', 'f7f7f7', 'b8e186', '4dac26'],
      6: ['c51b7d', 'e9a3c9', 'fde0ef', 'e6f5d0', 'a1d76a', '4d9221'],
      7: ['c51b7d', 'e9a3c9', 'fde0ef', 'f7f7f7', 'e6f5d0', 'a1d76a',
          '4d9221'],
      8: ['c51b7d', 'de77ae', 'f1b6da', 'fde0ef', 'e6f5d0', 'b8e186',
          '7fbc41', '4d9221'],
      9: ['c51b7d', 'de77ae', 'f1b6da', 'fde0ef', 'f7f7f7', 'e6f5d0',
          'b8e186', '7fbc41', '4d9221'],
      10: ['8e0152', 'c51b7d', 'de77ae', 'f1b6da', 'fde0ef', 'e6f5d0',
           'b8e186', '7fbc41', '4d9221', '276419'],
      11: ['8e0152', 'c51b7d', 'de77ae', 'f1b6da', 'fde0ef', 'f7f7f7',
           'e6f5d0', 'b8e186', '7fbc41', '4d9221', '276419']
    },
    RdBu: {
      type: 'diverging',
      cbf: 42,
      3: ['ef8a62', 'f7f7f7', '67a9cf'],
      4: ['ca0020', 'f4a582', '92c5de', '0571b0'],
      5: ['ca0020', 'f4a582', 'f7f7f7', '92c5de', '0571b0'],
      6: ['b2182b', 'ef8a62', 'fddbc7', 'd1e5f0', '67a9cf', '2166ac'],
      7: ['b2182b', 'ef8a62', 'fddbc7', 'f7f7f7', 'd1e5f0', '67a9cf',
          '2166ac'],
      8: ['b2182b', 'd6604d', 'f4a582', 'fddbc7', 'd1e5f0', '92c5de',
          '4393c3', '2166ac'],
      9: ['b2182b', 'd6604d', 'f4a582', 'fddbc7', 'f7f7f7', 'd1e5f0',
          '92c5de', '4393c3', '2166ac'],
      10: ['67001f', 'b2182b', 'd6604d', 'f4a582', 'fddbc7', 'd1e5f0',
           '92c5de', '4393c3', '2166ac', '053061'],
      11: ['67001f', 'b2182b', 'd6604d', 'f4a582', 'fddbc7', 'f7f7f7',
           'd1e5f0', '92c5de', '4393c3', '2166ac', '053061']
    },
    RdGy: {
      type: 'diverging',
      cbf: 42,
      3: ['ef8a62', 'ffffff', '999999'],
      4: ['ca0020', 'f4a582', 'bababa', '404040'],
      5: ['ca0020', 'f4a582', 'ffffff', 'bababa', '404040'],
      6: ['b2182b', 'ef8a62', 'fddbc7', 'e0e0e0', '999999', '4d4d4d'],
      7: ['b2182b', 'ef8a62', 'fddbc7', 'ffffff', 'e0e0e0', '999999',
          '4d4d4d'],
      8: ['b2182b', 'd6604d', 'f4a582', 'fddbc7', 'e0e0e0', 'bababa',
          '878787', '4d4d4d'],
      9: ['b2182b', 'd6604d', 'f4a582', 'fddbc7', 'ffffff', 'e0e0e0',
          'bababa', '878787', '4d4d4d'],
      10: ['67001f', 'b2182b', 'd6604d', 'f4a582', 'fddbc7', 'e0e0e0',
           'bababa', '878787', '4d4d4d', '1a1a1a'],
      11: ['67001f', 'b2182b', 'd6604d', 'f4a582', 'fddbc7', 'ffffff',
           'e0e0e0', 'bababa', '878787', '4d4d4d', '1a1a1a']
    },
    RdYlBu: {
      type: 'diverging',
      cbf: 42,
      3: ['fc8d59', 'ffffbf', '91bfdb'],
      4: ['d7191c', 'fdae61', 'abd9e9', '2c7bb6'],
      5: ['d7191c', 'fdae61', 'ffffbf', 'abd9e9', '2c7bb6'],
      6: ['d73027', 'fc8d59', 'fee090', 'e0f3f8', '91bfdb', '4575b4'],
      7: ['d73027', 'fc8d59', 'fee090', 'ffffbf', 'e0f3f8', '91bfdb',
          '4575b4'],
      8: ['d73027', 'f46d43', 'fdae61', 'fee090', 'e0f3f8', 'abd9e9',
          '74add1', '4575b4'],
      9: ['d73027', 'f46d43', 'fdae61', 'fee090', 'ffffbf', 'e0f3f8',
          'abd9e9', '74add1', '4575b4'],
      10: ['a50026', 'd73027', 'f46d43', 'fdae61', 'fee090', 'e0f3f8',
           'abd9e9', '74add1', '4575b4', '313695'],
      11: ['a50026', 'd73027', 'f46d43', 'fdae61', 'fee090', 'ffffbf',
           'e0f3f8', 'abd9e9', '74add1', '4575b4', '313695']
    },
    Spectral: {
      type: 'diverging',
      cbf: 0,
      3: ['fc8d59', 'ffffbf', '99d594'],
      4: ['d7191c', 'fdae61', 'abdda4', '2b83ba'],
      5: ['d7191c', 'fdae61', 'ffffbf', 'abdda4', '2b83ba'],
      6: ['d53e4f', 'fc8d59', 'fee08b', 'e6f598', '99d594', '3288bd'],
      7: ['d53e4f', 'fc8d59', 'fee08b', 'ffffbf', 'e6f598', '99d594',
          '3288bd'],
      8: ['d53e4f', 'f46d43', 'fdae61', 'fee08b', 'e6f598', 'abdda4',
          '66c2a5', '3288bd'],
      9: ['d53e4f', 'f46d43', 'fdae61', 'fee08b', 'ffffbf', 'e6f598',
          'abdda4', '66c2a5', '3288bd'],
      10: ['9e0142', 'd53e4f', 'f46d43', 'fdae61', 'fee08b', 'e6f598',
           'abdda4', '66c2a5', '3288bd', '5e4fa2'],
      11: ['9e0142', 'd53e4f', 'f46d43', 'fdae61', 'fee08b', 'ffffbf',
           'e6f598', 'abdda4', '66c2a5', '3288bd', '5e4fa2']
    },
    RdYlGn: {
      type: 'diverging',
      cbf: 0,
      3: ['fc8d59', 'ffffbf', '91cf60'],
      4: ['d7191c', 'fdae61', 'a6d96a', '1a9641'],
      5: ['d7191c', 'fdae61', 'ffffbf', 'a6d96a', '1a9641'],
      6: ['d73027', 'fc8d59', 'fee08b', 'd9ef8b', '91cf60', '1a9850'],
      7: ['d73027', 'fc8d59', 'fee08b', 'ffffbf', 'd9ef8b', '91cf60',
          '1a9850'],
      8: ['d73027', 'f46d43', 'fdae61', 'fee08b', 'd9ef8b', 'a6d96a',
          '66bd63', '1a9850'],
      9: ['d73027', 'f46d43', 'fdae61', 'fee08b', 'ffffbf', 'd9ef8b',
          'a6d96a', '66bd63', '1a9850'],
      10: ['a50026', 'd73027', 'f46d43', 'fdae61', 'fee08b', 'd9ef8b',
           'a6d96a', '66bd63', '1a9850', '006837'],
      11: ['a50026', 'd73027', 'f46d43', 'fdae61', 'fee08b', 'ffffbf',
           'd9ef8b', 'a6d96a', '66bd63', '1a9850', '006837']
    },
    Accent: {
      type: 'qualitative',
      cbf: 0,
      3: ['7fc97f', 'beaed4', 'fdc086'],
      4: ['7fc97f', 'beaed4', 'fdc086', 'ffff99'],
      5: ['7fc97f', 'beaed4', 'fdc086', 'ffff99', '386cb0'],
      6: ['7fc97f', 'beaed4', 'fdc086', 'ffff99', '386cb0', 'f0027f'],
      7: ['7fc97f', 'beaed4', 'fdc086', 'ffff99', '386cb0', 'f0027f',
          'bf5b17'],
      8: ['7fc97f', 'beaed4', 'fdc086', 'ffff99', '386cb0', 'f0027f',
          'bf5b17', '666666']
    },
    Dark2: {
      type: 'qualitative',
      cbf: 3,
      3: ['1b9e77', 'd95f02', '7570b3'],
      4: ['1b9e77', 'd95f02', '7570b3', 'e7298a'],
      5: ['1b9e77', 'd95f02', '7570b3', 'e7298a', '66a61e'],
      6: ['1b9e77', 'd95f02', '7570b3', 'e7298a', '66a61e', 'e6ab02'],
      7: ['1b9e77', 'd95f02', '7570b3', 'e7298a', '66a61e', 'e6ab02',
          'a6761d'],
      8: ['1b9e77', 'd95f02', '7570b3', 'e7298a', '66a61e', 'e6ab02',
          'a6761d', '666666']
    },
    Paired: {
      type: 'qualitative',
      cbf: 4,
      3: ['a6cee3', '1f78b4', 'b2df8a'],
      4: ['a6cee3', '1f78b4', 'b2df8a', '33a02c'],
      5: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99'],
      6: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c'],
      7: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
          'fdbf6f'],
      8: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
          'fdbf6f', 'ff7f00'],
      9: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
          'fdbf6f', 'ff7f00', 'cab2d6'],
      10: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
           'fdbf6f', 'ff7f00', 'cab2d6', '6a3d9a'],
      11: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
           'fdbf6f', 'ff7f00', 'cab2d6', '6a3d9a', 'ffff99'],
      12: ['a6cee3', '1f78b4', 'b2df8a', '33a02c', 'fb9a99', 'e31a1c',
           'fdbf6f', 'ff7f00', 'cab2d6', '6a3d9a', 'ffff99', 'b15928']
    },
    Pastel1: {
      type: 'qualitative',
      cbf: 0,
      3: ['fbb4ae', 'b3cde3', 'ccebc5'],
      4: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4'],
      5: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6'],
      6: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6', 'ffffcc'],
      7: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6', 'ffffcc',
          'e5d8bd'],
      8: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6', 'ffffcc',
          'e5d8bd', 'fddaec'],
      9: ['fbb4ae', 'b3cde3', 'ccebc5', 'decbe4', 'fed9a6', 'ffffcc',
          'e5d8bd', 'fddaec', 'f2f2f2']
    },
    Pastel2: {
      type: 'qualitative',
      cbf: 0,
      3: ['b3e2cd', 'fdcdac', 'cbd5e8'],
      4: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4'],
      5: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4', 'e6f5c9'],
      6: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4', 'e6f5c9', 'fff2ae'],
      7: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4', 'e6f5c9', 'fff2ae',
          'f1e2cc'],
      8: ['b3e2cd', 'fdcdac', 'cbd5e8', 'f4cae4', 'e6f5c9', 'fff2ae',
          'f1e2cc', 'cccccc']
    },
    Set1: {
      type: 'qualitative',
      cbf: 0,
      3: ['e41a1c', '377eb8', '4daf4a'],
      4: ['e41a1c', '377eb8', '4daf4a', '984ea3'],
      5: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00'],
      6: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00', 'ffff33'],
      7: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00', 'ffff33',
          'a65628'],
      8: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00', 'ffff33',
          'a65628', 'f781bf'],
      9: ['e41a1c', '377eb8', '4daf4a', '984ea3', 'ff7f00', 'ffff33',
          'a65628', 'f781bf', '999999']
    },
    Set2: {
      type: 'qualitative',
      cbf: 3,
      3: ['66c2a5', 'fc8d62', '8da0cb'],
      4: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3'],
      5: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3', 'a6d854'],
      6: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3', 'a6d854', 'ffd92f'],
      7: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3', 'a6d854', 'ffd92f',
          'e5c494'],
      8: ['66c2a5', 'fc8d62', '8da0cb', 'e78ac3', 'a6d854', 'ffd92f',
          'e5c494', 'b3b3b3']
    },
    Set3: {
      type: 'qualitative',
      cbf: 0,
      3: ['8dd3c7', 'ffffb3', 'bebada'],
      4: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072'],
      5: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3'],
      6: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462'],
      7: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
          'b3de69'],
      8: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
          'b3de69', 'fccde5'],
      9: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
          'b3de69', 'fccde5', 'd9d9d9'],
      10: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
           'b3de69', 'fccde5', 'd9d9d9', 'bc80bd'],
      11: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
           'b3de69', 'fccde5', 'd9d9d9', 'bc80bd', 'ccebc5'],
      12: ['8dd3c7', 'ffffb3', 'bebada', 'fb8072', '80b1d3', 'fdb462',
           'b3de69', 'fccde5', 'd9d9d9', 'bc80bd', 'ccebc5', 'ffed6f']
    }
  };

  for (var name in schemes) {
    var scheme = schemes[name];
    scheme = palette.Scheme.fromPalettes(
      'cb-' + name, [scheme.type, 'cb-' + scheme.type], scheme, 12, scheme.cbf);
    palette.register(scheme);
  }
})();

if(typeof module === "object" && module.exports) {
  module.exports = palette
}


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Randomize the order of the elements in a given array.
 * @param {Array} arr - The given array.
 * @param {Object} [options] - Optional configuration options.
 * @param {Boolean} [options.copy] - Sets if should return a shuffled copy of the given array. By default it's a falsy value.
 * @param {Function} [options.rng] - Specifies a custom random number generator.
 * @returns {Array}
 */
function shuffle(arr, options) {

  if (!Array.isArray(arr)) {
    throw new Error('shuffle expect an array as parameter.');
  }

  options = options || {};

  var collection = arr,
      len = arr.length,
      rng = options.rng || Math.random,
      random,
      temp;

  if (options.copy === true) {
    collection = arr.slice();
  }

  while (len) {
    random = Math.floor(rng() * len);
    len -= 1;
    temp = collection[len];
    collection[len] = collection[random];
    collection[random] = temp;
  }

  return collection;
};

/**
 * Pick one or more random elements from the given array.
 * @param {Array} arr - The given array.
 * @param {Object} [options] - Optional configuration options.
 * @param {Number} [options.picks] - Specifies how many random elements you want to pick. By default it picks 1.
 * @param {Function} [options.rng] - Specifies a custom random number generator.
 * @returns {Object}
 */
shuffle.pick = function(arr, options) {

  if (!Array.isArray(arr)) {
    throw new Error('shuffle.pick() expect an array as parameter.');
  }

  options = options || {};

  var rng = options.rng || Math.random,
      picks = options.picks || 1;

  if (typeof picks === 'number' && picks !== 1) {
    var len = arr.length,
        collection = arr.slice(),
        random = [],
        index;

    while (picks && len) {
      index = Math.floor(rng() * len);
      random.push(collection[index]);
      collection.splice(index, 1);
      len -= 1;
      picks -= 1;
    }

    return random;
  }

  return arr[Math.floor(rng() * arr.length)];
};

/**
 * Expose
 */
module.exports = shuffle;


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sentenceTemplates; });
var sentenceTemplates={1:["qimugta","the dog",[["Insert",["np"],[[["qimugta",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","simple","simple",[[["qimugta","npn00.b"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["dog","npn00.b"]]]],3:["qimugteka","my dog",[["Insert",["np"],[[["qimugta",0,0,0]],[1,1,0,1],"Abs"]]],"noun phrase only","simple","possession",[[["qimugte","npn00.b"],["ka","1stperson"],[" ","space"]],[["my","1stperson"],["one","npn00.pd"],["dog","npn00.b"]]]],4:["qimugtem ciutek","the dog's two ears",[["Insert",["np"],[[["ciun",0,0,0]],[0,0,0,2],"Abs"]],["Insert",["np","n",-1],[[["qimugta",0,0,0]],[0,0,0,1]]]],"noun phrase only","simple","possession",[[["qimugte","npn10.b"],["m","npn10.pd"],[" ","space"],["ciute","npn00.b"],["k","npn00.pd"],[" ","space"]],[["the","npn10.ps"],["one","npn10.pd"],["dog's","npn10.b"],["two","npn00.pd"],["ears","npn00.b"]]]],6:["imarpigmi","in the ocean",[["Insert",["np"],[[["imarpik,imarpak",0,0,0]],[0,0,0,1],"Loc"]]],"noun phrase only","simple","oblique nouns",[[["imarpig","npn00.b"],["mi","npn00.c"],[" ","space"]],[["in or at","npn00.c"],["the","npn00.ps"],["one","npn00.pd"],["ocean, sea","npn00.b"]]]],7:["kipusvigmun","to the store",[["Insert",["np"],[[["kipusvik,kipuyvik",0,0,0]],[0,0,0,1],"Ter"]]],"noun phrase only","simple","oblique nouns",[[["kipusvig","npn00.b"],["mun","npn00.c"],[" ","space"]],[["toward","npn00.c"],["the","npn00.ps"],["one","npn00.pd"],["store","npn00.b"]]]],8:["Mamterillermek","from Bethel",[["Insert",["np"],[[["Mamterilleq",0,0,0]],[0,0,0,1],"Abl_Mod","from"]]],"noun phrase only","simple","oblique nouns",[[["Mamteriller","npn00.b"],["mek","npn00.c"],[" ","space"]],[["from","npn00.c"],["the","npn00.ps"],["one","npn00.pd"],["Bethel","npn00.b"]]]],9:["tengssuutekun","using, via an airplane",[["Insert",["np"],[[["tengssuun",0,0,0]],[0,0,0,1],"Via"]]],"noun phrase only","simple","oblique nouns",[[["tengssuute","npn00.b"],["kun","npn00.c"],[" ","space"]],[["through, using","npn00.c"],["the","npn00.ps"],["one","npn00.pd"],["airplane","npn00.b"]]]],10:["qimugtetun","like a dog",[["Insert",["np"],[[["qimugta",0,0,0]],[0,0,0,1],"Equ"]]],"noun phrase only","simple","oblique nouns",[[["qimugce","npn00.b"],["tun","npn00.c"],[" ","space"]],[["like","npn00.c"],["the","npn00.ps"],["one","npn00.pd"],["dog","npn00.b"]]]],12:["arnaq elitnaurista","the woman teacher",[["Insert",["np"],[[["elitnaurista",0,0,0]],[0,0,0,1],"Abs"]],["Insert",["np","n",0,-1],[[["arnaq",0,0,0]],[0,0,0,1]]]],"noun phrase only","simple","descriptors",[[["elitnaurista","npn00.b"],[" ","space"],["arnaq","npn01.b"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["woman","npn01.b"],["teacher","npn00.b"]]]],14:["piipirpak","the big baby",[["Insert",["np"],[[["piipiq",0,0,0],["-rpak,-rpag-",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","noun-noun postbases",[[["piipi","npn00.b"],["rpak","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["large","npn00.1"],["baby","npn00.b"]]]],15:["piipicuar","the small baby",[["Insert",["np"],[[["piipiq",0,0,0],["-cuar(aq*)",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","noun-noun postbases",[[["piipi","npn00.b"],["cuar","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["small","npn00.1"],["baby","npn00.b"]]]],16:["arnayagaq","the little/baby woman",[["Insert",["np"],[[["arnaq",0,0,0],["-ya(g)aq*,-yagaq*,-ya(g)ar-,-yagar-",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","noun-noun postbases",[[["arna","npn00.b"],["yagaq","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["baby or little","npn00.1"],["woman","npn00.b"]]]],17:["piipiqegtaar","the good baby",[["Insert",["np"],[[["piipiq",0,0,0],["-kegtaar(aq*)",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","noun-noun postbases",[[["piipi","npn00.b"],["kegtaar","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["good","npn00.1"],["baby","npn00.b"]]]],18:["piipiruaq","the fake baby",[["Insert",["np"],[[["piipiq",0,0,0],["+(ng)uaq,@~+(ng)uar-",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","noun-noun postbases",[[["piipir","npn00.b"],["uaq","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["imitation","npn00.1"],["baby","npn00.b"]]]],20:["pissulria","the one who is hunting",[["Insert",["np"],[[["pissur-",0,0,0],["-lria",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","verb-noun postbases",[[["pissu","npn00.b"],["lria","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["who is","npn00.1"],["hunting","npn00.b"]]]],21:["pissurvik","the place to hunt",[["Insert",["np"],[[["pissur-",0,0,0],["@~+vik,+(r)vik",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","verb-noun postbases",[[["pissur","npn00.b"],["vik","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["place to","npn00.1"],["hunt","npn00.b"]]]],22:["pissurcuun","the device for hunting",[["Insert",["np"],[[["pissur-",0,0,0],["+cuun|+ssuun",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","verb-noun postbases",[[["pissur","npn00.b"],["cuun","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["device for","npn00.1"],["hunting","npn00.b"]]]],23:["pissuryaraq","the way of hunting",[["Insert",["np"],[[["pissur-",0,0,0],["@~+yaraq",0,1,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","verb-noun postbases",[[["pissur","npn00.b"],["yaraq","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["way of","npn00.1"],["hunting","npn00.b"]]]],24:["pissutuli","the one that often hunts",[["Insert",["np"],[[["pissur-",0,0,0],["+tuli,-tuli",0,1,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","verb-noun postbases",[[["pissu","npn00.b"],["tuli","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["who is fully capable of","npn00.1"],["hunting","npn00.b"]]]],25:["pissuyuli","the one that is good at hunting",[["Insert",["np"],[[["pissur-",0,0,0],["@~-yuli",0,0,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","verb-noun postbases",[[["pissu","npn00.b"],["yuli","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["who is good at","npn00.1"],["hunting","npn00.b"]]]],26:["pissulleq","the act or state of hunting",[["Insert",["np"],[[["pissur-",0,0,0],["-lleq¹",0,1,0]],[0,0,0,1],"Abs"]]],"noun phrase only","postbases","verb-noun postbases",[[["pissu","npn00.b"],["lleq","npn00.1"],[" ","space"]],[["the","npn00.ps"],["one","npn00.pd"],["act or state of","npn00.1"],["hunting","npn00.b"]]]],29:["ner'uq","he is eating",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","statement sentence","subject only",[[["ner","mvv.b"],["'u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["eating","mvv.b"],["","mvv.b"]]]],30:["piipiq ner'uq","the baby is eating",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Ind"]],["Insert",["mv","ns"],[[["piipiq",0,0,0]],[0,0,0,1]]]],"verb (+ noun) statements","statement sentence","subject only",[[["piipiq","mvns00.b"],[" ","space"],["ner","mvv.b"],["'u","mvv.m"],["q","mvv.s"],[" ","space"]],[["the","mvns00.ps"],["one","mvns00.pd"],["baby","mvns00.b"],["is","mvv.m"],["eating","mvv.b"],["","mvv.b"]]]],32:["ner'uq","he is eating something",[["Insert",["mv"],[[["nere-",0,1,0]],"it","Ind"]]],"verb (+ noun) statements","statement sentence","subject with object not marked on verb",[[["ner","mvv.b"],["'u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["eating","mvv.b"],["something","mvv.abl"],["","mvv.b"]]]],33:["piipiq ner'uq","the baby is eathing something",[["Insert",["mv"],[[["nere-",0,1,0]],"it","Ind"]],["Insert",["mv","ns"],[[["piipiq",0,0,0]],[0,0,0,1]]]],"verb (+ noun) statements","statement sentence","subject with object not marked on verb",[[["piipiq","mvns00.b"],[" ","space"],["ner","mvv.b"],["'u","mvv.m"],["q","mvv.s"],[" ","space"]],[["the","mvns00.ps"],["one","mvns00.pd"],["baby","mvns00.b"],["is","mvv.m"],["eating","mvv.b"],["something","mvv.abl"],["","mvv.b"]]]],34:["ner'uq akutamek","he is eating some akutaq",[["Insert",["mv"],[[["nere-",0,1,0]],"it","Ind"]],["Insert",["mv","no"],[[["akutaq",0,0,1]],[0,0,0,1]]]],"verb (+ noun) statements","statement sentence","subject with object not marked on verb",[[["ner","mvv.b"],["'u","mvv.m"],["q","mvv.s"],[" ","space"],["akuta","mvno00.b"],["mek","mvno00.c"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["eating","mvv.b"],["(some)","mvno00.c"],["the","mvno00.ps"],["one","mvno00.pd"],["“Eskimo ice cream”","mvno00.b"],["","mvv.b"]]]],35:["piipiq ner'uq akutamek","the baby is eating some akutaq",[["Insert",["mv"],[[["nere-",0,1,0]],"it","Ind"]],["Insert",["mv","ns"],[[["piipiq",0,0,0]],[0,0,0,1]]],["Insert",["mv","no"],[[["akutaq",0,0,1]],[0,0,0,1]]]],"verb (+ noun) statements","statement sentence","subject with object not marked on verb",[[["piipiq","mvns00.b"],[" ","space"],["ner","mvv.b"],["'u","mvv.m"],["q","mvv.s"],[" ","space"],["akuta","mvno00.b"],["mek","mvno00.c"],[" ","space"]],[["the","mvns00.ps"],["one","mvns00.pd"],["baby","mvns00.b"],["is","mvv.m"],["eating","mvv.b"],["(some)","mvno00.c"],["the","mvno00.ps"],["one","mvno00.pd"],["“Eskimo ice cream”","mvno00.b"],["","mvv.b"]]]],37:["neraa","he is eating it",[["Insert",["mv"],[[["nere-",0,2,0]],"t","Ind"]]],"verb (+ noun) statements","statement sentence","subject and object marked on verb",[[["ner","mvv.b"],["a","mvv.m"],["a","mvv.o"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["eating","mvv.b"],["it","mvv.o"],["","mvv.b"]]]],38:["piipim neraa","the baby is eating it",[["Insert",["mv"],[[["nere-",0,2,0]],"t","Ind"]],["Insert",["mv","ns"],[[["piipiq",0,0,0]],[0,0,0,1]]]],"verb (+ noun) statements","statement sentence","subject and object marked on verb",[[["piipi","mvns00.b"],["m","mvns00.pd"],[" ","space"],["ner","mvv.b"],["a","mvv.m"],["a","mvv.o"],[" ","space"]],[["the","mvns00.ps"],["one","mvns00.pd"],["baby","mvns00.b"],["is","mvv.m"],["eating","mvv.b"],["it","mvv.o"],["","mvv.b"]]]],39:["neraa akutaq","he is eating the akutaq",[["Insert",["mv"],[[["nere-",0,2,0]],"t","Ind"]],["Insert",["mv","no"],[[["akutaq",0,0,1]],[0,0,0,1]]]],"verb (+ noun) statements","statement sentence","subject and object marked on verb",[[["ner","mvv.b"],["a","mvv.m"],["a","mvv.o"],[" ","space"],["akutaq","mvno00.b"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["eating","mvv.b"],["the","mvno00.ps"],["one","mvno00.pd"],["“Eskimo ice cream”","mvno00.b"],["","mvv.b"]]]],40:["piipim neraa akutaq","the baby is eating the akutaq",[["Insert",["mv"],[[["nere-",0,2,0]],"t","Ind"]],["Insert",["mv","ns"],[[["piipiq",0,0,0]],[0,0,0,1]]],["Insert",["mv","no"],[[["akutaq",0,0,1]],[0,0,0,1]]]],"verb (+ noun) statements","statement sentence","subject and object marked on verb",[[["piipi","mvns00.b"],["m","mvns00.pd"],[" ","space"],["ner","mvv.b"],["a","mvv.m"],["a","mvv.o"],[" ","space"],["akutaq","mvno00.b"],[" ","space"]],[["the","mvns00.ps"],["one","mvns00.pd"],["baby","mvns00.b"],["is","mvv.m"],["eating","mvv.b"],["the","mvno00.ps"],["one","mvno00.pd"],["“Eskimo ice cream”","mvno00.b"],["","mvv.b"]]]],42:["ner'uq natermi","he is sitting at/on the floor",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Ind"]],["Insert",["mv","nObliques"],[[["nateq",0,0,0]],[0,0,0,1],"Loc"]]],"verb (+ noun) statements","statement sentence","verb + oblique noun",[[["ner","mvv.b"],["'u","mvv.m"],["q","mvv.s"],[" ","space"],["nater","mvnObliques000.b"],["mi","mvnObliques000.c"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["eating","mvv.b"],["","mvv.b"],["in or at","mvnObliques000.c"],["the","mvnObliques000.ps"],["one","mvnObliques000.pd"],["floor","mvnObliques000.b"]]]],43:["ayagtuq Mamterillermun","he is going to Bethel",[["Insert",["mv"],[[["ayag¹-",0,0,0]],"i","Ind"]],["Insert",["mv","nObliques"],[[["Mamterilleq",0,0,0]],[0,0,0,1],"Ter"]]],"verb (+ noun) statements","statement sentence","verb + oblique noun",[[["ayag","mvv.b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"],["Mamteriller","mvnObliques000.b"],["mun","mvnObliques000.c"],[" ","space"]],[["he","mvv.s"],["left","mvv.b"],["","mvv.b"],["toward","mvnObliques000.c"],["the","mvnObliques000.ps"],["one","mvnObliques000.pd"],["Bethel","mvnObliques000.b"]]]],44:["utertuq elitnaurvigmek","he is returning from the school",[["Insert",["mv"],[[["uterte-",0,0,0]],"i","Ind"]],["Insert",["mv","nObliques"],[[["elitnaurvik",0,0,0]],[0,0,0,1],"Abl_Mod","from"]]],"verb (+ noun) statements","statement sentence","verb + oblique noun",[[["utert","mvv.b"],["u","mvv.m"],["q","mvv.s"],[" ","space"],["elitnaurvig","mvnObliques000.b"],["mek","mvnObliques000.c"],[" ","space"]],[["he","mvv.s"],["returned","mvv.b"],["","mvv.b"],["from","mvnObliques000.c"],["the","mvnObliques000.ps"],["one","mvnObliques000.pd"],["school","mvnObliques000.b"]]]],45:["ayagtuq tengssuutekun","he is going using/via airplane",[["Insert",["mv"],[[["ayag¹-",0,0,0]],"i","Ind"]],["Insert",["mv","nObliques"],[[["tengssuun",0,0,0]],[0,0,0,1],"Via"]]],"verb (+ noun) statements","statement sentence","verb + oblique noun",[[["ayag","mvv.b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"],["tengssuute","mvnObliques000.b"],["kun","mvnObliques000.c"],[" ","space"]],[["he","mvv.s"],["left","mvv.b"],["","mvv.b"],["through, using","mvnObliques000.c"],["the","mvnObliques000.ps"],["one","mvnObliques000.pd"],["airplane","mvnObliques000.b"]]]],46:["pangalegtuq qimugtetun","he is running on fours like a dog",[["Insert",["mv"],[[["pangaleg-",0,0,0]],"i","Ind"]],["Insert",["mv","nObliques"],[[["qimugta",0,0,0]],[0,0,0,1],"Equ"]]],"verb (+ noun) statements","statement sentence","verb + oblique noun",[[["pangaleg","mvv.b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"],["qimugce","mvnObliques000.b"],["tun","mvnObliques000.c"],[" ","space"]],[["it","mvv.s"],["is","mvv.m"],["running on four legs","mvv.b"],["","mvv.b"],["like","mvnObliques000.c"],["the","mvnObliques000.ps"],["one","mvnObliques000.pd"],["dog","mvnObliques000.b"]]]],48:["nerellruuq","he ate",[["Insert",["mv"],[[["nere-",0,0,0],["-llru¹-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","verb-verb postbases",[[["nere","mvv.b"],["llru","mvv.1b"],["u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["ate ","mvv.b"],["","mvv.b"]]]],49:["nerciquq","he will eat",[["Insert",["mv"],[[["nere-",0,0,0],["+ciqe-|@ciiqe-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","verb-verb postbases",[[["ner","mvv.b"],["ciq","mvv.1b"],["u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["will","future"],["eat ","mvv.b"],["","mvv.b"]]]],50:["nerenrituq","he is not eating",[["Insert",["mv"],[[["nere-",0,0,0],["-nrite-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","verb-verb postbases",[[["nere","mvv.b"],["nrit","mvv.1b"],["u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["does","mvv.m"],["not","mvv.1b"],["eat ","mvv.b"],["","mvv.b"]]]],51:["neryugtuq","he wants to eat",[["Insert",["mv"],[[["nere-",0,0,0],["@~+yug-,+(r)yug-",0,1,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","verb-verb postbases",[[["ner","mvv.b"],["yug","mvv.1b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["wants to","mvv.1b"],["eat ","mvv.b"],["","mvv.b"]]]],52:["neryugngauq","he can eat",[["Insert",["mv"],[[["nere-",0,0,0],["@~+yugnga-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","verb-verb postbases",[[["ner","mvv.b"],["yugnga","mvv.1b"],["u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["able to","mvv.1b"],["eat ","mvv.b"],["","mvv.b"]]]],53:["nerengnaquq","he is trying to eat",[["Insert",["mv"],[[["nere-",0,0,0],["-ngnaqe-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","verb-verb postbases",[[["nere","mvv.b"],["ngnaq","mvv.1b"],["u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["trying to","mvv.1b"],["eat ","mvv.b"],["","mvv.b"]]]],54:["nerlartuq","he regularly eats",[["Insert",["mv"],[[["nere-",0,0,0],["~+lar-,@~+lar-,-lar-",0,2,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","verb-verb postbases",[[["ner","mvv.b"],["lar","mvv.1b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["regularly","mvv.1b"],["eating","mvv.b"],["","mvv.b"]]]],55:["neryugnarquq","he is probably eating",[["Insert",["mv"],[[["nere-",0,0,0],["@~+yugnarqe¹-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","verb-verb postbases",[[["ner","mvv.b"],["yugnarq","mvv.1b"],["u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["eating","mvv.b"],["","mvv.b"],["probably","mvv.1b"]]]],56:["nerrsiyaagtuq","he is excessively eating",[["Insert",["mv"],[[["nere-",0,0,0],["-ssiyaag-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","verb-verb postbases",[[["nerr","mvv.b"],["siyaag","mvv.1b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["eating","mvv.b"],["","mvv.b"],["too much","mvv.1b"]]]],58:["angyangqertuq","he has a boat",[["Insert",["mv"],[[["angyaq,angyar-",0,0,0],["-ngqerr-",0,1,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","noun-verb postbases",[[["angya","mvv.b"],["ngqer","mvv.1b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["has","mvv.1b"],["a boat","mvv.b"]]]],59:["angyanguq","he acquired a boat",[["Insert",["mv"],[[["angyaq,angyar-",0,0,0],["-nge-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","noun-verb postbases",[[["angya","mvv.b"],["ng","mvv.1b"],["u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["has acquired","mvv.1b"],["a boat","mvv.b"]]]],60:["angyaliuq","he is making a boat",[["Insert",["mv"],[[["angyaq,angyar-",0,0,0],["-li²-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","noun-verb postbases",[[["angy","mvv.b"],["i","mvv.1b"],["u","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["making","mvv.1b"],["a boat","mvv.b"]]]],61:["angyalirtuq","he has lots of boats",[["Insert",["mv"],[[["angyaq,angyar-",0,0,0],["-lir-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","noun-verb postbases",[[["angy","mvv.b"],["ir","mvv.1b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["has lots of","mvv.1b"],["boats","mvv.b"]]]],62:["tuntussurtuq","he is hunting caribou",[["Insert",["mv"],[[["tuntu",0,0,0],["+ssur-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","noun-verb postbases",[[["tuntu","mvv.b"],["ssur","mvv.1b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["hunting","mvv.1b"],["caribous (Rangifer tarandus)","mvv.b"]]]],63:["tuntuturtuq","he is eating caribou",[["Insert",["mv"],[[["tuntu",0,0,0],["+tur²-",0,0,0]],"i","Ind"]]],"verb (+ noun) statements","postbases","noun-verb postbases",[[["tuntu","mvv.b"],["tur","mvv.1b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["eating (food), wearing (clothing), using","mvv.1b"],["caribou (Rangifer tarandus)","mvv.b"]]]],68:["kaigtuten-qaa?","are you hungry?",[["Insert",["mv"],[[["kaig-",0,0,0]],"i","Ind","qaa"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","yes-no question",[[["kaig","mvv.b"],["tu","mvv.m"],["ten","mvv.s"],["-qaa","qaa"],["?","questionMark"],[" ","space"]],[["are","mvv.m"],["you","mvv.s"],[" hungry","mvv.b"],["","mvv.b"],["(yes or no)","qaa"]]]],69:["ayallruuq-qaa?","did he go?",[["Insert",["mv"],[[["ayag¹-",0,0,0],["-llru¹-",0,0,0]],"i","Ind","qaa"]],["Update",["mv","vs"],[3,1,1]]],"verb (+ noun) questions","question sentence","yes-no question",[[["aya","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["q","mvv.s"],["-qaa","qaa"],["?","questionMark"],[" ","space"]],[["did","past"],["he","mvv.s"],["(in the past)","mvv.1"],["leave ","mvv.b"],["","mvv.b"],["(yes or no)","qaa"]]]],71:["kina taiga?","who is coming?",[["Insert",["mv"],[[["tai-",0,0,0]],"i","Intrg","Intrg0"]],["Update",["mv","vs"],[3,1,1]]],"verb (+ noun) questions","question sentence","wh-question",[[["kina","mvqWord"],[" ","space"],["tai","mvv.b"],["ga","mvv.m"],["?","questionMark"],[" ","space"]],[["who","mvqWord"],["is","mvqWord"],["he","mvv.s"],["who","mvv.s"],["is","mvv.m"],["coming here","mvv.b"],["","mvv.b"]]]],72:["kia nerellruagu akutaqa?","who ate my akutaq?",[["Insert",["mv"],[[["nere-",0,2,0],["-llru¹-",0,0,0]],"t","Intrg","Intrg0"]],["Update",["mv","vs"],[3,1,1]],["Update",["mv","vo"],[3,1,3]],["Insert",["mv","no"],[[["akutaq",0,0,1]],[1,1,0,1]]]],"verb (+ noun) questions","question sentence","wh-question",[[["kia","mvqWord"],[" ","space"],["nere","mvv.b"],["llru","mvv.1"],["a","mvv.m"],["gu","mvv.o"],[" ","space"],["akuta","mvno00.b"],["qa","mvno00.ps"],["?","questionMark"],[" ","space"]],[["who","mvqWord"],["is","mvqWord"],["he","mvv.s"],["who","mvv.s"],["","mvv.1"],["ate ","mvv.b"],["my","mvno00.ps"],["one","mvno00.pd"],["“Eskimo ice cream”","mvno00.b"],["","mvv.b"]]]],74:["kina tangerciu?","who (specific) do you see?",[["Insert",["mv"],[[["tangerr-",0,2,0]],"t","Intrg","Intrg1"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,1]]],"verb (+ noun) questions","question sentence","wh-question",[[["kina","mvqWord"],[" ","space"],["tanger","mvv.b"],["ci","mvv.m"],["u","mvv.o"],["?","questionMark"],[" ","space"]],[["you","mvv.s"],["see","mvv.b"],["whom (person)","mvqWord"],["?","mvv.b"]]]],75:["kitumek tangercit?","who (non-specific) do you see?",[["Insert",["mv"],[[["tangerr-",0,1,0]],"it","Intrg","Intrg1"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["kitumek","mvqWord"],[" ","space"],["tanger","mvv.b"],["ci","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["you","mvv.s"],["see","mvv.b"],["whom (a person)","mvqWord"],["?","mvv.b"]]]],76:["ca igta?","what fell?",[["Insert",["mv"],[[["igte-",0,0,0]],"i","Intrg","Intrg2"]],["Update",["mv","vs"],[3,1,3]]],"verb (+ noun) questions","question sentence","wh-question",[[["ca","mvqWord"],[" ","space"],["igt","mvv.b"],["a","mvv.m"],["?","questionMark"],[" ","space"]],[["what","mvqWord"],["is","mvqWord"],["it","mvv.s"],["that","mvv.s"],["is","mvv.m"],["falling","mvv.b"],["","mvv.b"]]]],79:["camek kiputellrusit?","what did you buy?",[["Insert",["mv"],[[["kipute-",0,1,0],["-llru¹-",0,0,0]],"it","Intrg","Intrg3"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["camek","mvqWord"],[" ","space"],["kipute","mvv.b"],["llru","mvv.1"],["si","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["you","mvv.s"],["bought ","mvv.b"],["what (a thing)","mvqWord"],["?","mvv.b"]]]],80:["camek tangercit?","what do you see?",[["Insert",["mv"],[[["tangerr-",0,1,0]],"it","Intrg","Intrg3"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["camek","mvqWord"],[" ","space"],["tanger","mvv.b"],["ci","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["you","mvv.s"],["see","mvv.b"],["what (a thing)","mvqWord"],["?","mvv.b"]]]],81:["nani iqvallrusit?","at where did you pick berries?",[["Insert",["mv"],[[["iqvaq,iqvar-",0,1,0],["-llru¹-",0,0,0]],"i","Intrg","Intrg6"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["nani","mvqWord"],[" ","space"],["iqva","mvv.b"],["llru","mvv.1"],["si","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["where","mvqWord"],["did","past"],["you","mvv.s"],["pick berries","mvv.b"],["","mvv.b"]]]],82:["naken taillrusit?","from where did you come?",[["Insert",["mv"],[[["tai-",0,0,0],["-llru¹-",0,0,0]],"i","Intrg","Intrg7"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["naken","mvqWord"],[" ","space"],["tai","mvv.b"],["llru","mvv.1"],["si","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["from where","mvqWord"],["did","past"],["you","mvv.s"],["come here","mvv.b"],["","mvv.b"]]]],83:["natmun ayagcit?","toward where are you going?",[["Insert",["mv"],[[["ayag¹-",0,0,0]],"i","Intrg","Intrg8"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["natmun","mvqWord"],[" ","space"],["ayag","mvv.b"],["ci","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["to where","mvqWord"],["are","mvv.m"],["you","mvv.s"],["leaving","mvv.b"],["","mvv.b"]]]],84:["qangvaq tekitellrusit?","when (past) did you arrive?",[["Insert",["mv"],[[["tekite-",0,0,0],["-llru¹-",0,0,0]],"i","Intrg","Intrg4"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["qangvaq","mvqWord"],[" ","space"],["tekite","mvv.b"],["llru","mvv.1"],["si","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["when","mvqWord"],["did","past"],["you","mvv.s"],["(in the past)","mvv.1"],["arrive ","mvv.b"],["","mvv.b"]]]],85:["qaku ayagciqsit?","when (future) will you go?",[["Insert",["mv"],[[["ayag¹-",0,0,0],["+ciqe-|@ciiqe-",0,0,0]],"i","Intrg","Intrg5"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["qaku","mvqWord"],[" ","space"],["ayag","mvv.b"],["ciq","mvv.1"],["si","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["when will","mvqWord"],["you","mvv.s"],["(in the future)","mvv.1"],["leave ","mvv.b"],["","mvv.b"]]]],86:["ciin qavarnisit?","why are you sleepy?",[["Insert",["mv"],[[["qavarni-",0,0,0]],"i","Intrg","Intrg9"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["ciin","mvqWord"],[" ","space"],["qavarni","mvv.b"],["si","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["why","mvqWord"],["are","mvv.m"],["you","mvv.s"],[" sleepy","mvv.b"],["","mvv.b"]]]],87:["qaillun akngirtellrusit?","how did you get hurt?",[["Insert",["mv"],[[["akngirte-,aknirte-",0,0,0],["-llru¹-",0,0,0]],"i","Intrg","IntrgA"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) questions","question sentence","wh-question",[[["qaillun","mvqWord"],[" ","space"],["akngirte","mvv.b"],["llru","mvv.1"],["si","mvv.m"],["t","mvv.s"],["?","questionMark"],[" ","space"]],[["how","mvqWord"],["did","past"],["you","mvv.s"],["get hurt","mvv.b"],["","mvv.b"]]]],90:["neri","eat!",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Opt][PRS"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","optative",[[["ner","mvv.b"],["i","mvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["eat","mvv.b"],["","mvv.b"],["(right now)","mvv.com"]]]],91:["taikina","come (in the future)!",[["Insert",["mv"],[[["tai-",0,0,0]],"i","Opt][FUT"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","optative",[[["tai","mvv.b"],["ki","mvv.m"],["na","mvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["come here","mvv.b"],["","mvv.b"],["(in the future)","mvv.com"]]]],92:["usviipiiqnak","stop being crazy!",[["Insert",["mv"],[[["usviite-",0,0,0]],"i","Opt][PRS][NEG"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","optative",[[["usvii","mvv.b"],["piiqna","mvv.m"],["k","mvv.s"],[" ","space"]],[["you","mvv.s"],[", do not","mvv.m"],["be crazy","mvv.b"],["","mvv.b"],["(right now)","mvv.com"]]]],93:["kuingiryaqunak","don't smoke!",[["Insert",["mv"],[[["kuingiq,kuiniq,kuingir-,kuinir-",0,1,0]],"i","Opt][FUT][NEG"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","optative",[[["kuingir","mvv.b"],["yaquna","mvv.m"],["k","mvv.s"],[" ","space"]],[["you","mvv.s"],[", do not","mvv.m"],["smoke","mvv.b"],["","mvv.b"],["(in the future)","mvv.com"]]]],97:["teguqerru","please take it",[["Insert",["mv"],[[["tegu-",0,0,0],["-qar-",0,0,0]],"t","Opt][PRS"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]]],"verb (+ noun) commands","command sentence","optative",[[["tegu","mvv.b"],["qe","mvv.1"],["rru","mvv.o"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["take","mvv.b"],["it","mvv.o"],["","mvv.b"],["please","mvv.1"],["(right now)","mvv.com"]]]],99:["aqumluten","please sit down",[["Insert",["mv"],[[["aqume-",0,0,0]],"i","Sbrd"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","subordinative",[[["aqum","mvv.b"],["lu","mvv.m"],["ten","mvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["sit down","mvv.b"],["","mvv.b"],["(polite request)","mvv.com"]]]],100:["alingevkenak","don't be scared",[["Insert",["mv"],[[["alinge-",0,0,0],["+peke-|+vke-,+pege-|+vke-",0,0,0]],"i","Sbrd"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","subordinative",[[["alinge","mvv.b"],["vke","mvv.1"],["na","mvv.m"],["k","mvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["do not","mvv.1"],["be afraid","mvv.b"],["","mvv.b"],["(polite request)","mvv.com"]]]],102:["neri","eat",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Opt][PRS"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","subject only",[[["ner","mvv.b"],["i","mvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["eat","mvv.b"],["","mvv.b"],["(right now)","mvv.com"]]]],103:["nerkina","eat (in the future)",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Opt][FUT"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","subject only",[[["ner","mvv.b"],["ki","mvv.m"],["na","mvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["eat","mvv.b"],["","mvv.b"],["(in the future)","mvv.com"]]]],104:["nerviiqnak","stop eating",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Opt][PRS][NEG"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","subject only",[[["ner","mvv.b"],["viiqna","mvv.m"],["k","mvv.s"],[" ","space"]],[["you","mvv.s"],[", do not","mvv.m"],["eat","mvv.b"],["","mvv.b"],["(right now)","mvv.com"]]]],105:["neryaqunak","don't eat",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Opt][FUT][NEG"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","subject only",[[["ner","mvv.b"],["yaquna","mvv.m"],["k","mvv.s"],[" ","space"]],[["you","mvv.s"],[", do not","mvv.m"],["eat","mvv.b"],["","mvv.b"],["(in the future)","mvv.com"]]]],106:["nerqaa","please eat",[["Insert",["mv"],[[["nere-",0,0,0],["-qar-",0,0,0]],"i","Opt][PRS"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","subject only",[[["ner","mvv.b"],["qa","mvv.1"],["a","mvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["eat","mvv.b"],["","mvv.b"],["please","mvv.1"],["(right now)","mvv.com"]]]],107:["nerluten","please eat",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Sbrd"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","subject only",[[["ner","mvv.b"],["lu","mvv.m"],["ten","mvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["eat","mvv.b"],["","mvv.b"],["(polite request)","mvv.com"]]]],108:["nerevkenak","please don't eat",[["Insert",["mv"],[[["nere-",0,0,0],["+peke-|+vke-,+pege-|+vke-",0,0,0]],"i","Sbrd","neg"]],["Update",["mv","vs"],[2,1,0]]],"verb (+ noun) commands","command sentence","subject only",[[["nere","mvv.b"],["vke","mvv.1"],["na","mvv.m"],["k","mvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["do not","mvv.1"],["eat ","mvv.b"],["","mvv.b"],["(polite request)","mvv.com"]]]],110:["taisgu","bring it here",[["Insert",["mv"],[[["taite²-",0,3,0]],"t","Opt][PRS"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]]],"verb (+ noun) commands","command sentence","subject and object marked",[[["tais","mvv.b"],["gu","mvv.o"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["bring","mvv.b"],["it","mvv.o"],["over","mvv.b"],["(right now)","mvv.com"]]]],111:["taiskiu","bring it here (in the future)",[["Insert",["mv"],[[["taite²-",0,3,0]],"t","Opt][FUT"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]]],"verb (+ noun) commands","command sentence","subject and object marked",[[["tais","mvv.b"],["ki","mvv.m"],["u","mvv.o"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["bring","mvv.b"],["it","mvv.o"],["over","mvv.b"],["(in the future)","mvv.com"]]]],112:["taipiiqnaku","stop bringing it here",[["Insert",["mv"],[[["taite²-",0,3,0]],"t","Opt][PRS][NEG"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]]],"verb (+ noun) commands","command sentence","subject and object marked",[[["tai","mvv.b"],["piiqna","mvv.m"],["ku","mvv.o"],[" ","space"]],[["you","mvv.s"],[", do not","mvv.m"],["bring","mvv.b"],["it","mvv.o"],["over","mvv.b"],["(right now)","mvv.com"]]]],113:["taicaqunaku","don't bring it here",[["Insert",["mv"],[[["taite²-",0,3,0]],"t","Opt][FUT][NEG"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]]],"verb (+ noun) commands","command sentence","subject and object marked",[[["taic","mvv.b"],["aquna","mvv.m"],["ku","mvv.o"],[" ","space"]],[["you","mvv.s"],[", do not","mvv.m"],["bring","mvv.b"],["it","mvv.o"],["over","mvv.b"],["(in the future)","mvv.com"]]]],114:["taiteqerru","please bring it here",[["Insert",["mv"],[[["taite²-",0,3,0],["-qar-",0,0,0]],"t","Opt][PRS"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]]],"verb (+ noun) commands","command sentence","subject and object marked",[[["taite","mvv.b"],["qe","mvv.1"],["rru","mvv.o"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["bring","mvv.b"],["it","mvv.o"],["over","mvv.b"],["please","mvv.1"],["(right now)","mvv.com"]]]],115:["tailluku","please bring it here",[["Insert",["mv"],[[["taite²-",0,3,0]],"t","Sbrd"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]]],"verb (+ noun) commands","command sentence","subject and object marked",[[["tai","mvv.b"],["llu","mvv.m"],["ku","mvv.e"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["bring","mvv.b"],["it","mvv.o"],["over","mvv.b"],["(polite request)","mvv.com"]]]],116:["taitevkenaku","please don't bring it here",[["Insert",["mv"],[[["taite²-",0,3,0],["+peke-|+vke-,+pege-|+vke-",0,0,0]],"t","Sbrd","neg"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]]],"verb (+ noun) commands","command sentence","subject and object marked",[[["taite","mvv.b"],["vke","mvv.1"],["na","mvv.m"],["ku","mvv.e"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["do not","mvv.1"],["bring ","mvv.b"],["it","mvv.o"],["over","mvv.b"],["(polite request)","mvv.com"]]]],119:["ayagpailgan payugeskiu","before he leaves, take some food to her",[["Insert",["mv"],[[["payugte-",0,0,0]],"t","Opt][FUT"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,2]],["Insert",["cv"],[[["ayag¹-",0,0,0]],"i","Prec"]],["Update",["cv","vs"],[3,1,2]]],"verb + verb phrase sentence","connective verb","before...",[[["payuges","mvv.b"],["ki","mvv.m"],["u","mvv.o"],[" ","space"],["ayag","cvv.b"],["pailg","cvv.m"],["an","cvv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["take some food to","mvv.b"],["her","mvv.o"],["","mvv.b"],["(in the future)","mvv.com"],["before","cvv.m"],["she","cvv.s"],["leaves","cvv.b"],["","cvv.b"]]]],120:["ayagpailegpet kaassaq yuvrirniaran","before you go, check the gas",[["Insert",["mv"],[[["yuvrir-",0,2,0],["@~+niar-",0,0,0]],"t","Ind"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]],["Insert",["mv","no"],[[["kaassaq",0,0,0]],[0,0,0,1]]],["Insert",["cv"],[[["ayag¹-",0,0,0]],"i","Prec"]],["Update",["cv","vs"],[2,1,0]]],"verb + verb phrase sentence","connective verb","before...",[[["yuvrir","mvv.b"],["niar","mvv.1"],["a","mvv.m"],["n","mvv.s"],[" ","space"],["kaassaq","mvno00.b"],[" ","space"],["ayag","cvv.b"],["paileg","cvv.m"],["pet","cvv.s"],[" ","space"]],[["you","mvv.s"],["will","future"],["examine ","mvv.b"],["the","mvno00.ps"],["one","mvno00.pd"],["gas","mvno00.b"],["","mvv.b"],["before","cvv.m"],["you","cvv.s"],["leave","cvv.b"],["","cvv.b"]]]],121:["anvailegpet aturarkaten yuvrirniaraten","before you go out, check the clothing you will use",[["Insert",["mv"],[[["yuvrir-",0,2,0],["@~+niar-",0,0,0]],"t","Ind"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,3,1]],["Insert",["mv","no"],[[["aturaq",0,0,0],["+kaq",0,0,0]],[0,0,0,3]]],["Insert",["cv"],[[["ane-",0,0,0]],"i","Prec"]],["Update",["cv","vs"],[2,1,0]]],"verb + verb phrase sentence","connective verb","before...",[[["yuvrir","mvv.b"],["niar","mvv.1"],["a","mvv.m"],["ten","mvv.s"],[" ","space"],["aturar","mvno00.b"],["ka","mvno00.1"],["t","mvno00.pd"],[" ","space"],["an","cvv.b"],["vaileg","cvv.m"],["pet","cvv.s"],[" ","space"]],[["you","mvv.s"],["will","future"],["examine ","mvv.b"],["the","mvno00.ps"],["three or more","mvno00.pd"],["future","mvno00.1"],["articles of clothing","mvno00.b"],["","mvv.b"],["before","cvv.m"],["you","cvv.s"],["go out","cvv.b"],["","cvv.b"]]]],122:["kuimarpailegpet neryaqunak","do not eat before swimming",[["Insert",["mv"],[[["nere-",0,0,0]],"i","Opt][FUT][NEG"]],["Update",["mv","vs"],[2,1,0]],["Insert",["cv"],[[["kuimar-",0,0,0]],"i","Prec"]],["Update",["cv","vs"],[2,1,0]]],"verb + verb phrase sentence","connective verb","before...",[[["ner","mvv.b"],["yaquna","mvv.m"],["k","mvv.s"],[" ","space"],["kuimar","cvv.b"],["paileg","cvv.m"],["pet","cvv.s"],[" ","space"]],[["you","mvv.s"],[", do not","mvv.m"],["eat","mvv.b"],["","mvv.b"],["(in the future)","mvv.com"],["before","cvv.m"],["you","cvv.s"],["swim","cvv.b"],["","cvv.b"]]]],126:["kaigtuten nereksailavet nerevkarilriani","you're hungry because you didn't eat at the feast",[["Insert",["mv"],[[["kaig-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[2,1,0]],["Insert",["cv"],[[["nere-",0,0,0],["-ksaite-",0,0,0]],"i","Cnsq"]],["Update",["cv","vs"],[2,1,0]],["Insert",["cv","nObliques"],[[["nerevkari-",0,0,0],["-lria",0,0,0]],[0,0,0,3],"Loc"]]],"verb + verb phrase sentence","connective verb","because...",[[["kaig","mvv.b"],["tu","mvv.m"],["ten","mvv.s"],[" ","space"],["nere","cvv.b"],["ksail","cvv.1"],["nga","cvv.m"],["vet","cvv.s"],[" ","space"],["nerevkari","cvnObliques000.b"],["lria","cvnObliques000.1"],["ni","cvnObliques000.c"],[" ","space"]],[["you","mvv.s"],["are","mvv.m"],[" hungry","mvv.b"],["","mvv.b"],["because","cvv.m"],["you","cvv.s"],["had not","cvv.1"],["eaten ","cvv.b"],["","cvv.b"],["in or at","mvnObliques000.c"],["the","cvnObliques000.ps"],["three or more","cvnObliques000.pd"],["that are","cvnObliques000.1"],["having a feast","cvnObliques000.b"]]]],127:["utercugtua naulluungama","I want to go home because I am sick",[["Insert",["mv"],[[["uterte-",0,0,0],["@~+yug-,+(r)yug-",0,1,0]],"i","Ind"]],["Update",["mv","vs"],[1,1,0]],["Insert",["cv"],[[["naulluu-",0,0,0]],"i","Cnsq"]],["Update",["cv","vs"],[1,1,0]]],"verb + verb phrase sentence","connective verb","because...",[[["uterc","mvv.b"],["ug","mvv.1"],["tu","mvv.m"],["a","mvv.s"],[" ","space"],["naulluu","cvv.b"],["nga","cvv.m"],["ma","cvv.s"],[" ","space"]],[["I","mvv.s"],["want to","mvv.1"],["return ","mvv.b"],["","mvv.b"],["because","cvv.m"],["I","cvv.s"],["was","past"],[" sick","cvv.b"],["","cvv.b"]]]],129:["cen̄irtaalaavet qusertuten","because you visit around, you have a cold",[["Insert",["mv"],[[["quseq,quser-",0,1,0]],"i","Ind"]],["Update",["mv","vs"],[2,1,0]],["Insert",["cv"],[[["cen̄irtaar-",0,0,0],["~+lar-,@~+lar-,-lar-",0,2,0]],"i","Cnsq"]],["Update",["cv","vs"],[2,1,0]]],"verb + verb phrase sentence","connective verb","because...",[[["quser","mvv.b"],["tu","mvv.m"],["ten","mvv.s"],[" ","space"],["cen̄irtaa","cvv.b"],["la","cvv.1"],["a","cvv.m"],["vet","cvv.s"],[" ","space"]],[["you","mvv.s"],["have a cold","mvv.b"],["","mvv.b"],["because","cvv.m"],["you","cvv.s"],["regularly","cvv.1"],["visited around","cvv.b"],["","cvv.b"]]]],130:["kuuvviarpakaama qiivua","i'm shaky because i drank lots of coffee",[["Insert",["mv"],[[["qiive-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[1,1,0]],["Insert",["cv"],[[["kuuvviaq,kuuvviar-",0,1,0],["@+pakar-|~vakar-,-qpakar-",0,0,0]],"i","Cnsq"]],["Update",["cv","vs"],[1,1,0]]],"verb + verb phrase sentence","connective verb","because...",[[["qiiv","mvv.b"],["u","mvv.m"],["a","mvv.s"],[" ","space"],["kuuvviar","cvv.b"],["paka","cvv.1"],["a","cvv.m"],["ma","cvv.s"],[" ","space"]],[["I","mvv.s"],["am","mvv.m"],["trembling","mvv.b"],["","mvv.b"],["because","cvv.m"],["I","cvv.s"],["drank coffee","cvv.b"],["","cvv.b"],["so much","cvv.1"]]]],132:["nunataqavet nemni uitayugngauten","whenever you come to the village, you can stay at my house",[["Insert",["mv"],[[["uita-",0,0,0],["@~+yugnga-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[2,1,0]],["Insert",["mv","nObliques"],[[["[e]naᵉ,enaᵉ",0,0,0]],[1,1,0,1],"Loc"]],["Insert",["cv"],[[["nunate-",0,0,0]],"i","Cont"]],["Update",["cv","vs"],[2,1,0]]],"verb + verb phrase sentence","connective verb","whenever...",[[["uita","mvv.b"],["yugnga","mvv.1"],["u","mvv.m"],["ten","mvv.s"],[" ","space"],["ne","mvnObliques000.b"],["m","mvnObliques000.ps"],["ni","mvnObliques000.c"],[" ","space"],["nunat","cvv.b"],["aqa","cvv.m"],["vet","cvv.s"],[" ","space"]],[["you","mvv.s"],["are","mvv.m"],["able to","mvv.1"],["situate ","mvv.b"],["","mvv.b"],["in or at","mvnObliques000.c"],["my","mvnObliques000.ps"],["one","mvnObliques000.pd"],["house","mvnObliques000.b"],["whenever","cvv.m"],["you","cvv.s"],["visit in another village","cvv.b"],["","cvv.b"]]]],133:["ner'aqami cukangnaq'lartuq","whenever he eats, he tries to be quick",[["Insert",["mv"],[[["cuka-",0,0,0],["-ngnaqe-",0,0,0],["~+lar-,@~+lar-,-lar-",0,2,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,1]],["Insert",["cv"],[[["nere-",0,0,0]],"i","Cont"]],["Update",["cv","vs"],[4,1,0]]],"verb + verb phrase sentence","connective verb","whenever...",[[["cuka","mvv.b"],["ngnaq'","mvv.1"],["lar","mvv.2"],["tu","mvv.m"],["q","mvv.s"],[" ","space"],["ner","cvv.b"],["'aqa","cvv.m"],["mi","cvv.s"],[" ","space"]],[["he","mvv.s"],["is","mvv.m"],["regularly","mvv.2"],["trying to","mvv.1"],["be fast","mvv.b"],["","mvv.b"],["whenever","cvv.m"],["he","cvv.s"],["eats","cvv.b"],["","cvv.b"]]]],134:["maantaqavet nunaniryulartua","whenever you are here, i am joyful",[["Insert",["mv"],[[["nunaniryug-",0,0,0],["~+lar-,@~+lar-,-lar-",0,2,0]],"i","Ind"]],["Update",["mv","vs"],[1,1,0]],["Insert",["cv"],[[["maante-",0,0,0]],"i","Cont"]],["Update",["cv","vs"],[2,1,0]]],"verb + verb phrase sentence","connective verb","whenever...",[[["nunaniryu","mvv.b"],["lar","mvv.1"],["tu","mvv.m"],["a","mvv.s"],[" ","space"],["maant","cvv.b"],["aqa","cvv.m"],["vet","cvv.s"],[" ","space"]],[["I","mvv.s"],["am","mvv.m"],["regularly","mvv.1"],[" happy","mvv.b"],["","mvv.b"],["whenever","cvv.m"],["you","cvv.s"],["are","mvv.m"],[" here","cvv.b"],["","cvv.b"]]]],135:["agiirtaqavet qiilertelartua","whenevery you come from the distance, i get excited",[["Insert",["mv"],[[["qiilerte-",0,0,0],["~+lar-,@~+lar-,-lar-",0,2,0]],"i","Ind"]],["Update",["mv","vs"],[1,1,0]],["Insert",["cv"],[[["agiirte-",0,0,0]],"i","Cont"]],["Update",["cv","vs"],[2,1,0]]],"verb + verb phrase sentence","connective verb","whenever...",[[["qiilerte","mvv.b"],["lar","mvv.1"],["tu","mvv.m"],["a","mvv.s"],[" ","space"],["agiirt","cvv.b"],["aqa","cvv.m"],["vet","cvv.s"],[" ","space"]],[["I","mvv.s"],["am","mvv.m"],["regularly","mvv.1"],[" gleeful","mvv.b"],["","mvv.b"],["whenever","cvv.m"],["you","cvv.s"],["approach","cvv.b"],["","cvv.b"]]]],138:["angulluarungermi uqilalartuq","even though he is an old man, he runs fast",[["Insert",["mv"],[[["uqila-",0,0,0],["~+lar-,@~+lar-,-lar-",0,2,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,1]],["Insert",["cv"],[[["angulluaq",0,0,0],[":~(ng)u-",0,0,0]],"i","Conc","eventhough"]],["Update",["cv","vs"],[4,1,0]]],"verb + verb phrase sentence","connective verb","even though...",[[["uqila","mvv.b"],["lar","mvv.1"],["tu","mvv.m"],["q","mvv.s"],[" ","space"],["angulluar","cvv.b"],["u","cvv.1"],["nger","cvv.m"],["mi","cvv.s"],[" ","space"]],[["he","mvv.s"],["regularly","mvv.1"],["runs fast","mvv.b"],["","mvv.b"],["even though","cvv.m"],["he","cvv.s"],["is","mvv.m"],["","cvv.1"],["a old man","cvv.b"]]]],139:["yaaqsingraan paqcugaqa","even if it is far away, i want to check it",[["Insert",["mv"],[[["paqte-",0,2,0],["@~+yug-,+(r)yug-",0,1,0]],"t","Ind"]],["Update",["mv","vs"],[1,1,0]],["Update",["mv","vo"],[3,1,3]],["Insert",["cv"],[[["yaaqsig-",0,0,0]],"i","Conc","evenif"]],["Update",["cv","vs"],[3,1,3]]],"verb + verb phrase sentence","connective verb","even though...",[[["paqc","mvv.b"],["ug","mvv.1"],["a","mvv.m"],["qa","mvv.s"],[" ","space"],["yaaqsi","cvv.b"],["ngra","cvv.m"],["an","cvv.s"],[" ","space"]],[["I","mvv.s"],["want to","mvv.1"],["check ","mvv.b"],["it","mvv.o"],["","mvv.b"],["even if","cvv.m"],["it","cvv.s"],["is","mvv.m"],[" distant","cvv.b"],["","cvv.b"]]]],141:["qiangermi iluteqenrituq","even though he is crying, he is not emotionally pained",[["Insert",["mv"],[[["iluteqe-",0,0,0],["-nrite-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,1]],["Insert",["cv"],[[["qia-",0,0,0]],"i","Conc","eventhough"]],["Update",["cv","vs"],[4,1,0]]],"verb + verb phrase sentence","connective verb","even though...",[[["iluteqe","mvv.b"],["nrit","mvv.1"],["u","mvv.m"],["q","mvv.s"],[" ","space"],["qia","cvv.b"],["nger","cvv.m"],["mi","cvv.s"],[" ","space"]],[["he","mvv.s"],["does","mvv.m"],["not","mvv.1"],["grieve ","mvv.b"],["","mvv.b"],["even though","cvv.m"],["he","cvv.s"],["is","mvv.m"],["crying","cvv.b"],["","cvv.b"]]]],142:["ellallingraan angyaryugtua","even if it is raining, i want to go by boat",[["Insert",["mv"],[[["angyaq,angyar-",0,1,0],["@~+yug-,+(r)yug-",0,1,0]],"i","Ind"]],["Update",["mv","vs"],[1,1,0]],["Insert",["cv"],[[["ellallir-",0,0,0]],"i","Conc","evenif"]],["Update",["cv","vs"],[3,1,3]]],"verb + verb phrase sentence","connective verb","even though...",[[["angyar","mvv.b"],["yug","mvv.1"],["tu","mvv.m"],["a","mvv.s"],[" ","space"],["ellalli","cvv.b"],["ngra","cvv.m"],["an","cvv.s"],[" ","space"]],[["I","mvv.s"],["want to","mvv.1"],["go by boat","mvv.b"],["","mvv.b"],["even if","cvv.m"],["it","cvv.s"],["is","mvv.m"],["raining","cvv.b"],["","cvv.b"]]]],144:["tekiskuvet Mamterillermun kipusviggniartuten","when you arrive in Bethel, you'll go to the store",[["Insert",["mv"],[[["kipusvik,kipuyvik",0,0,0],["+te¹-",0,0,0],["@~+niar-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[2,1,0]],["Insert",["cv"],[[["tekite-",0,0,0]],"i","Cond","wheninthefuture"]],["Update",["cv","vs"],[2,1,0]],["Insert",["cv","nObliques"],[[["Mamterilleq",0,0,0]],[0,0,0,1],"Ter"]]],"verb + verb phrase sentence","connective verb","if, when in the future...",[[["kipusvigg","mvv.b"],["niar","mvv.2"],["tu","mvv.m"],["ten","mvv.s"],[" ","space"],["tekis","cvv.b"],["ku","cvv.m"],["vet","cvv.s"],[" ","space"],["Mamteriller","cvnObliques000.b"],["mun","cvnObliques000.c"],[" ","space"]],[["you","mvv.s"],["will","future"],["catch, go to","mvv.1"],["a store","mvv.b"],["when (in the future)","cvv.m"],["you","cvv.s"],["arrive","cvv.b"],["","cvv.b"],["toward","mvnObliques000.c"],["the","cvnObliques000.ps"],["one","cvnObliques000.pd"],["Bethel","cvnObliques000.b"]]]],146:["assikekuvgu qanruskia","if you like it, tell me",[["Insert",["mv"],[[["qanrute-",0,2,0]],"t","Opt][FUT"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[1,1,0]],["Insert",["cv"],[[["assike-",0,0,0]],"t","Cond","if"]],["Update",["cv","vs"],[2,1,0]],["Update",["cv","vo"],[3,1,3]]],"verb + verb phrase sentence","connective verb","if, when in the future...",[[["qanrus","mvv.b"],["ki","mvv.m"],["a","mvv.o"],[" ","space"],["assike","cvv.b"],["ku","cvv.m"],["v","cvv.s"],["gu","cvv.o"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["tell","mvv.b"],["me","mvv.o"],["","mvv.b"],["(in the future)","mvv.com"],["if","cvv.m"],["you","cvv.s"],["like","cvv.b"],["it","mvv.o"],["","cvv.b"]]]],147:["naspaayukuvgu ikircugngaan","if you want to try it, you can open it",[["Insert",["mv"],[[["ikirte-",0,2,0],["@~+yugnga-",0,0,0]],"t","Ind"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]],["Insert",["cv"],[[["naspaa-",0,2,0],["@~+yug-,+(r)yug-",0,1,0]],"t","Cond","if"]],["Update",["cv","vs"],[2,1,0]],["Update",["cv","vo"],[3,1,3]]],"verb + verb phrase sentence","connective verb","if, when in the future...",[[["ikirc","mvv.b"],["ugnga","mvv.1"],["a","mvv.m"],["n","mvv.s"],[" ","space"],["naspaa","cvv.b"],["yu","cvv.1"],["ku","cvv.m"],["v","cvv.s"],["gu","cvv.o"],[" ","space"]],[["you","mvv.s"],["are","mvv.m"],["able to","mvv.1"],["open ","mvv.b"],["it","mvv.o"],["","mvv.b"],["if","cvv.m"],["you","cvv.s"],["want to","cvv.1"],["try ","cvv.b"],["it","mvv.o"],["","cvv.b"]]]],148:["kaigciquten nerenrilkuvet","you will be hungry if you don't eat",[["Insert",["mv"],[[["kaig-",0,0,0],["+ciqe-|@ciiqe-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[2,1,0]],["Insert",["cv"],[[["nere-",0,0,0],["-nrite-",0,0,0]],"i","Cond","if"]],["Update",["cv","vs"],[2,1,0]]],"verb + verb phrase sentence","connective verb","if, when in the future...",[[["kaig","mvv.b"],["ciq","mvv.1"],["u","mvv.m"],["ten","mvv.s"],[" ","space"],["nere","cvv.b"],["nril","cvv.1"],["ku","cvv.m"],["vet","cvv.s"],[" ","space"]],[["you","mvv.s"],["will","future"],["be hungry","mvv.b"],["","mvv.b"],["if","cvv.m"],["you","cvv.s"],["do","mvv.m"],["not","cvv.1"],["eat ","cvv.b"],["","cvv.b"]]]],149:["nerciqut cen̄ireskuneng","they will eat when they visit",[["Insert",["mv"],[[["nere-",0,0,0],["+ciqe-|@ciiqe-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,3,0]],["Insert",["cv"],[[["cen̄irte-,cenirte-",0,0,0]],"i","Cond","wheninthefuture"]],["Update",["cv","vs"],[4,3,0]]],"verb + verb phrase sentence","connective verb","if, when in the future...",[[["ner","mvv.b"],["ciq","mvv.1"],["u","mvv.m"],["t","mvv.s"],[" ","space"],["cen̄ires","cvv.b"],["ku","cvv.m"],["neng","cvv.s"],[" ","space"]],[["they all (3+)","mvv.s"],["will","future"],["eat ","mvv.b"],["","mvv.b"],["when (in the future)","cvv.m"],["they all (3+)","cvv.s"],["go visiting","cvv.b"],["","cvv.b"]]]],150:["atuquvgu navegyaqunaku","if you use it, don't break it",[["Insert",["mv"],[[["naveg-",0,2,0]],"t","Opt][FUT][NEG"]],["Update",["mv","vs"],[2,1,0]],["Update",["mv","vo"],[3,1,3]],["Insert",["cv"],[[["atuq,atur-",0,3,0]],"t","Cond","if"]],["Update",["cv","vs"],[2,1,0]],["Update",["cv","vo"],[3,1,3]]],"verb + verb phrase sentence","connective verb","if, when in the future...",[[["naveg","mvv.b"],["yaquna","mvv.m"],["ku","mvv.o"],[" ","space"],["atu","cvv.b"],["qu","cvv.m"],["v","cvv.s"],["gu","cvv.o"],[" ","space"]],[["you","mvv.s"],[", do not","mvv.m"],["break","mvv.b"],["it","mvv.o"],["","mvv.b"],["(in the future)","mvv.com"],["if","cvv.m"],["you","cvv.s"],["use","cvv.b"],["it","mvv.o"],["","cvv.b"]]]],152:["qavarningllerpeni anellruunga","when you were getting sleepy, i went out",[["Insert",["mv"],[[["ane-",0,0,0],["-llru¹-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[1,1,0]],["Insert",["cv"],[[["qavarni-",0,0,0],["-nge-",0,1,0]],"i","CtmpI"]],["Update",["cv","vs"],[2,1,0]]],"verb + verb phrase sentence","connective verb","when in the past...",[[["ane","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["nga","mvv.s"],[" ","space"],["qavarni","cvv.b"],["ng","cvv.1"],["ller","cvv.m"],["peni","cvv.s"],[" ","space"]],[["I","mvv.s"],["went out","mvv.b"],["","mvv.b"],["when","cvv.m"],["you","cvv.s"],["were","past"],["beginning to","cvv.1"],["be sleepy","cvv.b"],["","cvv.b"]]]],154:["maqillemni uutellruunga","when i took a maqi, i burned (flesh)",[["Insert",["mv"],[[["uute-",0,0,0],["-llru¹-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[1,1,0]],["Insert",["cv"],[[["maqi-",0,0,0]],"i","CtmpI"]],["Update",["cv","vs"],[1,1,0]]],"verb + verb phrase sentence","connective verb","when in the past...",[[["uute","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["nga","mvv.s"],[" ","space"],["maqi","cvv.b"],["lle","cvv.m"],["mni","cvv.s"],[" ","space"]],[["I","mvv.s"],["burnt myself","mvv.b"],["","mvv.b"],["when","cvv.m"],["I","cvv.s"],["took a sweatbath","cvv.b"],["","cvv.b"]]]],155:["quyallruuq cen̄irtellratni","she was happy when they visited her",[["Insert",["mv"],[[["quya-",0,0,0],["-llru¹-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,2]],["Insert",["cv"],[[["cen̄irte-,cenirte-",0,2,0]],"t","CtmpI"]],["Update",["cv","vs"],[3,3,0]],["Update",["cv","vo"],[4,1,0]]],"verb + verb phrase sentence","connective verb","when in the past...",[[["quya","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["q","mvv.s"],[" ","space"],["cen̄irte","cvv.b"],["llr","cvv.m"],["at","cvv.s"],["ni","cvv.o"],[" ","space"]],[["she","mvv.s"],["was","past"],["thankful, glad","mvv.b"],["","mvv.b"],["when","cvv.m"],["they all (3+)","cvv.s"],["went to visit","cvv.b"],["her","mvv.o"],["","cvv.b"]]]],157:["ayainanemni massiinaqa navellruuq","while i was going, my motor broke",[["Insert",["mv"],[[["naveg-",0,0,0],["-llru¹-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,3]],["Insert",["mv","ns"],[[["massiinaq",0,0,0]],[1,1,0,1]]],["Insert",["cv"],[[["ayag¹-",0,0,0]],"i","CtmpII"]],["Update",["cv","vs"],[1,1,0]]],"verb + verb phrase sentence","connective verb","while...",[[["massiina","mvns00.b"],["qa","mvns00.ps"],[" ","space"],["nave","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["q","mvv.s"],[" ","space"],["ayag","cvv.b"],["inane","cvv.m"],["mni","cvv.s"],[" ","space"]],[["my","mvns00.ps"],["one","mvns00.pd"],["machine","mvns00.b"],["broke ","mvv.b"],["","mvv.b"],["while","cvv.m"],["I","cvv.s"],["left","cvv.b"],["","cvv.b"]]]],158:["qianginanrani camek niitellruuq","while he were crying, he heard something",[["Insert",["mv"],[[["niite-",0,1,0],["-llru¹-",0,0,0]],"it","Ind"]],["Update",["mv","vs"],[3,1,1]],["Insert",["mv","no"],[[["ca,ca-",0,0,1]],[0,0,0,1]]],["Insert",["cv"],[[["qia-",0,0,0]],"i","CtmpII"]],["Update",["cv","vs"],[3,1,1]]],"verb + verb phrase sentence","connective verb","while...",[[["niite","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["q","mvv.s"],[" ","space"],["ca","mvno00.b"],["mek","mvno00.c"],[" ","space"],["qia","cvv.b"],["nginanr","cvv.m"],["ani","cvv.s"],[" ","space"]],[["he","mvv.s"],["heard ","mvv.b"],["(some)","mvno00.c"],["the","mvno00.ps"],["one","mvno00.pd"],["something","mvno00.b"],["","mvv.b"],["while","cvv.m"],["he","cvv.s"],["cried","cvv.b"],["","cvv.b"]]]],162:["cukaluni kiturtuq","it passed by quickly",[["Insert",["mv"],[[["kitur-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,1]],["Insert",["sv"],[[["cuka-",0,0,0]],"i","Sbrd","being"]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["kitur","mvv.b"],["tu","mvv.m"],["q","mvv.s"],[" ","space"],["cuka","svv.b"],["lu","svv.m"],["ni","svv.s"],[" ","space"]],[["he","mvv.s"],["passed by","mvv.b"],["","mvv.b"],["being fast","svv.b"]]]],163:["taiciquq piyualuni","he will come (by) walking",[["Insert",["mv"],[[["tai-",0,0,0],["+ciqe-|@ciiqe-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,1]],["Insert",["sv"],[[["piyua-",0,0,0]],"i","Sbrd","by"]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["tai","mvv.b"],["ciq","mvv.1"],["u","mvv.m"],["q","mvv.s"],[" ","space"],["piyua","svv.b"],["lu","svv.m"],["ni","svv.s"],[" ","space"]],[["he","mvv.s"],["will","future"],["come here","mvv.b"],["","mvv.b"],["by","svv.subtype"],["walking","svv.b"]]]],164:["ayallruuq cavluni","he went (by) rowing",[["Insert",["mv"],[[["ayag¹-",0,0,0],["-llru¹-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,1]],["Insert",["sv"],[[["cave-",0,0,0]],"i","Sbrd","by"]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["aya","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["q","mvv.s"],[" ","space"],["cav","svv.b"],["lu","svv.m"],["ni","svv.s"],[" ","space"]],[["he","mvv.s"],["left ","mvv.b"],["","mvv.b"],["by","svv.subtype"],["rowing","svv.b"]]]],165:["itellruunga tangerrsugluku","i came in wanting to see her",[["Insert",["mv"],[[["iter-",0,0,0],["-llru¹-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[1,1,0]],["Insert",["sv"],[[["tangerr-",0,2,0],["@~+yug-,+(r)yug-",0,1,0]],"t","Sbrd","being"]],["Update",["sv","vo"],[3,1,2]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["ite","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["nga","mvv.s"],[" ","space"],["tangerr","svv.b"],["sug","svv.1"],["lu","svv.m"],["ku","svv.e"],[" ","space"]],[["I","mvv.s"],["came in","mvv.b"],["","mvv.b"],["wanting to","svv.1"],["see ","svv.b"],["her","mvv.o"]]]],167:["yurartuten assirluten","you are dancing well (literally: 'being good (at it)')",[["Insert",["mv"],[[["yuraq,yurar¹-",0,1,0]],"i","Ind"]],["Update",["mv","vs"],[2,1,0]],["Insert",["sv"],[[["assir-",0,0,0]],"i","Sbrd","being"]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["yurar","mvv.b"],["tu","mvv.m"],["ten","mvv.s"],[" ","space"],["assir","svv.b"],["lu","svv.m"],["ten","svv.s"],[" ","space"]],[["you","mvv.s"],["are","mvv.m"],["dancing","mvv.b"],["","mvv.b"],["being well","svv.b"]]]],168:["aqvaqurtut cukaluteng","they are running fast (being fast)",[["Insert",["mv"],[[["aqvaqur-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,3,0]],["Insert",["sv"],[[["cuka-",0,0,0]],"i","Sbrd","being"]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["aqvaqur","mvv.b"],["tu","mvv.m"],["t","mvv.s"],[" ","space"],["cuka","svv.b"],["lu","svv.m"],["teng","svv.s"],[" ","space"]],[["they all (3+)","mvv.s"],["are","mvv.m"],["running","mvv.b"],["","mvv.b"],["being fast","svv.b"]]]],169:["qenerrluni nunullrui","he scolded them angrily (being angry)",[["Insert",["mv"],[[["nunur¹-",0,2,0],["-llru¹-",0,0,0]],"t","Ind"]],["Update",["mv","vs"],[3,1,1]],["Update",["mv","vo"],[3,3,0]],["Insert",["sv"],[[["qenerte-",0,0,0]],"i","Sbrd","being"]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["nunu","mvv.b"],["llru","mvv.1"],["i","mvv.o"],[" ","space"],["qenerr","svv.b"],["lu","svv.m"],["ni","svv.s"],[" ","space"]],[["he","mvv.s"],["scolded ","mvv.b"],["them all (3+)","mvv.o"],["","mvv.b"],["being angry","svv.b"]]]],170:["aqumgallruuq utaqaluni","he sat down waiting",[["Insert",["mv"],[[["aqumga-",0,0,0],["-llru¹-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,1]],["Insert",["sv"],[[["utaqa-",0,0,0]],"i","Sbrd","being"]]],"","","",[[["aqumga","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["q","mvv.s"],[" ","space"],["utaqa","svv.b"],["lu","svv.m"],["ni","svv.s"],[" ","space"]],[["he","mvv.s"],["was","past"],["seated","mvv.b"],["","mvv.b"],["waiting","svv.b"]]]],174:["akluirpek'nak inarcaqunak","don't lay down without taking off your clothes",[["Insert",["mv"],[[["inarte-",0,0,0]],"i","Opt][FUT][NEG"]],["Update",["mv","vs"],[2,1,0]],["Insert",["sv"],[[["aklu,akluq,aklu-",1,0,0],[":(ng)ir²-",0,0,0],["+peke-|+vke-,+pege-|+vke-",0,0,0]],"i","Sbrd","without"]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["inarc","mvv.b"],["aquna","mvv.m"],["k","mvv.s"],[" ","space"],["aklu","svv.b"],["ir","svv.1"],["pek'","svv.2"],["na","svv.m"],["k","svv.s"],[" ","space"]],[["you","mvv.s"],[", do not","mvv.m"],["lay down","mvv.b"],["","mvv.b"],["(in the future)","mvv.com"],["being deprived of","svv.1"],["clothing","svv.b"]]]],175:["qiallruuq taqevkenani","he cried without stopping",[["Insert",["mv"],[[["qia-",0,0,0],["-llru¹-",0,0,0]],"i","Ind"]],["Update",["mv","vs"],[3,1,1]],["Insert",["sv"],[[["taqe-",0,0,0],["+peke-|+vke-,+pege-|+vke-",0,0,0]],"i","Sbrd","without"]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["qia","mvv.b"],["llru","mvv.1"],["u","mvv.m"],["q","mvv.s"],[" ","space"],["taqe","svv.b"],["vke","svv.1"],["na","svv.m"],["ni","svv.s"],[" ","space"]],[["he","mvv.s"],["cried ","mvv.b"],["","mvv.b"],["finishing ","svv.b"]]]],176:["alingevkenak inareskina","lay down (in the future), not being scared",[["Insert",["mv"],[[["inarte-",0,0,0]],"i","Opt][FUT"]],["Update",["mv","vs"],[2,1,0]],["Insert",["sv"],[[["alinge-",0,0,0],["+peke-|+vke-,+pege-|+vke-",0,0,0]],"i","Sbrd","notbeing"]]],"verb + verb phrase sentence","subordinative verb","adjectival",[[["inares","mvv.b"],["ki","mvv.m"],["na","mvv.s"],[" ","space"],["alinge","svv.b"],["vke","svv.1"],["na","svv.m"],["k","svv.s"],[" ","space"]],[["you","mvv.s"],[", ","mvv.m"],["lay down","mvv.b"],["","mvv.b"],["(in the future)","mvv.com"],["not","svv.subtype"],["being afraid","svv.b"]]]]};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(239);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(148);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(457);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool,
  spyThrottle: _propTypes2.default.number
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(919);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(240);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length && scrollSpy.spySetState.indexOf(stateHandler) > -1) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export testModeAPI */
/* unused harmony export OutboundLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core__ = __webpack_require__(928);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var initialize = __WEBPACK_IMPORTED_MODULE_1__core__["initialize"];
var ga = __WEBPACK_IMPORTED_MODULE_1__core__["ga"];
var set = __WEBPACK_IMPORTED_MODULE_1__core__["set"];
var send = __WEBPACK_IMPORTED_MODULE_1__core__["send"];
var pageview = __WEBPACK_IMPORTED_MODULE_1__core__["pageview"];
var modalview = __WEBPACK_IMPORTED_MODULE_1__core__["modalview"];
var timing = __WEBPACK_IMPORTED_MODULE_1__core__["timing"];
var event = __WEBPACK_IMPORTED_MODULE_1__core__["event"];
var exception = __WEBPACK_IMPORTED_MODULE_1__core__["exception"];
var plugin = __WEBPACK_IMPORTED_MODULE_1__core__["plugin"];
var outboundLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_1__core__["testModeAPI"];
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */].trackLink = __WEBPACK_IMPORTED_MODULE_1__core__["outboundLink"];
var OutboundLink = __WEBPACK_IMPORTED_MODULE_0__components_OutboundLink__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__core__, {
  OutboundLink: OutboundLink
}));

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikNounHowMany=function(_Component){_inherits(YupikNounHowMany,_Component);function YupikNounHowMany(){_classCallCheck(this,YupikNounHowMany);return _possibleConstructorReturn(this,(YupikNounHowMany.__proto__||Object.getPrototypeOf(YupikNounHowMany)).apply(this,arguments));}_createClass(YupikNounHowMany,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Header,null,'How many?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */].Group,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,onClick:this.props.setValue4.bind(this,1),active:this.props.value4===1},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */].Or,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,onClick:this.props.setValue4.bind(this,2),active:this.props.value4===2},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */].Or,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,onClick:this.props.setValue4.bind(this,3),active:this.props.value4===3},'3'))));}}]);return YupikNounHowMany;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikNounHowMany);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikNounPossessor=function(_Component){_inherits(YupikNounPossessor,_Component);function YupikNounPossessor(){_classCallCheck(this,YupikNounPossessor);return _possibleConstructorReturn(this,(YupikNounPossessor.__proto__||Object.getPrototypeOf(YupikNounPossessor)).apply(this,arguments));}_createClass(YupikNounPossessor,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Header,null,'It is owned by someone?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{as:'h4',toggle:true,onClick:this.props.setPossessiveButton.bind(this,1),active:this.props.possessiveButton===1},'possessive')));}}]);return YupikNounPossessor;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikNounPossessor);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(468);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}




/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(97);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(152);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(482)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(153);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(97);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(98);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(152);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(50) && !__webpack_require__(72)(function () {
  return Object.defineProperty(__webpack_require__(261)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(71);
var document = __webpack_require__(48).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(56);
var toIObject = __webpack_require__(57);
var arrayIndexOf = __webpack_require__(499)(false);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(156);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(158);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(501), __esModule: true };

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(100);
var $export = __webpack_require__(47);
var redefine = __webpack_require__(267);
var hide = __webpack_require__(70);
var Iterators = __webpack_require__(74);
var $iterCreate = __webpack_require__(506);
var setToStringTag = __webpack_require__(164);
var getPrototypeOf = __webpack_require__(268);
var ITERATOR = __webpack_require__(33)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(70);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(56);
var toObject = __webpack_require__(81);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(262);
var hiddenKeys = __webpack_require__(161).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(82),
    isArguments = __webpack_require__(109),
    isArray = __webpack_require__(15),
    isIndex = __webpack_require__(84),
    isLength = __webpack_require__(172),
    toKey = __webpack_require__(62);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(532);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(170);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 275 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(110);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(112),
    arrayIncludes = __webpack_require__(113),
    arrayIncludesWith = __webpack_require__(175),
    arrayMap = __webpack_require__(38),
    baseUnary = __webpack_require__(63),
    cacheHas = __webpack_require__(115);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 280 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(282),
    baseToString = __webpack_require__(108),
    toInteger = __webpack_require__(40),
    toString = __webpack_require__(37);

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null
    ? 0
    : baseClamp(toInteger(position), 0, string.length);

  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

module.exports = startsWith;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(565);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(286),
    isArguments = __webpack_require__(109),
    isArray = __webpack_require__(15),
    isBuffer = __webpack_require__(87),
    isIndex = __webpack_require__(84),
    isTypedArray = __webpack_require__(121);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 286 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(112),
    arraySome = __webpack_require__(289),
    cacheHas = __webpack_require__(115);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(293),
    getSymbols = __webpack_require__(181),
    keys = __webpack_require__(26);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(176),
    isArray = __webpack_require__(15);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 294 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(25);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(587),
    hasPath = __webpack_require__(270);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(39);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(156);
var TAG = __webpack_require__(33)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(302);
var ITERATOR = __webpack_require__(33)('iterator');
var Iterators = __webpack_require__(74);
module.exports = __webpack_require__(22).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(605),
    findIndex = __webpack_require__(305);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(280),
    baseIteratee = __webpack_require__(27),
    toInteger = __webpack_require__(40);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(39),
    metaMap = __webpack_require__(307);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(296);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(309),
    composeArgsRight = __webpack_require__(310),
    countHolders = __webpack_require__(623),
    createCtor = __webpack_require__(128),
    createRecurry = __webpack_require__(311),
    getHolder = __webpack_require__(188),
    reorder = __webpack_require__(630),
    replaceHolders = __webpack_require__(129),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(312),
    setData = __webpack_require__(315),
    setWrapToString = __webpack_require__(316);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(184),
    getData = __webpack_require__(186),
    getFuncName = __webpack_require__(314),
    lodash = __webpack_require__(625);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 313 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(624);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(306),
    shortOut = __webpack_require__(278);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(627),
    insertWrapDetails = __webpack_require__(628),
    setToString = __webpack_require__(173),
    updateWrapDetails = __webpack_require__(629);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(93),
    keys = __webpack_require__(26);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(179),
    arrayEach = __webpack_require__(90),
    assignValue = __webpack_require__(130),
    baseAssign = __webpack_require__(317),
    baseAssignIn = __webpack_require__(634),
    cloneBuffer = __webpack_require__(637),
    copyArray = __webpack_require__(92),
    copySymbols = __webpack_require__(638),
    copySymbolsIn = __webpack_require__(639),
    getAllKeys = __webpack_require__(292),
    getAllKeysIn = __webpack_require__(320),
    getTag = __webpack_require__(53),
    initCloneArray = __webpack_require__(640),
    initCloneByTag = __webpack_require__(641),
    initCloneObject = __webpack_require__(646),
    isArray = __webpack_require__(15),
    isBuffer = __webpack_require__(87),
    isMap = __webpack_require__(647),
    isObject = __webpack_require__(25),
    isSet = __webpack_require__(649),
    keys = __webpack_require__(26),
    keysIn = __webpack_require__(189);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(176),
    getPrototype = __webpack_require__(131),
    getSymbols = __webpack_require__(181),
    stubArray = __webpack_require__(294);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(293),
    getSymbolsIn = __webpack_require__(319),
    keysIn = __webpack_require__(189);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(127);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(85),
    baseSet = __webpack_require__(323),
    castPath = __webpack_require__(82);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(130),
    castPath = __webpack_require__(82),
    isIndex = __webpack_require__(84),
    isObject = __webpack_require__(25),
    toKey = __webpack_require__(62);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(64),
    isArrayLike = __webpack_require__(28);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseSum = __webpack_require__(680),
    identity = __webpack_require__(39);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? baseSum(array, identity)
    : 0;
}

module.exports = sum;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('map', __webpack_require__(17));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copy of sindre's leven, wrapped in dead code elimination for production
// https://github.com/sindresorhus/leven/blob/master/index.js
/* eslint-disable complexity, import/no-mutable-exports, no-multi-assign, no-nested-ternary, no-plusplus */

var leven = function leven() {
  return 0;
};

if (false) {
  var arr = [];
  var charCodeCache = [];

  leven = function leven(a, b) {
    if (a === b) return 0;

    var aLen = a.length;
    var bLen = b.length;

    if (aLen === 0) return bLen;
    if (bLen === 0) return aLen;

    var bCharCode = void 0;
    var ret = void 0;
    var tmp = void 0;
    var tmp2 = void 0;
    var i = 0;
    var j = 0;

    while (i < aLen) {
      charCodeCache[i] = a.charCodeAt(i);
      arr[i] = ++i;
    }

    while (j < bLen) {
      bCharCode = b.charCodeAt(j);
      tmp = j++;
      ret = j;

      for (i = 0; i < aLen; i++) {
        tmp2 = bCharCode === charCodeCache[i] ? tmp : tmp + 1;
        tmp = arr[i];
        ret = arr[i] = tmp > ret ? tmp2 > ret ? ret + 1 : tmp2 : tmp2 > tmp ? tmp + 1 : tmp2;
      }
    }

    return ret;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (leven);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(112),
    arrayIncludes = __webpack_require__(113),
    arrayIncludesWith = __webpack_require__(175),
    cacheHas = __webpack_require__(115),
    createSet = __webpack_require__(693),
    setToArray = __webpack_require__(124);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var baseInRange = __webpack_require__(702),
    toFinite = __webpack_require__(177),
    toNumber = __webpack_require__(118);

/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = toFinite(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = toFinite(end);
  }
  number = toNumber(number);
  return baseInRange(number, start, end);
}

module.exports = inRange;


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TYPES", function() { return TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMeta", function() { return isMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isType", function() { return isType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAddon", function() { return isAddon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCollection", function() { return isCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isElement", function() { return isElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isView", function() { return isView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isModule", function() { return isModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isParent", function() { return isParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isChild", function() { return isChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPrivate", function() { return isPrivate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_startsWith__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_startsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_has__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_eq__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_curry__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_get__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_includes__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_values__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_values__);










var TYPES = {
  ADDON: 'addon',
  BEHAVIOR: 'behavior',
  COLLECTION: 'collection',
  ELEMENT: 'element',
  VIEW: 'view',
  MODULE: 'module'
};

var TYPE_VALUES = __WEBPACK_IMPORTED_MODULE_7_lodash_fp_values___default()(TYPES);

/**
 * Determine if an object qualifies as a META object.
 * It must have the required keys and valid values.
 * @private
 * @param {Object} _meta A proposed component _meta object.
 * @returns {Boolean}
 */
var isMeta = function isMeta(_meta) {
  return __WEBPACK_IMPORTED_MODULE_6_lodash_fp_includes___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_get___default()('type', _meta), TYPE_VALUES);
};

/**
 * Extract a component's _meta object and optional key.
 * Handles literal _meta objects, classes with _meta, objects with _meta
 * @private
 * @param {function|object} metaArg A class, a component instance, or meta object..
 * @returns {object|string|undefined}
 */
var getMeta = function getMeta(metaArg) {
  // literal
  if (isMeta(metaArg)) return metaArg;

  // from prop
  else if (isMeta(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_get___default()('_meta', metaArg))) return metaArg._meta;

    // from class
    else if (isMeta(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_get___default()('constructor._meta', metaArg))) return metaArg.constructor._meta;
};

var metaHasKeyValue = __WEBPACK_IMPORTED_MODULE_4_lodash_fp_curry___default()(function (key, val, metaArg) {
  return __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow___default()(getMeta, __WEBPACK_IMPORTED_MODULE_5_lodash_fp_get___default()(key), __WEBPACK_IMPORTED_MODULE_2_lodash_fp_eq___default()(val))(metaArg);
});
var isType = metaHasKeyValue('type');

// ----------------------------------------
// Export
// ----------------------------------------

// type
var isAddon = isType(TYPES.ADDON);
var isCollection = isType(TYPES.COLLECTION);
var isElement = isType(TYPES.ELEMENT);
var isView = isType(TYPES.VIEW);
var isModule = isType(TYPES.MODULE);

// parent
var isParent = __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow___default()(getMeta, __WEBPACK_IMPORTED_MODULE_1_lodash_fp_has___default()('parent'), __WEBPACK_IMPORTED_MODULE_2_lodash_fp_eq___default()(false));
var isChild = __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow___default()(getMeta, __WEBPACK_IMPORTED_MODULE_1_lodash_fp_has___default()('parent'));

// other
var isPrivate = __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow___default()(getMeta, __WEBPACK_IMPORTED_MODULE_5_lodash_fp_get___default()('name'), __WEBPACK_IMPORTED_MODULE_0_lodash_fp_startsWith___default()('_'));

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createEllipsisItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createFirstPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createPrevItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPageFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createNextItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLastItem; });
/**
 * @param {number} pageNumber
 * @return {Object}
 */
var createEllipsisItem = function createEllipsisItem(pageNumber) {
  return {
    active: false,
    type: 'ellipsisItem',
    value: pageNumber
  };
};

/**
 * @return {Object}
 */
var createFirstPage = function createFirstPage() {
  return {
    active: false,
    type: 'firstItem',
    value: 1
  };
};

/**
 * @param {number} activePage
 * @return {Object}
 */
var createPrevItem = function createPrevItem(activePage) {
  return {
    active: false,
    type: 'prevItem',
    value: Math.max(1, activePage - 1)
  };
};

/**
 * @param {number} activePage
 * @return {function}
 */
var createPageFactory = function createPageFactory(activePage) {
  return function (pageNumber) {
    return {
      active: activePage === pageNumber,
      type: 'pageItem',
      value: pageNumber
    };
  };
};

/**
 * @param {number} activePage
 * @param {number} totalPages
 * @return {Object}
 */
var createNextItem = function createNextItem(activePage, totalPages) {
  return {
    active: false,
    type: 'nextItem',
    value: Math.min(activePage + 1, totalPages)
  };
};

/**
 * @param {number} totalPages
 * @return {Object}
 */
var createLastItem = function createLastItem(totalPages) {
  return {
    active: false,
    type: 'lastItem',
    value: totalPages
  };
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(286),
    castFunction = __webpack_require__(301),
    toInteger = __webpack_require__(40);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(180);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);









/**
 * Several icons can be used together as a group.
 */
function IconGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      size = props.size;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(size, 'icons', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(IconGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(IconGroup, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

IconGroup.handledProps = ['as', 'children', 'className', 'content', 'size'];
IconGroup._meta = {
  name: 'IconGroup',
  parent: 'Icon',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.ELEMENT
};

IconGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Size of the icon group. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};

IconGroup.defaultProps = {
  as: 'i'
};

/* harmony default export */ __webpack_exports__["a"] = (IconGroup);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_Dimmer__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Label_Label__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ImageGroup__ = __webpack_require__(340);













var imageProps = ['alt', 'height', 'src', 'srcSet', 'width'];

/**
 * An image is a graphic representation of something.
 * @see Icon
 */
function Image(props) {
  var avatar = props.avatar,
      bordered = props.bordered,
      centered = props.centered,
      children = props.children,
      circular = props.circular,
      className = props.className,
      content = props.content,
      dimmer = props.dimmer,
      disabled = props.disabled,
      floated = props.floated,
      fluid = props.fluid,
      hidden = props.hidden,
      href = props.href,
      inline = props.inline,
      label = props.label,
      rounded = props.rounded,
      size = props.size,
      spaced = props.spaced,
      verticalAlign = props.verticalAlign,
      wrapped = props.wrapped,
      ui = props.ui;


  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(ui, 'ui'), size, Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(avatar, 'avatar'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(bordered, 'bordered'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(hidden, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(inline, 'inline'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(rounded, 'rounded'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["C" /* useKeyOrValueAndKey */])(spaced, 'spaced'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["F" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["G" /* useVerticalAlignProp */])(verticalAlign, 'aligned'), 'image', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["r" /* getUnhandledProps */])(Image, props);

  var _partitionHTMLProps = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* partitionHTMLProps */])(rest, { htmlProps: imageProps }),
      _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
      imgTagProps = _partitionHTMLProps2[0],
      rootProps = _partitionHTMLProps2[1];

  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getElementType */])(Image, props, function () {
    if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(dimmer) || !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(label) || !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(wrapped) || !__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) return 'div';
  });

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }
  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      content
    );
  }

  if (ElementType === 'img') return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rootProps, imgTagProps, { className: classes }));
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rootProps, { className: classes, href: href }),
    __WEBPACK_IMPORTED_MODULE_7__modules_Dimmer__["a" /* default */].create(dimmer),
    __WEBPACK_IMPORTED_MODULE_8__Label_Label__["a" /* default */].create(label),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', imgTagProps)
  );
}

Image.handledProps = ['as', 'avatar', 'bordered', 'centered', 'children', 'circular', 'className', 'content', 'dimmer', 'disabled', 'floated', 'fluid', 'hidden', 'href', 'inline', 'label', 'rounded', 'size', 'spaced', 'ui', 'verticalAlign', 'wrapped'];
Image.Group = __WEBPACK_IMPORTED_MODULE_9__ImageGroup__["a" /* default */];

Image._meta = {
  name: 'Image',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.ELEMENT
};

Image.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An image may be formatted to appear inline with text as an avatar. */
  avatar: PropTypes.bool,

  /** An image may include a border to emphasize the edges of white or transparent content. */
  bordered: PropTypes.bool,

  /** An image can appear centered in a content block. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** An image may appear circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An image can show that it is disabled and cannot be selected. */
  disabled: PropTypes.bool,

  /** Shorthand for Dimmer. */
  dimmer: customPropTypes.itemShorthand,

  /** An image can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** An image can take up the width of its container. */
  fluid: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['size'])]),

  /** An image can be hidden. */
  hidden: PropTypes.bool,

  /** Renders the Image as an <a> tag with this href. */
  href: PropTypes.string,

  /** An image may appear inline. */
  inline: PropTypes.bool,

  /** Shorthand for Label. */
  label: customPropTypes.itemShorthand,

  /** An image may appear rounded. */
  rounded: PropTypes.bool,

  /** An image may appear at different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** An image can specify that it needs an additional spacing to separate it from nearby content. */
  spaced: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),

  /** Whether or not to add the ui className. */
  ui: PropTypes.bool,

  /** An image can specify its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** An image can render wrapped in a `div.ui.image` as alternative HTML markup. */
  wrapped: PropTypes.bool
} : {};

Image.defaultProps = {
  as: 'img',
  ui: true
};

Image.create = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["m" /* createShorthandFactory */])(Image, function (value) {
  return { src: value };
});

/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dimmer__ = __webpack_require__(728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dimmer__["a"]; });



/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A dimmable sub-component for Dimmer.
 */
function DimmerDimmable(props) {
  var blurring = props.blurring,
      className = props.className,
      children = props.children,
      content = props.content,
      dimmed = props.dimmed;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(blurring, 'blurring'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(dimmed, 'dimmed'), 'dimmable', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(DimmerDimmable, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(DimmerDimmable, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

DimmerDimmable.handledProps = ['as', 'blurring', 'children', 'className', 'content', 'dimmed'];
DimmerDimmable._meta = {
  name: 'DimmerDimmable',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Dimmer'
};

DimmerDimmable.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A dimmable element can blur its contents. */
  blurring: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Controls whether or not the dim is displayed. */
  dimmed: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DimmerDimmable);

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A group of images.
 */
function ImageGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      size = props.size;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', size, className, 'images');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ImageGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ImageGroup, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ImageGroup.handledProps = ['as', 'children', 'className', 'content', 'size'];
ImageGroup._meta = {
  name: 'ImageGroup',
  parent: 'Image',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

ImageGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A group of images can be formatted to have the same size. */
  size: PropTypes.oneOf(SUI.SIZES)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (ImageGroup);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







function LabelDetail(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('detail', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(LabelDetail, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(LabelDetail, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

LabelDetail.handledProps = ['as', 'children', 'className', 'content'];
LabelDetail._meta = {
  name: 'LabelDetail',
  parent: 'Label',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

LabelDetail.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (LabelDetail);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A label can be grouped.
 */
function LabelGroup(props) {
  var children = props.children,
      circular = props.circular,
      className = props.className,
      color = props.color,
      content = props.content,
      size = props.size,
      tag = props.tag;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(tag, 'tag'), 'labels', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(LabelGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(LabelGroup, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

LabelGroup.handledProps = ['as', 'children', 'circular', 'className', 'color', 'content', 'size', 'tag'];
LabelGroup._meta = {
  name: 'LabelGroup',
  parent: 'Label',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

LabelGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Labels can share shapes. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Label group can share colors together. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Label group can share sizes together. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** Label group can share tag formatting. */
  tag: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (LabelGroup);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * Used in some Button types, such as `animated`.
 */
function ButtonContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      hidden = props.hidden,
      visible = props.visible;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(visible, 'visible'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(hidden, 'hidden'), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ButtonContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ButtonContent, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ButtonContent.handledProps = ['as', 'children', 'className', 'content', 'hidden', 'visible'];
ButtonContent._meta = {
  name: 'ButtonContent',
  parent: 'Button',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

ButtonContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Initially hidden, visible on hover. */
  hidden: PropTypes.bool,

  /** Initially visible, hidden on hover. */
  visible: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (ButtonContent);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(197);











/**
 * Buttons can be grouped.
 */
function ButtonGroup(props) {
  var attached = props.attached,
      basic = props.basic,
      buttons = props.buttons,
      children = props.children,
      className = props.className,
      color = props.color,
      compact = props.compact,
      content = props.content,
      floated = props.floated,
      fluid = props.fluid,
      icon = props.icon,
      inverted = props.inverted,
      labeled = props.labeled,
      negative = props.negative,
      positive = props.positive,
      primary = props.primary,
      secondary = props.secondary,
      size = props.size,
      toggle = props.toggle,
      vertical = props.vertical,
      widths = props.widths;


  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(icon, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(labeled, 'labeled'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(primary, 'primary'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(secondary, 'secondary'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(toggle, 'toggle'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(vertical, 'vertical'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["C" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["F" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* useWidthProp */])(widths), 'buttons', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["r" /* getUnhandledProps */])(ButtonGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getElementType */])(ButtonGroup, props);

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(buttons)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      __WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children) ? content : children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(buttons, function (button) {
      return __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */].create(button);
    })
  );
}

ButtonGroup.handledProps = ['as', 'attached', 'basic', 'buttons', 'children', 'className', 'color', 'compact', 'content', 'floated', 'fluid', 'icon', 'inverted', 'labeled', 'negative', 'positive', 'primary', 'secondary', 'size', 'toggle', 'vertical', 'widths'];
ButtonGroup._meta = {
  name: 'ButtonGroup',
  parent: 'Button',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.ELEMENT
};

ButtonGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Groups can be attached to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'bottom'])]),

  /** Groups can be less pronounced. */
  basic: PropTypes.bool,

  /** Array of shorthand Button values. */
  buttons: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Groups can have a shared color. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Groups can reduce their padding to fit into tighter spaces. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Groups can be aligned to the left or right of its container. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Groups can take the width of their container. */
  fluid: PropTypes.bool,

  /** Groups can be formatted as icons. */
  icon: PropTypes.bool,

  /** Groups can be formatted to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Groups can be formatted as labeled icon buttons. */
  labeled: PropTypes.bool,

  /** Groups can hint towards a negative consequence. */
  negative: PropTypes.bool,

  /** Groups can hint towards a positive consequence. */
  positive: PropTypes.bool,

  /** Groups can be formatted to show different levels of emphasis. */
  primary: PropTypes.bool,

  /** Groups can be formatted to show different levels of emphasis. */
  secondary: PropTypes.bool,

  /** Groups can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** Groups can be formatted to toggle on and off. */
  toggle: PropTypes.bool,

  /** Groups can be formatted to appear vertically. */
  vertical: PropTypes.bool,

  /** Groups can have their widths divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * Button groups can contain conditionals.
 */
function ButtonOr(props) {
  var className = props.className,
      text = props.text;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('or', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ButtonOr, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ButtonOr, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, 'data-text': text }));
}

ButtonOr.handledProps = ['as', 'className', 'text'];
ButtonOr._meta = {
  name: 'ButtonOr',
  parent: 'Button',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

ButtonOr.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** Or buttons can have their text localized, or adjusted by using the text prop. */
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};

/* harmony default export */ __webpack_exports__["a"] = (ButtonOr);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(731);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });



/***/ }),
/* 347 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MountNode__ = __webpack_require__(733);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MountNode__["a"]; });



/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A modal can have a header.
 */
function ModalHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'header');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ModalHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ModalHeader, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ModalHeader.handledProps = ['as', 'children', 'className', 'content'];
ModalHeader._meta = {
  name: 'ModalHeader',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Modal'
};

ModalHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

ModalHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ModalHeader, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ModalHeader);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A modal can contain content.
 */
function ModalContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      image = props.image,
      scrolling = props.scrolling;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(image, 'image'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(scrolling, 'scrolling'), 'content');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ModalContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ModalContent, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ModalContent.handledProps = ['as', 'children', 'className', 'content', 'image', 'scrolling'];
ModalContent._meta = {
  name: 'ModalContent',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Modal'
};

ModalContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A modal can contain image content. */
  image: PropTypes.bool,

  /** A modal can use the entire size of the screen. */
  scrolling: PropTypes.bool
} : {};

ModalContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(ModalContent, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ModalContent);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_Button__ = __webpack_require__(136);















/**
 * A modal can contain a row of actions.
 */

var ModalActions = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalActions, _Component);

  function ModalActions() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ModalActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ModalActions.__proto__ || Object.getPrototypeOf(ModalActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleButtonOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(predefinedProps, 'onClick', e, buttonProps);
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onActionClick', e, buttonProps);
        }
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ModalActions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          actions = _props.actions,
          children = _props.children,
          className = _props.className,
          content = _props.content;

      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('actions', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(ModalActions, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(ModalActions, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
        children
      );
      if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
        content
      );

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
        __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(actions, function (action) {
          return __WEBPACK_IMPORTED_MODULE_11__elements_Button__["a" /* default */].create(action, { overrideProps: _this2.handleButtonOverrides });
        })
      );
    }
  }]);

  return ModalActions;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

ModalActions._meta = {
  name: 'ModalActions',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Modal'
};
ModalActions.handledProps = ['actions', 'as', 'children', 'className', 'content', 'onActionClick'];
/* harmony default export */ __webpack_exports__["a"] = (ModalActions);
ModalActions.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Array of shorthand buttons. */
  actions: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props from the clicked action.
   */
  onActionClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func])
} : {};


ModalActions.create = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["m" /* createShorthandFactory */])(ModalActions, function (actions) {
  return { actions: actions };
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A modal can have a header.
 */
function ModalDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('description', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ModalDescription, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ModalDescription, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ModalDescription.handledProps = ['as', 'children', 'className', 'content'];
ModalDescription._meta = {
  name: 'ModalDescription',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Modal'
};

ModalDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (ModalDescription);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });



/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MenuHeader__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MenuItem__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MenuMenu__ = __webpack_require__(357);


















/**
 * A menu displays grouped navigation actions.
 * @see Dropdown
 */

var Menu = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Menu, _Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, itemProps) {
          var index = itemProps.index;


          _this.trySetState({ activeIndex: index });

          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(predefinedProps, 'onClick', e, itemProps);
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onItemClick', e, itemProps);
        }
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Menu, [{
    key: 'renderItems',
    value: function renderItems() {
      var _this2 = this;

      var items = this.props.items;
      var activeIndex = this.state.activeIndex;


      return __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(items, function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_13__MenuItem__["a" /* default */].create(item, {
          defaultProps: {
            active: parseInt(activeIndex, 10) === index,
            index: index
          },
          overrideProps: _this2.handleItemOverrides
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          attached = _props.attached,
          borderless = _props.borderless,
          children = _props.children,
          className = _props.className,
          color = _props.color,
          compact = _props.compact,
          fixed = _props.fixed,
          floated = _props.floated,
          fluid = _props.fluid,
          icon = _props.icon,
          inverted = _props.inverted,
          pagination = _props.pagination,
          pointing = _props.pointing,
          secondary = _props.secondary,
          size = _props.size,
          stackable = _props.stackable,
          tabular = _props.tabular,
          text = _props.text,
          vertical = _props.vertical,
          widths = _props.widths;

      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(borderless, 'borderless'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(pagination, 'pagination'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(pointing, 'pointing'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(secondary, 'secondary'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(text, 'text'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(vertical, 'vertical'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["C" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["C" /* useKeyOrValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["C" /* useKeyOrValueAndKey */])(icon, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["C" /* useKeyOrValueAndKey */])(tabular, 'tabular'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["F" /* useValueAndKey */])(fixed, 'fixed'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["H" /* useWidthProp */])(widths, 'item'), className, 'menu');
      var rest = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["r" /* getUnhandledProps */])(Menu, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["q" /* getElementType */])(Menu, this.props);

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
        __WEBPACK_IMPORTED_MODULE_11__lib__["d" /* childrenUtils */].isNil(children) ? this.renderItems() : children
      );
    }
  }]);

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* AutoControlledComponent */]);

Menu._meta = {
  name: 'Menu',
  type: __WEBPACK_IMPORTED_MODULE_11__lib__["b" /* META */].TYPES.COLLECTION
};
Menu.autoControlledProps = ['activeIndex'];
Menu.Header = __WEBPACK_IMPORTED_MODULE_12__MenuHeader__["a" /* default */];
Menu.Item = __WEBPACK_IMPORTED_MODULE_13__MenuItem__["a" /* default */];
Menu.Menu = __WEBPACK_IMPORTED_MODULE_14__MenuMenu__["a" /* default */];
Menu.handledProps = ['activeIndex', 'as', 'attached', 'borderless', 'children', 'className', 'color', 'compact', 'defaultActiveIndex', 'fixed', 'floated', 'fluid', 'icon', 'inverted', 'items', 'onItemClick', 'pagination', 'pointing', 'secondary', 'size', 'stackable', 'tabular', 'text', 'vertical', 'widths'];
Menu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Index of the currently active item. */
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A menu may be attached to other content segments. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A menu item or menu can have no borders. */
  borderless: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Additional colors can be specified. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A menu can take up only the space necessary to fit its content. */
  compact: PropTypes.bool,

  /** Initial activeIndex value. */
  defaultActiveIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A menu can be fixed to a side of its context. */
  fixed: PropTypes.oneOf(['left', 'right', 'bottom', 'top']),

  /** A menu can be floated. */
  floated: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A vertical menu may take the size of its container. */
  fluid: PropTypes.bool,

  /** A menu may have just icons (bool) or labeled icons. */
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['labeled'])]),

  /** A menu may have its colors inverted to show greater contrast. */
  inverted: PropTypes.bool,

  /** Shorthand array of props for Menu. */
  items: customPropTypes.collectionShorthand,

  /**
   * onClick handler for MenuItem. Mutually exclusive with children.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onItemClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** A pagination menu is specially formatted to present links to pages of content. */
  pagination: PropTypes.bool,

  /** A menu can point to show its relationship to nearby content. */
  pointing: PropTypes.bool,

  /** A menu can adjust its appearance to de-emphasize its contents. */
  secondary: PropTypes.bool,

  /** A menu can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big')),

  /** A menu can stack at mobile resolutions. */
  stackable: PropTypes.bool,

  /** A menu can be formatted to show tabs of information. */
  tabular: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A menu can be formatted for text content. */
  text: PropTypes.bool,

  /** A vertical menu displays elements vertically. */
  vertical: PropTypes.bool,

  /** A menu can have its items divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};


Menu.create = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["m" /* createShorthandFactory */])(Menu, function (items) {
  return { items: items };
});

/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A menu item may include a header or may itself be a header.
 */
function MenuHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(MenuHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(MenuHeader, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

MenuHeader.handledProps = ['as', 'children', 'className', 'content'];
MenuHeader._meta = {
  name: 'MenuHeader',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Menu'
};

MenuHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (MenuHeader);

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(755),
    toString = __webpack_require__(37);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A menu can contain a sub menu.
 */
function MenuMenu(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      position = props.position;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(position, 'menu', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(MenuMenu, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(MenuMenu, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

MenuMenu.handledProps = ['as', 'children', 'className', 'content', 'position'];
MenuMenu._meta = {
  name: 'MenuMenu',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Menu'
};

MenuMenu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A sub menu can take left or right position. */
  position: PropTypes.oneOf(['left', 'right'])
} : {};

/* harmony default export */ __webpack_exports__["a"] = (MenuMenu);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__collections_Menu_MenuItem__ = __webpack_require__(200);












/**
 * An item of a pagination.
 */

var PaginationItem = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PaginationItem, _Component);

  function PaginationItem() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PaginationItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PaginationItem.__proto__ || Object.getPrototypeOf(PaginationItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var type = _this.props.type;


      if (type !== 'ellipsisItem') __WEBPACK_IMPORTED_MODULE_4_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    }, _this.handleKeyDown = function (e) {
      __WEBPACK_IMPORTED_MODULE_4_lodash_invoke___default()(_this.props, 'onKeyDown', e, _this.props);
      if (__WEBPACK_IMPORTED_MODULE_7__lib__["u" /* keyboardKey */].getCode(e) === __WEBPACK_IMPORTED_MODULE_7__lib__["u" /* keyboardKey */].Enter) __WEBPACK_IMPORTED_MODULE_4_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    }, _this.handleOverrides = function () {
      return {
        onClick: _this.handleClick,
        onKeyDown: _this.handleKeyDown
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PaginationItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          type = _props.type;

      var disabled = this.props.disabled || type === 'ellipsisItem';

      return __WEBPACK_IMPORTED_MODULE_8__collections_Menu_MenuItem__["a" /* default */].create(this.props, {
        defaultProps: {
          active: active,
          disabled: disabled,
          'aria-current': active,
          onClick: this.handleClick,
          onKeyDown: this.handleKeyDown,
          tabIndex: disabled ? -1 : 0
        },
        overrideProps: this.handleOverrides
      });
    }
  }]);

  return PaginationItem;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

PaginationItem._meta = {
  name: 'PaginationItem',
  parent: 'Pagination',
  type: __WEBPACK_IMPORTED_MODULE_7__lib__["b" /* META */].TYPES.ADDON
};
PaginationItem.handledProps = ['active', 'disabled', 'onClick', 'onKeyDown', 'type'];
PaginationItem.propTypes =  false ? {
  /** A pagination item can be active. */
  active: PropTypes.bool,

  /** A pagination item can be disabled. */
  disabled: PropTypes.bool,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called on key down.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onKeyDown: PropTypes.func,

  /** A pagination should have a type. */
  type: PropTypes.oneOf(['ellipsisItem', 'firstItem', 'prevItem', 'pageItem', 'nextItem', 'lastItem'])
} : {};


PaginationItem.create = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["m" /* createShorthandFactory */])(PaginationItem, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (PaginationItem);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(767);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });



/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(770);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(773);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(47);
var core = __webpack_require__(22);
var fails = __webpack_require__(72);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A dropdown menu can contain dividers to separate related content.
 */
function DropdownDivider(props) {
  var className = props.className;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('divider', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(DropdownDivider, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(DropdownDivider, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }));
}

DropdownDivider.handledProps = ['as', 'className'];
DropdownDivider._meta = {
  name: 'DropdownDivider',
  parent: 'Dropdown',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE
};

DropdownDivider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DropdownDivider);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_Flag__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_Icon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_Image__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_Label__ = __webpack_require__(140);

















/**
 * An item sub-component for Dropdown component.
 */

var DropdownItem = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownItem, _Component);

  function DropdownItem() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DropdownItem.__proto__ || Object.getPrototypeOf(DropdownItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var onClick = _this.props.onClick;


      if (onClick) onClick(e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DropdownItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          content = _props.content,
          disabled = _props.disabled,
          description = _props.description,
          flag = _props.flag,
          icon = _props.icon,
          image = _props.image,
          label = _props.label,
          selected = _props.selected,
          text = _props.text;


      var classes = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(selected, 'selected'), 'item', className);
      // add default dropdown icon if item contains another menu
      var iconName = __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(icon) ? __WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].someByType(children, 'DropdownMenu') && 'dropdown' : icon;
      var rest = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["r" /* getUnhandledProps */])(DropdownItem, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["q" /* getElementType */])(DropdownItem, this.props);
      var ariaOptions = {
        role: 'option',
        'aria-disabled': disabled,
        'aria-checked': active,
        'aria-selected': selected
      };

      if (!__WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, ariaOptions, { className: classes, onClick: this.handleClick }),
          children
        );
      }

      var flagElement = __WEBPACK_IMPORTED_MODULE_10__elements_Flag__["a" /* default */].create(flag);
      var iconElement = __WEBPACK_IMPORTED_MODULE_11__elements_Icon__["a" /* default */].create(iconName);
      var imageElement = __WEBPACK_IMPORTED_MODULE_12__elements_Image__["a" /* default */].create(image);
      var labelElement = __WEBPACK_IMPORTED_MODULE_13__elements_Label__["a" /* default */].create(label);
      var descriptionElement = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["l" /* createShorthand */])('span', function (val) {
        return { children: val };
      }, description, { defaultProps: { className: 'description' } });
      var textElement = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["l" /* createShorthand */])('span', function (val) {
        return { children: val };
      }, __WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].isNil(content) ? text : content, { defaultProps: { className: 'text' } });

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, ariaOptions, { className: classes, onClick: this.handleClick }),
        imageElement,
        iconElement,
        flagElement,
        labelElement,
        descriptionElement,
        textElement
      );
    }
  }]);

  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

DropdownItem._meta = {
  name: 'DropdownItem',
  parent: 'Dropdown',
  type: __WEBPACK_IMPORTED_MODULE_9__lib__["b" /* META */].TYPES.MODULE
};
DropdownItem.handledProps = ['active', 'as', 'children', 'className', 'content', 'description', 'disabled', 'flag', 'icon', 'image', 'label', 'onClick', 'selected', 'text', 'value'];
DropdownItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Style as the currently chosen item. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Additional text with less emphasis. */
  description: customPropTypes.itemShorthand,

  /** A dropdown item can be disabled. */
  disabled: PropTypes.bool,

  /** Shorthand for Flag. */
  flag: customPropTypes.itemShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** Shorthand for Image. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for Label. */
  label: customPropTypes.itemShorthand,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * The item currently selected by keyboard shortcut.
   * This is not the active item.
   */
  selected: PropTypes.bool,

  /** Display text. */
  text: customPropTypes.contentShorthand,

  /** Stored value. */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
} : {};


DropdownItem.create = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["m" /* createShorthandFactory */])(DropdownItem, function (opts) {
  return opts;
});

/* harmony default export */ __webpack_exports__["a"] = (DropdownItem);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flag__ = __webpack_require__(786);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Flag__["a"]; });



/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(21);








/**
 * A dropdown menu can contain a header.
 */
function DropdownHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(DropdownHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(DropdownHeader, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon),
    content
  );
}

DropdownHeader.handledProps = ['as', 'children', 'className', 'content', 'icon'];
DropdownHeader._meta = {
  name: 'DropdownHeader',
  parent: 'Dropdown',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE
};

DropdownHeader.propTypes =  false ? {
  /** An element type to render as (string or function) */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand
} : {};

DropdownHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(DropdownHeader, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (DropdownHeader);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A dropdown menu can contain a menu.
 */
function DropdownMenu(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      direction = props.direction,
      open = props.open,
      scrolling = props.scrolling;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(direction, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(open, 'visible'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(scrolling, 'scrolling'), 'menu transition', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(DropdownMenu, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(DropdownMenu, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

DropdownMenu.handledProps = ['as', 'children', 'className', 'content', 'direction', 'open', 'scrolling'];
DropdownMenu._meta = {
  name: 'DropdownMenu',
  parent: 'Dropdown',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE
};

DropdownMenu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A dropdown menu can open to the left or to the right. */
  direction: PropTypes.oneOf(['left', 'right']),

  /** Whether or not the dropdown menu is displayed. */
  open: PropTypes.bool,

  /** A dropdown menu can scroll. */
  scrolling: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);














/**
 * A search item sub-component for Dropdown component.
 */

var DropdownSearchInput = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownSearchInput, _Component);

  function DropdownSearchInput() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownSearchInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DropdownSearchInput.__proto__ || Object.getPrototypeOf(DropdownSearchInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.props, { value: value }));
    }, _this.handleRef = function (c) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'inputRef', c);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DropdownSearchInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          tabIndex = _props.tabIndex,
          type = _props.type,
          value = _props.value;

      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('search', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(DropdownSearchInput, this.props);

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        'aria-autocomplete': 'list',
        autoComplete: 'off',
        className: classes,
        onChange: this.handleChange,
        ref: this.handleRef,
        tabIndex: tabIndex,
        type: type,
        value: value
      }));
    }
  }]);

  return DropdownSearchInput;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

DropdownSearchInput.defaultProps = {
  type: 'text'
};
DropdownSearchInput._meta = {
  name: 'DropdownSearchInput',
  parent: 'Dropdown',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.MODULE
};
DropdownSearchInput.handledProps = ['as', 'className', 'inputRef', 'tabIndex', 'type', 'value'];
DropdownSearchInput.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** A ref handler for input. */
  inputRef: PropTypes.func,

  /** An input can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The HTML input type. */
  type: PropTypes.string,

  /** Stored value. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};


DropdownSearchInput.create = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["m" /* createShorthandFactory */])(DropdownSearchInput, function (type) {
  return { type: type };
});

/* harmony default export */ __webpack_exports__["a"] = (DropdownSearchInput);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextArea__ = __webpack_require__(787);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextArea__["a"]; });



/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Transition__ = __webpack_require__(370);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Transition__["a"]; });



/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_includes__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TransitionGroup__ = __webpack_require__(371);
















var TRANSITION_TYPE = {
  ENTERING: 'show',
  EXITING: 'hide'

  /**
   * A transition is an animation usually used to move content in or out of view.
   */
};
var Transition = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Transition, _Component);

  function Transition() {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Transition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Transition.__proto__ || Object.getPrototypeOf(Transition)).call.apply(_ref, [this].concat(args)));

    _initialiseProps.call(_this);

    var _this$computeInitialS = _this.computeInitialStatuses(),
        status = _this$computeInitialS.initial,
        next = _this$computeInitialS.next;

    _this.nextStatus = next;
    _this.state = { status: status };
    return _this;
  }

  // ----------------------------------------
  // Lifecycle
  // ----------------------------------------

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Transition, [{
    key: 'componentDidMount',
    value: function componentDidMount() {

      this.mounted = true;
      this.updateStatus();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _computeStatuses = this.computeStatuses(nextProps),
          status = _computeStatuses.current,
          next = _computeStatuses.next;

      this.nextStatus = next;
      if (status) this.setSafeState({ status: status });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {

      this.updateStatus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {

      this.mounted = false;
    }

    // ----------------------------------------
    // Callback handling
    // ----------------------------------------

    // ----------------------------------------
    // Helpers
    // ----------------------------------------

  }, {
    key: 'render',


    // ----------------------------------------
    // Render
    // ----------------------------------------

    value: function render() {
      var children = this.props.children;
      var status = this.state.status;


      if (status === Transition.UNMOUNTED) return null;
      return Object(__WEBPACK_IMPORTED_MODULE_10_react__["cloneElement"])(children, {
        className: this.computeClasses(),
        style: this.computeStyle()
      });
    }
  }]);

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Transition.defaultProps = {
  animation: 'fade',
  duration: 500,
  visible: true,
  mountOnShow: true,
  transitionOnMount: false,
  unmountOnHide: false
};
Transition._meta = {
  name: 'Transition',
  type: __WEBPACK_IMPORTED_MODULE_11__lib__["b" /* META */].TYPES.MODULE
};
Transition.ENTERED = 'ENTERED';
Transition.ENTERING = 'ENTERING';
Transition.EXITED = 'EXITED';
Transition.EXITING = 'EXITING';
Transition.UNMOUNTED = 'UNMOUNTED';
Transition.Group = __WEBPACK_IMPORTED_MODULE_12__TransitionGroup__["a" /* default */];
Transition.handledProps = ['animation', 'children', 'duration', 'mountOnShow', 'onComplete', 'onHide', 'onShow', 'onStart', 'reactKey', 'transitionOnMount', 'unmountOnHide', 'visible'];

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleStart = function () {
    var duration = _this2.props.duration;

    var status = _this2.nextStatus;

    _this2.nextStatus = null;
    _this2.setSafeState({ status: status, animating: true }, function () {
      var durationType = TRANSITION_TYPE[status];
      var durationValue = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["x" /* normalizeTransitionDuration */])(duration, durationType);

      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this2.props, 'onStart', null, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props, { status: status }));
      setTimeout(_this2.handleComplete, durationValue);
    });
  };

  this.handleComplete = function () {
    var current = _this2.state.status;


    __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this2.props, 'onComplete', null, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props, { status: current }));

    if (_this2.nextStatus) {
      _this2.handleStart();
      return;
    }

    var status = _this2.computeCompletedStatus();
    var callback = current === Transition.ENTERING ? 'onShow' : 'onHide';

    _this2.setSafeState({ status: status, animating: false }, function () {
      __WEBPACK_IMPORTED_MODULE_7_lodash_invoke___default()(_this2.props, callback, null, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props, { status: status }));
    });
  };

  this.updateStatus = function () {
    var animating = _this2.state.animating;


    if (_this2.nextStatus) {
      _this2.nextStatus = _this2.computeNextStatus();
      if (!animating) _this2.handleStart();
    }
  };

  this.computeClasses = function () {
    var _props = _this2.props,
        animation = _props.animation,
        children = _props.children;
    var _state = _this2.state,
        animating = _state.animating,
        status = _state.status;


    var childClasses = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(children, 'props.className');
    var directional = __WEBPACK_IMPORTED_MODULE_5_lodash_includes___default()(__WEBPACK_IMPORTED_MODULE_11__lib__["c" /* SUI */].DIRECTIONAL_TRANSITIONS, animation);

    if (directional) {
      return __WEBPACK_IMPORTED_MODULE_8_classnames___default()(animation, childClasses, Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(animating, 'animating'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(status === Transition.ENTERING, 'in'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(status === Transition.EXITING, 'out'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(status === Transition.EXITED, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(status !== Transition.EXITED, 'visible'), 'transition');
    }

    return __WEBPACK_IMPORTED_MODULE_8_classnames___default()(animation, childClasses, Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(animating, 'animating transition'));
  };

  this.computeCompletedStatus = function () {
    var unmountOnHide = _this2.props.unmountOnHide;
    var status = _this2.state.status;


    if (status === Transition.ENTERING) return Transition.ENTERED;
    return unmountOnHide ? Transition.UNMOUNTED : Transition.EXITED;
  };

  this.computeInitialStatuses = function () {
    var _props2 = _this2.props,
        visible = _props2.visible,
        mountOnShow = _props2.mountOnShow,
        transitionOnMount = _props2.transitionOnMount,
        unmountOnHide = _props2.unmountOnHide;


    if (visible) {
      if (transitionOnMount) {
        return {
          initial: Transition.EXITED,
          next: Transition.ENTERING
        };
      }
      return { initial: Transition.ENTERED };
    }

    if (mountOnShow || unmountOnHide) return { initial: Transition.UNMOUNTED };
    return { initial: Transition.EXITED };
  };

  this.computeNextStatus = function () {
    var _state2 = _this2.state,
        animating = _state2.animating,
        status = _state2.status;


    if (animating) return status === Transition.ENTERING ? Transition.EXITING : Transition.ENTERING;
    return status === Transition.ENTERED ? Transition.EXITING : Transition.ENTERING;
  };

  this.computeStatuses = function (props) {
    var status = _this2.state.status;
    var visible = props.visible;


    if (visible) {
      return {
        current: status === Transition.UNMOUNTED && Transition.EXITED,
        next: status !== Transition.ENTERING && status !== Transition.ENTERED && Transition.ENTERING
      };
    }

    return {
      next: (status === Transition.ENTERING || status === Transition.ENTERED) && Transition.EXITING
    };
  };

  this.computeStyle = function () {
    var _props3 = _this2.props,
        children = _props3.children,
        duration = _props3.duration;
    var status = _this2.state.status;


    var childStyle = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(children, 'props.style');
    var type = TRANSITION_TYPE[status];
    var animationDuration = type && Object(__WEBPACK_IMPORTED_MODULE_11__lib__["x" /* normalizeTransitionDuration */])(duration, type) + 'ms';

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, childStyle, { animationDuration: animationDuration });
  };

  this.setSafeState = function () {
    return _this2.mounted && _this2.setState.apply(_this2, arguments);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Transition);
Transition.propTypes =  false ? {
  /** Named animation event to used. Must be defined in CSS. */
  animation: PropTypes.oneOf(SUI.TRANSITIONS),

  /** Primary content. */
  children: PropTypes.element.isRequired,

  /** Duration of the CSS transition animation in milliseconds. */
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    hide: PropTypes.number,
    show: PropTypes.number
  }), PropTypes.string]),

  /** Show the component; triggers the enter or exit animation. */
  visible: PropTypes.bool,

  /** Wait until the first "enter" transition to mount the component (add it to the DOM). */
  mountOnShow: PropTypes.bool,

  /**
   * Callback on each transition that changes visibility to shown.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onComplete: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to hidden.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onHide: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to shown.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onShow: PropTypes.func,

  /**
   * Callback on animation start.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onStart: PropTypes.func,

  /** React's key of the element. */
  reactKey: PropTypes.string,

  /** Run the enter animation when the component mounts, if it is initially shown. */
  transitionOnMount: PropTypes.bool,

  /** Unmount the component (remove it from the DOM) when it is not shown. */
  unmountOnHide: PropTypes.bool
} : {};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_values__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_has__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_mapValues__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Transition__ = __webpack_require__(370);

















/**
 * A Transition.Group animates children as they mount and unmount.
 */
var TransitionGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TransitionGroup, _React$Component);

  function TransitionGroup() {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TransitionGroup.__proto__ || Object.getPrototypeOf(TransitionGroup)).call.apply(_ref, [this].concat(args)));

    _initialiseProps.call(_this);

    var children = _this.props.children;

    _this.state = { children: __WEBPACK_IMPORTED_MODULE_9_lodash_mapValues___default()(Object(__WEBPACK_IMPORTED_MODULE_12__lib__["p" /* getChildMapping */])(children), function (child) {
        return _this.wrapChild(child);
      }) };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TransitionGroup, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var prevMapping = this.state.children;

      var nextMapping = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["p" /* getChildMapping */])(nextProps.children);
      var children = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["v" /* mergeChildMappings */])(prevMapping, nextMapping);

      __WEBPACK_IMPORTED_MODULE_8_lodash_forEach___default()(children, function (child, key) {
        var hasPrev = __WEBPACK_IMPORTED_MODULE_7_lodash_has___default()(prevMapping, key);
        var hasNext = __WEBPACK_IMPORTED_MODULE_7_lodash_has___default()(nextMapping, key);
        var prevChild = prevMapping[key];

        var isLeaving = !__WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(prevChild, 'props.visible');

        // Heads up!
        // An item is new (entering), it will be picked from `nextChildren`, so it should be wrapped
        if (hasNext && (!hasPrev || isLeaving)) {
          children[key] = _this2.wrapChild(child, { transitionOnMount: true });
          return;
        }

        // Heads up!
        // An item is old (exiting), it will be picked from `prevChildren`, so it has been already
        // wrapped, so should be only updated
        if (!hasNext && hasPrev && !isLeaving) {
          children[key] = Object(__WEBPACK_IMPORTED_MODULE_11_react__["cloneElement"])(prevChild, { visible: false });
          return;
        }

        // Heads up!
        // An item item hasn't changed transition states, but it will be picked from `nextChildren`,
        // so we should wrap it again
        var _prevChild$props = prevChild.props,
            visible = _prevChild$props.visible,
            transitionOnMount = _prevChild$props.transitionOnMount;


        children[key] = _this2.wrapChild(child, { transitionOnMount: transitionOnMount, visible: visible });
      });

      this.setState({ children: children });
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.state.children;

      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["q" /* getElementType */])(TransitionGroup, this.props);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["r" /* getUnhandledProps */])(TransitionGroup, this.props);

      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
        ElementType,
        rest,
        __WEBPACK_IMPORTED_MODULE_5_lodash_values___default()(children)
      );
    }
  }]);

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Component);

TransitionGroup.defaultProps = {
  animation: 'fade',
  duration: 500
};
TransitionGroup._meta = {
  name: 'TransitionGroup',
  parent: 'Transition',
  type: __WEBPACK_IMPORTED_MODULE_12__lib__["b" /* META */].TYPES.MODULE
};
TransitionGroup.handledProps = ['animation', 'as', 'children', 'duration'];

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnHide = function (nothing, childProps) {
    var reactKey = childProps.reactKey;


    _this3.setState(function (state) {
      var children = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.children);
      delete children[reactKey];

      return { children: children };
    });
  };

  this.wrapChild = function (child) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _props = _this3.props,
        animation = _props.animation,
        duration = _props.duration;
    var key = child.key;
    var _options$visible = options.visible,
        visible = _options$visible === undefined ? true : _options$visible,
        _options$transitionOn = options.transitionOnMount,
        transitionOnMount = _options$transitionOn === undefined ? false : _options$transitionOn;


    return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13__Transition__["a" /* default */],
      {
        animation: animation,
        duration: duration,
        key: key,
        onHide: _this3.handleOnHide,
        reactKey: key,
        transitionOnMount: transitionOnMount,
        visible: visible
      },
      child
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionGroup);
TransitionGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Named animation event to used. Must be defined in CSS. */
  animation: PropTypes.oneOf(SUI.TRANSITIONS),

  /** Primary content. */
  children: PropTypes.node,

  /** Duration of the CSS transition animation in milliseconds. */
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    hide: PropTypes.number.isRequired,
    show: PropTypes.number.isRequired
  }), PropTypes.string])
} : {};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(125),
    baseForOwn = __webpack_require__(178),
    baseIteratee = __webpack_require__(27);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Icon__ = __webpack_require__(21);










/**
 * A divider sub-component for Breadcrumb component.
 */
function BreadcrumbDivider(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('divider', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(BreadcrumbDivider, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(BreadcrumbDivider, props);

  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(icon)) return __WEBPACK_IMPORTED_MODULE_6__elements_Icon__["a" /* default */].create(icon, { defaultProps: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }) });
  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(content)) return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content
  );

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? '/' : children
  );
}

BreadcrumbDivider.handledProps = ['as', 'children', 'className', 'content', 'icon'];
BreadcrumbDivider._meta = {
  name: 'BreadcrumbDivider',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Breadcrumb'
};

BreadcrumbDivider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Render as an `Icon` component with `divider` class instead of a `div`. */
  icon: customPropTypes.itemShorthand
} : {};

BreadcrumbDivider.create = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["m" /* createShorthandFactory */])(BreadcrumbDivider, function (icon) {
  return { icon: icon };
});

/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbDivider);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(2);













/**
 * A section sub-component for Breadcrumb component.
 */

var BreadcrumbSection = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BreadcrumbSection, _Component);

  function BreadcrumbSection() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BreadcrumbSection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = BreadcrumbSection.__proto__ || Object.getPrototypeOf(BreadcrumbSection)).call.apply(_ref, [this].concat(args))), _this), _this.computeElementType = function () {
      var _this$props = _this.props,
          link = _this$props.link,
          onClick = _this$props.onClick;


      if (link || onClick) return 'a';
    }, _this.handleClick = function (e) {
      return __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(BreadcrumbSection, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          content = _props.content,
          href = _props.href;


      var classes = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(active, 'active'), 'section', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["r" /* getUnhandledProps */])(BreadcrumbSection, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["q" /* getElementType */])(BreadcrumbSection, this.props, this.computeElementType);

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, href: href, onClick: this.handleClick }),
        __WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].isNil(children) ? content : children
      );
    }
  }]);

  return BreadcrumbSection;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

BreadcrumbSection._meta = {
  name: 'BreadcrumbSection',
  type: __WEBPACK_IMPORTED_MODULE_9__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Breadcrumb'
};
BreadcrumbSection.handledProps = ['active', 'as', 'children', 'className', 'content', 'href', 'link', 'onClick'];
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbSection);
BreadcrumbSection.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Style as the currently active section. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: customPropTypes.every([customPropTypes.disallow(['link']), PropTypes.string]),

  /** Render as an `a` tag instead of a `div`. */
  link: customPropTypes.every([customPropTypes.disallow(['href']), PropTypes.bool]),

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func
} : {};


BreadcrumbSection.create = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["m" /* createShorthandFactory */])(BreadcrumbSection, function (content) {
  return { content: content, link: true };
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Button__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(42);







/**
 * Sugar for <Form.Field control={Button} />.
 * @see Button
 * @see Form
 */
function FormButton(props) {
  var control = props.control;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(FormButton, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["q" /* getElementType */])(FormButton, props);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { control: control }));
}

FormButton.handledProps = ['as', 'control'];
FormButton._meta = {
  name: 'FormButton',
  parent: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.COLLECTION
};

FormButton.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};

FormButton.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__elements_Button__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (FormButton);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(42);







/**
 * Sugar for <Form.Field control={Checkbox} />.
 * @see Checkbox
 * @see Form
 */
function FormCheckbox(props) {
  var control = props.control;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(FormCheckbox, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["q" /* getElementType */])(FormCheckbox, props);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { control: control }));
}

FormCheckbox.handledProps = ['as', 'control'];
FormCheckbox._meta = {
  name: 'FormCheckbox',
  parent: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.COLLECTION
};

FormCheckbox.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};

FormCheckbox.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (FormCheckbox);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(42);







/**
 * Sugar for <Form.Field control={Dropdown} />.
 * @see Dropdown
 * @see Form
 */
function FormDropdown(props) {
  var control = props.control;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(FormDropdown, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["q" /* getElementType */])(FormDropdown, props);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { control: control }));
}

FormDropdown.handledProps = ['as', 'control'];
FormDropdown._meta = {
  name: 'FormDropdown',
  parent: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.COLLECTION
};

FormDropdown.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};

FormDropdown.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (FormDropdown);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);








/**
 * A set of fields can appear grouped together.
 * @see Form
 */
function FormGroup(props) {
  var children = props.children,
      className = props.className,
      grouped = props.grouped,
      inline = props.inline,
      unstackable = props.unstackable,
      widths = props.widths;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(grouped, 'grouped'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(inline, 'inline'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["H" /* useWidthProp */])(widths, null, true), 'fields', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(FormGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(FormGroup, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
}

FormGroup.handledProps = ['as', 'children', 'className', 'grouped', 'inline', 'unstackable', 'widths'];
FormGroup._meta = {
  name: 'FormGroup',
  parent: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.COLLECTION
};

FormGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Fields can show related choices. */
  grouped: customPropTypes.every([customPropTypes.disallow(['inline']), PropTypes.bool]),

  /** Multiple fields may be inline in a row. */
  inline: customPropTypes.every([customPropTypes.disallow(['grouped']), PropTypes.bool]),

  /** A form group can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** Fields Groups can specify their width in grid columns or automatically divide fields to be equal width. */
  widths: PropTypes.oneOf([].concat(_toConsumableArray(SUI.WIDTHS), ['equal']))
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Input__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(42);







/**
 * Sugar for <Form.Field control={Input} />.
 * @see Form
 * @see Input
 */
function FormInput(props) {
  var control = props.control;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(FormInput, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["q" /* getElementType */])(FormInput, props);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { control: control }));
}

FormInput.handledProps = ['as', 'control'];
FormInput._meta = {
  name: 'FormInput',
  parent: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.COLLECTION
};

FormInput.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};

FormInput.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__elements_Input__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (FormInput);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addons_Radio__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(42);







/**
 * Sugar for <Form.Field control={Radio} />.
 * @see Form
 * @see Radio
 */
function FormRadio(props) {
  var control = props.control;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(FormRadio, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["q" /* getElementType */])(FormRadio, props);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { control: control }));
}

FormRadio.handledProps = ['as', 'control'];
FormRadio._meta = {
  name: 'FormRadio',
  parent: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.COLLECTION
};

FormRadio.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};

FormRadio.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__addons_Radio__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (FormRadio);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addons_Select__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(42);







/**
 * Sugar for <Form.Field control={Select} />.
 * @see Form
 * @see Select
 */
function FormSelect(props) {
  var control = props.control;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(FormSelect, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["q" /* getElementType */])(FormSelect, props);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { control: control }));
}

FormSelect.handledProps = ['as', 'control'];
FormSelect._meta = {
  name: 'FormSelect',
  parent: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.COLLECTION
};

FormSelect.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};

FormSelect.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__addons_Select__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (FormSelect);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addons_TextArea__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormField__ = __webpack_require__(42);







/**
 * Sugar for <Form.Field control={TextArea} />.
 * @see Form
 * @see TextArea
 */
function FormTextArea(props) {
  var control = props.control;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(FormTextArea, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["q" /* getElementType */])(FormTextArea, props);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { control: control }));
}

FormTextArea.handledProps = ['as', 'control'];
FormTextArea._meta = {
  name: 'FormTextArea',
  parent: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.COLLECTION
};

FormTextArea.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};

FormTextArea.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_4__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_3__addons_TextArea__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (FormTextArea);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GridColumn__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GridRow__ = __webpack_require__(384);










/**
 * A grid is used to harmonize negative space in a layout.
 */
function Grid(props) {
  var celled = props.celled,
      centered = props.centered,
      children = props.children,
      className = props.className,
      columns = props.columns,
      container = props.container,
      divided = props.divided,
      doubling = props.doubling,
      inverted = props.inverted,
      padded = props.padded,
      relaxed = props.relaxed,
      reversed = props.reversed,
      stackable = props.stackable,
      stretched = props.stretched,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(container, 'container'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(doubling, 'doubling'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(stretched, 'stretched'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useKeyOrValueAndKey */])(celled, 'celled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useKeyOrValueAndKey */])(divided, 'divided'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useKeyOrValueAndKey */])(padded, 'padded'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["D" /* useMultipleProp */])(reversed, 'reversed'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["G" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["H" /* useWidthProp */])(columns, 'column', true), 'grid', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(Grid, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(Grid, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
}

Grid.handledProps = ['as', 'celled', 'centered', 'children', 'className', 'columns', 'container', 'divided', 'doubling', 'inverted', 'padded', 'relaxed', 'reversed', 'stackable', 'stretched', 'textAlign', 'verticalAlign'];
Grid.Column = __WEBPACK_IMPORTED_MODULE_6__GridColumn__["a" /* default */];
Grid.Row = __WEBPACK_IMPORTED_MODULE_7__GridRow__["a" /* default */];

Grid._meta = {
  name: 'Grid',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.COLLECTION
};

Grid.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A grid can have rows divided into cells. */
  celled: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['internally'])]),

  /** A grid can have its columns centered. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Represents column count per row in Grid. */
  columns: PropTypes.oneOf([].concat(_toConsumableArray(SUI.WIDTHS), ['equal'])),

  /** A grid can be combined with a container to use the available layout and alignment. */
  container: PropTypes.bool,

  /** A grid can have dividers between its columns. */
  divided: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['vertically'])]),

  /** A grid can double its column width on tablet and mobile sizes. */
  doubling: PropTypes.bool,

  /** A grid's colors can be inverted. */
  inverted: PropTypes.bool,

  /** A grid can preserve its vertical and horizontal gutters on first and last columns. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontally', 'vertically'])]),

  /** A grid can increase its gutters to allow for more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A grid can specify that its columns should reverse order at different device sizes. */
  reversed: customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),

  /** A grid can have its columns stack on-top of each other after reaching mobile breakpoints. */
  stackable: PropTypes.bool,

  /** A grid can stretch its contents to take up the entire grid height. */
  stretched: PropTypes.bool,

  /** A grid can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A grid can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);








/**
 * A row sub-component for Grid.
 */
function GridRow(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      color = props.color,
      columns = props.columns,
      divided = props.divided,
      only = props.only,
      reversed = props.reversed,
      stretched = props.stretched,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(color, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(divided, 'divided'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(stretched, 'stretched'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["D" /* useMultipleProp */])(only, 'only'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["D" /* useMultipleProp */])(reversed, 'reversed'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["G" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["H" /* useWidthProp */])(columns, 'column', true), 'row', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(GridRow, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(GridRow, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
}

GridRow.handledProps = ['as', 'centered', 'children', 'className', 'color', 'columns', 'divided', 'only', 'reversed', 'stretched', 'textAlign', 'verticalAlign'];
GridRow._meta = {
  name: 'GridRow',
  parent: 'Grid',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.COLLECTION
};

GridRow.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A row can have its columns centered. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A grid row can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Represents column count per line in Row. */
  columns: PropTypes.oneOf([].concat(_toConsumableArray(SUI.WIDTHS), ['equal'])),

  /** A row can have dividers between its columns. */
  divided: PropTypes.bool,

  /** A row can appear only for a specific device, or screen sizes. */
  only: customPropTypes.multipleProp(SUI.VISIBILITY),

  /** A row can specify that its columns should reverse order at different device sizes. */
  reversed: customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),

  /** A row can stretch its contents to take up the entire column height. */
  stretched: PropTypes.bool,

  /** A row can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A row can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (GridRow);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A message can contain a content.
 */
function MessageContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(MessageContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(MessageContent, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

MessageContent.handledProps = ['as', 'children', 'className', 'content'];
MessageContent._meta = {
  name: 'MessageContent',
  parent: 'Message',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.COLLECTION
};

MessageContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (MessageContent);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A message can contain a header.
 */
function MessageHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(MessageHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(MessageHeader, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

MessageHeader.handledProps = ['as', 'children', 'className', 'content'];
MessageHeader._meta = {
  name: 'MessageHeader',
  parent: 'Message',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.COLLECTION
};

MessageHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

MessageHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(MessageHeader, function (val) {
  return { content: val };
});

/* harmony default export */ __webpack_exports__["a"] = (MessageHeader);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MessageItem__ = __webpack_require__(205);










/**
 * A message can contain a list of items.
 */
function MessageList(props) {
  var children = props.children,
      className = props.className,
      items = props.items;

  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('list', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(MessageList, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(MessageList, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(items, __WEBPACK_IMPORTED_MODULE_6__MessageItem__["a" /* default */].create) : children
  );
}

MessageList.handledProps = ['as', 'children', 'className', 'items'];
MessageList._meta = {
  name: 'MessageList',
  parent: 'Message',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.COLLECTION
};

MessageList.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand Message.Items. */
  items: customPropTypes.collectionShorthand
} : {};

MessageList.defaultProps = {
  as: 'ul'
};

MessageList.create = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["m" /* createShorthandFactory */])(MessageList, function (val) {
  return { items: val };
});

/* harmony default export */ __webpack_exports__["a"] = (MessageList);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







function TableBody(props) {
  var children = props.children,
      className = props.className;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(TableBody, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(TableBody, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
}

TableBody.handledProps = ['as', 'children', 'className'];
TableBody._meta = {
  name: 'TableBody',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Table'
};

TableBody.defaultProps = {
  as: 'tbody'
};

TableBody.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string
} : {};

/* harmony default export */ __webpack_exports__["a"] = (TableBody);

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableHeader__ = __webpack_require__(206);






/**
 * A table can have a footer.
 */
function TableFooter(props) {
  var as = props.as;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(TableFooter, props);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TableHeader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { as: as }));
}

TableFooter.handledProps = ['as'];
TableFooter._meta = {
  name: 'TableFooter',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Table'
};

TableFooter.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as
} : {};

TableFooter.defaultProps = {
  as: 'tfoot'
};

/* harmony default export */ __webpack_exports__["a"] = (TableFooter);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableCell__ = __webpack_require__(141);








/**
 * A table can have a header cell.
 */
function TableHeaderCell(props) {
  var as = props.as,
      className = props.className,
      sorted = props.sorted;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["F" /* useValueAndKey */])(sorted, 'sorted'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(TableHeaderCell, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableCell__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { as: as, className: classes }));
}

TableHeaderCell.handledProps = ['as', 'className', 'sorted'];
TableHeaderCell._meta = {
  name: 'TableHeaderCell',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Table'
};

TableHeaderCell.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** A header cell can be sorted in ascending or descending order. */
  sorted: PropTypes.oneOf(['ascending', 'descending'])
} : {};

TableHeaderCell.defaultProps = {
  as: 'th'
};

/* harmony default export */ __webpack_exports__["a"] = (TableHeaderCell);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableCell__ = __webpack_require__(141);











/**
 * A table can have rows.
 */
function TableRow(props) {
  var active = props.active,
      cellAs = props.cellAs,
      cells = props.cells,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      error = props.error,
      negative = props.negative,
      positive = props.positive,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      warning = props.warning;


  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["E" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["G" /* useVerticalAlignProp */])(verticalAlign), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["r" /* getUnhandledProps */])(TableRow, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getElementType */])(TableRow, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(cells, function (cell) {
      return __WEBPACK_IMPORTED_MODULE_7__TableCell__["a" /* default */].create(cell, { defaultProps: { as: cellAs } });
    })
  );
}

TableRow.handledProps = ['active', 'as', 'cellAs', 'cells', 'children', 'className', 'disabled', 'error', 'negative', 'positive', 'textAlign', 'verticalAlign', 'warning'];
TableRow._meta = {
  name: 'TableRow',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.COLLECTION,
  parent: 'Table'
};

TableRow.defaultProps = {
  as: 'tr',
  cellAs: 'td'
};

TableRow.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A row can be active or selected by a user. */
  active: PropTypes.bool,

  /** An element type to render as (string or function). */
  cellAs: customPropTypes.as,

  /** Shorthand array of props for TableCell. */
  cells: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A row can be disabled. */
  disabled: PropTypes.bool,

  /** A row may call attention to an error or a negative value. */
  error: PropTypes.bool,

  /** A row may let a user know whether a value is bad. */
  negative: PropTypes.bool,

  /** A row may let a user know whether a value is good. */
  positive: PropTypes.bool,

  /** A table row can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table row can adjust its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A row may warn a user. */
  warning: PropTypes.bool
} : {};

TableRow.create = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["m" /* createShorthandFactory */])(TableRow, function (cells) {
  return { cells: cells };
});

/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * Headers may contain subheaders.
 */
function HeaderSubheader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('sub header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(HeaderSubheader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(HeaderSubheader, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

HeaderSubheader.handledProps = ['as', 'children', 'className', 'content'];
HeaderSubheader._meta = {
  name: 'HeaderSubheader',
  parent: 'Header',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

HeaderSubheader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

HeaderSubheader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(HeaderSubheader, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (HeaderSubheader);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * Header content wraps the main content when there is an adjacent Icon or Image.
 */
function HeaderContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(HeaderContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(HeaderContent, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

HeaderContent.handledProps = ['as', 'children', 'className', 'content'];
HeaderContent._meta = {
  name: 'HeaderContent',
  parent: 'Header',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

HeaderContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (HeaderContent);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isPlainObject__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_Image__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ListContent__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ListDescription__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ListHeader__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ListIcon__ = __webpack_require__(208);



















/**
 * A list item can contain a set of items.
 */

var ListItem = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ListItem, _Component);

  function ListItem() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var disabled = _this.props.disabled;


      if (!disabled) __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          content = _props.content,
          description = _props.description,
          disabled = _props.disabled,
          header = _props.header,
          icon = _props.icon,
          image = _props.image,
          value = _props.value;


      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(ListItem, this.props);
      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(ElementType !== 'li', 'item'), className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(ListItem, this.props);
      var valueProp = ElementType === 'li' ? { value: value } : { 'data-value': value };

      if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, valueProp, { role: 'listitem', className: classes, onClick: this.handleClick }),
          children
        );
      }

      var iconElement = __WEBPACK_IMPORTED_MODULE_15__ListIcon__["a" /* default */].create(icon);
      var imageElement = __WEBPACK_IMPORTED_MODULE_11__elements_Image__["a" /* default */].create(image);

      // See description of `content` prop for explanation about why this is necessary.
      if (!Object(__WEBPACK_IMPORTED_MODULE_9_react__["isValidElement"])(content) && __WEBPACK_IMPORTED_MODULE_5_lodash_isPlainObject___default()(content)) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, valueProp, { role: 'listitem', className: classes, onClick: this.handleClick }),
          iconElement || imageElement,
          __WEBPACK_IMPORTED_MODULE_12__ListContent__["a" /* default */].create(content, { header: header, description: description })
        );
      }

      var headerElement = __WEBPACK_IMPORTED_MODULE_14__ListHeader__["a" /* default */].create(header);
      var descriptionElement = __WEBPACK_IMPORTED_MODULE_13__ListDescription__["a" /* default */].create(description);
      if (iconElement || imageElement) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, valueProp, { role: 'listitem', className: classes, onClick: this.handleClick }),
          iconElement || imageElement,
          (content || headerElement || descriptionElement) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_12__ListContent__["a" /* default */],
            null,
            headerElement,
            descriptionElement,
            content
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, valueProp, { role: 'listitem', className: classes, onClick: this.handleClick }),
        headerElement,
        descriptionElement,
        content
      );
    }
  }]);

  return ListItem;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

ListItem._meta = {
  name: 'ListItem',
  parent: 'List',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.ELEMENT
};
ListItem.handledProps = ['active', 'as', 'children', 'className', 'content', 'description', 'disabled', 'header', 'icon', 'image', 'onClick', 'value'];
ListItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A list item can active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /**
   * Shorthand for primary content.
   *
   * Heads up!
   *
   * This is handled slightly differently than the typical `content` prop since
   * the wrapping ListContent is not used when there's no icon or image.
   *
   * If you pass content as:
   * - an element/literal, it's treated as the sibling node to
   * header/description (whether wrapped in Item.Content or not).
   * - a props object, it forces the presence of Item.Content and passes those
   * props to it. If you pass a content prop within that props object, it
   * will be treated as the sibling node to header/description.
   */
  content: customPropTypes.itemShorthand,

  /** Shorthand for ListDescription. */
  description: customPropTypes.itemShorthand,

  /** A list item can disabled. */
  disabled: PropTypes.bool,

  /** Shorthand for ListHeader. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ListIcon. */
  icon: customPropTypes.every([customPropTypes.disallow(['image']), customPropTypes.itemShorthand]),

  /** Shorthand for Image. */
  image: customPropTypes.every([customPropTypes.disallow(['icon']), customPropTypes.itemShorthand]),

  /** A ListItem can be clicked */
  onClick: PropTypes.func,

  /** A value for an ordered list. */
  value: PropTypes.string
} : {};


ListItem.create = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["m" /* createShorthandFactory */])(ListItem, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A list can contain a sub list.
 */
function ListList(props) {
  var children = props.children,
      className = props.className,
      content = props.content;


  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ListList, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ListList, props);
  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(ElementType !== 'ul' && ElementType !== 'ol', 'list'), className);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

ListList.handledProps = ['as', 'children', 'className', 'content'];
ListList._meta = {
  name: 'ListList',
  parent: 'List',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

ListList.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (ListList);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A content sub-component for the Reveal.
 */
function RevealContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      hidden = props.hidden,
      visible = props.visible;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(hidden, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(visible, 'visible'), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(RevealContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(RevealContent, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

RevealContent.handledProps = ['as', 'children', 'className', 'content', 'hidden', 'visible'];
RevealContent._meta = {
  name: 'RevealContent',
  parent: 'Reveal',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

RevealContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A reveal may contain content that is visible before interaction. */
  hidden: PropTypes.bool,

  /** A reveal may contain content that is hidden before user interaction. */
  visible: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (RevealContent);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SegmentGroup__ = __webpack_require__(398);










/**
 * A segment is used to create a grouping of related content.
 */
function Segment(props) {
  var attached = props.attached,
      basic = props.basic,
      children = props.children,
      circular = props.circular,
      className = props.className,
      clearing = props.clearing,
      color = props.color,
      compact = props.compact,
      content = props.content,
      disabled = props.disabled,
      floated = props.floated,
      inverted = props.inverted,
      loading = props.loading,
      padded = props.padded,
      piled = props.piled,
      raised = props.raised,
      secondary = props.secondary,
      size = props.size,
      stacked = props.stacked,
      tertiary = props.tertiary,
      textAlign = props.textAlign,
      vertical = props.vertical;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(circular, 'circular'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(clearing, 'clearing'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(piled, 'piled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(raised, 'raised'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(secondary, 'secondary'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(stacked, 'stacked'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(tertiary, 'tertiary'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(vertical, 'vertical'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useKeyOrValueAndKey */])(padded, 'padded'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["F" /* useValueAndKey */])(floated, 'floated'), 'segment', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(Segment, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(Segment, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

Segment.handledProps = ['as', 'attached', 'basic', 'children', 'circular', 'className', 'clearing', 'color', 'compact', 'content', 'disabled', 'floated', 'inverted', 'loading', 'padded', 'piled', 'raised', 'secondary', 'size', 'stacked', 'tertiary', 'textAlign', 'vertical'];
Segment.Group = __WEBPACK_IMPORTED_MODULE_6__SegmentGroup__["a" /* default */];

Segment._meta = {
  name: 'Segment',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.ELEMENT
};

Segment.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Attach segment to other content, like a header. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A basic segment has no special formatting. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** A segment can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A segment can clear floated content. */
  clearing: PropTypes.bool,

  /** Segment can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A segment may take up only as much space as is necessary. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A segment may show its content is disabled. */
  disabled: PropTypes.bool,

  /** Segment content can be floated to the left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A segment can have its colors inverted for contrast. */
  inverted: PropTypes.bool,

  /** A segment may show its content is being loaded. */
  loading: PropTypes.bool,

  /** A segment can increase its padding. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Formatted to look like a pile of pages. */
  piled: PropTypes.bool,

  /** A segment may be formatted to raise above the page. */
  raised: PropTypes.bool,

  /** A segment can be formatted to appear less noticeable. */
  secondary: PropTypes.bool,

  /** A segment can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Formatted to show it contains multiple pages. */
  stacked: PropTypes.bool,

  /** A segment can be formatted to appear even less noticeable. */
  tertiary: PropTypes.bool,

  /** Formats content to be aligned as part of a vertical group. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** Formats content to be aligned vertically. */
  vertical: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (Segment);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);









/**
 * A group of segments can be formatted to appear together.
 */
function SegmentGroup(props) {
  var children = props.children,
      className = props.className,
      compact = props.compact,
      content = props.content,
      horizontal = props.horizontal,
      piled = props.piled,
      raised = props.raised,
      size = props.size,
      stacked = props.stacked;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(piled, 'piled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(raised, 'raised'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(stacked, 'stacked'), 'segments', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(SegmentGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(SegmentGroup, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

SegmentGroup.handledProps = ['as', 'children', 'className', 'compact', 'content', 'horizontal', 'piled', 'raised', 'size', 'stacked'];
SegmentGroup._meta = {
  name: 'SegmentGroup',
  parent: 'Segment',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.ELEMENT
};

SegmentGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A segment may take up only as much space as is necessary. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Formats content to be aligned horizontally. */
  horizontal: PropTypes.bool,

  /** Formatted to look like a pile of pages. */
  piled: PropTypes.bool,

  /** A segment group may be formatted to raise above the page. */
  raised: PropTypes.bool,

  /** A segment group can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Formatted to show it contains multiple pages. */
  stacked: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (SegmentGroup);

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_Icon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepContent__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StepDescription__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StepGroup__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__StepTitle__ = __webpack_require__(210);



















/**
 * A step shows the completion status of an activity in a series of activities.
 */

var Step = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Step, _Component);

  function Step() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Step);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Step.__proto__ || Object.getPrototypeOf(Step)).call.apply(_ref, [this].concat(args))), _this), _this.computeElementType = function () {
      var onClick = _this.props.onClick;


      if (onClick) return 'a';
    }, _this.handleClick = function (e) {
      var disabled = _this.props.disabled;


      if (!disabled) __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Step, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          completed = _props.completed,
          content = _props.content,
          description = _props.description,
          disabled = _props.disabled,
          href = _props.href,
          icon = _props.icon,
          link = _props.link,
          title = _props.title;


      var classes = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(completed, 'completed'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_9__lib__["B" /* useKeyOnly */])(link, 'link'), 'step', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["r" /* getUnhandledProps */])(Step, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["q" /* getElementType */])(Step, this.props, this.computeElementType);

      if (!__WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, href: href, onClick: this.handleClick }),
          children
        );
      }

      if (!__WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, href: href, onClick: this.handleClick }),
          content
        );
      }

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, href: href, onClick: this.handleClick }),
        __WEBPACK_IMPORTED_MODULE_10__elements_Icon__["a" /* default */].create(icon),
        __WEBPACK_IMPORTED_MODULE_11__StepContent__["a" /* default */].create({ description: description, title: title })
      );
    }
  }]);

  return Step;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Step._meta = {
  name: 'Step',
  type: __WEBPACK_IMPORTED_MODULE_9__lib__["b" /* META */].TYPES.ELEMENT
};
Step.Content = __WEBPACK_IMPORTED_MODULE_11__StepContent__["a" /* default */];
Step.Description = __WEBPACK_IMPORTED_MODULE_12__StepDescription__["a" /* default */];
Step.Group = __WEBPACK_IMPORTED_MODULE_13__StepGroup__["a" /* default */];
Step.Title = __WEBPACK_IMPORTED_MODULE_14__StepTitle__["a" /* default */];
Step.handledProps = ['active', 'as', 'children', 'className', 'completed', 'content', 'description', 'disabled', 'href', 'icon', 'link', 'onClick', 'ordered', 'title'];
Step.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A step can be highlighted as active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A step can show that a user has completed it. */
  completed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for StepDescription. */
  description: customPropTypes.itemShorthand,

  /** Show that the Loader is inactive. */
  disabled: PropTypes.bool,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: PropTypes.string,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** A step can be link. */
  link: PropTypes.bool,

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A step can show a ordered sequence of steps. Passed from StepGroup. */
  ordered: PropTypes.bool,

  /** Shorthand for StepTitle. */
  title: customPropTypes.itemShorthand
} : {};


Step.create = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["m" /* createShorthandFactory */])(Step, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (Step);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StepDescription__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepTitle__ = __webpack_require__(210);









/**
 * A step can contain a content.
 */
function StepContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      title = props.title;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(StepContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(StepContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content
  );

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_6__StepTitle__["a" /* default */].create(title),
    __WEBPACK_IMPORTED_MODULE_5__StepDescription__["a" /* default */].create(description)
  );
}

StepContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'title'];
StepContent._meta = {
  name: 'StepContent',
  parent: 'Step',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

StepContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for StepDescription. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for StepTitle. */
  title: customPropTypes.itemShorthand
} : {};

StepContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(StepContent, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (StepContent);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pickBy__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Step__ = __webpack_require__(399);















var numberMap = __WEBPACK_IMPORTED_MODULE_6_lodash_pickBy___default()(__WEBPACK_IMPORTED_MODULE_10__lib__["y" /* numberToWordMap */], function (val, key) {
  return key <= 8;
});

/**
 * A set of steps.
 */
function StepGroup(props) {
  var attached = props.attached,
      children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      items = props.items,
      ordered = props.ordered,
      size = props.size,
      stackable = props.stackable,
      unstackable = props.unstackable,
      vertical = props.vertical,
      widths = props.widths;

  var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(ordered, 'ordered'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(vertical, 'vertical'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["C" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["F" /* useValueAndKey */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["H" /* useWidthProp */])(widths), 'steps', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(StepGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(StepGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
  if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content
  );

  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(items, function (item) {
      return __WEBPACK_IMPORTED_MODULE_11__Step__["a" /* default */].create(item);
    })
  );
}

StepGroup.handledProps = ['as', 'attached', 'children', 'className', 'content', 'fluid', 'items', 'ordered', 'size', 'stackable', 'unstackable', 'vertical', 'widths'];
StepGroup._meta = {
  name: 'StepGroup',
  parent: 'Step',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.ELEMENT
};

StepGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Steps can be attached to other elements. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A fluid step takes up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand array of props for Step. */
  items: customPropTypes.collectionShorthand,

  /** A step can show a ordered sequence of steps. */
  ordered: PropTypes.bool,

  /** Steps can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A step can stack vertically only on smaller screens. */
  stackable: PropTypes.oneOf(['tablet']),

  /** A step can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** A step can be displayed stacked vertically. */
  vertical: PropTypes.bool,

  /** Steps can be divided evenly inside their parent. */
  widths: PropTypes.oneOf([].concat(_toConsumableArray(_keys(numberMap)), _toConsumableArray(_keys(numberMap).map(Number)), _toConsumableArray(_values(numberMap))))
} : {};

/* harmony default export */ __webpack_exports__["a"] = (StepGroup);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_each__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AccordionContent__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AccordionTitle__ = __webpack_require__(212);




















/**
 * An Accordion can contain sub-accordions.
 */

var AccordionAccordion = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AccordionAccordion, _Component);

  function AccordionAccordion() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AccordionAccordion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AccordionAccordion.__proto__ || Object.getPrototypeOf(AccordionAccordion)).call.apply(_ref, [this].concat(args))), _this), _this.computeNewIndex = function (index) {
      var exclusive = _this.props.exclusive;
      var activeIndex = _this.state.activeIndex;


      if (exclusive) return index === activeIndex ? -1 : index;
      // check to see if index is in array, and remove it, if not then add it
      return __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(activeIndex, index) ? __WEBPACK_IMPORTED_MODULE_9_lodash_without___default()(activeIndex, index) : [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(activeIndex), [index]);
    }, _this.handleTitleOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, titleProps) {
          var index = titleProps.index;

          var activeIndex = _this.computeNewIndex(index);

          _this.trySetState({ activeIndex: activeIndex });

          __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(predefinedProps, 'onClick', e, titleProps);
          __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onTitleClick', e, titleProps);
        }
      };
    }, _this.isIndexActive = function (index) {
      var exclusive = _this.props.exclusive;
      var activeIndex = _this.state.activeIndex;


      return exclusive ? activeIndex === index : __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(activeIndex, index);
    }, _this.renderPanels = function () {
      var children = [];
      var panels = _this.props.panels;


      __WEBPACK_IMPORTED_MODULE_7_lodash_each___default()(panels, function (panel, index) {
        var content = panel.content,
            title = panel.title;

        var active = _this.isIndexActive(index);

        children.push(__WEBPACK_IMPORTED_MODULE_16__AccordionTitle__["a" /* default */].create(title, {
          defaultProps: { active: active, index: index },
          overrideProps: _this.handleTitleOverrides
        }));
        children.push(__WEBPACK_IMPORTED_MODULE_15__AccordionContent__["a" /* default */].create(content, { defaultProps: { active: active } }));
      });

      return children;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AccordionAccordion, [{
    key: 'getInitialAutoControlledState',
    value: function getInitialAutoControlledState(_ref2) {
      var exclusive = _ref2.exclusive;

      return { activeIndex: exclusive ? -1 : [-1] };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;


      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('accordion', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["r" /* getUnhandledProps */])(AccordionAccordion, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getElementType */])(AccordionAccordion, this.props);

      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
        __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(children) ? this.renderPanels() : children
      );
    }
  }]);

  return AccordionAccordion;
}(__WEBPACK_IMPORTED_MODULE_14__lib__["a" /* AutoControlledComponent */]);

AccordionAccordion.defaultProps = {
  exclusive: true
};
AccordionAccordion.autoControlledProps = ['activeIndex'];
AccordionAccordion._meta = {
  name: 'AccordionAccordion',
  type: __WEBPACK_IMPORTED_MODULE_14__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Accordion'
};
AccordionAccordion.handledProps = ['activeIndex', 'as', 'children', 'className', 'defaultActiveIndex', 'exclusive', 'onTitleClick', 'panels'];
/* harmony default export */ __webpack_exports__["a"] = (AccordionAccordion);
AccordionAccordion.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Index of the currently active panel. */
  activeIndex: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Initial activeIndex value. */
  defaultActiveIndex: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])]),

  /** Only allow one panel open at a time. */
  exclusive: PropTypes.bool,

  /**
   * Called when a panel title is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onTitleClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** Shorthand array of props for Accordion. */
  panels: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.arrayOf(PropTypes.shape({
    content: customPropTypes.itemShorthand,
    title: customPropTypes.itemShorthand
  }))])
} : {};


AccordionAccordion.create = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["m" /* createShorthandFactory */])(AccordionAccordion, function (content) {
  return { content: content };
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopupContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A PopupContent displays the content body of a Popover.
 */
function PopupContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(PopupContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(PopupContent, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

PopupContent.handledProps = ['as', 'children', 'className', 'content'];
PopupContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The content of the Popup */
  children: PropTypes.node,

  /** Classes to add to the Popup content className. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

PopupContent._meta = {
  name: 'PopupContent',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Popup'
};

PopupContent.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(PopupContent, function (children) {
  return { children: children };
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopupHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A PopupHeader displays a header in a Popover.
 */
function PopupHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(PopupHeader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(PopupHeader, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

PopupHeader.handledProps = ['as', 'children', 'className', 'content'];
PopupHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

PopupHeader._meta = {
  name: 'PopupHeader',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Popup'
};

PopupHeader.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(PopupHeader, function (children) {
  return { children: children };
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(2);











/**
 * An internal icon sub-component for Rating component
 */

var RatingIcon = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RatingIcon, _Component);

  function RatingIcon() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RatingIcon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = RatingIcon.__proto__ || Object.getPrototypeOf(RatingIcon)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var onClick = _this.props.onClick;


      if (onClick) onClick(e, _this.props);
    }, _this.handleKeyUp = function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onKeyUp = _this$props.onKeyUp;


      if (onKeyUp) onKeyUp(e, _this.props);

      if (onClick) {
        switch (__WEBPACK_IMPORTED_MODULE_8__lib__["u" /* keyboardKey */].getCode(e)) {
          case __WEBPACK_IMPORTED_MODULE_8__lib__["u" /* keyboardKey */].Enter:
          case __WEBPACK_IMPORTED_MODULE_8__lib__["u" /* keyboardKey */].Spacebar:
            e.preventDefault();
            onClick(e, _this.props);
            break;
          default:
        }
      }
    }, _this.handleMouseEnter = function (e) {
      var onMouseEnter = _this.props.onMouseEnter;


      if (onMouseEnter) onMouseEnter(e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RatingIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          className = _props.className,
          selected = _props.selected;

      var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(selected, 'selected'), 'icon', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["r" /* getUnhandledProps */])(RatingIcon, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* getElementType */])(RatingIcon, this.props);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        className: classes,
        onClick: this.handleClick,
        onKeyUp: this.handleKeyUp,
        onMouseEnter: this.handleMouseEnter,
        tabIndex: 0,
        role: 'radio'
      }));
    }
  }]);

  return RatingIcon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

RatingIcon.defaultProps = {
  as: 'i'
};
RatingIcon._meta = {
  name: 'RatingIcon',
  parent: 'Rating',
  type: __WEBPACK_IMPORTED_MODULE_8__lib__["b" /* META */].TYPES.MODULE
};
RatingIcon.handledProps = ['active', 'as', 'className', 'index', 'onClick', 'onKeyUp', 'onMouseEnter', 'selected'];
/* harmony default export */ __webpack_exports__["a"] = (RatingIcon);
RatingIcon.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Indicates activity of an icon. */
  active: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** An index of icon inside Rating. */
  index: PropTypes.number,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called on keyup.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onKeyUp: PropTypes.func,

  /**
   * Called on mouseenter.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseEnter: PropTypes.func,

  /** Indicates selection of an icon. */
  selected: PropTypes.bool
} : {};

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







function SearchCategory(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      renderer = props.renderer;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(active, 'active'), 'category', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(SearchCategory, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(SearchCategory, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: 'name' },
      renderer(props)
    ),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

SearchCategory.handledProps = ['active', 'as', 'children', 'className', 'content', 'name', 'renderer', 'results'];
SearchCategory._meta = {
  name: 'SearchCategory',
  parent: 'Search',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE
};

SearchCategory.defaultProps = {
  renderer: function renderer(_ref) {
    var name = _ref.name;
    return name;
  }
};

SearchCategory.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The item currently selected by keyboard shortcut. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Display name. */
  name: PropTypes.string,

  /**
   * Renders the category contents.
   *
   * @param {object} props - The SearchCategory props object.
   * @returns {*} - Renderable category contents.
   */
  renderer: PropTypes.func,

  /** Array of Search.Result props. */
  results: PropTypes.array
} : {};

/* harmony default export */ __webpack_exports__["a"] = (SearchCategory);

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(2);











// Note: You technically only need the 'content' wrapper when there's an
// image. However, optionally wrapping it makes this function a lot more
// complicated and harder to read. Since always wrapping it doesn't affect
// the style in any way let's just do that.
//
// Note: To avoid requiring a wrapping div, we return an array here so to
// prevent rendering issues each node needs a unique key.
var defaultRenderer = function defaultRenderer(_ref) {
  var image = _ref.image,
      price = _ref.price,
      title = _ref.title,
      description = _ref.description;
  return [image && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { key: 'image', className: 'image' },
    Object(__WEBPACK_IMPORTED_MODULE_8__lib__["g" /* createHTMLImage */])(image)
  ), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
    'div',
    { key: 'content', className: 'content' },
    price && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'price' },
      price
    ),
    title && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'title' },
      title
    ),
    description && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      { className: 'description' },
      description
    )
  )];
};

defaultRenderer.handledProps = [];

var SearchResult = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SearchResult, _Component);

  function SearchResult() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SearchResult);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = SearchResult.__proto__ || Object.getPrototypeOf(SearchResult)).call.apply(_ref2, [this].concat(args))), _this), _this.handleClick = function (e) {
      var onClick = _this.props.onClick;


      if (onClick) onClick(e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SearchResult, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          className = _props.className,
          renderer = _props.renderer;


      var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(active, 'active'), 'result', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["r" /* getUnhandledProps */])(SearchResult, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* getElementType */])(SearchResult, this.props);

      // Note: You technically only need the 'content' wrapper when there's an
      // image. However, optionally wrapping it makes this function a lot more
      // complicated and harder to read. Since always wrapping it doesn't affect
      // the style in any way let's just do that.
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, onClick: this.handleClick }),
        renderer(this.props)
      );
    }
  }]);

  return SearchResult;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

SearchResult.defaultProps = {
  renderer: defaultRenderer
};
SearchResult._meta = {
  name: 'SearchResult',
  parent: 'Search',
  type: __WEBPACK_IMPORTED_MODULE_8__lib__["b" /* META */].TYPES.MODULE
};
SearchResult.handledProps = ['active', 'as', 'className', 'content', 'description', 'id', 'image', 'onClick', 'price', 'renderer', 'title'];
/* harmony default export */ __webpack_exports__["a"] = (SearchResult);
SearchResult.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The item currently selected by keyboard shortcut. */
  active: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Additional text with less emphasis. */
  description: PropTypes.string,

  /** A unique identifier. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Add an image to the item. */
  image: PropTypes.string,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** Customized text for price. */
  price: PropTypes.string,

  /**
   * Renders the result contents.
   *
   * @param {object} props - The SearchResult props object.
   * @returns {*} - Renderable result contents.
   */
  renderer: PropTypes.func,

  /** Display title. */
  title: PropTypes.string.isRequired
} : {};

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







function SearchResults(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('results transition', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(SearchResults, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(SearchResults, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

SearchResults.handledProps = ['as', 'children', 'className', 'content'];
SearchResults._meta = {
  name: 'SearchResults',
  parent: 'Search',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE
};

SearchResults.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (SearchResults);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A pushable sub-component for Sidebar.
 */
function SidebarPushable(props) {
  var className = props.className,
      children = props.children,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('pushable', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(SidebarPushable, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(SidebarPushable, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

SidebarPushable.handledProps = ['as', 'children', 'className', 'content'];
SidebarPushable._meta = {
  name: 'SidebarPushable',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Sidebar'
};

SidebarPushable.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPushable);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A pushable sub-component for Sidebar.
 */
function SidebarPusher(props) {
  var className = props.className,
      dimmed = props.dimmed,
      children = props.children,
      content = props.content;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('pusher', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(dimmed, 'dimmed'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(SidebarPusher, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(SidebarPusher, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

SidebarPusher.handledProps = ['as', 'children', 'className', 'content', 'dimmed'];
SidebarPusher._meta = {
  name: 'SidebarPusher',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE,
  parent: 'Sidebar'
};

SidebarPusher.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Controls whether or not the dim is displayed. */
  dimmed: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPusher);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__ = __webpack_require__(397);








/**
 * A tab pane holds the content of a tab.
 */
function TabPane(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      loading = props.loading;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(loading, 'loading'), 'tab', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(TabPane, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(TabPane, props);

  var calculatedDefaultProps = {};
  if (ElementType === __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__["a" /* default */]) {
    calculatedDefaultProps.attached = 'bottom';
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, calculatedDefaultProps, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

TabPane.handledProps = ['active', 'as', 'children', 'className', 'content', 'loading'];
TabPane._meta = {
  name: 'TabPane',
  parent: 'Tab',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE
};

TabPane.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__["a" /* default */],
  active: true
};

TabPane.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A tab pane can be active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A Tab.Pane can display a loading indicator. */
  loading: PropTypes.bool
} : {};

TabPane.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(TabPane, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (TabPane);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Image__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CardContent__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardDescription__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardGroup__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardHeader__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardMeta__ = __webpack_require__(215);

















/**
 * A card displays site content in a manner similar to a playing card.
 */

var Card = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Card, _Component);

  function Card() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Card);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Card.__proto__ || Object.getPrototypeOf(Card)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var onClick = _this.props.onClick;


      if (onClick) onClick(e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Card, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          centered = _props.centered,
          children = _props.children,
          className = _props.className,
          color = _props.color,
          content = _props.content,
          description = _props.description,
          extra = _props.extra,
          fluid = _props.fluid,
          header = _props.header,
          href = _props.href,
          image = _props.image,
          link = _props.link,
          meta = _props.meta,
          onClick = _props.onClick,
          raised = _props.raised;


      var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('ui', color, Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(raised, 'raised'), 'card', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["r" /* getUnhandledProps */])(Card, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* getElementType */])(Card, this.props, function () {
        if (onClick) return 'a';
      });

      if (!__WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, href: href, onClick: this.handleClick }),
          children
        );
      }
      if (!__WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, href: href, onClick: this.handleClick }),
          content
        );
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, href: href, onClick: this.handleClick }),
        __WEBPACK_IMPORTED_MODULE_9__elements_Image__["a" /* default */].create(image),
        (description || header || meta) && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CardContent__["a" /* default */], { description: description, header: header, meta: meta }),
        extra && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10__CardContent__["a" /* default */],
          { extra: true },
          extra
        )
      );
    }
  }]);

  return Card;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Card._meta = {
  name: 'Card',
  type: __WEBPACK_IMPORTED_MODULE_8__lib__["b" /* META */].TYPES.VIEW
};
Card.Content = __WEBPACK_IMPORTED_MODULE_10__CardContent__["a" /* default */];
Card.Description = __WEBPACK_IMPORTED_MODULE_11__CardDescription__["a" /* default */];
Card.Group = __WEBPACK_IMPORTED_MODULE_12__CardGroup__["a" /* default */];
Card.Header = __WEBPACK_IMPORTED_MODULE_13__CardHeader__["a" /* default */];
Card.Meta = __WEBPACK_IMPORTED_MODULE_14__CardMeta__["a" /* default */];
Card.handledProps = ['as', 'centered', 'children', 'className', 'color', 'content', 'description', 'extra', 'fluid', 'header', 'href', 'image', 'link', 'meta', 'onClick', 'raised'];
/* harmony default export */ __webpack_exports__["a"] = (Card);
Card.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A Card can center itself inside its container. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A Card can be formatted to display different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for CardDescription. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for primary content of CardContent. */
  extra: customPropTypes.contentShorthand,

  /** A Card can be formatted to take up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand for CardHeader. */
  header: customPropTypes.itemShorthand,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: PropTypes.string,

  /** A card can contain an Image component. */
  image: customPropTypes.itemShorthand,

  /** A card can be formatted to link to other content. */
  link: PropTypes.bool,

  /** Shorthand for CardMeta. */
  meta: customPropTypes.itemShorthand,

  /**
   * Called on click. When passed, the component renders as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A Card can be formatted to raise above the page. */
  raised: PropTypes.bool
} : {};

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardDescription__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardHeader__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardMeta__ = __webpack_require__(215);












/**
 * A card can contain blocks of content or extra content meant to be formatted separately from the main content.
 */
function CardContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      meta = props.meta,
      textAlign = props.textAlign;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(extra, 'extra'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useTextAlignProp */])(textAlign), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(CardContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(CardContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content
  );

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    Object(__WEBPACK_IMPORTED_MODULE_5__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_7__CardHeader__["a" /* default */], function (val) {
      return { content: val };
    }, header),
    Object(__WEBPACK_IMPORTED_MODULE_5__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_8__CardMeta__["a" /* default */], function (val) {
      return { content: val };
    }, meta),
    Object(__WEBPACK_IMPORTED_MODULE_5__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__CardDescription__["a" /* default */], function (val) {
      return { content: val };
    }, description)
  );
}

CardContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'extra', 'header', 'meta', 'textAlign'];
CardContent._meta = {
  name: 'CardContent',
  parent: 'Card',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.VIEW
};

CardContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for CardDescription. */
  description: customPropTypes.itemShorthand,

  /** A card can contain extra content meant to be formatted separately from the main content. */
  extra: PropTypes.bool,

  /** Shorthand for CardHeader. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for CardMeta. */
  meta: customPropTypes.itemShorthand,

  /** A card content can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CardContent);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Card__ = __webpack_require__(412);











/**
 * A group of cards.
 */
function CardGroup(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      content = props.content,
      doubling = props.doubling,
      items = props.items,
      itemsPerRow = props.itemsPerRow,
      stackable = props.stackable,
      textAlign = props.textAlign;


  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(doubling, 'doubling'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["E" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* useWidthProp */])(itemsPerRow), 'cards', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["r" /* getUnhandledProps */])(CardGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getElementType */])(CardGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content
  );

  var itemsJSX = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(items, function (item) {
    var key = item.key || [item.header, item.description].join('-');
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Card__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, item));
  });

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    itemsJSX
  );
}

CardGroup.handledProps = ['as', 'centered', 'children', 'className', 'content', 'doubling', 'items', 'itemsPerRow', 'stackable', 'textAlign'];
CardGroup._meta = {
  name: 'CardGroup',
  parent: 'Card',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.VIEW
};

CardGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A group of cards can center itself inside its container. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A group of cards can double its column width for mobile. */
  doubling: PropTypes.bool,

  /** Shorthand array of props for Card. */
  items: customPropTypes.collectionShorthand,

  /** A group of cards can set how many cards should exist in a row. */
  itemsPerRow: PropTypes.oneOf(SUI.WIDTHS),

  /** A group of cards can automatically stack rows to a single columns on mobile devices. */
  stackable: PropTypes.bool,

  /** A card group can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CardGroup);

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A comment can contain an action.
 */
function CommentAction(props) {
  var active = props.active,
      className = props.className,
      children = props.children,
      content = props.content;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(active, 'active'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(CommentAction, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(CommentAction, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CommentAction.handledProps = ['active', 'as', 'children', 'className', 'content'];
CommentAction._meta = {
  name: 'CommentAction',
  parent: 'Comment',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

CommentAction.defaultProps = {
  as: 'a'
};

CommentAction.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Style as the currently active action. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CommentAction);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A comment can contain an list of actions a user may perform related to this comment.
 */
function CommentActions(props) {
  var className = props.className,
      children = props.children,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('actions', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(CommentActions, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(CommentActions, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CommentActions.handledProps = ['as', 'children', 'className', 'content'];
CommentActions._meta = {
  name: 'CommentActions',
  parent: 'Comment',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

CommentActions.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CommentActions);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A comment can contain an author.
 */
function CommentAuthor(props) {
  var className = props.className,
      children = props.children,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('author', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(CommentAuthor, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(CommentAuthor, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CommentAuthor.handledProps = ['as', 'children', 'className', 'content'];
CommentAuthor._meta = {
  name: 'CommentAuthor',
  parent: 'Comment',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

CommentAuthor.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CommentAuthor);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A comment can contain an image or avatar.
 */
function CommentAvatar(props) {
  var className = props.className,
      src = props.src;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('avatar', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(CommentAvatar, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(CommentAvatar, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["g" /* createHTMLImage */])(src)
  );
}

CommentAvatar.handledProps = ['as', 'className', 'src'];
CommentAvatar._meta = {
  name: 'CommentAvatar',
  parent: 'Comment',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

CommentAvatar.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** Specifies the URL of the image. */
  src: PropTypes.string
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CommentAvatar);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A comment can contain content.
 */
function CommentContent(props) {
  var className = props.className,
      children = props.children,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'content');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(CommentContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(CommentContent, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CommentContent.handledProps = ['as', 'children', 'className', 'content'];
CommentContent._meta = {
  name: 'CommentContent',
  parent: 'Comment',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

CommentContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CommentContent);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);









/**
 * Comments can be grouped.
 */
function CommentGroup(props) {
  var className = props.className,
      children = props.children,
      collapsed = props.collapsed,
      content = props.content,
      minimal = props.minimal,
      size = props.size,
      threaded = props.threaded;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(collapsed, 'collapsed'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(minimal, 'minimal'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(threaded, 'threaded'), 'comments', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(CommentGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(CommentGroup, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CommentGroup.handledProps = ['as', 'children', 'className', 'collapsed', 'content', 'minimal', 'size', 'threaded'];
CommentGroup._meta = {
  name: 'CommentGroup',
  parent: 'Comment',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.VIEW
};

CommentGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Comments can be collapsed, or hidden from view. */
  collapsed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Comments can hide extra information unless a user shows intent to interact with a comment. */
  minimal: PropTypes.bool,

  /** Comments can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A comment list can be threaded to showing the relationship between conversations. */
  threaded: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CommentGroup);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A comment can contain metadata about the comment, an arbitrary amount of metadata may be defined.
 */
function CommentMetadata(props) {
  var className = props.className,
      children = props.children,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('metadata', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(CommentMetadata, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(CommentMetadata, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CommentMetadata.handledProps = ['as', 'children', 'className', 'content'];
CommentMetadata._meta = {
  name: 'CommentMetadata',
  parent: 'Comment',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

CommentMetadata.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CommentMetadata);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A comment can contain text.
 */
function CommentText(props) {
  var className = props.className,
      children = props.children,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, 'text');
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(CommentText, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(CommentText, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

CommentText.handledProps = ['as', 'children', 'className', 'content'];
CommentText._meta = {
  name: 'CommentText',
  parent: 'Comment',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

CommentText.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (CommentText);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedContent__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedLabel__ = __webpack_require__(222);









/**
 * A feed contains an event.
 */
function FeedEvent(props) {
  var content = props.content,
      children = props.children,
      className = props.className,
      date = props.date,
      extraImages = props.extraImages,
      extraText = props.extraText,
      image = props.image,
      icon = props.icon,
      meta = props.meta,
      summary = props.summary;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('event', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(FeedEvent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(FeedEvent, props);

  var hasContentProp = content || date || extraImages || extraText || meta || summary;
  var contentProps = { content: content, date: date, extraImages: extraImages, extraText: extraText, meta: meta, summary: summary };

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedLabel__["a" /* default */], function (val) {
      return { icon: val };
    }, icon),
    Object(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedLabel__["a" /* default */], function (val) {
      return { image: val };
    }, image),
    hasContentProp && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FeedContent__["a" /* default */], contentProps),
    children
  );
}

FeedEvent.handledProps = ['as', 'children', 'className', 'content', 'date', 'extraImages', 'extraText', 'icon', 'image', 'meta', 'summary'];
FeedEvent._meta = {
  name: 'FeedEvent',
  parent: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

FeedEvent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for FeedContent. */
  content: customPropTypes.itemShorthand,

  /** Shorthand for FeedDate. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with images. */
  extraImages: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with content. */
  extraText: customPropTypes.itemShorthand,

  /** An event can contain icon label. */
  icon: customPropTypes.itemShorthand,

  /** An event can contain image label. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for FeedMeta. */
  meta: customPropTypes.itemShorthand,

  /** Shorthand for FeedSummary. */
  summary: customPropTypes.itemShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (FeedEvent);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemContent__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDescription__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemExtra__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemGroup__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ItemHeader__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ItemImage__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ItemMeta__ = __webpack_require__(226);














/**
 * An item view presents large collections of site content for display.
 */
function Item(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      image = props.image,
      meta = props.meta;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('item', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(Item, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(Item, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_10__ItemImage__["a" /* default */].create(image),
    __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ItemContent__["a" /* default */], {
      content: content,
      description: description,
      extra: extra,
      header: header,
      meta: meta
    })
  );
}

Item.handledProps = ['as', 'children', 'className', 'content', 'description', 'extra', 'header', 'image', 'meta'];
Item._meta = {
  name: 'Item',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

Item.Content = __WEBPACK_IMPORTED_MODULE_5__ItemContent__["a" /* default */];
Item.Description = __WEBPACK_IMPORTED_MODULE_6__ItemDescription__["a" /* default */];
Item.Extra = __WEBPACK_IMPORTED_MODULE_7__ItemExtra__["a" /* default */];
Item.Group = __WEBPACK_IMPORTED_MODULE_8__ItemGroup__["a" /* default */];
Item.Header = __WEBPACK_IMPORTED_MODULE_9__ItemHeader__["a" /* default */];
Item.Image = __WEBPACK_IMPORTED_MODULE_10__ItemImage__["a" /* default */];
Item.Meta = __WEBPACK_IMPORTED_MODULE_11__ItemMeta__["a" /* default */];

Item.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for ItemContent component. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ItemDescription component. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for ItemExtra component. */
  extra: customPropTypes.itemShorthand,

  /** Shorthand for ItemHeader component. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ItemImage component. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for ItemMeta component. */
  meta: customPropTypes.itemShorthand
} : {};

/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemHeader__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDescription__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemExtra__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemMeta__ = __webpack_require__(226);











/**
 * An item can contain content.
 */
function ItemContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      meta = props.meta,
      verticalAlign = props.verticalAlign;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["G" /* useVerticalAlignProp */])(verticalAlign), 'content', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(ItemContent, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(ItemContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__ItemHeader__["a" /* default */].create(header),
    __WEBPACK_IMPORTED_MODULE_8__ItemMeta__["a" /* default */].create(meta),
    __WEBPACK_IMPORTED_MODULE_6__ItemDescription__["a" /* default */].create(description),
    __WEBPACK_IMPORTED_MODULE_7__ItemExtra__["a" /* default */].create(extra),
    content
  );
}

ItemContent.handledProps = ['as', 'children', 'className', 'content', 'description', 'extra', 'header', 'meta', 'verticalAlign'];
ItemContent._meta = {
  name: 'ItemContent',
  parent: 'Item',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

ItemContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ItemDescription component. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for ItemExtra component. */
  extra: customPropTypes.itemShorthand,

  /** Shorthand for ItemHeader component. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ItemMeta component. */
  meta: customPropTypes.itemShorthand,

  /** Content can specify its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (ItemContent);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Item__ = __webpack_require__(424);











/**
 * A group of items.
 */
function ItemGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      divided = props.divided,
      items = props.items,
      link = props.link,
      relaxed = props.relaxed,
      unstackable = props.unstackable;


  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(divided, 'divided'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["C" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), 'items', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["r" /* getUnhandledProps */])(ItemGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getElementType */])(ItemGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content
  );

  var itemsJSX = __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(items, function (item) {
    var childKey = item.childKey,
        itemProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(item, ['childKey']);

    var finalKey = childKey || [itemProps.content, itemProps.description, itemProps.header, itemProps.meta].join('-');

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, itemProps, { key: finalKey }));
  });

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    itemsJSX
  );
}

ItemGroup.handledProps = ['as', 'children', 'className', 'content', 'divided', 'items', 'link', 'relaxed', 'unstackable'];
ItemGroup._meta = {
  name: 'ItemGroup',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.VIEW,
  parent: 'Item'
};

ItemGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Items can be divided to better distinguish between grouped content. */
  divided: PropTypes.bool,

  /** Shorthand array of props for Item. */
  items: customPropTypes.collectionShorthand,

  /** An item can be formatted so that the entire contents link to another page. */
  link: PropTypes.bool,

  /** A group of items can relax its padding to provide more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Prevent items from stacking on mobile. */
  unstackable: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (ItemGroup);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Image__ = __webpack_require__(77);






/**
 * An item can contain an image.
 */
function ItemImage(props) {
  var size = props.size;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(ItemImage, props);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Image__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { size: size, ui: !!size, wrapped: true }));
}

ItemImage.handledProps = ['size'];
ItemImage._meta = {
  name: 'ItemImage',
  parent: 'Item',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.VIEW
};

ItemImage.propTypes =  false ? {
  /** An image may appear at different sizes. */
  size: Image.propTypes.size
} : {};

ItemImage.create = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["m" /* createShorthandFactory */])(ItemImage, function (src) {
  return { src: src };
});

/* harmony default export */ __webpack_exports__["a"] = (ItemImage);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StatisticGroup__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StatisticValue__ = __webpack_require__(431);












/**
 * A statistic emphasizes the current value of an attribute.
 */
function Statistic(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      floated = props.floated,
      horizontal = props.horizontal,
      inverted = props.inverted,
      label = props.label,
      size = props.size,
      text = props.text,
      value = props.value;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["F" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), 'statistic', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(Statistic, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(Statistic, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content
  );

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_8__StatisticValue__["a" /* default */].create(value, {
      defaultProps: { text: text }
    }),
    __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__["a" /* default */].create(label)
  );
}

Statistic.handledProps = ['as', 'children', 'className', 'color', 'content', 'floated', 'horizontal', 'inverted', 'label', 'size', 'text', 'value'];
Statistic._meta = {
  name: 'Statistic',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.VIEW
};

Statistic.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A statistic can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A statistic can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A statistic can present its measurement horizontally. */
  horizontal: PropTypes.bool,

  /** A statistic can be formatted to fit on a dark background. */
  inverted: PropTypes.bool,

  /** Label content of the Statistic. */
  label: customPropTypes.contentShorthand,

  /** A statistic can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'medium')),

  /** Format the StatisticValue with smaller font size to fit nicely beside number values. */
  text: PropTypes.bool,

  /** Value content of the Statistic. */
  value: customPropTypes.contentShorthand
} : {};

Statistic.Group = __WEBPACK_IMPORTED_MODULE_6__StatisticGroup__["a" /* default */];
Statistic.Label = __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__["a" /* default */];
Statistic.Value = __WEBPACK_IMPORTED_MODULE_8__StatisticValue__["a" /* default */];

Statistic.create = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["m" /* createShorthandFactory */])(Statistic, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (Statistic);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Statistic__ = __webpack_require__(428);











/**
 * A group of statistics.
 */
function StatisticGroup(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      horizontal = props.horizontal,
      inverted = props.inverted,
      items = props.items,
      size = props.size,
      widths = props.widths;


  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* useWidthProp */])(widths), 'statistics', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["r" /* getUnhandledProps */])(StatisticGroup, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getElementType */])(StatisticGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );
  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content
  );

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(items, function (item) {
      return __WEBPACK_IMPORTED_MODULE_7__Statistic__["a" /* default */].create(item);
    })
  );
}

StatisticGroup.handledProps = ['as', 'children', 'className', 'color', 'content', 'horizontal', 'inverted', 'items', 'size', 'widths'];
StatisticGroup._meta = {
  name: 'StatisticGroup',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.VIEW,
  parent: 'Statistic'
};

StatisticGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A statistic group can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A statistic group can present its measurement horizontally. */
  horizontal: PropTypes.bool,

  /** A statistic group can be formatted to fit on a dark background. */
  inverted: PropTypes.bool,

  /** Array of props for Statistic. */
  items: customPropTypes.collectionShorthand,

  /** A statistic group can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'medium')),

  /** A statistic group can have its items divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (StatisticGroup);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A statistic can contain a label to help provide context for the presented value.
 */
function StatisticLabel(props) {
  var children = props.children,
      className = props.className,
      content = props.content;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('label', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(StatisticLabel, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(StatisticLabel, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

StatisticLabel.handledProps = ['as', 'children', 'className', 'content'];
StatisticLabel._meta = {
  name: 'StatisticLabel',
  parent: 'Statistic',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

StatisticLabel.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

StatisticLabel.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(StatisticLabel, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (StatisticLabel);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A statistic can contain a numeric, icon, image, or text value.
 */
function StatisticValue(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      text = props.text;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(text, 'text'), 'value', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(StatisticValue, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(StatisticValue, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

StatisticValue.handledProps = ['as', 'children', 'className', 'content', 'text'];
StatisticValue._meta = {
  name: 'StatisticValue',
  parent: 'Statistic',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

StatisticValue.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Format the value with smaller font size to fit nicely beside number values. */
  text: PropTypes.bool
} : {};

StatisticValue.create = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["m" /* createShorthandFactory */])(StatisticValue, function (content) {
  return { content: content };
});

/* harmony default export */ __webpack_exports__["a"] = (StatisticValue);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);
var settle = __webpack_require__(855);
var buildURL = __webpack_require__(857);
var parseHeaders = __webpack_require__(858);
var isURLSameOrigin = __webpack_require__(859);
var createError = __webpack_require__(434);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(860);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(856);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TableEntry=function(_PureComponent){_inherits(TableEntry,_PureComponent);function TableEntry(props){_classCallCheck(this,TableEntry);var _this=_possibleConstructorReturn(this,(TableEntry.__proto__||Object.getPrototypeOf(TableEntry)).call(this,props));_this.processSubjObjArrow=function(word,base){var finalHTML='';var ksub='';var kobj='';if(base=='n'){word.map(function(k,index){var lastIndex=k.lastIndexOf('<');finalHTML+='<span>'+k.slice(0,lastIndex).replace(/</g,'')+'</span>';var desiredRegion=k.slice(lastIndex+1).split('&')[0];if(desiredRegion.includes('↠')){finalHTML+='<span style="color:#002477">'+desiredRegion.split('↠')[0]+'</span>';finalHTML+='<span style="color:#7b0e0e">'+desiredRegion.split('↠')[1]+'</span>';}else if(desiredRegion.includes('↞')){finalHTML+='<span style="color:#7b0e0e">'+desiredRegion.split('↞')[0]+'</span>';finalHTML+='<span style="color:#002477">'+desiredRegion.split('↞')[1]+'</span>';}else{finalHTML+='<span style="color:#002477">'+desiredRegion+'</span>';}finalHTML+='<span>'+k.slice(lastIndex+1).split('&')[1]+'</span>';if(word.length-1!==index){finalHTML+='<span>, </span>';}});}else if(base=='quantQual'){word.map(function(k,index){var lastIndex=k.lastIndexOf('<');finalHTML+='<span>'+k.slice(0,lastIndex).replace(/</g,'')+'</span>';var desiredRegion=k.slice(lastIndex+1);finalHTML+='<span style="color:#002477">'+desiredRegion+'</span>';if(word.length-1!==index){finalHTML+='<span>, </span>';}});}else{word.map(function(k,index){k=k.replace(/</g,'');finalHTML+='<span>'+k.split('&')[0]+'</span>';if(k.split('&')[1].includes('↠')){finalHTML+='<span style="color:#002477">'+k.split('&')[1].split('↠')[0]+'</span>';finalHTML+='<span style="color:#7b0e0e">'+k.split('&')[1].split('↠')[1]+'</span>';}else if(k.split('&')[1].includes('↞')){finalHTML+='<span style="color:#7b0e0e">'+k.split('&')[1].split('↞')[0]+'</span>';finalHTML+='<span style="color:#002477">'+k.split('&')[1].split('↞')[1]+'</span>';}else{finalHTML+='<span style="color:#002477">'+k.split('&')[1]+'</span>';}if(word.length-1!==index){finalHTML+='<span>, </span>';}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:finalHTML}});};_this.state={entries:props.entries,mood:props.mood};return _this;}// componentDidUpdate(prevProps) {
//   if (prevProps.word !== this.props.word) {
//     this.setState({
//       entry: this.props.entry,
//       word: this.props.word,
//       displayEntryNumber: this.props.displayEntryNumber,
//       entryNumber: this.props.entryNumber
//     });
//   }
// }
_createClass(TableEntry,[{key:'render',value:function render(){var _this2=this;console.log(this.state);var e=this.state.entries;// console.log(this.state)
var subjectsEnglishTerms=[];var optativeIdentifiers=[];var transitiveTitles=[];var intransitiveTitles=[];if(this.state.mood==='[Ptcp]'||this.state.mood==='[Ind]'||this.state.mood==='[Intrg]'||this.state.mood==='[Sbrd]'){subjectsEnglishTerms=["[S_3Sg]","[S_3Du]","[S_3Pl]","[S_1Sg]","[S_1Du]","[S_1Pl]","[S_2Sg]","[S_2Du]","[S_2Pl]"];}if(this.state.mood==='[Prec]'||this.state.mood==="[Cnsq]"||this.state.mood==="[Cont]"||this.state.mood==="[Conc]"||this.state.mood==="[Cond]"||this.state.mood==="[CtmpI]"||this.state.mood==="[CtmpII]"){subjectsEnglishTerms=["[S_3Sg]","[S_3Du]","[S_3Pl]","[S_1Sg]","[S_1Du]","[S_1Pl]","[S_2Sg]","[S_2Du]","[S_2Pl]","[S_4Sg]","[S_4Du]","[S_4Pl]"];}if(this.state.mood==='[Opt]'){subjectsEnglishTerms=["[S_3Sg]","[S_3Du]","[S_3Pl]","[S_1Sg]","[S_1Du]","[S_1Pl]","[S_2Sg]","[S_2Du]","[S_2Pl]"];optativeIdentifiers=["[PRS]","[FUT]","[PRS][NEG]","[FUT][NEG]"];transitiveTitles=["TRANSITIVE (COMMAND PRESENT TENSE)","TRANSITIVE (COMMAND FUTURE TENSE)","TRANSITIVE (NEGATIVE COMMAND RIGHT NOW)","TRANSITIVE (NEGATIVE COMMAND IN THE FUTURE)"];intransitiveTitles=["INTRANSITIVE (COMMAND PRESENT TENSE)","INTRANSITIVE (COMMAND FUTURE TENSE)","INTRANSITIVE (NEGATIVE COMMAND RIGHT NOW)","INTRANSITIVE (NEGATIVE COMMAND IN THE FUTURE)"];}var subjectOptativeTerms=["[S_2Sg]","[S_2Du]","[S_2Pl]"];var subjectOptativeTermsEnglish=["you (don't)","you 2 (don't)","you 3+ (don't)"];var subjectsEnglishTermsSbrd=["[S_4Sg]","[S_4Du]","[S_4Pl]","[S_1Sg]","[S_1Du]","[S_1Pl]","[S_2Sg]","[S_2Du]","[S_2Pl]"];var subjectsEnglishSbrd=["he, she, it (itself)","they (2) (themselves)","they all (3+) (themselves)","I","we\xa0(2)","we\xa0all\xa0(3+)","you","you\xa0(2)","you\xa0all\xa0(3+)"];var subjectsEnglish=["he,\xa0she,\xa0it","they\xa0(2)","they\xa0all\xa0(3+)","I","we\xa0(2)","we\xa0all\xa0(3+)","you","you\xa0(2)","you\xa0all\xa0(3+)"];var subjectsEnglishConnective=["he,\xa0she,\xa0it","they\xa0(2)","they\xa0all\xa0(3+)","I","we\xa0(2)","we\xa0all\xa0(3+)","you","you\xa0(2)","you\xa0all\xa0(3+)","he, she, it (itself)","they (2) (themselves)","they all (3+) (themselves)"];var subjectsEnglishQuantQual=["it (him or her)","both of them","all of them","all of me","both of us","all of us","you","both of you","all of you","it (he or she)","both of them","all of them"];// console.log(subjectsEnglish)
// objectsEnglish = [
// "[P_3Sg]": "him, her, it",
// "[P_3Du]": "them (2)",
// "[P_3Pl]": "{"them\xa0all\xa0(3+)"}",
// "[P_1Sg]": "me",
// "[P_1Du]": "us (2)",
// "[P_1Pl]": "{"us\xa0all\xa0(3+)"}",
// "[P_2Sg]": "you",
// "[P_2Du]": "you (2)",
// "[P_2Pl]": "{"you\xa0all\xa0(3+)"}",
// // "[P_4Sg]": "he",
// // "[P_4Du]": "he",
// // "[P_4Pl]": "he",
// ]
var objectsEnglish3=["[P_3Sg]","[P_3Du]","[P_3Pl]","[P_1Sg]","[P_1Du]","[P_1Pl]","[P_2Sg]","[P_2Du]","[P_2Pl]"];var objectsEnglish1=["[P_3Sg]","[P_3Du]","[P_3Pl]","[P_2Sg]","[P_2Du]","[P_2Pl]"];var objectsEnglish2=["[P_3Sg]","[P_3Du]","[P_3Pl]","[P_1Sg]","[P_1Du]","[P_1Pl]"];var objectsEnglishConnective3=["[P_3Sg]","[P_3Du]","[P_3Pl]","[P_1Sg]","[P_1Du]","[P_1Pl]","[P_2Sg]","[P_2Du]","[P_2Pl]","[P_4Sg]","[P_4Du]","[P_4Pl]"];var objectsEnglishConnective1=["[P_3Sg]","[P_3Du]","[P_3Pl]","[P_2Sg]","[P_2Du]","[P_2Pl]","[P_4Sg]","[P_4Du]","[P_4Pl]"];var objectsEnglishConnective2=["[P_3Sg]","[P_3Du]","[P_3Pl]","[P_1Sg]","[P_1Du]","[P_1Pl]","[P_4Sg]","[P_4Du]","[P_4Pl]"];var objectsEnglishConnective4=["[P_3Sg]","[P_3Du]","[P_3Pl]","[P_1Sg]","[P_1Du]","[P_1Pl]","[P_2Sg]","[P_2Du]","[P_2Pl]"];var unpossessedNounIdentifiers=["[SgUnpd]","[DuUnpd]","[PlUnpd]"];var possessedNumberOfNounIdentifiers=["[SgPosd]","[DuPosd]","[PlPosd]"];var possessedNounIdentifiers=["[3SgPoss]","[3DuPoss]","[3PlPoss]","[1SgPoss]","[1DuPoss]","[1PlPoss]","[2SgPoss]","[2DuPoss]","[2PlPoss]","[4SgPoss]","[4DuPoss]","[4PlPoss]"];var unpossessedNouns=["Singular","Dual","Plural"];var possessedNouns=["his/her/its\xa0(other)","their\xa0(2)\xa0(other)","their\xa0(3+)\xa0(other)","my","our\xa0(2)","our\xa0(3+)","your\xa0(1)","your\xa0(2)","your\xa0(3+)","his/her/its\xa0own","their\xa0own\xa0(2)","their\xa0own\xa0(3+)"];var quantQual=["[P_3Sg]","[P_3Du]","[P_3Pl]","[S_1Sg]","[S_1Du]","[S_1Pl]","[S_2Sg]","[S_2Du]","[S_2Pl]","[S_4Sg]","[S_4Du]","[S_4Pl]"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.mood==="[Abs]"||this.state.mood==="[Rel]"||this.state.mood==="[Abl_Mod]"||this.state.mood==="[Loc]"||this.state.mood==="[Ter]"||this.state.mood==="[Via]"||this.state.mood==="[Equ]"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,unpossessedNounIdentifiers.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},unpossessedNouns[index]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[i],'n')));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',fontWeight:'bold',marginTop:10,marginBottom:10}},"POSSESSED"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'number of noun'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'possessor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"singular (1)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"dual (2)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"plural (3+)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,possessedNouns.map(function(l,lindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},l),possessedNumberOfNounIdentifiers.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[possessedNounIdentifiers[lindex]+possessedNumberOfNounIdentifiers[index]],'n'));}));}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.mood==='[Opt]'?intransitiveTitles.map(function(k,kindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:20,marginBottom:10,fontWeight:'bold'}},k),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,kindex<2?subjectsEnglishTerms.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},subjectsEnglish[index]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[optativeIdentifiers[kindex]+"[Intr]"+i])));}):subjectOptativeTerms.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},subjectOptativeTermsEnglish[index]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[optativeIdentifiers[kindex]+"[Intr]"+i])));})))));}):this.state.mood==='[Prec]'||this.state.mood==="[Cnsq]"||this.state.mood==="[Cont]"||this.state.mood==="[Conc]"||this.state.mood==="[Cond]"||this.state.mood==="[CtmpI]"||this.state.mood==="[CtmpII]"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',fontWeight:'bold',marginTop:10,marginBottom:10}},'INTRANSITIVE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,subjectsEnglishTerms.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},subjectsEnglishConnective[index]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Intr]"+i])));}))))):this.state.mood==='%5BQuant_Qual%5D'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,quantQual.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},subjectsEnglishQuantQual[index]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[i],"quantQual")));}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',fontWeight:'bold',marginTop:10,marginBottom:10}},'INTRANSITIVE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,subjectsEnglishTerms.map(function(i,index){return _this2.state.mood==='[Sbrd]'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},subjectsEnglishSbrd[index]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Intr]"+subjectsEnglishTermsSbrd[index]]))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},subjectsEnglish[index]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Intr]"+i])));}))))),this.state.mood==='[Ind]'||this.state.mood==='[Ptcp]'||this.state.mood==='[Intrg]'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',fontWeight:'bold',marginTop:20,marginBottom:10}},'TRANSITIVE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'3rd Person Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"us\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"you\xa0all\xa0(3+)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"he,\xa0she,\xa0it"),objectsEnglish3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_3Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'they (2)'),objectsEnglish3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_3Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"they\xa0all\xa0(3+)"),objectsEnglish3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_3Pl]"+i]));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'1st Person Subject'),this.state.mood==="[Intrg]"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'you'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477",width:80}},'I'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},this.processSubjObjArrow(e["[Trns][A_1Sg][P_2Sg]"])))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"you\xa0all\xa0(3+)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'I'),objectsEnglish1.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_1Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'we (2)'),objectsEnglish1.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_1Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"we\xa0all\xa03+"),objectsEnglish1.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_1Pl]"+i]));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'2nd Person Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"us\xa0all\xa0(3+)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'you'),objectsEnglish2.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_2Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'you (2)'),objectsEnglish2.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_2Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"you\xa0all\xa0(3+)"),objectsEnglish2.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_2Pl]"+i]));})))))):null,this.state.mood==='[Opt]'?optativeIdentifiers.map(function(k,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',fontWeight:'bold',marginTop:20,marginBottom:10}},transitiveTitles[index]),index<2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'3rd Person Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"us\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"you\xa0all\xa0(3+)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"he,\xa0she,\xa0it"),objectsEnglish3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[k+"[Trns]"+"[A_3Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'they (2)'),objectsEnglish3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[k+"[Trns]"+"[A_3Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"they\xa0all\xa0(3+)"),objectsEnglish3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[k+"[Trns]"+"[A_3Pl]"+i]));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'1st Person Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"you\xa0all\xa0(3+)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'I'),objectsEnglish1.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[k+"[Trns]"+"[A_1Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'we (2)'),objectsEnglish1.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[k+"[Trns]"+"[A_1Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"we\xa0all\xa03+"),objectsEnglish1.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[k+"[Trns]"+"[A_1Pl]"+i]));})))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'2nd Person Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"us\xa0all\xa0(3+)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'you'),objectsEnglish2.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[k+"[Trns]"+"[A_2Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'you (2)'),objectsEnglish2.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[k+"[Trns]"+"[A_2Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"you\xa0all\xa0(3+)"),objectsEnglish2.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e[k+"[Trns]"+"[A_2Pl]"+i]));}))))));}):null,this.state.mood==='[Sbrd]'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',fontWeight:'bold',marginTop:20,marginBottom:10}},'TRANSITIVE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"us\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"you\xa0all\xa0(3+)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477",fontStyle:'italic'}},"all"),objectsEnglish3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns]"+i]));})))))):null,this.state.mood==='[Prec]'||this.state.mood==="[Cnsq]"||this.state.mood==="[Cont]"||this.state.mood==="[Conc]"||this.state.mood==="[Cond]"||this.state.mood==="[CtmpI]"||this.state.mood==="[CtmpII]"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',fontWeight:'bold',marginTop:20,marginBottom:10}},'TRANSITIVE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'3rd Person Subject (other)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it\xa0(other)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them\xa0(others)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)\xa0(others)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"us\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"you\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it\xa0(itself)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them\xa0(themselves)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)\xa0(themselves)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"he,\xa0she,\xa0it\xa0(other)"),objectsEnglishConnective3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_3Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'they (2) (others)'),objectsEnglishConnective3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_3Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"they\xa0all\xa0(3+)\xa0(others)"),objectsEnglishConnective3.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_3Pl]"+i]));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'1st Person Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it\xa0(other)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them\xa0(others)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)\xa0(others)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"you\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it\xa0(itself)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them\xa0(themselves)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)\xa0(themselves)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'I'),objectsEnglishConnective1.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_1Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'we (2)'),objectsEnglishConnective1.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_1Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"we\xa0all\xa03+"),objectsEnglishConnective1.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_1Pl]"+i]));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'2nd Person Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it\xa0(other)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them\xa0(others)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)\xa0(others)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"us\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it\xa0(itself)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them\xa0(themselves)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)\xa0(themselves)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'you'),objectsEnglishConnective2.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_2Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},'you (2)'),objectsEnglishConnective2.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_2Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"you\xa0all\xa0(3+)"),objectsEnglishConnective2.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_2Pl]"+i]));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10,marginBottom:10}},'3rd Person Reflexive Subject (itself)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:'auto',fontSize:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */],{unstackable:true,basic:true,compact:true,collapsing:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',paddingLeft:10,"color":"#7b0e0e"}},'Object'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:'underline',color:"#002477"}},'Subject'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"her,\xa0him,\xa0it\xa0(other)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0them\xa0(others)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"them\xa0all\xa0(3+)\xa0(others)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'me'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0us"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"us\xa0all\xa0(3+)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},'you'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"the\xa0two\xa0of\xa0you"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,"color":"#7b0e0e"}},"you\xa0all\xa0(3+)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"her,\xa0him,\xa0it\xa0(itself)"),objectsEnglishConnective4.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_4Sg]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"they\xa0(2)\xa0(themselves)"),objectsEnglishConnective4.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_4Du]"+i]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},"they\xa0all\xa0(3+)\xa0(themselves)"),objectsEnglishConnective4.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this2.processSubjObjArrow(e["[Trns][A_4Pl]"+i]));})))))):null));}}]);return TableEntry;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* withRouter */])(TableEntry));

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return perPro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return demPro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return endingToEnglishTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return endingEnglishDescriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return endingDescriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return exampleSentences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return accordionTitlesVerbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accordionTitlesNouns; });
/* unused harmony export accordionTitlesQuantQual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return persPronounLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return persPronounSubjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return persPronounsEnglish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return demPronounTitles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return demPronounSubjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return demPronounEnglish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return moods; });
var perPro={"[Abl_Mod][1Du]":["wangkugnek"],"[Abl_Mod][1Pl]":["wangkutnek"],"[Abl_Mod][1Sg]":["wangnek"],"[Abl_Mod][2Du]":["elpetegnek"],"[Abl_Mod][2Pl]":["elpecnek"],"[Abl_Mod][2Sg]":["elpenek"],"[Abl_Mod][3Du]":["elkegnek"],"[Abl_Mod][3Pl]":["ellaitnek"],"[Abl_Mod][3Sg]":["elliinek"],"[Abl_Mod][4Du]":["ellmegnek"],"[Abl_Mod][4Pl]":["ellmeggnek"],"[Abl_Mod][4Sg]":["ellminek"],"[Abs][1Du]":["wangkuk"],"[Abs][1Pl]":["wangkuta"],"[Abs][1Sg]":["wii","wiinga"],"[Abs][2Du]":["elpetek"],"[Abs][2Pl]":["elpeci"],"[Abs][2Sg]":["elpet"],"[Abs][3Du]":["elkek"],"[Abs][3Pl]":["ellait"],"[Abs][3Sg]":["ellii"],"[Abs][4Du]":["ellmek"],"[Abs][4Pl]":["ellmeng"],"[Abs][4Sg]":["ellmi"],"[Equ][1Du]":["wangkugcetun","wangkugtun"],"[Equ][1Pl]":["wangkucetun","wangkutun"],"[Equ][1Sg]":["wangcetun","wangtun"],"[Equ][2Du]":["elpetegcetun","elpetegtun"],"[Equ][2Pl]":["elpecicetun","elpecitun"],"[Equ][2Sg]":["elpecetun","elpetun"],"[Equ][3Du]":["elkegcetun","elkegtun"],"[Equ][3Pl]":["ellaicetun","ellaitun"],"[Equ][3Sg]":["elliicetun","elliitun"],"[Equ][4Du]":["ellmegnegun"],"[Equ][4Pl]":["ellmegcetun","ellmegtun"],"[Equ][4Sg]":["ellmicetun","ellmitun"],"[Loc][1Du]":["wangkugni"],"[Loc][1Pl]":["wangkutni"],"[Loc][1Sg]":["wangni"],"[Loc][2Du]":["elpetegni"],"[Loc][2Pl]":["elpecni"],"[Loc][2Sg]":["elpeni"],"[Loc][3Du]":["elkegni"],"[Loc][3Pl]":["ellaitni"],"[Loc][3Sg]":["elliini"],"[Loc][4Du]":["ellmegni"],"[Loc][4Pl]":["ellmeggni"],"[Loc][4Sg]":["ellmini"],"[Rel][1Du]":["wangkuk"],"[Rel][1Pl]":["wangkuta"],"[Rel][1Sg]":["wii","wiinga"],"[Rel][2Du]":["elpetek"],"[Rel][2Pl]":["elpeci"],"[Rel][2Sg]":["elpet"],"[Rel][3Du]":["elkenka"],"[Rel][3Pl]":["ellaita"],"[Rel][3Sg]":["elliin"],"[Rel][4Du]":["ellmek"],"[Rel][4Pl]":["ellmeng"],"[Rel][4Sg]":["ellmi"],"[Ter][1Du]":["wangkugnun"],"[Ter][1Pl]":["wangkutnun"],"[Ter][1Sg]":["wangnun"],"[Ter][2Du]":["elpetegnun"],"[Ter][2Pl]":["elpecnun"],"[Ter][2Sg]":["elpenun"],"[Ter][3Du]":["elkegnun"],"[Ter][3Pl]":["ellaitnun"],"[Ter][3Sg]":["elliinun"],"[Ter][4Du]":["ellmegnun"],"[Ter][4Pl]":["ellmeggnun"],"[Ter][4Sg]":["ellminun"],"[Via][1Du]":["wangkugnegun"],"[Via][1Pl]":["wangkutgun"],"[Via][1Sg]":["wangkun"],"[Via][2Du]":["elpetegnegun"],"[Via][2Pl]":["elpecetgun"],"[Via][2Sg]":["elpetgun"],"[Via][3Du]":["elkegnegun"],"[Via][3Pl]":["ellaitgun"],"[Via][3Sg]":["elliikun"],"[Via][4Du]":["ellmegnegun"],"[Via][4Pl]":["ellmegteggun"],"[Via][4Sg]":["ellmikun"]};var demPro={"across there":{"extended":{"=i[Encl]":["agaa-i","ii-i"],"[Abl]":["agaaken","iiken"],"[Abl_Mod][DuUnpd]":["agkugnek"],"[Abl_Mod][PlUnpd]":["agkunek"],"[Abl_Mod][SgUnpd]":["ag'umek"],"[Abs][DuUnpd]":["agkuk"],"[Abs][PlUnpd]":["agkut"],"[Abs][SgUnpd]":["agna"],"[Equ]":["-"],"[Equ][DuUnpd]":["agkugcetun"],"[Equ][PlUnpd]":["agkucetun"],"[Equ][SgUnpd]":["ag'utun"],"[Loc]":["agaani","iini"],"[Loc][DuUnpd]":["agkugni"],"[Loc][PlUnpd]":["agkuni"],"[Loc][SgUnpd]":["ag'umi"],"[Rel][DuUnpd]":["agkuk"],"[Rel][PlUnpd]":["agkut"],"[Rel][SgUnpd]":["ag'um"],"[Sec_Ter]":["agaatmun","iitmun"],"[Ter]":["agaavet","iivet"],"[Ter][DuUnpd]":["agkugnun"],"[Ter][PlUnpd]":["agkunun"],"[Ter][SgUnpd]":["ag'umun"],"[Via]":["agaaggun","iiggun"],"[Via][DuUnpd]":["agkunegnun"],"[Via][PlUnpd]":["agkutgun"],"[Via][SgUnpd]":["ag'ukun"],"[Voc][DuUnpd]":["agkuuk"],"[Voc][PlUnpd]":["agkuut"],"[Voc][SgUnpd]":["agsuuq","agyuuq"]},"obscured":{"=i[Encl]":["akma-i"],"[Abl]":["akmaken"],"[Abl_Mod][DuUnpd]":["akemkugnek"],"[Abl_Mod][PlUnpd]":["akemkunek"],"[Abl_Mod][SgUnpd]":["ak'mumek"],"[Abs][DuUnpd]":["akemkuk"],"[Abs][PlUnpd]":["akemkut"],"[Abs][SgUnpd]":["akemna"],"[Equ]":["-"],"[Equ][DuUnpd]":["akemkugcetun"],"[Equ][PlUnpd]":["akemkucetun"],"[Equ][SgUnpd]":["ak'mutun"],"[Loc]":["akmani"],"[Loc][DuUnpd]":["akemkugni"],"[Loc][PlUnpd]":["akemkuni"],"[Loc][SgUnpd]":["ak'mumi"],"[Rel][DuUnpd]":["akemkuk"],"[Rel][PlUnpd]":["akemkut"],"[Rel][SgUnpd]":["ak'mum"],"[Sec_Ter]":["-"],"[Ter]":["akmavet"],"[Ter][DuUnpd]":["akemkugnun"],"[Ter][PlUnpd]":["akemkunun"],"[Ter][SgUnpd]":["ak'mumun"],"[Via]":["akmaggun"],"[Via][DuUnpd]":["akemkunegnun"],"[Via][PlUnpd]":["akemkutgun"],"[Via][SgUnpd]":["ak'mukun"],"[Voc][DuUnpd]":["akemkuuk"],"[Voc][PlUnpd]":["akemkuut"],"[Voc][SgUnpd]":["akemsuuq","akemyuuq"]},"restricted":{"=i[Encl]":["ika-i"],"[Abl]":["ikaken"],"[Abl_Mod][DuUnpd]":["ikegkugnek"],"[Abl_Mod][PlUnpd]":["ikegkunek"],"[Abl_Mod][SgUnpd]":["ik'umek","ikgumek"],"[Abs][DuUnpd]":["ikegkuk"],"[Abs][PlUnpd]":["ikegkut"],"[Abs][SgUnpd]":["ikna","ikeggna"],"[Equ]":["-"],"[Equ][DuUnpd]":["ikegkugcetun"],"[Equ][PlUnpd]":["ikegkucetun"],"[Equ][SgUnpd]":["ik'utun","ikgutun"],"[Loc]":["ikani"],"[Loc][DuUnpd]":["ikegkugni"],"[Loc][PlUnpd]":["ikegkuni"],"[Loc][SgUnpd]":["ik'umi","ikgumi"],"[Rel][DuUnpd]":["ikegkuk"],"[Rel][PlUnpd]":["ikegkut"],"[Rel][SgUnpd]":["ik'um","ikgum"],"[Sec_Ter]":["ikatmun"],"[Ter]":["ikavet"],"[Ter][DuUnpd]":["ikegkugnun"],"[Ter][PlUnpd]":["ikegkunun"],"[Ter][SgUnpd]":["ik'umun","ikgumun"],"[Via]":["ikaggun"],"[Via][DuUnpd]":["ikegkunegnun"],"[Via][PlUnpd]":["ikegkutgun"],"[Via][SgUnpd]":["ik'ukun","ikgukun"],"[Voc][DuUnpd]":["ikegkuuk"],"[Voc][PlUnpd]":["ikegkuut"],"[Voc][SgUnpd]":["iksuuq","ikyuuq","ikeggsuuq","ikeggyuuq"]}},"coming this way":{"extended":{"=i[Encl]":["uka-i"],"[Abl]":["ukaken"],"[Abl_Mod][DuUnpd]":["ukegkugnek"],"[Abl_Mod][PlUnpd]":["ukegkunek"],"[Abl_Mod][SgUnpd]":["uk'umek"],"[Abs][DuUnpd]":["ukegkuk"],"[Abs][PlUnpd]":["ukegkut"],"[Abs][SgUnpd]":["ukna"],"[Equ]":["-"],"[Equ][DuUnpd]":["ukegkugcetun"],"[Equ][PlUnpd]":["ukegkucetun"],"[Equ][SgUnpd]":["uk'utun"],"[Loc]":["ukani"],"[Loc][DuUnpd]":["ukegkugni"],"[Loc][PlUnpd]":["ukegkuni"],"[Loc][SgUnpd]":["uk'umi"],"[Rel][DuUnpd]":["ukegkuk"],"[Rel][PlUnpd]":["ukegkut"],"[Rel][SgUnpd]":["uk'um"],"[Sec_Ter]":["ukatmun"],"[Ter]":["ukavet"],"[Ter][DuUnpd]":["ukegkugnun"],"[Ter][PlUnpd]":["ukegkunun"],"[Ter][SgUnpd]":["uk'umun"],"[Via]":["ukaggun"],"[Via][DuUnpd]":["ukegkunegnun"],"[Via][PlUnpd]":["ukegkutgun"],"[Via][SgUnpd]":["uk'ukun"],"[Voc][DuUnpd]":["ukegkuuk"],"[Voc][PlUnpd]":["ukegkuut"],"[Voc][SgUnpd]":["uksuuq","ukyuuq"]}},"down below or down the slope":{"extended":{"=i[Encl]":["una-i"],"[Abl]":["unaken"],"[Abl_Mod][DuUnpd]":["unkugnek"],"[Abl_Mod][PlUnpd]":["unkunek"],"[Abl_Mod][SgUnpd]":["un'umek"],"[Abs][DuUnpd]":["unkuk"],"[Abs][PlUnpd]":["unkut"],"[Abs][SgUnpd]":["un'a"],"[Equ]":["-"],"[Equ][DuUnpd]":["unkugcetun"],"[Equ][PlUnpd]":["unkucetun"],"[Equ][SgUnpd]":["un'utun"],"[Loc]":["unani"],"[Loc][DuUnpd]":["unkugni"],"[Loc][PlUnpd]":["unkuni"],"[Loc][SgUnpd]":["un'umi"],"[Rel][DuUnpd]":["unkuk"],"[Rel][PlUnpd]":["unkut"],"[Rel][SgUnpd]":["un'um"],"[Sec_Ter]":["unatmun"],"[Ter]":["unavet"],"[Ter][DuUnpd]":["unkugnun"],"[Ter][PlUnpd]":["unkunun"],"[Ter][SgUnpd]":["un'umun"],"[Via]":["unaggun"],"[Via][DuUnpd]":["unkunegnun"],"[Via][PlUnpd]":["unkutgun"],"[Via][SgUnpd]":["un'ukun"],"[Voc][DuUnpd]":["unkuuk"],"[Voc][PlUnpd]":["unkuut"],"[Voc][SgUnpd]":["unsuuq","unyuuq"]},"obscured":{"=i[Encl]":["cama-i"],"[Abl]":["camaken"],"[Abl_Mod][DuUnpd]":["camkugnek"],"[Abl_Mod][PlUnpd]":["camkunek"],"[Abl_Mod][SgUnpd]":["cam'umek"],"[Abs][DuUnpd]":["camkuk"],"[Abs][PlUnpd]":["camkut"],"[Abs][SgUnpd]":["camna"],"[Equ]":["-"],"[Equ][DuUnpd]":["camkugcetun"],"[Equ][PlUnpd]":["camkucetun"],"[Equ][SgUnpd]":["cam'utun"],"[Loc]":["camani"],"[Loc][DuUnpd]":["camkugni"],"[Loc][PlUnpd]":["camkuni"],"[Loc][SgUnpd]":["cam'umi"],"[Rel][DuUnpd]":["camkuk"],"[Rel][PlUnpd]":["camkut"],"[Rel][SgUnpd]":["cam'um"],"[Sec_Ter]":["-"],"[Ter]":["camavet"],"[Ter][DuUnpd]":["camkugnun"],"[Ter][PlUnpd]":["camkunun"],"[Ter][SgUnpd]":["cam'umun"],"[Via]":["camaggun"],"[Via][DuUnpd]":["camkunegnun"],"[Via][PlUnpd]":["camkutgun"],"[Via][SgUnpd]":["cam'ukun"],"[Voc][DuUnpd]":["camkuuk"],"[Voc][PlUnpd]":["camkuut"],"[Voc][SgUnpd]":["camsuuq","camyuuq"]},"restricted":{"=i[Encl]":["kana-i"],"[Abl]":["kanaken"],"[Abl_Mod][DuUnpd]":["kankugnek"],"[Abl_Mod][PlUnpd]":["kankunek"],"[Abl_Mod][SgUnpd]":["kat'umek"],"[Abs][DuUnpd]":["kankuk"],"[Abs][PlUnpd]":["kankut"],"[Abs][SgUnpd]":["kan'a"],"[Equ]":["-"],"[Equ][DuUnpd]":["kankugcetun"],"[Equ][PlUnpd]":["kankucetun"],"[Equ][SgUnpd]":["kat'utun"],"[Loc]":["kanani"],"[Loc][DuUnpd]":["kankugni"],"[Loc][PlUnpd]":["kankuni"],"[Loc][SgUnpd]":["kat'umi"],"[Rel][DuUnpd]":["kankuk"],"[Rel][PlUnpd]":["kankut"],"[Rel][SgUnpd]":["kat'um"],"[Sec_Ter]":["kanatmun"],"[Ter]":["kanavet"],"[Ter][DuUnpd]":["kankugnun"],"[Ter][PlUnpd]":["kankunun"],"[Ter][SgUnpd]":["kat'umun"],"[Via]":["kanaggun"],"[Via][DuUnpd]":["kankunegnun"],"[Via][PlUnpd]":["kankutgun"],"[Via][SgUnpd]":["kat'ukun"],"[Voc][DuUnpd]":["kankuuk"],"[Voc][PlUnpd]":["kankuut"],"[Voc][SgUnpd]":["kacuuq"]}},"downriver or near the exit":{"extended":{"=i[Encl]":["un'ga-i","un'gaa-i"],"[Abl]":["un'gaken","un'gaaken"],"[Abl_Mod][DuUnpd]":["unegkugnek"],"[Abl_Mod][PlUnpd]":["unegkunek"],"[Abl_Mod][SgUnpd]":["ung'umek"],"[Abs][DuUnpd]":["unegkuk"],"[Abs][PlUnpd]":["unegkut"],"[Abs][SgUnpd]":["unegna"],"[Equ]":["-"],"[Equ][DuUnpd]":["unegkugcetun"],"[Equ][PlUnpd]":["unegkucetun"],"[Equ][SgUnpd]":["ung'utun"],"[Loc]":["un'gani","un'gaani"],"[Loc][DuUnpd]":["unegkugni"],"[Loc][PlUnpd]":["unegkuni"],"[Loc][SgUnpd]":["ung'umi"],"[Rel][DuUnpd]":["unegkuk"],"[Rel][PlUnpd]":["unegkut"],"[Rel][SgUnpd]":["ung'um"],"[Sec_Ter]":["un'gatmun","un'gaatmun"],"[Ter]":["un'gavet","un'gaavet"],"[Ter][DuUnpd]":["unegkugnun"],"[Ter][PlUnpd]":["unegkunun"],"[Ter][SgUnpd]":["ung'umun"],"[Via]":["un'gaggun","un'gaaggun"],"[Via][DuUnpd]":["unegkunegnun"],"[Via][PlUnpd]":["unegkutgun"],"[Via][SgUnpd]":["ung'ukun"],"[Voc][DuUnpd]":["unegkuuk"],"[Voc][PlUnpd]":["unegkuut"],"[Voc][SgUnpd]":["unegsuuq","unegyuuq"]},"obscured":{"=i[Encl]":["cakma-i"],"[Abl]":["cakmaken"],"[Abl_Mod][DuUnpd]":["cakemkugnek"],"[Abl_Mod][PlUnpd]":["cakemkunek"],"[Abl_Mod][SgUnpd]":["cak'mumek"],"[Abs][DuUnpd]":["cakemkuk"],"[Abs][PlUnpd]":["cakemkut"],"[Abs][SgUnpd]":["cakemna"],"[Equ]":["-"],"[Equ][DuUnpd]":["cakemkugcetun"],"[Equ][PlUnpd]":["cakemkucetun"],"[Equ][SgUnpd]":["cak'mutun"],"[Loc]":["cakmani"],"[Loc][DuUnpd]":["cakemkugni"],"[Loc][PlUnpd]":["cakemkuni"],"[Loc][SgUnpd]":["cak'mumi"],"[Rel][DuUnpd]":["cakemkuk"],"[Rel][PlUnpd]":["cakemkut"],"[Rel][SgUnpd]":["cak'mum"],"[Sec_Ter]":["-"],"[Ter]":["cakmavet"],"[Ter][DuUnpd]":["cakemkugnun"],"[Ter][PlUnpd]":["cakemkunun"],"[Ter][SgUnpd]":["cak'mumun"],"[Via]":["cakmaggun"],"[Via][DuUnpd]":["cakemkunegnun"],"[Via][PlUnpd]":["cakemkutgun"],"[Via][SgUnpd]":["cak'mukun"],"[Voc][DuUnpd]":["cakemkuuk"],"[Voc][PlUnpd]":["cakemkuut"],"[Voc][SgUnpd]":["cakemsuuq","cakemyuuq"]},"restricted":{"=i[Encl]":["ua-i"],"[Abl]":["uaken"],"[Abl_Mod][DuUnpd]":["ugkugnek"],"[Abl_Mod][PlUnpd]":["ugkunek"],"[Abl_Mod][SgUnpd]":["ug'umek"],"[Abs][DuUnpd]":["ugkuk"],"[Abs][PlUnpd]":["ugkut"],"[Abs][SgUnpd]":["ugna"],"[Equ]":["-"],"[Equ][DuUnpd]":["ugkugcetun"],"[Equ][PlUnpd]":["ugkucetun"],"[Equ][SgUnpd]":["ug'utun"],"[Loc]":["uani"],"[Loc][DuUnpd]":["ugkugni"],"[Loc][PlUnpd]":["ugkuni"],"[Loc][SgUnpd]":["ug'umi"],"[Rel][DuUnpd]":["ugkuk"],"[Rel][PlUnpd]":["ugkut"],"[Rel][SgUnpd]":["ug'um"],"[Sec_Ter]":["uatmun"],"[Ter]":["uavet"],"[Ter][DuUnpd]":["ugkugnun"],"[Ter][PlUnpd]":["ugkunun"],"[Ter][SgUnpd]":["ug'umun"],"[Via]":["uaggun"],"[Via][DuUnpd]":["ugkunegnun"],"[Via][PlUnpd]":["ugkutgun"],"[Via][SgUnpd]":["ug'ukun"],"[Voc][DuUnpd]":["ugkuuk"],"[Voc][PlUnpd]":["ugkuut"],"[Voc][SgUnpd]":["ugsuuq","ugyuuq"]}},"here, near speaker":{"extended":{"=i[Encl]":["maa-i"],"[Abl]":["maaken"],"[Abl_Mod][DuUnpd]":["makugnek"],"[Abl_Mod][PlUnpd]":["makunek"],"[Abl_Mod][SgUnpd]":["mat'umek"],"[Abs][DuUnpd]":["makuk"],"[Abs][PlUnpd]":["makut"],"[Abs][SgUnpd]":["man'a"],"[Equ]":["-"],"[Equ][DuUnpd]":["makugcetun"],"[Equ][PlUnpd]":["makucetun"],"[Equ][SgUnpd]":["mat'utun"],"[Loc]":["maani"],"[Loc][DuUnpd]":["makugni"],"[Loc][PlUnpd]":["makuni"],"[Loc][SgUnpd]":["mat'umi"],"[Rel][DuUnpd]":["makuk"],"[Rel][PlUnpd]":["makut"],"[Rel][SgUnpd]":["mat'um"],"[Sec_Ter]":["maatmun"],"[Ter]":["maavet"],"[Ter][DuUnpd]":["makugnun"],"[Ter][PlUnpd]":["makunun"],"[Ter][SgUnpd]":["mat'umun"],"[Via]":["maaggun"],"[Via][DuUnpd]":["makunegnun"],"[Via][PlUnpd]":["makutgun"],"[Via][SgUnpd]":["mat'ukun"],"[Voc][DuUnpd]":["makuuk"],"[Voc][PlUnpd]":["makuut"],"[Voc][SgUnpd]":["macuuq"]},"obscured":{"=i[Encl]":["ima-i"],"[Abl]":["imaken"],"[Abl_Mod][DuUnpd]":["imkugnek"],"[Abl_Mod][PlUnpd]":["imkunek"],"[Abl_Mod][SgUnpd]":["im'umek","imumek"],"[Abs][DuUnpd]":["imkuk"],"[Abs][PlUnpd]":["imkut"],"[Abs][SgUnpd]":["imna"],"[Equ]":["-"],"[Equ][DuUnpd]":["imkugcetun"],"[Equ][PlUnpd]":["imkucetun"],"[Equ][SgUnpd]":["im'utun","imutun"],"[Loc]":["imani"],"[Loc][DuUnpd]":["imkugni"],"[Loc][PlUnpd]":["imkuni"],"[Loc][SgUnpd]":["im'umi","imumi"],"[Rel][DuUnpd]":["imkuk"],"[Rel][PlUnpd]":["imkut"],"[Rel][SgUnpd]":["im'um","imum"],"[Sec_Ter]":["-"],"[Ter]":["imavet"],"[Ter][DuUnpd]":["imkugnun"],"[Ter][PlUnpd]":["imkunun"],"[Ter][SgUnpd]":["im'umun","imumun"],"[Via]":["imaggun"],"[Via][DuUnpd]":["imkunegnun"],"[Via][PlUnpd]":["imkutgun"],"[Via][SgUnpd]":["im'ukun","imukun"],"[Voc][DuUnpd]":["imkuuk"],"[Voc][PlUnpd]":["imkuut"],"[Voc][SgUnpd]":["imsuuq","imyuuq"]},"restricted":{"=i[Encl]":["wani-wa"],"[Abl]":["waken"],"[Abl_Mod][DuUnpd]":["ukugnek"],"[Abl_Mod][PlUnpd]":["ukunek"],"[Abl_Mod][SgUnpd]":["uumek"],"[Abs][DuUnpd]":["ukuk"],"[Abs][PlUnpd]":["ukut"],"[Abs][SgUnpd]":["una"],"[Equ]":["waten"],"[Equ][DuUnpd]":["ukugcetun"],"[Equ][PlUnpd]":["ukucetun"],"[Equ][SgUnpd]":["uutun"],"[Loc]":["wani"],"[Loc][DuUnpd]":["ukugni"],"[Loc][PlUnpd]":["ukuni"],"[Loc][SgUnpd]":["uumi"],"[Rel][DuUnpd]":["ukuk"],"[Rel][PlUnpd]":["ukut"],"[Rel][SgUnpd]":["uum"],"[Sec_Ter]":["-"],"[Ter]":["wavet"],"[Ter][DuUnpd]":["ukugnun"],"[Ter][PlUnpd]":["ukunun"],"[Ter][SgUnpd]":["uumun"],"[Via]":["uuggun","waggun"],"[Via][DuUnpd]":["ukunegnun"],"[Via][PlUnpd]":["ukutgun"],"[Via][SgUnpd]":["uukun","uuggun"],"[Voc][DuUnpd]":["ukuuk"],"[Voc][PlUnpd]":["ukuut"],"[Voc][SgUnpd]":["usuuq","uyuuq"]}},"inside, inland, or upriver":{"extended":{"=i[Encl]":["qava-i"],"[Abl]":["qavaken"],"[Abl_Mod][DuUnpd]":["qau͡gkugnek","qaugkugnek"],"[Abl_Mod][PlUnpd]":["qau͡gkunek","qaugkunek"],"[Abl_Mod][SgUnpd]":["qau͡g'umek","qaug'umek"],"[Abs][DuUnpd]":["qau͡gkuk","qaugkuk"],"[Abs][PlUnpd]":["qau͡gkut","qaugkut"],"[Abs][SgUnpd]":["qau͡gna","qaugna"],"[Equ]":["-"],"[Equ][DuUnpd]":["qau͡gkugcetun","qaugkugcetun"],"[Equ][PlUnpd]":["qau͡gkucetun","qaugkucetun"],"[Equ][SgUnpd]":["qau͡g'utun","qaug'utun"],"[Loc]":["qavani"],"[Loc][DuUnpd]":["qau͡gkugni","qaugkugni"],"[Loc][PlUnpd]":["qau͡gkuni","qaugkuni"],"[Loc][SgUnpd]":["qau͡g'umi","qaug'umi"],"[Rel][DuUnpd]":["qau͡gkuk","qaugkuk"],"[Rel][PlUnpd]":["qau͡gkut","qaugkut"],"[Rel][SgUnpd]":["qau͡g'um","qaug'um"],"[Sec_Ter]":["qavatmun"],"[Ter]":["qavavet"],"[Ter][DuUnpd]":["qau͡gkugnun","qaugkugnun"],"[Ter][PlUnpd]":["qau͡gkunun","qaugkunun"],"[Ter][SgUnpd]":["qau͡g'umun","qaug'umun"],"[Via]":["qavaggun"],"[Via][DuUnpd]":["qau͡gkunegnun","qaugkunegnun"],"[Via][PlUnpd]":["qau͡gkutgun","qaugkutgun"],"[Via][SgUnpd]":["qau͡g'ukun","qaug'ukun"],"[Voc][DuUnpd]":["qau͡gkuuk","qaugkuuk"],"[Voc][PlUnpd]":["qau͡gkuut","qaugkuut"],"[Voc][SgUnpd]":["qaugsuuq","qaugyuuq","qau͡gsuuq","qau͡gyuuq"]},"obscured":{"=i[Encl]":["qama-i"],"[Abl]":["qamaken"],"[Abl_Mod][DuUnpd]":["qamkugnek"],"[Abl_Mod][PlUnpd]":["qamkunek"],"[Abl_Mod][SgUnpd]":["qam'umek"],"[Abs][DuUnpd]":["qamkuk"],"[Abs][PlUnpd]":["qamkut"],"[Abs][SgUnpd]":["qamna"],"[Equ]":["-"],"[Equ][DuUnpd]":["qamkugcetun"],"[Equ][PlUnpd]":["qamkucetun"],"[Equ][SgUnpd]":["qam'utun"],"[Loc]":["qamani"],"[Loc][DuUnpd]":["qamkugni"],"[Loc][PlUnpd]":["qamkuni"],"[Loc][SgUnpd]":["qam'umi"],"[Rel][DuUnpd]":["qamkuk"],"[Rel][PlUnpd]":["qamkut"],"[Rel][SgUnpd]":["qam'um"],"[Sec_Ter]":["-"],"[Ter]":["qamavet"],"[Ter][DuUnpd]":["qamkugnun"],"[Ter][PlUnpd]":["qamkunun"],"[Ter][SgUnpd]":["qam'umun"],"[Via]":["qamaggun"],"[Via][DuUnpd]":["qamkunegnun"],"[Via][PlUnpd]":["qamkutgun"],"[Via][SgUnpd]":["qam'ukun"],"[Voc][DuUnpd]":["qamkuuk"],"[Voc][PlUnpd]":["qamkuut"],"[Voc][SgUnpd]":["qamsuuq","qamyuuq"]},"restricted":{"=i[Encl]":["kia-i"],"[Abl]":["kiaken"],"[Abl_Mod][DuUnpd]":["kiu͡gkugnek","kiugkugnek"],"[Abl_Mod][PlUnpd]":["kiu͡gkunek","kiugkunek"],"[Abl_Mod][SgUnpd]":["kiu͡g'umek","kiug'umek","kiugumek"],"[Abs][DuUnpd]":["kiu͡gkuk","kiugkuk"],"[Abs][PlUnpd]":["kiu͡gkut","kiugkut"],"[Abs][SgUnpd]":["kiu͡gna","kiugna"],"[Equ]":["-"],"[Equ][DuUnpd]":["kiu͡gkugcetun","kiugkugcetun"],"[Equ][PlUnpd]":["kiu͡gkucetun","kiugkucetun"],"[Equ][SgUnpd]":["kiu͡g'utun","kiug'utun","kiugutun"],"[Loc]":["kiani"],"[Loc][DuUnpd]":["kiu͡gkugni","kiugkugni"],"[Loc][PlUnpd]":["kiu͡gkuni","kiugkuni"],"[Loc][SgUnpd]":["kiu͡g'umi","kiug'umi","kiugumi"],"[Rel][DuUnpd]":["kiu͡gkuk","kiugkuk"],"[Rel][PlUnpd]":["kiu͡gkut","kiugkut"],"[Rel][SgUnpd]":["kiu͡g'um","kiugum","kiug'um"],"[Sec_Ter]":["kiatmun"],"[Ter]":["kiavet"],"[Ter][DuUnpd]":["kiu͡gkugnun","kiugkugnun"],"[Ter][PlUnpd]":["kiu͡gkunun","kiugkunun"],"[Ter][SgUnpd]":["kiu͡g'umun","kiug'umun","kiugumun"],"[Via]":["kiaggun"],"[Via][DuUnpd]":["kiu͡gkunegnun","kiugkunegnun"],"[Via][PlUnpd]":["kiu͡gkutgun","kiugkutgun"],"[Via][SgUnpd]":["kiu͡g'ukun","kiug'ukun","kiugukun"],"[Voc][DuUnpd]":["kiu͡gkuuk","kiugkuuk"],"[Voc][PlUnpd]":["kiu͡gkuut","kiugkuut"],"[Voc][SgUnpd]":["kiu͡gsuuq","kiu͡gyuuq","kiugsuuq","kiugyuuq"]}},"outside":{"extended":{"=i[Encl]":["qagaa-i","qii-i"],"[Abl]":["qagaaken","qiiken"],"[Abl_Mod][DuUnpd]":["qagkugnek"],"[Abl_Mod][PlUnpd]":["qagkunek"],"[Abl_Mod][SgUnpd]":["qag'umek"],"[Abs][DuUnpd]":["qagkuk"],"[Abs][PlUnpd]":["qagkut"],"[Abs][SgUnpd]":["qagna"],"[Equ]":["-"],"[Equ][DuUnpd]":["qagkugcetun"],"[Equ][PlUnpd]":["qagkucetun"],"[Equ][SgUnpd]":["qag'utun"],"[Loc]":["qagaani","qiini"],"[Loc][DuUnpd]":["qagkugni"],"[Loc][PlUnpd]":["qagkuni"],"[Loc][SgUnpd]":["qag'umi"],"[Rel][DuUnpd]":["qagkuk"],"[Rel][PlUnpd]":["qagkut"],"[Rel][SgUnpd]":["qag'um"],"[Sec_Ter]":["qagaatmun","qiitmun"],"[Ter]":["qagaavet","qiivet"],"[Ter][DuUnpd]":["qagkugnun"],"[Ter][PlUnpd]":["qagkunun"],"[Ter][SgUnpd]":["qag'umun"],"[Via]":["qagaaggun","qiiggun"],"[Via][DuUnpd]":["qagkunegnun"],"[Via][PlUnpd]":["qagkutgun"],"[Via][SgUnpd]":["qag'ukun"],"[Voc][DuUnpd]":["qagkuuk"],"[Voc][PlUnpd]":["qagkuut"],"[Voc][SgUnpd]":["qagsuuq","qagyuuq"]},"obscured":{"=i[Encl]":["qakma-i"],"[Abl]":["qakmaken"],"[Abl_Mod][DuUnpd]":["qakemkugnek"],"[Abl_Mod][PlUnpd]":["qakemkunek"],"[Abl_Mod][SgUnpd]":["qak'mumek"],"[Abs][DuUnpd]":["qakemkuk"],"[Abs][PlUnpd]":["qakemkut"],"[Abs][SgUnpd]":["qakemna"],"[Equ]":["-"],"[Equ][DuUnpd]":["qakemkugcetun"],"[Equ][PlUnpd]":["qakemkucetun"],"[Equ][SgUnpd]":["qak'mutun"],"[Loc]":["qakmani"],"[Loc][DuUnpd]":["qakemkugni"],"[Loc][PlUnpd]":["qakemkuni"],"[Loc][SgUnpd]":["qak'mumi"],"[Rel][DuUnpd]":["qakemkuk"],"[Rel][PlUnpd]":["qakemkut"],"[Rel][SgUnpd]":["qak'mum"],"[Sec_Ter]":["-"],"[Ter]":["qakmavet"],"[Ter][DuUnpd]":["qakemkugnun"],"[Ter][PlUnpd]":["qakemkunun"],"[Ter][SgUnpd]":["qak'mumun"],"[Via]":["qakmaggun"],"[Via][DuUnpd]":["qakemkunegnun"],"[Via][PlUnpd]":["qakemkutgun"],"[Via][SgUnpd]":["qak'mukun"],"[Voc][DuUnpd]":["qakemkuuk"],"[Voc][PlUnpd]":["qakemkuut"],"[Voc][SgUnpd]":["qakemsuuq","qakemyuuq"]},"restricted":{"=i[Encl]":["kegga-i"],"[Abl]":["keggaken"],"[Abl_Mod][DuUnpd]":["kegkugnek"],"[Abl_Mod][PlUnpd]":["kegkunek"],"[Abl_Mod][SgUnpd]":["kegg'umek"],"[Abs][DuUnpd]":["kegkuk"],"[Abs][PlUnpd]":["kegkut"],"[Abs][SgUnpd]":["keggna"],"[Equ]":["-"],"[Equ][DuUnpd]":["kegkugcetun"],"[Equ][PlUnpd]":["kegkucetun"],"[Equ][SgUnpd]":["kegg'utun"],"[Loc]":["keggani"],"[Loc][DuUnpd]":["kegkugni"],"[Loc][PlUnpd]":["kegkuni"],"[Loc][SgUnpd]":["kegg'umi"],"[Rel][DuUnpd]":["kegkuk"],"[Rel][PlUnpd]":["kegkut"],"[Rel][SgUnpd]":["kegg'um"],"[Sec_Ter]":["keggatmun"],"[Ter]":["keggavet"],"[Ter][DuUnpd]":["kegkugnun"],"[Ter][PlUnpd]":["kegkunun"],"[Ter][SgUnpd]":["kegg'umun"],"[Via]":["keggaggun"],"[Via][DuUnpd]":["kegkunegnun"],"[Via][PlUnpd]":["kegkutgun"],"[Via][SgUnpd]":["kegg'ukun"],"[Voc][DuUnpd]":["kegkuuk"],"[Voc][PlUnpd]":["kegkuut"],"[Voc][SgUnpd]":["keggsuuq","keggyuuq"]}},"over there or going away":{"extended":{"=i[Encl]":["ava-i"],"[Abl]":["avaken"],"[Abl_Mod][DuUnpd]":["au͡gkugnek","augkugnek","awkugnek"],"[Abl_Mod][PlUnpd]":["au͡gkunek","augkunek","awkunek"],"[Abl_Mod][SgUnpd]":["au͡g'umek","aug'umek"],"[Abs][DuUnpd]":["au͡gkuk","augkuk","awkuk"],"[Abs][PlUnpd]":["au͡gkut","augkut","awkut"],"[Abs][SgUnpd]":["au͡gna","augna"],"[Equ]":["-"],"[Equ][DuUnpd]":["au͡gkugcetun","augkugcetun","awkugcetun"],"[Equ][PlUnpd]":["au͡gkucetun","augkucetun","awkucetun"],"[Equ][SgUnpd]":["au͡g'utun","aug'utun"],"[Loc]":["avani"],"[Loc][DuUnpd]":["au͡gkugni","augkugni","awkugni"],"[Loc][PlUnpd]":["au͡gkuni","augkuni","awkuni"],"[Loc][SgUnpd]":["au͡g'umi","aug'umi"],"[Rel][DuUnpd]":["au͡gkuk","augkuk","awkuk"],"[Rel][PlUnpd]":["au͡gkut","augkut","awkut"],"[Rel][SgUnpd]":["au͡g'um","aug'um"],"[Sec_Ter]":["avatmun"],"[Ter]":["avavet"],"[Ter][DuUnpd]":["au͡gkugnun","augkugnun","awkugnun"],"[Ter][PlUnpd]":["au͡gkunun","augkunun","awkunun"],"[Ter][SgUnpd]":["au͡g'umun","aug'umun"],"[Via]":["avaggun"],"[Via][DuUnpd]":["au͡gkunegnun","augkunegnun","awkunegnun"],"[Via][PlUnpd]":["au͡gkutgun","augkutgun","awkutgun"],"[Via][SgUnpd]":["au͡g'ukun","aug'ukun"],"[Voc][DuUnpd]":["au͡gkuuk","augkuuk","awkuuk"],"[Voc][PlUnpd]":["au͡gkuut","augkuut","awkuut"],"[Voc][SgUnpd]":["au͡gsuuq","au͡gyuuq","augsuuq","augyuuq"]},"obscured":{"=i[Encl]":["ama-i"],"[Abl]":["amaken"],"[Abl_Mod][DuUnpd]":["amkugnek"],"[Abl_Mod][PlUnpd]":["amkunek"],"[Abl_Mod][SgUnpd]":["am'umek"],"[Abs][DuUnpd]":["amkuk"],"[Abs][PlUnpd]":["amkut"],"[Abs][SgUnpd]":["amna"],"[Equ]":["-"],"[Equ][DuUnpd]":["amkugcetun"],"[Equ][PlUnpd]":["amkucetun"],"[Equ][SgUnpd]":["am'utun"],"[Loc]":["amani"],"[Loc][DuUnpd]":["amkugni"],"[Loc][PlUnpd]":["amkuni"],"[Loc][SgUnpd]":["am'umi"],"[Rel][DuUnpd]":["amkuk"],"[Rel][PlUnpd]":["amkut"],"[Rel][SgUnpd]":["am'um"],"[Sec_Ter]":["-"],"[Ter]":["amavet"],"[Ter][DuUnpd]":["amkugnun"],"[Ter][PlUnpd]":["amkunun"],"[Ter][SgUnpd]":["am'umun"],"[Via]":["amaggun"],"[Via][DuUnpd]":["amkunegnun"],"[Via][PlUnpd]":["amkutgun"],"[Via][SgUnpd]":["am'ukun"],"[Voc][DuUnpd]":["amkuuk"],"[Voc][PlUnpd]":["amkuut"],"[Voc][SgUnpd]":["amsuuq","amyuuq"]},"restricted":{"=i[Encl]":["yaa-i"],"[Abl]":["yaaken"],"[Abl_Mod][DuUnpd]":["ingkugnek"],"[Abl_Mod][PlUnpd]":["ingkunek"],"[Abl_Mod][SgUnpd]":["ing'umek"],"[Abs][DuUnpd]":["ingkuk"],"[Abs][PlUnpd]":["ingkut"],"[Abs][SgUnpd]":["ingna"],"[Equ]":["-"],"[Equ][DuUnpd]":["ingkugcetun"],"[Equ][PlUnpd]":["ingkucetun"],"[Equ][SgUnpd]":["ing'utun"],"[Loc]":["yaani"],"[Loc][DuUnpd]":["ingkugni"],"[Loc][PlUnpd]":["ingkuni"],"[Loc][SgUnpd]":["ing'umi"],"[Rel][DuUnpd]":["ingkuk"],"[Rel][PlUnpd]":["ingkut"],"[Rel][SgUnpd]":["ing'um"],"[Sec_Ter]":["yaatmun"],"[Ter]":["yaavet"],"[Ter][DuUnpd]":["ingkugnun"],"[Ter][PlUnpd]":["ingkunun"],"[Ter][SgUnpd]":["ing'umun"],"[Via]":["yaaggun"],"[Via][DuUnpd]":["ingkunegnun"],"[Via][PlUnpd]":["ingkutgun"],"[Via][SgUnpd]":["ing'ukun"],"[Voc][DuUnpd]":["ingkuuk"],"[Voc][PlUnpd]":["ingkuut"],"[Voc][SgUnpd]":["ingsuuq","ingyuuq"]}},"there, near listener or in context":{"extended":{"=i[Encl]":["tamaa-i"],"[Abl]":["tamaaken"],"[Abl_Mod][DuUnpd]":["tamakugnek"],"[Abl_Mod][PlUnpd]":["tamakunek"],"[Abl_Mod][SgUnpd]":["tamatumek"],"[Abs][DuUnpd]":["tamakuk"],"[Abs][PlUnpd]":["tamakut"],"[Abs][SgUnpd]":["tamana"],"[Equ]":["-"],"[Equ][DuUnpd]":["tamakugcetun"],"[Equ][PlUnpd]":["tamakucetun"],"[Equ][SgUnpd]":["tamatutun"],"[Loc]":["tamaani"],"[Loc][DuUnpd]":["tamakugni"],"[Loc][PlUnpd]":["tamakuni"],"[Loc][SgUnpd]":["tamatumi"],"[Rel][DuUnpd]":["tamakuk"],"[Rel][PlUnpd]":["tamakut"],"[Rel][SgUnpd]":["tamatum"],"[Sec_Ter]":["tamaatmun"],"[Ter]":["tamaavet"],"[Ter][DuUnpd]":["tamakugnun"],"[Ter][PlUnpd]":["tamakunun"],"[Ter][SgUnpd]":["tamatumun"],"[Via]":["tamaaggun"],"[Via][DuUnpd]":["tamakunegnun"],"[Via][PlUnpd]":["tamakutgun"],"[Via][SgUnpd]":["tamatukun"],"[Voc][DuUnpd]":["tamakuuk"],"[Voc][PlUnpd]":["tamakuut"],"[Voc][SgUnpd]":["tamasuuq","tamayuuq"]},"restricted":{"=i[Encl]":["tua-i","tava-i"],"[Abl]":["tuaken","tavaken"],"[Abl_Mod][DuUnpd]":["taukugnek"],"[Abl_Mod][PlUnpd]":["taukunek"],"[Abl_Mod][SgUnpd]":["taumek"],"[Abs][DuUnpd]":["taukuk"],"[Abs][PlUnpd]":["taukut"],"[Abs][SgUnpd]":["tauna"],"[Equ]":["tuaten"],"[Equ][DuUnpd]":["taukugcetun"],"[Equ][PlUnpd]":["taukucetun"],"[Equ][SgUnpd]":["tautun"],"[Loc]":["tuani","tavani"],"[Loc][DuUnpd]":["taukugni"],"[Loc][PlUnpd]":["taukuni"],"[Loc][SgUnpd]":["taumi"],"[Rel][DuUnpd]":["taukuk"],"[Rel][PlUnpd]":["taukut"],"[Rel][SgUnpd]":["taum"],"[Sec_Ter]":["-"],"[Ter]":["tuavet","tavavet"],"[Ter][DuUnpd]":["taukugnun"],"[Ter][PlUnpd]":["taukunun"],"[Ter][SgUnpd]":["taumun"],"[Via]":["tuaggun","tavaggun"],"[Via][DuUnpd]":["taukunegnun"],"[Via][PlUnpd]":["taukutgun"],"[Via][SgUnpd]":["taukun"],"[Voc][DuUnpd]":["taukuuk"],"[Voc][PlUnpd]":["taukuut"],"[Voc][SgUnpd]":["tausuuq","tauyuuq"]}},"up above":{"extended":{"=i[Encl]":["pagaa-i","pii-i"],"[Abl]":["pagaaken","piiken"],"[Abl_Mod][DuUnpd]":["pagkugnek"],"[Abl_Mod][PlUnpd]":["pagkunek"],"[Abl_Mod][SgUnpd]":["pag'umek"],"[Abs][DuUnpd]":["pagkuk"],"[Abs][PlUnpd]":["pagkut"],"[Abs][SgUnpd]":["pagna"],"[Equ]":["-"],"[Equ][DuUnpd]":["pagkugcetun"],"[Equ][PlUnpd]":["pagkucetun"],"[Equ][SgUnpd]":["pag'utun"],"[Loc]":["pagaani","piini"],"[Loc][DuUnpd]":["pagkugni"],"[Loc][PlUnpd]":["pagkuni"],"[Loc][SgUnpd]":["pag'umi"],"[Rel][DuUnpd]":["pagkuk"],"[Rel][PlUnpd]":["pagkut"],"[Rel][SgUnpd]":["pag'um"],"[Sec_Ter]":["pagaatmun","piitmun"],"[Ter]":["pagaavet","piivet"],"[Ter][DuUnpd]":["pagkugnun"],"[Ter][PlUnpd]":["pagkunun"],"[Ter][SgUnpd]":["pag'umun"],"[Via]":["pagaaggun","piiggun"],"[Via][DuUnpd]":["pagkunegnun"],"[Via][PlUnpd]":["pagkutgun"],"[Via][SgUnpd]":["pag'ukun"],"[Voc][DuUnpd]":["pagkuuk"],"[Voc][PlUnpd]":["pagkuut"],"[Voc][SgUnpd]":["pagsuuq","pagyuuq"]},"obscured":{"=i[Encl]":["pakma-i"],"[Abl]":["pakmaken"],"[Abl_Mod][DuUnpd]":["pakemkugnek"],"[Abl_Mod][PlUnpd]":["pakemkunek"],"[Abl_Mod][SgUnpd]":["pak'mumek"],"[Abs][DuUnpd]":["pakemkuk"],"[Abs][PlUnpd]":["pakemkut"],"[Abs][SgUnpd]":["pakemna"],"[Equ]":["-"],"[Equ][DuUnpd]":["pakemkugcetun"],"[Equ][PlUnpd]":["pakemkucetun"],"[Equ][SgUnpd]":["pak'mutun"],"[Loc]":["pakmani"],"[Loc][DuUnpd]":["pakemkugni"],"[Loc][PlUnpd]":["pakemkuni"],"[Loc][SgUnpd]":["pak'mumi"],"[Rel][DuUnpd]":["pakemkuk"],"[Rel][PlUnpd]":["pakemkut"],"[Rel][SgUnpd]":["pak'mum"],"[Sec_Ter]":["-"],"[Ter]":["pakmavet"],"[Ter][DuUnpd]":["pakemkugnun"],"[Ter][PlUnpd]":["pakemkunun"],"[Ter][SgUnpd]":["pak'mumun"],"[Via]":["pakmaggun"],"[Via][DuUnpd]":["pakemkunegnun"],"[Via][PlUnpd]":["pakemkutgun"],"[Via][SgUnpd]":["pak'mukun"],"[Voc][DuUnpd]":["pakemkuuk"],"[Voc][PlUnpd]":["pakemkuut"],"[Voc][SgUnpd]":["pakemsuuq","pakemyuuq"]},"restricted":{"=i[Encl]":["pika-i"],"[Abl]":["pikaken"],"[Abl_Mod][DuUnpd]":["pikegkugnek"],"[Abl_Mod][PlUnpd]":["pikegkunek"],"[Abl_Mod][SgUnpd]":["pik'umek","pikgumek"],"[Abs][DuUnpd]":["pikegkuk"],"[Abs][PlUnpd]":["pikegkut"],"[Abs][SgUnpd]":["pikna","pikeggna"],"[Equ]":["-"],"[Equ][DuUnpd]":["pikegkugcetun"],"[Equ][PlUnpd]":["pikegkucetun"],"[Equ][SgUnpd]":["pik'utun","pikgutun"],"[Loc]":["pikani"],"[Loc][DuUnpd]":["pikegkugni"],"[Loc][PlUnpd]":["pikegkuni"],"[Loc][SgUnpd]":["pik'umi","pikgumi"],"[Rel][DuUnpd]":["pikegkuk"],"[Rel][PlUnpd]":["pikegkut"],"[Rel][SgUnpd]":["pik'um","pikgum"],"[Sec_Ter]":["pikatmun"],"[Ter]":["pikavet"],"[Ter][DuUnpd]":["pikegkugnun"],"[Ter][PlUnpd]":["pikegkunun"],"[Ter][SgUnpd]":["pik'umun","pikgumun"],"[Via]":["pikaggun"],"[Via][DuUnpd]":["pikegkunegnun"],"[Via][PlUnpd]":["pikegkutgun"],"[Via][SgUnpd]":["pik'ukun","pikgukun"],"[Voc][DuUnpd]":["pikegkuuk"],"[Voc][PlUnpd]":["pikegkuut"],"[Voc][SgUnpd]":["piksuuq","pikyuuq","pikeggsuuq","pikeggyuuq"]}},"up the slope":{"extended":{"=i[Encl]":["pava-i"],"[Abl]":["pavaken"],"[Abl_Mod][DuUnpd]":["pau͡gkugnek","paugkugnek"],"[Abl_Mod][PlUnpd]":["pau͡gkunek","paugkunek"],"[Abl_Mod][SgUnpd]":["pau͡g'umek","paug'umek"],"[Abs][DuUnpd]":["pau͡gkuk","paugkuk"],"[Abs][PlUnpd]":["pau͡gkut","paugkut"],"[Abs][SgUnpd]":["pau͡gna","paugna"],"[Equ]":["-"],"[Equ][DuUnpd]":["pau͡gkugcetun","paugkugcetun"],"[Equ][PlUnpd]":["pau͡gkucetun","paugkucetun"],"[Equ][SgUnpd]":["pau͡g'utun","paug'utun"],"[Loc]":["pavani"],"[Loc][DuUnpd]":["pau͡gkugni","paugkugni"],"[Loc][PlUnpd]":["pau͡gkuni","paugkuni"],"[Loc][SgUnpd]":["pau͡g'umi","paug'umi"],"[Rel][DuUnpd]":["pau͡gkuk","paugkuk"],"[Rel][PlUnpd]":["pau͡gkut","paugkut"],"[Rel][SgUnpd]":["pau͡g'um","paug'um"],"[Sec_Ter]":["pavatmun"],"[Ter]":["pavavet"],"[Ter][DuUnpd]":["pau͡gkugnun","paugkugnun"],"[Ter][PlUnpd]":["pau͡gkunun","paugkunun"],"[Ter][SgUnpd]":["pau͡g'umun","paug'umun"],"[Via]":["pavaggun"],"[Via][DuUnpd]":["pau͡gkunegnun","paugkunegnun"],"[Via][PlUnpd]":["pau͡gkutgun","paugkutgun"],"[Via][SgUnpd]":["pau͡g'ukun","paug'ukun"],"[Voc][DuUnpd]":["pau͡gkuuk","paugkuuk"],"[Voc][PlUnpd]":["pau͡gkuut","paugkuut"],"[Voc][SgUnpd]":["pau͡gsuuq","pau͡gyuuq","paugsuuq","paugyuuq"]},"obscured":{"=i[Encl]":["pama-i"],"[Abl]":["pamaken"],"[Abl_Mod][DuUnpd]":["pamkugnek"],"[Abl_Mod][PlUnpd]":["pamkunek"],"[Abl_Mod][SgUnpd]":["pam'umek"],"[Abs][DuUnpd]":["pamkuk"],"[Abs][PlUnpd]":["pamkut"],"[Abs][SgUnpd]":["pamna"],"[Equ]":["-"],"[Equ][DuUnpd]":["pamkugcetun"],"[Equ][PlUnpd]":["pamkucetun"],"[Equ][SgUnpd]":["pam'utun"],"[Loc]":["pamani"],"[Loc][DuUnpd]":["pamkugni"],"[Loc][PlUnpd]":["pamkuni"],"[Loc][SgUnpd]":["pam'umi"],"[Rel][DuUnpd]":["pamkuk"],"[Rel][PlUnpd]":["pamkut"],"[Rel][SgUnpd]":["pam'um"],"[Sec_Ter]":["-"],"[Ter]":["pamavet"],"[Ter][DuUnpd]":["pamkugnun"],"[Ter][PlUnpd]":["pamkunun"],"[Ter][SgUnpd]":["pam'umun"],"[Via]":["pamaggun"],"[Via][DuUnpd]":["pamkunegnun"],"[Via][PlUnpd]":["pamkutgun"],"[Via][SgUnpd]":["pam'ukun"],"[Voc][DuUnpd]":["pamkuuk"],"[Voc][PlUnpd]":["pamkuut"],"[Voc][SgUnpd]":["pamsuuq","pamyuuq"]},"restricted":{"=i[Encl]":["pia-i"],"[Abl]":["piaken"],"[Abl_Mod][DuUnpd]":["pingkugnek"],"[Abl_Mod][PlUnpd]":["pingkunek"],"[Abl_Mod][SgUnpd]":["ping'umek"],"[Abs][DuUnpd]":["pingkuk"],"[Abs][PlUnpd]":["pingkut"],"[Abs][SgUnpd]":["pingna"],"[Equ]":["-"],"[Equ][DuUnpd]":["pingkugcetun"],"[Equ][PlUnpd]":["pingkucetun"],"[Equ][SgUnpd]":["ping'utun"],"[Loc]":["piani"],"[Loc][DuUnpd]":["pingkugni"],"[Loc][PlUnpd]":["pingkuni"],"[Loc][SgUnpd]":["ping'umi"],"[Rel][DuUnpd]":["pingkuk"],"[Rel][PlUnpd]":["pingkut"],"[Rel][SgUnpd]":["ping'um"],"[Sec_Ter]":["piatmun"],"[Ter]":["piavet"],"[Ter][DuUnpd]":["pingkugnun"],"[Ter][PlUnpd]":["pingkunun"],"[Ter][SgUnpd]":["ping'umun"],"[Via]":["piaggun"],"[Via][DuUnpd]":["pingkunegnun"],"[Via][PlUnpd]":["pingkutgun"],"[Via][SgUnpd]":["ping'ukun"],"[Voc][DuUnpd]":["pingkuuk"],"[Voc][PlUnpd]":["pingkuut"],"[Voc][SgUnpd]":["pingsuuq","pingyuuq"]}}};var endingToEnglishTerms={"[Ind]":"Indicative (Statement Form)","[Intrg]":"Interrogative (Question Form)","[Opt]":"Optative (Command Form)","[Sbrd]":"Subordinative (Polite Command or -ing Form)","[Ptcp]":"Participial","[Prec]":"Precessive (before...)","[Cnsq]":"Consequential (because...)","[Cont]":"Contigent (whenever...)","[Conc]":"Concessive (although, even though, even if...)","[Cond]":"Conditional (if, when in the future...)","[CtmpI]":"Contemporative 1 (when in fthe past...)","[CtmpII]":"Contemporative 2 (while...)","[Abs]":"Absolutive","[Rel]":"Relative","[Abl_Mod]":"Ablative-Modalis (indirect object, from...)","[Abl]":"Ablative (from...)","[Loc]":"Localis (in, at...)","[Ter]":"Terminalis (to...)","[Sec_Ter]":"Second Terminalis (toward...)","[Via]":"Vialis (through, using...)","[Equ]":"Equalis (like, similar to...)","[Quant_Qual]":"Quantifier/Qualifier Inflection","[Voc]":"Vocative","[Cardinal]":"Cardinal Numeral","[S_3Sg]":"he,\xa0she,\xa0it","[S_3Du]":"they\xa0(2)","[S_3Pl]":"they\xa0all\xa0(3+)","[S_1Sg]":"I","[S_1Du]":"we\xa0(2)","[S_1Pl]":"we\xa0all\xa0(3+)","[S_2Sg]":"you","[S_2Du]":"you\xa0(2)","[S_2Pl]":"you\xa0all\xa0(3+)","[S_4Sg]":"he, she, it (itself)","[S_4Du]":"they (2) (themselves)","[S_4Pl]":"they all (3+) (themselves)","[A_3Sg]":"he,\xa0she,\xa0it","[A_3Du]":"they\xa0(2)","[A_3Pl]":"they\xa0all\xa0(3+)","[A_1Sg]":"I","[A_1Du]":"we\xa0(2)","[A_1Pl]":"we\xa0all\xa0(3+)","[A_2Sg]":"you","[A_2Du]":"you\xa0(2)","[A_2Pl]":"you\xa0all\xa0(3+)","[A_4Sg]":"he, she, it (itself)","[A_4Du]":"they (2) (themselves)","[A_4Pl]":"they all (3+) (themselves)",//   "[P_3Sg]":"her,\xa0him,\xa0it\xa0(other)",
//   "[P_3Du]":"the\xa0two\xa0of\xa0them\xa0(others)",
//   "[P_3Pl]":"them\xa0all\xa0(3+)\xa0(others)",
"[P_3Sg]":"another","[P_3Du]":"two others","[P_3Pl]":"3+ others","[P_1Sg]":"me","[P_1Du]":"the\xa0two\xa0of\xa0us","[P_1Pl]":"us\xa0all\xa0(3+)","[P_2Sg]":"you","[P_2Du]":"the\xa0two\xa0of\xa0you","[P_2Pl]":"you\xa0all\xa0(3+)","[P_4Sg]":"her,\xa0him,\xa0it\xa0(itself)","[P_4Du]":"the\xa0two\xa0of\xa0them\xa0(themselves)","[P_4Pl]":"them\xa0all\xa0(3+)\xa0(themselves)","[SgUnpd]":"one","[DuUnpd]":"two","[PlUnpd]":"3+","[SgPosd]":"one","[DuPosd]":"two","[PlPosd]":"3+","[3SgPoss]":"his/her/its\xa0(other)","[3DuPoss]":"their\xa0(2)\xa0(other)","[3PlPoss]":"their\xa0(3+)\xa0(other)","[1SgPoss]":"my","[1DuPoss]":"our\xa0(2)","[1PlPoss]":"our\xa0(3+)","[2SgPoss]":"your\xa0(1)","[2DuPoss]":"your\xa0(2)","[2PlPoss]":"your\xa0(3+)","[4SgPoss]":"his/her/its\xa0own","[4DuPoss]":"their\xa0own\xa0(2)","[4PlPoss]":"their\xa0own\xa0(3+)","[3Sg]":"it\xa0(other)","[3Du]":"them\xa0(2)\xa0(other)","[3Pl]":"them\xa0(3+)\xa0(other)","[1Sg]":"me","[1Du]":"us\xa0(2)","[1Pl]":"us\xa0(3+)","[2Sg]":"you\xa0(1)","[2Du]":"you\xa0(2)","[2Pl]":"you\xa0(3+)","[4Sg]":"itself","[4Du]":"themselves\xa0(2)","[4Pl]":"themselves\xa0(3+)","[Sg]":"one","[Du]":"two","[Pl]":"3+"};var endingEnglishDescriptions={"[Ind]":"(is, are, am)","[Intrg]":"(question)","[Opt]":"(do it!)","[Sbrd]":"(please do, being)","[Ptcp]":"(the one being, special case)","[Prec]":"(before)","[Cnsq]":"(because)","[Cont]":"(whenever)","[Conc]":"(although, even if)","[Cond]":"(if, when in future)","[CtmpI]":"(when in past)","[CtmpII]":"(while)","[Abs]":"the","[Rel]":"the","[Abl_Mod]":"[a, some, from]","[Abl]":"from","[Loc]":"in or at","[Ter]":"to","[Sec_Ter]":"toward","[Via]":"through or using","[Equ]":"like or similar to","[Quant_Qual]":"Quantifier/Qualifier Inflection","[Voc]":"(calling)","[Cardinal]":""};var endingDescriptions=["1) statements; 2) “yes-no” questions, usually with enclitic =qaa","1) content questions; 2) exclamations with the postbase @5+pag- | ~vag-","1) commands, requests, suggestions; 2) statements in narrative with the postbase ki- and a third person ending","1) actions or states subordinate to that of the main verb and involving the same subject; 2) requests, commands, suggestions with a second person ending","1) exclamations, usually with tang; 2) certain special constructions (see maaten and =wa)","“before”","“because”","“whenever”","“although, even though, even if” ","“if, when (in the future)”","“when (in the past)” ","“while”","1) subject of an intransitive verb; 2) object of a transitive verb","1) subject of a transitive verb; 2) possessor; 3) “independent relative construction,” see section on roots in Generation Introduction, and Appendix 1, for further information","1) place from which, time from which; 2) indefinite object of an intransitive verb; 3) specifying information about a noun within a verb; 4) secondary object especially with verbs of speaking and giving; 5) instrument (only in some dialects)","1) place at which, time at which; 2) object of a comparison; 3) with postbase @+paa|~vaa and enclitic =lli in exclamations; 4) formal vocative","1) place to which, time to which; 2) subject of an embedded verb","1) route; 2) instrument; 3) part of a whole","1) comparison; 2) language specification; 3) price specification"];var exampleSentences=["1) Pissurtuq. - It is hunting. 2) Maqillruuk-qaa? - Did they two took a steambath?","1) Qangvaq ayallrua? - When did he go? Caqatarcit? - What will you do? 2) Caperrnaqvagta. - How difficult it is.","1) Neri. - Eat. Taisgu. - Bring it here. 2) Tan'gaurluq qanqili, 'Maurluuq!, naw'un iterciqsia?' - The boy said (literally: let the boy say), 'Grandmother!, through where will I get in?'","1) Cukaluni aqvaqurtuq. - She is running quickly. 2) Qantan painqegcaarluku. - Lick your plate clean, please.","1) Tang, qavalria. - Look, it's sleeping. 2) Maaten itertua anelria. - I came in; lo and behold, he went out.","Ayagpailgan payugeskiu. - Before he leaves, bring him food.","Ayaksaituq arenqiapakaan ellalluk. - He hasn’t gone because of this bad weather.","Ner'aqami tamuanqegcaalartuq. - Whenever she eats, she chews her food well.","Pingraan ayagyugtua. - Even though that's the case, I want to go.","Anglirikuni elitnauristen͞guyugtuq. - When he grows up, he wants to be a teacher.","Akngirtuq atrallermini. - He got hurt when he was coming down.","Ayainanermini igtellruuq. - While he was going, he fell.","1) Saskaq kuv'uq. - The glass spilled. 2) Maqaruaq pissullrua. - He hunted the rabbit.","1) Angutem quyavikaa. - The man was thankful to her. 2) Ciquyam pania cen̄irtuq. - Ciquyaq's daughter is visiting.","1) Elitnaurvigmek utertuq. - She's coming home from the school. 2) Ner'uq akutamek. - She is eating some akutaq. 3) Nutaramek qayaliuq. - He is making a new kayak. 4) Aanama kuuvviaryuucimnek aptaanga. - My mother is asking me whether I want coffee.","1) Mermi uitauq. - It is in the water. 2) Aatamni sugtunruunga. - I am taller than my dad. 3) Akertem̄i-lli puqlanirpaa! - How warm the sun is! 4) Elpet angutmi, niicugninga. - You man, listen to me.","1) Kipusvigmun piyuaguq. - He's walking to the store. 2) Arnam neresqaa neqa taqukamun. - The woman asks/tells the bear to eat the fish.","1) Tumyarakun ayallruuq. - He went by the path. 2) Angyakun ayagtut. - They are going by boat. 3) Qercuallruunga it'gamkun. - I got frostbitten on my feet.","1) Aatamegcetun yurartut. - They are dancing like their father. 2) Una Yugtun cauga? - What is this in Yup'ik? 3) Akingqertuq malrugtun. - It is two dollars."];var accordionTitlesVerbs=["Indicative (it is...)","Interrogative (question)","Optative (do it...)","Subordinative (please do or it being...)","Participial (exclamation or special case)","Precessive (before...)","Consequential (because...)","Contigent (whenever...)","Concessive (although, even though, even if...)","Conditional (if, when in the future...)","Contemporative 1 (when in the past...)","Contemporative 2 (while...)"];// const accordionTitlesVerbs = [
//   "it is... (indicative)",
//   "question (interrogative)",
//   "do it... (optative)",
//   "please do or it being...(subordinative))",
//   "exclamation or special case (participial)",
//   "before... (precessive)",
//   "because... (consequential)",
//   "whenever... (contingent)",
//   "although, even though, even if... (concessive)",
//   "if, when in the future... (conditional)",
//   "when in the past... (contemporative 1)",
//   "while... (contemporative 2)",
//   ];
// const accordionTitlesVerbs = [
//   "it is... (Indicative)",
//   "question (Interrogative)",
//   "do it... (Optative)",
//   "please do or it being... (Subordinative))",
//   "exclamation or special case (Participial)",
//   "before... (Precessive)",
//   "because... (Consequential)",
//   "whenever... (Contingent)",
//   "although, even though, even if... (Concessive)",
//   "if, when in the future... (Conditional)",
//   "when in the past... (Contemporative 1)",
//   "while... (Contemporative 2)",
//   ];
var accordionTitlesNouns=["Absolutive (the)","Relative (the)","Ablative-Modalis (a, some, from)","Localis (in, at)","Terminalis (to)","Vialis (through, using)","Equalis (like, similar to)"];var accordionTitlesQuantQual=["Absolutive (the)","Relative (the possessor, owner)","Ablative-Modalis (a, some, from)","Localis (in, at)","Terminalis (to)","Vialis (through, using)","Equalis (like, similar to)"];var persPronounLabels=["[Abs]","[Rel]","[Abl_Mod]","[Loc]","[Ter]","[Via]","[Equ]"];var persPronounSubjects=["[3Sg]","[3Du]","[3Pl]","[1Sg]","[1Du]","[1Pl]","[2Sg]","[2Du]","[2Pl]","[4Sg]","[4Du]","[4Pl]"];var persPronounsEnglish=["it\xa0(other)","them\xa0(2)\xa0(other)","them\xa0(3+)\xa0(other)","me","us\xa0(2)","us\xa0(3+)","you\xa0(1)","you\xa0(2)","you\xa0(3+)","itself","themselves\xa0(2)","themselves\xa0(3+)"];var demPronounTitles=["over there or going away","across there","up the slope","up above","inside, inland, or upriver","outside","down below or down the slope","downriver or near the exit","here, near speaker","there, near listener or in context","coming this way"];var demPronounSubjects=["[Abs][SgUnpd]","[Abs][DuUnpd]","[Abs][PlUnpd]","[Rel][SgUnpd]","[Rel][DuUnpd]","[Rel][PlUnpd]","[Abl_Mod][SgUnpd]","[Abl_Mod][DuUnpd]","[Abl_Mod][PlUnpd]","[Loc][SgUnpd]","[Loc][DuUnpd]","[Loc][PlUnpd]","[Ter][SgUnpd]","[Ter][DuUnpd]","[Ter][PlUnpd]","[Via][SgUnpd]","[Via][DuUnpd]","[Via][PlUnpd]","[Equ][SgUnpd]","[Equ][DuUnpd]","[Equ][PlUnpd]","[Voc][SgUnpd]","[Voc][DuUnpd]","[Voc][PlUnpd]","","[Loc]","[Ter]","[Sec_Ter]","[Abl]","[Via]","[Equ]","=i[Encl]"];var demPronounEnglish=["absolutive singular","absolutive dual","absolutive plural","relative singular","relative dual","relative plural","abl-modalis singular","abl-modalis dual","abl-modalis plural","localis singular","localis dual","localis plural","terminalis singular","terminalis dual","terminalis plural","vialis singular","vialis dual","vialis plural","equalis singular","equalis dual","equalis plural","vocative singular","vocative dual","vocative plural","","localis","terminalis","second terminalis","ablative","vialis","equalis","predicative"];var moods=["[Ind]","[Intrg]","[Opt]","[Sbrd]","[Ptcp]","[Prec]","[Cnsq]","[Cont]","[Conc]","[Cond]","[CtmpI]","[CtmpII]","[Abs]","[Rel]","[Abl_Mod]","[Loc]","[Ter]","[Via]","[Equ]","%5BQuant_Qual%5D","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]"];

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(879);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(440);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(443);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(881);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(446);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(231);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleAllPostbases; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(448);
var toggleAllPostbases=function toggleAllPostbases(){return{type:__WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* TOGGLE_ALL_POSTBASES */],payload:{}};};

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_ALL_POSTBASES; });
var TOGGLE_ALL_POSTBASES='TOGGLE_ALL_POSTBASES';

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54), __webpack_require__(120)(module)))

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReCAPTCHA; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _excluded = ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl", "isolated"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }


var ReCAPTCHA = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);
  function ReCAPTCHA() {
    var _this;
    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = ReCAPTCHA.prototype;
  _proto.getCaptchaFunction = function getCaptchaFunction(fnName) {
    if (this.props.grecaptcha) {
      if (this.props.grecaptcha.enterprise) {
        return this.props.grecaptcha.enterprise[fnName];
      }
      return this.props.grecaptcha[fnName];
    }
    return null;
  };
  _proto.getValue = function getValue() {
    var getResponse = this.getCaptchaFunction("getResponse");
    if (getResponse && this._widgetId !== undefined) {
      return getResponse(this._widgetId);
    }
    return null;
  };
  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }
    return null;
  };
  _proto.execute = function execute() {
    var execute = this.getCaptchaFunction("execute");
    if (execute && this._widgetId !== undefined) {
      return execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };
  _proto.executeAsync = function executeAsync() {
    var _this2 = this;
    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;
      _this2.execute();
    });
  };
  _proto.reset = function reset() {
    var resetter = this.getCaptchaFunction("reset");
    if (resetter && this._widgetId !== undefined) {
      resetter(this._widgetId);
    }
  };
  _proto.forceReset = function forceReset() {
    var resetter = this.getCaptchaFunction("reset");
    if (resetter) {
      resetter();
    }
  };
  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };
  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }
    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };
  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }
    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };
  _proto.explicitRender = function explicitRender() {
    var render = this.getCaptchaFunction("render");
    if (render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge,
        isolated: this.props.isolated
      });
      this.captcha.appendChild(wrapper);
    }
    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };
  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };
  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };
  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
      sitekey = _this$props.sitekey,
      onChange = _this$props.onChange,
      theme = _this$props.theme,
      type = _this$props.type,
      tabindex = _this$props.tabindex,
      onExpired = _this$props.onExpired,
      onErrored = _this$props.onErrored,
      size = _this$props.size,
      stoken = _this$props.stoken,
      grecaptcha = _this$props.grecaptcha,
      badge = _this$props.badge,
      hl = _this$props.hl,
      isolated = _this$props.isolated,
      childProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    /* eslint-enable no-unused-vars */
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };
  return ReCAPTCHA;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  grecaptcha: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  theme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["dark", "light"]),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["image", "audio"]),
  tabindex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onExpired: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onErrored: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["compact", "normal", "invisible"]),
  stoken: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  badge: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["bottomright", "bottomleft", "inline"]),
  isolated: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ending_underlying; });
var ending_underlying={"[Abl]":[".ken"],"[Abl_Mod][DuUnpd]":[".gnek"],"[Abl_Mod][PlUnpd]":[".nek"],"[Abl_Mod][SgUnpd]":[".mek"],"[Abs][DuUnpd]":[".k"],"[Abs][PlUnpd]":[".t"],"[Abs][SgUnpd]":["+na","+n'a"],"[Equ]":[".ten"],"[Equ][DuUnpd]":[".gcetun"],"[Equ][PlUnpd]":[".cetun"],"[Equ][SgUnpd]":[".tun"],"[Loc]":[".ni"],"[Loc][DuUnpd]":[".gni"],"[Loc][PlUnpd]":[".ni"],"[Loc][SgUnpd]":[".mi"],"[Cardinal][Sg]":[""],"[Cardinal][Du]":[""],"[Cardinal][Pl]":[""],"[N][Abl_Mod][1DuPoss][DuPosd]":["%:(e)gmegnek","%:(e)gmegneng"],"[N][Abl_Mod][1DuPoss][PlPosd]":["–megnek","–megneng"],"[N][Abl_Mod][1DuPoss][SgPosd]":["–megnek","–megneng"],"[N][Abl_Mod][1PlPoss][DuPosd]":["%:(e)gemten̄ek","%:(e)gemten̄eng"],"[N][Abl_Mod][1PlPoss][PlPosd]":["–mten̄ek","–mten̄eng"],"[N][Abl_Mod][1PlPoss][SgPosd]":["–mten̄ek","–mten̄eng"],"[N][Abl_Mod][1SgPoss][DuPosd]":["%:(e)gemnek","%:(e)gemneng"],"[N][Abl_Mod][1SgPoss][PlPosd]":["–mnek","–mneng"],"[N][Abl_Mod][1SgPoss][SgPosd]":["–mnek","–mneng"],"[N][Abl_Mod][2DuPoss][DuPosd]":["%:(e)gpetegnek","%:(e)gpetegneng"],"[N][Abl_Mod][2DuPoss][PlPosd]":["–vtegnek","–vtegneng",".vtegnek",".vtegneng","+petegnek","+petegneng"],"[N][Abl_Mod][2DuPoss][SgPosd]":["–vtegnek","–vtegneng",".vtegnek",".vtegneng","+petegnek","+petegneng"],"[N][Abl_Mod][2PlPoss][DuPosd]":["%:(e)gpecen̄ek","%:(e)gpecineng"],"[N][Abl_Mod][2PlPoss][PlPosd]":["–vcineng","–vcen̄ek",".vcineng",".vcen̄ek","+pecineng","+pecen̄ek"],"[N][Abl_Mod][2PlPoss][SgPosd]":["–vcineng","–vcen̄ek",".vcineng",".vcen̄ek","+pecineng","+pecen̄ek"],"[N][Abl_Mod][2SgPoss][DuPosd]":["%:(e)gpenek","%:(e)gpeneng"],"[N][Abl_Mod][2SgPoss][PlPosd]":["–vnek","–vneng",".vnek",".vneng","+penek","+peneng"],"[N][Abl_Mod][2SgPoss][SgPosd]":["–vnek","–vneng",".vnek",".vneng","+penek","+peneng"],"[N][Abl_Mod][3DuPoss][DuPosd]":["%:(e)gkegni","%:(e)gkegneng"],"[N][Abl_Mod][3DuPoss][PlPosd]":["–kegnek","–kegneng"],"[N][Abl_Mod][3DuPoss][SgPosd]":[":(ng)agnek",":(ng)agneng"],"[N][Abl_Mod][3PlPoss][DuPosd]":["%:(e)gketnek","%:(e)gketneng"],"[N][Abl_Mod][3PlPoss][PlPosd]":[":(ng)itnek",":(ng)itneng"],"[N][Abl_Mod][3PlPoss][SgPosd]":[":(ng)atnek",":(ng)atneng"],"[N][Abl_Mod][3SgPoss][DuPosd]":["%:(e)gkenek","%:(e)gkeneng"],"[N][Abl_Mod][3SgPoss][PlPosd]":[":(ng)inek",":(ng)ineng"],"[N][Abl_Mod][3SgPoss][SgPosd]":[":(ng)anek",":(ng)aneng"],"[N][Abl_Mod][4DuPoss][DuPosd]":["%:(e)gmegnek","%:(e)gmegneng"],"[N][Abl_Mod][4DuPoss][PlPosd]":["–megnek","–megneng"],"[N][Abl_Mod][4DuPoss][SgPosd]":["–megnek","–megneng"],"[N][Abl_Mod][4PlPoss][DuPosd]":["%:(e)gmeggnek","%:(e)gmeggneng"],"[N][Abl_Mod][4PlPoss][PlPosd]":["–meggnek","–meggneng"],"[N][Abl_Mod][4PlPoss][SgPosd]":["–meggnek","–meggneng"],"[N][Abl_Mod][4SgPoss][DuPosd]":["%:(e)gminek","%:(e)gmineng"],"[N][Abl_Mod][4SgPoss][PlPosd]":["–minek","–mineng"],"[N][Abl_Mod][4SgPoss][SgPosd]":["–minek","–mineng"],"[N][Abl_Mod][DuUnpd]":["%:(e)gnek","%:(e)gneng"],"[N][Abl_Mod][PlUnpd]":["%~nek","%~neng"],"[N][Abl_Mod][SgUnpd]":["%~mek","%~meng"],"[N][Abs][1DuPoss][DuPosd]":["%:(e)gpuk"],"[N][Abs][1DuPoss][PlPosd]":["–puk"],"[N][Abs][1DuPoss][SgPosd]":["–puk",".vuk","+puk"],"[N][Abs][1PlPoss][DuPosd]":["%:(e)gput"],"[N][Abs][1PlPoss][PlPosd]":["–put"],"[N][Abs][1PlPoss][SgPosd]":["–put",".vut","+put"],"[N][Abs][1SgPoss][DuPosd]":["%:(e)gka"],"[N][Abs][1SgPoss][PlPosd]":["%:(e)nka"],"[N][Abs][1SgPoss][SgPosd]":["–ka"],"[N][Abs][2DuPoss][DuPosd]":["%:(e)gtek"],"[N][Abs][2DuPoss][PlPosd]":["–tek"],"[N][Abs][2DuPoss][SgPosd]":["–tek","+tek",".sek"],"[N][Abs][2PlPoss][DuPosd]":["%:(e)gci"],"[N][Abs][2PlPoss][PlPosd]":["–ci"],"[N][Abs][2PlPoss][SgPosd]":["–ci","+ci",".si"],"[N][Abs][2SgPoss][DuPosd]":["%:(e)gken"],"[N][Abs][2SgPoss][PlPosd]":["–ten"],"[N][Abs][2SgPoss][SgPosd]":["%:(e)n"],"[N][Abs][3DuPoss][DuPosd]":["%:(e)gkek"],"[N][Abs][3DuPoss][PlPosd]":["–kek"],"[N][Abs][3DuPoss][SgPosd]":[":(ng)ak"],"[N][Abs][3PlPoss][DuPosd]":["%:(e)gket"],"[N][Abs][3PlPoss][PlPosd]":[":(ng)it"],"[N][Abs][3PlPoss][SgPosd]":[":(ng)at"],"[N][Abs][3SgPoss][DuPosd]":["%:(e)k"],"[N][Abs][3SgPoss][PlPosd]":[":(ng)i"],"[N][Abs][3SgPoss][SgPosd]":[":(ng)a"],"[N][Abs][4DuPoss][DuPosd]":["%:(e)gtek"],"[N][Abs][4DuPoss][PlPosd]":["–tek"],"[N][Abs][4DuPoss][SgPosd]":["–tek","+tek",".sek"],"[N][Abs][4PlPoss][DuPosd]":["%:(e)gteng"],"[N][Abs][4PlPoss][PlPosd]":["–teng"],"[N][Abs][4PlPoss][SgPosd]":["–teng","+teng",".seng"],"[N][Abs][4SgPoss][DuPosd]":["%:(e)gni"],"[N][Abs][4SgPoss][PlPosd]":["–ni"],"[N][Abs][4SgPoss][SgPosd]":["–ni"],"[N][Abs][DuUnpd]":["%:(e)k"],"[N][Abs][PlUnpd]":["%:(e)t"],"[N][Abs][SgUnpd]":[""],"[N][Equ][1DuPoss][DuPosd]":["%:(e)gmegtun"],"[N][Equ][1DuPoss][PlPosd]":["–megtun"],"[N][Equ][1DuPoss][SgPosd]":["–megtun"],"[N][Equ][1PlPoss][DuPosd]":["%:(e)gemcetun"],"[N][Equ][1PlPoss][PlPosd]":["–mcetun"],"[N][Equ][1PlPoss][SgPosd]":["–mcetun"],"[N][Equ][1SgPoss][DuPosd]":["%:(e)gemtun"],"[N][Equ][1SgPoss][PlPosd]":["–mtun"],"[N][Equ][1SgPoss][SgPosd]":["–mtun"],"[N][Equ][2DuPoss][DuPosd]":["%:(e)gpetegtun"],"[N][Equ][2DuPoss][PlPosd]":["–vtegtun",".vtegtun","+petegtun"],"[N][Equ][2DuPoss][SgPosd]":["–vtegtun",".vtegtun","+petegtun"],"[N][Equ][2PlPoss][DuPosd]":["%:(e)gpecetun"],"[N][Equ][2PlPoss][PlPosd]":["–vcetun",".vcetun","+pecetun"],"[N][Equ][2PlPoss][SgPosd]":["–vcetun",".vcetun","+pecetun"],"[N][Equ][2SgPoss][DuPosd]":["%:(e)gpetun"],"[N][Equ][2SgPoss][PlPosd]":["–vtun",".vtun","+petun"],"[N][Equ][2SgPoss][SgPosd]":["–vtun",".vtun","+petun"],"[N][Equ][3DuPoss][DuPosd]":["%:(e)gkegtun"],"[N][Equ][3DuPoss][PlPosd]":["–kegtun"],"[N][Equ][3DuPoss][SgPosd]":[":(ng)agtun"],"[N][Equ][3PlPoss][DuPosd]":["%:(e)gkecetun"],"[N][Equ][3PlPoss][PlPosd]":[":(ng)icetun"],"[N][Equ][3PlPoss][SgPosd]":[":(ng)acetun"],"[N][Equ][3SgPoss][DuPosd]":["%:(e)gketun"],"[N][Equ][3SgPoss][PlPosd]":[":(ng)itun"],"[N][Equ][3SgPoss][SgPosd]":[":(ng)atun"],"[N][Equ][4DuPoss][DuPosd]":["%:(e)gmegtun"],"[N][Equ][4DuPoss][PlPosd]":["–megtun"],"[N][Equ][4DuPoss][SgPosd]":["–megtun"],"[N][Equ][4PlPoss][DuPosd]":["%:(e)gmegcetun"],"[N][Equ][4PlPoss][PlPosd]":["–megcetun"],"[N][Equ][4PlPoss][SgPosd]":["–megcetun"],"[N][Equ][4SgPoss][DuPosd]":["%:(e)gmitun"],"[N][Equ][4SgPoss][PlPosd]":["–mitun"],"[N][Equ][4SgPoss][SgPosd]":["–mitun"],"[N][Equ][DuUnpd]":["%:(e)gtun"],"[N][Equ][PlUnpd]":["%cetun"],"[N][Equ][SgUnpd]":["%tun"],"[N][Loc][1DuPoss][DuPosd]":["%:(e)gmegni"],"[N][Loc][1DuPoss][PlPosd]":["–megni"],"[N][Loc][1DuPoss][SgPosd]":["–megni"],"[N][Loc][1PlPoss][DuPosd]":["%:(e)gemten̄i"],"[N][Loc][1PlPoss][PlPosd]":["–mten̄i"],"[N][Loc][1PlPoss][SgPosd]":["–mten̄i"],"[N][Loc][1SgPoss][DuPosd]":["%:(e)gemni"],"[N][Loc][1SgPoss][PlPosd]":["–mni"],"[N][Loc][1SgPoss][SgPosd]":["–mni"],"[N][Loc][2DuPoss][DuPosd]":["%:(e)gpetegni"],"[N][Loc][2DuPoss][PlPosd]":["–vtegni",".vtegni","+petegni"],"[N][Loc][2DuPoss][SgPosd]":["–vtegni",".vtegni","+petegni"],"[N][Loc][2PlPoss][DuPosd]":["%:(e)gpecini","%:(e)gpecen̄i"],"[N][Loc][2PlPoss][PlPosd]":["–vcini","–vcen̄i",".vcini",".vcen̄i","+pecini","+pecen̄i"],"[N][Loc][2PlPoss][SgPosd]":["–vcini","–vcen̄i",".vcini",".vcen̄i","+pecini","+pecen̄i"],"[N][Loc][2SgPoss][DuPosd]":["%:(e)gpeni"],"[N][Loc][2SgPoss][PlPosd]":["–vni",".vni","+peni"],"[N][Loc][2SgPoss][SgPosd]":["–vni",".vni","+peni"],"[N][Loc][3DuPoss][DuPosd]":["%:(e)gkegni"],"[N][Loc][3DuPoss][PlPosd]":["–kegni"],"[N][Loc][3DuPoss][SgPosd]":[":(ng)agni"],"[N][Loc][3PlPoss][DuPosd]":["%:(e)gketni"],"[N][Loc][3PlPoss][PlPosd]":[":(ng)itni"],"[N][Loc][3PlPoss][SgPosd]":[":(ng)atni"],"[N][Loc][3SgPoss][DuPosd]":["%:(e)gkeni"],"[N][Loc][3SgPoss][PlPosd]":[":(ng)ini"],"[N][Loc][3SgPoss][SgPosd]":[":(ng)ani"],"[N][Loc][4DuPoss][DuPosd]":["%:(e)gmegni"],"[N][Loc][4DuPoss][PlPosd]":["–megni"],"[N][Loc][4DuPoss][SgPosd]":["–megni"],"[N][Loc][4PlPoss][DuPosd]":["%:(e)gmeggni"],"[N][Loc][4PlPoss][PlPosd]":["–meggni"],"[N][Loc][4PlPoss][SgPosd]":["–meggni"],"[N][Loc][4SgPoss][DuPosd]":["%:(e)gmini"],"[N][Loc][4SgPoss][PlPosd]":["–mini"],"[N][Loc][4SgPoss][SgPosd]":["–mini"],"[N][Loc][DuUnpd]":["%:(e)gni"],"[N][Loc][PlUnpd]":["%~ni"],"[N][Loc][SgUnpd]":["%~mi"],"[N][Rel][1DuPoss][DuPosd]":["%:(e)gmegnuk"],"[N][Rel][1DuPoss][PlPosd]":["–megnuk","–mnuk"],"[N][Rel][1DuPoss][SgPosd]":["–megnuk","–mnuk"],"[N][Rel][1PlPoss][DuPosd]":["%:(e)gemta"],"[N][Rel][1PlPoss][PlPosd]":["–mta"],"[N][Rel][1PlPoss][SgPosd]":["–mta"],"[N][Rel][1SgPoss][DuPosd]":["%:(e)gma"],"[N][Rel][1SgPoss][PlPosd]":["–ma"],"[N][Rel][1SgPoss][SgPosd]":["–ma"],"[N][Rel][2DuPoss][DuPosd]":["%:(e)gpetek"],"[N][Rel][2DuPoss][PlPosd]":["–vtek",".vtek","+petek"],"[N][Rel][2DuPoss][SgPosd]":["–vtek",".vtek","+petek"],"[N][Rel][2PlPoss][DuPosd]":["%:(e)gpeci"],"[N][Rel][2PlPoss][PlPosd]":["–vci",".vci","+peci"],"[N][Rel][2PlPoss][SgPosd]":["–vci",".vci","+peci"],"[N][Rel][2SgPoss][DuPosd]":["%:(e)gpet"],"[N][Rel][2SgPoss][PlPosd]":["–vet",".vet","+pet"],"[N][Rel][2SgPoss][SgPosd]":["–vet",".vet","+pet"],"[N][Rel][3DuPoss][DuPosd]":["%:(e)gkenka"],"[N][Rel][3DuPoss][PlPosd]":["–kenka"],"[N][Rel][3DuPoss][SgPosd]":[":(ng)agnek"],"[N][Rel][3PlPoss][DuPosd]":["%:(e)gketa"],"[N][Rel][3PlPoss][PlPosd]":[":(ng)ita"],"[N][Rel][3PlPoss][SgPosd]":[":(ng)ata"],"[N][Rel][3SgPoss][DuPosd]":["%:(e)gken"],"[N][Rel][3SgPoss][PlPosd]":[":(ng)in"],"[N][Rel][3SgPoss][SgPosd]":[":(ng)an"],"[N][Rel][4DuPoss][DuPosd]":["%:(e)gmek"],"[N][Rel][4DuPoss][PlPosd]":["–mek"],"[N][Rel][4DuPoss][SgPosd]":["–mek"],"[N][Rel][4PlPoss][DuPosd]":["%:(e)gmeng"],"[N][Rel][4PlPoss][PlPosd]":["–megta","–megteng","–meng"],"[N][Rel][4PlPoss][SgPosd]":["–megta","–megteng","–meng"],"[N][Rel][4SgPoss][DuPosd]":["%:(e)gmi"],"[N][Rel][4SgPoss][PlPosd]":["–mi"],"[N][Rel][4SgPoss][SgPosd]":["–mi"],"[N][Rel][DuUnpd]":["%:(e)k"],"[N][Rel][PlUnpd]":["%:(e)t"],"[N][Rel][SgUnpd]":["%:(e)m"],"[N][Ter][1DuPoss][DuPosd]":["%:(e)gmegnun"],"[N][Ter][1DuPoss][PlPosd]":["–megnun"],"[N][Ter][1DuPoss][SgPosd]":["–megnun"],"[N][Ter][1PlPoss][DuPosd]":["%:(e)gemten̄un"],"[N][Ter][1PlPoss][PlPosd]":["–mten̄un"],"[N][Ter][1PlPoss][SgPosd]":["–mten̄un"],"[N][Ter][1SgPoss][DuPosd]":["%:(e)gemnun"],"[N][Ter][1SgPoss][PlPosd]":["–mnun"],"[N][Ter][1SgPoss][SgPosd]":["–mnun"],"[N][Ter][2DuPoss][DuPosd]":["%:(e)gpetegnun"],"[N][Ter][2DuPoss][PlPosd]":["–vtegnun",".vtegnun","+petegnun"],"[N][Ter][2DuPoss][SgPosd]":["–vtegnun",".vtegnun","+petegnun"],"[N][Ter][2PlPoss][DuPosd]":["%:(e)gpecinun","%:(e)gpecen̄un"],"[N][Ter][2PlPoss][PlPosd]":["–vcinun","–vcen̄un",".vcinun",".vcen̄un","+pecinun","+pecen̄un"],"[N][Ter][2PlPoss][SgPosd]":["–vcinun","–vcen̄un",".vcinun",".vcen̄un","+pecinun","+pecen̄un"],"[N][Ter][2SgPoss][DuPosd]":["%:(e)gpenun"],"[N][Ter][2SgPoss][PlPosd]":["–vnun",".vnun","+penun"],"[N][Ter][2SgPoss][SgPosd]":["–vnun",".vnun","+penun"],"[N][Ter][3DuPoss][DuPosd]":["%:(e)gkegnun"],"[N][Ter][3DuPoss][PlPosd]":["–kegnun"],"[N][Ter][3DuPoss][SgPosd]":[":(ng)agnun"],"[N][Ter][3PlPoss][DuPosd]":["%:(e)gketnun"],"[N][Ter][3PlPoss][PlPosd]":[":(ng)itnun"],"[N][Ter][3PlPoss][SgPosd]":[":(ng)atnun"],"[N][Ter][3SgPoss][DuPosd]":["%:(e)gkenun"],"[N][Ter][3SgPoss][PlPosd]":[":(ng)inun"],"[N][Ter][3SgPoss][SgPosd]":[":(ng)anun"],"[N][Ter][4DuPoss][DuPosd]":["%:(e)gmegnun"],"[N][Ter][4DuPoss][PlPosd]":["–megnun"],"[N][Ter][4DuPoss][SgPosd]":["–megnun"],"[N][Ter][4PlPoss][DuPosd]":["%:(e)gmeggnun"],"[N][Ter][4PlPoss][PlPosd]":["–meggnun"],"[N][Ter][4PlPoss][SgPosd]":["–meggnun"],"[N][Ter][4SgPoss][DuPosd]":["%:(e)gminun"],"[N][Ter][4SgPoss][PlPosd]":["–minun"],"[N][Ter][4SgPoss][SgPosd]":["–minun"],"[N][Ter][DuUnpd]":["%:(e)gnun"],"[N][Ter][PlUnpd]":["%~nun"],"[N][Ter][SgUnpd]":["%~mun"],"[N][Via][1DuPoss][DuPosd]":["%:(e)gmegnegun"],"[N][Via][1DuPoss][PlPosd]":["–megnegun"],"[N][Via][1DuPoss][SgPosd]":["–megnegun"],"[N][Via][1PlPoss][DuPosd]":["%:(e)gemteggun"],"[N][Via][1PlPoss][PlPosd]":["–mteggun"],"[N][Via][1PlPoss][SgPosd]":["–mteggun"],"[N][Via][1SgPoss][DuPosd]":["%:(e)gemkun"],"[N][Via][1SgPoss][PlPosd]":["–mkun"],"[N][Via][1SgPoss][SgPosd]":["–mkun"],"[N][Via][2DuPoss][DuPosd]":["%:(e)gpetegnegun"],"[N][Via][2DuPoss][PlPosd]":["–vtegnegun",".vtegnegun","+petegnegun"],"[N][Via][2DuPoss][SgPosd]":["–vtegnegun",".vtegnegun","+petegnegun"],"[N][Via][2PlPoss][DuPosd]":["%:(e)gpeciuggun","%:(e)gpecetgun"],"[N][Via][2PlPoss][PlPosd]":["–vciuggun","–vcetgun",".vciuggun",".vcetgun","+peciuggun","+pecetgun"],"[N][Via][2PlPoss][SgPosd]":["–vciuggun","–vcetgun",".vciuggun",".vcetgun","+peciuggun","+pecetgun"],"[N][Via][2SgPoss][DuPosd]":["%:(e)gpegun"],"[N][Via][2SgPoss][PlPosd]":["–vkun","+pegun",".vkun"],"[N][Via][2SgPoss][SgPosd]":["–vkun","+pegun",".vkun"],"[N][Via][3DuPoss][DuPosd]":["%:(e)gkegnegun"],"[N][Via][3DuPoss][PlPosd]":["–kegnegun"],"[N][Via][3DuPoss][SgPosd]":[":(ng)agnegun"],"[N][Via][3PlPoss][DuPosd]":["%:(e)gketgun"],"[N][Via][3PlPoss][PlPosd]":[":(ng)itgun"],"[N][Via][3PlPoss][SgPosd]":[":(ng)atgun"],"[N][Via][3SgPoss][DuPosd]":["%:(e)gkenkun"],"[N][Via][3SgPoss][PlPosd]":[":(ng)ikun"],"[N][Via][3SgPoss][SgPosd]":[":(ng)akun"],"[N][Via][4DuPoss][DuPosd]":["%:(e)gmegnegun"],"[N][Via][4DuPoss][PlPosd]":["–megnegun"],"[N][Via][4DuPoss][SgPosd]":["–megnegun"],"[N][Via][4PlPoss][DuPosd]":["%:(e)gmegteggun"],"[N][Via][4PlPoss][PlPosd]":["–megteggun"],"[N][Via][4PlPoss][SgPosd]":["–megteggun"],"[N][Via][4SgPoss][DuPosd]":["%:(e)gmikun"],"[N][Via][4SgPoss][PlPosd]":["–mikun"],"[N][Via][4SgPoss][SgPosd]":["–mikun"],"[N][Via][DuUnpd]":["%:(e)gkun","%:(e)gnegun"],"[N][Via][PlUnpd]":["%tgun"],"[N][Via][SgUnpd]":["%kun"],"[Quant_Qual][A_1Du]":["–megnuk"],"[Quant_Qual][A_1Pl]":["–mta"],"[Quant_Qual][A_1Sg]":["+ma"],"[Quant_Qual][A_2Du]":[".vtek","+petek"],"[Quant_Qual][A_2Pl]":[".vci","+peci"],"[Quant_Qual][A_2Sg]":[".vet","+pet"],"[Quant_Qual][A_4Du]":["+mek"],"[Quant_Qual][A_4Pl]":["+meng"],"[Quant_Qual][A_4Sg]":["+mi"],"[Quant_Qual][P_1Du]":["–megnuk"],"[Quant_Qual][P_1Pl]":["–mta"],"[Quant_Qual][P_1Sg]":["+ma"],"[Quant_Qual][P_2Du]":[".vtek","+petek"],"[Quant_Qual][P_2Pl]":[".vci","+peci"],"[Quant_Qual][P_2Sg]":[".vet","+pet"],"[Quant_Qual][P_3Du]":["%:(e)gkenka"],"[Quant_Qual][P_3Pl]":[":(ng)ita"],"[Quant_Qual][P_3Sg]":[":(ng)an"],"[Quant_Qual][S_1Du]":["–megnuk"],"[Quant_Qual][S_1Pl]":["–mta"],"[Quant_Qual][S_1Sg]":["+ma"],"[Quant_Qual][S_2Du]":[".vtek","+petek"],"[Quant_Qual][S_2Pl]":[".vci","+peci"],"[Quant_Qual][S_2Sg]":[".vet","+pet"],"[Quant_Qual][S_4Du]":["+mek"],"[Quant_Qual][S_4Pl]":["+meng"],"[Quant_Qual][S_4Sg]":["+mi"],"[Rel][DuUnpd]":[".k"],"[Rel][PlUnpd]":[".t"],"[Rel][SgUnpd]":[".m"],"[Sec_Ter]":[".tmun"],"[Ter]":[".vet"],"[Ter][DuUnpd]":[".gnun"],"[Ter][PlUnpd]":[".nun"],"[Ter][SgUnpd]":[".mun"],"[V][Cnsq][Intr][S_1Du]":["@%:~(ng)a–megnuk","@~+nga–megnuk"],"[V][Cnsq][Intr][S_1Pl]":["@%:~(ng)a–mta","@~+nga–mta"],"[V][Cnsq][Intr][S_1Sg]":["@%:~(ng)a+ma","@~+nga+ma"],"[V][Cnsq][Intr][S_2Du]":["@%:~(ng)a.vtek","@~+nga.vtek"],"[V][Cnsq][Intr][S_2Pl]":["@%:~(ng)a.veci","@~+nga.veci"],"[V][Cnsq][Intr][S_2Sg]":["@%:~(ng)a.vet","@~+nga.vet"],"[V][Cnsq][Intr][S_3Du]":["@%:~(ng)a:agnek","@~+nga:agnek"],"[V][Cnsq][Intr][S_3Pl]":["@%:~(ng)a:ata","@~+nga:ata"],"[V][Cnsq][Intr][S_3Sg]":["@%:~(ng)a:an","@~+nga:an"],"[V][Cnsq][Intr][S_4Du]":["@%:~(ng)a+mek","@~+nga+mek"],"[V][Cnsq][Intr][S_4Pl]":["@%:~(ng)a+meng","@~+nga+meng"],"[V][Cnsq][Intr][S_4Sg]":["@%:~(ng)a+mi","@~+nga+mi"],"[V][Cnsq][Trns][A_1Du][P_2Du]":["@%:~(ng)a–megtek","@~+nga–megtek"],"[V][Cnsq][Trns][A_1Du][P_2Pl]":["@%:~(ng)a–megci","@~+nga–megci"],"[V][Cnsq][Trns][A_1Du][P_2Sg]":["@%:~(ng)a–megten","@~+nga–megten"],"[V][Cnsq][Trns][A_1Du][P_3Du]":["@%:~(ng)a–megkek","@~+nga–megkek"],"[V][Cnsq][Trns][A_1Du][P_3Pl]":["@%:~(ng)a–megki","@~+nga–megki"],"[V][Cnsq][Trns][A_1Du][P_3Sg]":["@%:~(ng)a–megnegu","@~+nga–megnegu"],"[V][Cnsq][Trns][A_1Du][P_4Du]":["@%:~(ng)a–megtek","@~+nga–megtek"],"[V][Cnsq][Trns][A_1Du][P_4Pl]":["@%:~(ng)a–megteng","@~+nga–megteng"],"[V][Cnsq][Trns][A_1Du][P_4Sg]":["@%:~(ng)a–megni","@~+nga–megni"],"[V][Cnsq][Trns][A_1Pl][P_2Du]":["@%:~(ng)a–mcetek","@~+nga–mcetek"],"[V][Cnsq][Trns][A_1Pl][P_2Pl]":["@%:~(ng)a–mceci","@~+nga–mceci"],"[V][Cnsq][Trns][A_1Pl][P_2Sg]":["@%:~(ng)a–mteggen","@~+nga–mteggen"],"[V][Cnsq][Trns][A_1Pl][P_3Du]":["@%:~(ng)a–mtekek","@~+nga–mtekek"],"[V][Cnsq][Trns][A_1Pl][P_3Pl]":["@%:~(ng)a–mteki","@~+nga–mteki"],"[V][Cnsq][Trns][A_1Pl][P_3Sg]":["@%:~(ng)a–mteggu","@~+nga–mteggu"],"[V][Cnsq][Trns][A_1Pl][P_4Du]":["@%:~(ng)a–mcetek","@~+nga–mcetek"],"[V][Cnsq][Trns][A_1Pl][P_4Pl]":["@%:~(ng)a–mceteng","@~+nga–mceteng"],"[V][Cnsq][Trns][A_1Pl][P_4Sg]":["@%:~(ng)a–mten̄i","@~+nga–mten̄i"],"[V][Cnsq][Trns][A_1Sg][P_2Du]":["@%:~(ng)a–mtek","@~+nga–mtek"],"[V][Cnsq][Trns][A_1Sg][P_2Pl]":["@%:~(ng)a–mci","@~+nga–mci"],"[V][Cnsq][Trns][A_1Sg][P_2Sg]":["@%:~(ng)a–mken","@~+nga–mken"],"[V][Cnsq][Trns][A_1Sg][P_3Du]":["@%:~(ng)a–mkek","@~+nga–mkek"],"[V][Cnsq][Trns][A_1Sg][P_3Pl]":["@%:~(ng)a–mki","@~+nga–mki"],"[V][Cnsq][Trns][A_1Sg][P_3Sg]":["@%:~(ng)a–mku","@~+nga–mku"],"[V][Cnsq][Trns][A_1Sg][P_4Du]":["@%:~(ng)a–mtek","@~+nga–mtek"],"[V][Cnsq][Trns][A_1Sg][P_4Pl]":["@%:~(ng)a–mteng","@~+nga–mteng"],"[V][Cnsq][Trns][A_1Sg][P_4Sg]":["@%:~(ng)a–mni","@~+nga–mni"],"[V][Cnsq][Trns][A_2Du][P_1Du]":["@%:~(ng)a.vtegkuk","@~+nga.vtegkuk"],"[V][Cnsq][Trns][A_2Du][P_1Pl]":["@%:~(ng)a.vtegkut","@~+nga.vtegkut"],"[V][Cnsq][Trns][A_2Du][P_1Sg]":["@%:~(ng)a.vtegnga","@~+nga.vtegnga"],"[V][Cnsq][Trns][A_2Du][P_3Du]":["@%:~(ng)a.vtegkek","@~+nga.vtegkek"],"[V][Cnsq][Trns][A_2Du][P_3Pl]":["@%:~(ng)a.vtegki","@~+nga.vtegki"],"[V][Cnsq][Trns][A_2Du][P_3Sg]":["@%:~(ng)a.vtegnegu","@~+nga.vtegnegu"],"[V][Cnsq][Trns][A_2Du][P_4Du]":["@%:~(ng)a.vtegtek","@~+nga.vtegtek"],"[V][Cnsq][Trns][A_2Du][P_4Pl]":["@%:~(ng)a.vtegteng","@~+nga.vtegteng"],"[V][Cnsq][Trns][A_2Du][P_4Sg]":["@%:~(ng)a.vtegni","@~+nga.vtegni"],"[V][Cnsq][Trns][A_2Pl][P_1Du]":["@%:~(ng)a.vcikuk","@~+nga.vcikuk"],"[V][Cnsq][Trns][A_2Pl][P_1Pl]":["@%:~(ng)a.vcikut","@~+nga.vcikut"],"[V][Cnsq][Trns][A_2Pl][P_1Sg]":["@%:~(ng)a.vcia","@~+nga.vcia"],"[V][Cnsq][Trns][A_2Pl][P_3Du]":["@%:~(ng)a.vcikek","@~+nga.vcikek"],"[V][Cnsq][Trns][A_2Pl][P_3Pl]":["@%:~(ng)a.vciki","@~+nga.vciki"],"[V][Cnsq][Trns][A_2Pl][P_3Sg]":["@%:~(ng)a.vciu","@~+nga.vciu"],"[V][Cnsq][Trns][A_2Pl][P_4Du]":["@%:~(ng)a.vcitek","@~+nga.vcitek"],"[V][Cnsq][Trns][A_2Pl][P_4Pl]":["@%:~(ng)a.vciteng","@~+nga.vciteng"],"[V][Cnsq][Trns][A_2Pl][P_4Sg]":["@%:~(ng)a.vcini","@~+nga.vcini"],"[V][Cnsq][Trns][A_2Sg][P_1Du]":["@%:~(ng)a.vkuk","@~+nga.vkuk"],"[V][Cnsq][Trns][A_2Sg][P_1Pl]":["@%:~(ng)a.vkut","@~+nga.vkut"],"[V][Cnsq][Trns][A_2Sg][P_1Sg]":["@%:~(ng)a.vnga","@~+nga.vnga"],"[V][Cnsq][Trns][A_2Sg][P_3Du]":["@%:~(ng)a.vkek","@~+nga.vkek"],"[V][Cnsq][Trns][A_2Sg][P_3Pl]":["@%:~(ng)a.vki","@~+nga.vki"],"[V][Cnsq][Trns][A_2Sg][P_3Sg]":["@%:~(ng)a.vgu","@~+nga.vgu"],"[V][Cnsq][Trns][A_2Sg][P_4Du]":["@%:~(ng)a.vtek","@~+nga.vtek"],"[V][Cnsq][Trns][A_2Sg][P_4Pl]":["@%:~(ng)a.vteng","@~+nga.vteng"],"[V][Cnsq][Trns][A_2Sg][P_4Sg]":["@%:~(ng)a.vni","@~+nga.vni"],"[V][Cnsq][Trns][A_3Du][P_1Du]":["@%:~(ng)a:agkuk","@~+nga:agkuk"],"[V][Cnsq][Trns][A_3Du][P_1Pl]":["@%:~(ng)a:agkut","@~+nga:agkut"],"[V][Cnsq][Trns][A_3Du][P_1Sg]":["@%:~(ng)a:agnga","@~+nga:agnga"],"[V][Cnsq][Trns][A_3Du][P_2Du]":["@%:~(ng)a:agtek","@~+nga:agtek"],"[V][Cnsq][Trns][A_3Du][P_2Pl]":["@%:~(ng)a:agci","@~+nga:agci"],"[V][Cnsq][Trns][A_3Du][P_2Sg]":["@%:~(ng)a:agten","@~+nga:agten"],"[V][Cnsq][Trns][A_3Du][P_3Du]":["@%:~(ng)a:agkek","@~+nga:agkek"],"[V][Cnsq][Trns][A_3Du][P_3Pl]":["@%:~(ng)a:agki","@~+nga:agki"],"[V][Cnsq][Trns][A_3Du][P_3Sg]":["@%:~(ng)a:agnegu","@~+nga:agnegu"],"[V][Cnsq][Trns][A_3Du][P_4Du]":["@%:~(ng)a:agtek","@~+nga:agtek"],"[V][Cnsq][Trns][A_3Du][P_4Pl]":["@%:~(ng)a:agteng","@~+nga:agteng"],"[V][Cnsq][Trns][A_3Du][P_4Sg]":["@%:~(ng)a:agni","@~+nga:agni"],"[V][Cnsq][Trns][A_3Pl][P_1Du]":["@%:~(ng)a:atkuk","@~+nga:atkuk"],"[V][Cnsq][Trns][A_3Pl][P_1Pl]":["@%:~(ng)a:atkut","@~+nga:atkut"],"[V][Cnsq][Trns][A_3Pl][P_1Sg]":["@%:~(ng)a:atnga","@~+nga:atnga"],"[V][Cnsq][Trns][A_3Pl][P_2Du]":["@%:~(ng)a:acetek","@~+nga:acetek"],"[V][Cnsq][Trns][A_3Pl][P_2Pl]":["@%:~(ng)a:aceci","@~+nga:aceci"],"[V][Cnsq][Trns][A_3Pl][P_2Sg]":["@%:~(ng)a:atgen","@~+nga:atgen"],"[V][Cnsq][Trns][A_3Pl][P_3Du]":["@%:~(ng)a:atkek","@~+nga:atkek"],"[V][Cnsq][Trns][A_3Pl][P_3Pl]":["@%:~(ng)a:atki","@~+nga:atki"],"[V][Cnsq][Trns][A_3Pl][P_3Sg]":["@%:~(ng)a:atgu","@~+nga:atgu"],"[V][Cnsq][Trns][A_3Pl][P_4Du]":["@%:~(ng)a:acetek","@~+nga:acetek"],"[V][Cnsq][Trns][A_3Pl][P_4Pl]":["@%:~(ng)a:aceteng","@~+nga:aceteng"],"[V][Cnsq][Trns][A_3Pl][P_4Sg]":["@%:~(ng)a:atni","@~+nga:atni"],"[V][Cnsq][Trns][A_3Sg][P_1Du]":["@%:~(ng)a:akuk","@~+nga:akuk"],"[V][Cnsq][Trns][A_3Sg][P_1Pl]":["@%:~(ng)a:akut","@~+nga:akut"],"[V][Cnsq][Trns][A_3Sg][P_1Sg]":["@%:~(ng)a:anga","@~+nga:anga"],"[V][Cnsq][Trns][A_3Sg][P_2Du]":["@%:~(ng)a:atek","@~+nga:atek"],"[V][Cnsq][Trns][A_3Sg][P_2Pl]":["@%:~(ng)a:aci","@~+nga:aci"],"[V][Cnsq][Trns][A_3Sg][P_2Sg]":["@%:~(ng)a:aten","@~+nga:aten"],"[V][Cnsq][Trns][A_3Sg][P_3Du]":["@%:~(ng)a:akek","@~+nga:akek"],"[V][Cnsq][Trns][A_3Sg][P_3Pl]":["@%:~(ng)a:aki","@~+nga:aki"],"[V][Cnsq][Trns][A_3Sg][P_3Sg]":["@%:~(ng)a:aku","@~+nga:aku"],"[V][Cnsq][Trns][A_3Sg][P_4Du]":["@%:~(ng)a:atek","@~+nga:atek"],"[V][Cnsq][Trns][A_3Sg][P_4Pl]":["@%:~(ng)a:ateng","@~+nga:ateng"],"[V][Cnsq][Trns][A_3Sg][P_4Sg]":["@%:~(ng)a:ani","@~+nga:ani"],"[V][Cnsq][Trns][A_4Du][P_1Du]":["@%:~(ng)a+megnekuk","@~+nga+megnekuk"],"[V][Cnsq][Trns][A_4Du][P_1Pl]":["@%:~(ng)a+megnekut","@~+nga+megnekut"],"[V][Cnsq][Trns][A_4Du][P_1Sg]":["@%:~(ng)a+megnenga","@~+nga+megnenga"],"[V][Cnsq][Trns][A_4Du][P_2Du]":["@%:~(ng)a+megnetek","@~+nga+megnetek"],"[V][Cnsq][Trns][A_4Du][P_2Pl]":["@%:~(ng)a+megneci","@~+nga+megneci"],"[V][Cnsq][Trns][A_4Du][P_2Sg]":["@%:~(ng)a+megnegen","@~+nga+megnegen"],"[V][Cnsq][Trns][A_4Du][P_3Du]":["@%:~(ng)a+megnekek","@~+nga+megnekek"],"[V][Cnsq][Trns][A_4Du][P_3Pl]":["@%:~(ng)a+megneki","@~+nga+megneki"],"[V][Cnsq][Trns][A_4Du][P_3Sg]":["@%:~(ng)a+megnegu","@~+nga+megnegu"],"[V][Cnsq][Trns][A_4Pl][P_1Du]":["@%:~(ng)a+megtekuk","@~+nga+megtekuk"],"[V][Cnsq][Trns][A_4Pl][P_1Pl]":["@%:~(ng)a+megtekut","@~+nga+megtekut"],"[V][Cnsq][Trns][A_4Pl][P_1Sg]":["@%:~(ng)a+megtenga","@~+nga+megtenga"],"[V][Cnsq][Trns][A_4Pl][P_2Du]":["@%:~(ng)a+megcetek","@~+nga+megcetek"],"[V][Cnsq][Trns][A_4Pl][P_2Pl]":["@%:~(ng)a+megceci","@~+nga+megceci"],"[V][Cnsq][Trns][A_4Pl][P_2Sg]":["@%:~(ng)a+megteggen","@~+nga+megteggen"],"[V][Cnsq][Trns][A_4Pl][P_3Du]":["@%:~(ng)a+megtekek","@~+nga+megtekek"],"[V][Cnsq][Trns][A_4Pl][P_3Pl]":["@%:~(ng)a+megteki","@~+nga+megteki"],"[V][Cnsq][Trns][A_4Pl][P_3Sg]":["@%:~(ng)a+megteggu","@~+nga+megteggu"],"[V][Cnsq][Trns][A_4Sg][P_1Du]":["@%:~(ng)a+mikuk","@~+nga+mikuk"],"[V][Cnsq][Trns][A_4Sg][P_1Pl]":["@%:~(ng)a+mikut","@~+nga+mikut"],"[V][Cnsq][Trns][A_4Sg][P_1Sg]":["@%:~(ng)a+mia","@~+nga+mia"],"[V][Cnsq][Trns][A_4Sg][P_2Du]":["@%:~(ng)a+mitek","@~+nga+mitek"],"[V][Cnsq][Trns][A_4Sg][P_2Pl]":["@%:~(ng)a+mici","@~+nga+mici"],"[V][Cnsq][Trns][A_4Sg][P_2Sg]":["@%:~(ng)a+miten","@~+nga+miten"],"[V][Cnsq][Trns][A_4Sg][P_3Du]":["@%:~(ng)a+mikek","@~+nga+mikek"],"[V][Cnsq][Trns][A_4Sg][P_3Pl]":["@%:~(ng)a+miki","@~+nga+miki"],"[V][Cnsq][Trns][A_4Sg][P_3Sg]":["@%:~(ng)a+miu","@~+nga+miu"],"[V][Conc][Intr][S_1Du]":["@–ngrar–megnuk"],"[V][Conc][Intr][S_1Pl]":["@–ngrar–mta"],"[V][Conc][Intr][S_1Sg]":["@–nger+ma"],"[V][Conc][Intr][S_2Du]":["@–nger+petek"],"[V][Conc][Intr][S_2Pl]":["@–nger+peci"],"[V][Conc][Intr][S_2Sg]":["@–nger+pet"],"[V][Conc][Intr][S_3Du]":["@–ngrar:agnek"],"[V][Conc][Intr][S_3Pl]":["@–ngrar:ata"],"[V][Conc][Intr][S_3Sg]":["@–ngrar:an"],"[V][Conc][Intr][S_4Du]":["@–nger+mek"],"[V][Conc][Intr][S_4Pl]":["@–nger+meng"],"[V][Conc][Intr][S_4Sg]":["@–nger+mi"],"[V][Conc][Trns][A_1Du][P_2Du]":["@–ngrar–megtek"],"[V][Conc][Trns][A_1Du][P_2Pl]":["@–ngrar–megci"],"[V][Conc][Trns][A_1Du][P_2Sg]":["@–ngrar–megten"],"[V][Conc][Trns][A_1Du][P_3Du]":["@–ngrar–megkek"],"[V][Conc][Trns][A_1Du][P_3Pl]":["@–ngrar–megki"],"[V][Conc][Trns][A_1Du][P_3Sg]":["@–ngrar–megnegu"],"[V][Conc][Trns][A_1Du][P_4Du]":["@–ngrar–megtek"],"[V][Conc][Trns][A_1Du][P_4Pl]":["@–ngrar–megteng"],"[V][Conc][Trns][A_1Du][P_4Sg]":["@–ngrar–megni"],"[V][Conc][Trns][A_1Pl][P_2Du]":["@–ngrar–mcetek"],"[V][Conc][Trns][A_1Pl][P_2Pl]":["@–ngrar–mceci"],"[V][Conc][Trns][A_1Pl][P_2Sg]":["@–ngrar–mteggen"],"[V][Conc][Trns][A_1Pl][P_3Du]":["@–ngrar–mtekek"],"[V][Conc][Trns][A_1Pl][P_3Pl]":["@–ngrar–mteki"],"[V][Conc][Trns][A_1Pl][P_3Sg]":["@–ngrar–mteggu"],"[V][Conc][Trns][A_1Pl][P_4Du]":["@–ngrar–mcetek"],"[V][Conc][Trns][A_1Pl][P_4Pl]":["@–ngrar–mceteng"],"[V][Conc][Trns][A_1Pl][P_4Sg]":["@–ngrar–mten̄i"],"[V][Conc][Trns][A_1Sg][P_2Du]":["@–ngrar–mtek"],"[V][Conc][Trns][A_1Sg][P_2Pl]":["@–ngrar–mci"],"[V][Conc][Trns][A_1Sg][P_2Sg]":["@–ngrar–mken"],"[V][Conc][Trns][A_1Sg][P_3Du]":["@–ngrar–mkek"],"[V][Conc][Trns][A_1Sg][P_3Pl]":["@–ngrar–mki"],"[V][Conc][Trns][A_1Sg][P_3Sg]":["@–ngrar–mku"],"[V][Conc][Trns][A_1Sg][P_4Du]":["@–ngrar–mtek"],"[V][Conc][Trns][A_1Sg][P_4Pl]":["@–ngrar–mteng"],"[V][Conc][Trns][A_1Sg][P_4Sg]":["@–ngrar–mni"],"[V][Conc][Trns][A_2Du][P_1Du]":["@–nger+petegkuk"],"[V][Conc][Trns][A_2Du][P_1Pl]":["@–nger+petegkut"],"[V][Conc][Trns][A_2Du][P_1Sg]":["@–nger+petegnga"],"[V][Conc][Trns][A_2Du][P_3Du]":["@–nger+petegkek"],"[V][Conc][Trns][A_2Du][P_3Pl]":["@–nger+petegki"],"[V][Conc][Trns][A_2Du][P_3Sg]":["@–nger+petegnegu"],"[V][Conc][Trns][A_2Du][P_4Du]":["@–nger+petegtek"],"[V][Conc][Trns][A_2Du][P_4Pl]":["@–nger+petegteng"],"[V][Conc][Trns][A_2Du][P_4Sg]":["@–nger+petegni"],"[V][Conc][Trns][A_2Pl][P_1Du]":["@–nger+pecikuk"],"[V][Conc][Trns][A_2Pl][P_1Pl]":["@–nger+pecikut"],"[V][Conc][Trns][A_2Pl][P_1Sg]":["@–nger+pecia"],"[V][Conc][Trns][A_2Pl][P_3Du]":["@–nger+pecikek"],"[V][Conc][Trns][A_2Pl][P_3Pl]":["@–nger+peciki"],"[V][Conc][Trns][A_2Pl][P_3Sg]":["@–nger+peciu"],"[V][Conc][Trns][A_2Pl][P_4Du]":["@–nger+pecitek"],"[V][Conc][Trns][A_2Pl][P_4Pl]":["@–nger+peciteng"],"[V][Conc][Trns][A_2Pl][P_4Sg]":["@–nger+pecini"],"[V][Conc][Trns][A_2Sg][P_1Du]":["@–nger+pekuk"],"[V][Conc][Trns][A_2Sg][P_1Pl]":["@–nger+pekut"],"[V][Conc][Trns][A_2Sg][P_1Sg]":["@–nger+penga"],"[V][Conc][Trns][A_2Sg][P_3Du]":["@–nger+pekek"],"[V][Conc][Trns][A_2Sg][P_3Pl]":["@–nger+peki"],"[V][Conc][Trns][A_2Sg][P_3Sg]":["@–nger+pegu"],"[V][Conc][Trns][A_2Sg][P_4Du]":["@–nger+petek"],"[V][Conc][Trns][A_2Sg][P_4Pl]":["@–nger+peteng"],"[V][Conc][Trns][A_2Sg][P_4Sg]":["@–nger+peni"],"[V][Conc][Trns][A_3Du][P_1Du]":["@–ngrar:agkuk"],"[V][Conc][Trns][A_3Du][P_1Pl]":["@–ngrar:agkut"],"[V][Conc][Trns][A_3Du][P_1Sg]":["@–ngrar:agnga"],"[V][Conc][Trns][A_3Du][P_2Du]":["@–ngrar:agtek"],"[V][Conc][Trns][A_3Du][P_2Pl]":["@–ngrar:agci"],"[V][Conc][Trns][A_3Du][P_2Sg]":["@–ngrar:agten"],"[V][Conc][Trns][A_3Du][P_3Du]":["@–ngrar:agkek"],"[V][Conc][Trns][A_3Du][P_3Pl]":["@–ngrar:agki"],"[V][Conc][Trns][A_3Du][P_3Sg]":["@–ngrar:agnegu"],"[V][Conc][Trns][A_3Du][P_4Du]":["@–ngrar:agtek"],"[V][Conc][Trns][A_3Du][P_4Pl]":["@–ngrar:agteng"],"[V][Conc][Trns][A_3Du][P_4Sg]":["@–ngrar:agni"],"[V][Conc][Trns][A_3Pl][P_1Du]":["@–ngrar:atkuk"],"[V][Conc][Trns][A_3Pl][P_1Pl]":["@–ngrar:atkut"],"[V][Conc][Trns][A_3Pl][P_1Sg]":["@–ngrar:atnga"],"[V][Conc][Trns][A_3Pl][P_2Du]":["@–ngrar:acetek"],"[V][Conc][Trns][A_3Pl][P_2Pl]":["@–ngrar:aceci"],"[V][Conc][Trns][A_3Pl][P_2Sg]":["@–ngrar:atgen"],"[V][Conc][Trns][A_3Pl][P_3Du]":["@–ngrar:atkek"],"[V][Conc][Trns][A_3Pl][P_3Pl]":["@–ngrar:atki"],"[V][Conc][Trns][A_3Pl][P_3Sg]":["@–ngrar:atgu"],"[V][Conc][Trns][A_3Pl][P_4Du]":["@–ngrar:acetek"],"[V][Conc][Trns][A_3Pl][P_4Pl]":["@–ngrar:aceteng"],"[V][Conc][Trns][A_3Pl][P_4Sg]":["@–ngrar:atni"],"[V][Conc][Trns][A_3Sg][P_1Du]":["@–ngrar:akuk"],"[V][Conc][Trns][A_3Sg][P_1Pl]":["@–ngrar:akut"],"[V][Conc][Trns][A_3Sg][P_1Sg]":["@–ngrar:anga"],"[V][Conc][Trns][A_3Sg][P_2Du]":["@–ngrar:atek"],"[V][Conc][Trns][A_3Sg][P_2Pl]":["@–ngrar:aci"],"[V][Conc][Trns][A_3Sg][P_2Sg]":["@–ngrar:aten"],"[V][Conc][Trns][A_3Sg][P_3Du]":["@–ngrar:akek"],"[V][Conc][Trns][A_3Sg][P_3Pl]":["@–ngrar:aki"],"[V][Conc][Trns][A_3Sg][P_3Sg]":["@–ngrar:aku"],"[V][Conc][Trns][A_3Sg][P_4Du]":["@–ngrar:atek"],"[V][Conc][Trns][A_3Sg][P_4Pl]":["@–ngrar:ateng"],"[V][Conc][Trns][A_3Sg][P_4Sg]":["@–ngrar:ani"],"[V][Conc][Trns][A_4Du][P_1Du]":["@–nger+megnekuk"],"[V][Conc][Trns][A_4Du][P_1Pl]":["@–nger+megnekut"],"[V][Conc][Trns][A_4Du][P_1Sg]":["@–nger+megnenga"],"[V][Conc][Trns][A_4Du][P_2Du]":["@–nger+megnetek"],"[V][Conc][Trns][A_4Du][P_2Pl]":["@–nger+megneci"],"[V][Conc][Trns][A_4Du][P_2Sg]":["@–nger+megnegen"],"[V][Conc][Trns][A_4Du][P_3Du]":["@–nger+megnekek"],"[V][Conc][Trns][A_4Du][P_3Pl]":["@–nger+megneki"],"[V][Conc][Trns][A_4Du][P_3Sg]":["@–nger+megnegu"],"[V][Conc][Trns][A_4Pl][P_1Du]":["@–nger+megtekuk"],"[V][Conc][Trns][A_4Pl][P_1Pl]":["@–nger+megtekut"],"[V][Conc][Trns][A_4Pl][P_1Sg]":["@–nger+megtenga"],"[V][Conc][Trns][A_4Pl][P_2Du]":["@–nger+megcetek"],"[V][Conc][Trns][A_4Pl][P_2Pl]":["@–nger+megceci"],"[V][Conc][Trns][A_4Pl][P_2Sg]":["@–nger+megteggen"],"[V][Conc][Trns][A_4Pl][P_3Du]":["@–nger+megtekek"],"[V][Conc][Trns][A_4Pl][P_3Pl]":["@–nger+megteki"],"[V][Conc][Trns][A_4Pl][P_3Sg]":["@–nger+megteggu"],"[V][Conc][Trns][A_4Sg][P_1Du]":["@–nger+mikuk"],"[V][Conc][Trns][A_4Sg][P_1Pl]":["@–nger+mikut"],"[V][Conc][Trns][A_4Sg][P_1Sg]":["@–nger+mia"],"[V][Conc][Trns][A_4Sg][P_2Du]":["@–nger+mitek"],"[V][Conc][Trns][A_4Sg][P_2Pl]":["@–nger+mici"],"[V][Conc][Trns][A_4Sg][P_2Sg]":["@–nger+miten"],"[V][Conc][Trns][A_4Sg][P_3Du]":["@–nger+mikek"],"[V][Conc][Trns][A_4Sg][P_3Pl]":["@–nger+miki"],"[V][Conc][Trns][A_4Sg][P_3Sg]":["@–nger+miu"],"[V][Cond][Intr][S_1Du]":["@~–ku–megnuk"],"[V][Cond][Intr][S_1Pl]":["@~–ku–mta"],"[V][Cond][Intr][S_1Sg]":["@~–ku+ma"],"[V][Cond][Intr][S_2Du]":["@~–ku.vtek"],"[V][Cond][Intr][S_2Pl]":["@~–ku.veci"],"[V][Cond][Intr][S_2Sg]":["@~–ku.vet"],"[V][Cond][Intr][S_3Du]":["@~–ku:agnek"],"[V][Cond][Intr][S_3Pl]":["@~–ku:ata"],"[V][Cond][Intr][S_3Sg]":["@~–ku:an"],"[V][Cond][Intr][S_4Du]":["@~–ku+nek"],"[V][Cond][Intr][S_4Pl]":["@~–ku+neng"],"[V][Cond][Intr][S_4Sg]":["@~–ku+ni"],"[V][Cond][Trns][A_1Du][P_2Du]":["@~–ku–megtek"],"[V][Cond][Trns][A_1Du][P_2Pl]":["@~–ku–megci"],"[V][Cond][Trns][A_1Du][P_2Sg]":["@~–ku–megten"],"[V][Cond][Trns][A_1Du][P_3Du]":["@~–ku–megkek"],"[V][Cond][Trns][A_1Du][P_3Pl]":["@~–ku–megki"],"[V][Cond][Trns][A_1Du][P_3Sg]":["@~–ku–megnegu"],"[V][Cond][Trns][A_1Du][P_4Du]":["@~–ku–megtek"],"[V][Cond][Trns][A_1Du][P_4Pl]":["@~–ku–megteng"],"[V][Cond][Trns][A_1Du][P_4Sg]":["@~–ku–megni"],"[V][Cond][Trns][A_1Pl][P_2Du]":["@~–ku–mcetek"],"[V][Cond][Trns][A_1Pl][P_2Pl]":["@~–ku–mceci"],"[V][Cond][Trns][A_1Pl][P_2Sg]":["@~–ku–mteggen"],"[V][Cond][Trns][A_1Pl][P_3Du]":["@~–ku–mtekek"],"[V][Cond][Trns][A_1Pl][P_3Pl]":["@~–ku–mteki"],"[V][Cond][Trns][A_1Pl][P_3Sg]":["@~–ku–mteggu"],"[V][Cond][Trns][A_1Pl][P_4Du]":["@~–ku–mcetek"],"[V][Cond][Trns][A_1Pl][P_4Pl]":["@~–ku–mceteng"],"[V][Cond][Trns][A_1Pl][P_4Sg]":["@~–ku–mten̄i"],"[V][Cond][Trns][A_1Sg][P_2Du]":["@~–ku–mtek"],"[V][Cond][Trns][A_1Sg][P_2Pl]":["@~–ku–mci"],"[V][Cond][Trns][A_1Sg][P_2Sg]":["@~–ku–mken"],"[V][Cond][Trns][A_1Sg][P_3Du]":["@~–ku–mkek"],"[V][Cond][Trns][A_1Sg][P_3Pl]":["@~–ku–mki"],"[V][Cond][Trns][A_1Sg][P_3Sg]":["@~–ku–mku"],"[V][Cond][Trns][A_1Sg][P_4Du]":["@~–ku–mtek"],"[V][Cond][Trns][A_1Sg][P_4Pl]":["@~–ku–mteng"],"[V][Cond][Trns][A_1Sg][P_4Sg]":["@~–ku–mni"],"[V][Cond][Trns][A_2Du][P_1Du]":["@~–ku.vtegkuk"],"[V][Cond][Trns][A_2Du][P_1Pl]":["@~–ku.vtegkut"],"[V][Cond][Trns][A_2Du][P_1Sg]":["@~–ku.vtegnga"],"[V][Cond][Trns][A_2Du][P_3Du]":["@~–ku.vtegkek"],"[V][Cond][Trns][A_2Du][P_3Pl]":["@~–ku.vtegki"],"[V][Cond][Trns][A_2Du][P_3Sg]":["@~–ku.vtegnegu"],"[V][Cond][Trns][A_2Du][P_4Du]":["@~–ku.vtegtek"],"[V][Cond][Trns][A_2Du][P_4Pl]":["@~–ku.vtegteng"],"[V][Cond][Trns][A_2Du][P_4Sg]":["@~–ku.vtegni"],"[V][Cond][Trns][A_2Pl][P_1Du]":["@~–ku.vcikuk"],"[V][Cond][Trns][A_2Pl][P_1Pl]":["@~–ku.vcikut"],"[V][Cond][Trns][A_2Pl][P_1Sg]":["@~–ku.vcia"],"[V][Cond][Trns][A_2Pl][P_3Du]":["@~–ku.vcikek"],"[V][Cond][Trns][A_2Pl][P_3Pl]":["@~–ku.vciki"],"[V][Cond][Trns][A_2Pl][P_3Sg]":["@~–ku.vciu"],"[V][Cond][Trns][A_2Pl][P_4Du]":["@~–ku.vcitek"],"[V][Cond][Trns][A_2Pl][P_4Pl]":["@~–ku.vciteng"],"[V][Cond][Trns][A_2Pl][P_4Sg]":["@~–ku.vcini"],"[V][Cond][Trns][A_2Sg][P_1Du]":["@~–ku.vkuk"],"[V][Cond][Trns][A_2Sg][P_1Pl]":["@~–ku.vkut"],"[V][Cond][Trns][A_2Sg][P_1Sg]":["@~–ku.vnga"],"[V][Cond][Trns][A_2Sg][P_3Du]":["@~–ku.vkek"],"[V][Cond][Trns][A_2Sg][P_3Pl]":["@~–ku.vki"],"[V][Cond][Trns][A_2Sg][P_3Sg]":["@~–ku.vgu"],"[V][Cond][Trns][A_2Sg][P_4Du]":["@~–ku.vtek"],"[V][Cond][Trns][A_2Sg][P_4Pl]":["@~–ku.vteng"],"[V][Cond][Trns][A_2Sg][P_4Sg]":["@~–ku.vni"],"[V][Cond][Trns][A_3Du][P_1Du]":["@~–ku:agkuk"],"[V][Cond][Trns][A_3Du][P_1Pl]":["@~–ku:agkut"],"[V][Cond][Trns][A_3Du][P_1Sg]":["@~–ku:agnga"],"[V][Cond][Trns][A_3Du][P_2Du]":["@~–ku:agtek"],"[V][Cond][Trns][A_3Du][P_2Pl]":["@~–ku:agci"],"[V][Cond][Trns][A_3Du][P_2Sg]":["@~–ku:agten"],"[V][Cond][Trns][A_3Du][P_3Du]":["@~–ku:agkek"],"[V][Cond][Trns][A_3Du][P_3Pl]":["@~–ku:agki"],"[V][Cond][Trns][A_3Du][P_3Sg]":["@~–ku:agnegu"],"[V][Cond][Trns][A_3Du][P_4Du]":["@~–ku:agtek"],"[V][Cond][Trns][A_3Du][P_4Pl]":["@~–ku:agteng"],"[V][Cond][Trns][A_3Du][P_4Sg]":["@~–ku:agni"],"[V][Cond][Trns][A_3Pl][P_1Du]":["@~–ku:atkuk"],"[V][Cond][Trns][A_3Pl][P_1Pl]":["@~–ku:atkut"],"[V][Cond][Trns][A_3Pl][P_1Sg]":["@~–ku:atnga"],"[V][Cond][Trns][A_3Pl][P_2Du]":["@~–ku:acetek"],"[V][Cond][Trns][A_3Pl][P_2Pl]":["@~–ku:aceci"],"[V][Cond][Trns][A_3Pl][P_2Sg]":["@~–ku:atgen"],"[V][Cond][Trns][A_3Pl][P_3Du]":["@~–ku:atkek"],"[V][Cond][Trns][A_3Pl][P_3Pl]":["@~–ku:atki"],"[V][Cond][Trns][A_3Pl][P_3Sg]":["@~–ku:atgu"],"[V][Cond][Trns][A_3Pl][P_4Du]":["@~–ku:acetek"],"[V][Cond][Trns][A_3Pl][P_4Pl]":["@~–ku:aceteng"],"[V][Cond][Trns][A_3Pl][P_4Sg]":["@~–ku:atni"],"[V][Cond][Trns][A_3Sg][P_1Du]":["@~–ku:akuk"],"[V][Cond][Trns][A_3Sg][P_1Pl]":["@~–ku:akut"],"[V][Cond][Trns][A_3Sg][P_1Sg]":["@~–ku:anga"],"[V][Cond][Trns][A_3Sg][P_2Du]":["@~–ku:atek"],"[V][Cond][Trns][A_3Sg][P_2Pl]":["@~–ku:aci"],"[V][Cond][Trns][A_3Sg][P_2Sg]":["@~–ku:aten"],"[V][Cond][Trns][A_3Sg][P_3Du]":["@~–ku:akek"],"[V][Cond][Trns][A_3Sg][P_3Pl]":["@~–ku:aki"],"[V][Cond][Trns][A_3Sg][P_3Sg]":["@~–ku:aku"],"[V][Cond][Trns][A_3Sg][P_4Du]":["@~–ku:atek"],"[V][Cond][Trns][A_3Sg][P_4Pl]":["@~–ku:ateng"],"[V][Cond][Trns][A_3Sg][P_4Sg]":["@~–ku:ani"],"[V][Cond][Trns][A_4Du][P_1Du]":["@~–ku+negnekuk"],"[V][Cond][Trns][A_4Du][P_1Pl]":["@~–ku+negnekut"],"[V][Cond][Trns][A_4Du][P_1Sg]":["@~–ku+negnenga"],"[V][Cond][Trns][A_4Du][P_2Du]":["@~–ku+negnetek"],"[V][Cond][Trns][A_4Du][P_2Pl]":["@~–ku+negneci"],"[V][Cond][Trns][A_4Du][P_2Sg]":["@~–ku+negnegen"],"[V][Cond][Trns][A_4Du][P_3Du]":["@~–ku+negnekek"],"[V][Cond][Trns][A_4Du][P_3Pl]":["@~–ku+negneki"],"[V][Cond][Trns][A_4Du][P_3Sg]":["@~–ku+negnegu"],"[V][Cond][Trns][A_4Pl][P_1Du]":["@~–ku+negtekuk"],"[V][Cond][Trns][A_4Pl][P_1Pl]":["@~–ku+negtekut"],"[V][Cond][Trns][A_4Pl][P_1Sg]":["@~–ku+negtenga"],"[V][Cond][Trns][A_4Pl][P_2Du]":["@~–ku+negcetek"],"[V][Cond][Trns][A_4Pl][P_2Pl]":["@~–ku+negceci"],"[V][Cond][Trns][A_4Pl][P_2Sg]":["@~–ku+negteggen"],"[V][Cond][Trns][A_4Pl][P_3Du]":["@~–ku+negtekek"],"[V][Cond][Trns][A_4Pl][P_3Pl]":["@~–ku+negteki"],"[V][Cond][Trns][A_4Pl][P_3Sg]":["@~–ku+negteggu"],"[V][Cond][Trns][A_4Sg][P_1Du]":["@~–ku+nikuk"],"[V][Cond][Trns][A_4Sg][P_1Pl]":["@~–ku+nikut"],"[V][Cond][Trns][A_4Sg][P_1Sg]":["@~–ku+nia"],"[V][Cond][Trns][A_4Sg][P_2Du]":["@~–ku+nitek"],"[V][Cond][Trns][A_4Sg][P_2Pl]":["@~–ku+nici"],"[V][Cond][Trns][A_4Sg][P_2Sg]":["@~–ku+niten"],"[V][Cond][Trns][A_4Sg][P_3Du]":["@~–ku+nikek"],"[V][Cond][Trns][A_4Sg][P_3Pl]":["@~–ku+niki"],"[V][Cond][Trns][A_4Sg][P_3Sg]":["@~–ku+niu"],"[V][Cont][Intr][S_1Du]":["+'(g)aqa–megnuk"],"[V][Cont][Intr][S_1Pl]":["+'(g)aqa–mta"],"[V][Cont][Intr][S_1Sg]":["+'(g)aqa+ma"],"[V][Cont][Intr][S_2Du]":["+'(g)aqa.vtek"],"[V][Cont][Intr][S_2Pl]":["+'(g)aqa.veci"],"[V][Cont][Intr][S_2Sg]":["+'(g)aqa.vet"],"[V][Cont][Intr][S_3Du]":["+'(g)aqa:agnek"],"[V][Cont][Intr][S_3Pl]":["+'(g)aqa:ata"],"[V][Cont][Intr][S_3Sg]":["+'(g)aqa:an"],"[V][Cont][Intr][S_4Du]":["+'(g)aqa+mek"],"[V][Cont][Intr][S_4Pl]":["+'(g)aqa+meng"],"[V][Cont][Intr][S_4Sg]":["+'(g)aqa+mi"],"[V][Cont][Trns][A_1Du][P_2Du]":["+'(g)aqa–megtek"],"[V][Cont][Trns][A_1Du][P_2Pl]":["+'(g)aqa–megci"],"[V][Cont][Trns][A_1Du][P_2Sg]":["+'(g)aqa–megten"],"[V][Cont][Trns][A_1Du][P_3Du]":["+'(g)aqa–megkek"],"[V][Cont][Trns][A_1Du][P_3Pl]":["+'(g)aqa–megki"],"[V][Cont][Trns][A_1Du][P_3Sg]":["+'(g)aqa–megnegu"],"[V][Cont][Trns][A_1Du][P_4Du]":["+'(g)aqa–megtek"],"[V][Cont][Trns][A_1Du][P_4Pl]":["+'(g)aqa–megteng"],"[V][Cont][Trns][A_1Du][P_4Sg]":["+'(g)aqa–megni"],"[V][Cont][Trns][A_1Pl][P_2Du]":["+'(g)aqa–mcetek"],"[V][Cont][Trns][A_1Pl][P_2Pl]":["+'(g)aqa–mceci"],"[V][Cont][Trns][A_1Pl][P_2Sg]":["+'(g)aqa–mteggen"],"[V][Cont][Trns][A_1Pl][P_3Du]":["+'(g)aqa–mtekek"],"[V][Cont][Trns][A_1Pl][P_3Pl]":["+'(g)aqa–mteki"],"[V][Cont][Trns][A_1Pl][P_3Sg]":["+'(g)aqa–mteggu"],"[V][Cont][Trns][A_1Pl][P_4Du]":["+'(g)aqa–mcetek"],"[V][Cont][Trns][A_1Pl][P_4Pl]":["+'(g)aqa–mceteng"],"[V][Cont][Trns][A_1Pl][P_4Sg]":["+'(g)aqa–mten̄i"],"[V][Cont][Trns][A_1Sg][P_2Du]":["+'(g)aqa–mtek"],"[V][Cont][Trns][A_1Sg][P_2Pl]":["+'(g)aqa–mci"],"[V][Cont][Trns][A_1Sg][P_2Sg]":["+'(g)aqa–mken"],"[V][Cont][Trns][A_1Sg][P_3Du]":["+'(g)aqa–mkek"],"[V][Cont][Trns][A_1Sg][P_3Pl]":["+'(g)aqa–mki"],"[V][Cont][Trns][A_1Sg][P_3Sg]":["+'(g)aqa–mku"],"[V][Cont][Trns][A_1Sg][P_4Du]":["+'(g)aqa–mtek"],"[V][Cont][Trns][A_1Sg][P_4Pl]":["+'(g)aqa–mteng"],"[V][Cont][Trns][A_1Sg][P_4Sg]":["+'(g)aqa–mni"],"[V][Cont][Trns][A_2Du][P_1Du]":["+'(g)aqa.vtegkuk"],"[V][Cont][Trns][A_2Du][P_1Pl]":["+'(g)aqa.vtegkut"],"[V][Cont][Trns][A_2Du][P_1Sg]":["+'(g)aqa.vtegnga"],"[V][Cont][Trns][A_2Du][P_3Du]":["+'(g)aqa.vtegkek"],"[V][Cont][Trns][A_2Du][P_3Pl]":["+'(g)aqa.vtegki"],"[V][Cont][Trns][A_2Du][P_3Sg]":["+'(g)aqa.vtegnegu"],"[V][Cont][Trns][A_2Du][P_4Du]":["+'(g)aqa.vtegtek"],"[V][Cont][Trns][A_2Du][P_4Pl]":["+'(g)aqa.vtegteng"],"[V][Cont][Trns][A_2Du][P_4Sg]":["+'(g)aqa.vtegni"],"[V][Cont][Trns][A_2Pl][P_1Du]":["+'(g)aqa.vcikuk"],"[V][Cont][Trns][A_2Pl][P_1Pl]":["+'(g)aqa.vcikut"],"[V][Cont][Trns][A_2Pl][P_1Sg]":["+'(g)aqa.vcia"],"[V][Cont][Trns][A_2Pl][P_3Du]":["+'(g)aqa.vcikek"],"[V][Cont][Trns][A_2Pl][P_3Pl]":["+'(g)aqa.vciki"],"[V][Cont][Trns][A_2Pl][P_3Sg]":["+'(g)aqa.vciu"],"[V][Cont][Trns][A_2Pl][P_4Du]":["+'(g)aqa.vcitek"],"[V][Cont][Trns][A_2Pl][P_4Pl]":["+'(g)aqa.vciteng"],"[V][Cont][Trns][A_2Pl][P_4Sg]":["+'(g)aqa.vcini"],"[V][Cont][Trns][A_2Sg][P_1Du]":["+'(g)aqa.vkuk"],"[V][Cont][Trns][A_2Sg][P_1Pl]":["+'(g)aqa.vkut"],"[V][Cont][Trns][A_2Sg][P_1Sg]":["+'(g)aqa.vnga"],"[V][Cont][Trns][A_2Sg][P_3Du]":["+'(g)aqa.vkek"],"[V][Cont][Trns][A_2Sg][P_3Pl]":["+'(g)aqa.vki"],"[V][Cont][Trns][A_2Sg][P_3Sg]":["+'(g)aqa.vgu"],"[V][Cont][Trns][A_2Sg][P_4Du]":["+'(g)aqa.vtek"],"[V][Cont][Trns][A_2Sg][P_4Pl]":["+'(g)aqa.vteng"],"[V][Cont][Trns][A_2Sg][P_4Sg]":["+'(g)aqa.vni"],"[V][Cont][Trns][A_3Du][P_1Du]":["+'(g)aqa:agkuk"],"[V][Cont][Trns][A_3Du][P_1Pl]":["+'(g)aqa:agkut"],"[V][Cont][Trns][A_3Du][P_1Sg]":["+'(g)aqa:agnga"],"[V][Cont][Trns][A_3Du][P_2Du]":["+'(g)aqa:agtek"],"[V][Cont][Trns][A_3Du][P_2Pl]":["+'(g)aqa:agci"],"[V][Cont][Trns][A_3Du][P_2Sg]":["+'(g)aqa:agten"],"[V][Cont][Trns][A_3Du][P_3Du]":["+'(g)aqa:agkek"],"[V][Cont][Trns][A_3Du][P_3Pl]":["+'(g)aqa:agki"],"[V][Cont][Trns][A_3Du][P_3Sg]":["+'(g)aqa:agnegu"],"[V][Cont][Trns][A_3Du][P_4Du]":["+'(g)aqa:agtek"],"[V][Cont][Trns][A_3Du][P_4Pl]":["+'(g)aqa:agteng"],"[V][Cont][Trns][A_3Du][P_4Sg]":["+'(g)aqa:agni"],"[V][Cont][Trns][A_3Pl][P_1Du]":["+'(g)aqa:atkuk"],"[V][Cont][Trns][A_3Pl][P_1Pl]":["+'(g)aqa:atkut"],"[V][Cont][Trns][A_3Pl][P_1Sg]":["+'(g)aqa:atnga"],"[V][Cont][Trns][A_3Pl][P_2Du]":["+'(g)aqa:acetek"],"[V][Cont][Trns][A_3Pl][P_2Pl]":["+'(g)aqa:aceci"],"[V][Cont][Trns][A_3Pl][P_2Sg]":["+'(g)aqa:atgen"],"[V][Cont][Trns][A_3Pl][P_3Du]":["+'(g)aqa:atkek"],"[V][Cont][Trns][A_3Pl][P_3Pl]":["+'(g)aqa:atki"],"[V][Cont][Trns][A_3Pl][P_3Sg]":["+'(g)aqa:atgu"],"[V][Cont][Trns][A_3Pl][P_4Du]":["+'(g)aqa:acetek"],"[V][Cont][Trns][A_3Pl][P_4Pl]":["+'(g)aqa:aceteng"],"[V][Cont][Trns][A_3Pl][P_4Sg]":["+'(g)aqa:atni"],"[V][Cont][Trns][A_3Sg][P_1Du]":["+'(g)aqa:akuk"],"[V][Cont][Trns][A_3Sg][P_1Pl]":["+'(g)aqa:akut"],"[V][Cont][Trns][A_3Sg][P_1Sg]":["+'(g)aqa:anga"],"[V][Cont][Trns][A_3Sg][P_2Du]":["+'(g)aqa:atek"],"[V][Cont][Trns][A_3Sg][P_2Pl]":["+'(g)aqa:aci"],"[V][Cont][Trns][A_3Sg][P_2Sg]":["+'(g)aqa:aten"],"[V][Cont][Trns][A_3Sg][P_3Du]":["+'(g)aqa:akek"],"[V][Cont][Trns][A_3Sg][P_3Pl]":["+'(g)aqa:aki"],"[V][Cont][Trns][A_3Sg][P_3Sg]":["+'(g)aqa:aku"],"[V][Cont][Trns][A_3Sg][P_4Du]":["+'(g)aqa:atek"],"[V][Cont][Trns][A_3Sg][P_4Pl]":["+'(g)aqa:ateng"],"[V][Cont][Trns][A_3Sg][P_4Sg]":["+'(g)aqa:ani"],"[V][Cont][Trns][A_4Du][P_1Du]":["+'(g)aqa+megnekuk"],"[V][Cont][Trns][A_4Du][P_1Pl]":["+'(g)aqa+megnekut"],"[V][Cont][Trns][A_4Du][P_1Sg]":["+'(g)aqa+megnenga"],"[V][Cont][Trns][A_4Du][P_2Du]":["+'(g)aqa+megnetek"],"[V][Cont][Trns][A_4Du][P_2Pl]":["+'(g)aqa+megneci"],"[V][Cont][Trns][A_4Du][P_2Sg]":["+'(g)aqa+megnegen"],"[V][Cont][Trns][A_4Du][P_3Du]":["+'(g)aqa+megnekek"],"[V][Cont][Trns][A_4Du][P_3Pl]":["+'(g)aqa+megneki"],"[V][Cont][Trns][A_4Du][P_3Sg]":["+'(g)aqa+megnegu"],"[V][Cont][Trns][A_4Pl][P_1Du]":["+'(g)aqa+megtekuk"],"[V][Cont][Trns][A_4Pl][P_1Pl]":["+'(g)aqa+megtekut"],"[V][Cont][Trns][A_4Pl][P_1Sg]":["+'(g)aqa+megtenga"],"[V][Cont][Trns][A_4Pl][P_2Du]":["+'(g)aqa+megcetek"],"[V][Cont][Trns][A_4Pl][P_2Pl]":["+'(g)aqa+megceci"],"[V][Cont][Trns][A_4Pl][P_2Sg]":["+'(g)aqa+megteggen"],"[V][Cont][Trns][A_4Pl][P_3Du]":["+'(g)aqa+megtekek"],"[V][Cont][Trns][A_4Pl][P_3Pl]":["+'(g)aqa+megteki"],"[V][Cont][Trns][A_4Pl][P_3Sg]":["+'(g)aqa+megteggu"],"[V][Cont][Trns][A_4Sg][P_1Du]":["+'(g)aqa+mikuk"],"[V][Cont][Trns][A_4Sg][P_1Pl]":["+'(g)aqa+mikut"],"[V][Cont][Trns][A_4Sg][P_1Sg]":["+'(g)aqa+mia"],"[V][Cont][Trns][A_4Sg][P_2Du]":["+'(g)aqa+mitek"],"[V][Cont][Trns][A_4Sg][P_2Pl]":["+'(g)aqa+mici"],"[V][Cont][Trns][A_4Sg][P_2Sg]":["+'(g)aqa+miten"],"[V][Cont][Trns][A_4Sg][P_3Du]":["+'(g)aqa+mikek"],"[V][Cont][Trns][A_4Sg][P_3Pl]":["+'(g)aqa+miki"],"[V][Cont][Trns][A_4Sg][P_3Sg]":["+'(g)aqa+miu"],"[V][CtmpII][Intr][S_1Du]":["@%:(ng)inaner–megni","@~+nginaner–megni"],"[V][CtmpII][Intr][S_1Pl]":["@%:(ng)inaner–mten̄i","@~+nginaner–mten̄i"],"[V][CtmpII][Intr][S_1Sg]":["@%:(ng)inaner–mni","@~+nginaner–mni"],"[V][CtmpII][Intr][S_2Du]":["@%:(ng)inaner+petegni","@~+nginaner+petegni"],"[V][CtmpII][Intr][S_2Pl]":["@%:(ng)inaner+pecen̄i","@~+nginaner+pecen̄i"],"[V][CtmpII][Intr][S_2Sg]":["@%:(ng)inaner+peni","@~+nginaner+peni"],"[V][CtmpII][Intr][S_3Du]":["@%:(ng)inaner:agni","@~+nginaner:agni"],"[V][CtmpII][Intr][S_3Pl]":["@%:(ng)inaner:atni","@~+nginaner:atni"],"[V][CtmpII][Intr][S_3Sg]":["@%:(ng)inaner:ani","@~+nginaner:ani"],"[V][CtmpII][Intr][S_4Du]":["@%:(ng)inaner+megni","@~+nginaner+megni"],"[V][CtmpII][Intr][S_4Pl]":["@%:(ng)inaner+meggni","@~+nginaner+meggni"],"[V][CtmpII][Intr][S_4Sg]":["@%:(ng)inaner+mini","@~+nginaner+mini"],"[V][CtmpII][Trns][A_1Du][P_2Du]":["@%:(ng)inaner–megtek","@~+nginaner–megtek"],"[V][CtmpII][Trns][A_1Du][P_2Pl]":["@%:(ng)inaner–megci","@~+nginaner–megci"],"[V][CtmpII][Trns][A_1Du][P_2Sg]":["@%:(ng)inaner–megten","@~+nginaner–megten"],"[V][CtmpII][Trns][A_1Du][P_3Du]":["@%:(ng)inaner–megkek","@~+nginaner–megkek"],"[V][CtmpII][Trns][A_1Du][P_3Pl]":["@%:(ng)inaner–megki","@~+nginaner–megki"],"[V][CtmpII][Trns][A_1Du][P_3Sg]":["@%:(ng)inaner–megnegu","@~+nginaner–megnegu"],"[V][CtmpII][Trns][A_1Du][P_4Du]":["@%:(ng)inaner–megtek","@~+nginaner–megtek"],"[V][CtmpII][Trns][A_1Du][P_4Pl]":["@%:(ng)inaner–megteng","@~+nginaner–megteng"],"[V][CtmpII][Trns][A_1Du][P_4Sg]":["@%:(ng)inaner–megni","@~+nginaner–megni"],"[V][CtmpII][Trns][A_1Pl][P_2Du]":["@%:(ng)inaner–mcetek","@~+nginaner–mcetek"],"[V][CtmpII][Trns][A_1Pl][P_2Pl]":["@%:(ng)inaner–mceci","@~+nginaner–mceci"],"[V][CtmpII][Trns][A_1Pl][P_2Sg]":["@%:(ng)inaner–mteggen","@~+nginaner–mteggen"],"[V][CtmpII][Trns][A_1Pl][P_3Du]":["@%:(ng)inaner–mtekek","@~+nginaner–mtekek"],"[V][CtmpII][Trns][A_1Pl][P_3Pl]":["@%:(ng)inaner–mteki","@~+nginaner–mteki"],"[V][CtmpII][Trns][A_1Pl][P_3Sg]":["@%:(ng)inaner–mteggu","@~+nginaner–mteggu"],"[V][CtmpII][Trns][A_1Pl][P_4Du]":["@%:(ng)inaner–mcetek","@~+nginaner–mcetek"],"[V][CtmpII][Trns][A_1Pl][P_4Pl]":["@%:(ng)inaner–mceteng","@~+nginaner–mceteng"],"[V][CtmpII][Trns][A_1Pl][P_4Sg]":["@%:(ng)inaner–mten̄i","@~+nginaner–mten̄i"],"[V][CtmpII][Trns][A_1Sg][P_2Du]":["@%:(ng)inaner–mtek","@~+nginaner–mtek"],"[V][CtmpII][Trns][A_1Sg][P_2Pl]":["@%:(ng)inaner–mci","@~+nginaner–mci"],"[V][CtmpII][Trns][A_1Sg][P_2Sg]":["@%:(ng)inaner–mken","@~+nginaner–mken"],"[V][CtmpII][Trns][A_1Sg][P_3Du]":["@%:(ng)inaner–mkek","@~+nginaner–mkek"],"[V][CtmpII][Trns][A_1Sg][P_3Pl]":["@%:(ng)inaner–mki","@~+nginaner–mki"],"[V][CtmpII][Trns][A_1Sg][P_3Sg]":["@%:(ng)inaner–mku","@~+nginaner–mku"],"[V][CtmpII][Trns][A_1Sg][P_4Du]":["@%:(ng)inaner–mtek","@~+nginaner–mtek"],"[V][CtmpII][Trns][A_1Sg][P_4Pl]":["@%:(ng)inaner–mteng","@~+nginaner–mteng"],"[V][CtmpII][Trns][A_1Sg][P_4Sg]":["@%:(ng)inaner–mni","@~+nginaner–mni"],"[V][CtmpII][Trns][A_2Du][P_1Du]":["@%:(ng)inaner+petegkuk","@~+nginaner+petegkuk"],"[V][CtmpII][Trns][A_2Du][P_1Pl]":["@%:(ng)inaner+petegkut","@~+nginaner+petegkut"],"[V][CtmpII][Trns][A_2Du][P_1Sg]":["@%:(ng)inaner+petegnga","@~+nginaner+petegnga"],"[V][CtmpII][Trns][A_2Du][P_3Du]":["@%:(ng)inaner+petegkek","@~+nginaner+petegkek"],"[V][CtmpII][Trns][A_2Du][P_3Pl]":["@%:(ng)inaner+petegki","@~+nginaner+petegki"],"[V][CtmpII][Trns][A_2Du][P_3Sg]":["@%:(ng)inaner+petegnegu","@~+nginaner+petegnegu"],"[V][CtmpII][Trns][A_2Du][P_4Du]":["@%:(ng)inaner+petegtek","@~+nginaner+petegtek"],"[V][CtmpII][Trns][A_2Du][P_4Pl]":["@%:(ng)inaner+petegteng","@~+nginaner+petegteng"],"[V][CtmpII][Trns][A_2Du][P_4Sg]":["@%:(ng)inaner+petegni","@~+nginaner+petegni"],"[V][CtmpII][Trns][A_2Pl][P_1Du]":["@%:(ng)inaner+pecikuk","@~+nginaner+pecikuk"],"[V][CtmpII][Trns][A_2Pl][P_1Pl]":["@%:(ng)inaner+pecikut","@~+nginaner+pecikut"],"[V][CtmpII][Trns][A_2Pl][P_1Sg]":["@%:(ng)inaner+pecia","@~+nginaner+pecia"],"[V][CtmpII][Trns][A_2Pl][P_3Du]":["@%:(ng)inaner+pecikek","@~+nginaner+pecikek"],"[V][CtmpII][Trns][A_2Pl][P_3Pl]":["@%:(ng)inaner+peciki","@~+nginaner+peciki"],"[V][CtmpII][Trns][A_2Pl][P_3Sg]":["@%:(ng)inaner+peciu","@~+nginaner+peciu"],"[V][CtmpII][Trns][A_2Pl][P_4Du]":["@%:(ng)inaner+pecitek","@~+nginaner+pecitek"],"[V][CtmpII][Trns][A_2Pl][P_4Pl]":["@%:(ng)inaner+peciteng","@~+nginaner+peciteng"],"[V][CtmpII][Trns][A_2Pl][P_4Sg]":["@%:(ng)inaner+pecini","@~+nginaner+pecini"],"[V][CtmpII][Trns][A_2Sg][P_1Du]":["@%:(ng)inaner+pekuk","@~+nginaner+pekuk"],"[V][CtmpII][Trns][A_2Sg][P_1Pl]":["@%:(ng)inaner+pekut","@~+nginaner+pekut"],"[V][CtmpII][Trns][A_2Sg][P_1Sg]":["@%:(ng)inaner+penga","@~+nginaner+penga"],"[V][CtmpII][Trns][A_2Sg][P_3Du]":["@%:(ng)inaner+pekek","@~+nginaner+pekek"],"[V][CtmpII][Trns][A_2Sg][P_3Pl]":["@%:(ng)inaner+peki","@~+nginaner+peki"],"[V][CtmpII][Trns][A_2Sg][P_3Sg]":["@%:(ng)inaner+pegu","@~+nginaner+pegu"],"[V][CtmpII][Trns][A_2Sg][P_4Du]":["@%:(ng)inaner+petek","@~+nginaner+petek"],"[V][CtmpII][Trns][A_2Sg][P_4Pl]":["@%:(ng)inaner+peteng","@~+nginaner+peteng"],"[V][CtmpII][Trns][A_2Sg][P_4Sg]":["@%:(ng)inaner+peni","@~+nginaner+peni"],"[V][CtmpII][Trns][A_3Du][P_1Du]":["@%:(ng)inaner:agkuk","@~+nginaner:agkuk"],"[V][CtmpII][Trns][A_3Du][P_1Pl]":["@%:(ng)inaner:agkut","@~+nginaner:agkut"],"[V][CtmpII][Trns][A_3Du][P_1Sg]":["@%:(ng)inaner:agnga","@~+nginaner:agnga"],"[V][CtmpII][Trns][A_3Du][P_2Du]":["@%:(ng)inaner:agtek","@~+nginaner:agtek"],"[V][CtmpII][Trns][A_3Du][P_2Pl]":["@%:(ng)inaner:agci","@~+nginaner:agci"],"[V][CtmpII][Trns][A_3Du][P_2Sg]":["@%:(ng)inaner:agten","@~+nginaner:agten"],"[V][CtmpII][Trns][A_3Du][P_3Du]":["@%:(ng)inaner:agkek","@~+nginaner:agkek"],"[V][CtmpII][Trns][A_3Du][P_3Pl]":["@%:(ng)inaner:agki","@~+nginaner:agki"],"[V][CtmpII][Trns][A_3Du][P_3Sg]":["@%:(ng)inaner:agnegu","@~+nginaner:agnegu"],"[V][CtmpII][Trns][A_3Du][P_4Du]":["@%:(ng)inaner:agtek","@~+nginaner:agtek"],"[V][CtmpII][Trns][A_3Du][P_4Pl]":["@%:(ng)inaner:agteng","@~+nginaner:agteng"],"[V][CtmpII][Trns][A_3Du][P_4Sg]":["@%:(ng)inaner:agni","@~+nginaner:agni"],"[V][CtmpII][Trns][A_3Pl][P_1Du]":["@%:(ng)inaner:atkuk","@~+nginaner:atkuk"],"[V][CtmpII][Trns][A_3Pl][P_1Pl]":["@%:(ng)inaner:atkut","@~+nginaner:atkut"],"[V][CtmpII][Trns][A_3Pl][P_1Sg]":["@%:(ng)inaner:atnga","@~+nginaner:atnga"],"[V][CtmpII][Trns][A_3Pl][P_2Du]":["@%:(ng)inaner:acetek","@~+nginaner:acetek"],"[V][CtmpII][Trns][A_3Pl][P_2Pl]":["@%:(ng)inaner:aceci","@~+nginaner:aceci"],"[V][CtmpII][Trns][A_3Pl][P_2Sg]":["@%:(ng)inaner:atgen","@~+nginaner:atgen"],"[V][CtmpII][Trns][A_3Pl][P_3Du]":["@%:(ng)inaner:atkek","@~+nginaner:atkek"],"[V][CtmpII][Trns][A_3Pl][P_3Pl]":["@%:(ng)inaner:atki","@~+nginaner:atki"],"[V][CtmpII][Trns][A_3Pl][P_3Sg]":["@%:(ng)inaner:atgu","@~+nginaner:atgu"],"[V][CtmpII][Trns][A_3Pl][P_4Du]":["@%:(ng)inaner:acetek","@~+nginaner:acetek"],"[V][CtmpII][Trns][A_3Pl][P_4Pl]":["@%:(ng)inaner:aceteng","@~+nginaner:aceteng"],"[V][CtmpII][Trns][A_3Pl][P_4Sg]":["@%:(ng)inaner:atni","@~+nginaner:atni"],"[V][CtmpII][Trns][A_3Sg][P_1Du]":["@%:(ng)inaner:akuk","@~+nginaner:akuk"],"[V][CtmpII][Trns][A_3Sg][P_1Pl]":["@%:(ng)inaner:akut","@~+nginaner:akut"],"[V][CtmpII][Trns][A_3Sg][P_1Sg]":["@%:(ng)inaner:anga","@~+nginaner:anga"],"[V][CtmpII][Trns][A_3Sg][P_2Du]":["@%:(ng)inaner:atek","@~+nginaner:atek"],"[V][CtmpII][Trns][A_3Sg][P_2Pl]":["@%:(ng)inaner:aci","@~+nginaner:aci"],"[V][CtmpII][Trns][A_3Sg][P_2Sg]":["@%:(ng)inaner:aten","@~+nginaner:aten"],"[V][CtmpII][Trns][A_3Sg][P_3Du]":["@%:(ng)inaner:akek","@~+nginaner:akek"],"[V][CtmpII][Trns][A_3Sg][P_3Pl]":["@%:(ng)inaner:aki","@~+nginaner:aki"],"[V][CtmpII][Trns][A_3Sg][P_3Sg]":["@%:(ng)inaner:aku","@~+nginaner:aku"],"[V][CtmpII][Trns][A_3Sg][P_4Du]":["@%:(ng)inaner:atek","@~+nginaner:atek"],"[V][CtmpII][Trns][A_3Sg][P_4Pl]":["@%:(ng)inaner:ateng","@~+nginaner:ateng"],"[V][CtmpII][Trns][A_3Sg][P_4Sg]":["@%:(ng)inaner:ani","@~+nginaner:ani"],"[V][CtmpII][Trns][A_4Du][P_1Du]":["@%:(ng)inaner+megnekuk","@~+nginaner+megnekuk"],"[V][CtmpII][Trns][A_4Du][P_1Pl]":["@%:(ng)inaner+megnekut","@~+nginaner+megnekut"],"[V][CtmpII][Trns][A_4Du][P_1Sg]":["@%:(ng)inaner+megnenga","@~+nginaner+megnenga"],"[V][CtmpII][Trns][A_4Du][P_2Du]":["@%:(ng)inaner+megnetek","@~+nginaner+megnetek"],"[V][CtmpII][Trns][A_4Du][P_2Pl]":["@%:(ng)inaner+megneci","@~+nginaner+megneci"],"[V][CtmpII][Trns][A_4Du][P_2Sg]":["@%:(ng)inaner+megnegen","@~+nginaner+megnegen"],"[V][CtmpII][Trns][A_4Du][P_3Du]":["@%:(ng)inaner+megnekek","@~+nginaner+megnekek"],"[V][CtmpII][Trns][A_4Du][P_3Pl]":["@%:(ng)inaner+megneki","@~+nginaner+megneki"],"[V][CtmpII][Trns][A_4Du][P_3Sg]":["@%:(ng)inaner+megnegu","@~+nginaner+megnegu"],"[V][CtmpII][Trns][A_4Pl][P_1Du]":["@%:(ng)inaner+megtekuk","@~+nginaner+megtekuk"],"[V][CtmpII][Trns][A_4Pl][P_1Pl]":["@%:(ng)inaner+megtekut","@~+nginaner+megtekut"],"[V][CtmpII][Trns][A_4Pl][P_1Sg]":["@%:(ng)inaner+megtenga","@~+nginaner+megtenga"],"[V][CtmpII][Trns][A_4Pl][P_2Du]":["@%:(ng)inaner+megcetek","@~+nginaner+megcetek"],"[V][CtmpII][Trns][A_4Pl][P_2Pl]":["@%:(ng)inaner+megceci","@~+nginaner+megceci"],"[V][CtmpII][Trns][A_4Pl][P_2Sg]":["@%:(ng)inaner+megteggen","@~+nginaner+megteggen"],"[V][CtmpII][Trns][A_4Pl][P_3Du]":["@%:(ng)inaner+megtekek","@~+nginaner+megtekek"],"[V][CtmpII][Trns][A_4Pl][P_3Pl]":["@%:(ng)inaner+megteki","@~+nginaner+megteki"],"[V][CtmpII][Trns][A_4Pl][P_3Sg]":["@%:(ng)inaner+megteggu","@~+nginaner+megteggu"],"[V][CtmpII][Trns][A_4Sg][P_1Du]":["@%:(ng)inaner+minikuk","@~+nginaner+minikuk"],"[V][CtmpII][Trns][A_4Sg][P_1Pl]":["@%:(ng)inaner+minikut","@~+nginaner+minikut"],"[V][CtmpII][Trns][A_4Sg][P_1Sg]":["@%:(ng)inaner+minia","@~+nginaner+minia"],"[V][CtmpII][Trns][A_4Sg][P_2Du]":["@%:(ng)inaner+minitek","@~+nginaner+minitek"],"[V][CtmpII][Trns][A_4Sg][P_2Pl]":["@%:(ng)inaner+minici","@~+nginaner+minici"],"[V][CtmpII][Trns][A_4Sg][P_2Sg]":["@%:(ng)inaner+miniten","@~+nginaner+miniten"],"[V][CtmpII][Trns][A_4Sg][P_3Du]":["@%:(ng)inaner+minikek","@~+nginaner+minikek"],"[V][CtmpII][Trns][A_4Sg][P_3Pl]":["@%:(ng)inaner+miniki","@~+nginaner+miniki"],"[V][CtmpII][Trns][A_4Sg][P_3Sg]":["@%:(ng)inaner+miniu","@~+nginaner+miniu"],"[V][CtmpI][Intr][S_1Du]":["–ller–megni"],"[V][CtmpI][Intr][S_1Pl]":["–ller–mten̄i"],"[V][CtmpI][Intr][S_1Sg]":["–ller–mni"],"[V][CtmpI][Intr][S_2Du]":["–ller+petegni"],"[V][CtmpI][Intr][S_2Pl]":["–ller+pecen̄i"],"[V][CtmpI][Intr][S_2Sg]":["–ller+peni"],"[V][CtmpI][Intr][S_3Du]":["–ller:agni"],"[V][CtmpI][Intr][S_3Pl]":["–ller:atni"],"[V][CtmpI][Intr][S_3Sg]":["–ller:ani"],"[V][CtmpI][Intr][S_4Du]":["–ller+megni"],"[V][CtmpI][Intr][S_4Pl]":["–ller+meggni"],"[V][CtmpI][Intr][S_4Sg]":["–ller+mini"],"[V][CtmpI][Trns][A_1Du][P_2Du]":["–ller–megtek"],"[V][CtmpI][Trns][A_1Du][P_2Pl]":["–ller–megci"],"[V][CtmpI][Trns][A_1Du][P_2Sg]":["–ller–megten"],"[V][CtmpI][Trns][A_1Du][P_3Du]":["–ller–megkek"],"[V][CtmpI][Trns][A_1Du][P_3Pl]":["–ller–megki"],"[V][CtmpI][Trns][A_1Du][P_3Sg]":["–ller–megnegu"],"[V][CtmpI][Trns][A_1Du][P_4Du]":["–ller–megtek"],"[V][CtmpI][Trns][A_1Du][P_4Pl]":["–ller–megteng"],"[V][CtmpI][Trns][A_1Du][P_4Sg]":["–ller–megni"],"[V][CtmpI][Trns][A_1Pl][P_2Du]":["–ller–mcetek"],"[V][CtmpI][Trns][A_1Pl][P_2Pl]":["–ller–mceci"],"[V][CtmpI][Trns][A_1Pl][P_2Sg]":["–ller–mteggen"],"[V][CtmpI][Trns][A_1Pl][P_3Du]":["–ller–mtekek"],"[V][CtmpI][Trns][A_1Pl][P_3Pl]":["–ller–mteki"],"[V][CtmpI][Trns][A_1Pl][P_3Sg]":["–ller–mteggu"],"[V][CtmpI][Trns][A_1Pl][P_4Du]":["–ller–mcetek"],"[V][CtmpI][Trns][A_1Pl][P_4Pl]":["–ller–mceteng"],"[V][CtmpI][Trns][A_1Pl][P_4Sg]":["–ller–mten̄i"],"[V][CtmpI][Trns][A_1Sg][P_2Du]":["–ller–mtek"],"[V][CtmpI][Trns][A_1Sg][P_2Pl]":["–ller–mci"],"[V][CtmpI][Trns][A_1Sg][P_2Sg]":["–ller–mken"],"[V][CtmpI][Trns][A_1Sg][P_3Du]":["–ller–mkek"],"[V][CtmpI][Trns][A_1Sg][P_3Pl]":["–ller–mki"],"[V][CtmpI][Trns][A_1Sg][P_3Sg]":["–ller–mku"],"[V][CtmpI][Trns][A_1Sg][P_4Du]":["–ller–mtek"],"[V][CtmpI][Trns][A_1Sg][P_4Pl]":["–ller–mteng"],"[V][CtmpI][Trns][A_1Sg][P_4Sg]":["–ller–mni"],"[V][CtmpI][Trns][A_2Du][P_1Du]":["–ller+petegkuk"],"[V][CtmpI][Trns][A_2Du][P_1Pl]":["–ller+petegkut"],"[V][CtmpI][Trns][A_2Du][P_1Sg]":["–ller+petegnga"],"[V][CtmpI][Trns][A_2Du][P_3Du]":["–ller+petegkek"],"[V][CtmpI][Trns][A_2Du][P_3Pl]":["–ller+petegki"],"[V][CtmpI][Trns][A_2Du][P_3Sg]":["–ller+petegnegu"],"[V][CtmpI][Trns][A_2Du][P_4Du]":["–ller+petegtek"],"[V][CtmpI][Trns][A_2Du][P_4Pl]":["–ller+petegteng"],"[V][CtmpI][Trns][A_2Du][P_4Sg]":["–ller+petegni"],"[V][CtmpI][Trns][A_2Pl][P_1Du]":["–ller+pecikuk"],"[V][CtmpI][Trns][A_2Pl][P_1Pl]":["–ller+pecikut"],"[V][CtmpI][Trns][A_2Pl][P_1Sg]":["–ller+pecia"],"[V][CtmpI][Trns][A_2Pl][P_3Du]":["–ller+pecikek"],"[V][CtmpI][Trns][A_2Pl][P_3Pl]":["–ller+peciki"],"[V][CtmpI][Trns][A_2Pl][P_3Sg]":["–ller+peciu"],"[V][CtmpI][Trns][A_2Pl][P_4Du]":["–ller+pecitek"],"[V][CtmpI][Trns][A_2Pl][P_4Pl]":["–ller+peciteng"],"[V][CtmpI][Trns][A_2Pl][P_4Sg]":["–ller+pecini"],"[V][CtmpI][Trns][A_2Sg][P_1Du]":["–ller+pekuk"],"[V][CtmpI][Trns][A_2Sg][P_1Pl]":["–ller+pekut"],"[V][CtmpI][Trns][A_2Sg][P_1Sg]":["–ller+penga"],"[V][CtmpI][Trns][A_2Sg][P_3Du]":["–ller+pekek"],"[V][CtmpI][Trns][A_2Sg][P_3Pl]":["–ller+peki"],"[V][CtmpI][Trns][A_2Sg][P_3Sg]":["–ller+pegu"],"[V][CtmpI][Trns][A_2Sg][P_4Du]":["–ller+petek"],"[V][CtmpI][Trns][A_2Sg][P_4Pl]":["–ller+peteng"],"[V][CtmpI][Trns][A_2Sg][P_4Sg]":["–ller+peni"],"[V][CtmpI][Trns][A_3Du][P_1Du]":["–ller:agkuk"],"[V][CtmpI][Trns][A_3Du][P_1Pl]":["–ller:agkut"],"[V][CtmpI][Trns][A_3Du][P_1Sg]":["–ller:agnga"],"[V][CtmpI][Trns][A_3Du][P_2Du]":["–ller:agtek"],"[V][CtmpI][Trns][A_3Du][P_2Pl]":["–ller:agci"],"[V][CtmpI][Trns][A_3Du][P_2Sg]":["–ller:agten"],"[V][CtmpI][Trns][A_3Du][P_3Du]":["–ller:agkek"],"[V][CtmpI][Trns][A_3Du][P_3Pl]":["–ller:agki"],"[V][CtmpI][Trns][A_3Du][P_3Sg]":["–ller:agnegu"],"[V][CtmpI][Trns][A_3Du][P_4Du]":["–ller:agtek"],"[V][CtmpI][Trns][A_3Du][P_4Pl]":["–ller:agteng"],"[V][CtmpI][Trns][A_3Du][P_4Sg]":["–ller:agni"],"[V][CtmpI][Trns][A_3Pl][P_1Du]":["–ller:atkuk"],"[V][CtmpI][Trns][A_3Pl][P_1Pl]":["–ller:atkut"],"[V][CtmpI][Trns][A_3Pl][P_1Sg]":["–ller:atnga"],"[V][CtmpI][Trns][A_3Pl][P_2Du]":["–ller:acetek"],"[V][CtmpI][Trns][A_3Pl][P_2Pl]":["–ller:aceci"],"[V][CtmpI][Trns][A_3Pl][P_2Sg]":["–ller:atgen"],"[V][CtmpI][Trns][A_3Pl][P_3Du]":["–ller:atkek"],"[V][CtmpI][Trns][A_3Pl][P_3Pl]":["–ller:atki"],"[V][CtmpI][Trns][A_3Pl][P_3Sg]":["–ller:atgu"],"[V][CtmpI][Trns][A_3Pl][P_4Du]":["–ller:acetek"],"[V][CtmpI][Trns][A_3Pl][P_4Pl]":["–ller:aceteng"],"[V][CtmpI][Trns][A_3Pl][P_4Sg]":["–ller:atni"],"[V][CtmpI][Trns][A_3Sg][P_1Du]":["–ller:akuk"],"[V][CtmpI][Trns][A_3Sg][P_1Pl]":["–ller:akut"],"[V][CtmpI][Trns][A_3Sg][P_1Sg]":["–ller:anga"],"[V][CtmpI][Trns][A_3Sg][P_2Du]":["–ller:atek"],"[V][CtmpI][Trns][A_3Sg][P_2Pl]":["–ller:aci"],"[V][CtmpI][Trns][A_3Sg][P_2Sg]":["–ller:aten"],"[V][CtmpI][Trns][A_3Sg][P_3Du]":["–ller:akek"],"[V][CtmpI][Trns][A_3Sg][P_3Pl]":["–ller:aki"],"[V][CtmpI][Trns][A_3Sg][P_3Sg]":["–ller:aku"],"[V][CtmpI][Trns][A_3Sg][P_4Du]":["–ller:atek"],"[V][CtmpI][Trns][A_3Sg][P_4Pl]":["–ller:ateng"],"[V][CtmpI][Trns][A_3Sg][P_4Sg]":["–ller:ani"],"[V][CtmpI][Trns][A_4Du][P_1Du]":["–ller+megnekuk"],"[V][CtmpI][Trns][A_4Du][P_1Pl]":["–ller+megnekut"],"[V][CtmpI][Trns][A_4Du][P_1Sg]":["–ller+megnenga"],"[V][CtmpI][Trns][A_4Du][P_2Du]":["–ller+megnetek"],"[V][CtmpI][Trns][A_4Du][P_2Pl]":["–ller+megneci"],"[V][CtmpI][Trns][A_4Du][P_2Sg]":["–ller+megnegen"],"[V][CtmpI][Trns][A_4Du][P_3Du]":["–ller+megnekek"],"[V][CtmpI][Trns][A_4Du][P_3Pl]":["–ller+megneki"],"[V][CtmpI][Trns][A_4Du][P_3Sg]":["–ller+megnegu"],"[V][CtmpI][Trns][A_4Pl][P_1Du]":["–ller+megtekuk"],"[V][CtmpI][Trns][A_4Pl][P_1Pl]":["–ller+megtekut"],"[V][CtmpI][Trns][A_4Pl][P_1Sg]":["–ller+megtenga"],"[V][CtmpI][Trns][A_4Pl][P_2Du]":["–ller+megcetek"],"[V][CtmpI][Trns][A_4Pl][P_2Pl]":["–ller+megceci"],"[V][CtmpI][Trns][A_4Pl][P_2Sg]":["–ller+megteggen"],"[V][CtmpI][Trns][A_4Pl][P_3Du]":["–ller+megtekek"],"[V][CtmpI][Trns][A_4Pl][P_3Pl]":["–ller+megteki"],"[V][CtmpI][Trns][A_4Pl][P_3Sg]":["–ller+megteggu"],"[V][CtmpI][Trns][A_4Sg][P_1Du]":["–ller+minikuk"],"[V][CtmpI][Trns][A_4Sg][P_1Pl]":["–ller+minikut"],"[V][CtmpI][Trns][A_4Sg][P_1Sg]":["–ller+minia"],"[V][CtmpI][Trns][A_4Sg][P_2Du]":["–ller+minitek"],"[V][CtmpI][Trns][A_4Sg][P_2Pl]":["–ller+minici"],"[V][CtmpI][Trns][A_4Sg][P_2Sg]":["–ller+miniten"],"[V][CtmpI][Trns][A_4Sg][P_3Du]":["–ller+minikek"],"[V][CtmpI][Trns][A_4Sg][P_3Pl]":["–ller+miniki"],"[V][CtmpI][Trns][A_4Sg][P_3Sg]":["–ller+miniu"],"[V][Ind][Intr][S_1Du]":["+'(g/t)ukuk"],"[V][Ind][Intr][S_1Pl]":["+'(g/t)ukut"],"[V][Ind][Intr][S_1Sg]":["+'(g/t)u:nga"],"[V][Ind][Intr][S_2Du]":["+'(g/t)utek"],"[V][Ind][Intr][S_2Pl]":["+'(g/t)uci"],"[V][Ind][Intr][S_2Sg]":["+'(g/t)uten"],"[V][Ind][Intr][S_3Du]":["+'(g/t)uk"],"[V][Ind][Intr][S_3Pl]":["+'(g/t)ut"],"[V][Ind][Intr][S_3Sg]":["+'(g/t)uq"],"[V][Ind][Trns][A_1Du][P_2Du]":["+'(g)amegtek"],"[V][Ind][Trns][A_1Du][P_2Pl]":["+'(g)amegci"],"[V][Ind][Trns][A_1Du][P_2Sg]":["+'(g)amegten"],"[V][Ind][Trns][A_1Du][P_3Du]":["+'(g)agpuk"],"[V][Ind][Trns][A_1Du][P_3Pl]":["+'(g)apuk"],"[V][Ind][Trns][A_1Du][P_3Sg]":["+'(g)apuk","+'(g)arpuk"],"[V][Ind][Trns][A_1Pl][P_2Du]":["+'(g)amcetek"],"[V][Ind][Trns][A_1Pl][P_2Pl]":["+'(g)amceci"],"[V][Ind][Trns][A_1Pl][P_2Sg]":["+'(g)amteggen"],"[V][Ind][Trns][A_1Pl][P_3Du]":["+'(g)agput"],"[V][Ind][Trns][A_1Pl][P_3Pl]":["+'(g)aput"],"[V][Ind][Trns][A_1Pl][P_3Sg]":["+'(g)aput","+'(g)arput"],"[V][Ind][Trns][A_1Sg][P_2Du]":["+'(g)amtek"],"[V][Ind][Trns][A_1Sg][P_2Pl]":["+'(g)amci"],"[V][Ind][Trns][A_1Sg][P_2Sg]":["+'(g)amken"],"[V][Ind][Trns][A_1Sg][P_3Du]":["+'(g)agka"],"[V][Ind][Trns][A_1Sg][P_3Pl]":["+'(g)anka"],"[V][Ind][Trns][A_1Sg][P_3Sg]":["+'(g)aqa"],"[V][Ind][Trns][A_2Du][P_1Du]":["+'(g)avtegkuk","+'(g)arpetegkuk"],"[V][Ind][Trns][A_2Du][P_1Pl]":["+'(g)avtegkut","+'(g)arpetegkut"],"[V][Ind][Trns][A_2Du][P_1Sg]":["+'(g)avtegnenga","+'(g)avtegnga","+'(g)arpetegnenga","+'(g)arpetegnga"],"[V][Ind][Trns][A_2Du][P_3Du]":["+'(g)agtek"],"[V][Ind][Trns][A_2Du][P_3Pl]":["+'(g)atek"],"[V][Ind][Trns][A_2Du][P_3Sg]":["+'(g)atek","+'(g)artek"],"[V][Ind][Trns][A_2Pl][P_1Du]":["+'(g)avcikuk","+'(g)arpecikuk"],"[V][Ind][Trns][A_2Pl][P_1Pl]":["+'(g)avcikut","+'(g)arpecikut"],"[V][Ind][Trns][A_2Pl][P_1Sg]":["+'(g)avcia","+'(g)arpecia"],"[V][Ind][Trns][A_2Pl][P_3Du]":["+'(g)agci"],"[V][Ind][Trns][A_2Pl][P_3Pl]":["+'(g)aci"],"[V][Ind][Trns][A_2Pl][P_3Sg]":["+'(g)aci","+'(g)arci"],"[V][Ind][Trns][A_2Sg][P_1Du]":["+'(g)avkuk","+'(g)arpekuk"],"[V][Ind][Trns][A_2Sg][P_1Pl]":["+'(g)avkut","+'(g)arpekut"],"[V][Ind][Trns][A_2Sg][P_1Sg]":["+'(g)avnga","+'(g)arpenga"],"[V][Ind][Trns][A_2Sg][P_3Du]":["+'(g)agken"],"[V][Ind][Trns][A_2Sg][P_3Pl]":["+'(g)aten"],"[V][Ind][Trns][A_2Sg][P_3Sg]":["+'(g)an"],"[V][Ind][Trns][A_3Du][P_1Du]":["+'(g)aagkuk"],"[V][Ind][Trns][A_3Du][P_1Pl]":["+'(g)aagkut"],"[V][Ind][Trns][A_3Du][P_1Sg]":["+'(g)aagnenga","+'(g)aagnga"],"[V][Ind][Trns][A_3Du][P_2Du]":["+'(g)aagtek"],"[V][Ind][Trns][A_3Du][P_2Pl]":["+'(g)aagci"],"[V][Ind][Trns][A_3Du][P_2Sg]":["+'(g)aagten"],"[V][Ind][Trns][A_3Du][P_3Du]":["+'(g)agkek"],"[V][Ind][Trns][A_3Du][P_3Pl]":["+'(g)akek"],"[V][Ind][Trns][A_3Du][P_3Sg]":["+'(g)aak"],"[V][Ind][Trns][A_3Pl][P_1Du]":["+'(g)aitkuk"],"[V][Ind][Trns][A_3Pl][P_1Pl]":["+'(g)aitkut"],"[V][Ind][Trns][A_3Pl][P_1Sg]":["+'(g)aatnga"],"[V][Ind][Trns][A_3Pl][P_2Du]":["+'(g)aicetek"],"[V][Ind][Trns][A_3Pl][P_2Pl]":["+'(g)aiceci"],"[V][Ind][Trns][A_3Pl][P_2Sg]":["+'(g)aatgen"],"[V][Ind][Trns][A_3Pl][P_3Du]":["+'(g)agket"],"[V][Ind][Trns][A_3Pl][P_3Pl]":["+'(g)ait"],"[V][Ind][Trns][A_3Pl][P_3Sg]":["+'(g)aat"],"[V][Ind][Trns][A_3Sg][P_1Du]":["+'(g)aakuk"],"[V][Ind][Trns][A_3Sg][P_1Pl]":["+'(g)aakut"],"[V][Ind][Trns][A_3Sg][P_1Sg]":["+'(g)aanga"],"[V][Ind][Trns][A_3Sg][P_2Du]":["+'(g)aatek"],"[V][Ind][Trns][A_3Sg][P_2Pl]":["+'(g)aaci"],"[V][Ind][Trns][A_3Sg][P_2Sg]":["+'(g)aaten"],"[V][Ind][Trns][A_3Sg][P_3Du]":["+'(g)ak"],"[V][Ind][Trns][A_3Sg][P_3Pl]":["+'(g)ai"],"[V][Ind][Trns][A_3Sg][P_3Sg]":["+'(g)aa"],"[V][Intrg][Intr][S_1Du]":["@~+cen̄uk","@~+cen̄ung"],"[V][Intrg][Intr][S_1Pl]":["@~+ceta"],"[V][Intrg][Intr][S_1Sg]":["~+(t)sia","~+(t)yia"],"[V][Intrg][Intr][S_2Du]":["@~+cetek"],"[V][Intrg][Intr][S_2Pl]":["@~+ceci","+(s)tessi"],"[V][Intrg][Intr][S_2Sg]":["~+(t)sit","~+(t)yit"],"[V][Intrg][Intr][S_3Du]":["+'(g/t)ak"],"[V][Intrg][Intr][S_3Pl]":["+'(g/t)at"],"[V][Intrg][Intr][S_3Sg]":["+'(g/t)a"],"[V][Intrg][Trns][A_1Sg][P_2Sg]":["~+(t)siken","~+(t)yiken"],"[V][Intrg][Trns][A_2Du][P_1Du]":["@~+cetegkuk"],"[V][Intrg][Trns][A_2Du][P_1Pl]":["@~+cetegkut"],"[V][Intrg][Trns][A_2Du][P_1Sg]":["@~+cetegnga"],"[V][Intrg][Trns][A_2Du][P_3Du]":["@~+cetegkek"],"[V][Intrg][Trns][A_2Du][P_3Pl]":["@~+cetegki"],"[V][Intrg][Trns][A_2Du][P_3Sg]":["@~+cetegnegu"],"[V][Intrg][Trns][A_2Pl][P_1Du]":["@~+cecikuk"],"[V][Intrg][Trns][A_2Pl][P_1Pl]":["@~+cecikut"],"[V][Intrg][Trns][A_2Pl][P_1Sg]":["@~+cecia"],"[V][Intrg][Trns][A_2Pl][P_3Du]":["@~+cecikek"],"[V][Intrg][Trns][A_2Pl][P_3Pl]":["@~+ceciki"],"[V][Intrg][Trns][A_2Pl][P_3Sg]":["@~+ceciu"],"[V][Intrg][Trns][A_2Sg][P_1Du]":["~+(t)sikuk","~+(t)yikuk"],"[V][Intrg][Trns][A_2Sg][P_1Pl]":["~+(t)sikut","~+(t)yikut"],"[V][Intrg][Trns][A_2Sg][P_1Sg]":["~+(t)sia","~+(t)yia"],"[V][Intrg][Trns][A_2Sg][P_3Du]":["~+(t)sikek","~+(t)yikek"],"[V][Intrg][Trns][A_2Sg][P_3Pl]":["~+(t)siki","~+(t)yiki"],"[V][Intrg][Trns][A_2Sg][P_3Sg]":["~+(t)siu","~+(t)yiu"],"[V][Intrg][Trns][A_3Du][P_1Du]":["+'(g/t)agkuk","+'(g/t)agnekuk"],"[V][Intrg][Trns][A_3Du][P_1Pl]":["+'(g/t)agkut","+'(g/t)agnekut"],"[V][Intrg][Trns][A_3Du][P_1Sg]":["+'(g/t)agnenga","+'(g/t)agnga"],"[V][Intrg][Trns][A_3Du][P_2Du]":["+'(g/t)agtek","+'(g/t)agnetek"],"[V][Intrg][Trns][A_3Du][P_2Pl]":["+'(g/t)agneci","+'(g/t)agci"],"[V][Intrg][Trns][A_3Du][P_2Sg]":["+'(g/t)agten","+'(g/t)agneten"],"[V][Intrg][Trns][A_3Du][P_3Du]":["+'(g/t)agkek","+'(g/t)agnekek"],"[V][Intrg][Trns][A_3Du][P_3Pl]":["+'(g/t)agki","+'(g/t)agneki"],"[V][Intrg][Trns][A_3Du][P_3Sg]":["+'(g/t)agnegu","+'(g/t)anʼgu"],"[V][Intrg][Trns][A_3Pl][P_1Du]":["+'(g/t)atkuk"],"[V][Intrg][Trns][A_3Pl][P_1Pl]":["+'(g/t)atkut"],"[V][Intrg][Trns][A_3Pl][P_1Sg]":["+'(g/t)atnga"],"[V][Intrg][Trns][A_3Pl][P_2Du]":["+'(g/t)acetek"],"[V][Intrg][Trns][A_3Pl][P_2Pl]":["+'(g/t)aceci"],"[V][Intrg][Trns][A_3Pl][P_2Sg]":["+'(g/t)atgen"],"[V][Intrg][Trns][A_3Pl][P_3Du]":["+'(g/t)atkek"],"[V][Intrg][Trns][A_3Pl][P_3Pl]":["+'(g/t)atki"],"[V][Intrg][Trns][A_3Pl][P_3Sg]":["+'(g/t)atgu"],"[V][Intrg][Trns][A_3Sg][P_1Du]":["+'(g/t)akuk"],"[V][Intrg][Trns][A_3Sg][P_1Pl]":["+'(g/t)akut"],"[V][Intrg][Trns][A_3Sg][P_1Sg]":["+'(g/t)anga"],"[V][Intrg][Trns][A_3Sg][P_2Du]":["+'(g/t)atek"],"[V][Intrg][Trns][A_3Sg][P_2Pl]":["+'(g/t)aci"],"[V][Intrg][Trns][A_3Sg][P_2Sg]":["+'(g/t)aten"],"[V][Intrg][Trns][A_3Sg][P_3Du]":["+'(g/t)akek"],"[V][Intrg][Trns][A_3Sg][P_3Pl]":["+'(g/t)aki"],"[V][Intrg][Trns][A_3Sg][P_3Sg]":["+'(g/t)a:gu"],"[V][Opt][Intr][FUT][NEG][S_2Du]":["@~+yaqunatek"],"[V][Opt][Intr][FUT][NEG][S_2Pl]":["@~+yaqunaci"],"[V][Opt][Intr][FUT][NEG][S_2Sg]":["@~+yaqunak"],"[V][Opt][Intr][FUT][S_1Du]":["@~–kiluk"],"[V][Opt][Intr][FUT][S_1Pl]":["@~–kilta"],"[V][Opt][Intr][FUT][S_1Sg]":["@~–kilii"],"[V][Opt][Intr][FUT][S_2Du]":["@~–kitek"],"[V][Opt][Intr][FUT][S_2Pl]":["@~–kici"],"[V][Opt][Intr][FUT][S_2Sg]":["@~–kina"],"[V][Opt][Intr][FUT][S_3Du]":["@~–kilik"],"[V][Opt][Intr][FUT][S_3Pl]":["@~–kilit"],"[V][Opt][Intr][FUT][S_3Sg]":["@~–kili"],"[V][Opt][Intr][PRS][NEG][S_2Du]":["~viiqnatek","@+piiqnatek"],"[V][Opt][Intr][PRS][NEG][S_2Pl]":["~viiqnaci","@+piiqnaci"],"[V][Opt][Intr][PRS][NEG][S_2Sg]":["~viiqnak","@+piiqnak"],"[V][Opt][Intr][PRS][S_1Du]":["@~+luk"],"[V][Opt][Intr][PRS][S_1Pl]":["%:(e)lta","–lta"],"[V][Opt][Intr][PRS][S_1Sg]":["@~+lii"],"[V][Opt][Intr][PRS][S_2Du]":["@+tek","~(g)itek"],"[V][Opt][Intr][PRS][S_2Pl]":["@+ci","~(g)ici"],"[V][Opt][Intr][PRS][S_2Sg]":[":a","@lu","","~(g)i","+n"],"[V][Opt][Intr][PRS][S_3Du]":["@~+lik"],"[V][Opt][Intr][PRS][S_3Pl]":["@~+lit"],"[V][Opt][Intr][PRS][S_3Sg]":["@~+li"],"[V][Opt][Trns][FUT][A_1Du][P_2Du]":["@~–kilamegtek"],"[V][Opt][Trns][FUT][A_1Du][P_2Pl]":["@~–kilamegci"],"[V][Opt][Trns][FUT][A_1Du][P_2Sg]":["@~–kilamegten"],"[V][Opt][Trns][FUT][A_1Du][P_3Du]":["@~–kilagpuk"],"[V][Opt][Trns][FUT][A_1Du][P_3Pl]":["@~–kilapuk"],"[V][Opt][Trns][FUT][A_1Du][P_3Sg]":["@~–kilauk"],"[V][Opt][Trns][FUT][A_1Pl][P_2Du]":["@~–kilamcetek"],"[V][Opt][Trns][FUT][A_1Pl][P_2Pl]":["@~–kilamceci"],"[V][Opt][Trns][FUT][A_1Pl][P_2Sg]":["@~–kilamteggen"],"[V][Opt][Trns][FUT][A_1Pl][P_3Du]":["@~–kilagput"],"[V][Opt][Trns][FUT][A_1Pl][P_3Pl]":["@~–kilaput"],"[V][Opt][Trns][FUT][A_1Pl][P_3Sg]":["@~–kilaut"],"[V][Opt][Trns][FUT][A_1Sg][P_2Du]":["@~–kilamtek"],"[V][Opt][Trns][FUT][A_1Sg][P_2Pl]":["@~–kilamci"],"[V][Opt][Trns][FUT][A_1Sg][P_2Sg]":["@~–kilaken","@~–kilamken"],"[V][Opt][Trns][FUT][A_1Sg][P_3Du]":["@~–kilakek"],"[V][Opt][Trns][FUT][A_1Sg][P_3Pl]":["@~–kilaki"],"[V][Opt][Trns][FUT][A_1Sg][P_3Sg]":["@~–kilaku"],"[V][Opt][Trns][FUT][A_2Du][P_1Du]":["@~–kitegkuk"],"[V][Opt][Trns][FUT][A_2Du][P_1Pl]":["@~–kitegkut"],"[V][Opt][Trns][FUT][A_2Du][P_1Sg]":["@~–kitegnga"],"[V][Opt][Trns][FUT][A_2Du][P_3Du]":["@~–kitegkek"],"[V][Opt][Trns][FUT][A_2Du][P_3Pl]":["@~–kitegki"],"[V][Opt][Trns][FUT][A_2Du][P_3Sg]":["@~–kitegu"],"[V][Opt][Trns][FUT][A_2Pl][P_1Du]":["@~–kicikuk"],"[V][Opt][Trns][FUT][A_2Pl][P_1Pl]":["@~–kicikut"],"[V][Opt][Trns][FUT][A_2Pl][P_1Sg]":["@~–kicia"],"[V][Opt][Trns][FUT][A_2Pl][P_3Du]":["@~–kicikek"],"[V][Opt][Trns][FUT][A_2Pl][P_3Pl]":["@~–kiciki"],"[V][Opt][Trns][FUT][A_2Pl][P_3Sg]":["@~–kiciu"],"[V][Opt][Trns][FUT][A_2Sg][P_1Du]":["@~–kikuk"],"[V][Opt][Trns][FUT][A_2Sg][P_1Pl]":["@~–kikut"],"[V][Opt][Trns][FUT][A_2Sg][P_1Sg]":["@~–kia"],"[V][Opt][Trns][FUT][A_2Sg][P_3Du]":["@~–kikek"],"[V][Opt][Trns][FUT][A_2Sg][P_3Pl]":["@~–kiki"],"[V][Opt][Trns][FUT][A_2Sg][P_3Sg]":["@~–kiu"],"[V][Opt][Trns][FUT][A_3Du][P_1Du]":["@~–kiligkuk","@~–kilignekuk"],"[V][Opt][Trns][FUT][A_3Du][P_1Pl]":["@~–kiligkut","@~–kilignekut"],"[V][Opt][Trns][FUT][A_3Du][P_1Sg]":["@~–kilignenga","@~–kilignga"],"[V][Opt][Trns][FUT][A_3Du][P_2Du]":["@~–kiligtek","@~–kilignetek"],"[V][Opt][Trns][FUT][A_3Du][P_2Pl]":["@~–kiligneci","@~–kiligci"],"[V][Opt][Trns][FUT][A_3Du][P_2Sg]":["@~–kiligten","@~–kiligneten"],"[V][Opt][Trns][FUT][A_3Du][P_3Du]":["@~–kiligkek","@~–kilignekek"],"[V][Opt][Trns][FUT][A_3Du][P_3Pl]":["@~–kiligki","@~–kiligneki"],"[V][Opt][Trns][FUT][A_3Du][P_3Sg]":["@~–kilignegu","@~–kilinʼgu"],"[V][Opt][Trns][FUT][A_3Pl][P_1Du]":["@~–kilitkuk"],"[V][Opt][Trns][FUT][A_3Pl][P_1Pl]":["@~–kilitkut"],"[V][Opt][Trns][FUT][A_3Pl][P_1Sg]":["@~–kilitnga"],"[V][Opt][Trns][FUT][A_3Pl][P_2Du]":["@~–kilicetek"],"[V][Opt][Trns][FUT][A_3Pl][P_2Pl]":["@~–kiliceci"],"[V][Opt][Trns][FUT][A_3Pl][P_2Sg]":["@~–kilitgen"],"[V][Opt][Trns][FUT][A_3Pl][P_3Du]":["@~–kilitkek"],"[V][Opt][Trns][FUT][A_3Pl][P_3Pl]":["@~–kilitki"],"[V][Opt][Trns][FUT][A_3Pl][P_3Sg]":["@~–kilitgu"],"[V][Opt][Trns][FUT][A_3Sg][P_1Du]":["@~–kilikuk"],"[V][Opt][Trns][FUT][A_3Sg][P_1Pl]":["@~–kilikut"],"[V][Opt][Trns][FUT][A_3Sg][P_1Sg]":["@~–kilinga"],"[V][Opt][Trns][FUT][A_3Sg][P_2Du]":["@~–kilitek"],"[V][Opt][Trns][FUT][A_3Sg][P_2Pl]":["@~–kilici"],"[V][Opt][Trns][FUT][A_3Sg][P_2Sg]":["@~–kiliten"],"[V][Opt][Trns][FUT][A_3Sg][P_3Du]":["@~–kilikek"],"[V][Opt][Trns][FUT][A_3Sg][P_3Pl]":["@~–kiliki"],"[V][Opt][Trns][FUT][A_3Sg][P_3Sg]":["@~–kiliu"],"[V][Opt][Trns][FUT][NEG][A_2Du][P_1Du]":["@~+yaqunategkuk"],"[V][Opt][Trns][FUT][NEG][A_2Du][P_1Pl]":["@~+yaqunategkut"],"[V][Opt][Trns][FUT][NEG][A_2Du][P_1Sg]":["@~+yaqunategnga"],"[V][Opt][Trns][FUT][NEG][A_2Du][P_3Du]":["@~+yaqunategkek"],"[V][Opt][Trns][FUT][NEG][A_2Du][P_3Pl]":["@~+yaqunategki"],"[V][Opt][Trns][FUT][NEG][A_2Du][P_3Sg]":["@~+yaqunategu"],"[V][Opt][Trns][FUT][NEG][A_2Pl][P_1Du]":["@~+yaqunacikuk"],"[V][Opt][Trns][FUT][NEG][A_2Pl][P_1Pl]":["@~+yaqunacikut"],"[V][Opt][Trns][FUT][NEG][A_2Pl][P_1Sg]":["@~+yaqunacia"],"[V][Opt][Trns][FUT][NEG][A_2Pl][P_3Du]":["@~+yaqunacikek"],"[V][Opt][Trns][FUT][NEG][A_2Pl][P_3Pl]":["@~+yaqunaciki"],"[V][Opt][Trns][FUT][NEG][A_2Pl][P_3Sg]":["@~+yaqunaciu"],"[V][Opt][Trns][FUT][NEG][A_2Sg][P_1Du]":["@~+yaqunakuk"],"[V][Opt][Trns][FUT][NEG][A_2Sg][P_1Pl]":["@~+yaqunakut"],"[V][Opt][Trns][FUT][NEG][A_2Sg][P_1Sg]":["@~+yaquna:nga"],"[V][Opt][Trns][FUT][NEG][A_2Sg][P_3Du]":["@~+yaqunakek"],"[V][Opt][Trns][FUT][NEG][A_2Sg][P_3Pl]":["@~+yaqunaki"],"[V][Opt][Trns][FUT][NEG][A_2Sg][P_3Sg]":["@~+yaqunaku"],"[V][Opt][Trns][PRS][A_1Du][P_2Du]":["@~+lamegtek"],"[V][Opt][Trns][PRS][A_1Du][P_2Pl]":["@~+lamegci"],"[V][Opt][Trns][PRS][A_1Du][P_2Sg]":["@~+lamegten"],"[V][Opt][Trns][PRS][A_1Du][P_3Du]":["@~+lagpuk"],"[V][Opt][Trns][PRS][A_1Du][P_3Pl]":["@~+lapuk"],"[V][Opt][Trns][PRS][A_1Du][P_3Sg]":["@~+lauk"],"[V][Opt][Trns][PRS][A_1Pl][P_2Du]":["@~+lamcetek"],"[V][Opt][Trns][PRS][A_1Pl][P_2Pl]":["@~+lamceci"],"[V][Opt][Trns][PRS][A_1Pl][P_2Sg]":["@~+lamteggen"],"[V][Opt][Trns][PRS][A_1Pl][P_3Du]":["@~+lagput"],"[V][Opt][Trns][PRS][A_1Pl][P_3Pl]":["@~+laput"],"[V][Opt][Trns][PRS][A_1Pl][P_3Sg]":["@~+laut"],"[V][Opt][Trns][PRS][A_1Sg][P_2Du]":["@~+lamtek"],"[V][Opt][Trns][PRS][A_1Sg][P_2Pl]":["@~+lamci"],"[V][Opt][Trns][PRS][A_1Sg][P_2Sg]":["@~+laken","@~+lamken"],"[V][Opt][Trns][PRS][A_1Sg][P_3Du]":["@~+lakek"],"[V][Opt][Trns][PRS][A_1Sg][P_3Pl]":["@~+laki"],"[V][Opt][Trns][PRS][A_1Sg][P_3Sg]":["@~+laku"],"[V][Opt][Trns][PRS][A_2Du][P_1Du]":["@+tegkuk"],"[V][Opt][Trns][PRS][A_2Du][P_1Pl]":["@+tegkut"],"[V][Opt][Trns][PRS][A_2Du][P_1Sg]":["@+tegnga"],"[V][Opt][Trns][PRS][A_2Du][P_3Du]":["@+tegkek"],"[V][Opt][Trns][PRS][A_2Du][P_3Pl]":["@+tegki"],"[V][Opt][Trns][PRS][A_2Du][P_3Sg]":["@+tegu"],"[V][Opt][Trns][PRS][A_2Pl][P_1Du]":["@+cikuk"],"[V][Opt][Trns][PRS][A_2Pl][P_1Pl]":["@+cikut"],"[V][Opt][Trns][PRS][A_2Pl][P_1Sg]":["@+cia"],"[V][Opt][Trns][PRS][A_2Pl][P_3Du]":["@+cikek"],"[V][Opt][Trns][PRS][A_2Pl][P_3Pl]":["@+ciki"],"[V][Opt][Trns][PRS][A_2Pl][P_3Sg]":["@+ciu"],"[V][Opt][Trns][PRS][A_2Sg][P_1Du]":["@+kuk","~(g)ikuk"],"[V][Opt][Trns][PRS][A_2Sg][P_1Pl]":["@+kut","~(g)ikut"],"[V][Opt][Trns][PRS][A_2Sg][P_1Sg]":["~(g)ia","@+nga"],"[V][Opt][Trns][PRS][A_2Sg][P_3Du]":["@+kek","~(g)ikek"],"[V][Opt][Trns][PRS][A_2Sg][P_3Pl]":["@+ki","~(g)iki"],"[V][Opt][Trns][PRS][A_2Sg][P_3Sg]":["@gu","u","~(g)iu"],"[V][Opt][Trns][PRS][A_3Du][P_1Du]":["@~+ligkuk","@~+lignekuk"],"[V][Opt][Trns][PRS][A_3Du][P_1Pl]":["@~+ligkut","@~+lignekut"],"[V][Opt][Trns][PRS][A_3Du][P_1Sg]":["@~+lignenga","@~+lignga"],"[V][Opt][Trns][PRS][A_3Du][P_2Du]":["@~+ligtek","@~+lignetek"],"[V][Opt][Trns][PRS][A_3Du][P_2Pl]":["@~+ligneci","@~+ligci"],"[V][Opt][Trns][PRS][A_3Du][P_2Sg]":["@~+ligten","@~+ligneten"],"[V][Opt][Trns][PRS][A_3Du][P_3Du]":["@~+ligkek","@~+lignekek"],"[V][Opt][Trns][PRS][A_3Du][P_3Pl]":["@~+ligki","@~+ligneki"],"[V][Opt][Trns][PRS][A_3Du][P_3Sg]":["@~+lignegu","@~linʼgu"],"[V][Opt][Trns][PRS][A_3Pl][P_1Du]":["@~+litkuk"],"[V][Opt][Trns][PRS][A_3Pl][P_1Pl]":["@~+litkut"],"[V][Opt][Trns][PRS][A_3Pl][P_1Sg]":["@~+litnga"],"[V][Opt][Trns][PRS][A_3Pl][P_2Du]":["@~+licetek"],"[V][Opt][Trns][PRS][A_3Pl][P_2Pl]":["@~+liceci"],"[V][Opt][Trns][PRS][A_3Pl][P_2Sg]":["@~+litgen"],"[V][Opt][Trns][PRS][A_3Pl][P_3Du]":["@~+litkek"],"[V][Opt][Trns][PRS][A_3Pl][P_3Pl]":["@~+litki"],"[V][Opt][Trns][PRS][A_3Pl][P_3Sg]":["@~+litgu"],"[V][Opt][Trns][PRS][A_3Sg][P_1Du]":["@~+likuk"],"[V][Opt][Trns][PRS][A_3Sg][P_1Pl]":["@~+likut"],"[V][Opt][Trns][PRS][A_3Sg][P_1Sg]":["@~+lia","@~+linga"],"[V][Opt][Trns][PRS][A_3Sg][P_2Du]":["@~+litek"],"[V][Opt][Trns][PRS][A_3Sg][P_2Pl]":["@~+lici"],"[V][Opt][Trns][PRS][A_3Sg][P_2Sg]":["@~+liten"],"[V][Opt][Trns][PRS][A_3Sg][P_3Du]":["@~+likek"],"[V][Opt][Trns][PRS][A_3Sg][P_3Pl]":["@~+liki"],"[V][Opt][Trns][PRS][A_3Sg][P_3Sg]":["@~+liku","@~+liu"],"[V][Opt][Trns][PRS][NEG][A_2Du][P_1Du]":["~viiqnategkuk","@+piiqnategkuk"],"[V][Opt][Trns][PRS][NEG][A_2Du][P_1Pl]":["~viiqnategkut","@+piiqnategkut"],"[V][Opt][Trns][PRS][NEG][A_2Du][P_1Sg]":["~viiqnategnga","@+piiqnategnga"],"[V][Opt][Trns][PRS][NEG][A_2Du][P_3Du]":["~viiqnategkek","@+piiqnategkek"],"[V][Opt][Trns][PRS][NEG][A_2Du][P_3Pl]":["~viiqnategki","@+piiqnategki"],"[V][Opt][Trns][PRS][NEG][A_2Du][P_3Sg]":["~viiqnategu","@+piiqnategu"],"[V][Opt][Trns][PRS][NEG][A_2Pl][P_1Du]":["~viiqnacikuk","@+piiqnacikuk"],"[V][Opt][Trns][PRS][NEG][A_2Pl][P_1Pl]":["~viiqnacikut","@+piiqnacikut"],"[V][Opt][Trns][PRS][NEG][A_2Pl][P_1Sg]":["~viiqnacia","@+piiqnacia"],"[V][Opt][Trns][PRS][NEG][A_2Pl][P_3Du]":["~viiqnacikek","@+piiqnacikek"],"[V][Opt][Trns][PRS][NEG][A_2Pl][P_3Pl]":["~viiqnaciki","@+piiqnaciki"],"[V][Opt][Trns][PRS][NEG][A_2Pl][P_3Sg]":["~viiqnaciu","@+piiqnaciu"],"[V][Opt][Trns][PRS][NEG][A_2Sg][P_1Du]":["~viiqnakuk","@+piiqnakuk"],"[V][Opt][Trns][PRS][NEG][A_2Sg][P_1Pl]":["~viiqnakut","@+piiqnakut"],"[V][Opt][Trns][PRS][NEG][A_2Sg][P_1Sg]":["~viiqna:nga","@+piiqna:nga"],"[V][Opt][Trns][PRS][NEG][A_2Sg][P_3Du]":["~viiqnakek","@+piiqnakek"],"[V][Opt][Trns][PRS][NEG][A_2Sg][P_3Pl]":["~viiqnaki","@+piiqnaki"],"[V][Opt][Trns][PRS][NEG][A_2Sg][P_3Sg]":["~viiqnaku","@+piiqnaku"],"[V][Prec][Intr][S_1Du]":["~vaileg–megnuk","@+paileg–megnuk"],"[V][Prec][Intr][S_1Pl]":["~vaileg–mta","@+paileg–mta"],"[V][Prec][Intr][S_1Sg]":["~vaileg+ma","@+paileg+ma"],"[V][Prec][Intr][S_2Du]":["~vaileg+petek","@+paileg+petek"],"[V][Prec][Intr][S_2Pl]":["~vaileg+peci","@+paileg+peci"],"[V][Prec][Intr][S_2Sg]":["~vaileg+pet","@+paileg+pet"],"[V][Prec][Intr][S_3Du]":["~vaileg:agnek","@+paileg:agnek"],"[V][Prec][Intr][S_3Pl]":["~vaileg:ata","@+paileg:ata"],"[V][Prec][Intr][S_3Sg]":["~vaileg:an","@+paileg:an"],"[V][Prec][Intr][S_4Du]":["~vaileg+mek","@+paileg+mek"],"[V][Prec][Intr][S_4Pl]":["~vaileg+meng","@+paileg+meng"],"[V][Prec][Intr][S_4Sg]":["~vaileg+mi","@+paileg+mi"],"[V][Prec][Trns][A_1Du][P_2Du]":["~vaileg–megtek","@+paileg–megtek"],"[V][Prec][Trns][A_1Du][P_2Pl]":["~vaileg–megci","@+paileg–megci"],"[V][Prec][Trns][A_1Du][P_2Sg]":["~vaileg–megten","@+paileg–megten"],"[V][Prec][Trns][A_1Du][P_3Du]":["~vaileg–megkek","@+paileg–megkek"],"[V][Prec][Trns][A_1Du][P_3Pl]":["~vaileg–megki","@+paileg–megki"],"[V][Prec][Trns][A_1Du][P_3Sg]":["~vaileg–megnegu","@+paileg–megnegu"],"[V][Prec][Trns][A_1Du][P_4Du]":["~vaileg–megtek","@+paileg–megtek"],"[V][Prec][Trns][A_1Du][P_4Pl]":["~vaileg–megteng","@+paileg–megteng"],"[V][Prec][Trns][A_1Du][P_4Sg]":["~vaileg–megni","@+paileg–megni"],"[V][Prec][Trns][A_1Pl][P_2Du]":["~vaileg–mcetek","@+paileg–mcetek"],"[V][Prec][Trns][A_1Pl][P_2Pl]":["~vaileg–mceci","@+paileg–mceci"],"[V][Prec][Trns][A_1Pl][P_2Sg]":["~vaileg–mteggen","@+paileg–mteggen"],"[V][Prec][Trns][A_1Pl][P_3Du]":["~vaileg–mtekek","@+paileg–mtekek"],"[V][Prec][Trns][A_1Pl][P_3Pl]":["~vaileg–mteki","@+paileg–mteki"],"[V][Prec][Trns][A_1Pl][P_3Sg]":["~vaileg–mteggu","@+paileg–mteggu"],"[V][Prec][Trns][A_1Pl][P_4Du]":["~vaileg–mcetek","@+paileg–mcetek"],"[V][Prec][Trns][A_1Pl][P_4Pl]":["~vaileg–mceteng","@+paileg–mceteng"],"[V][Prec][Trns][A_1Pl][P_4Sg]":["~vaileg–mten̄i","@+paileg–mten̄i"],"[V][Prec][Trns][A_1Sg][P_2Du]":["~vaileg–mtek","@+paileg–mtek"],"[V][Prec][Trns][A_1Sg][P_2Pl]":["~vaileg–mci","@+paileg–mci"],"[V][Prec][Trns][A_1Sg][P_2Sg]":["~vaileg–mken","@+paileg–mken"],"[V][Prec][Trns][A_1Sg][P_3Du]":["~vaileg–mkek","@+paileg–mkek"],"[V][Prec][Trns][A_1Sg][P_3Pl]":["~vaileg–mki","@+paileg–mki"],"[V][Prec][Trns][A_1Sg][P_3Sg]":["~vaileg–mku","@+paileg–mku"],"[V][Prec][Trns][A_1Sg][P_4Du]":["~vaileg–mtek","@+paileg–mtek"],"[V][Prec][Trns][A_1Sg][P_4Pl]":["~vaileg–mteng","@+paileg–mteng"],"[V][Prec][Trns][A_1Sg][P_4Sg]":["~vaileg–mni","@+paileg–mni"],"[V][Prec][Trns][A_2Du][P_1Du]":["~vaileg+petegkuk","@+paileg+petegkuk"],"[V][Prec][Trns][A_2Du][P_1Pl]":["~vaileg+petegkut","@+paileg+petegkut"],"[V][Prec][Trns][A_2Du][P_1Sg]":["~vaileg+petegnga","@+paileg+petegnga"],"[V][Prec][Trns][A_2Du][P_3Du]":["~vaileg+petegkek","@+paileg+petegkek"],"[V][Prec][Trns][A_2Du][P_3Pl]":["~vaileg+petegki","@+paileg+petegki"],"[V][Prec][Trns][A_2Du][P_3Sg]":["~vaileg+petegnegu","@+paileg+petegnegu"],"[V][Prec][Trns][A_2Du][P_4Du]":["~vaileg+petegtek","@+paileg+petegtek"],"[V][Prec][Trns][A_2Du][P_4Pl]":["~vaileg+petegteng","@+paileg+petegteng"],"[V][Prec][Trns][A_2Du][P_4Sg]":["~vaileg+petegni","@+paileg+petegni"],"[V][Prec][Trns][A_2Pl][P_1Du]":["~vaileg+pecikuk","@+paileg+pecikuk"],"[V][Prec][Trns][A_2Pl][P_1Pl]":["~vaileg+pecikut","@+paileg+pecikut"],"[V][Prec][Trns][A_2Pl][P_1Sg]":["~vaileg+pecia","@+paileg+pecia"],"[V][Prec][Trns][A_2Pl][P_3Du]":["~vaileg+pecikek","@+paileg+pecikek"],"[V][Prec][Trns][A_2Pl][P_3Pl]":["~vaileg+peciki","@+paileg+peciki"],"[V][Prec][Trns][A_2Pl][P_3Sg]":["~vaileg+peciu","@+paileg+peciu"],"[V][Prec][Trns][A_2Pl][P_4Du]":["~vaileg+pecitek","@+paileg+pecitek"],"[V][Prec][Trns][A_2Pl][P_4Pl]":["~vaileg+peciteng","@+paileg+peciteng"],"[V][Prec][Trns][A_2Pl][P_4Sg]":["~vaileg+pecini","@+paileg+pecini"],"[V][Prec][Trns][A_2Sg][P_1Du]":["~vaileg+pekuk","@+paileg+pekuk"],"[V][Prec][Trns][A_2Sg][P_1Pl]":["~vaileg+pekut","@+paileg+pekut"],"[V][Prec][Trns][A_2Sg][P_1Sg]":["~vaileg+penga","@+paileg+penga"],"[V][Prec][Trns][A_2Sg][P_3Du]":["~vaileg+pekek","@+paileg+pekek"],"[V][Prec][Trns][A_2Sg][P_3Pl]":["~vaileg+peki","@+paileg+peki"],"[V][Prec][Trns][A_2Sg][P_3Sg]":["~vaileg+pegu","@+paileg+pegu"],"[V][Prec][Trns][A_2Sg][P_4Du]":["~vaileg+petek","@+paileg+petek"],"[V][Prec][Trns][A_2Sg][P_4Pl]":["~vaileg+peteng","@+paileg+peteng"],"[V][Prec][Trns][A_2Sg][P_4Sg]":["~vaileg+peni","@+paileg+peni"],"[V][Prec][Trns][A_3Du][P_1Du]":["~vaileg:agkuk","@+paileg:agkuk"],"[V][Prec][Trns][A_3Du][P_1Pl]":["~vaileg:agkut","@+paileg:agkut"],"[V][Prec][Trns][A_3Du][P_1Sg]":["~vaileg:agnga","@+paileg:agnga"],"[V][Prec][Trns][A_3Du][P_2Du]":["~vaileg:agtek","@+paileg:agtek"],"[V][Prec][Trns][A_3Du][P_2Pl]":["~vaileg:agci","@+paileg:agci"],"[V][Prec][Trns][A_3Du][P_2Sg]":["~vaileg:agten","@+paileg:agten"],"[V][Prec][Trns][A_3Du][P_3Du]":["~vaileg:agkek","@+paileg:agkek"],"[V][Prec][Trns][A_3Du][P_3Pl]":["~vaileg:agki","@+paileg:agki"],"[V][Prec][Trns][A_3Du][P_3Sg]":["~vaileg:agnegu","@+paileg:agnegu"],"[V][Prec][Trns][A_3Du][P_4Du]":["~vaileg:agtek","@+paileg:agtek"],"[V][Prec][Trns][A_3Du][P_4Pl]":["~vaileg:agteng","@+paileg:agteng"],"[V][Prec][Trns][A_3Du][P_4Sg]":["~vaileg:agni","@+paileg:agni"],"[V][Prec][Trns][A_3Pl][P_1Du]":["~vaileg:atkuk","@+paileg:atkuk"],"[V][Prec][Trns][A_3Pl][P_1Pl]":["~vaileg:atkut","@+paileg:atkut"],"[V][Prec][Trns][A_3Pl][P_1Sg]":["~vaileg:atnga","@+paileg:atnga"],"[V][Prec][Trns][A_3Pl][P_2Du]":["~vaileg:acetek","@+paileg:acetek"],"[V][Prec][Trns][A_3Pl][P_2Pl]":["~vaileg:aceci","@+paileg:aceci"],"[V][Prec][Trns][A_3Pl][P_2Sg]":["~vaileg:atgen","@+paileg:atgen"],"[V][Prec][Trns][A_3Pl][P_3Du]":["~vaileg:atkek","@+paileg:atkek"],"[V][Prec][Trns][A_3Pl][P_3Pl]":["~vaileg:atki","@+paileg:atki"],"[V][Prec][Trns][A_3Pl][P_3Sg]":["~vaileg:atgu","@+paileg:atgu"],"[V][Prec][Trns][A_3Pl][P_4Du]":["~vaileg:acetek","@+paileg:acetek"],"[V][Prec][Trns][A_3Pl][P_4Pl]":["~vaileg:aceteng","@+paileg:aceteng"],"[V][Prec][Trns][A_3Pl][P_4Sg]":["~vaileg:atni","@+paileg:atni"],"[V][Prec][Trns][A_3Sg][P_1Du]":["~vaileg:akuk","@+paileg:akuk"],"[V][Prec][Trns][A_3Sg][P_1Pl]":["~vaileg:akut","@+paileg:akut"],"[V][Prec][Trns][A_3Sg][P_1Sg]":["~vaileg:anga","@+paileg:anga"],"[V][Prec][Trns][A_3Sg][P_2Du]":["~vaileg:atek","@+paileg:atek"],"[V][Prec][Trns][A_3Sg][P_2Pl]":["~vaileg:aci","@+paileg:aci"],"[V][Prec][Trns][A_3Sg][P_2Sg]":["~vaileg:aten","@+paileg:aten"],"[V][Prec][Trns][A_3Sg][P_3Du]":["~vaileg:akek","@+paileg:akek"],"[V][Prec][Trns][A_3Sg][P_3Pl]":["~vaileg:aki","@+paileg:aki"],"[V][Prec][Trns][A_3Sg][P_3Sg]":["~vaileg:aku","@+paileg:aku"],"[V][Prec][Trns][A_3Sg][P_4Du]":["~vaileg:atek","@+paileg:atek"],"[V][Prec][Trns][A_3Sg][P_4Pl]":["~vaileg:ateng","@+paileg:ateng"],"[V][Prec][Trns][A_3Sg][P_4Sg]":["~vaileg:ani","@+paileg:ani"],"[V][Prec][Trns][A_4Du][P_1Du]":["~vaileg+megnekuk","@+paileg+megnekuk"],"[V][Prec][Trns][A_4Du][P_1Pl]":["~vaileg+megnekut","@+paileg+megnekut"],"[V][Prec][Trns][A_4Du][P_1Sg]":["~vaileg+megnenga","@+paileg+megnenga"],"[V][Prec][Trns][A_4Du][P_2Du]":["~vaileg+megnetek","@+paileg+megnetek"],"[V][Prec][Trns][A_4Du][P_2Pl]":["~vaileg+megneci","@+paileg+megneci"],"[V][Prec][Trns][A_4Du][P_2Sg]":["~vaileg+megnegen","@+paileg+megnegen"],"[V][Prec][Trns][A_4Du][P_3Du]":["~vaileg+megnekek","@+paileg+megnekek"],"[V][Prec][Trns][A_4Du][P_3Pl]":["~vaileg+megneki","@+paileg+megneki"],"[V][Prec][Trns][A_4Du][P_3Sg]":["~vaileg+megnegu","@+paileg+megnegu"],"[V][Prec][Trns][A_4Pl][P_1Du]":["~vaileg+megtekuk","@+paileg+megtekuk"],"[V][Prec][Trns][A_4Pl][P_1Pl]":["~vaileg+megtekut","@+paileg+megtekut"],"[V][Prec][Trns][A_4Pl][P_1Sg]":["~vaileg+megtenga","@+paileg+megtenga"],"[V][Prec][Trns][A_4Pl][P_2Du]":["~vaileg+megcetek","@+paileg+megcetek"],"[V][Prec][Trns][A_4Pl][P_2Pl]":["~vaileg+megceci","@+paileg+megceci"],"[V][Prec][Trns][A_4Pl][P_2Sg]":["~vaileg+megteggen","@+paileg+megteggen"],"[V][Prec][Trns][A_4Pl][P_3Du]":["~vaileg+megtekek","@+paileg+megtekek"],"[V][Prec][Trns][A_4Pl][P_3Pl]":["~vaileg+megteki","@+paileg+megteki"],"[V][Prec][Trns][A_4Pl][P_3Sg]":["~vaileg+megteggu","@+paileg+megteggu"],"[V][Prec][Trns][A_4Sg][P_1Du]":["~vaileg+mikuk","@+paileg+mikuk"],"[V][Prec][Trns][A_4Sg][P_1Pl]":["~vaileg+mikut","@+paileg+mikut"],"[V][Prec][Trns][A_4Sg][P_1Sg]":["~vaileg+mia","@+paileg+mia"],"[V][Prec][Trns][A_4Sg][P_2Du]":["~vaileg+mitek","@+paileg+mitek"],"[V][Prec][Trns][A_4Sg][P_2Pl]":["~vaileg+mici","@+paileg+mici"],"[V][Prec][Trns][A_4Sg][P_2Sg]":["~vaileg+miten","@+paileg+miten"],"[V][Prec][Trns][A_4Sg][P_3Du]":["~vaileg+mikek","@+paileg+mikek"],"[V][Prec][Trns][A_4Sg][P_3Pl]":["~vaileg+miki","@+paileg+miki"],"[V][Prec][Trns][A_4Sg][P_3Sg]":["~vaileg+miu","@+paileg+miu"],"[V][Ptcp][Intr][S_1Du]":["–lria–kuk","–lrii–kuk","@+ngur*–kuk"],"[V][Ptcp][Intr][S_1Pl]":["–lria–kut","–lrii–kut","@+ngur*–kut"],"[V][Ptcp][Intr][S_1Sg]":["–lria:(ng)a","–lrii:(ng)a","@+ngur*:(ng)a"],"[V][Ptcp][Intr][S_2Du]":["–lria–tek","–lrii–tek","@+ngur*–tek"],"[V][Ptcp][Intr][S_2Pl]":["–lria–si","–lrii–si","@+ngur*–si"],"[V][Ptcp][Intr][S_2Sg]":["–lria–ten","–lrii–ten","@+ngur*–ten"],"[V][Ptcp][Intr][S_3Du]":["–lria%:(e)k","–lrii%:(e)k","@+ngur*%:(e)k"],"[V][Ptcp][Intr][S_3Pl]":["–lria%:(e)t","–lrii%:(e)t","@+ngur*%:(e)t"],"[V][Ptcp][Intr][S_3Sg]":["–lria","–lrii","@+ngur*"],"[V][Ptcp][Trns][A_1Du][P_2Du]":["@~–kemegtek"],"[V][Ptcp][Trns][A_1Du][P_2Pl]":["@~–kemegci"],"[V][Ptcp][Trns][A_1Du][P_2Sg]":["@~–kemegten"],"[V][Ptcp][Trns][A_1Du][P_3Du]":["@~–kegpuk"],"[V][Ptcp][Trns][A_1Du][P_3Pl]":["@~–kepuk"],"[V][Ptcp][Trns][A_1Du][P_3Sg]":["@~–kevuk","@~–kevvuk"],"[V][Ptcp][Trns][A_1Pl][P_2Du]":["@~–kemcetek"],"[V][Ptcp][Trns][A_1Pl][P_2Pl]":["@~–kemceci"],"[V][Ptcp][Trns][A_1Pl][P_2Sg]":["@~–kemteggen"],"[V][Ptcp][Trns][A_1Pl][P_3Du]":["@~–kegput"],"[V][Ptcp][Trns][A_1Pl][P_3Pl]":["@~–keput"],"[V][Ptcp][Trns][A_1Pl][P_3Sg]":["@~–kevut","@~–kevvut"],"[V][Ptcp][Trns][A_1Sg][P_2Du]":["@~–kemtek"],"[V][Ptcp][Trns][A_1Sg][P_2Pl]":["@~–kemci"],"[V][Ptcp][Trns][A_1Sg][P_2Sg]":["@~–kemken"],"[V][Ptcp][Trns][A_1Sg][P_3Du]":["@~–kegka"],"[V][Ptcp][Trns][A_1Sg][P_3Pl]":["@~–kenka"],"[V][Ptcp][Trns][A_1Sg][P_3Sg]":["@~–keka"],"[V][Ptcp][Trns][A_2Du][P_1Du]":["@~–kevtegkuk"],"[V][Ptcp][Trns][A_2Du][P_1Pl]":["@~–kevtegkut"],"[V][Ptcp][Trns][A_2Du][P_1Sg]":["@~–kevtegnga"],"[V][Ptcp][Trns][A_2Du][P_3Du]":["@~–kegtek"],"[V][Ptcp][Trns][A_2Du][P_3Pl]":["@~–ketek"],"[V][Ptcp][Trns][A_2Du][P_3Sg]":["@~–kessek"],"[V][Ptcp][Trns][A_2Pl][P_1Du]":["@~–kevcikuk"],"[V][Ptcp][Trns][A_2Pl][P_1Pl]":["@~–kevcikut"],"[V][Ptcp][Trns][A_2Pl][P_1Sg]":["@~–kevcia"],"[V][Ptcp][Trns][A_2Pl][P_3Du]":["@~–kegci"],"[V][Ptcp][Trns][A_2Pl][P_3Pl]":["@~–keci"],"[V][Ptcp][Trns][A_2Pl][P_3Sg]":["@~–kessi"],"[V][Ptcp][Trns][A_2Sg][P_1Du]":["@~–kevkuk"],"[V][Ptcp][Trns][A_2Sg][P_1Pl]":["@~–kevkut"],"[V][Ptcp][Trns][A_2Sg][P_1Sg]":["@~–kevnga"],"[V][Ptcp][Trns][A_2Sg][P_3Du]":["@~–kegken"],"[V][Ptcp][Trns][A_2Sg][P_3Pl]":["@~–keten"],"[V][Ptcp][Trns][A_2Sg][P_3Sg]":["@~–ken"],"[V][Ptcp][Trns][A_3Du][P_1Du]":["@~–ke~iigkuk"],"[V][Ptcp][Trns][A_3Du][P_1Pl]":["@~–ke~iigkut"],"[V][Ptcp][Trns][A_3Du][P_1Sg]":["@~–ke~iignga"],"[V][Ptcp][Trns][A_3Du][P_2Du]":["@~–ke~iigtek"],"[V][Ptcp][Trns][A_3Du][P_2Pl]":["@~–ke~iigci"],"[V][Ptcp][Trns][A_3Du][P_2Sg]":["@~–ke~iigten"],"[V][Ptcp][Trns][A_3Du][P_3Du]":["@~–kegkek"],"[V][Ptcp][Trns][A_3Du][P_3Pl]":["@~–kekek"],"[V][Ptcp][Trns][A_3Du][P_3Sg]":["@~–ke~iik"],"[V][Ptcp][Trns][A_3Pl][P_1Du]":["@~–ke~aitkuk"],"[V][Ptcp][Trns][A_3Pl][P_1Pl]":["@~–ke~aitkut"],"[V][Ptcp][Trns][A_3Pl][P_1Sg]":["@~–ke~iitnga"],"[V][Ptcp][Trns][A_3Pl][P_2Du]":["@~–ke~aicetek"],"[V][Ptcp][Trns][A_3Pl][P_2Pl]":["@~–ke~aiceci"],"[V][Ptcp][Trns][A_3Pl][P_2Sg]":["@~–ke~iitgen"],"[V][Ptcp][Trns][A_3Pl][P_3Du]":["@~–kegket"],"[V][Ptcp][Trns][A_3Pl][P_3Pl]":["@~–ke~ait"],"[V][Ptcp][Trns][A_3Pl][P_3Sg]":["@~–ke~iit"],"[V][Ptcp][Trns][A_3Sg][P_1Du]":["@~–ke~iikuk"],"[V][Ptcp][Trns][A_3Sg][P_1Pl]":["@~–ke~iikut"],"[V][Ptcp][Trns][A_3Sg][P_1Sg]":["@~–ke~iinga"],"[V][Ptcp][Trns][A_3Sg][P_2Du]":["@~–ke~iitek"],"[V][Ptcp][Trns][A_3Sg][P_2Pl]":["@~–ke~iici"],"[V][Ptcp][Trns][A_3Sg][P_2Sg]":["@~–ke~iiten"],"[V][Ptcp][Trns][A_3Sg][P_3Du]":["@~–kek"],"[V][Ptcp][Trns][A_3Sg][P_3Pl]":["@~–ke~ai"],"[V][Ptcp][Trns][A_3Sg][P_3Sg]":["@~–ke~ii"],"[V][Sbrd][Intr][S_1Du]":["@~+lunuk","@~+lunung","@nanuk","@nanung"],"[V][Sbrd][Intr][S_1Pl]":["@~+luta","@nata"],"[V][Sbrd][Intr][S_1Sg]":["@~+lu:nga","@na:nga"],"[V][Sbrd][Intr][S_2Du]":["@~+lutek","@natek"],"[V][Sbrd][Intr][S_2Pl]":["@~+luci","@naci"],"[V][Sbrd][Intr][S_2Sg]":["@~+luten","@nak"],"[V][Sbrd][Intr][S_4Du]":["@~+lutek","@natek"],"[V][Sbrd][Intr][S_4Pl]":["@~+luteng","@nateng"],"[V][Sbrd][Intr][S_4Sg]":["@~+luni","@nani"],"[V][Sbrd][Trns][P_1Du]":["@~+lunuk","@~+lunung","@nanuk","@nanung"],"[V][Sbrd][Trns][P_1Pl]":["@~+luta","@nata"],"[V][Sbrd][Trns][P_1Sg]":["@~+lu:nga","@na:nga"],"[V][Sbrd][Trns][P_2Du]":["@~+lutek","@natek"],"[V][Sbrd][Trns][P_2Pl]":["@~+luci","@naci"],"[V][Sbrd][Trns][P_2Sg]":["@~+luten","@naten"],"[V][Sbrd][Trns][P_3Du]":["@~+lukek","@nakek"],"[V][Sbrd][Trns][P_3Pl]":["@~+luki","@naki"],"[V][Sbrd][Trns][P_3Sg]":["@~+luku","@naku"],"[Via]":[".ggun"],"[Via][DuUnpd]":[".negnun"],"[Via][PlUnpd]":[".tgun"],"[Via][SgUnpd]":[".kun"],"[Voc][DuUnpd]":[".uk"],"[Voc][PlUnpd]":[".ut"],"[Voc][SgUnpd]":["@+yuuq","@+suuq"],"[Abl_Mod][1Du]":[""],"[Abl_Mod][1Pl]":[""],"[Abl_Mod][1Sg]":[""],"[Abl_Mod][2Du]":[""],"[Abl_Mod][2Pl]":[""],"[Abl_Mod][2Sg]":[""],"[Abl_Mod][3Du]":[""],"[Abl_Mod][3Pl]":[""],"[Abl_Mod][3Sg]":[""],"[Abl_Mod][4Du]":[""],"[Abl_Mod][4Pl]":[""],"[Abl_Mod][4Sg]":[""],"[Abs][1Du]":[""],"[Abs][1Pl]":[""],"[Abs][1Sg]":[""],"[Abs][2Du]":[""],"[Abs][2Pl]":[""],"[Abs][2Sg]":[""],"[Abs][3Du]":[""],"[Abs][3Pl]":[""],"[Abs][3Sg]":[""],"[Abs][4Du]":[""],"[Abs][4Pl]":[""],"[Abs][4Sg]":[""],"[Equ][1Du]":[""],"[Equ][1Pl]":[""],"[Equ][1Sg]":[""],"[Equ][2Du]":[""],"[Equ][2Pl]":[""],"[Equ][2Sg]":[""],"[Equ][3Du]":[""],"[Equ][3Pl]":[""],"[Equ][3Sg]":[""],"[Equ][4Du]":[""],"[Equ][4Pl]":[""],"[Equ][4Sg]":[""],"[Loc][1Du]":[""],"[Loc][1Pl]":[""],"[Loc][1Sg]":[""],"[Loc][2Du]":[""],"[Loc][2Pl]":[""],"[Loc][2Sg]":[""],"[Loc][3Du]":[""],"[Loc][3Pl]":[""],"[Loc][3Sg]":[""],"[Loc][4Du]":[""],"[Loc][4Pl]":[""],"[Loc][4Sg]":[""],"[Rel][1Du]":[""],"[Rel][1Pl]":[""],"[Rel][1Sg]":[""],"[Rel][2Du]":[""],"[Rel][2Pl]":[""],"[Rel][2Sg]":[""],"[Rel][3Du]":[""],"[Rel][3Pl]":[""],"[Rel][3Sg]":[""],"[Rel][4Du]":[""],"[Rel][4Pl]":[""],"[Rel][4Sg]":[""],"[Ter][1Du]":[""],"[Ter][1Pl]":[""],"[Ter][1Sg]":[""],"[Ter][2Du]":[""],"[Ter][2Pl]":[""],"[Ter][2Sg]":[""],"[Ter][3Du]":[""],"[Ter][3Pl]":[""],"[Ter][3Sg]":[""],"[Ter][4Du]":[""],"[Ter][4Pl]":[""],"[Ter][4Sg]":[""],"[Via][1Du]":[""],"[Via][1Pl]":[""],"[Via][1Sg]":[""],"[Via][2Du]":[""],"[Via][2Pl]":[""],"[Via][2Sg]":[""],"[Via][3Du]":[""],"[Via][3Pl]":[""],"[Via][3Sg]":[""],"[Via][4Du]":[""],"[Via][4Pl]":[""],"[Via][4Sg]":[""]};

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_newconstants_js__ = __webpack_require__(79);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customFontFam="Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif";var accordionTitles=[{key:'noun phrase only',name:'Noun phrases',values:[{key:'simple',values:['simple','possession','oblique nouns','descriptors']},{key:'postbases',values:['noun-noun postbases','verb-noun postbases']}]},{key:'verb (+ noun) statements',name:'Verb phrases',values:[{key:'statement sentence',values:['subject only','subject with object not marked on verb','subject and object marked on verb','verb + oblique noun']},{key:'postbases',values:['verb-verb postbases','noun-verb postbases']}]},{key:'verb (+ noun) questions',name:'Ask a question',values:[{key:'question sentence',values:['yes-no question','wh-question']}]},{key:'verb (+ noun) commands',name:'Make a command',values:[{key:'command sentence',values:['optative','subordinative','subject only','subject and object marked']}]},{key:'verb + verb phrase sentence',name:'Advanced verb phrases',values:[{key:'connective verb',values:['before...','because...','whenever...','even though...','if, when in the future...','when in the past...','while...']},{key:'subordinative verb',values:['adjectival']}]}];var SentenceGlossary=function(_PureComponent){_inherits(SentenceGlossary,_PureComponent);function SentenceGlossary(props){_classCallCheck(this,SentenceGlossary);var _this=_possibleConstructorReturn(this,(SentenceGlossary.__proto__||Object.getPrototypeOf(SentenceGlossary)).call(this,props));_this.handleClick=function(e,titleProps){// console.log(e,titleProps)
// this.setState({ loaderOn: true });
var index=titleProps.index;var activeIndexes=_this.state.activeIndexes;var newIndex=_this.state.activeIndexes.slice();// const newIndex = activeIndex === index ? -1 : index;
var currentIndexPosition=activeIndexes.indexOf(index);console.log(currentIndexPosition,activeIndexes,index);if(currentIndexPosition>-1){newIndex.splice(currentIndexPosition,1);}else{newIndex.push(index);}console.log(newIndex);// let mood = moods[index];
// if (newIndex !== -1) {   
// this.getEndings(this.state.parses[currentIndex], mood);
// }
_this.setState({activeIndexes:newIndex});};_this.randomizeSentence=function(direction){if(direction==='+'){if(_this.state.randomSentences.length-1===_this.state.randomSentenceIndex){_this.setState({randomSentences:_this.state.randomSentences.concat([Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */])[Math.floor(Math.random()*Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */]).length)]])});}_this.setState({randomSentenceIndex:_this.state.randomSentenceIndex+1});}else{_this.setState({randomSentenceIndex:_this.state.randomSentenceIndex-1});}};_this.state={// entries: props.entries,
// mood: props.mood,
activeIndexes:[],randomSentenceIndex:0,randomSentences:[Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */])[Math.floor(Math.random()*Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */]).length)]],seeMoreExamples:true};return _this;}_createClass(SentenceGlossary,[{key:'render',// getColor = (pos) => {
//   return colorsList[0][pos]  
// }
value:function render(){var _this2=this;console.log(this.state);// <div style={{textAlign:'left',fontSize:'16px',paddingTop:'2px',paddingBottom:'6px',fontFamily:customFontFam}}>
//   {sentenceTemplates[k][6][0].map((t)=>
//     <span style={{color:this.props.getColor(t[1],true,t[0]),fontWeight:'bold'}}>{t[0]}</span>
//   )}
// </div>
// <div style={{textAlign:'left',lineHeight:'16px',fontFamily:customFontFam}}>
//   {sentenceTemplates[k][6][1].map((t)=>
//     <span style={{color:this.props.getColor(t[1],true,t[0]),fontSize:'16px'}}>{t[0]+' '}</span>
//   )}
// </div>
// console.log(this.state.activeIndexes)
// console.log(sentenceTemplates)
var englishOffsets=[// 0,
// 0,
// 0,
// 78,
// 120,
// 111,
// 101,
// 129,
// //the one woman teacher
// 47,
// 83,
// 81,
// 31,
// 83,
// 60,
// 57,
// 68,
// 34,
// 58,
// 0,
// 0,
// 7,
0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];var activeIndexes=this.state.activeIndexes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Click on a random example to get started')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{fontSize:16},fluid:true,styled:true},accordionTitles.map(function(p,pindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndexes.includes(pindex),index:pindex,onClick:_this2.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),p.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{style:{paddingTop:0},active:activeIndexes.includes(pindex)},p.values.map(function(q,qindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontVariant:'small-caps',fontWeight:'500',fontSize:'20px',color:"#000000cc",marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,q.values.map(function(r,rindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',borderRadius:'3px',marginTop:'10px',fontVariant:'none',fontSize:'15px',padding:'5px',color:"#00000066"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'2px',fontWeight:'400'}},r)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */]).map(function(k,index){return __WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][3]===p.key&&__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][4]===q.key&&__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][5]===r?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{fluid:true,basic:true,onClick:function onClick(){_this2.props.backEndCall(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][2],true);_this2.setState({activeIndexes:[]});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{textAlign:'left',fontSize:'16px',fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][6][0].map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this2.props.getColor(t[1],true,t[0])}},t[0]);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{textAlign:'right',paddingRight:englishOffsets[index],fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][6][1].map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this2.props.getColor(t[1],true,t[0]),fontSize:'16px'}},t[0]+' ');})))):null;})));})));})));}))));}}]);return SentenceGlossary;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* withRouter */])(SentenceGlossary));

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export lessonsList */
/* unused harmony export dialogueLibrary */
var lessonsList=[{"title":"Iqvallruuten-qaa?: Did you go berry picking?","context":"Two friends see each other","dialogues":["qaneryaurci-3-14-2-1-a","qaneryaurci-3-14-2-2-b","qaneryaurci-3-14-2-3-a","qaneryaurci-3-14-2-4-b","qaneryaurci-3-14-2-5-a","qaneryaurci-3-14-2-6-b"]},{"title":"Elitnaurista: The Teacher","context":"Two men talking","dialogues":["qaneryaurci-4-15-2-1-a","qaneryaurci-4-15-2-2-b","qaneryaurci-4-15-2-3-a","qaneryaurci-4-15-2-4-b","qaneryaurci-4-15-2-5-a","qaneryaurci-4-15-2-6-b","qaneryaurci-4-15-2-7-a"]},{"title":"Kipusvigmek: From The Store","context":"At home","dialogues":["qaneryaurci-4-21-7-1-a","qaneryaurci-4-21-7-2-b","qaneryaurci-4-21-7-3-a","qaneryaurci-4-21-7-4-b","qaneryaurci-4-21-7-5-a","qaneryaurci-4-21-7-6-b","qaneryaurci-4-21-7-7-a"]}];var dialogueLibrary={"qaneryaurci-3-14-2-1-a":{"yup":"Cangacit?","eng":"How are you?","audio":"3-14-2-1-a"},"qaneryaurci-3-14-2-2-b":{"yup":"Assirtua, elpet-mi?","eng":"I'm fine, and you?","audio":"3-14-2-2-b"},"qaneryaurci-3-14-2-3-a":{"yup":"Wii-ll' assirtua. Iqvallruuten-qaa?","eng":"I'm fine also. Have you been picking berries?","audio":"3-14-2-3-a"},"qaneryaurci-3-14-2-4-b":{"yup":"Ii-i, iqvallruunga curanek.","eng":"Yes, I picked blueberries.","audio":"3-14-2-4-b"},"qaneryaurci-3-14-2-5-a":{"yup":"Qangvaq iqvallrusit?","eng":"When were you picking?","audio":"3-14-2-5-a"},"qaneryaurci-3-14-2-6-b":{"yup":"Yaaliagni.","eng":"The day before yesterday.","audio":"3-14-2-6-b"},"qaneryaurci-4-15-2-1-a":{"yup":"Tangellruan-qaa imna elitnaurista?","eng":"Did you see that teacher?","audio":"4-15-2-1-a"},"qaneryaurci-4-15-2-2-b":{"yup":"Kina?","eng":"Who?","audio":"4-15-2-2-b"},"qaneryaurci-4-15-2-3-a":{"yup":"Imna-wa sugtulria high school-ami elitnaurituli.","eng":"You know that tall one that teaches at the high school.","audio":"4-15-2-3-a"},"qaneryaurci-4-15-2-4-b":{"yup":"Ii-i nallunritaqa.","eng":"Yes, I know him.","audio":"4-15-2-4-b"},"qaneryaurci-4-15-2-5-a":{"yup":"Qanrutellruanga pissurciquq-gguq Maqinermi.","eng":"He told me that he's going hunting on Saturday.","audio":"4-15-2-5-a"},"qaneryaurci-4-15-2-6-b":{"yup":"Nani-gguq pissurciqa?","eng":"Where did he say he's going to hunt?","audio":"4-15-2-6-b"},"qaneryaurci-4-15-2-7-a":{"yup":"Naamell', yaaqvanun ayagngaicugnarquq. Snuukuura-gguq assissiyaanrituq.","eng":"I don't know, he probably won't go very far. He said that his snow-go isn't working too well.","audio":"4-15-2-7-a"},"qaneryaurci-4-21-7-1-a":{"yup":"Camek kiputellrusit kipusvigmek?","eng":"What did you buy from the store?","audio":"4-21-7-1-a"},"qaneryaurci-4-21-7-2-b":{"yup":"Kuuvviamek, saayumek, tuntum kemganek allanek-llu.","eng":"Some coffee, tea, caribou meat and other things.","audio":"4-21-7-2-b"},"qaneryaurci-4-21-7-3-a":{"yup":"Tangellruan-qaa Ac'aq kipusvigmi?","eng":"Did you see Ac'aq at the store?","audio":"4-21-7-3-a"},"qaneryaurci-4-21-7-4-b":{"yup":"Tangellrunritaqa. Calinrituq-gguq unuamek.","eng":"I didn't see her. They said that she's not working today.","audio":"4-21-7-4-b"},"qaneryaurci-4-21-7-5-a":{"yup":"Ciin kiputenricit kuulicaanek?","eng":"Why didn't you buy some chicken?","audio":"4-21-7-5-a"},"qaneryaurci-4-21-7-6-b":{"yup":"Akitussiyaagtut. Tuntum kemga akikitenrullruuq.","eng":"They were too expensive. The caribou meat was cheaper.","audio":"4-21-7-6-b"},"qaneryaurci-4-21-7-7-a":{"yup":"Canrituq. Ikayurciqamken keniquvgu.","eng":"It's ok. I'll help you when you cook it.","audio":"4-21-7-7-a"}};

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dialogueGenerator;
/* harmony export (immutable) */ __webpack_exports__["b"] = exerciseGenerator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dialogueList_js__ = __webpack_require__(916);
// npm i --save finnlp
// npm install en-inflectors --save
// import * as Fin from "finnlp";
// import { Inflectors } from "en-inflectors";
var lessonChunks={0:"Featured",1:"Basic Questions",2:"Introductions",3:"At Home",4:"Talking to Others",5:"At School",6:"Gathering",7:"Hunting",8:"Fishing",9:"Vehicles"};function dialogueGenerator(){var lessons=[];var dialogues={};var bagOfWords={'v':{'yup':new Set(),'eng':new Set()},'n':{'yup':new Set(),'eng':new Set()},'p':{'yup':new Set(),'eng':new Set()},'e':{'yup':new Set(),'eng':new Set()}};var currentLesson="";var lessonDialogues=[];// var lessonExercises = [];
var previousDialogue="";var dialogueIndex=2;var order_out;var title_out="";var context_out="";// var matchingYug_out = [];
// var matchingEng_out = [];
for(var d in __WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */]){// Chapter	Lesson	Number	Turn	Person	
var ch=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][0];var lsn=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][1];var num=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][2];var turn=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][3];var per=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][4];// Yugtun	English	Audio-Full	
var yug=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][5];var eng=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][6];var audio=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][7];// Order	Title	Context	
var order=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][8];var title=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][9];var context=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][10];// Base-Yugtun	Base-Yugtun-Choose	Base-English	Base-English-Choose	
var baseYug=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][11];// const baseYugCh = dialogueList[d][12]
var baseEng=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][13];// const baseEngCh = dialogueList[d][14]
// Ending-Yugtun	Ending-Yugtun-Choose	Ending-English	Ending-English-Choose
// const endingYug = dialogueList[d][15]
// const endingYugCh = dialogueList[d][16]
// const endingEng = dialogueList[d][17]
// const endingEngCh = dialogueList[d][18]
// Fill-in-Blank 1	Fill-in-Blank 2	
// const fib1 = dialogueList[d][19]
// const fib2 = dialogueList[d][20]		
// Matching-Yugtun	Matching-English
// const matchingYug = dialogueList[d][21]
// const matchingEng = dialogueList[d][22]
// Exercise 1	Exercise 2
// const exercise1 = dialogueList[d][23]
// const exercise2 = dialogueList[d][24]
// const exercise3 = dialogueList[d][25]
// const exercise4 = dialogueList[d][26]
// baseType
var baseType=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][27];var engPos=__WEBPACK_IMPORTED_MODULE_0__dialogueList_js__["a" /* dialogueList */][d][28];// const engConj = dialogueList[d][29].split(',')
var lesson=ch+"-"+lsn+"-"+num;var dialogue="qaneryaurci-"+ch+"-"+lsn+"-"+num+"-"+turn+"-"+per;if(currentLesson===""){currentLesson=lesson;}else if(currentLesson!==lesson){// const matching = matchingYug_out.length === 1 ? [] : [matchingYug_out,matchingEng_out]
lessons.push({"order":order_out,"title":title_out,"context":context_out,"dialogues":lessonDialogues// "exercises":lessonExercises, 
// "matching":matching
});currentLesson=lesson;lessonDialogues=[];// lessonExercises = [];
}// first line in lesson
if(turn===1&&per==="a"&&dialogue!==previousDialogue){title_out=title;if(title_out===''){title_out="Qaneryaurci Ch"+ch+"-"+lsn+" #"+num;}context_out=context;order_out=order;// matchingYug_out = matchingYug.split(";");
// matchingEng_out = matchingEng.split(";");
}if(dialogue===previousDialogue){dialogue+="-"+dialogueIndex;dialogueIndex++;lessonDialogues[lessonDialogues.length-1].push(dialogue);}else{lessonDialogues.push([dialogue]);// lessonExercises.push([exercise1,exercise2,exercise3,exercise4])
previousDialogue=dialogue;dialogueIndex=2;}// add to bag of words
var baseYug_bow=baseYug.match(/<.*?>/)[0].slice(1,-1);var baseEng_bow=baseEng.match(/<.*?>/)[0].slice(1,-1);bagOfWords[baseType]['yup'].add(baseYug_bow.toLowerCase());bagOfWords[baseType]['eng'].add([baseEng_bow.toLowerCase(),engPos]);dialogues[dialogue]={"speaker":per,"yupik":yug,"english":eng,"audio":audio,"baseType":baseType,"baseYupik":baseYug,// "baseYupikChoose":baseYugCh.split(";"),
"baseEnglish":baseEng,// "baseEnglishChoose":baseEngCh.split(";"),
// "endingYupik":endingYug,
// "endingYupikChoose":endingYugCh.split(";"),
// "endingEnglish":endingEng,
// "endingEnglishChoose":endingEngCh.split(";"),
// "fillinblank1":fib1,
// "fillinblank2":fib2,
"engPos":engPos// "engConj": engConj,
};}lessons=lessons.filter(function(a){return a.order!==undefined;});lessons=lessons.sort(function(a,b){return a.order>b.order?1:-1;});lessons=addHeaders(lessons);console.log("DialogueGenerator",{lessons:lessons,dialogues:dialogues,bagOfWords:bagOfWords});return{lessons:lessons,dialogues:dialogues,bagOfWords:bagOfWords};}function addHeaders(lsns){var lsns_out=[];var currChunk=-1;for(var l in lsns){var newChunk=Math.floor(lsns[l].order/100);if(newChunk!==currChunk){currChunk=newChunk;lsns_out.push({"title":lessonChunks[currChunk],"context":"chunk"});}lsns_out.push(lsns[l]);}return lsns_out;}function exerciseGenerator(lesson,dialogueList,bagOfWords){var dialogues={};// ADD NEW
// 1. shuffle multi dialogues in lesson
// englishQuestion  ["Are you ",6,"?"]  (6 is length of hungry) (always have leftText, middleInt, rightText)
// englishQuestionOptions  ["happy", "come", "hungry", "go"] (4 RANDOMLY GENERATED)
// englishQuestionCorrect  "hungry"
// yupikQuestion  ["",4,"tuten-qaa?"] (always have leftText, middleInt, rightText)
// yupikQuestionOptions  ["Kaig", "Ane", "Ayag", "Tune"] (4 RANDOMLY GENERATED) (add capitalization fixes)
// yupikQuestionCorrect  "Kaig"
var shuffleArray=function shuffleArray(array){for(var i=array.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var _ref=[array[j],array[i]];array[i]=_ref[0];array[j]=_ref[1];}return array;};var startsWithCapital=function startsWithCapital(word){return /[A-Z]/.test(word.charAt(0));};var capitalizeFirstLetter=function capitalizeFirstLetter(word){return word.charAt(0).toUpperCase()+word.slice(1);};var lowercaseFirstLetter=function lowercaseFirstLetter(word){return word.charAt(0).toLowerCase()+word.slice(1);};for(var d_list in lesson.dialogues){// list
if(lesson.dialogues[d_list].length>1){shuffleArray(lesson.dialogues[d_list]);}for(var d in lesson.dialogues[d_list]){// list
var dialogue=lesson.dialogues[d_list][d];var dialogue_out=dialogueList[dialogue];var yug_bow=dialogue_out.baseYupik.match(/<.*?>/)[0];var eng_bow=dialogue_out.baseEnglish.match(/<.*?>/)[0];var yug_span=dialogue_out.baseYupik.split(yug_bow);if(yug_span.length===1){yug_span.push('');}yug_span.splice(1,0,yug_bow.slice(1,-1).length);var eng_span=dialogue_out.baseEnglish.split(eng_bow);if(eng_span.length===1){eng_span.push('');}eng_span.splice(1,0,eng_bow.slice(1,-1).length);var yup_words=Array.from(bagOfWords[dialogue_out.baseType]['yup'].values());var yup_options_all=shuffleArray(yup_words);var yup_options=[yug_bow.slice(1,-1)];for(var i in yup_options_all){if(yup_options.length>=4){break;}var correctWord=yug_bow.slice(1,-1);var checkWord="";if(startsWithCapital(correctWord)){checkWord=capitalizeFirstLetter(yup_options_all[i]);}else{checkWord=lowercaseFirstLetter(yup_options_all[i]);}if(!yup_options.includes(checkWord)){yup_options.push(checkWord);}}var eng_words=Array.from(bagOfWords[dialogue_out.baseType]['eng'].values());var eng_options_all=shuffleArray(eng_words);var eng_options=[eng_bow.slice(1,-1)];for(var _i in eng_options_all){if(eng_options.length>=4){break;}var _correctWord=eng_bow.slice(1,-1);var checkWord2="";if(['v','n'].includes(dialogue_out.baseType)){if(eng_options_all[_i][1]===dialogue_out.engPos){if(startsWithCapital(_correctWord)){checkWord2=capitalizeFirstLetter(eng_options_all[_i][0]);}else{checkWord2=lowercaseFirstLetter(eng_options_all[_i][0]);}if(!eng_options.includes(checkWord2)){eng_options.push(checkWord2);}}}else{if(startsWithCapital(_correctWord)){checkWord2=capitalizeFirstLetter(eng_options_all[_i][0]);}else{checkWord2=lowercaseFirstLetter(eng_options_all[_i][0]);}if(!eng_options.includes(checkWord2)){eng_options.push(checkWord2);}}}// make smarter english options
// if (dialogue_out.baseType === 'v') {
// 	let tag = dialogue_out.engPos;
// console.log('',eng_options[0],tag)
// for (let i in eng_options) {
// 	if (i === 0) {
// 		continue
// 	}
// if (['VB','VBP'].includes(tag)) {
// 		eng_options[i] = new Inflectors(eng_options[i]).conjugate("VBP"); // toPresent
// 	} else if (tag === 'VBD') {
// 		eng_options[i] = new Inflectors(eng_options[i]).conjugate("VBD"); // toPast
// 	} else if (tag === 'VBN') {
// 		eng_options[i] = new Inflectors(eng_options[i]).conjugate("VBN"); // toPastParticiple
// 	} else if (tag === 'VBZ') {
// 		eng_options[i] = new Inflectors(eng_options[i]).conjugate("VBZ"); // toPresentS
// 	} else if (tag === 'VBG') {
// 		eng_options[i] = new Inflectors(eng_options[i]).conjugate("VBG"); // toGerund
// 	}
// }
// } else if (dialogue_out.baseType === 'n') {
// 	let tag = dialogue_out.engPos;
// 	for (let i in eng_options) {
// 		if (tag === 'sg') {
// 			const instance = new Inflectors(eng_options[i]);
// 			eng_options[i] = instance.toSingular();
// 		} else {
// 			const instance = new Inflectors(eng_options[i]);
// 			eng_options[i] = instance.toPlural();
// 		}
// 	}
// }
dialogue_out['yupikQuestion']=yug_span;dialogue_out['yupikQuestionOptions']=shuffleArray(yup_options);dialogue_out['yupikQuestionCorrect']=yug_bow.slice(1,-1);dialogue_out['englishQuestion']=eng_span;dialogue_out['englishQuestionOptions']=shuffleArray(eng_options);dialogue_out['englishQuestionCorrect']=eng_bow.slice(1,-1);dialogues[dialogue]=dialogue_out;}}console.log("ExerciseGenerator",{lesson:lesson,dialogues:dialogues});return{lesson:lesson,dialogues:dialogues};}/* unused harmony default export */ var _unused_webpack_default_export = (dialogueGenerator);

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__(918);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(922);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(923);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(148);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(241);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(239);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(456);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(238);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(458);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(924);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(149);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(920);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(921);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(241);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(240);

var _utils = __webpack_require__(149);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(32);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(148);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_constants_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikNounNounPostbases=function(_Component){_inherits(YupikNounNounPostbases,_Component);function YupikNounNounPostbases(){_classCallCheck(this,YupikNounNounPostbases);return _possibleConstructorReturn(this,(YupikNounNounPostbases.__proto__||Object.getPrototypeOf(YupikNounNounPostbases)).apply(this,arguments));}_createClass(YupikNounNounPostbases,[{key:'render',value:function render(){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{key:'adjectival'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Header,null,'Adjectives')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{stackable:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:0,onClick:this.props.setPostbase.bind(this,0),disabled:this.props.allowable_next_ids.indexOf(0)>=0,active:this.props.currentPostbases.indexOf(0)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][0].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:1,onClick:this.props.setPostbase.bind(this,1),disabled:this.props.allowable_next_ids.indexOf(1)>=0,active:this.props.currentPostbases.indexOf(1)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][1].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:2,onClick:this.props.setPostbase.bind(this,2),disabled:this.props.allowable_next_ids.indexOf(2)>=0,active:this.props.currentPostbases.indexOf(2)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][2].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:3,onClick:this.props.setPostbase.bind(this,3),disabled:this.props.allowable_next_ids.indexOf(3)>=0,active:this.props.currentPostbases.indexOf(3)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][3].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:5,onClick:this.props.setPostbase.bind(this,5),disabled:this.props.allowable_next_ids.indexOf(5)>=0,active:this.props.currentPostbases.indexOf(5)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][5].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:6,onClick:this.props.setPostbase.bind(this,6),disabled:this.props.allowable_next_ids.indexOf(6)>=0,active:this.props.currentPostbases.indexOf(6)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][6].description))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{key:'endings',color:'violet'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Header,null,'Number of objects')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{stackable:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:7,onClick:this.props.setPostbase.bind(this,7),disabled:this.props.allowable_next_ids.indexOf(7)>=0,active:this.props.currentPostbases.indexOf(7)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][7].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:8,onClick:this.props.setPostbase.bind(this,8),disabled:this.props.allowable_next_ids.indexOf(8)>=0,active:this.props.currentPostbases.indexOf(8)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][8].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:9,onClick:this.props.setPostbase.bind(this,9),disabled:this.props.allowable_next_ids.indexOf(9)>=0,active:this.props.currentPostbases.indexOf(9)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][9].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:10,onClick:this.props.setPostbase.bind(this,10),disabled:this.props.allowable_next_ids.indexOf(10)>=0,active:this.props.currentPostbases.indexOf(10)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][10].description)))))];}}]);return YupikNounNounPostbases;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikNounNounPostbases);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikNounEndingMoods=function(_Component){_inherits(YupikNounEndingMoods,_Component);function YupikNounEndingMoods(props){_classCallCheck(this,YupikNounEndingMoods);var _this=_possibleConstructorReturn(this,(YupikNounEndingMoods.__proto__||Object.getPrototypeOf(YupikNounEndingMoods)).call(this,props));_this.state={};_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(YupikNounEndingMoods,[{key:'handleClick',value:function handleClick(e,titleProps){var index=titleProps.index;var activeIndex=this.state.activeIndex;var newIndex=activeIndex===index?-1:index;this.setState({activeIndex:newIndex});}},{key:'render',value:function render(){var activeIndex=this.state.activeIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{color:'pink'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Header,null,'Ending moods')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:this.props.setMood.bind(this,'absolutive'),active:this.props.mood==='absolutive'},'absolutive (default)')),this.props.mood==='absolutive'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],null,'Uses:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===0,index:0,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'subject of an intransitive verb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'if used along with an intransitive form of a verb (such as pissurtuq, \u2018[it] is hunting\u2019), this form of the noun suggests that it is the subject of the verb, or the hunter.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===1,index:1,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'object of a transitive verb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'if used along with a transitive form of a verb (such as pissuraa, \u2018[it] is hunting [it]\u2019), this form of the noun reveals that it is the object of the verb, or the thing being hunted.'))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:this.props.setMood.bind(this,'relative'),active:this.props.mood==='relative'},'relative')),this.props.mood==='relative'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],null,'Uses:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===2,index:2,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'subject of a transitive verb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'if used along with a transitive form of a verb (such as pissuraa, \u2018[it] is hunting [it]\u2019), this form of the noun reveals that it is the subject of the verb, or the hunter.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===3,index:3,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'possessor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'if used with another noun, this noun form will indicate that that it belongs to this noun'))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:this.props.setMood.bind(this,'localis'),active:this.props.mood==='localis'},'localis')),this.props.mood==='localis'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],null,'Uses:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===4,index:4,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'place at which, time at which'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(assuming this noun is an object, place, or time) if used with a verb, the localis form of this noun indicates that the verb phrase is happening at the noun, or place at which the noun is at')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===5,index:5,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'object of a comparison'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===5}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===6,index:6,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'with postbase @5+paa/~vaa and enclitic =lli in exclamations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===6}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===7,index:7,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'formal vocative'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===7})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:this.props.setMood.bind(this,'ablative'),active:this.props.mood==='ablative'},'ablative')),this.props.mood==='ablative'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],null,'Uses:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===8,index:8,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'place from which, time from which'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(assuming this noun is an object, place, or time) if used with a verb, this noun form iindicates that the verb phrase is happening from the noun, or from the place where the the noun is at')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===9,index:9,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'indefinite object of an intransitive verb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'if used along with an intransitive form of a verb (such as pissurtuq, \u2018[it] is hunting\u2019), this form of the noun suggests that it is the indefinite object of the verb, or the indefinite thing that is being hunted.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===10,index:10,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'specifying information about a noun within a verb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===10}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===11,index:11,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'secondary object especially with verbs of speaking and giving'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===11}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===12,index:12,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'instrument (only in some dialects)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===12})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:this.props.setMood.bind(this,'terminalis'),active:this.props.mood==='terminalis'},'terminalis')),this.props.mood==='terminalis'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],null,'Uses:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===13,index:13,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'route'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===13}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===14,index:14,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'instrument'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===14}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===15,index:15,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'part of a whole'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===15})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:this.props.setMood.bind(this,'vialis'),active:this.props.mood==='vialis'},'vialis')),this.props.mood==='vialis'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],null,'Uses:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===16,index:16,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'route'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===16}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===17,index:17,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'instrument'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===17}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===18,index:18,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'part of a whole'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===18})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:this.props.setMood.bind(this,'equalis'),active:this.props.mood==='equalis'},'equalis')),this.props.mood==='equalis'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],null,'Uses:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===19,index:19,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'comparison'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===19}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===20,index:20,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'language specific'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===20}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===21,index:21,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'price specification'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===21})):'')));}}]);return YupikNounEndingMoods;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikNounEndingMoods);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_constants_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikNounVerbPostbases=function(_Component){_inherits(YupikNounVerbPostbases,_Component);function YupikNounVerbPostbases(){_classCallCheck(this,YupikNounVerbPostbases);return _possibleConstructorReturn(this,(YupikNounVerbPostbases.__proto__||Object.getPrototypeOf(YupikNounVerbPostbases)).apply(this,arguments));}_createClass(YupikNounVerbPostbases,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{color:'violet',fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Header,null,'Verb forms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{stackable:true,itemsPerRow:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:16,onClick:this.props.setPostbase.bind(this,16),disabled:this.props.allowable_next_ids.indexOf(16)>=0,active:this.props.currentPostbases.indexOf(16)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][16].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:11,onClick:this.props.setPostbase.bind(this,11),disabled:this.props.allowable_next_ids.indexOf(11)>=0,active:this.props.currentPostbases.indexOf(11)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][11].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:12,onClick:this.props.setPostbase.bind(this,12),disabled:this.props.allowable_next_ids.indexOf(12)>=0,active:this.props.currentPostbases.indexOf(12)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][12].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:13,onClick:this.props.setPostbase.bind(this,13),disabled:this.props.allowable_next_ids.indexOf(13)>=0,active:this.props.currentPostbases.indexOf(13)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][13].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:14,onClick:this.props.setPostbase.bind(this,14),disabled:this.props.allowable_next_ids.indexOf(14)>=0,active:this.props.currentPostbases.indexOf(14)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][14].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:15,onClick:this.props.setPostbase.bind(this,15),disabled:this.props.allowable_next_ids.indexOf(15)>=0,active:this.props.currentPostbases.indexOf(15)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][15].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:17,onClick:this.props.setPostbase.bind(this,17),disabled:this.props.allowable_next_ids.indexOf(17)>=0,active:this.props.currentPostbases.indexOf(17)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][17].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:18,onClick:this.props.setPostbase.bind(this,18),disabled:this.props.allowable_next_ids.indexOf(18)>=0,active:this.props.currentPostbases.indexOf(18)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][18].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:19,onClick:this.props.setPostbase.bind(this,19),disabled:this.props.allowable_next_ids.indexOf(19)>=0,active:this.props.currentPostbases.indexOf(19)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][19].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:20,onClick:this.props.setPostbase.bind(this,20),disabled:this.props.allowable_next_ids.indexOf(20)>=0,active:this.props.currentPostbases.indexOf(20)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][20].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{toggle:true,key:21,onClick:this.props.setPostbase.bind(this,21),disabled:this.props.allowable_next_ids.indexOf(21)>=0,active:this.props.currentPostbases.indexOf(21)>=0},__WEBPACK_IMPORTED_MODULE_3__constants_constants_js__["a" /* nounPostbases */][21].description)))));}}]);return YupikNounVerbPostbases;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikNounVerbPostbases);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return nounEndings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return absolutive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return relative_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return localis_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ablative_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return terminalis_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return vialis_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return equalis_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return indicative_intransitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return indicative_transitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return interrogative_intransitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return interrogative_transitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return optative_intransitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return optative_transitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return subordinative_intransitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return subordinative_transitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return connective_intransitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return connective_transitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return connective_consonantEnd_intransitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return connective_consonantEnd_transitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return connective_contemporative_intransitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return connective_contemporative_transitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return connective_conditional_intransitive_endings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return connective_conditional_transitive_endings; });
var nounEndings={'the one who is':'-lria','device for':'+cuun','one that often or capably is':'-tuli','how to/way of':'@~+yaraq','one who is good at':'@~-yuli','act or state of':'-lleq ','place for':'@~+vik'};var absolutive_endings={1:{0:{0:''},1:{1:'-ka',2:'+(t)vuk',3:'+(t)vut'},2:{1:'%:(e)n',2:'-tek',3:'-ci'},3:{1:':(6)a',2:':(6)ak',3:':(6)at'},4:{1:'-ni',2:'-tek',3:'-teng'}},3:{0:{0:'%:(e)t'},1:{1:'%:(e)nka',2:'-puk',3:'-put'},2:{1:'-ten',2:'-tek',3:'-ci'},3:{1:':(6)i',2:'-kek',3:':(6)it'},4:{1:'-ni',2:'-tek',3:'-teng'}},2:{0:{0:'%:(e)k'},1:{1:'%:(e)gka',2:'%:(e)gpuk',3:'%:(e)gput'},2:{1:'%:(e)gken',2:'%:(e)gtek',3:'%:(e)gci'},3:{1:'%:(e)k',2:'%:(e)gkek',3:'%:(e)gket'},4:{1:'%:(e)gni',2:'%:(e)gtek',3:'%:(e)gteng'}}};var relative_endings={1:{0:{0:'%:(e)m'},1:{1:'-ma',2:'-megnuk',3:'-mta'},2:{1:'+(t)vet',2:'+(t)vetek',3:'+(t)veci'},3:{1:':(6)an',2:':(6)agnek',3:':(6)ata'},4:{1:'-mi',2:'-mek',3:'-meng'}},2:{0:{0:'%:(e)k'},1:{1:'%:(e)gma',2:'%:(e)gmegnuk',3:'%:(e)gemta'},2:{1:'%:(e)gpet',2:'%:(e)gpetek',3:'%:(e)gpeci'},3:{1:'%:(e)gken',2:'%:(e)gkenka',3:'%:(e)gketa'},4:{1:'%:(e)gmi',2:'%:(e)gmek',3:'%:(e)gmeng'}},3:{0:{0:'%:(e)t'},1:{1:'-ma',2:'-megnuk',3:'-mta'},2:{1:'+(t)vet',2:'+(t)vetek',3:'+(t)veci'},3:{1:':(6)in',2:'-kenka',3:':(6)ita'},4:{1:'-mi',2:'-mek',3:'-meng'}}};var localis_endings={1:{0:{0:'%~mi'},1:{1:'-mni',2:'-megni',3:'-mte7i'},2:{1:'+(t)veni',2:'+(t)vetegni',3:'+(t)vece7i'},3:{1:':(6)ani',2:':(6)agni',3:':(6)atni'},4:{1:'-mini',2:'-megni',3:'-meggni'}},2:{0:{0:'%:(e)gni'},1:{1:'%:(e)gemni',2:'%:(e)gmegni',3:'%:(e)gemte7i'},2:{1:'%:(e)gpeni',2:'%:(e)gpetegni',3:'%:(e)gpece7i'},3:{1:'%:(e)gkeni',2:'%:(e)gkegni',3:'%:(e)gketni'},4:{1:'%:(e)gmini',2:'%:(e)gmegni',3:'%:(e)gmeggni'}},3:{0:{0:'%~ni'},1:{1:'-mni',2:'-megni',3:'-mte7i'},2:{1:'+(t)veni',2:'+(t)vetegni',3:'+(t)vece7i'},3:{1:':(6)ini',2:'-kegni',3:':(6)itni'},4:{1:'-mini',2:'-megni',3:'-meggni'}}};var ablative_endings={1:{0:{0:'%~mek'},1:{1:'-mnek',2:'-megnek',3:'-mte7ek'},2:{1:'+(t)venek',2:'+(t)vetegnek',3:'+(t)vece7ek'},3:{1:':(6)anek',2:':(6)agnek',3:':(6)atnek'},4:{1:'-minek',2:'-megnek',3:'-meggnek'}},2:{0:{0:'%:(e)gnek'},1:{1:'%:(e)gemnek',2:'%:(e)gmegnek',3:'%:(e)gemte7ek'},2:{1:'%:(e)gpenek',2:'%:(e)gpetegnek',3:'%:(e)gpece7ek'},3:{1:'%:(e)gkenek',2:'%:(e)gkegnek',3:'%:(e)gketnek'},4:{1:'%:(e)gminek',2:'%:(e)gmegnek',3:'%:(e)gmeggnek'}},3:{0:{0:'%~nek'},1:{1:'-mnek',2:'-megnek',3:'-mte7ek'},2:{1:'+(t)venek',2:'+(t)vetegnek',3:'+(t)vece7ek'},3:{1:':(6)inek',2:'-kegnek',3:':(6)itnek'},4:{1:'-minek',2:'-megnek',3:'-meggnek'}}};var terminalis_endings={1:{0:{0:'%~mun'},1:{1:'-mnun',2:'-megnun',3:'-mte7un'},2:{1:'+(t)venun',2:'+(t)vetegnun',3:'+(t)vece7un'},3:{1:':(6)anun',2:':(6)agnun',3:':(6)atnun'},4:{1:'-minun',2:'-megnun',3:'-meggnun'}},2:{0:{0:'%:(e)gnun'},1:{1:'%:(e)gemnun',2:'%:(e)gmegnun',3:'%:(e)gemte7un'},2:{1:'%:(e)gpenun',2:'%:(e)gpetegnun',3:'%:(e)gpece7un'},3:{1:'%:(e)gkenun',2:'%:(e)gkegnun',3:'%:(e)gketnun'},4:{1:'%:(e)gminun',2:'%:(e)gmegnun',3:'%:(e)gmeggnun'}},3:{0:{0:'%~nun'},1:{1:'-mnun',2:'-megnun',3:'-mte7un'},2:{1:'+(t)venun',2:'+(t)vetegnun',3:'+(t)vece7un'},3:{1:':(6)inun',2:'-kegnun',3:':(6)itnun'},4:{1:'-minun',2:'-megnun',3:'-meggnun'}}};var vialis_endings={1:{0:{0:'%kun'},1:{1:'-mkun',2:'-megnegun',3:'-mteggun'},2:{1:'+(t)vegun',//also include -vkun
2:'+(t)vetegnegun',//-vcetgun
3:'+(t)vecetgun'//-vtegnegun
},3:{1:':(6)akun',2:':(6)agnegun',3:':(6)atgun'},4:{1:'-mikun',2:'-megnegun',3:'-megteggun'}},2:{0:{0:'%:(e)gnegun'},1:{1:'%:(e)gemkun',2:'%:(e)gmegnegun',3:'%:(e)gemteggun'},2:{1:'%:(e)gpegun',2:'%:(e)gpetegnegun',3:'%:(e)gpecetnun'},3:{1:'%:(e)gkenkun',2:'%:(e)gketgun',3:'%:(e)gkegnegun'},4:{1:'%:(e)gmikun',2:'%:(e)gmegnegun',3:'%:(e)gmegteggun'}},3:{0:{0:'%tgun'},1:{1:'-mkun',2:'-megnegun',3:'-mteggun'},2:{1:'+(t)vegun',2:'+(t)vetegnegun',3:'+(t)vecetgun'},3:{1:':(6)ikun',2:'-kegnegun',3:':(6)itgun'},4:{1:'-mikun',2:'-megnegun',3:'-megteggun'}}};var equalis_endings={1:{0:{0:'%tun'},1:{1:'-mtun',2:'-megtun',3:'-mcetun'},2:{1:'+(t)vetun',//also include -vkun
2:'+(t)vetegtun',//-vcetgun
3:'+(t)vecetun'//-vtegnegun
},3:{1:':(6)atun',2:':(6)agtun',3:':(6)acetun'},4:{1:'-mitun',2:'-megtun',3:'-megcetun'}},2:{0:{0:'%:(e)gtun'},1:{1:'%:(e)gemtun',2:'%:(e)gmegtun',3:'%:(e)gemcetun'},2:{1:'%:(e)gpetun',2:'%:(e)gpetegtun',3:'%:(e)gpecetun'},3:{1:'%:(e)gketun',2:'%:(e)gkegtun',3:'%:(e)gkecetun'},4:{1:'%:(e)gmitun',2:'%:(e)gmegtun',3:'%:(e)gmegcetun'}},3:{0:{0:'%tun'},1:{1:'-mtun',2:'-megtun',3:'-mcetun'},2:{1:'+(t)vetun',//also include -vkun
2:'+(t)vetegtun',//-vcetgun
3:'+(t)vecetun'//-vtegnegun
},3:{1:':(6)itun',2:'-kegtun',3:':(6)icetun'},4:{1:'-mitun',2:'-megtun',3:'-megcetun'}}};var indicative_intransitive_endings={1:{// 1st person
1:'+\'(g/t)u:6a',// I
2:'+\'(g/t)ukuk',// you
3:'+\'(g/t)ukut'// he
},2:{1:'+\'(g/t)uten',// I
2:'+\'(g/t)utek',// you
3:'+\'(g/t)uci'// he
},3:{1:'+\'(g/t)uq',2:'+\'(g/t)uk',3:'+\'(g/t)ut'}};var indicative_transitive_endings={1:{1:{1:{1:'',//not allowed
2:'',3:''},2:{1:'+\'(g)amken',2:'+\'(g)amtek',3:'+\'(g)amci'},3:{1:'+\'(g)aqa',2:'+\'(g)agka',3:'+\'(g)anka'}},2:{1:{1:'',2:'',3:''},2:{1:'+\'(g)amegten',2:'+\'(g)amegtek',3:'+\'(g)amegci'},3:{1:'+\'(g)apuk',2:'+\'(g)agpuk',3:'+\'(g)apuk'}},3:{1:{1:'',2:'',3:''},2:{1:'+\'(g)amte4en',2:'+\'(g)amcetek',3:'+\'(g)amceci'},3:{1:'+\'(g)aput',2:'+\'(g)agput',3:'+\'(g)aput'}}},2:{1:{1:{1:'+\'(g)arpenga',2:'+\'(g)arpekuk',3:'+\'(g)arpekut'},2:{1:'',2:'',3:''},3:{1:'+\'(g)an',2:'+\'(g)agken',3:'+\'(g)aten'}},2:{1:{1:'+\'(g)arpetegnga',2:'+\'(g)arpetegkuk',3:'+\'(g)arpetegkut'},2:{1:'',2:'',3:''},3:{1:'+\'(g)atek',2:'+\'(g)agtek',3:'+\'(g)atek'}},3:{1:{1:'+\'(g)arpecia',2:'+\'(g)arpecikuk',3:'+\'(g)arpecikut'},2:{1:'',2:'',3:''},3:{1:'+\'(g)aci',2:'+\'(g)agci',3:'+\'(g)aci'}}},3:{1:{1:{1:'+\'(g)anga',2:'+\'(g)akuk',3:'+\'(g)akut'},2:{1:'+\'(g)aten',2:'+\'(g)atek',3:'+\'(g)aci'},3:{1:'+\'(g)aa',2:'+\'(g)ak',3:'+\'(g)ai'}},2:{1:{1:'+\'(g)agnga',2:'+\'(g)agkuk',3:'+\'(g)agkut'},2:{1:'+\'(g)agten',2:'+\'(g)agtek',3:'+\'(g)agci'},3:{1:'+\'(g)aak',2:'+\'(g)agkek',3:'+\'(g)akek'}},3:{1:{1:'+\'(g)atnga',2:'+\'(g)aitkuk',3:'+\'(g)aitkut'},2:{1:'+\'(g)atgen',2:'+\'(g)aicetek',3:'+\'(g)aiceci'},3:{1:'+\'(g)aat',2:'+\'(g)agket',3:'+\'(g)ait'}}}};var interrogative_intransitive_endings={1:{// 1st person
1:'~+(t)sia',2:'@~+ce7uk',3:'@~+ceta'},2:{1:'~+(t)sit',2:'@~+cetek',3:'@~+ceci'},3:{1:'+\'(g/t)a',2:'+\'(g/t)ak',3:'+\'(g/t)at'}};var interrogative_transitive_endings={1:{1:{1:{1:'',2:'',3:''},2:{1:'',2:'',3:''},3:{1:'',2:'',3:''}},2:{1:{1:'',2:'',3:''},2:{1:'',2:'',3:''},3:{1:'',2:'',3:''}},3:{1:{1:'',2:'',3:''},2:{1:'',2:'',3:''},3:{1:'',2:'',3:''}}},2:{1:{1:{1:'~+(t)sia',2:'~+(t)sikuk',3:'~+(t)sikut'},2:{1:'',2:'',3:''},3:{1:'~+(t)siu',2:'~+(t)sikek',3:'~+(t)siki'}},2:{1:{1:'@~+cetegnga',2:'@~+cetegkuk',3:'@~+cetegkut'},2:{1:'',2:'',3:''},3:{1:'@~+cetegnegu',2:'@~+cetegkek',3:'@~+cetegki'}},3:{1:{1:'@~+cecia',2:'@~+cecikuk',3:'@~+cecikut'},2:{1:'',2:'',3:''},3:{1:'@~+ceciu',2:'@~+cecikek',3:'@~+ceciki'}}},3:{1:{1:{1:'+\'(g/t)anga',2:'+\'(g/t)akuk',3:'+\'(g/t)akut'},2:{1:'+\'(g/t)aten',2:'+\'(g/t)atek',3:'+\'(g/t)aci'},3:{1:'+\'(g/t)a:gu',2:'+\'(g/t)akek',3:'+\'(g/t)aki'}},2:{1:{1:'+\'(g/t)agnga',2:'+\'(g/t)agkuk',3:'+\'(g/t)agkut'},2:{1:'+\'(g/t)agten',2:'+\'(g/t)agtek',3:'+\'(g/t)agci'},3:{1:'+\'(g/t)agnegu',2:'+\'(g/t)agkek',3:'+\'(g/t)agki'}},3:{1:{1:'+\'(g/t)atnga',2:'+\'(g/t)atkuk',3:'+\'(g/t)atkut'},2:{1:'+\'(g/t)atgen',2:'+\'(g/t)acetek',3:'+\'(g/t)aceci'},3:{1:'+\'(g/t)atgu',2:'+\'(g/t)atkek',3:'+\'(g/t)atki'}}}};var optative_intransitive_endings={1:{// 1st person
1:'@~+lii',//if te ending, tl becomes ll
2:'@~+luk',//if te ending, tl becomes ll
3:'-lta'// also %(e)lta
},2:{1:'$',// ending in a, i, u, do nothing. ending in two vowels or e, (g)i. ending in te, ending is n. consonant ending, end is :a. special te, ending is lu.
2:'@+tek',//drops te from bases
3:'@+ci'},3:{1:'@~+li',//if te ending, tl becomes ll
2:'@~+lik',//if te ending, tl becomes ll
3:'@~+lit'//if te ending, tl becomes ll
}};var optative_transitive_endings={1:{1:{1:{1:'',2:'',3:''},2:{1:'@~+lamken',2:'@~+lamtek',3:'@~+lamci'},3:{1:'@~+laku',2:'@~+lakek',3:'@~+laki'}},2:{1:{1:'',2:'',3:''},2:{1:'@~+lamegten',2:'@~+lamegtek',3:'@~+lamegci'},3:{1:'@+lauk',2:'@+lagpuk',3:'@+lapuk'}},3:{1:{1:'',2:'',3:''},2:{1:'@~+lamte4en',2:'@~+lamcetek',3:'@~+lamceci'},3:{1:'@+laut',2:'@+lagput',3:'@+laput'}}},2:{1:{1:{1:'@+6a',2:'@+kuk',3:'@+kut'},2:{1:'',2:'',3:''},3:{1:'&',2:'@+kek',3:'@+ki'}},2:{1:{1:'@+tegnga',2:'@+tegkuk',3:'@+tegkut'},2:{1:'',2:'',3:''},3:{1:'@+tegu',2:'@+tegkek',3:'@+tegki'}},3:{1:{1:'@+cia',2:'@+cikuk',3:'@+cikut'},2:{1:'',2:'',3:''},3:{1:'@+ciu',2:'@+ciki',3:'@+cikek'}}},3:{1:{1:{1:'@~+lia',2:'@~+likuk',3:'@~+likut'},2:{1:'@~+liten',2:'@~+litek',3:'@~+lici'},3:{1:'@~+liu',2:'@~+likek',3:'@~+liki'}},2:{1:{1:'@~+lignga',2:'@~+ligkuk',3:'@~+ligkut'},2:{1:'@~+ligten',2:'@~+ligtek',3:'@~+ligci'},3:{1:'@~+lignegu',2:'@~+ligkek',3:'@~+ligki'}},3:{1:{1:'@~+litnga',2:'@~+litkuk',3:'@~+litkut'},2:{1:'@~+litgen',2:'@~+licetek',3:'@~+liceci'},3:{1:'@~+litgu',2:'@~+litkek',3:'@~+litki'}}}};var subordinative_intransitive_endings={1:{1:'@~+lua',2:'@~+lunuk',3:'@~+luta'},2:{1:'@~+luten',2:'@~+lutek',3:'@~+luci'},4:{1:'@~+luni',2:'@~+lutek',3:'@~+luteng'}};var subordinative_transitive_endings={1:{1:{1:{1:'',2:'',3:''},2:{1:'@~+luten',2:'@~+lutek',3:'@~+luci'},3:{1:'@~+luku',2:'@~+lukek',3:'@~+luki'}},2:{1:{1:'',2:'',3:''},2:{1:'@~+luten',2:'@~+lutek',3:'@~+luci'},3:{1:'@~+luku',2:'@~+lukek',3:'@~+luki'}},3:{1:{1:'',2:'',3:''},2:{1:'@~+luten',2:'@~+lutek',3:'@~+luci'},3:{1:'@~+luku',2:'@~+lukek',3:'@~+luki'}}},2:{1:{1:{1:'@~+lua',2:'@~+lunuk',3:'@~+luta'},2:{1:'',2:'',3:''},3:{1:'@~+luku',2:'@~+lukek',3:'@~+luki'}},2:{1:{1:'@~+lua',2:'@~+lunuk',3:'@~+luta'},2:{1:'',2:'',3:''},3:{1:'@~+luku',2:'@~+lukek',3:'@~+luki'}},3:{1:{1:'@~+lua',2:'@~+lunuk',3:'@~+luta'},2:{1:'',2:'',3:''},3:{1:'@~+luku',2:'@~+lukek',3:'@~+luki'}}},4:{1:{1:{1:'@~+lua',2:'@~+lunuk',3:'@~+luta'},2:{1:'@~+luten',2:'@~+lutek',3:'@~+luci'},3:{1:'@~+luku',2:'@~+lukek',3:'@~+luki'}},2:{1:{1:'@~+lua',2:'@~+lunuk',3:'@~+luta'},2:{1:'@~+luten',2:'@~+lutek',3:'@~+luci'},3:{1:'@~+luku',2:'@~+lukek',3:'@~+luki'}},3:{1:{1:'@~+lua',2:'@~+lunuk',3:'@~+luta'},2:{1:'@~+luten',2:'@~+lutek',3:'@~+luci'},//
3:{1:'@~+luku',2:'@~+lukek',3:'@~+luki'}}}};var connective_intransitive_endings={1:{1:'+ma',2:'-megnuk',3:'-mta'},2:{1:'+(t)vet',2:'+(t)vtek',3:'+(t)vci'},3:{1:':an',2:':agnek',3:':ata'},4:{1:'+mi',2:'+mek',3:'+meng'}};var connective_transitive_endings={1:{1:{1:{1:'',2:'',3:''},2:{1:'-mken',2:'-mtek',3:'-mci'},3:{1:'-mku',2:'-mkek',3:'-mki'},4:{1:'-mni',2:'-mtek',3:'-mteng'}},2:{1:{1:'',2:'',3:''},2:{1:'-megten',2:'-megtek',3:'-megci'},3:{1:'-megnegu',2:'-megkek',3:'-megki'},4:{1:'-megni',2:'-megtek',3:'-megteng'}},3:{1:{1:'',2:'',3:''},2:{1:'-mte4en',2:'-mcetek',3:'-mceci'},3:{1:'-mte4u',2:'-mtekek',3:'-mteki'},4:{1:'-mteni',2:'-mcetek',3:'-mceteng'}}},2:{1:{1:{1:'+(t)vnga',2:'+(t)vkuk',3:'+(t)vkut'},2:{1:'',2:'',3:''},3:{1:'+(t)vgu',2:'+(t)vkek',3:'+(t)vki'},4:{1:'+(t)vni',2:'+(t)vtek',3:'+(t)vteng'}},2:{1:{1:'+(t)vtegnga',2:'+(t)vtegkuk',3:'+(t)vtegkut'},2:{1:'',2:'',3:''},3:{1:'+(t)vtegni',2:'+(t)vtegtek',3:'+(t)vtegteng'},4:{1:'+(t)vtegu',2:'+(t)vtegkek',3:'+(t)vtegki'}},3:{1:{1:'+(t)vcia',2:'+(t)vcikuk',3:'+(t)vcikut'},2:{1:'',2:'',3:''},3:{1:'+(t)vciu',2:'+(t)vcikek',3:'+(t)vciki'},4:{1:'+(t)vce7i',2:'+(t)vcetek',3:'+(t)vceteng'}}},3:{1:{1:{1:':anga',2:':akuk',3:':akut'},2:{1:':aten',2:':atek',3:':aci'},3:{1:':aku',2:':akek',3:':aki'},4:{1:':ani',2:':atek',3:':ateng'}},2:{1:{1:':agnga',2:':agkuk',3:':agkut'},2:{1:':agten',2:':agtek',3:':agci'},3:{1:':agku',2:':agkek',3:':agki'},4:{1:':agni',2:':agtek',3:':agteng'}},3:{1:{1:':atnga',2:':atkuk',3:':atkut'},2:{1:':atgen',2:':acetek',3:':aceci'},3:{1:':atgu',2:':atkek',3:':atki'},4:{1:':atni',2:':acetek',3:':aceteng'}}},4:{1:{1:{1:'+mia',2:'+mikuk',3:'+mikut'},2:{1:'+miten',2:'+mitek',3:'+mici'},3:{1:'+miu',2:'+mikek',3:'+miki'},4:{1:'',2:'',3:''}},2:{1:{1:'+megnenga',2:'+megnekuk',3:'+megnekut'},2:{1:'+megnegen',2:'+megnetek',3:'+megneci'},3:{1:'+megnegu',2:'+megnekek',3:'+megneki'},4:{1:'',2:'',3:''}},3:{1:{1:'+megtenga',2:'+megtekuk',3:'+megtekut'},2:{1:'+megte4en',2:'+megcetek',3:'+megneci'},3:{1:'+megte4u',2:'+megtekek',3:'+megteki'},4:{1:'',2:'',3:''}}}};var connective_consonantEnd_intransitive_endings={1:{1:'+ma',2:'-megnuk',3:'-mta'},2:{1:'+(t)vet',2:'+(t)vetek',3:'+(t)veci'},3:{1:':an',2:':agnek',3:':ata'},4:{1:'+mi',2:'+mek',3:'+meng'}};var connective_consonantEnd_transitive_endings={1:{1:{1:{1:'',2:'',3:''},2:{1:'-mken',2:'-mtek',3:'-mci'},3:{1:'-mku',2:'-mkek',3:'-mki'},4:{1:'-mni',2:'-mtek',3:'-mteng'}},2:{1:{1:'',2:'',3:''},2:{1:'-megten',2:'-megtek',3:'-megci'},3:{1:'-megnegu',2:'-megkek',3:'-megki'},4:{1:'-megni',2:'-megtek',3:'-megteng'}},3:{1:{1:'',2:'',3:''},2:{1:'-mte4en',2:'-mcetek',3:'-mceci'},3:{1:'-mte4u',2:'-mtekek',3:'-mteki'},4:{1:'-mteni',2:'-mcetek',3:'-mceteng'}}},2:{1:{1:{1:'+(t)venga',2:'+(t)vekuk',3:'+(t)vekut'},2:{1:'',2:'',3:''},3:{1:'+(t)vegu',2:'+(t)vekek',3:'+(t)veki'},4:{1:'+(t)veni',2:'+(t)vetek',3:'+(t)veteng'}},2:{1:{1:'+(t)vetegnga',2:'+(t)vetegkuk',3:'+(t)vetegkut'},2:{1:'',2:'',3:''},3:{1:'+(t)vetegni',2:'+(t)vetegtek',3:'+(t)vetegteng'},4:{1:'+(t)vetgu',2:'+(t)vetegkek',3:'+(t)vetegki'}},3:{1:{1:'+(t)vecia',2:'+(t)vecikuk',3:'+(t)vecikut'},2:{1:'',2:'',3:''},3:{1:'+(t)veciu',2:'+(t)vecikek',3:'+(t)veciki'},4:{1:'+(t)vece7i',2:'+(t)vecetek',3:'+(t)veceteng'}}},3:{1:{1:{1:':anga',2:':akuk',3:':akut'},2:{1:':aten',2:':atek',3:':aci'},3:{1:':aku',2:':akek',3:':aki'},4:{1:':ani',2:':atek',3:':ateng'}},2:{1:{1:':agnga',2:':agkuk',3:':agkut'},2:{1:':agten',2:':agtek',3:':agci'},3:{1:':agku',2:':agkek',3:':agki'},4:{1:':agni',2:':agtek',3:':agteng'}},3:{1:{1:':atnga',2:':atkuk',3:':atkut'},2:{1:':atgen',2:':acetek',3:':aceci'},3:{1:':atgu',2:':atkek',3:':atki'},4:{1:':atni',2:':acetek',3:':aceteng'}}},4:{1:{1:{1:'+mia',2:'+mikuk',3:'+mikut'},2:{1:'+miten',2:'+mitek',3:'+mici'},3:{1:'+miu',2:'+mikek',3:'+miki'},4:{1:'',2:'',3:''}},2:{1:{1:'+megnenga',2:'+megnekuk',3:'+megnekut'},2:{1:'+megnegen',2:'+megnetek',3:'+megneci'},3:{1:'+megnegu',2:'+megnekek',3:'+megneki'},4:{1:'',2:'',3:''}},3:{1:{1:'+megtenga',2:'+megtekuk',3:'+megtekut'},2:{1:'+megte4en',2:'+megcetek',3:'+megneci'},3:{1:'+megte4u',2:'+megtekek',3:'+megteki'},4:{1:'',2:'',3:''}}}};var connective_contemporative_intransitive_endings={1:{1:'-mni',2:'-megni',3:'-mte7i'},2:{1:'+(t)veni',2:'+(t)vetegni',3:'+(t)vece7i'},3:{1:':ani',2:':agni',3:':atni'},4:{1:'+mini',2:'+megni',3:'+me4ni'}};var connective_contemporative_transitive_endings={1:{1:{1:{1:'',2:'',3:''},2:{1:'-mken',2:'-mtek',3:'-mci'},3:{1:'-mku',2:'-mkek',3:'-mki'},4:{1:'-mni',2:'-mtek',3:'-mteng'}},2:{1:{1:'',2:'',3:''},2:{1:'-megten',2:'-megtek',3:'-megci'},3:{1:'-megnegu',2:'-megkek',3:'-megki'},4:{1:'-megni',2:'-megtek',3:'-megteng'}},3:{1:{1:'',2:'',3:''},2:{1:'-mte4en',2:'-mcetek',3:'-mceci'},3:{1:'-mte4u',2:'-mtekek',3:'-mteki'},4:{1:'-mteni',2:'-mcetek',3:'-mceteng'}}},2:{1:{1:{1:'+(t)venga',2:'+(t)vekuk',3:'+(t)vekut'},2:{1:'',2:'',3:''},3:{1:'+(t)vegu',2:'+(t)vekek',3:'+(t)veki'},4:{1:'+(t)veni',2:'+(t)vetek',3:'+(t)veteng'}},2:{1:{1:'+(t)vetegnga',2:'+(t)vetegkuk',3:'+(t)vetegkut'},2:{1:'',2:'',3:''},3:{1:'+(t)vetegni',2:'+(t)vetegtek',3:'+(t)vetegteng'},4:{1:'+(t)vetgu',2:'+(t)vetegkek',3:'+(t)vetegki'}},3:{1:{1:'+(t)vecia',2:'+(t)vecikuk',3:'+(t)vecikut'},2:{1:'',2:'',3:''},3:{1:'+(t)veciu',2:'+(t)vecikek',3:'+(t)veciki'},4:{1:'+(t)vece7i',2:'+(t)vecetek',3:'+(t)veceteng'}}},3:{1:{1:{1:':anga',2:':akuk',3:':akut'},2:{1:':aten',2:':atek',3:':aci'},3:{1:':aku',2:':akek',3:':aki'},4:{1:':ani',2:':atek',3:':ateng'}},2:{1:{1:':agnga',2:':agkuk',3:':agkut'},2:{1:':agten',2:':agtek',3:':agci'},3:{1:':agku',2:':agkek',3:':agki'},4:{1:':agni',2:':agtek',3:':agteng'}},3:{1:{1:':atnga',2:':atkuk',3:':atkut'},2:{1:':atgen',2:':acetek',3:':aceci'},3:{1:':atgu',2:':atkek',3:':atki'},4:{1:':atni',2:':acetek',3:':aceteng'}}},4:{1:{1:{1:'+minia',2:'+minikuk',3:'+minikut'},2:{1:'+miniten',2:'+minitek',3:'+minici'},3:{1:'+miniu',2:'+minikek',3:'+miniki'},4:{1:'',2:'',3:''}},2:{1:{1:'+minegnenga',2:'+minegnekuk',3:'+minegnekut'},2:{1:'+minegnegen',2:'+minegnetek',3:'+minegneci'},3:{1:'+minegnegu',2:'+minegnekek',3:'+minegneki'},4:{1:'',2:'',3:''}},3:{1:{1:'+minegtenga',2:'+minegtekuk',3:'+minegtekut'},2:{1:'+minegte4en',2:'+minegcetek',3:'+minegneci'},3:{1:'+minegte4u',2:'+minegtekek',3:'+minegteki'},4:{1:'',2:'',3:''}}}};var connective_conditional_intransitive_endings={1:{1:'+ma',2:'-megnuk',3:'-mta'},2:{1:'+(t)vet',2:'+(t)vtek',3:'+(t)vci'},3:{1:':an',2:':agnek',3:':ata'},4:{1:'+mi',2:'+mek',3:'+meng'}};var connective_conditional_transitive_endings={1:{1:{1:{1:'',2:'',3:''},2:{1:'-mken',2:'-mtek',3:'-mci'},3:{1:'-mku',2:'-mkek',3:'-mki'},4:{1:'-mni',2:'-mtek',3:'-mteng'}},2:{1:{1:'',2:'',3:''},2:{1:'-megten',2:'-megtek',3:'-megci'},3:{1:'-megnegu',2:'-megkek',3:'-megki'},4:{1:'-megni',2:'-megtek',3:'-megteng'}},3:{1:{1:'',2:'',3:''},2:{1:'-mte4en',2:'-mcetek',3:'-mceci'},3:{1:'-mte4u',2:'-mtekek',3:'-mteki'},4:{1:'-mteni',2:'-mcetek',3:'-mceteng'}}},2:{1:{1:{1:'+(t)vnga',2:'+(t)vkuk',3:'+(t)vkut'},2:{1:'',2:'',3:''},3:{1:'+(t)vgu',2:'+(t)vkek',3:'+(t)vki'},4:{1:'+(t)vni',2:'+(t)vtek',3:'+(t)vteng'}},2:{1:{1:'+(t)vtegnga',2:'+(t)vtegkuk',3:'+(t)vtegkut'},2:{1:'',2:'',3:''},3:{1:'+(t)vtegni',2:'+(t)vtegtek',3:'+(t)vtegteng'},4:{1:'+(t)vtegu',2:'+(t)vtegkek',3:'+(t)vtegki'}},3:{1:{1:'+(t)vcia',2:'+(t)vcikuk',3:'+(t)vcikut'},2:{1:'',2:'',3:''},3:{1:'+(t)vciu',2:'+(t)vcikek',3:'+(t)vciki'},4:{1:'+(t)vce7i',2:'+(t)vcetek',3:'+(t)vceteng'}}},3:{1:{1:{1:':anga',2:':akuk',3:':akut'},2:{1:':aten',2:':atek',3:':aci'},3:{1:':aku',2:':akek',3:':aki'},4:{1:':ani',2:':atek',3:':ateng'}},2:{1:{1:':agnga',2:':agkuk',3:':agkut'},2:{1:':agten',2:':agtek',3:':agci'},3:{1:':agku',2:':agkek',3:':agki'},4:{1:':agni',2:':agtek',3:':agteng'}},3:{1:{1:':atnga',2:':atkuk',3:':atkut'},2:{1:':atgen',2:':acetek',3:':aceci'},3:{1:':atgu',2:':atkek',3:':atki'},4:{1:':atni',2:':acetek',3:':aceteng'}}},4:{1:{1:{1:'+nia',2:'+nikuk',3:'+nikut'},2:{1:'+niten',2:'+nitek',3:'+nici'},3:{1:'+niu',2:'+nikek',3:'+niki'},4:{1:'',2:'',3:''}},2:{1:{1:'+negnenga',2:'+negnekuk',3:'+negnekut'},2:{1:'+negnegen',2:'+negnetek',3:'+negneci'},3:{1:'+negnegu',2:'+negnekek',3:'+negneki'},4:{1:'',2:'',3:''}},3:{1:{1:'+negtenga',2:'+negtekuk',3:'+negtekut'},2:{1:'+negte4en',2:'+negcetek',3:'+negneci'},3:{1:'+negte4u',2:'+negtekek',3:'+negteki'},4:{1:'',2:'',3:''}}}};

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * AudioWaveform.
 * Gradio-style waveform: static peaks on canvas, played portion
 * recolored, click-to-seek, play/pause button. Falls back to a
 * plain <audio controls> if decoding fails.
 *
 * props: src (object/blob URL or URL), label (optional)
 */function decodeAudio(arrayBuffer){var AudioCtx=window.AudioContext||window.webkitAudioContext;var ctx=new AudioCtx();return new Promise(function(resolve,reject){ctx.decodeAudioData(arrayBuffer,resolve,reject);}).finally(function(){if(ctx.close)ctx.close();});}function computePeaks(audioBuffer,numBuckets){var data=audioBuffer.getChannelData(0);var bucketSize=Math.max(1,Math.floor(data.length/numBuckets));var peaks=[];for(var i=0;i<numBuckets;i++){var max=0;var start=i*bucketSize;var end=Math.min(start+bucketSize,data.length);for(var j=start;j<end;j++){var v=Math.abs(data[j]);if(v>max)max=v;}peaks.push(max);}var overall=Math.max.apply(null,peaks)||1;return peaks.map(function(p){return p/overall;});}function drawPeaks(canvas,peaks,playedFraction){var dpr=window.devicePixelRatio||1;var w=canvas.clientWidth;var h=canvas.clientHeight;canvas.width=w*dpr;canvas.height=h*dpr;var ctx=canvas.getContext('2d');ctx.scale(dpr,dpr);ctx.clearRect(0,0,w,h);var barWidth=2;var gap=1;var n=peaks.length;var mid=h/2;var playedBars=Math.floor(n*playedFraction);for(var i=0;i<n;i++){var x=i*(barWidth+gap);var barH=Math.max(2,peaks[i]*(h-4));ctx.fillStyle=i<playedBars?'#f2711c':'#2185d0';// SUI orange / blue
ctx.fillRect(x,mid-barH/2,barWidth,barH);}}var AudioWaveform=function(_React$Component){_inherits(AudioWaveform,_React$Component);function AudioWaveform(props){_classCallCheck(this,AudioWaveform);var _this=_possibleConstructorReturn(this,(AudioWaveform.__proto__||Object.getPrototypeOf(AudioWaveform)).call(this,props));_this.state={playing:false,duration:0,decodeFailed:false};_this.canvasRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.audioRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.peaks=null;_this.cancelled=false;_this.togglePlay=_this.togglePlay.bind(_this);_this.seek=_this.seek.bind(_this);_this.redraw=_this.redraw.bind(_this);_this.onPlay=_this.onPlay.bind(_this);_this.onPause=_this.onPause.bind(_this);_this.onEnded=_this.onEnded.bind(_this);return _this;}_createClass(AudioWaveform,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.src)this.load(this.props.src);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.src!==prevProps.src&&this.props.src){this.load(this.props.src);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.cancelled=true;}},{key:'load',value:function load(src){var _this2=this;this.peaks=null;this.setState({decodeFailed:false,playing:false,duration:0});fetch(src).then(function(r){return r.arrayBuffer();}).then(decodeAudio).then(function(audioBuffer){if(_this2.cancelled||_this2.props.src!==src)return;var canvas=_this2.canvasRef.current;if(!canvas)return;var numBuckets=Math.floor(canvas.clientWidth/3);// bar+gap = 3px
_this2.peaks=computePeaks(audioBuffer,numBuckets);_this2.setState({duration:audioBuffer.duration});drawPeaks(canvas,_this2.peaks,0);}).catch(function(){if(!_this2.cancelled)_this2.setState({decodeFailed:true});});}},{key:'redraw',value:function redraw(){var audio=this.audioRef.current;var canvas=this.canvasRef.current;if(!audio||!canvas||!this.peaks)return;var frac=audio.duration?audio.currentTime/audio.duration:0;drawPeaks(canvas,this.peaks,frac);}},{key:'togglePlay',value:function togglePlay(){var audio=this.audioRef.current;if(!audio)return;if(audio.paused)audio.play();else audio.pause();}},{key:'seek',value:function seek(e){var audio=this.audioRef.current;var canvas=this.canvasRef.current;if(!audio||!canvas||!audio.duration)return;var rect=canvas.getBoundingClientRect();var frac=(e.clientX-rect.left)/rect.width;audio.currentTime=frac*audio.duration;this.redraw();}},{key:'onPlay',value:function onPlay(){this.setState({playing:true});}},{key:'onPause',value:function onPause(){this.setState({playing:false});}},{key:'onEnded',value:function onEnded(){this.setState({playing:false});this.redraw();}},{key:'formatTime',value:function formatTime(s){if(!s||!isFinite(s))return'0:00';var m=Math.floor(s/60);var sec=Math.floor(s%60);return m+':'+(sec<10?'0':'')+sec;}},{key:'render',value:function render(){var _props=this.props,src=_props.src,label=_props.label;var _state=this.state,playing=_state.playing,duration=_state.duration,decodeFailed=_state.decodeFailed;if(!src)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],null,label&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{attached:'top'},label),decodeFailed?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{controls:true,src:src,style:{width:'100%'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{icon:playing?'pause':'play',circular:true,primary:true,onClick:this.togglePlay,'aria-label':playing?'Pause':'Play'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas',{ref:this.canvasRef,onClick:this.seek,style:{flex:1,height:64,marginLeft:12,cursor:'pointer'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:12,color:'#666',minWidth:40}},this.formatTime(duration)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{ref:this.audioRef,src:src,onTimeUpdate:this.redraw,onPlay:this.onPlay,onPause:this.onPause,onEnded:this.onEnded})));}}]);return AudioWaveform;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AudioWaveform);

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(466);
module.exports = __webpack_require__(471);


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(467).enable();
  window.Promise = __webpack_require__(469);
}

// fetch() polyfill for making API calls.
__webpack_require__(470);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(150);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(246);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(246);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 470 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_scrollToTop_js__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_store__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_history_createBrowserHistory__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_ga__ = __webpack_require__(242);
// Uncomment this for deployment
// ReactGA.initialize('UA-127737321-1');
var history=__WEBPACK_IMPORTED_MODULE_8_history_createBrowserHistory___default()({//basename: '/yuarcuun'
});//FIXME how to exclude localhost?
history.listen(function(location){__WEBPACK_IMPORTED_MODULE_9_react_ga__["a" /* default */].set({page:location.pathname});__WEBPACK_IMPORTED_MODULE_9_react_ga__["a" /* default */].pageview(location.pathname);});var supportsHistory='pushState'in window.history;__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_6__redux_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Router */],{forceRefresh:!supportsHistory,keyLength:20,history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_common_scrollToTop_js__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["c" /* default */],null)))),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_3__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(150),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(150),r=__webpack_require__(474);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(475);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(151);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(478);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(151);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(252);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(251);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(255);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(256);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(257);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(258);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(153);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(98);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(259);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Confirm__ = __webpack_require__(493);
/* unused harmony reexport default */



/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_has__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_Button__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_Modal__ = __webpack_require__(346);















/**
 * A Confirm modal gives the user a choice to confirm or cancel an action/
 * @see Modal
 */

var Confirm = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Confirm, _Component);

  function Confirm() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Confirm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call.apply(_ref, [this].concat(args))), _this), _this.handleCancel = function (e) {
      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onCancel', e, _this.props);
    }, _this.handleCancelOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(predefinedProps, 'onClick', e, buttonProps);
          _this.handleCancel(e);
        }
      };
    }, _this.handleConfirmOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(predefinedProps, 'onClick', e, buttonProps);
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onConfirm', e, _this.props);
        }
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Confirm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cancelButton = _props.cancelButton,
          confirmButton = _props.confirmButton,
          content = _props.content,
          header = _props.header,
          open = _props.open,
          size = _props.size;

      var rest = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["r" /* getUnhandledProps */])(Confirm, this.props);

      // `open` is auto controlled by the Modal
      // It cannot be present (even undefined) with `defaultOpen`
      // only apply it if the user provided an open prop
      var openProp = {};
      if (__WEBPACK_IMPORTED_MODULE_5_lodash_has___default()(this.props, 'open')) openProp.open = open;

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11__modules_Modal__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, openProp, { size: size, onClose: this.handleCancel }),
        __WEBPACK_IMPORTED_MODULE_11__modules_Modal__["a" /* default */].Header.create(header),
        __WEBPACK_IMPORTED_MODULE_11__modules_Modal__["a" /* default */].Content.create(content),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_11__modules_Modal__["a" /* default */].Actions,
          null,
          __WEBPACK_IMPORTED_MODULE_10__elements_Button__["a" /* default */].create(cancelButton, { overrideProps: this.handleCancelOverrides }),
          __WEBPACK_IMPORTED_MODULE_10__elements_Button__["a" /* default */].create(confirmButton, {
            defaultProps: { primary: true },
            overrideProps: this.handleConfirmOverrides
          })
        )
      );
    }
  }]);

  return Confirm;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Confirm.defaultProps = {
  cancelButton: 'Cancel',
  confirmButton: 'OK',
  content: 'Are you sure?',
  size: 'small'
};
Confirm._meta = {
  name: 'Confirm',
  type: __WEBPACK_IMPORTED_MODULE_9__lib__["b" /* META */].TYPES.ADDON
};
Confirm.handledProps = ['cancelButton', 'confirmButton', 'content', 'header', 'onCancel', 'onConfirm', 'open', 'size'];
Confirm.propTypes =  false ? {
  /** The cancel button text. */
  cancelButton: customPropTypes.itemShorthand,

  /** The OK button text. */
  confirmButton: customPropTypes.itemShorthand,

  /** The ModalContent text. */
  content: customPropTypes.itemShorthand,

  /** The ModalHeader text. */
  header: customPropTypes.itemShorthand,

  /**
   * Called when the Modal is closed without clicking confirm.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onCancel: PropTypes.func,

  /**
   * Called when the OK button is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onConfirm: PropTypes.func,

  /** Whether or not the modal is visible. */
  open: PropTypes.bool,

  /** A Confirm can vary in size */
  size: PropTypes.oneOf(['fullscreen', 'large', 'mini', 'small', 'tiny'])
} : {};


/* unused harmony default export */ var _unused_webpack_default_export = (Confirm);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(495), __esModule: true };

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(496);
module.exports = __webpack_require__(22).Object.assign;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(47);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(498) });


/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(50);
var getKeys = __webpack_require__(99);
var gOPS = __webpack_require__(162);
var pIE = __webpack_require__(102);
var toObject = __webpack_require__(81);
var IObject = __webpack_require__(263);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(72)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(57);
var toLength = __webpack_require__(264);
var toAbsoluteIndex = __webpack_require__(500);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(158);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(502);
var $Object = __webpack_require__(22).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(47);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(50), 'Object', { defineProperty: __webpack_require__(49).f });


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(504), __esModule: true };

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(103);
__webpack_require__(165);
module.exports = __webpack_require__(166).f('iterator');


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(158);
var defined = __webpack_require__(157);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(163);
var descriptor = __webpack_require__(80);
var setToStringTag = __webpack_require__(164);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(70)(IteratorPrototype, __webpack_require__(33)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(49);
var anObject = __webpack_require__(55);
var getKeys = __webpack_require__(99);

module.exports = __webpack_require__(50) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(48).document;
module.exports = document && document.documentElement;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(510);
var step = __webpack_require__(511);
var Iterators = __webpack_require__(74);
var toIObject = __webpack_require__(57);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(266)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(513), __esModule: true };

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(514);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
module.exports = __webpack_require__(22).Symbol;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(48);
var has = __webpack_require__(56);
var DESCRIPTORS = __webpack_require__(50);
var $export = __webpack_require__(47);
var redefine = __webpack_require__(267);
var META = __webpack_require__(515).KEY;
var $fails = __webpack_require__(72);
var shared = __webpack_require__(160);
var setToStringTag = __webpack_require__(164);
var uid = __webpack_require__(101);
var wks = __webpack_require__(33);
var wksExt = __webpack_require__(166);
var wksDefine = __webpack_require__(167);
var enumKeys = __webpack_require__(516);
var isArray = __webpack_require__(517);
var anObject = __webpack_require__(55);
var isObject = __webpack_require__(71);
var toObject = __webpack_require__(81);
var toIObject = __webpack_require__(57);
var toPrimitive = __webpack_require__(155);
var createDesc = __webpack_require__(80);
var _create = __webpack_require__(163);
var gOPNExt = __webpack_require__(518);
var $GOPD = __webpack_require__(168);
var $GOPS = __webpack_require__(162);
var $DP = __webpack_require__(49);
var $keys = __webpack_require__(99);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(269).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(102).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(100)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(70)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(101)('meta');
var isObject = __webpack_require__(71);
var has = __webpack_require__(56);
var setDesc = __webpack_require__(49).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(72)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(99);
var gOPS = __webpack_require__(162);
var pIE = __webpack_require__(102);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(156);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(57);
var gOPN = __webpack_require__(269).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 519 */
/***/ (function(module, exports) {



/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(167)('asyncIterator');


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(167)('observable');


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(523), __esModule: true };

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(524);
module.exports = __webpack_require__(22).Object.setPrototypeOf;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(47);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(525).set });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(71);
var anObject = __webpack_require__(55);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(154)(Function.call, __webpack_require__(168).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(527), __esModule: true };

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(528);
var $Object = __webpack_require__(22).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(47);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(163) });


/***/ }),
/* 529 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 531 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(273);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(534),
    ListCache = __webpack_require__(105),
    Map = __webpack_require__(171);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(535),
    hashDelete = __webpack_require__(540),
    hashGet = __webpack_require__(541),
    hashHas = __webpack_require__(542),
    hashSet = __webpack_require__(543);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(104);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(61),
    isMasked = __webpack_require__(537),
    isObject = __webpack_require__(25),
    toSource = __webpack_require__(274);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(538);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 539 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 540 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(104);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(104);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(104);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 544 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(106);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(106);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(106);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(106);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(107);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(107);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(107);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(107);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(110),
    castPath = __webpack_require__(82),
    last = __webpack_require__(275),
    parent = __webpack_require__(556),
    toKey = __webpack_require__(62);

/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = castPath(path, object);
  object = parent(object, path);
  var func = object == null ? object : object[toKey(last(path))];
  return func == null ? undefined : apply(func, object, args);
}

module.exports = baseInvoke;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(85),
    baseSlice = __webpack_require__(111);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(558),
    defineProperty = __webpack_require__(277),
    identity = __webpack_require__(39);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 558 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAutoControlledStateValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_difference__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isUndefined__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_startsWith__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_startsWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_startsWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_filter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_intersection__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_has__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_each__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react__);














 /* eslint-disable no-console */
/**
 * Why choose inheritance over a HOC?  Multiple advantages for this particular use case.
 * In short, we need identical functionality to setState(), unless there is a prop defined
 * for the state key.  Also:
 *
 * 1. Single Renders
 *    Calling trySetState() in constructor(), componentWillMount(), or componentWillReceiveProps()
 *    does not cause two renders. Consumers and tests do not have to wait two renders to get state.
 *    See www.react.run/4kJFdKoxb/27 for an example of this issue.
 *
 * 2. Simple Testing
 *    Using a HOC means you must either test the undecorated component or test through the decorator.
 *    Testing the undecorated component means you must mock the decorator functionality.
 *    Testing through the HOC means you can not simply shallow render your component.
 *
 * 3. Statics
 *    HOC wrap instances, so statics are no longer accessible.  They can be hoisted, but this is more
 *    looping over properties and storing references.  We rely heavily on statics for testing and sub
 *    components.
 *
 * 4. Instance Methods
 *    Some instance methods may be exposed to users via refs.  Again, these are lost with HOC unless
 *    hoisted and exposed by the HOC.
 */



var getDefaultPropName = function getDefaultPropName(prop) {
  return 'default' + (prop[0].toUpperCase() + prop.slice(1));
};

/**
 * Return the auto controlled state value for a give prop. The initial value is chosen in this order:
 *  - regular props
 *  - then, default props
 *  - then, initial state
 *  - then, `checked` defaults to false
 *  - then, `value` defaults to '' or [] if props.multiple
 *  - else, undefined
 *
 *  @param {string} propName A prop name
 *  @param {object} [props] A props object
 *  @param {object} [state] A state object
 *  @param {boolean} [includeDefaults=false] Whether or not to heed the default props or initial state
 */
var getAutoControlledStateValue = function getAutoControlledStateValue(propName, props, state) {
  var includeDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  // regular props
  var propValue = props[propName];
  if (propValue !== undefined) return propValue;

  if (includeDefaults) {
    // defaultProps
    var defaultProp = props[getDefaultPropName(propName)];
    if (defaultProp !== undefined) return defaultProp;

    // initial state - state may be null or undefined
    if (state) {
      var initialState = state[propName];
      if (initialState !== undefined) return initialState;
    }
  }

  // React doesn't allow changing from uncontrolled to controlled components,
  // default checked/value if they were not present.
  if (propName === 'checked') return false;
  if (propName === 'value') return props.multiple ? [] : '';

  // otherwise, undefined
};

var AutoControlledComponent = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AutoControlledComponent, _Component);

  function AutoControlledComponent() {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AutoControlledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AutoControlledComponent.__proto__ || Object.getPrototypeOf(AutoControlledComponent)).call.apply(_ref, [this].concat(args)));

    _initialiseProps.call(_this);

    var autoControlledProps = _this.constructor.autoControlledProps;

    var state = __WEBPACK_IMPORTED_MODULE_14_lodash_invoke___default()(_this, 'getInitialAutoControlledState', _this.props) || {};

    if (false) {
      var _this$constructor = _this.constructor,
          defaultProps = _this$constructor.defaultProps,
          name = _this$constructor.name,
          propTypes = _this$constructor.propTypes;
      // require static autoControlledProps

      if (!autoControlledProps) {
        console.error('Auto controlled ' + name + ' must specify a static autoControlledProps array.');
      }

      // require propTypes
      _each(autoControlledProps, function (prop) {
        var defaultProp = getDefaultPropName(prop);
        // regular prop
        if (!_has(propTypes, defaultProp)) {
          console.error(name + ' is missing "' + defaultProp + '" propTypes validation for auto controlled prop "' + prop + '".');
        }
        // its default prop
        if (!_has(propTypes, prop)) {
          console.error(name + ' is missing propTypes validation for auto controlled prop "' + prop + '".');
        }
      });

      // prevent autoControlledProps in defaultProps
      //
      // When setting state, auto controlled props values always win (so the parent can manage them).
      // It is not reasonable to decipher the difference between props from the parent and defaultProps.
      // Allowing defaultProps results in trySetState always deferring to the defaultProp value.
      // Auto controlled props also listed in defaultProps can never be updated.
      //
      // To set defaults for an AutoControlled prop, you can set the initial state in the
      // constructor or by using an ES7 property initializer:
      // https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers
      var illegalDefaults = _intersection(autoControlledProps, _keys(defaultProps));
      if (!_isEmpty(illegalDefaults)) {
        console.error(['Do not set defaultProps for autoControlledProps. You can set defaults by', 'setting state in the constructor or using an ES7 property initializer', '(https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers)', 'See ' + name + ' props: "' + illegalDefaults + '".'].join(' '));
      }

      // prevent listing defaultProps in autoControlledProps
      //
      // Default props are automatically handled.
      // Listing defaults in autoControlledProps would result in allowing defaultDefaultValue props.
      var illegalAutoControlled = _filter(autoControlledProps, function (prop) {
        return _startsWith(prop, 'default');
      });
      if (!_isEmpty(illegalAutoControlled)) {
        console.error(['Do not add default props to autoControlledProps.', 'Default props are automatically handled.', 'See ' + name + ' autoControlledProps: "' + illegalAutoControlled + '".'].join(' '));
      }
    }

    // Auto controlled props are copied to state.
    // Set initial state by copying auto controlled props to state.
    // Also look for the default prop for any auto controlled props (foo => defaultFoo)
    // so we can set initial values from defaults.
    var initialAutoControlledState = autoControlledProps.reduce(function (acc, prop) {
      acc[prop] = getAutoControlledStateValue(prop, _this.props, state, true);

      if (false) {
        var defaultPropName = getDefaultPropName(prop);
        var _name = _this.constructor.name;
        // prevent defaultFoo={} along side foo={}

        if (!_isUndefined(_this.props[defaultPropName]) && !_isUndefined(_this.props[prop])) {
          console.error(_name + ' prop "' + prop + '" is auto controlled. Specify either ' + defaultPropName + ' or ' + prop + ', but not both.');
        }
      }

      return acc;
    }, {});

    _this.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state, initialAutoControlledState);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AutoControlledComponent, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var autoControlledProps = this.constructor.autoControlledProps;

      // Solve the next state for autoControlledProps

      var newState = autoControlledProps.reduce(function (acc, prop) {
        var isNextUndefined = __WEBPACK_IMPORTED_MODULE_6_lodash_isUndefined___default()(nextProps[prop]);
        var propWasRemoved = !__WEBPACK_IMPORTED_MODULE_6_lodash_isUndefined___default()(_this2.props[prop]) && isNextUndefined;

        // if next is defined then use its value
        if (!isNextUndefined) acc[prop] = nextProps[prop];

        // reinitialize state for props just removed / set undefined
        else if (propWasRemoved) acc[prop] = getAutoControlledStateValue(prop, nextProps);

        return acc;
      }, {});

      if (Object.keys(newState).length > 0) this.setState(newState);
    }

    /**
     * Safely attempt to set state for props that might be controlled by the user.
     * Second argument is a state object that is always passed to setState.
     * @param {object} maybeState State that corresponds to controlled props.
     * @param {object} [state] Actual state, useful when you also need to setState.
     */

  }]);

  return AutoControlledComponent;
}(__WEBPACK_IMPORTED_MODULE_15_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.trySetState = function (maybeState, state) {
    var autoControlledProps = _this3.constructor.autoControlledProps;

    if (false) {
      var name = _this3.constructor.name;
      // warn about failed attempts to setState for keys not listed in autoControlledProps

      var illegalKeys = _difference(_keys(maybeState), autoControlledProps);
      if (!_isEmpty(illegalKeys)) {
        console.error([name + ' called trySetState() with controlled props: "' + illegalKeys + '".', 'State will not be set.', 'Only props in static autoControlledProps will be set on state.'].join(' '));
      }
    }

    var newState = Object.keys(maybeState).reduce(function (acc, prop) {
      // ignore props defined by the parent
      if (_this3.props[prop] !== undefined) return acc;

      // ignore props not listed in auto controlled props
      if (autoControlledProps.indexOf(prop) === -1) return acc;

      acc[prop] = maybeState[prop];
      return acc;
    }, {});

    if (state) newState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, newState, state);

    if (Object.keys(newState).length > 0) _this3.setState(newState);
  };
};

/* harmony default export */ __webpack_exports__["a"] = (AutoControlledComponent);

/***/ }),
/* 560 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 561 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 563 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59),
    isArguments = __webpack_require__(109),
    isArray = __webpack_require__(15);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 565 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(64);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(568);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 569 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isLength = __webpack_require__(172),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(287);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(28);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(574),
    getMatchData = __webpack_require__(585),
    matchesStrictComparable = __webpack_require__(298);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(179),
    baseIsEqual = __webpack_require__(180);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(105);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 576 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 578 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(105),
    Map = __webpack_require__(171),
    MapCache = __webpack_require__(170);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(179),
    equalArrays = __webpack_require__(288),
    equalByTag = __webpack_require__(581),
    equalObjects = __webpack_require__(582),
    getTag = __webpack_require__(53),
    isArray = __webpack_require__(15),
    isBuffer = __webpack_require__(87),
    isTypedArray = __webpack_require__(121);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59),
    Uint8Array = __webpack_require__(290),
    eq = __webpack_require__(83),
    equalArrays = __webpack_require__(288),
    mapToArray = __webpack_require__(291),
    setToArray = __webpack_require__(124);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(292);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(60),
    root = __webpack_require__(23);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(297),
    keys = __webpack_require__(26);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(180),
    get = __webpack_require__(29),
    hasIn = __webpack_require__(299),
    isKey = __webpack_require__(169),
    isStrictComparable = __webpack_require__(297),
    matchesStrictComparable = __webpack_require__(298),
    toKey = __webpack_require__(62);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 587 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(300),
    basePropertyDeep = __webpack_require__(589),
    isKey = __webpack_require__(169),
    toKey = __webpack_require__(62);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(85);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38),
    baseIntersection = __webpack_require__(591),
    baseRest = __webpack_require__(52),
    castArrayLikeObject = __webpack_require__(592);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(112),
    arrayIncludes = __webpack_require__(113),
    arrayIncludesWith = __webpack_require__(175),
    arrayMap = __webpack_require__(38),
    baseUnary = __webpack_require__(63),
    cacheHas = __webpack_require__(115);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(116);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChildMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mergeChildMappings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_keyBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);









/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {object} children Element's children
 * @return {object} Mapping of key to child
 */
var getChildMapping = function getChildMapping(children) {
  return __WEBPACK_IMPORTED_MODULE_5_lodash_keyBy___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_filter___default()(__WEBPACK_IMPORTED_MODULE_6_react__["Children"].toArray(children), __WEBPACK_IMPORTED_MODULE_6_react__["isValidElement"]), 'key');
};

var getPendingKeys = function getPendingKeys(prev, next) {
  var nextKeysPending = {};
  var pendingKeys = [];

  __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_keys___default()(prev), function (prevKey) {
    if (!__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(next, prevKey)) {
      pendingKeys.push(prevKey);
      return;
    }

    if (pendingKeys.length) {
      nextKeysPending[prevKey] = pendingKeys;
      pendingKeys = [];
    }
  });

  return [nextKeysPending, pendingKeys];
};

var getValue = function getValue(key, prev, next) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(next, key) ? next[key] : prev[key];
};

/**
 * When you're adding or removing children some may be added or removed in the same render pass. We want to show *both*
 * since we want to simultaneously animate elements in and out. This function takes a previous set of keys and a new set
 * of keys and merges them with its best guess of the correct ordering.
 *
 * @param {object} prev Prev children as returned from `getChildMapping()`
 * @param {object} next Next children as returned from `getChildMapping()`
 * @return {object} A key set that contains all keys in `prev` and all keys in `next` in a reasonable order
 */
var mergeChildMappings = function mergeChildMappings() {
  var prev = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var childMapping = {};

  var _getPendingKeys = getPendingKeys(prev, next),
      _getPendingKeys2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_getPendingKeys, 2),
      nextKeysPending = _getPendingKeys2[0],
      pendingKeys = _getPendingKeys2[1];

  __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_keys___default()(next), function (nextKey) {
    if (__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(nextKeysPending, nextKey)) {
      __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(nextKeysPending[nextKey], function (pendingKey) {
        childMapping[pendingKey] = getValue(pendingKey, prev, next);
      });
    }

    childMapping[nextKey] = getValue(nextKey, prev, next);
  });

  __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(pendingKeys, function (pendingKey) {
    childMapping[pendingKey] = getValue(pendingKey, prev, next);
  });

  return childMapping;
};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(595), __esModule: true };

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(165);
__webpack_require__(103);
module.exports = __webpack_require__(596);


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(302);
var ITERATOR = __webpack_require__(33)('iterator');
var Iterators = __webpack_require__(74);
module.exports = __webpack_require__(22).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(598), __esModule: true };

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(165);
__webpack_require__(103);
module.exports = __webpack_require__(599);


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(55);
var get = __webpack_require__(303);
module.exports = __webpack_require__(22).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(125),
    createAggregator = __webpack_require__(601);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(602),
    baseAggregator = __webpack_require__(603),
    baseIteratee = __webpack_require__(27),
    isArray = __webpack_require__(15);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 602 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(64);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "someByType", function() { return someByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findByType", function() { return findByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNil", function() { return isNil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);





/**
 * Determine if child by type exists in children.
 * @param {Object} children The children prop of a component.
 * @param {string|Function} type An html tag name string or React component.
 * @returns {Boolean}
 */
var someByType = function someByType(children, type) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_some___default()(__WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children), { type: type });
};

/**
 * Find child by type.
 * @param {Object} children The children prop of a component.
 * @param {string|Function} type An html tag name string or React component.
 * @returns {undefined|Object}
 */
var findByType = function findByType(children, type) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(__WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children), { type: type });
};

/**
 * Tests if children are nil in React and Preact.
 * @param {Object} children The children prop of a component.
 * @returns {Boolean}
 */
var isNil = function isNil(children) {
  return children === null || children === undefined || Array.isArray(children) && children.length === 0;
};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(27),
    isArrayLike = __webpack_require__(28),
    keys = __webpack_require__(26);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(64);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useKeyOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useValueAndKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useKeyOrValueAndKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useMultipleProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return useTextAlignProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return useVerticalAlignProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return useWidthProp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberToWord__ = __webpack_require__(183);



/*
 * There are 3 prop patterns used to build up the className for a component.
 * Each utility here is meant for use in a classnames() argument.
 *
 * There is no util for valueOnly() because it would simply return val.
 * Use the prop value inline instead.
 *   <Label size='big' />
 *   <div class="ui big label"></div>
 */

/**
 * Props where only the prop key is used in the className.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example
 * <Label tag />
 * <div class="ui tag label"></div>
 */
var useKeyOnly = function useKeyOnly(val, key) {
  return val && key;
};

/**
 * Props that require both a key and value to create a className.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example
 * <Label corner='left' />
 * <div class="ui left corner label"></div>
 */
var useValueAndKey = function useValueAndKey(val, key) {
  return val && val !== true && val + ' ' + key;
};

/**
 * Props whose key will be used in className, or value and key.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example Key Only
 * <Label pointing />
 * <div class="ui pointing label"></div>
 *
 * @example Key and Value
 * <Label pointing='left' />
 * <div class="ui left pointing label"></div>
 */
var useKeyOrValueAndKey = function useKeyOrValueAndKey(val, key) {
  return val && (val === true ? key : val + ' ' + key);
};

//
// Prop to className exceptions
//

/**
 * The "multiple" prop implements control of visibility and reserved classes for Grid subcomponents.
 *
 * @param {*} val The value of the "multiple" prop
 * @param {*} key A props key
 *
 * @example
 * <Grid.Row only='mobile' />
 * <Grid.Row only='mobile tablet' />
 * <div class="mobile only row"></div>
 * <div class="mobile only tablet only row"></div>
 */
var useMultipleProp = function useMultipleProp(val, key) {
  if (!val || val === true) return null;

  return val.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (prop) {
    return prop.replace('-', ' ') + ' ' + key;
  }).join(' ');
};

/**
 * The "textAlign" prop follows the useValueAndKey except when the value is "justified'.
 * In this case, only the class "justified" is used, ignoring the "aligned" class.
 * @param {*} val The value of the "textAlign" prop
 *
 * @example
 * <Container textAlign='justified' />
 * <div class="ui justified container"></div>
 *
 * @example
 * <Container textAlign='left' />
 * <div class="ui left aligned container"></div>
 */
var useTextAlignProp = function useTextAlignProp(val) {
  return val === 'justified' ? 'justified' : useValueAndKey(val, 'aligned');
};

/**
 * The "verticalAlign" prop follows the useValueAndKey.
 *
 * @param {*} val The value of the "verticalAlign" prop
 *
 * @example
 * <Grid verticalAlign='middle' />
 * <div class="ui middle aligned grid"></div>
 */
var useVerticalAlignProp = function useVerticalAlignProp(val) {
  return useValueAndKey(val, 'aligned');
};

/**
 * Create "X", "X wide" and "equal width" classNames.
 * "X" is a numberToWord value and "wide" is configurable.
 * @param {*} val The prop value
 * @param {string} [widthClass=''] The class
 * @param {boolean} [canEqual=false] Flag that indicates possibility of "equal" value
 *
 * @example
 * <Grid columns='equal' />
 * <div class="ui equal width grid"></div>
 *
 * <Form widths='equal' />
 * <div class="ui equal width form"></div>
 *
 * <FieldGroup widths='equal' />
 * <div class="equal width fields"></div>
 *
 * @example
 * <Grid columns={4} />
 * <div class="ui four column grid"></div>
 */
var useWidthProp = function useWidthProp(val) {
  var widthClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var canEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (canEqual && val === 'equal') {
    return 'equal width';
  }
  var valType = typeof val === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(val);
  if ((valType === 'string' || valType === 'number') && widthClass) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__numberToWord__["a" /* numberToWord */])(val) + ' ' + widthClass;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__numberToWord__["a" /* numberToWord */])(val);
};

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export as */
/* unused harmony export domNode */
/* unused harmony export suggest */
/* unused harmony export disallow */
/* unused harmony export every */
/* unused harmony export some */
/* unused harmony export givenProps */
/* unused harmony export demand */
/* unused harmony export multipleProp */
/* unused harmony export contentShorthand */
/* unused harmony export itemShorthand */
/* unused harmony export collectionShorthand */
/* unused harmony export deprecate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_take__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_fp_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_fp_min__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_fp_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_fp_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__leven__ = __webpack_require__(328);





















var typeOf = function typeOf() {
  var _Object$prototype$toS;

  return (_Object$prototype$toS = Object.prototype.toString).call.apply(_Object$prototype$toS, arguments);
};

/**
 * Ensure a component can render as a give prop value.
 */
var as = function as() {
  return __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.symbol]).apply(undefined, arguments);
};

/**
 * Ensure a prop is a valid DOM node.
 */
var domNode = function domNode(props, propName) {
  // skip if prop is undefined
  if (props[propName] === undefined) return;
  // skip if prop is valid
  if (props[propName] instanceof Element) return;

  throw new Error('Invalid prop "' + propName + '" supplied, expected a DOM node.');
};

/**
 * Similar to PropTypes.oneOf but shows closest matches.
 * Word order is ignored allowing `left chevron` to match `chevron left`.
 * Useful for very large lists of options (e.g. Icon name, Flag name, etc.)
 * @param {string[]} suggestions An array of allowed values.
 */
var suggest = function suggest(suggestions) {
  if (!Array.isArray(suggestions)) {
    throw new Error('Invalid argument supplied to suggest, expected an instance of array.');
  }

  /* eslint-disable max-nested-callbacks */
  var findBestSuggestions = __WEBPACK_IMPORTED_MODULE_16_lodash_fp_memoize___default()(function (str) {
    var propValueWords = str.split(' ');

    return __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (suggestion) {
      var suggestionWords = suggestion.split(' ');

      var propValueScore = __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (x) {
        return __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (y) {
          return Object(__WEBPACK_IMPORTED_MODULE_18__leven__["a" /* default */])(x, y);
        }, suggestionWords);
      }), __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_fp_min___default.a), __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum___default.a)(propValueWords);

      var suggestionScore = __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (x) {
        return __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (y) {
          return Object(__WEBPACK_IMPORTED_MODULE_18__leven__["a" /* default */])(x, y);
        }, propValueWords);
      }), __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_fp_min___default.a), __WEBPACK_IMPORTED_MODULE_12_lodash_fp_sum___default.a)(suggestionWords);

      return { suggestion: suggestion, score: propValueScore + suggestionScore };
    }), __WEBPACK_IMPORTED_MODULE_11_lodash_fp_sortBy___default()(['score', 'suggestion']), __WEBPACK_IMPORTED_MODULE_10_lodash_fp_take___default()(3))(suggestions);
  });
  /* eslint-enable max-nested-callbacks */

  // Convert the suggestions list into a hash map for O(n) lookup times. Ensure
  // the words in each key are sorted alphabetically so that we have a consistent
  // way of looking up a value in the map, i.e. we can sort the words in the
  // incoming propValue and look that up without having to check all permutations.
  var suggestionsLookup = suggestions.reduce(function (acc, key) {
    acc[key.split(' ').sort().join(' ')] = true;
    return acc;
  }, {});

  return function (props, propName, componentName) {
    var propValue = props[propName];

    // skip if prop is undefined or is included in the suggestions
    if (!propValue || suggestionsLookup[propValue]) return;

    // check if the words were correct but ordered differently.
    // Since we're matching for classNames we need to allow any word order
    // to pass validation, e.g. `left chevron` vs `chevron left`.
    var propValueSorted = propValue.split(' ').sort().join(' ');
    if (suggestionsLookup[propValueSorted]) return;

    // find best suggestions
    var bestMatches = findBestSuggestions(propValue);

    // skip if a match scored 0
    if (bestMatches.some(function (x) {
      return x.score === 0;
    })) return;

    return new Error(['Invalid prop `' + propName + '` of value `' + propValue + '` supplied to `' + componentName + '`.', '\n\nInstead of `' + propValue + '`, did you mean:', bestMatches.map(function (x) {
      return '\n  - ' + x.suggestion;
    }).join(''), '\n'].join(''));
  };
};

/**
 * Disallow other props from being defined with this prop.
 * @param {string[]} disallowedProps An array of props that cannot be used with this prop.
 */
var disallow = function disallow(disallowedProps) {
  return function (props, propName, componentName) {
    if (!Array.isArray(disallowedProps)) {
      throw new Error(['Invalid argument supplied to disallow, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
    }

    // skip if prop is undefined
    if (__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default()(props[propName]) || props[propName] === false) return;

    // find disallowed props with values
    var disallowed = disallowedProps.reduce(function (acc, disallowedProp) {
      if (!__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default()(props[disallowedProp]) && props[disallowedProp] !== false) {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(acc), [disallowedProp]);
      }
      return acc;
    }, []);

    if (disallowed.length > 0) {
      return new Error(['Prop `' + propName + '` in `' + componentName + '` conflicts with props: `' + disallowed.join('`, `') + '`.', 'They cannot be defined together, choose one or the other.'].join(' '));
    }
  };
};

/**
 * Ensure a prop adherers to multiple prop type validators.
 * @param {function[]} validators An array of propType functions.
 */
var every = function every(validators) {
  return function (props, propName, componentName) {
    for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    if (!Array.isArray(validators)) {
      throw new Error(['Invalid argument supplied to every, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
    }

    var errors = __WEBPACK_IMPORTED_MODULE_15_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(function (validator) {
      if (typeof validator !== 'function') {
        throw new Error('every() argument "validators" should contain functions, found: ' + typeOf(validator) + '.');
      }
      return validator.apply(undefined, [props, propName, componentName].concat(rest));
    }), __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact___default.a)(validators);

    // we can only return one error at a time
    return errors[0];
  };
};

/**
 * Ensure a prop adherers to at least one of the given prop type validators.
 * @param {function[]} validators An array of propType functions.
 */
var some = function some(validators) {
  return function (props, propName, componentName) {
    for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    if (!Array.isArray(validators)) {
      throw new Error(['Invalid argument supplied to some, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
    }

    var errors = __WEBPACK_IMPORTED_MODULE_8_lodash_fp_compact___default()(__WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(validators, function (validator) {
      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_fp_isFunction___default()(validator)) {
        throw new Error('some() argument "validators" should contain functions, found: ' + typeOf(validator) + '.');
      }
      return validator.apply(undefined, [props, propName, componentName].concat(rest));
    }));

    // fail only if all validators failed
    if (errors.length === validators.length) {
      var error = new Error('One of these validators must pass:');
      error.message += '\n' + __WEBPACK_IMPORTED_MODULE_14_lodash_fp_map___default()(errors, function (err, i) {
        return '[' + (i + 1) + ']: ' + err.message;
      }).join('\n');
      return error;
    }
  };
};

/**
 * Ensure a validator passes only when a component has a given propsShape.
 * @param {object} propsShape An object describing the prop shape.
 * @param {function} validator A propType function.
 */
var givenProps = function givenProps(propsShape, validator) {
  return function (props, propName, componentName) {
    for (var _len3 = arguments.length, rest = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
      rest[_key3 - 3] = arguments[_key3];
    }

    if (!__WEBPACK_IMPORTED_MODULE_6_lodash_fp_isPlainObject___default()(propsShape)) {
      throw new Error(['Invalid argument supplied to givenProps, expected an object.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
    }

    if (typeof validator !== 'function') {
      throw new Error(['Invalid argument supplied to givenProps, expected a function.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
    }

    var shouldValidate = __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default()(propsShape).every(function (key) {
      var val = propsShape[key];
      // require propShape validators to pass or prop values to match
      return typeof val === 'function' ? !val.apply(undefined, [props, key, componentName].concat(rest)) : val === props[propName];
    });

    if (!shouldValidate) return;

    var error = validator.apply(undefined, [props, propName, componentName].concat(rest));

    if (error) {
      // poor mans shallow pretty print, prevents JSON circular reference errors
      var prettyProps = '{ ' + __WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_pick___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_keys___default()(propsShape), props)).map(function (key) {
        var val = props[key];
        var renderedValue = val;
        if (typeof val === 'string') renderedValue = '"' + val + '"';else if (Array.isArray(val)) renderedValue = '[' + val.join(', ') + ']';else if (__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject___default()(val)) renderedValue = '{...}';

        return key + ': ' + renderedValue;
      }).join(', ') + ' }';

      error.message = 'Given props ' + prettyProps + ': ' + error.message;
      return error;
    }
  };
};

/**
 * Define prop dependencies by requiring other props.
 * @param {string[]} requiredProps An array of required prop names.
 */
var demand = function demand(requiredProps) {
  return function (props, propName, componentName) {
    if (!Array.isArray(requiredProps)) {
      throw new Error(['Invalid `requiredProps` argument supplied to require, expected an instance of array.', ' See `' + propName + '` prop in `' + componentName + '`.'].join(''));
    }

    // skip if prop is undefined
    if (props[propName] === undefined) return;

    var missingRequired = requiredProps.filter(function (requiredProp) {
      return props[requiredProp] === undefined;
    });
    if (missingRequired.length > 0) {
      return new Error('`' + propName + '` prop in `' + componentName + '` requires props: `' + missingRequired.join('`, `') + '`.');
    }
  };
};

/**
 * Ensure an multiple prop contains a string with only possible values.
 * @param {string[]} possible An array of possible values to prop.
 */
var multipleProp = function multipleProp(possible) {
  return function (props, propName, componentName) {
    if (!Array.isArray(possible)) {
      throw new Error(['Invalid argument supplied to some, expected an instance of array.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
    }

    var propValue = props[propName];

    // skip if prop is undefined
    if (__WEBPACK_IMPORTED_MODULE_9_lodash_fp_isNil___default()(propValue) || propValue === false) return;

    var values = propValue.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (val) {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_fp_trim___default()(val).replace('-', ' ');
    });
    var invalid = __WEBPACK_IMPORTED_MODULE_1_lodash_fp_difference___default()(values, possible);

    // fail only if there are invalid values
    if (invalid.length > 0) {
      return new Error('`' + propName + '` prop in `' + componentName + '` has invalid values: `' + invalid.join('`, `') + '`.');
    }
  };
};

/**
 * Ensure a component can render as a node passed as a prop value in place of children.
 */
var contentShorthand = function contentShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.node]).apply(undefined, arguments);
};

/**
 * Item shorthand is a description of a component that can be a literal,
 * a props object, or an element.
 */
var itemShorthand = function itemShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.object]))])]).apply(undefined, arguments);
};

/**
 * Collection shorthand ensures a prop is an array of item shorthand.
 */
var collectionShorthand = function collectionShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_17_prop_types___default.a.arrayOf(itemShorthand)]).apply(undefined, arguments);
};

/**
 * Show a deprecated warning for component props with a help message and optional validator.
 * @param {string} help A help message to display with the deprecation warning.
 * @param {function} [validator] A propType function.
 */
var deprecate = function deprecate(help, validator) {
  return function (props, propName, componentName) {
    for (var _len4 = arguments.length, args = Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
      args[_key4 - 3] = arguments[_key4];
    }

    if (typeof help !== 'string') {
      throw new Error(['Invalid `help` argument supplied to deprecate, expected a string.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
    }

    // skip if prop is undefined
    if (props[propName] === undefined) return;

    // deprecation error and help
    var error = new Error('The `' + propName + '` prop in `' + componentName + '` is deprecated.');
    if (help) error.message += ' ' + help;

    // add optional validation error message
    if (validator) {
      if (typeof validator === 'function') {
        var validationError = validator.apply(undefined, [props, propName, componentName].concat(args));
        if (validationError) {
          error.message = error.message + ' ' + validationError.message;
        }
      } else {
        throw new Error(['Invalid argument supplied to deprecate, expected a function.', 'See `' + propName + '` prop in `' + componentName + '`.'].join(' '));
      }
    }

    return error;
  };
};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(610), __esModule: true };

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(103);
__webpack_require__(611);
module.exports = __webpack_require__(22).Array.from;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(154);
var $export = __webpack_require__(47);
var toObject = __webpack_require__(81);
var call = __webpack_require__(612);
var isArrayIter = __webpack_require__(613);
var toLength = __webpack_require__(264);
var createProperty = __webpack_require__(614);
var getIterFn = __webpack_require__(303);

$export($export.S + $export.F * !__webpack_require__(615)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(55);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(74);
var ITERATOR = __webpack_require__(33)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(49);
var createDesc = __webpack_require__(80);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(33)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('difference', __webpack_require__(174));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(618),
    fallbackHolder = __webpack_require__(13);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 618 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(620),
  'assign': __webpack_require__(317),
  'clone': __webpack_require__(633),
  'curry': __webpack_require__(321),
  'forEach': __webpack_require__(90),
  'isArray': __webpack_require__(15),
  'isError': __webpack_require__(651),
  'isFunction': __webpack_require__(61),
  'isWeakMap': __webpack_require__(652),
  'iteratee': __webpack_require__(653),
  'keys': __webpack_require__(123),
  'rearg': __webpack_require__(654),
  'toInteger': __webpack_require__(40),
  'toPath': __webpack_require__(656)
};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(127);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(128),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(110),
    createCtor = __webpack_require__(128),
    createHybrid = __webpack_require__(308),
    createRecurry = __webpack_require__(311),
    getHolder = __webpack_require__(188),
    replaceHolders = __webpack_require__(129),
    root = __webpack_require__(23);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 623 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 624 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(184),
    LodashWrapper = __webpack_require__(187),
    baseLodash = __webpack_require__(185),
    isArray = __webpack_require__(15),
    isObjectLike = __webpack_require__(20),
    wrapperClone = __webpack_require__(626);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(184),
    LodashWrapper = __webpack_require__(187),
    copyArray = __webpack_require__(92);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 627 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 628 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(90),
    arrayIncludes = __webpack_require__(113);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(92),
    isIndex = __webpack_require__(84);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(110),
    createCtor = __webpack_require__(128),
    root = __webpack_require__(23);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(309),
    composeArgsRight = __webpack_require__(310),
    replaceHolders = __webpack_require__(129);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(318);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(93),
    keysIn = __webpack_require__(189);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(25),
    isPrototype = __webpack_require__(88),
    nativeKeysIn = __webpack_require__(636);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 636 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(23);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120)(module)))

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(93),
    getSymbols = __webpack_require__(181);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(93),
    getSymbolsIn = __webpack_require__(319);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 640 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(190),
    cloneDataView = __webpack_require__(642),
    cloneRegExp = __webpack_require__(643),
    cloneSymbol = __webpack_require__(644),
    cloneTypedArray = __webpack_require__(645);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(190);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 643 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(190);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(91),
    getPrototype = __webpack_require__(131),
    isPrototype = __webpack_require__(88);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(648),
    baseUnary = __webpack_require__(63),
    nodeUtil = __webpack_require__(122);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(650),
    baseUnary = __webpack_require__(63),
    nodeUtil = __webpack_require__(122);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(20),
    isPlainObject = __webpack_require__(132);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(53),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(318),
    baseIteratee = __webpack_require__(27);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(127),
    flatRest = __webpack_require__(191);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(86);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38),
    copyArray = __webpack_require__(92),
    isArray = __webpack_require__(15),
    isSymbol = __webpack_require__(58),
    stringToPath = __webpack_require__(272),
    toKey = __webpack_require__(62),
    toString = __webpack_require__(37);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('trim', __webpack_require__(658));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(108),
    baseTrim = __webpack_require__(283),
    castSlice = __webpack_require__(192),
    charsEndIndex = __webpack_require__(659),
    charsStartIndex = __webpack_require__(660),
    stringToArray = __webpack_require__(133),
    toString = __webpack_require__(37);

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim(string);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(114);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(114);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 662 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('isObject', __webpack_require__(25), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('pick', __webpack_require__(193));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(322),
    hasIn = __webpack_require__(299);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('keys', __webpack_require__(26), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('isPlainObject', __webpack_require__(132), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('isFunction', __webpack_require__(61), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('compact', __webpack_require__(324), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('isNil', __webpack_require__(19), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('take', __webpack_require__(672));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(111),
    toInteger = __webpack_require__(40);

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = take;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('sortBy', __webpack_require__(674));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(86),
    baseOrderBy = __webpack_require__(675),
    baseRest = __webpack_require__(52),
    isIterateeCall = __webpack_require__(75);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38),
    baseGet = __webpack_require__(85),
    baseIteratee = __webpack_require__(27),
    baseMap = __webpack_require__(325),
    baseSortBy = __webpack_require__(676),
    baseUnary = __webpack_require__(63),
    compareMultiple = __webpack_require__(677),
    identity = __webpack_require__(39),
    isArray = __webpack_require__(15);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 676 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(678);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(58);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('sum', __webpack_require__(326), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('min', __webpack_require__(682), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(683),
    baseLt = __webpack_require__(684),
    identity = __webpack_require__(39);

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseLt)
    : undefined;
}

module.exports = min;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(58);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 684 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(686);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(187),
    flatRest = __webpack_require__(191),
    getData = __webpack_require__(186),
    getFuncName = __webpack_require__(314),
    isArray = __webpack_require__(15),
    isLaziable = __webpack_require__(312);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('memoize', __webpack_require__(273));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeDebugger */
/* unused harmony export debug */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isBrowser__ = __webpack_require__(195);



if (Object(__WEBPACK_IMPORTED_MODULE_0__isBrowser__["a" /* default */])() && "production" !== 'production' && "production" !== 'test') {
  // Heads Up!
  // https://github.com/visionmedia/debug/pull/331
  //
  // debug now clears storage on load, grab the debug settings before require('debug').
  // We try/catch here as Safari throws on localStorage access in private mode or with cookies disabled.
  var DEBUG = void 0;
  try {
    DEBUG = window.localStorage.debug;
  } catch (e) {
    /* eslint-disable no-console */
    console.error('Semantic-UI-React could not enable debug.');
    console.error(e);
    /* eslint-enable no-console */
  }

  // enable what ever settings we got from storage
}

/**
 * Create a namespaced debug function.
 * @param {String} namespace Usually a component name.
 * @example
 * import { makeDebugger } from 'src/lib'
 * const debug = makeDebugger('namespace')
 *
 * debug('Some message')
 * @returns {Function}
 */
var makeDebugger = function makeDebugger(namespace) {};

/**
 * Default debugger, simple log.
 * @example
 * import { debug } from 'src/lib'
 * debug('Some message')
 */
var debug = makeDebugger('log');

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventStack__ = __webpack_require__(690);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__eventStack__["a"]; });



/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isBrowser__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventTarget__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__normalizeTarget__ = __webpack_require__(694);





var EventStack = function EventStack() {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, EventStack);

  this._find = function (target) {
    var autoCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var normalized = Object(__WEBPACK_IMPORTED_MODULE_3__normalizeTarget__["a" /* default */])(target);

    if (_this._targets.has(normalized)) return _this._targets.get(normalized);
    if (!autoCreate) return;

    var eventTarget = new __WEBPACK_IMPORTED_MODULE_2__EventTarget__["a" /* default */](normalized);
    _this._targets.set(normalized, eventTarget);

    return eventTarget;
  };

  this._remove = function (target) {
    var normalized = Object(__WEBPACK_IMPORTED_MODULE_3__normalizeTarget__["a" /* default */])(target);

    _this._targets.delete(normalized);
  };

  this.sub = function (name, handlers) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__isBrowser__["a" /* default */])()) return;

    var _options$target = options.target,
        target = _options$target === undefined ? document : _options$target,
        _options$pool = options.pool,
        pool = _options$pool === undefined ? 'default' : _options$pool;

    var eventTarget = _this._find(target);

    eventTarget.sub(name, handlers, pool);
  };

  this.unsub = function (name, handlers) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__isBrowser__["a" /* default */])()) return;

    var _options$target2 = options.target,
        target = _options$target2 === undefined ? document : _options$target2,
        _options$pool2 = options.pool,
        pool = _options$pool2 === undefined ? 'default' : _options$pool2;

    var eventTarget = _this._find(target, false);

    if (eventTarget) {
      eventTarget.unsub(name, handlers, pool);
      if (eventTarget.empty()) _this._remove(target);
    }
  };

  this._targets = new Map();
}

// ------------------------------------
// Target utils
// ------------------------------------

// ------------------------------------
// Pub/sub
// ------------------------------------

;

var instance = new EventStack();

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_set__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniq__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_some__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_last__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_forEach__);













var EventTarget = function EventTarget(target) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, EventTarget);

  this._handlers = {};
  this._pools = {};

  this._emit = function (name) {
    return function (event) {
      __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(_this._pools, function (pool, poolName) {
        var handlers = pool[name];


        if (!handlers) return;
        if (poolName === 'default') {
          __WEBPACK_IMPORTED_MODULE_11_lodash_forEach___default()(handlers, function (handler) {
            return handler(event);
          });
          return;
        }
        __WEBPACK_IMPORTED_MODULE_10_lodash_last___default()(handlers)(event);
      });
    };
  };

  this._normalize = function (handlers) {
    return __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default()(handlers) ? handlers : [handlers];
  };

  this._listen = function (name) {
    if (__WEBPACK_IMPORTED_MODULE_8_lodash_has___default()(_this._handlers, name)) return;
    var handler = _this._emit(name);

    _this.target.addEventListener(name, handler);
    _this._handlers[name] = handler;
  };

  this._unlisten = function (name) {
    if (__WEBPACK_IMPORTED_MODULE_7_lodash_some___default()(_this._pools, name)) return;
    var handler = _this._handlers[name];


    _this.target.removeEventListener(name, handler);
    delete _this._handlers[name];
  };

  this.empty = function () {
    return __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(_this._handlers);
  };

  this.sub = function (name, handlers) {
    var pool = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';

    var events = __WEBPACK_IMPORTED_MODULE_5_lodash_uniq___default()([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(_this._pools, pool + '.' + name, [])), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this._normalize(handlers))));

    _this._listen(name);
    __WEBPACK_IMPORTED_MODULE_3_lodash_set___default()(_this._pools, pool + '.' + name, events);
  };

  this.unsub = function (name, handlers) {
    var pool = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';

    var events = __WEBPACK_IMPORTED_MODULE_2_lodash_without___default.a.apply(undefined, [__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(_this._pools, pool + '.' + name, [])].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this._normalize(handlers))));

    if (events.length > 0) {
      __WEBPACK_IMPORTED_MODULE_3_lodash_set___default()(_this._pools, pool + '.' + name, events);
      return;
    }

    __WEBPACK_IMPORTED_MODULE_3_lodash_set___default()(_this._pools, pool + '.' + name, undefined);
    _this._unlisten(name);
  };

  this.target = target;
}

// ------------------------------------
// Utils
// ------------------------------------

// ------------------------------------
// Listeners handling
// ------------------------------------

// ------------------------------------
// Pub/sub
// ------------------------------------

;

/* harmony default export */ __webpack_exports__["a"] = (EventTarget);

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(323);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(295),
    noop = __webpack_require__(313),
    setToArray = __webpack_require__(124);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Normalizes `target` for EventStack, because `target` can be passed as `boolean` or `string`.
 *
 * @param {boolean|string|HTMLElement|Window} target Value for normalization.
 * @return {HTMLElement|Window} A DOM node.
 */
var normalizeTarget = function normalizeTarget(target) {
  if (target === 'document') return document;
  if (target === 'window') return window;
  return target || document;
};

/* harmony default export */ __webpack_exports__["a"] = (normalizeTarget);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = createShorthand;
/* harmony export (immutable) */ __webpack_exports__["h"] = createShorthandFactory;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createHTMLDivision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHTMLIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createHTMLImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createHTMLInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createHTMLLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createHTMLParagraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isPlainObject__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);














// ============================================================
// Factories
// ============================================================

/**
 * A more robust React.createElement. It can create elements from primitive values.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @param {string|object|function} val The value to create a ReactElement from
 * @param {Object} [options={}]
 * @param {object} [options.defaultProps={}] Default props object
 * @param {object|function} [options.overrideProps={}] Override props object or function (called with regular props)
 * @returns {object|null}
 */
function createShorthand(Component, mapValueToProps, val) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (typeof Component !== 'function' && typeof Component !== 'string') {
    throw new Error('createShorthand() Component must be a string or function.');
  }
  // short circuit noop values
  if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(val) || __WEBPACK_IMPORTED_MODULE_8_lodash_isBoolean___default()(val)) return null;

  var valIsString = __WEBPACK_IMPORTED_MODULE_7_lodash_isString___default()(val);
  var valIsNumber = __WEBPACK_IMPORTED_MODULE_6_lodash_isNumber___default()(val);

  var isReactElement = Object(__WEBPACK_IMPORTED_MODULE_11_react__["isValidElement"])(val);
  var isPropsObject = __WEBPACK_IMPORTED_MODULE_5_lodash_isPlainObject___default()(val);
  var isPrimitiveValue = valIsString || valIsNumber || __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(val);

  // unhandled type return null
  /* eslint-disable no-console */
  if (!isReactElement && !isPropsObject && !isPrimitiveValue) {
    if (false) {
      console.error(['Shorthand value must be a string|number|array|object|ReactElement.', ' Use null|undefined|boolean for none', ' Received ' + (typeof val === 'undefined' ? 'undefined' : _typeof(val)) + '.'].join(''));
    }
    return null;
  }
  /* eslint-enable no-console */

  // ----------------------------------------
  // Build up props
  // ----------------------------------------
  var _options$defaultProps = options.defaultProps,
      defaultProps = _options$defaultProps === undefined ? {} : _options$defaultProps;

  // User's props

  var usersProps = isReactElement && val.props || isPropsObject && val || isPrimitiveValue && mapValueToProps(val);

  // Override props
  var _options$overrideProp = options.overrideProps,
      overrideProps = _options$overrideProp === undefined ? {} : _options$overrideProp;

  overrideProps = __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(overrideProps) ? overrideProps(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultProps, usersProps)) : overrideProps;

  // Merge props
  /* eslint-disable react/prop-types */
  var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultProps, usersProps, overrideProps);

  // Merge className
  if (defaultProps.className || overrideProps.className || usersProps.className) {
    var mergedClassesNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(defaultProps.className, overrideProps.className, usersProps.className);
    props.className = __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default()(mergedClassesNames.split(' ')).join(' ');
  }

  // Merge style
  if (defaultProps.style || overrideProps.style || usersProps.style) {
    props.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultProps.style, usersProps.style, overrideProps.style);
  }

  // ----------------------------------------
  // Get key
  // ----------------------------------------

  // Use key, childKey, or generate key
  if (__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(props.key)) {
    var childKey = props.childKey;


    if (!__WEBPACK_IMPORTED_MODULE_9_lodash_isNil___default()(childKey)) {
      // apply and consume the childKey
      props.key = typeof childKey === 'function' ? childKey(props) : childKey;
      delete props.childKey;
    } else if (valIsString || valIsNumber) {
      // use string/number shorthand values as the key
      props.key = val;
    }
  }
  /* eslint-enable react/prop-types */

  // ----------------------------------------
  // Create Element
  // ----------------------------------------

  // Clone ReactElements
  if (isReactElement) return Object(__WEBPACK_IMPORTED_MODULE_11_react__["cloneElement"])(val, props);

  // Create ReactElements from built up props
  if (isPrimitiveValue || isPropsObject) return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Component, props);
}

// ============================================================
// Factory Creators
// ============================================================

/**
 * Creates a `createShorthand` function that is waiting for a value and options.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @returns {function} A shorthand factory function waiting for `val` and `defaultProps`.
 */
createShorthand.handledProps = [];
function createShorthandFactory(Component, mapValueToProps) {
  if (typeof Component !== 'function' && typeof Component !== 'string') {
    throw new Error('createShorthandFactory() Component must be a string or function.');
  }

  return function (val, options) {
    return createShorthand(Component, mapValueToProps, val, options);
  };
}

// ============================================================
// HTML Factories
// ============================================================
var createHTMLDivision = createShorthandFactory('div', function (val) {
  return { children: val };
});
var createHTMLIframe = createShorthandFactory('iframe', function (src) {
  return { src: src };
});
var createHTMLImage = createShorthandFactory('img', function (val) {
  return { src: val };
});
var createHTMLInput = createShorthandFactory('input', function (val) {
  return { type: val };
});
var createHTMLLabel = createShorthandFactory('label', function (val) {
  return { children: val };
});
var createHTMLParagraph = createShorthandFactory('p', function (val) {
  return { children: val };
});

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns an object consisting of props beyond the scope of the Component.
 * Useful for getting and spreading unknown props from the user.
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @returns {{}} A shallow copy of the prop object
 */
var getUnhandledProps = function getUnhandledProps(Component, props) {
  // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
  var _Component$handledPro = Component.handledProps,
      handledProps = _Component$handledPro === undefined ? [] : _Component$handledPro;


  return Object.keys(props).reduce(function (acc, prop) {
    if (prop === 'childKey') return acc;
    if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
    return acc;
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = (getUnhandledProps);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns a createElement() type based on the props of the Component.
 * Useful for calculating what type a component should render as.
 *
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @param {function} [getDefault] A function that returns a default element type.
 * @returns {string|function} A ReactElement type
 */
function getElementType(Component, props, getDefault) {
  var _Component$defaultPro = Component.defaultProps,
      defaultProps = _Component$defaultPro === undefined ? {} : _Component$defaultPro;

  // ----------------------------------------
  // user defined "as" element type

  if (props.as && props.as !== defaultProps.as) return props.as;

  // ----------------------------------------
  // computed default element type

  if (getDefault) {
    var computedDefault = getDefault();
    if (computedDefault) return computedDefault;
  }

  // ----------------------------------------
  // infer anchor links

  if (props.href) return 'a';

  // ----------------------------------------
  // use defaultProp or 'div'

  return defaultProps.as || 'div';
}

/* harmony default export */ __webpack_exports__["a"] = (getElementType);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return htmlInputAttrs; });
/* unused harmony export htmlInputEvents */
/* unused harmony export htmlInputProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return partitionHTMLProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);




var htmlInputAttrs = [
// REACT
'selected', 'defaultValue', 'defaultChecked',

// LIMITED HTML PROPS
'accept', 'autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'checked', 'disabled', 'form', 'id', 'list', 'max', 'maxLength', 'min', 'minLength', 'multiple', 'name', 'pattern', 'placeholder', 'readOnly', 'required', 'step', 'type', 'value'];

var htmlInputEvents = [
// EVENTS
// keyboard
'onKeyDown', 'onKeyPress', 'onKeyUp',

// focus
'onFocus', 'onBlur',

// form
'onChange', 'onInput',

// mouse
'onClick', 'onContextMenu', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp',

// selection
'onSelect',

// touch
'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];

var htmlInputProps = [].concat(htmlInputAttrs, htmlInputEvents);

/**
 * Returns an array of objects consisting of: props of html input element and rest.
 * @param {object} props A ReactElement props object
 * @param {Object} [options={}]
 * @param {Array} [options.htmlProps] An array of html input props
 * @param {boolean} [options.includeAria] Includes all input props that starts with "aria-"
 * @returns {[{}, {}]} An array of objects
 */
var partitionHTMLProps = function partitionHTMLProps(props) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$htmlProps = options.htmlProps,
      htmlProps = _options$htmlProps === undefined ? htmlInputProps : _options$htmlProps,
      _options$includeAria = options.includeAria,
      includeAria = _options$includeAria === undefined ? true : _options$includeAria;

  var inputProps = {};
  var rest = {};

  __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(props, function (val, prop) {
    var possibleAria = includeAria && (/^aria-.*$/.test(prop) || prop === 'role');
    var target = __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(htmlProps, prop) || possibleAria ? inputProps : rest;
    target[prop] = val;
  });

  return [inputProps, rest];
};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_inRange__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_inRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_first__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_some__);







/**
 * Determines if a click's coordinates are within the bounds of a node.
 *
 * @see https://github.com/Semantic-Org/Semantic-UI-React/pull/2384
 *
 * @param {object} node - A DOM node.
 * @param {object} e - A SyntheticEvent or DOM Event.
 * @returns {boolean}
 */
var doesNodeContainClick = function doesNodeContainClick(node, e) {
  if (__WEBPACK_IMPORTED_MODULE_4_lodash_some___default()([e, node], __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a)) return false;

  // if there is an e.target and it is in the document, use a simple node.contains() check
  if (e.target) {
    __WEBPACK_IMPORTED_MODULE_2_lodash_invoke___default()(e.target, 'setAttribute', 'data-suir-click-target', true);

    if (document.querySelector('[data-suir-click-target=true]')) {
      __WEBPACK_IMPORTED_MODULE_2_lodash_invoke___default()(e.target, 'removeAttribute', 'data-suir-click-target');
      return node.contains(e.target);
    }
  }

  // Below logic handles cases where the e.target is no longer in the document.
  // The result of the click likely has removed the e.target node.
  // Instead of node.contains(), we'll identify the click by X/Y position.

  // return early if the event properties aren't available
  // prevent measuring the node and repainting if we don't need to
  var clientX = e.clientX,
      clientY = e.clientY;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_some___default()([clientX, clientY], __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a)) return false;

  // false if the node is not visible
  var clientRects = node.getClientRects();
  // Heads Up!
  // getClientRects returns a DOMRectList, not an array nor a plain object
  // We explicitly avoid _.isEmpty and check .length to cover all possible shapes
  if (!node.offsetWidth || !node.offsetHeight || !clientRects || !clientRects.length) return false;

  // false if the node doesn't have a valid bounding rect

  var _first2 = __WEBPACK_IMPORTED_MODULE_1_lodash_first___default()(clientRects),
      top = _first2.top,
      bottom = _first2.bottom,
      left = _first2.left,
      right = _first2.right;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_some___default()([top, bottom, left, right], __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default.a)) return false;

  // we add a small decimal to the upper bound just to make it inclusive
  // don't add an whole pixel (1) as the event/node values may be decimal sensitive
  return __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default()(clientY, top, bottom + 0.001) && __WEBPACK_IMPORTED_MODULE_0_lodash_inRange___default()(clientX, left, right + 0.001);
};

/* harmony default export */ __webpack_exports__["a"] = (doesNodeContainClick);

/***/ }),
/* 702 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin(start, end) && number < nativeMax(start, end);
}

module.exports = baseInRange;


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(704);


/***/ }),
/* 704 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('startsWith', __webpack_require__(281));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('has', __webpack_require__(51));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('eq', __webpack_require__(83));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('curry', __webpack_require__(321));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('get', __webpack_require__(29));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('includes', __webpack_require__(41));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('values', __webpack_require__(76), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPaginationItems__ = __webpack_require__(713);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createPaginationItems__["a"]; });



/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemFactories__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rangeFactories__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paginationUtils__ = __webpack_require__(719);





/**
 * @param {object} rawOptions
 * @param {number} rawOptions.activePage
 * @param {number} rawOptions.boundaryRange Number of always visible pages at the beginning and end.
 * @param {number} rawOptions.siblingRange Number of always visible pages before and after the current one.
 * @param {number} rawOptions.totalPages Total number of pages.
 */
var createPaginationItems = function createPaginationItems(rawOptions) {
  var options = Object(__WEBPACK_IMPORTED_MODULE_3__paginationUtils__["b" /* typifyOptions */])(rawOptions);
  var activePage = options.activePage,
      totalPages = options.totalPages;


  var pageFactory = Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["e" /* createPageFactory */])(activePage);
  var innerRange = Object(__WEBPACK_IMPORTED_MODULE_3__paginationUtils__["a" /* isSimplePagination */])(options) ? Object(__WEBPACK_IMPORTED_MODULE_2__rangeFactories__["b" /* createSimpleRange */])(1, totalPages, pageFactory) : Object(__WEBPACK_IMPORTED_MODULE_2__rangeFactories__["a" /* createComplexRange */])(options, pageFactory);

  return [Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["b" /* createFirstPage */])(), Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["f" /* createPrevItem */])(activePage)].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(innerRange), [Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["d" /* createNextItem */])(activePage, totalPages), Object(__WEBPACK_IMPORTED_MODULE_1__itemFactories__["c" /* createLastItem */])(totalPages)]);
};

/* harmony default export */ __webpack_exports__["a"] = (createPaginationItems);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createSimpleRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createComplexRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__suffixFactories__ = __webpack_require__(718);






var createSimpleRange = function createSimpleRange(start, end, pageFactory) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(start, end + 1), pageFactory);
};

var createComplexRange = function createComplexRange(options, pageFactory) {
  var activePage = options.activePage,
      boundaryRange = options.boundaryRange,
      siblingRange = options.siblingRange,
      totalPages = options.totalPages;


  var firstGroupEnd = boundaryRange;
  var firstGroup = createSimpleRange(1, firstGroupEnd, pageFactory);

  var lastGroupStart = totalPages + 1 - boundaryRange;
  var lastGroup = createSimpleRange(lastGroupStart, totalPages, pageFactory);

  var innerGroupStart = Math.min(Math.max(activePage - siblingRange, firstGroupEnd + 2), lastGroupStart - 1 - 2 * siblingRange - 1);
  var innerGroupEnd = innerGroupStart + 2 * siblingRange;
  var innerGroup = createSimpleRange(innerGroupStart, innerGroupEnd, pageFactory);

  return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(firstGroup), [Object(__WEBPACK_IMPORTED_MODULE_3__suffixFactories__["a" /* createInnerPrefix */])(firstGroupEnd, innerGroupStart, pageFactory)], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(innerGroup), [Object(__WEBPACK_IMPORTED_MODULE_3__suffixFactories__["b" /* createInnerSuffix */])(innerGroupEnd, lastGroupStart, pageFactory)], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(lastGroup)).filter(Boolean);
};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(716);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(717),
    isIterateeCall = __webpack_require__(75),
    toFinite = __webpack_require__(177);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createInnerPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createInnerSuffix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__itemFactories__ = __webpack_require__(333);


var createInnerPrefix = function createInnerPrefix(firstGroupEnd, innerGroupStart, pageFactory) {
  var prefixPage = innerGroupStart - 1;
  var showEllipsis = prefixPage !== firstGroupEnd + 1;
  var prefixFactory = showEllipsis ? __WEBPACK_IMPORTED_MODULE_0__itemFactories__["a" /* createEllipsisItem */] : pageFactory;

  return prefixFactory(prefixPage);
};

var createInnerSuffix = function createInnerSuffix(innerGroupEnd, lastGroupStart, pageFactory) {
  var suffixPage = innerGroupEnd + 1;
  var showEllipsis = suffixPage !== lastGroupStart - 1;
  var suffixFactory = showEllipsis ? __WEBPACK_IMPORTED_MODULE_0__itemFactories__["a" /* createEllipsisItem */] : pageFactory;

  return suffixFactory(suffixPage);
};

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isSimplePagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return typifyOptions; });
/**
 * Checks the possibility of using simple range generation, if number of generated pages is equal
 * or greater than total pages to show.
 *
 * @param {object} options
 * @param {number} options.boundaryRange Number of always visible pages at the beginning and end.
 * @param {number} options.siblingRange Number of always visible pages before and after the current one.
 * @param {number} options.totalPages Total number of pages.
 * @return {boolean}
 */
var isSimplePagination = function isSimplePagination(_ref) {
  var boundaryRange = _ref.boundaryRange,
      siblingRange = _ref.siblingRange,
      totalPages = _ref.totalPages;

  var boundaryRangeSize = 2 * boundaryRange;
  var ellipsisSize = 2;
  var siblingRangeSize = 2 * siblingRange;

  return 1 + ellipsisSize + siblingRangeSize + boundaryRangeSize >= totalPages;
};

var typifyOptions = function typifyOptions(_ref2) {
  var activePage = _ref2.activePage,
      boundaryRange = _ref2.boundaryRange,
      siblingRange = _ref2.siblingRange,
      totalPages = _ref2.totalPages;
  return {
    activePage: +activePage,
    boundaryRange: +boundaryRange,
    siblingRange: +siblingRange,
    totalPages: +totalPages
  };
};

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLORS", function() { return COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLOATS", function() { return FLOATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIZES", function() { return SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ALIGNMENTS", function() { return TEXT_ALIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERTICAL_ALIGNMENTS", function() { return VERTICAL_ALIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VISIBILITY", function() { return VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDTHS", function() { return WIDTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIRECTIONAL_TRANSITIONS", function() { return DIRECTIONAL_TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATIC_TRANSITIONS", function() { return STATIC_TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSITIONS", function() { return TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WEB_CONTENT_ICONS", function() { return WEB_CONTENT_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_ACTIONS_ICONS", function() { return USER_ACTIONS_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MESSAGES_ICONS", function() { return MESSAGES_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USERS_ICONS", function() { return USERS_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GENDER_SEXUALITY_ICONS", function() { return GENDER_SEXUALITY_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCESSIBILITY_ICONS", function() { return ACCESSIBILITY_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIEW_ADJUSTMENT_ICONS", function() { return VIEW_ADJUSTMENT_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LITERAL_OBJECTS_ICONS", function() { return LITERAL_OBJECTS_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHAPES_ICONS", function() { return SHAPES_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ITEM_SELECTION_ICONS", function() { return ITEM_SELECTION_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDIA_ICONS", function() { return MEDIA_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINTERS_ICONS", function() { return POINTERS_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOBILE_ICONS", function() { return MOBILE_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPUTER_ICONS", function() { return COMPUTER_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_SYSTEM_ICONS", function() { return FILE_SYSTEM_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TECHNOLOGIES_ICONS", function() { return TECHNOLOGIES_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RATING_ICONS", function() { return RATING_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUDIO_ICONS", function() { return AUDIO_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAP_LOCATIONS_TRANSPORTATION_ICONS", function() { return MAP_LOCATIONS_TRANSPORTATION_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLES_ICONS", function() { return TABLES_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_EDITOR_ICONS", function() { return TEXT_EDITOR_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CURRENCY_ICONS", function() { return CURRENCY_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAYMENT_OPTIONS_ICONS", function() { return PAYMENT_OPTIONS_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NETWORKS_AND_WEBSITE_ICONS", function() { return NETWORKS_AND_WEBSITE_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS", function() { return ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_ALIASES", function() { return ICON_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS_AND_ALIASES", function() { return ICONS_AND_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPONENT_CONTEXT_SPECIFIC_ICONS", function() { return COMPONENT_CONTEXT_SPECIFIC_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALL_ICONS_IN_ALL_CONTEXTS", function() { return ALL_ICONS_IN_ALL_CONTEXTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_values__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__numberToWord__ = __webpack_require__(183);






var COLORS = ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'];
var FLOATS = ['left', 'right'];
var SIZES = ['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'];
var TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justified'];
var VERTICAL_ALIGNMENTS = ['bottom', 'middle', 'top'];

var VISIBILITY = ['mobile', 'tablet', 'computer', 'large screen', 'widescreen'];

var WIDTHS = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_keys___default()(__WEBPACK_IMPORTED_MODULE_3__numberToWord__["b" /* numberToWordMap */])), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_keys___default()(__WEBPACK_IMPORTED_MODULE_3__numberToWord__["b" /* numberToWordMap */]).map(Number)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_values___default()(__WEBPACK_IMPORTED_MODULE_3__numberToWord__["b" /* numberToWordMap */])));

var DIRECTIONAL_TRANSITIONS = ['browse', 'browse right', 'drop', 'fade', 'fade up', 'fade down', 'fade left', 'fade right', 'fly up', 'fly down', 'fly left', 'fly right', 'horizontal flip', 'vertical flip', 'scale', 'slide up', 'slide down', 'slide left', 'slide right', 'swing up', 'swing down', 'swing left', 'swing right'];
var STATIC_TRANSITIONS = ['jiggle', 'flash', 'shake', 'pulse', 'tada', 'bounce'];
var TRANSITIONS = [].concat(DIRECTIONAL_TRANSITIONS, STATIC_TRANSITIONS);

// Generated from:
// https://github.com/Semantic-Org/Semantic-UI/blob/master/dist/components/icon.css
var WEB_CONTENT_ICONS = ['search', 'mail outline', 'signal', 'setting', 'home', 'inbox', 'browser', 'tag', 'tags', 'image', 'calendar', 'comment', 'shop', 'comments', 'external', 'privacy', 'settings', 'comments', 'external', 'trophy', 'payment', 'feed', 'alarm outline', 'tasks', 'cloud', 'lab', 'mail', 'dashboard', 'comment outline', 'comments outline', 'sitemap', 'idea', 'alarm', 'terminal', 'code', 'protect', 'calendar outline', 'ticket', 'external square', 'bug', 'mail square', 'history', 'options', 'text telephone', 'find', 'wifi', 'alarm mute', 'alarm mute outline', 'copyright', 'at', 'eyedropper', 'paint brush', 'heartbeat', 'mouse pointer', 'hourglass empty', 'hourglass start', 'hourglass half', 'hourglass end', 'hourglass full', 'hand pointer', 'trademark', 'registered', 'creative commons', 'add to calendar', 'remove from calendar', 'delete calendar', 'checked calendar', 'industry', 'shopping bag', 'shopping basket', 'hashtag', 'percent', 'address book', 'address book outline', 'address card', 'address card outline', 'id badge', 'id card', 'id card outline', 'podcast', 'window close', 'window close outline', 'window maximize', 'window minimize', 'window restore'];
var USER_ACTIONS_ICONS = ['wait', 'download', 'repeat', 'refresh', 'lock', 'bookmark', 'print', 'write', 'adjust', 'theme', 'edit', 'external share', 'ban', 'mail forward', 'share', 'expand', 'compress', 'unhide', 'hide', 'random', 'retweet', 'sign out', 'pin', 'sign in', 'upload', 'call', 'remove bookmark', 'call square', 'unlock', 'configure', 'filter', 'wizard', 'undo', 'exchange', 'cloud download', 'cloud upload', 'reply', 'reply all', 'erase', 'unlock alternate', 'write square', 'share square', 'archive', 'translate', 'recycle', 'send', 'send outline', 'share alternate', 'share alternate square', 'add to cart', 'in cart', 'add user', 'remove user', 'object group', 'object ungroup', 'clone', 'talk', 'talk outline'];
var MESSAGES_ICONS = ['help circle', 'info circle', 'warning circle', 'warning sign', 'announcement', 'help', 'info', 'warning', 'birthday', 'help circle outline'];
var USERS_ICONS = ['user', 'users', 'doctor', 'handicap', 'student', 'child', 'spy', 'user circle', 'user circle outline', 'user outline'];
var GENDER_SEXUALITY_ICONS = ['female', 'male', 'woman', 'man', 'non binary transgender', 'intergender', 'transgender', 'lesbian', 'gay', 'heterosexual', 'other gender', 'other gender vertical', 'other gender horizontal', 'neuter', 'genderless'];
var ACCESSIBILITY_ICONS = ['universal access', 'wheelchair', 'blind', 'audio description', 'volume control phone', 'braille', 'asl', 'assistive listening systems', 'deafness', 'sign language', 'low vision'];
var VIEW_ADJUSTMENT_ICONS = ['block layout', 'grid layout', 'list layout', 'zoom', 'zoom out', 'resize vertical', 'resize horizontal', 'maximize', 'crop'];
var LITERAL_OBJECTS_ICONS = ['cocktail', 'road', 'flag', 'book', 'gift', 'leaf', 'fire', 'plane', 'magnet', 'lemon', 'world', 'travel', 'shipping', 'money', 'legal', 'lightning', 'umbrella', 'treatment', 'suitcase', 'bar', 'flag outline', 'flag checkered', 'puzzle', 'fire extinguisher', 'rocket', 'anchor', 'bullseye', 'sun', 'moon', 'fax', 'life ring', 'bomb', 'soccer', 'calculator', 'diamond', 'sticky note', 'sticky note outline', 'law', 'hand peace', 'hand rock', 'hand paper', 'hand scissors', 'hand lizard', 'hand spock', 'tv', 'thermometer empty', 'thermometer full', 'thermometer half', 'thermometer quarter', 'thermometer three quarters', 'bath', 'snowflake outline'];
var SHAPES_ICONS = ['crosshairs', 'asterisk', 'square outline', 'certificate', 'square', 'quote left', 'quote right', 'spinner', 'circle', 'ellipsis horizontal', 'ellipsis vertical', 'cube', 'cubes', 'circle notched', 'circle thin'];
var ITEM_SELECTION_ICONS = ['checkmark', 'remove', 'checkmark box', 'move', 'add circle', 'minus circle', 'remove circle', 'check circle', 'remove circle outline', 'check circle outline', 'plus', 'minus', 'add square', 'radio', 'minus square', 'minus square outline', 'check square', 'selected radio', 'plus square outline', 'toggle off', 'toggle on'];
var MEDIA_ICONS = ['film', 'sound', 'photo', 'bar chart', 'camera retro', 'newspaper', 'area chart', 'pie chart', 'line chart'];
var POINTERS_ICONS = ['arrow circle outline down', 'arrow circle outline up', 'chevron left', 'chevron right', 'arrow left', 'arrow right', 'arrow up', 'arrow down', 'chevron up', 'chevron down', 'pointing right', 'pointing left', 'pointing up', 'pointing down', 'arrow circle left', 'arrow circle right', 'arrow circle up', 'arrow circle down', 'caret down', 'caret up', 'caret left', 'caret right', 'angle double left', 'angle double right', 'angle double up', 'angle double down', 'angle left', 'angle right', 'angle up', 'angle down', 'chevron circle left', 'chevron circle right', 'chevron circle up', 'chevron circle down', 'toggle down', 'toggle up', 'toggle right', 'long arrow down', 'long arrow up', 'long arrow left', 'long arrow right', 'arrow circle outline right', 'arrow circle outline left', 'toggle left'];
var MOBILE_ICONS = ['tablet', 'mobile', 'battery full', 'battery high', 'battery medium', 'battery low', 'battery empty'];
var COMPUTER_ICONS = ['power', 'trash outline', 'disk outline', 'desktop', 'laptop', 'game', 'keyboard', 'plug'];
var FILE_SYSTEM_ICONS = ['trash', 'file outline', 'folder', 'folder open', 'file text outline', 'folder outline', 'folder open outline', 'level up', 'level down', 'file', 'file text', 'file pdf outline', 'file word outline', 'file excel outline', 'file powerpoint outline', 'file image outline', 'file archive outline', 'file audio outline', 'file video outline', 'file code outline'];
var TECHNOLOGIES_ICONS = ['qrcode', 'barcode', 'rss', 'fork', 'html5', 'css3', 'rss square', 'openid', 'database', 'server', 'usb', 'bluetooth', 'bluetooth alternative', 'microchip'];
var RATING_ICONS = ['heart', 'star', 'empty star', 'thumbs outline up', 'thumbs outline down', 'star half', 'empty heart', 'smile', 'frown', 'meh', 'star half empty', 'thumbs up', 'thumbs down'];
var AUDIO_ICONS = ['music', 'video play outline', 'volume off', 'volume down', 'volume up', 'record', 'step backward', 'fast backward', 'backward', 'play', 'pause', 'stop', 'forward', 'fast forward', 'step forward', 'eject', 'unmute', 'mute', 'video play', 'closed captioning', 'pause circle', 'pause circle outline', 'stop circle', 'stop circle outline'];
var MAP_LOCATIONS_TRANSPORTATION_ICONS = ['marker', 'coffee', 'food', 'building outline', 'hospital', 'emergency', 'first aid', 'military', 'h', 'location arrow', 'compass', 'space shuttle', 'university', 'building', 'paw', 'spoon', 'car', 'taxi', 'tree', 'bicycle', 'bus', 'ship', 'motorcycle', 'street view', 'hotel', 'train', 'subway', 'map pin', 'map signs', 'map outline', 'map'];
var TABLES_ICONS = ['table', 'columns', 'sort', 'sort descending', 'sort ascending', 'sort alphabet ascending', 'sort alphabet descending', 'sort content ascending', 'sort content descending', 'sort numeric ascending', 'sort numeric descending'];
var TEXT_EDITOR_ICONS = ['font', 'bold', 'italic', 'text height', 'text width', 'align left', 'align center', 'align right', 'align justify', 'list', 'outdent', 'indent', 'linkify', 'cut', 'copy', 'attach', 'save', 'content', 'unordered list', 'ordered list', 'strikethrough', 'underline', 'paste', 'unlinkify', 'superscript', 'subscript', 'header', 'paragraph', 'text cursor'];
var CURRENCY_ICONS = ['euro', 'pound', 'dollar', 'rupee', 'yen', 'ruble', 'won', 'bitcoin', 'lira', 'shekel'];
var PAYMENT_OPTIONS_ICONS = ['paypal', 'google wallet', 'visa', 'mastercard', 'discover', 'american express', 'paypal card', 'stripe', 'japan credit bureau', 'diners club', 'credit card alternative'];
var NETWORKS_AND_WEBSITE_ICONS = ['twitter square', 'facebook square', 'linkedin square', 'github square', 'twitter', 'facebook f', 'github', 'pinterest', 'pinterest square', 'google plus square', 'google plus', 'linkedin', 'github alternate', 'maxcdn', 'youtube square', 'youtube', 'xing', 'xing square', 'youtube play', 'dropbox', 'stack overflow', 'instagram', 'flickr', 'adn', 'bitbucket', 'bitbucket square', 'tumblr', 'tumblr square', 'apple', 'windows', 'android', 'linux', 'dribble', 'skype', 'foursquare', 'trello', 'gittip', 'vk', 'weibo', 'renren', 'pagelines', 'stack exchange', 'vimeo square', 'slack', 'wordpress', 'yahoo', 'google', 'reddit', 'reddit square', 'stumbleupon circle', 'stumbleupon', 'delicious', 'digg', 'pied piper', 'pied piper alternate', 'drupal', 'joomla', 'behance', 'behance square', 'steam', 'steam square', 'spotify', 'deviantart', 'soundcloud', 'vine', 'codepen', 'jsfiddle', 'rebel', 'empire', 'git square', 'git', 'hacker news', 'tencent weibo', 'qq', 'wechat', 'slideshare', 'twitch', 'yelp', 'lastfm', 'lastfm square', 'ioxhost', 'angellist', 'meanpath', 'buysellads', 'connectdevelop', 'dashcube', 'forumbee', 'leanpub', 'sellsy', 'shirtsinbulk', 'simplybuilt', 'skyatlas', 'facebook', 'pinterest', 'whatsapp', 'viacoin', 'medium', 'y combinator', 'optinmonster', 'opencart', 'expeditedssl', 'gg', 'gg circle', 'tripadvisor', 'odnoklassniki', 'odnoklassniki square', 'pocket', 'wikipedia', 'safari', 'chrome', 'firefox', 'opera', 'internet explorer', 'contao', '500px', 'amazon', 'houzz', 'vimeo', 'black tie', 'fonticons', 'reddit alien', 'microsoft edge', 'codiepie', 'modx', 'fort awesome', 'product hunt', 'mixcloud', 'scribd', 'gitlab', 'wpbeginner', 'wpforms', 'envira gallery', 'glide', 'glide g', 'viadeo', 'viadeo square', 'snapchat', 'snapchat ghost', 'snapchat square', 'pied piper hat', 'first order', 'yoast', 'themeisle', 'google plus circle', 'font awesome', 'bandcamp', 'eercast', 'etsy', 'free code camp', 'grav', 'imdb', 'linode', 'meetup', 'quora', 'ravelry', 'superpowers', 'telegram', 'wpexplorer'];
var ICONS = [].concat(WEB_CONTENT_ICONS, USER_ACTIONS_ICONS, MESSAGES_ICONS, USERS_ICONS, GENDER_SEXUALITY_ICONS, ACCESSIBILITY_ICONS, VIEW_ADJUSTMENT_ICONS, LITERAL_OBJECTS_ICONS, SHAPES_ICONS, ITEM_SELECTION_ICONS, MEDIA_ICONS, POINTERS_ICONS, MOBILE_ICONS, COMPUTER_ICONS, FILE_SYSTEM_ICONS, TECHNOLOGIES_ICONS, RATING_ICONS, AUDIO_ICONS, MAP_LOCATIONS_TRANSPORTATION_ICONS, TABLES_ICONS, TEXT_EDITOR_ICONS, CURRENCY_ICONS, PAYMENT_OPTIONS_ICONS, NETWORKS_AND_WEBSITE_ICONS);
var ICON_ALIASES = ['like', 'favorite', 'video', 'check', 'close', 'cancel', 'delete', 'x', 'zoom in', 'magnify', 'shutdown', 'clock', 'time', 'play circle outline', 'headphone', 'camera', 'video camera', 'picture', 'pencil', 'compose', 'point', 'tint', 'signup', 'plus circle', 'question circle', 'dont', 'minimize', 'add', 'exclamation circle', 'attention', 'eye', 'exclamation triangle', 'shuffle', 'chat', 'cart', 'shopping cart', 'bar graph', 'key', 'cogs', 'discussions', 'like outline', 'dislike outline', 'heart outline', 'log out', 'thumb tack', 'winner', 'phone', 'bookmark outline', 'phone square', 'credit card', 'hdd outline', 'bullhorn', 'bell outline', 'hand outline right', 'hand outline left', 'hand outline up', 'hand outline down', 'globe', 'wrench', 'briefcase', 'group', 'linkify', 'chain', 'flask', 'sidebar', 'bars', 'list ul', 'list ol', 'numbered list', 'magic', 'truck', 'currency', 'triangle down', 'dropdown', 'triangle up', 'triangle left', 'triangle right', 'envelope', 'conversation', 'rain', 'clipboard', 'lightbulb', 'bell', 'ambulance', 'medkit', 'fighter jet', 'beer', 'plus square', 'computer', 'circle outline', 'gamepad', 'star half full', 'broken chain', 'question', 'exclamation', 'eraser', 'microphone', 'microphone slash', 'shield', 'target', 'play circle', 'pencil square', 'eur', 'gbp', 'usd', 'inr', 'cny', 'rmb', 'jpy', 'rouble', 'rub', 'krw', 'btc', 'gratipay', 'zip', 'dot circle outline', 'try', 'graduation', 'circle outline', 'sliders', 'weixin', 'tty', 'teletype', 'binoculars', 'power cord', 'wifi', 'visa card', 'mastercard card', 'discover card', 'amex', 'american express card', 'stripe card', 'bell slash', 'bell slash outline', 'area graph', 'pie graph', 'line graph', 'cc', 'sheqel', 'ils', 'plus cart', 'arrow down cart', 'detective', 'venus', 'mars', 'mercury', 'intersex', 'venus double', 'female homosexual', 'mars double', 'male homosexual', 'venus mars', 'mars stroke', 'mars alternate', 'mars vertical', 'mars stroke vertical', 'mars horizontal', 'mars stroke horizontal', 'asexual', 'facebook official', 'user plus', 'user times', 'user close', 'user cancel', 'user delete', 'user x', 'bed', 'yc', 'ycombinator', 'battery four', 'battery three', 'battery three quarters', 'battery two', 'battery half', 'battery one', 'battery quarter', 'battery zero', 'i cursor', 'jcb', 'japan credit bureau card', 'diners club card', 'balance', 'hourglass outline', 'hourglass zero', 'hourglass one', 'hourglass two', 'hourglass three', 'hourglass four', 'grab', 'hand victory', 'tm', 'r circle', 'television', 'five hundred pixels', 'calendar plus', 'calendar minus', 'calendar times', 'calendar check', 'factory', 'commenting', 'commenting outline', 'edge', 'ms edge', 'wordpress beginner', 'wordpress forms', 'envira', 'question circle outline', 'assistive listening devices', 'als', 'ald', 'asl interpreting', 'deaf', 'american sign language interpreting', 'hard of hearing', 'signing', 'new pied piper', 'theme isle', 'google plus official', 'fa', 'bathtub', 'drivers license', 'drivers license outline', 's15', 'thermometer', 'times rectangle', 'times rectangle outline', 'vcard', 'vcard outline'];
var ICONS_AND_ALIASES = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ICONS), ICON_ALIASES);

// Some icon names are not part of icons.css.
// These are only valid as children of other components.
// Their CSS rules are defined by a specific component's CSS.
// We don't want to show name warnings for those usages so we add them as valid names here.
var COMPONENT_CONTEXT_SPECIFIC_ICONS = ['left dropdown'];
var ALL_ICONS_IN_ALL_CONTEXTS = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(ICONS_AND_ALIASES), COMPONENT_CONTEXT_SPECIFIC_ICONS);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_times__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_times___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_times__);

 /**
                                    * All previous KeyboardEvent key identifying properties are deprecated in favor of `key`.
                                    * Unfortunately, `key` is not yet fully supported.
                                    * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
                                    */

var codes = {
  // ----------------------------------------
  // By Code
  // ----------------------------------------
  3: 'Cancel',
  6: 'Help',
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  28: 'Convert',
  29: 'NonConvert',
  30: 'Accept',
  31: 'ModeChange',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  41: 'Select',
  42: 'Print',
  43: 'Execute',
  44: 'PrintScreen',
  45: 'Insert',
  46: 'Delete',
  48: ['0', ')'],
  49: ['1', '!'],
  50: ['2', '@'],
  51: ['3', '#'],
  52: ['4', '$'],
  53: ['5', '%'],
  54: ['6', '^'],
  55: ['7', '&'],
  56: ['8', '*'],
  57: ['9', '('],
  91: 'OS',
  93: 'ContextMenu',
  144: 'NumLock',
  145: 'ScrollLock',
  181: 'VolumeMute',
  182: 'VolumeDown',
  183: 'VolumeUp',
  186: [';', ':'],
  187: ['=', '+'],
  188: [',', '<'],
  189: ['-', '_'],
  190: ['.', '>'],
  191: ['/', '?'],
  192: ['`', '~'],
  219: ['[', '{'],
  220: ['\\', '|'],
  221: [']', '}'],
  222: ["'", '"'],
  224: 'Meta',
  225: 'AltGraph',
  246: 'Attn',
  247: 'CrSel',
  248: 'ExSel',
  249: 'EraseEof',
  250: 'Play',
  251: 'ZoomOut'

  // Function Keys (F1-24)
};__WEBPACK_IMPORTED_MODULE_1_lodash_times___default()(24, function (i) {
  return codes[112 + i] = 'F' + (i + 1);
});

// Alphabet (a-Z)
__WEBPACK_IMPORTED_MODULE_1_lodash_times___default()(26, function (i) {
  var n = i + 65;
  codes[n] = [String.fromCharCode(n + 32), String.fromCharCode(n)];
});

var keyboardKey = {
  codes: codes,

  /**
   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
   * @param {string|object} name A keyboard event like object or `key` name.
   * @param {string} [name.key] If object, it must have one of these keys.
   * @param {string} [name.keyCode] If object, it must have one of these keys.
   * @param {string} [name.which] If object, it must have one of these keys.
   * @returns {*}
   */
  getCode: function getCode(name) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(name)) {
      return name.keyCode || name.which || this[name.key];
    }
    return this[name];
  },


  /**
   * Get the key name from a keyboard event, `keyCode`, or `which` value.
   * @param {number|object} code A keyboard event like object or key name.
   * @param {number} [code.keyCode] If object, it must have one of these keys.
   * @param {number} [code.which] If object, it must have one of these keys.
   * @param {number} [code.shiftKey] If object, it must have one of these keys.
   * @returns {*}
   */
  getName: function getName(code) {
    var isEvent = __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(code);
    var name = codes[isEvent ? code.keyCode || code.which : code];

    if (Array.isArray(name)) {
      if (isEvent) {
        name = name[code.shiftKey ? 1 : 0];
      } else {
        name = name[0];
      }
    }

    return name;
  },


  // ----------------------------------------
  // By Name
  // ----------------------------------------
  // declare these manually for static analysis
  Cancel: 3,
  Help: 6,
  Backspace: 8,
  Tab: 9,
  Clear: 12,
  Enter: 13,
  Shift: 16,
  Control: 17,
  Alt: 18,
  Pause: 19,
  CapsLock: 20,
  Escape: 27,
  Convert: 28,
  NonConvert: 29,
  Accept: 30,
  ModeChange: 31,
  ' ': 32,
  PageUp: 33,
  PageDown: 34,
  End: 35,
  Home: 36,
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,
  Select: 41,
  Print: 42,
  Execute: 43,
  PrintScreen: 44,
  Insert: 45,
  Delete: 46,
  0: 48,
  ')': 48,
  1: 49,
  '!': 49,
  2: 50,
  '@': 50,
  3: 51,
  '#': 51,
  4: 52,
  $: 52,
  5: 53,
  '%': 53,
  6: 54,
  '^': 54,
  7: 55,
  '&': 55,
  8: 56,
  '*': 56,
  9: 57,
  '(': 57,
  a: 65,
  A: 65,
  b: 66,
  B: 66,
  c: 67,
  C: 67,
  d: 68,
  D: 68,
  e: 69,
  E: 69,
  f: 70,
  F: 70,
  g: 71,
  G: 71,
  h: 72,
  H: 72,
  i: 73,
  I: 73,
  j: 74,
  J: 74,
  k: 75,
  K: 75,
  l: 76,
  L: 76,
  m: 77,
  M: 77,
  n: 78,
  N: 78,
  o: 79,
  O: 79,
  p: 80,
  P: 80,
  q: 81,
  Q: 81,
  r: 82,
  R: 82,
  s: 83,
  S: 83,
  t: 84,
  T: 84,
  u: 85,
  U: 85,
  v: 86,
  V: 86,
  w: 87,
  W: 87,
  x: 88,
  X: 88,
  y: 89,
  Y: 89,
  z: 90,
  Z: 90,
  OS: 91,
  ContextMenu: 93,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  F13: 124,
  F14: 125,
  F15: 126,
  F16: 127,
  F17: 128,
  F18: 129,
  F19: 130,
  F20: 131,
  F21: 132,
  F22: 133,
  F23: 134,
  F24: 135,
  NumLock: 144,
  ScrollLock: 145,
  VolumeMute: 181,
  VolumeDown: 182,
  VolumeUp: 183,
  ';': 186,
  ':': 186,
  '=': 187,
  '+': 187,
  ',': 188,
  '<': 188,
  '-': 189,
  _: 189,
  '.': 190,
  '>': 190,
  '/': 191,
  '?': 191,
  '`': 192,
  '~': 192,
  '[': 219,
  '{': 219,
  '\\': 220,
  '|': 220,
  ']': 221,
  '}': 221,
  "'": 222,
  '"': 222,
  Meta: 224,
  AltGraph: 225,
  Attn: 246,
  CrSel: 247,
  ExSel: 248,
  EraseEof: 249,
  Play: 250,
  ZoomOut: 251

  // ----------------------------------------
  // By Alias
  // ----------------------------------------
  // provide dot-notation accessible keys for all key names
};keyboardKey.Spacebar = keyboardKey[' '];
keyboardKey.Digit0 = keyboardKey['0'];
keyboardKey.Digit1 = keyboardKey['1'];
keyboardKey.Digit2 = keyboardKey['2'];
keyboardKey.Digit3 = keyboardKey['3'];
keyboardKey.Digit4 = keyboardKey['4'];
keyboardKey.Digit5 = keyboardKey['5'];
keyboardKey.Digit6 = keyboardKey['6'];
keyboardKey.Digit7 = keyboardKey['7'];
keyboardKey.Digit8 = keyboardKey['8'];
keyboardKey.Digit9 = keyboardKey['9'];
keyboardKey.Tilde = keyboardKey['~'];
keyboardKey.GraveAccent = keyboardKey['`'];
keyboardKey.ExclamationPoint = keyboardKey['!'];
keyboardKey.AtSign = keyboardKey['@'];
keyboardKey.PoundSign = keyboardKey['#'];
keyboardKey.PercentSign = keyboardKey['%'];
keyboardKey.Caret = keyboardKey['^'];
keyboardKey.Ampersand = keyboardKey['&'];
keyboardKey.PlusSign = keyboardKey['+'];
keyboardKey.MinusSign = keyboardKey['-'];
keyboardKey.EqualsSign = keyboardKey['='];
keyboardKey.DivisionSign = keyboardKey['/'];
keyboardKey.MultiplicationSign = keyboardKey['*'];
keyboardKey.Comma = keyboardKey[','];
keyboardKey.Decimal = keyboardKey['.'];
keyboardKey.Colon = keyboardKey[':'];
keyboardKey.Semicolon = keyboardKey[';'];
keyboardKey.Pipe = keyboardKey['|'];
keyboardKey.BackSlash = keyboardKey['\\'];
keyboardKey.QuestionMark = keyboardKey['?'];
keyboardKey.SingleQuote = keyboardKey['"'];
keyboardKey.DoubleQuote = keyboardKey['"'];
keyboardKey.LeftCurlyBrace = keyboardKey['{'];
keyboardKey.RightCurlyBrace = keyboardKey['}'];
keyboardKey.LeftParenthesis = keyboardKey['('];
keyboardKey.RightParenthesis = keyboardKey[')'];
keyboardKey.LeftAngleBracket = keyboardKey['<'];
keyboardKey.RightAngleBracket = keyboardKey['>'];
keyboardKey.LeftSquareBracket = keyboardKey['['];
keyboardKey.RightSquareBracket = keyboardKey[']'];

/* harmony default export */ __webpack_exports__["a"] = (keyboardKey);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Normalizes the offset value.
 * @param {number|array} value The value to normalize.
 * @returns {number}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'number' || typeof value === 'string' ? [value, value] : value;
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Normalizes the duration of a transition.
 * @param {number|object} duration The value to normalize.
 * @param {'hide'|'show'} type The type of transition.
 * @returns {number}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (duration, type) {
  return typeof duration === 'number' || typeof duration === 'string' ? duration : duration[type];
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_transform__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_transform__);





/**
 * Naive and inefficient object difference, intended for development / debugging use only.
 * Deleted keys are shown as [DELETED].
 * @param {{}} source The source object
 * @param {{}} target The target object.
 * @returns {{}} A new object containing new/modified/deleted keys.
 * @example
 * import { objectDiff } from 'src/lib'
 *
 * const a = { key: 'val', foo: 'bar' }
 * const b = { key: 'val', foo: 'baz' }
 *
 * objectDiff(a, b)
 * //=> { foo: 'baz' }
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (source, target) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_transform___default()(source, function (res, val, key) {
    // deleted keys
    if (!__WEBPACK_IMPORTED_MODULE_1_lodash_has___default()(target, key)) res[key] = '[DELETED]';
    // new keys / changed values
    // Note, we tolerate isEqual here as this is a dev only utility and not included in production code
    else if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(val, target[key])) res[key] = target[key];
  }, {});
});

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(90),
    baseCreate = __webpack_require__(91),
    baseForOwn = __webpack_require__(178),
    baseIteratee = __webpack_require__(27),
    getPrototype = __webpack_require__(131),
    isArray = __webpack_require__(15),
    isBuffer = __webpack_require__(87),
    isFunction = __webpack_require__(61),
    isObject = __webpack_require__(25),
    isTypedArray = __webpack_require__(121);

/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = isArray(object),
      isArrLike = isArr || isBuffer(object) || isTypedArray(object);

  iteratee = baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (isObject(object)) {
      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

module.exports = transform;


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_shallowEqual__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_shallowEqual__);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_shallowEqual___default.a);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addons_Portal__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DimmerDimmable__ = __webpack_require__(339);













/**
 * A dimmer hides distractions to focus attention on particular content.
 */

var Dimmer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dimmer, _Component);

  function Dimmer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Dimmer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Dimmer.__proto__ || Object.getPrototypeOf(Dimmer)).call.apply(_ref, [this].concat(args))), _this), _this.handlePortalMount = function () {
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__lib__["t" /* isBrowser */])()) return;

      // Heads up, IE doesn't support second argument in add()
      document.body.classList.add('dimmed');
      document.body.classList.add('dimmable');
    }, _this.handlePortalUnmount = function () {
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__lib__["t" /* isBrowser */])()) return;

      // Heads up, IE doesn't support second argument in add()
      document.body.classList.remove('dimmed');
      document.body.classList.remove('dimmable');
    }, _this.handleClick = function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onClickOutside = _this$props.onClickOutside;


      if (onClick) onClick(e, _this.props);
      if (_this.centerRef && _this.centerRef !== e.target && Object(__WEBPACK_IMPORTED_MODULE_8__lib__["n" /* doesNodeContainClick */])(_this.centerRef, e)) return;
      if (onClickOutside) onClickOutside(e, _this.props);
    }, _this.handleCenterRef = function (c) {
      return _this.centerRef = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Dimmer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          content = _props.content,
          disabled = _props.disabled,
          inverted = _props.inverted,
          page = _props.page,
          simple = _props.simple;


      var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(active, 'active transition visible'), Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(page, 'page'), Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(simple, 'simple'), 'dimmer', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["r" /* getUnhandledProps */])(Dimmer, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* getElementType */])(Dimmer, this.props);

      var childrenContent = __WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(children) ? content : children;

      var dimmerElement = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, onClick: this.handleClick }),
        childrenContent && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: 'content' },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            'div',
            { className: 'center', ref: this.handleCenterRef },
            childrenContent
          )
        )
      );

      if (page) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__addons_Portal__["a" /* default */],
          {
            closeOnEscape: false,
            closeOnDocumentClick: false,
            onMount: this.handlePortalMount,
            onUnmount: this.handlePortalUnmount,
            open: active,
            openOnTriggerClick: false
          },
          dimmerElement
        );
      }

      return dimmerElement;
    }
  }]);

  return Dimmer;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Dimmer._meta = {
  name: 'Dimmer',
  type: __WEBPACK_IMPORTED_MODULE_8__lib__["b" /* META */].TYPES.MODULE
};
Dimmer.Dimmable = __WEBPACK_IMPORTED_MODULE_10__DimmerDimmable__["a" /* default */];
Dimmer.handledProps = ['active', 'as', 'children', 'className', 'content', 'disabled', 'inverted', 'onClick', 'onClickOutside', 'page', 'simple'];
/* harmony default export */ __webpack_exports__["a"] = (Dimmer);
Dimmer.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An active dimmer will dim its parent container. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A disabled dimmer cannot be activated */
  disabled: PropTypes.bool,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Handles click outside Dimmer's content, but inside Dimmer area.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClickOutside: PropTypes.func,

  /** A dimmer can be formatted to have its colors inverted. */
  inverted: PropTypes.bool,

  /** A dimmer can be formatted to be fixed to the page. */
  page: PropTypes.bool,

  /** A dimmer can be controlled with simple prop. */
  simple: PropTypes.bool
} : {};


Dimmer.create = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["m" /* createShorthandFactory */])(Dimmer, function (value) {
  return { content: value };
});

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Ref__ = __webpack_require__(199);














/**
 * A component that allows you to render children outside their parent.
 * @see Modal
 * @see Popup
 * @see Dimmer
 * @see Confirm
 */
var Portal = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Portal, _Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Portal.__proto__ || Object.getPrototypeOf(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.handleDocumentClick = function (e) {
      var _this$props = _this.props,
          closeOnDocumentClick = _this$props.closeOnDocumentClick,
          closeOnRootNodeClick = _this$props.closeOnRootNodeClick;


      if (!_this.rootNode // not mounted
      || !_this.portalNode // no portal
      || Object(__WEBPACK_IMPORTED_MODULE_9__lib__["n" /* doesNodeContainClick */])(_this.triggerNode, e) // event happened in trigger (delegate to trigger handlers)
      || Object(__WEBPACK_IMPORTED_MODULE_9__lib__["n" /* doesNodeContainClick */])(_this.portalNode, e) // event happened in the portal
      ) return; // ignore the click

      var didClickInRootNode = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["n" /* doesNodeContainClick */])(_this.rootNode, e);

      if (closeOnDocumentClick && !didClickInRootNode || closeOnRootNodeClick && didClickInRootNode) {

        _this.close(e);
      }
    }, _this.handleEscape = function (e) {
      if (!_this.props.closeOnEscape) return;
      if (__WEBPACK_IMPORTED_MODULE_9__lib__["u" /* keyboardKey */].getCode(e) !== __WEBPACK_IMPORTED_MODULE_9__lib__["u" /* keyboardKey */].Escape) return;

      _this.close(e);
    }, _this.handlePortalMouseLeave = function (e) {
      var _this$props2 = _this.props,
          closeOnPortalMouseLeave = _this$props2.closeOnPortalMouseLeave,
          mouseLeaveDelay = _this$props2.mouseLeaveDelay;


      if (!closeOnPortalMouseLeave) return;

      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
    }, _this.handlePortalMouseEnter = function () {
      // In order to enable mousing from the trigger to the portal, we need to
      // clear the mouseleave timer that was set when leaving the trigger.
      var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;


      if (!closeOnPortalMouseLeave) return;

      clearTimeout(_this.mouseLeaveTimer);
    }, _this.handleTriggerBlur = function (e) {
      for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }

      var _this$props3 = _this.props,
          trigger = _this$props3.trigger,
          closeOnTriggerBlur = _this$props3.closeOnTriggerBlur;

      // Call original event handler

      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default.a.apply(undefined, [trigger, 'props.onBlur', e].concat(rest));

      // do not close if focus is given to the portal
      var didFocusPortal = __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this, 'rootNode.contains', e.relatedTarget);

      if (!closeOnTriggerBlur || didFocusPortal) return;

      _this.close(e);
    }, _this.handleTriggerClick = function (e) {
      for (var _len3 = arguments.length, rest = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        rest[_key3 - 1] = arguments[_key3];
      }

      var _this$props4 = _this.props,
          trigger = _this$props4.trigger,
          closeOnTriggerClick = _this$props4.closeOnTriggerClick,
          openOnTriggerClick = _this$props4.openOnTriggerClick;
      var open = _this.state.open;

      // Call original event handler

      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default.a.apply(undefined, [trigger, 'props.onClick', e].concat(rest));

      if (open && closeOnTriggerClick) {

        _this.close(e);
      } else if (!open && openOnTriggerClick) {

        _this.open(e);
      }
    }, _this.handleTriggerFocus = function (e) {
      for (var _len4 = arguments.length, rest = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        rest[_key4 - 1] = arguments[_key4];
      }

      var _this$props5 = _this.props,
          trigger = _this$props5.trigger,
          openOnTriggerFocus = _this$props5.openOnTriggerFocus;

      // Call original event handler

      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default.a.apply(undefined, [trigger, 'props.onFocus', e].concat(rest));

      if (!openOnTriggerFocus) return;

      _this.open(e);
    }, _this.handleTriggerMouseLeave = function (e) {
      for (var _len5 = arguments.length, rest = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        rest[_key5 - 1] = arguments[_key5];
      }

      clearTimeout(_this.mouseEnterTimer);

      var _this$props6 = _this.props,
          trigger = _this$props6.trigger,
          closeOnTriggerMouseLeave = _this$props6.closeOnTriggerMouseLeave,
          mouseLeaveDelay = _this$props6.mouseLeaveDelay;

      // Call original event handler

      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default.a.apply(undefined, [trigger, 'props.onMouseLeave', e].concat(rest));

      if (!closeOnTriggerMouseLeave) return;

      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
    }, _this.handleTriggerMouseEnter = function (e) {
      for (var _len6 = arguments.length, rest = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        rest[_key6 - 1] = arguments[_key6];
      }

      clearTimeout(_this.mouseLeaveTimer);

      var _this$props7 = _this.props,
          trigger = _this$props7.trigger,
          mouseEnterDelay = _this$props7.mouseEnterDelay,
          openOnTriggerMouseEnter = _this$props7.openOnTriggerMouseEnter;

      // Call original event handler

      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default.a.apply(undefined, [trigger, 'props.onMouseEnter', e].concat(rest));

      if (!openOnTriggerMouseEnter) return;

      _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
    }, _this.open = function (e) {
      var onOpen = _this.props.onOpen;

      if (onOpen) onOpen(e, _this.props);

      _this.trySetState({ open: true });
    }, _this.openWithTimeout = function (e, delay) {
      // React wipes the entire event object and suggests using e.persist() if
      // you need the event for async access. However, even with e.persist
      // certain required props (e.g. currentTarget) are null so we're forced to clone.
      var eventClone = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, e);
      return setTimeout(function () {
        return _this.open(eventClone);
      }, delay || 0);
    }, _this.close = function (e) {
      var onClose = _this.props.onClose;

      if (onClose) onClose(e, _this.props);

      _this.trySetState({ open: false });
    }, _this.closeWithTimeout = function (e, delay) {
      // React wipes the entire event object and suggests using e.persist() if
      // you need the event for async access. However, even with e.persist
      // certain required props (e.g. currentTarget) are null so we're forced to clone.
      var eventClone = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, e);
      return setTimeout(function () {
        return _this.close(eventClone);
      }, delay || 0);
    }, _this.attachRenderSubTreeSubscribers = function (eventPool) {
      // Prevent race condition bug
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/2401
      if (!_this.rootNode) return null;

      _this.portalNode = _this.rootNode.firstElementChild;

      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].sub('mouseleave', _this.handlePortalMouseLeave, { pool: eventPool, target: _this.portalNode });
      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].sub('mouseenter', _this.handlePortalMouseEnter, { pool: eventPool, target: _this.portalNode });
    }, _this.mountPortal = function () {
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__lib__["t" /* isBrowser */])() || _this.rootNode) return;

      var _this$props8 = _this.props,
          eventPool = _this$props8.eventPool,
          _this$props8$mountNod = _this$props8.mountNode,
          mountNode = _this$props8$mountNod === undefined ? Object(__WEBPACK_IMPORTED_MODULE_9__lib__["t" /* isBrowser */])() ? document.body : null : _this$props8$mountNod,
          prepend = _this$props8.prepend;


      _this.rootNode = document.createElement('div');

      if (prepend) {
        mountNode.insertBefore(_this.rootNode, mountNode.firstElementChild);
      } else {
        mountNode.appendChild(_this.rootNode);
      }

      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].sub('click', _this.handleDocumentClick, { pool: eventPool });
      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].sub('keydown', _this.handleEscape, { pool: eventPool });
      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onMount', null, _this.props);
    }, _this.unmountPortal = function () {
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__lib__["t" /* isBrowser */])() || !_this.rootNode) return;

      var eventPool = _this.props.eventPool;


      __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(_this.rootNode);
      _this.rootNode.parentNode.removeChild(_this.rootNode);

      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].unsub('mouseleave', _this.handlePortalMouseLeave, { pool: eventPool, target: _this.portalNode });
      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].unsub('mouseenter', _this.handlePortalMouseEnter, { pool: eventPool, target: _this.portalNode });

      _this.rootNode = null;
      _this.portalNode = null;

      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].unsub('click', _this.handleDocumentClick, { pool: eventPool });
      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].unsub('keydown', _this.handleEscape, { pool: eventPool });
      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onUnmount', null, _this.props);
    }, _this.handleRef = function (c) {
      return _this.triggerNode = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // NOTE: Ideally the portal rendering would happen in the render() function
      // but React gives a warning about not being pure and suggests doing it
      // within this method.

      // If the portal is open, render (or re-render) the portal and child.
      this.renderPortal();

      if (prevState.open && !this.state.open) {
        this.unmountPortal();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmountPortal();

      // Clean up timers
      clearTimeout(this.mouseEnterTimer);
      clearTimeout(this.mouseLeaveTimer);
    }

    // ----------------------------------------
    // Document Event Handlers
    // ----------------------------------------

    // ----------------------------------------
    // Component Event Handlers
    // ----------------------------------------

    // ----------------------------------------
    // Behavior
    // ----------------------------------------

  }, {
    key: 'renderPortal',
    value: function renderPortal() {
      var _this2 = this;

      if (!this.state.open) return;
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          eventPool = _props.eventPool;


      this.mountPortal();

      // Server side rendering
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__lib__["t" /* isBrowser */])()) return null;

      this.rootNode.className = className || '';

      // when re-rendering, first remove listeners before re-adding them to the new node
      if (this.portalNode) {
        __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].unsub('mouseleave', this.handlePortalMouseLeave, { pool: eventPool, target: this.portalNode });
        __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].unsub('mouseenter', this.handlePortalMouseEnter, { pool: eventPool, target: this.portalNode });
      }

      __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, __WEBPACK_IMPORTED_MODULE_7_react__["Children"].only(children), this.rootNode, function () {
        return _this2.attachRenderSubTreeSubscribers(eventPool);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var trigger = this.props.trigger;


      if (!trigger) return null;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Ref__["a" /* default */],
        { innerRef: this.handleRef },
        Object(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(trigger, {
          onBlur: this.handleTriggerBlur,
          onClick: this.handleTriggerClick,
          onFocus: this.handleTriggerFocus,
          onMouseLeave: this.handleTriggerMouseLeave,
          onMouseEnter: this.handleTriggerMouseEnter
        })
      );
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* AutoControlledComponent */]);

Portal.defaultProps = {
  closeOnDocumentClick: true,
  closeOnEscape: true,
  eventPool: 'default',
  openOnTriggerClick: true
};
Portal.autoControlledProps = ['open'];
Portal._meta = {
  name: 'Portal',
  type: __WEBPACK_IMPORTED_MODULE_9__lib__["b" /* META */].TYPES.ADDON
};
Portal.handledProps = ['children', 'className', 'closeOnDocumentClick', 'closeOnEscape', 'closeOnPortalMouseLeave', 'closeOnRootNodeClick', 'closeOnTriggerBlur', 'closeOnTriggerClick', 'closeOnTriggerMouseLeave', 'defaultOpen', 'eventPool', 'mountNode', 'mouseEnterDelay', 'mouseLeaveDelay', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'open', 'openOnTriggerClick', 'openOnTriggerFocus', 'openOnTriggerMouseEnter', 'prepend', 'trigger'];
Portal.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /** Additional classes. */
  className: PropTypes.string,

  /** Controls whether or not the portal should close when the document is clicked. */
  closeOnDocumentClick: PropTypes.bool,

  /** Controls whether or not the portal should close when escape is pressed is displayed. */
  closeOnEscape: PropTypes.bool,

  /**
   * Controls whether or not the portal should close when mousing out of the portal.
   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
   * gap from the trigger to the portal.
   */
  closeOnPortalMouseLeave: PropTypes.bool,

  /**
   * Controls whether or not the portal should close on a click on the portal background.
   * NOTE: This differs from closeOnDocumentClick:
   * - DocumentClick - any click not within the portal
   * - RootNodeClick - a click not within the portal but within the portal's wrapper
   */
  closeOnRootNodeClick: PropTypes.bool,

  /** Controls whether or not the portal should close on blur of the trigger. */
  closeOnTriggerBlur: PropTypes.bool,

  /** Controls whether or not the portal should close on click of the trigger. */
  closeOnTriggerClick: PropTypes.bool,

  /** Controls whether or not the portal should close when mousing out of the trigger. */
  closeOnTriggerMouseLeave: PropTypes.bool,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Event pool namespace that is used to handle component events */
  eventPool: PropTypes.string,

  /** The node where the portal should mount. */
  mountNode: PropTypes.any,

  /** Milliseconds to wait before opening on mouse over */
  mouseEnterDelay: PropTypes.number,

  /** Milliseconds to wait before closing on mouse leave */
  mouseLeaveDelay: PropTypes.number,

  /**
   * Called when a close event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Controls whether or not the portal is displayed. */
  open: PropTypes.bool,

  /** Controls whether or not the portal should open when the trigger is clicked. */
  openOnTriggerClick: PropTypes.bool,

  /** Controls whether or not the portal should open on focus of the trigger. */
  openOnTriggerFocus: PropTypes.bool,

  /** Controls whether or not the portal should open when mousing over the trigger. */
  openOnTriggerMouseEnter: PropTypes.bool,

  /** Controls whether the portal should be prepended to the mountNode instead of appended. */
  prepend: PropTypes.bool,

  /** Element to be rendered in-place where the portal is defined. */
  trigger: PropTypes.node
} : {};


/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_META__ = __webpack_require__(332);










/**
 * This component exposes a callback prop that always returns the DOM node of both functional and class component
 * children.
 */

var Ref = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Ref, _Component);

  function Ref() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Ref);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Ref.__proto__ || Object.getPrototypeOf(Ref)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Ref, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var innerRef = this.props.innerRef;

      // Heads up! Don't move this condition, it's a short circuit that avoids run of `findDOMNode`
      // if `innerRef` isn't passed
      // eslint-disable-next-line react/no-find-dom-node

      if (innerRef) innerRef(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return __WEBPACK_IMPORTED_MODULE_5_react__["Children"].only(children);
    }
  }]);

  return Ref;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Ref._meta = {
  name: 'Ref',
  type: __WEBPACK_IMPORTED_MODULE_7__lib_META__["TYPES"].ADDON
};
Ref.handledProps = ['children', 'innerRef'];
/* harmony default export */ __webpack_exports__["a"] = (Ref);
Ref.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.element,

  /**
   * Called when componentDidMount.
   *
   * @param {HTMLElement} node - Referred node.
   */
  innerRef: PropTypes.func
} : {};

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_reduce__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Icon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__addons_MountNode__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__addons_Portal__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalHeader__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalContent__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalActions__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalDescription__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__addons_Ref__ = __webpack_require__(199);

























/**
 * A modal displays content that temporarily blocks interactions with the main view of a site.
 * @see Confirm
 * @see Portal
 */
var Modal = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_13__lib__["t" /* isBrowser */])() ? _this.props.mountNode || document.body : null;
    }, _this.handleActionsOverrides = function (predefinedProps) {
      return {
        onActionClick: function onActionClick(e, actionProps) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onActionClick', e, actionProps);
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onActionClick', e, _this.props);

          _this.handleClose(e);
        }
      };
    }, _this.handleClose = function (e) {

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);
      _this.trySetState({ open: false });
    }, _this.handleIconOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(predefinedProps, 'onClick', e);
          _this.handleClose(e);
        }
      };
    }, _this.handleOpen = function (e) {

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onOpen', e, _this.props);
      _this.trySetState({ open: true });
    }, _this.handlePortalMount = function (e) {

      _this.setState({ scrolling: false });
      _this.setPositionAndClassNames();

      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onMount', e, _this.props);
    }, _this.handlePortalUnmount = function (e) {

      cancelAnimationFrame(_this.animationRequestId);
      __WEBPACK_IMPORTED_MODULE_9_lodash_invoke___default()(_this.props, 'onUnmount', e, _this.props);
    }, _this.handleRef = function (c) {
      return _this.ref = c;
    }, _this.setPositionAndClassNames = function () {
      var dimmer = _this.props.dimmer;

      var classes = void 0;

      if (dimmer) {
        classes = 'dimmable dimmed';

        if (dimmer === 'blurring') {
          classes += ' blurring';
        }
      }

      var newState = {};

      if (_this.ref) {
        var _this$ref$getBounding = _this.ref.getBoundingClientRect(),
            height = _this$ref$getBounding.height;

        var marginTop = -Math.round(height / 2);
        var scrolling = height >= window.innerHeight;

        if (_this.state.marginTop !== marginTop) {
          newState.marginTop = marginTop;
        }

        if (_this.state.scrolling !== scrolling) {
          newState.scrolling = scrolling;
        }

        if (scrolling) classes += ' scrolling';
      }

      if (_this.state.mountClasses !== classes) newState.mountClasses = classes;
      if (!__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default()(newState)) _this.setState(newState);

      _this.animationRequestId = requestAnimationFrame(_this.setPositionAndClassNames);
    }, _this.renderContent = function (rest) {
      var _this$props = _this.props,
          actions = _this$props.actions,
          basic = _this$props.basic,
          children = _this$props.children,
          className = _this$props.className,
          closeIcon = _this$props.closeIcon,
          content = _this$props.content,
          header = _this$props.header,
          mountNode = _this$props.mountNode,
          size = _this$props.size,
          style = _this$props.style;
      var _this$state = _this.state,
          marginTop = _this$state.marginTop,
          mountClasses = _this$state.mountClasses,
          scrolling = _this$state.scrolling;


      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_13__lib__["B" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_13__lib__["B" /* useKeyOnly */])(scrolling, 'scrolling'), 'modal transition visible active', className);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* getElementType */])(Modal, _this.props);

      var closeIconName = closeIcon === true ? 'close' : closeIcon;
      var closeIconJSX = __WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */].create(closeIconName, { overrideProps: _this.handleIconOverrides });

      if (!__WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children)) {
        // TODO: remove when ref with "as" is resolved: PR #2306
        return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_21__addons_Ref__["a" /* default */],
          { innerRef: _this.handleRef },
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
            ElementType,
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ marginTop: marginTop }, style) }),
            __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__addons_MountNode__["a" /* default */], { className: mountClasses, node: mountNode }),
            closeIconJSX,
            children
          )
        );
      }

      // TODO: remove when ref with "as" is resolved: PR #2306
      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_21__addons_Ref__["a" /* default */],
        { innerRef: _this.handleRef },
        __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ marginTop: marginTop }, style) }),
          __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__addons_MountNode__["a" /* default */], { className: mountClasses, node: mountNode }),
          closeIconJSX,
          __WEBPACK_IMPORTED_MODULE_17__ModalHeader__["a" /* default */].create(header),
          __WEBPACK_IMPORTED_MODULE_18__ModalContent__["a" /* default */].create(content),
          __WEBPACK_IMPORTED_MODULE_19__ModalActions__["a" /* default */].create(actions, { overrideProps: _this.handleActionsOverrides })
        )
      );
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Modal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handlePortalUnmount();
    }

    // Do not access document when server side rendering

  }, {
    key: 'render',
    value: function render() {
      var open = this.state.open;
      var _props = this.props,
          closeOnDimmerClick = _props.closeOnDimmerClick,
          closeOnDocumentClick = _props.closeOnDocumentClick,
          dimmer = _props.dimmer,
          eventPool = _props.eventPool,
          trigger = _props.trigger;

      var mountNode = this.getMountNode();

      // Short circuit when server side rendering
      if (!Object(__WEBPACK_IMPORTED_MODULE_13__lib__["t" /* isBrowser */])()) {
        return Object(__WEBPACK_IMPORTED_MODULE_12_react__["isValidElement"])(trigger) ? trigger : null;
      }

      var unhandled = Object(__WEBPACK_IMPORTED_MODULE_13__lib__["r" /* getUnhandledProps */])(Modal, this.props);
      var portalPropNames = __WEBPACK_IMPORTED_MODULE_16__addons_Portal__["a" /* default */].handledProps;

      var rest = __WEBPACK_IMPORTED_MODULE_7_lodash_reduce___default()(unhandled, function (acc, val, key) {
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash_includes___default()(portalPropNames, key)) acc[key] = val;

        return acc;
      }, {});
      var portalProps = __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default()(unhandled, portalPropNames);

      // wrap dimmer modals
      var dimmerClasses = !dimmer ? null : __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ui', dimmer === 'inverted' && 'inverted', 'page modals dimmer transition visible active');

      // Heads up!
      //
      // The SUI CSS selector to prevent the modal itself from blurring requires an immediate .dimmer child:
      // .blurring.dimmed.dimmable>:not(.dimmer) { ... }
      //
      // The .blurring.dimmed.dimmable is the body, so that all body content inside is blurred.
      // We need the immediate child to be the dimmer to :not() blur the modal itself!
      // Otherwise, the portal div is also blurred, blurring the modal.
      //
      // We cannot them wrap the modalJSX in an actual <Dimmer /> instead, we apply the dimmer classes to the <Portal />.

      return __WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_16__addons_Portal__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          closeOnDocumentClick: closeOnDocumentClick,
          closeOnRootNodeClick: closeOnDimmerClick
        }, portalProps, {
          trigger: trigger,
          className: dimmerClasses,
          eventPool: eventPool,
          mountNode: mountNode,
          open: open,
          onClose: this.handleClose,
          onMount: this.handlePortalMount,
          onOpen: this.handleOpen,
          onUnmount: this.handlePortalUnmount
        }),
        this.renderContent(rest)
      );
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* AutoControlledComponent */]);

Modal.defaultProps = {
  dimmer: true,
  closeOnDimmerClick: true,
  closeOnDocumentClick: false,
  eventPool: 'Modal'
};
Modal.autoControlledProps = ['open'];
Modal._meta = {
  name: 'Modal',
  type: __WEBPACK_IMPORTED_MODULE_13__lib__["b" /* META */].TYPES.MODULE
};
Modal.Header = __WEBPACK_IMPORTED_MODULE_17__ModalHeader__["a" /* default */];
Modal.Content = __WEBPACK_IMPORTED_MODULE_18__ModalContent__["a" /* default */];
Modal.Description = __WEBPACK_IMPORTED_MODULE_20__ModalDescription__["a" /* default */];
Modal.Actions = __WEBPACK_IMPORTED_MODULE_19__ModalActions__["a" /* default */];
Modal.handledProps = ['actions', 'as', 'basic', 'children', 'className', 'closeIcon', 'closeOnDimmerClick', 'closeOnDocumentClick', 'content', 'defaultOpen', 'dimmer', 'eventPool', 'header', 'mountNode', 'onActionClick', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'open', 'size', 'style', 'trigger'];
Modal.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Shorthand for Modal.Actions. Typically an array of button shorthand. */
  actions: customPropTypes.itemShorthand,

  /** A modal can reduce its complexity */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for the close icon. Closes the modal on click. */
  closeIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.bool]),

  /** Whether or not the Modal should close when the dimmer is clicked. */
  closeOnDimmerClick: PropTypes.bool,

  /** Whether or not the Modal should close when the document is clicked. */
  closeOnDocumentClick: PropTypes.bool,

  /** Simple text content for the Modal. */
  content: customPropTypes.itemShorthand,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** A Modal can appear in a dimmer. */
  dimmer: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['inverted', 'blurring'])]),

  /** Event pool namespace that is used to handle component events */
  eventPool: PropTypes.string,

  /** Modal displayed above the content in bold. */
  header: customPropTypes.itemShorthand,

  /** The node where the modal should mount. Defaults to document.body. */
  mountNode: PropTypes.any,

  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onActionClick: PropTypes.func,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Controls whether or not the Modal is displayed. */
  open: PropTypes.bool,

  /** A modal can vary in size */
  size: PropTypes.oneOf(['fullscreen', 'large', 'mini', 'small', 'tiny']),

  /** Custom styles. */
  style: PropTypes.object,

  /** Element to be rendered in-place where the portal is defined. */
  trigger: PropTypes.node

  /**
   * NOTE: Any unhandled props that are defined in Portal are passed-through
   * to the wrapping Portal.
   */
} : {};


/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 732 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_getNodeFromProps__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_handleClassNamesChange__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_NodeRegistry__ = __webpack_require__(750);












var nodeRegistry = new __WEBPACK_IMPORTED_MODULE_9__lib_NodeRegistry__["a" /* default */]();

/**
 * A component that allows to manage classNames on a DOM node in declarative manner.
 */

var MountNode = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MountNode, _Component);

  function MountNode() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MountNode);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MountNode.__proto__ || Object.getPrototypeOf(MountNode)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MountNode, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(_ref) {
      var nextClassName = _ref.className;
      var currentClassName = this.props.className;


      return nextClassName !== currentClassName;
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var node = Object(__WEBPACK_IMPORTED_MODULE_7__lib_getNodeFromProps__["a" /* default */])(this.props);

      if (node) {
        nodeRegistry.add(node, this);
        nodeRegistry.emit(node, __WEBPACK_IMPORTED_MODULE_8__lib_handleClassNamesChange__["a" /* default */]);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var node = Object(__WEBPACK_IMPORTED_MODULE_7__lib_getNodeFromProps__["a" /* default */])(this.props);

      if (node) nodeRegistry.emit(node, __WEBPACK_IMPORTED_MODULE_8__lib_handleClassNamesChange__["a" /* default */]);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var node = Object(__WEBPACK_IMPORTED_MODULE_7__lib_getNodeFromProps__["a" /* default */])(this.props);

      if (node) {
        nodeRegistry.del(node, this);
        nodeRegistry.emit(node, __WEBPACK_IMPORTED_MODULE_8__lib_handleClassNamesChange__["a" /* default */]);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return MountNode;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

MountNode._meta = {
  name: 'MountNode',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.ADDON
};
MountNode.handledProps = ['className', 'node'];
/* harmony default export */ __webpack_exports__["a"] = (MountNode);
MountNode.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** The DOM node where we will apply class names. Defaults to document.body. */
  node: customPropTypes.domNode
} : {};

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(2);




/**
 * Given `this.props`, return a `node` value or undefined.
 *
 * @param {object} props Component's props
 * @return {HTMLElement|undefined}
 */
var getNodeFromProps = function getNodeFromProps(props) {
  var node = props.node;


  if (Object(__WEBPACK_IMPORTED_MODULE_1__lib__["t" /* isBrowser */])()) {
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(node)) return document.body;
    return node;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getNodeFromProps);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__computeClassNames__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__computeClassNamesDifference__ = __webpack_require__(749);







var prevClassNames = new Map();

var handleClassNamesChange = function handleClassNamesChange(node, components) {
  var currentClassNames = Object(__WEBPACK_IMPORTED_MODULE_2__computeClassNames__["a" /* default */])(components);

  var _computeClassNamesDif = Object(__WEBPACK_IMPORTED_MODULE_3__computeClassNamesDifference__["a" /* default */])(prevClassNames.get(node), currentClassNames),
      _computeClassNamesDif2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_computeClassNamesDif, 2),
      forAdd = _computeClassNamesDif2[0],
      forRemoval = _computeClassNamesDif2[1];

  __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(forAdd, function (className) {
    return node.classList.add(className);
  });
  __WEBPACK_IMPORTED_MODULE_1_lodash_forEach___default()(forRemoval, function (className) {
    return node.classList.remove(className);
  });

  prevClassNames.set(node, currentClassNames);
};

/* harmony default export */ __webpack_exports__["a"] = (handleClassNamesChange);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_split__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow__);










var computeClassNames = __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_toArray___default.a, __WEBPACK_IMPORTED_MODULE_5_lodash_fp_map___default()('props.className'), __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flatMap___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_split___default()(/\s+/)), __WEBPACK_IMPORTED_MODULE_2_lodash_fp_filter___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default.a), __WEBPACK_IMPORTED_MODULE_0_lodash_fp_uniq___default.a);

/* harmony default export */ __webpack_exports__["a"] = (computeClassNames);

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('uniq', __webpack_require__(196), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('identity', __webpack_require__(39), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('filter', __webpack_require__(119));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('split', __webpack_require__(741));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(108),
    castSlice = __webpack_require__(192),
    hasUnicode = __webpack_require__(134),
    isIterateeCall = __webpack_require__(75),
    isRegExp = __webpack_require__(742),
    stringToArray = __webpack_require__(133),
    toString = __webpack_require__(37);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(743),
    baseUnary = __webpack_require__(63),
    nodeUtil = __webpack_require__(122);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(34),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('flatMap', __webpack_require__(745));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(86),
    map = __webpack_require__(17);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(14),
    func = convert('toArray', __webpack_require__(747), __webpack_require__(30));

func.placeholder = __webpack_require__(13);
module.exports = func;


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(59),
    copyArray = __webpack_require__(92),
    getTag = __webpack_require__(53),
    isArrayLike = __webpack_require__(28),
    isString = __webpack_require__(135),
    iteratorToArray = __webpack_require__(748),
    mapToArray = __webpack_require__(291),
    setToArray = __webpack_require__(124),
    stringToArray = __webpack_require__(133),
    values = __webpack_require__(76);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = Symbol ? Symbol.iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (symIterator && value[symIterator]) {
    return iteratorToArray(value[symIterator]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

module.exports = toArray;


/***/ }),
/* 748 */
/***/ (function(module, exports) {

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

module.exports = iteratorToArray;


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_difference__);



var computeClassNamesDifference = function computeClassNamesDifference(prevClassNames, currentClassNames) {
  return [__WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(currentClassNames, prevClassNames), __WEBPACK_IMPORTED_MODULE_0_lodash_difference___default()(prevClassNames, currentClassNames)];
};

/* harmony default export */ __webpack_exports__["a"] = (computeClassNamesDifference);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var NodeRegistry = function NodeRegistry() {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NodeRegistry);

  this.add = function (node, component) {
    if (_this.nodes.has(node)) {
      var set = _this.nodes.get(node);

      set.add(component);
      return;
    }

    _this.nodes.set(node, new Set([component]));
  };

  this.del = function (node, component) {
    if (!_this.nodes.has(node)) return;

    var set = _this.nodes.get(node);

    if (set.size === 1) {
      _this.nodes.delete(node);
      return;
    }

    set.delete(component);
  };

  this.emit = function (node, callback) {
    callback(node, _this.nodes.get(node));
  };

  this.nodes = new Map();
};

/* harmony default export */ __webpack_exports__["a"] = (NodeRegistry);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(752);
/* unused harmony reexport default */



/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__collections_Menu__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PaginationItem__ = __webpack_require__(358);















/**
 * A component to render a pagination.
 */

var Pagination = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pagination, _Component);

  function Pagination() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClick = function (e, _ref2) {
      var nextActivePage = _ref2.value;
      var prevActivePage = _this.state.activePage;

      // Heads up! We need the cast to the "number" type there, as `activePage` can be a string

      if (+prevActivePage === +nextActivePage) return;

      _this.trySetState({ activePage: nextActivePage });
      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onPageChange', e, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.props, { activePage: nextActivePage }));
    }, _this.handleItemOverrides = function (active, type, value) {
      return function (predefinedProps) {
        return {
          active: active,
          type: type,
          key: type + '-' + value,
          onClick: function onClick(e, itemProps) {
            __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(predefinedProps, 'onClick', e, itemProps);
            _this.handleItemClick(e, itemProps);
          }
        };
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Pagination, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          ariaLabel = _props['aria-label'],
          boundaryRange = _props.boundaryRange,
          siblingRange = _props.siblingRange,
          totalPages = _props.totalPages;
      var activePage = this.state.activePage;


      var items = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["k" /* createPaginationItems */])({ activePage: activePage, boundaryRange: boundaryRange, siblingRange: siblingRange, totalPages: totalPages });
      var rest = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["r" /* getUnhandledProps */])(Pagination, this.props);

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__collections_Menu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { 'aria-label': ariaLabel, pagination: true, role: 'navigation' }),
        __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(items, function (_ref3) {
          var active = _ref3.active,
              type = _ref3.type,
              value = _ref3.value;
          return __WEBPACK_IMPORTED_MODULE_11__PaginationItem__["a" /* default */].create(_this2.props[type], {
            defaultProps: {
              content: value,
              value: value
            },
            overrideProps: _this2.handleItemOverrides(active, type, value)
          });
        })
      );
    }
  }]);

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* AutoControlledComponent */]);

Pagination.autoControlledProps = ['activePage'];
Pagination.defaultProps = {
  'aria-label': 'Pagination Navigation',
  boundaryRange: 1,
  ellipsisItem: '...',
  firstItem: {
    'aria-label': 'First item',
    content: '«'
  },
  lastItem: {
    'aria-label': 'Last item',
    content: '»'
  },
  nextItem: {
    'aria-label': 'Next item',
    content: '⟩'
  },
  pageItem: {},
  prevItem: {
    'aria-label': 'Previous item',
    content: '⟨'
  },
  siblingRange: 1
};
Pagination._meta = {
  name: 'Pagination',
  type: __WEBPACK_IMPORTED_MODULE_9__lib__["b" /* META */].TYPES.ADDON
};
Pagination.Item = __WEBPACK_IMPORTED_MODULE_11__PaginationItem__["a" /* default */];
Pagination.handledProps = ['activePage', 'aria-label', 'boundaryRange', 'defaultActivePage', 'ellipsisItem', 'firstItem', 'lastItem', 'nextItem', 'onPageChange', 'pageItem', 'prevItem', 'siblingRange', 'totalPages'];
/* unused harmony default export */ var _unused_webpack_default_export = (Pagination);
Pagination.propTypes =  false ? {
  /** A pagination item can have an aria label. */
  'aria-label': PropTypes.string,

  /** Initial activePage value. */
  defaultActivePage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Index of the currently active page. */
  activePage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Number of always visible pages at the beginning and end. */
  boundaryRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A shorthand for PaginationItem. */
  ellipsisItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  firstItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  lastItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  nextItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  pageItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  prevItem: customPropTypes.itemShorthand,

  /**
   * Called on change of an active page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onPageChange: PropTypes.func,

  /** Number of always visible pages before and after the current one. */
  siblingRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Total number of pages. */
  totalPages: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
} : {};

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(754),
    upperFirst = __webpack_require__(761);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(347),
    deburr = __webpack_require__(356),
    words = __webpack_require__(757);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(756);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 756 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(758),
    hasUnicodeWord = __webpack_require__(759),
    toString = __webpack_require__(37),
    unicodeWords = __webpack_require__(760);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 758 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 760 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(762);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(192),
    hasUnicode = __webpack_require__(134),
    stringToArray = __webpack_require__(133),
    toString = __webpack_require__(37);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__ = __webpack_require__(139);






/**
 * A Radio is sugar for <Checkbox radio />.
 * Useful for exclusive groups of sliders or toggles.
 * @see Checkbox
 * @see Form
 */
function Radio(props) {
  var slider = props.slider,
      toggle = props.toggle,
      type = props.type;

  var rest = Object(__WEBPACK_IMPORTED_MODULE_2__lib__["r" /* getUnhandledProps */])(Radio, props);
  // const ElementType = getElementType(Radio, props)
  // radio, slider, toggle are exclusive
  // use an undefined radio if slider or toggle are present
  var radio = !(slider || toggle) || undefined;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { type: type, radio: radio, slider: slider, toggle: toggle }));
}

Radio.handledProps = ['slider', 'toggle', 'type'];
Radio._meta = {
  name: 'Radio',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.ADDON
};

Radio.propTypes =  false ? {
  /** Format to emphasize the current selection state. */
  slider: Checkbox.propTypes.slider,

  /** Format to show an on or off choice. */
  toggle: Checkbox.propTypes.toggle,

  /** HTML input type, either checkbox or radio. */
  type: Checkbox.propTypes.type
} : {};

Radio.defaultProps = {
  type: 'radio'
};

/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(2);















/**
 * A checkbox allows a user to select a value from a small set of options, often binary.
 * @see Form
 * @see Radio
 */
var Checkbox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.canToggle = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          radio = _this$props.radio,
          readOnly = _this$props.readOnly;
      var checked = _this.state.checked;


      return !disabled && !readOnly && !(radio && checked);
    }, _this.computeTabIndex = function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;


      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default()(tabIndex)) return tabIndex;
      return disabled ? -1 : 0;
    }, _this.handleContainerClick = function (e) {
      var id = _this.props.id;


      if (__WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default()(id)) _this.handleClick(e);
    }, _this.handleInputClick = function (e) {
      var id = _this.props.id;


      if (id) _this.handleClick(e);
    }, _this.handleInputRef = function (c) {
      return _this.inputRef = c;
    }, _this.handleClick = function (e) {
      var _this$state = _this.state,
          checked = _this$state.checked,
          indeterminate = _this$state.indeterminate;


      if (!_this.canToggle()) return;

      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onClick', e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { checked: !checked, indeterminate: !!indeterminate }));
      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { checked: !checked, indeterminate: false }));

      _this.trySetState({ checked: !checked, indeterminate: false });
    }, _this.handleMouseDown = function (e) {
      var _this$state2 = _this.state,
          checked = _this$state2.checked,
          indeterminate = _this$state2.indeterminate;


      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onMouseDown', e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { checked: !!checked, indeterminate: !!indeterminate }));
      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.inputRef, 'focus');

      e.preventDefault();
    }, _this.setIndeterminate = function () {
      var indeterminate = _this.state.indeterminate;


      if (_this.inputRef) _this.inputRef.indeterminate = !!indeterminate;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setIndeterminate();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setIndeterminate();
    }

    // Note: You can't directly set the indeterminate prop on the input, so we
    // need to maintain a ref to the input and set it manually whenever the
    // component updates.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          label = _props.label,
          id = _props.id,
          name = _props.name,
          radio = _props.radio,
          readOnly = _props.readOnly,
          slider = _props.slider,
          toggle = _props.toggle,
          type = _props.type,
          value = _props.value;
      var _state = this.state,
          checked = _state.checked,
          indeterminate = _state.indeterminate;


      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(checked, 'checked'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(indeterminate, 'indeterminate'),
      // auto apply fitted class to compact white space when there is no label
      // https://semantic-ui.com/modules/checkbox.html#fitted
      Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(__WEBPACK_IMPORTED_MODULE_7_lodash_isNil___default()(label), 'fitted'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(radio, 'radio'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(readOnly, 'read-only'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(slider, 'slider'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(toggle, 'toggle'), 'checkbox', className);
      var unhandled = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["r" /* getUnhandledProps */])(Checkbox, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["q" /* getElementType */])(Checkbox, this.props);

      var _partitionHTMLProps = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["z" /* partitionHTMLProps */])(unhandled, { htmlProps: __WEBPACK_IMPORTED_MODULE_11__lib__["s" /* htmlInputAttrs */] }),
          _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
          htmlInputProps = _partitionHTMLProps2[0],
          rest = _partitionHTMLProps2[1];

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          onClick: this.handleContainerClick,
          onChange: this.handleContainerClick,
          onMouseDown: this.handleMouseDown
        }),
        __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, htmlInputProps, {
          checked: checked,
          className: 'hidden',
          id: id,
          name: name,
          onClick: this.handleInputClick,
          readOnly: true,
          ref: this.handleInputRef,
          tabIndex: this.computeTabIndex(),
          type: type,
          value: value
        })),
        Object(__WEBPACK_IMPORTED_MODULE_11__lib__["i" /* createHTMLLabel */])(label, { defaultProps: { htmlFor: id } }) || __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement('label', { htmlFor: id })
      );
    }
  }]);

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* AutoControlledComponent */]);

Checkbox.defaultProps = {
  type: 'checkbox'
};
Checkbox.autoControlledProps = ['checked', 'indeterminate'];
Checkbox._meta = {
  name: 'Checkbox',
  type: __WEBPACK_IMPORTED_MODULE_11__lib__["b" /* META */].TYPES.MODULE
};
Checkbox.handledProps = ['as', 'checked', 'className', 'defaultChecked', 'defaultIndeterminate', 'disabled', 'fitted', 'id', 'indeterminate', 'label', 'name', 'onChange', 'onClick', 'onMouseDown', 'radio', 'readOnly', 'slider', 'tabIndex', 'toggle', 'type', 'value'];
/* harmony default export */ __webpack_exports__["a"] = (Checkbox);
Checkbox.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Whether or not checkbox is checked. */
  checked: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** The initial value of checked. */
  defaultChecked: PropTypes.bool,

  /** Whether or not checkbox is indeterminate. */
  defaultIndeterminate: PropTypes.bool,

  /** A checkbox can appear disabled and be unable to change states */
  disabled: PropTypes.bool,

  /** Removes padding for a label. Auto applied when there is no label. */
  fitted: PropTypes.bool,

  /** A unique identifier. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Whether or not checkbox is indeterminate. */
  indeterminate: PropTypes.bool,

  /** The text of the associated label element. */
  label: customPropTypes.itemShorthand,

  /** The HTML input name. */
  name: PropTypes.string,

  /**
   * Called when the user attempts to change the checked state.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed checked/indeterminate state.
   */
  onChange: PropTypes.func,

  /**
   * Called when the checkbox or label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onClick: PropTypes.func,

  /**
   * Called when the user presses down on the mouse.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onMouseDown: PropTypes.func,

  /** Format as a radio element. This means it is an exclusive option. */
  radio: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['slider', 'toggle'])]),

  /** A checkbox can be read-only and unable to change states. */
  readOnly: PropTypes.bool,

  /** Format to emphasize the current selection state. */
  slider: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['radio', 'toggle'])]),

  /** A checkbox can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Format to show an on or off choice. */
  toggle: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['radio', 'slider'])]),

  /** HTML input type, either checkbox or radio. */
  type: PropTypes.oneOf(['checkbox', 'radio']),

  /** The HTML input value. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Responsive__ = __webpack_require__(766);
/* unused harmony reexport default */



/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(2);













/**
 * Responsive can control visibility of content.
 */

var Responsive = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Responsive, _Component);

  function Responsive() {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Responsive);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // Measure the root element dimension to handle gesture transitions on iOS safely
    // https://github.com/Semantic-Org/Semantic-UI-React/pull/2531
    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Responsive.__proto__ || Object.getPrototypeOf(Responsive)).call.apply(_ref, [this].concat(args)));

    _initialiseProps.call(_this);

    _this.state = { width: Object(__WEBPACK_IMPORTED_MODULE_9__lib__["t" /* isBrowser */])() ? document.documentElement.clientWidth : 0 };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Responsive, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var fireOnMount = this.props.fireOnMount;


      this.mounted = true;

      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].sub('resize', this.handleResize, { target: 'window' });
      if (fireOnMount) this.handleUpdate();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      __WEBPACK_IMPORTED_MODULE_9__lib__["o" /* eventStack */].unsub('resize', this.handleResize, { target: 'window' });
    }

    // ----------------------------------------
    // Helpers
    // ----------------------------------------

    // ----------------------------------------
    // Event handlers
    // ----------------------------------------

  }, {
    key: 'render',


    // ----------------------------------------
    // Render
    // ----------------------------------------

    value: function render() {
      var children = this.props.children;


      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["q" /* getElementType */])(Responsive, this.props);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_9__lib__["r" /* getUnhandledProps */])(Responsive, this.props);

      if (this.isVisible()) return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        ElementType,
        rest,
        children
      );
      return null;
    }
  }]);

  return Responsive;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Responsive._meta = {
  name: 'Responsive',
  type: __WEBPACK_IMPORTED_MODULE_9__lib__["b" /* META */].TYPES.ADDON
};
Responsive.onlyMobile = { minWidth: 320, maxWidth: 767 };
Responsive.onlyTablet = { minWidth: 768, maxWidth: 991 };
Responsive.onlyComputer = { minWidth: 992 };
Responsive.onlyLargeScreen = { minWidth: 1200, maxWidth: 1919 };
Responsive.onlyWidescreen = { minWidth: 1920 };
Responsive.handledProps = ['as', 'children', 'fireOnMount', 'maxWidth', 'minWidth', 'onUpdate'];

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.fitsMaxWidth = function () {
    var maxWidth = _this2.props.maxWidth;
    var width = _this2.state.width;


    return __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(maxWidth) ? true : width <= maxWidth;
  };

  this.fitsMinWidth = function () {
    var minWidth = _this2.props.minWidth;
    var width = _this2.state.width;


    return __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(minWidth) ? true : width >= minWidth;
  };

  this.setSafeState = function () {
    return _this2.mounted && _this2.setState.apply(_this2, arguments);
  };

  this.isVisible = function () {
    return _this2.fitsMinWidth() && _this2.fitsMaxWidth();
  };

  this.handleResize = function (e) {
    if (_this2.ticking) return;

    _this2.ticking = true;
    requestAnimationFrame(function () {
      return _this2.handleUpdate(e);
    });
  };

  this.handleUpdate = function (e) {
    _this2.ticking = false;
    var width = document.documentElement.clientWidth;

    _this2.setSafeState({ width: width });
    __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this2.props, 'onUpdate', e, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props, { width: width }));
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (Responsive);
Responsive.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Fires callbacks immediately after mount. */
  fireOnMount: PropTypes.bool,

  /** The maximum width at which content will be displayed. */
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The minimum width at which content will be displayed. */
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called on update.
   *
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onUpdate: PropTypes.func
} : {};

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__ = __webpack_require__(202);






/**
 * A Select is sugar for <Dropdown selection />.
 * @see Dropdown
 * @see Form
 */
function Select(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { selection: true }));
}

Select.handledProps = [];
Select._meta = {
  name: 'Select',
  type: __WEBPACK_IMPORTED_MODULE_2__lib__["b" /* META */].TYPES.ADDON
};

Select.Divider = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Divider;
Select.Header = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Header;
Select.Item = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Item;
Select.Menu = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Menu;

/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_compact__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_compact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_compact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_every__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_find__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_reduce__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_some__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_escapeRegExp__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_escapeRegExp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_escapeRegExp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_deburr__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_deburr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash_deburr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isFunction__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_filter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_lodash_dropRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isEmpty__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_size__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_union__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_lodash_union___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_lodash_union__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_includes__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_isUndefined__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_isEqual__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_has__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_lodash_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_lodash_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__elements_Icon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__elements_Label__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__DropdownDivider__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__DropdownItem__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__DropdownHeader__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__DropdownMenu__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__DropdownSearchInput__ = __webpack_require__(367);












































var getKeyOrValue = function getKeyOrValue(key, value) {
  return __WEBPACK_IMPORTED_MODULE_29_lodash_isNil___default()(key) ? value : key;
};

/**
 * A dropdown allows a user to select a value from a series of options.
 * @see Form
 * @see Select
 * @see Menu
 */

var Dropdown = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e, value) {
      __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { value: value }));
    }, _this.closeOnChange = function (e) {
      var _this$props = _this.props,
          closeOnChange = _this$props.closeOnChange,
          multiple = _this$props.multiple;

      var shouldClose = __WEBPACK_IMPORTED_MODULE_25_lodash_isUndefined___default()(closeOnChange) ? !multiple : closeOnChange;

      if (shouldClose) _this.close(e);
    }, _this.closeOnEscape = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].getCode(e) !== __WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].Escape) return;
      e.preventDefault();
      _this.close();
    }, _this.moveSelectionOnKeyDown = function (e) {
      var _moves;

      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          selectOnNavigation = _this$props2.selectOnNavigation;

      var moves = (_moves = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_moves, __WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].ArrowDown, 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_moves, __WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].ArrowUp, -1), _moves);
      var move = moves[__WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].getCode(e)];

      if (move === undefined) return;
      e.preventDefault();
      _this.moveSelectionBy(move);
      if (!multiple && selectOnNavigation) _this.makeSelectedItemActive(e);
    }, _this.openOnSpace = function (e) {

      if (__WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].getCode(e) !== __WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].Spacebar) return;
      if (_this.state.open) return;

      e.preventDefault();

      _this.open(e);
    }, _this.openOnArrow = function (e) {

      var code = __WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].getCode(e);
      if (!__WEBPACK_IMPORTED_MODULE_24_lodash_includes___default()([__WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].ArrowDown, __WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].ArrowUp], code)) return;
      if (_this.state.open) return;

      e.preventDefault();

      _this.open(e);
    }, _this.makeSelectedItemActive = function (e) {
      var open = _this.state.open;
      var multiple = _this.props.multiple;


      var item = _this.getSelectedItem();
      var value = __WEBPACK_IMPORTED_MODULE_23_lodash_get___default()(item, 'value');

      // prevent selecting null if there was no selected item value
      // prevent selecting duplicate items when the dropdown is closed
      if (__WEBPACK_IMPORTED_MODULE_29_lodash_isNil___default()(value) || !open) return;

      // state value may be undefined
      var newValue = multiple ? __WEBPACK_IMPORTED_MODULE_22_lodash_union___default()(_this.state.value, [value]) : value;

      // notify the onChange prop that the user is trying to change value
      _this.setValue(newValue);
      _this.setSelectedIndex(newValue);
      _this.handleChange(e, newValue);

      // Heads up! This event handler should be called after `onChange`
      // Notify the onAddItem prop if this is a new value
      if (item['data-additional']) __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default()(_this.props, 'onAddItem', e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { value: value }));
    }, _this.selectItemOnEnter = function (e) {
      var search = _this.props.search;


      if (__WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].getCode(e) !== __WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].Enter) return;
      e.preventDefault();

      var optionSize = __WEBPACK_IMPORTED_MODULE_21_lodash_size___default()(_this.getMenuOptions());
      if (search && optionSize === 0) return;

      _this.makeSelectedItemActive(e);
      _this.closeOnChange(e);
      _this.clearSearchQuery();
      if (search && _this.searchRef) _this.searchRef.focus();
    }, _this.removeItemOnBackspace = function (e) {
      var _this$props3 = _this.props,
          multiple = _this$props3.multiple,
          search = _this$props3.search;
      var _this$state = _this.state,
          searchQuery = _this$state.searchQuery,
          value = _this$state.value;


      if (__WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].getCode(e) !== __WEBPACK_IMPORTED_MODULE_33__lib__["u" /* keyboardKey */].Backspace) return;
      if (searchQuery || !search || !multiple || __WEBPACK_IMPORTED_MODULE_20_lodash_isEmpty___default()(value)) return;
      e.preventDefault();

      // remove most recent value
      var newValue = __WEBPACK_IMPORTED_MODULE_19_lodash_dropRight___default()(value);

      _this.setValue(newValue);
      _this.setSelectedIndex(newValue);
      _this.handleChange(e, newValue);
    }, _this.closeOnDocumentClick = function (e) {

      if (!_this.props.closeOnBlur) return;

      // If event happened in the dropdown, ignore it
      if (_this.ref && Object(__WEBPACK_IMPORTED_MODULE_33__lib__["n" /* doesNodeContainClick */])(_this.ref, e)) return;

      _this.close();
    }, _this.attachHandlersOnOpen = function () {
      __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].sub('keydown', [_this.closeOnEscape, _this.moveSelectionOnKeyDown, _this.selectItemOnEnter, _this.removeItemOnBackspace]);
      __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].sub('click', _this.closeOnDocumentClick);
      __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].unsub('keydown', [_this.openOnArrow, _this.openOnSpace]);
    }, _this.handleMouseDown = function (e) {

      _this.isMouseDown = true;
      __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].sub('mouseup', _this.handleDocumentMouseUp);
      __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default()(_this.props, 'onMouseDown', e, _this.props);
    }, _this.handleDocumentMouseUp = function () {

      _this.isMouseDown = false;
      __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].unsub('mouseup', _this.handleDocumentMouseUp);
    }, _this.handleClick = function (e) {
      var _this$props4 = _this.props,
          minCharacters = _this$props4.minCharacters,
          search = _this$props4.search;
      var _this$state2 = _this.state,
          open = _this$state2.open,
          searchQuery = _this$state2.searchQuery;


      __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
      // prevent closeOnDocumentClick()
      e.stopPropagation();

      if (!search) return _this.toggle(e);
      if (open) return;
      if (searchQuery.length >= minCharacters || minCharacters === 1) {
        _this.open(e);
        return;
      }
      if (_this.searchRef) _this.searchRef.focus();
    }, _this.handleIconClick = function (e) {

      __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default()(_this.props, 'onClick', e, _this.props);
      // prevent handleClick()
      e.stopPropagation();
      _this.toggle(e);
    }, _this.handleItemClick = function (e, item) {
      var _this$props5 = _this.props,
          multiple = _this$props5.multiple,
          search = _this$props5.search;
      var value = item.value;

      // prevent toggle() in handleClick()

      e.stopPropagation();
      // prevent closeOnDocumentClick() if multiple or item is disabled
      if (multiple || item.disabled) e.nativeEvent.stopImmediatePropagation();
      if (item.disabled) return;

      var isAdditionItem = item['data-additional'];
      var newValue = multiple ? __WEBPACK_IMPORTED_MODULE_22_lodash_union___default()(_this.state.value, [value]) : value;

      // notify the onChange prop that the user is trying to change value
      _this.setValue(newValue);
      _this.setSelectedIndex(value);

      var optionSize = __WEBPACK_IMPORTED_MODULE_21_lodash_size___default()(_this.getMenuOptions());
      if (!multiple || isAdditionItem || optionSize === 1) _this.clearSearchQuery();

      _this.handleChange(e, newValue);
      _this.closeOnChange(e);

      // Heads up! This event handler should be called after `onChange`
      // Notify the onAddItem prop if this is a new value
      if (isAdditionItem) __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default()(_this.props, 'onAddItem', e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { value: value }));

      if (multiple && search && _this.searchRef) _this.searchRef.focus();
    }, _this.handleFocus = function (e) {
      var focus = _this.state.focus;


      if (focus) return;

      __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default()(_this.props, 'onFocus', e, _this.props);
      _this.setState({ focus: true });
    }, _this.handleBlur = function (e) {

      // Heads up! Don't remove this.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/1315
      var currentTarget = __WEBPACK_IMPORTED_MODULE_23_lodash_get___default()(e, 'currentTarget');
      if (currentTarget && currentTarget.contains(document.activeElement)) return;

      var _this$props6 = _this.props,
          closeOnBlur = _this$props6.closeOnBlur,
          multiple = _this$props6.multiple,
          onBlur = _this$props6.onBlur,
          selectOnBlur = _this$props6.selectOnBlur;
      // do not "blur" when the mouse is down inside of the Dropdown

      if (_this.isMouseDown) return;
      if (onBlur) onBlur(e, _this.props);
      if (selectOnBlur && !multiple) {
        _this.makeSelectedItemActive(e);
        if (closeOnBlur) _this.close();
      }
      _this.setState({ focus: false });
      _this.clearSearchQuery();
    }, _this.handleSearchChange = function (e, _ref2) {
      var value = _ref2.value;


      // prevent propagating to this.props.onChange()
      e.stopPropagation();

      var minCharacters = _this.props.minCharacters;
      var open = _this.state.open;

      var newQuery = value;

      __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default()(_this.props, 'onSearchChange', e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { searchQuery: newQuery }));
      _this.trySetState({ searchQuery: newQuery }, { selectedIndex: 0 });

      // open search dropdown on search query
      if (!open && newQuery.length >= minCharacters) {
        _this.open();
        return;
      }
      // close search dropdown if search query is too small
      if (open && minCharacters !== 1 && newQuery.length < minCharacters) _this.close();
    }, _this.getMenuOptions = function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
      var _this$props7 = _this.props,
          additionLabel = _this$props7.additionLabel,
          additionPosition = _this$props7.additionPosition,
          allowAdditions = _this$props7.allowAdditions,
          deburr = _this$props7.deburr,
          multiple = _this$props7.multiple,
          search = _this$props7.search;
      var searchQuery = _this.state.searchQuery;


      var filteredOptions = options;

      // filter out active options
      if (multiple) {
        filteredOptions = __WEBPACK_IMPORTED_MODULE_18_lodash_filter___default()(filteredOptions, function (opt) {
          return !__WEBPACK_IMPORTED_MODULE_24_lodash_includes___default()(value, opt.value);
        });
      }

      // filter by search query
      if (search && searchQuery) {
        if (__WEBPACK_IMPORTED_MODULE_17_lodash_isFunction___default()(search)) {
          filteredOptions = search(filteredOptions, searchQuery);
        } else {
          // remove diacritics on search input and options, if deburr prop is set
          var strippedQuery = deburr ? __WEBPACK_IMPORTED_MODULE_16_lodash_deburr___default()(searchQuery) : searchQuery;

          var re = new RegExp(__WEBPACK_IMPORTED_MODULE_15_lodash_escapeRegExp___default()(strippedQuery), 'i');

          filteredOptions = __WEBPACK_IMPORTED_MODULE_18_lodash_filter___default()(filteredOptions, function (opt) {
            return re.test(deburr ? __WEBPACK_IMPORTED_MODULE_16_lodash_deburr___default()(opt.text) : opt.text);
          });
        }
      }

      // insert the "add" item
      if (allowAdditions && search && searchQuery && !__WEBPACK_IMPORTED_MODULE_14_lodash_some___default()(filteredOptions, { text: searchQuery })) {
        var additionLabelElement = __WEBPACK_IMPORTED_MODULE_32_react___default.a.isValidElement(additionLabel) ? __WEBPACK_IMPORTED_MODULE_32_react___default.a.cloneElement(additionLabel, { key: 'addition-label' }) : additionLabel || '';

        var addItem = {
          key: 'addition',
          // by using an array, we can pass multiple elements, but when doing so
          // we must specify a `key` for React to know which one is which
          text: [additionLabelElement, __WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(
            'b',
            { key: 'addition-query' },
            searchQuery
          )],
          value: searchQuery,
          className: 'addition',
          'data-additional': true
        };
        if (additionPosition === 'top') filteredOptions.unshift(addItem);else filteredOptions.push(addItem);
      }

      return filteredOptions;
    }, _this.getSelectedItem = function () {
      var selectedIndex = _this.state.selectedIndex;

      var options = _this.getMenuOptions();

      return __WEBPACK_IMPORTED_MODULE_23_lodash_get___default()(options, '[' + selectedIndex + ']');
    }, _this.getEnabledIndices = function (givenOptions) {
      var options = givenOptions || _this.getMenuOptions();

      return __WEBPACK_IMPORTED_MODULE_13_lodash_reduce___default()(options, function (memo, item, index) {
        if (!item.disabled) memo.push(index);
        return memo;
      }, []);
    }, _this.getItemByValue = function (value) {
      var options = _this.props.options;


      return __WEBPACK_IMPORTED_MODULE_12_lodash_find___default()(options, { value: value });
    }, _this.getMenuItemIndexByValue = function (value, givenOptions) {
      var options = givenOptions || _this.getMenuOptions();

      return __WEBPACK_IMPORTED_MODULE_11_lodash_findIndex___default()(options, ['value', value]);
    }, _this.getDropdownAriaOptions = function () {
      var _this$props8 = _this.props,
          loading = _this$props8.loading,
          disabled = _this$props8.disabled,
          search = _this$props8.search,
          multiple = _this$props8.multiple;
      var open = _this.state.open;

      var ariaOptions = {
        role: search ? 'combobox' : 'listbox',
        'aria-busy': loading,
        'aria-disabled': disabled,
        'aria-expanded': !!open
      };
      if (ariaOptions.role === 'listbox') {
        ariaOptions['aria-multiselectable'] = multiple;
      }
      return ariaOptions;
    }, _this.clearSearchQuery = function () {
      _this.trySetState({ searchQuery: '' });
    }, _this.setValue = function (value) {
      _this.trySetState({ value: value });
    }, _this.setSelectedIndex = function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var optionsProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.options;
      var multiple = _this.props.multiple;
      var selectedIndex = _this.state.selectedIndex;

      var options = _this.getMenuOptions(value, optionsProps);
      var enabledIndicies = _this.getEnabledIndices(options);

      var newSelectedIndex = void 0;

      // update the selected index
      if (!selectedIndex || selectedIndex < 0) {
        var firstIndex = enabledIndicies[0];

        // Select the currently active item, if none, use the first item.
        // Multiple selects remove active items from the list,
        // their initial selected index should be 0.
        newSelectedIndex = multiple ? firstIndex : _this.getMenuItemIndexByValue(value, options) || enabledIndicies[0];
      } else if (multiple) {
        // multiple selects remove options from the menu as they are made active
        // keep the selected index within range of the remaining items
        if (selectedIndex >= options.length - 1) {
          newSelectedIndex = enabledIndicies[enabledIndicies.length - 1];
        }
      } else {
        var activeIndex = _this.getMenuItemIndexByValue(value, options);

        // regular selects can only have one active item
        // set the selected index to the currently active item
        newSelectedIndex = __WEBPACK_IMPORTED_MODULE_24_lodash_includes___default()(enabledIndicies, activeIndex) ? activeIndex : undefined;
      }

      if (!newSelectedIndex || newSelectedIndex < 0) {
        newSelectedIndex = enabledIndicies[0];
      }

      _this.setState({ selectedIndex: newSelectedIndex });
    }, _this.handleLabelClick = function (e, labelProps) {
      // prevent focusing search input on click
      e.stopPropagation();

      _this.setState({ selectedLabel: labelProps.value });

      var onLabelClick = _this.props.onLabelClick;

      if (onLabelClick) onLabelClick(e, labelProps);
    }, _this.handleLabelRemove = function (e, labelProps) {
      // prevent focusing search input on click
      e.stopPropagation();
      var value = _this.state.value;

      var newValue = __WEBPACK_IMPORTED_MODULE_10_lodash_without___default()(value, labelProps.value);


      _this.setValue(newValue);
      _this.setSelectedIndex(newValue);
      _this.handleChange(e, newValue);
    }, _this.moveSelectionBy = function (offset) {
      var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.selectedIndex;


      var options = _this.getMenuOptions();

      // Prevent infinite loop
      // TODO: remove left part of condition after children API will be removed
      if (options === undefined || __WEBPACK_IMPORTED_MODULE_9_lodash_every___default()(options, 'disabled')) return;

      var lastIndex = options.length - 1;
      var wrapSelection = _this.props.wrapSelection;
      // next is after last, wrap to beginning
      // next is before first, wrap to end

      var nextIndex = startIndex + offset;

      // if 'wrapSelection' is set to false and selection is after last or before first, it just does not change
      if (!wrapSelection && (nextIndex > lastIndex || nextIndex < 0)) {
        nextIndex = startIndex;
      } else if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;

      if (options[nextIndex].disabled) {
        _this.moveSelectionBy(offset, nextIndex);
        return;
      }

      _this.setState({ selectedIndex: nextIndex });
      _this.scrollSelectedItemIntoView();
    }, _this.handleIconOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          __WEBPACK_IMPORTED_MODULE_26_lodash_invoke___default()(predefinedProps, 'onClick', e, predefinedProps);
          _this.handleIconClick(e);
        }
      };
    }, _this.handleSearchRef = function (c) {
      return _this.searchRef = c;
    }, _this.handleSizerRef = function (c) {
      return _this.sizerRef = c;
    }, _this.handleRef = function (c) {
      return _this.ref = c;
    }, _this.computeSearchInputTabIndex = function () {
      var _this$props9 = _this.props,
          disabled = _this$props9.disabled,
          tabIndex = _this$props9.tabIndex;


      if (!__WEBPACK_IMPORTED_MODULE_29_lodash_isNil___default()(tabIndex)) return tabIndex;
      return disabled ? -1 : 0;
    }, _this.computeSearchInputWidth = function () {
      var searchQuery = _this.state.searchQuery;


      if (_this.sizerRef && searchQuery) {
        // resize the search input, temporarily show the sizer so we can measure it

        _this.sizerRef.style.display = 'inline';
        _this.sizerRef.textContent = searchQuery;
        var searchWidth = Math.ceil(_this.sizerRef.getBoundingClientRect().width);
        _this.sizerRef.style.removeProperty('display');

        return searchWidth;
      }
    }, _this.computeTabIndex = function () {
      var _this$props10 = _this.props,
          disabled = _this$props10.disabled,
          search = _this$props10.search,
          tabIndex = _this$props10.tabIndex;

      // don't set a root node tabIndex as the search input has its own tabIndex

      if (search) return undefined;
      if (disabled) return -1;
      return __WEBPACK_IMPORTED_MODULE_29_lodash_isNil___default()(tabIndex) ? 0 : tabIndex;
    }, _this.scrollSelectedItemIntoView = function () {
      if (!_this.ref) return;
      var menu = _this.ref.querySelector('.menu.visible');
      if (!menu) return;
      var item = menu.querySelector('.item.selected');
      if (!item) return;

      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;

      if (isOutOfUpperView) {
        menu.scrollTop = item.offsetTop;
      } else if (isOutOfLowerView) {
        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
      }
    }, _this.open = function (e) {
      var _this$props11 = _this.props,
          disabled = _this$props11.disabled,
          onOpen = _this$props11.onOpen,
          search = _this$props11.search;

      if (disabled) return;
      if (search && _this.searchRef) _this.searchRef.focus();
      if (onOpen) onOpen(e, _this.props);

      _this.trySetState({ open: true });
      _this.scrollSelectedItemIntoView();
    }, _this.close = function (e) {
      var onClose = _this.props.onClose;

      if (onClose) onClose(e, _this.props);

      _this.trySetState({ open: false });
    }, _this.handleClose = function () {
      var hasSearchFocus = document.activeElement === _this.searchRef;
      var hasDropdownFocus = document.activeElement === _this.ref;
      var hasFocus = hasSearchFocus || hasDropdownFocus;
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
      // Blur the Dropdown on close so it is blurred after selecting an item.
      // This is to prevent it from re-opening when switching tabs after selecting an item.
      if (!hasSearchFocus) {
        _this.ref.blur();
      }

      // We need to keep the virtual model in sync with the browser focus change
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/692
      _this.setState({ focus: hasFocus });
    }, _this.toggle = function (e) {
      return _this.state.open ? _this.close(e) : _this.open(e);
    }, _this.renderText = function () {
      var _this$props12 = _this.props,
          multiple = _this$props12.multiple,
          placeholder = _this$props12.placeholder,
          search = _this$props12.search,
          text = _this$props12.text;
      var _this$state3 = _this.state,
          searchQuery = _this$state3.searchQuery,
          value = _this$state3.value,
          open = _this$state3.open;

      var hasValue = multiple ? !__WEBPACK_IMPORTED_MODULE_20_lodash_isEmpty___default()(value) : !__WEBPACK_IMPORTED_MODULE_29_lodash_isNil___default()(value) && value !== '';

      var classes = __WEBPACK_IMPORTED_MODULE_30_classnames___default()(placeholder && !hasValue && 'default', 'text', search && searchQuery && 'filtered');
      var _text = placeholder;
      if (searchQuery) {
        _text = null;
      } else if (text) {
        _text = text;
      } else if (open && !multiple) {
        _text = __WEBPACK_IMPORTED_MODULE_23_lodash_get___default()(_this.getSelectedItem(), 'text');
      } else if (hasValue) {
        _text = __WEBPACK_IMPORTED_MODULE_23_lodash_get___default()(_this.getItemByValue(value), 'text');
      }

      return __WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(
        'div',
        { className: classes, role: 'alert', 'aria-live': 'polite' },
        _text
      );
    }, _this.renderSearchInput = function () {
      var _this$props13 = _this.props,
          search = _this$props13.search,
          searchInput = _this$props13.searchInput;
      var searchQuery = _this.state.searchQuery;


      if (!search) return null;
      return __WEBPACK_IMPORTED_MODULE_40__DropdownSearchInput__["a" /* default */].create(searchInput, { defaultProps: {
          inputRef: _this.handleSearchRef,
          onChange: _this.handleSearchChange,
          style: { width: _this.computeSearchInputWidth() },
          tabIndex: _this.computeSearchInputTabIndex(),
          value: searchQuery
        } });
    }, _this.renderSearchSizer = function () {
      var _this$props14 = _this.props,
          search = _this$props14.search,
          multiple = _this$props14.multiple;


      if (!(search && multiple)) return null;
      return __WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement('span', { className: 'sizer', ref: _this.handleSizerRef });
    }, _this.renderLabels = function () {
      var _this$props15 = _this.props,
          multiple = _this$props15.multiple,
          renderLabel = _this$props15.renderLabel;
      var _this$state4 = _this.state,
          selectedLabel = _this$state4.selectedLabel,
          value = _this$state4.value;

      if (!multiple || __WEBPACK_IMPORTED_MODULE_20_lodash_isEmpty___default()(value)) {
        return;
      }
      var selectedItems = __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(value, _this.getItemByValue);


      // if no item could be found for a given state value the selected item will be undefined
      // compact the selectedItems so we only have actual objects left
      return __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_7_lodash_compact___default()(selectedItems), function (item, index) {
        var defaultProps = {
          active: item.value === selectedLabel,
          as: 'a',
          key: getKeyOrValue(item.key, item.value),
          onClick: _this.handleLabelClick,
          onRemove: _this.handleLabelRemove,
          value: item.value
        };

        return __WEBPACK_IMPORTED_MODULE_35__elements_Label__["a" /* default */].create(renderLabel(item, index, defaultProps), { defaultProps: defaultProps });
      });
    }, _this.renderOptions = function () {
      var _this$props16 = _this.props,
          multiple = _this$props16.multiple,
          search = _this$props16.search,
          noResultsMessage = _this$props16.noResultsMessage;
      var _this$state5 = _this.state,
          selectedIndex = _this$state5.selectedIndex,
          value = _this$state5.value;

      var options = _this.getMenuOptions();

      if (noResultsMessage !== null && search && __WEBPACK_IMPORTED_MODULE_20_lodash_isEmpty___default()(options)) {
        return __WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(
          'div',
          { className: 'message' },
          noResultsMessage
        );
      }

      var isActive = multiple ? function (optValue) {
        return __WEBPACK_IMPORTED_MODULE_24_lodash_includes___default()(value, optValue);
      } : function (optValue) {
        return optValue === value;
      };

      return __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(options, function (opt, i) {
        return __WEBPACK_IMPORTED_MODULE_37__DropdownItem__["a" /* default */].create(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          active: isActive(opt.value),
          onClick: _this.handleItemClick,
          selected: selectedIndex === i
        }, opt, {
          key: getKeyOrValue(opt.key, opt.value),
          // Needed for handling click events on disabled items
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, opt.style, { pointerEvents: 'all' })
        }));
      });
    }, _this.renderMenu = function () {
      var _this$props17 = _this.props,
          children = _this$props17.children,
          direction = _this$props17.direction,
          header = _this$props17.header;
      var open = _this.state.open;

      var ariaOptions = _this.getDropdownMenuAriaOptions();

      // single menu child
      if (!__WEBPACK_IMPORTED_MODULE_33__lib__["d" /* childrenUtils */].isNil(children)) {
        var menuChild = __WEBPACK_IMPORTED_MODULE_32_react__["Children"].only(children);
        var className = __WEBPACK_IMPORTED_MODULE_30_classnames___default()(direction, Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(open, 'visible'), menuChild.props.className);

        return Object(__WEBPACK_IMPORTED_MODULE_32_react__["cloneElement"])(menuChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ className: className }, ariaOptions));
      }

      return __WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_39__DropdownMenu__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, ariaOptions, { direction: direction, open: open }),
        __WEBPACK_IMPORTED_MODULE_38__DropdownHeader__["a" /* default */].create(header),
        _this.renderOptions()
      );
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Dropdown, [{
    key: 'getInitialAutoControlledState',
    value: function getInitialAutoControlledState() {
      return { searchQuery: '' };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _state = this.state,
          open = _state.open,
          value = _state.value;


      this.setValue(value);
      this.setSelectedIndex(value);

      if (open) {
        this.open();
        this.attachHandlersOnOpen();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(Dropdown.prototype.__proto__ || Object.getPrototypeOf(Dropdown.prototype), 'componentWillReceiveProps', this).call(this, nextProps);


      /* eslint-disable no-console */
      if (false) {
        // in development, validate value type matches dropdown type
        var isNextValueArray = Array.isArray(nextProps.value);
        var hasValue = _has(nextProps, 'value');

        if (hasValue && nextProps.multiple && !isNextValueArray) {
          console.error('Dropdown `value` must be an array when `multiple` is set.' + (' Received type: `' + Object.prototype.toString.call(nextProps.value) + '`.'));
        } else if (hasValue && !nextProps.multiple && isNextValueArray) {
          console.error('Dropdown `value` must not be an array when `multiple` is not set.' + ' Either set `multiple={true}` or use a string or number value.');
        }
      }
      /* eslint-enable no-console */

      if (!Object(__WEBPACK_IMPORTED_MODULE_33__lib__["A" /* shallowEqual */])(nextProps.value, this.props.value)) {
        this.setValue(nextProps.value);
        this.setSelectedIndex(nextProps.value);
      }

      if (!__WEBPACK_IMPORTED_MODULE_27_lodash_isEqual___default()(nextProps.options, this.props.options)) {
        this.setSelectedIndex(undefined, nextProps.options);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !Object(__WEBPACK_IMPORTED_MODULE_33__lib__["A" /* shallowEqual */])(nextProps, this.props) || !Object(__WEBPACK_IMPORTED_MODULE_33__lib__["A" /* shallowEqual */])(nextState, this.state);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {

      // focused / blurred
      // eslint-disable-line complexity
      if (!prevState.focus && this.state.focus) {
        if (!this.isMouseDown) {
          var _props = this.props,
              minCharacters = _props.minCharacters,
              openOnFocus = _props.openOnFocus,
              search = _props.search;

          var openable = !search || search && minCharacters === 1;

          if (openOnFocus && openable) this.open();
        }
        if (!this.state.open) {
          __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].sub('keydown', [this.openOnArrow, this.openOnSpace]);
        } else {
          __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
        }
        __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].sub('keydown', this.removeItemOnBackspace);
      } else if (prevState.focus && !this.state.focus) {
        var closeOnBlur = this.props.closeOnBlur;

        if (!this.isMouseDown && closeOnBlur) {
          this.close();
        }
        __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].unsub('keydown', [this.openOnArrow, this.openOnSpace, this.moveSelectionOnKeyDown, this.selectItemOnEnter, this.removeItemOnBackspace]);
      }

      // opened / closed
      if (!prevState.open && this.state.open) {
        this.attachHandlersOnOpen();
        this.scrollSelectedItemIntoView();
      } else if (prevState.open && !this.state.open) {
        this.handleClose();
        __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
        __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].unsub('click', this.closeOnDocumentClick);
        if (!this.state.focus) {
          __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].unsub('keydown', this.removeItemOnBackspace);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {

      __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].unsub('keydown', [this.openOnArrow, this.openOnSpace, this.moveSelectionOnKeyDown, this.selectItemOnEnter, this.removeItemOnBackspace, this.closeOnEscape]);
      __WEBPACK_IMPORTED_MODULE_33__lib__["o" /* eventStack */].unsub('click', this.closeOnDocumentClick);
    }

    // ----------------------------------------
    // Document Event Handlers
    // ----------------------------------------

    // onChange needs to receive a value
    // can't rely on props.value if we are controlled


    // ----------------------------------------
    // Component Event Handlers
    // ----------------------------------------

    // ----------------------------------------
    // Getters
    // ----------------------------------------

    // There are times when we need to calculate the options based on a value
    // that hasn't yet been persisted to state.

  }, {
    key: 'getDropdownMenuAriaOptions',
    value: function getDropdownMenuAriaOptions() {
      var _props2 = this.props,
          search = _props2.search,
          multiple = _props2.multiple;

      var ariaOptions = {};

      if (search) {
        ariaOptions['aria-multiselectable'] = multiple;
        ariaOptions.role = 'listbox';
      }
      return ariaOptions;
    }

    // ----------------------------------------
    // Setters
    // ----------------------------------------

    // ----------------------------------------
    // Overrides
    // ----------------------------------------

    // ----------------------------------------
    // Refs
    // ----------------------------------------

    // ----------------------------------------
    // Helpers
    // ----------------------------------------

    // ----------------------------------------
    // Behavior
    // ----------------------------------------

    // ----------------------------------------
    // Render
    // ----------------------------------------

  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          basic = _props3.basic,
          button = _props3.button,
          className = _props3.className,
          compact = _props3.compact,
          disabled = _props3.disabled,
          error = _props3.error,
          fluid = _props3.fluid,
          floating = _props3.floating,
          icon = _props3.icon,
          inline = _props3.inline,
          item = _props3.item,
          labeled = _props3.labeled,
          loading = _props3.loading,
          multiple = _props3.multiple,
          pointing = _props3.pointing,
          search = _props3.search,
          selection = _props3.selection,
          scrolling = _props3.scrolling,
          simple = _props3.simple,
          trigger = _props3.trigger,
          upward = _props3.upward;
      var open = this.state.open;

      // Classes

      var classes = __WEBPACK_IMPORTED_MODULE_30_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(open, 'active visible'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(button, 'button'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(floating, 'floating'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(inline, 'inline'),
      // TODO: consider augmentation to render Dropdowns as Button/Menu, solves icon/link item issues
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
      // TODO: the icon class is only required when a dropdown is a button
      // useKeyOnly(icon, 'icon'),
      Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(labeled, 'labeled'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(item, 'item'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(multiple, 'multiple'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(search, 'search'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(selection, 'selection'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(simple, 'simple'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(scrolling, 'scrolling'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["B" /* useKeyOnly */])(upward, 'upward'), Object(__WEBPACK_IMPORTED_MODULE_33__lib__["C" /* useKeyOrValueAndKey */])(pointing, 'pointing'), 'dropdown', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_33__lib__["r" /* getUnhandledProps */])(Dropdown, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_33__lib__["q" /* getElementType */])(Dropdown, this.props);
      var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);

      return __WEBPACK_IMPORTED_MODULE_32_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, ariaOptions, {
          className: classes,
          onBlur: this.handleBlur,
          onClick: this.handleClick,
          onMouseDown: this.handleMouseDown,
          onFocus: this.handleFocus,
          onChange: this.handleChange,
          tabIndex: this.computeTabIndex(),
          ref: this.handleRef
        }),
        this.renderLabels(),
        this.renderSearchInput(),
        this.renderSearchSizer(),
        trigger || this.renderText(),
        __WEBPACK_IMPORTED_MODULE_34__elements_Icon__["a" /* default */].create(icon, {
          overrideProps: this.handleIconOverrides
        }),
        this.renderMenu()
      );
    }
  }]);

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_33__lib__["a" /* AutoControlledComponent */]);

Dropdown.defaultProps = {
  additionLabel: 'Add ',
  additionPosition: 'top',
  closeOnBlur: true,
  deburr: false,
  icon: 'dropdown',
  minCharacters: 1,
  noResultsMessage: 'No results found.',
  openOnFocus: true,
  renderLabel: function renderLabel(_ref3) {
    var text = _ref3.text;
    return text;
  },
  searchInput: 'text',
  selectOnBlur: true,
  selectOnNavigation: true,
  wrapSelection: true
};
Dropdown.autoControlledProps = ['open', 'searchQuery', 'selectedLabel', 'value'];
Dropdown._meta = {
  name: 'Dropdown',
  type: __WEBPACK_IMPORTED_MODULE_33__lib__["b" /* META */].TYPES.MODULE
};
Dropdown.Divider = __WEBPACK_IMPORTED_MODULE_36__DropdownDivider__["a" /* default */];
Dropdown.Header = __WEBPACK_IMPORTED_MODULE_38__DropdownHeader__["a" /* default */];
Dropdown.Item = __WEBPACK_IMPORTED_MODULE_37__DropdownItem__["a" /* default */];
Dropdown.Menu = __WEBPACK_IMPORTED_MODULE_39__DropdownMenu__["a" /* default */];
Dropdown.SearchInput = __WEBPACK_IMPORTED_MODULE_40__DropdownSearchInput__["a" /* default */];
Dropdown.handledProps = ['additionLabel', 'additionPosition', 'allowAdditions', 'as', 'basic', 'button', 'children', 'className', 'closeOnBlur', 'closeOnChange', 'compact', 'deburr', 'defaultOpen', 'defaultSearchQuery', 'defaultSelectedLabel', 'defaultValue', 'direction', 'disabled', 'error', 'floating', 'fluid', 'header', 'icon', 'inline', 'item', 'labeled', 'loading', 'minCharacters', 'multiple', 'noResultsMessage', 'onAddItem', 'onBlur', 'onChange', 'onClick', 'onClose', 'onFocus', 'onLabelClick', 'onMouseDown', 'onOpen', 'onSearchChange', 'open', 'openOnFocus', 'options', 'placeholder', 'pointing', 'renderLabel', 'scrolling', 'search', 'searchInput', 'searchQuery', 'selectOnBlur', 'selectOnNavigation', 'selectedLabel', 'selection', 'simple', 'tabIndex', 'text', 'trigger', 'upward', 'value', 'wrapSelection'];
/* harmony default export */ __webpack_exports__["a"] = (Dropdown);
Dropdown.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Label prefixed to an option added by a user. */
  additionLabel: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  /** Position of the `Add: ...` option in the dropdown list ('top' or 'bottom'). */
  additionPosition: PropTypes.oneOf(['top', 'bottom']),

  /**
   * Allow user additions to the list of options (boolean).
   * Requires the use of `selection`, `options` and `search`.
   */
  allowAdditions: customPropTypes.every([customPropTypes.demand(['options', 'selection', 'search']), PropTypes.bool]),

  /** A Dropdown can reduce its complexity. */
  basic: PropTypes.bool,

  /** Format the Dropdown to appear as a button. */
  button: PropTypes.bool,

  /** Primary content. */
  children: customPropTypes.every([customPropTypes.disallow(['options', 'selection']), customPropTypes.givenProps({ children: PropTypes.any.isRequired }, PropTypes.element.isRequired)]),

  /** Additional classes. */
  className: PropTypes.string,

  /** Whether or not the menu should close when the dropdown is blurred. */
  closeOnBlur: PropTypes.bool,

  /**
   * Whether or not the menu should close when a value is selected from the dropdown.
   * By default, multiple selection dropdowns will remain open on change, while single
   * selection dropdowns will close on change.
   */
  closeOnChange: PropTypes.bool,

  /** A compact dropdown has no minimum width. */
  compact: PropTypes.bool,

  /** Whether or not the dropdown should strip diacritics in options and input search */
  deburr: PropTypes.bool,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Initial value of searchQuery. */
  defaultSearchQuery: PropTypes.string,

  /** Currently selected label in multi-select. */
  defaultSelectedLabel: customPropTypes.every([customPropTypes.demand(['multiple']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** Initial value or value array if multiple. */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))]),

  /** A dropdown menu can open to the left or to the right. */
  direction: PropTypes.oneOf(['left', 'right']),

  /** A disabled dropdown menu or item does not allow user interaction. */
  disabled: PropTypes.bool,

  /** An errored dropdown can alert a user to a problem. */
  error: PropTypes.bool,

  /** A dropdown menu can contain floated content. */
  floating: PropTypes.bool,

  /** A dropdown can take the full width of its parent */
  fluid: PropTypes.bool,

  /** A dropdown menu can contain a header. */
  header: PropTypes.node,

  /** Shorthand for Icon. */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** A dropdown can be formatted to appear inline in other content. */
  inline: PropTypes.bool,

  /** A dropdown can be formatted as a Menu item. */
  item: PropTypes.bool,

  /** A dropdown can be labeled. */
  labeled: PropTypes.bool,

  /** A dropdown can show that it is currently loading data. */
  loading: PropTypes.bool,

  /** The minimum characters for a search to begin showing results. */
  minCharacters: PropTypes.number,

  /** A selection dropdown can allow multiple selections. */
  multiple: PropTypes.bool,

  /** Message to display when there are no results. */
  noResultsMessage: PropTypes.string,

  /**
   * Called when a user adds a new item. Use this to update the options list.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and the new item's value.
   */
  onAddItem: PropTypes.func,

  /**
   * Called on blur.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBlur: PropTypes.func,

  /**
   * Called when the user attempts to change the value.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onChange: PropTypes.func,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called on focus.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onFocus: PropTypes.func,

  /**
   * Called when a multi-select label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All label props.
   */
  onLabelClick: PropTypes.func,

  /**
   * Called on mousedown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called on search input change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props, includes current value of searchQuery.
   */
  onSearchChange: PropTypes.func,

  /** Controls whether or not the dropdown menu is displayed. */
  open: PropTypes.bool,

  /** Whether or not the menu should open when the dropdown is focused. */
  openOnFocus: PropTypes.bool,

  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.arrayOf(PropTypes.shape(DropdownItem.propTypes))]),

  /** Placeholder text. */
  placeholder: PropTypes.string,

  /** A dropdown can be formatted so that its menu is pointing. */
  pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'top left', 'top right', 'bottom', 'bottom left', 'bottom right'])]),

  /**
   * Mapped over the active items and returns shorthand for the active item Labels.
   * Only applies to `multiple` Dropdowns.
   *
   * @param {object} item - A currently active dropdown item.
   * @param {number} index - The current index.
   * @param {object} defaultLabelProps - The default props for an active item Label.
   * @returns {*} Shorthand for a Label.
   */
  renderLabel: PropTypes.func,

  /** A dropdown can have its menu scroll. */
  scrolling: PropTypes.bool,

  /**
   * A selection dropdown can allow a user to search through a large list of choices.
   * Pass a function here to replace the default search.
   */
  search: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),

  /** A shorthand for a search input. */
  searchInput: PropTypes.oneOfType([PropTypes.array, PropTypes.node, PropTypes.object]),

  /** Current value of searchQuery. Creates a controlled component. */
  searchQuery: PropTypes.string,

  // TODO 'searchInMenu' or 'search='in menu' or ???  How to handle this markup and functionality?

  /** Define whether the highlighted item should be selected on blur. */
  selectOnBlur: PropTypes.bool,

  /**
   * Whether or not to change the value when navigating the menu using arrow keys.
   * Setting to false will require enter or left click to confirm a choice.
   */
  selectOnNavigation: PropTypes.bool,

  /** Currently selected label in multi-select. */
  selectedLabel: customPropTypes.every([customPropTypes.demand(['multiple']), PropTypes.oneOfType([PropTypes.string, PropTypes.number])]),

  /** A dropdown can be used to select between choices in a form. */
  selection: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['options']), PropTypes.bool]),

  /** A simple dropdown can open without Javascript. */
  simple: PropTypes.bool,

  /** A dropdown can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The text displayed in the dropdown, usually for the active item. */
  text: PropTypes.string,

  /** Custom element to trigger the menu to become visible. Takes place of 'text'. */
  trigger: customPropTypes.every([customPropTypes.disallow(['selection', 'text']), PropTypes.node]),

  /** Current value or value array if multiple. Creates a controlled component. */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]))]),

  /** A dropdown can open upward. */
  upward: PropTypes.bool,

  /**
   * A dropdown will go to the last element when ArrowUp is pressed on the first,
   * or go to the first when ArrowDown is pressed on the last( aka infinite selection )
   */
  wrapSelection: PropTypes.bool
} : {};

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(265);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(771), __esModule: true };

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(772);
module.exports = __webpack_require__(22).Object.getPrototypeOf;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(81);
var $getPrototypeOf = __webpack_require__(268);

__webpack_require__(361)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(774), __esModule: true };

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(775);
var $Object = __webpack_require__(22).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(57);
var $getOwnPropertyDescriptor = __webpack_require__(168).f;

__webpack_require__(361)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(777),
    baseEvery = __webpack_require__(778),
    baseIteratee = __webpack_require__(27),
    isArray = __webpack_require__(15),
    isIterateeCall = __webpack_require__(75);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(64);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(37);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(111),
    toInteger = __webpack_require__(40);

/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = dropRight;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(123),
    getTag = __webpack_require__(53),
    isArrayLike = __webpack_require__(28),
    isString = __webpack_require__(135),
    stringSize = __webpack_require__(782);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(783),
    hasUnicode = __webpack_require__(134),
    unicodeSize = __webpack_require__(784);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(300);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 784 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(86),
    baseRest = __webpack_require__(52),
    baseUniq = __webpack_require__(329),
    isArrayLikeObject = __webpack_require__(116);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(2);











var names = ['ad', 'andorra', 'ae', 'united arab emirates', 'uae', 'af', 'afghanistan', 'ag', 'antigua', 'ai', 'anguilla', 'al', 'albania', 'am', 'armenia', 'an', 'netherlands antilles', 'ao', 'angola', 'ar', 'argentina', 'as', 'american samoa', 'at', 'austria', 'au', 'australia', 'aw', 'aruba', 'ax', 'aland islands', 'az', 'azerbaijan', 'ba', 'bosnia', 'bb', 'barbados', 'bd', 'bangladesh', 'be', 'belgium', 'bf', 'burkina faso', 'bg', 'bulgaria', 'bh', 'bahrain', 'bi', 'burundi', 'bj', 'benin', 'bm', 'bermuda', 'bn', 'brunei', 'bo', 'bolivia', 'br', 'brazil', 'bs', 'bahamas', 'bt', 'bhutan', 'bv', 'bouvet island', 'bw', 'botswana', 'by', 'belarus', 'bz', 'belize', 'ca', 'canada', 'cc', 'cocos islands', 'cd', 'congo', 'cf', 'central african republic', 'cg', 'congo brazzaville', 'ch', 'switzerland', 'ci', 'cote divoire', 'ck', 'cook islands', 'cl', 'chile', 'cm', 'cameroon', 'cn', 'china', 'co', 'colombia', 'cr', 'costa rica', 'cs', 'cu', 'cuba', 'cv', 'cape verde', 'cx', 'christmas island', 'cy', 'cyprus', 'cz', 'czech republic', 'de', 'germany', 'dj', 'djibouti', 'dk', 'denmark', 'dm', 'dominica', 'do', 'dominican republic', 'dz', 'algeria', 'ec', 'ecuador', 'ee', 'estonia', 'eg', 'egypt', 'eh', 'western sahara', 'er', 'eritrea', 'es', 'spain', 'et', 'ethiopia', 'eu', 'european union', 'fi', 'finland', 'fj', 'fiji', 'fk', 'falkland islands', 'fm', 'micronesia', 'fo', 'faroe islands', 'fr', 'france', 'ga', 'gabon', 'gb', 'united kingdom', 'gd', 'grenada', 'ge', 'georgia', 'gf', 'french guiana', 'gh', 'ghana', 'gi', 'gibraltar', 'gl', 'greenland', 'gm', 'gambia', 'gn', 'guinea', 'gp', 'guadeloupe', 'gq', 'equatorial guinea', 'gr', 'greece', 'gs', 'sandwich islands', 'gt', 'guatemala', 'gu', 'guam', 'gw', 'guinea-bissau', 'gy', 'guyana', 'hk', 'hong kong', 'hm', 'heard island', 'hn', 'honduras', 'hr', 'croatia', 'ht', 'haiti', 'hu', 'hungary', 'id', 'indonesia', 'ie', 'ireland', 'il', 'israel', 'in', 'india', 'io', 'indian ocean territory', 'iq', 'iraq', 'ir', 'iran', 'is', 'iceland', 'it', 'italy', 'jm', 'jamaica', 'jo', 'jordan', 'jp', 'japan', 'ke', 'kenya', 'kg', 'kyrgyzstan', 'kh', 'cambodia', 'ki', 'kiribati', 'km', 'comoros', 'kn', 'saint kitts and nevis', 'kp', 'north korea', 'kr', 'south korea', 'kw', 'kuwait', 'ky', 'cayman islands', 'kz', 'kazakhstan', 'la', 'laos', 'lb', 'lebanon', 'lc', 'saint lucia', 'li', 'liechtenstein', 'lk', 'sri lanka', 'lr', 'liberia', 'ls', 'lesotho', 'lt', 'lithuania', 'lu', 'luxembourg', 'lv', 'latvia', 'ly', 'libya', 'ma', 'morocco', 'mc', 'monaco', 'md', 'moldova', 'me', 'montenegro', 'mg', 'madagascar', 'mh', 'marshall islands', 'mk', 'macedonia', 'ml', 'mali', 'mm', 'myanmar', 'burma', 'mn', 'mongolia', 'mo', 'macau', 'mp', 'northern mariana islands', 'mq', 'martinique', 'mr', 'mauritania', 'ms', 'montserrat', 'mt', 'malta', 'mu', 'mauritius', 'mv', 'maldives', 'mw', 'malawi', 'mx', 'mexico', 'my', 'malaysia', 'mz', 'mozambique', 'na', 'namibia', 'nc', 'new caledonia', 'ne', 'niger', 'nf', 'norfolk island', 'ng', 'nigeria', 'ni', 'nicaragua', 'nl', 'netherlands', 'no', 'norway', 'np', 'nepal', 'nr', 'nauru', 'nu', 'niue', 'nz', 'new zealand', 'om', 'oman', 'pa', 'panama', 'pe', 'peru', 'pf', 'french polynesia', 'pg', 'new guinea', 'ph', 'philippines', 'pk', 'pakistan', 'pl', 'poland', 'pm', 'saint pierre', 'pn', 'pitcairn islands', 'pr', 'puerto rico', 'ps', 'palestine', 'pt', 'portugal', 'pw', 'palau', 'py', 'paraguay', 'qa', 'qatar', 're', 'reunion', 'ro', 'romania', 'rs', 'serbia', 'ru', 'russia', 'rw', 'rwanda', 'sa', 'saudi arabia', 'sb', 'solomon islands', 'sc', 'seychelles', 'gb sct', 'scotland', 'sd', 'sudan', 'se', 'sweden', 'sg', 'singapore', 'sh', 'saint helena', 'si', 'slovenia', 'sj', 'svalbard', 'jan mayen', 'sk', 'slovakia', 'sl', 'sierra leone', 'sm', 'san marino', 'sn', 'senegal', 'so', 'somalia', 'sr', 'suriname', 'st', 'sao tome', 'sv', 'el salvador', 'sy', 'syria', 'sz', 'swaziland', 'tc', 'caicos islands', 'td', 'chad', 'tf', 'french territories', 'tg', 'togo', 'th', 'thailand', 'tj', 'tajikistan', 'tk', 'tokelau', 'tl', 'timorleste', 'tm', 'turkmenistan', 'tn', 'tunisia', 'to', 'tonga', 'tr', 'turkey', 'tt', 'trinidad', 'tv', 'tuvalu', 'tw', 'taiwan', 'tz', 'tanzania', 'ua', 'ukraine', 'ug', 'uganda', 'um', 'us minor islands', 'us', 'america', 'united states', 'uy', 'uruguay', 'uz', 'uzbekistan', 'va', 'vatican city', 'vc', 'saint vincent', 've', 'venezuela', 'vg', 'british virgin islands', 'vi', 'us virgin islands', 'vn', 'vietnam', 'vu', 'vanuatu', 'gb wls', 'wales', 'wf', 'wallis and futuna', 'ws', 'samoa', 'ye', 'yemen', 'yt', 'mayotte', 'za', 'south africa', 'zm', 'zambia', 'zw', 'zimbabwe'];

/**
 * A flag is is used to represent a political state.
 */

var Flag = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Flag, _Component);

  function Flag() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Flag);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Flag.__proto__ || Object.getPrototypeOf(Flag)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Flag, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !Object(__WEBPACK_IMPORTED_MODULE_8__lib__["A" /* shallowEqual */])(this.props, nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          name = _props.name;

      var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(name, 'flag', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["r" /* getUnhandledProps */])(Flag, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* getElementType */])(Flag, this.props);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }));
    }
  }]);

  return Flag;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Flag.defaultProps = {
  as: 'i'
};
Flag._meta = {
  name: 'Flag',
  type: __WEBPACK_IMPORTED_MODULE_8__lib__["b" /* META */].TYPES.ELEMENT
};
Flag.handledProps = ['as', 'className', 'name'];
Flag.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /** Flag name, can use the two digit country code, the full name, or a common alias. */
  name: customPropTypes.suggest(names)
} : {};


Flag.create = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["m" /* createShorthandFactory */])(Flag, function (value) {
  return { name: value };
});

/* harmony default export */ __webpack_exports__["a"] = (Flag);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sum__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);














/**
 * A TextArea can be used to allow for extended user input.
 * @see Form
 */

var TextArea = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TextArea, _Component);

  function TextArea() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TextArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
      return _this.ref.focus();
    }, _this.handleChange = function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.props, { value: value }));
    }, _this.handleInput = function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onInput', e, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.props, { value: value }));
      _this.updateHeight();
    }, _this.handleRef = function (c) {
      return _this.ref = c;
    }, _this.removeAutoHeightStyles = function () {
      _this.ref.style.height = null;
      _this.ref.style.resize = null;
    }, _this.updateHeight = function () {
      var autoHeight = _this.props.autoHeight;

      if (!_this.ref || !autoHeight) return;

      var _window$getComputedSt = window.getComputedStyle(_this.ref),
          minHeight = _window$getComputedSt.minHeight,
          borderBottomWidth = _window$getComputedSt.borderBottomWidth,
          borderTopWidth = _window$getComputedSt.borderTopWidth;

      var borderHeight = __WEBPACK_IMPORTED_MODULE_5_lodash_sum___default()([borderBottomWidth, borderTopWidth].map(function (x) {
        return parseFloat(x);
      }));

      // Measure the scrollHeight and update the height to match.
      _this.ref.style.height = 'auto';
      _this.ref.style.overflowY = 'hidden';
      _this.ref.style.height = Math.max(parseFloat(minHeight), Math.ceil(_this.ref.scrollHeight + borderHeight)) + 'px';
      _this.ref.style.overflowY = '';
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TextArea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateHeight();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // removed autoHeight
      if (!this.props.autoHeight && prevProps.autoHeight) {
        this.removeAutoHeightStyles();
      }
      // added autoHeight or value changed
      if (this.props.autoHeight && !prevProps.autoHeight || prevProps.value !== this.props.value) {
        this.updateHeight();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoHeight = _props.autoHeight,
          rows = _props.rows,
          style = _props.style,
          value = _props.value;

      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(TextArea, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(TextArea, this.props);

      var resize = autoHeight ? 'none' : '';

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        onChange: this.handleChange,
        onInput: this.handleInput,
        ref: this.handleRef,
        rows: rows,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ resize: resize }, style),
        value: value
      }));
    }
  }]);

  return TextArea;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

TextArea._meta = {
  name: 'TextArea',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.ADDON
};
TextArea.defaultProps = {
  as: 'textarea',
  rows: 3
};
TextArea.handledProps = ['as', 'autoHeight', 'onChange', 'onInput', 'rows', 'style', 'value'];
TextArea.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Indicates whether height of the textarea fits the content or not. */
  autoHeight: PropTypes.bool,

  /**
   * Called on change.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onChange: PropTypes.func,

  /**
   * Called on input.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onInput: PropTypes.func,

  /** Indicates row count for a TextArea. */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Custom TextArea style. */
  style: PropTypes.object,

  /** The value of the textarea. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};


/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransitionablePortal__ = __webpack_require__(789);
/* unused harmony reexport default */



/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Portal__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_Transition__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);














/**
 * A sugar for `Portal` and `Transition`.
 * @see Portal
 * @see Transition
 */
var TransitionablePortal = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TransitionablePortal, _Component);

  function TransitionablePortal(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TransitionablePortal);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TransitionablePortal.__proto__ || Object.getPrototypeOf(TransitionablePortal)).call(this, props));

    _this.handlePortalClose = function () {

      _this.setState({ portalOpen: false });
    };

    _this.handlePortalOpen = function () {

      _this.setState({ portalOpen: true });
    };

    _this.handleTransitionHide = function (nothing, data) {
      var portalOpen = _this.state.portalOpen;


      _this.setState({ transitionVisible: false });
      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onClose', null, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { portalOpen: false, transitionVisible: false }));
      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onHide', null, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { portalOpen: portalOpen, transitionVisible: false }));
    };

    _this.handleTransitionStart = function (nothing, data) {
      var portalOpen = _this.state.portalOpen;
      var status = data.status;

      var transitionVisible = status === __WEBPACK_IMPORTED_MODULE_9__modules_Transition__["a" /* default */].ENTERING;

      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onStart', null, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { portalOpen: portalOpen, transitionVisible: transitionVisible }));

      // Heads up! TransitionablePortal fires onOpen callback on the start of transition animation
      if (!transitionVisible) return;

      _this.setState({ transitionVisible: transitionVisible });
      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onOpen', null, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, { transitionVisible: transitionVisible, portalOpen: true }));
    };

    _this.state = {
      portalOpen: props.open
    };
    return _this;
  }

  // ----------------------------------------
  // Lifecycle
  // ----------------------------------------

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TransitionablePortal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var open = _ref.open;


      this.setState({ portalOpen: open });
    }

    // ----------------------------------------
    // Callback handling
    // ----------------------------------------

  }, {
    key: 'render',


    // ----------------------------------------
    // Render
    // ----------------------------------------

    value: function render() {
      var _props = this.props,
          children = _props.children,
          transition = _props.transition;
      var _state = this.state,
          portalOpen = _state.portalOpen,
          transitionVisible = _state.transitionVisible;


      var open = portalOpen || transitionVisible;
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(TransitionablePortal, this.props);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Portal__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
          open: open,
          onOpen: this.handlePortalOpen,
          onClose: this.handlePortalClose
        }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__modules_Transition__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, transition, {
            transitionOnMount: true,
            onStart: this.handleTransitionStart,
            onHide: this.handleTransitionHide,
            visible: portalOpen
          }),
          children
        )
      );
    }
  }]);

  return TransitionablePortal;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

TransitionablePortal._meta = {
  name: 'TransitionablePortal',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.ADDON
};
TransitionablePortal.defaultProps = {
  transition: {
    animation: 'scale',
    duration: 400
  }
};
TransitionablePortal.handledProps = ['children', 'onClose', 'onHide', 'onOpen', 'onStart', 'open', 'transition'];
/* unused harmony default export */ var _unused_webpack_default_export = (TransitionablePortal);
TransitionablePortal.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and internal state.
   */
  onClose: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to hidden.
   *
   * @param {null}
   * @param {object} data - All props with transition status and internal state.
   */
  onHide: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and internal state.
   */
  onOpen: PropTypes.func,

  /**
   * Callback on animation start.
   *
   * @param {null}
   * @param {object} data - All props with transition status and internal state.
   */
  onStart: PropTypes.func,

  /** Controls whether or not the portal is displayed. */
  open: PropTypes.bool,

  /** Transition props. */
  transition: PropTypes.object
} : {};

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Visibility__ = __webpack_require__(791);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Visibility__["a"]; });



/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_includes__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(2);
















/**
 * Visibility provides a set of callbacks for when a content appears in the viewport.
 */

var Visibility = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Visibility, _Component);

  function Visibility() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Visibility);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Visibility.__proto__ || Object.getPrototypeOf(Visibility)).call.apply(_ref, [this].concat(args))), _this), _this.calculations = {
      bottomPassed: false,
      bottomVisible: false,
      fits: false,
      passing: false,
      offScreen: false,
      onScreen: false,
      topPassed: false,
      topVisible: false
    }, _this.firedCallbacks = [], _this.fire = function (_ref2, value) {
      var callback = _ref2.callback,
          name = _ref2.name;
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props = _this.props,
          continuous = _this$props.continuous,
          once = _this$props.once;

      // Heads up! For the execution is required:
      // - current value correspond to the fired direction
      // - `continuous` is true or calculation values are different

      var matchesDirection = _this.calculations[value] !== reverse;
      var executionPossible = continuous || _this.calculations[value] !== _this.oldCalculations[value];

      if (matchesDirection && executionPossible) _this.execute(callback, name);

      // Heads up! We should remove callback from the happened when it's not `once`
      if (!once) _this.firedCallbacks = __WEBPACK_IMPORTED_MODULE_8_lodash_without___default()(_this.firedCallbacks, name);
    }, _this.handleUpdate = function () {
      if (_this.ticking) return;

      _this.ticking = true;
      _this.frameId = requestAnimationFrame(_this.update);
    }, _this.update = function () {
      _this.ticking = false;

      _this.oldCalculations = _this.calculations;
      _this.calculations = _this.computeCalculations();
      _this.pageYOffset = window.pageYOffset;

      var _this$props2 = _this.props,
          onBottomPassed = _this$props2.onBottomPassed,
          onBottomPassedReverse = _this$props2.onBottomPassedReverse,
          onBottomVisible = _this$props2.onBottomVisible,
          onBottomVisibleReverse = _this$props2.onBottomVisibleReverse,
          onPassing = _this$props2.onPassing,
          onPassingReverse = _this$props2.onPassingReverse,
          onTopPassed = _this$props2.onTopPassed,
          onTopPassedReverse = _this$props2.onTopPassedReverse,
          onTopVisible = _this$props2.onTopVisible,
          onTopVisibleReverse = _this$props2.onTopVisibleReverse,
          onOffScreen = _this$props2.onOffScreen,
          onOnScreen = _this$props2.onOnScreen;

      var forward = {
        bottomPassed: { callback: onBottomPassed, name: 'onBottomPassed' },
        bottomVisible: { callback: onBottomVisible, name: 'onBottomVisible' },
        passing: { callback: onPassing, name: 'onPassing' },
        offScreen: { callback: onOffScreen, name: 'onOffScreen' },
        onScreen: { callback: onOnScreen, name: 'onOnScreen' },
        topPassed: { callback: onTopPassed, name: 'onTopPassed' },
        topVisible: { callback: onTopVisible, name: 'onTopVisible' }
      };

      var reverse = {
        bottomPassed: { callback: onBottomPassedReverse, name: 'onBottomPassedReverse' },
        bottomVisible: { callback: onBottomVisibleReverse, name: 'onBottomVisibleReverse' },
        passing: { callback: onPassingReverse, name: 'onPassingReverse' },
        topPassed: { callback: onTopPassedReverse, name: 'onTopPassedReverse' },
        topVisible: { callback: onTopVisibleReverse, name: 'onTopVisibleReverse' }
      };

      __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onUpdate', null, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { calculations: _this.calculations }));
      _this.fireOnPassed();

      // Heads up! Reverse callbacks should be fired first
      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(reverse, function (data, value) {
        return _this.fire(data, value, true);
      });
      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(forward, function (data, value) {
        return _this.fire(data, value);
      });
    }, _this.handleRef = function (c) {
      return _this.ref = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Visibility, [{
    key: 'componentWillReceiveProps',


    // ----------------------------------------
    // Lifecycle
    // ----------------------------------------

    value: function componentWillReceiveProps(_ref3) {
      var continuous = _ref3.continuous,
          once = _ref3.once,
          context = _ref3.context;

      var cleanHappened = continuous !== this.props.continuous || once !== this.props.once;

      // Heads up! We should clean up array of happened callbacks, if values of these props are changed
      if (cleanHappened) this.firedCallbacks = [];

      if (this.props.context !== context) {
        this.unattachHandlers(this.props.context);
        this.attachHandlers(context);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_12__lib__["t" /* isBrowser */])()) return;
      var _props = this.props,
          context = _props.context,
          fireOnMount = _props.fireOnMount;


      this.pageYOffset = window.pageYOffset;
      this.attachHandlers(context);

      if (fireOnMount) this.update();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var context = this.props.context;


      this.unattachHandlers(context);
      if (this.frameId) cancelAnimationFrame(this.frameId);
    }
  }, {
    key: 'attachHandlers',
    value: function attachHandlers(context) {
      if (context) {
        __WEBPACK_IMPORTED_MODULE_12__lib__["o" /* eventStack */].sub('resize', this.handleUpdate, { target: context });
        __WEBPACK_IMPORTED_MODULE_12__lib__["o" /* eventStack */].sub('scroll', this.handleUpdate, { target: context });
      }
    }
  }, {
    key: 'unattachHandlers',
    value: function unattachHandlers(context) {
      if (context) {
        __WEBPACK_IMPORTED_MODULE_12__lib__["o" /* eventStack */].unsub('resize', this.handleUpdate, { target: context });
        __WEBPACK_IMPORTED_MODULE_12__lib__["o" /* eventStack */].unsub('scroll', this.handleUpdate, { target: context });
      }
    }

    // ----------------------------------------
    // Callback handling
    // ----------------------------------------

  }, {
    key: 'execute',
    value: function execute(callback, name) {
      var continuous = this.props.continuous;

      if (!callback) return;

      // Heads up! When `continuous` is true, callback will be fired always
      if (!continuous && __WEBPACK_IMPORTED_MODULE_9_lodash_includes___default()(this.firedCallbacks, name)) return;

      callback(null, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, { calculations: this.calculations }));
      this.firedCallbacks.push(name);
    }
  }, {
    key: 'fireOnPassed',
    value: function fireOnPassed() {
      var _this2 = this;

      var _calculations = this.calculations,
          percentagePassed = _calculations.percentagePassed,
          pixelsPassed = _calculations.pixelsPassed;
      var onPassed = this.props.onPassed;


      __WEBPACK_IMPORTED_MODULE_7_lodash_forEach___default()(onPassed, function (callback, passed) {
        var pixelsValue = Number(passed);

        if (pixelsValue && pixelsPassed >= pixelsValue) {
          _this2.execute(callback, passed);
          return;
        }

        var matchPercentage = ('' + passed).match(/^(\d+)%$/);
        if (!matchPercentage) return;

        var percentageValue = Number(matchPercentage[1]) / 100;
        if (percentagePassed >= percentageValue) _this2.execute(callback, passed);
      });
    }
  }, {
    key: 'computeCalculations',


    // ----------------------------------------
    // Helpers
    // ----------------------------------------

    value: function computeCalculations() {
      var offset = this.props.offset;

      var _ref$getBoundingClien = this.ref.getBoundingClientRect(),
          bottom = _ref$getBoundingClien.bottom,
          height = _ref$getBoundingClien.height,
          top = _ref$getBoundingClien.top,
          width = _ref$getBoundingClien.width;

      var _normalizeOffset = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["w" /* normalizeOffset */])(offset),
          _normalizeOffset2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_normalizeOffset, 2),
          topOffset = _normalizeOffset2[0],
          bottomOffset = _normalizeOffset2[1];

      var direction = window.pageYOffset > this.pageYOffset ? 'down' : 'up';
      var topPassed = top < topOffset;
      var bottomPassed = bottom < bottomOffset;

      var pixelsPassed = bottomPassed ? 0 : Math.max(top * -1, 0);
      var percentagePassed = pixelsPassed / height;

      var bottomVisible = bottom >= bottomOffset && bottom <= window.innerHeight;
      var topVisible = top >= topOffset && top <= window.innerHeight;

      var fits = topVisible && bottomVisible;
      var passing = topPassed && !bottomPassed;

      var onScreen = (topVisible || topPassed) && !bottomPassed;
      var offScreen = !onScreen;

      return {
        bottomPassed: bottomPassed,
        bottomVisible: bottomVisible,
        direction: direction,
        fits: fits,
        height: height,
        passing: passing,
        percentagePassed: percentagePassed,
        pixelsPassed: pixelsPassed,
        offScreen: offScreen,
        onScreen: onScreen,
        topPassed: topPassed,
        topVisible: topVisible,
        width: width
      };
    }

    // ----------------------------------------
    // Refs
    // ----------------------------------------

  }, {
    key: 'render',


    // ----------------------------------------
    // Render
    // ----------------------------------------

    value: function render() {
      var children = this.props.children;

      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["q" /* getElementType */])(Visibility, this.props);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["r" /* getUnhandledProps */])(Visibility, this.props);

      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { ref: this.handleRef }),
        children
      );
    }
  }]);

  return Visibility;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Visibility.defaultProps = {
  context: Object(__WEBPACK_IMPORTED_MODULE_12__lib__["t" /* isBrowser */])() ? window : null,
  continuous: false,
  offset: [0, 0],
  once: true
};
Visibility._meta = {
  name: 'Visibility',
  type: __WEBPACK_IMPORTED_MODULE_12__lib__["b" /* META */].TYPES.BEHAVIOR
};
Visibility.handledProps = ['as', 'children', 'context', 'continuous', 'fireOnMount', 'offset', 'onBottomPassed', 'onBottomPassedReverse', 'onBottomVisible', 'onBottomVisibleReverse', 'onOffScreen', 'onOnScreen', 'onPassed', 'onPassing', 'onPassingReverse', 'onTopPassed', 'onTopPassedReverse', 'onTopVisible', 'onTopVisibleReverse', 'onUpdate', 'once'];
/* harmony default export */ __webpack_exports__["a"] = (Visibility);
Visibility.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Context which visibility should attach onscroll events. */
  context: PropTypes.object,

  /**
   * When set to true a callback will occur anytime an element passes a condition not just immediately after the
   * threshold is met.
   */
  continuous: PropTypes.bool,

  /** Fires callbacks immediately after mount. */
  fireOnMount: PropTypes.bool,

  /**
   * Element's bottom edge has passed top of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomPassed: PropTypes.func,

  /**
   * Element's bottom edge has not passed top of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomPassedReverse: PropTypes.func,

  /**
   * Element's bottom edge has passed bottom of screen
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomVisible: PropTypes.func,

  /**
   * Element's bottom edge has not passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomVisibleReverse: PropTypes.func,

  /**
   * Value that context should be adjusted in pixels. Useful for making content appear below content fixed to the
   * page.
   */
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]),

  /** When set to false a callback will occur each time an element passes the threshold for a condition. */
  once: PropTypes.bool,

  /** Element is not visible on the screen. */
  onPassed: PropTypes.object,

  /**
   * Any part of an element is visible on screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onPassing: PropTypes.func,

  /**
   * Element's top has not passed top of screen but bottom has.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onPassingReverse: PropTypes.func,

  /**
   * Element is not visible on the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onOffScreen: PropTypes.func,

  /**
   * Element is visible on the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onOnScreen: PropTypes.func,

  /**
   * Element's top edge has passed top of the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopPassed: PropTypes.func,

  /**
   * Element's top edge has not passed top of the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopPassedReverse: PropTypes.func,

  /**
   * Element's top edge has passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopVisible: PropTypes.func,

  /**
   * Element's top edge has not passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopVisibleReverse: PropTypes.func,

  /**
   * Element's top edge has passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUpdate: PropTypes.func
} : {};

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumb__ = __webpack_require__(793);
/* unused harmony reexport default */



/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__ = __webpack_require__(374);












/**
 * A breadcrumb is used to show hierarchy between content.
 */
function Breadcrumb(props) {
  var children = props.children,
      className = props.className,
      divider = props.divider,
      icon = props.icon,
      sections = props.sections,
      size = props.size;


  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', size, 'breadcrumb', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["r" /* getUnhandledProps */])(Breadcrumb, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getElementType */])(Breadcrumb, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    children
  );

  var childElements = [];

  __WEBPACK_IMPORTED_MODULE_2_lodash_each___default()(sections, function (section, index) {
    // section
    var breadcrumbElement = __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__["a" /* default */].create(section);
    childElements.push(breadcrumbElement);

    // divider
    if (index !== sections.length - 1) {
      var key = breadcrumbElement.key + '_divider' || JSON.stringify(section);
      childElements.push(__WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__["a" /* default */].create({ content: divider, icon: icon, key: key }));
    }
  });

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    childElements
  );
}

Breadcrumb.handledProps = ['as', 'children', 'className', 'divider', 'icon', 'sections', 'size'];
Breadcrumb._meta = {
  name: 'Breadcrumb',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.COLLECTION
};

Breadcrumb.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content of the Breadcrumb.Divider. */
  divider: customPropTypes.every([customPropTypes.disallow(['icon']), customPropTypes.contentShorthand]),

  /** For use with the sections prop. Render as an `Icon` component with `divider` class instead of a `div` in
   *  Breadcrumb.Divider. */
  icon: customPropTypes.every([customPropTypes.disallow(['divider']), customPropTypes.itemShorthand]),

  /** Shorthand array of props for Breadcrumb.Section. */
  sections: customPropTypes.collectionShorthand,

  /** Size of Breadcrumb. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};

Breadcrumb.Divider = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__["a" /* default */];
Breadcrumb.Section = __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Breadcrumb);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Form__["a"]; });



/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormButton__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FormCheckbox__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FormDropdown__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FormField__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FormGroup__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FormInput__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FormRadio__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FormSelect__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__FormTextArea__ = __webpack_require__(382);























/**
 * A Form displays a set of related user input fields in a structured way.
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Message
 * @see Radio
 * @see Select
 * @see Visibility
 */

var Form = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Form, _Component);

  function Form() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Form);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Form, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          action = _props.action,
          children = _props.children,
          className = _props.className,
          error = _props.error,
          inverted = _props.inverted,
          loading = _props.loading,
          reply = _props.reply,
          size = _props.size,
          success = _props.success,
          unstackable = _props.unstackable,
          warning = _props.warning,
          widths = _props.widths;


      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(reply, 'reply'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(success, 'success'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["H" /* useWidthProp */])(widths, null, true), 'form', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(Form, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(Form, this.props);

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
          action: action,
          className: classes,
          onSubmit: this.handleSubmit
        }),
        children
      );
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

Form.defaultProps = {
  as: 'form'
};
Form._meta = {
  name: 'Form',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.COLLECTION
};
Form.Field = __WEBPACK_IMPORTED_MODULE_14__FormField__["a" /* default */];
Form.Button = __WEBPACK_IMPORTED_MODULE_11__FormButton__["a" /* default */];
Form.Checkbox = __WEBPACK_IMPORTED_MODULE_12__FormCheckbox__["a" /* default */];
Form.Dropdown = __WEBPACK_IMPORTED_MODULE_13__FormDropdown__["a" /* default */];
Form.Group = __WEBPACK_IMPORTED_MODULE_15__FormGroup__["a" /* default */];
Form.Input = __WEBPACK_IMPORTED_MODULE_16__FormInput__["a" /* default */];
Form.Radio = __WEBPACK_IMPORTED_MODULE_17__FormRadio__["a" /* default */];
Form.Select = __WEBPACK_IMPORTED_MODULE_18__FormSelect__["a" /* default */];
Form.TextArea = __WEBPACK_IMPORTED_MODULE_19__FormTextArea__["a" /* default */];
Form.handledProps = ['action', 'as', 'children', 'className', 'error', 'inverted', 'loading', 'onSubmit', 'reply', 'size', 'success', 'unstackable', 'warning', 'widths'];

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleSubmit = function (e) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var action = _this2.props.action;

    // Heads up! Third party libs can pass own data as first argument, we need to check that it has preventDefault()
    // method.

    if (typeof action !== 'string') __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(e, 'preventDefault');
    __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default.a.apply(undefined, [_this2.props, 'onSubmit', e, _this2.props].concat(args));
  };
};

Form.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The HTML form action */
  action: PropTypes.string,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Automatically show any error Message children. */
  error: PropTypes.bool,

  /** A form can have its color inverted for contrast. */
  inverted: PropTypes.bool,

  /** Automatically show a loading indicator. */
  loading: PropTypes.bool,

  /** The HTML form submit handler. */
  onSubmit: PropTypes.func,

  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
  reply: PropTypes.bool,

  /** A form can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Automatically show any success Message children. */
  success: PropTypes.bool,

  /** A form can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** Automatically show any warning Message children. */
  warning: PropTypes.bool,

  /** Forms can automatically divide fields to be equal width. */
  widths: PropTypes.oneOf(['equal'])
} : {};


/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__elements_Button__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__elements_Icon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__elements_Label__ = __webpack_require__(140);





















/**
 * An Input is a field used to elicit a response from a user.
 * @see Button
 * @see Form
 * @see Icon
 * @see Label
 */

var Input = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.computeIcon = function () {
      var _this$props = _this.props,
          loading = _this$props.loading,
          icon = _this$props.icon;


      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(icon)) return icon;
      if (loading) return 'spinner';
    }, _this.computeTabIndex = function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;


      if (!__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(tabIndex)) return tabIndex;
      if (disabled) return -1;
    }, _this.focus = function () {
      return _this.inputRef.focus();
    }, _this.handleChange = function (e) {
      var value = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(e, 'target.value');

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onChange', e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { value: value }));
    }, _this.handleChildOverrides = function (child, defaultProps) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultProps, child.props, {
        ref: function ref(c) {
          __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(child, 'ref', c);
          _this.handleInputRef(c);
        }
      });
    }, _this.handleInputRef = function (c) {
      return _this.inputRef = c;
    }, _this.partitionProps = function () {
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          type = _this$props3.type;


      var tabIndex = _this.computeTabIndex();
      var unhandled = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["r" /* getUnhandledProps */])(Input, _this.props);

      var _partitionHTMLProps = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["z" /* partitionHTMLProps */])(unhandled),
          _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
          htmlInputProps = _partitionHTMLProps2[0],
          rest = _partitionHTMLProps2[1];

      return [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, htmlInputProps, {
        disabled: disabled,
        type: type,
        tabIndex: tabIndex,
        onChange: _this.handleChange,
        ref: _this.handleInputRef
      }), rest];
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Input, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          action = _props.action,
          actionPosition = _props.actionPosition,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          error = _props.error,
          fluid = _props.fluid,
          focus = _props.focus,
          icon = _props.icon,
          iconPosition = _props.iconPosition,
          input = _props.input,
          inverted = _props.inverted,
          label = _props.label,
          labelPosition = _props.labelPosition,
          loading = _props.loading,
          size = _props.size,
          transparent = _props.transparent,
          type = _props.type;


      var classes = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(focus, 'focus'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(transparent, 'transparent'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["F" /* useValueAndKey */])(actionPosition, 'action') || Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(action, 'action'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["F" /* useValueAndKey */])(iconPosition, 'icon') || Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(icon || loading, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_14__lib__["F" /* useValueAndKey */])(labelPosition, 'labeled') || Object(__WEBPACK_IMPORTED_MODULE_14__lib__["B" /* useKeyOnly */])(label, 'labeled'), 'input', className);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["q" /* getElementType */])(Input, this.props);

      var _partitionProps = this.partitionProps(),
          _partitionProps2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_partitionProps, 2),
          htmlInputProps = _partitionProps2[0],
          rest = _partitionProps2[1];

      // Render with children
      // ----------------------------------------


      if (!__WEBPACK_IMPORTED_MODULE_14__lib__["d" /* childrenUtils */].isNil(children)) {
        // add htmlInputProps to the `<input />` child
        var childElements = __WEBPACK_IMPORTED_MODULE_7_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_13_react__["Children"].toArray(children), function (child) {
          if (child.type !== 'input') return child;
          return Object(__WEBPACK_IMPORTED_MODULE_13_react__["cloneElement"])(child, _this2.handleChildOverrides(child, htmlInputProps));
        });

        return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
          childElements
        );
      }

      // Render Shorthand
      // ----------------------------------------
      var actionElement = __WEBPACK_IMPORTED_MODULE_15__elements_Button__["a" /* default */].create(action);
      var labelElement = __WEBPACK_IMPORTED_MODULE_17__elements_Label__["a" /* default */].create(label, {
        defaultProps: {
          className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()('label',
          // add 'left|right corner'
          __WEBPACK_IMPORTED_MODULE_6_lodash_includes___default()(labelPosition, 'corner') && labelPosition)
        }
      });

      return __WEBPACK_IMPORTED_MODULE_13_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
        actionPosition === 'left' && actionElement,
        labelPosition !== 'right' && labelElement,
        Object(__WEBPACK_IMPORTED_MODULE_14__lib__["h" /* createHTMLInput */])(input || type, { defaultProps: htmlInputProps }),
        actionPosition !== 'left' && actionElement,
        __WEBPACK_IMPORTED_MODULE_16__elements_Icon__["a" /* default */].create(this.computeIcon()),
        labelPosition === 'right' && labelElement
      );
    }
  }]);

  return Input;
}(__WEBPACK_IMPORTED_MODULE_13_react__["Component"]);

Input.defaultProps = {
  type: 'text'
};
Input._meta = {
  name: 'Input',
  type: __WEBPACK_IMPORTED_MODULE_14__lib__["b" /* META */].TYPES.ELEMENT
};
Input.handledProps = ['action', 'actionPosition', 'as', 'children', 'className', 'disabled', 'error', 'fluid', 'focus', 'icon', 'iconPosition', 'input', 'inverted', 'label', 'labelPosition', 'loading', 'onChange', 'size', 'tabIndex', 'transparent', 'type'];
Input.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An Input can be formatted to alert the user to an action they may perform. */
  action: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** An action can appear along side an Input on the left or right. */
  actionPosition: PropTypes.oneOf(['left']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** An Input field can show that it is disabled. */
  disabled: PropTypes.bool,

  /** An Input field can show the data contains errors. */
  error: PropTypes.bool,

  /** Take on the size of its container. */
  fluid: PropTypes.bool,

  /** An Input field can show a user is currently interacting with it. */
  focus: PropTypes.bool,

  /** Optional Icon to display inside the Input. */
  icon: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** An Icon can appear inside an Input on the left or right. */
  iconPosition: PropTypes.oneOf(['left']),

  /** Shorthand for creating the HTML Input. */
  input: customPropTypes.itemShorthand,

  /** Format to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Optional Label to display along side the Input. */
  label: customPropTypes.itemShorthand,

  /** A Label can appear outside an Input on the left or right. */
  labelPosition: PropTypes.oneOf(['left', 'right', 'left corner', 'right corner']),

  /** An Icon Input field can show that it is currently loading data. */
  loading: PropTypes.bool,

  /**
   * Called on change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onChange: PropTypes.func,

  /** An Input can vary in size. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** An Input can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Transparent Input has no background. */
  transparent: PropTypes.bool,

  /** The HTML input type. */
  type: PropTypes.string
} : {};


Input.create = Object(__WEBPACK_IMPORTED_MODULE_14__lib__["m" /* createShorthandFactory */])(Input, function (type) {
  return { type: type };
});

/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });



/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Message__["a"]; });



/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_Icon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MessageContent__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MessageHeader__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__MessageList__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MessageItem__ = __webpack_require__(205);



















/**
 * A message displays information that explains nearby content.
 * @see Form
 */

var Message = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Message, _Component);

  function Message() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Message);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Message.__proto__ || Object.getPrototypeOf(Message)).call.apply(_ref, [this].concat(args))), _this), _this.handleDismiss = function (e) {
      var onDismiss = _this.props.onDismiss;


      if (onDismiss) onDismiss(e, _this.props);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Message, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          attached = _props.attached,
          children = _props.children,
          className = _props.className,
          color = _props.color,
          compact = _props.compact,
          content = _props.content,
          error = _props.error,
          floating = _props.floating,
          header = _props.header,
          hidden = _props.hidden,
          icon = _props.icon,
          info = _props.info,
          list = _props.list,
          negative = _props.negative,
          onDismiss = _props.onDismiss,
          positive = _props.positive,
          size = _props.size,
          success = _props.success,
          visible = _props.visible,
          warning = _props.warning;


      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(floating, 'floating'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(hidden, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(icon, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(info, 'info'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(negative, 'negative'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(positive, 'positive'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(success, 'success'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(visible, 'visible'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["C" /* useKeyOrValueAndKey */])(attached, 'attached'), 'message', className);

      var dismissIcon = onDismiss && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_Icon__["a" /* default */], { name: 'close', onClick: this.handleDismiss });
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(Message, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(Message, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
          dismissIcon,
          children
        );
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
        dismissIcon,
        __WEBPACK_IMPORTED_MODULE_11__elements_Icon__["a" /* default */].create(icon),
        (!__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(header) || !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(content) || !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(list)) && __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__MessageContent__["a" /* default */],
          null,
          __WEBPACK_IMPORTED_MODULE_13__MessageHeader__["a" /* default */].create(header),
          __WEBPACK_IMPORTED_MODULE_14__MessageList__["a" /* default */].create(list),
          Object(__WEBPACK_IMPORTED_MODULE_10__lib__["j" /* createHTMLParagraph */])(content)
        )
      );
    }
  }]);

  return Message;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

Message._meta = {
  name: 'Message',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.COLLECTION
};
Message.Content = __WEBPACK_IMPORTED_MODULE_12__MessageContent__["a" /* default */];
Message.Header = __WEBPACK_IMPORTED_MODULE_13__MessageHeader__["a" /* default */];
Message.List = __WEBPACK_IMPORTED_MODULE_14__MessageList__["a" /* default */];
Message.Item = __WEBPACK_IMPORTED_MODULE_15__MessageItem__["a" /* default */];
Message.handledProps = ['as', 'attached', 'children', 'className', 'color', 'compact', 'content', 'error', 'floating', 'header', 'hidden', 'icon', 'info', 'list', 'negative', 'onDismiss', 'positive', 'size', 'success', 'visible', 'warning'];
/* harmony default export */ __webpack_exports__["a"] = (Message);
Message.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A message can be formatted to attach itself to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['bottom', 'top'])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A message can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A message can only take up the width of its content. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A message may be formatted to display a negative message. Same as `negative`. */
  error: PropTypes.bool,

  /** A message can float above content that it is related to. */
  floating: PropTypes.bool,

  /** Shorthand for MessageHeader. */
  header: customPropTypes.itemShorthand,

  /** A message can be hidden. */
  hidden: PropTypes.bool,

  /** A message can contain an icon. */
  icon: PropTypes.oneOfType([customPropTypes.itemShorthand, PropTypes.bool]),

  /** A message may be formatted to display information. */
  info: PropTypes.bool,

  /** Array shorthand items for the MessageList. Mutually exclusive with children. */
  list: customPropTypes.collectionShorthand,

  /** A message may be formatted to display a negative message. Same as `error`. */
  negative: PropTypes.bool,

  /**
   * A message that the user can choose to hide.
   * Called when the user clicks the "x" icon. This also adds the "x" icon.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onDismiss: PropTypes.func,

  /** A message may be formatted to display a positive message.  Same as `success`. */
  positive: PropTypes.bool,

  /** A message can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A message may be formatted to display a positive message.  Same as `positive`. */
  success: PropTypes.bool,

  /** A message can be set to visible to force itself to be shown. */
  visible: PropTypes.bool,

  /** A message may be formatted to display warning messages. */
  warning: PropTypes.bool
} : {};

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(801);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Table__["a"]; });



/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableBody__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableCell__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TableFooter__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableHeader__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableHeaderCell__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TableRow__ = __webpack_require__(391);
















/**
 * A table displays a collections of data grouped into rows.
 */
function Table(props) {
  var attached = props.attached,
      basic = props.basic,
      celled = props.celled,
      children = props.children,
      className = props.className,
      collapsing = props.collapsing,
      color = props.color,
      columns = props.columns,
      compact = props.compact,
      definition = props.definition,
      fixed = props.fixed,
      footerRow = props.footerRow,
      headerRow = props.headerRow,
      inverted = props.inverted,
      padded = props.padded,
      renderBodyRow = props.renderBodyRow,
      selectable = props.selectable,
      singleLine = props.singleLine,
      size = props.size,
      sortable = props.sortable,
      stackable = props.stackable,
      striped = props.striped,
      structured = props.structured,
      tableData = props.tableData,
      textAlign = props.textAlign,
      unstackable = props.unstackable,
      verticalAlign = props.verticalAlign;


  var classes = __WEBPACK_IMPORTED_MODULE_3_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(celled, 'celled'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(collapsing, 'collapsing'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(definition, 'definition'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(fixed, 'fixed'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(selectable, 'selectable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(singleLine, 'single line'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(sortable, 'sortable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(stackable, 'stackable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(striped, 'striped'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(structured, 'structured'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["B" /* useKeyOnly */])(unstackable, 'unstackable'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["C" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["C" /* useKeyOrValueAndKey */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["C" /* useKeyOrValueAndKey */])(compact, 'compact'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["C" /* useKeyOrValueAndKey */])(padded, 'padded'), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["E" /* useTextAlignProp */])(textAlign), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["G" /* useVerticalAlignProp */])(verticalAlign), Object(__WEBPACK_IMPORTED_MODULE_6__lib__["H" /* useWidthProp */])(columns, 'column'), 'table', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["r" /* getUnhandledProps */])(Table, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_6__lib__["q" /* getElementType */])(Table, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    headerRow && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(headerRow, { defaultProps: { cellAs: 'th' } })
    ),
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__TableBody__["a" /* default */],
      null,
      renderBodyRow && __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(tableData, function (data, index) {
        return __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(renderBodyRow(data, index));
      })
    ),
    footerRow && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__TableFooter__["a" /* default */],
      null,
      __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(footerRow)
    )
  );
}

Table.handledProps = ['as', 'attached', 'basic', 'celled', 'children', 'className', 'collapsing', 'color', 'columns', 'compact', 'definition', 'fixed', 'footerRow', 'headerRow', 'inverted', 'padded', 'renderBodyRow', 'selectable', 'singleLine', 'size', 'sortable', 'stackable', 'striped', 'structured', 'tableData', 'textAlign', 'unstackable', 'verticalAlign'];
Table._meta = {
  name: 'Table',
  type: __WEBPACK_IMPORTED_MODULE_6__lib__["b" /* META */].TYPES.COLLECTION
};

Table.defaultProps = {
  as: 'table'
};

Table.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Attach table to other content */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A table can reduce its complexity to increase readability. */
  basic: PropTypes.oneOfType([PropTypes.oneOf(['very']), PropTypes.bool]),

  /** A table may be divided each row into separate cells. */
  celled: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A table can be collapsing, taking up only as much space as its rows. */
  collapsing: PropTypes.bool,

  /** A table can be given a color to distinguish it from other tables. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A table can specify its column count to divide its content evenly. */
  columns: PropTypes.oneOf(SUI.WIDTHS),

  /** A table may sometimes need to be more compact to make more rows visible at a time. */
  compact: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A table may be formatted to emphasize a first column that defines a rows content. */
  definition: PropTypes.bool,

  /**
   * A table can use fixed a special faster form of table rendering that does not resize table cells based on content
   */
  fixed: PropTypes.bool,

  /** Shorthand for a TableRow to be placed within Table.Footer. */
  footerRow: customPropTypes.itemShorthand,

  /** Shorthand for a TableRow to be placed within Table.Header. */
  headerRow: customPropTypes.itemShorthand,

  /** A table's colors can be inverted. */
  inverted: PropTypes.bool,

  /** A table may sometimes need to be more padded for legibility. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /**
   * Mapped over `tableData` and should return shorthand for each Table.Row to be placed within Table.Body.
   *
   * @param {*} data - An element in the `tableData` array.
   * @param {number} index - The index of the current element in `tableData`.
   * @returns {*} Shorthand for a Table.Row.
   */
  renderBodyRow: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['tableData']), PropTypes.func]),

  /** A table can have its rows appear selectable. */
  selectable: PropTypes.bool,

  /** A table can specify that its cell contents should remain on a single line and not wrap. */
  singleLine: PropTypes.bool,

  /** A table can also be small or large. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive')),

  /** A table may allow a user to sort contents by clicking on a table header. */
  sortable: PropTypes.bool,

  /** A table can specify how it stacks table content responsively. */
  stackable: PropTypes.bool,

  /** A table can stripe alternate rows of content with a darker color to increase contrast. */
  striped: PropTypes.bool,

  /** A table can be formatted to display complex structured data. */
  structured: PropTypes.bool,

  /** Data to be passed to the renderBodyRow function. */
  tableData: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['renderBodyRow']), PropTypes.array]),

  /** A table can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table can specify how it stacks table content responsively. */
  unstackable: PropTypes.bool,

  /** A table can adjust its text alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};

Table.Body = __WEBPACK_IMPORTED_MODULE_7__TableBody__["a" /* default */];
Table.Cell = __WEBPACK_IMPORTED_MODULE_8__TableCell__["a" /* default */];
Table.Footer = __WEBPACK_IMPORTED_MODULE_9__TableFooter__["a" /* default */];
Table.Header = __WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */];
Table.HeaderCell = __WEBPACK_IMPORTED_MODULE_11__TableHeaderCell__["a" /* default */];
Table.Row = __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(803);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Container__["a"]; });



/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A container limits content to a maximum width.
 */
function Container(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      text = props.text,
      textAlign = props.textAlign;

  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(text, 'text'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["E" /* useTextAlignProp */])(textAlign), 'container', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(Container, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(Container, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

Container.handledProps = ['as', 'children', 'className', 'content', 'fluid', 'text', 'textAlign'];
Container._meta = {
  name: 'Container',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

Container.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Container has no maximum width. */
  fluid: PropTypes.bool,

  /** Reduce maximum width to more naturally accommodate text. */
  text: PropTypes.bool,

  /** Align container text. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Divider__ = __webpack_require__(805);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Divider__["a"]; });



/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A divider visually segments content into groups.
 */
function Divider(props) {
  var children = props.children,
      className = props.className,
      clearing = props.clearing,
      content = props.content,
      fitted = props.fitted,
      hidden = props.hidden,
      horizontal = props.horizontal,
      inverted = props.inverted,
      section = props.section,
      vertical = props.vertical;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(clearing, 'clearing'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(fitted, 'fitted'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(hidden, 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(section, 'section'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(vertical, 'vertical'), 'divider', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(Divider, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(Divider, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

Divider.handledProps = ['as', 'children', 'className', 'clearing', 'content', 'fitted', 'hidden', 'horizontal', 'inverted', 'section', 'vertical'];
Divider._meta = {
  name: 'Divider',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

Divider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Divider can clear the content above it. */
  clearing: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Divider can be fitted without any space above or below it. */
  fitted: PropTypes.bool,

  /** Divider can divide content without creating a dividing line. */
  hidden: PropTypes.bool,

  /** Divider can segment content horizontally. */
  horizontal: PropTypes.bool,

  /** Divider can have its colours inverted. */
  inverted: PropTypes.bool,

  /** Divider can provide greater margins to divide sections of content. */
  section: PropTypes.bool,

  /** Divider can segment content vertically. */
  vertical: PropTypes.bool
} : {};

/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(807);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Header__["a"]; });



/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Icon__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_Image__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HeaderContent__ = __webpack_require__(393);














/**
 * A header provides a short summary of content
 */
function Header(props) {
  var attached = props.attached,
      block = props.block,
      children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      disabled = props.disabled,
      dividing = props.dividing,
      floated = props.floated,
      icon = props.icon,
      image = props.image,
      inverted = props.inverted,
      size = props.size,
      sub = props.sub,
      subheader = props.subheader,
      textAlign = props.textAlign;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(block, 'block'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(dividing, 'dividing'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["F" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(icon === true, 'icon'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(image === true, 'image'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(sub, 'sub'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useKeyOrValueAndKey */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["E" /* useTextAlignProp */])(textAlign), 'header', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(Header, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(Header, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  var iconElement = __WEBPACK_IMPORTED_MODULE_6__elements_Icon__["a" /* default */].create(icon);
  var imageElement = __WEBPACK_IMPORTED_MODULE_7__elements_Image__["a" /* default */].create(image);
  var subheaderElement = __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__["a" /* default */].create(subheader);

  if (iconElement || imageElement) {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      iconElement || imageElement,
      (content || subheaderElement) && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__HeaderContent__["a" /* default */],
        null,
        content,
        subheaderElement
      )
    );
  }

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    content,
    subheaderElement
  );
}

Header.handledProps = ['as', 'attached', 'block', 'children', 'className', 'color', 'content', 'disabled', 'dividing', 'floated', 'icon', 'image', 'inverted', 'size', 'sub', 'subheader', 'textAlign'];
Header._meta = {
  name: 'Header',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.ELEMENT
};

Header.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Attach header  to other content, like a segment. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** Format header to appear inside a content block. */
  block: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the header. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Show that the header is inactive. */
  disabled: PropTypes.bool,

  /** Divide header from the content below it. */
  dividing: PropTypes.bool,

  /** Header can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Add an icon by icon name or pass an Icon. */
  icon: customPropTypes.every([customPropTypes.disallow(['image']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand])]),

  /** Add an image by img src or pass an Image. */
  image: customPropTypes.every([customPropTypes.disallow(['icon']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand])]),

  /** Inverts the color of the header for dark backgrounds. */
  inverted: PropTypes.bool,

  /** Content headings are sized with em and are based on the font-size of their container. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'mini')),

  /** Headers may be formatted to label smaller or de-emphasized content. */
  sub: PropTypes.bool,

  /** Shorthand for Header.Subheader. */
  subheader: customPropTypes.itemShorthand,

  /** Align header content. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS)
} : {};

Header.Content = __WEBPACK_IMPORTED_MODULE_9__HeaderContent__["a" /* default */];
Header.Subheader = __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(809);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });



/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ListContent__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ListDescription__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ListHeader__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ListIcon__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ListItem__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ListList__ = __webpack_require__(395);




















/**
 * A list groups related content.
 */

var List = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(List, _Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, itemProps) {
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(predefinedProps, 'onClick', e, itemProps);
          __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default()(_this.props, 'onItemClick', e, itemProps);
        }
      };
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(List, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animated = _props.animated,
          bulleted = _props.bulleted,
          celled = _props.celled,
          children = _props.children,
          className = _props.className,
          content = _props.content,
          divided = _props.divided,
          floated = _props.floated,
          horizontal = _props.horizontal,
          inverted = _props.inverted,
          items = _props.items,
          link = _props.link,
          ordered = _props.ordered,
          relaxed = _props.relaxed,
          selection = _props.selection,
          size = _props.size,
          verticalAlign = _props.verticalAlign;


      var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(animated, 'animated'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(bulleted, 'bulleted'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(celled, 'celled'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(divided, 'divided'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(horizontal, 'horizontal'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(link, 'link'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(ordered, 'ordered'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["B" /* useKeyOnly */])(selection, 'selection'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["C" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["F" /* useValueAndKey */])(floated, 'floated'), Object(__WEBPACK_IMPORTED_MODULE_10__lib__["G" /* useVerticalAlignProp */])(verticalAlign), 'list', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["r" /* getUnhandledProps */])(List, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* getElementType */])(List, this.props);

      if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(children)) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { role: 'list', className: classes }),
          children
        );
      }

      if (!__WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(content)) {
        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
          ElementType,
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { role: 'list', className: classes }),
          content
        );
      }

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { role: 'list', className: classes }),
        __WEBPACK_IMPORTED_MODULE_5_lodash_map___default()(items, function (item) {
          return __WEBPACK_IMPORTED_MODULE_15__ListItem__["a" /* default */].create(item, { overrideProps: _this2.handleItemOverrides });
        })
      );
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

List._meta = {
  name: 'List',
  type: __WEBPACK_IMPORTED_MODULE_10__lib__["b" /* META */].TYPES.ELEMENT
};
List.Content = __WEBPACK_IMPORTED_MODULE_11__ListContent__["a" /* default */];
List.Description = __WEBPACK_IMPORTED_MODULE_12__ListDescription__["a" /* default */];
List.Header = __WEBPACK_IMPORTED_MODULE_13__ListHeader__["a" /* default */];
List.Icon = __WEBPACK_IMPORTED_MODULE_14__ListIcon__["a" /* default */];
List.Item = __WEBPACK_IMPORTED_MODULE_15__ListItem__["a" /* default */];
List.List = __WEBPACK_IMPORTED_MODULE_16__ListList__["a" /* default */];
List.handledProps = ['animated', 'as', 'bulleted', 'celled', 'children', 'className', 'content', 'divided', 'floated', 'horizontal', 'inverted', 'items', 'link', 'onItemClick', 'ordered', 'relaxed', 'selection', 'size', 'verticalAlign'];
List.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A list can animate to set the current item apart from the list. */
  animated: PropTypes.bool,

  /** A list can mark items with a bullet. */
  bulleted: PropTypes.bool,

  /** A list can divide its items into cells. */
  celled: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A list can show divisions between content. */
  divided: PropTypes.bool,

  /** An list can be floated left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A list can be formatted to have items appear horizontally. */
  horizontal: PropTypes.bool,

  /** A list can be inverted to appear on a dark background. */
  inverted: PropTypes.bool,

  /** Shorthand array of props for ListItem. */
  items: customPropTypes.collectionShorthand,

  /** A list can be specially formatted for navigation links. */
  link: PropTypes.bool,

  /**
   * onClick handler for ListItem. Mutually exclusive with children.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onItemClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** A list can be ordered numerically. */
  ordered: PropTypes.bool,

  /** A list can relax its padding to provide more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A selection list formats list items as possible choices. */
  selection: PropTypes.bool,

  /** A list can vary in size. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};


/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(811);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader__["a"]; });



/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * A loader alerts a user to wait for an activity to complete.
 * @see Dimmer
 */
function Loader(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      disabled = props.disabled,
      indeterminate = props.indeterminate,
      inline = props.inline,
      inverted = props.inverted,
      size = props.size;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', size, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(indeterminate, 'indeterminate'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(children || content, 'text'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["C" /* useKeyOrValueAndKey */])(inline, 'inline'), 'loader', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(Loader, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(Loader, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

Loader.handledProps = ['active', 'as', 'children', 'className', 'content', 'disabled', 'indeterminate', 'inline', 'inverted', 'size'];
Loader._meta = {
  name: 'Loader',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

Loader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A loader can be active or visible. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A loader can be disabled or hidden. */
  disabled: PropTypes.bool,

  /** A loader can show it's unsure of how long a task will take. */
  indeterminate: PropTypes.bool,

  /** Loaders can appear inline with content. */
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['centered'])]),

  /** Loaders can have their colors inverted. */
  inverted: PropTypes.bool,

  /** Loaders can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES)
} : {};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rail__ = __webpack_require__(813);
/* unused harmony reexport default */



/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(2);









/**
 * A rail is used to show accompanying content outside the boundaries of the main view of a site.
 */
function Rail(props) {
  var attached = props.attached,
      children = props.children,
      className = props.className,
      close = props.close,
      content = props.content,
      dividing = props.dividing,
      internal = props.internal,
      position = props.position,
      size = props.size;


  var classes = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('ui', position, size, Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(attached, 'attached'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(dividing, 'dividing'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["B" /* useKeyOnly */])(internal, 'internal'), Object(__WEBPACK_IMPORTED_MODULE_5__lib__["C" /* useKeyOrValueAndKey */])(close, 'close'), 'rail', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["r" /* getUnhandledProps */])(Rail, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* getElementType */])(Rail, props);

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

Rail.handledProps = ['as', 'attached', 'children', 'className', 'close', 'content', 'dividing', 'internal', 'position', 'size'];
Rail._meta = {
  name: 'Rail',
  type: __WEBPACK_IMPORTED_MODULE_5__lib__["b" /* META */].TYPES.ELEMENT
};

Rail.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A rail can appear attached to the main viewport. */
  attached: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A rail can appear closer to the main viewport. */
  close: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A rail can create a division between itself and a container. */
  dividing: PropTypes.bool,

  /** A rail can attach itself to the inside of a container. */
  internal: PropTypes.bool,

  /** A rail can be presented on the left or right side of a container. */
  position: PropTypes.oneOf(SUI.FLOATS).isRequired,

  /** A rail can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};

/* unused harmony default export */ var _unused_webpack_default_export = (Rail);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Reveal__ = __webpack_require__(815);
/* unused harmony reexport default */



/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RevealContent__ = __webpack_require__(396);








/**
 * A reveal displays additional content in place of previous content when activated.
 */
function Reveal(props) {
  var active = props.active,
      animated = props.animated,
      children = props.children,
      className = props.className,
      content = props.content,
      disabled = props.disabled,
      instant = props.instant;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', animated, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(active, 'active'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(instant, 'instant'), 'reveal', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(Reveal, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(Reveal, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

Reveal.handledProps = ['active', 'animated', 'as', 'children', 'className', 'content', 'disabled', 'instant'];
Reveal._meta = {
  name: 'Reveal',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.ELEMENT
};

Reveal.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An active reveal displays its hidden content. */
  active: PropTypes.bool,

  /** An animation name that will be applied to Reveal. */
  animated: PropTypes.oneOf(['fade', 'small fade', 'move', 'move right', 'move up', 'move down', 'rotate', 'rotate left']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A disabled reveal will not animate when hovered. */
  disabled: PropTypes.bool,

  /** An element can show its content without delay. */
  instant: PropTypes.bool
} : {};

Reveal.Content = __WEBPACK_IMPORTED_MODULE_5__RevealContent__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Reveal);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Segment__ = __webpack_require__(397);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Segment__["a"]; });



/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Step__ = __webpack_require__(399);
/* unused harmony reexport default */



/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(38),
    baseIteratee = __webpack_require__(27),
    basePickBy = __webpack_require__(322),
    getAllKeysIn = __webpack_require__(320);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionContent__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccordionTitle__ = __webpack_require__(212);










/**
 * An accordion allows users to toggle the display of sections of content.
 */
function Accordion(props) {
  var className = props.className,
      fluid = props.fluid,
      inverted = props.inverted,
      styled = props.styled;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(styled, 'styled'), className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(Accordion, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }));
}

Accordion.handledProps = ['className', 'fluid', 'inverted', 'styled'];
Accordion._meta = {
  name: 'Accordion',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.MODULE
};

Accordion.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** Format to take up the width of its container. */
  fluid: PropTypes.bool,

  /** Format for dark backgrounds. */
  inverted: PropTypes.bool,

  /** Adds some basic styling to accordion panels. */
  styled: PropTypes.bool
} : {};

Accordion.Accordion = __WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__["a" /* default */];
Accordion.Content = __WEBPACK_IMPORTED_MODULE_6__AccordionContent__["a" /* default */];
Accordion.Title = __WEBPACK_IMPORTED_MODULE_7__AccordionTitle__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Embed__ = __webpack_require__(821);
/* unused harmony reexport default */



/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Icon__ = __webpack_require__(21);












/**
 * An embed displays content from other websites like YouTube videos or Google Maps.
 */

var Embed = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Embed, _Component);

  function Embed() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Embed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Embed.__proto__ || Object.getPrototypeOf(Embed)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var onClick = _this.props.onClick;
      var active = _this.state.active;


      if (onClick) onClick(e, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.props, { active: true }));
      if (!active) _this.trySetState({ active: true });
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Embed, [{
    key: 'getSrc',
    value: function getSrc() {
      var _props = this.props,
          _props$autoplay = _props.autoplay,
          autoplay = _props$autoplay === undefined ? true : _props$autoplay,
          _props$brandedUI = _props.brandedUI,
          brandedUI = _props$brandedUI === undefined ? false : _props$brandedUI,
          _props$color = _props.color,
          color = _props$color === undefined ? '#444444' : _props$color,
          _props$hd = _props.hd,
          hd = _props$hd === undefined ? true : _props$hd,
          id = _props.id,
          source = _props.source,
          url = _props.url;


      if (source === 'youtube') {
        return ['//www.youtube.com/embed/' + id, '?autohide=true', '&amp;autoplay=' + autoplay, '&amp;color=' + encodeURIComponent(color), '&amp;hq=' + hd, '&amp;jsapi=false', '&amp;modestbranding=' + brandedUI, '&amp;rel=' + (brandedUI ? 0 : 1)].join('');
      }

      if (source === 'vimeo') {
        return ['//player.vimeo.com/video/' + id, '?api=false', '&amp;autoplay=' + autoplay, '&amp;byline=false', '&amp;color=' + encodeURIComponent(color), '&amp;portrait=false', '&amp;title=false'].join('');
      }

      return url;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          aspectRatio = _props2.aspectRatio,
          className = _props2.className,
          icon = _props2.icon,
          placeholder = _props2.placeholder;
      var active = this.state.active;


      var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('ui', aspectRatio, Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(active, 'active'), 'embed', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["r" /* getUnhandledProps */])(Embed, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* getElementType */])(Embed, this.props);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, onClick: this.handleClick }),
        __WEBPACK_IMPORTED_MODULE_9__elements_Icon__["a" /* default */].create(icon),
        placeholder && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { className: 'placeholder', src: placeholder }),
        this.renderEmbed()
      );
    }
  }, {
    key: 'renderEmbed',
    value: function renderEmbed() {
      var _props3 = this.props,
          children = _props3.children,
          content = _props3.content,
          iframe = _props3.iframe,
          source = _props3.source;
      var active = this.state.active;


      if (!active) return null;
      if (!__WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'embed' },
        children
      );
      if (!__WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'embed' },
        content
      );

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: 'embed' },
        Object(__WEBPACK_IMPORTED_MODULE_8__lib__["f" /* createHTMLIframe */])(__WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(iframe) ? this.getSrc() : iframe, {
          defaultProps: {
            allowFullScreen: false,
            frameBorder: 0,
            height: '100%',
            scrolling: 'no',
            src: this.getSrc(),
            title: 'Embedded content from ' + source + '.',
            width: '100%'
          }
        })
      );
    }
  }]);

  return Embed;
}(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* AutoControlledComponent */]);

Embed.autoControlledProps = ['active'];
Embed.defaultProps = {
  icon: 'video play'
};
Embed._meta = {
  name: 'Embed',
  type: __WEBPACK_IMPORTED_MODULE_8__lib__["b" /* META */].TYPES.MODULE
};
Embed.handledProps = ['active', 'as', 'aspectRatio', 'autoplay', 'brandedUI', 'children', 'className', 'color', 'content', 'defaultActive', 'hd', 'icon', 'id', 'iframe', 'onClick', 'placeholder', 'source', 'url'];
/* unused harmony default export */ var _unused_webpack_default_export = (Embed);
Embed.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** An embed can be active. */
  active: PropTypes.bool,

  /** An embed can specify an alternative aspect ratio. */
  aspectRatio: PropTypes.oneOf(['4:3', '16:9', '21:9']),

  /** Setting to true or false will force autoplay. */
  autoplay: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Whether to show networks branded UI like title cards, or after video calls to action. */
  brandedUI: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Specifies a default chrome color with Vimeo or YouTube. */
  color: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.string]),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Initial value of active. */
  defaultActive: PropTypes.bool,

  /** Whether to prefer HD content. */
  hd: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Specifies an icon to use with placeholder content. */
  icon: customPropTypes.itemShorthand,

  /** Specifies an id for source. */
  id: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.string]),

  /** Shorthand for HTML iframe. */
  iframe: customPropTypes.every([customPropTypes.demand(['source']), customPropTypes.itemShorthand]),

  /**
   * Сalled on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onClick: PropTypes.func,

  /** A placeholder image for embed. */
  placeholder: PropTypes.string,

  /** Specifies a source to use. */
  source: customPropTypes.every([customPropTypes.disallow(['sourceUrl']), PropTypes.oneOf(['youtube', 'vimeo'])]),

  /** Specifies a url to use for embed. */
  url: customPropTypes.every([customPropTypes.disallow(['source']), PropTypes.string])
} : {};

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popup__ = __webpack_require__(823);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popup__["a"]; });



/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export POSITIONS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reduce__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_assign__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isNumber__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__addons_Portal__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__PopupContent__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__PopupHeader__ = __webpack_require__(404);
























var POSITIONS = ['top left', 'top right', 'bottom right', 'bottom left', 'right center', 'left center', 'top center', 'bottom center'];

/**
 * A Popup displays additional information on top of a page.
 */

var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Popup.__proto__ || Object.getPrototypeOf(Popup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.hideOnScroll = function (e) {
      _this.setState({ closed: true });

      __WEBPACK_IMPORTED_MODULE_17__lib__["o" /* eventStack */].unsub('scroll', _this.hideOnScroll, { target: window });
      setTimeout(function () {
        return _this.setState({ closed: false });
      }, 50);

      _this.handleClose(e);
    }, _this.handleClose = function (e) {

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onClose', e, _this.props);
    }, _this.handleOpen = function (e) {
      _this.coords = e.currentTarget.getBoundingClientRect();

      var onOpen = _this.props.onOpen;

      if (onOpen) onOpen(e, _this.props);
    }, _this.handlePortalMount = function (e) {
      var hideOnScroll = _this.props.hideOnScroll;


      if (hideOnScroll) __WEBPACK_IMPORTED_MODULE_17__lib__["o" /* eventStack */].sub('scroll', _this.hideOnScroll, { target: window });
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onMount', e, _this.props);
    }, _this.handlePortalUnmount = function (e) {
      var hideOnScroll = _this.props.hideOnScroll;


      if (hideOnScroll) __WEBPACK_IMPORTED_MODULE_17__lib__["o" /* eventStack */].unsub('scroll', _this.hideOnScroll, { target: window });
      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onUnmount', e, _this.props);
    }, _this.handlePopupRef = function (popupRef) {
      _this.popupCoords = popupRef ? popupRef.getBoundingClientRect() : null;
      _this.setPopupStyle();
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Popup, [{
    key: 'computePopupStyle',
    value: function computePopupStyle(positions) {
      var style = { position: 'absolute'

        // Do not access window/document when server side rendering
      };if (!Object(__WEBPACK_IMPORTED_MODULE_17__lib__["t" /* isBrowser */])()) return style;

      var _props = this.props,
          horizontalOffset = _props.horizontalOffset,
          verticalOffset = _props.verticalOffset;
      var _window = window,
          pageYOffset = _window.pageYOffset,
          pageXOffset = _window.pageXOffset;
      var _document$documentEle = document.documentElement,
          clientWidth = _document$documentEle.clientWidth,
          clientHeight = _document$documentEle.clientHeight;


      if (__WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(positions, 'right')) {
        style.right = Math.round(clientWidth - (this.coords.right + pageXOffset));
        style.left = 'auto';
      } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(positions, 'left')) {
        style.left = Math.round(this.coords.left + pageXOffset);
        style.right = 'auto';
      } else {
        // if not left nor right, we are horizontally centering the element
        var xOffset = (this.coords.width - this.popupCoords.width) / 2;
        style.left = Math.round(this.coords.left + xOffset + pageXOffset);
        style.right = 'auto';
      }

      if (__WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(positions, 'top')) {
        style.bottom = Math.round(clientHeight - (this.coords.top + pageYOffset));
        style.top = 'auto';
      } else if (__WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(positions, 'bottom')) {
        style.top = Math.round(this.coords.bottom + pageYOffset);
        style.bottom = 'auto';
      } else {
        // if not top nor bottom, we are vertically centering the element
        var yOffset = (this.coords.height + this.popupCoords.height) / 2;
        style.top = Math.round(this.coords.bottom + pageYOffset - yOffset);
        style.bottom = 'auto';

        var _xOffset = this.popupCoords.width + 8;
        if (__WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(positions, 'right')) {
          style.right -= _xOffset;
        } else {
          style.left -= _xOffset;
        }
      }

      if (horizontalOffset) {
        if (__WEBPACK_IMPORTED_MODULE_11_lodash_isNumber___default()(style.right)) {
          style.right -= horizontalOffset;
        } else {
          style.left -= horizontalOffset;
        }
      }

      if (verticalOffset) {
        if (__WEBPACK_IMPORTED_MODULE_11_lodash_isNumber___default()(style.top)) {
          style.top += verticalOffset;
        } else {
          style.bottom += verticalOffset;
        }
      }

      return style;
    }

    // check if the style would display
    // the popup outside of the view port

  }, {
    key: 'isStyleInViewport',
    value: function isStyleInViewport(style) {
      var _window2 = window,
          pageYOffset = _window2.pageYOffset,
          pageXOffset = _window2.pageXOffset;
      var _document$documentEle2 = document.documentElement,
          clientWidth = _document$documentEle2.clientWidth,
          clientHeight = _document$documentEle2.clientHeight;


      var element = {
        top: style.top,
        left: style.left,
        width: this.popupCoords.width,
        height: this.popupCoords.height
      };
      if (__WEBPACK_IMPORTED_MODULE_11_lodash_isNumber___default()(style.right)) {
        element.left = clientWidth - style.right - element.width;
      }
      if (__WEBPACK_IMPORTED_MODULE_11_lodash_isNumber___default()(style.bottom)) {
        element.top = clientHeight - style.bottom - element.height;
      }

      // hidden on top
      if (element.top < pageYOffset) return false;
      // hidden on the bottom
      if (element.top + element.height > pageYOffset + clientHeight) return false;
      // hidden the left
      if (element.left < pageXOffset) return false;
      // hidden on the right
      if (element.left + element.width > pageXOffset + clientWidth) return false;

      return true;
    }
  }, {
    key: 'setPopupStyle',
    value: function setPopupStyle() {
      if (!this.coords || !this.popupCoords) return;
      var position = this.props.position;
      var style = this.computePopupStyle(position);
      var keepInViewPort = this.props.keepInViewPort;


      if (keepInViewPort) {
        // Lets detect if the popup is out of the viewport and adjust
        // the position accordingly
        var positions = __WEBPACK_IMPORTED_MODULE_13_lodash_without___default()(POSITIONS, position).concat([position]);
        for (var i = 0; !this.isStyleInViewport(style) && i < positions.length; i += 1) {
          style = this.computePopupStyle(positions[i]);
          position = positions[i];
        }
      }

      // Append 'px' to every numerical values in the style
      style = __WEBPACK_IMPORTED_MODULE_10_lodash_mapValues___default()(style, function (value) {
        return __WEBPACK_IMPORTED_MODULE_11_lodash_isNumber___default()(value) ? value + 'px' : value;
      });
      this.setState({ style: style, position: position });
    }
  }, {
    key: 'getPortalProps',
    value: function getPortalProps() {
      var portalProps = {};

      var _props2 = this.props,
          on = _props2.on,
          hoverable = _props2.hoverable;

      var normalizedOn = __WEBPACK_IMPORTED_MODULE_9_lodash_isArray___default()(on) ? on : [on];

      if (hoverable) {
        portalProps.closeOnPortalMouseLeave = true;
        portalProps.mouseLeaveDelay = 300;
      }
      if (__WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(normalizedOn, 'click')) {
        portalProps.openOnTriggerClick = true;
        portalProps.closeOnTriggerClick = true;
        portalProps.closeOnDocumentClick = true;
      }
      if (__WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(normalizedOn, 'focus')) {
        portalProps.openOnTriggerFocus = true;
        portalProps.closeOnTriggerBlur = true;
      }
      if (__WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(normalizedOn, 'hover')) {
        portalProps.openOnTriggerMouseEnter = true;
        portalProps.closeOnTriggerMouseLeave = true;
        // Taken from SUI: https://git.io/vPmCm
        portalProps.mouseLeaveDelay = 70;
        portalProps.mouseEnterDelay = 50;
      }

      return portalProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          basic = _props3.basic,
          children = _props3.children,
          className = _props3.className,
          content = _props3.content,
          flowing = _props3.flowing,
          header = _props3.header,
          inverted = _props3.inverted,
          size = _props3.size,
          trigger = _props3.trigger,
          wide = _props3.wide;
      var _state = this.state,
          position = _state.position,
          closed = _state.closed;

      var style = __WEBPACK_IMPORTED_MODULE_7_lodash_assign___default()({}, this.state.style, this.props.style);
      var classes = __WEBPACK_IMPORTED_MODULE_14_classnames___default()('ui', position, size, Object(__WEBPACK_IMPORTED_MODULE_17__lib__["C" /* useKeyOrValueAndKey */])(wide, 'wide'), Object(__WEBPACK_IMPORTED_MODULE_17__lib__["B" /* useKeyOnly */])(basic, 'basic'), Object(__WEBPACK_IMPORTED_MODULE_17__lib__["B" /* useKeyOnly */])(flowing, 'flowing'), Object(__WEBPACK_IMPORTED_MODULE_17__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), 'popup transition visible', className);

      if (closed) return trigger;

      var unhandled = Object(__WEBPACK_IMPORTED_MODULE_17__lib__["r" /* getUnhandledProps */])(Popup, this.props);
      var portalPropNames = __WEBPACK_IMPORTED_MODULE_18__addons_Portal__["a" /* default */].handledProps;

      var rest = __WEBPACK_IMPORTED_MODULE_6_lodash_reduce___default()(unhandled, function (acc, val, key) {
        if (!__WEBPACK_IMPORTED_MODULE_12_lodash_includes___default()(portalPropNames, key)) acc[key] = val;

        return acc;
      }, {});
      var portalProps = __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default()(unhandled, portalPropNames);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_17__lib__["q" /* getElementType */])(Popup, this.props);

      var popupJSX = __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, style: style, ref: this.handlePopupRef }),
        children,
        __WEBPACK_IMPORTED_MODULE_17__lib__["d" /* childrenUtils */].isNil(children) && __WEBPACK_IMPORTED_MODULE_20__PopupHeader__["a" /* default */].create(header),
        __WEBPACK_IMPORTED_MODULE_17__lib__["d" /* childrenUtils */].isNil(children) && __WEBPACK_IMPORTED_MODULE_19__PopupContent__["a" /* default */].create(content)
      );

      var mergedPortalProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getPortalProps(), portalProps);


      return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_18__addons_Portal__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mergedPortalProps, {
          trigger: trigger,
          onClose: this.handleClose,
          onMount: this.handlePortalMount,
          onOpen: this.handleOpen,
          onUnmount: this.handlePortalUnmount
        }),
        popupJSX
      );
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_16_react__["Component"]);

Popup.defaultProps = {
  position: 'top left',
  on: 'hover',
  keepInViewPort: true
};
Popup._meta = {
  name: 'Popup',
  type: __WEBPACK_IMPORTED_MODULE_17__lib__["b" /* META */].TYPES.MODULE
};
Popup.Content = __WEBPACK_IMPORTED_MODULE_19__PopupContent__["a" /* default */];
Popup.Header = __WEBPACK_IMPORTED_MODULE_20__PopupHeader__["a" /* default */];
Popup.handledProps = ['as', 'basic', 'children', 'className', 'content', 'flowing', 'header', 'hideOnScroll', 'horizontalOffset', 'hoverable', 'inverted', 'keepInViewPort', 'on', 'onClose', 'onMount', 'onOpen', 'onUnmount', 'position', 'size', 'style', 'trigger', 'verticalOffset', 'wide'];
/* harmony default export */ __webpack_exports__["a"] = (Popup);
Popup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Display the popup without the pointing arrow. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Simple text content for the popover. */
  content: customPropTypes.itemShorthand,

  /** A flowing Popup has no maximum width and continues to flow to fit its content. */
  flowing: PropTypes.bool,

  /** Takes up the entire width of its offset container. */
  // TODO: implement the Popup fluid layout
  // fluid: PropTypes.bool,

  /** Header displayed above the content in bold. */
  header: customPropTypes.itemShorthand,

  /** Hide the Popup when scrolling the window. */
  hideOnScroll: PropTypes.bool,

  /** Whether the popup should not close on hover. */
  hoverable: PropTypes.bool,

  /** Invert the colors of the Popup. */
  inverted: PropTypes.bool,

  /** Horizontal offset in pixels to be applied to the Popup. */
  horizontalOffset: PropTypes.number,

  /** Vertical offset in pixels to be applied to the Popup. */
  verticalOffset: PropTypes.number,

  /** Events triggering the popup. */
  on: PropTypes.oneOfType([PropTypes.oneOf(['hover', 'click', 'focus']), PropTypes.arrayOf(PropTypes.oneOf(['hover', 'click', 'focus']))]),

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Position for the popover. */
  position: PropTypes.oneOf(POSITIONS),

  /** Popup size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big', 'massive')),

  /** Custom Popup style. */
  style: PropTypes.object,

  /** Element to be rendered in-place where the popup is defined. */
  trigger: PropTypes.node,

  /** Popup width. */
  wide: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Element to be rendered within the confines of the viewport whenever possible. */
  keepInViewPort: PropTypes.bool
} : {};

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(130),
    copyObject = __webpack_require__(93),
    createAssigner = __webpack_require__(825),
    isArrayLike = __webpack_require__(28),
    isPrototype = __webpack_require__(88),
    keys = __webpack_require__(26);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(52),
    isIterateeCall = __webpack_require__(75);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Progress__ = __webpack_require__(827);
/* unused harmony reexport default */



/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_round__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_round___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_round__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_clamp__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib__ = __webpack_require__(2);
















/**
 * A progress bar shows the progression of a task.
 */

var Progress = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Progress, _Component);

  function Progress() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Progress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Progress.__proto__ || Object.getPrototypeOf(Progress)).call.apply(_ref, [this].concat(args))), _this), _this.calculatePercent = function () {
      var _this$props = _this.props,
          percent = _this$props.percent,
          total = _this$props.total,
          value = _this$props.value;


      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default()(percent)) return percent;
      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default()(total) && !__WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default()(value)) return value / total * 100;
    }, _this.computeValueText = function (percent) {
      var _this$props2 = _this.props,
          progress = _this$props2.progress,
          total = _this$props2.total,
          value = _this$props2.value;


      if (progress === 'value') return value;
      if (progress === 'ratio') return value + '/' + total;
      return percent + '%';
    }, _this.getPercent = function () {
      var _this$props3 = _this.props,
          precision = _this$props3.precision,
          progress = _this$props3.progress,
          total = _this$props3.total,
          value = _this$props3.value;

      var percent = __WEBPACK_IMPORTED_MODULE_6_lodash_clamp___default()(_this.calculatePercent(), 0, 100);
      if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default()(total) && !__WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default()(value) && progress === 'value') return value / total * 100;
      if (progress === 'value') return value;
      if (__WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default()(precision)) return percent;
      return __WEBPACK_IMPORTED_MODULE_5_lodash_round___default()(percent, precision);
    }, _this.isAutoSuccess = function () {
      var _this$props4 = _this.props,
          autoSuccess = _this$props4.autoSuccess,
          percent = _this$props4.percent,
          total = _this$props4.total,
          value = _this$props4.value;


      return autoSuccess && (percent >= 100 || value >= total);
    }, _this.renderLabel = function () {
      var _this$props5 = _this.props,
          children = _this$props5.children,
          content = _this$props5.content,
          label = _this$props5.label;


      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(children)) return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
        'div',
        { className: 'label' },
        children
      );
      if (!__WEBPACK_IMPORTED_MODULE_12__lib__["d" /* childrenUtils */].isNil(content)) return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
        'div',
        { className: 'label' },
        content
      );
      return Object(__WEBPACK_IMPORTED_MODULE_12__lib__["e" /* createHTMLDivision */])(label, { defaultProps: { className: 'label' } });
    }, _this.renderProgress = function (percent) {
      var _this$props6 = _this.props,
          precision = _this$props6.precision,
          progress = _this$props6.progress;


      if (!progress && __WEBPACK_IMPORTED_MODULE_7_lodash_isUndefined___default()(precision)) return;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
        'div',
        { className: 'progress' },
        _this.computeValueText(percent)
      );
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Progress, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          attached = _props.attached,
          className = _props.className,
          color = _props.color,
          disabled = _props.disabled,
          error = _props.error,
          indicating = _props.indicating,
          inverted = _props.inverted,
          size = _props.size,
          success = _props.success,
          warning = _props.warning;


      var classes = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('ui', color, size, Object(__WEBPACK_IMPORTED_MODULE_12__lib__["B" /* useKeyOnly */])(active || indicating, 'active'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["B" /* useKeyOnly */])(error, 'error'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["B" /* useKeyOnly */])(indicating, 'indicating'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["B" /* useKeyOnly */])(inverted, 'inverted'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["B" /* useKeyOnly */])(success || this.isAutoSuccess(), 'success'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["B" /* useKeyOnly */])(warning, 'warning'), Object(__WEBPACK_IMPORTED_MODULE_12__lib__["F" /* useValueAndKey */])(attached, 'attached'), 'progress', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["r" /* getUnhandledProps */])(Progress, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_12__lib__["q" /* getElementType */])(Progress, this.props);
      var percent = this.getPercent();

      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, 'data-percent': Math.floor(percent) }),
        __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(
          'div',
          { className: 'bar', style: { width: percent + '%' } },
          this.renderProgress(percent)
        ),
        this.renderLabel()
      );
    }
  }]);

  return Progress;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Progress._meta = {
  name: 'Progress',
  type: __WEBPACK_IMPORTED_MODULE_12__lib__["b" /* META */].TYPES.MODULE
};
Progress.handledProps = ['active', 'as', 'attached', 'autoSuccess', 'children', 'className', 'color', 'content', 'disabled', 'error', 'indicating', 'inverted', 'label', 'percent', 'precision', 'progress', 'size', 'success', 'total', 'value', 'warning'];
Progress.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A progress bar can show activity. */
  active: PropTypes.bool,

  /** A progress bar can attach to and show the progress of an element (i.e. Card or Segment). */
  attached: PropTypes.oneOf(['top', 'bottom']),

  /** Whether success state should automatically trigger when progress completes. */
  autoSuccess: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A progress bar can have different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A progress bar be disabled. */
  disabled: PropTypes.bool,

  /** A progress bar can show a error state. */
  error: PropTypes.bool,

  /** An indicating progress bar visually indicates the current level of progress of a task. */
  indicating: PropTypes.bool,

  /** A progress bar can have its colors inverted. */
  inverted: PropTypes.bool,

  /** Can be set to either to display progress as percent or ratio. */
  label: customPropTypes.itemShorthand,

  /** Current percent complete. */
  percent: customPropTypes.every([customPropTypes.disallow(['total', 'value']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** Decimal point precision for calculated progress. */
  precision: PropTypes.number,

  /** A progress bar can contain a text value indicating current progress. */
  progress: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['percent', 'ratio', 'value'])]),

  /** A progress bar can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'huge', 'massive')),

  /** A progress bar can show a success state. */
  success: PropTypes.bool,

  /** For use with value. Together, these will calculate the percent. Mutually excludes percent. */
  total: customPropTypes.every([customPropTypes.demand(['value']), customPropTypes.disallow(['percent']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** For use with total. Together, these will calculate the percent. Mutually excludes percent. */
  value: customPropTypes.every([customPropTypes.disallow(['percent']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** A progress bar can show a warning state. */
  warning: PropTypes.bool
} : {};


/* unused harmony default export */ var _unused_webpack_default_export = (Progress);

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__(829);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(23),
    toInteger = __webpack_require__(40),
    toNumber = __webpack_require__(118),
    toString = __webpack_require__(37);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(282),
    toNumber = __webpack_require__(118);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rating__ = __webpack_require__(832);
/* unused harmony reexport default */



/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_times__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_times___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_times__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RatingIcon__ = __webpack_require__(405);
















/**
 * A rating indicates user interest in content.
 */

var Rating = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Rating, _Component);

  function Rating() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Rating);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Rating.__proto__ || Object.getPrototypeOf(Rating)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Rating, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          icon = _props.icon,
          maxRating = _props.maxRating,
          size = _props.size;
      var _state = this.state,
          rating = _state.rating,
          selectedIndex = _state.selectedIndex,
          isSelecting = _state.isSelecting;


      var classes = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ui', icon, size, Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(disabled, 'disabled'), Object(__WEBPACK_IMPORTED_MODULE_11__lib__["B" /* useKeyOnly */])(isSelecting && !disabled && selectedIndex >= 0, 'selected'), 'rating', className);
      var rest = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["r" /* getUnhandledProps */])(Rating, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["q" /* getElementType */])(Rating, this.props);

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, role: 'radiogroup', onMouseLeave: this.handleMouseLeave }),
        __WEBPACK_IMPORTED_MODULE_5_lodash_times___default()(maxRating, function (i) {
          return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RatingIcon__["a" /* default */], {
            active: rating >= i + 1,
            'aria-checked': rating === i + 1,
            'aria-posinset': i + 1,
            'aria-setsize': maxRating,
            index: i,
            key: i,
            onClick: _this2.handleIconClick,
            onMouseEnter: _this2.handleIconMouseEnter,
            selected: selectedIndex >= i && isSelecting
          });
        })
      );
    }
  }]);

  return Rating;
}(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* AutoControlledComponent */]);

Rating.autoControlledProps = ['rating'];
Rating.defaultProps = {
  clearable: 'auto',
  maxRating: 1
};
Rating._meta = {
  name: 'Rating',
  type: __WEBPACK_IMPORTED_MODULE_11__lib__["b" /* META */].TYPES.MODULE
};
Rating.Icon = __WEBPACK_IMPORTED_MODULE_12__RatingIcon__["a" /* default */];
Rating.handledProps = ['as', 'className', 'clearable', 'defaultRating', 'disabled', 'icon', 'maxRating', 'onRate', 'rating', 'size'];

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleIconClick = function (e, _ref2) {
    var index = _ref2.index;
    var _props2 = _this3.props,
        clearable = _props2.clearable,
        disabled = _props2.disabled,
        maxRating = _props2.maxRating,
        onRate = _props2.onRate;
    var rating = _this3.state.rating;

    if (disabled) return;

    // default newRating is the clicked icon
    // allow toggling a binary rating
    // allow clearing ratings
    var newRating = index + 1;
    if (clearable === 'auto' && maxRating === 1) {
      newRating = +!rating;
    } else if (clearable === true && newRating === rating) {
      newRating = 0;
    }

    // set rating
    _this3.trySetState({ rating: newRating }, { isSelecting: false });
    if (onRate) onRate(e, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.props, { rating: newRating }));
  };

  this.handleIconMouseEnter = function (e, _ref3) {
    var index = _ref3.index;

    if (_this3.props.disabled) return;

    _this3.setState({ selectedIndex: index, isSelecting: true });
  };

  this.handleMouseLeave = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    __WEBPACK_IMPORTED_MODULE_6_lodash_invoke___default.a.apply(undefined, [_this3.props, 'onMouseLeave'].concat(args));

    if (_this3.props.disabled) return;

    _this3.setState({ selectedIndex: -1, isSelecting: false });
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (Rating);
Rating.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Additional classes. */
  className: PropTypes.string,

  /**
   * You can clear the rating by clicking on the current start rating.
   * By default a rating will be only clearable if there is 1 icon.
   * Setting to `true`/`false` will allow or disallow a user to clear their rating.
   */
  clearable: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['auto'])]),

  /** The initial rating value. */
  defaultRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** You can disable or enable interactive rating.  Makes a read-only rating. */
  disabled: PropTypes.bool,

  /** A rating can use a set of star or heart icons. */
  icon: PropTypes.oneOf(['star', 'heart']),

  /** The total number of icons. */
  maxRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called after user selects a new rating.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed rating.
   */
  onRate: PropTypes.func,

  /** The current number of active icons. */
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A progress bar can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big'))
} : {};

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(834);
/* unused harmony reexport default */



/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_partialRight__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_partialRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_partialRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_inRange__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_inRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_inRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_reduce__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__elements_Input__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__SearchCategory__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SearchResult__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SearchResults__ = __webpack_require__(408);



























/**
 * A search module allows a user to query for results from a selection of data
 */
var Search = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Search, _Component);

  function Search() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Search.__proto__ || Object.getPrototypeOf(Search)).call.apply(_ref, [this].concat(args))), _this), _this.handleResultSelect = function (e, result) {

      __WEBPACK_IMPORTED_MODULE_14_lodash_invoke___default()(_this.props, 'onResultSelect', e, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.props, { result: result }));
    }, _this.handleSelectionChange = function (e) {

      var result = _this.getSelectedResult();
      __WEBPACK_IMPORTED_MODULE_14_lodash_invoke___default()(_this.props, 'onSelectionChange', e, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.props, { result: result }));
    }, _this.closeOnEscape = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_19__lib__["u" /* keyboardKey */].getCode(e) !== __WEBPACK_IMPORTED_MODULE_19__lib__["u" /* keyboardKey */].Escape) return;
      e.preventDefault();
      _this.close();
    }, _this.moveSelectionOnKeyDown = function (e) {
      switch (__WEBPACK_IMPORTED_MODULE_19__lib__["u" /* keyboardKey */].getCode(e)) {
        case __WEBPACK_IMPORTED_MODULE_19__lib__["u" /* keyboardKey */].ArrowDown:
          e.preventDefault();
          _this.moveSelectionBy(e, 1);
          break;
        case __WEBPACK_IMPORTED_MODULE_19__lib__["u" /* keyboardKey */].ArrowUp:
          e.preventDefault();
          _this.moveSelectionBy(e, -1);
          break;
        default:
          break;
      }
    }, _this.selectItemOnEnter = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_19__lib__["u" /* keyboardKey */].getCode(e) !== __WEBPACK_IMPORTED_MODULE_19__lib__["u" /* keyboardKey */].Enter) return;

      var result = _this.getSelectedResult();

      // prevent selecting null if there was no selected item value
      if (!result) return;

      e.preventDefault();

      // notify the onResultSelect prop that the user is trying to change value
      _this.setValue(result.title);
      _this.handleResultSelect(e, result);
      _this.close();
    }, _this.closeOnDocumentClick = function (e) {
      _this.close();
    }, _this.handleMouseDown = function (e) {

      _this.isMouseDown = true;
      __WEBPACK_IMPORTED_MODULE_14_lodash_invoke___default()(_this.props, 'onMouseDown', e, _this.props);
      __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].sub('mouseup', _this.handleDocumentMouseUp);
    }, _this.handleDocumentMouseUp = function () {

      _this.isMouseDown = false;
      __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].unsub('mouseup', _this.handleDocumentMouseUp);
    }, _this.handleInputClick = function (e) {

      // prevent closeOnDocumentClick()
      e.nativeEvent.stopImmediatePropagation();

      _this.tryOpen();
    }, _this.handleItemClick = function (e, _ref2) {
      var id = _ref2.id;

      var result = _this.getSelectedResult(id);

      // prevent closeOnDocumentClick()
      e.nativeEvent.stopImmediatePropagation();

      // notify the onResultSelect prop that the user is trying to change value
      _this.setValue(result.title);
      _this.handleResultSelect(e, result);
      _this.close();
    }, _this.handleFocus = function (e) {
      var onFocus = _this.props.onFocus;

      if (onFocus) onFocus(e, _this.props);
      _this.setState({ focus: true });
    }, _this.handleBlur = function (e) {
      var onBlur = _this.props.onBlur;

      if (onBlur) onBlur(e, _this.props);
      _this.setState({ focus: false });
    }, _this.handleSearchChange = function (e) {
      // prevent propagating to this.props.onChange()
      e.stopPropagation();
      var minCharacters = _this.props.minCharacters;
      var open = _this.state.open;

      var newQuery = e.target.value;

      __WEBPACK_IMPORTED_MODULE_14_lodash_invoke___default()(_this.props, 'onSearchChange', e, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.props, { value: newQuery }));

      // open search dropdown on search query
      if (newQuery.length < minCharacters) {
        _this.close();
      } else if (!open) {
        _this.tryOpen(newQuery);
      }

      _this.setValue(newQuery);
    }, _this.getFlattenedResults = function () {
      var _this$props = _this.props,
          category = _this$props.category,
          results = _this$props.results;


      return !category ? results : __WEBPACK_IMPORTED_MODULE_13_lodash_reduce___default()(results, function (memo, categoryData) {
        return memo.concat(categoryData.results);
      }, []);
    }, _this.getSelectedResult = function () {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.selectedIndex;

      var results = _this.getFlattenedResults();
      return __WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(results, index);
    }, _this.setValue = function (value) {
      var selectFirstResult = _this.props.selectFirstResult;


      _this.trySetState({ value: value }, { selectedIndex: selectFirstResult ? 0 : -1 });
    }, _this.moveSelectionBy = function (e, offset) {
      var selectedIndex = _this.state.selectedIndex;


      var results = _this.getFlattenedResults();
      var lastIndex = results.length - 1;

      // next is after last, wrap to beginning
      // next is before first, wrap to end
      var nextIndex = selectedIndex + offset;
      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;

      _this.setState({ selectedIndex: nextIndex });
      _this.scrollSelectedItemIntoView();
      _this.handleSelectionChange(e);
    }, _this.scrollSelectedItemIntoView = function () {
      // Do not access document when server side rendering
      if (!Object(__WEBPACK_IMPORTED_MODULE_19__lib__["t" /* isBrowser */])()) return;
      var menu = document.querySelector('.ui.search.active.visible .results.visible');
      var item = menu.querySelector('.result.active');
      if (!item) return;

      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;

      if (isOutOfUpperView) {
        menu.scrollTop = item.offsetTop;
      } else if (isOutOfLowerView) {
        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
      }
    }, _this.tryOpen = function () {
      var currentValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var minCharacters = _this.props.minCharacters;

      if (currentValue.length < minCharacters) return;

      _this.open();
    }, _this.open = function () {
      _this.trySetState({ open: true });
    }, _this.close = function () {
      _this.trySetState({ open: false });
    }, _this.renderSearchInput = function (rest) {
      var _this$props2 = _this.props,
          icon = _this$props2.icon,
          input = _this$props2.input;
      var value = _this.state.value;


      return __WEBPACK_IMPORTED_MODULE_20__elements_Input__["a" /* default */].create(input, { defaultProps: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, rest, {
          icon: icon,
          input: { className: 'prompt', tabIndex: '0', autoComplete: 'off' },
          onChange: _this.handleSearchChange,
          onClick: _this.handleInputClick,
          value: value
        }) });
    }, _this.renderNoResults = function () {
      var _this$props3 = _this.props,
          noResultsDescription = _this$props3.noResultsDescription,
          noResultsMessage = _this$props3.noResultsMessage;


      return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
        'div',
        { className: 'message empty' },
        __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
          'div',
          { className: 'header' },
          noResultsMessage
        ),
        noResultsDescription && __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
          'div',
          { className: 'description' },
          noResultsDescription
        )
      );
    }, _this.renderResult = function (_ref3, index, _array) {
      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      var childKey = _ref3.childKey,
          result = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['childKey']);

      var resultRenderer = _this.props.resultRenderer;
      var selectedIndex = _this.state.selectedIndex;

      var offsetIndex = index + offset;

      return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__SearchResult__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        key: childKey || result.title,
        active: selectedIndex === offsetIndex,
        onClick: _this.handleItemClick,
        renderer: resultRenderer
      }, result, {
        id: offsetIndex // Used to lookup the result on item click
      }));
    }, _this.renderResults = function () {
      var results = _this.props.results;


      return __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(results, _this.renderResult);
    }, _this.renderCategories = function () {
      var _this$props4 = _this.props,
          categoryRenderer = _this$props4.categoryRenderer,
          categories = _this$props4.results;
      var selectedIndex = _this.state.selectedIndex;


      var count = 0;

      return __WEBPACK_IMPORTED_MODULE_11_lodash_map___default()(categories, function (_ref4) {
        var childKey = _ref4.childKey,
            category = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['childKey']);

        var categoryProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
          key: childKey || category.name,
          active: __WEBPACK_IMPORTED_MODULE_10_lodash_inRange___default()(selectedIndex, count, count + category.results.length),
          renderer: categoryRenderer
        }, category);
        var renderFn = __WEBPACK_IMPORTED_MODULE_9_lodash_partialRight___default()(_this.renderResult, count);

        count += category.results.length;

        return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_21__SearchCategory__["a" /* default */],
          categoryProps,
          category.results.map(renderFn)
        );
      });
    }, _this.renderMenuContent = function () {
      var _this$props5 = _this.props,
          category = _this$props5.category,
          showNoResults = _this$props5.showNoResults,
          results = _this$props5.results;


      if (__WEBPACK_IMPORTED_MODULE_8_lodash_isEmpty___default()(results)) {
        return showNoResults ? _this.renderNoResults() : null;
      }

      return category ? _this.renderCategories() : _this.renderResults();
    }, _this.renderResultsMenu = function () {
      var open = _this.state.open;

      var resultsClasses = open ? 'visible' : '';
      var menuContent = _this.renderMenuContent();

      if (!menuContent) return;

      return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_23__SearchResults__["a" /* default */],
        { className: resultsClasses },
        menuContent
      );
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Search, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _state = this.state,
          open = _state.open,
          value = _state.value;


      this.setValue(value);
      if (open) this.open();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(Search.prototype.__proto__ || Object.getPrototypeOf(Search.prototype), 'componentWillReceiveProps', this).call(this, nextProps);


      if (!Object(__WEBPACK_IMPORTED_MODULE_19__lib__["A" /* shallowEqual */])(nextProps.value, this.props.value)) {
        this.setValue(nextProps.value);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !Object(__WEBPACK_IMPORTED_MODULE_19__lib__["A" /* shallowEqual */])(nextProps, this.props) || !Object(__WEBPACK_IMPORTED_MODULE_19__lib__["A" /* shallowEqual */])(nextState, this.state);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {

      // focused / blurred
      // eslint-disable-line complexity
      if (!prevState.focus && this.state.focus) {
        if (!this.isMouseDown) {
          this.tryOpen();
        }
        if (this.state.open) {
          __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
        }
      } else if (prevState.focus && !this.state.focus) {
        if (!this.isMouseDown) {
          this.close();
        }
        __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].unsub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      }

      // opened / closed
      if (!prevState.open && this.state.open) {
        this.open();
        __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].sub('click', this.closeOnDocumentClick);
        __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].sub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      } else if (prevState.open && !this.state.open) {
        this.close();
        __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].unsub('click', this.closeOnDocumentClick);
        __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {

      __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].unsub('click', this.closeOnDocumentClick);
      __WEBPACK_IMPORTED_MODULE_19__lib__["o" /* eventStack */].unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
    }

    // ----------------------------------------
    // Document Event Handlers
    // ----------------------------------------

    // ----------------------------------------
    // Component Event Handlers
    // ----------------------------------------

    // ----------------------------------------
    // Getters
    // ----------------------------------------

    // ----------------------------------------
    // Setters
    // ----------------------------------------

    // ----------------------------------------
    // Behavior
    // ----------------------------------------

    // Open if the current value is greater than the minCharacters prop


    // ----------------------------------------
    // Render
    // ----------------------------------------

    /**
     * Offset is needed for determining the active item for results within a
     * category. Since the index is reset to 0 for each new category, an offset
     * must be passed in.
     */

  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          searchClasses = _state2.searchClasses,
          focus = _state2.focus,
          open = _state2.open;
      var _props = this.props,
          aligned = _props.aligned,
          category = _props.category,
          className = _props.className,
          fluid = _props.fluid,
          loading = _props.loading,
          size = _props.size;

      // Classes

      var classes = __WEBPACK_IMPORTED_MODULE_16_classnames___default()('ui', open && 'active visible', size, searchClasses, Object(__WEBPACK_IMPORTED_MODULE_19__lib__["B" /* useKeyOnly */])(category, 'category'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["B" /* useKeyOnly */])(focus, 'focus'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["B" /* useKeyOnly */])(fluid, 'fluid'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["B" /* useKeyOnly */])(loading, 'loading'), Object(__WEBPACK_IMPORTED_MODULE_19__lib__["F" /* useValueAndKey */])(aligned, 'aligned'), 'search', className);
      var unhandled = Object(__WEBPACK_IMPORTED_MODULE_19__lib__["r" /* getUnhandledProps */])(Search, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_19__lib__["q" /* getElementType */])(Search, this.props);

      var _partitionHTMLProps = Object(__WEBPACK_IMPORTED_MODULE_19__lib__["z" /* partitionHTMLProps */])(unhandled, {
        htmlProps: __WEBPACK_IMPORTED_MODULE_19__lib__["s" /* htmlInputAttrs */]
      }),
          _partitionHTMLProps2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_partitionHTMLProps, 2),
          htmlInputProps = _partitionHTMLProps2[0],
          rest = _partitionHTMLProps2[1];

      return __WEBPACK_IMPORTED_MODULE_18_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, rest, {
          className: classes,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onMouseDown: this.handleMouseDown
        }),
        this.renderSearchInput(htmlInputProps),
        this.renderResultsMenu()
      );
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_19__lib__["a" /* AutoControlledComponent */]);

Search.defaultProps = {
  icon: 'search',
  input: 'text',
  minCharacters: 1,
  noResultsMessage: 'No results found.',
  showNoResults: true
};
Search.autoControlledProps = ['open', 'value'];
Search._meta = {
  name: 'Search',
  type: __WEBPACK_IMPORTED_MODULE_19__lib__["b" /* META */].TYPES.MODULE
};
Search.Category = __WEBPACK_IMPORTED_MODULE_21__SearchCategory__["a" /* default */];
Search.Result = __WEBPACK_IMPORTED_MODULE_22__SearchResult__["a" /* default */];
Search.Results = __WEBPACK_IMPORTED_MODULE_23__SearchResults__["a" /* default */];
Search.handledProps = ['aligned', 'as', 'category', 'categoryRenderer', 'className', 'defaultOpen', 'defaultValue', 'fluid', 'icon', 'input', 'loading', 'minCharacters', 'noResultsDescription', 'noResultsMessage', 'onBlur', 'onFocus', 'onMouseDown', 'onResultSelect', 'onSearchChange', 'onSelectionChange', 'open', 'resultRenderer', 'results', 'selectFirstResult', 'showNoResults', 'size', 'value'];
/* unused harmony default export */ var _unused_webpack_default_export = (Search);
Search.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  // ------------------------------------
  // Behavior
  // ------------------------------------

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Initial value. */
  defaultValue: PropTypes.string,

  /** Shorthand for Icon. */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** Minimum characters to query for results */
  minCharacters: PropTypes.number,

  /** Additional text for "No Results" message with less emphasis. */
  noResultsDescription: PropTypes.node,

  /** Message to display when there are no results. */
  noResultsMessage: PropTypes.node,

  /** Controls whether or not the results menu is displayed. */
  open: PropTypes.bool,

  /**
   * One of:
   * - array of Search.Result props e.g. `{ title: '', description: '' }` or
   * - object of categories e.g. `{ name: '', results: [{ title: '', description: '' }]`
   */
  results: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape(SearchResult.propTypes)), PropTypes.shape(SearchCategory.propTypes)]),

  /** Whether the search should automatically select the first result after searching. */
  selectFirstResult: PropTypes.bool,

  /** Whether a "no results" message should be shown if no results are found. */
  showNoResults: PropTypes.bool,

  /** Current value of the search input. Creates a controlled component. */
  value: PropTypes.string,

  // ------------------------------------
  // Rendering
  // ------------------------------------

  /**
   * Renders the SearchCategory contents.
   *
   * @param {object} props - The SearchCategory props object.
   * @returns {*} - Renderable SearchCategory contents.
   */
  categoryRenderer: PropTypes.func,

  /**
   * Renders the SearchResult contents.
   *
   * @param {object} props - The SearchResult props object.
   * @returns {*} - Renderable SearchResult contents.
   */
  resultRenderer: PropTypes.func,

  // ------------------------------------
  // Callbacks
  // ------------------------------------

  /**
   * Called on blur.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBlur: PropTypes.func,

  /**
   * Called on focus.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onFocus: PropTypes.func,

  /**
   * Called on mousedown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when a result is selected.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onResultSelect: PropTypes.func,

  /**
   * Called on search input change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props, includes current value of search input.
   */
  onSearchChange: PropTypes.func,

  /**
   * Called when the active selection index is changed.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onSelectionChange: PropTypes.func,

  // ------------------------------------
  // Style
  // ------------------------------------

  /** A search can have its results aligned to its left or right container edge. */
  aligned: PropTypes.string,

  /** A search can display results from remote content ordered by categories. */
  category: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A search can have its results take up the width of its container. */
  fluid: PropTypes.bool,

  /** A search input can take up the width of its container. */
  input: customPropTypes.itemShorthand,

  /** A search can show a loading indicator. */
  loading: PropTypes.bool,

  /** A search can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(52),
    createWrap = __webpack_require__(127),
    getHolder = __webpack_require__(188),
    replaceHolders = __webpack_require__(129);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partialRight));
  return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

module.exports = partialRight;


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(837);
/* unused harmony reexport default */



/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarPushable__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SidebarPusher__ = __webpack_require__(410);













/**
 * A sidebar hides additional content beside a page.
 */

var Sidebar = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Sidebar, _Component);

  function Sidebar() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Sidebar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call.apply(_ref, [this].concat(args))), _this), _this.startAnimating = function () {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;

      clearTimeout(_this.stopAnimatingTimer);

      _this.setState({ animating: true });

      _this.stopAnimatingTimer = setTimeout(function () {
        return _this.setState({ animating: false });
      }, duration);
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Sidebar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.visible !== this.props.visible) {
        this.startAnimating();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          children = _props.children,
          content = _props.content,
          direction = _props.direction,
          visible = _props.visible,
          width = _props.width;
      var animating = this.state.animating;


      var classes = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('ui', animation, direction, width, Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(animating, 'animating'), Object(__WEBPACK_IMPORTED_MODULE_8__lib__["B" /* useKeyOnly */])(visible, 'visible'), 'sidebar', className);

      var rest = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["r" /* getUnhandledProps */])(Sidebar, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* getElementType */])(Sidebar, this.props);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
        __WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(children) ? content : children
      );
    }
  }]);

  return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* AutoControlledComponent */]);

Sidebar.defaultProps = {
  direction: 'left'
};
Sidebar.autoControlledProps = ['visible'];
Sidebar._meta = {
  name: 'Sidebar',
  type: __WEBPACK_IMPORTED_MODULE_8__lib__["b" /* META */].TYPES.MODULE
};
Sidebar.Pushable = __WEBPACK_IMPORTED_MODULE_9__SidebarPushable__["a" /* default */];
Sidebar.Pusher = __WEBPACK_IMPORTED_MODULE_10__SidebarPusher__["a" /* default */];
Sidebar.handledProps = ['animation', 'as', 'children', 'className', 'content', 'defaultVisible', 'direction', 'visible', 'width'];
Sidebar.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Animation style. */
  animation: PropTypes.oneOf(['overlay', 'push', 'scale down', 'uncover', 'slide out', 'slide along']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Initial value of visible. */
  defaultVisible: PropTypes.bool,

  /** Direction the sidebar should appear on. */
  direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /** Controls whether or not the sidebar is visible on the page. */
  visible: PropTypes.bool,

  /** Sidebar width. */
  width: PropTypes.oneOf(['very thin', 'thin', 'wide', 'very wide'])
} : {};


/* unused harmony default export */ var _unused_webpack_default_export = (Sidebar);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sticky__ = __webpack_require__(839);
/* unused harmony reexport default */



/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(2);












/**
 * Sticky content stays fixed to the browser viewport while another column of content is visible on the page.
 */

var Sticky = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Sticky, _Component);

  function Sticky() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Sticky);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Sticky.__proto__ || Object.getPrototypeOf(Sticky)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      sticky: false
    }, _this.addListeners = function (props) {
      var scrollContext = props.scrollContext;


      if (scrollContext) {
        __WEBPACK_IMPORTED_MODULE_8__lib__["o" /* eventStack */].sub('resize', _this.handleUpdate, { target: scrollContext });
        __WEBPACK_IMPORTED_MODULE_8__lib__["o" /* eventStack */].sub('scroll', _this.handleUpdate, { target: scrollContext });
      }
    }, _this.removeListeners = function () {
      var scrollContext = _this.props.scrollContext;


      if (scrollContext) {
        __WEBPACK_IMPORTED_MODULE_8__lib__["o" /* eventStack */].unsub('resize', _this.handleUpdate, { target: scrollContext });
        __WEBPACK_IMPORTED_MODULE_8__lib__["o" /* eventStack */].unsub('scroll', _this.handleUpdate, { target: scrollContext });
      }
    }, _this.update = function (e) {
      var pushing = _this.state.pushing;


      _this.ticking = false;
      _this.assignRects();

      if (pushing) {
        if (_this.didReachStartingPoint()) return _this.stickToContextTop(e);
        if (_this.didTouchScreenBottom()) return _this.stickToScreenBottom(e);
        return _this.stickToContextBottom(e);
      }

      if (_this.isOversized()) {
        if (_this.contextRect.top > 0) return _this.stickToContextTop(e);
        if (_this.contextRect.bottom < window.innerHeight) return _this.stickToContextBottom(e);
      }

      if (_this.didTouchScreenTop()) {
        if (_this.didReachContextBottom()) return _this.stickToContextBottom(e);
        return _this.stickToScreenTop(e);
      }

      return _this.stickToContextTop(e);
    }, _this.handleUpdate = function (e) {
      if (!_this.ticking) {
        _this.ticking = true;
        requestAnimationFrame(function () {
          return _this.update(e);
        });
      }
    }, _this.assignRects = function () {
      var context = _this.props.context;


      _this.triggerRect = _this.triggerRef.getBoundingClientRect();
      _this.contextRect = (context || document.body).getBoundingClientRect();
      _this.stickyRect = _this.stickyRef.getBoundingClientRect();
    }, _this.didReachContextBottom = function () {
      var offset = _this.props.offset;


      return _this.stickyRect.height + offset >= _this.contextRect.bottom;
    }, _this.didReachStartingPoint = function () {
      return _this.stickyRect.top <= _this.triggerRect.top;
    }, _this.didTouchScreenTop = function () {
      return _this.triggerRect.top < _this.props.offset;
    }, _this.didTouchScreenBottom = function () {
      var bottomOffset = _this.props.bottomOffset;


      return _this.contextRect.bottom + bottomOffset > window.innerHeight;
    }, _this.isOversized = function () {
      return _this.stickyRect.height > window.innerHeight;
    }, _this.pushing = function (pushing) {
      var possible = _this.props.pushing;


      if (possible) _this.setState({ pushing: pushing });
    }, _this.stick = function (e) {
      _this.setState({ sticky: true });
      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onStick', e, _this.props);
    }, _this.unstick = function (e) {
      _this.setState({ sticky: false });
      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onUnstick', e, _this.props);
    }, _this.stickToContextBottom = function (e) {
      var top = _this.contextRect.bottom - _this.stickyRect.height;

      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onBottom', e, _this.props);

      _this.stick(e);
      _this.setState({ top: top, bottom: null });
      _this.pushing(true);
    }, _this.stickToContextTop = function (e) {
      __WEBPACK_IMPORTED_MODULE_5_lodash_invoke___default()(_this.props, 'onTop', e, _this.props);

      _this.unstick(e);
      _this.pushing(false);
    }, _this.stickToScreenBottom = function (e) {
      var bottom = _this.props.bottomOffset;


      _this.stick(e);
      _this.setState({ bottom: bottom, top: null });
    }, _this.stickToScreenTop = function (e) {
      var top = _this.props.offset;


      _this.stick(e);
      _this.setState({ top: top, bottom: null });
    }, _this.handleStickyRef = function (c) {
      return _this.stickyRef = c;
    }, _this.handleTriggerRef = function (c) {
      return _this.triggerRef = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Sticky, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__lib__["t" /* isBrowser */])()) return;
      var active = this.props.active;


      if (active) {
        this.handleUpdate();
        this.addListeners(this.props);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          current = _props.active,
          currentScrollContext = _props.scrollContext;
      var next = nextProps.active,
          nextScrollContext = nextProps.scrollContext;


      if (current === next) {
        if (currentScrollContext !== nextScrollContext) {
          this.removeListeners();
          this.addListeners(nextProps);
        }
        return;
      }

      if (next) {
        this.handleUpdate();
        this.addListeners(nextProps);
        return;
      }

      this.removeListeners();
      this.setState({ sticky: false });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__lib__["t" /* isBrowser */])()) return;
      var active = this.props.active;


      if (active) this.removeListeners();
    }

    // ----------------------------------------
    // Events
    // ----------------------------------------

    // ----------------------------------------
    // Handlers
    // ----------------------------------------

    // ----------------------------------------
    // Helpers
    // ----------------------------------------

  }, {
    key: 'computeStyle',
    value: function computeStyle() {
      var _state = this.state,
          bottom = _state.bottom,
          sticky = _state.sticky,
          top = _state.top;


      if (!sticky) return {};
      return {
        bottom: bottom,
        top: top,
        position: 'fixed',
        width: this.triggerRect.width
      };
    }

    // Return true when the component reached the bottom of the context


    // Return true when the component reached the starting point


    // Return true when the top of the screen overpasses the Sticky component


    // Return true when the bottom of the screen overpasses the Sticky component


    // Return true if the height of the component is higher than the window


    // ----------------------------------------
    // Stick helpers
    // ----------------------------------------

    // If true, the component will stick to the bottom of the screen instead of the top


    // ----------------------------------------
    // Refs
    // ----------------------------------------

  }, {
    key: 'render',


    // ----------------------------------------
    // Render
    // ----------------------------------------

    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className;

      var rest = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["r" /* getUnhandledProps */])(Sticky, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* getElementType */])(Sticky, this.props);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        ElementType,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: className }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', { ref: this.handleTriggerRef }),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { ref: this.handleStickyRef, style: this.computeStyle() },
          children
        )
      );
    }
  }]);

  return Sticky;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Sticky.defaultProps = {
  active: true,
  bottomOffset: 0,
  offset: 0,
  scrollContext: Object(__WEBPACK_IMPORTED_MODULE_8__lib__["t" /* isBrowser */])() ? window : null
};
Sticky._meta = {
  name: 'Sticky',
  type: __WEBPACK_IMPORTED_MODULE_8__lib__["b" /* META */].TYPES.MODULE
};
Sticky.handledProps = ['active', 'as', 'bottomOffset', 'children', 'className', 'context', 'offset', 'onBottom', 'onStick', 'onTop', 'onUnstick', 'pushing', 'scrollContext'];
/* unused harmony default export */ var _unused_webpack_default_export = (Sticky);
Sticky.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** A Sticky can be active. */
  active: PropTypes.bool,

  /** Offset in pixels from the bottom of the screen when fixing element to viewport. */
  bottomOffset: PropTypes.number,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Context which sticky element should stick to. */
  context: PropTypes.object,

  /** Offset in pixels from the top of the screen when fixing element to viewport. */
  offset: PropTypes.number,

  /**
   * Callback when element is bound to bottom of parent container.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBottom: PropTypes.func,

  /**
   * Callback when element is fixed to page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onStick: PropTypes.func,

  /**
   * Callback when element is bound to top of parent container.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onTop: PropTypes.func,

  /**
   * Callback when element is unfixed from page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onUnstick: PropTypes.func,

  /** Whether element should be "pushed" by the viewport, attaching to the bottom of the screen when scrolling up. */
  pushing: PropTypes.bool,

  /** Context which sticky should attach onscroll events. */
  scrollContext: PropTypes.object
} : {};

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab__ = __webpack_require__(841);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tab__["a"]; });



/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_invoke__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__collections_Grid_Grid__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__collections_Grid_GridColumn__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__collections_Menu_Menu__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TabPane__ = __webpack_require__(411);



















/**
 * A Tab is a hidden section of content activated by a Menu.
 * @see Menu
 * @see Segment
 */

var Tab = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Tab, _Component);

  function Tab() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Tab.__proto__ || Object.getPrototypeOf(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClick = function (e, _ref2) {
      var index = _ref2.index;

      __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(_this.props, 'onTabChange', e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.props, { activeIndex: index }));
      _this.trySetState({ activeIndex: index });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Tab, [{
    key: 'getInitialAutoControlledState',
    value: function getInitialAutoControlledState() {
      return { activeIndex: 0 };
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var _props = this.props,
          panes = _props.panes,
          renderActiveOnly = _props.renderActiveOnly;
      var activeIndex = this.state.activeIndex;


      if (renderActiveOnly) return __WEBPACK_IMPORTED_MODULE_8_lodash_invoke___default()(__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(panes, '[' + activeIndex + ']'), 'render', this.props);
      return __WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(panes, function (_ref3, index) {
        var pane = _ref3.pane;
        return __WEBPACK_IMPORTED_MODULE_15__TabPane__["a" /* default */].create(pane, {
          overrideProps: {
            active: index === activeIndex
          }
        });
      });
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _props2 = this.props,
          menu = _props2.menu,
          panes = _props2.panes;
      var activeIndex = this.state.activeIndex;


      return __WEBPACK_IMPORTED_MODULE_14__collections_Menu_Menu__["a" /* default */].create(menu, {
        overrideProps: {
          items: __WEBPACK_IMPORTED_MODULE_6_lodash_map___default()(panes, 'menuItem'),
          onItemClick: this.handleItemClick,
          activeIndex: activeIndex
        }
      });
    }
  }, {
    key: 'renderVertical',
    value: function renderVertical(menu) {
      var grid = this.props.grid;

      var paneWidth = grid.paneWidth,
          tabWidth = grid.tabWidth,
          gridProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(grid, ['paneWidth', 'tabWidth']);

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_12__collections_Grid_Grid__["a" /* default */],
        gridProps,
        menu.props.aligned !== 'right' && __WEBPACK_IMPORTED_MODULE_13__collections_Grid_GridColumn__["a" /* default */].create({ width: tabWidth, children: menu }),
        __WEBPACK_IMPORTED_MODULE_13__collections_Grid_GridColumn__["a" /* default */].create({
          width: paneWidth,
          children: this.renderItems(),
          stretched: true
        }),
        menu.props.aligned === 'right' && __WEBPACK_IMPORTED_MODULE_13__collections_Grid_GridColumn__["a" /* default */].create({ width: tabWidth, children: menu })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var menu = this.renderMenu();
      var rest = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["r" /* getUnhandledProps */])(Tab, this.props);
      var ElementType = Object(__WEBPACK_IMPORTED_MODULE_11__lib__["q" /* getElementType */])(Tab, this.props);

      if (menu.props.vertical) {
        return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
          ElementType,
          rest,
          this.renderVertical(menu)
        );
      }

      return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        ElementType,
        rest,
        menu.props.attached !== 'bottom' && menu,
        this.renderItems(),
        menu.props.attached === 'bottom' && menu
      );
    }
  }]);

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* AutoControlledComponent */]);

Tab.autoControlledProps = ['activeIndex'];
Tab.defaultProps = {
  grid: { paneWidth: 12, tabWidth: 4 },
  menu: { attached: true, tabular: true, aligned: 'left' },
  renderActiveOnly: true
};
Tab._meta = {
  name: 'Tab',
  type: __WEBPACK_IMPORTED_MODULE_11__lib__["b" /* META */].TYPES.MODULE
};
Tab.Pane = __WEBPACK_IMPORTED_MODULE_15__TabPane__["a" /* default */];
Tab.handledProps = ['activeIndex', 'as', 'defaultActiveIndex', 'grid', 'menu', 'onTabChange', 'panes', 'renderActiveOnly'];
Tab.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** The initial activeIndex. */
  defaultActiveIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Index of the currently active tab. */
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Shorthand props for the Menu. */
  menu: PropTypes.object,

  /** Shorthand props for the Grid. */
  grid: PropTypes.object,

  /**
   * Called on tab change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed new activeIndex.
   * @param {object} data.activeIndex - The new proposed activeIndex.
   */
  onTabChange: PropTypes.func,

  /**
   * Array of objects describing each Menu.Item and Tab.Pane:
   * { menuItem: 'Home', render: () => <Tab.Pane /> }
   * or
   * { menuItem: 'Home', pane: 'Welcome' }
   */
  panes: PropTypes.arrayOf(PropTypes.shape({
    menuItem: customPropTypes.itemShorthand,
    pane: customPropTypes.itemShorthand,
    render: PropTypes.func
  })),

  /** A Tab can render only active pane. */
  renderActiveOnly: PropTypes.bool
} : {};


/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Advertisement__ = __webpack_require__(843);
/* unused harmony reexport default */



/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);







/**
 * An ad displays third-party promotional content.
 */
function Advertisement(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      content = props.content,
      test = props.test,
      unit = props.unit;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ui', unit, Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(centered, 'centered'), Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(test, 'test'), 'ad', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(Advertisement, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(Advertisement, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes, 'data-text': test }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

Advertisement.handledProps = ['as', 'centered', 'children', 'className', 'content', 'test', 'unit'];
Advertisement._meta = {
  name: 'Advertisement',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

Advertisement.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Center the advertisement. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Text to be displayed on the advertisement. */
  test: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),

  /** Varies the size of the advertisement. */
  unit: PropTypes.oneOf(['medium rectangle', 'large rectangle', 'vertical rectangle', 'small rectangle', 'mobile banner', 'banner', 'vertical banner', 'top banner', 'half banner', 'button', 'square button', 'small button', 'skyscraper', 'wide skyscraper', 'leaderboard', 'large leaderboard', 'mobile leaderboard', 'billboard', 'panorama', 'netboard', 'half page', 'square', 'small square']).isRequired

} : {};

/* unused harmony default export */ var _unused_webpack_default_export = (Advertisement);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comment__ = __webpack_require__(845);
/* unused harmony reexport default */



/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommentAction__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CommentActions__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CommentAuthor__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CommentAvatar__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CommentContent__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CommentGroup__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CommentMetadata__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CommentText__ = __webpack_require__(422);















/**
 * A comment displays user feedback to site content.
 */
function Comment(props) {
  var className = props.className,
      children = props.children,
      collapsed = props.collapsed,
      content = props.content;


  var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_4__lib__["B" /* useKeyOnly */])(collapsed, 'collapsed'), 'comment', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* getUnhandledProps */])(Comment, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_4__lib__["q" /* getElementType */])(Comment, props);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children
  );
}

Comment.handledProps = ['as', 'children', 'className', 'collapsed', 'content'];
Comment._meta = {
  name: 'Comment',
  type: __WEBPACK_IMPORTED_MODULE_4__lib__["b" /* META */].TYPES.VIEW
};

Comment.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Comment can be collapsed, or hidden from view. */
  collapsed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};

Comment.Author = __WEBPACK_IMPORTED_MODULE_7__CommentAuthor__["a" /* default */];
Comment.Action = __WEBPACK_IMPORTED_MODULE_5__CommentAction__["a" /* default */];
Comment.Actions = __WEBPACK_IMPORTED_MODULE_6__CommentActions__["a" /* default */];
Comment.Avatar = __WEBPACK_IMPORTED_MODULE_8__CommentAvatar__["a" /* default */];
Comment.Content = __WEBPACK_IMPORTED_MODULE_9__CommentContent__["a" /* default */];
Comment.Group = __WEBPACK_IMPORTED_MODULE_10__CommentGroup__["a" /* default */];
Comment.Metadata = __WEBPACK_IMPORTED_MODULE_11__CommentMetadata__["a" /* default */];
Comment.Text = __WEBPACK_IMPORTED_MODULE_12__CommentText__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Comment);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Feed__ = __webpack_require__(847);
/* unused harmony reexport default */



/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_without__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_without___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_without__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeedContent__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FeedDate__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FeedEvent__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FeedExtra__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FeedLabel__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FeedLike__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FeedMeta__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FeedSummary__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FeedUser__ = __webpack_require__(221);




















/**
 * A feed presents user activity chronologically.
 */
function Feed(props) {
  var children = props.children,
      className = props.className,
      events = props.events,
      size = props.size;


  var classes = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('ui', size, 'feed', className);
  var rest = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["r" /* getUnhandledProps */])(Feed, props);
  var ElementType = Object(__WEBPACK_IMPORTED_MODULE_7__lib__["q" /* getElementType */])(Feed, props);

  if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      ElementType,
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
      children
    );
  }

  var eventElements = __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(events, function (eventProps) {
    var childKey = eventProps.childKey,
        date = eventProps.date,
        meta = eventProps.meta,
        summary = eventProps.summary,
        eventData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(eventProps, ['childKey', 'date', 'meta', 'summary']);

    var finalKey = childKey || [date, meta, summary].join('-');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FeedEvent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      date: date,
      key: finalKey,
      meta: meta,
      summary: summary
    }, eventData));
  });

  return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
    ElementType,
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, rest, { className: classes }),
    eventElements
  );
}

Feed.handledProps = ['as', 'children', 'className', 'events', 'size'];
Feed._meta = {
  name: 'Feed',
  type: __WEBPACK_IMPORTED_MODULE_7__lib__["b" /* META */].TYPES.VIEW
};

Feed.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: customPropTypes.as,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand array of props for FeedEvent. */
  events: customPropTypes.collectionShorthand,

  /** A feed can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive'))
} : {};

Feed.Content = __WEBPACK_IMPORTED_MODULE_8__FeedContent__["a" /* default */];
Feed.Date = __WEBPACK_IMPORTED_MODULE_9__FeedDate__["a" /* default */];
Feed.Event = __WEBPACK_IMPORTED_MODULE_10__FeedEvent__["a" /* default */];
Feed.Extra = __WEBPACK_IMPORTED_MODULE_11__FeedExtra__["a" /* default */];
Feed.Label = __WEBPACK_IMPORTED_MODULE_12__FeedLabel__["a" /* default */];
Feed.Like = __WEBPACK_IMPORTED_MODULE_13__FeedLike__["a" /* default */];
Feed.Meta = __WEBPACK_IMPORTED_MODULE_14__FeedMeta__["a" /* default */];
Feed.Summary = __WEBPACK_IMPORTED_MODULE_15__FeedSummary__["a" /* default */];
Feed.User = __WEBPACK_IMPORTED_MODULE_16__FeedUser__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (Feed);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__(424);
/* unused harmony reexport default */



/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Statistic__ = __webpack_require__(428);
/* unused harmony reexport default */



/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_performance_now__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_performance_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_performance_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchPageDictionary_js__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SearchPageAudioLibrary_js__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SearchPageYugtunToEnglish_js__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_ga4__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Fuse from 'fuse.js';
// import fuzzysort from 'fuzzysort'
// import ReactGA from 'react-ga';
// import GitHubForkRibbon from 'react-github-fork-ribbon';
// import TableEntry from './TableEntry.js';
// import {demPro, perPro} from './constants/pronounEndings.js';
// import {endingRules} from './constants/endingRules.js';
__WEBPACK_IMPORTED_MODULE_12_react_ga4___default.a.initialize("G-WDEJDCK7QT");// Cache dictionary
var dictionary=[];var audiolibrary=[];var dictionary_dict={};// let dictionary_prepared = [];
var SearchPage=function(_Component){_inherits(SearchPage,_Component);function SearchPage(props){_classCallCheck(this,SearchPage);var _this=_possibleConstructorReturn(this,(SearchPage.__proto__||Object.getPrototypeOf(SearchPage)).call(this,props));_this.resetAll=function(e,data){_this.setState({reset:!_this.state.reset// search:'',
//   newSearchList:[],
//   parses:[],
//   segments:[],
//   searchWord:"",
//   notFirstParse:false,
});};_this.handleTabChange=function(e,data){// console.log(data.activeIndex, this.state.activeTabIndex)
// if (data.activeIndex == 3) {
//   console.log('hi')
//   return <Redirect push to='/dialogues' />
// }
if(_this.state.activeTabIndex!==data.activeIndex){console.log('tested',data.activeIndex);_this.resetAll();_this.setState({activeTabIndex:data.activeIndex,fromTab:true});}// } else if (data.activeIndex === 1 && this.state.activeTabIndex !== 1) {
//   // if (!this.state.yugtunAnalyzer) {
//   this.setState({ activeTabIndex:1, parses:[],segments:[],endingrule:[],newSearchList:[],notFirstParse:false,search:""});                     
//   // this.inputClicked()
//   // }
// } else if (data.activeIndex === 2 && this.state.activeTabIndex !== 2) {
//   // if (!this.state.yugtunAnalyzer) {
//   this.setState({ activeTabIndex:2, parses:[],segments:[],endingrule:[],newSearchList:[],notFirstParse:false,search:""});                     
//   // this.inputClicked()
//   // }
// }
};_this.handleTabChange2=function(e,_ref){var value=_ref.value;// if (value == 3) {
//   console.log('hi')
//   return <Redirect push to='/dialogues' />
// }
if(_this.state.activeTabIndex!==value){console.log(value);_this.setState({activeTabIndex:value,fromTab:true});}// } else if (value === 1 && this.state.activeTabIndex !== 1) {
//   // if (!this.state.yugtunAnalyzer) {
//   this.setState({ activeTabIndex:1, newSearchList:[],search:""});                     
//   // this.inputClicked()
//   // }
// } else if (value === 2 && this.state.activeTabIndex !== 2) {
//   // if (!this.state.yugtunAnalyzer) {
//   this.setState({ activeTabIndex:2, newSearchList:[],search:""});                     
//   // this.inputClicked()
//   // }
// }
// this.setState({activeTabIndex: value})
};console.log("SearchPage props: ",props);_this.state={dictionary:props.dictionary,audiolibrary:props.audiolibrary,dictionary_dict:props.dictionary_dict,reset:true,fromTab:false,// dictionaryNouns: [],
// dictionaryVerbs: [],
// wordsList: [],
// yugtunAnalyzer: props.location.state === undefined ? false : props.location.state.yugtunAnalyzer,
// search: props.location.state === undefined ? '' : props.location.state.search,
// currentWord: {},
// onlyCommon: false,
// startingSearch: true,
// smallestParseIndex: -1,
// parses: props.location.state === undefined ? [] : props.location.state.parses,
// segments: props.location.state === undefined ? [] : props.location.state.segments,
// endingrule: props.location.state === undefined ? [] : props.location.state.endingrule,
// parses:[],
// segments:[],
// endingrule:[],
// currentTableOpen: -1,
// getCall:false,
// notFirstParse: false,
// searchBarStuckTop: false,
// searchBarStuckTop: props.location.state === undefined ? false : props.location.state.searchBarStuckTop,
// notFirstParse: props.location.state === undefined ? false : props.location.state.notFirstParse,
// searchWord: props.location.state === undefined ? "" : props.location.state.searchWord,
// activeSentenceIndex: props.location.state === undefined ? 0 : props.location.state.activeSentenceIndex,
// exampleSentenceSearch: false,
// smallestParse:[[],[]],
// segmentOutputList:[],
// searchWord:"",
// activeSentenceIndex: 0,
// activeTabIndex:0,
// showMoreEnding: false,
// moreIndex:-1,
// updateSearchEntry: props.location.state === undefined ? false : props.location.state.updateSearchEntry,
activeTabIndex:props.location.state===undefined?0:props.location.state.activeTabIndex// tabValue: 0,
// exampleSentenceSearch: props.location.state === undefined ? false : props.location.state.exampleSentenceSearch,
// newSearchList: props.location.state === undefined ? [] : props.location.state.newSearchList,
// activeIndex:-1,
// loaderOn:true,
// entries:undefined,
// hover:-1,
// seeMoreActive:false,
// segment: "",
// possibleDefinition: ["","","","","","","","","",""],
// moods: ["[Ind]","[Intrg]","[Opt]","[Sbrd]","[Ptcp]","[Prec]","[Cnsq]","[Cont]","[Conc]","[Cond]","[CtmpI]","[CtmpII]","[Abs]","[Rel]","[Abl_Mod]","[Loc]", "[Ter]","[Via]","[Equ]","%5BQuant_Qual%5D","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]",],
// this.getParse = this.getParse.bind(this);
// this.onChangeSearch = this.onChangeSearch.bind(this);
// this.selectWord = this.selectWord.bind(this);
};_this.search_container=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createRef();// this.getEndings = this.getEndings.bind(this);
// this.getLinks = this.getLinks.bind(this);
// this.inputClicked = this.inputClicked.bind(this);
return _this;}// componentDidMount() {
//   let start = now();
//   // if (this.state.updateSearchEntry) {
//   //   this.inputClicked();
//   //   this.setState({ updateSearchEntry: false });
//   // }
//   // console.log('hi',dictionary)
//   if (dictionary.length === 0) {
//     axios
//       .get(API_URL + "/word/all2021")
//       .then(response => {
//         let end = now();
//         ReactGA.timing({
//           category: 'Loading',
//           variable: 'dictionary',
//           value: (end-start).toFixed(3),
//           label: 'Dictionary loading'
//         });
//         dictionary = response.data;
//         console.log(dictionary)
//         // fuse.setCollection(dictionary);
//         // fuse1.setCollection(dictionary);
//         console.log('Fetched dictionary');
//         dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
//         // dictionary_prepared = fuzzysort.prepare(dictionary)
//         this.setState({ dictionary: dictionary, dictionary_dict: dictionary_dict});
//       });
//   }
//   else {
//     // fuse.setCollection(dictionary);
//     this.setState({ dictionary: dictionary, dictionary_dict: dictionary_dict });
//   }
//   if (audiolibrary.length === 0) {
//     axios
//       .get(API_URL + "/audiolibrary/all")
//       .then(response => {
//         // let end = now();
//         // ReactGA.timing({
//         //   category: 'Loading',
//         //   variable: 'dictionary',
//         //   value: (end-start).toFixed(3),
//         //   label: 'Dictionary loading'
//         // });
//         audiolibrary = response.data;
//         // fuse.setCollection(dictionary);
//         // fuse1.setCollection(dictionary);
//         console.log('Fetched AudioLibrary');
//         // dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
//         // dictionary_prepared = fuzzysort.prepare(dictionary)
//         this.setState({ audiolibrary: audiolibrary });
//       });
//   } else {
//     this.setState({ audiolibrary: audiolibrary });
//   }
// }
_createClass(SearchPage,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// if (prevState.dictionary.length !== this.state.dictionary.length) {
//   this.onChangeSearch(undefined, {value: this.state.search});
// }
// if (prevState.search !== this.state.search) {
// 	this.setState({searchBarStuckTop:true});
// }
if(prevState.startingSearch&&!this.state.startingSearch){if(navigator.userAgent.match(/(iPhone|iPod|iPad)/i)){var elts=__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this).getElementsByClassName('search_container');if(elts.length>0){elts[0].scrollIntoView();}}}}// getParse(word) {
//   if (word === "") {
//     this.setState({
//         parses: [],
//         segments: [],
//         endingrule: [],
//         getCall:false,
//       })
//   } else {
//   axios
//     .get(API_URL + "/parse/" + word)
//     .then(response => {
//       // console.log(response)
//       //  var lowest = 0;
//        // var a = response.data.parses;
//       //  for (var i = 1; i < a.length; i++) {
//       //   if (a[i].length < a[lowest].length) 
//       //     lowest = i;
//       //  }
//       // console.log(a)
//       // let sortedParses = response.data.parses.sort(function(a,b){return a.length - b.length;}).slice(0, 5)
//       // console.log(sortedParses)
//       this.setState({
//         parses: response.data.parses,
//         segments: response.data.segments,
//         endingrule: response.data.endingrule,
//         getCall:false,
//     	})
//       // let segmentOutputList = [];
//       // sortedParses.map((i,index)=>
//       //   this.getSegment(i)
//       //   )
//       // console.log(segmentOutputList)
//       // if (a.length > 0) {
//       // 	this.setState({
//       //    smallestParseIndex: lowest,
//       //    smallestParse: response.data.parses[lowest].split('-'),
//       //  });
//         // this.getSegment(response.data.parses[lowest])
//      // }
//     });
//   }
// }
// getSegment(word) {
//   axios
//     .get(API_URL + "/segment/" + encodeURIComponent(word))
//     .then(response => {
//       // return response.data.words[0]
//       console.log(response)
//       // this.setState({
//         // segment: response.data.words[0],
//       // })
//     });
// }
// getEndings(word, mood) {
//   console.log("Word",word,mood)
//   axios
//     .get(API_URL + "/mood?underlying_form=" + encodeURIComponent(word) + "&mood=" + mood)
//     .then(response => {
//       this.setState({ entries: response.data.results,}); 
//       this.setState({ loaderOn: false})
//   });
// }
// onChangeSearch(event, data) {
//   // this.setState({entries:undefined, activeIndex:-1, loaderOn: true, seeMoreActive:false,currentTableOpen: -1,})
//   let newStartingSearch = event === undefined;
//   let new_search = data.value.replace("’","'");
//   // console.log(new_search)
//   // if (data.value === undefined) {new_search = this.state.search}
//   let wordsList = fuzzysort.go(new_search, dictionary, optionsFuzzy).map(({ obj }) => (obj));
//   this.setState({ startingSearch: newStartingSearch, wordsList: wordsList, search: new_search });
//   // if (new_search.length >= 4 && !this.state.yugtunAnalyzer) {
//   //   ReactGA.event({
//   //     category: 'User',
//   //     action: 'Search word',
//   //     label: new_search
//   //   });
//   //   let start = now();
//   //   let wordsList = fuse.search(new_search);
//   //   let end = now();
//   //   console.log('done! in ', (end-start).toFixed(3), 'ms');
//   //   ReactGA.timing({
//   //     category: 'Search',
//   //     variable: 'fuse.search',
//   //     value: (end-start).toFixed(3),
//   //     label:'Fuse.js search duration'
//   //   });
//   //   this.setState({ startingSearch: newStartingSearch, wordsList: wordsList, search: new_search });
//   // }
//   // else {
//   //   this.setState({ startingSearch: newStartingSearch, search: new_search });
//   // }
// }
// selectWord(word, event) {
//   this.setState({ currentWord: word });
// }
// resetCurrentWord(event, data) {
//   this.setState({ currentWord: {} });
// }
// handleRef = (c) => {
//   this.inputRef = c;
// }
// handleClick = (e, titleProps) => {
//   // console.log(e,titleProps)
//   this.setState({ loaderOn: true,})
//   const { index, currentIndex } = titleProps
//   const { activeIndex } = this.state
//   const newIndex = activeIndex === index ? -1 : index
//   let mood = this.state.moods[index]
//   this.getEndings(this.state.parses[currentIndex],mood)
//   this.setState({activeIndex: newIndex, mood: mood})
// }
// handleClick2 = (e, titleProps) => {
//   // console.log(e,titleProps)
//   const { index, currentIndex } = titleProps
//   const { activeIndex } = this.state
//   const newIndex = activeIndex === index ? -1 : index
//   console.log(index)
//   let mood = this.state.moods[index]
//   // console.log(mood)
//   this.setState({loaderOn:false, entries: (mood === "[DemPro]" ? demPro: perPro), activeIndex: newIndex, mood: mood})
// }
// onKeyPress = (e) => {
//   if(e.key === 'Enter') {//} && (this.state.activeTabIndex === 0 || this.state.search !== this.state.searchWord)){
//     // if (!this.state.yugtunAnalyzer && this.state.parses.length === 0) {this.setState({getCall:true})}
//     // this.setState({ yugtunAnalyzer: !this.state.yugtunAnalyzer}); 
//     // if (this.state.yugtunAnalyzer) {
//       // this.setState({activeTabsIndex:1})
//       this.inputClicked(true)
//     // }
//   }
// }
// inputClicked(search) {
//   this.setState({entries:undefined, activeIndex:-1, loaderOn: true, seeMoreActive:false,currentTableOpen: -1,yugtunAnalyzer:true,showMoreEnding: false,})
//   // console.log(search)
//   if (search === undefined || search === true) {
//   	search = this.state.search
//   }
//   console.log(search)
//   if (search.length > 0) {
//     this.setState({ 
//       newSearchList: search.split(" "), 
//       activeSentenceIndex: 0, 
//       searchWord: search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g, "").toLowerCase(),
//       getCall:true,
//       notFirstParse:true,
//     }); 
//     this.getParse(search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g, "").toLowerCase());                          
//   } 
//   //   this.inputRef.focus();
//   //   this.setState({
//   //     search: '', startingSearch: false
//   //   });
//   // }
// }
// endingToEnglish(ending,index,qindex) {
//   const tags = [...ending.matchAll(/\[.*?\]/g)];
//   var english1 = ""
//   var english2 = ""
//   var english3 = ""
//   var english4 = ""
//   var before = true;
// 	// console.log(this.state,tags[1])
//   if (ending.includes('[V]')) {
//     if (this.state.parses[index].includes('[Ind]') ||
//         this.state.parses[index].includes('[Intrg]') ||
//         this.state.parses[index].includes('[Opt]') ||
//         this.state.parses[index].includes('[Sbrd]')) {
//       before = false;
//     }
//     english1 += 'Verb Ending';
//     english2 += endingToEnglishTerms[tags[1]];
//     english4 += endingEnglishDescriptions[tags[1]];
//     if (ending.includes('[Trns]')) {
// 	  var subject = endingToEnglishTerms[tags[tags.length-2]]
// 	  if (subject === undefined ) {
// 	  	subject = 'unspecified'
// 	  }
//       english3 += subject + " to " + endingToEnglishTerms[tags[tags.length-1]];
//       } else if (ending.includes('[Intr]')) {
//         english3 += endingToEnglishTerms[tags[tags.length-1]];
//       }
//     } else if (ending.includes('[N]')) {
//       english1 += 'Noun Ending';
//       english2 += endingToEnglishTerms[tags[1]];
//   		if (ending.includes('[Abs]')) {
//   			english4 = ""
//   		} else {
//   			english4 += endingEnglishDescriptions[tags[1]];
//   		}      
//       if (ending.includes('Poss')) {
//         english3 += endingToEnglishTerms[tags[tags.length-2]] + "\xa0" + endingToEnglishTerms[tags[tags.length-1]];
//       } else {
//         english3 += endingToEnglishTerms[tags[tags.length-1]];
//       }
//     } else if (this.state.parses[index].includes('[D')) {
//       english1 += 'Demonstrative';
//       english2 += endingToEnglishTerms[tags[0]];
//       english4 += endingEnglishDescriptions[tags[0]];
//       if (endingToEnglishTerms[tags[1]] !== undefined) {
//       	english3 += endingToEnglishTerms[tags[1]];      	
//       }
//     } else if (this.state.parses[index].includes('[P')) {
//       english1 += 'Personal Pronoun';
//       english2 += endingToEnglishTerms[tags[0]];
//       english4 += endingEnglishDescriptions[tags[0]];
//       english3 += endingToEnglishTerms[tags[1]];      	
//     } else if (this.state.parses[index].includes('[Q')) {
//       english1 = '';
//       english2 += endingToEnglishTerms[tags[0]];
//       english4 += endingEnglishDescriptions[tags[0]];
//       if (endingToEnglishTerms[tags[1]] !== undefined) {
//       	english3 += endingToEnglishTerms[tags[1]];      	
//       }
//     } else {
//       english1 += ending;
//       english2 += endingToEnglishTerms[tags[0]];
//       english4 += endingEnglishDescriptions[tags[0]];
//       if (endingToEnglishTerms[tags[1]] !== undefined) {
//       	english3 += endingToEnglishTerms[tags[1]];      	
//       }	
//     }
//     // var possibleDefinition = this.state.possibleDefinition
//     // var entry = possibleDefinition[index]
//     // entry = entry + '\xa0' + english3
//     // possibleDefinition[index] = entry
//     // this.setState({possibleDefinition:possibleDefinition})
//     return (
//     <div style={{paddingTop:15,paddingLeft:20*qindex}}>
//     <div style={{fontWeight:'bold',fontSize:16,paddingBottom:'1px'}}>{this.state.endingrule[index][1].join(', ')}</div>
//     <div style={{fontSize:16}}>
//     {before && english4.length !== 0 ?
//     <span>
//     {english4+'\xa0'}
//     </span>
//     :
//     null
//     }
//     <span>{english3}</span>
//     {!before ?
//     <span>
//     {'\xa0'+english4}
//     </span>
//     :
//     null
//     }
//     </div>
//     <div onClick={()=>this.setState({showMoreEnding:(this.state.moreIndex !== index || !this.state.showMoreEnding ? true : false),moreIndex:index})}style={{color:'#bdbdbd',fontWeight:'100',paddingTop:10,paddingBottom:10,cursor:'pointer',fontSize:16}}>{'more'}<Icon style={{paddingLeft:5,fontSize:12}} name={this.state.showMoreEnding && index === this.state.moreIndex ? 'chevron up' : 'chevron down'} /></div>
//     {this.state.showMoreEnding && index === this.state.moreIndex ?
//     <div style={{marginLeft:15,fontSize:16}}>
// 	    <div>{english2}</div>
// 	    <div>{english1}</div>
// 	    <div onClick={()=> window.open("http://www.yugtun.com/symbols")} style={{color:'#4183c4',fontWeight:'100',textDecoration:'underline',paddingTop:10, cursor:'pointer'}}>{'Translation and Symbols'}</div>
//     </div>
//     :
//     null
// 	}
//     </div>
//     )
//   }
},{key:'render',// getLinks(index, parse) {
// 	// console.log(parse)
//   if (index === 0) {            // if base
//     if ((parse[index].includes("[P") || parse[index].includes("[I")) && parse.length === 1) {  // if particle or ignorative
//       return parse[index].split("[")[0].replace(/=/g,"-");
//     } else if (parse[index].includes("[PerPro]")) {
//       return parse[index].split("[")[0]
//     } else if (parse[index].includes("[DemPro]") || parse[index].includes("[DemAdv]")) {
//       var dem = parse[index].replace("n[DemPro]","n'a")
//       dem = dem.replace("[DemPro]","na")
//       dem = dem.replace("[DemAdv]","(ni)")
//       return dem
//     } else {
//       var base = parse[0];
//       base = base.split(/\[[^e]/)[0] // remove special tag
//       var dictionaryForm = '';
//       // console.log("getLinks:",base,index,parse)
//       if (parse[1].includes('[N')) {                      // if Noun base:
//         dictionaryForm = base.replace(/([aeiu])te\b/, "$1n");              // Vte -> n
//         dictionaryForm = dictionaryForm.replace(/([^\[])e\b/, "$1a")      // e -> a
//         dictionaryForm = dictionaryForm.replace(/g\b/, "k");      // g -> k
//         dictionaryForm = dictionaryForm.replace(/r(\*)?\b/, "q$1"); // r(*) -> q(*)
//       } else if (parse[1].includes('[V') || parse[1].includes('[Q')) {
//         dictionaryForm = base+"-"       // if Verb or Quant_Qual base 
//       } else {
//         dictionaryForm = base
//       }
//       return dictionaryForm.replace(/=/g,"-");          
//     }
//   } else {
// if (parse[index].includes("ete[N→V]")) {
//     		return "ete[N→V]"
//     	}
//   }
//   // else (["[N→N]","[N→V]","[V→V]","[V→N]","[Encl]"].some(v => parse[index].includes(v))) { //if postbase or enclitic
//   return parse[index];
// }
value:function render(){// console.log("SearchPage state: ", this.state);
// console.log("SearchPage props: ", this.props);
console.log("props history: ",this.props.history);// console.log("fuse.js: ",fuse.search('pissur'))
// console.log("Fuzzysort: ",fuzzysort.go('pissur', dictionary, optionsFuzzy));
// console.log("Fuzzysort_prepared: ",fuzzysort.go('pissur', dictionary_prepared, optionsFuzzy));
// console.log("pissur-[V][Ind][Intr][S_3Sg]=qaa[Encl]".split('-'))
// let displayList = this.state.search.length >= 2 && this.state.wordsList.length > 0;
// let emptyList = this.state.search.length >= 2 && this.state.wordsList.length === 0 && !this.state.yugtunAnalyzer;
// let pressEnter = this.state.search.length > 0 && this.state.yugtunAnalyzer && this.state.newSearchList.length === 0;
// let wordsList = this.state.wordsList;
var activeIndex=this.state.activeIndex;// let isCommonList = wordsList.map((word) => {
//   return Object.keys(word).some((key) => {
//     return word[key].properties && word[key].properties.indexOf('common') > -1;
//   });
// });
// if (this.state.onlyCommon) {
// wordsList = wordsList.filter((word, i) => { return isCommonList[i]; });
// }
// let displayCommonOption = this.state.onlyCommon || (wordsList.some((word, i) => { return isCommonList[i]; }) && wordsList.some((word, i) => { return !isCommonList[i]; }));
var panes=[{menuItem:{content:'Dictionary',size:'massive'}},{menuItem:'Yugtun to English'},{menuItem:'Audio Library'}];var panes2=[{menuItem:{content:'Dictionary',size:'massive'}},{menuItem:'Yugtun to English'},{menuItem:'Audio'}];var tabOptions=[{key:0,text:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'Dictionary')),value:0},{key:1,text:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'Yugtun to English')),value:1},{key:2,text:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'Audio Library')),value:2}];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */],{textAlign:'center',verticalAlign:this.state.searchBarStuckTop?'top':'top'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{height:40,paddingBottom:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Column,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'flex-end',paddingBottom:5}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */],{horizontal:true,divided:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],{style:{textDecoration:'underline',color:'#000000de'},to:'/about'},'About'),' '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],{style:{textDecoration:'underline',color:'#000000de'},to:'/dialogues'},'Dialogues'),' '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],{style:{textDecoration:'underline',color:'#000000de'},to:'/sentencebuilder/1'},'Sentence Builder'),' '))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{paddingTop:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Column,{style:{maxWidth:800,padding:10},textAlign:'left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["m" /* Header */],{as:'h1'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{onClick:this.resetAll,style:{'fontSize':'1.5em',cursor:'pointer'},src:__WEBPACK_IMPORTED_MODULE_7__App_js__["b" /* ICON_URL */]}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{onClick:this.resetAll,style:{color:'black',verticalAlign:'bottom',cursor:'pointer'}},'Yugtun')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["e" /* Container */],{ref:this.search_container,className:'search_container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */],{stackable:true},window.innerWidth<480?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["A" /* Tab */],{style:{paddingTop:15},activeIndex:this.state.activeTabIndex,menu:{secondary:true,pointing:true,size:'large'},panes:panes2,onTabChange:this.handleTabChange}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["A" /* Tab */],{style:{paddingTop:10},activeIndex:this.state.activeTabIndex,menu:{secondary:true,pointing:true,size:'huge'},panes:panes,onTabChange:this.handleTabChange})),this.state.activeTabIndex===0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SearchPageDictionary_js__["a" /* default */],Object.assign({fromTab:this.state.fromTab,dictionary:this.state.dictionary,dictionary_dict:this.state.dictionary_dict,reset:this.state.reset},this.props)):null,this.state.activeTabIndex===1?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__SearchPageYugtunToEnglish_js__["a" /* default */],Object.assign({fromTab:this.state.fromTab,dictionary:this.state.dictionary,dictionary_dict:this.state.dictionary_dict,reset:this.state.reset},this.props)):null,this.state.activeTabIndex===2?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SearchPageAudioLibrary_js__["a" /* default */],Object.assign({fromTab:this.state.fromTab,audiolibrary:this.state.audiolibrary,reset:this.state.reset},this.props)):null)))));}}]);return SearchPage;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchPage);

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);
var bind = __webpack_require__(432);
var Axios = __webpack_require__(853);
var defaults = __webpack_require__(227);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(436);
axios.CancelToken = __webpack_require__(866);
axios.isCancel = __webpack_require__(435);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(867);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 852 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(227);
var utils = __webpack_require__(31);
var InterceptorManager = __webpack_require__(861);
var dispatchRequest = __webpack_require__(862);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(434);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);
var transformData = __webpack_require__(863);
var isCancel = __webpack_require__(435);
var defaults = __webpack_require__(227);
var isAbsoluteURL = __webpack_require__(864);
var combineURLs = __webpack_require__(865);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(31);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(436);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fuzzysort__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_fuzzysort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_fuzzysort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SearchPageHelpers_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_ga4__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { Link } from 'react-router-dom';
// import { API_URL } from '../App.js';
// import Fuse from 'fuse.js';
// import now from 'performance-now';
// import ReactGA from 'react-ga';
// import GitHubForkRibbon from 'react-github-fork-ribbon';
// import TableEntry from './TableEntry.js';
// import {demPro, perPro} from './constants/pronounEndings.js';
// import {endingRules} from './constants/endingRules.js';
__WEBPACK_IMPORTED_MODULE_9_react_ga4___default.a.initialize("G-WDEJDCK7QT");// Cache dictionary
// let dictionary = [];
// let audiolibrary = []
// let dictionary_dict = {};
var optionsFuzzy={keys:['keyString','definitionString'],limit:50,// don't return more results than you need!
threshold:-10000// don't return bad results
};var SearchPageDictionary=function(_Component){_inherits(SearchPageDictionary,_Component);function SearchPageDictionary(props){_classCallCheck(this,SearchPageDictionary);var _this=_possibleConstructorReturn(this,(SearchPageDictionary.__proto__||Object.getPrototypeOf(SearchPageDictionary)).call(this,props));_this.handleRef=function(c){_this.inputRef=c;};_this.resetAll=function(e,data){_this.setState({search:'',wordsList:[]// newSearchList:[],
// parses:[],
// segments:[],
// searchWord:"",
// notFirstParse:false,
});};console.log("SearchPageDictionary props: ",props);_this.state={// dictionary: [],
// dictionary_dict: {},
// dictionaryNouns: [],
// dictionaryVerbs: [],
wordsList:[],playingAudio:false,// yugtunAnalyzer: props.location.state === undefined ? false : props.location.state.yugtunAnalyzer,
search:props.location.state===undefined?'':props.location.state.search,// currentWord: {},
// onlyCommon: false,
startingSearch:true,// smallestParseIndex: -1,
// parses: props.location.state === undefined ? [] : props.location.state.parses,
// segments: props.location.state === undefined ? [] : props.location.state.segments,
// endingrule: props.location.state === undefined ? [] : props.location.state.endingrule,
// parses:[],
// segments:[],
// endingrule:[],
// currentTableOpen: -1,
// getCall:false,
// notFirstParse: false,
// searchBarStuckTop: false,
searchBarStuckTop:props.location.state===undefined?false:props.location.state.searchBarStuckTop// notFirstParse: props.location.state === undefined ? false : props.location.state.notFirstParse,
// searchWord: props.location.state === undefined ? "" : props.location.state.searchWord,
// activeSentenceIndex: props.location.state === undefined ? 0 : props.location.state.activeSentenceIndex,
// exampleSentenceSearch: false,
// smallestParse:[[],[]],
// segmentOutputList:[],
// searchWord:"",
// activeSentenceIndex: 0,
// activeTabIndex:0,
// showMoreEnding: false,
// moreIndex:-1,
// updateSearchEntry: props.location.state === undefined ? false : props.location.state.updateSearchEntry,
// activeTabIndex: props.location.state === undefined ? 0 : props.location.state.activeTabIndex,
// exampleSentenceSearch: props.location.state === undefined ? false : props.location.state.exampleSentenceSearch,
// newSearchList: props.location.state === undefined ? [] : props.location.state.newSearchList,
// activeIndex:-1,
// loaderOn:true,
// entries:undefined,
// hover:-1,
// seeMoreActive:false,
// segment: "",
// possibleDefinition: ["","","","","","","","","",""],
// moods: ["[Ind]","[Intrg]","[Opt]","[Sbrd]","[Ptcp]","[Prec]","[Cnsq]","[Cont]","[Conc]","[Cond]","[CtmpI]","[CtmpII]","[Abs]","[Rel]","[Abl_Mod]","[Loc]", "[Ter]","[Via]","[Equ]","%5BQuant_Qual%5D","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]",],
// this.getParse = this.getParse.bind(this);
};_this.onChangeSearch=_this.onChangeSearch.bind(_this);// this.selectWord = this.selectWord.bind(this);
_this.search_container=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createRef();// this.getEndings = this.getEndings.bind(this);
// this.getLinks = this.getLinks.bind(this);
// this.inputClicked = this.inputClicked.bind(this);
return _this;}_createClass(SearchPageDictionary,[{key:'componentDidMount',value:function componentDidMount(){window.history.replaceState({},document.title);this.resetAll();}//   let start = now();
//   if (this.state.updateSearchEntry) {
//     this.inputClicked();
//     this.setState({ updateSearchEntry: false });
//   }
// if (dictionary.length === 0) {
//   axios
//     .get(API_URL + "/word/all2021")
//     .then(response => {
//       let end = now();
//       ReactGA.timing({
//         category: 'Loading',
//         variable: 'dictionary',
//         value: (end-start).toFixed(3),
//         label: 'Dictionary loading'
//       });
//       dictionary = response.data;
//       // fuse.setCollection(dictionary);
//       // fuse1.setCollection(dictionary);
//       console.log('Fetched dictionary');
//       dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
//       // dictionary_prepared = fuzzysort.prepare(dictionary)
//       this.setState({ dictionary: dictionary });
//     });
//   // axios
//   //   .get(API_URL + "/audiolibrary/all")
//   //   .then(response => {
//   //     // let end = now();
//   //     // ReactGA.timing({
//   //     //   category: 'Loading',
//   //     //   variable: 'dictionary',
//   //     //   value: (end-start).toFixed(3),
//   //     //   label: 'Dictionary loading'
//   //     // });
//   //     audiolibrary = response.data;
//   //     // fuse.setCollection(dictionary);
//   //     // fuse1.setCollection(dictionary);
//   //     console.log('Fetched AudioLibrary');
//   //     // dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
//   //     // dictionary_prepared = fuzzysort.prepare(dictionary)
//   //     this.setState({ audiolibrary: audiolibrary });
//   //   });
// }
// else {
//   // fuse.setCollection(dictionary);
//   this.setState({ dictionary: dictionary });
// }
// }
},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// if (prevState.dictionary.length !== this.state.dictionary.length) {
//   this.onChangeSearch(undefined, {value: this.state.search});
// }
if(this.props.reset!==prevProps.reset){this.resetAll();}// if (this.props.location.state.activeTabIndex !== prevProps.activeTabIndex) {
//   this.resetAll()      
//   console.log('hi')
// }
// if (this.props.dictionary.length !== this.state.dictionary.length) {
//   this.setState({dictionary:this.props.dictionary});
//   this.setState({dictionary_dict:this.props.dictionary_dict})
// }
if(prevState.search!==this.state.search){this.setState({searchBarStuckTop:true});}if(prevState.startingSearch&&!this.state.startingSearch){if(navigator.userAgent.match(/(iPhone|iPod|iPad)/i)){var elts=__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this).getElementsByClassName('search_container');if(elts.length>0){elts[0].scrollIntoView();}}}}// getParse(word) {
//   if (word === "") {
//     this.setState({
//         parses: [],
//         segments: [],
//         endingrule: [],
//         getCall:false,
//       })
//   } else {
//   axios
//     .get(API_URL + "/parse/" + word)
//     .then(response => {
//       // console.log(response)
//       //  var lowest = 0;
//        // var a = response.data.parses;
//       //  for (var i = 1; i < a.length; i++) {
//       //   if (a[i].length < a[lowest].length) 
//       //     lowest = i;
//       //  }
//       // console.log(a)
//       // let sortedParses = response.data.parses.sort(function(a,b){return a.length - b.length;}).slice(0, 5)
//       // console.log(sortedParses)
//       this.setState({
//         parses: response.data.parses,
//         segments: response.data.segments,
//         endingrule: response.data.endingrule,
//         getCall:false,
//     	})
//       // let segmentOutputList = [];
//       // sortedParses.map((i,index)=>
//       //   this.getSegment(i)
//       //   )
//       // console.log(segmentOutputList)
//       // if (a.length > 0) {
//       // 	this.setState({
//       //    smallestParseIndex: lowest,
//       //    smallestParse: response.data.parses[lowest].split('-'),
//       //  });
//         // this.getSegment(response.data.parses[lowest])
//      // }
//     });
//   }
// }
// getSegment(word) {
//   axios
//     .get(API_URL + "/segment/" + encodeURIComponent(word))
//     .then(response => {
//       // return response.data.words[0]
//       console.log(response)
//       // this.setState({
//         // segment: response.data.words[0],
//       // })
//     });
// }
// getEndings(word, mood) {
//   console.log("Word",word,mood)
//   axios
//     .get(API_URL + "/mood?underlying_form=" + encodeURIComponent(word) + "&mood=" + mood)
//     .then(response => {
//       this.setState({ entries: response.data.results,}); 
//       this.setState({ loaderOn: false})
//   });
// }
},{key:'onChangeSearch',value:function onChangeSearch(event,data){// this.setState({entries:undefined, activeIndex:-1, loaderOn: true, seeMoreActive:false,currentTableOpen: -1,})
var newStartingSearch=event===undefined;var new_search=data.value.replace("’","'").replace("0","⁰").replace("1","¹").replace("2","²").replace("3","³").replace("4","⁴").replace("5","⁵").replace("6","⁶").replace("7","⁷").replace("8","⁸").replace("9","⁹");// console.log(new_search)
// if (data.value === undefined) {new_search = this.state.search}
var wordsList=__WEBPACK_IMPORTED_MODULE_6_fuzzysort___default.a.go(new_search,this.props.dictionary,optionsFuzzy).map(function(_ref){var obj=_ref.obj;return obj;});this.setState({startingSearch:newStartingSearch,wordsList:wordsList,search:new_search});// if (new_search.length >= 4 && !this.state.yugtunAnalyzer) {
//   ReactGA.event({
//     category: 'User',
//     action: 'Search word',
//     label: new_search
//   });
//   let start = now();
//   let wordsList = fuse.search(new_search);
//   let end = now();
//   console.log('done! in ', (end-start).toFixed(3), 'ms');
//   ReactGA.timing({
//     category: 'Search',
//     variable: 'fuse.search',
//     value: (end-start).toFixed(3),
//     label:'Fuse.js search duration'
//   });
//   this.setState({ startingSearch: newStartingSearch, wordsList: wordsList, search: new_search });
// }
// else {
//   this.setState({ startingSearch: newStartingSearch, search: new_search });
// }
}// selectWord(word, event) {
//   this.setState({ currentWord: word });
// }
// resetCurrentWord(event, data) {
//   this.setState({ currentWord: {} });
// }
// handleClick = (e, titleProps) => {
//   // console.log(e,titleProps)
//   this.setState({ loaderOn: true,})
//   const { index, currentIndex } = titleProps
//   const { activeIndex } = this.state
//   const newIndex = activeIndex === index ? -1 : index
//   let mood = this.state.moods[index]
//   this.getEndings(this.state.parses[currentIndex],mood)
//   this.setState({activeIndex: newIndex, mood: mood})
// }
// handleClick2 = (e, titleProps) => {
//   // console.log(e,titleProps)
//   const { index, currentIndex } = titleProps
//   const { activeIndex } = this.state
//   const newIndex = activeIndex === index ? -1 : index
//   console.log(index)
//   let mood = this.state.moods[index]
//   // console.log(mood)
//   this.setState({loaderOn:false, entries: (mood === "[DemPro]" ? demPro: perPro), activeIndex: newIndex, mood: mood})
// }
// onKeyPress = (e) => {
//   if(e.key === 'Enter') {//} && (this.state.activeTabIndex === 0 || this.state.search !== this.state.searchWord)){
//     // if (!this.state.yugtunAnalyzer && this.state.parses.length === 0) {this.setState({getCall:true})}
//     // this.setState({ yugtunAnalyzer: !this.state.yugtunAnalyzer}); 
//     // if (this.state.yugtunAnalyzer) {
//       // this.setState({activeTabsIndex:1})
//       this.inputClicked(true)
//     // }
//   }
// }
// inputClicked(search) {
//   this.setState({entries:undefined, activeIndex:-1, loaderOn: true, seeMoreActive:false,currentTableOpen: -1,yugtunAnalyzer:true,showMoreEnding: false,})
//   // console.log(search)
//   if (search === undefined || search === true) {
//   	search = this.state.search
//   }
//   console.log(search)
//   if (search.length > 0) {
//     this.setState({ 
//       newSearchList: search.split(" "), 
//       activeSentenceIndex: 0, 
//       searchWord: search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g, "").toLowerCase(),
//       getCall:true,
//       // notFirstParse:true,
//     }); 
//     this.getParse(search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g, "").toLowerCase());                          
//   } 
//   //   this.inputRef.focus();
//   //   this.setState({
//   //     search: '', startingSearch: false
//   //   });
//   // }
// }
},{key:'repeatAudio',// handleTabChange = (e,data) => {
//   // console.log(data.activeIndex, this.state.activeIndex)
//   if (data.activeIndex === 0 && this.state.activeTabIndex !== 0) {
//     this.setState({ yugtunAnalyzer: false, activeTabIndex:0,parses:[],segments:[],endingrule:[],newSearchList:[],notFirstParse:false,search:""})
//   } else if (data.activeIndex === 1 && this.state.activeTabIndex !== 1) {
//     // if (!this.state.yugtunAnalyzer) {
//     this.setState({ yugtunAnalyzer: true, activeTabIndex:1, parses:[],segments:[],endingrule:[],newSearchList:[],notFirstParse:false,search:""});                     
//     // this.inputClicked()
//     // }
//   }
// }
// getLinks(index, parse) {
// 	// console.log(parse)
//   if (index === 0) {            // if base
//     if ((parse[index].includes("[P") || parse[index].includes("[I")) && parse.length === 1) {  // if particle or ignorative
//       return parse[index].split("[")[0].replace(/=/g,"-");
//     } else if (parse[index].includes("[PerPro]")) {
//       return parse[index].split("[")[0]
//     } else if (parse[index].includes("[DemPro]") || parse[index].includes("[DemAdv]")) {
//       var dem = parse[index].replace("n[DemPro]","n'a")
//       dem = dem.replace("[DemPro]","na")
//       dem = dem.replace("[DemAdv]","(ni)")
//       return dem
//     } else {
//       var base = parse[0];
//       base = base.split(/\[[^e]/)[0] // remove special tag
//       var dictionaryForm = '';
//       // console.log("getLinks:",base,index,parse)
//       if (parse[1].includes('[N')) {                      // if Noun base:
//         dictionaryForm = base.replace(/([aeiu])te\b/, "$1n");              // Vte -> n
//         dictionaryForm = dictionaryForm.replace(/([^\[])e\b/, "$1a")      // e -> a
//         dictionaryForm = dictionaryForm.replace(/g\b/, "k");      // g -> k
//         dictionaryForm = dictionaryForm.replace(/r(\*)?\b/, "q$1"); // r(*) -> q(*)
//       } else if (parse[1].includes('[V') || parse[1].includes('[Q')) {
//         dictionaryForm = base+"-"       // if Verb or Quant_Qual base 
//       } else {
//         dictionaryForm = base
//       }
//       return dictionaryForm.replace(/=/g,"-");          
//     }
//   } else {
// if (parse[index].includes("ete[N→V]")) {
//     		return "ete[N→V]"
//     	}
//   }
//   // else (["[N→N]","[N→V]","[V→V]","[V→N]","[Encl]"].some(v => parse[index].includes(v))) { //if postbase or enclitic
//   return parse[index];
// }
value:function repeatAudio(audio,event,data){var _this2=this;console.log(audio,this.state.playingAudio);if(!this.state.playingAudio){var sound=new Audio(__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/yugtunCrowdsourceAudio/"+audio);this.setState({playingAudio:true});sound.play();sound.onended=function(){_this2.setState({playingAudio:false});};}}},{key:'render',value:function render(){var _this3=this;// console.log("SearchPage state: ", this.state);
// console.log("props:",this.props)
// console.log("dictionary: ",dictionary_dict);
// console.log("fuse.js: ",fuse.search('pissur'))
// console.log("Fuzzysort: ",fuzzysort.go('pissur', dictionary, optionsFuzzy));
// console.log("Fuzzysort_prepared: ",fuzzysort.go('pissur', dictionary_prepared, optionsFuzzy));
// console.log("pissur-[V][Ind][Intr][S_3Sg]=qaa[Encl]".split('-'))
var displayList=this.state.search.length>=2&&this.state.wordsList.length>0;var emptyList=this.state.search.length>=2&&this.state.wordsList.length===0;// let pressEnter = this.state.search.length > 0 && this.state.yugtunAnalyzer && this.state.newSearchList.length === 0;
var wordsList=this.state.wordsList;// const { activeIndex } = this.state
// let isCommonList = wordsList.map((word) => {
//   return Object.keys(word).some((key) => {
//     return word[key].properties && word[key].properties.indexOf('common') > -1;
//   });
// });
// if (this.state.onlyCommon) {
//   wordsList = wordsList.filter((word, i) => { return isCommonList[i]; });
// }
// let displayCommonOption = this.state.onlyCommon || (wordsList.some((word, i) => { return isCommonList[i]; }) && wordsList.some((word, i) => { return !isCommonList[i]; }));
return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{paddingBottom:14}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Column,{style:{flex:1,paddingLeft:0,paddingRight:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["p" /* Input */],{ref:this.handleRef,placeholder:'Search a word...',disabled:this.props.dictionary.length===0// action={{ icon: (this.state.yugtunAnalyzer ? 'search' : null), transparent:true,size:'huge', onClick: () => 
// {this.state.yugtunAnalyzer ? this.inputClicked() : null}
// }}
// icon={<Icon name='x' onClick={console.log('hi')} link />}
// iconPosition='right'
// action={{ icon:'x', transparent:true,size:'huge', onClick: () => this.inputClicked()}}
// // icon={<Icon name='search' onClick={console.log('hi')} link />}
// iconPosition='right'
,size:'huge',onChange:this.onChangeSearch,value:this.state.search// onKeyPress={this.onKeyPress}
,fluid:true}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{display:'flex',justifyContent:'center',padding:0,paddingLeft:window.innerWidth<480?7:16,paddingRight:window.innerWidth<480?7:16}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */],{style:{width:'100%'},divided:true},displayList?wordsList.map(function(word){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SearchPageHelpers_js__["b" /* WordItemLikeInup */],{repeatAudio:_this3.repeatAudio.bind(_this3),key:word,word:word,search:_this3.state.search,wordsList:_this3.state.wordsList});}):this.state.search.length===0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',paddingLeft:window.innerWidth<480?7:0,paddingRight:window.innerWidth<480?7:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontSize:'1.2rem',color:'#666',lineHeight:1.6,maxWidth:500}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{textDecoration:'underline',marginBottom:10,marginTop:15}},' Dictionary '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginBottom:10}},' Type any English word or Yugtun base and the matching dictionary entries will show automatically.'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,' Examples: '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{onClick:function onClick(){_this3.setState({search:'pissur',wordsList:__WEBPACK_IMPORTED_MODULE_6_fuzzysort___default.a.go('pissur',_this3.props.dictionary,optionsFuzzy).map(function(_ref2){var obj=_ref2.obj;return obj;}),newStartingSearch:true});},style:{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}},'pissur-'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,', '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{onClick:function onClick(){_this3.setState({search:'akutaq',wordsList:__WEBPACK_IMPORTED_MODULE_6_fuzzysort___default.a.go('akutaq',_this3.props.dictionary,optionsFuzzy).map(function(_ref3){var obj=_ref3.obj;return obj;}),newStartingSearch:true});},style:{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}},'akutaq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,', '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{onClick:function onClick(){_this3.setState({search:'book',wordsList:__WEBPACK_IMPORTED_MODULE_6_fuzzysort___default.a.go('book',_this3.props.dictionary,optionsFuzzy).map(function(_ref4){var obj=_ref4.obj;return obj;}),newStartingSearch:true});},style:{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}},'book'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,', '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{onClick:function onClick(){_this3.setState({search:'Christmas',wordsList:__WEBPACK_IMPORTED_MODULE_6_fuzzysort___default.a.go('Christmas',_this3.props.dictionary,optionsFuzzy).map(function(_ref5){var obj=_ref5.obj;return obj;}),newStartingSearch:true});},style:{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}},'Christmas'))))):null,displayList?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["g" /* Divider */],{style:{paddingBottom:0,marginTop:'3px'}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-evenly',alignItems:'center',height:60,paddingBottom:16}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}))):null,emptyList?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',null,'Aren, no matches... for English you can only search by word... for Yugtun try Yugtun to English mode...')):'')));}}]);return SearchPageDictionary;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchPageDictionary);

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(870);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54), __webpack_require__(228)))

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GA4 = void 0;
var _gtag = _interopRequireDefault(__webpack_require__(872));
var _format = _interopRequireDefault(__webpack_require__(873));
var _excluded = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"],
  _excluded2 = ["title", "location"],
  _excluded3 = ["page", "hitType"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/
/**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */
/**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */
/**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */
var GA4 = /*#__PURE__*/function () {
  function GA4() {
    var _this = this;
    _classCallCheck(this, GA4);
    _defineProperty(this, "reset", function () {
      _this.isInitialized = false;
      _this._testMode = false;
      _this._currentMeasurementId;
      _this._hasLoadedGA = false;
      _this._isQueuing = false;
      _this._queueGtag = [];
    });
    _defineProperty(this, "_gtag", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (!_this._testMode) {
        if (_this._isQueuing) {
          _this._queueGtag.push(args);
        } else {
          _gtag["default"].apply(void 0, args);
        }
      } else {
        _this._queueGtag.push(args);
      }
    });
    _defineProperty(this, "_loadGA", function (GA_MEASUREMENT_ID, nonce) {
      var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
      if (typeof window === "undefined" || typeof document === "undefined") {
        return;
      }
      if (!_this._hasLoadedGA) {
        // Global Site Tag (gtag.js) - Google Analytics
        var script = document.createElement("script");
        script.async = true;
        script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
        if (nonce) {
          script.setAttribute("nonce", nonce);
        }
        document.body.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
        _this._hasLoadedGA = true;
      }
    });
    _defineProperty(this, "_toGtagOptions", function (gaOptions) {
      if (!gaOptions) {
        return;
      }
      var mapFields = {
        // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
        // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
        cookieUpdate: "cookie_update",
        cookieExpires: "cookie_expires",
        cookieDomain: "cookie_domain",
        cookieFlags: "cookie_flags",
        // must be in set method?
        userId: "user_id",
        clientId: "client_id",
        anonymizeIp: "anonymize_ip",
        // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
        contentGroup1: "content_group1",
        contentGroup2: "content_group2",
        contentGroup3: "content_group3",
        contentGroup4: "content_group4",
        contentGroup5: "content_group5",
        // https://support.google.com/analytics/answer/9050852?hl=en
        allowAdFeatures: "allow_google_signals",
        allowAdPersonalizationSignals: "allow_ad_personalization_signals",
        nonInteraction: "non_interaction",
        page: "page_path",
        hitCallback: "event_callback"
      };
      var gtagOptions = Object.entries(gaOptions).reduce(function (prev, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (mapFields[key]) {
          prev[mapFields[key]] = value;
        } else {
          prev[key] = value;
        }
        return prev;
      }, {});
      return gtagOptions;
    });
    _defineProperty(this, "initialize", function (GA_MEASUREMENT_ID) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!GA_MEASUREMENT_ID) {
        throw new Error("Require GA_MEASUREMENT_ID");
      }
      var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [{
        trackingId: GA_MEASUREMENT_ID
      }] : GA_MEASUREMENT_ID;
      _this._currentMeasurementId = initConfigs[0].trackingId;
      var gaOptions = options.gaOptions,
        gtagOptions = options.gtagOptions,
        nonce = options.nonce,
        _options$testMode = options.testMode,
        testMode = _options$testMode === void 0 ? false : _options$testMode,
        gtagUrl = options.gtagUrl;
      _this._testMode = testMode;
      if (!testMode) {
        _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
      }
      if (!_this.isInitialized) {
        _this._gtag("js", new Date());
        initConfigs.forEach(function (config) {
          var mergedGtagOptions = _objectSpread(_objectSpread(_objectSpread({}, _this._toGtagOptions(_objectSpread(_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
          if (Object.keys(mergedGtagOptions).length) {
            _this._gtag("config", config.trackingId, mergedGtagOptions);
          } else {
            _this._gtag("config", config.trackingId);
          }
        });
      }
      _this.isInitialized = true;
      if (!testMode) {
        var queues = _toConsumableArray(_this._queueGtag);
        _this._queueGtag = [];
        _this._isQueuing = false;
        while (queues.length) {
          var queue = queues.shift();
          _this._gtag.apply(_this, _toConsumableArray(queue));
          if (queue[0] === "get") {
            _this._isQueuing = true;
          }
        }
      }
    });
    _defineProperty(this, "set", function (fieldsObject) {
      if (!fieldsObject) {
        console.warn("`fieldsObject` is required in .set()");
        return;
      }
      if (_typeof(fieldsObject) !== "object") {
        console.warn("Expected `fieldsObject` arg to be an Object");
        return;
      }
      if (Object.keys(fieldsObject).length === 0) {
        console.warn("empty `fieldsObject` given to .set()");
      }
      _this._gaCommand("set", fieldsObject);
    });
    _defineProperty(this, "_gaCommandSendEvent", function (eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
      _this._gtag("event", eventAction, _objectSpread(_objectSpread({
        event_category: eventCategory,
        event_label: eventLabel,
        value: eventValue
      }, fieldsObject && {
        non_interaction: fieldsObject.nonInteraction
      }), _this._toGtagOptions(fieldsObject)));
    });
    _defineProperty(this, "_gaCommandSendEventParameters", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendEvent.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$ = args[0],
          eventCategory = _args$.eventCategory,
          eventAction = _args$.eventAction,
          eventLabel = _args$.eventLabel,
          eventValue = _args$.eventValue,
          hitType = _args$.hitType,
          rest = _objectWithoutProperties(_args$, _excluded);
        _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
      }
    });
    _defineProperty(this, "_gaCommandSendTiming", function (timingCategory, timingVar, timingValue, timingLabel) {
      _this._gtag("event", "timing_complete", {
        name: timingVar,
        value: timingValue,
        event_category: timingCategory,
        event_label: timingLabel
      });
    });
    _defineProperty(this, "_gaCommandSendPageview", function (page, fieldsObject) {
      if (fieldsObject && Object.keys(fieldsObject).length) {
        var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject),
          title = _this$_toGtagOptions.title,
          location = _this$_toGtagOptions.location,
          rest = _objectWithoutProperties(_this$_toGtagOptions, _excluded2);
        _this._gtag("event", "page_view", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, page && {
          page_path: page
        }), title && {
          page_title: title
        }), location && {
          page_location: location
        }), rest));
      } else if (page) {
        _this._gtag("event", "page_view", {
          page_path: page
        });
      } else {
        _this._gtag("event", "page_view");
      }
    });
    _defineProperty(this, "_gaCommandSendPageviewParameters", function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendPageview.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$2 = args[0],
          page = _args$2.page,
          hitType = _args$2.hitType,
          rest = _objectWithoutProperties(_args$2, _excluded3);
        _this._gaCommandSendPageview(page, rest);
      }
    });
    _defineProperty(this, "_gaCommandSend", function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
      switch (hitType) {
        case "event":
          _this._gaCommandSendEventParameters.apply(_this, args);
          break;
        case "pageview":
          _this._gaCommandSendPageviewParameters.apply(_this, args);
          break;
        case "timing":
          _this._gaCommandSendTiming.apply(_this, _toConsumableArray(args.slice(1)));
          break;
        case "screenview":
        case "transaction":
        case "item":
        case "social":
        case "exception":
          console.warn("Unsupported send command: ".concat(hitType));
          break;
        default:
          console.warn("Send command doesn't exist: ".concat(hitType));
      }
    });
    _defineProperty(this, "_gaCommandSet", function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      if (typeof args[0] === "string") {
        args[0] = _defineProperty({}, args[0], args[1]);
      }
      _this._gtag("set", _this._toGtagOptions(args[0]));
    });
    _defineProperty(this, "_gaCommand", function (command) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      switch (command) {
        case "send":
          _this._gaCommandSend.apply(_this, args);
          break;
        case "set":
          _this._gaCommandSet.apply(_this, args);
          break;
        default:
          console.warn("Command doesn't exist: ".concat(command));
      }
    });
    _defineProperty(this, "ga", function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      if (typeof args[0] === "string") {
        _this._gaCommand.apply(_this, args);
      } else {
        var readyCallback = args[0];
        _this._gtag("get", _this._currentMeasurementId, "client_id", function (clientId) {
          _this._isQueuing = false;
          var queues = _this._queueGtag;
          readyCallback({
            get: function get(property) {
              return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
            }
          });
          while (queues.length) {
            var queue = queues.shift();
            _this._gtag.apply(_this, _toConsumableArray(queue));
          }
        });
        _this._isQueuing = true;
      }
      return _this.ga;
    });
    _defineProperty(this, "event", function (optionsOrName, params) {
      if (typeof optionsOrName === "string") {
        _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
      } else {
        var action = optionsOrName.action,
          category = optionsOrName.category,
          label = optionsOrName.label,
          value = optionsOrName.value,
          nonInteraction = optionsOrName.nonInteraction,
          transport = optionsOrName.transport;
        if (!category || !action) {
          console.warn("args.category AND args.action are required in event()");
          return;
        }

        // Required Fields
        var fieldObject = {
          hitType: "event",
          eventCategory: (0, _format["default"])(category),
          eventAction: (0, _format["default"])(action)
        };

        // Optional Fields
        if (label) {
          fieldObject.eventLabel = (0, _format["default"])(label);
        }
        if (typeof value !== "undefined") {
          if (typeof value !== "number") {
            console.warn("Expected `args.value` arg to be a Number.");
          } else {
            fieldObject.eventValue = value;
          }
        }
        if (typeof nonInteraction !== "undefined") {
          if (typeof nonInteraction !== "boolean") {
            console.warn("`args.nonInteraction` must be a boolean.");
          } else {
            fieldObject.nonInteraction = nonInteraction;
          }
        }
        if (typeof transport !== "undefined") {
          if (typeof transport !== "string") {
            console.warn("`args.transport` must be a string.");
          } else {
            if (["beacon", "xhr", "image"].indexOf(transport) === -1) {
              console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
            }
            fieldObject.transport = transport;
          }
        }
        _this._gaCommand("send", fieldObject);
      }
    });
    _defineProperty(this, "send", function (fieldObject) {
      _this._gaCommand("send", fieldObject);
    });
    this.reset();
  }
  _createClass(GA4, [{
    key: "gtag",
    value: function gtag() {
      this._gtag.apply(this, arguments);
    }
  }]);
  return GA4;
}();
exports.GA4 = GA4;
var _default = new GA4();
exports["default"] = _default;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var gtag = function gtag() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof window !== "undefined") {
    var _window;
    if (typeof window.gtag === "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
    (_window = window).gtag.apply(_window, args);
  }
};
var _default = gtag;
exports["default"] = _default;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = format;
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }
    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }
    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === "string" && s.indexOf("@") !== -1;
}
var redacted = "REDACTED (Potential Email Address)";
function redactEmail(string) {
  if (mightBeEmail(string)) {
    console.warn("This arg looks like an email address, redacting.");
    return redacted;
  }
  return string;
}
function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var _str = s || "";
  if (titleCase) {
    _str = toTitleCase(s);
  }
  if (redactingEmail) {
    _str = redactEmail(_str);
  }
  return _str;
}

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fuzzysort__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fuzzysort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_fuzzysort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_performance_now__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_performance_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_performance_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SearchPageHelpers_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_ga4__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Fuse from 'fuse.js';
// import ReactGA from 'react-ga';
// import GitHubForkRibbon from 'react-github-fork-ribbon';
// import TableEntry from './TableEntry.js';
// import {demPro, perPro} from './constants/pronounEndings.js';
// import {endingRules} from './constants/endingRules.js';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
__WEBPACK_IMPORTED_MODULE_11_react_ga4___default.a.initialize("G-WDEJDCK7QT");var WEB_URL="https://yuarcuun.inupiaqonline.com";var KYUK_URL='https://archive.kyuk.org';// Cache dictionary
// let dictionary = [];
// let audiolibrary = []
// let dictionary_dict = {};
// let dictionary_prepared = [];
// Search options
// let options = {
//   keys: ['yupik', 'english'],
//   minMatchCharLength: 3,
//   // includeScore: true,
//   distance: 10,
//   location: 2,
//   shouldSort: true,
//   //tokenize: true, // super slow!! 6x slower
//   // matchAllTokens: true,
//   threshold: 0.4,
//   findAllMatches: true,
// };
// let fuse = new Fuse([], options);
// let options1 = {
//   keys: ['yupik'],
//   // minMatchCharLength: 3,
//   // includeScore: true,
//   distance: 0,
//   // location: 2,
//   // shouldSort: true,
//   //tokenize: true, // super slow!! 6x slower
//   // matchAllTokens: true,
//   threshold: 0.0,
//   // findAllMatches: true,
// };
// let fuse1 = new Fuse([], options1);
// fuzzysort search
var optionsFuzzy={keys:['y','e'],limit:50,// don't return more results than you need!
threshold:-10000// don't return bad results
};// const endingToEnglishTerms = {
//   "[Ind]":"Indicative (Statement Form)",
//   "[Intrg]":"Interrogative (Question Form)",
//   "[Opt]":"Optative (Command Form)",
//   "[Sbrd]":"Subordinative (Polite Command or -ing Form)",
//   "[Ptcp]":"Participial",
//   "[Prec]":"Precessive (before...)",
//   "[Cnsq]":"Consequential (because...)",
//   "[Cont]":"Contigent (whenever...)",
//   "[Conc]":"Concessive (although, even though, even if...)",
//   "[Cond]":"Conditional (if, when in the future...)",
//   "[CtmpI]":"Contemporative 1 (when in fthe past...)",
//   "[CtmpII]":"Contemporative 2 (while...)",
//   "[Abs]":"Absolutive",
//   "[Rel]":"Relative",
//   "[Abl_Mod]":"Ablative-Modalis (indirect object, from...)",
//   "[Loc]":"Localis (in, at...)",
//   "[Ter]":"Terminalis (toward...)",
//   "[Via]":"Vialis (through, using...)",
//   "[Equ]":"Equalis (like, similar to...)",
//   "[Quant_Qual]":"Quantifier/Qualifier Inflection",
//   "[S_3Sg]":"he,\xa0she,\xa0it",
//   "[S_3Du]":"they\xa0(2)",
//   "[S_3Pl]":"they\xa0all\xa0(3+)",
//   "[S_1Sg]":"I",
//   "[S_1Du]":"we\xa0(2)",
//   "[S_1Pl]":"we\xa0all\xa0(3+)",
//   "[S_2Sg]":"you",
//   "[S_2Du]":"you\xa0(2)",
//   "[S_2Pl]":"you\xa0all\xa0(3+)",
//   "[S_4Sg]":"he, she, it (itself)",
//   "[S_4Du]":"they (2) (themselves)",
//   "[S_4Pl]":"they all (3+) (themselves)",
//   "[A_3Sg]":"he,\xa0she,\xa0it",
//   "[A_3Du]":"they\xa0(2)",
//   "[A_3Pl]":"they\xa0all\xa0(3+)",
//   "[A_1Sg]":"I",
//   "[A_1Du]":"we\xa0(2)",
//   "[A_1Pl]":"we\xa0all\xa0(3+)",
//   "[A_2Sg]":"you",
//   "[A_2Du]":"you\xa0(2)",
//   "[A_2Pl]":"you\xa0all\xa0(3+)",
//   "[A_4Sg]":"he, she, it (itself)",
//   "[A_4Du]":"they (2) (themselves)",
//   "[A_4Pl]":"they all (3+) (themselves)",
// //   "[P_3Sg]":"her,\xa0him,\xa0it\xa0(other)",
// //   "[P_3Du]":"the\xa0two\xa0of\xa0them\xa0(others)",
// //   "[P_3Pl]":"them\xa0all\xa0(3+)\xa0(others)",
//   "[P_3Sg]":"another",
//   "[P_3Du]":"two others",
//   "[P_3Pl]":"3+ others",
//   "[P_1Sg]":"me",
//   "[P_1Du]":"the\xa0two\xa0of\xa0us",
//   "[P_1Pl]":"us\xa0all\xa0(3+)",
//   "[P_2Sg]":"you",
//   "[P_2Du]":"the\xa0two\xa0of\xa0you",
//   "[P_2Pl]":"you\xa0all\xa0(3+)",
//   "[P_4Sg]":"her,\xa0him,\xa0it\xa0(itself)",
//   "[P_4Du]":"the\xa0two\xa0of\xa0them\xa0(themselves)",
//   "[P_4Pl]":"them\xa0all\xa0(3+)\xa0(themselves)",
//   "[SgUnpd]":"the one",
//   "[DuUnpd]":"the two",
//   "[PlUnpd]":"the 3+",
//   "[SgPosd]":"one",
//   "[DuPosd]":"two",
//   "[PlPosd]":"three or more",
//   "[3SgPoss]":"his/her/its\xa0(other)",
//   "[3DuPoss]":"their\xa0(2)\xa0(other)",
//   "[3PlPoss]":"their\xa0(3+)\xa0(other)",
//   "[1SgPoss]":"my",
//   "[1DuPoss]":"our\xa0(2)",
//   "[1PlPoss]":"our\xa0(3+)",
//   "[2SgPoss]":"your\xa0(1)",
//   "[2DuPoss]":"your\xa0(2)",
//   "[2PlPoss]":"your\xa0(3+)",
//   "[4SgPoss]":"his/her/its\xa0own",
//   "[4DuPoss]":"their\xa0own\xa0(2)",
//   "[4PlPoss]":"their\xa0own\xa0(3+)",
//   "[3Sg]":"it\xa0(other)",
//   "[3Du]":"them\xa0(2)\xa0(other)",
//   "[3Pl]":"them\xa0(3+)\xa0(other)",
//   "[1Sg]":"me",
//   "[1Du]":"us\xa0(2)",
//   "[1Pl]":"us\xa0(3+)",
//   "[2Sg]":"you\xa0(1)",
//   "[2Du]":"you\xa0(2)",
//   "[2Pl]":"you\xa0(3+)",
//   "[4Sg]":"itself",
//   "[4Du]":"themselves\xa0(2)",
//   "[4Pl]":"themselves\xa0(3+)",
// };
// const endingEnglishDescriptions = {
//   "[Ind]":"(is, are, am)",
//   "[Intrg]":"(question)",
//   "[Opt]":"(do it!)",
//   "[Sbrd]":"(please do, being)",
//   "[Ptcp]":"(the one being, special case)",
//   "[Prec]":"(before)",
//   "[Cnsq]":"(because)",
//   "[Cont]":"(whenever)",
//   "[Conc]":"(although, even if)",
//   "[Cond]":"(if, when in future)",
//   "[CtmpI]":"(when in past)",
//   "[CtmpII]":"(while)",
//   "[Abs]":"the",
//   "[Rel]":"the",
//   "[Abl_Mod]":"[a, some, from]",
//   "[Loc]":"in or at",
//   "[Ter]":"toward",
//   "[Via]":"through or using",
//   "[Equ]":"like or similar to",
//   "[Quant_Qual]":"Quantifier/Qualifier Inflection",
// }
// const endingDescriptions = [
// "1) statements; 2) “yes-no” questions, usually with enclitic =qaa",
// "1) content questions; 2) exclamations with the postbase @5+pag- | ~vag-",
// "1) commands, requests, suggestions; 2) statements in narrative with the postbase ki- and a third person ending",
// "1) actions or states subordinate to that of the main verb and involving the same subject; 2) requests, commands, suggestions with a second person ending",
// "1) exclamations, usually with tang; 2) certain special constructions (see maaten and =wa)",
// "“before”",
// "“because”",
// "“whenever”",
// "“although, even though, even if” ",
// "“if, when (in the future)”",
// "“when (in the past)” ",
// "“while”",
// "1) subject of an intransitive verb; 2) object of a transitive verb",
// "1) subject of a transitive verb; 2) possessor; 3) “independent relative construction,” see section on roots in Generation Introduction, and Appendix 1, for further information",
// "1) place from which, time from which; 2) indefinite object of an intransitive verb; 3) specifying information about a noun within a verb; 4) secondary object especially with verbs of speaking and giving; 5) instrument (only in some dialects)",
// "1) place at which, time at which; 2) object of a comparison; 3) with postbase @+paa|~vaa and enclitic =lli in exclamations; 4) formal vocative",
// "1) place to which, time to which; 2) subject of an embedded verb",
// "1) route; 2) instrument; 3) part of a whole",
// "1) comparison; 2) language specification; 3) price specification",
// ];
// const exampleSentences = [
// "1) Pissurtuq. - It is hunting. 2) Maqillruuk-qaa? - Did they two took a steambath?",
// "1) Qangvaq ayallrua? - When did he go? Caqatarcit? - What will you do? 2) Caperrnaqvagta. - How difficult it is.",
// "1) Neri. - Eat. Taisgu. - Bring it here. 2) Tan'gaurluq qanqili, 'Maurluuq!, naw'un iterciqsia?' - The boy said (literally: let the boy say), 'Grandmother!, through where will I get in?'",
// "1) Cukaluni aqvaqurtuq. - She is running quickly. 2) Qantan painqegcaarluku. - Lick your plate clean, please.",
// "1) Tang, qavalria. - Look, it's sleeping. 2) Maaten itertua anelria. - I came in; lo and behold, he went out.",
// "Ayagpailgan payugeskiu. - Before he leaves, bring him food.",
// "Ayaksaituq arenqiapakaan ellalluk. - He hasn’t gone because of this bad weather.",
// "Ner'aqami tamuanqegcaalartuq. - Whenever she eats, she chews her food well.",
// "Pingraan ayagyugtua. - Even though that's the case, I want to go.",
// "Anglirikuni elitnauristen͞guyugtuq. - When he grows up, he wants to be a teacher.",
// "Akngirtuq atrallermini. - He got hurt when he was coming down.",
// "Ayainanermini igtellruuq. - While he was going, he fell.",
// "1) Saskaq kuv'uq. - The glass spilled. 2) Maqaruaq pissullrua. - He hunted the rabbit.",
// "1) Angutem quyavikaa. - The man was thankful to her. 2) Ciquyam pania cen̄irtuq. - Ciquyaq's daughter is visiting.",
// "1) Elitnaurvigmek utertuq. - She's coming home from the school. 2) Ner'uq akutamek. - She is eating some akutaq. 3) Nutaramek qayaliuq. - He is making a new kayak. 4) Aanama kuuvviaryuucimnek aptaanga. - My mother is asking me whether I want coffee.",
// "1) Mermi uitauq. - It is in the water. 2) Aatamni sugtunruunga. - I am taller than my dad. 3) Akertem̄i-lli puqlanirpaa! - How warm the sun is! 4) Elpet angutmi, niicugninga. - You man, listen to me.",
// "1) Kipusvigmun piyuaguq. - He's walking to the store. 2) Arnam neresqaa neqa taqukamun. - The woman asks/tells the bear to eat the fish.",
// "1) Tumyarakun ayallruuq. - He went by the path. 2) Angyakun ayagtut. - They are going by boat. 3) Qercuallruunga it'gamkun. - I got frostbitten on my feet.",
// "1) Aatamegcetun yurartut. - They are dancing like their father. 2) Una Yugtun cauga? - What is this in Yup'ik? 3) Akingqertuq malrugtun. - It is two dollars.",
// ];
var SearchPage=function(_Component){_inherits(SearchPage,_Component);function SearchPage(props){_classCallCheck(this,SearchPage);// console.log("SearchPage props: ", props);
var _this=_possibleConstructorReturn(this,(SearchPage.__proto__||Object.getPrototypeOf(SearchPage)).call(this,props));_this.handleRef=function(c){_this.inputRef=c;};_this.resetAll=function(e,data){_this.setState({search:'',wordsList:[],activeAudioIndex:{},playingAudio:false,clickedAudioUrl:"",clickedAudio:null// newSearchList:[],
// parses:[],
// segments:[],
// searchWord:"",
// notFirstParse:false,
});};_this.processUsageDefinition=function(definition){// console.log(definition)
var search=_this.state.search;var matches=definition.match(search);if(matches!==null){matches.map(function(m){return definition=definition.replace(m,"<i>"+m+'</i>');});}// let matches1 = definition.match(/\⎡.*?\⎤/g)
// if (matches1 !== null) {
//   matches1.map((m) => definition = definition.replace(m,'<i>'+m.slice(1,-1)+'</i>'))        
// }
// if (tag !== 'noun') {
//   definition = '<i>it is </i>'+definition
// } else {
//   definition = '<i>the one </i>'+definition
// }
// console.log(sentence)
// var dom = document.createElement('span');
// dom.innerHTML = sentence;
// console.log(definition)
return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:definition}});};_this.setActiveAudioIndex=function(word,index){// console.log(word, index)
var activeAudioIndex=_this.state.activeAudioIndex;if(index in activeAudioIndex){delete activeAudioIndex[index];_this.setState({activeAudioIndex:activeAudioIndex});}else{// activeAudioIndex.push(index)
// console.log(word)
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/audioentry/"+word.mp3).then(function(response){// let end = now();
// ReactGA.timing({
//   category: 'Loading',
//   variable: 'dictionary',
//   value: (end-start).toFixed(3),
//   label: 'Dictionary loading'
// });
// audiolibrary = response.data;
// fuse.setCollection(dictionary);
// fuse1.setCollection(dictionary);
// console.log(response.data);
activeAudioIndex[index]=response.data;_this.setState({activeAudioIndex:activeAudioIndex});// dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
// dictionary_prepared = fuzzysort.prepare(dictionary)
// this.setState({ audiolibrary: audiolibrary });
});}// console.log(activeAudioIndex)
// this.setState({activeAudioIndex:activeAudioIndex})
};_this.state={// dictionary: [],
// dictionaryNouns: [],
// dictionaryVerbs: [],
// audiolibrary: [],
wordsList:[],// yugtunAnalyzer: props.location.state === undefined ? false : props.location.state.yugtunAnalyzer,
search:props.location.state===undefined?'':props.location.state.search,// currentWord: {},
// onlyCommon: false,
startingSearch:true,// smallestParseIndex: -1,
// parses: props.location.state === undefined ? [] : props.location.state.parses,
// segments: props.location.state === undefined ? [] : props.location.state.segments,
// endingrule: props.location.state === undefined ? [] : props.location.state.endingrule,
// parses:[],
// segments:[],
// endingrule:[],
// currentTableOpen: -1,
// getCall:false,
// notFirstParse: false,
// searchBarStuckTop: false,
searchBarStuckTop:props.location.state===undefined?false:props.location.state.searchBarStuckTop,// notFirstParse: props.location.state === undefined ? false : props.location.state.notFirstParse,
// searchWord: props.location.state === undefined ? "" : props.location.state.searchWord,
// activeSentenceIndex: props.location.state === undefined ? 0 : props.location.state.activeSentenceIndex,
// exampleSentenceSearch: false,
// smallestParse:[[],[]],
// segmentOutputList:[],
// searchWord:"",
// activeSentenceIndex: 0,
// activeTabIndex:0,
// showMoreEnding: false,
// moreIndex:-1,
// updateSearchEntry: props.location.state === undefined ? false : props.location.state.updateSearchEntry,
// activeTabIndex: props.location.state === undefined ? 0 : props.location.state.activeTabIndex,
// exampleSentenceSearch: props.location.state === undefined ? false : props.location.state.exampleSentenceSearch,
// newSearchList: props.location.state === undefined ? [] : props.location.state.newSearchList,
// activeIndex:-1,
// loaderOn:true,
// entries:undefined,
// hover:-1,
// seeMoreActive:false,
// segment: "",
// possibleDefinition: ["","","","","","","","","",""],
// moods: ["[Ind]","[Intrg]","[Opt]","[Sbrd]","[Ptcp]","[Prec]","[Cnsq]","[Cont]","[Conc]","[Cond]","[CtmpI]","[CtmpII]","[Abs]","[Rel]","[Abl_Mod]","[Loc]", "[Ter]","[Via]","[Equ]","%5BQuant_Qual%5D","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]",],
activeAudioIndex:{},playingAudio:false,clickedAudioUrl:"",clickedAudio:null,clickedAudioIndex:-1// this.getParse = this.getParse.bind(this);
};_this.onChangeSearch=_this.onChangeSearch.bind(_this);// this.selectWord = this.selectWord.bind(this);
_this.search_container=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createRef();// this.getEndings = this.getEndings.bind(this);
// this.getLinks = this.getLinks.bind(this);
// this.inputClicked = this.inputClicked.bind(this);
return _this;}_createClass(SearchPage,[{key:'componentDidMount',value:function componentDidMount(){this.resetAll();}//   let start = now();
//   if (this.state.updateSearchEntry) {
//     this.inputClicked();
//     this.setState({ updateSearchEntry: false });
//   }
//   if (dictionary.length === 0) {
//     axios
//       .get(API_URL + "/word/all2021")
//       .then(response => {
//         let end = now();
//         ReactGA.timing({
//           category: 'Loading',
//           variable: 'dictionary',
//           value: (end-start).toFixed(3),
//           label: 'Dictionary loading'
//         });
//         dictionary = response.data;
//         // fuse.setCollection(dictionary);
//         // fuse1.setCollection(dictionary);
//         console.log('Fetched dictionary');
//         dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
//         // dictionary_prepared = fuzzysort.prepare(dictionary)
//         this.setState({ dictionary: dictionary });
//       });
//     axios
//       .get(API_URL + "/audiolibrary/all")
//       .then(response => {
//         // let end = now();
//         // ReactGA.timing({
//         //   category: 'Loading',
//         //   variable: 'dictionary',
//         //   value: (end-start).toFixed(3),
//         //   label: 'Dictionary loading'
//         // });
//         audiolibrary = response.data;
//         // fuse.setCollection(dictionary);
//         // fuse1.setCollection(dictionary);
//         console.log('Fetched AudioLibrary');
//         // dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
//         // dictionary_prepared = fuzzysort.prepare(dictionary)
//         this.setState({ audiolibrary: audiolibrary });
//       });
//   }
//   else {
//     // fuse.setCollection(dictionary);
//     this.setState({ dictionary: dictionary });
//   }
// }
},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){// if (prevState.dictionary.length !== this.state.dictionary.length) {
//   this.onChangeSearch(undefined, {value: this.state.search});
// }
// if (this.props.audiolibrary.length !== this.state.audiolibrary.length) {
//   this.setState({audiolibrary:this.props.audiolibrary});
//   // this.setState({dictionary_dict:this.props.dictionary_dict})
// }
if(this.props.reset!==prevProps.reset){this.resetAll();}if(prevState.search!==this.state.search){this.setState({searchBarStuckTop:true});}if(prevState.startingSearch&&!this.state.startingSearch){if(navigator.userAgent.match(/(iPhone|iPod|iPad)/i)){var elts=__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this).getElementsByClassName('search_container');if(elts.length>0){elts[0].scrollIntoView();}}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.state.playingAudio){var audio=this.state.clickedAudio;audio.pause();audio.currentTime=0;}}// getParse(word) {
//   if (word === "") {
//     this.setState({
//         parses: [],
//         segments: [],
//         endingrule: [],
//         getCall:false,
//       })
//   } else {
//   axios
//     .get(API_URL + "/parse/" + word)
//     .then(response => {
//       // console.log(response)
//       //  var lowest = 0;
//        // var a = response.data.parses;
//       //  for (var i = 1; i < a.length; i++) {
//       //   if (a[i].length < a[lowest].length) 
//       //     lowest = i;
//       //  }
//       // console.log(a)
//       // let sortedParses = response.data.parses.sort(function(a,b){return a.length - b.length;}).slice(0, 5)
//       // console.log(sortedParses)
//       this.setState({
//         parses: response.data.parses,
//         segments: response.data.segments,
//         endingrule: response.data.endingrule,
//         getCall:false,
//     	})
//       // let segmentOutputList = [];
//       // sortedParses.map((i,index)=>
//       //   this.getSegment(i)
//       //   )
//       // console.log(segmentOutputList)
//       // if (a.length > 0) {
//       // 	this.setState({
//       //    smallestParseIndex: lowest,
//       //    smallestParse: response.data.parses[lowest].split('-'),
//       //  });
//         // this.getSegment(response.data.parses[lowest])
//      // }
//     });
//   }
// }
// getSegment(word) {
//   axios
//     .get(API_URL + "/segment/" + encodeURIComponent(word))
//     .then(response => {
//       // return response.data.words[0]
//       console.log(response)
//       // this.setState({
//         // segment: response.data.words[0],
//       // })
//     });
// }
// getEndings(word, mood) {
//   console.log("Word",word,mood)
//   axios
//     .get(API_URL + "/mood?underlying_form=" + encodeURIComponent(word) + "&mood=" + mood)
//     .then(response => {
//       this.setState({ entries: response.data.results,}); 
//       this.setState({ loaderOn: false})
//   });
// }
},{key:'onChangeSearch',value:function onChangeSearch(event,data){// this.setState({entries:undefined, activeIndex:-1, loaderOn: true, seeMoreActive:false,currentTableOpen: -1,})
this.resetAll();var newStartingSearch=event===undefined;var new_search=data.value.replace("’","'");// console.log(new_search)
// if (data.value === undefined) {new_search = this.state.search}
var wordsList=__WEBPACK_IMPORTED_MODULE_8_fuzzysort___default.a.go(new_search,this.props.audiolibrary,optionsFuzzy).map(function(_ref){var obj=_ref.obj;return obj;});this.setState({startingSearch:newStartingSearch,wordsList:wordsList,search:new_search});if(this.state.playingAudio){var audio=this.state.clickedAudio;audio.pause();audio.currentTime=0;}// if (new_search.length >= 4 && !this.state.yugtunAnalyzer) {
//   ReactGA.event({
//     category: 'User',
//     action: 'Search word',
//     label: new_search
//   });
//   let start = now();
//   let wordsList = fuse.search(new_search);
//   let end = now();
//   console.log('done! in ', (end-start).toFixed(3), 'ms');
//   ReactGA.timing({
//     category: 'Search',
//     variable: 'fuse.search',
//     value: (end-start).toFixed(3),
//     label:'Fuse.js search duration'
//   });
//   this.setState({ startingSearch: newStartingSearch, wordsList: wordsList, search: new_search });
// }
// else {
//   this.setState({ startingSearch: newStartingSearch, search: new_search });
// }
}// selectWord(word, event) {
//   this.setState({ currentWord: word });
// }
// resetCurrentWord(event, data) {
//   this.setState({ currentWord: {} });
// }
// handleClick = (e, titleProps) => {
//   // console.log(e,titleProps)
//   this.setState({ loaderOn: true,})
//   const { index, currentIndex } = titleProps
//   const { activeIndex } = this.state
//   const newIndex = activeIndex === index ? -1 : index
//   let mood = this.state.moods[index]
//   this.getEndings(this.state.parses[currentIndex],mood)
//   this.setState({activeIndex: newIndex, mood: mood})
// }
// handleClick2 = (e, titleProps) => {
//   // console.log(e,titleProps)
//   const { index, currentIndex } = titleProps
//   const { activeIndex } = this.state
//   const newIndex = activeIndex === index ? -1 : index
//   console.log(index)
//   let mood = this.state.moods[index]
//   // console.log(mood)
//   this.setState({loaderOn:false, entries: (mood === "[DemPro]" ? demPro: perPro), activeIndex: newIndex, mood: mood})
// }
// onKeyPress = (e) => {
//   if(e.key === 'Enter') {//} && (this.state.activeTabIndex === 0 || this.state.search !== this.state.searchWord)){
//     // if (!this.state.yugtunAnalyzer && this.state.parses.length === 0) {this.setState({getCall:true})}
//     // this.setState({ yugtunAnalyzer: !this.state.yugtunAnalyzer}); 
//     // if (this.state.yugtunAnalyzer) {
//       // this.setState({activeTabsIndex:1})
//       this.inputClicked(true)
//     // }
//   }
// }
// inputClicked(search) {
//   this.setState({entries:undefined, activeIndex:-1, loaderOn: true, seeMoreActive:false,currentTableOpen: -1,yugtunAnalyzer:true,showMoreEnding: false,})
//   // console.log(search)
//   if (search === undefined || search === true) {
//   	search = this.state.search
//   }
//   console.log(search)
//   if (search.length > 0) {
//     this.setState({ 
//       newSearchList: search.split(" "), 
//       activeSentenceIndex: 0, 
//       searchWord: search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g, "").toLowerCase(),
//       getCall:true,
//       notFirstParse:true,
//     }); 
//     this.getParse(search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g, "").toLowerCase());                          
//   } 
//   //   this.inputRef.focus();
//   //   this.setState({
//   //     search: '', startingSearch: false
//   //   });
//   // }
// }
// endingToEnglish(ending,index,qindex) {
//   const tags = [...ending.matchAll(/\[.*?\]/g)];
//   var english1 = ""
//   var english2 = ""
//   var english3 = ""
//   var english4 = ""
//   var before = true;
// 	// console.log(this.state,tags[1])
//   if (ending.includes('[V]')) {
//     if (this.state.parses[index].includes('[Ind]') ||
//         this.state.parses[index].includes('[Intrg]') ||
//         this.state.parses[index].includes('[Opt]') ||
//         this.state.parses[index].includes('[Sbrd]')) {
//       before = false;
//     }
//     english1 += 'Verb Ending';
//     english2 += endingToEnglishTerms[tags[1]];
//     english4 += endingEnglishDescriptions[tags[1]];
//     if (ending.includes('[Trns]')) {
// 	  var subject = endingToEnglishTerms[tags[tags.length-2]]
// 	  if (subject === undefined ) {
// 	  	subject = 'unspecified'
// 	  }
//       english3 += subject + " to " + endingToEnglishTerms[tags[tags.length-1]];
//       } else if (ending.includes('[Intr]')) {
//         english3 += endingToEnglishTerms[tags[tags.length-1]];
//       }
//     } else if (ending.includes('[N]')) {
//       english1 += 'Noun Ending';
//       english2 += endingToEnglishTerms[tags[1]];
//   		if (ending.includes('[Abs]')) {
//   			english4 = ""
//   		} else {
//   			english4 += endingEnglishDescriptions[tags[1]];
//   		}      
//       if (ending.includes('Poss')) {
//         english3 += endingToEnglishTerms[tags[tags.length-2]] + "\xa0" + endingToEnglishTerms[tags[tags.length-1]];
//       } else {
//         english3 += endingToEnglishTerms[tags[tags.length-1]];
//       }
//     } else if (this.state.parses[index].includes('[D')) {
//       english1 += 'Demonstrative';
//       english2 += endingToEnglishTerms[tags[0]];
//       english4 += endingEnglishDescriptions[tags[0]];
//       if (endingToEnglishTerms[tags[1]] !== undefined) {
//       	english3 += endingToEnglishTerms[tags[1]];      	
//       }
//     } else if (this.state.parses[index].includes('[P')) {
//       english1 += 'Personal Pronoun';
//       english2 += endingToEnglishTerms[tags[0]];
//       english4 += endingEnglishDescriptions[tags[0]];
//       english3 += endingToEnglishTerms[tags[1]];      	
//     } else if (this.state.parses[index].includes('[Q')) {
//       english1 = '';
//       english2 += endingToEnglishTerms[tags[0]];
//       english4 += endingEnglishDescriptions[tags[0]];
//       if (endingToEnglishTerms[tags[1]] !== undefined) {
//       	english3 += endingToEnglishTerms[tags[1]];      	
//       }
//     } else {
//       english1 += ending;
//       english2 += endingToEnglishTerms[tags[0]];
//       english4 += endingEnglishDescriptions[tags[0]];
//       if (endingToEnglishTerms[tags[1]] !== undefined) {
//       	english3 += endingToEnglishTerms[tags[1]];      	
//       }	
//     }
//     // var possibleDefinition = this.state.possibleDefinition
//     // var entry = possibleDefinition[index]
//     // entry = entry + '\xa0' + english3
//     // possibleDefinition[index] = entry
//     // this.setState({possibleDefinition:possibleDefinition})
//     return (
//     <div style={{paddingTop:15,paddingLeft:20*qindex}}>
//     <div style={{fontWeight:'bold',fontSize:16,paddingBottom:'1px'}}>{this.state.endingrule[index][1].join(', ')}</div>
//     <div style={{fontSize:16}}>
//     {before && english4.length !== 0 ?
//     <span>
//     {english4+'\xa0'}
//     </span>
//     :
//     null
//     }
//     <span>{english3}</span>
//     {!before ?
//     <span>
//     {'\xa0'+english4}
//     </span>
//     :
//     null
//     }
//     </div>
//     <div onClick={()=>this.setState({showMoreEnding:(this.state.moreIndex !== index || !this.state.showMoreEnding ? true : false),moreIndex:index})}style={{color:'#bdbdbd',fontWeight:'100',paddingTop:10,paddingBottom:10,cursor:'pointer',fontSize:16}}>{'more'}<Icon style={{paddingLeft:5,fontSize:12}} name={this.state.showMoreEnding && index === this.state.moreIndex ? 'chevron up' : 'chevron down'} /></div>
//     {this.state.showMoreEnding && index === this.state.moreIndex ?
//     <div style={{marginLeft:15,fontSize:16}}>
// 	    <div>{english2}</div>
// 	    <div>{english1}</div>
// 	    <div onClick={()=> window.open("http://www.yugtun.com/symbols")} style={{color:'#4183c4',fontWeight:'100',textDecoration:'underline',paddingTop:10, cursor:'pointer'}}>{'Translation and Symbols'}</div>
//     </div>
//     :
//     null
// 	}
//     </div>
//     )
//   }
},{key:'repeatAudio',// handleTabChange = (e,data) => {
//   // console.log(data.activeIndex, this.state.activeIndex)
//   if (data.activeIndex === 0 && this.state.activeTabIndex !== 0) {
//     this.setState({ yugtunAnalyzer: false, activeTabIndex:0,parses:[],segments:[],endingrule:[],newSearchList:[],notFirstParse:false,search:""})
//   } else if (data.activeIndex === 1 && this.state.activeTabIndex !== 1) {
//     // if (!this.state.yugtunAnalyzer) {
//     this.setState({ yugtunAnalyzer: true, activeTabIndex:1, parses:[],segments:[],endingrule:[],newSearchList:[],notFirstParse:false,search:""});                     
//     // this.inputClicked()
//     // }
//   }
// }
// getLinks(index, parse) {
// 	// console.log(parse)
//   if (index === 0) {            // if base
//     if ((parse[index].includes("[P") || parse[index].includes("[I")) && parse.length === 1) {  // if particle or ignorative
//       return parse[index].split("[")[0].replace(/=/g,"-");
//     } else if (parse[index].includes("[PerPro]")) {
//       return parse[index].split("[")[0]
//     } else if (parse[index].includes("[DemPro]") || parse[index].includes("[DemAdv]")) {
//       var dem = parse[index].replace("n[DemPro]","n'a")
//       dem = dem.replace("[DemPro]","na")
//       dem = dem.replace("[DemAdv]","(ni)")
//       return dem
//     } else {
//       var base = parse[0];
//       base = base.split(/\[[^e]/)[0] // remove special tag
//       var dictionaryForm = '';
//       // console.log("getLinks:",base,index,parse)
//       if (parse[1].includes('[N')) {                      // if Noun base:
//         dictionaryForm = base.replace(/([aeiu])te\b/, "$1n");              // Vte -> n
//         dictionaryForm = dictionaryForm.replace(/([^\[])e\b/, "$1a")      // e -> a
//         dictionaryForm = dictionaryForm.replace(/g\b/, "k");      // g -> k
//         dictionaryForm = dictionaryForm.replace(/r(\*)?\b/, "q$1"); // r(*) -> q(*)
//       } else if (parse[1].includes('[V') || parse[1].includes('[Q')) {
//         dictionaryForm = base+"-"       // if Verb or Quant_Qual base 
//       } else {
//         dictionaryForm = base
//       }
//       return dictionaryForm.replace(/=/g,"-");          
//     }
//   } else {
// if (parse[index].includes("ete[N→V]")) {
//     		return "ete[N→V]"
//     	}
//   }
//   // else (["[N→N]","[N→V]","[V→V]","[V→N]","[Encl]"].some(v => parse[index].includes(v))) { //if postbase or enclitic
//   return parse[index];
// }
value:function repeatAudio(audio,index,event,data){var _this2=this;// console.log(audio.mp3)
// var a = new Audio(API_URL+'static/WoW-Link.mp3');
// a.play();
// let a;
// axios
//   .get(API_URL + "/audiolibrary/" + audio.mp3)
//   .then(response => {
//     // let end = now();
//     // ReactGA.timing({
//     //   category: 'Loading',
//     //   variable: 'dictionary',
//     //   value: (end-start).toFixed(3),
//     //   label: 'Dictionary loading'
//     // });
//     var a = new Audio(response.data);
//     console.log(a)
//     a.play();
//     // fuse.setCollection(dictionary);
//     // fuse1.setCollection(dictionary);
//     // console.log('Fetched dictionary');
//     // dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
//     // // dictionary_prepared = fuzzysort.prepare(dictionary)
//     // this.setState({ dictionary: dictionary });
//   });
var audioURL=__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/audiolibrary/"+audio.mp3;// stop audio on double click
if(this.state.playingAudio===true&&this.state.clickedAudioUrl===audioURL){var _audio=this.state.clickedAudio;_audio.pause();_audio.currentTime=0;this.setState({clickedAudio:_audio,clickedAudioIndex:-1,playingAudio:false});}// stop first audio then play new one
if(this.state.playingAudio===true&&this.state.clickedAudioUrl!==audioURL){var firstAudio=this.state.clickedAudio;firstAudio.pause();firstAudio.currentTime=0;this.setState({playingAudio:true});var secondAudio=new Audio(audioURL);secondAudio.play();this.setState({clickedAudioUrl:audioURL,clickedAudioIndex:index,clickedAudio:secondAudio});secondAudio.onended=function(){_this2.setState({playingAudio:false,clickedAudioIndex:-1});};}// play audio again
if(this.state.playingAudio===false&&this.state.clickedAudioUrl===audioURL){var _audio2=this.state.clickedAudio;this.setState({playingAudio:true,clickedAudioIndex:index});_audio2.play();_audio2.onended=function(){_this2.setState({playingAudio:false,clickedAudioIndex:-1});};}// play new audio
if(this.state.playingAudio===false&&this.state.clickedAudioUrl!==audioURL){this.setState({playingAudio:true});var _audio3=new Audio(audioURL);_audio3.play();this.setState({clickedAudioUrl:audioURL,clickedAudioIndex:index,clickedAudio:_audio3});_audio3.onended=function(){_this2.setState({playingAudio:false,clickedAudioIndex:-1});};}}},{key:'render',value:function render(){var _this3=this;console.log("SearchPage state: ",this.state);// console.log("dictionary: ",dictionary_dict);
// console.log("fuse.js: ",fuse.search('pissur'))
// console.log("Fuzzysort: ",fuzzysort.go('pissur', dictionary, optionsFuzzy));
// console.log("Fuzzysort_prepared: ",fuzzysort.go('pissur', dictionary_prepared, optionsFuzzy));
// console.log("pissur-[V][Ind][Intr][S_3Sg]=qaa[Encl]".split('-'))
var displayList=this.state.search.length>=2&&this.state.wordsList.length>0;var emptyList=this.state.search.length>=2&&this.state.wordsList.length===0;// let pressEnter = this.state.search.length > 0 && this.state.yugtunAnalyzer && this.state.newSearchList.length === 0;
var wordsList=this.state.wordsList;// const { activeIndex } = this.state
// let isCommonList = wordsList.map((word) => {
//   return Object.keys(word).some((key) => {
//     return word[key].properties && word[key].properties.indexOf('common') > -1;
//   });
// });
// if (this.state.onlyCommon) {
//   wordsList = wordsList.filter((word, i) => { return isCommonList[i]; });
// }
// let displayCommonOption = this.state.onlyCommon || (wordsList.some((word, i) => { return isCommonList[i]; }) && wordsList.some((word, i) => { return !isCommonList[i]; }));
return this.props.audiolibrary.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{paddingBottom:14}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Column,{style:{paddingLeft:0,paddingRight:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["p" /* Input */],{ref:this.handleRef,placeholder:'Search a word...'// action={{ icon: (this.state.yugtunAnalyzer ? 'search' : null), transparent:true,size:'huge', onClick: () => 
// {this.state.yugtunAnalyzer ? this.inputClicked() : null}
// }}
// icon={<Icon name='x' onClick={console.log('hi')} link />}
// iconPosition='right'
,size:'huge',onChange:this.onChangeSearch,value:this.state.search// onKeyPress={this.onKeyPress}
,fluid:true}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{display:'flex',justifyContent:'center',padding:0,paddingLeft:16,paddingRight:16}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */],{style:{width:'100%'},divided:true},displayList?wordsList.map(function(word,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{style:{paddingTop:'10px',paddingBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */],{style:{float:'left',border:_this3.state.playingAudio&&_this3.state.clickedAudioIndex===index?'solid 1px #4a80b5':'solid 1px #dededf',backgroundColor:'white',color:'#4a80b5',cursor:'pointer'},circular:true,icon:'volume up',onClick:function onClick(){return _this3.repeatAudio(word,index);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */],{style:{float:'right',color:'#8F8F8F',cursor:'pointer'},basic:true,icon:'dropdown',onClick:function onClick(){return _this3.setActiveAudioIndex(word,index);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Content,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Header,{style:{width:'100%',display:'flex',fontFamily:'Lato,Arial,Helvetica,sans-serif',fontSize:'16px',paddingBottom:'4px'}},_this3.processUsageDefinition(word.y)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Description,{style:{fontSize:'16px',fontWeight:'400'}},_this3.processUsageDefinition(word.e))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,index in _this3.state.activeAudioIndex?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{paddingTop:'14px',paddingBottom:'6px',fontSize:'14px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginTop:'5px',marginBottom:'10px',paddingLeft:'6px',borderLeft:'solid 2px grey'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex'}},_this3.state.activeAudioIndex[index]['content']['speaker'].length===1?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{style:{marginRight:'10px'}},'Speaker:'):null,_this3.state.activeAudioIndex[index]['content']['speaker'].length===1?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{height:'75px',width:'100px',style:{borderRadius:'10px'},src:WEB_URL+'/images/EldersPhotos/'+_this3.state.activeAudioIndex[index]['content']['speaker'][0][1]}),_this3.state.activeAudioIndex[index]['content']['speaker'][0][0].includes('~')?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{color:'#333333',display:'flex',justifyContent:'center',textAlign:'center',fontWeight:'bold'}},_this3.state.activeAudioIndex[index]['content']['speaker'][0][0].split('--')[0].split('~')[0]),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{color:'#333333',display:'flex',justifyContent:'center',textAlign:'center'}},_this3.state.activeAudioIndex[index]['content']['speaker'][0][0].split('--')[0].split('~')[1]),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{color:'#333333',display:'flex',justifyContent:'center',textAlign:'center'}},_this3.state.activeAudioIndex[index]['content']['speaker'][0][0].split('--')[1])):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{color:'#333333',display:'flex',justifyContent:'center',textAlign:'center'}},_this3.state.activeAudioIndex[index]['content']['speaker'][0][0].split('--')[0]),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{color:'#333333',display:'flex',justifyContent:'center',textAlign:'center'}},_this3.state.activeAudioIndex[index]['content']['speaker'][0][0].split('--')[1]))):null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,'Context:'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{padding:'12px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'...'+_this3.state.activeAudioIndex[index]['content']['contextBeforeYup']),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{style:{fontWeight:'bold'}},' '+_this3.state.activeAudioIndex[index]['yupik']+' '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,_this3.state.activeAudioIndex[index]['content']['contextAfterYup']+'...')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{padding:'12px',fontStyle:'italic'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'...'+_this3.state.activeAudioIndex[index]['content']['contextBeforeEng']),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{style:{fontWeight:'bold'}},' '+_this3.state.activeAudioIndex[index]['english']+' '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,_this3.state.activeAudioIndex[index]['content']['contextAfterEng']+'..')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{paddingTop:'5px',paddingBottom:'5px'}},'Source: '+_this3.state.activeAudioIndex[index]['content']['source']),_this3.state.activeAudioIndex[index]['content']['link'].length!==0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,'Link: ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{style:{color:'#4a80b5',textDecoration:'underline'},href:KYUK_URL+_this3.state.activeAudioIndex[index]['content']['link'],target:'_blank'},KYUK_URL+_this3.state.activeAudioIndex[index]['content']['link'])):null)):null));}):this.state.search.length===0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontSize:'1.2rem',color:'#666',lineHeight:1.6,maxWidth:500}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{textDecoration:'underline',marginBottom:10,marginTop:15}},' Audio Library '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginBottom:10}},' Type any English word or Yugtun word and matching audio entries will show automatically.'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,' Examples: '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{onClick:function onClick(){_this3.setState({search:'shaman',wordsList:__WEBPACK_IMPORTED_MODULE_8_fuzzysort___default.a.go('shaman',_this3.props.audiolibrary,optionsFuzzy).map(function(_ref2){var obj=_ref2.obj;return obj;}),newStartingSearch:true});},style:{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}},'shaman'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,', '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{onClick:function onClick(){_this3.setState({search:'ellam yua',wordsList:__WEBPACK_IMPORTED_MODULE_8_fuzzysort___default.a.go('ellam yua',_this3.props.audiolibrary,optionsFuzzy).map(function(_ref3){var obj=_ref3.obj;return obj;}),newStartingSearch:true});},style:{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}},'ellam yua'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,', '),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{onClick:function onClick(){_this3.setState({search:'weather',wordsList:__WEBPACK_IMPORTED_MODULE_8_fuzzysort___default.a.go('weather',_this3.props.audiolibrary,optionsFuzzy).map(function(_ref4){var obj=_ref4.obj;return obj;}),newStartingSearch:true});},style:{textDecoration:'underline',color:'#4A80B5',cursor:'pointer'}},'weather'))))):null,displayList?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["g" /* Divider */],{style:{paddingBottom:0}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-evenly',alignItems:'center',height:60,paddingBottom:16}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}))):null,emptyList?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',null,'Aren, no matches...')):''))):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{paddingBottom:14}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Column,{style:{paddingLeft:0,paddingRight:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["p" /* Input */],{disabled:true,ref:this.handleRef,placeholder:'Search a word...'// action={{ icon: (this.state.yugtunAnalyzer ? 'search' : null), transparent:true,size:'huge', onClick: () => 
// {this.state.yugtunAnalyzer ? this.inputClicked() : null}
// }}
// icon={<Icon name='x' onClick={console.log('hi')} link />}
// iconPosition='right'
,size:'huge',onChange:this.onChangeSearch,value:this.state.search// onKeyPress={this.onKeyPress}
,fluid:true}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{height:200}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Column,{style:{paddingLeft:0,paddingRight:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["f" /* Dimmer */],{active:true,inverted:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["t" /* Loader */],{size:'massive'},'Audio loading...')))));}}]);return SearchPage;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchPage);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_performance_now__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_performance_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_performance_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TableEntry_js__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_ga4__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Fuse from 'fuse.js';
// import fuzzysort from 'fuzzysort'
// import ReactGA from 'react-ga';
// import GitHubForkRibbon from 'react-github-fork-ribbon';
// import { YugtunLoader, YugtunFooter, WordItem, tagColors } from './SearchPageHelpers.js';
// import {endingIndexess} from './constants/endingIndexess.js';
__WEBPACK_IMPORTED_MODULE_11_react_ga4___default.a.initialize("G-WDEJDCK7QT");// Cache dictionary
// let dictionary = [];
// let audiolibrary = []
// let dictionary_dict = {};
// let dictionary_prepared = [];
// Search options
// let options = {
//   keys: ['yupik', 'english'],
//   minMatchCharLength: 3,
//   // includeScore: true,
//   distance: 10,
//   location: 2,
//   shouldSort: true,
//   //tokenize: true, // super slow!! 6x slower
//   // matchAllTokens: true,
//   threshold: 0.4,
//   findAllMatches: true,
// };
// let fuse = new Fuse([], options);
// let options1 = {
//   keys: ['yupik'],
//   // minMatchCharLength: 3,
//   // includeScore: true,
//   distance: 0,
//   // location: 2,
//   // shouldSort: true,
//   //tokenize: true, // super slow!! 6x slower
//   // matchAllTokens: true,
//   threshold: 0.0,
//   // findAllMatches: true,
// };
// let fuse1 = new Fuse([], options1);
// fuzzysort search
// const optionsFuzzy = {
//   keys: ['definitionString', 'keyString'],
//   limit: 50, // don't return more results than you need!
//   threshold: -10000, // don't return bad results
// };
var SearchPage=function(_Component){_inherits(SearchPage,_Component);function SearchPage(props){_classCallCheck(this,SearchPage);// console.log("SearchPage props: ", props);
var _this=_possibleConstructorReturn(this,(SearchPage.__proto__||Object.getPrototypeOf(SearchPage)).call(this,props));_this.handleRef=function(c){_this.inputRef=c;};_this.handleClick=function(e,titleProps){// console.log(e,titleProps)
_this.setState({loaderOn:true});var index=titleProps.index,currentIndex=titleProps.currentIndex;var activeIndex=_this.state.activeIndex;var newIndex=activeIndex===index?-1:index;var mood=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["k" /* moods */][index];if(newIndex!==-1){_this.getEndings(_this.state.parses[currentIndex],mood);}_this.setState({activeIndex:newIndex,mood:mood});};_this.handleClick2=function(e,titleProps){// console.log(e,titleProps)
var index=titleProps.index,currentIndex=titleProps.currentIndex;var activeIndex=_this.state.activeIndex;var newIndex=activeIndex===index?-1:index;console.log(index);var mood=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["k" /* moods */][index];// console.log(mood)
_this.setState({loaderOn:false,entries:mood==="[DemPro]"?__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["c" /* demPro */]:__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["l" /* perPro */],activeIndex:newIndex,mood:mood});};_this.onKeyPress=function(e){if(e.key==="Enter"){//} && (this.state.activeTabIndex === 0 || this.state.search !== this.state.searchWord)){
// if (!this.state.yugtunAnalyzer && this.state.parses.length === 0) {this.setState({getCall:true})}
// this.setState({ yugtunAnalyzer: !this.state.yugtunAnalyzer});
// if (this.state.yugtunAnalyzer) {
// this.setState({activeTabsIndex:1})
_this.inputClicked(true);// }
}};_this.resetAll=function(e,data){// console.log('hello???')
_this.setState({search:"",newSearchList:[],activeIndex:-1,parses:[],segments:[],endingIndexes:[],yugtun:[],english:[],links:[],searchWord:"",notFirstParse:false});};_this.state={// dictionary: [],
// dictionary_dict: {},
// dictionaryNouns: [],
// dictionaryVerbs: [],
wordsList:[],// yugtunAnalyzer: props.location.state === undefined ? false : props.location.state.yugtunAnalyzer,
search:props.location.state===undefined?"":props.location.state.search,// currentWord: {},
// onlyCommon: false,
startingSearch:true,// smallestParseIndex: -1,
parses:props.location.state===undefined?[]:props.location.state.parses,segments:props.location.state===undefined?[]:props.location.state.segments,endingIndexes:props.location.state===undefined?[]:props.location.state.endingIndexes,yugtun:props.location.state===undefined?[]:props.location.state.yugtun,english:props.location.state===undefined?[]:props.location.state.english,links:props.location.state===undefined?[]:props.location.state.links,// parses:[],
// segments:[],
// endingIndexes:[],
currentTableOpen:-1,getCall:false,// notFirstParse: false,
// searchBarStuckTop: false,
searchBarStuckTop:props.location.state===undefined?false:props.location.state.searchBarStuckTop,notFirstParse:props.location.state===undefined?false:props.location.state.notFirstParse,searchWord:props.location.state===undefined?"":props.location.state.searchWord,activeSentenceIndex:props.location.state===undefined?0:props.location.state.activeSentenceIndex,// exampleSentenceSearch: false,
// smallestParse:[[],[]],
// segmentOutputList:[],
// searchWord:"",
// activeSentenceIndex: 0,
// activeTabIndex:0,
showMoreEnding:false,moreIndex:-1,updateSearchEntry:props.location.state===undefined?false:props.location.state.updateSearchEntry,// activeTabIndex: props.location.state === undefined ? 0 : props.location.state.activeTabIndex,
// exampleSentenceSearch: props.location.state === undefined ? false : props.location.state.exampleSentenceSearch,
newSearchList:props.location.state===undefined?[]:props.location.state.newSearchList,activeIndex:-1,loaderOn:true,entries:undefined,hover:-1,seeMoreActive:false,segment:""// possibleDefinition: ["","","","","","","","","",""],
};_this.getParse=_this.getParse.bind(_this);_this.onChangeSearch=_this.onChangeSearch.bind(_this);// this.selectWord = this.selectWord.bind(this);
_this.search_container=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createRef();_this.getEndings=_this.getEndings.bind(_this);_this.getLinks=_this.getLinks.bind(_this);_this.inputClicked=_this.inputClicked.bind(_this);return _this;}_createClass(SearchPage,[{key:"componentDidMount",value:function componentDidMount(){// let start = now();
// console.log('before',this.state)
// console.log(this.props)
this.resetAll();if(this.state.updateSearchEntry&&!this.props.fromTab){this.inputClicked();this.setState({updateSearchEntry:false});}}// if (dictionary.length === 0) {
//   axios
//     .get(API_URL + "/word/all2021")
//     .then(response => {
//       let end = now();
//       ReactGA.timing({
//         category: 'Loading',
//         variable: 'dictionary',
//         value: (end-start).toFixed(3),
//         label: 'Dictionary loading'
//       });
//       dictionary = response.data;
//       // fuse.setCollection(dictionary);
//       // fuse1.setCollection(dictionary);
//       console.log('Fetched dictionary');
//       dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
//       // dictionary_prepared = fuzzysort.prepare(dictionary)
//       this.setState({ dictionary: dictionary });
//     });
//   axios
//     .get(API_URL + "/audiolibrary/all")
//     .then(response => {
//       // let end = now();
//       // ReactGA.timing({
//       //   category: 'Loading',
//       //   variable: 'dictionary',
//       //   value: (end-start).toFixed(3),
//       //   label: 'Dictionary loading'
//       // });
//       audiolibrary = response.data;
//       // fuse.setCollection(dictionary);
//       // fuse1.setCollection(dictionary);
//       console.log('Fetched AudioLibrary');
//       // dictionary.forEach(entry => dictionary_dict[entry.keyString] = entry.definitionString) // create dictionary_dict dictionary
//       // dictionary_prepared = fuzzysort.prepare(dictionary)
//       this.setState({ audiolibrary: audiolibrary });
//     });
// }
// else {
//   // fuse.setCollection(dictionary);
//   this.setState({ dictionary: dictionary });
// }
// }
},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){// if (prevState.dictionary.length !== this.state.dictionary.length) {
//   this.onChangeSearch(undefined, {value: this.state.search});
// }
// if (this.props.dictionary.length !== this.state.dictionary.length) {
//   this.setState({dictionary:this.props.dictionary});
//   this.setState({dictionary_dict:this.props.dictionary_dict})
// }
if(this.props.reset!==prevProps.reset){this.resetAll();}if(prevState.search!==this.state.search){this.setState({searchBarStuckTop:true});}if(prevState.startingSearch&&!this.state.startingSearch){if(navigator.userAgent.match(/(iPhone|iPod|iPad)/i)){var elts=__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this).getElementsByClassName("search_container");if(elts.length>0){elts[0].scrollIntoView();}}}}},{key:"getParse",value:function getParse(word){var _this2=this;if(word===""){this.setState({parses:[],segments:[],endingIndexes:[],yugtun:[],english:[],links:[],getCall:false});}else{__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/parseV2/"+word).then(function(response){// console.log(response)
//  var lowest = 0;
// var a = response.data.parses;
//  for (var i = 1; i < a.length; i++) {
//   if (a[i].length < a[lowest].length)
//     lowest = i;
//  }
// console.log(a)
// let sortedParses = response.data.parses.sort(function(a,b){return a.length - b.length;}).slice(0, 5)
// console.log(sortedParses)
_this2.setState({parses:response.data.parses,segments:response.data.segments,endingIndexes:response.data.endingIndexes,yugtun:response.data.yugtun,english:response.data.english,links:response.data.links,getCall:false});// let segmentOutputList = [];
// sortedParses.map((i,index)=>
//   this.getSegment(i)
//   )
// console.log(segmentOutputList)
// if (a.length > 0) {
//  this.setState({
//    smallestParseIndex: lowest,
//    smallestParse: response.data.parses[lowest].split('-'),
//  });
// this.getSegment(response.data.parses[lowest])
// }
});}}// getSegment(word) {
//   axios
//     .get(API_URL + "/segment/" + encodeURIComponent(word))
//     .then(response => {
//       // return response.data.words[0]
//       console.log(response)
//       // this.setState({
//         // segment: response.data.words[0],
//       // })
//     });
// }
},{key:"getEndings",value:function getEndings(word,mood){var _this3=this;console.log("Word",word,mood);__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/moodV2?underlying_form="+encodeURIComponent(word)+"&mood="+mood).then(function(response){console.log(response.data);_this3.setState({entries:response.data.results});_this3.setState({loaderOn:false});});}},{key:"onChangeSearch",value:function onChangeSearch(event,data){// this.setState({entries:undefined, activeIndex:-1, loaderOn: true, seeMoreActive:false,currentTableOpen: -1,})
var newStartingSearch=event===undefined;var new_search=data.value.replace("’","'");// console.log(new_search)
// if (data.value === undefined) {new_search = this.state.search}
// let wordsList = fuzzysort.go(new_search, dictionary, optionsFuzzy).map(({ obj }) => (obj));
this.setState({startingSearch:newStartingSearch,search:new_search});// if (new_search.length >= 4 && !this.state.yugtunAnalyzer) {
//   ReactGA.event({
//     category: 'User',
//     action: 'Search word',
//     label: new_search
//   });
//   let start = now();
//   let wordsList = fuse.search(new_search);
//   let end = now();
//   console.log('done! in ', (end-start).toFixed(3), 'ms');
//   ReactGA.timing({
//     category: 'Search',
//     variable: 'fuse.search',
//     value: (end-start).toFixed(3),
//     label:'Fuse.js search duration'
//   });
//   this.setState({ startingSearch: newStartingSearch, wordsList: wordsList, search: new_search });
// }
// else {
//   this.setState({ startingSearch: newStartingSearch, search: new_search });
// }
}// selectWord(word, event) {
//   this.setState({ currentWord: word });
// }
// resetCurrentWord(event, data) {
//   this.setState({ currentWord: {} });
// }
},{key:"inputClicked",value:function inputClicked(search){this.setState({entries:undefined,activeIndex:-1,loaderOn:true,seeMoreActive:false,currentTableOpen:-1,yugtunAnalyzer:true,showMoreEnding:false});// console.log(search)
if(search===undefined||search===true){search=this.state.search;}console.log(search);if(search.length>0){this.setState({newSearchList:search.split(" "),activeSentenceIndex:0,searchWord:search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase(),getCall:true,notFirstParse:true});this.getParse(search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase());}//   this.inputRef.focus();
//   this.setState({
//     search: '', startingSearch: false
//   });
// }
}},{key:"endingToEnglish",value:function endingToEnglish(ending,index,qindex){var _this4=this;var tags=[].concat(_toConsumableArray(ending.matchAll(/\[.*?\]/g)));var english1="";var english2="";var english3="";var english4="";var before=true;// console.log(this.state,tags[1])
if(ending.includes("[V]")){if(this.state.parses[index].includes("[Ind]")||this.state.parses[index].includes("[Intrg]")||this.state.parses[index].includes("[Opt]")||this.state.parses[index].includes("[Sbrd]")){before=false;}english1+="Verb Ending";english2+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[1]];english4+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["h" /* endingEnglishDescriptions */][tags[1]];if(ending.includes("[Trns]")){var subject=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[tags.length-2]];if(subject===undefined){subject="unspecified";}english3+=subject+" to "+__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[tags.length-1]];}else if(ending.includes("[Intr]")){english3+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[tags.length-1]];}}else if(ending.includes("[N]")){english1+="Noun Ending";english2+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[1]];if(ending.includes("[Abs]")){english4="";}else{english4+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["h" /* endingEnglishDescriptions */][tags[1]];}if(ending.includes("Poss")){english3+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[tags.length-2]]+"\xa0"+__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[tags.length-1]];}else{english3+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[tags.length-1]];}}else if(this.state.parses[index].includes("[D")){english1+="Demonstrative";english2+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[0]];english4+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["h" /* endingEnglishDescriptions */][tags[0]];if(__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[1]]!==undefined){english3+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[1]];}}else if(this.state.parses[index].includes("[P")){english1+="Personal Pronoun";english2+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[0]];english4+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["h" /* endingEnglishDescriptions */][tags[0]];english3+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[1]];}else if(this.state.parses[index].includes("[Q")){english1="";english2+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[0]];english4+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["h" /* endingEnglishDescriptions */][tags[0]];if(__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[1]]!==undefined){english3+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[1]];}}else{english1+=ending;english2+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[0]];english4+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["h" /* endingEnglishDescriptions */][tags[0]];if(__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[1]]!==undefined){english3+=__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["i" /* endingToEnglishTerms */][tags[1]];}}// var possibleDefinition = this.state.possibleDefinition
// var entry = possibleDefinition[index]
// entry = entry + '\xa0' + english3
// possibleDefinition[index] = entry
// this.setState({possibleDefinition:possibleDefinition})
return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingTop:15,paddingLeft:20*qindex}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontWeight:"bold",fontSize:16,paddingBottom:"1px"}},this.state.yugtun[index][qindex]),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontSize:16}},before&&english4.length!==0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",null,english4+"\xa0"):null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",null,english3),!before?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",null,"\xa0"+english4):null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{onClick:function onClick(){return _this4.setState({showMoreEnding:_this4.state.moreIndex!==index||!_this4.state.showMoreEnding?true:false,moreIndex:index});},style:{color:"#bdbdbd",fontWeight:"100",paddingTop:10,paddingBottom:10,cursor:"pointer",fontSize:16}},"more",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["n" /* Icon */],{style:{paddingLeft:5,fontSize:12},name:this.state.showMoreEnding&&index===this.state.moreIndex?"chevron up":"chevron down"})),this.state.showMoreEnding&&index===this.state.moreIndex?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{marginLeft:15,fontSize:16}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,english2),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,english1),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{onClick:function onClick(){return window.open("http://www.yugtun.com/symbols");},style:{color:"#4183c4",fontWeight:"100",textDecoration:"underline",paddingTop:10,cursor:"pointer"}},"Translation and Symbols")):null);}},{key:"getLinks",// handleTabChange = (e,data) => {
//   // console.log(data.activeIndex, this.state.activeIndex)
//   if (data.activeIndex === 0 && this.state.activeTabIndex !== 0) {
//     this.setState({ yugtunAnalyzer: false, activeTabIndex:0,parses:[],segments:[],endingIndexes:[],newSearchList:[],notFirstParse:false,search:""})
//   } else if (data.activeIndex === 1 && this.state.activeTabIndex !== 1) {
//     // if (!this.state.yugtunAnalyzer) {
//     this.setState({ yugtunAnalyzer: true, activeTabIndex:1, parses:[],segments:[],endingIndexes:[],newSearchList:[],notFirstParse:false,search:""});
//     // this.inputClicked()
//     // }
//   }
// }
value:function getLinks(index,parse){// console.log(parse)
if(index===0){// if base
if((parse[index].includes("[P")||parse[index].includes("[I"))&&parse.length===1){// if particle or ignorative
return parse[index].split("[")[0].replace(/=/g,"-");}else if(parse[index].includes("[PerPro]")){return parse[index].split("[")[0];}else if(parse[index].includes("[DemPro]")||parse[index].includes("[DemAdv]")){var dem=parse[index].replace("n[DemPro]","n'a");dem=dem.replace("[DemPro]","na");dem=dem.replace("[DemAdv]","(ni)");return dem;}else{var base=parse[0];base=base.split(/\[[^e]/)[0];// remove special tag
var dictionaryForm="";// console.log("getLinks:",base,index,parse)
if(parse[1].includes("[N")){// if Noun base:
dictionaryForm=base.replace(/([aeiu])te\b/,"$1n");// Vte -> n
dictionaryForm=dictionaryForm.replace(/([^\[])e\b/,"$1a");// e -> a
dictionaryForm=dictionaryForm.replace(/g\b/,"k");// g -> k
dictionaryForm=dictionaryForm.replace(/r(\*)?\b/,"q$1");// r(*) -> q(*)
}else if(parse[1].includes("[V")||parse[1].includes("[Q")){dictionaryForm=base+"-";// if Verb or Quant_Qual base
}else{dictionaryForm=base;}return dictionaryForm.replace(/=/g,"-");}}else{if(parse[index].includes("ete[N→V]")){return"ete[N→V]";}}// else (["[N→N]","[N→V]","[V→V]","[V→N]","[Encl]"].some(v => parse[index].includes(v))) { //if postbase or enclitic
return parse[index];}},{key:"render",value:function render(){var _this5=this;console.log("SearchPage state: ",this.state);// console.log("dictionary: ",dictionary_dict);
// console.log("fuse.js: ",fuse.search('pissur'))
// console.log("Fuzzysort: ",fuzzysort.go('pissur', dictionary, optionsFuzzy));
// console.log("Fuzzysort_prepared: ",fuzzysort.go('pissur', dictionary_prepared, optionsFuzzy));
// console.log("pissur-[V][Ind][Intr][S_3Sg]=qaa[Encl]".split('-'))
// let displayList = this.state.search.length >= 2 && this.state.wordsList.length > 0;
var pressEnter=this.state.search.length>0&&this.state.newSearchList.length===0;// let wordsList = this.state.wordsList;
var activeIndex=this.state.activeIndex;// let isCommonList = wordsList.map((word) => {
//   return Object.keys(word).some((key) => {
//     return word[key].properties && word[key].properties.indexOf('common') > -1;
//   });
// });
// if (this.state.onlyCommon) {
//   wordsList = wordsList.filter((word, i) => { return isCommonList[i]; });
// }
// let displayCommonOption = this.state.onlyCommon || (wordsList.some((word, i) => { return isCommonList[i]; }) && wordsList.some((word, i) => { return !isCommonList[i]; }));
var panes=[{menuItem:{content:"Dictionary",size:"massive"}},{menuItem:"Yugtun to English"}];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */],{style:{paddingTop:"14px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{paddingBottom:10}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Column,{style:{paddingLeft:0,paddingRight:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["p" /* Input */],{ref:this.handleRef,autoCorrect:false,placeholder:"Search by Yugtun...",action:{icon:"search",transparent:true,size:"huge",onClick:function onClick(){return _this5.inputClicked();}}// icon={<Icon name='search' onClick={console.log('hi')} link />}
,iconPosition:"right",size:"huge",onChange:this.onChangeSearch,value:this.state.search,onKeyPress:this.onKeyPress,fluid:true})))),this.state.search.length>0||this.state.notFirstParse?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["z" /* Segment */],{vertical:true,style:{fontSize:22,padding:0,marginTop:20,maxHeight:145,overflow:"auto",borderBottom:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{display:"flex",flexWrap:"wrap"}},this.state.newSearchList.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{onClick:function onClick(){if(index!==_this5.state.activeSentenceIndex){_this5.setState({getCall:true,activeSentenceIndex:index,searchWord:_this5.state.newSearchList[index].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase(),parses:[],segments:[],endingIndexes:[],yugtun:[],english:[],links:[],entries:undefined,activeIndex:-1,loaderOn:true,seeMoreActive:false,currentTableOpen:-1});_this5.getParse(_this5.state.newSearchList[index].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase());}},onMouseEnter:function onMouseEnter(){_this5.setState({hover:index});},onMouseLeave:function onMouseLeave(){_this5.setState({hover:-1});},style:{marginTop:10,paddingBottom:_this5.state.activeSentenceIndex===index||_this5.state.hover===index?3:5,cursor:"pointer",marginRight:6,borderBottomColor:"red",borderBottom:_this5.state.activeSentenceIndex===index||_this5.state.hover===index?"3px solid #000000DE":"1px solid #000000DE",color:"#000000DE"}},i);}))):null,this.state.getCall?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingTop:20}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["t" /* Loader */],{active:true,inline:true})):null,this.state.parses.length===0&&!this.state.getCall&&this.state.notFirstParse?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingTop:20}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontStyle:"italic",marginTop:10}},"No results. Pisciigatuq. Type a complete Yugtun word.")):null,pressEnter?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("i",null,"Press ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"Enter")," to parse. Must be complete Yugtun word(s).")):"",!this.state.getCall&&(this.state.search.length>0||this.state.notFirstParse)?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingTop:20}},this.state.parses.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingBottom:10}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["q" /* Label */],{circular:true,color:"#E5E5E5"},index+1)),index===0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontSize:16,color:"#deb103",fontWeight:"300"}},"Most Likely Result"):null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontSize:22}},_this5.state.segments[index].replace(/</g,"·").replace(/&/g,"·").replace(/↞/g,"·").replace(/↠/g,"·").replace(/·$/g,"")),i.split("-").map(function(q,qindex){return qindex===_this5.state.endingIndexes[index]?_this5.endingToEnglish(q,index,qindex):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingTop:15,paddingLeft:qindex*20,fontSize:"16px"}},_this5.state.links[index][qindex]!==""?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontWeight:"bold",fontFamily:"Lato,Arial,Helvetica,sans-serif",textDecoration:"underline",color:'#4183c4',paddingBottom:"5px"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],{to:{pathname:_this5.state.links[index][qindex],state:{word:_this5.state.links[index][qindex],search:_this5.state.search,newSearchList:_this5.state.newSearchList,parses:_this5.state.parses,segments:_this5.state.segments,endingIndexes:_this5.state.endingIndexes,yugtun:_this5.state.yugtun,english:_this5.state.english,links:_this5.state.links,searchBarStuckTop:_this5.state.searchBarStuckTop,notFirstParse:_this5.state.notFirstParse,searchWord:_this5.state.searchWord,activeSentenceIndex:_this5.state.activeSentenceIndex// activeTabIndex: this.state.activeTabIndex,
}}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",null,_this5.state.yugtun[index][qindex]))),_this5.state.english[index][qindex]):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontWeight:"bold",fontFamily:"Lato,Arial,Helvetica,sans-serif",textDecoration:"underline"}},_this5.state.yugtun[index][qindex]));}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingTop:15,paddingBottom:15,textAlign:"center"}},!_this5.state.parses[index].includes("-")&&(_this5.state.parses[index].includes("[I")||_this5.state.parses[index].includes("[P"))?null:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["b" /* Button */],{basic:true,color:"blue",style:{fontFamily:"sans-serif",fontSize:16},onClick:function onClick(){_this5.setState({currentTableOpen:_this5.state.currentTableOpen===index?-1:index,activeIndex:-1});}},_this5.state.currentTableOpen===index?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,"See Less Endings",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["n" /* Icon */],{style:{paddingLeft:10},name:"chevron up"})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,"See More Endings",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["n" /* Icon */],{style:{paddingLeft:10},name:"chevron down"})))),_this5.state.currentTableOpen===index?_this5.state.parses[index].includes("[V]")?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */],{style:{fontSize:16},fluid:true,styled:true},__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["b" /* accordionTitlesVerbs */].map(function(p,pindex){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===pindex,index:pindex,currentIndex:index,onClick:_this5.handleClick},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["n" /* Icon */],{name:"dropdown"}),p),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===pindex},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingBottom:15}},__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["g" /* endingDescriptions */][pindex]),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingBottom:10,fontStyle:"italic"}},"Examples: "+__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["j" /* exampleSentences */][pindex]),_this5.state.loaderOn?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["t" /* Loader */],{active:true,inline:true}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TableEntry_js__["a" /* default */],{entries:_this5.state.entries,mood:_this5.state.mood}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontStyle:"italic",paddingTop:15,paddingBottom:5}},"Note: Many verb bases can be intransitive-only, transitive-only, or only allow certain endings. There are occasional mistakes."))));})):_this5.state.parses[index].includes("[N]")?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */],{style:{fontSize:16},fluid:true,styled:true},__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["a" /* accordionTitlesNouns */].map(function(p,pindex){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===pindex+12,index:pindex+12,currentIndex:index,onClick:_this5.handleClick},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["n" /* Icon */],{name:"dropdown"}),p),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===pindex+12},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingBottom:15}},__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["g" /* endingDescriptions */][pindex+12]),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{paddingBottom:15,fontStyle:"italic"}},"Examples: "+__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["j" /* exampleSentences */][pindex+12]),_this5.state.loaderOn?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["t" /* Loader */],{active:true,inline:true})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TableEntry_js__["a" /* default */],{entries:_this5.state.entries,mood:_this5.state.mood})));})):_this5.state.parses[index].includes("[Q")?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */],{style:{fontSize:16},fluid:true,styled:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===19,index:19,currentIndex:index,onClick:_this5.handleClick},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["n" /* Icon */],{name:"dropdown"}),"Quantifier/Qualifier Inflections"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===19},_this5.state.loaderOn?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["t" /* Loader */],{active:true,inline:true})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TableEntry_js__["a" /* default */],{entries:_this5.state.entries,mood:_this5.state.mood})))):_this5.state.parses[index].includes("[P")?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */],{style:{fontSize:16},fluid:true,styled:true},__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["a" /* accordionTitlesNouns */].map(function(p,pindex){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===pindex+20,index:pindex+20,currentIndex:index,onClick:_this5.handleClick2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["n" /* Icon */],{name:"dropdown"}),p),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===pindex+20},_this5.state.loaderOn?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["t" /* Loader */],{active:true,inline:true})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */],{unstackable:true,celled:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{textDecoration:"underline",color:"#002477"}},"Subject"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].HeaderCell,null))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["n" /* persPronounSubjects */].map(function(i,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["o" /* persPronounsEnglish */][index]),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this5.state.entries[__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["m" /* persPronounLabels */][pindex]+i].join(",\n").replace(/>/g,"")));})))))));})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */],{style:{fontSize:16},fluid:true,styled:true},__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["f" /* demPronounTitles */].map(function(p,pindex){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===pindex+27,index:pindex+27,currentIndex:index,onClick:_this5.handleClick2},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["n" /* Icon */],{name:"dropdown"}),p),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===pindex+27},_this5.state.loaderOn?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["t" /* Loader */],{active:true,inline:true})):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontStyle:"italic",marginTop:5,marginBottom:10}},"Extended: moving, long, or of large extent"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontStyle:"italic",marginTop:10,marginBottom:10}},"Restricted: stationary, localized, visible"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontStyle:"italic",marginTop:10,marginBottom:20}},"Obscured: stationary, indistinct or out of sight"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["z" /* Segment */],{style:{margin:0,overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */],{unstackable:true,celled:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Header,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].HeaderCell,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,color:"#7b0e0e"}},"Extended"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,color:"#7b0e0e"}},"Restricted"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{paddingLeft:10,color:"#7b0e0e"}},"Obscured")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Cell,{style:{fontStyle:"italic"}},"pronoun forms:"))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Body,null,__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["e" /* demPronounSubjects */].map(function(i,index){return index===24?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Cell,{style:{fontStyle:"italic"}},"adverb forms:")):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Row,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].HeaderCell,{style:{color:"#002477"}},__WEBPACK_IMPORTED_MODULE_10__constants_endingsConstants_js__["d" /* demPronounEnglish */][index]),"extended"in _this5.state.entries[p]?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this5.state.entries[p]["extended"][i].join(",\n").replace(/>/g,"")):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},"-"),"restricted"in _this5.state.entries[p]?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this5.state.entries[p]["restricted"][i].join(",\n").replace(/>/g,"")):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},"-"),"obscured"in _this5.state.entries[p]?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},_this5.state.entries[p]["obscured"][i].join(",\n").replace(/>/g,"")):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["B" /* Table */].Cell,{style:{paddingLeft:10}},"-"));})))))));})):null);}),this.state.newSearchList.length!==0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["g" /* Divider */],{style:{paddingBottom:0}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-evenly",alignItems:"center",height:60,paddingBottom:16}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:"30px",opacity:0.7},src:"https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg"}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:"30px",opacity:0.7},src:"https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg"}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:"30px",opacity:0.7},src:"https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg"}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:"30px",opacity:0.7},src:"https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg"}))):null):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */],{divided:true,selection:true},this.state.search.length===0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"center"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{fontSize:"1.2rem",color:"#666",lineHeight:1.6,maxWidth:500}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{textDecoration:"underline",marginBottom:10,marginTop:15}}," ","Yugtun to English"," "),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{style:{marginBottom:10}}," ","Type any complete Yugtun word or sentence and press"," ",__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("b",null,"Enter")," to see the meaning of each part of the word."," "),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null," Examples: "),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{onClick:function onClick(){_this5.setState({search:"elitnaurvigmi",yugtunAnalyzer:true,// activeTabIndex: 1,
parses:[],segments:[],endingIndexes:[],yugtun:[],english:[],links:[],newSearchList:[],notFirstParse:false});_this5.inputClicked("elitnaurvigmi");},style:{textDecoration:"underline",color:"#4A80B5",cursor:"pointer"}},"elitnaurvigmi"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",null,", "),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{onClick:function onClick(){_this5.setState({search:"piipiqa popsicle-aamek ner'uq",yugtunAnalyzer:true,// activeTabIndex: 1,
parses:[],segments:[],endingIndexes:[],yugtun:[],english:[],links:[],newSearchList:[],notFirstParse:false});_this5.inputClicked("piipiqa popsicle-aamek ner'uq");},style:{textDecoration:"underline",color:"#4A80B5",cursor:"pointer"}},"piipiqa popsicle-aamek ner'uq"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",null,", "),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span",{onClick:function onClick(){_this5.setState({search:"ellami-lli assirpaa",yugtunAnalyzer:true,// activeTabIndex: 1,
parses:[],segments:[],endingIndexes:[],yugtun:[],english:[],links:[],newSearchList:[],notFirstParse:false});_this5.inputClicked("ellami-lli assirpaa");},style:{textDecoration:"underline",color:"#4A80B5",cursor:"pointer"}},"ellami-lli assirpaa"))))):null));}}]);return SearchPage;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchPage);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__YupikEntry_js__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_StickyMenu_js__ = __webpack_require__(147);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikDetails=function(_Component){_inherits(YupikDetails,_Component);function YupikDetails(props){_classCallCheck(this,YupikDetails);var _this=_possibleConstructorReturn(this,(YupikDetails.__proto__||Object.getPrototypeOf(YupikDetails)).call(this,props));console.log("YupikDetails props: ",props);_this.state={search:props.location.state===undefined?'':props.location.state.search,wordsList:props.location.state===undefined?[]:props.location.state.wordsList,yugtunAnalyzer:props.location.state===undefined?false:props.location.state.yugtunAnalyzer,currentWord:"",modifiedWord:"",fullWord:"",fromSearch:props.location.state!==undefined};_this.getWord=_this.getWord.bind(_this);// Fetch more word informations from API
_this.getWord(props.match.params.word);return _this;}_createClass(YupikDetails,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.match.params.word!==this.props.match.params.word){this.getWord(this.props.match.params.word);}}},{key:'getWord',value:function getWord(word){var _this2=this;__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__App_js__["a" /* API_URL */]+"/word2021/"+word).then(function(response){console.log(response.data);_this2.setState({currentWord:word,modifiedWord:word,fullWord:response.data});});}},{key:'render',value:function render(){// console.log(this.state)
// let numEntries = Object.keys(this.state.fullWord).filter((entryNumber) => {
//   return entryNumber !== 'english' && entryNumber !== 'yupik';
// }).length;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["e" /* Container */],{style:{margin:0,padding:0},text:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__YupikEntry_js__["a" /* default */],{entry:this.state.fullWord,word:this.state.modifiedWord}));}}]);return YupikDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_router__["a" /* withRouter */])(YupikDetails));

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__YupikEntry_js__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_StickyMenu_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_newconstants_js__ = __webpack_require__(79);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customFontFam="Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif";var options=[{key:1,text:'it',value:1},{key:2,text:'you',value:2}];var peopleDict={'1':"Sg",'2':"Du",'3':"Pl"};var SimpleWordBuilder=function(_Component){_inherits(SimpleWordBuilder,_Component);function SimpleWordBuilder(props){_classCallCheck(this,SimpleWordBuilder);var _this=_possibleConstructorReturn(this,(SimpleWordBuilder.__proto__||Object.getPrototypeOf(SimpleWordBuilder)).call(this,props));_this.defaultFstCall=function(){console.log(_this.state);var tag=_this.state.tag;var value1='';var value2='';var nounvalue1='';var nounvalue2='';var owner='';// console.log(tag,ind)
if(tag==='i'){// value1 = "s31-1(1)"  
// let items = this.identifySubjectandIsCase(this.state.definition)
// console.log(items)
_this.setIntransitive(true,undefined,undefined);// this.setState({person: 3,people: 1, value1: "31-1(1)",activeEditIndex:ind}); this.getFSTParse(fstCall,ind,0); 
}else if(tag==='n'){nounvalue1="1";nounvalue2="00(3)";owner='Unpd';var definitionBaseOptions=[];_this.state.definition.map(function(k,index){definitionBaseOptions.push({value:index,key:index,text:k[0].replace("⟨","").replace("⟩","")});});_this.setState({definitionBaseOptions:definitionBaseOptions});_this.setNoun(true,nounvalue1,nounvalue2,owner,undefined,undefined);}else if(tag==='t'){// let values = this.identifySubjectIsObjectCase(this.state.definition)
// console.log(splitSentence[0],splitSentence[1])
// this.setState({
// transitiveLeftOfObject: this.state.,
// transitiveRightOfObject: splitSentence[1].replace("⟨","").replace("⟩",""),
// entryModified: matches[0],
// });
_this.setTransitive(true,undefined,undefined);}};_this.getSubjectIs=function(personN,peopleN){var subjectis='';if(_this.state.containsIs){if(peopleN==='1'&&personN==='1'){subjectis='am';}else if(peopleN==='1'&&personN==='3'){subjectis='is';}else{subjectis='are';}}return subjectis;};_this.processStyledText=function(sentence){sentence=sentence.replace("⟨","").replace("⟩","");var matches=sentence.match(/\⎡.*?\⎤/g);if(matches!==null){matches.map(function(m){return sentence=sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>');});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:sentence}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence);}};_this.processStyledText2=function(sentence,ind,tag){// console.log(sentence,ind,tag)
sentence=sentence.replace("⟨","").replace("⟩","").replace("<","").replace(">","").replace("[","").replace("]","").replaceAll("^","");// if (tag == 'NOUN') {
//   sentence = 'the one '+sentence
// } else {
//   if (ind % 2 == 0) {
//   sentence = 'she is '+sentence       
//   } else {
//   sentence = 'he is '+sentence
//   }     
// }
// let matches = sentence.match(/\⎡.*?\⎤/g)
// if (matches !== null) {
//   matches.map((m) => sentence = sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>'))   
//   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
// } else {
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence);// }
};_this.processStyledText3=function(sentence){// sentence = sentence.replace("⟨","").replace("⟩","")
var matches=sentence.match(/\^.*?\^/g);var type1='';// let self = sentence.includes('self')
var regSub=['^he^','^she^','^it^'];var regObj=['^him^','^she^','^it^'];var self=['^himself^','^herself^','^itself^'];var poss=['^her^','^his^','^its^'];if(matches!==null){if(regSub.includes(matches[0])){type1='regSub';}else if(regObj.includes(matches[0])){type1='regObj';}else if(self.includes(matches[0])){type1='self';}else if(poss.includes(matches[0])){type1='poss';}matches.map(function(m){return sentence=sentence.replace(m,__WEBPACK_IMPORTED_MODULE_10__constants_newconstants_js__["R" /* retrieveReflexiveSubjectPronoun */][type1][_this.state.value1]);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:sentence}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence);}};_this.usageEntry=function(tag){if(tag==='n'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'15px',marginLeft:'0px',fontSize:'20px',color:'#000000',fontWeight:'300'}},_this.state.entryModified.map(function(modifiedword,m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,m>0?', ':null,_this.state.baseCases.length==1?modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:modifiedword.split(">").length-1==index?'#852828':'#000000'}},q);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,onChange:_this.changeActiveUsageKey.bind(_this),text:modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:modifiedword.split(">").length-1==index?'#852828':'#000000'}},q);}),value:_this.state.activeKeyInEditIndex,options:_this.state.baseOptions}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){return console.log('hi');},style:{marginLeft:'20px',color:'#8F8F8F',cursor:'pointer'},name:'volume up'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'15px',marginBottom:'15px',marginLeft:'0px',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setNoun.bind(_this,false,'','',''),value:_this.state.nounvalue2,options:__WEBPACK_IMPORTED_MODULE_10__constants_newconstants_js__["v" /* nounoptions1 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setNoun.bind(_this,false,'','',''),value:_this.state.nounvalue1,options:__WEBPACK_IMPORTED_MODULE_10__constants_newconstants_js__["w" /* nounoptions2 */]}),_this.state.definition.length>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,onChange:_this.changeActiveDefinitionKey.bind(_this),value:_this.state.activeDefinitionInEditIndex,options:_this.state.definitionBaseOptions}):_this.state.nounvalue1!=='1'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.definition[_this.state.activeDefinitionInEditIndex][2][1])):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.definition[_this.state.activeDefinitionInEditIndex][2][0]))));}else if(tag==='i'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'15px',marginLeft:'0px',fontSize:'20px',color:'#000000',fontWeight:'300'}},_this.state.entryModified.map(function(modifiedword,m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,m>0?', ':null,_this.state.baseCases.length==1?modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:modifiedword.split(">").length-1==index?'#852828':'#000000'}},q);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,onChange:_this.changeActiveUsageKey.bind(_this),text:modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:modifiedword.split(">").length-1==index?'#852828':'#000000'}},q);}),value:_this.state.activeKeyInEditIndex,options:_this.state.baseOptions}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){return console.log('hi');},style:{marginLeft:'20px',color:'#8F8F8F',cursor:'pointer'},name:'volume up'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'3px',marginBottom:'15px',marginLeft:'0px',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.preSubjectText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setIntransitive.bind(_this,false),value:_this.state.value1,options:__WEBPACK_IMPORTED_MODULE_10__constants_newconstants_js__["A" /* options1 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.getSubjectIs(_this.state.value1[1],_this.state.value1[2])+" "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.primaryVerb+" ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText3(_this.state.preObjectText+" ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText3(_this.state.afterObjectText+" "))));}else if(tag==='t'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'15px',marginLeft:'0px',fontSize:'20px',color:'#000000',fontWeight:'300'}},_this.state.entryModified.map(function(modifiedword,m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,m>0?', ':null,_this.state.baseCases.length==1?modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:modifiedword.split(">").length-1==index?'#852828':'#000000'}},q);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,onChange:_this.changeActiveUsageKey.bind(_this),text:modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:modifiedword.split(">").length-1==index?'#852828':'#000000'}},q);}),value:_this.state.activeKeyInEditIndex,options:_this.state.baseOptions}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){return console.log('hi');},style:{marginLeft:'20px',color:'#8F8F8F',cursor:'pointer'},name:'volume up'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'3px',marginBottom:'15px',marginLeft:'0px',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.preSubjectText+" ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setTransitive.bind(_this,false),value:_this.state.value1,options:__WEBPACK_IMPORTED_MODULE_10__constants_newconstants_js__["A" /* options1 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.getSubjectIs(_this.state.value1[1],_this.state.value1[2])+" "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.primaryVerb+" ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText3(_this.state.preObjectText+" ")),_this.state.objectPossessed?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setTransitive.bind(_this,false),value:_this.state.value2,options:__WEBPACK_IMPORTED_MODULE_10__constants_newconstants_js__["C" /* options3 */]}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setTransitive.bind(_this,false),value:_this.state.value2,options:__WEBPACK_IMPORTED_MODULE_10__constants_newconstants_js__["B" /* options2 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText3(_this.state.afterObjectText))));}};console.log("YupikDetails props: ",props);console.log(props.entry);// console.log(props.entry[5][0])
_this.state={tag:props.entry[0],baseCases:props.entry[1],baseWord:props.entry[2],definition:props.entry[3],firstVerb:'',preSubjectText:'',value1:'',afterSubjectText:'',containsIs:'',primaryVerb:'',preObjectText:'',value2:'',afterObjectText:'',// baseCases: ['pissur','nere'], // from json
// definitionraw: "⟨hunting⟩ <it>", 
// firstVerb: [
//               "hunt", 
//               "hunted", 
//               "hunts", 
//               "hunting"
//           ],
// containsIs: false,
fstCall:'',objectPossessed:false,baseOptions:[],activeKeyInEditIndex:0,// definition: props.entry === undefined ? '' : props.definition,
entryModified:[],verbMood:'Indicative',nounMood:'Absolutive',wordBuilderOn:false,nounvalue1:'1',nounvalue2:'00(3)',activeDefinitionInEditIndex:0,pluralizedDefinition:'',definitionBaseOptions:[]// base: props.base === undefined ? '' : props.base,
};if(props.entry[0]!=='n'){_this.state=Object.assign({},_this.state,{firstDefinition:props.entry[3],firstVerb:_this.props.entry[4],preSubjectText:_this.props.entry[5][0],value1:_this.props.entry[5][1],afterSubjectText:_this.props.entry[5][2],containsIs:_this.props.entry[5][3],primaryVerb:_this.props.entry[5][4],preObjectText:_this.props.entry[5][5],value2:_this.props.entry[5][6],afterObjectText:_this.props.entry[5][7]});}else{_this.state=Object.assign({},_this.state,{firstDefinition:'the one '+props.entry[3][0][0]});}// this.initialize = this.initialize.bind(this);
// this.initialize(this,props.entry[0]);
// this.getWord = this.getWord.bind(this);
// this.getWord(decodeURI(props.match.params.word));
return _this;}_createClass(SimpleWordBuilder,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){console.log(nextProps);this.setState({tag:nextProps.entry[0],baseCases:nextProps.entry[1],baseWord:nextProps.entry[2],definition:nextProps.entry[3],firstVerb:'',preSubjectText:'',value1:'',afterSubjectText:'',containsIs:'',primaryVerb:'',preObjectText:'',value2:'',afterObjectText:'',fstCall:'',objectPossessed:false,baseOptions:[],activeKeyInEditIndex:0,entryModified:[],verbMood:'Indicative',nounMood:'Absolutive',wordBuilderOn:false,nounvalue1:'1',nounvalue2:'00(3)',activeDefinitionInEditIndex:0,pluralizedDefinition:'',definitionBaseOptions:[]});if(nextProps.entry[0]!=='n'){this.setState({firstDefinition:nextProps.entry[3],firstVerb:nextProps.entry[4],preSubjectText:nextProps.entry[5][0],value1:nextProps.entry[5][1],afterSubjectText:nextProps.entry[5][2],containsIs:nextProps.entry[5][3],primaryVerb:nextProps.entry[5][4],preObjectText:nextProps.entry[5][5],value2:nextProps.entry[5][6],afterObjectText:nextProps.entry[5][7]});}else{this.setState({firstDefinition:'the one '+nextProps.entry[3][0][0]});}}// componentDidUpdate(prevProps) {
//   if (prevProps.match.params.word !== this.props.match.params.word) {
//     this.getWord(decodeURI(this.props.match.params.word));
//   }
// }
// getWord(word) {
//   axios
//     .get(API_URL + "/word2021/" + encodeURIComponent(word))
//     .then(response => {
//       // console.log(response.data);
//       this.setState({
//         currentWord: word,
//         modifiedWord: word,
//         fullWord: response.data
//       });
//     });
// }
// initialize(tag) {
//   console.log(tag.state.tag)
//   if (tag.state.tag !== 'n') {
//     console.log('hi',this.props)
//     this.setState({
//       firstVerb: this.props.entry[4],
//       preSubjectText: this.props.entry[5][0],
//       value1: this.props.entry[5][1],
//       afterSubjectText: this.props.entry[5][2],
//       containsIs: this.props.entry[5][3],
//       primaryVerb: this.props.entry[5][4],
//       preObjectText: this.props.entry[5][5],
//       value2: this.props.entry[5][6],
//       afterObjectText: this.props.entry[5][7],
//     })
//   }
// }
// getFSTParse(fstCall,activeEditIndex,activeKeyInEditIndex) {
//   console.log(fstCall,activeEditIndex,activeKeyInEditIndex)
//   let FSTsearch = this.state.definition[activeEditIndex][3][activeKeyInEditIndex] + fstCall
//   // console.log(FSTsearch,activeEditIndex)
//   let baseOptions = []
//   this.state.definition[activeEditIndex][3].map((m,ind)=>{
//     baseOptions.push({id:ind,value:ind,text:m})
//   })
//   this.setState({baseOptions:baseOptions})
//   console.log(encodeURIComponent(FSTsearch))
//   axios
//     .get(API_URL + "/inupiaqsegment/" + encodeURIComponent(FSTsearch))
//     .then(response => {
//       console.log(response.data);
//       this.setState({
//         entryModified: response.data.words,
//       });
//       // if (response.data.chld !== []) {}
//       // console.log(response.data.etymology)
//       // if (response.data.etymology !== []) {
//       //  this.setState({etymology: response.data.etymology[0]})
//       // }
//     });
// }
// identifySubjectandIsCase = (match) => {
//   //   console.log('eventually set the object type here, her/him versus it')
//   // console.log(match)
//   // if (match == '<her/him>') {
//   //  if (ind % 2 === 0) {
//   //    //return him
//   //  } else {
//   //    //return her
//   //  }
//   // value2 = "o31-1(2)"  him
//   // value2 = "o31-2(2)"  her
//   // value2 = "o31-3(2)"  its
//   // }
//   let value1 = ''
//   let containsIs = false
//   // let value2 = ''
//   // let possessed = false
//   // if (ind % 2 == 0) {
//   // value1 = "s31-2(1)"  
//   // } else {
//   // value1 = "s31-1(1)"  
//   // }
//   if (match.includes('[he]')) {
//     value1 = "s31-1(1)"
//     match = match.replace('[he]','')
//   } else if (match.includes('[she]')) {
//     // if (ind % 2 == 0) {
//     value1 = "s31-2(1)"     
//     match = match.replace('[she]','')
//     // } else {
//     // value2 = "o31-2(2)"
//     // }
//   } else if (match.includes('[it]')) {
//     // if (ind % 2 == 0) {
//     value1 = "s31-3(1)"     
//     match = match.replace('[it]','')
//     // } else {
//     // value2 = "o31-2(2)"
//     // }
//   } else {
//     value1 = "s31-3(1)"
//   }
//   console.log(match)
//   let matches = match.trim().split(' ')
//   let definitionraw = ''
//   console.log(matches)
//   if (matches[0] == 'is') {
//     containsIs = true
//     definitionraw = matches.slice(1,).join(' ')
//   }
//   this.setState({
//     definitionraw:definitionraw,
//     containsIs:containsIs,
//   })
//   return [value1, containsIs, definitionraw]
// }
// identifySubjectIsObjectCase = (match) => {
//   console.log('eventually set the object type here, her/him versus it')
//   console.log(match)
//   let matches = this.state.definitionraw.match(/\<.*?\>/g)
//   let splitSentence = []
//   if (matches.length == 1) {
//     splitSentence = this.state.definitionraw.split(matches[0])
//   }      
//   // if (match == '<her/him>') {
//   //  if (ind % 2 === 0) {
//   //    //return him
//   //  } else {
//   //    //return her
//   //  }
//   // value2 = "o31-1(2)"  him
//   // value2 = "o31-2(2)"  her
//   // value2 = "o31-3(2)"  its
//   // }
//   let value1 = ''
//   let value2 = ''
//   let possessed = false
//   // if (ind % 2 == 0) {
//   value1 = "s31-2(1)"  
//   // } else {
//   // value1 = "s31-1(1)"  
//   // }
//   if (match == '<her/him/it>') {
//     value2 = "o31-3(2)"
//   } else if (match == '<her/him>') {
//     // if (ind % 2 == 0) {
//     value2 = "o31-1(2)"     
//     // } else {
//     // value2 = "o31-2(2)"
//     // }
//   } else if (match == '<her/his>') {
//     // if (ind % 2 == 0) {
//     value2 = "o31-1(2)"     
//     // } else {
//     // value2 = "o31-2(2)"
//     // }
//   } else if (match == '<her>') {
//     value2 = "o31-2(2)"
//   } else if (match == '<him>') {
//     value2 = "o31-1(2)"
//   } else if (match == '<a person/it>') {
//     value2 = "o31-3(2)"
//   } else if (match == '<it>') {
//     value2 = "o31-3(2)"
//   } else if (match == '<them>') {
//     value2 = "o33(2)"
//   } else if (match == '<someone/something>') {
//     value2 = "o31-3(2)"
//   } else if (match == '<her/his/its>') {
//     possessed = true
//     value2 = "o31-3(2)"
//   } else {
//     value2 = "o31-3(2)"     
//   }
//   this.setState({objectPossessed:possessed})
//   return [value1, value2]
// }
},{key:'setIntransitive',value:function setIntransitive(initializing,e,data){console.log(e,data);// console.log(this.state.definitionraw)
var value1=this.state.value1;console.log(value1);if(!initializing){value1=data.value;// person = data.value[0]
// people = data.value[1]
}var fstCall='';if(this.state.verbMood==='Indicative'){fstCall='-[V][Ind][Intr][S_'+value1[1]+peopleDict[value1[2]]+']';}this.setState({value1:value1,// activeEditIndex:ind,
// person: person,
// people: people,
fstCall:fstCall});this.getFSTParse(fstCall,this.state.activeKeyInEditIndex);}},{key:'setNoun',value:function setNoun(initializing,nounvalue1,nounvalue2,owner,e,data){var _this2=this;console.log(e,data,initializing,nounvalue1,nounvalue2,owner);if(!initializing){if(data.value.length==1){nounvalue1=data.value;nounvalue2=this.state.nounvalue2;}else{nounvalue1=this.state.nounvalue1;nounvalue2=data.value;}if(nounvalue2[0]!=='0'){owner=nounvalue2[0]+peopleDict[nounvalue2[1]]+'Poss';}else{owner='Unpd';}console.log(owner);// value1 = data.value
// person = data.value[0]
// people = data.value[1]
}var fstCall='';console.log(peopleDict[nounvalue1],owner);if(this.state.nounMood==='Absolutive'){if(owner!=='Unpd'){fstCall='-[N][Abs]['+owner+']['+peopleDict[nounvalue1]+'Posd]';}else{fstCall='-[N][Abs]['+peopleDict[nounvalue1]+owner+']';}}var definitionBaseOptions=[];this.state.definition.map(function(k,index){var sentence=_this2.state.definition[index][0];var matches=sentence.match(/\⟨.*?\⟩/g);if(matches!==null){if(nounvalue1!=='1'){matches.map(function(m){return sentence=sentence.replace(m,_this2.state.definition[index][2][1]);});}else{matches.map(function(m){return sentence=sentence.replace(m,_this2.state.definition[index][2][0]);});}}// console.log(sentence)
definitionBaseOptions.push({value:index,key:index,text:sentence});});this.setState({nounvalue1:nounvalue1,nounvalue2:nounvalue2,value1:"s31-3(1)",definitionBaseOptions:definitionBaseOptions,// activeEditIndex:ind,
// person: person,
// people: people,
fstCall:fstCall});this.getFSTParse(fstCall,this.state.activeKeyInEditIndex);}},{key:'setTransitive',value:function setTransitive(initializing,e,data){// console.log(e, data, ind, initializing)
var value1=this.state.value1;var value2=this.state.value2;if(!initializing){console.log(data.value);if(data.value[0]=='s'){value1=data.value;}else{value2=data.value;}// person = data.value[0]
// people = data.value[1]
}var fstCall='';if(this.state.verbMood==='Indicative'){fstCall='-[V][Ind][Trns][A_'+value1[1]+peopleDict[value1[2]]+'][P_'+value2[1]+peopleDict[value2[2]]+']';}this.setState({value1:value1,value2:value2,// activeEditIndex:ind,
// person: person,
// people: people,
fstCall:fstCall});this.getFSTParse(fstCall,this.state.activeKeyInEditIndex);}//   if (this.state.nounMood === 'Absolutive') {
//    let fstCall = '>+N+Abs+'+
//   }
//   this.getFSTParse(fstCall,this.state.activeEditIndex,this.state.activeKeyInEditIndex)
// }
// setNounNumber(e, data) {
//  // console.log(data)
//   this.setState({
//     value1: data.value,
//     person: parseInt(data.value[0]),
//     people: parseInt(data.value[1])
//   });
//   this.getFSTParse(">+V+Ind+Prs+",data.value[0],data.value[1],this.state.activeEditIndex,this.state.activeKeyInEditIndex)
// }
},{key:'changeActiveUsageKey',value:function changeActiveUsageKey(entry,data){console.log(data);this.setState({// value1: data.value,
activeKeyInEditIndex:data.value});this.getFSTParse(this.state.fstCall,data.value);}},{key:'changeActiveDefinitionKey',value:function changeActiveDefinitionKey(entry,data){console.log(data);var num=data.value;// console.log(data.options)
this.setState({// value1: data.value,
activeDefinitionInEditIndex:data.value// baseCase: data.options[data.value].text,
});console.log(this.state.definition[data.value][0]);var sentence=this.state.definition[data.value][0];var matches=sentence.match(/\⟨.*?\⟩/g);if(matches!==null){matches.map(function(m){return sentence=sentence.replace(m,m.slice(1,-1));});}console.log(sentence);this.setState({pluralizedDefinition:sentence});// console.log(this.state.usageDefinition[data.value][])
// this.getFSTParse(this.state.baseCase,this.state.currentPostbases,this.state.tag,this.state.verbMood,this.state.moodSpecific,this.state.value1,this.state.value2,this.state.nounMood,this.state.nounvalue1,this.state.nounvalue2)
}},{key:'getFSTParse',value:function getFSTParse(fstCall,activeKeyInEditIndex){var _this3=this;console.log(fstCall,activeKeyInEditIndex);var FSTsearch=this.state.baseCases[activeKeyInEditIndex]+fstCall;console.log(FSTsearch);var baseOptions=[];this.state.baseCases.map(function(m,ind){baseOptions.push({id:ind,value:ind,text:m});});this.setState({baseOptions:baseOptions,wordBuilderOn:true});console.log(encodeURIComponent(FSTsearch));__WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_6__App_js__["a" /* API_URL */]+"/segment/"+encodeURIComponent(FSTsearch)).then(function(response){console.log(response.data);_this3.setState({entryModified:response.data.words});// if (response.data.chld !== []) {}
// console.log(response.data.etymology)
// if (response.data.etymology !== []) {
//  this.setState({etymology: response.data.etymology[0]})
// }
});}},{key:'render',value:function render(){console.log(this.state);// let numEntries = Object.keys(this.state.fullWord).filter((entryNumber) => {
//   return entryNumber !== 'english' && entryNumber !== 'yupik';
// }).length;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.wordBuilderOn?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'20px',color:'#000000',fontWeight:'300',marginLeft:'8px'}},this.usageEntry(this.state.tag),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:{pathname:'/wordbuilder/'+this.state.baseWord,state:{word:this.state.baseWord,activeDefinitionInEditIndex:this.state.activeDefinitionInEditIndex,activeKeyInEditIndex:this.state.activeKeyInEditIndex,usageDefinition:this.state.definition,baseCase:this.state.baseCases,nounvalue1:this.state.nounvalue1,nounvalue2:this.state.nounvalue2,value1:this.state.value1,value2:this.state.value2}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{fontSize:'16px',fontWeight:'300',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',fontFamily:customFontFam}},'Try Word Builder')))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'12px',marginLeft:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'20px',color:'#000000',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.baseWord),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){return console.log('hi');},style:{marginLeft:'20px',color:'#8F8F8F',cursor:'pointer'},name:'volume up'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{onClick:this.defaultFstCall.bind(this),style:{marginLeft:'5px',fontSize:'20px',color:'#989898',cursor:'pointer'},name:'edit outline'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'10px',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},this.processStyledText2(this.state.firstDefinition)))));}}]);return SimpleWordBuilder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8_react_router__["a" /* withRouter */])(SimpleWordBuilder));

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(231);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(893);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(445);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectSpread2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(887);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(888);

function _defineProperty(e, r, t) {
  return (r = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPropertyKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(889);


function toPropertyKey(t) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(t, "string");
  return "symbol" == Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i) ? i : i + "";
}


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPrimitive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(444);

function toPrimitive(t, r) {
  if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(445);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(446);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(894);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(231);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(896);


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(897);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 897 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

var UAParser = __webpack_require__(899);

var ClientUAInstance = new UAParser();
var browser = ClientUAInstance.getBrowser();
var cpu = ClientUAInstance.getCPU();
var device = ClientUAInstance.getDevice();
var engine = ClientUAInstance.getEngine();
var os = ClientUAInstance.getOS();
var ua = ClientUAInstance.getUA();
var setUa = function setUa(userAgentString) {
  return ClientUAInstance.setUA(userAgentString);
};
var parseUserAgent = function parseUserAgent(userAgent) {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  var UserAgentInstance = new UAParser(userAgent);
  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: function setUserAgent(userAgentString) {
      return UserAgentInstance.setUA(userAgentString);
    }
  };
};

var UAHelper = /*#__PURE__*/Object.freeze({
  ClientUAInstance: ClientUAInstance,
  browser: browser,
  cpu: cpu,
  device: device,
  engine: engine,
  os: os,
  ua: ua,
  setUa: setUa,
  parseUserAgent: parseUserAgent
});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DeviceTypes = {
  Mobile: 'mobile',
  Tablet: 'tablet',
  SmartTv: 'smarttv',
  Console: 'console',
  Wearable: 'wearable',
  Embedded: 'embedded',
  Browser: undefined
};
var BrowserTypes = {
  Chrome: 'Chrome',
  Firefox: 'Firefox',
  Opera: 'Opera',
  Yandex: 'Yandex',
  Safari: 'Safari',
  InternetExplorer: 'Internet Explorer',
  Edge: 'Edge',
  Chromium: 'Chromium',
  Ie: 'IE',
  MobileSafari: 'Mobile Safari',
  EdgeChromium: 'Edge Chromium',
  MIUI: 'MIUI Browser',
  SamsungBrowser: 'Samsung Browser'
};
var OsTypes = {
  IOS: 'iOS',
  Android: 'Android',
  WindowsPhone: 'Windows Phone',
  Windows: 'Windows',
  MAC_OS: 'Mac OS'
};
var InitialDeviceTypes = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkDeviceType = function checkDeviceType(type) {
  switch (type) {
    case DeviceTypes.Mobile:
      return {
        isMobile: true
      };

    case DeviceTypes.Tablet:
      return {
        isTablet: true
      };

    case DeviceTypes.SmartTv:
      return {
        isSmartTV: true
      };

    case DeviceTypes.Console:
      return {
        isConsole: true
      };

    case DeviceTypes.Wearable:
      return {
        isWearable: true
      };

    case DeviceTypes.Browser:
      return {
        isBrowser: true
      };

    case DeviceTypes.Embedded:
      return {
        isEmbedded: true
      };

    default:
      return InitialDeviceTypes;
  }
};
var setUserAgent = function setUserAgent(userAgent) {
  return setUa(userAgent);
};
var setDefaults = function setDefaults(p) {
  var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
  return p ? p : d;
};
var getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
    if (window.navigator || navigator) {
      return window.navigator || navigator;
    }
  }

  return false;
};
var isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
};

var browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: setDefaults(browser.major),
    browserFullVersion: setDefaults(browser.version),
    browserName: setDefaults(browser.name),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _objectSpread2({}, type, {
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    os: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    ua: setDefaults(ua)
  });
};
var smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};
var embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
  return {
    isEmbedded: isEmbedded,
    vendor: setDefaults(device.vendor),
    model: setDefaults(device.model),
    engineName: setDefaults(engine.name),
    engineVersion: setDefaults(engine.version),
    osName: setDefaults(os.name),
    osVersion: setDefaults(os.version),
    userAgent: setDefaults(ua)
  };
};

function deviceDetect(userAgent) {
  var _ref = userAgent ? parseUserAgent(userAgent) : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      engine = _ref.engine,
      os = _ref.os,
      ua = _ref.ua;

  var type = checkDeviceType(device.type);
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable,
      isEmbedded = type.isEmbedded;

  if (isBrowser) {
    return browserPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return smartTvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearablePayload(isWearable, engine, os, ua);
  }

  if (isEmbedded) {
    return embeddedPayload(isEmbedded, device, engine, os, ua);
  }
}

var isMobileType = function isMobileType(_ref) {
  var type = _ref.type;
  return type === DeviceTypes.Mobile;
};
var isTabletType = function isTabletType(_ref2) {
  var type = _ref2.type;
  return type === DeviceTypes.Tablet;
};
var isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
  var type = _ref3.type;
  return type === DeviceTypes.Mobile || type === DeviceTypes.Tablet;
};
var isSmartTVType = function isSmartTVType(_ref4) {
  var type = _ref4.type;
  return type === DeviceTypes.SmartTv;
};
var isBrowserType = function isBrowserType(_ref5) {
  var type = _ref5.type;
  return type === DeviceTypes.Browser;
};
var isWearableType = function isWearableType(_ref6) {
  var type = _ref6.type;
  return type === DeviceTypes.Wearable;
};
var isConsoleType = function isConsoleType(_ref7) {
  var type = _ref7.type;
  return type === DeviceTypes.Console;
};
var isEmbeddedType = function isEmbeddedType(_ref8) {
  var type = _ref8.type;
  return type === DeviceTypes.Embedded;
};
var getMobileVendor = function getMobileVendor(_ref9) {
  var vendor = _ref9.vendor;
  return setDefaults(vendor);
};
var getMobileModel = function getMobileModel(_ref10) {
  var model = _ref10.model;
  return setDefaults(model);
};
var getDeviceType = function getDeviceType(_ref11) {
  var type = _ref11.type;
  return setDefaults(type, 'browser');
}; // os types

var isAndroidType = function isAndroidType(_ref12) {
  var name = _ref12.name;
  return name === OsTypes.Android;
};
var isWindowsType = function isWindowsType(_ref13) {
  var name = _ref13.name;
  return name === OsTypes.Windows;
};
var isMacOsType = function isMacOsType(_ref14) {
  var name = _ref14.name;
  return name === OsTypes.MAC_OS;
};
var isWinPhoneType = function isWinPhoneType(_ref15) {
  var name = _ref15.name;
  return name === OsTypes.WindowsPhone;
};
var isIOSType = function isIOSType(_ref16) {
  var name = _ref16.name;
  return name === OsTypes.IOS;
};
var getOsVersion = function getOsVersion(_ref17) {
  var version = _ref17.version;
  return setDefaults(version);
};
var getOsName = function getOsName(_ref18) {
  var name = _ref18.name;
  return setDefaults(name);
}; // browser types

var isChromeType = function isChromeType(_ref19) {
  var name = _ref19.name;
  return name === BrowserTypes.Chrome;
};
var isFirefoxType = function isFirefoxType(_ref20) {
  var name = _ref20.name;
  return name === BrowserTypes.Firefox;
};
var isChromiumType = function isChromiumType(_ref21) {
  var name = _ref21.name;
  return name === BrowserTypes.Chromium;
};
var isEdgeType = function isEdgeType(_ref22) {
  var name = _ref22.name;
  return name === BrowserTypes.Edge;
};
var isYandexType = function isYandexType(_ref23) {
  var name = _ref23.name;
  return name === BrowserTypes.Yandex;
};
var isSafariType = function isSafariType(_ref24) {
  var name = _ref24.name;
  return name === BrowserTypes.Safari || name === BrowserTypes.MobileSafari;
};
var isMobileSafariType = function isMobileSafariType(_ref25) {
  var name = _ref25.name;
  return name === BrowserTypes.MobileSafari;
};
var isOperaType = function isOperaType(_ref26) {
  var name = _ref26.name;
  return name === BrowserTypes.Opera;
};
var isIEType = function isIEType(_ref27) {
  var name = _ref27.name;
  return name === BrowserTypes.InternetExplorer || name === BrowserTypes.Ie;
};
var isMIUIType = function isMIUIType(_ref28) {
  var name = _ref28.name;
  return name === BrowserTypes.MIUI;
};
var isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
  var name = _ref29.name;
  return name === BrowserTypes.SamsungBrowser;
};
var getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
  var version = _ref30.version;
  return setDefaults(version);
};
var getBrowserVersion = function getBrowserVersion(_ref31) {
  var major = _ref31.major;
  return setDefaults(major);
};
var getBrowserName = function getBrowserName(_ref32) {
  var name = _ref32.name;
  return setDefaults(name);
}; // engine types

var getEngineName = function getEngineName(_ref33) {
  var name = _ref33.name;
  return setDefaults(name);
};
var getEngineVersion = function getEngineVersion(_ref34) {
  var version = _ref34.version;
  return setDefaults(version);
};
var isElectronType = function isElectronType() {
  var nav = getNavigatorInstance();
  var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
  return typeof ua === 'string' ? /electron/.test(ua) : false;
};
var isEdgeChromiumType = function isEdgeChromiumType(ua) {
  return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
};
var getIOS13 = function getIOS13() {
  var nav = getNavigatorInstance();
  return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
};
var getIPad13 = function getIPad13() {
  return isIOS13Check('iPad');
};
var getIphone13 = function getIphone13() {
  return isIOS13Check('iPhone');
};
var getIPod13 = function getIPod13() {
  return isIOS13Check('iPod');
};
var getUseragent = function getUseragent(userAg) {
  return setDefaults(userAg);
};

function buildSelectorsObject(options) {
  var _ref = options ? options : UAHelper,
      device = _ref.device,
      browser = _ref.browser,
      os = _ref.os,
      engine = _ref.engine,
      ua = _ref.ua;

  return {
    isSmartTV: isSmartTVType(device),
    isConsole: isConsoleType(device),
    isWearable: isWearableType(device),
    isEmbedded: isEmbeddedType(device),
    isMobileSafari: isMobileSafariType(browser) || getIPad13(),
    isChromium: isChromiumType(browser),
    isMobile: isMobileAndTabletType(device) || getIPad13(),
    isMobileOnly: isMobileType(device),
    isTablet: isTabletType(device) || getIPad13(),
    isBrowser: isBrowserType(device),
    isDesktop: isBrowserType(device),
    isAndroid: isAndroidType(os),
    isWinPhone: isWinPhoneType(os),
    isIOS: isIOSType(os) || getIPad13(),
    isChrome: isChromeType(browser),
    isFirefox: isFirefoxType(browser),
    isSafari: isSafariType(browser),
    isOpera: isOperaType(browser),
    isIE: isIEType(browser),
    osVersion: getOsVersion(os),
    osName: getOsName(os),
    fullBrowserVersion: getBrowserFullVersion(browser),
    browserVersion: getBrowserVersion(browser),
    browserName: getBrowserName(browser),
    mobileVendor: getMobileVendor(device),
    mobileModel: getMobileModel(device),
    engineName: getEngineName(engine),
    engineVersion: getEngineVersion(engine),
    getUA: getUseragent(ua),
    isEdge: isEdgeType(browser) || isEdgeChromiumType(ua),
    isYandex: isYandexType(browser),
    deviceType: getDeviceType(device),
    isIOS13: getIOS13(),
    isIPad13: getIPad13(),
    isIPhone13: getIphone13(),
    isIPod13: getIPod13(),
    isElectron: isElectronType(),
    isEdgeChromium: isEdgeChromiumType(ua),
    isLegacyEdge: isEdgeType(browser) && !isEdgeChromiumType(ua),
    isWindows: isWindowsType(os),
    isMacOs: isMacOsType(os),
    isMIUI: isMIUIType(browser),
    isSamsungBrowser: isSamsungBrowserType(browser)
  };
}

var isSmartTV = isSmartTVType(device);
var isConsole = isConsoleType(device);
var isWearable = isWearableType(device);
var isEmbedded = isEmbeddedType(device);
var isMobileSafari = isMobileSafariType(browser) || getIPad13();
var isChromium = isChromiumType(browser);
var isMobile = isMobileAndTabletType(device) || getIPad13();
var isMobileOnly = isMobileType(device);
var isTablet = isTabletType(device) || getIPad13();
var isBrowser = isBrowserType(device);
var isDesktop = isBrowserType(device);
var isAndroid = isAndroidType(os);
var isWinPhone = isWinPhoneType(os);
var isIOS = isIOSType(os) || getIPad13();
var isChrome = isChromeType(browser);
var isFirefox = isFirefoxType(browser);
var isSafari = isSafariType(browser);
var isOpera = isOperaType(browser);
var isIE = isIEType(browser);
var osVersion = getOsVersion(os);
var osName = getOsName(os);
var fullBrowserVersion = getBrowserFullVersion(browser);
var browserVersion = getBrowserVersion(browser);
var browserName = getBrowserName(browser);
var mobileVendor = getMobileVendor(device);
var mobileModel = getMobileModel(device);
var engineName = getEngineName(engine);
var engineVersion = getEngineVersion(engine);
var getUA = getUseragent(ua);
var isEdge = isEdgeType(browser) || isEdgeChromiumType(ua);
var isYandex = isYandexType(browser);
var deviceType = getDeviceType(device);
var isIOS13 = getIOS13();
var isIPad13 = getIPad13();
var isIPhone13 = getIphone13();
var isIPod13 = getIPod13();
var isElectron = isElectronType();
var isEdgeChromium = isEdgeChromiumType(ua);
var isLegacyEdge = isEdgeType(browser) && !isEdgeChromiumType(ua);
var isWindows = isWindowsType(os);
var isMacOs = isMacOsType(os);
var isMIUI = isMIUIType(browser);
var isSamsungBrowser = isSamsungBrowserType(browser);
var getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
  if (!userAgent || typeof userAgent !== 'string') {
    console.error('No valid user agent string was provided');
    return;
  }

  var _UAHelper$parseUserAg = parseUserAgent(userAgent),
      device = _UAHelper$parseUserAg.device,
      browser = _UAHelper$parseUserAg.browser,
      os = _UAHelper$parseUserAg.os,
      engine = _UAHelper$parseUserAg.engine,
      ua = _UAHelper$parseUserAg.ua;

  return buildSelectorsObject({
    device: device,
    browser: browser,
    os: os,
    engine: engine,
    ua: ua
  });
};

var AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderWithFragment", "children"]);

  return isAndroid ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["renderWithFragment", "children"]);

  return isBrowser ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, ["renderWithFragment", "children"]);

  return isIE ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, ["renderWithFragment", "children"]);

  return isIOS ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["renderWithFragment", "children"]);

  return isMobile ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      props = _objectWithoutProperties(_ref6, ["renderWithFragment", "children"]);

  return isTablet ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, ["renderWithFragment", "children"]);

  return isWinPhone ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style,
      props = _objectWithoutProperties(_ref8, ["renderWithFragment", "children", "viewClassName", "style"]);

  return isMobileOnly ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      props = _objectWithoutProperties(_ref9, ["renderWithFragment", "children"]);

  return isSmartTV ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      props = _objectWithoutProperties(_ref10, ["renderWithFragment", "children"]);

  return isConsole ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      props = _objectWithoutProperties(_ref11, ["renderWithFragment", "children"]);

  return isWearable ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};
var CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition,
      props = _objectWithoutProperties(_ref12, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);

  return condition ? renderWithFragment ? React__default.createElement(React.Fragment, null, children) : React__default.createElement("div", props, children) : null;
};

function withOrientationChange(WrappedComponent) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
      _this.isEventListenerAdded = false;
      _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
      _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
      _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
      _this.state = {
        isLandscape: false,
        isPortrait: false
      };
      return _this;
    }

    _createClass(_class, [{
      key: "handleOrientationChange",
      value: function handleOrientationChange() {
        if (!this.isEventListenerAdded) {
          this.isEventListenerAdded = true;
        }

        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: orientation === 0,
          isLandscape: orientation === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function onOrientationChange() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function onPageLoad() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
          if (!this.isEventListenerAdded) {
            this.handleOrientationChange();
            window.addEventListener("load", this.onPageLoad, false);
          } else {
            window.removeEventListener("load", this.onPageLoad, false);
          }

          window.addEventListener("resize", this.onOrientationChange, false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener("resize", this.onOrientationChange, false);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]);

    return _class;
  }(React__default.Component);
}

function useMobileOrientation() {
  var _useState = React.useState(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleOrientationChange = React.useCallback(function () {
    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
    var next = {
      isPortrait: orientation === 0,
      isLandscape: orientation === 90,
      orientation: orientation === 0 ? 'portrait' : 'landscape'
    };
    state.orientation !== next.orientation && setState(next);
  }, [state.orientation]);
  React.useEffect(function () {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
      handleOrientationChange();
      window.addEventListener("load", handleOrientationChange, false);
      window.addEventListener("resize", handleOrientationChange, false);
    }

    return function () {
      window.removeEventListener("resize", handleOrientationChange, false);
      window.removeEventListener("load", handleOrientationChange, false);
    };
  }, [handleOrientationChange]);
  return state;
}

function useDeviceData(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  return parseUserAgent(hookUserAgent);
}

function useDeviceSelectors(userAgent) {
  var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
  var deviceData = useDeviceData(hookUserAgent);
  var selectors = buildSelectorsObject(deviceData);
  return [selectors, deviceData];
}

exports.AndroidView = AndroidView;
exports.BrowserTypes = BrowserTypes;
exports.BrowserView = BrowserView;
exports.ConsoleView = ConsoleView;
exports.CustomView = CustomView;
exports.IEView = IEView;
exports.IOSView = IOSView;
exports.MobileOnlyView = MobileOnlyView;
exports.MobileView = MobileView;
exports.OsTypes = OsTypes;
exports.SmartTVView = SmartTVView;
exports.TabletView = TabletView;
exports.WearableView = WearableView;
exports.WinPhoneView = WinPhoneView;
exports.browserName = browserName;
exports.browserVersion = browserVersion;
exports.deviceDetect = deviceDetect;
exports.deviceType = deviceType;
exports.engineName = engineName;
exports.engineVersion = engineVersion;
exports.fullBrowserVersion = fullBrowserVersion;
exports.getSelectorsByUserAgent = getSelectorsByUserAgent;
exports.getUA = getUA;
exports.isAndroid = isAndroid;
exports.isBrowser = isBrowser;
exports.isChrome = isChrome;
exports.isChromium = isChromium;
exports.isConsole = isConsole;
exports.isDesktop = isDesktop;
exports.isEdge = isEdge;
exports.isEdgeChromium = isEdgeChromium;
exports.isElectron = isElectron;
exports.isEmbedded = isEmbedded;
exports.isFirefox = isFirefox;
exports.isIE = isIE;
exports.isIOS = isIOS;
exports.isIOS13 = isIOS13;
exports.isIPad13 = isIPad13;
exports.isIPhone13 = isIPhone13;
exports.isIPod13 = isIPod13;
exports.isLegacyEdge = isLegacyEdge;
exports.isMIUI = isMIUI;
exports.isMacOs = isMacOs;
exports.isMobile = isMobile;
exports.isMobileOnly = isMobileOnly;
exports.isMobileSafari = isMobileSafari;
exports.isOpera = isOpera;
exports.isSafari = isSafari;
exports.isSamsungBrowser = isSamsungBrowser;
exports.isSmartTV = isSmartTV;
exports.isTablet = isTablet;
exports.isWearable = isWearable;
exports.isWinPhone = isWinPhone;
exports.isWindows = isWindows;
exports.isYandex = isYandex;
exports.mobileModel = mobileModel;
exports.mobileVendor = mobileVendor;
exports.osName = osName;
exports.osVersion = osVersion;
exports.parseUserAgent = parseUserAgent;
exports.setUserAgent = setUserAgent;
exports.useDeviceData = useDeviceData;
exports.useDeviceSelectors = useDeviceSelectors;
exports.useMobileOrientation = useMobileOrientation;
exports.withOrientationChange = withOrientationChange;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */
(function(window,undefined){"use strict";var LIBVERSION="1.0.41",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded",UA_MAX_LENGTH=500;var AMAZON="Amazon",APPLE="Apple",ASUS="ASUS",BLACKBERRY="BlackBerry",BROWSER="Browser",CHROME="Chrome",EDGE="Edge",FIREFOX="Firefox",GOOGLE="Google",HONOR="Honor",HUAWEI="Huawei",LENOVO="Lenovo",LG="LG",MICROSOFT="Microsoft",MOTOROLA="Motorola",NVIDIA="Nvidia",ONEPLUS="OnePlus",OPERA="Opera",OPPO="OPPO",SAMSUNG="Samsung",SHARP="Sharp",SONY="Sony",XIAOMI="Xiaomi",ZEBRA="Zebra",FACEBOOK="Facebook",CHROMIUM_OS="Chromium OS",MAC_OS="Mac OS",SUFFIX_BROWSER=" Browser";var extend=function(regexes,extensions){var mergedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){mergedRegexes[i]=extensions[i].concat(regexes[i])}else{mergedRegexes[i]=regexes[i]}}return mergedRegexes},enumerize=function(arr){var enums={};for(var i=0;i<arr.length;i++){enums[arr[i].toUpperCase()]=arr[i]}return enums},has=function(str1,str2){return typeof str1===STR_TYPE?lowerize(str2).indexOf(lowerize(str1))!==-1:false},lowerize=function(str){return str.toLowerCase()},majorize=function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,EMPTY).split(".")[0]:undefined},trim=function(str,len){if(typeof str===STR_TYPE){str=str.replace(/^\s\s*/,EMPTY);return typeof len===UNDEF_TYPE?str:str.substring(0,UA_MAX_LENGTH)}};var rgxMapper=function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){if(!regex[j]){break}matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length===2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length===3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length===4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},strMapper=function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(has(map[i],str)){return i===UNKNOWN?undefined:i}}return map.hasOwnProperty("*")?map["*"]:str};var oldSafariMap={"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"},windowsVersionMap={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"};var regexes={browser:[[/\b(?:crmo|crios)\/([\w\.]+)/i],[VERSION,[NAME,"Chrome"]],[/edg(?:e|ios|a)?\/([\w\.]+)/i],[VERSION,[NAME,"Edge"]],[/(opera mini)\/([-\w\.]+)/i,/(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,/(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i],[NAME,VERSION],[/opios[\/ ]+([\w\.]+)/i],[VERSION,[NAME,OPERA+" Mini"]],[/\bop(?:rg)?x\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" GX"]],[/\bopr\/([\w\.]+)/i],[VERSION,[NAME,OPERA]],[/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"Baidu"]],[/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i],[VERSION,[NAME,"Maxthon"]],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,/(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,/(?:ms|\()(ie) ([\w\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,/(heytap|ovi|115)browser\/([\d\.]+)/i,/(weibo)__([\d\.]+)/i],[NAME,VERSION],[/quark(?:pc)?\/([-\w\.]+)/i],[VERSION,[NAME,"Quark"]],[/\bddg\/([\w\.]+)/i],[VERSION,[NAME,"DuckDuckGo"]],[/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i],[VERSION,[NAME,"UC"+BROWSER]],[/microm.+\bqbcore\/([\w\.]+)/i,/\bqbcore\/([\w\.]+).+microm/i,/micromessenger\/([\w\.]+)/i],[VERSION,[NAME,"WeChat"]],[/konqueror\/([\w\.]+)/i],[VERSION,[NAME,"Konqueror"]],[/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i],[VERSION,[NAME,"IE"]],[/ya(?:search)?browser\/([\w\.]+)/i],[VERSION,[NAME,"Yandex"]],[/slbrowser\/([\w\.]+)/i],[VERSION,[NAME,"Smart Lenovo "+BROWSER]],[/(avast|avg)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 Secure "+BROWSER],VERSION],[/\bfocus\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" Focus"]],[/\bopt\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Touch"]],[/coc_coc\w+\/([\w\.]+)/i],[VERSION,[NAME,"Coc Coc"]],[/dolfin\/([\w\.]+)/i],[VERSION,[NAME,"Dolphin"]],[/coast\/([\w\.]+)/i],[VERSION,[NAME,OPERA+" Coast"]],[/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI"+SUFFIX_BROWSER]],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,FIREFOX]],[/\bqihoobrowser\/?([\w\.]*)/i],[VERSION,[NAME,"360"]],[/\b(qq)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1Browser"],VERSION],[/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i],[[NAME,/(.+)/,"$1"+SUFFIX_BROWSER],VERSION],[/samsungbrowser\/([\w\.]+)/i],[VERSION,[NAME,SAMSUNG+" Internet"]],[/metasr[\/ ]?([\d\.]+)/i],[VERSION,[NAME,"Sogou Explorer"]],[/(sogou)mo\w+\/([\d\.]+)/i],[[NAME,"Sogou Mobile"],VERSION],[/(electron)\/([\w\.]+) safari/i,/(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,/m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i],[NAME,VERSION],[/(lbbrowser|rekonq)/i,/\[(linkedin)app\]/i],[NAME],[/ome\/([\w\.]+) \w* ?(iron) saf/i,/ome\/([\w\.]+).+qihu (360)[es]e/i],[VERSION,NAME],[/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i],[[NAME,FACEBOOK],VERSION],[/(Klarna)\/([\w\.]+)/i,/(kakao(?:talk|story))[\/ ]([\w\.]+)/i,/(naver)\(.*?(\d+\.[\w\.]+).*\)/i,/(daum)apps[\/ ]([\w\.]+)/i,/safari (line)\/([\w\.]+)/i,/\b(line)\/([\w\.]+)\/iab/i,/(alipay)client\/([\w\.]+)/i,/(twitter)(?:and| f.+e\/([\w\.]+))/i,/(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i],[NAME,VERSION],[/\bgsa\/([\w\.]+) .*safari\//i],[VERSION,[NAME,"GSA"]],[/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i],[VERSION,[NAME,"TikTok"]],[/headlesschrome(?:\/([\w\.]+)| )/i],[VERSION,[NAME,CHROME+" Headless"]],[/ wv\).+(chrome)\/([\w\.]+)/i],[[NAME,CHROME+" WebView"],VERSION],[/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i],[VERSION,[NAME,"Android "+BROWSER]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i],[VERSION,NAME],[/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,strMapper,oldSafariMap]],[/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape\d?)\/([-\w\.]+)/i],[[NAME,"Netscape"],VERSION],[/(wolvic|librewolf)\/([\w\.]+)/i],[NAME,VERSION],[/mobile vr; rv:([\w\.]+)\).+firefox/i],[VERSION,[NAME,FIREFOX+" Reality"]],[/ekiohf.+(flow)\/([\w\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,/(firefox)\/([\w\.]+)/i,/(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,/(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,/\b(links) \(([\w\.]+)/i],[NAME,[VERSION,/_/g,"."]],[/(cobalt)\/([\w\.]+)/i],[NAME,[VERSION,/master.|lts./,""]]],cpu:[[/\b((amd|x|x86[-_]?|wow|win)64)\b/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i,/\b((i[346]|x)86)(pc)?\b/i],[[ARCHITECTURE,"ia32"]],[/\b(aarch64|arm(v?[89]e?l?|_?64))\b/i],[[ARCHITECTURE,"arm64"]],[/\b(arm(v[67])?ht?n?[fl]p?)\b/i],[[ARCHITECTURE,"armhf"]],[/( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i],[[ARCHITECTURE,"arm"]],[/((ppc|powerpc)(64)?)( mac|;|\))/i],[[ARCHITECTURE,/ower/,EMPTY,lowerize]],[/ sun4\w[;\)]/i],[[ARCHITECTURE,"sparc"]],[/\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i],[[ARCHITECTURE,lowerize]]],device:[[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,TABLET]],[/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,/samsung[- ]((?!sm-[lr])[-\w]+)/i,/sec-(sgh\w+)/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,MOBILE]],[/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i],[MODEL,[VENDOR,APPLE],[TYPE,MOBILE]],[/\((ipad);[-\w\),; ]+apple/i,/applecoremedia\/[\w\.]+ \((ipad)/i,/\b(ipad)\d\d?,\d\d?[;\]].+ios/i],[MODEL,[VENDOR,APPLE],[TYPE,TABLET]],[/(macintosh);/i],[MODEL,[VENDOR,APPLE]],[/\b(sh-?[altvz]?\d\d[a-ekm]?)/i],[MODEL,[VENDOR,SHARP],[TYPE,MOBILE]],[/\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i],[MODEL,[VENDOR,HONOR],[TYPE,TABLET]],[/honor([-\w ]+)[;\)]/i],[MODEL,[VENDOR,HONOR],[TYPE,MOBILE]],[/\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,TABLET]],[/(?:huawei)([-\w ]+)[;\)]/i,/\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i],[MODEL,[VENDOR,HUAWEI],[TYPE,MOBILE]],[/oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,/\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,TABLET]],[/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,/\b; (\w+) build\/hm\1/i,/\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,/\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,/oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,/\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,/ ([\w ]+) miui\/v?\d/i],[[MODEL,/_/g," "],[VENDOR,XIAOMI],[TYPE,MOBILE]],[/; (\w+) bui.+ oppo/i,/\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i],[MODEL,[VENDOR,OPPO],[TYPE,MOBILE]],[/\b(opd2(\d{3}a?))(?: bui|\))/i],[MODEL,[VENDOR,strMapper,{OnePlus:["304","403","203"],"*":OPPO}],[TYPE,TABLET]],[/vivo (\w+)(?: bui|\))/i,/\b(v[12]\d{3}\w?[at])(?: bui|;)/i],[MODEL,[VENDOR,"Vivo"],[TYPE,MOBILE]],[/\b(rmx[1-3]\d{3})(?: bui|;|\))/i],[MODEL,[VENDOR,"Realme"],[TYPE,MOBILE]],[/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,/\bmot(?:orola)?[- ](\w*)/i,/((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,MOBILE]],[/\b(mz60\d|xoom[2 ]{0,2}) build\//i],[MODEL,[VENDOR,MOTOROLA],[TYPE,TABLET]],[/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i],[MODEL,[VENDOR,LG],[TYPE,TABLET]],[/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,/\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,/\blg-?([\d\w]+) bui/i],[MODEL,[VENDOR,LG],[TYPE,MOBILE]],[/(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,/lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i],[MODEL,[VENDOR,LENOVO],[TYPE,TABLET]],[/(nokia) (t[12][01])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,/nokia[-_ ]?(([-\w\. ]*))/i],[[MODEL,/_/g," "],[TYPE,MOBILE],[VENDOR,"Nokia"]],[/(pixel (c|tablet))\b/i],[MODEL,[VENDOR,GOOGLE],[TYPE,TABLET]],[/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i],[MODEL,[VENDOR,GOOGLE],[TYPE,MOBILE]],[/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i],[MODEL,[VENDOR,SONY],[TYPE,MOBILE]],[/sony tablet [ps]/i,/\b(?:sony)?sgp\w+(?: bui|\))/i],[[MODEL,"Xperia Tablet"],[VENDOR,SONY],[TYPE,TABLET]],[/ (kb2005|in20[12]5|be20[12][59])\b/i,/(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,MOBILE]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,/(kf[a-z]+)( bui|\)).+silk\//i],[MODEL,[VENDOR,AMAZON],[TYPE,TABLET]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i],[[MODEL,/(.+)/g,"Fire Phone $1"],[VENDOR,AMAZON],[TYPE,MOBILE]],[/(playbook);[-\w\),; ]+(rim)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/\b((?:bb[a-f]|st[hv])100-\d)/i,/\(bb10; (\w+)/i],[MODEL,[VENDOR,BLACKBERRY],[TYPE,MOBILE]],[/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i],[MODEL,[VENDOR,ASUS],[TYPE,TABLET]],[/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],[MODEL,[VENDOR,ASUS],[TYPE,MOBILE]],[/(nexus 9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,/(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i],[MODEL,[VENDOR,"TCL"],[TYPE,TABLET]],[/(itel) ((\w+))/i],[[VENDOR,lowerize],MODEL,[TYPE,strMapper,{tablet:["p10001l","w7001"],"*":"mobile"}]],[/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/droid.+; (m[1-5] note) bui/i,/\bmz-([-\w]{2,})/i],[MODEL,[VENDOR,"Meizu"],[TYPE,MOBILE]],[/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i],[MODEL,[VENDOR,"Ulefone"],[TYPE,MOBILE]],[/; (energy ?\w+)(?: bui|\))/i,/; energizer ([\w ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Energizer"],[TYPE,MOBILE]],[/; cat (b35);/i,/; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i],[MODEL,[VENDOR,"Cat"],[TYPE,MOBILE]],[/((?:new )?andromax[\w- ]+)(?: bui|\))/i],[MODEL,[VENDOR,"Smartfren"],[TYPE,MOBILE]],[/droid.+; (a(?:015|06[35]|142p?))/i],[MODEL,[VENDOR,"Nothing"],[TYPE,MOBILE]],[/; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,/archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,TABLET]],[/archos ([\w ]+)( b|\))/i,/; (ac[3-6]\d\w{2,8})( b|\))/i],[MODEL,[VENDOR,"Archos"],[TYPE,MOBILE]],[/(imo) (tab \w+)/i,/(infinix) (x1101b?)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,/; (hmd|imo) ([\w ]+?)(?: bui|\))/i,/(hp) ([\w ]+\w)/i,/(microsoft); (lumia[\w ]+)/i,/(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,/(oppo) ?([\w ]+) bui/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kobo)\s(ereader|touch)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\/([\w\.]+)/i,/(nook)[\w ]+build\/(\w+)/i,/(dell) (strea[kpr\d ]*[\dko])/i,/(le[- ]+pan)[- ]+(\w{1,9}) bui/i,/(trinity)[- ]*(t\d{3}) bui/i,/(gigaset)[- ]+(q\w{1,9}) bui/i,/(vodafone) ([\w ]+)(?:\)| bui)/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(surface duo)/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,TABLET]],[/droid [\d\.]+; (fp\du?)(?: b|\))/i],[MODEL,[VENDOR,"Fairphone"],[TYPE,MOBILE]],[/(u304aa)/i],[MODEL,[VENDOR,"AT&T"],[TYPE,MOBILE]],[/\bsie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/\b(rct\w+) b/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/\b(venue[\d ]{2,7}) b/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/\b(q(?:mv|ta)\w+) b/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i],[MODEL,[VENDOR,"Barnes & Noble"],[TYPE,TABLET]],[/\b(tm\d{3}\w+) b/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/\b(k88) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/\b(nx\d{3}j) b/i],[MODEL,[VENDOR,"ZTE"],[TYPE,MOBILE]],[/\b(gen\d{3}) b.+49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/\b(zur\d{3}) b/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/\b((zeki)?tb.*\b) b/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/\b([yr]\d{2}) b/i,/\b(dragon[- ]+touch |dt)(\w{5}) b/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/\b(ns-?\w{0,9}) b/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/\b((nxa|next)-?\w{0,9}) b/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/\b(lvtel\-)?(v1[12]) b/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/\b(ph-1) /i],[MODEL,[VENDOR,"Essential"],[TYPE,MOBILE]],[/\b(v(100md|700na|7011|917g).*\b) b/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/\b(trio[-\w\. ]+) b/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/\btu_(1491) b/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,TABLET]],[/(sprint) (\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,MICROSOFT],[TYPE,MOBILE]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,TABLET]],[/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,MOBILE]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,SAMSUNG],[TYPE,SMARTTV]],[/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i],[[VENDOR,LG],[TYPE,SMARTTV]],[/(apple) ?tv/i],[VENDOR,[MODEL,APPLE+" TV"],[TYPE,SMARTTV]],[/crkey/i],[[MODEL,CHROME+"cast"],[VENDOR,GOOGLE],[TYPE,SMARTTV]],[/droid.+aft(\w+)( bui|\))/i],[MODEL,[VENDOR,AMAZON],[TYPE,SMARTTV]],[/(shield \w+ tv)/i],[MODEL,[VENDOR,NVIDIA],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i,/(aquos-tv[\w ]+)\)/i],[MODEL,[VENDOR,SHARP],[TYPE,SMARTTV]],[/(bravia[\w ]+)( bui|\))/i],[MODEL,[VENDOR,SONY],[TYPE,SMARTTV]],[/(mi(tv|box)-?\w+) bui/i],[MODEL,[VENDOR,XIAOMI],[TYPE,SMARTTV]],[/Hbbtv.*(technisat) (.*);/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,/hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i],[[VENDOR,trim],[MODEL,trim],[TYPE,SMARTTV]],[/droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i],[MODEL,[TYPE,SMARTTV]],[/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i],[[TYPE,SMARTTV]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/droid.+; (shield)( bui|\))/i],[MODEL,[VENDOR,NVIDIA],[TYPE,CONSOLE]],[/(playstation \w+)/i],[MODEL,[VENDOR,SONY],[TYPE,CONSOLE]],[/\b(xbox(?: one)?(?!; xbox))[\); ]/i],[MODEL,[VENDOR,MICROSOFT],[TYPE,CONSOLE]],[/\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i],[MODEL,[VENDOR,SAMSUNG],[TYPE,WEARABLE]],[/((pebble))app/i,/(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/(ow(?:19|20)?we?[1-3]{1,3})/i],[MODEL,[VENDOR,OPPO],[TYPE,WEARABLE]],[/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i],[MODEL,[VENDOR,APPLE],[TYPE,WEARABLE]],[/(opwwe\d{3})/i],[MODEL,[VENDOR,ONEPLUS],[TYPE,WEARABLE]],[/(moto 360)/i],[MODEL,[VENDOR,MOTOROLA],[TYPE,WEARABLE]],[/(smartwatch 3)/i],[MODEL,[VENDOR,SONY],[TYPE,WEARABLE]],[/(g watch r)/i],[MODEL,[VENDOR,LG],[TYPE,WEARABLE]],[/droid.+; (wt63?0{2,3})\)/i],[MODEL,[VENDOR,ZEBRA],[TYPE,WEARABLE]],[/droid.+; (glass) \d/i],[MODEL,[VENDOR,GOOGLE],[TYPE,WEARABLE]],[/(pico) (4|neo3(?: link|pro)?)/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/; (quest( \d| pro)?)/i],[MODEL,[VENDOR,FACEBOOK],[TYPE,WEARABLE]],[/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i],[VENDOR,[TYPE,EMBEDDED]],[/(aeobc)\b/i],[MODEL,[VENDOR,AMAZON],[TYPE,EMBEDDED]],[/(homepod).+mac os/i],[MODEL,[VENDOR,APPLE],[TYPE,EMBEDDED]],[/windows iot/i],[[TYPE,EMBEDDED]],[/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i],[MODEL,[TYPE,MOBILE]],[/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i],[MODEL,[TYPE,TABLET]],[/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i],[[TYPE,TABLET]],[/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i],[[TYPE,MOBILE]],[/droid .+?; ([\w\. -]+)( bui|\))/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+ edge\/([\w\.]+)/i],[VERSION,[NAME,EDGE+"HTML"]],[/(arkweb)\/([\w\.]+)/i],[NAME,VERSION],[/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i],[VERSION,[NAME,"Blink"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,/ekioh(flow)\/([\w\.]+)/i,/(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,/(icab)[\/ ]([23]\.[\d\.]+)/i,/\b(libweb)/i],[NAME,VERSION],[/ladybird\//i],[[NAME,"LibWeb"]],[/rv\:([\w\.]{1,9})\b.+(gecko)/i],[VERSION,NAME]],os:[[/microsoft (windows) (vista|xp)/i],[NAME,VERSION],[/(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i],[NAME,[VERSION,strMapper,windowsVersionMap]],[/windows nt 6\.2; (arm)/i,/windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,/(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i],[[VERSION,strMapper,windowsVersionMap],[NAME,"Windows"]],[/[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,/(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,/cfnetwork\/.+darwin/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac os x) ?([\w\. ]*)/i,/(macintosh|mac_powerpc\b)(?!.+haiku)/i],[[NAME,MAC_OS],[VERSION,/_/g,"."]],[/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i],[VERSION,NAME],[/(ubuntu) ([\w\.]+) like android/i],[[NAME,/(.+)/,"$1 Touch"],VERSION],[/(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i],[NAME,VERSION],[/\(bb(10);/i],[VERSION,[NAME,BLACKBERRY]],[/(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i],[VERSION,[NAME,"Symbian"]],[/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i],[VERSION,[NAME,FIREFOX+" OS"]],[/web0s;.+rt(tv)/i,/\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i],[VERSION,[NAME,"webOS"]],[/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i],[VERSION,[NAME,"watchOS"]],[/crkey\/([\d\.]+)/i],[VERSION,[NAME,CHROME+"cast"]],[/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i],[[NAME,CHROMIUM_OS],VERSION],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\/(\d+\.[\w\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\);]+)/i,/\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,/(mint)[\/\(\) ]?(\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,/(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,/(gnu) ?([\w\.]*)/i,/\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,/(haiku) (\w+)/i],[NAME,VERSION],[/(sunos) ?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/((?:open)?solaris)[-\/ ]?([\w\.]*)/i,/(aix) ((\d)(?=\.|\)| )[\w\.])*/i,/\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(ua,extensions){if(typeof ua===OBJ_TYPE){extensions=ua;ua=undefined}if(!(this instanceof UAParser)){return new UAParser(ua,extensions).getResult()}var _navigator=typeof window!==UNDEF_TYPE&&window.navigator?window.navigator:undefined;var _ua=ua||(_navigator&&_navigator.userAgent?_navigator.userAgent:EMPTY);var _uach=_navigator&&_navigator.userAgentData?_navigator.userAgentData:undefined;var _rgxmap=extensions?extend(regexes,extensions):regexes;var _isSelfNav=_navigator&&_navigator.userAgent==_ua;this.getBrowser=function(){var _browser={};_browser[NAME]=undefined;_browser[VERSION]=undefined;rgxMapper.call(_browser,_ua,_rgxmap.browser);_browser[MAJOR]=majorize(_browser[VERSION]);if(_isSelfNav&&_navigator&&_navigator.brave&&typeof _navigator.brave.isBrave==FUNC_TYPE){_browser[NAME]="Brave"}return _browser};this.getCPU=function(){var _cpu={};_cpu[ARCHITECTURE]=undefined;rgxMapper.call(_cpu,_ua,_rgxmap.cpu);return _cpu};this.getDevice=function(){var _device={};_device[VENDOR]=undefined;_device[MODEL]=undefined;_device[TYPE]=undefined;rgxMapper.call(_device,_ua,_rgxmap.device);if(_isSelfNav&&!_device[TYPE]&&_uach&&_uach.mobile){_device[TYPE]=MOBILE}if(_isSelfNav&&_device[MODEL]=="Macintosh"&&_navigator&&typeof _navigator.standalone!==UNDEF_TYPE&&_navigator.maxTouchPoints&&_navigator.maxTouchPoints>2){_device[MODEL]="iPad";_device[TYPE]=TABLET}return _device};this.getEngine=function(){var _engine={};_engine[NAME]=undefined;_engine[VERSION]=undefined;rgxMapper.call(_engine,_ua,_rgxmap.engine);return _engine};this.getOS=function(){var _os={};_os[NAME]=undefined;_os[VERSION]=undefined;rgxMapper.call(_os,_ua,_rgxmap.os);if(_isSelfNav&&!_os[NAME]&&_uach&&_uach.platform&&_uach.platform!="Unknown"){_os[NAME]=_uach.platform.replace(/chrome os/i,CHROMIUM_OS).replace(/macos/i,MAC_OS)}return _os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return _ua};this.setUA=function(ua){_ua=typeof ua===STR_TYPE&&ua.length>UA_MAX_LENGTH?trim(ua,UA_MAX_LENGTH):ua;return this};this.setUA(_ua);return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER=enumerize([NAME,VERSION,MAJOR]);UAParser.CPU=enumerize([ARCHITECTURE]);UAParser.DEVICE=enumerize([MODEL,VENDOR,TYPE,CONSOLE,MOBILE,SMARTTV,TABLET,WEARABLE,EMBEDDED]);UAParser.ENGINE=UAParser.OS=enumerize([NAME,VERSION]);if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(900)){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(typeof window!==UNDEF_TYPE){window.UAParser=UAParser}}var $=typeof window!==UNDEF_TYPE&&(window.jQuery||window.Zepto);if($&&!$.ua){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(ua){parser.setUA(ua);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 900 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recaptcha__ = __webpack_require__(450);
/* unused harmony reexport ReCAPTCHA */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__recaptcha_wrapper__["a" /* default */]);


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script__ = __webpack_require__(903);


var callbackName = "onloadcallback";
var globalName = "grecaptcha";
function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}
function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  if (dynamicOptions.enterprise) {
    return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + callbackName + "&render=explicit";
  }
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_async_script__["a" /* default */])(getURL, {
  callbackName: callbackName,
  globalName: globalName,
  attributes: getOptions().nonce ? {
    nonce: getOptions().nonce
  } : {}
})(__WEBPACK_IMPORTED_MODULE_0__recaptcha__["a" /* default */]));

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeAsyncScript;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = _objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(AsyncScriptLoader, _extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
    };
    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ForwardedComponent, WrappedComponent);
  };
}

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
// useRecorder hook
// import { useAudioLevels } from './useAudioLevels';
var useRecorder=function useRecorder(){var _a=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])('idle'),recordingState=_a[0],setRecordingState=_a[1];var _b=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(''),audioURL=_b[0],setAudioURL=_b[1];var _c=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(0),time=_c[0],setTime=_c[1];var _d=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),blob=_d[0],setBlob=_d[1];var timerRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();var mediaRecorderRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();var streamRef=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);//CODE ADDED
// var audioLevel = useAudioLevels(recordingState === 'recording');  //CODE ADDED
var _e=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),audioFile=_e[0],setAudioFile=_e[1];// Function to start recording
var startRecording=function startRecording(){return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(void 0,void 0,void 0,function(){var stream,chunks;return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this,function(_a){switch(_a.label){case 0:setRecordingState('recording');setTime(0);timerRef.current=window.setInterval(function(){setTime(function(prevTime){return prevTime+1;});},1000);return[4/*yield*/,navigator.mediaDevices.getUserMedia({audio:true})];case 1:stream=_a.sent();streamRef.current=stream;//CODE ADDED
mediaRecorderRef.current=new MediaRecorder(stream);chunks=[];mediaRecorderRef.current.ondataavailable=function(e){return chunks.push(e.data);};mediaRecorderRef.current.onstop=function(){var blob=new Blob(chunks,{type:'audio/mpeg'});setBlob(blob);setAudioURL(URL.createObjectURL(blob));var audioFile=new File([blob],'recorded_audio.mp3',{type:'audio/mpeg'});setAudioFile(audioFile);};mediaRecorderRef.current.start();return[2/*return*/];}});});};// Function to pause recording
var pauseRecording=function pauseRecording(){var _a;setRecordingState('paused');clearInterval(timerRef.current);(_a=mediaRecorderRef.current)===null||_a===void 0?void 0:_a.pause();};// Function to stop recording
var resumeRecording=function resumeRecording(){var _a;setRecordingState('recording');timerRef.current=window.setInterval(function(){setTime(function(prevTime){return prevTime+1;});},1000);(_a=mediaRecorderRef.current)===null||_a===void 0?void 0:_a.resume();};// Add a function to reset recording
var resetRecording=function resetRecording(){setRecordingState('idle');setAudioURL('');setTime(0);};var stopRecording=function stopRecording(){var _a;setRecordingState('stopped');clearInterval(timerRef.current);(_a=mediaRecorderRef.current)===null||_a===void 0?void 0:_a.stop();streamRef.current.getTracks().forEach(function(track){return track.stop();});//CODE ADDED
streamRef.current=null;//CODE ADDED
};Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){return function(){clearInterval(timerRef.current);};},[]);return{// audioLevel: audioLevel,
startRecording:startRecording,pauseRecording:pauseRecording,resumeRecording:resumeRecording,stopRecording:stopRecording,resetRecording:resetRecording,timeElapsed:time,recordingState:recordingState,isRecording:recordingState==='recording',audioURL:audioURL,audioFile:audioFile,audioBlob:blob};};/* harmony default export */ __webpack_exports__["a"] = (useRecorder);//# sourceMappingURL=useRecorder.js.map

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __esDecorate */
/* unused harmony export __runInitializers */
/* unused harmony export __propKey */
/* unused harmony export __setFunctionName */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["a"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["b"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/* unused harmony export __addDisposableResource */
/* unused harmony export __disposeResources */
/* unused harmony export __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
        var ar = [];
        for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
        env.stack.push({ value: value, dispose: dispose, async: async });
    }
    else if (async) {
        env.stack.push({ async: true });
    }
    return value;

}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while (r = env.stack.pop()) {
            try {
                if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
                if (r.dispose) {
                    var result = r.dispose.call(r.value);
                    if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
                }
                else s |= 1;
            }
            catch (e) {
                fail(e);
            }
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
        });
    }
    return path;
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension,
});


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__YupikEntry_js__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Recorder_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_StickyMenu_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SearchPageHelpers_js__ = __webpack_require__(67);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customFontFam="Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif";var options=[{key:1,text:'it',value:1},{key:2,text:'you',value:2}];var peopleDict={'1':"Sg",'2':"Du",'3':"Pl"};var vOptions=['vBase','nsBases','noBases','no','ns','vMood','vs','vo','nObliques','qWord','vType'];var nOptions=['n','nBases','nCase','nType'];var vEnglish=['mvEnglish1','mvEnglish2','mvEnglish3','mvEnglishAbl','mvnsEnglish1','mvnsEnglish2','mvnoEnglish1','mvnoEnglish2','cvnsEnglish1','cvnsEnglish2','cvnoEnglish1','cvnoEnglish2','svnoEnglish1','svnoEnglish2','cvEnglish1','cvEnglish2','cvEnglish3','cvEnglishAbl','svEnglish1','svEnglish2','svEnglishAbl','npnEnglish1','npnEnglish2','mvnObliquesEnglish1','mvnObliquesEnglish2','cvnObliquesEnglish1','cvnObliquesEnglish2','svnObliquesEnglish1','svnObliquesEnglish2'];var SimpleWordBuilderUpdated=function(_Component){_inherits(SimpleWordBuilderUpdated,_Component);function SimpleWordBuilderUpdated(props){_classCallCheck(this,SimpleWordBuilderUpdated);var _this=_possibleConstructorReturn(this,(SimpleWordBuilderUpdated.__proto__||Object.getPrototypeOf(SimpleWordBuilderUpdated)).call(this,props));_this.updateAllowableOptions=function(){var mvSubjectOptions1=[];var mvObjectOptions1=[];// let nounOptionsSVPossessors1 
// let nounOptionsCVPossessors1 
// let nounOptionsMVPossessors1 
// let nounOptionsCVAblPossessors1
// let nounOptionsMVAblPossessors1 
// let nounOptionsSVAblPossessors1
if(_this.state.mvvs.length>0&&_this.state.mvvo.length>0){if(_this.state.mvvs[0]==1){__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["d" /* mvObjectOptions */].map(function(k){if(![0,6,10].includes(k['id'])){mvObjectOptions1=mvObjectOptions1.concat(k);}});}else if(_this.state.mvvs[0]==2){__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["d" /* mvObjectOptions */].map(function(k){if(![1,7,11].includes(k['id'])){mvObjectOptions1=mvObjectOptions1.concat(k);}});}else{mvObjectOptions1=__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["d" /* mvObjectOptions */];}if(_this.state.mvvo[0]==1){__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["k" /* mvSubjectOptions */].map(function(k){if(![0,6,10].includes(k['id'])){mvSubjectOptions1=mvSubjectOptions1.concat(k);}});}else if(_this.state.mvvo[0]==2){__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["k" /* mvSubjectOptions */].map(function(k){if(![1,7,11].includes(k['id'])){mvSubjectOptions1=mvSubjectOptions1.concat(k);}});}else{mvSubjectOptions1=__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["k" /* mvSubjectOptions */];}}else{mvSubjectOptions1=__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["k" /* mvSubjectOptions */];}_this.setState({mvSubjectOptions1:mvSubjectOptions1,mvObjectOptions1:mvObjectOptions1});};_this.recordClip=function(sentence,siteLocation,english){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["w" /* Modal */],{on:'click',open:_this.state.showModal,style:{maxWidth:500,marginTop:window.innerWidth<480?10:10},closeOnDimmerClick:false,onOpen:function onOpen(){},onClose:function onClose(){console.log('modal closing?');_this.setState({showModal:false,wordsList:[],searchQuery:''});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["x" /* ModalContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{circular:true,style:{margin:0,color:'#929292',cursor:'pointer',position:'relative',float:'right'},size:'large',onClick:function onClick(){_this.setState({showModal:false});},name:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Recorder_js__["a" /* default */],{english:english,sentence:sentence,siteLocation:siteLocation})));};_this.displayIfClipExists=function(sentence){// console.log(sentence)
// axios
//   .get(API_URL + "/yugtunCrowdsourceAudioLookup/" + sentence)
//   .then(response => {
//     // console.log(response.data);
//     this.setState({audioRetrieved:response.data})
//   });
};_this.displayAudioMic=function(audioRetrieved){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["y" /* Popup */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["r" /* List */],{style:{fontFamily:customFontFam},divided:true,verticalAlign:'middle'},audioRetrieved.map(function(k,kindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["s" /* ListItem */],{style:{display:'flex',flexDirection:'row',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],{style:{float:'left',border:_this.state.playingAudio&&_this.state.clickedAudioIndex===kindex?'solid 1px #4a80b5':'solid 1px #dededf',marginLeft:5,backgroundColor:'white',color:k['village']=='computer generated'?'#929292':'#106181',cursor:'pointer'},circular:true,icon:'volume up',onClick:function onClick(){return _this.repeatAudio(k['filename'],kindex);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',marginLeft:10,padding:'5px 0px'}},k['gender']!='do_not_wish_to_say'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,k['gender'].replaceAll('_',' / ')):null,k['age']!='do_not_wish_to_say'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,k['age']):null,k['village']!='do_not_wish_to_say'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,k['village']):null,(k['gender']=='do_not_wish_to_say'||k['gender']=='')&&(k['age']=='do_not_wish_to_say'||k['age']=='')&&(k['village']=='do_not_wish_to_say'||k['village']=='')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Anonymous'):null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["s" /* ListItem */],{style:{display:'flex',flexDirection:'row',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],{circular:true,basic:true,style:{opacity:0.9,marginLeft:5,fontSize:'14px'},onClick:function onClick(){_this.setState({openPopup:false},function(){_this.setState({showModal:true});});},icon:'microphone'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:10,padding:'5px 0px'}},'Submit a Recording for Yugtun.com'))),on:'click',open:_this.state.openPopup,onClose:function onClose(){return _this.setState({openPopup:false});},style:{padding:8},position:'bottom center',trigger:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({openPopup:true});},style:{paddingRight:15,marginLeft:10},circular:true,basic:true,icon:true},audioRetrieved.length==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{style:{color:'#929292'},name:'microphone'}):audioRetrieved.length==1&&audioRetrieved[0]['village']=='computer generated'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{style:{color:'#929292',fontSize:'16px'},name:'volume up'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{style:{color:'#106181',fontSize:'16px'},name:'volume up'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{style:{color:'#d2d2d2',paddingLeft:'6px',fontSize:'11px'},name:'chevron down'}),' ')});};console.log("SimpleWordBuilderUpdated props: ",props);// console.log(props.entry)
// console.log(props.entry[5][0])
var queryString=window.location.search;var urlParams=new URLSearchParams(queryString);var record=urlParams.get('record');// console.log(urlParams, record)
_this.state={showModal:false,mvEnglish1:[],mvEnglish2:[],mvEnglish3:[],mvEnglishAbl:[],mvvs:[],mvvo:[],mvvBase:[],mvvMood:"",mvvSegments:"",colorScheme:0,colorsList:{'mvv.b':'#000000','mvv.e':'#852828','mvv.s':'#852828','mvv.o':'#961616','mvv.m':'#838383','mvv.1':'#3455b5','mvv.2':'#d3741e','mvv.3':'#c062c3','mvv.4':'#008000','mvv.5':'#69b4b4','mvv.6':'#e02323','npn00.b':'#000000','npn00.1':'#e02323','npn00.2':'#69b4b4','npn00.pd':'#961616','npn00.ps':'#852828'// 'mvns00.b':'#852828',
// 'mvns00.1':'#b53434',
// 'mvns00.2':'#578f7f',
// 'mvns00.e':'#f29090',
// 'mvns10.b':'#852828',
// 'mvv.4':'#000000',
},npnEnglish1:[],npnEnglish2:[],npn:[],npnBases:[],npnCase:[],npnSegments:[],npnType:[],// mvSubjectOptions:mvSubjectOptions,
// mvObjectOptions:mvObjectOptions,
mvSubjectOptions1:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["k" /* mvSubjectOptions */],mvObjectOptions1:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["d" /* mvObjectOptions */],segmentString:props.entry[2],audioRetrieved:props.usageStartingAudio,openPopup:false,// entry:props.entry[2],
audioParameterBool:record!==null||true?true:false,englishString:'',playingAudio:false,clickedAudioUrl:"",clickedAudio:null,clickedAudioIndex:-1};return _this;}_createClass(SimpleWordBuilderUpdated,[{key:'componentDidMount',value:function componentDidMount(){// backEndCall()
// console.log(this.props)
var initializedCall=void 0;if(this.props.entry[0]=='n'){initializedCall=[["Insert",["np"],[[[this.props.word,0,this.props.index,this.props.definitionIndex]],[0,0,0,1],"Abs"]]];}else{initializedCall=[["Insert",["mv"],[[[this.props.word,0,this.props.index,0]],this.props.entry[0],"Ind"]]];}// [["Insert", ["mv"], [[["nere-", 0, 0, 0]], "i", "Ind"]]]]
this.backEndCall(initializedCall,true);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// backEndCall()
// console.log(nextProps)
var initializedCall=void 0;if(nextProps.entry[0]=='n'){initializedCall=[["Insert",["np"],[[[nextProps.word,0,nextProps.index,nextProps.definitionIndex]],[0,0,0,1],"Abs"]]];}else{initializedCall=[["Insert",["mv"],[[[nextProps.word,0,nextProps.index,0]],nextProps.entry[0],"Ind"]]];}// [["Insert", ["mv"], [[["nere-", 0, 0, 0]], "i", "Ind"]]]]
this.backEndCall(initializedCall,true);}},{key:'backEndCall',value:function backEndCall(keyChanged,eraseExisting){var _this2=this;// console.log('backend',this.state)
// console.log(keyChanged)
var mv={};var cv={};var sv={};var np={};if(eraseExisting){}else{if(this.state.mvvBase.length>0){mv['vBase']=this.state.mvvBase;}if(this.state.mvvMood.length>0){mv['vMood']=this.state.mvvMood;}if(this.state.mvvs.length>0){mv['vs']=this.state.mvvs;}if(this.state.mvvo.length>0){mv['vo']=this.state.mvvo;}if(this.state.npn.length>0){np['n']=this.state.npn;}if(this.state.npnBases.length>0){np['nBases']=this.state.npnBases;}if(this.state.npnCase.length>0){np['nCase']=this.state.npnCase;}}// console.log(keyChanged,mv)
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_6__App_js__["a" /* API_URL */]+"/sentencebuilder",{keyChanged:keyChanged,mv:mv,cv:cv,sv:sv,np:np}).then(function(response){console.log('backend',response.data);var vkey=void 0,nkey=void 0;var updateDict={};if("english"in response.data){vEnglish.map(function(k){if(k in response.data['english']){updateDict[[k]]=response.data['english'][k];}else{updateDict[[k]]=[];}});}if("mv"in response.data){updateDict['mv']=response.data['mv'];vOptions.map(function(k){vkey='mv'+k;if(k in response.data['mv']){// this.setState({
// [vkey]: response.data['mv'][k],
// })
updateDict[[vkey]]=response.data['mv'][k];// if (k == 'qWord') {
//  updateDict[['interCase']] = response.data['mv'][k][0]           
// }
}else{updateDict[[vkey]]=[];// this.setState({
// [vkey]: [],
// })             
}});}else{_this2.initialize('mv');}if("np"in response.data){updateDict['np']=response.data['np'];nOptions.map(function(k){nkey='np'+k;if(k in response.data['np']){updateDict[[nkey]]=response.data['np'][k];}else{updateDict[[nkey]]=[];}});}else{_this2.initialize('np');}// let segmentString = ''
if("segments"in response.data){if("mv"in response.data.segments){if("v"in response.data.segments.mv){// this.setState({
// mvvSegments: response.data.segments.mv.v,
// })
// response.data.segments.mv.v.map((t)=>{segmentString+=t[0]})
updateDict['mvvSegments']=response.data.segments.mv.v;// updateDict['segmentString'] = segmentString
}else{// this.setState({
// mvvSegments: "",
// })                     
updateDict['mvvSegments']="";}}if("np"in response.data.segments){if("n"in response.data.segments.np){// this.setState({
// npnSegments: response.data.segments.np.n,
// })             
// response.data.segments.np.n[0][0].map((t)=>{segmentString+=t[0]})
updateDict['npnSegments']=response.data.segments.np.n;// updateDict['segmentString'] = segmentString
}else{// this.setState({
// npnSegments: [],
// })                     
updateDict['npnSegments']=[];}}}updateDict['segmentString']=response.data.segmentString;updateDict['audioRetrieved']=response.data.audioRetrieved;var englishString='';if("mvEnglishString"in response.data.english){englishString+=response.data.english.mvEnglishString;}if("cvEnglishString"in response.data.english){englishString+=' '+response.data.english.cvEnglishString;}if("svEnglishString"in response.data.english){englishString+=' '+response.data.english.svEnglishString;}if("npEnglishString"in response.data.english){englishString+=' '+response.data.english.npEnglishString;}updateDict['englishString']=englishString;_this2.setState(updateDict);});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.mv!==this.state.mv||prevState.np!==this.state.np){this.updateAllowableOptions();}// if (prevState.segmentString !== this.state.segmentString) {
//   console.log(this.state.segmentString)
//   this.displayIfClipExists(this.state.segmentString)
// }
}},{key:'repeatAudio',// repeatAudio(audio, event, data) {
//   // console.log(audio)
//   if (!this.state.playingAudio) {
//     let sound = new Audio(API_URL + "/yugtunCrowdsourceAudio/" + audio);
//     this.setState({playingAudio: true});
//     sound.play()
//     sound.onended=()=>{
//       this.setState({playingAudio: false});
//     }
//   }
// }
value:function repeatAudio(audio,index,event,data){var _this3=this;var audioURL=__WEBPACK_IMPORTED_MODULE_6__App_js__["a" /* API_URL */]+"/yugtunCrowdsourceAudio/"+audio;// stop audio on double click
if(this.state.playingAudio===true&&this.state.clickedAudioUrl===audioURL){var _audio=this.state.clickedAudio;_audio.pause();_audio.currentTime=0;this.setState({clickedAudio:_audio,clickedAudioIndex:-1,playingAudio:false});}// stop first audio then play new one
if(this.state.playingAudio===true&&this.state.clickedAudioUrl!==audioURL){var firstAudio=this.state.clickedAudio;firstAudio.pause();firstAudio.currentTime=0;this.setState({playingAudio:true});var secondAudio=new Audio(audioURL);secondAudio.play();this.setState({clickedAudioUrl:audioURL,clickedAudioIndex:index,clickedAudio:secondAudio});secondAudio.onended=function(){_this3.setState({playingAudio:false,clickedAudioIndex:-1});};}// play audio again
if(this.state.playingAudio===false&&this.state.clickedAudioUrl===audioURL){var _audio2=this.state.clickedAudio;this.setState({playingAudio:true,clickedAudioIndex:index});_audio2.play();_audio2.onended=function(){_this3.setState({playingAudio:false,clickedAudioIndex:-1});};}// play new audio
if(this.state.playingAudio===false&&this.state.clickedAudioUrl!==audioURL){this.setState({playingAudio:true});var _audio3=new Audio(audioURL);_audio3.play();this.setState({clickedAudioUrl:audioURL,clickedAudioIndex:index,clickedAudio:_audio3});_audio3.onended=function(){_this3.setState({playingAudio:false,clickedAudioIndex:-1});};}}},{key:'render',value:function render(){var _this4=this;console.log(this.state.englishString);// console.log(mvSubjectOptions)
// console.log(mvObjectOptions)
// let numEntries = Object.keys(this.state.fullWord).filter((entryNumber) => {
//   return entryNumber !== 'english' && entryNumber !== 'yupik';
// }).length;
var newWord='';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.npnSegments.length===0&&this.state.mvvBase.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["z" /* Segment */],{basic:true,style:{height:171}}):null,this.state.mvvBase.length>0&&this.state.mvvSegments.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'13px',marginBottom:'20px',marginLeft:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:10,fontSize:'22px',color:'#000000',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{cursor:'pointer',lineHeight:'35px',marginLeft:'2px'}},this.state.mvvSegments.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["b" /* colorsList */][_this4.state.colorScheme][t[1]]}},t[0]);}),this.state.audioParameterBool?this.displayAudioMic(this.state.audioRetrieved):null,this.state.showModal?this.recordClip(this.state.segmentString,'entryUsage',this.state.englishString):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'10px',marginBottom:'20px',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}},this.state.mvEnglish1.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["b" /* colorsList */][_this4.state.colorScheme][w[1]]}},w[0]+" ");}),this.state.mvvs.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{border:'solid 1px #22242626',color:'#852828',fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:function onChange(event,data){_this4.backEndCall([["Update",["mv","vs"],data.value.split('').map(Number)]]);},value:this.state.mvvs.join(""),options:this.state.mvSubjectOptions1}):null,this.state.mvEnglish2.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["b" /* colorsList */][_this4.state.colorScheme][w[1]]}},w[0]+" ");}),this.state.mvvo.length>0?this.state.mvvBase[1]=='it'?this.state.mvEnglishAbl.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["b" /* colorsList */][_this4.state.colorScheme][w[1]]}},w[0]);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{border:'solid 1px #22242626',color:'#c84141',fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:function onChange(event,data){_this4.backEndCall([["Update",["mv","vo"],data.value.split('').map(Number)]]);},value:this.state.mvvo.join(""),options:this.state.mvObjectOptions1}):null,this.state.mvEnglish3.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:_this4.state.mvvo.length>0?_this4.state.mvvBase[1]=='it'?'4px':'0px':'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["b" /* colorsList */][_this4.state.colorScheme][w[1]]}},w[0]+" "));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:{pathname:'/sentencebuilder/2',state:{mv:this.state.mv}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{fontSize:'16px',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',fontFamily:customFontFam}},'Try Word Builder'))))):null,this.state.npnSegments.length>0&&this.state.npnSegments.length===this.state.npn.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'13px',marginBottom:'20px',marginLeft:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:10,fontSize:'22px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{lineHeight:'35px',marginLeft:'2px'}},this.state.npnSegments.slice().reverse()[0][0].map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["b" /* colorsList */][_this4.state.colorScheme][t[1]]}},t[0]);}),this.state.audioParameterBool?this.displayAudioMic(this.state.audioRetrieved):null,this.state.showModal?this.recordClip(this.state.segmentString,'entryUsage',this.state.englishString):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'10px',marginBottom:'20px',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}},this.state.npnEnglish1.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["b" /* colorsList */][_this4.state.colorScheme][w[1]]}},w[0]+" ");}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{border:'solid 1px #22242626',color:'#5c5c5c',fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:function onChange(event,data){_this4.backEndCall([["Update",["np","n",_this4.state.npnSegments.length-1,0],(data.value+_this4.state.npn[_this4.state.npnSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:this.state.npn[this.state.npnSegments.length-1][0].slice(0,-1).join(""),options:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["r" /* nounOptionsMVPossessorsThe */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{border:'solid 1px #22242626',color:'#852828',fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:function onChange(event,data){_this4.backEndCall([["Update",["np","n",_this4.state.npnSegments.length-1,0],_this4.state.npn[_this4.state.npnSegments.length-1][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:this.state.npn[this.state.npnSegments.length-1][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),this.state.npnEnglish2[0].map(function(w,wind){return w.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:__WEBPACK_IMPORTED_MODULE_11__constants_newconstants_js__["b" /* colorsList */][_this4.state.colorScheme][t[1]]}},t[0]+" ");});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:{pathname:'/sentencebuilder/2',state:{np:this.state.np}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{fontSize:'16px',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',fontFamily:customFontFam}},'Try Word Builder'))))):null);}}]);return SimpleWordBuilderUpdated;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_router__["a" /* withRouter */])(SimpleWordBuilderUpdated));

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DialectDictionary; });
var DialectDictionary={"NSU":"Norton Sound–Unaliq (northern Norton Sound)","NSK":"Norton Sound–Kotlik (southern Norton Sound)","NS":"Norton Sound (both northern and southern shores)","Y":"Yukon","HBC":"Hooper Bay and Chevak","NI":"Nelson Island","NUN":"Nunivak Island","NUN(A)":"Nunivak Island, from Cup'ig Eskimo Dictionary","K":"Kuskokwim","LK":"Lower Kuskokwim","BB":"Bristol Bay","NR":"Nushagak River","LI":"Lake Iliamna","EG":"Egegik","UK":"Upper Kuskokwim (i.e., around Aniak)","CAN":"Canineq (around Kwigillingok, Kipnuk, Kongiganek, and Chefornak)","MY":"middle Yukon","LY":"Lower Yukon","Hooper Bay":"Hooper Bay"};

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_ending_underlying_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_google_palette__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_google_palette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_google_palette__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shuffle_array__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shuffle_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_shuffle_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SearchPageHelpers_js__ = __webpack_require__(67);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var peopleDict={'1':"Sg",'2':"Du",'3':"Pl"};var notis=[1,2,7,10];var future=[1,2];var nextinfinitive=[1,2,6,8,9,11];var matchCase=[3,4,5,12];var pastwas=[8,9];var pastdid=[4];// becomes inf
var pastVerbTense=[3,5,12];var pastGerund=[7,10];var doesis=[7,10];var beingnotis=[1,2,7,10];var befirst=[1,2,6,8,9,11];var beingfirst=[7,10];var beingwas=[3,4,5,8,9,12];// let nounPostbaseDefaultNoNV = [13,14,15,16]
var verbPostbaseParticipialDefault=[3,4,5,6,7,8,9,10,11,12];var verbPostbaseDefault=[1,2,3,4,5,6,7,8,9,10,11,12];var nnpostbases=[13,14,15,16];var nounPostbaseDefault=[13,14,15,16,17,18,19,20,21,22,23,24,25];var nounToVerb=[17,18,19,20,21,22,23,24,25];var nvNoIs=[20,21,22];var getVerbInfo={0:{'inup':'','eng':'',text:'past tense'},1:{'inup':'','eng':'',text:'question: yes or no?'},2:{'inup':'summan ','eng':'why ',text:'question: why?'},3:{'inup':'qanuq ','eng':'how ',text:'question: how?'},4:{'inup':'sumi ','eng':'at where ',text:'question: where at?'},5:{'inup':'sumun ','eng':'to where ',text:'question: to where?'},6:{'inup':'sumiñ ','eng':'from where ',text:'question: from where?'}};var nounQuestionWords=[{value:0,key:0,text:'at (localis)'},{value:1,key:1,text:'toward (terminalis)'},{value:2,key:2,text:'from (ablative)'},{value:3,key:3,text:'like (similaris)'},{value:4,key:4,text:'the (relative)'},{value:5,key:5,text:'a, some (modalis)'}];var getNounInfo={0:{'inup':'','eng':'at ',text:'Localis',buttontext:'at (localis)'},1:{'inup':'','eng':'toward ',text:'Terminalis',buttontext:'toward (terminalis)'},2:{'inup':'','eng':'from ',text:'Ablative',buttontext:'from (ablative)'},3:{'inup':'','eng':'like ',text:'Similaris',buttontext:'like (similaris)'},4:{'inup':'','eng':'',text:'Relative',buttontext:'the (relative)'},5:{'inup':'','eng':'',text:'Modalis',buttontext:'a, some (modalis)'}// 6:{'inup':'','eng':'',text:'Vialis',buttontext:'through, using (vialis)'},
// 2:{'inup':'summan ','eng':'why ',text:'question: why?'},
// 3:{'inup':'qanuq ','eng':'how ',text:'question: how?'},
// 4:{'inup':'sumi ','eng':'at where ',text:'question: where at?'},
// 5:{'inup':'sumun ','eng':'to where ',text:'question: to where?'},
// 6:{'inup':'sumiñ ','eng':'from where ',text:'question: from where?'},
};var customFontFam="Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif";var letterbutton={paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'};var nounvalue1def='1';var nounvalue2def='00(3)';var value1def='s31-3(1)';var value2def='o31-3(2)';var WordBuilder=function(_Component){_inherits(WordBuilder,_Component);function WordBuilder(props){var _this$state;_classCallCheck(this,WordBuilder);var _this=_possibleConstructorReturn(this,(WordBuilder.__proto__||Object.getPrototypeOf(WordBuilder)).call(this,props));// console.log(props)
_this.defaultFstCall=function(tag){// console.log(ind)
console.log(tag);_this.setState({baseTag:tag});if(tag==='i'){_this.setIntransitive(true,undefined,undefined);// this.setState({person: 3,people: 1, value1: "31-1(1)",activeEditIndex:ind}); this.getFSTParse(fstCall,ind,0); 
var verbTenseMatch=_this.state.usageDefinition.match(/\⟨.*?\⟩/g);var ind=-1;var indCase='';// console.log(verbTenseMatch)
// if (verbTenseMatch.length == 1) {
ind=_this.state.usageVerbTenses.indexOf(_this.state.primaryVerbBase);// }
if(ind==3){indCase='g';}else if(ind==0){indCase='i';}_this.setState({containsIs:_this.state.usageDefinition.includes(' is '),primaryVerbIndex:ind,primaryVerbIndexCase:indCase});}else if(tag==='n'){_this.setNoun(true,undefined,undefined);// this.setState({
// 	primaryNoun: this.state.usageDefinition,
// })			
}else if(tag==='t'){// let matches = this.state.usageDefinition.match(/\<.*?\>/g)
// let splitSentence = []
// if (matches.length == 1) {
// 	splitSentence = this.state.usageDefinition.split(matches[0])
// }
// this.identifyObjectCase(matches[0])
// // let leftOfObject = splitSentence[0]
// let verbTenseMatch = splitSentence[0].match(/\⟨.*?\⟩/g)
// let splitLeftOfObject = []
// if (verbTenseMatch.length == 1) {
// 	splitLeftOfObject = splitSentence[0].split(verbTenseMatch[0])
// }
// this.setState({
// 	leftOfVerb: splitLeftOfObject[0],
// 	rightOfVerb: splitLeftOfObject[1],
// 	primaryVerb: verbTenseMatch[0].replace("⟨","").replace("⟩",""),
// 	primaryVerbBase: verbTenseMatch[0].replace("⟨","").replace("⟩",""),
// 	transitiveRightOfObject: splitSentence[1],
// 	// entryModified: matches[0],
// });
_this.setTransitive(true,undefined,undefined);}if(tag==='n'){var postbaseInformationAvailable=[];nounPostbaseDefault.map(function(a){postbaseInformationAvailable.push({value:a,key:a,text:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["u" /* nounPostbases */][a].description});});var definitionBaseOptions=[];_this.state.usageDefinition.map(function(k,index){var sentence=_this.state.usageDefinition[index][0];var matches=sentence.match(/\⟨.*?\⟩/g);if(matches!==null){if(_this.state.nounvalue1!=='1'){matches.map(function(m){return sentence=sentence.replace(m,_this.state.usageDefinition[index][2][1]);});}else{matches.map(function(m){return sentence=sentence.replace(m,_this.state.usageDefinition[index][2][0]);});}}definitionBaseOptions.push({value:index,key:index,text:sentence});});_this.setState({definitionBaseOptions:definitionBaseOptions});_this.setState({postbasesAvailable:nounPostbaseDefault});_this.setState({allPostbasesAvailable:nounPostbaseDefault});_this.setState({postbaseMaster:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["u" /* nounPostbases */]});_this.setState({postbaseInformationAvailable1:postbaseInformationAvailable});}else{var _postbaseInformationAvailable=[];Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["a" /* VVpostbases */]).map(function(a){_postbaseInformationAvailable.push({value:a,key:a,text:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["a" /* VVpostbases */][a].exp_display+' - '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["a" /* VVpostbases */][a].description});});_this.setState({postbasesAvailable:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["a" /* VVpostbases */]});_this.setState({allPostbasesAvailable:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["a" /* VVpostbases */]});_this.setState({postbaseMaster:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["a" /* VVpostbases */]});_this.setState({postbaseInformationAvailable1:_postbaseInformationAvailable});}var baseOptions=[];var otherBases=_this.state.otherBases;var index=otherBases.indexOf(_this.state.baseCase);otherBases.splice(index,1);baseOptions.push({id:0,value:0,text:_this.state.baseCase});otherBases.map(function(m,ind){baseOptions.push({id:ind+1,value:ind+1,text:m});});_this.setState({baseOptions:baseOptions});};_this.getIs=function(personN,peopleN,capitalize){// console.log()
var subjectis='';if(capitalize){if(peopleN==='1'&&personN==='1'){subjectis='Am ';}else if(peopleN==='1'&&personN==='3'){subjectis='Is ';}else{subjectis='Are ';}}else{if(peopleN==='1'&&personN==='1'){subjectis='am ';}else if(peopleN==='1'&&personN==='3'){subjectis='is ';}else{subjectis='are ';}}return subjectis;};_this.getDo=function(personN,peopleN,capitalize){var subjectis='';if(capitalize){if(peopleN==='1'&&personN==='1'){subjectis='Do ';}else if(peopleN==='1'&&personN==='3'){subjectis='Does ';}else{subjectis='Do ';}}else{if(peopleN==='1'&&personN==='1'){subjectis='do ';}else if(peopleN==='1'&&personN==='3'){subjectis='does ';}else{subjectis='do ';}}return subjectis;};_this.usageEntry=function(ind,tag){// console.log(ind,tag)
if(tag==='n'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'30px',marginBottom:'10px',fontSize:'30px',color:'#000000',fontWeight:'400'}},_this.state.entryModified.map(function(modifiedword,m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',lineHeight:'35px'}},_this.state.otherBases.length==0?modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:index===0?'#000000':modifiedword.split(">").length-1==index?'#852828':_this.state.colorsList[_this.state.currentPostbases[_this.state.currentPostbases.length-index]]}},q);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,onChange:_this.changeActiveUsageKey.bind(_this),text:modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'400',color:modifiedword.split(">").length-1==index?'#852828':'#000000'}},q);}),value:_this.state.activeDefinitionInEditIndex,options:_this.state.baseOptions}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',fontSize:'20px',marginBottom:'15px',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{padding:'10px'}},_this.state.baseCase+'-'),_this.state.underlyingCallReturn.map(function(x,xind){return x[0]==''?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{padding:'10px',color:xind==_this.state.underlyingCallReturn.length-1?'#852828':_this.state.colorsList[_this.state.currentPostbases[_this.state.currentPostbases.length-xind-1]]}},x.join(', '));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},_this.state.englishPreNounOptions),_this.state.nounMood==='Modalis'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setNoun.bind(_this,false),value:_this.state.nounvalue2,options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["x" /* nounoptionsmodalis */]}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setNoun.bind(_this,false),value:_this.state.nounvalue2,options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["v" /* nounoptions1 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setNoun.bind(_this,false),value:_this.state.nounvalue1,options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["w" /* nounoptions2 */]}),_this.state.englishPreNoun.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.state.colorsList[_this.state.currentPostbases[wind]]}},w);}),_this.state.usageDefinition.length>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,onChange:_this.changeActiveDefinitionKey.bind(_this),value:_this.state.activeDefinitionInEditIndex,options:_this.state.definitionBaseOptions}):_this.state.nounvalue1!=='1'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.usageDefinition[_this.state.activeDefinitionInEditIndex][2][1])):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.usageDefinition[_this.state.activeDefinitionInEditIndex][2][0]))));}else if(tag==='i'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'30px',marginBottom:'10px',fontSize:'30px',color:'#000000',fontWeight:'400'}},_this.state.entryModified.map(function(modifiedword,m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',lineHeight:'35px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828','paddingRight':'5px'}},_this.state.questionWord),_this.state.otherBases.length==0?modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:index===0?'#000000':modifiedword.split(">").length-1==index?'#852828':_this.state.colorsList[_this.state.currentPostbases[_this.state.currentPostbases.length-index]]}},q);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,onChange:_this.changeActiveUsageKey.bind(_this),text:modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'400',color:modifiedword.split(">").length-1==index?'#852828':_this.state.colorsList[_this.state.currentPostbases[_this.state.currentPostbases.length-index]]}},q);}),value:_this.state.activeKeyInEditIndex,options:_this.state.baseOptions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},' '+_this.state.questionMark));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',fontSize:'20px',marginBottom:'15px',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{padding:'10px'}},_this.state.baseCase+'-'),_this.state.underlyingCallReturn.map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{padding:'10px',color:xind==_this.state.underlyingCallReturn.length-1?'#852828':_this.state.colorsList[_this.state.currentPostbases[_this.state.currentPostbases.length-xind-1]]}},x.join(', '));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},_this.processStyledText(_this.state.questionWordEnglish)),_this.state.englishPreSubject.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.state.colorsList[_this.state.currentPostbases[wind]]}},w);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.state.preSubjectText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setIntransitive.bind(_this,false),value:_this.state.value1,options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["A" /* options1 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.state.afterSubjectText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.state.subjectIs),_this.state.englishPreNoun.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.state.colorsList[_this.state.currentPostbases[wind]]}},w);}),_this.state.englishPreVerb.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.state.colorsList[_this.state.currentPostbases[w[1]]]}},w[0]+" ");}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.bePreVerb)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.primaryVerb+" ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.primaryNoun)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.preObjectText+" ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.afterObjectText)),_this.state.afterObjectText2.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.state.colorsList[_this.state.currentPostbases[w[1]]]}}," "+w[0]);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},' '+_this.state.questionMark)));}else if(tag==='t'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'30px',marginBottom:'10px',fontSize:'30px',color:'#000000',fontWeight:'400'}},_this.state.entryModified.map(function(modifiedword,m){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',lineHeight:'35px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828','paddingRight':'5px'}},_this.state.questionWord),_this.state.otherBases.length==0?modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:index===0?'#000000':modifiedword.split(">").length-1==index?'#852828':_this.state.colorsList[_this.state.currentPostbases[_this.state.currentPostbases.length-index]]}},q);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,onChange:_this.changeActiveUsageKey.bind(_this),text:modifiedword.split('>').map(function(q,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'400',color:modifiedword.split(">").length-1==index?'#852828':_this.state.colorsList[_this.state.currentPostbases[_this.state.currentPostbases.length-index]]}},q);}),value:_this.state.activeKeyInEditIndex,options:_this.state.baseOptions}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},' '+_this.state.questionMark));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',fontSize:'20px',marginBottom:'15px',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{padding:'10px'}},_this.state.baseCase+'-'),_this.state.underlyingCallReturn.map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{padding:'10px',color:xind==_this.state.underlyingCallReturn.length-1?'#852828':_this.state.colorsList[_this.state.currentPostbases[_this.state.currentPostbases.length-xind-1]]}},x.join(', '));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'18px',color:'#0D0D0D',fontWeight:'300'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},_this.processStyledText(_this.state.questionWordEnglish)),_this.state.englishPreSubject.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.state.colorsList[_this.state.currentPostbases[wind]]}},w);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.state.preSubjectText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px'},onChange:_this.setTransitive.bind(_this,false),value:_this.state.value1,options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["A" /* options1 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.state.afterSubjectText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.state.subjectIs),_this.state.englishPreVerb.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.state.colorsList[_this.state.currentPostbases[w[1]]]}},w[0]+" ");}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.bePreVerb)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.preObjectText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.primaryVerb)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.primaryNoun)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:{backgroundColor:'#F3F3F3',color:'#852828',fontSize:'18px',fontWeight:'300',padding:'5px',borderRadius:'5px',marginRight:'4px',marginLeft:'4px'},onChange:_this.setTransitive.bind(_this,false),value:_this.state.value2,options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["B" /* options2 */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#777777'}},_this.processStyledText(_this.state.afterObjectText)),_this.state.afterObjectText2.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.state.colorsList[_this.state.currentPostbases[w[1]]]}}," "+w[0]);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},' '+_this.state.questionMark)));}};_this.processStyledText=function(sentence){var matches=sentence.match(/\⎡.*?\⎤/g);if(matches!==null){matches.map(function(m){return sentence=sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>');});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:sentence}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence.replace("<","").replace(">",""));}};_this.processStyledText2=function(sentence,tag){console.log(sentence,tag);sentence=sentence.replace("⟨","").replace("⟩","").replace("]","").replace("[","").replace("<","").replace(">","");// if (tag == 'NOUN') {
// 	sentence = 'the one '+sentence
// } else {
// 	sentence = 'he/she is '+sentence
// }
// let matches = sentence.match(/\<.*?\>/g)
// if (matches !== null) {
// matches.map((m) => sentence = sentence.replace(m,'<b>'+m.slice(1,-1)+'</b>'))		
// return <span dangerouslySetInnerHTML={{__html: sentence}} />		
// } else {
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence);// }
};_this.state=(_this$state={// show: false,
// word: decodeURI(props.match.params.word),
// word: 'nakuu-',
entryModified:[],activeKeyInEditIndex:props.location.state===undefined?0:props.location.state.activeKeyInEditIndex,activeDefinitionInEditIndex:props.location.state===undefined?0:props.location.state.activeDefinitionInEditIndex,usageDefinition:props.location.state===undefined?'':props.location.state.usageDefinition,baseUsageWord:props.location.state===undefined?'pissurtuq':props.location.state.word,baseCase:props.location.state===undefined?'':props.location.state.baseCase,pluralizedDefinition:'',tag:'',baseTag:'',otherBases:[],entryUrl:'',nounMood:'Absolutive',verbMood:'Indicative',baseOptions:[],definitionBaseOptions:[],postbaseInformationAvailable1:[],postbaseInformationAvailable2:[],postbasesAvailable:[],postbaseMaster:{},allPostbasesAvailable:[],colorsList:__WEBPACK_IMPORTED_MODULE_8_shuffle_array___default()(__WEBPACK_IMPORTED_MODULE_7_google_palette___default()('tol-rainbow',500).map(function(c){return'#'+c;})),// url: 
subjectIs:'is ',subject:'it',people:1,person:3,nounvalue1:props.location.state===undefined?nounvalue1def:props.location.state.nounvalue1,nounvalue2:props.location.state===undefined?nounvalue2def:props.location.state.nounvalue2,value1:props.location.state===undefined?value1def:props.location.state.value1,value2:props.location.state===undefined?value2def:props.location.state.value2,sisters:[],firstVerb:'',// definitionraw: '',
preSubjectText:''},_defineProperty(_this$state,'value1',''),_defineProperty(_this$state,'afterSubjectText',''),_defineProperty(_this$state,'containsIs',''),_defineProperty(_this$state,'primaryVerb',''),_defineProperty(_this$state,'preObjectText',''),_defineProperty(_this$state,'value2',''),_defineProperty(_this$state,'afterObjectText',''),_defineProperty(_this$state,'startingVerbTense',-1),_defineProperty(_this$state,'currentPostbases',[]),_defineProperty(_this$state,'availablePostbaseInformationText',[]),_defineProperty(_this$state,'usageVerbTenses',[]),_defineProperty(_this$state,'transitiveLeftOfObject',''),_defineProperty(_this$state,'transitiveRightOfObject',''),_defineProperty(_this$state,'englishPreVerb',[]),_defineProperty(_this$state,'englishPreSubject',[]),_defineProperty(_this$state,'englishPreNoun',[]),_defineProperty(_this$state,'englishPreNounOptions',''),_defineProperty(_this$state,'leftOfVerb',''),_defineProperty(_this$state,'rightOfVerb',''),_defineProperty(_this$state,'primaryNoun',''),_defineProperty(_this$state,'primaryVerb',''),_defineProperty(_this$state,'primaryVerbBase',''),_defineProperty(_this$state,'bePreVerb',''),_defineProperty(_this$state,'beforeSubject',''),_defineProperty(_this$state,'questionMark',''),_defineProperty(_this$state,'questionWord',''),_defineProperty(_this$state,'questionWordEnglish',''),_defineProperty(_this$state,'moodSpecific',''),_defineProperty(_this$state,'endingNumber',-1),_defineProperty(_this$state,'hasFuture',false),_defineProperty(_this$state,'underlyingCallReturn',[]),_defineProperty(_this$state,'postbase1',-1),_defineProperty(_this$state,'postbase2',-1),_defineProperty(_this$state,'ending1',-1),_defineProperty(_this$state,'objectPossessed',false),_defineProperty(_this$state,'containsIs',false),_defineProperty(_this$state,'afterObjectText2',[]),_this$state);_this.getWord=_this.getWord.bind(_this);_this.addPostbase=_this.addPostbase.bind(_this);_this.getWord(decodeURI(props.match.params.word),-1);_this.setNoun=_this.setNoun.bind(_this);_this.setIntransitive=_this.setIntransitive.bind(_this);return _this;}// identifyObjectCase = (match) => {
// 	console.log('eventually set the object type here, her/him versus it')
// 	let ind = Math.round(Math.random())
// let value1 = ''
// let value2 = ''
// let possessed = false
// if (ind % 2 == 0) {
// value1 = "s31-2(1)"  
// } else {
// value1 = "s31-1(1)"  
// }
// if (match == '<her/him/it>') {
// 		value2 = "o31-3(2)"
// } else if (match == '<her/him>') {
// 		if (ind % 2 == 0) {
// 		value2 = "o31-1(2)"			
// 		} else {
// 		value2 = "o31-2(2)"
// 		}
// } else if (match == '<her/his>') {
// 		if (ind % 2 == 0) {
// 		value2 = "o31-1(2)"			
// 		} else {
// 		value2 = "o31-2(2)"
// 		}
// } else if (match == '<her>') {
// 		value2 = "o31-2(2)"
// } else if (match == '<him>') {
// 		value2 = "o31-1(2)"
// } else if (match == '<a person/it>') {
// 		value2 = "o31-3(2)"
// } else if (match == '<it>') {
// 		value2 = "o31-3(2)"
// } else if (match == '<them>') {
// 		value2 = "o33(2)"
// } else if (match == '<someone/something>') {
// 		value2 = "o31-3(2)"
// } else if (match == '<her/his/its>') {
// 	possessed = true
// 		value2 = "o31-3(2)"
// } else {
// 		value2 = "o31-3(2)"			
// }
// this.setState({objectPossessed:possessed})
// this.setState({value1:value1,value2:value2})
// }
_createClass(WordBuilder,[{key:'getWord',value:function getWord(word,num){var _this2=this;// console.log(this.state.baseCase,this.state.activeKeyInEditIndex)
this.setState({nounvalue1:nounvalue1def,nounvalue2:nounvalue2def,value1:value1def,value2:value2def,verbMood:'Indicative',nounMood:'Absolutive',currentPostbases:[],englishPreVerb:[],primaryNoun:'',englishPreNounOptions:'',postbase1:-1,postbase2:-1});__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/yupikusage/"+encodeURIComponent(word)).then(function(response){console.log(response.data);var tag=void 0;if(num===-1){// console.log(response.data[Object.keys(response.data)[0]])
_this2.setState({tag:response.data['key'][0],baseCase:response.data['key'][1],baseUsageWord:response.data['key'][2],entryUrl:response.data['key'][2],usageDefinition:response.data['key'][3],// otherBases: response.data['key'].otherBases,
sisters:response.data['sisters']});console.log(response.data['key'].length);if(response.data['key'].length>4){_this2.setState({usageVerbTenses:response.data['key'][4],startingVerbTense:response.data['key'][4].indexOf(response.data['key'][5][4]),// definitionraw: response.data['key'][3][0][0] === undefined ? '' : response.data['key'][3][0][0],
preSubjectText:response.data['key'][5][0]===undefined?'':response.data['key'][5][0],value1:response.data['key'][5][1]===undefined?'':response.data['key'][5][1],afterSubjectText:response.data['key'][5][2]===undefined?'':response.data['key'][5][2],containsIs:response.data['key'][5][3]===undefined?'':response.data['key'][5][3],primaryVerbBase:response.data['key'][5][4]===undefined?'':response.data['key'][5][4],preObjectText:response.data['key'][5][5]===undefined?'':response.data['key'][5][5],value2:response.data['key'][5][6]===undefined?'':response.data['key'][5][6],afterObjectText:response.data['key'][5][7]===undefined?'':response.data['key'][5][7]});}// console.log(index)
tag=response.data['key'][0];}// } else {
// console.log(response.data[this.state.num])        
//  this.setState({
//    otherBases: response.data[this.state.activeKeyInEditIndex].otherBases,	
//    entryUrl: response.data[this.state.activeKeyInEditIndex].url,	
//    tag: response.data[this.state.activeKeyInEditIndex].tag,	
//    sisters: response.data[this.state.activeKeyInEditIndex].sisters,
//    usageVerbTenses: response.data[this.state.activeKeyInEditIndex].usageVerbTenses
// })
//  tag = response.data[this.state.activeKeyInEditIndex].tag
// }   
_this2.setState({entryData:response.data});// console.log(tag)
_this2.defaultFstCall(tag);// if (tag == 'NOUN') {
// 	this.setNoun(this,true)
// } else if (tag == 'INTRANSITIVE VERB') {
// 	this.setIntransitive(this,true)
// }
});}},{key:'setIntransitive',value:function setIntransitive(initializing,e,data){// console.log(e, data)
var value1=void 0;var tag='i';// let verbMood = 'Indicative'
if(initializing){var ind=Math.round(Math.random());if(ind%2==0){value1="s31-2(1)";}else{value1="s31-1(1)";}// person = 
// people = 
}else{value1=data.value;// person = data.value[0]
// people = data.value[1]
}// let fstCall = ''
//  if (verbMood === 'Indicative') {
//  	fstCall = '>+V+Ind+Prs+' + value1[1] + peopleDict[value1[2]]
//  }
this.setState({value1:value1// containsIs: containsIs,
// activeEditIndex:ind,
// person: person,
// people: people,
// fstCall: fstCall,
});if(this.state.baseTag==='n'){this.setEnglishNoun(this.state.currentPostbases,value1,'',this.state.nounMood);}else{this.setEnglish(this.state.currentPostbases,value1,'',this.state.verbMood,this.state.moodSpecific);}this.getFSTParse(this.state.baseCase,this.state.currentPostbases,tag,this.state.verbMood,this.state.moodSpecific,value1,'',this.state.nounMood,[],[]);}},{key:'setTransitive',value:function setTransitive(initializing,e,data){// console.log(e, data, ind, initializing)
var value1=void 0,value2=void 0;if(initializing){// if (ind % 2 == 0) {
value1=this.state.value1;// } else {
// value1 = "s31-1(1)"  
// }
value2=this.state.value2;// person = 
// people = 
}else{console.log(data.value);if(data.value[0]=='s'){value1=data.value;value2=this.state.value2;}else{value1=this.state.value1;value2=data.value;}// person = data.value[0]
// people = data.value[1]
}// let fstCall = ''
//  if (this.state.verbMood === 'Indicative') {
//  	fstCall = '>+V+Ind+Prs+' + value1[1] + peopleDict[value1[2]] + '+' + value2[1]+peopleDict[value2[2]] + 'O'
//  }
this.setState({value1:value1,value2:value2// activeEditIndex:ind,
// person: person,
// people: people,
// fstCall: fstCall,
});this.setEnglish(this.state.currentPostbases,value1,value2,this.state.verbMood,this.state.moodSpecific);this.getFSTParse(this.state.baseCase,this.state.currentPostbases,this.state.tag,this.state.verbMood,this.state.moodSpecific,value1,value2,this.state.nounMood,[],[]);}// getSubjectIs = (personN, peopleN) => {
//   let subjectis = '';
//   if (this.state.currentPostbases.length > 0) {
// 	  if (!notis.includes(this.state.currentPostbases[0])) {
// 		  if (peopleN === '1' && personN === '1') {
// 		    subjectis = 'am '
// 		  } else if (peopleN === '1' && personN === '3') {
// 		    subjectis = 'is '
// 		  } else {
// 		    subjectis = 'are '
// 		  }	  	
// 	  }  	
//   } else {
// 	  if (peopleN === '1' && personN === '1') {
// 	    subjectis = 'am '
// 	  } else if (peopleN === '1' && personN === '3') {
// 	    subjectis = 'is '
// 	  } else {
// 	    subjectis = 'are '
// 	  }	 	  	
//   }
//    this.setState({
//      person: parseInt(personN),
//      people: parseInt(peopleN),
//      subjectIs: subjectis,
//      })	 
// };
},{key:'setNoun',value:function setNoun(initializing,e,data){var _this3=this;console.log(e,data,initializing);var nounvalue1=void 0,nounvalue2=void 0,owner=void 0;if(initializing){nounvalue1=this.state.nounvalue1;nounvalue2=this.state.nounvalue2;// owner = '+'+this.state.nounvalue2[0]+peopleDict[this.state.nounvalue2[1]]
// person = 
// people = 
}else{if(data.value.length==1){nounvalue1=data.value;nounvalue2=this.state.nounvalue2;}else{nounvalue1=this.state.nounvalue1;nounvalue2=data.value;}// console.log(owner)
// value1 = data.value
// person = data.value[0]
// people = data.value[1]
}// if (nounvalue2[0] !== '0') {
// 	owner = '+'+nounvalue2[0]+peopleDict[nounvalue2[1]]
// } else {
// 	owner = ''
// }
//  	let fstCall = ''
//    if (this.state.nounMood === 'Absolutive') {
//    	fstCall = '>+N+Abs+' + peopleDict[nounvalue1] + owner
//    }
this.setState({nounvalue1:nounvalue1,nounvalue2:nounvalue2// activeEditIndex:ind,
// person: person,
// people: people,
// fstCall: fstCall,
});var definitionBaseOptions=[];this.state.usageDefinition.map(function(k,index){var sentence=_this3.state.usageDefinition[index][0];var matches=sentence.match(/\⟨.*?\⟩/g);if(matches!==null){if(nounvalue1!=='1'){matches.map(function(m){return sentence=sentence.replace(m,_this3.state.usageDefinition[index][2][1]);});}else{matches.map(function(m){return sentence=sentence.replace(m,_this3.state.usageDefinition[index][2][0]);});}}// console.log(sentence)
definitionBaseOptions.push({value:index,key:index,text:sentence});});this.setState({definitionBaseOptions:definitionBaseOptions});this.setEnglishNoun(this.state.currentPostbases,nounvalue1,nounvalue2,this.state.nounMood);this.getFSTParse(this.state.baseCase,this.state.currentPostbases,this.state.tag,this.state.verbMood,this.state.moodSpecific,[],[],this.state.nounMood,nounvalue1,nounvalue2);}},{key:'processUnderlyingForm',value:function processUnderlyingForm(){//add here
}},{key:'switchToSister',value:function switchToSister(info){this.getWord(info,-1);}},{key:'setEnglishNoun',value:function setEnglishNoun(currentPostbases,value1,value2,nounMood){var _this4=this;var subjectis='';var englishPreNoun=[];var englishPreNounOptions='';console.log(currentPostbases,nounMood);var personN=value1[1];var peopleN=value1[2];if(currentPostbases.length>0){if(!nvNoIs.includes(currentPostbases[0])){subjectis=this.getIs(personN,peopleN,false);}if(peopleN==='1'&&personN==='3'){currentPostbases.map(function(i,index){englishPreNoun.push(_this4.state.postbaseMaster[i].englishModifier(""));});}else{currentPostbases.map(function(i,index){englishPreNoun.push(_this4.state.postbaseMaster[i].englishModifierPlural(""));});}}// currentPostbases.map((i,index)=>{
// 	englishPreNoun.push(this.state.postbaseMaster[i].englishModifier(""))
// })
if(nounMood==='Localis'){englishPreNounOptions=getNounInfo[0]['eng'];}else if(nounMood==='Terminalis'){englishPreNounOptions=getNounInfo[1]['eng'];}else if(nounMood==='Ablative'){englishPreNounOptions=getNounInfo[2]['eng'];}else if(nounMood==='Similaris'){englishPreNounOptions=getNounInfo[3]['eng'];}else if(nounMood==='Relative'){englishPreNounOptions=getNounInfo[4]['eng'];}else if(nounMood==='Modalis'){englishPreNounOptions=getNounInfo[5]['eng'];}// console.log(englishPreVerb)
// this.getSubjectIs(value1[1],value1[2])
this.setState({englishPreNoun:englishPreNoun,englishPreNounOptions:englishPreNounOptions,subjectIs:subjectis});// this.getSubjectIs(value1[1],value1[2])
}},{key:'setEnglish',value:function setEnglish(currentPostbases,value1,value2,verbMood,moodSpecific){var _this5=this;var englishPreVerb=[];var englishPreSubject=[];var primaryVerb='';// let subjectis = ''
var beforeSubject='';var bePreVerb='';var personN=value1[1];var peopleN=value1[2];var questionWord='';var questionWordEnglish='';var capitalize=false;var subjectIs='';// let i = -1
// let j = -1
// if (currentPostbases.length == 1) {
// 	i = currentPostbases[0]
// } else if (currentPostbases.length == 2) {
// 	i = currentPostbases[0]
// 	j = currentPostbases[1]
// }
// let pastwas = [8,9]
// let pastdid = [4] // becomes inf
// let pastVerbTense = [3,5,12]
// let pastGerund = [7,10]
// if (verbMood == 'Participial') {
// 	if (this.state.primaryVerbBase.length === 0) { //be condition
// 		if (currentPostbases.length === 0) {
// 			subjectis = 'was '
// 		} else {
// 			if (pastwas.includes(i)) {
// 				subjectis = 'was '
// 			}
// 			englishPreVerb.push(this.state.postbaseMaster[i].englishModifierPast(""))
// 			if (befirst.includes(i)) {
// 				bePreVerb = 'be'
// 			} else if (beingfirst.includes(i)) {
// 				bePreVerb = 'being'
// 			}
// 		}
// 	} else {
// 		if (currentPostbases.length === 0) {
// 			primaryVerb=this.state.usageVerbTenses[1]
// 		} else {
// 			if (pastdid.includes(i)) {
// 				subjectis = 'did '
// 			} else if (pastwas.includes(i)) {
// 				subjectis = 'was '
// 			}
// 			englishPreVerb.push(this.state.postbaseMaster[i].englishModifierPast(""))
// 			if (pastVerbTense.includes(i)) {
// 				primaryVerb = this.state.usageVerbTenses[1]
// 			} else if (pastGerund.includes(i)) {
// 				primaryVerb = this.state.usageVerbTenses[3]
// 			} else {
// 				primaryVerb = this.state.usageVerbTenses[0]
// 			}
// 		}
// 	}
// } else if (verbMood == 'Interrogative') {
// 	if (moodSpecific.length !== 0) {
// 		// console.log(moodSpecific)
// 		questionWord = getVerbInfo[moodSpecific]['inup']
// 		questionWordEnglish = getVerbInfo[moodSpecific]['eng']
// 		capitalize = false
// 	}
// 	if (this.state.primaryVerbBase.length === 0) { //be condition
// 		primaryVerb = this.state.primaryVerbBase
// 		if (currentPostbases.length === 0) {
// 		  beforeSubject = this.getIs(personN, peopleN, capitalize) 
// 		} else {
// 			if (notis.includes(i)) {
// 				if (doesis.includes(i)) {
// 					beforeSubject = this.getDo(personN,peopleN,capitalize)
// 				englishPreVerb.push(this.state.postbaseMaster[i].englishModifierInfinitive(""))
// 				} else {
// 					beforeSubject = ''
// 				englishPreVerb.push(this.state.postbaseMaster[i].englishModifier(""))
// 				}
// 			} else {
// 			  beforeSubject = this.getIs(personN, peopleN, capitalize)  	
// 				englishPreVerb.push(this.state.postbaseMaster[i].englishModifier(""))
// 			}
// 			if (befirst.includes(i)) {
// 				bePreVerb = 'be'
// 			} else if (beingfirst.includes(i)) {
// 				bePreVerb = 'being'
// 			}
// 		}
// 	} else {
// 		if (currentPostbases.length === 0) {
// 		  beforeSubject = this.getIs(personN, peopleN, capitalize) 
// 		  primaryVerb = this.state.primaryVerbBase
// 		} else {
// 			if (notis.includes(i)) {
// 				if (doesis.includes(i)) {
// 				  beforeSubject = this.getDo(personN,peopleN,capitalize)
// 					englishPreVerb.push(this.state.postbaseMaster[i].englishModifierInfinitive(""))
// 				} else {
// 					beforeSubject = ''
// 					englishPreSubject.push(this.state.postbaseMaster[i].englishModifierPast(""))
// 				}
// 			} else {
// 			  beforeSubject = this.getIs(personN, peopleN, capitalize) 
// 				englishPreVerb.push(this.state.postbaseMaster[i].englishModifier(""))
// 			}
// 			if (nextinfinitive.includes(i)) {
// 				primaryVerb = this.state.usageVerbTenses[0]
// 			} else {
// 				primaryVerb = this.state.usageVerbTenses[3]
// 			}
// 		}
// 	}
// } else{
// if (notis.includes(i) || future.includes(j)) {
// if (this.state.postbaseMaster[i]['is']) {
// 	subjectis = this.getIs(personN, peopleN, false) 	
// } 
// if (this.state.primaryVerbBase.length === 0) { //be condition
// 	if (currentPostbases.length === 0) {
// 		// this.setState({primaryVerb: this.state.primaryVerbBase});	
// 	} else if (currentPostbases.length === 1) { 
// 		englishPreVerb.push(this.state.postbaseMaster[i].englishModifier(""))
// 		if (befirst.includes(i)) {
// 			bePreVerb = 'be'
// 		} else if (beingfirst.includes(i)) {
// 			bePreVerb = 'being'
// 		}
// 	} else { // two postbases
// 		englishPreVerb.push(this.state.postbaseMaster[i].englishModifier(""))
// 		if (nextinfinitive.includes(i)) {
// 			englishPreVerb.push(this.state.postbaseMaster[j].englishModifierInfinitive(""))
// 		} else {
// 			englishPreVerb.push(this.state.postbaseMaster[j].englishModifierGerund(""))
// 		}
// 		if (matchCase.includes(j)) {
// 			if (befirst.includes(i)) {
// 				bePreVerb = 'be'
// 			} else if (beingfirst.includes(i)) {
// 				bePreVerb = 'being'
// 			}
// 		} else if (befirst.includes(j)) {
// 			bePreVerb = 'be'
// 		} else if (beingfirst.includes(j)) {
// 			bePreVerb = 'being'
// 		}
// 	}
// } else {
// if (currentPostbases.length === 0) {
// 	primaryVerb=this.state.primaryVerbBase
// 	if (this.state.containsIs) {
// 		subjectIs = this.getIs(personN, peopleN, capitalize) 
// 	}
// } else if (currentPostbases.length === 1) { 
// 	if (this.state.postbaseMaster[i].is) {
// 		subjectIs = this.getIs(personN, peopleN, capitalize) 
// 	} else {
// 		subjectIs = ''
// 	}
// 	englishPreVerb.push(this.state.postbaseMaster[i].gen_preverb)
// 	console.log(this.state.postbaseMaster[i].gen_preverb_after)
// 	if (this.state.postbaseMaster[i].gen_preverb_after == 'ger') { 
// 		primaryVerb=this.state.usageVerbTenses[0]
// 	} else {
// 		primaryVerb=this.state.usageVerbTenses[3]
// 	}
// } else { // two postbases
// 	if (this.state.postbaseMaster[i].is) {
// 		subjectIs = this.getIs(personN, peopleN, capitalize) 
// 	}
// 	englishPreVerb.push(this.state.postbaseMaster[i].gen_preverb)
// 	// console.log(i,j)
// 	if (this.state.postbaseMaster[i].gen_preverb_after == 'ger') { 
// 		// if (this.state.postbaseMaster[j].ger_preverb_after == this.state.postbaseMaster[i].gen_preverb_after) {
// 			// englishPreVerb.push(this.state.postbaseMaster[j].ger_preverb)
// 			// primaryVerb=this.state.usageVerbTenses[3]
// 		// } else {
// 			englishPreVerb.push(this.state.postbaseMaster[j].inf_preverb)
// 			if (this.state.postbaseMaster[j].inf_preverb_after == 'inf') { 
// 				primaryVerb=this.state.usageVerbTenses[0]
// 			} else {
// 				primaryVerb=this.state.usageVerbTenses[3]
// 			}
// 		// }
// 	} else {
// 		// if (this.state.postbaseMaster[j].inf_preverb_after == this.state.postbaseMaster[i].gen_preverb_after) {
// 			// englishPreVerb.push(this.state.postbaseMaster[j].inf_preverb)
// 			// primaryVerb=this.state.usageVerbTenses[0]
// 		// } else {
// 			englishPreVerb.push(this.state.postbaseMaster[j].ger_preverb)
// 			if (this.state.postbaseMaster[j].ger_preverb_after == 'inf') { 
// 				primaryVerb=this.state.usageVerbTenses[0]
// 			} else {
// 				primaryVerb=this.state.usageVerbTenses[3]
// 			}
// 		// }						
// 	}
// }
// }
// }
var nextCase='';var previousCase=this.state.primaryVerbIndexCase;var afterObjectText2=[];if(currentPostbases.length===0){primaryVerb=this.state.primaryVerbBase;if(this.state.containsIs){subjectIs=this.getIs(personN,peopleN,capitalize);}}else{currentPostbases.map(function(i,index){// if ('postverb' in this.state.postbaseMaster[i]) {
// } else {
if(index==0){if(_this5.state.postbaseMaster[i].is){subjectIs=_this5.getIs(personN,peopleN,capitalize);}if('postverb'in _this5.state.postbaseMaster[i]){afterObjectText2.push([_this5.state.postbaseMaster[i].description,index]);nextCase=_this5.state.primaryVerbIndexCase;}else{englishPreVerb.push([_this5.state.postbaseMaster[i].gen_preverb,index]);// console.log(this.state.postbaseMaster[i].match_case,this.state.primaryVerbIndexCase)
if(_this5.state.postbaseMaster[i].match_case===true){nextCase=_this5.state.primaryVerbIndexCase;}else{nextCase=_this5.state.postbaseMaster[i].gen_preverb_after;}}}else{if('postverb'in _this5.state.postbaseMaster[i]){afterObjectText2.push([_this5.state.postbaseMaster[i].description,index]);}else{if(nextCase=='g'){englishPreVerb.push([_this5.state.postbaseMaster[i].ger_preverb,index]);nextCase=_this5.state.postbaseMaster[i].ger_preverb_after;}else{englishPreVerb.push([_this5.state.postbaseMaster[i].inf_preverb,index]);nextCase=_this5.state.postbaseMaster[i].inf_preverb_after;}}}console.log(nextCase);if(currentPostbases.length-1==index){if(nextCase=='g'){primaryVerb=_this5.state.usageVerbTenses[3];}else{primaryVerb=_this5.state.usageVerbTenses[0];}}// }
});}// if ('postverb' in this.state.postbaseMaster[currentPostbases[currentPostbases.length-2]])
// else { // two postbases
// 	if (this.state.postbaseMaster[i].is) {
// 		subjectIs = this.getIs(personN, peopleN, capitalize) 
// 	}
// 	englishPreVerb.push(this.state.postbaseMaster[i].gen_preverb)
// 	// console.log(i,j)
// 	if (this.state.postbaseMaster[i].gen_preverb_after == 'ger') { 
// 		// if (this.state.postbaseMaster[j].ger_preverb_after == this.state.postbaseMaster[i].gen_preverb_after) {
// 			// englishPreVerb.push(this.state.postbaseMaster[j].ger_preverb)
// 			// primaryVerb=this.state.usageVerbTenses[3]
// 		// } else {
// 			englishPreVerb.push(this.state.postbaseMaster[j].inf_preverb)
// 			if (this.state.postbaseMaster[j].inf_preverb_after == 'inf') { 
// 				primaryVerb=this.state.usageVerbTenses[0]
// 			} else {
// 				primaryVerb=this.state.usageVerbTenses[3]
// 			}
// 		// }
// 	} else {
// 		// if (this.state.postbaseMaster[j].inf_preverb_after == this.state.postbaseMaster[i].gen_preverb_after) {
// 			// englishPreVerb.push(this.state.postbaseMaster[j].inf_preverb)
// 			// primaryVerb=this.state.usageVerbTenses[0]
// 		// } else {
// 			englishPreVerb.push(this.state.postbaseMaster[j].ger_preverb)
// 			if (this.state.postbaseMaster[j].ger_preverb_after == 'inf') { 
// 				primaryVerb=this.state.usageVerbTenses[0]
// 			} else {
// 				primaryVerb=this.state.usageVerbTenses[3]
// 			}
// 		// }						
// 	}
// }
// currentPostbases.map((i,index)=>{
// 	if (index !== currentPostbases.length-1) {
// 		// console.log(notis.includes(i), value1[1], value1[2])
// 		if (notis.includes(i)) {
// 			if (value1[1] === '3' && value1[2] === '1') {
// 				englishPreVerb.push(this.state.postbaseMaster[i].englishModifier(""))
// 			} else {
// 				englishPreVerb.push(this.state.postbaseMaster[i].englishModifierSecond(""))
// 			}
// 		} else {
// 			englishPreVerb.push(this.state.postbaseMaster[i].englishModifierSecond(""))
// 		}
// 	} else {
// 		englishPreVerb.push(this.state.postbaseMaster[i].englishModifierSecond(""))
// 		if (infinitive.includes(i)) {
// 			this.setState({primaryVerb: this.state.usageVerbTenses[0],});	
// 		}
// 	}
// })
// console.log(englishPreVerb)
// this.getSubjectIs(value1[1],value1[2])
if(verbMood=='Interrogative'){this.setState({questionMark:'?'});}else{this.setState({questionMark:''});}this.setState({primaryVerb:primaryVerb,englishPreVerb:englishPreVerb,afterObjectText2:afterObjectText2,englishPreSubject:englishPreSubject,bePreVerb:bePreVerb,person:parseInt(personN),people:parseInt(peopleN),subjectIs:subjectIs,beforeSubject:beforeSubject,questionWord:questionWord,questionWordEnglish:questionWordEnglish});}// addNounPostbase(e, {value}) {
// 	// console.log(e, value)
// 	let currentPostbases = this.state.currentPostbases
// 	let postbasesAvailable = this.state.postbaseMaster[value].allowable_next_ids
// 	// var remove = postbasesAvailable.indexOf(value)
// 	// postbasesAvailable.splice(remove,1)
// 	// console.log(postbasesAvailable)
// 	let postbaseInformationAvailable = []
// 	postbasesAvailable.map((a)=>{
// 		postbaseInformationAvailable.push({value:a,key:a,text:this.state.postbaseMaster[a].englishModifier("")})
// 	})
// 	currentPostbases.push(value)
// 	this.setState({
// 		currentPostbases: currentPostbases,
// 		postbasesAvailable: postbasesAvailable,
// 		postbaseInformationAvailable: postbaseInformationAvailable,
// 	});
// 	// let fstCall = ''
// 	let owner = ''
// 	let nounvalue1 = this.state.nounvalue1
// 	let nounvalue2 = this.state.nounvalue2
// 	if (nounvalue2[0] !== '0') {
// 		owner = '+'+nounvalue2[0]+peopleDict[nounvalue2[1]]
// 	} else {
// 		owner = ''
// 	}
// 	// if (currentPostbases.includes(17)) {
// 	// 	this.setState({tag: 'INTRANSITIVE VERB'})	
//  //   	fstCall = '>+V+Ind+Prs+' + this.state.value1[1] + peopleDict[this.state.value1[2]]
// 	// } else {
// 	// 	this.setState({tag: 'NOUN'})	
//  //    if (this.state.nounMood === 'Absolutive') {
//  //    	fstCall = '>+N+Abs+' + peopleDict[nounvalue1] + owner
//  //    }
// 	// }
// 	this.setEnglishNoun(currentPostbases,this.state.value1,this.state.value2)
// 	this.getFSTParse(this.state.baseCase,currentPostbases,this.state.tag,this.state.verbMood,null,null,this.state.nounMood,nounvalue1,nounvalue2)
// }
},{key:'addPostbase',value:function addPostbase(e,_ref){var value=_ref.value;// console.log(e, value)
var currentPostbases=this.state.currentPostbases;// let postbasesAvailable = this.state.postbaseMaster[value].allowable_next_ids
// var remove = postbasesAvailable.indexOf(value)
// postbasesAvailable.splice(remove,1)
// console.log(postbasesAvailable)
this.setState({nextCase:value});if(this.state.baseTag=='n'){if(nnpostbases.includes(value)){currentPostbases.push(value);}else{currentPostbases.unshift(value);}}else{currentPostbases.push(value);}// this.setAvailablePostbaseInformation(currentPostbases,this.state.verbMood)
// let postbaseInformationAvailable = []
// let fstCall = this.state.fstCall
// let owner = ''
// let nounvalue1 = this.state.nounvalue1
// let nounvalue2 = this.state.nounvalue2
var tag=this.state.tag;var verbMood=this.state.verbMood;if(this.state.baseTag=='n'){// postbasesAvailable.map((a)=>{
// 	postbaseInformationAvailable.push({value:a,key:a,text:this.state.postbaseMaster[a].englishModifier("")})
// })
// if (nounvalue2[0] !== '0') {
// 	owner = '+'+nounvalue2[0]+peopleDict[nounvalue2[1]]
// } else {
// 	owner = ''
// }
// this.setAvailablePostbaseInformation(postbasesAvailable)
// console.log(currentPostbases,nounToVerb)
// console.log(currentPostbases.filter(value => nounToVerb.includes(value)).)
if(currentPostbases.filter(function(value){return nounToVerb.includes(value);}).length>0){tag='INTRANSITIVE VERB';verbMood='Indicative';// this.getFSTParse(this.state.baseCase,this.state.currentPostbases,'INTRANSITIVE VERB','INDICATIVE',this.state.value1,'',this.state.nounMood,[],[])
}// this.setState({tag: 'INTRANSITIVE VERB'})	
// fstCall = '>+V+Ind+Prs+' + this.state.value1[1] + peopleDict[this.state.value1[2]]
// } else {
// this.setState({tag: 'NOUN'})	
// if (this.state.nounMood === 'Absolutive') {
// fstCall = '>+N+Abs+' + peopleDict[nounvalue1] + owner
// }
// }
this.setAvailablePostbaseInformation(currentPostbases,this.state.nounMood);this.setEnglishNoun(currentPostbases,this.state.value1,this.state.value2,this.state.nounMood);}else{// postbasesAvailable.map((a)=>{
// 	postbaseInformationAvailable.push({value:a,key:a,text:this.state.postbaseMaster[a].englishModifier("")})
// })
this.setAvailablePostbaseInformation(currentPostbases,this.state.verbMood);this.setEnglish(currentPostbases,this.state.value1,this.state.value2,this.state.verbMood,this.state.moodSpecific);}console.log(tag,verbMood);this.getFSTParse(this.state.baseCase,currentPostbases,tag,verbMood,this.state.moodSpecific,this.state.value1,this.state.value2,this.state.nounMood,this.state.nounvalue1,this.state.nounvalue2);var postbase1=-1;var postbase2=-1;if(currentPostbases.length==2){postbase1=currentPostbases[0];postbase2=currentPostbases[1];}else if(currentPostbases.length==1){postbase1=currentPostbases[0];}this.setState({postbase1:postbase1,postbase2:postbase2,currentPostbases:currentPostbases,tag:tag,verbMood:this.state.verbMood// postbasesAvailable: postbasesAvailable,
// postbaseInformationAvailable: postbaseInformationAvailable,
});}},{key:'removePostbase',value:function removePostbase(value,e,data){// console.log(value)
var currentPostbases=this.state.currentPostbases;// var remove = currentPostbases.indexOf(value)
currentPostbases.splice(value,1);// console.log(postbasesAvailable)
// let postbasesAvailable = []
// if (currentPostbases.length == 1) {
// 	postbasesAvailable = this.state.postbaseMaster[currentPostbases[0]].allowable_next_ids
// } else {
// 	if (this.state.verbMood == 'Participial') {
// 		postbasesAvailable = verbPostbaseParticipialDefault
// 	} else {
// 		postbasesAvailable = this.state.allPostbasesAvailable
// 	}
// }
// let postbaseInformationAvailable = []
// postbasesAvailable.map((a)=>{
// 	postbaseInformationAvailable.push({value:a,key:a,text:this.state.postbaseMaster[a].description})
// })
this.setAvailablePostbaseInformation(currentPostbases,this.state.verbMood);var postbase1=-1;var postbase2=-1;if(currentPostbases.length==2){postbase1=currentPostbases[0];postbase2=currentPostbases[1];}else if(currentPostbases.length==1){postbase1=currentPostbases[0];}this.setState({postbase1:postbase1,postbase2:postbase2,currentPostbases:currentPostbases// postbasesAvailable: postbasesAvailable,
// postbaseInformationAvailable: postbaseInformationAvailable,
});var tag=this.state.tag;var verbMood=this.state.verbMood;// let fstCall = this.state.fstCall
var owner='';var nounvalue1=this.state.nounvalue1;var nounvalue2=this.state.nounvalue2;if(this.state.baseTag=='n'){// postbasesAvailable.map((a)=>{
// 	postbaseInformationAvailable.push({value:a,key:a,text:this.state.postbaseMaster[a].englishModifier("")})
// })
// if (nounvalue2[0] !== '0') {
// 	owner = '+'+nounvalue2[0]+peopleDict[nounvalue2[1]]
// } else {
// 	owner = ''
// }
// if (currentPostbases.includes(17)) {
// 	this.setState({tag: 'INTRANSITIVE VERB'})	
//   	fstCall = '>+V+Ind+Prs+' + this.state.value1[1] + peopleDict[this.state.value1[2]]
// } else {
// 	this.setState({tag: 'NOUN'})	
//    if (this.state.nounMood === 'Absolutive') {
//    	fstCall = '>+N+Abs+' + peopleDict[nounvalue1] + owner
//    }
// }
// console.log(currentPostbases)
// console.log(currentPostbases.filter(value => nounToVerb.includes(value)))
if(currentPostbases.filter(function(value){return nounToVerb.includes(value);}).length>0){tag='INTRANSITIVE VERB';verbMood='Indicative';// this.getFSTParse(this.state.baseCase,this.state.currentPostbases,'INTRANSITIVE VERB','INDICATIVE',this.state.value1,'',this.state.nounMood,[],[])
}else{tag='n';}this.setState({tag:tag});console.log(tag);this.setAvailablePostbaseInformation(currentPostbases,this.state.nounMood);this.setEnglishNoun(currentPostbases,this.state.value1,this.state.value2,this.state.nounMood);}else{// postbasesAvailable.map((a)=>{
// 	postbaseInformationAvailable.push({value:a,key:a,text:this.state.postbaseMaster[a].englishModifierSecond("")})
// })
this.setAvailablePostbaseInformation(currentPostbases,this.state.verbMood);this.setEnglish(currentPostbases,this.state.value1,this.state.value2,this.state.verbMood,this.state.moodSpecific);}this.getFSTParse(this.state.baseCase,currentPostbases,tag,this.state.verbMood,this.state.moodSpecific,this.state.value1,this.state.value2,this.state.nounMood,this.state.nounvalue1,this.state.nounvalue2);}},{key:'setAvailablePostbaseInformation',value:function setAvailablePostbaseInformation(currentPostbases,mood){var _this6=this;// let availablePostbaseInformationText = []
var postbaseInformationAvailable1=[];// let postbaseInformationAvailable2 = []
// // if (this.state.currentPostbases.length == 0 && this.state.verbMood == 'Participial') {
// // 	postbasesAvailable = verbPostbaseParticipialDefault
// // }
// console.log(currentPostbases)
// let postbasesAvailable = []
// if (currentPostbases.length == 0) {
// 	if (mood == 'Participial') {
// 		postbasesAvailable = verbPostbaseParticipialDefault
// 	} else if (this.state.baseTag == 'n' && mood !== 'Absolutive') {
// 		postbasesAvailable = nnpostbases
// 	} else {
var postbasesAvailable=this.state.allPostbasesAvailable;// 	}
// } else {
// 	if (this.state.baseTag == 'n' && mood !== 'Absolutive') {
// 	} else {
// 		postbasesAvailable = this.state.postbaseMaster[currentPostbases[0]].allowable_next_ids
// 	}
// }
// console.log(mood)
// let hasFuture = false
// if (mood !== 'Indicative' && mood !== 'Participial' && mood !== 'Interrogative') {
// 	if (this.state.currentPostbases.length == 0) {
// 		postbasesAvailable.map((a)=>{
// 			postbaseInformationAvailable1.push({value:a,key:a,text:this.state.postbaseMaster[a].description})
// 			availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifier(""))
// 		})
// 	} else if (this.state.currentPostbases.length == 1) {
// 		// console.log('hi',postbasesAvailable)
// 		postbaseInformationAvailable1 = this.state.postbaseInformationAvailable1
// 		postbasesAvailable.map((a)=>{
// 			postbaseInformationAvailable2.push({value:a,key:a,text:this.state.postbaseMaster[a].description})
// 			availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifier(""))
// 		})		
// 	}
// } else {
// 	if (mood == 'Participial') {
// 		postbasesAvailable.map((a)=>{
// 			postbaseInformationAvailable1.push({value:a,key:a,text:this.state.postbaseMaster[a].englishModifierPast("")})
// 			availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifierPast(""))
// 		})
// 	} else if (mood == 'Interrogative') {
// 		postbasesAvailable.map((a)=>{
// 			postbaseInformationAvailable1.push({value:a,key:a,text:this.state.postbaseMaster[a].englishModifierInfinitive("")})
// 			availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifierInfinitive(""))
// 		})
// 	} else {
if(currentPostbases.length==0){Object.keys(postbasesAvailable).map(function(a){postbaseInformationAvailable1.push({value:a,key:a,text:_this6.state.postbaseMaster[a].description});// availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifier(""))
});}else if(currentPostbases.length==1){// console.log(this.state.postbaseMaster[currentPostbases[0]].gen_preverb_after)
// console.log(this.state.postbaseMaster[currentPostbases[0]])
if(this.state.postbaseMaster[currentPostbases[0]].match_case){Object.keys(postbasesAvailable).map(function(a){postbaseInformationAvailable1.push({value:a,key:a,text:_this6.state.postbaseMaster[a].description});// availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifierInfinitive(""))
});}else{if(this.state.postbaseMaster[currentPostbases[0]].gen_preverb_after=='g'){Object.keys(postbasesAvailable).map(function(a){postbaseInformationAvailable1.push({value:a,key:a,text:'postverb'in _this6.state.postbaseMaster[a]?_this6.state.postbaseMaster[a].description:_this6.state.postbaseMaster[a].ger_preverb});// availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifierInfinitive(""))
});}else{Object.keys(postbasesAvailable).map(function(a){postbaseInformationAvailable1.push({value:a,key:a,text:'postverb'in _this6.state.postbaseMaster[a]?_this6.state.postbaseMaster[a].description:_this6.state.postbaseMaster[a].inf_preverb});// availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifierGerund(""))
});}}}else{var k=this.state.postbaseMaster[currentPostbases[currentPostbases.length-2]].ger_preverb_after;console.log(k);if(k=='g'){if(this.state.postbaseMaster[currentPostbases[currentPostbases.length-1]].ger_preverb_after=='g'){Object.keys(postbasesAvailable).map(function(a){postbaseInformationAvailable1.push({value:a,key:a,text:'postverb'in _this6.state.postbaseMaster[a]?_this6.state.postbaseMaster[a].description:_this6.state.postbaseMaster[a].ger_preverb});// availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifierInfinitive(""))
});}else{Object.keys(postbasesAvailable).map(function(a){postbaseInformationAvailable1.push({value:a,key:a,text:'postverb'in _this6.state.postbaseMaster[a]?_this6.state.postbaseMaster[a].description:_this6.state.postbaseMaster[a].inf_preverb});// availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifierGerund(""))
});}}else{if(this.state.postbaseMaster[currentPostbases[currentPostbases.length-1]].inf_preverb_after=='g'){Object.keys(postbasesAvailable).map(function(a){postbaseInformationAvailable1.push({value:a,key:a,text:'postverb'in _this6.state.postbaseMaster[a]?_this6.state.postbaseMaster[a].description:_this6.state.postbaseMaster[a].ger_preverb});// availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifierInfinitive(""))
});}else{Object.keys(postbasesAvailable).map(function(a){postbaseInformationAvailable1.push({value:a,key:a,text:'postverb'in _this6.state.postbaseMaster[a]?_this6.state.postbaseMaster[a].description:_this6.state.postbaseMaster[a].inf_preverb});// availablePostbaseInformationText.push(this.state.postbaseMaster[a].englishModifierGerund(""))
});}}}// postbaseInformationAvailable1 = this.state.postbaseInformationAvailable1
// if (future.includes(this.state.currentPostbases[0])) {
// hasFuture = true
// }
// console.log('wadup')
// 	}
// }
// postbasesAvailable.map((a)=>{
// 	postbaseInformationAvailable.push({value:a,key:a,text:this.state.postbaseMaster[a].englishModifier("")})
// })		
this.setState({// currentPostbases: currentPostbases,
// postbasesAvailable: postbasesAvailable,
// hasFuture: hasFuture,
postbaseInformationAvailable1:postbaseInformationAvailable1// postbaseInformationAvailable2: postbaseInformationAvailable2,
// availablePostbaseInformationText: availablePostbaseInformationText,
});}},{key:'changeVerbEnding',value:function changeVerbEnding(reset,e,data){console.log(data.value);// let mood = 'Interrogative'
// let moodSpecific = data.value
this.setState({endingNumber:data.value});if(reset){this.changeEnding('Indicative','','');}else{if(data.value===0){this.changeEnding('Participial','','');}else{this.changeEnding('Interrogative',data.value,'');}}}},{key:'changeNounEnding',value:function changeNounEnding(reset,e,data){console.log(data.value);// let mood = 'Interrogative'
// let moodSpecific = data.value
this.setState({endingNumber:data.value});if(reset){this.changeEnding('','','Absolutive');}else{this.changeEnding('','',getNounInfo[data.value]['text']);}}},{key:'changeEnding',value:function changeEnding(verbMood,moodSpecific,nounMood){console.log();var postbasesAvailable=[];if(this.state.tag==='n'){// if (mood === this.state.nounMood) {	
// 	mood = 'Absolutive'
// 	moodSpecific = ''
// 	// nounMood = 
// }
this.setAvailablePostbaseInformation(this.state.currentPostbases,nounMood);this.setEnglishNoun(this.state.currentPostbases,this.state.value1,this.state.value2,nounMood);this.setState({nounMood:nounMood});this.setState({moodSpecific:moodSpecific});}else{if(verbMood===this.state.verbMood&&moodSpecific===this.state.moodSpecific){// verbMood = 'Indicative'
verbMood='Indicative';moodSpecific='';}// if (this.state.currentPostbases.length === 0) {
// 	if (mood == 'Participial') {
// 		this.setAvailablePostbaseInformation(verbPostbaseParticipialDefault,mood)
// 	} else {
// 		this.setAvailablePostbaseInformation(verbPostbaseDefault,mood)
// 	}
// }
this.setAvailablePostbaseInformation(this.state.currentPostbases,verbMood);this.setEnglish(this.state.currentPostbases,this.state.value1,this.state.value2,verbMood,moodSpecific);this.setState({verbMood:verbMood});this.setState({moodSpecific:moodSpecific});}this.getFSTParse(this.state.baseCase,this.state.currentPostbases,this.state.tag,verbMood,moodSpecific,this.state.value1,this.state.value2,nounMood,this.state.nounvalue1,this.state.nounvalue2);// if (this.state.currentPostbases.length == 0) {
// 	this.setAvailablePostbaseInformation(this.state.allPostbasesAvailable)
// 	// if (verbMood == 'Participial') {
// 	// 	this.setAvailablePostbaseInformation(verbPostbaseParticipialDefault)
// 	// } else if (verbMood == 'Indicative') {
// 	// }
// }
}},{key:'changeActiveUsageKey',value:function changeActiveUsageKey(entry,data){console.log(data);var num=data.value;// console.log(data.options)
this.setState({// value1: data.value,
activeKeyInEditIndex:data.value// baseCase: data.options[data.value].text,
});this.getFSTParse(this.state.baseCase,this.state.currentPostbases,this.state.tag,this.state.verbMood,this.state.moodSpecific,this.state.value1,this.state.value2,this.state.nounMood,this.state.nounvalue1,this.state.nounvalue2);}},{key:'changeActiveDefinitionKey',value:function changeActiveDefinitionKey(entry,data){console.log(data);var num=data.value;// console.log(data.options)
this.setState({// value1: data.value,
activeDefinitionInEditIndex:data.value// baseCase: data.options[data.value].text,
});console.log(this.state.usageDefinition[data.value][0]);var sentence=this.state.usageDefinition[data.value][0];var matches=sentence.match(/\⟨.*?\⟩/g);if(matches!==null){matches.map(function(m){return sentence=sentence.replace(m,m.slice(1,-1));});}console.log(sentence);this.setState({pluralizedDefinition:sentence});// console.log(this.state.usageDefinition[data.value][])
// this.getFSTParse(this.state.baseCase,this.state.currentPostbases,this.state.tag,this.state.verbMood,this.state.moodSpecific,this.state.value1,this.state.value2,this.state.nounMood,this.state.nounvalue1,this.state.nounvalue2)
}},{key:'getFSTParse',value:function getFSTParse(baseCase,currentPostbases,tag,verbMood,moodSpecific,value1,value2,nounMood,nounvalue1,nounvalue2){var _this7=this;console.log(baseCase,currentPostbases,tag,verbMood,value1,value2,nounMood,nounvalue1,nounvalue2);console.log(nounMood,tag,value1,value2);var fstCall='';var owner='';if(tag=='n'){if(nounvalue2[0]!=='0'){owner=nounvalue2[0]+peopleDict[nounvalue2[1]]+'Poss';}else{owner='Unpd';}if(nounMood=='Absolutive'){if(owner!=='Unpd'){fstCall='[N][Abs]['+owner+']['+peopleDict[nounvalue1]+'Posd]';}else{fstCall='[N][Abs]['+peopleDict[nounvalue1]+owner+']';}}else if(nounMood=='Localis'){fstCall='>+N+Loc+'+peopleDict[nounvalue1]+owner;}else if(nounMood=='Terminalis'){fstCall='>+N+Trm+'+peopleDict[nounvalue1]+owner;}else if(nounMood=='Ablative'){fstCall='>+N+Abl+'+peopleDict[nounvalue1]+owner;}else if(nounMood=='Similaris'){fstCall='>+N+Sim+'+peopleDict[nounvalue1]+owner;}else if(nounMood=='Relative'){fstCall='>+N+Rel+'+peopleDict[nounvalue1]+owner;}else if(nounMood=='Modalis'){fstCall='>+N+Mod+'+peopleDict[nounvalue1]+owner;}}else{if(verbMood=='Indicative'){if(tag=='i'){fstCall='[V][Ind][Intr][S_'+value1[1]+peopleDict[value1[2]]+']';}else{fstCall='[V][Ind][Trns][A_'+value1[1]+peopleDict[value1[2]]+'][P_'+value2[1]+peopleDict[value2[2]]+']';}}else if(verbMood=='Participial'){if(tag=='i'){fstCall='>+V+Ind+Pst+'+value1[1]+peopleDict[value1[2]];}else{fstCall='>+V+Ind+Pst+'+value1[1]+peopleDict[value1[2]]+'+'+value2[1]+peopleDict[value2[2]]+'O';}}else if(verbMood=='Interrogative'){if(tag=='i'){fstCall='>+V+Int+'+value1[1]+peopleDict[value1[2]];}else{fstCall='>+V+Int+'+value1[1]+peopleDict[value1[2]]+'+'+value2[1]+peopleDict[value2[2]]+'O';}}}var underlyingCall=[];var postfstCall=[];var postfstCallString='';if(currentPostbases.length>0){currentPostbases.map(function(i){postfstCall.push(_this7.state.postbaseMaster[i].exp);});postfstCall=postfstCall.reverse();postfstCallString='-'+postfstCall.join('-');}// fstCall = postfstCall+fstCall
// console.log(underlyingCall,postfstCall)
underlyingCall=underlyingCall.concat(postfstCall);underlyingCall.push(fstCall.slice(1));var FSTsearch=baseCase[this.state.activeKeyInEditIndex]+postfstCallString+'-'+fstCall;// console.log(baseCase,postfstCallString,fstCall)
// console.log(FSTsearch)
// console.log(underlyingCall)
console.log(postfstCall);console.log(fstCall);// console.log(FSTsearch,activeEditIndex)
var underlyingCallReturn=[];postfstCall.map(function(j){underlyingCallReturn.push([j.replace('[V→V]','-')]);});// console.log(ending_underlying[fstCall])
underlyingCallReturn.push(__WEBPACK_IMPORTED_MODULE_6__constants_ending_underlying_js__["a" /* ending_underlying */][fstCall]);// console.log(underlyingCallReturn)
this.setState({underlyingCallReturn:underlyingCallReturn});console.log(FSTsearch);__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/segment/"+encodeURIComponent(FSTsearch)).then(function(response){console.log(response.data);// var slicedColors = this.state.colorsList
// slicedColors=slicedColors.slice(0,this.state.currentPostbases.length)
var words=[];response.data.words.map(function(k,ind){words.push(k.replace("u>a","ua"));// words.push(k)
});_this7.setState({// englishColorList: slicedColors,
// inupiaqColorList: ['#000000'].concat(slicedColors.slice(0).reverse()).concat(['#852828']),
entryModified:words});// if (response.data.chld !== []) {}
// console.log(response.data.etymology)
// if (response.data.etymology !== []) {
// 	this.setState({etymology: response.data.etymology[0]})
// }
});}},{key:'render',value:function render(){var _this8=this;console.log(this.state);// console.log(this.state.colorsList)
var verbQuestionWords=[{value:0,key:0,text:'past tense',disabled:this.state.hasFuture},{value:1,key:1,text:'question: yes or no?'},{value:2,key:2,text:'question: why?'},{value:3,key:3,text:'question: how?'},{value:4,key:4,text:'question: where at?'},{value:5,key:5,text:'question: to where?'},{value:6,key:6,text:'question: from where?'}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */],{textAlign:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Row,{style:{height:40,paddingBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Column,{style:{maxWidth:800,padding:10},textAlign:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',textDecoration:'underline'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1,justifyContent:'flex-start'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'/'}},'Back to Search')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1,display:'flex',justifyContent:'flex-end',paddingLeft:5,textDecoration:'underline'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'/'+this.state.entryUrl}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'See Dictionary Entry: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'500'}},this.state.entryUrl)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span2'},'Word Builder')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["e" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.usageEntry(this.state.activeKeyInEditIndex,this.state.tag))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'30px',paddingRight:'30px',paddingLeft:'30px'}},this.state.englishPreSubject.map(function(q,qindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',paddingBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{fluid:true,style:{display:'flex',maxWidth:'350px',justifyContent:'space-between',paddingLeft:'14px',paddingRight:'3px',color:_this8.state.colorsList[_this8.state.currentPostbases[qindex]],border:'1px solid '+_this8.state.colorsList[_this8.state.currentPostbases[qindex]],backgroundColor:'white'},onClick:_this8.removePostbase.bind(_this8,qindex)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,q),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'delete'})));}),this.state.englishPreNoun.map(function(q,qindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',paddingBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{fluid:true,style:{display:'flex',maxWidth:'350px',justifyContent:'space-between',paddingLeft:'14px',paddingRight:'3px',color:_this8.state.colorsList[_this8.state.currentPostbases[qindex]],border:'1px solid '+_this8.state.colorsList[_this8.state.currentPostbases[qindex]],backgroundColor:'white'},onClick:_this8.removePostbase.bind(_this8,qindex)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,q),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'delete'})));}),this.state.englishPreVerb.map(function(q,qindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',paddingBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{fluid:true,style:{display:'flex',maxWidth:'350px',justifyContent:'space-between',paddingLeft:'14px',paddingRight:'3px',color:_this8.state.colorsList[_this8.state.currentPostbases[q[1]]],border:'1px solid '+_this8.state.colorsList[_this8.state.currentPostbases[q[1]]],backgroundColor:'white'},onClick:_this8.removePostbase.bind(_this8,q[1])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,q[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'delete'})));}),this.state.afterObjectText2.map(function(q,qindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',paddingBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{fluid:true,style:{display:'flex',maxWidth:'350px',justifyContent:'space-between',paddingLeft:'14px',paddingRight:'3px',color:_this8.state.colorsList[_this8.state.currentPostbases[q[1]]],border:'1px solid '+_this8.state.colorsList[_this8.state.currentPostbases[q[1]]],backgroundColor:'white'},onClick:_this8.removePostbase.bind(_this8,q[1])},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,q[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'delete'})));}),this.state.nounMood!=='Absolutive'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',paddingBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{fluid:true,style:{display:'flex',maxWidth:'350px',justifyContent:'space-between',paddingLeft:'14px',paddingRight:'3px',color:'#852828',backgroundColor:'white',border:'1px solid #852828'},onClick:this.changeNounEnding.bind(this,true)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,getNounInfo[this.state.endingNumber]['buttontext']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'delete'}))):null,this.state.verbMood=='Participial'||this.state.verbMood=='Interrogative'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',paddingBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{fluid:true,style:{display:'flex',maxWidth:'350px',justifyContent:'space-between',paddingLeft:'14px',paddingRight:'3px',color:'#852828',backgroundColor:'white',border:'1px solid #852828'},onClick:this.changeVerbEnding.bind(this,true)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,getVerbInfo[this.state.endingNumber]['text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'delete'}))):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'15px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',paddingRight:'30px',paddingLeft:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{style:{maxWidth:'350px'},fluid:true,search:true,selection:true,text:'Add a Postbase',selectOnBlur:false,options:this.state.postbaseInformationAvailable1,onChange:this.addPostbase.bind(this)})),this.state.baseTag!='n'&&this.state.verbMood=='Participial'&&this.state.verbMood!='Interrogative'&&this.state.currentPostbases.length<2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',paddingTop:'15px',paddingRight:'30px',paddingLeft:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{style:{maxWidth:'350px'},fluid:true,search:true,selection:true,selectOnBlur:false,text:'Change Ending',value:this.state.ending1,options:verbQuestionWords,onChange:this.changeVerbEnding.bind(this,false)})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'30px'}}),Object.keys(this.state.sisters).length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span2'},'Related Entries')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{style:{marginTop:0},divided:true,selection:true},Object.keys(this.state.sisters).map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{key:i,onClick:function onClick(){return _this8.switchToSister(i);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'3px',color:'#B1B1B1'},size:'large',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,{style:{paddingRight:'16px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Header,{style:{fontSize:'19px',paddingBottom:'4px',paddingLeft:'15px',fontFamily:customFontFam,lineHeight:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{'paddingRight':'3px',fontWeight:'400'}},_this8.processStyledText(_this8.state.sisters[i][2]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{'marginLeft':'15px',marginRight:'6px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SearchPageHelpers_js__["a" /* TagColors */],{key:_this8.state.sisters[i][0],word:_this8.state.sisters[i][0]}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Description,{style:{fontSize:'16px',color:'#000000cc',paddingLeft:'15px',fontWeight:'400',lineHeight:'23px',paddingTop:'4px'}},_this8.processStyledText2(_this8.state.sisters[i][3]))));}))):null)))));}}]);return WordBuilder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (WordBuilder);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_ending_underlying_js__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_google_palette__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_google_palette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_google_palette__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Recorder_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shuffle_array__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shuffle_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shuffle_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fuzzysort__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fuzzysort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_fuzzysort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_performance_now__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_performance_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_performance_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SentenceTemplates_js__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SentenceGlossary_js__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants_sentence_templates_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_reactjs_popup__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_reactjs_popup_dist_index_css__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_reactjs_popup_dist_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_reactjs_popup_dist_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_ga4__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { TagColors } from './SentenceBulderHelpe.js';
// import ReactGA from 'react-ga';
// import SentenceTemplates from './SentenceTemplates.js'
__WEBPACK_IMPORTED_MODULE_18_react_ga4___default.a.initialize("G-WDEJDCK7QT");var customFontFam="Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif";var YUGTUNDOTCOM_URL="https://www.yugtun.com/";var popularVPostbases=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["M" /* popularVPostbasesPAST */].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["K" /* popularVPostbasesFUTURE */],__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["L" /* popularVPostbasesNOTIME */]);var popularVPostbasesOnlyPast=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["M" /* popularVPostbasesPAST */].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["L" /* popularVPostbasesNOTIME */]);var popularVPostbasesOnlyFuture=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["K" /* popularVPostbasesFUTURE */].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["L" /* popularVPostbasesNOTIME */]);var popularVPostbasesNoTime=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["L" /* popularVPostbasesNOTIME */];var popularNouns=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["E" /* popularNounsBeings */].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["H" /* popularNounsThings */]);var tensesSentenceTemplates=['llru','ciq','ksail'];var requirePostbasesDictionary={'Intrg4':[{'fst':[['-llru¹-',0,-1,0]],'english':'past tense (-llru-)'}],'Intrg5':[{'fst':[['+ciqe-|@ciiqe-',0,-1,0]],'english':'future V (+ciqe-)'},{'fst':[['-qatar-',0,-1,0]],'english':'about to V (-qatar-)'}],'CtmpI':[{'fst':[['-llru¹-',0,-1,0]],'english':'past tense (-llru-)'}],'CtmpII':[{'fst':[['-llru¹-',0,-1,0]],'english':'past tense (-llru-)'}],'Cont':[{'fst':[['@~-yuite-',0,-1,0]],'english':'never Vs (@~-yuite-)'},{'fst':[['~+lar-,@~+lar-,-lar-',0,-1,0]],'english':'often Vs (-lar-)'}]};var pastTensePostbases=['-llru¹-'];var futureTensePostbases=['+ciqe-|@ciiqe-','-qatar-'];var vOptions=['vBase','nsBases','noBases','no','ns','vMood','vs','vo','nObliques','qWord','vType'];var nOptions=['n','nBases','nCase','nType'];var vEnglish=['mvEnglish1','mvEnglish2','mvEnglish3','mvEnglish3in2','mvEnglishAbl','mvEnglishQaa','mvnsEnglish1','mvnsEnglish2','mvnoEnglish1','mvnoEnglish2','cvnsEnglish1','cvnsEnglish2','cvnoEnglish1','cvnoEnglish2','svnoEnglish1','svnoEnglish2','cvEnglish1','cvEnglish2','cvEnglish3','cvEnglish3in2','cvEnglishAbl','svEnglish1','svEnglish2','svEnglishAbl','npnEnglish1','npnEnglish2','mvnObliquesEnglish1','mvnObliquesEnglish2','cvnObliquesEnglish1','cvnObliquesEnglish2','svnObliquesEnglish1','svnObliquesEnglish2'];// let retrieveMoodEnglish = {
// 	'Prec':'before'
// }
var dictionary=[];var usageDictionary=[];var dictionary_dict={};var SentenceBuilder=function(_Component){_inherits(SentenceBuilder,_Component);function SentenceBuilder(props){_classCallCheck(this,SentenceBuilder);// console.log(this.props)
var _this=_possibleConstructorReturn(this,(SentenceBuilder.__proto__||Object.getPrototypeOf(SentenceBuilder)).call(this,props));_this.updateDimensions=function(){// console.log('updated')
_this.setState({width:window.innerWidth,height:window.innerHeight});};_this.update4thPersonAndAgreement=function(){var mvSubjectOptions1=[];var mvObjectOptions1=[];var cvSubjectOptions1=[];var cvObjectOptions1=[];var nounOptionsSVPossessors1=[];var nounOptionsCVPossessors1=[];var nounOptionsMVPossessors1=[];var nounOptionsCVAblPossessors1=[];var nounOptionsMVAblPossessors1=[];var nounOptionsSVAblPossessors1=[];if(_this.state.mvvs.length>0){// console.log(this.state.mvvs.join(""))
var mvvalueSub=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["j" /* mvSubject4thPersonCalls */][_this.state.mvvs.join("")];var mvvalueObj=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["c" /* mvObject4thPersonCalls */][_this.state.mvvs.join("")];var npossvalue=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["p" /* nObject4thPersonCalls */][_this.state.mvvs.join("")];var subjDontAllow=[];var objDontAllow=[];if(_this.state.cvvo.length>0){if(_this.state.cvvs[0]==1&&_this.state.cvvo[0]==4||_this.state.cvvs[0]==4&&_this.state.cvvo[0]==1){subjDontAllow=subjDontAllow.concat([0,6,10]);// mvSubjectOptions.map((k)=>{
//   if (![0,6,10].includes(k['id'])) {
//     mvSubjectOptions1 = mvSubjectOptions1.concat(k)
//   }
// })
}else if(_this.state.cvvs[0]==2&&_this.state.cvvo[0]==4||_this.state.cvvs[0]==4&&_this.state.cvvo[0]==2){subjDontAllow=subjDontAllow.concat([1,7,11]);// mvSubjectOptions.map((k)=>{
// if (![1,7,11].includes(k['id'])) {
// mvSubjectOptions1 = mvSubjectOptions1.concat(k)
// }
// })
}}if(_this.state.mvvo.length>0){if(_this.state.mvvMood=='Intrg'){if(_this.state.mvvType=='Intrg1'||_this.state.mvvType==='Intrg3'){subjDontAllow=subjDontAllow.concat([6,10]);}else{subjDontAllow=subjDontAllow.concat([0,6,10]);}}if(_this.state.mvvs[0]==1){objDontAllow=objDontAllow.concat([0,6,10]);// mvObjectOptions.map((k)=>{
// if (![0,6,10].includes(k['id'])) {
// mvObjectOptions1 = mvObjectOptions1.concat(k)
// }
// })
}else if(_this.state.mvvs[0]==2){objDontAllow=objDontAllow.concat([1,7,11]);// mvObjectOptions.map((k)=>{
//   if (![1,7,11].includes(k['id'])) {
//     mvObjectOptions1 = mvObjectOptions1.concat(k)
//   }
// })
}if(_this.state.mvvo[0]==1){subjDontAllow=subjDontAllow.concat([0,6,10]);// mvSubjectOptions.map((k)=>{
//   if (![0,6,10].includes(k['id'])) {
//     mvSubjectOptions1 = mvSubjectOptions1.concat(k)
//   }
// })
}else if(_this.state.mvvo[0]==2){subjDontAllow=subjDontAllow.concat([1,7,11]);// mvSubjectOptions.map((k)=>{
//   if (![1,7,11].includes(k['id'])) {
//     mvSubjectOptions1 = mvSubjectOptions1.concat(k)
//   }
// })
}__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["d" /* mvObjectOptions */].map(function(k){if(!objDontAllow.includes(k['id'])){mvObjectOptions1=mvObjectOptions1.concat(k);}});}if(_this.state.mvvMood=='Sbrd'){subjDontAllow=subjDontAllow.concat([0,2,3,4,6,8,10,12]);}__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["k" /* mvSubjectOptions */].map(function(k){if(!subjDontAllow.includes(k['id'])){mvSubjectOptions1=mvSubjectOptions1.concat(k);}});if(_this.state.cvvo.length>0){if(_this.state.cvvs[0]==1){__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["d" /* mvObjectOptions */].map(function(k){if(![0,6,10].includes(k['id'])){cvObjectOptions1=cvObjectOptions1.concat(k);}});}else if(_this.state.cvvs[0]==2){__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["d" /* mvObjectOptions */].map(function(k){if(![1,7,11].includes(k['id'])){cvObjectOptions1=cvObjectOptions1.concat(k);}});}else{cvObjectOptions1=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["d" /* mvObjectOptions */];}if(_this.state.cvvo[0]==1){__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["k" /* mvSubjectOptions */].map(function(k){if(![0,6,10].includes(k['id'])){cvSubjectOptions1=cvSubjectOptions1.concat(k);}});}else if(_this.state.cvvo[0]==2){__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["k" /* mvSubjectOptions */].map(function(k){if(![1,7,11].includes(k['id'])){cvSubjectOptions1=cvSubjectOptions1.concat(k);}});}else{cvSubjectOptions1=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["k" /* mvSubjectOptions */];}}else{cvSubjectOptions1=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["k" /* mvSubjectOptions */];}if(_this.state.mvvs[0]==3&&_this.state.mvvs[1]==1){if(_this.state.cvvs[0]!==4&&_this.state.svvs[0]!==4){cvObjectOptions1=[{id:5,value:'410',text:mvvalueObj+' (subject)'}].concat(cvObjectOptions1);}if(_this.state.cvvo[0]!==4){cvSubjectOptions1=[{id:5,value:'410',text:mvvalueSub+' (subject)'}].concat(cvSubjectOptions1);}nounOptionsMVPossessors1=[{id:6,value:'410',text:npossvalue+" (subject)"}].concat(_this.state.nounOptionsMVPossessors);nounOptionsMVAblPossessors1=[{id:6,value:'410',text:npossvalue+" (subject)"}].concat(_this.state.nounOptionsMVAblPossessors);}else if(_this.state.mvvs[0]==3&&_this.state.mvvs[1]==2){cvSubjectOptions1=[{id:9,value:'420',text:mvvalueSub+' (subjects)'}].concat(cvSubjectOptions1);cvObjectOptions1=[{id:9,value:'420',text:mvvalueObj+' (subjects)'}].concat(cvObjectOptions1);nounOptionsMVPossessors1=[{id:10,value:'420',text:npossvalue+" (subject)"}].concat(_this.state.nounOptionsMVPossessors);nounOptionsMVAblPossessors1=[{id:10,value:'420',text:npossvalue+" (subject)"}].concat(_this.state.nounOptionsMVAblPossessors);}else if(_this.state.mvvs[0]==3&&_this.state.mvvs[1]==3){cvSubjectOptions1=[{id:13,value:'430',text:mvvalueSub+' (subjects)'}].concat(cvSubjectOptions1);cvObjectOptions1=[{id:13,value:'430',text:mvvalueObj+' (subjects)'}].concat(cvObjectOptions1);nounOptionsMVPossessors1=[{id:14,value:'430',text:npossvalue+" (subject)"}].concat(_this.state.nounOptionsMVPossessors);nounOptionsMVAblPossessors1=[{id:14,value:'430',text:npossvalue+" (subject)"}].concat(_this.state.nounOptionsMVAblPossessors);}else{// cvSubjectOptions1 = mvSubjectOptions
// cvObjectOptions1 = mvObjectOptions
nounOptionsMVPossessors1=_this.state.nounOptionsMVPossessors;nounOptionsMVAblPossessors1=_this.state.nounOptionsMVAblPossessors;}_this.setState({mvSubjectOptions1:mvSubjectOptions1,mvObjectOptions1:mvObjectOptions1,cvSubjectOptions1:cvSubjectOptions1,cvObjectOptions1:cvObjectOptions1,nounOptionsMVPossessors1:nounOptionsMVPossessors1,nounOptionsMVAblPossessors1:nounOptionsMVAblPossessors1});}if(_this.state.cvvs.length>0){var _npossvalue=void 0;if(_this.state.cvvs[0]==4){_npossvalue=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["p" /* nObject4thPersonCalls */][_this.state.mvvs.join("")];}else{_npossvalue=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["p" /* nObject4thPersonCalls */][_this.state.cvvs.join("")];}if((_this.state.cvvs[0]==3||_this.state.cvvs[0]==4)&&_this.state.cvvs[1]==1){nounOptionsCVPossessors1=[{id:6,value:'411',text:_npossvalue+" (subject)"}].concat(_this.state.nounOptionsCVPossessors);nounOptionsCVAblPossessors1=[{id:6,value:'411',text:_npossvalue+" (subject)"}].concat(_this.state.nounOptionsCVAblPossessors);}else if((_this.state.cvvs[0]==3||_this.state.cvvs[0]==4)&&_this.state.cvvs[1]==2){nounOptionsCVPossessors1=[{id:10,value:'421',text:_npossvalue+" (subject)"}].concat(_this.state.nounOptionsCVPossessors);nounOptionsCVAblPossessors1=[{id:10,value:'421',text:_npossvalue+" (subject)"}].concat(_this.state.nounOptionsCVAblPossessors);}else if((_this.state.cvvs[0]==3||_this.state.cvvs[0]==4)&&_this.state.cvvs[1]==3){nounOptionsCVPossessors1=[{id:14,value:'431',text:_npossvalue+" (subject)"}].concat(_this.state.nounOptionsCVPossessors);nounOptionsCVAblPossessors1=[{id:14,value:'431',text:_npossvalue+" (subject)"}].concat(_this.state.nounOptionsCVAblPossessors);}else{nounOptionsCVPossessors1=_this.state.nounOptionsCVPossessors;nounOptionsCVAblPossessors1=_this.state.nounOptionsCVAblPossessors;}_this.setState({nounOptionsCVPossessors1:nounOptionsCVPossessors1,nounOptionsCVAblPossessors1:nounOptionsCVAblPossessors1});}if(_this.state.svvo.length>0){var svvalueSub=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["j" /* mvSubject4thPersonCalls */][_this.state.mvvs.join("")];var svvalueObj=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["c" /* mvObject4thPersonCalls */][_this.state.mvvs.join("")];var _npossvalue2=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["p" /* nObject4thPersonCalls */][_this.state.mvvs.join("")];if(_this.state.mvvs[0]==3&&_this.state.mvvs[1]==1){nounOptionsSVPossessors1=[{id:6,value:'410',text:_npossvalue2+" (subject)"}].concat(_this.state.nounOptionsSVPossessors);nounOptionsSVAblPossessors1=[{id:6,value:'410',text:_npossvalue2+" (subject)"}].concat(_this.state.nounOptionsSVAblPossessors);}else if(_this.state.mvvs[0]==3&&_this.state.mvvs[1]==2){nounOptionsSVPossessors1=[{id:10,value:'420',text:_npossvalue2+" (subject)"}].concat(_this.state.nounOptionsSVPossessors);nounOptionsSVAblPossessors1=[{id:10,value:'420',text:_npossvalue2+" (subject)"}].concat(_this.state.nounOptionsSVAblPossessors);}else if(_this.state.mvvs[0]==3&&_this.state.mvvs[1]==3){nounOptionsSVPossessors1=[{id:14,value:'430',text:_npossvalue2+" (subject)"}].concat(_this.state.nounOptionsSVPossessors);nounOptionsSVAblPossessors1=[{id:14,value:'430',text:_npossvalue2+" (subject)"}].concat(_this.state.nounOptionsSVAblPossessors);}else{nounOptionsSVPossessors1=_this.state.nounOptionsSVPossessors;nounOptionsSVAblPossessors1=_this.state.nounOptionsSVAblPossessors;}_this.setState({nounOptionsSVPossessors1:nounOptionsSVPossessors1,nounOptionsSVAblPossessors1:nounOptionsSVAblPossessors1});}};_this.resetAfterSubmit=function(){_this.setState({containsTime:false,activeIndexes:[],activeIndexes1:[],currentlyOpen:'',isOpen:false,mvvsPlanned:[],searchQuery:'',wordsList:[],candidateBase:[],candidateDisplay:[],candidateCall:[],nextTenses:[],nounNum:'s',unallowable_next_ids:[],addIs:true,lockSubmit:false});};_this.processStyledText=function(sentence){var matches=sentence.match(/\<.*?\>/g);if(matches!==null){matches.map(function(m){return sentence=sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>');});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:sentence.replace("⟨","").replace("⟩","")}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence.replace("⟨","").replace("⟩",""));}};_this.onChangeBaseSearch=function(endingNeeded,forEnglish,itemUpdating,mood,submood,update,itemUpdatingFull,event,data){_this.setState({activeIndexes1:[]});var word=data.value;var wordsList=void 0;var filteredDictV={};var Sbrd=false;var noFuture=false;var noPast=false;var vsPlanned=[];var startingCase='';var optionsFuzzy={keys:['yupikword','englishraw'],limit:10,// don't return more results than you need!
threshold:-10000// don't return bad results
};// if (word.length>0) {
// this.setState({ activeIndexes: [] });			
// }
var newSearch=word.toLowerCase().replaceAll(/^is /g,'').replaceAll(/^am /g,'').replaceAll(/^are /g,'');// console.log(newSearch)
if(_this.state.endingAdjusted=='v'||_this.state.endingAdjusted!=='n'||endingNeeded=='v'){if(forEnglish!==undefined){startingCase=forEnglish[0];vsPlanned=forEnglish[1];}else{if(itemUpdating=='cv'){vsPlanned=_this.state.cvvs;}else{vsPlanned=_this.state.mvvs;}}if(_this.state.nextTenses.length>0){if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='p'){optionsFuzzy['keys']=['yupikword','past_preverb'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='g'){optionsFuzzy['keys']=['yupikword','ger_preverb'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='i'){optionsFuzzy['keys']=['yupikword','inf_preverb'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='pp'){optionsFuzzy['keys']=['yupikword','past_preverb'];}}else{var specialStartingCase=_this.returnBaseCaseforMoods(itemUpdating,mood,vsPlanned);// console.log(verbtype,mood,vsPlanned)
// console.log(specialStartingCase)
var s0=specialStartingCase[0];if(s0==='p'){optionsFuzzy['keys']=['yupikword','past_preverb'];}else if(s0==='g'){optionsFuzzy['keys']=['yupikword','ger_preverb'];}else if(s0==='i'){optionsFuzzy['keys']=['yupikword','inf_preverb'];}else if(s0==='past'){optionsFuzzy['keys']=['yupikword','past_preverb'];}// else if (s0 === 'pp') {
// 	verbAdd = key['englishtenses'][4]
// } else if (s0 === 'gen') {
// 	verbAdd = key['englishtenses'][2]
// } else if (s0 === 'gen2') {
// 	verbAdd = key['englishtenses'][2]
// } else if (s0 === 'present') {
// 	verbAdd = key['englishtenses'][2]
// }						
}}// console.log((endingNeeded,event,data))
// console.log(endingNeeded,forEnglish,itemUpdating,mood,submood, update,itemUpdatingFull, this.state.nextTenses)
// this.returnBaseCaseforMoods(verbtype,mood,vsPlanned)
// console.log(optionsFuzzy)
if(mood!==undefined){if(mood=='Sbrd'||mood.includes('Opt')){noFuture=true;noPast=true;}}if(itemUpdating=='sv'){Sbrd=true;}if(mood=='CtmpI'||mood=='CtmpII'||submood=='Intrg4'){noFuture=true;}if(submood=='Intrg5'){noPast=true;}// if (submood == 'Intrg4' || submood == 'Intrg5') {
// 	noFuture = true
// 	noPast = true
// }
if(submood=='Intrg1'||submood=='Intrg3'){filteredDictV=_this.state.filteredDictVit;}else if(Sbrd){filteredDictV=_this.state.filteredDictVsub;}else{filteredDictV=_this.state.filteredDictV;}if(Sbrd){Object.keys(_this.state.filteredDictVVnotimesub).map(function(key){return filteredDictV[key]=_this.state.filteredDictVVnotimesub[key];});}else if(noFuture&&noPast){Object.keys(_this.state.filteredDictVVnotime).map(function(key){return filteredDictV[key]=_this.state.filteredDictVVnotime[key];});}else if(noFuture){Object.keys(_this.state.filteredDictVVnofuture).map(function(key){return filteredDictV[key]=_this.state.filteredDictVVnofuture[key];});}else if(noPast){Object.keys(_this.state.filteredDictVVnopast).map(function(key){return filteredDictV[key]=_this.state.filteredDictVVnopast[key];});}else{Object.keys(_this.state.filteredDictVVall).map(function(key){return filteredDictV[key]=_this.state.filteredDictVVall[key];});}if(_this.state.endingAdjusted=='n'){wordsList=__WEBPACK_IMPORTED_MODULE_11_fuzzysort___default.a.go(newSearch,_this.state.filteredDictN,optionsFuzzy).map(function(_ref){var obj=_ref.obj;return obj;});// console.log(wordsList)
_this.setState({wordsList:wordsList,searchQuery:word});}else if(_this.state.endingAdjusted=='v'){wordsList=__WEBPACK_IMPORTED_MODULE_11_fuzzysort___default.a.go(newSearch,filteredDictV,optionsFuzzy).map(function(_ref2){var obj=_ref2.obj;return obj;});// console.log(wordsList)
_this.setState({wordsList:wordsList,searchQuery:word});}else{if(endingNeeded==='v'){wordsList=__WEBPACK_IMPORTED_MODULE_11_fuzzysort___default.a.go(newSearch,filteredDictV,optionsFuzzy).map(function(_ref3){var obj=_ref3.obj;return obj;});// console.log(wordsList)
_this.setState({wordsList:wordsList,searchQuery:word});}else if(endingNeeded==='n'){wordsList=__WEBPACK_IMPORTED_MODULE_11_fuzzysort___default.a.go(newSearch,_this.state.filteredDictN,optionsFuzzy).map(function(_ref4){var obj=_ref4.obj;return obj;});// console.log(wordsList)
_this.setState({wordsList:wordsList,searchQuery:word});}}};_this.handleOpen=function(current){_this.setState({isOpen:true,currentlyOpen:current});};_this.menuSelect=function(direction){// console.log(direction)
// if (this.state.cpreviousEditMode !== this.state.currentEditMode) {
// this.closeEditMenuRef(direction[0],'default')
// } else {
_this.closeEditMenuRef(direction[0],direction[1],true);// }
// this.setState({ isOpen: false },()=>{this.setState({isOpen: true})});
};_this.returnHeight=function(type){// var height = 0
// console.log(type)
// height = document.getElementById('tester');
// if (height) {
// 	console.log(height.offsetHeight)  		
// } else {
// 	console.log('null')
// }
if(type==='default'){return;}else if(type==='mvinsert'||type==='mvupdate'){return 616;}else{return 616;// return document.getElementById.clientHeight('menuheight');
}};_this.triggerItems=function(type,ind){// console.log(this.state)
// console.log('trigger',type,ind)
if(type==='default'){return _this.contentDisplay(type,[],3);}else if(type==='defaultverbphrase'){return _this.contentDisplay(type,[],3);}else if(type==='defaultmv'){return _this.contentDisplay(type,[],4);}else if(type==='defaultcv'){return _this.contentDisplay(type,[],4);}else if(type==='defaultsv'){return _this.contentDisplay(type,[],4);}else if(type==='mvnsParser'){return _this.contentDisplay(type,_this.state.mvnsSegments.slice().reverse()[ind[0]][ind[1]],1);}else if(type==='mvnsappositiveParser'){return _this.contentDisplay(type,_this.state.mvnsSegments.slice().reverse()[ind[0]][ind[1]],1);}else if(type==='mvnoParser'){return _this.contentDisplay(type,_this.state.mvnoSegments.slice().reverse()[ind[0]][ind[1]],1);}else if(type==='mvnoappositiveParser'){return _this.contentDisplay(type,_this.state.mvnoSegments.slice().reverse()[ind[0]][ind[1]],1);}else if(type==='cvnsParser'||type==='cvnsappositiveParser'){return _this.contentDisplay(type,_this.state.cvnsSegments.slice().reverse()[ind[0]][ind[1]],1);}else if(type==='cvnoParser'||type==='cvnoappositiveParser'){return _this.contentDisplay(type,_this.state.cvnoSegments.slice().reverse()[ind[0]][ind[1]],1);}else if(type==='svnoParser'||type==='svnoappositiveParser'){return _this.contentDisplay(type,_this.state.svnoSegments.slice().reverse()[ind[0]][ind[1]],1);}else if(type==='cvnoappositiveParser'){return _this.contentDisplay(type,_this.state.cvnoSegments.slice().reverse()[ind[0]][ind[1]],1);}else if(type=='mvQuestion'||type=='mvParser'){return _this.contentDisplay(type,_this.state.mvvSegments,2);}else if(type==='mvqWord'||type==='mvqWordParser'){return _this.contentDisplay(type,_this.state.mvqWordSegments,2);}else if(type=='cvParser'){return _this.contentDisplay(type,_this.state.cvvSegments,2);}else if(type=='svParser'){return _this.contentDisplay(type,_this.state.svvSegments,2);}else if(type==='npnParser'||type==='npnappositiveParser'){return _this.contentDisplay(type,_this.state.npnSegments.slice().reverse()[ind[0]][ind[1]],1);}else if(type==='mvnObliquesParser'||type=='mvnObliquesAppositiveParser'){return _this.contentDisplay(type,_this.state.mvnObliquesSegments[ind[0]][ind[1]][ind[2]],1);}else if(type==='cvnObliquesParser'||type==='cvnObliquesAppositiveParser'){return _this.contentDisplay(type,_this.state.cvnObliquesSegments[ind[0]][ind[1]][ind[2]],1);}else if(type==='svnObliquesParser'||type==='svnObliquesAppositiveParser'){return _this.contentDisplay(type,_this.state.svnObliquesSegments[ind[0]][ind[1]][ind[2]],1);}else if(type==='mvEnglish1'){return _this.contentDisplay(type,_this.state.mvEnglish1,5);}else if(type==='mvEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.state.mvEnglish3in2.length>0?_this.contentDisplay(type,[_this.state.mvEnglish3in2,_this.state.mvEnglish2],8):_this.contentDisplay(type,_this.state.mvEnglish2,5));}else if(type==='mvEnglishAbl'){return _this.contentDisplay(type,_this.state.mvEnglishAbl,5);}else if(type==='mvEnglishQaa'){return _this.contentDisplay(type,_this.state.mvEnglishQaa,5);}else if(type==='npnEnglish1'){return _this.contentDisplay(type,_this.state.npnEnglish1,5);}else if(type==='cvEnglish1'){return _this.contentDisplay(type,_this.state.cvEnglish1,5);}else if(type==='cvEnglishAbl'){return _this.contentDisplay(type,_this.state.cvEnglishAbl,5);}else if(type==='cvEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.state.cvEnglish3in2.length>0?_this.contentDisplay(type,[_this.state.cvEnglish3in2,_this.state.cvEnglish2],8):_this.contentDisplay(type,_this.state.cvEnglish2,5));}else if(type==='svEnglishAbl'){return _this.contentDisplay(type,_this.state.svEnglishAbl,5);}else if(type==='svEnglish2'){return _this.contentDisplay(type,_this.state.svEnglish2,5);}else if(type==='mvnObliquesEnglish1'){return _this.contentDisplay(type,_this.state.mvnObliquesEnglish1[ind],5);}else if(type==='svnObliquesEnglish1'){return _this.contentDisplay(type,_this.state.svnObliquesEnglish1[ind],5);}else if(type==='cvnObliquesEnglish1'){return _this.contentDisplay(type,_this.state.cvnObliquesEnglish1[ind],5);}else if(type==='mvnsEnglish2'||type==='mvnsEnglish2appositive'){return _this.contentDisplay(type,_this.state.mvnsEnglish2[ind[0]][ind[1]],5);}else if(type==='mvnoEnglish2'||type==='mvnoEnglish2appositive'){return _this.contentDisplay(type,_this.state.mvnoEnglish2[ind[0]][ind[1]],5);}else if(type==='cvnsEnglish2'||type==='cvnsEnglish2appositive'){return _this.contentDisplay(type,_this.state.cvnsEnglish2[ind[0]][ind[1]],5);}else if(type==='cvnoEnglish2'||type==='cvnoEnglish2appositive'){return _this.contentDisplay(type,_this.state.cvnoEnglish2[ind[0]][ind[1]],5);}else if(type==='svnoEnglish2'||type==='svnoEnglish2appositive'){return _this.contentDisplay(type,_this.state.svnoEnglish2[ind[0]][ind[1]],5);}else if(type==='npnEnglish2'){// console.log('npn', this.state.npnEnglish2, ind[0], ind[1])
return _this.contentDisplay(type,_this.state.npnEnglish2[ind[0]][_this.state.npnEnglish2[ind[0]].length-1-ind[1]],5);}else if(type==='npnEnglish2appositive'){// console.log('npnappositive', this.state.npnEnglish2, ind[0], ind[1])
return _this.contentDisplay(type,_this.state.npnEnglish2[ind[0]][_this.state.npnEnglish2[ind[0]].length-1-ind[1]],5);}else if(type==='cvnsEnglish2'){return _this.contentDisplay(type,_this.state.cvnsEnglish2[ind],6);}else if(type==='svnoEnglish2'){return _this.contentDisplay(type,_this.state.svnoEnglish2[ind],6);}else if(type==='mvnObliquesEnglish2'||type==='mvnObliquesEnglish2appositive'){return _this.contentDisplay(type,_this.state.mvnObliquesEnglish2[ind[0]][_this.state.mvnObliquesEnglish2[ind[0]].length-1-ind[1]][_this.state.mvnObliquesEnglish2[ind[0]][_this.state.mvnObliquesEnglish2[ind[0]].length-1-ind[1]].length-1-ind[2]],5);}else if(type==='cvnObliquesEnglish2'||type==='cvnObliquesEnglish2appositive'){return _this.contentDisplay(type,_this.state.cvnObliquesEnglish2[ind[0]][_this.state.cvnObliquesEnglish2[ind[0]].length-1-ind[1]][_this.state.cvnObliquesEnglish2[ind[0]][_this.state.cvnObliquesEnglish2[ind[0]].length-1-ind[1]].length-1-ind[2]],5);}else if(type==='svnObliquesEnglish2'||type==='svnObliquesEnglish2appositive'){return _this.contentDisplay(type,_this.state.svnObliquesEnglish2[ind[0]][_this.state.svnObliquesEnglish2[ind[0]].length-1-ind[1]][_this.state.svnObliquesEnglish2[ind[0]][_this.state.svnObliquesEnglish2[ind[0]].length-1-ind[1]].length-1-ind[2]],5);}else if(type==='svEnglish1'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',border:'1px solid #22242626',marginRight:'2px',marginLeft:'2px',cursor:'pointer',fontSize:'18px',padding:'8px 5px 8px 5px',borderRadius:'5px'}},_this.state.svEnglish2.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.getColor(w[1])}},_this.state.svvText+w[0]+" ");}),_this.state.svEnglish1.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.getColor(w[1])}},_this.state.svvText+w[0]+" ");}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{fontSize:'16px',margin:0},name:'dropdown'}));}};_this.contentDisplay=function(type,data,fontType){// console.log(type, data)
if(fontType==1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10,cursor:'pointer',marginBottom:5}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer',display:'flex',justifyContent:'center',flexDirection:'row',lineHeight:'40px'}},data.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.getColor(t[1])}},t[0]);})));}else if(fontType==2){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:window.innerWidth<480&&data.length>5?'25px':'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{cursor:'pointer',display:'flex',justifyContent:'center',flexDirection:'row',marginBottom:5,lineHeight:'40px'}},data.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{whiteSpace:'nowrap',color:_this.getColor(t[1])}},t[0]);})));}else if(fontType==3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{size:'large',basic:true,icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'plus'}));}else if(fontType==4){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{size:'small',basic:true,icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'plus'}));}else if(fontType==5){// console.log(data)
// console.log('5')
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{ref:function ref(element){_this.vEnglish2Ref[type]=element;},style:{display:'inline-block',border:'solid 1px #22242626',marginRight:'2px',marginLeft:'2px',cursor:'pointer',fontSize:'18px',padding:'8px 5px 8px 5px',borderRadius:'5px'}},data.map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.getColor(w[1])}// {{color:this.getColor(w[1]),cursor:'pointer',paddingBottom:'1px',borderBottom:'1px solid '+this.getColor(w[1])}}
// {{border:'solid 1px #22242626',color:this.getColor(w[1]),fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'2px',marginLeft:'2px',}}
},w[0].replaceAll("<","").replaceAll(">","")+" ");}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{fontSize:'16px',margin:0},name:'dropdown'}));}else if(fontType==6){// console.log('6')
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' ',data.map(function(w,wind){return w.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.getColor(t[1]),cursor:'pointer',paddingBottom:'1px',borderBottom:'1px solid '+_this.getColor(t[1])}},t[0]+" ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:_this.getColor(t[1]),fontSize:'16px',margin:0},name:'dropdown'}));});}));}else if(fontType==7){// console.log('7')
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.getColor(data[1]),cursor:'pointer',paddingBottom:'1px',borderBottom:'1px solid '+_this.getColor(data[1])}},data[0]+" ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:_this.getColor(data[1]),fontSize:'16px',margin:0},name:'dropdown'}));}else if(fontType==8){// console.log('8')
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{ref:function ref(element){_this.vEnglish2Ref[type]=element;},style:{display:'inline-block',border:'solid 1px #22242626',marginRight:'2px',marginLeft:'2px',cursor:'pointer',fontSize:'18px',padding:'8px 5px 8px 5px',borderRadius:'5px'}},data[0].map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.getColor(w[1])}},w[0]+(w[0].length>0&&w[1]!=='mvv.com'?" ":""));}),data[1].map(function(w,wind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this.getColor(w[1])}},w[0]+(w[0].length>0&&wind!==data[1].length-1?" ":""));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:_this.getColor(data[1]),fontSize:'16px',margin:0},name:'dropdown'}));}};_this.contentItems=function(currentEditMode,type,ind,mainscreen,forEnglish,setStateTo){// console.log(type,ind)
// console.log(setStateTo)
// console.log(currentEditMode,type,ind,mainscreen,forEnglish,setStateTo)
var typeInd=type+(ind+1).toString();// let currentEditMode = this.state.currentEditMode
if(setStateTo==undefined){setStateTo=['',''];}if(mainscreen){currentEditMode=type;}// console.log(currentEditMode)
if(currentEditMode==='default'){if(type==='default'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Make a Verb Statement',[typeInd,'mvinsert'],null,null),_this.subMenuItem('nounPhrase'),_this.subMenuItem('addQuestion'),_this.subMenuItem('addCommand'));}else if(type==='defaultmv'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.state.mvvs.length>0&&_this.state.mvns.length==0&&_this.state.mvvType!=='Intrg0'&&_this.state.mvvType!=='Intrg2'?_this.menuItem('BaseChooser','Add Noun Subject',[typeInd,'mvnsinsert'],null):null,_this.state.mvvo.length>0&&_this.state.mvno.length==0&&_this.state.mvvType!=='Intrg1'&&_this.state.mvvType!=='Intrg3'?_this.menuItem('BaseChooser','Add Noun Object',[typeInd,'mvnoinsert'],null):null,_this.subMenuItem('addnOblique'));}else if(type==='mvEnglishAbl'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.state.mvvo.length>0&&_this.state.mvno.length==0&&_this.state.mvvType!=='Intrg1'&&_this.state.mvvType!=='Intrg3'?_this.menuItem('BaseChooser','Add Noun Object',[typeInd,'mvnoinsert'],null):null);}else if(type==='mvEnglishQaa'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('Update','Remove Yes or No Question',null,null,[["Update",["mv","vType"],'']]));}else if(type==='defaultcv'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.state.cvvs.length>0&&_this.state.cvns.length==0?_this.menuItem('BaseChooser','Add Connective Noun Subject',[typeInd,'cvnsinsert'],null):null,_this.state.cvvo.length>0&&_this.state.cvno.length==0?_this.menuItem('BaseChooser','Add Connective Noun Object',[typeInd,'cvnoinsert'],null):null,_this.subMenuItem('caddnOblique'));}else if(type==='cvEnglishAbl'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.state.cvvo.length>0&&_this.state.cvno.length==0?_this.menuItem('BaseChooser','Add Connective Noun Object',[typeInd,'cvnoinsert'],null):null);}else if(type==='defaultsv'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.state.svvo.length>0&&_this.state.svno.length==0?_this.menuItem('BaseChooser','Add Subordinative Noun Object',[typeInd,'svnoinsert'],null):null,_this.subMenuItem('saddnOblique'));}else if(type==='svEnglishAbl'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.state.svvo.length>0&&_this.state.svno.length==0?_this.menuItem('BaseChooser','Add Subordinative Noun Object',[typeInd,'svnoinsert'],null):null);}else if(type==='defaultverbphrase'&&_this.state.cvvs.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.subMenuItem('addnOblique'),_this.subMenuItem('addAnotherVerbPhrase'));}else if(type==='mvParser'){return _this.parserPopup(_this.state.parses.mv.v);}else if(type==='mvnsParser'||type==='mvnsappositiveParser'){return _this.parserPopup(_this.state.parses.mv.ns[_this.state.mvnsSegments.length-1-ind[0]][ind[1]]);}else if(type==='mvnoParser'||type==='mvnoappositiveParser'){return _this.parserPopup(_this.state.parses.mv.no[_this.state.mvnoSegments.length-1-ind[0]][ind[1]]);}else if(type==='mvnObliquesParser'||type==='mvnObliquesAppositiveParser'){return _this.parserPopup(_this.state.parses.mv.nObliques[ind[0]][ind[1]][ind[2]]);}else if(type==='cvParser'){return _this.parserPopup(_this.state.parses.cv.v);}else if(type==='cvnsParser'||type==='cvnsappositiveParser'){return _this.parserPopup(_this.state.parses.cv.ns[_this.state.cvnsSegments.length-1-ind[0]][ind[1]]);}else if(type==='cvnoParser'||type==='cvnoappositiveParser'){return _this.parserPopup(_this.state.parses.cv.no[_this.state.cvnoSegments.length-1-ind[0]][ind[1]]);}else if(type==='cvnObliquesParser'||type==='cvnObliquesAppositiveParser'){return _this.parserPopup(_this.state.parses.cv.nObliques[ind[0]][ind[1]][ind[2]]);}else if(type==='svParser'){return _this.parserPopup(_this.state.parses.sv.v);}else if(type==='svnoParser'||type==='svnoappositiveParser'){return _this.parserPopup(_this.state.parses.sv.no[_this.state.svnoSegments.length-1-ind[0]][ind[1]]);}else if(type==='svnObliquesParser'||type==='svnObliquesAppositiveParser'){return _this.parserPopup(_this.state.parses.sv.nObliques[ind[0]][ind[1]][ind[2]]);}else if(type==='npnParser'||type==='npnappositiveParser'){return _this.parserPopup(_this.state.parses.np.n[_this.state.npn.length-1-ind[0]][ind[1]]);}else if(type==='mvqWordParser'){return _this.parserPopup(_this.state.parses.mv.qWord);}else if(type=='mvEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Verb',[typeInd,'mvupdate'],null),_this.menuItem('Delete','Delete Verb',null,null,[["Delete",["mv"],-1]]),_this.state.requirePostbase.length>0?_this.subMenuItem('changeRequiredPostbase'):null,_this.state.mvvMood=='Ind'&&_this.state.mvvType!=='qaa'?_this.menuItem('Update','Make Yes or No Question',null,null,[["Update",["mv","vType"],'qaa']]):null,_this.state.mvvMood=='Ind'&&_this.state.mvvType!=='qaa'&&_this.state.cvvMood!=='CtmpI'?_this.menuItem('Update','Change to Command',null,null,[["Update",["mv","vMood"],'Opt][PRS']]):null,_this.state.mvvMood.includes("Opt")||_this.state.mvvMood=='Sbrd'?_this.subMenuItem('switchOptative'):null,_this.state.mvvMood.includes("Opt")||_this.state.mvvMood=='Sbrd'?_this.menuItem('Update','Change to Statement',null,null,[["Update",["mv","vMood"],'Ind']]):null);}else if(type=='mvEnglish1'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.subMenuItem('changeQuestiontype'));}else if(type==='cvEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Connective Verb',[typeInd,'cvupdate'],null),_this.menuItem('Delete','Delete Connective Verb',null,null,[["Delete",["cv"],-1]]));}else if(type==='cvEnglish1'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.subMenuItem('changeCVtype'));}else if(type==='cvEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Connective Verb',[typeInd,'cvupdate'],null),_this.menuItem('Delete','Delete Connective Verb',null,null,[["Delete",["cv"],-1]]));}else if(type==='svEnglish1'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Subordinative Verb',[typeInd,'svupdate'],null),_this.menuItem('Delete','Delete Subordinative Verb',null,null,[["Delete",["sv"],-1]]));}else if(type==='svnoEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Noun',[typeInd,'svnoupdateEnglish'],null),ind[0]==0?_this.menuItem('BaseChooser','Add Possessor Noun',[typeInd,'svnopossessorinsert'],null):null,ind[0]==_this.state.svno.length-1?_this.menuItem('BaseChooser','Add Possessed Noun',[typeInd,'svnopossessedinsert'],null):null,_this.menuItem('BaseChooser','Add Descriptor Noun',[typeInd,'svnoappositiveinsert'],null),_this.menuItem('Delete','Delete Noun',null,null,[["Delete",["sv","no",_this.state.svno.length-1-ind[0]],-1]]));}else if(type==='svnoEnglish2appositive'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Descriptor Noun',[typeInd,'svnoupdateEnglishappositiveupdate'],null),_this.menuItem('Delete','Delete Descriptor Noun',null,null,[["Delete",["sv","no",_this.state.svno.length-1-ind[0],_this.state.svno[ind[0]].length-1-ind[1]],-1]]));}else if(type=='mvnsEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Noun',[typeInd,'mvnsupdateEnglish'],null),ind[0]==0?_this.menuItem('BaseChooser','Add Possessor Noun',[typeInd,'mvnspossessorinsert'],null):null,ind[0]==_this.state.mvns.length-1?_this.menuItem('BaseChooser','Add Possessed Noun',[typeInd,'mvnspossessedinsert'],null):null,_this.menuItem('BaseChooser','Add Descriptor Noun',[typeInd,'mvnsappositiveinsert'],null),_this.menuItem('Delete','Delete Noun',null,null,[["Delete",["mv","ns",_this.state.mvns.length-1-ind[0]],-1]]));}else if(type=='mvnsEnglish2appositive'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Descriptor Noun',[typeInd,'mvnsupdateEnglishappositiveupdate'],null),_this.menuItem('Delete','Delete Descriptor Noun',null,null,[["Delete",["mv","ns",_this.state.mvns.length-1-ind[0],_this.state.mvns[ind[0]].length-1-ind[1]],-1]]));}else if(type==='mvnoEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Noun',[typeInd,'mvnoupdateEnglish'],null),ind[0]==0?_this.menuItem('BaseChooser','Add Possessor Noun',[typeInd,'mvnopossessorinsert'],null):null,ind[0]==_this.state.mvno.length-1?_this.menuItem('BaseChooser','Add Possessed Noun',[typeInd,'mvnopossessedinsert'],null):null,_this.menuItem('BaseChooser','Add Descriptor Noun',[typeInd,'mvnoappositiveinsert'],null),_this.menuItem('Delete','Delete Noun',null,null,[["Delete",["mv","no",_this.state.mvno.length-1-ind[0]],-1]]));}else if(type==='mvnoEnglish2appositive'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Descriptor Noun',[typeInd,'mvnoupdateEnglishappositiveupdate'],null),_this.menuItem('Delete','Delete Descriptor Noun',null,null,[["Delete",["mv","no",_this.state.mvno.length-1-ind[0],_this.state.mvno[ind[0]].length-1-ind[1]],-1]]));}else if(type==='cvnsEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Noun',[typeInd,'cvnsupdateEnglish'],null),ind[0]==0?_this.menuItem('BaseChooser','Add Possessor Noun',[typeInd,'cvnspossessorinsert'],null):null,ind[0]==_this.state.cvns.length-1?_this.menuItem('BaseChooser','Add Possessed Noun',[typeInd,'cvnspossessedinsert'],null):null,_this.menuItem('BaseChooser','Add Descriptor Noun',[typeInd,'cvnsappositiveinsert'],null),_this.menuItem('Delete','Delete Noun',null,null,[["Delete",["cv","ns",_this.state.cvns.length-1-ind[0]],-1]]));}else if(type==='cvnoEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Noun',[typeInd,'cvnoupdateEnglish'],null),ind[0]==0?_this.menuItem('BaseChooser','Add Possessor Noun',[typeInd,'cvnopossessorinsert'],null):null,ind[0]==_this.state.cvno.length-1?_this.menuItem('BaseChooser','Add Possessed Noun',[typeInd,'cvnopossessedinsert'],null):null,_this.menuItem('BaseChooser','Add Descriptor Noun',[typeInd,'cvnoappositiveinsert'],null),_this.menuItem('Delete','Delete Noun',null,null,[["Delete",["cv","no",_this.state.cvno.length-1-ind[0]],-1]]));}else if(type==='cvnsEnglish2appositive'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Descriptor Noun',[typeInd,'cvnsupdateEnglishappositiveupdate'],null),_this.menuItem('Delete','Delete Descriptor Noun',null,null,[["Delete",["cv","ns",_this.state.cvns.length-1-ind[0],_this.state.cvns[ind[0]].length-1-ind[1]],-1]]));}else if(type==='cvnoEnglish2appositive'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Descriptor Noun',[typeInd,'cvnoupdateEnglishappositiveupdate'],null),_this.menuItem('Delete','Delete Descriptor Noun',null,null,[["Delete",["cv","no",_this.state.cvno.length-1-ind[0],_this.state.cvno[ind[0]].length-1-ind[1]],-1]]));}else if(type==='npnEnglish2'){// console.log(ind, this.state.npnEnglish2[ind[0]].length-1)
// console.log('content',type,ind)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Noun',[typeInd,'npnupdateEnglish'],null),ind[0]==0?_this.menuItem('BaseChooser','Add Possessor Noun',[typeInd,'npnpossessorinsert'],null):null,ind[0]==_this.state.npnEnglish2.length-1?_this.menuItem('BaseChooser','Add Possessed Noun',[typeInd,'npnpossessedinsert'],null):null,_this.menuItem('BaseChooser','Add Descriptor Noun',[typeInd,'npnappositiveinsert'],null),_this.menuItem('Delete','Delete Noun',null,null,[["Delete",["np","n",_this.state.npnSegments.length-1-ind[0]],-1]]));}else if(type==='npnEnglish2appositive'){// console.log('content',type,ind)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Noun',[typeInd,'npnupdateEnglishappositiveupdate'],null),_this.menuItem('Delete','Delete Noun',null,null,[["Delete",["np","n",_this.state.npnSegments.length-1-ind[0],ind[1]],-1]]));}else if(type==='npnEnglish1'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.subMenuItem('changeNPtype'));}else if(type==='mvnObliquesEnglish1'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.subMenuItem('changeVObliquetype','mv',ind));}else if(type==='cvnObliquesEnglish1'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.subMenuItem('changeVObliquetype','cv',ind));}else if(type==='svnObliquesEnglish1'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.subMenuItem('changeVObliquetype','sv',ind));}else if(type==='mvnObliquesEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Oblique Noun',[typeInd,'mvnObliqueUpdate'],null),_this.state.mvnObliques.length>0?ind[1]==_this.state.mvnObliques[ind[0]].n.length-1?_this.menuItem('BaseChooser','Add Oblique Possessor Noun',[typeInd,'mvnObliquepossessorinsert'],null):null:null,ind[1]==0?_this.menuItem('BaseChooser','Add Oblique Possessed Noun',[typeInd,'mvnObliquepossessedinsert'],null):null,_this.menuItem('BaseChooser','Add Descriptor Noun',[typeInd,'mvnObliqueappositiveinsert'],null),_this.menuItem('Delete','Delete Oblique Noun',null,null,[["Delete",["mv","nObliques",ind[0],ind[1]],-1]]));}else if(type==='cvnObliquesEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Oblique Noun',[typeInd,'cvnObliqueUpdate'],null),_this.state.cvnObliques.length>0?ind[1]==_this.state.cvnObliques[ind[0]].n.length-1?_this.menuItem('BaseChooser','Add Oblique Possessor Noun',[typeInd,'cvnObliquepossessorinsert'],null):null:null,ind[1]==0?_this.menuItem('BaseChooser','Add Oblique Possessed Noun',[typeInd,'cvnObliquepossessedinsert'],null):null,_this.menuItem('BaseChooser','Add Descriptor Noun',[typeInd,'cvnObliqueappositiveinsert'],null),_this.menuItem('Delete','Delete Oblique Noun',null,null,[["Delete",["cv","nObliques",ind[0],ind[1]],-1]]));}else if(type==='cvnObliquesEnglish2appositive'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Oblique Descriptor Noun',[typeInd,'cvnObliqueUpdateappositiveupdate'],null),_this.menuItem('Delete','Delete Oblique Descriptor Noun',null,null,[["Delete",["cv","nObliques",ind[0],ind[1],ind[2]],-1]]));}else if(type==='svnObliquesEnglish2'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Oblique Noun',[typeInd,'svnObliqueUpdate'],null),_this.state.svnObliques.length>0?ind[1]==_this.state.svnObliques[ind[0]].n.length-1?_this.menuItem('BaseChooser','Add Oblique Possessor Noun',[typeInd,'svnObliquepossessorinsert'],null):null:null,ind[1]==0?_this.menuItem('BaseChooser','Add Oblique Possessed Noun',[typeInd,'svnObliquepossessedinsert'],null):null,_this.menuItem('BaseChooser','Add Descriptor Noun',[typeInd,'svnObliqueappositiveinsert'],null),_this.menuItem('Delete','Delete Oblique Noun',null,null,[["Delete",["sv","nObliques",ind[0],ind[1]],-1]]));}else if(type==='svnObliquesEnglish2appositive'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Oblique Descriptor Noun',[typeInd,'cvnObliqueUpdateappositiveupdate'],null),_this.menuItem('Delete','Delete Oblique Descriptor Noun',null,null,[["Delete",["cv","nObliques",ind[0],ind[1],ind[2]],-1]]));}else if(type==='mvnObliquesEnglish2appositive'){// console.log(ind)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */],{vertical:true,style:{marginTop:10,marginBottom:10}},_this.menuItem('BaseChooser','Change Oblique Descriptor Noun',[typeInd,'mvnObliqueUpdateappositiveupdate'],null),_this.menuItem('Delete','Delete Oblique Descriptor Noun',null,null,[["Delete",["mv","nObliques",ind[0],ind[1],ind[2]],-1]]));}}else if(currentEditMode==='mvnObliqueUpdate'){var nCases=['',''];nCases=_this.getnCasenType(_this.state.mvnObliques,ind[0]);return _this.baseChooser(["Update",["mv","nObliques",ind[0],'nBases',ind[1],ind[2]]],'n','updatebase',nCases[0],nCases[1]);}else if(currentEditMode==='cvnObliqueUpdate'){var _nCases=['',''];_nCases=_this.getnCasenType(_this.state.cvnObliques,ind[0]);return _this.baseChooser(["Update",["cv","nObliques",ind[0],'nBases',ind[1],ind[2]]],'n','updatebase',_nCases[0],_nCases[1]);}else if(currentEditMode==='svnObliqueUpdate'){var _nCases2=['',''];_nCases2=_this.getnCasenType(_this.state.svnObliques,ind[0]);return _this.baseChooser(["Update",["sv","nObliques",ind[0],'nBases',ind[1],ind[2]]],'n','updatebase',_nCases2[0],_nCases2[1]);}else if(currentEditMode==='mvnObliqueUpdateappositiveupdate'){var _nCases3=['',''];_nCases3=_this.getnCasenType(_this.state.mvnObliques,ind[0]);return _this.baseChooser(["Update",["mv","nObliques",ind[0],'nBases',ind[1],ind[2]]],'n','updatebase',_nCases3[0],_nCases3[1]);}else if(currentEditMode==='cvnObliqueUpdateappositiveupdate'){var _nCases4=['',''];_nCases4=_this.getnCasenType(_this.state.cvnObliques,ind[0]);return _this.baseChooser(["Update",["cv","nObliques",ind[0],'nBases',ind[1],ind[2]]],'n','updatebase',_nCases4[0],_nCases4[1]);}else if(currentEditMode==='svnObliqueUpdateappositiveupdate'){var _nCases5=['',''];_nCases5=_this.getnCasenType(_this.state.svnObliques,ind[0]);return _this.baseChooser(["Update",["sv","nObliques",ind[0],'nBases',ind[1],ind[2]]],'n','updatebase',_nCases5[0],_nCases5[1]);}else if(currentEditMode==='mvinsert'){return _this.baseChooser(["Insert",["mv"]],'v','insert','Ind',null,forEnglish);}else if(currentEditMode==='mvinsertqaa'){return _this.baseChooser(["Insert",["mv"]],'v','insert','Ind','qaa',forEnglish);}else if(currentEditMode==='cvinsert'){return _this.baseChooser(["Insert",["cv"]],'v','insert',setStateTo[0],setStateTo[1],forEnglish);}else if(currentEditMode==='questionInsert'){return _this.baseChooser(["Insert",["mv"]],'v','insert','Intrg',setStateTo[0],forEnglish);}else if(currentEditMode==='commandInsert'){return _this.baseChooser(["Insert",["mv"]],'v','insert',setStateTo[0],setStateTo[1],forEnglish);}else if(currentEditMode==='svinsert'){return _this.baseChooser(["Insert",["sv"]],'v','insert','Sbrd',setStateTo[0],forEnglish);}else if(currentEditMode==='mvupdate'){return _this.baseChooser(["Update",["mv","vBase"]],'v','update',_this.state.mvvMood,_this.state.mvvType);}else if(currentEditMode==='svupdate'){return _this.baseChooser(["Update",["sv","vBase"]],'v','update');}else if(currentEditMode==='nObliqueInsert'){if(_this.state.mvnObliques.length>0){return _this.baseChooser(["Insert",["mv","nObliques",-1]],'n','insert',setStateTo[0],setStateTo[1],forEnglish);}else{return _this.baseChooser(["Insert",["mv","nObliques"]],'n','insert',setStateTo[0],setStateTo[1],forEnglish);}}else if(currentEditMode==='nPhraseInsert'){return _this.baseChooser(["Insert",["np"]],'n','insert',setStateTo[0],setStateTo[1],forEnglish);}else if(currentEditMode==='cnObliqueInsert'){if(_this.state.cvnObliques.length>0){return _this.baseChooser(["Insert",["cv","nObliques",-1]],'n','insert',_this.state.npCase,_this.state.npCaseType,forEnglish);}else{return _this.baseChooser(["Insert",["cv","nObliques"]],'n','insert',_this.state.npCase,_this.state.npCaseType,forEnglish);}}else if(currentEditMode==='snObliqueInsert'){if(_this.state.svnObliques.length>0){return _this.baseChooser(["Insert",["sv","nObliques",-1]],'n','insert',_this.state.npCase,_this.state.npCaseType,forEnglish);}else{return _this.baseChooser(["Insert",["sv","nObliques"]],'n','insert',_this.state.npCase,_this.state.npCaseType,forEnglish);}}else if(currentEditMode==='mvnObliquepossessorinsert'){return _this.baseChooser(["Insert",["mv","nObliques",ind[0],-1]],'n','insert',_this.state.npCase,_this.state.npCaseType);}else if(currentEditMode==='mvnObliquepossessedinsert'){return _this.baseChooser(["Insert",["mv","nObliques",ind[0],0]],'n','insert',_this.state.npCase,_this.state.npCaseType);}else if(currentEditMode==='cvnObliquepossessorinsert'){return _this.baseChooser(["Insert",["cv","nObliques",ind[0],-1]],'n','insert',_this.state.npCase,_this.state.npCaseType);}else if(currentEditMode==='cvnObliquepossessedinsert'){return _this.baseChooser(["Insert",["cv","nObliques",ind[0],0]],'n','insert',_this.state.npCase,_this.state.npCaseType);}else if(currentEditMode==='svnObliquepossessorinsert'){return _this.baseChooser(["Insert",["sv","nObliques",ind[0],-1]],'n','insert',_this.state.npCase,_this.state.npCaseType);}else if(currentEditMode==='svnObliquepossessedinsert'){return _this.baseChooser(["Insert",["sv","nObliques",ind[0],0]],'n','insert',_this.state.npCase,_this.state.npCaseType);}else if(currentEditMode==='npnupdate'){return _this.baseChooser(["Update",["np","nBases",_this.state.npn.length-1-ind[0],ind[1]]],'n','updatebase');}else if(currentEditMode==='npnupdateEnglish'||currentEditMode==='npnupdateEnglishappositiveupdate'){// console.log(this.state.npn, this.state.npn.length-1-ind[0], ind[1])
return _this.baseChooser(["Update",["np","nBases",_this.state.npn.length-1-ind[0],ind[1]]],'n','updatebase');// return this.baseChooser(["Update",["np","nBases",this.state.npn.length-1-ind[0],this.state.npn[this.state.npn.length-1-ind[0]].length-1-ind[1]]],'n','updatebase')
}else if(currentEditMode==='npinsert'){return _this.baseChooser(["Insert",["np"]],'n','insert',_this.state.npCase,_this.state.npCaseType);}else if(currentEditMode==='npnpossessorinsert'){return _this.baseChooser(["Insert",["np","n",-1]],'n','insert');}else if(currentEditMode==='npnappositiveinsert'){// console.log(this.state.npn,ind)
return _this.baseChooser(["Insert",["np","n",_this.state.npn.length-1-ind[0],-1]],'n','insert');}else if(currentEditMode==='npnpossessedinsert'){return _this.baseChooser(["Insert",["np","n",0]],'n','insert');}else if(currentEditMode==='mvnsinsert'){return _this.baseChooser(["Insert",["mv","ns"]],'n','insert','Rel');}else if(currentEditMode==='mvnsupdate'){return _this.baseChooser(["Update",["mv","nsBases",_this.state.mvnsSegments.length-1-ind[0],ind[1]]],'n','updatebase');}else if((currentEditMode==='mvnsupdateEnglish'||currentEditMode==='mvnsupdateEnglishappositiveupdate')&&ind!==-1){// console.log(this.state.mvnsSegments, this.state.mvnsSegments.length-1-ind[0], ind[0],ind[1])
if(ind[0]!==undefined){return _this.baseChooser(["Update",["mv","nsBases",_this.state.mvnsSegments.length-1-ind[0],_this.state.mvnsSegments[_this.state.mvnsSegments.length-1-ind[0]].length-1-ind[1]]],'n','updatebase');}}else if((currentEditMode==='mvnoupdateEnglish'||currentEditMode==='mvnoupdateEnglishappositiveupdate')&&ind!==-1){if(ind[0]!==undefined){return _this.baseChooser(["Update",["mv","noBases",_this.state.mvnoSegments.length-1-ind[0],_this.state.mvnoSegments[_this.state.mvnoSegments.length-1-ind[0]].length-1-ind[1]]],'n','updatebase');}}else if(currentEditMode==='mvnsappositiveinsert'){return _this.baseChooser(["Insert",["mv","ns",_this.state.mvnsSegments.length-1-ind[0],-1]],'n','insert');}else if(currentEditMode==='mvnObliqueappositiveinsert'){return _this.baseChooser(["Insert",["mv","nObliques",ind[0],ind[1],-1]],'n','insert');}else if(currentEditMode==='cvnObliqueappositiveinsert'){return _this.baseChooser(["Insert",["cv","nObliques",ind[0],ind[1],-1]],'n','insert');}else if(currentEditMode==='svnObliqueappositiveinsert'){return _this.baseChooser(["Insert",["sv","nObliques",ind[0],ind[1],-1]],'n','insert');}else if(currentEditMode==='mvnspossessorinsert'){return _this.baseChooser(["Insert",["mv","ns",-1]],'n','insert');}else if(currentEditMode==='mvnspossessedinsert'){return _this.baseChooser(["Insert",["mv","ns",0]],'n','insert');}else if(currentEditMode==='mvnopossessedinsert'){return _this.baseChooser(["Insert",["mv","no",0]],'n','insert');}else if(currentEditMode==='mvnoinsert'){if(_this.state.mvvBase[1]==='it'){return _this.baseChooser(["Insert",["mv","no"]],'n','insert','io');}else{return _this.baseChooser(["Insert",["mv","no"]],'n','insert','Abs');}}else if(currentEditMode==='mvnoappositiveinsert'){return _this.baseChooser(["Insert",["mv","no",_this.state.mvnoSegments.length-1-ind[0],-1]],'n','insert');}else if(currentEditMode==='mvnoupdate'){return _this.baseChooser(["Update",["mv","noBases",_this.state.mvnoSegments.length-1-ind[0],ind[1]]],'n','updatebase');}else if(currentEditMode==='mvnopossessorinsert'){return _this.baseChooser(["Insert",["mv","no",-1]],'n','insert',null);}else if(currentEditMode==='cvupdate'){return _this.baseChooser(["Update",["cv","vBase"]],'v','update',_this.state.cvvMood,null);}else if(currentEditMode==='cvnsinsert'){return _this.baseChooser(["Insert",["cv","ns"]],'n','insert','Ind');}else if(currentEditMode==='cvnsupdate'){return _this.baseChooser(["Update",["cv","nsBases",_this.state.cvnsSegments.length-1-ind[0],ind[1]]],'n','updatebase');}else if((currentEditMode==='cvnsupdateEnglish'||currentEditMode==='cvnsupdateEnglishappositiveupdate')&&ind!==-1){if(ind[0]!==undefined){return _this.baseChooser(["Update",["cv","nsBases",_this.state.cvnsSegments.length-1-ind[0],_this.state.cvnsSegments[_this.state.cvnsSegments.length-1-ind[0]].length-1-ind[1]]],'n','updatebase');}}else if((currentEditMode==='cvnoupdateEnglish'||currentEditMode==='cvnsupdateEnglishappositiveupdate')&&ind!==-1){if(ind[0]!==undefined){return _this.baseChooser(["Update",["cv","noBases",_this.state.cvnoSegments.length-1-ind[0],_this.state.cvnoSegments[_this.state.cvnoSegments.length-1-ind[0]].length-1-ind[1]]],'n','updatebase');}}else if((currentEditMode==='svnoupdateEnglish'||currentEditMode==='cvnsupdateEnglishappositiveupdate')&&ind!==-1){if(ind[0]!==undefined){return _this.baseChooser(["Update",["sv","noBases",_this.state.svnoSegments.length-1-ind[0],_this.state.svnoSegments[_this.state.svnoSegments.length-1-ind[0]].length-1-ind[1]]],'n','updatebase');}}else if(currentEditMode==='cvnsappositiveinsert'){return _this.baseChooser(["Insert",["cv","ns",_this.state.cvnsSegments.length-1-ind[0],-1]],'n','insert');}else if(currentEditMode==='cvnspossessorinsert'){return _this.baseChooser(["Insert",["cv","ns",-1]],'n','insert');}else if(currentEditMode==='cvnoinsert'){return _this.baseChooser(["Insert",["cv","no"]],'n','insert','Ind');}else if(currentEditMode==='cvnoappositiveinsert'){return _this.baseChooser(["Insert",["cv","no",_this.state.cvnoSegments.length-1-ind[0],-1]],'n','insert');}else if(currentEditMode==='cvnoupdate'){return _this.baseChooser(["Update",["cv","noBases",_this.state.cvnoSegments.length-1-ind[0],ind[1]]],'n','updatebase');}else if(currentEditMode==='cvnopossessorinsert'){return _this.baseChooser(["Insert",["cv","no",-1]],'n','insert',null);}else if(currentEditMode==='cvnopossessedinsert'){return _this.baseChooser(["Insert",["cv","no",0]],'n','insert');}else if(currentEditMode==='cvnspossessedinsert'){return _this.baseChooser(["Insert",["cv","ns",0]],'n','insert');}else if(currentEditMode==='svnopossessedinsert'){return _this.baseChooser(["Insert",["sv","no",0]],'n','insert');}else if(currentEditMode==='svnoinsert'){return _this.baseChooser(["Insert",["sv","no"]],'n','insert','Ind');}else if(currentEditMode==='svnoappositiveinsert'){return _this.baseChooser(["Insert",["sv","no",_this.state.svnoSegments.length-1-ind[0],-1]],'n','insert');}else if(currentEditMode==='svnoupdate'){return _this.baseChooser(["Update",["sv","noBases",_this.state.svnoSegments.length-1-ind[0],ind[1]]],'n','updatebase');}else if(currentEditMode==='svnopossessorinsert'){return _this.baseChooser(["Insert",["sv","no",-1]],'n','insert',null);}else if(currentEditMode==='question'){return _this.menuItem('Question','Make Command','command',null,null);}};_this.getnCasenType=function(nObliques,ind){var nCase='';var nType='';if(ind!==undefined){if('nCase'in nObliques[ind]){nCase=nObliques[ind]['nCase'];}if('nType'in nObliques[ind]){nType=nObliques[ind]['nType'];}}return[nCase,nType];};_this.closeSubjectMenu=function(tag,addSubject,back){// console.log(tag, addSubject, this.state.crecentlyOpen)
if(addSubject){if(tag in _this.subjectMenu){if(_this.subjectMenu[tag]!==null){if(_this.state.addSubject&&window.innerWidth<480){_this.subjectMenu[tag].handleClose();}else{_this.subjectMenu[tag].close();}}}_this.setState({crecentlyOpen:tag,addSubject:true},function(){if(_this.state.addSubject&&window.innerWidth<480){_this.subjectMenu[tag].handleOpen();}else{_this.subjectMenu[tag].open();}});}else{if(tag in _this.subjectMenu){if(_this.subjectMenu[tag]!==null){if(_this.state.addSubject&&window.innerWidth<480){_this.subjectMenu[tag].handleClose();}else{_this.subjectMenu[tag].close();}}}_this.setState({crecentlyOpen:tag,addSubject:false},function(){if(back){_this.subjectMenu[tag].open();}});}};_this.editSubjectMenu=function(nounInsert,subject,tag,statevvs,update,backendcall,value,options){if(_this.state.addSubject&&window.innerWidth<480){var _ref5;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["w" /* Modal */],{style:{marginTop:0,minHeight:430},trigger:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:(_ref5={display:'inline-block',border:'solid 1px #22242626',marginRight:'2px',marginLeft:'2px',color:_this.getColor(tag),fontSize:'18px',padding:'8px 2px 8px 5px',borderRadius:'5px'},_defineProperty(_ref5,'marginRight','2px'),_defineProperty(_ref5,'marginLeft','2px'),_defineProperty(_ref5,'cursor','pointer'),_ref5)},options.map(function(k){return value==k['value']?k['text']:null;}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:_this.getColor(tag),fontSize:'16px',margin:0},name:'dropdown'})),on:'click',position:'bottom center'// positionFixed
// open={this.state.currentlyOpen === tag}
// style={{
// height:this.returnHeight(name),
// }}
,ref:function ref(element){_this.subjectMenu[tag]=element;},onOpen:function onOpen(){_this.setState({currentlyOpen:tag,overlayOn:true,candidateCall:[],candidateBase:[],candidateDisplay:[],unallowable_next_ids:[],nextTenses:[]});},onClose:function onClose(){_this.resetEditMenu();}// content={
// }
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingBottom:0}},_this.baseChooser(nounInsert,'n','insert','Abs','')));}else{var _ref6;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_reactjs_popup__["a" /* default */],{trigger:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:(_ref6={display:'inline-block',border:'solid 1px #22242626',marginRight:'2px',marginLeft:'2px',color:_this.getColor(tag),fontSize:'18px',padding:'8px 2px 8px 5px',borderRadius:'5px'},_defineProperty(_ref6,'marginRight','2px'),_defineProperty(_ref6,'marginLeft','2px'),_defineProperty(_ref6,'cursor','pointer'),_ref6)},options.map(function(k){return value==k['value']?k['text']:null;}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:_this.getColor(tag),fontSize:'16px',margin:0},name:'dropdown'})),on:'click',position:window.innerWidth<480?subject==='a subject'?'bottom left':'bottom right':'bottom center'// positionFixed
// open={this.state.currentlyOpen === tag}
// style={{
// height:this.returnHeight(name),
// }}
,ref:function ref(element){_this.subjectMenu[tag]=element;},onOpen:function onOpen(){_this.setState({currentlyOpen:tag,overlayOn:true,candidateCall:[],candidateBase:[],candidateDisplay:[],unallowable_next_ids:[],nextTenses:[]});},onClose:function onClose(){_this.resetEditMenu();}// content={
// }
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingBottom:0}},_this.state.addSubject?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,style:{display:'flex',flexDirection:'row',alignItems:'center',paddingLeft:'13px',marginBottom:'5px',marginTop:'10px'},onClick:function onClick(){_this.closeSubjectMenu(tag,false,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'chevron left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#666666'}},'Back')),_this.baseChooser(nounInsert,'n','insert','Abs','')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'tester',style:{display:'flex',flexDirection:'column',justifyContent:'center',marginTop:10}},subject.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,onClick:function onClick(){_this.closeSubjectMenu(tag,true);}},'Add '+subject):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{maxHeight:200,overflow:'auto',padding:0,marginBottom:8}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{style:{border:0},basic:true,vertical:true},options.map(function(k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{active:k['value']==statevvs.join(""),onClick:function onClick(){_this.closeSubjectMenu(tag,false,false);_this.backEndCall([[update,backendcall,k['value'].split('').map(Number)]]);}},k['text']);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{color:'grey',name:'chevron down'})))));}};_this.closeMainScreenMenuRef=function(name,currentEditMode){// console.log(this.mainScreenMenuRef, name, currentEditMode)
if(name in _this.mainScreenMenuRef){if(window.innerWidth<480){_this.mainScreenMenuRef[name].handleClose();}else{_this.mainScreenMenuRef[name].close();}}if(currentEditMode!=='default'){_this.setState({crecentlyOpen:name},function(){_this.setState({currentEditMode:currentEditMode});});}else{_this.setState({crecentlyOpen:''},function(){_this.setState({currentEditMode:currentEditMode});});}};_this.openMainScreenMenuRef=function(name){if(name in _this.mainScreenMenuRef){if(window.innerWidth<480){_this.mainScreenMenuRef[name].handleOpen();}else{_this.mainScreenMenuRef[name].open();}}};_this.mainScreenMenu=function(name,currentEditMode,setState,setStateTo,forEnglish){if(window.innerWidth<480){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["w" /* Modal */],{style:{marginTop:0,minHeight:430},trigger:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'solid 1px #22242626',fontSize:'16px',padding:'5px',borderRadius:'5px',marginRight:'2px',marginLeft:'2px',cursor:'pointer',textAlign:'center',color:'#00000099'}},name),ref:function ref(element){_this.mainScreenMenuRef[name]=element;},onOpen:function onOpen(){_this.setState({candidateCall:[],candidateBase:[],candidateDisplay:[],unallowable_next_ids:[],nextTenses:[]// activeIndexes1:['verbs'],	        		
});if(setState==='npCase'){_this.setState({npCase:setStateTo[0],npCaseType:setStateTo[1]});}else if(setState==='mvvType'){_this.setState({mvvType:setStateTo[0]});}else if(setState==='mvinsertqaa'){_this.setState({mvvMood:setStateTo[0],mvvType:setStateTo[1]});}else if(setState==='cvvType'){_this.setState({cvvMood:setStateTo[0],cvvType:setStateTo[1]});}else if(setState==='svvType'){_this.setState({svvType:setStateTo[0]});}else if(setState==='optCase'){_this.setState({optCase:setStateTo[0],mvvType:setStateTo[1]});}_this.setState({currentlyOpen:name,crecentlyOpen:name,currentEditMode:currentEditMode,overlayOn:true});},onClose:function onClose(){if(_this.state.mvvBase.length===0){_this.setState({mvvMood:'',mvvType:''});}_this.setState({currentlyOpen:'',cvvMood:'',cvvType:'',svvType:'',optCase:'',npCase:'',npCaseType:'',containsTime:false,activeIndexes1:[],candidateCall:[],candidateBase:[],lockSubmit:false,nextTenses:[],candidateDisplay:[],searchQuery:'',wordsList:[]});}},_this.contentItems(currentEditMode,currentEditMode,-1,true,forEnglish,setStateTo));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_reactjs_popup__["a" /* default */],{trigger:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'solid 1px #22242626',fontSize:'16px',padding:'5px',borderRadius:'5px',marginRight:'2px',marginLeft:'2px',cursor:'pointer',textAlign:'center',color:'#00000099'}},name),position:'bottom center',ref:function ref(element){_this.mainScreenMenuRef[name]=element;},onOpen:function onOpen(){_this.setState({candidateCall:[],candidateBase:[],candidateDisplay:[],unallowable_next_ids:[],nextTenses:[]});if(setState==='npCase'){_this.setState({npCase:setStateTo[0],npCaseType:setStateTo[1]});}else if(setState==='mvvType'){_this.setState({mvvType:setStateTo[0]});}else if(setState==='mvinsertqaa'){_this.setState({mvvMood:setStateTo[0],mvvType:setStateTo[1]});}else if(setState==='cvvType'){_this.setState({cvvMood:setStateTo[0],cvvType:setStateTo[1]});}else if(setState==='svvType'){_this.setState({svvType:setStateTo[0]});}else if(setState==='optCase'){_this.setState({optCase:setStateTo[0],mvvType:setStateTo[1]});}_this.setState({currentlyOpen:name,crecentlyOpen:name,currentEditMode:currentEditMode,overlayOn:true});},onClose:function onClose(){if(_this.state.mvvBase.length===0){_this.setState({mvvMood:'',mvvType:''});}_this.setState({currentlyOpen:'',cvvMood:'',cvvType:'',svvType:'',optCase:'',npCase:'',npCaseType:'',containsTime:false,activeIndexes1:[],candidateCall:[],candidateBase:[],lockSubmit:false,nextTenses:[],candidateDisplay:[],searchQuery:'',wordsList:[]});}},_this.contentItems(currentEditMode,currentEditMode,-1,true,forEnglish,setStateTo));}};_this.editMenuRefClose=function(closeoropen,typeInd,currentEditMode){if(window.innerWidth<480&&_this.state.currentEditMode!=='default'){if(closeoropen=='open'){_this.editMenuRef[typeInd].handleOpen();}else{_this.editMenuRef[typeInd].handleClose();}}else{if(closeoropen=='open'){_this.editMenuRef[typeInd].open();}else{_this.editMenuRef[typeInd].close();}}};_this.closeEditMenuRef=function(typeInd,currentEditMode,turnOffAndOn){// console.log(typeInd,currentEditMode)
if(turnOffAndOn){if(typeInd in _this.editMenuRef){_this.editMenuRefClose('close',typeInd,currentEditMode);}_this.setState({currentEditMode:currentEditMode},function(){_this.editMenuRefClose('open',typeInd,currentEditMode);});}else{// console.log(this.editMenuRef, typeInd, typeInd in this.editMenuRef)
if(typeInd in _this.editMenuRef){if(_this.editMenuRef[typeInd]!==null){_this.editMenuRefClose('close',typeInd,currentEditMode);}}_this.setState({currentEditMode:'default',currentlyOpen:''});}};_this.resetEditMenu=function(){_this.setState({activeIndexes1:[],lockSubmit:false,searchQuery:'',wordsList:[],containsTime:false,overlayOn:false// candidateCall:[],
// candidateBase:[],
// candidateDisplay:[],
// unallowable_next_ids:[],
// nextTenses:[],
});};_this.checkIfIntrgTense=function(type,ind){// console.log(type, ind)
if(type=='mvEnglish2'&&_this.state.mvvMood==='Intrg'&&(_this.state.mvvType==='Intrg4'||_this.state.mvvType==='Intrg5')){if(_this.state.mvvType==='Intrg4'&&_this.state.candidateDisplay.length===0){// console.log(popularVPostbases)
var p='0';_this.setState({candidateBase:_this.state.candidateBase.concat([[__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[p]['expression']]['keylookup'],popularVPostbases[p]['expression']]]),candidateDisplay:_this.state.candidateDisplay.concat([[_this.processStyledPostbaseText(popularVPostbases[p],'1',undefined,'mv','Intrg',undefined),__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[p]['expression']]['exp']]]),unallowable_next_ids:_this.state.unallowable_next_ids.concat([[popularVPostbases[p]['allowable_next_ids']]]),nextTenses:__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[p]['expression']]['match_case']&&!('gen_preverb_after'in __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[p]['expression']])?_this.state.nextTenses.length==0?_this.state.nextTenses.concat(['gen']):_this.state.nextTenses.concat([_this.state.nextTenses[_this.state.nextTenses.length-1]]):_this.state.nextTenses.concat([__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[p]['expression']]['gen_preverb_after']])},function(){_this.updateCandidateCall('v','insert','Intrg','Intrg4','p');});}else if(_this.state.mvvType==='Intrg5'&&_this.state.candidateDisplay.length===0){var _p='2';_this.setState({candidateBase:_this.state.candidateBase.concat([[__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[_p]['expression']]['keylookup'],popularVPostbases[_p]['expression']]]),candidateDisplay:_this.state.candidateDisplay.concat([[_this.processStyledPostbaseText(popularVPostbases[_p],'1',undefined,'mv','Intrg',undefined),__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[_p]['expression']]['exp']]]),unallowable_next_ids:_this.state.unallowable_next_ids.concat([[popularVPostbases[_p]['allowable_next_ids']]]),nextTenses:__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[_p]['expression']]['match_case']&&!('gen_preverb_after'in __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[_p]['expression']])?_this.state.nextTenses.length==0?_this.state.nextTenses.concat(['gen']):_this.state.nextTenses.concat([_this.state.nextTenses[_this.state.nextTenses.length-1]]):_this.state.nextTenses.concat([__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularVPostbases[_p]['expression']]['gen_preverb_after']])},function(){_this.updateCandidateCall('v','insert','Intrg','Intrg5','p');});}}else{_this.setState({candidateCall:[],candidateBase:[],candidateDisplay:[],unallowable_next_ids:[],nextTenses:[]});}};_this.editMenu=function(type,ind){// console.log(type, ind)
var typeInd=type+(ind+1).toString();if(window.innerWidth<480&&_this.state.currentEditMode!=='default'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["w" /* Modal */],{style:{marginTop:0,minHeight:430},trigger:_this.triggerItems(type,ind),onOpen:function onOpen(){_this.checkIfIntrgTense(type,ind);_this.setState({cpreviousEditMode:_this.state.currentEditMode,currentlyOpen:typeInd,crecentlyOpen:typeInd,overlayOn:true});},onClose:function onClose(){_this.resetEditMenu();},position:'bottom center',ref:function ref(element){_this.editMenuRef[typeInd]=element;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.contentItems(_this.state.currentEditMode,type,ind,false)));}else{var position='bottom center';if(window.innerWidth<480){if(type==='npnEnglish1'||type==='mvEnglish1'||type==='cvEnglish1'||type=='mvnObliquesEnglish1'||type=='cvnObliquesEnglish1'||type=='svnObliquesEnglish1'){position='bottom left';}else if(type==='npnEnglish2'||type==='cvEnglish2'||type==='cvnsEnglish2'||type==='mvnsEnglish2'||type==='cvnoEnglish2'||type==='mvnoEnglish2'){position='bottom right';}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_reactjs_popup__["a" /* default */],{trigger:_this.triggerItems(type,ind),onOpen:function onOpen(){_this.checkIfIntrgTense(type,ind);_this.setState({cpreviousEditMode:_this.state.currentEditMode,currentlyOpen:typeInd,crecentlyOpen:typeInd,overlayOn:true});},onClose:function onClose(){_this.resetEditMenu();},position:position,ref:function ref(element){_this.editMenuRef[typeInd]=element;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this.contentItems(_this.state.currentEditMode,type,ind,false)));}};_this.handleClick=function(index,allowAdd){// console.log(e,titleProps.id)
// this.setState({ loaderOn: true });
// const index = titleProps.id;
var activeIndexes=_this.state.activeIndexes;var newIndex=_this.state.activeIndexes.slice();// const newIndex = []
// const newIndex = activeIndex === index ? -1 : index;
var currentIndexPosition=activeIndexes.indexOf(index);// console.log(currentIndexPosition, activeIndexes, index)
if(currentIndexPosition>-1){newIndex.splice(currentIndexPosition,1);}else{if(allowAdd){// newIndex.push(index); //this allows multiple open  
newIndex=[index];//restricts open to one at a time
_this.setState({searchQuery:'',wordsList:[]});}}// 	let tag = this.state.currentlyOpen
// this.setState({currentlyOpen:''},()=>{this.setState({currentlyOpen:tag})})
// console.log(newIndex)
// newIndex.map((k)=>{
// 	console.log()
// })
// let mood = moods[index];
// if (newIndex !== -1) {   
// this.getEndings(this.state.parses[currentIndex],mood);
// }
_this.setState({activeIndexes:newIndex});};_this.handleClick1=function(index,allowAdd){// console.log(e,titleProps.id)
// this.setState({ loaderOn: true });
// const index = titleProps.id;
var activeIndexes1=_this.state.activeIndexes1;// const newIndex = this.state.activeIndexes1.slice()
var newIndex=[];// const newIndex = activeIndex === index ? -1 : index;
var currentIndexPosition=activeIndexes1.indexOf(index);// console.log(currentIndexPosition, activeIndexes, index)
if(currentIndexPosition>-1){newIndex.splice(currentIndexPosition,1);}else{if(allowAdd){newIndex.push(index);_this.setState({searchQuery:'',wordsList:[]});}}// 	let tag = this.state.currentlyOpen
// this.setState({currentlyOpen:''},()=>{this.setState({currentlyOpen:tag})})
// console.log(newIndex)
// newIndex.map((k)=>{
// 	console.log()
// })
// let mood = moods[index];
// if (newIndex !== -1) {   
// this.getEndings(this.state.parses[currentIndex],mood);
// }
_this.setState({activeIndexes1:newIndex});};_this.subMenuItem=function(type,ind1,ind2){if(type==='addCV'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,style:{paddingBottom:'2px'},active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Add Connective Verb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Prec',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'before...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Cnsq',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'because...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Cont',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'whenever...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Conc',cvvType:'eventhough'},function(){_this.menuSelect('cvinsert',-1);});}},'even though...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Conc',cvvType:'evenif'},function(){_this.menuSelect('cvinsert',-1);});}},'even if...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Cond',cvvType:'if'},function(){_this.menuSelect('cvinsert',-1);});}},'if...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Cond',cvvType:'wheninthefuture'},function(){_this.menuSelect('cvinsert',-1);});}},'when (in future)...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'CtmpI',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'when (in past)...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'CtmpII',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'while...'))));}else if(type==='addAnotherVerbPhrase'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,style:{paddingBottom:'2px'},active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Add another verb phrase'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Prec',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'before he...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Cnsq',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'because he...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Cont',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'whenever he...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Conc',cvvType:'eventhough'},function(){_this.menuSelect('cvinsert',-1);});}},'even though he...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Conc',cvvType:'evenif'},function(){_this.menuSelect('cvinsert',-1);});}},'even if he...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Cond',cvvType:'if'},function(){_this.menuSelect('cvinsert',-1);});}},'if he...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'Cond',cvvType:'wheninthefuture'},function(){_this.menuSelect('cvinsert',-1);});}},'when (in future) he...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'CtmpI',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'when (in past) he...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({cvvMood:'CtmpII',cvvType:''},function(){_this.menuSelect('cvinsert',-1);});}},'while he...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({svvType:'by'},function(){_this.menuSelect('svinsert',-1);});}},'by...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({svvType:'being'},function(){_this.menuSelect('svinsert',-1);});}},'being...'))));}else if(type==='addQuestion'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Ask a Question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvMood:'Ind',mvvType:'qaa'},function(){_this.menuSelect('mvinsertqaa',-1);});}},'yes or no question...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg0'},function(){_this.menuSelect('questionInsert',-1);});}},'who is (subject)...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg1'},function(){_this.menuSelect('questionInsert',-1);});}},'to whom (object)...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg2'},function(){_this.menuSelect('questionInsert',-1);});}},'what is (subject)...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg3'},function(){_this.menuSelect('questionInsert',-1);});}},'to what (object)...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg4'},function(){_this.menuSelect('questionInsert',-1);});}},'when did...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg5'},function(){_this.menuSelect('questionInsert',-1);});}},'when will...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg6'},function(){_this.menuSelect('questionInsert',-1);});}},'where is...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg7'},function(){_this.menuSelect('questionInsert',-1);});}},'from where is...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg8'},function(){_this.menuSelect('questionInsert',-1);});}},'to where is...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'Intrg9'},function(){_this.menuSelect('questionInsert',-1);});}},'why is...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({mvvType:'IntrgA'},function(){_this.menuSelect('questionInsert',-1);});}},'how is...?'))));}else if(type==='addCommand'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Make a Command'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({optCase:'Opt][PRS',mvvType:''},function(){_this.menuSelect('commandInsert',-1);});}},'command right now'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({optCase:'Opt][FUT',mvvType:''},function(){_this.menuSelect('commandInsert',-1);});}},'command in future'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({optCase:'Opt][PRS][NEG',mvvType:''},function(){_this.menuSelect('commandInsert',-1);});}},'do not ...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({optCase:'Opt][FUT][NEG',mvvType:''},function(){_this.menuSelect('commandInsert',-1);});}},'do not ... (future)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({optCase:'Sbrd',mvvType:''},function(){_this.menuSelect('commandInsert',-1);});}},'polite request'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({optCase:'Sbrd',mvvType:'neg'},function(){_this.menuSelect('commandInsert',-1);});}},'polite do not...'))));}else if(type==='nounPhrase'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Make a noun phrase'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Abs',npCaseType:''},function(){_this.menuSelect('nPhraseInsert',-1);});}},'the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Abl_Mod',npCaseType:'from'},function(){_this.menuSelect('nPhraseInsert',-1);});}},'from...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Abl_Mod',npCaseType:'io'},function(){_this.menuSelect('nPhraseInsert',-1);});}},'a or some...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Loc',npCaseType:''},function(){_this.menuSelect('nPhraseInsert',-1);});}},'in, at...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Ter',npCaseType:''},function(){_this.menuSelect('nPhraseInsert',-1);});}},'to...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Via',npCaseType:''},function(){_this.menuSelect('nPhraseInsert',-1);});}},'through, using...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Equ',npCaseType:''},function(){_this.menuSelect('nPhraseInsert',-1);});}},'like, similar to...'))));}else if(type==='addnOblique'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,style:{paddingBottom:'2px'},active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Add location, direction, etc.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Loc',npCaseType:''},function(){_this.menuSelect('nObliqueInsert',-1);});}},'in or at the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Ter',npCaseType:''},function(){_this.menuSelect('nObliqueInsert',-1);});}},'to the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Abl_Mod',npCaseType:'from'},function(){_this.menuSelect('nObliqueInsert',-1);});}},'from the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Via',npCaseType:''},function(){_this.menuSelect('nObliqueInsert',-1);});}},'through, using...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Equ',npCaseType:''},function(){_this.menuSelect('nObliqueInsert',-1);});}},'like a...'))));}else if(type==='caddnOblique'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,style:{paddingBottom:'2px'},active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Add location, direction, etc.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Loc',npCaseType:''},function(){_this.menuSelect('cnObliqueInsert',-1);});}},'in or at the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Ter',npCaseType:''},function(){_this.menuSelect('cnObliqueInsert',-1);});}},'to the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Abl_Mod',npCaseType:'from'},function(){_this.menuSelect('cnObliqueInsert',-1);});}},'from the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Via',npCaseType:''},function(){_this.menuSelect('cnObliqueInsert',-1);});}},'through, using...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Equ',npCaseType:''},function(){_this.menuSelect('cnObliqueInsert',-1);});}},'like a...'))));}else if(type==='saddnOblique'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,style:{paddingBottom:'2px'},active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Add location, direction, etc.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Loc',npCaseType:''},function(){_this.menuSelect('snObliqueInsert',-1);});}},'in or at the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Ter',npCaseType:''},function(){_this.menuSelect('snObliqueInsert',-1);});}},'to the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Abl_Mod',npCaseType:'from'},function(){_this.menuSelect('snObliqueInsert',-1);});}},'from the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Via',npCaseType:''},function(){_this.menuSelect('snObliqueInsert',-1);});}},'through, using...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({npCase:'Equ',npCaseType:''},function(){_this.menuSelect('snObliqueInsert',-1);});}},'like a...'))));}else if(type==='addSV'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,style:{paddingBottom:'2px'},active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Add Subordinative Verb'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({svvType:'by'},function(){_this.menuSelect('svinsert',-1);});}},'by...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.setState({svvType:'being'},function(){_this.menuSelect('svinsert',-1);});}},'being...'))));}else if(type==='changeCVtype'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Change Connective Verb Phrase'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',cvvMood:'Prec',cvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["cv","vMood"],_this.state.cvvMood]]);});}},'before...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',cvvMood:'Cnsq',cvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["cv","vMood"],_this.state.cvvMood]]);});}},'because...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',cvvMood:'Cont',cvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["cv","vMood"],_this.state.cvvMood]]);});}},'whenever...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',cvvMood:'Conc',cvvType:'eventhough',isOpen:false},function(){_this.backEndCall([["Update",["cv","vMood"],_this.state.cvvMood],["Update",["cv","vType"],_this.state.cvvType]]);});}},'even though...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',cvvMood:'Conc',cvvType:'evenif',isOpen:false},function(){_this.backEndCall([["Update",["cv","vMood"],_this.state.cvvMood],["Update",["cv","vType"],_this.state.cvvType]]);});}},'even if...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',cvvMood:'Cond',cvvType:'if',isOpen:false},function(){_this.backEndCall([["Update",["cv","vMood"],_this.state.cvvMood],["Update",["cv","vType"],_this.state.cvvType]]);});}},'if...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',cvvMood:'Cond',cvvType:'wheninthefuture',isOpen:false},function(){_this.backEndCall([["Update",["cv","vMood"],_this.state.cvvMood],["Update",["cv","vType"],_this.state.cvvType]]);});}},'when (in future)...'),_this.state.mvvMood.includes('Opt')||_this.state.mvvMood==='Sbrd'?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',cvvMood:'CtmpI',cvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["cv","vMood"],_this.state.cvvMood]]);});}},'when (in past)...'),_this.state.mvvMood.includes('Opt')||_this.state.mvvMood==='Sbrd'?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',cvvMood:'CtmpII',cvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["cv","vMood"],_this.state.cvvMood]]);});}},'while...'))));}else if(type==='changeQuestiontype'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,style:{paddingBottom:'2px'},active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Change Question Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Ind',mvvType:'qaa',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Ind'],["Update",["mv","vType"],'qaa']]);});}},'(yes or no question)?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg0',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg0']]);});}},'who is (subject)...?'),_this.state.mvvBase[1]!='i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg1',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg1']]);});}},'to whom (object)...?'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg2',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg2']]);});}},'what is (subject)...?'),_this.state.mvvBase[1]!='i'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg3',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg3']]);});}},'to what (object)...?'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg4',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg4']]);});}},'when did...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg5',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg5']]);});}},'when will...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg6',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg6']]);});}},'where is...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg7',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg7']]);});}},'from where is...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg8',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg8']]);});}},'to where is...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'Intrg9',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'Intrg9']]);});}},'why is...?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',mvvMood:'Intrg',mvvType:'IntrgA',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Intrg'],["Update",["mv","vType"],'IntrgA']]);});}},'how is...?'))));}else if(type=='switchOptative'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,active:_this.state.activeIndexes.includes(type),onClick:function onClick(){_this.handleClick(type,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Change Command Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes.includes(type)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',optCase:'Opt][PRS',mvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Opt][PRS']]);});}},'command right now'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',optCase:'Opt][FUT',mvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Opt][FUT']]);});}},'command in future'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',optCase:'Opt][PRS][NEG',mvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Opt][PRS][NEG']]);});}},'do not ...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',optCase:'Opt][FUT][NEG',mvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Opt][FUT][NEG']]);});}},'do not ... (future)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',optCase:'Sbrd',mvvType:'',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Sbrd']]);});}},'polite request'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',optCase:'Sbrd',mvvType:'neg',isOpen:false},function(){_this.backEndCall([["Update",["mv","vMood"],'Sbrd'],["Insert",["mv"],[_this.state.mvvBase[0].concat([['+peke-|+vke-,+pege-|+vke-',0,0,0]]),_this.state.mvvBase[1],'Sbrd']]]);});}},'polite do not...'))));}else if(type=='changeNPtype'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,active:true// style={{paddingBottom:'2px'}}
// active={this.state.activeIndexes.includes(type)}
// onClick={()=>{this.handleClick(type,true)}}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Change Noun Phrase Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',npCase:'Abs',npCaseType:'',npnType:'',isOpen:false},function(){_this.backEndCall([["Update",["np","nCase"],'Abs']]);});}},'the...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',npCase:'Rel',npCaseType:'',npnType:'',isOpen:false},function(){_this.backEndCall([["Update",["np","nCase"],'Rel']]);});}},'the (relative)...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',npCase:'Abl_Mod',npCaseType:'from',npnType:'',isOpen:false},function(){_this.backEndCall([["Update",["np","nCase"],'Abl_Mod'],["Update",["np","nType"],'from']]);});}},'from...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',npCase:'Abl_Mod',npCaseType:'io',npnType:'',isOpen:false},function(){_this.backEndCall([["Update",["np","nCase"],'Abl_Mod'],["Update",["np","nType"],'io']]);});}},'a or some...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',npCase:'Loc',npCaseType:'',npnType:'',isOpen:false},function(){_this.backEndCall([["Update",["np","nCase"],'Loc']]);});}},'in or at...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',npCase:'Ter',npCaseType:'',npnType:'',isOpen:false},function(){_this.backEndCall([["Update",["np","nCase"],'Ter']]);});}},'to...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',npCase:'Via',npCaseType:'',npnType:'',isOpen:false},function(){_this.backEndCall([["Update",["np","nCase"],'Via']]);});}},'through, using...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:'',npCase:'Equ',npCaseType:'',npnType:'',isOpen:false},function(){_this.backEndCall([["Update",["np","nCase"],'Equ']]);});}},'like, similar to...'))));}else if(type=='changeVObliquetype'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:type,active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Change Noun Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:''},function(){_this.backEndCall([["Update",[ind1,"nObliques",ind2,'nCase'],'Abl_Mod'],["Update",[ind1,"nObliques",ind2,'nType'],'from']]);});}},'from...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:''},function(){_this.backEndCall([["Update",[ind1,"nObliques",ind2,'nCase'],'Abl_Mod'],["Update",[ind1,"nObliques",ind2,'nType'],'io']]);});}},'a or some...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:''},function(){_this.backEndCall([["Update",[ind1,"nObliques",ind2,'nCase'],'Loc']]);});}},'in or at...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:''},function(){_this.backEndCall([["Update",[ind1,"nObliques",ind2,'nCase'],'Ter']]);});}},'to...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:''},function(){_this.backEndCall([["Update",[ind1,"nObliques",ind2,'nCase'],'Via']]);});}},'through, using...'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this.editMenuRef[_this.state.currentlyOpen].close();_this.setState({currentlyOpen:''},function(){_this.backEndCall([["Update",[ind1,"nObliques",ind2,'nCase'],'Equ']]);});}},'like, similar to...'))));}};_this.menuItem=function(type,text,endRequirement,mood,backEnd){if(type==='Update'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */].Item,{name:'messages'// active={this.state.activeItem === 'messages'}
,style:{display:'flex',flexDirection:'row',alignItems:'center',paddingRight:'13px'},onClick:function onClick(){_this.closeEditMenuRef(_this.state.crecentlyOpen,'default',false);if(text=='Change to Command'){_this.setState({isOpen:false,optCase:"Opt][PRS",currentEditMode:'default'},function(){_this.backEndCall(backEnd);});}else if(text=='Change to Statement'){_this.setState({isOpen:false,optCase:"",currentEditMode:'default'},function(){_this.backEndCall(backEnd);});}else{_this.setState({isOpen:false,currentEditMode:'default'},function(){_this.backEndCall(backEnd);});}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,text));}if(type==='Delete'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */].Item,{name:'messages'// active={this.state.activeItem === 'messages'}
,style:{display:'flex',flexDirection:'row',alignItems:'center',paddingRight:'13px'},onClick:function onClick(){// console.log(backEnd)
_this.closeEditMenuRef(_this.state.crecentlyOpen,'default',false);_this.setState({isOpen:false,currentEditMode:'default'},function(){_this.backEndCall(backEnd);});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,text));}if(type==='BaseChooser'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["u" /* Menu */].Item,{name:'messages'// active={this.state.activeItem === 'messages'}
,style:{display:'flex',flexDirection:'row',alignItems:'center',paddingRight:'13px'},onClick:function onClick(){_this.menuSelect(endRequirement);}// onClose={()=>{this.setState({searchQuery:'',wordsList:[]})}}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,text));}};_this.updateCandidateCall=function(type,update,mood,submood,pos){// console.log(type, update, mood, submood,this.state.candidateBase)
var lockSubmit=false;var candidateFST=[];var transitivity='';var containsTime=false;_this.state.candidateBase.slice().reverse().map(function(x,xind){if(Array.isArray(x)){if(['-llru¹-','-ksaite-','+ciqe-|@ciiqe-','@~+ngaite-','@~+niarar-','-qatar-'].includes(x[0][0])){containsTime=true;}}if(xind===0){if(!Array.isArray(x)){lockSubmit=true;transitivity=x['type'];if(transitivity=='n'&&type=='v'){transitivity='i';}_this.setState({endingAdjusted:''});candidateFST.push([x['key'],0,x['usageIndex'],0]);}else{// console.log(x[1],!newpostbases[x[1]]['match_case'])
if(!('post_verb'in __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][x[1]])){_this.setState({addIs:false});}if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][x[1]]['type']=='VN'||__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][x[1]]['type']=='VV'){lockSubmit=false;_this.setState({endingAdjusted:'v'});}else{lockSubmit=false;_this.setState({endingAdjusted:'n'});_this.setState({nounNum:__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][x[1]]['nounNum']});}candidateFST.push([x[0][0],0,x[0][1],0]);}}else{if(!Array.isArray(x)){candidateFST.push([x['key'],0,x['usageIndex'],0]);}else{candidateFST.push([x[0][0],0,x[0][1],0]);}}});_this.setState({containsTime:containsTime});if(_this.state.candidateBase.length===0){_this.setState({endingAdjusted:''});}// candidateFST = [candidateFST]
// console.log(candidateFST, transitivity)
if(update==='insert'){if(type==='n'){if(mood===undefined){_this.setState({candidateCall:[candidateFST,[0,0,0,1]],lockSubmit:lockSubmit});}else{_this.setState({candidateCall:[candidateFST,[0,0,0,1],mood,submood],lockSubmit:lockSubmit});}}else if(type==='v'){if(mood==='Ind'){_this.setState({candidateCall:[candidateFST,transitivity,mood],lockSubmit:lockSubmit});}else if(mood==='Intrg'){_this.setState({candidateCall:[candidateFST,transitivity,mood,submood],lockSubmit:lockSubmit});}else{_this.setState({candidateCall:[candidateFST,transitivity,mood,submood],lockSubmit:lockSubmit});}}}else if(update==='update'){if(type==='n'){_this.setState({candidateCall:[candidateFST,[0,0,0,1]],lockSubmit:lockSubmit});}else if(type==='v'){_this.setState({candidateCall:[candidateFST,transitivity],lockSubmit:lockSubmit});}}else if(update==='updatebase'){if(type==='n'){_this.setState({candidateCall:candidateFST,lockSubmit:lockSubmit});}}};_this.processStyledMainText=function(key,forEnglish,verbtype,mood){// console.log(key,this.state.startingCase,this.state.mvvs,this.state.mvvsPlanned,this.state.nextTenses)
var verbAdd='';var sentence=key['englishmain'];var startingCase='';var vsPlanned=[];// console.log(key,forEnglish, verbtype, mood)
if(forEnglish!==undefined){startingCase=forEnglish[0];vsPlanned=forEnglish[1];}else{if(verbtype=='cv'){vsPlanned=_this.state.cvvs;}else{vsPlanned=_this.state.mvvs;}}// if (mood === 'mv') {console.log(key, mood, forEnglish, startingCase, vsPlanned)}
// console.log(key, forEnglish, startingCase)
if(key['type']=='n'){sentence=key['englishraw'].replaceAll('⟨','').replaceAll('⟩','');// sentence = key['englishraw']
// let verbMatches = key['englishraw'].match(/\⟨.*?\⟩/g)
// if (this.state.nounNum == 'p') {
// 	verbAdd = key['englishtenses'][this.state.nounIndexChosen][1]
// } else {
// 	verbAdd = key['englishtenses'][this.state.nounIndexChosen][0]
// }
// if (verbMatches !== null) {
// 	verbMatches.map((m) => sentence = sentence.replace(m,verbAdd))	
// }
}else{sentence=key['englishmain'];if(_this.state.nextTenses.length>0){if(_this.state.addIs&&key['englishtenses'][2]=='is'||_this.state.nextTenses[_this.state.nextTenses.length-1]==='gen'){if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='p'||_this.state.nextTenses[_this.state.nextTenses.length-1]==='pp'){if(vsPlanned[0]==1&&vsPlanned[1]==1){sentence=sentence.replace('!is!','was');}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1||vsPlanned.length===0){sentence=sentence.replace('!is!','was');}else{sentence=sentence.replace('!is!','were');}}else{if(vsPlanned[0]==1&&vsPlanned[1]==1){sentence=sentence.replace('!is!','am');}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1||vsPlanned.length===0){sentence=sentence.replace('!is!','is');}else{sentence=sentence.replace('!is!','are');}}}else{// console.log(this.state.nextTenses[this.state.nextTenses.length-1], key['englishtenses'], key['englishraw'])
if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='p'){if(['Intrg4','Intrg5','Intrg6','Intrg7','Intrg8','Intrg9','IntrgA'].includes(_this.state.mvvType)){verbAdd=key['englishtenses'][0];}else{verbAdd=key['englishtenses'][1];}}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='g'){verbAdd=key['englishtenses'][3];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='i'){verbAdd=key['englishtenses'][0];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='pp'){verbAdd=key['englishtenses'][4];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='past'){verbAdd=key['englishtenses'][1];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='present'){verbAdd=key['englishtenses'][2];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='gen2'){verbAdd=key['englishtenses'][2];}sentence=key['englishraw'];var verbMatches=key['englishraw'].match(/\⟨.*?\⟩/g);if(verbMatches!==null){verbMatches.map(function(m){return sentence=sentence.replace(m,verbAdd);});}}}else{if(startingCase.length>0){if(startingCase==='p'){verbAdd=key['englishtenses'][1];}else if(startingCase==='g'){verbAdd=key['englishtenses'][3];}else if(startingCase==='i'){verbAdd=key['englishtenses'][0];}else if(startingCase==='pp'){verbAdd=key['englishtenses'][4];}else if(startingCase==='gen'){verbAdd=key['englishtenses'][2];}else if(startingCase==='gen2'){verbAdd=key['englishtenses'][2];}else if(startingCase==='past'){verbAdd=key['englishtenses'][1];}else if(startingCase==='present'){verbAdd=key['englishtenses'][2];}sentence=key['englishraw'];var _verbMatches=key['englishraw'].match(/\⟨.*?\⟩/g);if(_verbMatches!==null){_verbMatches.map(function(m){return sentence=sentence.replace(m,verbAdd);});}sentence=sentence.replace('!is!','');}else{var specialStartingCase=_this.returnBaseCaseforMoods(verbtype,mood,vsPlanned);// console.log(verbtype,mood,vsPlanned)
// console.log(key,specialStartingCase)
var s0=specialStartingCase[0];var s1=specialStartingCase[1];if(s0==='gen'){sentence=key['englishmain'].replace('!is!',s1);}else if(key['englishtenses'][0]=='be'&&s1.length>0){sentence=key['englishmain'].replace('!is!',s1);}else{if(s0==='p'){verbAdd=key['englishtenses'][1];}else if(s0==='g'){verbAdd=key['englishtenses'][3];}else if(s0==='i'){verbAdd=key['englishtenses'][0];}else if(s0==='pp'){verbAdd=key['englishtenses'][4];}else if(s0==='gen'){verbAdd=key['englishtenses'][2];}else if(s0==='gen2'){verbAdd=key['englishtenses'][2];}else if(s0==='past'){verbAdd=key['englishtenses'][1];}else if(s0==='present'){verbAdd=key['englishtenses'][2];}sentence=key['englishraw'];var _verbMatches2=key['englishraw'].match(/\⟨.*?\⟩/g);if(_verbMatches2!==null){_verbMatches2.map(function(m){return sentence=sentence.replace(m,verbAdd);});}}// if (key['englishtenses'][0]==='be') {
// 	sentence = sentence.replace('!is!',s1[1])	
// } else {
// 	sentence = sentence.replace('!is!',s1[0])	
// }
// if (this.state.mvvs.length > 0) {
// 	if (this.state.mvvs[0] == 1 && this.state.mvvs[1] == 1)	{
// 		sentence = sentence.replace('!is!','am')
// 	} else if ((this.state.mvvs[0] == 3 && this.state.mvvs[1] == 1) || this.state.mvvs.length === 0) {
// 		sentence = sentence.replace('!is!','is')
// 	} else {
// 		sentence = sentence.replace('!is!','are')
// 	}						
// } else {
// 	if (mvvsPlanned[0] == 1 && mvvsPlanned[1] == 1)	{
// 		sentence = sentence.replace('!is!','am')
// 	} else if ((mv(vsPlanned[0] == 3 || vsPlanned[0] == 4) && mvvsPlanned[1] == 1) || mvvsPlanned.length === 0) {
// 		sentence = sentence.replace('!is!','is')
// 	} else {
// 		sentence = sentence.replace('!is!','are')
// 	}
// }
}}}sentence=_this.returnPossessor(sentence,forEnglish,vsPlanned);sentence=sentence.replace('[he or it]','');// if (sentence.includes('[')) {
// 	console.log(sentence)
// }
var matches=sentence.match(/\<.*?\>/g);if(matches!==null){matches.map(function(m){return sentence=sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>');});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:sentence.replace("⟨","").replace("⟩","")}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence.replace("⟨","").replace("⟩",""));}};_this.processStyledPostbaseText=function(key,i,forEnglish,verbtype,mood,itemUpdating){// console.log(mood)
var nounNumber=1;if(itemUpdating!==undefined){if(itemUpdating[0]=='Update'){// if (itemUpdating[1][0] == 'nBases' || itemUpdating[1][1] == 'nBases') {
// } else {
// }
if(itemUpdating[1][0]+itemUpdating[1][1]in _this.state){if([itemUpdating[1][2]]in _this.state[itemUpdating[1][0]+itemUpdating[1][1]]){if([itemUpdating[1][3]]in _this.state[itemUpdating[1][0]+itemUpdating[1][1]][itemUpdating[1][2]]){// console.log(itemUpdating)
// console.log(itemUpdating[1][0]+' '+itemUpdating[1][1])
// console.log(itemUpdating[1][2]+' '+itemUpdating[1][3])
if(itemUpdating[1][0]==='np'){nounNumber=_this.state.npn[itemUpdating[1][2]][itemUpdating[1][3]][3];}else if(itemUpdating[1][0]==='mv'){if(itemUpdating[1][1]==='nsBases'){nounNumber=_this.state.mvns[itemUpdating[1][2]][itemUpdating[1][3]][3];}else if(itemUpdating[1][1]==='noBases'){nounNumber=_this.state.mvno[itemUpdating[1][2]][itemUpdating[1][3]][3];}else if(itemUpdating[1][1]==='nObliques'){if(itemUpdating[1][5]===undefined){nounNumber=_this.state.mvnObliques[itemUpdating[1][2]]['n'][itemUpdating[1][4]][3];}else{nounNumber=_this.state.mvnObliques[itemUpdating[1][2]]['n'][itemUpdating[1][4]][itemUpdating[1][5]][3];}}}else if(itemUpdating[1][0]==='sv'){if(itemUpdating[1][1]==='nsBases'){nounNumber=_this.state.svns[itemUpdating[1][2]][itemUpdating[1][3]][3];}else if(itemUpdating[1][1]==='noBases'){nounNumber=_this.state.svno[itemUpdating[1][2]][itemUpdating[1][3]][3];}else if(itemUpdating[1][1]==='nObliques'){if(itemUpdating[1][5]===undefined){nounNumber=_this.state.svnObliques[itemUpdating[1][2]]['n'][itemUpdating[1][4]][3];}else{nounNumber=_this.state.svnObliques[itemUpdating[1][2]]['n'][itemUpdating[1][4]][itemUpdating[1][5]][3];}}}else if(itemUpdating[1][0]==='cv'){if(itemUpdating[1][1]==='nsBases'){nounNumber=_this.state.cvns[itemUpdating[1][2]][itemUpdating[1][3]][3];}else if(itemUpdating[1][1]==='noBases'){nounNumber=_this.state.cvno[itemUpdating[1][2]][itemUpdating[1][3]][3];}else if(itemUpdating[1][1]==='nObliques'){if(itemUpdating[1][5]===undefined){nounNumber=_this.state.cvnObliques[itemUpdating[1][2]]['n'][itemUpdating[1][4]][3];}else{nounNumber=_this.state.cvnObliques[itemUpdating[1][2]]['n'][itemUpdating[1][4]][itemUpdating[1][5]][3];}}}}}}}}var lookup=void 0;var vsPlanned=[];if(forEnglish!==undefined){vsPlanned=forEnglish[1];}else{if(verbtype=='cv'){vsPlanned=_this.state.cvvs;}else{vsPlanned=_this.state.mvvs;}}if(i==='1'){lookup=key['expression'];}else if(i==='2'){lookup=key;}if(lookup in __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */]){var sentence='';// console.log(sentence)
if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['type']==='VV'){if(!__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['is']&&!__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['has']){if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1||_this.state.mvvs[0]==3&&_this.state.mvvs[1]==1){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['description'];}else{if('inf_preverb'in __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['inf_preverb'];}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['description'];}}}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['description'];}if(key['id']==5){sentence='(in the past)';}else if(key['id']==27){var s1='';// let specialStartingCase = this.returnBaseCaseforMoods(verbtype,mood,vsPlanned)
// console.log(newpostbases[lookup], specialStartingCase)
// if (this.state.nextTenses.length === 0 && mood === {
// let s1 = ''
// if (vsPlanned[0] == 1 && vsPlanned[1] == 1)	{
// 	sentence = 'am '
// } else if ((vsPlanned[0] == 3 || vsPlanned[0] == 4) && vsPlanned[1] == 1) {
// 	sentence = 'is '
// } else {
// 	sentence = 'are '
// }
// }
// if (specialStartingCase[1].length > 0) {
// if (this.state.nextTenses.length == 0) {
// s1 = specialStartingCase[1]+' '
// } 
// else if (this.state.nextTenses[this.state.nextTenses.length-1] === 'p') {
// s1 = specialStartingCase[1].replace('is','did').replace('are','do').replace('am','did')+' '
// }
// }
sentence=s1+'not';}else{// console.log(this.state.nextTenses[this.state.nextTenses.length-1])
if(!__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['match_case']){if(_this.state.nextTenses.length===0){var specialStartingCase=_this.returnBaseCaseforMoods(verbtype,mood,vsPlanned);// console.log(key)
// console.log(newpostbases[lookup], specialStartingCase)
var s0=specialStartingCase[0];var _s=specialStartingCase[1];if(s0==='gen'||_s.length>0){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['is']){sentence=_s+' '+sentence;}else if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['has']){if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){sentence='has '+sentence;}else{sentence='have '+sentence;}}}else{if(s0==='p'){if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['was']){if(vsPlanned[0]==1&&vsPlanned[1]==1){sentence='was '+__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){sentence='was '+__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}else{sentence='were '+__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}// sentence = s1+' (was) '+newpostbases[lookup]['gen_preverb']
}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past_preverb'];}}else if(s0==='g'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['ger_preverb'];}else if(s0==='i'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['inf_preverb'];}else if(s0==='pp'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past_preverb'];}else if(s0==='gen'){sentence=_s+' '+__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}else if(s0==='gen2'){sentence=_s+' '+__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}else if(s0==='past'){if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['was']){if(vsPlanned[0]==1&&vsPlanned[1]==1){sentence='was '+__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){sentence='was '+__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}else{sentence='were '+__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}// sentence = s1+' (was) '+newpostbases[lookup]['gen_preverb']
}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past_preverb'];}}else if(s0==='present'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}}}else{if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='p'||_this.state.nextTenses[_this.state.nextTenses.length-1]==='pp'||_this.state.nextTenses[_this.state.nextTenses.length-1]==='past'){if(['Intrg4','Intrg5','Intrg6','Intrg7','Intrg8','Intrg9','IntrgA'].includes(_this.state.mvvType)){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['inf_preverb'];}else{if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past_preverb'].length==0&&__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['was']){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['description'];if(_this.state.mvvs[0]==1&&_this.state.mvvs[1]==1){sentence='was '+sentence;}else if(_this.state.mvvs[0]==3&&_this.state.mvvs[1]==1||_this.state.mvvs.length===0){if(vsPlanned[1]!==1){sentence='were '+sentence;}else{sentence='was '+sentence;}}else{sentence='were '+sentence;}}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past_preverb'];}}}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='g'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['ger_preverb'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='gen'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='gen2'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='i'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['inf_preverb'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='past'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past_preverb'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='present'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_preverb'];}}}}}else if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['type']==='NV'){// console.log(this.state.nounNum, nounNumber, newpostbases[lookup])
if(vsPlanned.length>0){if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['present'];}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['inf_prenoun'];}}if(!__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['match_case']){if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='p'){if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past'].length==0&&__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['was']){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_prenoun'];if(_this.state.mvvs[0]==1&&_this.state.mvvs[1]==1){sentence='was '+sentence;}else if(_this.state.mvvs[0]==3&&_this.state.mvvs[1]==1||_this.state.mvvs.length===0){if(vsPlanned[1]!==1){sentence='were '+sentence;}else{sentence='was '+sentence;}}else{sentence='were '+sentence;}}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past'];}}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='g'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['ger_prenoun'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='gen'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['gen_prenoun'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='i'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['inf_prenoun'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='pp'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='past'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['past'];}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='present'){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['present'];}}}else if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['type']==='NN'){if(_this.state.nounNum=='p'||nounNumber>1){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['pluralDefinition'];}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['singularDefinition'];}}else if(__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['type']==='VN'){if(_this.state.nounNum=='p'||nounNumber>1){sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['pluralDefinition'];}else{sentence=__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][lookup]['singularDefinition'];}}// console.log(sentence)
// if (newpostbases[lookup]['is'] && this.state.addIs) {
// 	// if (this.state.nextTenses[this.state.nextTenses.length-1] === 'pp' || this.state.nextTenses[this.state.nextTenses.length-1] === 'p') {
// 	// if (this.state.mvvs[0] == 1 && this.state.mvvs[1] == 1)	{
// 	// 	sentence = 'was '+sentence
// 	// } else if (this.state.mvvs[0] == 3 && this.state.mvvs[1] == 1) {
// 	// 	sentence = 'was '+sentence
// 	// } else {
// 	// 	sentence = 'were '+sentence
// 	// }  
// 	// } else {
// 	// if (this.state.mvvs[0] == 1 && this.state.mvvs[1] == 1)	{
// 	// 	sentence = 'am '+sentence
// 	// } else if ((this.state.mvvs[0] == 3 && this.state.mvvs[1] == 1) || this.state.mvvs.length === 0) {
// 	// 	if (mvvsPlanned[1] !== 1) {
// 	// 		sentence = 'are '+sentence							
// 	// 	} else {
// 	// 		sentence = 'is '+sentence														
// 	// 	}
// 	// } else {
// 	// 	sentence = 'are '+sentence
// 	// }  	  			
// 	if (mvvsPlanned[0] == 1 && mvvsPlanned[1] == 1)	{
// 		sentence = 'am '+sentence							
// 	} else if (mvvsPlanned.length === 0 || (mv(vsPlanned[0] == 3 || vsPlanned[0] == 4) && mvvsPlanned[1] == 1)) {
// 		sentence = 'is '+sentence														
// 	} else {
// 		sentence = 'are '+sentence							
// 	}		
// 	// }
// // this.setState({addIs:false})
// }
// if (newpostbases[lookup]['has'] && this.state.addIs) {
// 	if (this.state.nextTenses[this.state.nextTenses.length-1] === 'pp' || this.state.nextTenses[this.state.nextTenses.length-1] === 'p') {
// 		sentence = 'had '+sentence
// 	} else {
// 	if (mvvsPlanned[0] == 1 && mvvsPlanned[1] == 1)	{
// 		sentence = 'have '+sentence							
// 	} else if (mvvsPlanned.length === 0 || (mv(vsPlanned[0] == 3 || vsPlanned[0] == 4) && mvvsPlanned[1] == 1)) {
// 		sentence = 'has '+sentence														
// 	} else {
// 		sentence = 'have '+sentence							
// 	}		  			
// 	}
// // this.setState({addIs:false})
// }
sentence=_this.returnPossessor(sentence,forEnglish,vsPlanned);var matches=sentence.match(/\<.*?\>/g);if(matches!==null){matches.map(function(m){return sentence=sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>');});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:sentence.replace("⟨","").replace("⟩","")}});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sentence.replace("⟨","").replace("⟩",""));}}else{// console.log('not in',lookup)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'not in lookup');}};_this.returnPossessor=function(sentence,forEnglish,vsPlanned){var mvvs=_this.state.mvvs;if(vsPlanned.length>0&&mvvs.length==0){mvvs=vsPlanned;}if(sentence.includes('^his^')){return sentence.replace('^his^',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["y" /* npnEnglish */][mvvs.join("")]);}else if(sentence.includes('^its^')){return sentence.replace('^its^',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["y" /* npnEnglish */][mvvs.join("")]);}else if(sentence.includes('^himself^')){return sentence.replace('^himself^',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["z" /* npnEnglishself */][mvvs.join("")]);}else if(sentence.includes('^herself^')){return sentence.replace('^herself^',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["z" /* npnEnglishself */][mvvs.join("")]);}else if(sentence.includes('^itself^')){return sentence.replace('^itself^',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["z" /* npnEnglishself */][mvvs.join("")]);}else if(sentence.includes('^he^')){return sentence.replace('^he^',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][mvvs.join("")]);}else if(sentence.includes('^she^')){return sentence.replace('^she^',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][mvvs.join("")]);}else if(sentence.includes('^it^')){return sentence.replace('^it^',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["e" /* mvObjectOptionsEnglish */][mvvs.join("")]);}else if(sentence.includes('^him^')){return sentence.replace('^him^',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["e" /* mvObjectOptionsEnglish */][mvvs.join("")]);}else{return sentence;}};_this.returnBaseChooserTitle=function(itemUpdating,endingNeeded,mood,submood,forEnglish){var subject='';if(forEnglish===undefined){forEnglish=['',[]];}var starters={'Abs':'[the one] _____','Rel':'[the one] _____','Loc':'in or at [the one] _____','Ter':'to [the one] _____','from':'from [the one] _____','io':'a _____','Via':'through, using [a] _____','Equ':'like [a] _____','Prec':'before [] _____','Cnsq':'because [] _____','Cont':'whenever [] _____','CtmpI':'when (in past) [] _____','CtmpII':'while [] _____','Conc':'even though [] _____','evenif':'even if [] _____','if':'if [] _____','wheninthefuture':'when (in future) [] _____','Intrg0':'who is [he] who _____?','Intrg1':'[she] _____ whom (object)?','Intrg2':'what is [it] that _____?','Intrg3':'[he] _____ what (object)?','Intrg4':'when did [you] _____?','Intrg5':'when will [you] _____?','Intrg6':'where *are* [you] _____?','Intrg7':'from where *are* [you] _____?','Intrg8':'to where *are* [you] _____?','Intrg9':'why *are* [you] _____?','IntrgA':'how *are* [you] _____?','Opt][PRS':'[you], _____ (command)','Opt][FUT':'[you], _____ (command in the future)','Opt][PRS][NEG':'[you], do not _____','Opt][FUT][NEG':'[you], do not _____ (future)','Sbrd':'[you], ____ (polite request)','neg':'[you], do not ____ (polite request)','by':'by ____ ','being':'being ____'// console.log(itemUpdating,endingNeeded,mood,submood,forEnglish)
// console.log(itemUpdating, mood,submood)
// console.log(this.state)
};if(itemUpdating[0]==='Insert'){if(mood==='Ind'){if(forEnglish[1].length>0){subject=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][forEnglish[1].join("")]+' _____';if(submood==='qaa'){subject=subject+'?';}}else if(endingNeeded!=='v'){subject='';}else{subject='he _____';}}else if(itemUpdating[1][0]==='cv'){if(submood!=''){if(submood in starters){subject=starters[submood].replace('[]',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][_this.state.mvvs.join("")]).replace('[','').replace(']','');// if reflexive
}}else{if(mood in starters){subject=starters[mood].replace('[]',__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][_this.state.mvvs.join("")]).replace('[','').replace(']','');// if reflexive
}}}else if(submood!=''){if(submood in starters){subject=starters[submood].replace('[','').replace(']','');if(_this.state.nextTenses.length>0){if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='p'){subject=subject.replace('*are*','did');}}subject=subject.replace('*are*','are');}}else{if(mood in starters){subject=starters[mood].replace('[','').replace(']','');}}}// if (submood === 'qaa') {
// 	subject = subject + '?'
// }
return subject;};_this.returnBaseCaseforMoods=function(verbtype,mood,vsPlanned){if(verbtype==='mv'&&(mood==="Opt][PRS"||mood==="Opt][FUT"||mood==="Opt][PRS][NEG"||mood==="Sbrd"||_this.state.mvvMood==="Opt][PRS"||_this.state.mvvMood==="Opt][FUT"||_this.state.mvvMood==="Opt][PRS][NEG"||_this.state.mvvMood==="Sbrd")){// return 'hunt, be happy, etc.'
return['i',''];}else if(verbtype==='cv'&&(_this.state.cvvMood==="Prec"||_this.state.cvvMood==="Cond"||_this.state.cvvMood==="Cont")){if(vsPlanned.length===0){if(_this.state.cvvs[0]==1&&_this.state.cvvs[1]==1){// return 'hunt, am happy, etc.'
return['i','am'];}else if(_this.state.cvvs.length===0||(_this.state.cvvs[0]==3||_this.state.cvvs[0]==4)&&_this.state.cvvs[1]==1){// return 'hunts, is happy, etc.'
return['gen2','is'];}else{// return 'hunt, are happy, etc.'
return['i','are'];}}else{if(vsPlanned[0]==1&&vsPlanned[1]==1){// return 'hunt, am happy, etc.'
return['i','am'];}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){// return 'hunts, is happy, etc.'
return['gen2','is'];}else{// return 'hunt, are happy, etc.'
return['i','are'];}}}else if(verbtype==='cv'&&_this.state.cvvMood==="Conc"){if(vsPlanned.length===0){if(_this.state.cvvs[0]==1&&_this.state.cvvs[1]==1){// return 'am hunting, happy, etc.'
return['gen','am'];}else if(_this.state.cvvs.length===0||(_this.state.cvvs[0]==3||_this.state.cvvs[0]==4)&&_this.state.cvvs[1]==1){return['gen','is'];}else{return['gen','are'];}}else{if(vsPlanned[0]==1&&vsPlanned[1]==1){// return 'am hunting, happy, etc.'
return['gen','am'];}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){return['gen','is'];}else{return['gen','are'];}}}else if(verbtype==='cv'&&(_this.state.cvvMood==="Cnsq"||_this.state.cvvMood==="CtmpI"||_this.state.cvvMood==="CtmpII")){if(_this.state.cvvs[0]==1&&_this.state.cvvs[1]==1){// return 'hunted, was happy, etc.'
return['p',''];}else if(_this.state.cvvs.length===0||(_this.state.cvvs[0]==3||_this.state.cvvs[0]==4)&&_this.state.cvvs[1]==1){return['p',''];}else{return['p',''];}}else if(verbtype==='mv'&&(_this.state.mvvType==="Intrg4"||_this.state.mvvType==="Intrg5")){// return 'hunt, be happy, etc.'
return['i',''];}else if(verbtype==='mv'&&(_this.state.mvvType==="Intrg6"||_this.state.mvvType==="Intrg7"||_this.state.mvvType==="Intrg8"||_this.state.mvvType==="Intrg9"||_this.state.mvvType==="IntrgA")){// return 'hunting, being happy, etc.'
return['g',''];}else if(verbtype==='mv'&&_this.state.mvvType==="qaa"&&_this.state.mvvs.length!==0){// return 'hunting, being happy, etc.'
return['g',''];}else if(verbtype==='sv'&&(_this.state.svvType==="by"||_this.state.svvType==="being")){return['g',''];}else{if(vsPlanned.length===0){if(_this.state.mvvs[0]==1&&_this.state.mvvs[1]==1){// return 'am hunting, am happy, etc.'
return['gen','am'];}else if(_this.state.mvvs.length===0||_this.state.mvvs[0]==3&&_this.state.mvvs[1]==1){return['gen','is'];}else{return['gen','are'];}}else{if(vsPlanned[0]==1&&vsPlanned[1]==1){// return 'am hunting, am happy, etc.'
return['gen','am'];}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){return['gen','is'];}else{return['gen','are'];}}}};_this.returnPlaceholder=function(endingNeeded,forEnglish,verbtype,mood){// console.log(endingNeeded, this.state.endingAdjusted, this.state.startingCase, this.state.mvvsPlanned)
// console.log(endingNeeded, forEnglish, mood)
var startingCase='';var vsPlanned=[];if(forEnglish!==undefined){startingCase=forEnglish[0];vsPlanned=forEnglish[1];}// console.log(endingNeeded, forEnglish, verbtype, mood, startingCase, vsPlanned)
if(endingNeeded=='n'){if(_this.state.endingAdjusted==='v'){if(startingCase=='i'){return'hunt, be happy, etc.';}else if(startingCase=='g'){return'hunting, being happy, etc.';}else if(vsPlanned.length>0){if(vsPlanned[0]==1&&vsPlanned[1]==1){return'am hunting, happy, etc.';}else if(vsPlanned.length===0||(vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){return'is hunting, happy, etc.';}else{return'are hunting, happy, etc.';}}else{if(_this.state.mvvs[0]==1&&_this.state.mvvs[1]==1){return'am hunting, happy, etc.';}else if(_this.state.mvvs.length===0||_this.state.mvvs[0]==3&&_this.state.mvvs[1]==1){return'is hunting, happy, etc.';}else{return'are hunting, happy, etc.';}}}else{return'person, land, etc.';}}else if(endingNeeded=='v'){if(_this.state.endingAdjusted==='n'){return'person, land, etc.';}else{if(startingCase=='i'||_this.state.nextTenses[_this.state.nextTenses.length-1]==='i'){return'hunt, be happy, etc.';}else if(startingCase=='g'||_this.state.nextTenses[_this.state.nextTenses.length-1]==='g'){return'hunting, being happy, etc.';}else if(_this.state.nextTenses[_this.state.nextTenses.length-1]==='p'||_this.state.nextTenses[_this.state.nextTenses.length-1]==='pp'){return'hunted, been happy, etc.';}// else if (vsPlanned.length > 0) {
// 	if (vsPlanned[0] == 1 && vsPlanned[1] == 1)	{
// 		return 'am hunting, happy, etc.'
// 	} else if (vsPlanned.length === 0 || ((vsPlanned[0] == 3 || vsPlanned[0] == 4) && vsPlanned[1] == 1)) {
// 		return 'is hunting, happy, etc.'
// 	} else {
// 		return 'are hunting, happy, etc.'
// 	}
// } 
else{if(verbtype==='mv'&&(_this.state.mvvMood==="Opt][PRS"||_this.state.mvvMood==="Opt][FUT"||_this.state.mvvMood==="Opt][PRS][NEG"||_this.state.mvvMood==="Sbrd")){return'hunt, be happy, etc.';}else if(verbtype==='cv'&&(_this.state.cvvMood==="Prec"||_this.state.cvvMood==="Cond"||_this.state.cvvMood==="Cont")){if(vsPlanned.length===0){if(_this.state.cvvs[0]==1&&_this.state.cvvs[1]==1){return'hunt, am happy, etc.';// return ['i','am']
}else if(_this.state.cvvs.length===0||(_this.state.cvvs[0]==3||_this.state.cvvs[0]==4)&&_this.state.cvvs[1]==1){return'hunts, is happy, etc.';// return ['gen','is']
}else{return'hunt, are happy, etc.';// return ['i','are']
}}else{if(vsPlanned[0]==1&&vsPlanned[1]==1){return'hunt, am happy, etc.';// return ['i','am']
}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){return'hunts, is happy, etc.';// return ['gen','is']
}else{return'hunt, are happy, etc.';// return ['i','are']
}}// if (this.state.cvvs[0] == 1 && this.state.cvvs[1] == 1)	{
// 	return 'hunt, am happy, etc.'
// } else if (this.state.cvvs.length === 0 || (this.state.cvvs[0] == 3 && this.state.cvvs[1] == 1)) {
// 	return 'hunts, is happy, etc.'
// } else {
// 	return 'hunt, are happy, etc.'
// }		
}else if(verbtype==='cv'&&_this.state.cvvMood==="Conc"){if(vsPlanned.length===0){if(_this.state.cvvs[0]==1&&_this.state.cvvs[1]==1){return'am hunting, happy, etc.';}else if(_this.state.cvvs.length===0||(_this.state.cvvs[0]==3||_this.state.cvvs[0]==4)&&_this.state.cvvs[1]==1){return'is hunting, happy, etc.';}else{return'are hunting, happy, etc.';}}else{if(vsPlanned[0]==1&&vsPlanned[1]==1){return'am hunting, happy, etc.';}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){return'is hunting, happy, etc.';}else{return'are hunting, happy, etc.';}}}else if(verbtype==='cv'&&(_this.state.cvvMood==="Cnsq"||_this.state.cvvMood==="CtmpI"||_this.state.cvvMood==="CtmpII")){if(vsPlanned.length===0){if(_this.state.cvvs[0]==1&&_this.state.cvvs[1]==1){return'hunted, was happy, etc.';}else if(_this.state.cvvs.length===0||(_this.state.cvvs[0]==3||_this.state.cvvs[0]==4)&&_this.state.cvvs[1]==1){return'hunted, was happy, etc.';}else{return'hunted, were happy, etc.';}}else{if(vsPlanned[0]==1&&vsPlanned[1]==1){return'hunted, was happy, etc.';}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){return'hunted, was happy, etc.';}else{return'hunted, were happy, etc.';}}}else if(verbtype==='mv'&&(_this.state.mvvType==="Intrg4"||_this.state.mvvType==="Intrg5")){return'hunt, be happy, etc.';}else if(verbtype==='mv'&&(_this.state.mvvType==="Intrg6"||_this.state.mvvType==="Intrg7"||_this.state.mvvType==="Intrg8"||_this.state.mvvType==="Intrg9"||_this.state.mvvType==="IntrgA")){return'hunting, being happy, etc.';}else if(verbtype==='mv'&&_this.state.mvvType==="qaa"&&_this.state.mvvs.length!==0){// return 'hunting, being happy, etc.'
return'hunting, being happy, etc.';}else if(verbtype==='sv'&&(_this.state.svvType==="by"||_this.state.svvType==="being")){return'hunting, being happy, etc.';}else{if(vsPlanned.length===0){if(_this.state.mvvs[0]==1&&_this.state.mvvs[1]==1){// return 'am hunting, am happy, etc.'
return'am hunting, happy, etc.';}else if(_this.state.mvvs.length===0||_this.state.mvvs[0]==3&&_this.state.mvvs[1]==1){return'is hunting, happy, etc.';}else{return'are hunting, happy, etc.';}}else{if(vsPlanned[0]==1&&vsPlanned[1]==1){// return 'am hunting, am happy, etc.'
return'am hunting, happy, etc.';}else if((vsPlanned[0]==3||vsPlanned[0]==4)&&vsPlanned[1]==1){return'is hunting, happy, etc.';}else{return'are hunting, happy, etc.';}}}}// } 
}}};_this.popularVPostbasesGetter=function(mood,submood){var noFuture=false;var noPast=false;// console.log(mood,submood)
if(mood===undefined){return popularVPostbases;}else{if(mood.includes('Opt')){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["J" /* popularOptPostbases */];}if(mood=='CtmpI'||mood=='CtmpII'||submood=='Intrg4'||mood=='Sbrd'){noFuture=true;}if(mood=='Sbrd'||submood=='Intrg5'){noPast=true;}if(noFuture&&noPast||_this.state.containsTime){return popularVPostbasesNoTime;}else if(noFuture){return popularVPostbasesOnlyPast;}else if(noPast){return popularVPostbasesOnlyFuture;}else{return popularVPostbases;}}};_this.popularVerbsGetter=function(mood,submood,forEnglish){if(mood===undefined){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["O" /* popularVerbsIT */];}else{if(submood=='Intrg1'||submood=='Intrg3'){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["Q" /* popularVerbsT */];}else if(mood.includes('Opt')){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["P" /* popularVerbsOptative */];}else{return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["O" /* popularVerbsIT */];}}};_this.popularNounsGetter=function(itemUpdating,mood,submood,forEnglish){// console.log(itemUpdating, forEnglish)
// if (itemUpdating[1][0] == 'mv') {
// 	if (itemUpdating[1][1] === 'nObliques') {
// 		mood = this.state.mv[itemUpdating[1][1]][itemUpdating[1][2]]['nCase']
// 		submood = this.state.mv[itemUpdating[1][1]][itemUpdating[1][2]]['nType']				
// 	}
// }
// console.log(itemUpdating, this.state.currentEditMode, 'mood=',mood,',submood=',submood)
if(_this.state.currentEditMode.includes("appositiveinsert")||_this.state.currentEditMode.includes("appositiveupdate")){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["F" /* popularNounsDescriptors */];}else if(mood==='Loc'||mood==='Ter'||submood==='from'){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["G" /* popularNounsPlaces */];}else if(mood==='Via'){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["I" /* popularNounsVialis */];}else{return popularNouns;}};_this.getPopular=function(itemUpdating,endingNeeded,mood,submood,forEnglish){var popularPostbases=[];var popularBases=[];// console.log(itemUpdating,endingNeeded, mood, submood,forEnglish)
if(itemUpdating[1][0]=='sv'){popularPostbases=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["N" /* popularVPostbasesSub */];popularBases=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["O" /* popularVerbsIT */];}else if(endingNeeded=='n'){if(_this.state.endingAdjusted==='v'){popularPostbases=_this.popularVPostbasesGetter(mood,submood,forEnglish);popularBases=_this.popularVerbsGetter(mood,submood,forEnglish);}else{popularPostbases=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["D" /* popularNPostbases */];popularBases=_this.popularNounsGetter(itemUpdating,mood,submood,forEnglish);}}else{if(_this.state.endingAdjusted==='n'){popularPostbases=__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["D" /* popularNPostbases */];popularBases=_this.popularNounsGetter(itemUpdating,mood,submood,forEnglish);}else{popularPostbases=_this.popularVPostbasesGetter(mood,submood,forEnglish);popularBases=_this.popularVerbsGetter(mood,submood,forEnglish);}}return[popularPostbases,popularBases];};_this.baseChooser=function(itemUpdating,endingNeeded,update,mood,submood,forEnglish){var key=void 0;// console.log(itemUpdating,endingNeeded,update,mood,submood,forEnglish)
var popular=_this.getPopular(itemUpdating,endingNeeded,mood,submood,forEnglish);var popularPostbases=popular[0];var popularBases=popular[1];var vsPlanned=[];if(forEnglish!==undefined){vsPlanned=forEnglish[1];}// console.log(itemUpdating,endingNeeded,update,mood,submood,forEnglish)
var subject=_this.returnBaseChooserTitle(itemUpdating,endingNeeded,mood,submood,forEnglish);// console.log(subject)
// if (this.state.currentlyOpen.length === 0) {
// subject = ''
// }
// if (['npnBases10'].includes(itemUpdating[1].join(""))) {
// 		subject = 'yes'				
// } else if (['npnBases00'].includes(itemUpdating[1].join(""))) {
// 		subject = '...'+this.state.npn[0][3]+'...'				
// }
// let currentTense;n
// console.log(this.state)
// console.log(this.state.currentEditMode, itemUpdating,endingNeeded,update,mood,submood)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */],{style:{width:window.innerWidth<480?'':'300px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Row,{columns:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Column,{style:{paddingTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{style:{overflow:'auto',padding:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{divided:true,style:{margin:0,padding:0}},subject.length!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{style:{color:'#545454',fontFamily:customFontFam,padding:'8px 15px',backgroundColor:'#f7f7f7'}},subject):null,_this.state.candidateDisplay.map(function(k,kindex){return kindex===_this.state.candidateBase.length-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{style:{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',padding:'8px 15px',backgroundColor:'#f7f7f7'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#545454',fontFamily:customFontFam}},k[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#d3d3d3',fontFamily:customFontFam,marginLeft:'5px'}},k[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,onClick:function onClick(){// if (newpostbases[popularPostbases[p]['expression']]['type']=="VV") {
// 	if (!newpostbases[popularPostbases[p]['expression']]['match_case']) {
// 		this.setState({addIs:false})
// 	}
// }
// this.handleClick('vvpostbases',false); 
_this.handleClick('verbs',false);if(_this.state.candidateBase.length===1){_this.setState({addIs:true});}else{if(!__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][_this.state.candidateBase[_this.state.candidateBase.length-2][1]]['match_case']){_this.setState({addIs:false});}else{_this.setState({addIs:true});}}_this.setState({candidateBase:_this.state.candidateBase.slice(0,-1),candidateDisplay:_this.state.candidateDisplay.slice(0,-1),nextTenses:_this.state.lockSubmit?_this.state.nextTenses:_this.state.nextTenses.slice(0,-1),unallowable_next_ids:_this.state.lockSubmit?_this.state.unallowable_next_ids:_this.state.unallowable_next_ids.slice(0,-1),lockSubmit:false// endingAdjusted:'',
},function(){_this.updateCandidateCall(endingNeeded,update,mood,submood,'');});},style:{cursor:'pointer',width:30},name:'x'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{style:{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',padding:'8px 15px',backgroundColor:'#f7f7f7'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#545454',fontFamily:customFontFam}},k[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#d3d3d3',fontFamily:customFontFam,marginLeft:'5px'}},k[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:30}}));})),_this.state.lockSubmit?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:0,margin:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["p" /* Input */],{icon:'search',iconPosition:'left',name:'search',autoComplete:'off',autoFocus:true,disabled:_this.state.lockSubmit,placeholder:_this.returnPlaceholder(endingNeeded,forEnglish,itemUpdating[1][0],mood)// width='100%'
,style:{width:'100%',padding:'5px 5px',fontSize:window.innerWidth<480?'16px':'14px'},onChange:_this.onChangeBaseSearch.bind(_this,endingNeeded,forEnglish,itemUpdating[1][0],mood,submood,update,itemUpdating),value:_this.state.searchQuery// onClose={()=>{this.setState({searchQuery:'',wordsList:[]})}}
}),_this.state.wordsList.length===0&&_this.state.searchQuery.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'12px',fontStyle:'italic',color:'grey'}},' ','No results...',' '):null,_this.state.wordsList.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{vertical:true,style:{maxHeight:window.innerWidth<480?166:204,overflow:'auto',padding:0,margin:"4px 9px",borderBottom:'0px solid #e2e2e2'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},_this.state.wordsList.map(function(k,index){if(k['type'].includes('→')){if(k['fsts']in __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{textAlign:'left',padding:'10px'},onClick:function onClick(){_this.setState({searchQuery:'',wordsList:[],candidateBase:_this.state.candidateBase.concat([[__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][k['fsts']]['keylookup'],k['fsts']]]),candidateDisplay:_this.state.candidateDisplay.concat([[_this.processStyledPostbaseText(k['fsts'],'2',forEnglish,itemUpdating[1][0],mood,itemUpdating),k['fsts']]]),nextTenses:__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][k['fsts']]['match_case']&&!('gen_preverb_after'in __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][k['fsts']])?_this.state.nextTenses.length==0?_this.state.nextTenses.concat([_this.returnBaseCaseforMoods(itemUpdating[1][0],mood,vsPlanned)[0]]):_this.state.nextTenses.concat([_this.state.nextTenses[_this.state.nextTenses.length-1]]):__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][k['fsts']]['match_case']?_this.state.nextTenses.length==0?_this.state.nextTenses.concat([_this.returnBaseCaseforMoods(itemUpdating[1][0],mood,vsPlanned)[0]]):_this.state.nextTenses.concat([_this.state.nextTenses[_this.state.nextTenses.length-1]]):'verbType'in __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][k['fsts']]?_this.state.nextTenses.concat([__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][k['fsts']]['verbType']]):_this.state.nextTenses.concat([__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][k['fsts']]['gen_preverb_after']])},function(){_this.updateCandidateCall(endingNeeded,update,mood,submood,'p');});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'5px',color:'#545454'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.processStyledPostbaseText(k['fsts'],'2',forEnglish,itemUpdating[1][0],mood,itemUpdating)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#bdbdbd'}},'...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#d3d3d3',fontFamily:customFontFam,marginLeft:'5px'}},k['fsts'])));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{textAlign:'left',padding:'10px'},onClick:function onClick(){_this.setState({searchQuery:'',wordsList:[],candidateBase:_this.state.candidateBase.concat(k),candidateDisplay:_this.state.candidateDisplay.concat([[_this.processStyledMainText(k,forEnglish,itemUpdating[1][0],mood),k['fsts'].toString()+'-']])},function(){_this.updateCandidateCall(endingNeeded,update,mood,submood,'b');});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'5px',color:'#545454'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.processStyledMainText(k,forEnglish,itemUpdating[1][0],mood))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#d3d3d3',fontFamily:customFontFam,marginLeft:'5px'}},k['fsts'].toString()+'-')));}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',color:'#252525'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}))):null,_this.state.candidateBase.length<2&&Object.keys(popularPostbases).length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:'verb',style:{fontSize:'14px',paddingTop:window.innerWidth<480?'10px':'',paddingBottom:window.innerWidth<480?'5px':'2px'},active:_this.state.activeIndexes1.includes('vvpostbases'),onClick:function onClick(){_this.handleClick1('vvpostbases',true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Common Postbases'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes1.includes('vvpostbases')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{vertical:true,style:{maxHeight:window.innerWidth<480?162:200,overflow:'auto',padding:0,marginTop:5,marginBottom:0,borderBottom:'0px solid #e2e2e2'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},Object.keys(popularPostbases).map(function(p,index){var removeItem=false;if(_this.state.unallowable_next_ids.length>0){removeItem=_this.state.unallowable_next_ids[_this.state.unallowable_next_ids.length-1][0].includes(popularPostbases[p]['id']);}if(!removeItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{textAlign:'left',padding:'10px'},onClick:function onClick(){_this.handleClick1('vvpostbases',false);// console.log(newpostbases[popularPostbases[p]['expression']])
// this.handleClick('verbs',false); 
_this.setState({candidateBase:_this.state.candidateBase.concat([[__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularPostbases[p]['expression']]['keylookup'],popularPostbases[p]['expression']]]),candidateDisplay:_this.state.candidateDisplay.concat([[_this.processStyledPostbaseText(popularPostbases[p],'1',forEnglish,itemUpdating[1][0],mood,itemUpdating),__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularPostbases[p]['expression']]['exp']]]),unallowable_next_ids:_this.state.unallowable_next_ids.concat([[popularPostbases[p]['allowable_next_ids']]]),nextTenses:__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularPostbases[p]['expression']]['match_case']&&!('gen_preverb_after'in __WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularPostbases[p]['expression']])?_this.state.nextTenses.length==0?_this.state.nextTenses.concat([_this.returnBaseCaseforMoods(itemUpdating[1][0],mood,vsPlanned)[0]]):_this.state.nextTenses.concat([_this.state.nextTenses[_this.state.nextTenses.length-1]]):__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularPostbases[p]['expression']]['match_case']?_this.state.nextTenses.length==0?_this.state.nextTenses.concat([_this.returnBaseCaseforMoods(itemUpdating[1][0],mood,vsPlanned)[0]]):_this.state.nextTenses.concat([_this.state.nextTenses[_this.state.nextTenses.length-1]]):_this.state.nextTenses.concat([__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularPostbases[p]['expression']]['gen_preverb_after']])},function(){_this.updateCandidateCall(endingNeeded,update,mood,submood,'p');});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'5px',color:'#545454'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.processStyledPostbaseText(popularPostbases[p],'1',forEnglish,itemUpdating[1][0],mood,itemUpdating)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#bdbdbd'}},'...')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#d3d3d3',fontFamily:customFontFam,marginLeft:'5px'}},__WEBPACK_IMPORTED_MODULE_6__constants_newpostbases_js__["a" /* newpostbases */][popularPostbases[p]['expression']]['exp'])));}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',color:'#252525'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'})))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:0,margin:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:'verb',style:{fontSize:'14px',paddingTop:window.innerWidth<480?'10px':'',paddingBottom:window.innerWidth<480?'5px':'2px'},active:_this.state.activeIndexes1.includes('verbs'),onClick:function onClick(){_this.handleClick1('verbs',true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Common Bases'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:_this.state.activeIndexes1.includes('verbs')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{vertical:true,style:{maxHeight:window.innerWidth<480?162:200,overflow:'auto',padding:0,marginTop:5,marginBottom:0,borderBottom:'0px solid #e2e2e2'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{vertical:true,basic:true,fluid:true},Object.keys(popularBases).map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{textAlign:'left',padding:'10px'},onClick:function onClick(){// this.handleClick('vvpostbases',false); 
_this.handleClick1('verbs',false);_this.setState({searchQuery:'',wordsList:[],candidateBase:_this.state.candidateBase.concat(popularBases[p]),candidateDisplay:_this.state.candidateDisplay.concat([[_this.processStyledMainText(popularBases[p],forEnglish,itemUpdating[1][0],mood),popularBases[p]['fsts'].join("-, ")+'-']])},function(){_this.updateCandidateCall(endingNeeded,update,mood,submood,'b');});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'5px',color:'#545454'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this.processStyledMainText(popularBases[p],forEnglish,itemUpdating[1][0],mood)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#bdbdbd'}},'.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#d3d3d3',fontFamily:customFontFam,marginLeft:'5px'}},popularBases[p]['fstsDisplay'])));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',color:'#252525'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between',paddingBottom:10}},window.innerWidth<480?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{size:'medium',onClick:function onClick(){_this.setState({overlayOn:false});_this.closeEditMenuRef(_this.state.crecentlyOpen,'default',false);_this.closeMainScreenMenuRef(_this.state.crecentlyOpen,'default');_this.closeSubjectMenu(_this.state.crecentlyOpen,false,false);},style:{display:'flex',flexDirection:'row',alignItems:'center',paddingLeft:'13px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'chevron left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontFamily:'Lato'}},'Back')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'/sentencebuilder/2'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{size:'medium',color:'blue',onClick:function onClick(){_this.setState({overlayOn:false});_this.closeEditMenuRef(_this.state.crecentlyOpen,'default',false);_this.closeMainScreenMenuRef(_this.state.crecentlyOpen,'default');if(mood==='Intrg'){_this.backEndCall([[itemUpdating[0],itemUpdating[1],_this.state.candidateCall],["Insert",["mv","qWord"],[submood,1]]]);}else{if(vsPlanned.length>0){if(submood=='qaa'){_this.backEndCall([[itemUpdating[0],itemUpdating[1],_this.state.candidateCall],["Update",["mv","vs"],vsPlanned],["Update",["mv","vType"],'qaa']]);}else{_this.backEndCall([[itemUpdating[0],itemUpdating[1],_this.state.candidateCall],["Update",["mv","vs"],vsPlanned]]);}}else{if(submood=='qaa'){_this.backEndCall([[itemUpdating[0],itemUpdating[1],_this.state.candidateCall],["Update",["mv","vType"],'qaa']]);}else{_this.backEndCall([[itemUpdating[0],itemUpdating[1],_this.state.candidateCall]]);}}}// console.log(submood)
// if (submood == 'qaa') {
// 	this.backEndCall([["Update",["mv","vType"],'qaa']])
// }
},disabled:!_this.state.lockSubmit,style:{display:'flex',flexDirection:'row',alignItems:'center',paddingRight:'13px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontFamily:'Lato'}},'Submit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'chevron right'})))),_this.state.lockSubmit?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontFamily:customFontFam,textAlign:window.innerWidth<480?'right':'left',fontSize:'14px',color:'#c7c7c7',marginBottom:'8px'}},'You need at least one base'),_this.state.wordsList.length===0&&_this.state.activeIndexes1.length==0&&window.innerWidth<480?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-evenly',alignItems:'center',height:60,paddingBottom:16,paddingTop:5}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'})):null)));};_this.arraysEqual=function(a,b){if(a===b)return true;if(a==null||b==null)return false;if(a.length!==b.length)return false;// If you don't care about the order of the elements inside
// the array, you should sort both arrays here.
// Please note that calling sort on an array will modify that array.
// you might want to clone your array first.
for(var i=0;i<a.length;++i){if(a[i]!==b[i])return false;}return true;};_this.flipGlossary=function(bool){_this.setState({glossary:bool});};_this.parserPopup=function(parses){// console.log(parses)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{maxWidth:'320px',padding:'11px 14px',fontFamily:"Lato,'Helvetica Neue',Arial,Helvetica,sans-serif"}},parses['yugtun'].map(function(q,qindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingBottom:qindex!==parses['yugtun'].length-1?15:0,paddingLeft:qindex*20,fontSize:'16px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontWeight:'bold',paddingBottom:'5px'}},parses['link'][qindex]!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{paddingBottom:'1px',borderBottom:'1px solid #4183c4'},href:YUGTUNDOTCOM_URL+parses['link'][qindex],target:'_blank'},q):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,q)),parses.endingIndex===qindex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,parses.english[qindex][0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#00000066'}},parses.english[qindex][2])):parses.english[qindex]));}));};_this.getColor=function(pos,template,test){// console.log(pos, this.state)
// console.log(this.state.npn[this.state.npn.length-1][0][0], this.state.npn[this.state.npn.length-1][0][0] === 1)
var grey='#5c5c5c';var black='#000000';// console.log(test)
// console.log(tensesSentenceTemplates.includes(test))
var currentColorScheme=_this.state.colorScheme;if(template){// console.log(pos,test)
if(!(pos in __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][1])){return black;}else{return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][1][pos];}}if(currentColorScheme===-1){return'#000000';}else if(currentColorScheme===0){if(pos==='mvno00.ps'&&_this.state.mvvBase[1]==='it'&&_this.arraysEqual(_this.state.mvno[0][0],[0,0,0,1])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['mvns00.c'];}else if(pos==='cvno00.ps'&&_this.state.cvvBase[1]==='it'&&_this.arraysEqual(_this.state.cvno[0][0],[0,0,0,1])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['cvns00.c'];}else if(pos==='svno00.ps'&&_this.state.svvBase[1]==='it'&&_this.arraysEqual(_this.state.svno[0][0],[0,0,0,1])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['svns00.c'];}if(pos==='mvqWord'&&(_this.state.mvvType==='Intrg0'||_this.state.mvvType==='Intrg2')){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['mvv.s'];}if(pos==='mvqWord'&&(_this.state.mvvType==='Intrg1'||_this.state.mvvType==='Intrg3')){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['mvv.o'];}if(_this.state.mvvBase.length>0){if(pos=='mvv.'+(_this.state.mvvBase[0].length-1).toString()){if(pastTensePostbases.includes(_this.state.mvvBase[0][_this.state.mvvBase[0].length-1][0])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['past'];}else if(futureTensePostbases.includes(_this.state.mvvBase[0][_this.state.mvvBase[0].length-1][0])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['future'];}}}else if(_this.state.cvvBase.length>0){if(pos=='cvv.'+(_this.state.cvvBase[0].length-1).toString()){if(pastTensePostbases.includes(_this.state.cvvBase[0][_this.state.cvvBase[0].length-1][0])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['past'];}else if(futureTensePostbases.includes(_this.state.cvvBase[0][_this.state.cvvBase[0].length-1][0])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['future'];}}}else if(_this.state.svvBase.length>0){if(pos=='svv.'+(_this.state.svvBase[0].length-1).toString()){if(pastTensePostbases.includes(_this.state.svvBase[0][_this.state.svvBase[0].length-1][0])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['past'];}else if(futureTensePostbases.includes(_this.state.svvBase[0][_this.state.svvBase[0].length-1][0])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['future'];}}}if(!(pos in __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme])){return grey;}else{return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme][pos];}}else if(currentColorScheme===1){//IF 1st PERSON CHOOSE COLOR
//IF 2nd PERSON CHOOSE COLOR
//ALL OTHER COLORS BLACK
// } else if (currentColorScheme === 1) {
// 	if (pos === 'npn00.ps' || pos === 'npn10.ps') {
// 		if (this.arraysEqual(this.state.npn[this.state.npn.length-1][0],[0,0,0,1])) {
// 			return grey
// 		} else {
// 			return colorsList[currentColorScheme][pos]				
// 		}
// 	} else {
// 		// console.log(colorsList[currentColorScheme], pos)
// 		if (!(pos in colorsList[currentColorScheme])) {
// 			return grey
// 		} else {
// 			return colorsList[currentColorScheme][pos]				
// 		}
// 	}
}else{if(pos==='npn00.ps'){if(_this.arraysEqual(_this.state.npn[_this.state.npn.length-1][0],[0,0,0,1])){return grey;}else if(_this.state.npn[_this.state.npn.length-1][0][0]===1){// console.log('hi')
return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['1st-1'];}else{return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme][pos];}}else if(pos==='npn00.pd'){if(_this.arraysEqual(_this.state.npn[_this.state.npn.length-1][0],[0,0,0,1])){return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['npn00.b'];}else if(_this.state.npn[_this.state.npn.length-1][0][0]===1){// console.log('hi')
return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme]['1st-2'];}else{return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme][pos];}}else{// console.log(colorsList[currentColorScheme], pos)
if(!(pos in __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme])){return'#000000';}else{return __WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["b" /* colorsList */][currentColorScheme][pos];}}}};_this.getDropdownStyle=function(color){return{lineHeight:'33px',marginTop:'2px',marginBottom:'2px',border:'solid 1px #22242626',color:_this.getColor(color),fontSize:'18px',padding:'5px',borderRadius:'5px',marginRight:'2px',marginLeft:'2px'};};_this.shortEnoughVEnglish2=function(type){var offsetWidth=0;var offsetHeight=0;if(_this.vEnglish2Ref[type]!==null&&_this.vEnglish2Ref[type]!==undefined){offsetWidth=_this.vEnglish2Ref[type].offsetWidth;offsetHeight=_this.vEnglish2Ref[type].offsetHeight;}// console.log(offsetWidth)
// console.log(offsetHeight)
if(offsetHeight>50){return false;}else{return true;}// if (window.innerWidth < 480 && offsetWidth > 230) {
// 	return false
// } else if (offsetWidth > 300) {
// 	return false
// } else {
// 	return true
// }
// }
};_this.recordClip=function(sentence,siteLocation,english){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["w" /* Modal */],{on:'click',open:_this.state.showModal,style:{maxWidth:500,marginTop:window.innerWidth<480?10:10},closeOnDimmerClick:false,onOpen:function onOpen(){},onClose:function onClose(){_this.setState({showModal:false,wordsList:[],searchQuery:''});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["x" /* ModalContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,style:{margin:0,color:'#929292',cursor:'pointer',position:'relative',float:'right'},size:'large',onClick:function onClick(){_this.setState({showModal:false});},name:'x'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Recorder_js__["a" /* default */],{english:english,sentence:sentence,siteLocation:siteLocation})));};_this.displayIfClipExists=function(sentence){console.log(sentence);// axios
//   .get(API_URL + "/yugtunCrowdsourceAudioLookup/" + sentence)
//   .then(response => {
//     // console.log(response.data);
//     this.setState({audioRetrieved:response.data})
//   });
};_this.displayAudioMic=function(audioRetrieved){// console.log(audioRetrieved)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["y" /* Popup */],{content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{style:{fontFamily:customFontFam},divided:true,verticalAlign:'middle'},audioRetrieved.map(function(k,kindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["s" /* ListItem */],{style:{display:'flex',flexDirection:'row',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{float:'left',border:_this.state.playingAudio&&_this.state.clickedAudioIndex===kindex?'solid 1px #4a80b5':'solid 1px #dededf',marginLeft:5,backgroundColor:'white',color:k['village']=='computer generated'?'#929292':'#106181',cursor:'pointer'},circular:true,icon:'volume up',onClick:function onClick(){return _this.repeatAudio(k['filename'],kindex);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',marginLeft:10,padding:'5px 0px'}},k['gender']!='do_not_wish_to_say'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,k['gender'].replaceAll('_',' / ')):null,k['age']!='do_not_wish_to_say'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,k['age']):null,k['village']!='do_not_wish_to_say'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,k['village']):null,(k['gender']=='do_not_wish_to_say'||k['gender']=='')&&(k['age']=='do_not_wish_to_say'||k['age']=='')&&(k['village']=='do_not_wish_to_say'||k['village']=='')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Anonymous'):null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["s" /* ListItem */],{style:{display:'flex',flexDirection:'row',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{circular:true,basic:true,style:{opacity:0.9,marginLeft:5,fontSize:'14px'},onClick:function onClick(){_this.setState({openPopup:false},function(){_this.setState({showModal:true});});},icon:'microphone'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:10,padding:'5px 0px'}},'Submit a Recording for Yugtun.com'))),on:'click',open:_this.state.openPopup,onClose:function onClose(){return _this.setState({openPopup:false});},style:{padding:8},position:'top right',trigger:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{size:'large',onClick:function onClick(){_this.setState({openPopup:true});},style:{paddingRight:15,fontSize:'17px',margin:10},circular:true,basic:true,icon:true},audioRetrieved.length==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:'#929292'},name:'microphone'}):audioRetrieved.length==1&&audioRetrieved[0]['village']=='computer generated'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:'#929292',fontSize:'16px'},name:'volume up'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:'#106181',fontSize:'16px'},name:'volume up'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{color:'#d2d2d2',paddingLeft:'6px',fontSize:'11px'},name:'chevron down'}),' ')});};var queryString=window.location.search;var urlParams=new URLSearchParams(queryString);var record=urlParams.get('record');// console.log(decodeURI(props.match.params.num))
_this.state={dictionary:_this.props.dictionary,usageDictionary:_this.props.usageDictionary,dictionary_dict:_this.props.dictionary_dict,filteredDictV:_this.props.filteredDictV,filteredDictVit:_this.props.filteredDictVit,filteredDictN:_this.props.filteredDictN,// filteredDictVVfuture:{},
// filteredDictVVpast:{},
filteredDictVVall:{},otherBases:[],nextTenses:[],unallowable_next_ids:[],startingCase:'',modalOpen:true,colorScheme:0,activeIndexes:[],activeIndexes1:[],addSubject:false,addIs:true,nounNum:'s',mvvsPlanned:[],overlayOn:false,// colorsList: {
// 	'mvv.b':'#000000',
// 	'mvv.e':'#852828',
// 	'mvv.s':'#852828',
// 	'mvv.o':'#C84141',
// 	'mvv.m':'#838383',
// 	'mvv.1':'#d3741e',
// 	'mvv.2':'#c062c3',
// 	'mvv.3':'#008000',
// 	'mvv.4':'#69b4b4',
// 	'mvv.5':'#e02323',
// 	'mvv.6':'#3455b5',
// 	'mvnObliques000.b':'#000000',
// 	'mvnObliques000.ps':'#c51818',
// 	'mvnObliques000.pd':'#d23636',
// 	'mvnObliques000.c':'#9c9c9c',
// 	'mvnObliques000.1':'#69b4b4',
// 	'mvnObliques100.b':'#000000',
// 	'mvnObliques100.ps':'#c51818',
// 	'mvnObliques100.pd':'#d23636',
// 	'mvnObliques100.c':'#9c9c9c',
// 	'cvv.b':'#000000',
// 	'cvv.e':'#3070AB',
// 	'cvv.s':'#3070AB',
// 	'cvv.o':'#618EB8',
// 	'cvv.m':'#75557e',
// 	'npn00.b':'#000000',
// 	'npn00.pd':'#d23636',
// 	'npn00.ps':'#c51818',
// 	'npn00.1':'#69b4b4',
// 	'npn00.2':'#e02323',
// 	'npn00.c':'#9c9c9c',
// 	'mvns00.b':'#852828',
// 	'mvns00.ps':'#c51818',
// 	'mvns00.pd':'#d23636',				
// 	'mvns00.1':'#b53434',
// 	'mvns00.2':'#578f7f',
// 	'mvns00.e':'#f29090',
// 	'mvno00.b':'#C84141',
// 	'mvno00.1':'#b53434',
// 	'mvno00.2':'#578f7f',
// 	'mvno00.e':'#f29090',
// 	// 'mvns10.b':'#852828',
// 	// 'mvv.4':'#000000',
// },
// '#000000',
// '#852828',
// '#b53434',
// '#578f7f',
// '#f29090',
// 'purple',//connective 5
// '#3070AB',//connective subject 6
// '#4338ac', //connective object 7
// ].concat(shuffle(palette('tol-rainbow', 500).map((c) => { return '#' + c; }))),
mvSubjectColor:'#852828',mvObjectColor:'#b53434',// // mvPostbaseColors: 
// cvSubjectColor: '#3070AB',
// cvObjectColor: '#b53434',
// currentPostbases: ['13'],
// mvSubjectDisplay: [['angute',1],['cuara',20],['at',1]],
// mvSubjectUnderlyingDisplay: [[['angute-',1]],[['–cuar(ar*)[N→N]',20]],[['%:(e)t',1]],],
// mvObjectDisplay: [['tuntuvi',2],['it',2]],
// mvObjectUnderlyingDisplay: [[['tuntuvag-',2]],[['%:(e)t',2]],],
// mvDisplay: [['nii',0],['cugnarqe',3],['llru',0],['i',2],['t',1]],
// mvUnderlyingDisplay: [[['niite-',0]],[['@~+yugnarqe2[V→V]',3]],[['–llru[V→V]',0]],[["+'(g)ai",2],["t",1]]],
// mvEnglish1: [],			
// mvSubjectEnglish: [['small',20],['men',1]],
// mvEnglish2: [['probably',3],['heard',0],['', 0]],
// mvObjectEnglish: [['moose',2]],
// mvEnglish3: [],
// cvExists: true,
// cvSubjectDisplay: [['arnar',6],['pi',21],['it',6]],
// cvSubjectUnderlyingDisplay: [[['arnar-',6]],[['–rpag|@vag[N→N]',21]],[['%:(e)t',6]],],
// cvObjectDisplay: [['tumyara',7],['t',7]],
// cvObjectUnderlyingDisplay: [[['tumyarar-',7]],[['%:(e)t',7]],],
// cvDisplay: [['tanger',0],['pailg',5],['at',6],['ki',7]],
// cvUnderlyingDisplay: [[['niite-',0]],[['@+paileg',5]],[['at',6],["ki",7]]],
// cvEnglish1: [['before',5],],			
// cvSubjectEnglish: [['big',21],['women',6]],
// cvEnglish2: [['saw',0]],
// cvObjectEnglish: [['trails',7]],
// cvEnglish3: [],
mvSubjectDisplay:[[['arna',2],['cuara',2],['ak',2]],[['qimugt',1],['ii',1],['k',2]]],mvSubjectUnderlyingDisplay:[[[['arnar-',2]],[['–cuar(ar*)[N→N]',2]],[['%:(e)k',2]]],[[['qimugte-',1]],[[':(ng)a',1],['k',2]]]],mvObjectDisplay:[],mvObjectUnderlyingDisplay:[],// mvDisplay: [['aqume',0],['llru',3],['uq',1]],
// mvUnderlyingDisplay: [[['aqume-',0]],[['–llru[V→V]',3]],[["+'(g/t)uq",1]]],
mvEnglish1:[],mvEnglish2:[],mvEnglish3:[],mvEnglish3in2:[],mvEnglishAbl:[],mvEnglishQaa:[],svEnglishAbl:[],mvnsEnglish1:[],mvnsEnglish2:[],mvnoEnglish1:[],mvnoEnglish2:[],mvSubjectEnglish:[],mvObjectEnglish:[],cvEnglish1:[],cvEnglish2:[],cvEnglish3:[],cvEnglish3in2:[],cvEnglishAbl:[],cvSubjectEnglish:[],cvObjectEnglish:[],svEnglish1:[],svEnglish2:[],svObjectEnglish:[],npnEnglish1:[],npnEnglish2:[],mvSubjectSegments:"",// mvSegments:"nere>llru>uq",
mvvSegments:"",mvqWordSegments:"",mvnsSegments:[],mvnoSegments:[],// cvExists: false,
// cvSubjectDisplay: [['arnar',6],['pi',21],['it',6]],
// cvSubjectUnderlyingDisplay: [[['arnar-',6]],[['–rpag|@vag[N→N]',21]],[['%:(e)t',6]],],
// cvObjectDisplay: [['tumyara',7],['t',7]],
// cvObjectUnderlyingDisplay: [[['tumyarar-',7]],[['%:(e)t',7]],],
// cvDisplay: [['tanger',0],['pailg',5],['at',6],['ki',7]],
// cvUnderlyingDisplay: [[['niite-',0]],[['@+paileg',5]],[['at',6],["ki",7]]],
// cvEnglish1: [['before',5],],			
// cvSubjectEnglish: [['big',21],['women',6]],
// cvEnglish2: [['saw',0]],
// cvObjectEnglish: [['trails',7]],
// cvEnglish3: [],
// mvvBase:[["nere","–llru[V→V]"],"i"],
// mvvMood:"Ind",
// mvvs:[3,1,1],
// mvnsBases:[["qimugte","–cuar(ar*)[N→N]"],["angute","–rpag|@vag[N→N]"],],
// mvns:[[3,1,1,1],[2,1,1,1]],
mvvBase:[],mvvMood:"",mvvs:[],mvvType:'',mvnsBases:[],mvns:[],mvvo:[],mvnoBases:[],mvno:[],mvqWord:[],cvvBase:[],cvnsBases:[],cvnoBases:[],cvno:[],cvns:[],cvvMood:"",cvvType:'',cvvs:[],cvvo:[],cvvSegments:"",cvnsSegments:[],cvnoSegments:[],svvBase:[],svnsBases:[],svnoBases:[],svno:[],svns:[],svvMood:"",svvType:'',svvs:[],svvo:[],svvSegments:"",svnsSegments:[],svnoSegments:[],npn:[],npnBases:[],npnCase:[],npnSegments:[],npnType:[],mvnObliquesSegments:[],cvnObliquesSegments:[],svnObliquesSegments:[],// mvSubject:[3,1,1],
// mvSubjectNumbers: [['000','2'],['1']],
// mvSubjectPossessor: '000',
// mvObjectNumber: '3',
// mvObjectPossessor: '000',
// cvSubject: "330",
// cvObject: "330",
// cvSubjectExists: true,
// cvSubjectNounExists: true,
// cvSubjectNumber: '3',
// cvSubjectPossessor: '000',
// cvObjectExists: true,
// cvObjectNounExists: true,
// cvObjectNumber: '3',
// cvObjectPossessor: '000',
segmentString:'',audioRetrieved:[],wordsList:[],searchQuery:'',search:'',currentEditMode:'default',cpreviousEditMode:'default',mvnObliques:[],cvnObliques:[],svnObliques:[],candidateBase:[],candidateDisplay:[],candidateFST:[],candidateType:'',lockSubmit:false,glossary:false,showShortcuts:false,svvText:'',endingAdjusted:'',requirePostbase:'',optCase:'',// mvSubjectOptions:mvSubjectOptions,
// mvObjectOptions:mvObjectOptions,
nounOptionsMVPossessors:[{id:0,value:'000',text:'the'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsMVAblPossessors:[{id:0,value:'000',text:'a, some'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsCVPossessors:[{id:0,value:'000',text:'the'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsCVAblPossessors:[{id:0,value:'000',text:'a, some'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsSVPossessors:[{id:0,value:'000',text:'the'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsSVAblPossessors:[{id:0,value:'000',text:'a, some'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),cvSubjectOptions1:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["k" /* mvSubjectOptions */],cvObjectOptions1:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["d" /* mvObjectOptions */],mvSubjectOptions1:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["k" /* mvSubjectOptions */],mvObjectOptions1:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["d" /* mvObjectOptions */],svObjectOptions1:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["d" /* mvObjectOptions */],nounOptionsMVPossessors1:[{id:0,value:'000',text:'the'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsMVAblPossessors1:[{id:0,value:'000',text:'a, some'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsCVPossessors1:[{id:0,value:'000',text:'the'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsCVAblPossessors1:[{id:0,value:'000',text:'a, some'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsSVPossessors1:[{id:0,value:'000',text:'the'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounOptionsSVAblPossessors1:[{id:0,value:'000',text:'a, some'}].concat(__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["q" /* nounOptionsMVPossessors */]),nounIndexChosen:0,parses:{},switchedToEdit:false,currentlyOpen:'',crecentlyOpen:'',containsTime:false,width:window.innerWidth,height:window.innerHeight,openPopup:false,showModal:false,audioParameterBool:record!==null||true?true:false,englishString:'',playingAudio:false,clickedAudioUrl:"",clickedAudio:null,clickedAudioIndex:-1};_this.subjectMenu={};_this.editMenuRef={};_this.mainScreenMenuRef={};_this.mvEnglish2Ref={};_this.cvEnglish2Ref={};_this.vEnglish2Ref={};_this.mvEnglishVerticalRef={};_this.cvEnglishVerticalRef={};_this.fromEntry=false;// console.log(decodeURI(props.match.params.num))
if(decodeURI(props.match.params.num)==2&&props.location.state!==undefined){// console.log('hi',this.props.location.state)
_this.fromEntry=true;_this.backEndCall([],true,true);}else{_this.backEndCall([['Delete',['mv'],''],['Delete',['np'],'']]);}// if (decodeURI(props.match.params.num) in sentenceTemplates) {
// this.backEndCall(sentenceTemplates[decodeURI(props.match.params.num)][2])
// }
return _this;}_createClass(SentenceBuilder,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var start=__WEBPACK_IMPORTED_MODULE_12_performance_now___default()();window.addEventListener('resize',this.updateDimensions);// console.log(this.props)
// if (dictionary.length === 0) {
//   // axios
//   //   .get(API_URL + "/word/all2021")
//   //   .then(response => {
//   //     let end = now();
//   //     ReactGA.timing({
//   //       category: 'Loading',
//   //       variable: 'dictionary',
//   //       value: (end-start).toFixed(3),
//   //       label: 'Dictionary loading'
//   //     });
//   //     dictionary = response.data;
//   //     console.log(dictionary)
//   //     console.log('Fetched dictionary');
// this.setState({ dictionary: this.props.dictionary});
//   //   });
// }
// if (this.props.usageDictionary.length > 0) {
//   // axios
//   //   .get(API_URL + "/yupiksearchableusagelist/all")
//   //   .then(response => {
//   //     let end = now();
//   //     ReactGA.timing({
//   //       category: 'Loading',
//   //       variable: 'dictionary',
//   //       value: (end-start).toFixed(3),
//   //       label: 'Dictionary loading'
//   //     });
//   //     usageDictionary = response.data;
//   //     console.log(usageDictionary)
//   //     console.log('Fetched usage dictionary');
// 	let filteredDictV = this.props.usageDictionary.filter(entry => (entry.type.includes('i')||entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]')||entry.type.includes('[V→V]')) )
// 	let filteredDictN = this.props.usageDictionary.filter(entry => (entry.type.includes('n')||entry.type.includes('[V→N]')||entry.type.includes('[N→N]')))
// 	let filteredDictVit = this.props.usageDictionary.filter(entry => (entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]')||entry.type.includes('[V→V]')))
//       this.setState({ filteredDictV: filteredDictV, filteredDictVit: filteredDictVit, filteredDictN: filteredDictN});
//     // });
// }
if(this.state.usageDictionary.length===0){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/yupiksearchableusagelist/all").then(function(response){var end=__WEBPACK_IMPORTED_MODULE_12_performance_now___default()();// ReactGA.timing({
//   category: 'Loading',
//   variable: 'dictionary',
//   value: (end-start).toFixed(3),
//   label: 'Dictionary loading'
// });
usageDictionary=response.data;// console.log(usageDictionary)
// console.log('Fetched usage dictionary');
// let filteredDictV = usageDictionary.filter(entry => (entry.type.includes('i')||entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]')||entry.type.includes('[V→V]')) )
// let filteredDictN = usageDictionary.filter(entry => (entry.type.includes('n')||entry.type.includes('[V→N]')||entry.type.includes('[N→N]')))
// let filteredDictVit = usageDictionary.filter(entry => (entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]')||entry.type.includes('[V→V]')))
// this.setState({ usageDictionary: usageDictionary});
var filteredDictV=usageDictionary.filter(function(entry){return(entry.type.includes('i')||entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]'))&&!entry.properties.includes('sub');});var filteredDictVsub=usageDictionary.filter(function(entry){return entry.type.includes('i')||entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]');});var filteredDictN=usageDictionary.filter(function(entry){return entry.type.includes('n')||entry.type.includes('[V→N]')||entry.type.includes('[N→N]');});var filteredDictVit=usageDictionary.filter(function(entry){return(entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]'))&&!entry.properties.includes('sub');});var filteredDictVVnofuture=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('future')&&!entry.properties.includes('sub');});var filteredDictVVnopast=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('past')&&!entry.properties.includes('sub');});var filteredDictVVnotime=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('past')&&!entry.properties.includes('future')&&!entry.properties.includes('sub');});var filteredDictVVnotimesub=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('past')&&!entry.properties.includes('future');});var filteredDictVVall=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('sub');});_this2.setState({usageDictionary:usageDictionary,filteredDictVsub:filteredDictVsub,filteredDictVVnotimesub:filteredDictVVnotimesub,filteredDictV:filteredDictV,filteredDictVit:filteredDictVit,filteredDictN:filteredDictN,filteredDictVVnofuture:filteredDictVVnofuture,filteredDictVVnopast:filteredDictVVnopast,filteredDictVVnotime:filteredDictVVnotime,filteredDictVVall:filteredDictVVall});});}else{usageDictionary=this.state.usageDictionary;var filteredDictV=usageDictionary.filter(function(entry){return(entry.type.includes('i')||entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]'))&&!entry.properties.includes('sub');});var filteredDictVsub=usageDictionary.filter(function(entry){return entry.type.includes('i')||entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]');});var filteredDictN=usageDictionary.filter(function(entry){return entry.type.includes('n')||entry.type.includes('[V→N]')||entry.type.includes('[N→N]');});var filteredDictVit=usageDictionary.filter(function(entry){return(entry.type.includes('t')||entry.type.includes('it')||entry.type.includes('[N→V]'))&&!entry.properties.includes('sub');});var filteredDictVVnofuture=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('future')&&!entry.properties.includes('sub');});var filteredDictVVnopast=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('past')&&!entry.properties.includes('sub');});var filteredDictVVnotime=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('past')&&!entry.properties.includes('future')&&!entry.properties.includes('sub');});var filteredDictVVnotimesub=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('past')&&!entry.properties.includes('future');});var filteredDictVVall=usageDictionary.filter(function(entry){return entry.type.includes('[V→V]')&&!entry.properties.includes('sub');});this.setState({usageDictionary:usageDictionary,filteredDictVsub:filteredDictVsub,filteredDictVVnotimesub:filteredDictVVnotimesub,filteredDictV:filteredDictV,filteredDictVit:filteredDictVit,filteredDictN:filteredDictN,filteredDictVVnofuture:filteredDictVVnofuture,filteredDictVVnopast:filteredDictVVnopast,filteredDictVVnotime:filteredDictVVnotime,filteredDictVVall:filteredDictVVall});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('resize',this.updateDimensions);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _this3=this;if(this.props.match.params.num!==prevProps.match.params.num){if(decodeURI(this.props.match.params.num)==1){this.fromEntry=false;this.backEndCall([['Delete',['mv'],''],['Delete',['np'],'']]);}}if(prevState.mv!==this.state.mv||prevState.cv!==this.state.cv||prevState.sv!==this.state.sv||prevState.np!==this.state.np){// console.log('changed')
this.update4thPersonAndAgreement();}if(prevState.wordsList!==this.state.wordsList||prevState.activeIndexes!==this.state.activeIndexes){var tag=this.state.currentlyOpen;this.setState({currentlyOpen:''},function(){_this3.setState({currentlyOpen:tag});});}// if (prevState.segmentString !== this.state.segmentString) {
//   console.log(this.state.segmentString)
//   this.displayIfClipExists(this.state.segmentString)
// }
// if (prevState.addSubject !== this.state.addSubject && this.state.crecentlyOpen !== '') {
// 	this.openSubjectMenu(this.state.crecentlyOpen)
// 	// this.subjectMenu.open();    		
// }
// if (prevState.currentEditMode !== this.state.currentEditMode && this.state.crecentlyOpen !== '') {
// 	// console.log(this.state.crecentlyOpen)
// 	this.openEditMenuRef(this.state.crecentlyOpen)
// 	// this.setState({currentEditMode:'default'})
// 	// this.openMainScreenMenuRef(this.state.crecentlyOpen)
// }
// if (prevState.currentlyOpen !== this.state.currentlyOpen && this.state.currentEditMode === this.state.cpreviousEditMode) {
// 	// console.log(this.state.currentlyOpen)
// 	this.setState({currentEditMode:'default'})
// }
// if (prevState.currentEditMode !== this.state.currentEditMode) {
// 	this.editMenuRef.open();
// }
}},{key:'initialize',// setDefaultInstructions = (num, event, data) => {
// 	// instructionSet[num].map((x)=>{
// 	// 	console.log(x)
// 	this.backEndCall(instructionSet[num])
// 	// })
// }
value:function initialize(type){if(type==='mv'){this.setState({mvvBase:[],mvnsBases:[],mvnoBases:[],mvno:[],mvns:[],mvvMood:"",mvvs:[],mvvo:[],mvnObliques:[],mvnObliquesSegments:[],mvvSegments:[],mvnsSegments:[],mvnoSegments:[],mvEnglish1:[],mvEnglish2:[],mvEnglish3:[],mvEnglish3in2:[],mvEnglishAbl:[],mvEnglishQaa:[],mvqWord:[],mvqWordSegments:[],mvvType:'',optCase:'',mv:{},requirePostbase:''});}else if(type==='cv'){this.setState({cvvBase:[],cvnsBases:[],cvnoBases:[],cvno:[],cvns:[],cvvMood:"",cvvType:'',cvvs:[],cvvo:[],cvnObliques:[],cvnObliquesSegments:[],cvvSegments:[],cvnsSegments:[],cvnoSegments:[],cvEnglish1:[],cvEnglish2:[],cvEnglish3:[],cvEnglish3in2:[],cvEnglishAbl:[],cv:{},requirePostbase:''});}else if(type==='sv'){this.setState({svvBase:[],svnsBases:[],svnoBases:[],svno:[],svns:[],svvMood:"",svvType:"",svvs:[],svvo:[],svnObliques:[],svnObliquesSegments:[],svvSegments:[],svnoSegments:[],svEnglish1:[],svEnglish2:[],svEnglishAbl:[],sv:{}});}else if(type==='np'){this.setState({npn:[],npnBases:[],npnCase:[],npnType:[],npnSegments:[],npnEnglish1:[],npnEnglish2:[],np:{}});}}},{key:'requirePostbaseMood',value:function requirePostbaseMood(mood){if(mood=='Intrg4'||mood=='Intrg5'||mood=='Cont'||mood=='CtmpI'||mood=='CtmpII'){return true;}else{return false;}}},{key:'backEndCall',value:function backEndCall(keyChanged,eraseExisting,simpleCall){var _this4=this;// console.log('backend',this.state)
// console.log('backendcall',keyChanged, eraseExisting, simpleCall)
var mv={};var cv={};var sv={};var np={};if(eraseExisting){if(simpleCall&&this.props.location.state!==undefined){if('mv'in this.props.location.state){Object.keys(this.props.location.state['mv']).map(function(k){// console.log('entry',k)
mv[k]=_this4.props.location.state['mv'][k];});}else{Object.keys(this.props.location.state['np']).map(function(k){// console.log('entry',k)
np[k]=_this4.props.location.state['np'][k];});}}}else{if(this.state.mvvBase.length>0){mv['vBase']=this.state.mvvBase;}if(this.state.mvnsBases.length>0){mv['nsBases']=this.state.mvnsBases;}if(this.state.mvnoBases.length>0){mv['noBases']=this.state.mvnoBases;}if(this.state.mvno.length>0){mv['no']=this.state.mvno;}if(this.state.mvns.length>0){mv['ns']=this.state.mvns;}if(this.state.mvvMood.length>0){mv['vMood']=this.state.mvvMood;}if(this.state.mvvType.length>0){mv['vType']=this.state.mvvType;}if(this.state.mvvs.length>0){mv['vs']=this.state.mvvs;}if(this.state.mvvo.length>0){mv['vo']=this.state.mvvo;}if(this.state.mvnObliques.length>0){mv['nObliques']=this.state.mvnObliques;}// if (this.state.mvqWord.length > 0) {mv['qWord']=this.state.mvqWord}
if(this.state.cvvBase.length>0){cv['vBase']=this.state.cvvBase;}if(this.state.cvnsBases.length>0){cv['nsBases']=this.state.cvnsBases;}if(this.state.cvnoBases.length>0){cv['noBases']=this.state.cvnoBases;}if(this.state.cvno.length>0){cv['no']=this.state.cvno;}if(this.state.cvns.length>0){cv['ns']=this.state.cvns;}if(this.state.cvvMood.length>0){cv['vMood']=this.state.cvvMood;}if(this.state.cvvType.length>0){cv['vType']=this.state.cvvType;}if(this.state.cvvs.length>0){cv['vs']=this.state.cvvs;}if(this.state.cvvo.length>0){cv['vo']=this.state.cvvo;}if(this.state.cvnObliques.length>0){cv['nObliques']=this.state.cvnObliques;}if(this.state.svvBase.length>0){sv['vBase']=this.state.svvBase;}if(this.state.svnsBases.length>0){sv['nsBases']=this.state.svnsBases;}if(this.state.svnoBases.length>0){sv['noBases']=this.state.svnoBases;}if(this.state.svno.length>0){sv['no']=this.state.svno;}if(this.state.svns.length>0){sv['ns']=this.state.svns;}if(this.state.svvMood.length>0){sv['vMood']=this.state.svvMood;}if(this.state.svvType.length>0){sv['vType']=this.state.svvType;}if(this.state.svvs.length>0){sv['vs']=this.state.svvs;}if(this.state.svvo.length>0){sv['vo']=this.state.svvo;}if(this.state.svnObliques.length>0){sv['nObliques']=this.state.svnObliques;}if(this.state.npn.length>0){np['n']=this.state.npn;}if(this.state.npnBases.length>0){np['nBases']=this.state.npnBases;}if(this.state.npnCase.length>0){np['nCase']=this.state.npnCase;}if(this.state.npnType.length>0){np['nType']=this.state.npnType;}}// console.log(keyChanged,mv)
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/sentencebuilder",{keyChanged:keyChanged,mv:mv,cv:cv,sv:sv,np:np}).then(function(response){console.log(response.data);var vkey=void 0,nkey=void 0;var updateDict={};if("english"in response.data){vEnglish.map(function(k){if(k in response.data['english']){updateDict[[k]]=response.data['english'][k];}else{updateDict[[k]]=[];}});// Object.keys(response.data['english']).map((k)=>{
// 		// console.log(k)
// 		// console.log(response.data['english'][k])
// 		updateDict[[k]] = response.data['english'][k]
//    // this.setState({
//    // 	[k]: response.data['english'][k],
//    // })
//  })
}if("mv"in response.data){updateDict['mv']=response.data['mv'];vOptions.map(function(k){vkey='mv'+k;if(k in response.data['mv']){// this.setState({
// [vkey]: response.data['mv'][k],
// })
updateDict[[vkey]]=response.data['mv'][k];if(k=='vType'){if(_this4.requirePostbaseMood(response.data['mv']['vType'])){updateDict['requirePostbase']=response.data['mv']['vType'];}}}else{updateDict[[vkey]]=[];// this.setState({
// [vkey]: [],
// })      				
}});}else{_this4.initialize('mv');}if("cv"in response.data){updateDict['cv']=response.data['cv'];vOptions.map(function(k){vkey='cv'+k;if(k in response.data['cv']){updateDict[[vkey]]=response.data['cv'][k];if(k=='vMood'){if(_this4.requirePostbaseMood(response.data['cv']['vMood'])){updateDict['requirePostbase']=response.data['cv']['vMood'];}}}else{updateDict[[vkey]]=[];// this.setState({
// [vkey]: [],
// })      				
}});}else{_this4.initialize('cv');}if("sv"in response.data){updateDict['sv']=response.data['sv'];vOptions.map(function(k){vkey='sv'+k;if(k in response.data['sv']){updateDict[[vkey]]=response.data['sv'][k];// this.setState({
// 	[vkey]: response.data['sv'][k],
// })
}else{updateDict[[vkey]]=[];// this.setState({
// [vkey]: [],
// })      				
}});// if (this.state.svvType.length > 0) {
// updateDict['svEnglish1']=[[this.state.svvType, 'svv.e']].concat(updateDict['svEnglish1'])
// this.setState({svEnglish1:[[this.state.svvType, 'svv.e']].concat(this.state.svEnglish1)})
// }
}else{_this4.initialize('sv');}if("np"in response.data){updateDict['np']=response.data['np'];nOptions.map(function(k){nkey='np'+k;if(k in response.data['np']){updateDict[[nkey]]=response.data['np'][k];}else{updateDict[[nkey]]=[];}});}else{_this4.initialize('np');}if("parses"in response.data){updateDict['parses']=response.data.parses;}if("segments"in response.data){// let segmentString = ''
if("mv"in response.data.segments){if("qWord"in response.data.segments.mv){// this.setState({
// mvvSegments: response.data.segments.mv.v,
// })      				
updateDict['mvqWordSegments']=response.data.segments.mv.qWord;// response.data.segments.mv.qWord.map((t)=>{segmentString+=t[0]})
// segmentString+=' '
}else{// this.setState({
// mvvSegments: "",
// })      	      				
updateDict['mvqWordSegments']="";}if("ns"in response.data.segments.mv){// this.setState({
// mvnsSegments: response.data.segments.mv.ns,
// })      				
updateDict['mvnsSegments']=response.data.segments.mv.ns;// response.data.segments.mv.ns.reverse().map((t)=>{t.map((u)=>{u.map((x)=>segmentString+=x[0]); segmentString+=' '})})
}else{// this.setState({
// mvnsSegments: [],
// })      	      				
updateDict['mvnsSegments']=[];}if("v"in response.data.segments.mv){// this.setState({
// mvvSegments: response.data.segments.mv.v,
// })      				
updateDict['mvvSegments']=response.data.segments.mv.v;// response.data.segments.mv.v.map((t)=>{segmentString+=t[0]})
// segmentString+=' '
}else{// this.setState({
// mvvSegments: "",
// })      	      				
updateDict['mvvSegments']="";}if("no"in response.data.segments.mv){// this.setState({
// mvnoSegments: response.data.segments.mv.no,
// })      				
updateDict['mvnoSegments']=response.data.segments.mv.no;// response.data.segments.mv.no.reverse().map((t)=>{t.map((u)=>{u.map((x)=>segmentString+=x[0]); segmentString+=' '})})
}else{// this.setState({
// mvnoSegments: [],
// })      	      				
updateDict['mvnoSegments']=[];}if("nObliques"in response.data.segments.mv){// this.setState({
// mvnObliquesSegments: response.data.segments.mv.nObliques,
// })      				
updateDict['mvnObliquesSegments']=response.data.segments.mv.nObliques;// response.data.segments.mv.nObliques.map((t)=>{t.reverse().map((u)=>{u.map((x)=>{x.map((y)=>segmentString+=y[0]); segmentString+=' '})})})
}else{// this.setState({
// mvnObliquesSegments: [],
// })      	      				
updateDict['mvnObliquesSegments']=[];}}if("cv"in response.data.segments){if("nObliques"in response.data.segments.cv){// this.setState({
// cvnObliquesSegments: response.data.segments.cv.nObliques,
// })      				
updateDict['cvnObliquesSegments']=response.data.segments.cv.nObliques;// response.data.segments.cv.nObliques.map((t)=>{t.reverse().map((u)=>{u.map((x)=>{x.map((y)=>segmentString+=y[0]); segmentString+=' '})})})
}else{// this.setState({
// cvnObliquesSegments: "",
// })      	      				
updateDict['cvnObliquesSegments']="";}if("ns"in response.data.segments.cv){// this.setState({
// cvnsSegments: response.data.segments.cv.ns,
// })      				
updateDict['cvnsSegments']=response.data.segments.cv.ns;// response.data.segments.cv.ns.reverse().map((t)=>{t.map((u)=>{u.map((x)=>segmentString+=x[0]); segmentString+=' '})})
}else{// this.setState({
// cvnsSegments: [],
// })      	      				
updateDict['cvnsSegments']=[];}if("v"in response.data.segments.cv){// this.setState({
// cvvSegments: response.data.segments.cv.v,
// })      				
updateDict['cvvSegments']=response.data.segments.cv.v;// response.data.segments.cv.v.map((t)=>{segmentString+=t[0]})
}else{// this.setState({
// cvvSegments: "",
// })      	      				
updateDict['cvvSegments']="";}if("no"in response.data.segments.cv){// this.setState({
// cvnoSegments: response.data.segments.cv.no,
// })      				
updateDict['cvnoSegments']=response.data.segments.cv.no;// response.data.segments.cv.no.reverse().map((t)=>{t.map((u)=>{u.map((x)=>segmentString+=x[0]); segmentString+=' '})})
}else{// this.setState({
// cvnoSegments: [],
// })      	      				
updateDict['cvnoSegments']=[];}}if("sv"in response.data.segments){if("nObliques"in response.data.segments.sv){// this.setState({
// svnObliquesSegments: response.data.segments.sv.nObliques,
// })      				
updateDict['svnObliquesSegments']=response.data.segments.sv.nObliques;// response.data.segments.sv.nObliques.map((t)=>{t.reverse().map((u)=>{u.map((x)=>{x.map((y)=>segmentString+=y[0]); segmentString+=' '})})})
}else{// this.setState({
// svnObliquesSegments: "",
// })      	      				
updateDict['svnObliquesSegments']="";}if("v"in response.data.segments.sv){// this.setState({
// svvSegments: response.data.segments.sv.v,
// })      				
updateDict['svvSegments']=response.data.segments.sv.v;// response.data.segments.sv.v.map((t)=>{segmentString+=t[0]})
}else{// this.setState({
// svvSegments: "",
// })      	      				
updateDict['svvSegments']="";}if("no"in response.data.segments.sv){// this.setState({
// svnoSegments: response.data.segments.sv.no,
// })      				
updateDict['svnoSegments']=response.data.segments.sv.no;// response.data.segments.sv.no.reverse().map((t)=>{t.map((u)=>{u.map((x)=>segmentString+=x[0]); segmentString+=' '})})
}else{// this.setState({
// svnoSegments: [],
// })      	      				
updateDict['svnoSegments']=[];}}if("np"in response.data.segments){if("n"in response.data.segments.np){// this.setState({
// npnSegments: response.data.segments.np.n,
// })      				
updateDict['npnSegments']=response.data.segments.np.n;// response.data.segments.np.n.reverse().map((t)=>{t.map((u)=>{u.map((x)=>segmentString+=x[0]); segmentString+=' '})})
}else{// this.setState({
// npnSegments: [],
// })      	      				
updateDict['npnSegments']=[];}}updateDict['segmentString']=response.data.segmentString;updateDict['audioRetrieved']=response.data.audioRetrieved;var englishString='';if("mvEnglishString"in response.data.english){englishString+=response.data.english.mvEnglishString;}if("cvEnglishString"in response.data.english){englishString+=' '+response.data.english.cvEnglishString;}if("svEnglishString"in response.data.english){englishString+=' '+response.data.english.svEnglishString;}if("npEnglishString"in response.data.english){englishString+=' '+response.data.english.npEnglishString;}updateDict['englishString']=englishString;}_this4.setState(updateDict,function(){_this4.resetAfterSubmit();});// Object.keys(updateDict).map((k)=>{
// this.setState({[k]:updateDict[k]})
// })
});}// closeEditMenuRef = (typeInd,currentEditMode,turnOffAndOn) => {
// 	// console.log(typeInd,currentEditMode)
// 	if (turnOffAndOn) {
// 		if (typeInd in this.editMenuRef) {
// 			this.editMenuRef[typeInd].close()
// 		}
// 		this.setState({
// 			currentEditMode:currentEditMode,
// 		},()=>{
// 			this.editMenuRef[typeInd].open()
// 		})
// 	} else {
// 		// console.log(this.editMenuRef, typeInd, typeInd in this.editMenuRef)
// 		if (typeInd in this.editMenuRef) {
// 			if (this.editMenuRef[typeInd] !== null) {
// 				this.editMenuRef[typeInd].close()
// 			}
// 		}
// 		this.setState({
// 			currentEditMode:'default',
// 			currentlyOpen:'',
// 		})		
// 	}
// }
// openSubjectMenu = (tag) => {
// 	this.subjectMenu[tag].open()
// }
// mainScreenMenu = (name, currentEditMode,setState,setStateTo,forEnglish) => {
// 	// console.log(name, currentEditMode,setState,setStateTo)
// 	return   <Popup
// 				    trigger={<div style={{
// 				    	border:'solid 1px #22242626',
// 				    	fontSize:'16px',
// 				    	padding:'5px',
// 				    	borderRadius:'5px',
// 				    	marginRight:'2px',
// 				    	marginLeft:'2px',
// 				    	cursor:'pointer',
// 				    	textAlign:'center',
// 				    	color:'#00000099'
// 				    }}>{name}</div>}
// 				    position="bottom center"
// 				    ref={(element)=>{this.mainScreenMenuRef[name]=element;}}
// 			      onOpen={()=>{
// 			      	console.log('open', name, currentEditMode, setState, setStateTo, forEnglish)
// 			      	this.setState({
// 							candidateCall:[],
// 							candidateBase:[],
// 							candidateDisplay:[],
// 							unallowable_next_ids:[],
// 							nextTenses:[],			      		
// 			      	})
// 		      		if (setState === 'npCase') {
// 								this.setState({npCase:setStateTo[0],npCaseType:setStateTo[1]})
// 							} else if (setState === 'mvvType') {
// 								this.setState({mvvType:setStateTo[0]})
// 							} else if (setState === 'mvinsertqaa') {
// 								this.setState({mvvMood:setStateTo[0] ,mvvType:setStateTo[1]})
// 							} else if (setState === 'cvvType') {
// 								this.setState({cvvMood:setStateTo[0] ,cvvType:setStateTo[1]})
// 							} else if (setState === 'svvType') {
// 								this.setState({svvType:setStateTo[0]})
// 							} else if (setState === 'optCase') {
// 								this.setState({optCase:setStateTo[0], mvvType:setStateTo[1]})
// 							} 
// 							// else {
// 								// this.setState({mvvMood:'',mvvType:'',cvvMood:'',svvType:'',optCase:'',npCase:'',npCaseType:''})
// 							// }
// 							this.setState({
// 								currentlyOpen:name, 
// 								crecentlyOpen: name, 
// 								currentEditMode:currentEditMode,
// 								overlayOn:true,
// 							// candidateCall:[],
// 							// candidateBase:[],
// 							// candidateDisplay:[],
// 							// unallowable_next_ids:[],
// 							// nextTenses:[],
// 							})
// 			      }}
//      				onClose={()=>{this.setState({currentlyOpen:'',mvvMood:'',mvvType:'',cvvMood:'',svvType:'',optCase:'',npCase:'',npCaseType:'',containsTime:false,activeIndexes1:[],candidateCall:[],candidateBase:[],lockSubmit:false,nextTenses:[],candidateDisplay:[],searchQuery:'',wordsList:[]})}}
//   >
//   	{this.contentItems(currentEditMode,currentEditMode,-1,true,forEnglish,setStateTo)}
//   </Popup>
// }
// editMenu = (type,ind) => {
// 	let typeInd = type+(ind+1).toString()
// 		return <Modal
//      trigger={									
// 			this.triggerItems(type,ind)
//      }
//      onOpen={()=>{console.log('open', this.state); 
//       						this.checkIfIntrgTense(type, ind);
//      							this.setState({
//      								cpreviousEditMode: this.state.currentEditMode, 
//      								currentlyOpen: typeInd,
//      								crecentlyOpen: typeInd,
//      								overlayOn:true,
//      							})
//      						}}
//      onClose={()=>{console.log('close', this.state); 
// 									this.resetEditMenu();
//      						}}
//      position='bottom center'
//      ref={(element)=>{this.editMenuRef[typeInd]=element;}}
//      >
//     		<div>
// 	      	{this.contentItems(this.state.currentEditMode,type,ind,false)}
// 	      </div>
//      </Modal>
// }
// "[Abl_Mod]":"Ablative-Modalis (indirect object, from...)",
// "[Loc]":"Localis (in, at...)",
// "[Ter]":"Terminalis (to...)",
// "[Via]":"Vialis (through, using...)",
// "[Equ]":"Equalis (like, similar to...)",
// getNextTenses = (p) => {
// 		if (this.state.nextTenses.length == 0) {
// 			return this.state.nextTenses.concat(['gen'])
// 		} else {
// 			let lastTense = this.state.nextTenses[this.state.nextTenses.length-1]
// 			if (p['match_case']) {
// 				return this.state.nextTenses.concat([lastTense])
// 			} else if (lastTense === 'g') {
// 				return this.state.nextTenses.concat(p['ger_preverb_after'])
// 			} else if (lastTense === 'i') {
// 				return this.state.nextTenses.concat(p['inf_preverb_after'])
// 			} else if (lastTense === 'gen') {
// 				return this.state.nextTenses.concat(p['gen_preverb_after'])
// 			} else if (lastTense === 'p') {
// 				return this.state.nextTenses.concat(p['past_preverb_after'])
// 			} else if (lastTense === 'past') {
// 				return this.state.nextTenses.concat(p['past_preverb_after'])
// 			} else if (lastTense === 'pp') {
// 				return this.state.nextTenses.concat(p['past_preverb_after'])
// 			} else if (lastTense === 'present') {
// 				return this.state.nextTenses.concat(p['gen_preverb_after'])
// 			}
// 		}
// }
// baseChooser2 = (itemUpdating,endingNeeded,update,mood,submood) => {
// 	// console.log(itemUpdating,endingNeeded,update,mood,submood)
// 	// console.log(this.state)
// 	// console.log(this.state.currentEditMode, itemUpdating,endingNeeded,update,mood,submood)
// 	         return <Grid style={{height:'400px',width:'505px'}}>
// 	                	<Grid.Row columns={2} style={{paddingBottom:'0px'}}divided>
// 	                	<Grid.Column >
// 	                		<Button onClick={()=>{this.menuSelect('default'); this.setState({searchQuery:'',wordsList:[]})}} style={{display:'flex',flexDirection:'row',alignItems:'center',paddingLeft:'13px',marginBottom:'10px'}}>
// 	                			<Icon name='chevron left' />
// 	                			<div style={{color:'#666666'}}>{'Back'}</div>
// 	                		</Button>
// 								      <Input 
// 								      icon='search' 
// 								      iconPosition='left' 
// 								      name='search'     
// 								      disabled={this.state.lockSubmit}
// 								      // width='100%'
// 								      style={{width:'220px'}}
// 								 		  onChange={this.onChangeBaseSearch.bind(this,endingNeeded)}
// 					            value={this.state.searchQuery}
// 					            // onClose={()=>{this.setState({searchQuery:'',wordsList:[]})}}
// 					            />
// 								      <Segment vertical style={{height:255,overflow: 'auto',padding:0,marginTop:5,marginBottom:0,borderBottom:'0px solid #e2e2e2'}}>
// 								      <List selection>
// 									    {this.state.wordsList.map((k)=>{return <List.Item onClick={()=>{
// 									    	// if (k['type']=='[→V]' || k['type']=='[V→V]')
// 									    	console.log(k)
// 									    	this.setState({
// 									    		searchQuery:'',
// 									    		wordsList:[],
// 									    		candidateBase:this.state.candidateBase.concat(k),
// 									    	},()=>{
// 									    		this.updateCandidateCall(endingNeeded,update,mood,submood)
// 									    	})
// 									    }} style={{cursor:'pointer',fontFamily:'Lato,Arial,Helvetica,sans-serif',fontSize:'15px',padding:5}}>
// 										        <List.Description style={{paddingBottom:'4px'}}>{k['yupikword']}</List.Description>
// 										        <List.Header style={{fontWeight:'400'}}>{this.processStyledText(k['englishraw'])}</List.Header>
// 										      </List.Item>				      	
// 									      })}
// 								    	</List>
// 								      </Segment>
// 								      {this.state.wordsList.length > 0 ?
// 									      <div style={{textAlign:'center'}}>
// 										      <Icon color='grey' name='chevron down' />
// 									      </div>
// 									      :
// 									      null
// 									    }
// 									  </Grid.Column>
// 									  <Grid.Column style={{display:'flex',flexDirection:'column'}}>
// 								        <div style={{color:'#666666'}}>{'Candidate (English Order)'}</div>
// 								        <Segment style={{height:290,overflow: 'auto',padding:10}}>
// 								        	<List divided>
// 								        	{this.state.cvvMood.length > 0 && this.state.currentEditMode == 'cvupdate' ?
// 									        		<List.Item style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
// 									        		<div style={{flex:1}}>
// 										        		<div style={{color:'#000000b3'}}>{retrieveMoodEnglish[this.state.cvvMood]['fst']}</div>
// 										        		<div style={{fontWeight:''}}>{retrieveMoodEnglish[this.state.cvvMood]['english']+' '}<span style={{fontStyle:'italic'}}>{mvSubjectOptionsEnglish[this.state.cvvs.join("")]}</span></div>
// 									        		</div>
// 									        		</List.Item>
// 								        		:
// 								        		null
// 								        	}
// 								        	{this.state.candidateBase.map((k,kindex)=>{return (kindex===this.state.candidateBase.length-1 ?
// 									        		<List.Item style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
// 									        		<div style={{flex:1}}>
// 										        		<div style={{color:'#000000b3'}}>{k['yupikword']}</div>
// 										        		<div style={{fontWeight:''}}>{this.processStyledText(k['englishraw'])}</div>
// 									        		</div>
// 									        		<Icon circular onClick={()=>{this.setState({candidateBase:this.state.candidateBase.slice(0,-1)},()=>{this.updateCandidateCall(endingNeeded,update,mood,submood)})}} style={{cursor:'pointer',width:30}} name='x' />
// 									        		</List.Item>
// 								        			:
// 									        		<List.Item style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
// 									        		<div style={{flex:1}}>										        		
// 										        		<div style={{color:'#000000b3'}}>{k['yupikword']}</div>
// 										        		<div style={{fontWeight:''}}>{this.processStyledText(k['englishraw'])}</div>
// 									        		</div>
// 									        		<div style={{width:30}} />
// 									        		</List.Item>
// 								        			)
// 								        	})}
// 								        	</List>
// 							        	</Segment>
// 								      <div style={{paddingBottom:10}}>  
// 	                		<Button color='blue' onClick={()=>{
// 	                			if (mood === 'Intrg') {
// 	                				this.backEndCall([[itemUpdating[0],itemUpdating[1],this.state.candidateCall],["Insert",["mv","qWord"],[submood,1]]]); 		                				
// 	                			} else {
// 	                				console.log([[itemUpdating[0],itemUpdating[1],this.state.candidateCall]])
// 	                				this.backEndCall([[itemUpdating[0],itemUpdating[1],this.state.candidateCall]]); 		                						                				
// 	                			}
// 	                			this.setState({isOpen:false,currentEditMode:'default',searchQuery:'',wordsList:[],candidateBase:[],lockSubmit:false}) 
// 	                		}} disabled={!this.state.lockSubmit} style={{display:'flex',flexDirection:'row',alignItems:'center',paddingRight:'13px'}}>
// 	                			<div>{'Submit'}</div>
// 	                			<Icon name='chevron right' />
// 	                		</Button>
// 	                		</div>
// 	                	</Grid.Column>
// 	                	</Grid.Row>
// 								    </Grid>
// }
},{key:'repeatAudio',// repeatAudio(audio, event, data) {
//   // console.log(audio)
//   if (!this.state.playingAudio) {
//     let sound = new Audio(API_URL + "/yugtunCrowdsourceAudio/" + audio);
//     this.setState({playingAudio: true});
//     sound.play()
//     sound.onended=()=>{
//       this.setState({playingAudio: false});
//     }
//   }
// }
value:function repeatAudio(audio,index,event,data){var _this5=this;var audioURL=__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/yugtunCrowdsourceAudio/"+audio;// stop audio on double click
if(this.state.playingAudio===true&&this.state.clickedAudioUrl===audioURL){var _audio=this.state.clickedAudio;_audio.pause();_audio.currentTime=0;this.setState({clickedAudio:_audio,clickedAudioIndex:-1,playingAudio:false});}// stop first audio then play new one
if(this.state.playingAudio===true&&this.state.clickedAudioUrl!==audioURL){var firstAudio=this.state.clickedAudio;firstAudio.pause();firstAudio.currentTime=0;this.setState({playingAudio:true});var secondAudio=new Audio(audioURL);secondAudio.play();this.setState({clickedAudioUrl:audioURL,clickedAudioIndex:index,clickedAudio:secondAudio});secondAudio.onended=function(){_this5.setState({playingAudio:false,clickedAudioIndex:-1});};}// play audio again
if(this.state.playingAudio===false&&this.state.clickedAudioUrl===audioURL){var _audio2=this.state.clickedAudio;this.setState({playingAudio:true,clickedAudioIndex:index});_audio2.play();_audio2.onended=function(){_this5.setState({playingAudio:false,clickedAudioIndex:-1});};}// play new audio
if(this.state.playingAudio===false&&this.state.clickedAudioUrl!==audioURL){this.setState({playingAudio:true});var _audio3=new Audio(audioURL);_audio3.play();this.setState({clickedAudioUrl:audioURL,clickedAudioIndex:index,clickedAudio:_audio3});_audio3.onended=function(){_this5.setState({playingAudio:false,clickedAudioIndex:-1});};}}},{key:'render',value:function render(){var _this6=this;console.log(this.state.englishString);// console.log("mvv",this.state.mvvMood)
// console.log("mvvtype",this.state.mvvType)
// console.log("cvv",this.state.cvvMood)
// console.log("cvvtype",this.state.cvvType)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["e" /* Container */],{style:{margin:0,padding:0},text:true},this.state.usageDictionary.length==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["f" /* Dimmer */],{className:'overlay',active:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["t" /* Loader */],{size:'massive'},'Yugtun is loading...')):null,this.state.overlayOn?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overlay',onClick:function onClick(){_this6.closeSubjectMenu(_this6.state.crecentlyOpen,false,false);_this6.setState({overlayOn:false,currentEditMode:'default'});}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */],{textAlign:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Row,{style:{height:40,paddingBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Column,{style:{maxWidth:800,padding:0},textAlign:'left'},this.state.from==='/'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:"/",state:{history:this.state.history}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,style:{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'chevron left'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){_this6.props.history.goBack();},circular:true,style:{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'chevron left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:"/"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,style:{margin:0,marginLeft:5,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'search'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'20px'}},!this.fromEntry&&this.state.mvvBase.length===0&&this.state.npnBases.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Build your own sentence!')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Sentence Builder')),!this.fromEntry&&this.state.mvvBase.length===0&&this.state.npnBases.length===0?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.segmentString.length!=0&&this.state.audioParameterBool?this.displayAudioMic(this.state.audioRetrieved):null,this.state.showModal?this.recordClip(this.state.segmentString,'sentenceBuilder',this.state.englishString):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'/sentencebuilder/1'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,onClick:function onClick(){_this6.setState({crecentlyOpen:'',currentEditMode:'default'},function(){_this6.backEndCall([['Delete',['mv'],''],['Delete',['np'],'']]);});},style:{margin:10,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'x'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["e" /* Container */],{style:{marginTop:'30px',marginBottom:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'30px'}},this.state.mvqWordSegments.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:'row',lineHeight:'40px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},this.editMenu('mvqWordParser',-1))))):null,this.state.mvnsBases.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:window.innerWidth<480||this.state.mvnsBases.length>2?'column':'row',lineHeight:'40px'}},this.state.mvnsSegments.slice().reverse().map(function(k,kind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},k.map(function(q,qind){if(qind===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnsParser',[kind,0]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnsappositiveParser',[kind,qind]));}}));})))):null,this.state.mvvBase.length>0&&this.state.mvvSegments.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:'row',lineHeight:'40px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},this.editMenu('mvParser',-1))))):null,this.state.mvnoBases.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:window.innerWidth<480||this.state.mvnoBases.length>2?'column':'row',lineHeight:'40px'}},this.state.mvnoSegments.slice().reverse().map(function(k,kind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},k.map(function(q,qind){if(qind===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnoParser',[kind,0]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnoappositiveParser',[kind,qind]));}}));})))):null,this.state.mvnObliquesSegments.length>0&&this.state.mvnObliques.length===this.state.mvnObliquesSegments.length?this.state.mvnObliquesSegments.map(function(obliques,obliqueind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:window.innerWidth<480||_this6.state.mvnObliquesSegments.length>2?'column':'row',lineHeight:'40px'}},obliques.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},x.map(function(k,kind){if(kind===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnObliquesParser',[obliqueind,obliques.length-1-xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnObliquesAppositiveParser',[obliqueind,obliques.length-1-xind,kind]));}}));}))));}):null,this.state.npnSegments.length>0&&this.state.npnSegments.length===this.state.npn.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:window.innerWidth<480||this.state.npnSegments.length>2?'column':'row',lineHeight:'40px'}},this.state.npnSegments.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},x.map(function(k,kind){if(kind===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('npnParser',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('npnappositiveParser',[xind,kind]));}}));})))):null,this.fromEntry&&this.state.mvvs.length==0&&this.state.npn.length==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],{basic:true,style:{height:257}},this.state.usageDictionary.length!=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["f" /* Dimmer */],{active:true,inverted:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["t" /* Loader */],{size:'large',inverted:true})):null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(element){_this6.mvEnglishVerticalRef=element;},style:{textAlign:'center',fontSize:'18px',fontWeight:'300',marginTop:'20px'}},(this.state.mvEnglish1.length>0||this.state.mvvType==='Intrg1'||this.state.mvvType==='Intrg3')&&this.state.mvvs.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{height:45,display:'inline-flex',alignItems:'center',marginBottom:'2px',marginTop:'2px'}},this.editMenu('mvEnglish1',-1)):null,this.state.mvvs.length>0?this.state.mvnsSegments.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:window.innerWidth<480||this.state.mvnsSegments.length>2?'column':'row',justifyContent:'center',alignItems:'center'}},this.state.mvnsSegments.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,xind===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvns'+(_this6.state.mvnsSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","ns",_this6.state.mvnsSegments.length-1,0],(data.value+_this6.state.mvns[_this6.state.mvnsSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.mvns[_this6.state.mvnsSegments.length-1][0].slice(0,-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["t" /* nounOptionsPossessorsNo4th */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvns'+(_this6.state.mvnsSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","ns",_this6.state.mvnsSegments.length-1,0],_this6.state.mvns[_this6.state.mvnsSegments.length-1][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.mvns[_this6.state.mvnsSegments.length-1][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnsEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnsEnglish2appositive',[xind,kind]));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvns'+(_this6.state.mvnsSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","ns",_this6.state.mvnsSegments.length-1-xind,0],_this6.state.mvns[_this6.state.mvnsSegments.length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.mvns[_this6.state.mvnsSegments.length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnsEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnsEnglish2appositive',[xind,kind]));}})));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.mvvMood=="Opt][PRS][NEG"||this.state.mvvMood=="Opt][FUT][NEG"||this.state.mvvMood=='Sbrd'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:this.getDropdownStyle('mvv.s'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","vs"],data.value.split('').map(Number)]]);},value:this.state.mvvs.join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["m" /* mvSubjectOptionsOnly2nd */]}):this.state.mvvType=='Intrg0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:this.getDropdownStyle('mvv.s'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","vs"],data.value.split('').map(Number)]]);},value:this.state.mvvs.join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["o" /* mvSubjectOptionsWho */]}):this.state.mvvType=='Intrg2'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:this.getDropdownStyle('mvv.s'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","vs"],data.value.split('').map(Number)]]);},value:this.state.mvvs.join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["n" /* mvSubjectOptionsWhat */]}):this.editSubjectMenu(["Insert",["mv","ns"]],'a subject','mvv.s',this.state.mvvs,"Update",["mv","vs"],this.state.mvvs.join(""),this.state.mvSubjectOptions1)):null,this.state.mvEnglish2.length>0?this.shortEnoughVEnglish2('mvEnglish2')&&(this.state.mvnsSegments.length===0||this.state.mvvo.length>0&&this.state.mvnoSegments.length===0)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{height:45,display:'inline-flex',alignItems:'center',marginBottom:'2px',marginTop:'2px'}},this.editMenu('mvEnglish2',-1)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',alignItems:'center',marginBottom:'2px',marginTop:'2px'}},this.editMenu('mvEnglish2',-1)):null,this.state.mvvo.length>0?this.state.mvnoSegments.length>0&&this.state.mvnoSegments.length===this.state.mvno.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:window.innerWidth<480||this.state.mvnoSegments.length>2?'column':'row',justifyContent:'center',alignItems:'center'}},this.state.mvnoSegments.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,xind===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.state.mvvBase[1]=='it'&&!_this6.arraysEqual(_this6.state.mvno[0][0],[0,0,0,1])&&!_this6.arraysEqual(_this6.state.mvno[0][0],[0,0,0,2])&&!_this6.arraysEqual(_this6.state.mvno[0][0],[0,0,0,3])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this6.getColor('mvns00.c')}},'(some of) '):null,_this6.state.mvvBase[1]=='it'&&xind===_this6.state.mvnoSegments.length-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvno'+(_this6.state.mvnoSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","no",_this6.state.mvnoSegments.length-1,0],(data.value+_this6.state.mvno[_this6.state.mvnoSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.mvno[_this6.state.mvnoSegments.length-1][0].slice(0,-1).join(""),options:_this6.state.nounOptionsMVAblPossessors1}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvno'+(_this6.state.mvnoSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","no",_this6.state.mvnoSegments.length-1,0],(data.value+_this6.state.mvno[_this6.state.mvnoSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.mvno[_this6.state.mvnoSegments.length-1][0].slice(0,-1).join(""),options:_this6.state.nounOptionsMVPossessors1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvno'+(_this6.state.mvnoSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","no",_this6.state.mvnoSegments.length-1,0],_this6.state.mvno[_this6.state.mvnoSegments.length-1][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.mvno[_this6.state.mvnoSegments.length-1][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnoEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnoEnglish2appositive',[xind,kind]));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvno'+(_this6.state.mvnoSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","no",_this6.state.mvnoSegments.length-1-xind,0],_this6.state.mvno[_this6.state.mvnoSegments.length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.mvno[_this6.state.mvnoSegments.length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnoEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnoEnglish2appositive',[xind,kind]));}})));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.mvvBase[1]=='it'?this.state.mvvType=='Intrg1'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:this.getDropdownStyle('mvv.o'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","vo"],data.value.split('').map(Number)]]);},value:this.state.mvvo.join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["i" /* mvObjectOptionsWhomAbl */]}):this.state.mvvType=='Intrg3'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:this.getDropdownStyle('mvv.o'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","vo"],data.value.split('').map(Number)]]);},value:this.state.mvvo.join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["g" /* mvObjectOptionsWhatAbl */]}):this.editMenu('mvEnglishAbl',-1):this.state.mvvType=='Intrg1'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:this.getDropdownStyle('mvv.o'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","vo"],data.value.split('').map(Number)]]);},value:this.state.mvvo.join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["h" /* mvObjectOptionsWhom */]}):this.state.mvvType=='Intrg3'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:this.getDropdownStyle('mvv.o'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","vo"],data.value.split('').map(Number)]]);},value:this.state.mvvo.join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["f" /* mvObjectOptionsWhat */]}):this.editSubjectMenu(["Insert",["mv","no"]],'an object','mvv.o',this.state.mvvo,"Update",["mv","vo"],this.state.mvvo.join(""),this.state.mvObjectOptions1)):null,this.state.mvEnglish3.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:2,lineHeight:'40px'}},this.state.mvEnglish3.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this6.getColor(t[1])}},t[0]);})):null,this.state.mvEnglishQaa.length>0?this.editMenu('mvEnglishQaa',-1):null),!this.fromEntry&&this.state.mvvs.length===0&&this.state.npn.length===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'300px',display:'flex',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:'vPhraseInsert',active:this.state.activeIndexes.includes('vPhraseInsert'),onClick:function onClick(){_this6.handleClick('vPhraseInsert',true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Make a verb phrase'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:this.state.activeIndexes.includes('vPhraseInsert')},this.mainScreenMenu('I am _____','mvinsert','I',[],['',[1,1,0]]),this.mainScreenMenu('you are _____','mvinsert','you',[],['',[2,1,0]]),this.mainScreenMenu('he is _____','mvinsert','he',[],['',[3,1,1]]),this.mainScreenMenu('she is _____','mvinsert','she',[],['',[3,1,2]]),this.mainScreenMenu('it is _____','mvinsert','it',[],['',[3,1,3]]),this.mainScreenMenu('the two of them are _____','mvinsert','they2',[],['',[3,2,0]]),this.mainScreenMenu('they all (3+) are _____','mvinsert','they3',[],['',[3,3,0]]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:'nPhraseInsert',active:this.state.activeIndexes.includes('nPhraseInsert'),onClick:function onClick(){_this6.handleClick('nPhraseInsert',true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Make a noun phrase'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:this.state.activeIndexes.includes('nPhraseInsert')},this.mainScreenMenu('the one _____','nPhraseInsert','npCase',['Abs',''],['',[]]),this.mainScreenMenu('from the one _____','nPhraseInsert','npCase',['Abl_Mod','from'],['',[]]),this.mainScreenMenu('in or at the one _____','nPhraseInsert','npCase',['Loc',''],['',[]]),this.mainScreenMenu('to the one _____','nPhraseInsert','npCase',['Ter',''],['',[]]),this.mainScreenMenu('through, using the one _____','nPhraseInsert','npCase',['Via',''],['',[]]),this.mainScreenMenu('like, similar to the one _____','nPhraseInsert','npCase',['Equ',''],['',[]]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],null),this.mainScreenMenu('a or some _____','nPhraseInsert','npCase',['Abl_Mod','io'],['',[]]),this.mainScreenMenu('the one (relative case) _____','nPhraseInsert','npCase',['Rel',''],['',[]]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:'questionInsert',active:this.state.activeIndexes.includes('questionInsert'),onClick:function onClick(){_this6.handleClick('questionInsert',true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Ask a question'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:this.state.activeIndexes.includes('questionInsert')},this.mainScreenMenu('he is _____ (yes or no)?','mvinsertqaa','mvinsertqaa',['Ind','qaa'],['',[3,1,1]]),this.mainScreenMenu('who is he who is _____?','questionInsert','mvvType',['Intrg0',''],['',[3,1,1]]),this.mainScreenMenu('she is _____ whom (object)?','questionInsert','mvvType',['Intrg1',''],['',[3,1,2]]),this.mainScreenMenu('what is it that is _____ ?','questionInsert','mvvType',['Intrg2',''],['',[3,1,3]]),this.mainScreenMenu('he is _____ what (object)?','questionInsert','mvvType',['Intrg3',''],['',[3,1,1]]),this.mainScreenMenu('when did you _____?','questionInsert','mvvType',['Intrg4',''],['i',[2,1,0]]),this.mainScreenMenu('when will you _____?','questionInsert','mvvType',['Intrg5',''],['i',[2,1,0]]),this.mainScreenMenu('where are you _____?','questionInsert','mvvType',['Intrg6',''],['g',[2,1,0]]),this.mainScreenMenu('from where are you _____?','questionInsert','mvvType',['Intrg7',''],['g',[2,1,0]]),this.mainScreenMenu('to where are you _____?','questionInsert','mvvType',['Intrg8',''],['g',[2,1,0]]),this.mainScreenMenu('why are you _____?','questionInsert','mvvType',['Intrg9',''],['g',[2,1,0]]),this.mainScreenMenu('how are you _____?','questionInsert','mvvType',['IntrgA',''],['g',[2,1,0]]))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{color:'000000de',borderTop:'1px solid #2224261a',padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:'commandInsert',active:this.state.activeIndexes.includes('commandInsert'),onClick:function onClick(){_this6.handleClick('commandInsert',true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Make a command'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:this.state.activeIndexes.includes('commandInsert')},this.mainScreenMenu('command right now','commandInsert','optCase',['Opt][PRS',''],['i',[2,1,0]]),this.mainScreenMenu('command future','commandInsert','optCase',['Opt][FUT',''],['i',[2,1,0]]),this.mainScreenMenu('do not ____','commandInsert','optCase',['Opt][PRS][NEG',''],['i',[2,1,0]]),this.mainScreenMenu('do not ____ (future)?','commandInsert','optCase',['Opt][FUT][NEG',''],['i',[2,1,0]]),this.mainScreenMenu('polite request','commandInsert','optCase',['Sbrd',''],['i',[2,1,0]]),this.mainScreenMenu('polite do not ____','commandInsert','optCase',['Sbrd','neg'],['i',[2,1,0]]))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'18px',fontWeight:'300'}},this.state.mvnObliquesSegments.length>0&&this.state.mvnObliquesSegments.length===this.state.mvnObliques.length&&this.state.mvnObliquesSegments.length===this.state.mvnObliquesEnglish2.length?this.state.mvnObliques.map(function(obliques,obliqueind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:window.innerWidth<480||_this6.state.npnSegments.length>2?'column':'row',justifyContent:'center',alignItems:'center'}},obliques['n'].slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,xind===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnObliquesEnglish1',obliqueind),obliques['nCase']=='Equ'||obliques['nCase']=='Via'||obliques['nType']=='io'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],(data.value+_this6.state.mvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.mvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).join(""),options:_this6.state.nounOptionsMVAblPossessors1}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],(data.value+_this6.state.mvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.mvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).join(""),options:_this6.state.nounOptionsMVPossessors1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],_this6.state.mvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.mvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnObliquesEnglish2',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnObliquesEnglish2appositive',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('mvnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["mv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],_this6.state.mvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.mvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnObliquesEnglish2',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('mvnObliquesEnglish2appositive',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}})));}));}):null,this.state.npnSegments.length>0&&this.state.npnSegments.length===this.state.npnEnglish2.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:window.innerWidth<480||this.state.npnSegments.length>2?'column':'row',justifyContent:'center',alignItems:'center'}},this.state.npnSegments.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,xind===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('npnEnglish1',-1),_this6.state.npnCase=='Equ'||_this6.state.npnCase=='Via'||_this6.state.npCaseType=='io'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('npn'+(_this6.state.npnSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["np","n",_this6.state.npnSegments.length-1,0],(data.value+_this6.state.npn[_this6.state.npnSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.npn[_this6.state.npnSegments.length-1][0].slice(0,-1).join(""),options:_this6.state.nounOptionsMVAblPossessors1}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('npn'+(_this6.state.npnSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["np","n",_this6.state.npnSegments.length-1,0],(data.value+_this6.state.npn[_this6.state.npnSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.npn[_this6.state.npnSegments.length-1][0].slice(0,-1).join(""),options:_this6.state.nounOptionsMVPossessors1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('npn'+(_this6.state.npnSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["np","n",_this6.state.npnSegments.length-1,0],_this6.state.npn[_this6.state.npnSegments.length-1][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.npn[_this6.state.npnSegments.length-1][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('npnEnglish2',[xind,x.length-1-kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('npnEnglish2appositive',[xind,x.length-1-kind]));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('npn'+(_this6.state.npnSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["np","n",_this6.state.npnSegments.length-1-xind,0],_this6.state.npn[_this6.state.npnSegments.length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.npn[_this6.state.npnSegments.length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('npnEnglish2',[xind,x.length-1-kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('npnEnglish2appositive',[xind,x.length-1-kind]));}})));}))),this.state.npnCase==='Rel'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'35px',fontSize:'12pt',color:'grey'}},'This ending (relative case) is used when the noun is a subject of a transitive verb or is the owner of something. By itself, it is likely a response to a question.'):null,this.state.npnType==='io'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'35px',fontSize:'12pt',color:'grey'}},'This ending (ablative-modalis case) is used when a noun is an indirect object. For example, "Tangertuq yaqulegmek - He saw [a] bird" versus "Tangraa yaqulek - He saw [the] bird". By itself, it is likely a response to a question.'):null):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'30px'}},this.state.cvnsBases.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:window.innerWidth<480||this.state.cvnsBases.length>2?'column':'row',lineHeight:'40px'}},this.state.cvnsSegments.slice().reverse().map(function(k,kind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},k.map(function(q,qind){if(qind===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnsParser',[kind,0]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnsappositiveParser',[kind,qind]));}}));})))):null,this.state.cvvBase.length>0&&this.state.cvvSegments.length>0?this.editMenu('cvParser',-1):null,this.state.cvnoBases.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:window.innerWidth<480||this.state.cvnoBases.length>2?'column':'row',lineHeight:'40px'}},this.state.cvnoSegments.slice().reverse().map(function(k,kind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},k.map(function(q,qind){if(qind===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnoParser',[kind,0]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnoappositiveParser',[kind,qind]));}}));})))):null,this.state.cvnObliquesSegments.length>0&&this.state.cvnObliques.length===this.state.cvnObliquesSegments.length?this.state.cvnObliquesSegments.map(function(obliques,obliqueind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:window.innerWidth<480||_this6.state.cvnObliquesSegments.length>2?'column':'row',lineHeight:'40px'}},obliques.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},x.map(function(k,kind){if(kind===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnObliquesParser',[obliqueind,obliques.length-1-xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnObliquesAppositiveParser',[obliqueind,obliques.length-1-xind,kind]));}}));}))));}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(element){_this6.cvEnglishVerticalRef=element;},style:{textAlign:'center',fontSize:'18px',fontWeight:'300',marginTop:'20px'}},this.state.cvEnglish1.length>0?this.editMenu('cvEnglish1',-1):null,this.state.cvvs.length>0?this.state.cvnsSegments.length>0&&this.state.cvnsSegments.length===this.state.cvns.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:window.innerWidth<480||this.state.cvnsSegments.length>2?'column':'row',justifyContent:'center',alignItems:'center'}},this.state.cvnsSegments.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,xind===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvns'+(_this6.state.cvnsSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","ns",_this6.state.cvnsSegments.length-1,0],(data.value+_this6.state.cvns[_this6.state.cvnsSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.cvns[_this6.state.cvnsSegments.length-1][0].slice(0,-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["t" /* nounOptionsPossessorsNo4th */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvns'+(_this6.state.cvnsSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","ns",_this6.state.cvnsSegments.length-1,0],_this6.state.cvns[_this6.state.cvnsSegments.length-1][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.cvns[_this6.state.cvnsSegments.length-1][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnsEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnsEnglish2appositive',[xind,kind]));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvns'+(_this6.state.cvnsSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","ns",_this6.state.cvnsSegments.length-1-xind,0],_this6.state.cvns[_this6.state.cvnsSegments.length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.cvns[_this6.state.cvnsSegments.length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnsEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnsEnglish2appositive',[xind,kind]));}})));})):this.editSubjectMenu(["Insert",["cv","ns"]],'a subject','cvv.s',this.state.cvvs,"Update",["cv","vs"],this.state.cvvs.join(""),this.state.cvSubjectOptions1):null,this.state.cvEnglish2.length>0?this.shortEnoughVEnglish2('cvEnglish2')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{ref:function ref(element){_this6.cvEnglish2Ref=element;},style:{height:45,display:'inline-flex',alignItems:'center',marginBottom:'2px',marginTop:'2px'}},this.editMenu('cvEnglish2',-1)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{ref:function ref(element){_this6.cvEnglish2Ref=element;},style:{display:'flex',justifyContent:'center',alignItems:'center',marginBottom:'2px',marginTop:'2px'}},this.editMenu('cvEnglish2',-1)):null,this.state.cvvo.length>0?this.state.cvnoSegments.length>0&&this.state.cvnoSegments.length===this.state.cvno.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:window.innerWidth<480||this.state.cvnoSegments.length>2?'column':'row',justifyContent:'center',alignItems:'center'}},this.state.cvnoSegments.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,xind===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.state.cvvBase[1]=='it'&&!_this6.arraysEqual(_this6.state.cvno[0][0],[0,0,0,1])&&!_this6.arraysEqual(_this6.state.cvno[0][0],[0,0,0,2])&&!_this6.arraysEqual(_this6.state.cvno[0][0],[0,0,0,3])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this6.getColor('cvns00.c')}},'(some of) '):null,_this6.state.cvvBase[1]=='it'&&xind===_this6.state.cvnoSegments.length-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvno'+(_this6.state.cvnoSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","no",_this6.state.cvnoSegments.length-1,0],(data.value+_this6.state.cvno[_this6.state.cvnoSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.cvno[_this6.state.cvnoSegments.length-1][0].slice(0,-1).join(""),options:_this6.state.nounOptionsCVAblPossessors1}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvno'+(_this6.state.cvnoSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","no",_this6.state.cvnoSegments.length-1,0],(data.value+_this6.state.cvno[_this6.state.cvnoSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.cvno[_this6.state.cvnoSegments.length-1][0].slice(0,-1).join(""),options:_this6.state.nounOptionsCVPossessors1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvno'+(_this6.state.cvnoSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","no",_this6.state.cvnoSegments.length-1,0],_this6.state.cvno[_this6.state.cvnoSegments.length-1][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.cvno[_this6.state.cvnoSegments.length-1][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnoEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnoEnglish2appositive',[xind,kind]));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvno'+(_this6.state.cvnoSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","no",_this6.state.cvnoSegments.length-1-xind,0],_this6.state.cvno[_this6.state.cvnoSegments.length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.cvno[_this6.state.cvnoSegments.length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnoEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnoEnglish2appositive',[xind,kind]));}})));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.cvvBase[1]=='it'?this.editMenu('cvEnglishAbl',-1):this.editSubjectMenu(["Insert",["cv","no"]],'an object','cvv.o',this.state.cvvo,"Update",["cv","vo"],this.state.cvvo.join(""),this.state.cvObjectOptions1)):null,this.state.cvnObliquesSegments.length>0&&this.state.cvnObliquesSegments.length===this.state.cvnObliques.length?this.state.cvnObliques.map(function(obliques,obliqueind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,obliques['n'].slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,xind===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnObliquesEnglish1',obliqueind),obliques['nCase']=='Equ'||obliques['nCase']=='Via'||obliques['nType']=='io'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],(data.value+_this6.state.cvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.cvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).join(""),options:_this6.state.nounOptionsCVAblPossessors1}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],(data.value+_this6.state.cvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.cvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).join(""),options:_this6.state.nounOptionsCVPossessors1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],_this6.state.cvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.cvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnObliquesEnglish2',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnObliquesEnglish2appositive',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('cvnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["cv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],_this6.state.cvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.cvnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnObliquesEnglish2',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('cvnObliquesEnglish2appositive',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}})));}));}):null),this.state.svvBase.length>0&&this.state.svvSegments.length>0?this.editMenu('svParser',-1):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'18px',fontWeight:'300'}},this.state.svnoBases.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:window.innerWidth<480||this.state.svnoBases.length>2?'column':'row',lineHeight:'40px'}},this.state.svnoSegments.slice().reverse().map(function(k,kind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},k.map(function(q,qind){if(qind===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnoParser',[kind,0]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnoappositiveParser',[kind,qind]));}}));})))):null,this.state.svnObliquesSegments.length>0&&this.state.svnObliques.length===this.state.svnObliquesSegments.length?this.state.svnObliquesSegments.map(function(obliques,obliqueind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'30px',fontWeight:'400'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:window.innerWidth<480||_this6.state.svnObliquesSegments.length>2?'column':'row',lineHeight:'40px'}},obliques.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:10,paddingLeft:10}},x.map(function(k,kind){if(kind===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnObliquesParser',[obliqueind,obliques.length-1-xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnObliquesAppositiveParser',[obliqueind,obliques.length-1-xind,kind]));}}));}))));}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontSize:'18px',fontWeight:'300',marginTop:'20px'}},this.state.svEnglish1.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{height:45,display:'inline-flex',alignItems:'center',marginBottom:'2px',marginTop:'2px'}},this.editMenu('svEnglish1',-1)):null,this.state.svvo.length>0?this.state.svnoSegments.length>0&&this.state.svnoSegments.length===this.state.svno.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:window.innerWidth<480||this.state.svnoSegments.length>2?'column':'row',justifyContent:'center',alignItems:'center'}},this.state.svnoSegments.slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,xind===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.state.svvBase[1]=='it'&&!_this6.arraysEqual(_this6.state.svno[0][0],[0,0,0,1])&&!_this6.arraysEqual(_this6.state.svno[0][0],[0,0,0,2])&&!_this6.arraysEqual(_this6.state.svno[0][0],[0,0,0,3])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this6.getColor('svns00.c')}},'(some of) '):null,_this6.state.svvBase[1]=='it'&&xind===_this6.state.svnoSegments.length-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('svno'+(_this6.state.svnoSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["sv","no",_this6.state.svnoSegments.length-1,0],(data.value+_this6.state.svno[_this6.state.svnoSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.svno[_this6.state.svnoSegments.length-1][0].slice(0,-1).join(""),options:_this6.state.nounOptionsSVAblPossessors1}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('svno'+(_this6.state.svnoSegments.length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["sv","no",_this6.state.svnoSegments.length-1,0],(data.value+_this6.state.svno[_this6.state.svnoSegments.length-1][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.svno[_this6.state.svnoSegments.length-1][0].slice(0,-1).join(""),options:_this6.state.nounOptionsSVPossessors1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('svno'+(_this6.state.svnoSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["sv","no",_this6.state.svnoSegments.length-1,0],_this6.state.svno[_this6.state.svnoSegments.length-1][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.svno[_this6.state.svnoSegments.length-1][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnoEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnoEnglish2appositive',[xind,kind]));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('svno'+(_this6.state.svnoSegments.length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["sv","no",_this6.state.svnoSegments.length-1-xind,0],_this6.state.svno[_this6.state.svnoSegments.length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.svno[_this6.state.svnoSegments.length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnoEnglish2',[xind,kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnoEnglish2appositive',[xind,kind]));}})));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.svvBase[1]=='it'?this.editMenu('svEnglishAbl',-1):this.editSubjectMenu(["Insert",["sv","no"]],'an object','svv.o',this.state.svvo,"Update",["sv","vo"],this.state.svvo.join(""),this.state.svObjectOptions1)):null,this.state.svnObliquesSegments.length>0&&this.state.svnObliquesSegments.length===this.state.svnObliques.length?this.state.svnObliques.map(function(obliques,obliqueind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,obliques['n'].slice().reverse().map(function(x,xind){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,xind===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnObliquesEnglish1',obliqueind),obliques['nCase']=='Equ'||obliques['nCase']=='Via'||obliques['nType']=='io'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('svnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["sv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],(data.value+_this6.state.svnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.svnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).join(""),options:_this6.state.nounOptionsSVAblPossessors1}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('svnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.pd'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["sv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],(data.value+_this6.state.svnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).toString()).split('').map(Number)]]);},value:_this6.state.svnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).join(""),options:_this6.state.nounOptionsSVPossessors1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('svnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["sv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],_this6.state.svnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.svnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnObliquesEnglish2',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnObliquesEnglish2appositive',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,style:_this6.getDropdownStyle('svnObliques'+obliqueind.toString()+(obliques['n'].length-1-xind).toString()+'0.ps'),onChange:function onChange(event,data){_this6.backEndCall([["Update",["sv","nObliques",obliqueind,'n',obliques['n'].length-1-xind,0],_this6.state.svnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(0,-1).concat(data.value.split('').map(Number))]]);},value:_this6.state.svnObliques[obliqueind]['n'][obliques['n'].length-1-xind][0].slice(-1).join(""),options:__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["s" /* nounOptionsNumbers */]}),x.map(function(k,kind){if(kind===x.length-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnObliquesEnglish2',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this6.editMenu('svnObliquesEnglish2appositive',[obliqueind,obliques['n'].length-1-xind,x.length-1-kind]));}})));}));}):null))),this.state.mvvs.length>0&&this.state.cvvBase.length==0&&this.state.svvBase.length==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',marginTop:'50px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'300px',display:'flex',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{padding:'4px 9px',paddingBottom:'9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:'nObliqueInsert',style:{color:this.state.activeIndexes.includes('nObliqueInsert')?'#000000':'#00000066'},active:this.state.activeIndexes.includes('nObliqueInsert'),onClick:function onClick(){_this6.handleClick('nObliqueInsert',true);_this6.setState({candidateCall:[],candidateBase:[],candidateDisplay:[],unallowable_next_ids:[],nextTenses:[]});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Add location, direction, etc.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:this.state.activeIndexes.includes('nObliqueInsert')},this.mainScreenMenu('from the one _____','nObliqueInsert','npCase',['Abl_Mod','from'],['',[]]),this.mainScreenMenu('in or at the one _____','nObliqueInsert','npCase',['Loc',''],['',[]]),this.mainScreenMenu('to the one _____','nObliqueInsert','npCase',['Ter',''],['',[]]),this.mainScreenMenu('through, using the one _____','nObliqueInsert','npCase',['Via',''],['',[]]),this.mainScreenMenu('like, similar to the one _____','nObliqueInsert','npCase',['Equ',''],['',[]])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{id:'cvinsert',style:{color:this.state.activeIndexes.includes('nObliqueInsert')?'#000000':'#00000066'},active:this.state.activeIndexes.includes('cvinsert'),onClick:function onClick(){_this6.handleClick('cvinsert',true);_this6.setState({candidateCall:[],candidateBase:[],candidateDisplay:[],unallowable_next_ids:[],nextTenses:[]});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Add an additional verb phrase'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:this.state.activeIndexes.includes('cvinsert')},this.mainScreenMenu('before '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][this.state.mvvs.join("")]+' _____','cvinsert','cvvType',['Prec',''],['',this.state.mvvs]),this.mainScreenMenu('because '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][this.state.mvvs.join("")]+' _____','cvinsert','cvvType',['Cnsq',''],['',this.state.mvvs]),this.mainScreenMenu('whenever '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][this.state.mvvs.join("")]+' _____','cvinsert','cvvType',['Cont',''],['',this.state.mvvs]),this.mainScreenMenu('even though '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][this.state.mvvs.join("")]+' _____','cvinsert','cvvType',['Conc','eventhough'],['',this.state.mvvs]),this.mainScreenMenu('even if '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][this.state.mvvs.join("")]+' _____','cvinsert','cvvType',['Conc','evenif'],['',this.state.mvvs]),this.mainScreenMenu('if '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][this.state.mvvs.join("")]+' _____','cvinsert','cvvType',['Cond','if'],['',this.state.mvvs]),this.mainScreenMenu('when (in future) '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][this.state.mvvs.join("")]+' _____','cvinsert','cvvType',['Cond','wheninthefuture'],['',this.state.mvvs]),this.state.mvvMood.includes('Opt')||this.state.mvvMood==='Sbrd'?null:this.mainScreenMenu('when (in past) '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][this.state.mvvs.join("")]+' _____','cvinsert','cvvType',['CtmpI',''],['',this.state.mvvs]),this.state.mvvMood.includes('Opt')||this.state.mvvMood==='Sbrd'?null:this.mainScreenMenu('while '+__WEBPACK_IMPORTED_MODULE_5__constants_newconstants_js__["l" /* mvSubjectOptionsEnglish */][this.state.mvvs.join("")]+' _____','cvinsert','cvvType',['CtmpII',''],['',this.state.mvvs]),this.mainScreenMenu('by _____','svinsert','svvType',['by',''],['g',[]]),this.mainScreenMenu('being _____','svinsert','svvType',['being',''],['g',[]]))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:this.state.mvvs.length===0&&this.state.npn.length===0?'0px':'40px'}}))),!this.fromEntry&&this.state.mvvBase.length===0&&this.state.npnBases.length===0?this.state.glossary?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__SentenceGlossary_js__["a" /* default */],{backEndCall:this.backEndCall.bind(this),getColor:this.getColor.bind(this)}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__SentenceTemplates_js__["a" /* default */],{flipGlossary:this.flipGlossary.bind(this),backEndCall:this.backEndCall.bind(this),getColor:this.getColor.bind(this)}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-evenly',alignItems:'center',height:60,paddingBottom:16,paddingTop:25}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',justifyContent:'center',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'14px',color:'grey',padding:'15px',fontWeight:'400',lineHeight:'23px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{textDecoration:'underline'}},'Disclaimer:'),' Please note that there may be mistakes with word results and translations. The automated computer rules that produce these words don\'t often reflect common language use, context, and cultural knowledge.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'14px',color:'grey',padding:'15px',fontWeight:'400',lineHeight:'23px'}},'Sentence builder production provided by ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{color:'#306190'},href:'https://yuarcuun.github.io',target:'_blank'},'Yuarcuun Technologies'),' in partnership with the Native Village of Kwinhagak (NVK). This website was made possible by Grant Number 90XN0110-01-00 from Administration for Native Americans.')))))));}}]);return SentenceBuilder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SentenceBuilder);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newpostbases; });
var newpostbases={"\u2013a|\u2013ar|\u2013aa|+a|+aar[V\u2192V]":{"exp":"\u2013a|\u2013ar|\u2013aa|+a|+aar[V\u2192V]","exp_display":"+a|+aar","type":"VV","subj":"he","is":true,"has":false,"description":"repeatedly","gen_preverb":"repeatedly","past_preverb":"repeatedly","inf_preverb":"repeatedly","ger_preverb":"repeatedly","match_case":true,"gen_preverb_after":"g","keylookup":["-a-|-ar-|-aa-|+a-|+aar-",0]},"+`(g)aqe[V\u2192V]":{"exp":"+`(g)aqe[V\u2192V]","exp_display":"+`(g)aqe","type":"VV","subj":"he","is":true,"has":false,"description":"repeatedly","gen_preverb":"repeatedly","past_preverb":"repeatedly","inf_preverb":"repeatedly","ger_preverb":"repeatedly","match_case":true,"gen_preverb_after":"g","keylookup":["+'(g)aqe-",0]},"+`(g)ar(ar)[V\u2192V]":{"exp":"+`(g)ar(ar)[V\u2192V]","exp_display":"+`(g)ar(ar)","type":"VV","subj":"he","is":true,"has":false,"description":"just barely","gen_preverb":"just barely","past_preverb":"just barely","inf_preverb":"just barely","ger_preverb":"just barely","match_case":true,"gen_preverb_after":"g","keylookup":["+'(g)ar(ar)-",2]},"@+(g)ar(ar)te\xB9[V\u2192V]":{"exp":"@+(g)ar(ar)te\xB9[V\u2192V]","exp_display":"@+\u2013`(g)ar(ar)te","type":"VV","subj":"he","is":true,"has":false,"description":"suddenly","gen_preverb":"suddenly","past_preverb":"suddenly","inf_preverb":"suddenly","ger_preverb":"suddenly","match_case":true,"gen_preverb_after":"g","keylookup":["@+(g)ar(ar)te\xB9-",0]},"+`(g)arkau[V\u2192V]":{"exp":"+`(g)arkau[V\u2192V]","exp_display":"+`(g)arkau","type":"VV","tense":"future","subj":"he","is":false,"has":false,"description":"will eventually","gen_preverb":"will eventually","gen_preverb_after":"i","was":false,"past_preverb":"did not eventually","past_preverb_after":"i","inf_preverb":"eventually (in the future)","inf_preverb_after":"i","ger_preverb":"eventually (in the future)","ger_preverb_after":"g","match_case":false,"keylookup":["+'(g)arkau-",0]},"+`(g)arkaunrir[V\u2192V]":{"exp":"+`(g)arkaunrir[V\u2192V]","exp_display":"+`(g)arkaunrir","type":"VV","tense":"future","neg":true,"subj":"he","is":true,"has":false,"description":"now unable to","gen_preverb":"now unable to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be now unable to","inf_preverb_after":"i","ger_preverb":"being able to now","ger_preverb_after":"i","match_case":false,"keylookup":["+'(g)arkaunrir-",0]},"+aur(ar)[V\u2192V]":{"exp":"+aur(ar)[V\u2192V]","exp_display":"+aur(ar)","type":"VV","subj":"he","is":true,"has":false,"description":"continuing (over a period of time) to","gen_preverb":"continuing (over a period of time) to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"continue (over a period of time) to","inf_preverb_after":"i","ger_preverb":"continuing (over a period of time) to","ger_preverb_after":"i","match_case":false,"keylookup":["+aur(ar)-",0]},"@~+caar(ar)[V\u2192V]":{"exp":"@~+caar(ar)[V\u2192V]","exp_display":"@\u2074~+caar(ar)","type":"VV","subj":"he","is":true,"has":false,"description":"endeavoring to","gen_preverb":"endeavoring to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"endeavor to","inf_preverb_after":"i","ger_preverb":"endeavoring to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+caar(ar)-",0]},"+(s)ciigali[V\u2192V]":{"exp":"+(s)ciigali[V\u2192V]","exp_display":"+(s)ciigali","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"no longer able to","gen_preverb":"no longer able to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be no longer able to","inf_preverb_after":"i","ger_preverb":"being no longer able to","ger_preverb_after":"i","match_case":false,"keylookup":["+(s)ciigali-,+(s)ciigalli-",0]},"+(s)ciigalli[V\u2192V]":{"exp":"+(s)ciigalli[V\u2192V]","exp_display":"+(s)ciigalli","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"no longer able to","gen_preverb":"no longer able to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be no longer able to","inf_preverb_after":"i","ger_preverb":"being no longer able to","ger_preverb_after":"i","match_case":false,"keylookup":["+(s)ciigali-,+(s)ciigalli-",1]},"+(s)ciigate[V\u2192V]":{"exp":"+(s)ciigate[V\u2192V]","exp_display":"+(s)ciigate\xB0","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"not able to","gen_preverb":"not able to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be not able to","inf_preverb_after":"i","ger_preverb":"being not able to","ger_preverb_after":"i","match_case":false,"keylookup":["+(s)ciigate-",0]},"\u2013cilli[V\u2192V]":{"exp":"\u2013cilli[V\u2192V]","exp_display":"\u2013cilli","type":"VV","subj":"he","is":false,"has":false,"description":"appears to have been","gen_preverb":"appears to have been","gen_preverb_after":"g","was":false,"past_preverb":"appeared to have been","past_preverb_after":"g","inf_preverb":"appear to have been","inf_preverb_after":"g","ger_preverb":"appearing to have been","ger_preverb_after":"g","match_case":false,"keylookup":["-cilli-",0]},"+ciqe|@ciiqe[V\u2192V]":{"exp":"+ciqe|@ciiqe[V\u2192V]","exp_display":"+ciqe|@\u2075ciiqe","type":"VV","tense":"future","subj":"he","is":false,"has":false,"description":"will","gen_preverb":"will","gen_preverb_after":"i","was":false,"past_preverb":"(in the future)","past_preverb_after":"gen","inf_preverb":"(in the future)","inf_preverb_after":"i","ger_preverb":"(in the future)","ger_preverb_after":"g","match_case":false,"keylookup":["+ciqe-|@ciiqe-",0]},"+ciqiar|@ciiqiar[V\u2192V]":{"exp":"+ciqiar|@ciiqiar[V\u2192V]","exp_display":"+ciqiar|@\u2075ciiqiar","type":"VV","tense":"future","subj":"he","is":true,"has":false,"description":"about to","gen_preverb":"about to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be about to","inf_preverb_after":"i","ger_preverb":"being about to","ger_preverb_after":"i","match_case":false,"keylookup":["+ciqiar-|@ciiqiar-",0]},"@~+cir\xB9[V\u2192V]":{"exp":"@~+cir\xB9[V\u2192V]","exp_display":"@\u2075~+cir","type":"VV","tense":"past","subj":"","is":false,"has":false,"description":"","gen_preverb":"","gen_preverb_after":"","was":false,"past_preverb":"","past_preverb_after":"","inf_preverb":"","inf_preverb_after":"i","ger_preverb":"","ger_preverb_after":"g","match_case":false,"keylookup":["@~+cir\xB9-",0]},"+(s)cir\xB2[V\u2192V]":{"exp":"+(s)cir\xB2[V\u2192V]","exp_display":"+(s)cir","type":"VV","subj":"he","is":false,"has":true,"description":"been (detrimentally)","gen_preverb":"been (detrimentally)","gen_preverb_after":"pp","was":false,"past_preverb":"had been (detrimentally)","past_preverb_after":"pp","inf_preverb":"have been (detrimentally)","inf_preverb_after":"pp","ger_preverb":"having been (detrimentally)","ger_preverb_after":"pp","match_case":false,"keylookup":["+(s)cir\xB2-",0]},"+(s)ciryar[V\u2192V]":{"exp":"+(s)ciryar[V\u2192V]","exp_display":"+(s)ciryar","type":"VV","subj":"he","is":true,"has":false,"description":"easily","gen_preverb":"easily","gen_preverb_after":"pp","was":true,"past_preverb":"","past_preverb_after":"pp","inf_preverb":"be easily","inf_preverb_after":"pp","ger_preverb":"being easily","ger_preverb_after":"pp","match_case":false,"keylookup":["+(s)ciryar-",0]},"+cite\xB2[V\u2192V]":{"exp":"+cite\xB2[V\u2192V]","exp_display":"+cite\xB0","type":"VV","subj":"it","is":false,"has":false,"description":"has the quality of","gen_preverb":"has the quality of","gen_preverb_after":"g","was":false,"past_preverb":"had the quality of","past_preverb_after":"g","inf_preverb":"have the quality of","inf_preverb_after":"g","ger_preverb":"having the quality of","ger_preverb_after":"g","match_case":false,"keylookup":["+cite\xB2-",1]},"+(s)ciur[V\u2192V]":{"exp":"+(s)ciur[V\u2192V]","exp_display":"+(s)ciur","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"been (detrimentally)","gen_preverb":"been (detrimentally)","gen_preverb_after":"pp","was":false,"past_preverb":"had been (detrimentally)","past_preverb_after":"pp","inf_preverb":"have been (detrimentally)","inf_preverb_after":"pp","ger_preverb":"having been (detrimentally)","ger_preverb_after":"pp","match_case":false,"keylookup":["+(s)ciur-",0]},"\u2013curlag[V\u2192V]":{"exp":"\u2013curlag[V\u2192V]","exp_display":"\u2013curlag","type":"VV","description":"with unsatisfactory results","postverb":"with unsatisfactory results","match_case":true,"keylookup":["-curlak,-curlag-",0]},"@~+(ng)iinar[V\u2192V]":{"exp":"@~+(ng)iinar[V\u2192V]","exp_display":"@\xB2~+(ng)iinar","type":"VV","description":"more and more","postverb":"more and more","match_case":true,"keylookup":["@~+(ng)iinar-",0]},":(ng)illiqe[V\u2192V]":{"exp":"%:(ng)illiqe[V\u2192V]","exp_display":"%:(ng)illiqe","type":"VV","subj":"he","is":true,"has":false,"description":"suffering from the lack of","gen_preverb":"suffering from the lack of","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"suffer from the lack of","inf_preverb_after":"g","ger_preverb":"suffering from the lack of","ger_preverb_after":"g","match_case":false,"keylookup":[":(ng)illiqe-",1]},"\u2013inar[V\u2192V]":{"exp":"\u2013inar[V\u2192V]","exp_display":"\u2013inar","type":"VV","subj":"he","is":true,"has":false,"description":"finally","gen_preverb":"finally","past_preverb":"finally","inf_preverb":"finally","ger_preverb":"finally","match_case":true,"gen_preverb_after":"g","keylookup":["-inar-",0]},":(ng)ite\xB9[V\u2192V]":{"exp":"%:(ng)ite\xB9[V\u2192V]","exp_display":"%:(ng)ite\xB0","type":"VV","subj":"he","is":false,"has":false,"description":"lacks","gen_preverb":"lacks","gen_preverb_after":"g","was":false,"past_preverb":"lacked","past_preverb_after":"g","inf_preverb":"lack","inf_preverb_after":"g","ger_preverb":"lacking","ger_preverb_after":"g","match_case":false,"keylookup":[":(ng)ite\xB9-",1]},"+kanir[V\u2192V]":{"exp":"+kanir[V\u2192V]","exp_display":"+kanir","type":"VV","description":"more with greater intensity","postverb":"more with greater intensity","match_case":true,"keylookup":["+kanir-",0]},"+kanir(ar)[V\u2192V]":{"exp":"+kanir(ar)[V\u2192V]","exp_display":"+kanir(ar)","type":"VV","description":"more and more, with greater intensity","postverb":"more and more, with greater intensity","match_case":true,"keylookup":["+kanir(ar)-",0]},"\u2013@kaunrir[V\u2192V]":{"exp":"\u2013@kaunrir[V\u2192V]","exp_display":"\u2013@\u2074k\u0332aunrir","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"unable to (due to an inhibiting factor)","gen_preverb":"unable to (due to an inhibiting factor)","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be unable to (due to an inhibiting factor)","inf_preverb_after":"i","ger_preverb":"being unable to (due to an inhibiting factor)","ger_preverb_after":"i","match_case":false,"keylookup":["-@kaunrir-",0]},"\u2013knig[V\u2192V]":{"exp":"\u2013knig[V\u2192V]","exp_display":"\u2013knig","type":"VV","subj":"he","is":true,"has":false,"description":"suddenly (in motion)","gen_preverb":"suddenly (in motion)","past_preverb":"suddenly (in motion)","inf_preverb":"suddenly (in motion)","ger_preverb":"suddenly (in motion)","match_case":true,"gen_preverb_after":"g","keylookup":["-knig-",0]},"\u2013ksaar(ar)[V\u2192V]":{"exp":"\u2013ksaar(ar)[V\u2192V]","exp_display":"\u2013ksaar(ar)","type":"VV","description":"in a small and unnoticeable way","postverb":"in a small and unnoticeable way","match_case":true,"keylookup":["-ksaar(ar)-",0]},"\u2013ksaite[V\u2192V]":{"exp":"\u2013ksaite[V\u2192V]","exp_display":"\u2013k\u0332saite\xB0","type":"VV","tense":"past","neg":true,"subj":"he","is":false,"has":true,"description":"not","gen_preverb":"not","gen_preverb_after":"pp","was":false,"past_preverb":"had not","past_preverb_after":"pp","inf_preverb":"have not","inf_preverb_after":"pp","ger_preverb":"having not","ger_preverb_after":"pp","match_case":false,"keylookup":["-ksaite-",0]},"\u2013ksaitelar[V\u2192V]":{"exp":"\u2013ksaitelar[V\u2192V]","exp_display":"\u2013k\u0332saitelar","type":"VV","tense":"past","neg":true,"subj":"he","is":false,"has":true,"description":"never","gen_preverb":"never","gen_preverb_after":"pp","was":false,"past_preverb":"had never","past_preverb_after":"pp","inf_preverb":"have never","inf_preverb_after":"pp","ger_preverb":"having never","ger_preverb_after":"pp","match_case":false,"keylookup":["-ksaitelar-,-ksaitlar-",0]},"\u2013ksaitlar[V\u2192V]":{"exp":"\u2013ksaitlar[V\u2192V]","exp_display":"\u2013k\u0332saitlar","type":"VV","tense":"past","neg":true,"subj":"he","is":false,"has":true,"description":"never","gen_preverb":"never","gen_preverb_after":"pp","was":false,"past_preverb":"had never","past_preverb_after":"pp","inf_preverb":"have never","inf_preverb_after":"pp","ger_preverb":"having never","ger_preverb_after":"pp","match_case":false,"keylookup":["-ksaitelar-,-ksaitlar-",1]},"\u2013ksuar(ar)[V\u2192V]":{"exp":"\u2013ksuar(ar)[V\u2192V]","exp_display":"\u2013ksuar(ar)","type":"VV","description":"in a small and not very noticeable way","postverb":"in a small and not very noticeable way","match_case":true,"keylookup":["-ksuar(ar)-,-ksuar(ar)-",1]},"\u2013kugte[V\u2192V]":{"exp":"\u2013kugte[V\u2192V]","exp_display":"\u2013kugte","type":"VV","tense":"future","subj":"he","is":true,"has":false,"description":"about to","gen_preverb":"about to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be about to","inf_preverb_after":"i","ger_preverb":"being about to","ger_preverb_after":"i","match_case":false,"keylookup":["-kugte-",0]},"\u2013kuna[V\u2192V]":{"exp":"\u2013kuna[V\u2192V]","exp_display":"\u2013kuna","type":"VV","tense":"future","subj":"he","is":true,"has":false,"description":"planning to","gen_preverb":"planning to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"plan to","inf_preverb_after":"i","ger_preverb":"planning to","ger_preverb_after":"i","match_case":false,"keylookup":["-kuna-",0]},"\u2013kunayaaqe[V\u2192V]":{"exp":"\u2013kunayaaqe[V\u2192V]","exp_display":"\u2013kunayaaqe","type":"VV","tense":"future","subj":"he","is":true,"has":false,"description":"considering","gen_preverb":"considering","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"consider","inf_preverb_after":"g","ger_preverb":"considering","ger_preverb_after":"g","match_case":false,"keylookup":["-kunayaaqe-",0]},"\u2013kutag[V\u2192V]":{"exp":"\u2013kutag[V\u2192V]","exp_display":"\u2013kutag","type":"VV","tense":"future","subj":"he","is":true,"has":false,"description":"probably","gen_preverb":"probably","past_preverb":"probably","inf_preverb":"probably","ger_preverb":"probably","match_case":true,"gen_preverb_after":"g","keylookup":["-kutag-",0]},"\u2013kutar(ar)[V\u2192V]":{"exp":"\u2013kutar(ar)[V\u2192V]","exp_display":"\u2013kutar(ar)","type":"VV","tense":"future","subj":"he","is":true,"has":false,"description":"planning to","gen_preverb":"planning to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"plan to","inf_preverb_after":"i","ger_preverb":"planning to","ger_preverb_after":"i","match_case":false,"keylookup":["-kutar(ar)-",0]},"\u2013laag[V\u2192V]":{"exp":"\u2013laag[V\u2192V]","exp_display":"\u2013laag","type":"VV","subj":"he","is":true,"has":false,"description":"quickly","gen_preverb":"quickly","past_preverb":"quickly","inf_preverb":"quickly","ger_preverb":"quickly","match_case":true,"gen_preverb_after":"g","keylookup":["-laag-",0]},"~+lallru[V\u2192V]":{"exp":"~+lallru[V\u2192V]","exp_display":"~+lallru","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"formerly regularly","gen_preverb":"formerly regularly","gen_preverb_after":"pp","was":false,"past_preverb":"had formerly regularly","past_preverb_after":"pp","inf_preverb":"have formerly regularly","inf_preverb_after":"pp","ger_preverb":"having formerly regularly","ger_preverb_after":"pp","match_case":false,"keylookup":["~+lallru-,@~+lallru-,-lallru-",0]},"@~+lallru[V\u2192V]":{"exp":"@~+lallru[V\u2192V]","exp_display":"@\u02E1~+lallru","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"formerly regularly","gen_preverb":"formerly regularly","gen_preverb_after":"pp","was":false,"past_preverb":"had formerly regularly","past_preverb_after":"pp","inf_preverb":"have formerly regularly","inf_preverb_after":"pp","ger_preverb":"having formerly regularly","ger_preverb_after":"pp","match_case":false,"keylookup":["~+lallru-,@~+lallru-,-lallru-",1]},"\u2013lallru[V\u2192V]":{"exp":"\u2013lallru[V\u2192V]","exp_display":"\u2013lallru","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"formerly regularly","gen_preverb":"formerly regularly","gen_preverb_after":"pp","was":false,"past_preverb":"had formerly regularly","past_preverb_after":"pp","inf_preverb":"have formerly regularly","inf_preverb_after":"pp","ger_preverb":"having formerly regularly","ger_preverb_after":"pp","match_case":false,"keylookup":["~+lallru-,@~+lallru-,-lallru-",2]},"~+lar[V\u2192V]":{"exp":"~+lar[V\u2192V]","exp_display":"~+lar","type":"VV","subj":"he","is":true,"has":false,"description":"regularly","gen_preverb":"regularly","past_preverb":"regularly","inf_preverb":"regularly","ger_preverb":"regularly","match_case":true,"gen_preverb_after":"g","keylookup":["~+lar-,@~+lar-,-lar-",0]},"@~+lar[V\u2192V]":{"exp":"@~+lar[V\u2192V]","exp_display":"@\u02E1~+lar","type":"VV","subj":"he","is":true,"has":false,"description":"regularly","gen_preverb":"regularly","past_preverb":"regularly","inf_preverb":"regularly","ger_preverb":"regularly","match_case":true,"gen_preverb_after":"g","keylookup":["~+lar-,@~+lar-,-lar-",1]},"\u2013lar[V\u2192V]":{"exp":"\u2013lar[V\u2192V]","exp_display":"\u2013lar","type":"VV","subj":"he","is":true,"has":false,"description":"regularly","gen_preverb":"regularly","past_preverb":"regularly","inf_preverb":"regularly","ger_preverb":"regularly","match_case":true,"gen_preverb_after":"g","keylookup":["~+lar-,@~+lar-,-lar-",2]},"~+laryaaqe[V\u2192V]":{"exp":"~+laryaaqe[V\u2192V]","exp_display":"~+laryaaqe","type":"VV","subj":"he","is":true,"has":false,"description":"usually (though not at this time)","gen_preverb":"usually (though not at this time)","past_preverb":"usually (though not at this time)","inf_preverb":"usually (though not at this time)","ger_preverb":"usually (though not at this time)","match_case":true,"gen_preverb_after":"g","keylookup":["~+laryaaqe-,@~+laryaaqe-,-laryaaqe-",0]},"@~+laryaaqe[V\u2192V]":{"exp":"@~+laryaaqe[V\u2192V]","exp_display":"@\u02E1~+laryaaqe","type":"VV","subj":"he","is":true,"has":false,"description":"usually (though not at this time)","gen_preverb":"usually (though not at this time)","past_preverb":"usually (though not at this time)","inf_preverb":"usually (though not at this time)","ger_preverb":"usually (though not at this time)","match_case":true,"gen_preverb_after":"g","keylookup":["~+laryaaqe-,@~+laryaaqe-,-laryaaqe-",1]},"\u2013laryaaqe[V\u2192V]":{"exp":"\u2013laryaaqe[V\u2192V]","exp_display":"\u2013laryaaqe","type":"VV","subj":"he","is":true,"has":false,"description":"usually (though not at this time)","gen_preverb":"usually (though not at this time)","past_preverb":"usually (though not at this time)","inf_preverb":"usually (though not at this time)","ger_preverb":"usually (though not at this time)","match_case":true,"gen_preverb_after":"g","keylookup":["~+laryaaqe-,@~+laryaaqe-,-laryaaqe-",2]},"\u2013ler[V\u2192V]":{"exp":"\u2013ler[V\u2192V]","exp_display":"\u2013ler","type":"VV","description":"suddenly and willfully","postverb":"suddenly and willfully","match_case":true,"keylookup":["-ler-,~+ler-",0]},"~+ler[V\u2192V]":{"exp":"~+ler[V\u2192V]","exp_display":"~+ler","type":"VV","description":"suddenly and willfully","postverb":"suddenly and willfully","match_case":true,"keylookup":["-ler-,~+ler-",1]},"\u2013leryag[V\u2192V]":{"exp":"\u2013leryag[V\u2192V]","exp_display":"\u2013leryag","type":"VV","description":"abruptly","postverb":"abruptly","match_case":true,"keylookup":["-leryag-,~+leryag-",0]},"~+leryag[V\u2192V]":{"exp":"~+leryag[V\u2192V]","exp_display":"~+leryag","type":"VV","description":"abruptly","postverb":"abruptly","match_case":true,"keylookup":["-leryag-,~+leryag-",1]},"\u2013lgu[V\u2192V]":{"exp":"\u2013lgu[V\u2192V]","exp_display":"\u2013lgu","type":"VV","subj":"he","is":true,"has":false,"description":"always","gen_preverb":"always","past_preverb":"always","inf_preverb":"always","ger_preverb":"always","match_case":true,"gen_preverb_after":"g","keylookup":["-lgu-",0]},"\u2013lguir[V\u2192V]":{"exp":"\u2013lguir[V\u2192V]","exp_display":"\u2013lguir","type":"VV","neg":true,"subj":"he","is":false,"has":false,"description":"stopped being able to","gen_preverb":"stopped being able to","gen_preverb_after":"i","was":false,"past_preverb":"had stopped being able to","past_preverb_after":"i","inf_preverb":"have stopped being able to","inf_preverb_after":"i","ger_preverb":"having stopped being able to","ger_preverb_after":"i","match_case":false,"keylookup":["-lguir-",0]},"\u2013lguirute[V\u2192V]":{"exp":"\u2013lguirute[V\u2192V]","exp_display":"\u2013lguirute","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"no longer able to","gen_preverb":"no longer able to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be no longer able to","inf_preverb_after":"i","ger_preverb":"being no longer able to","ger_preverb_after":"i","match_case":false,"keylookup":["-lguirute-",0]},"\u2013lguite[V\u2192V]":{"exp":"\u2013lguite[V\u2192V]","exp_display":"\u2013lguite\xB0","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"unable to","gen_preverb":"unable to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be unable to","inf_preverb_after":"i","ger_preverb":"being unable to","ger_preverb_after":"i","match_case":false,"keylookup":["-lguite-",0]},"\u2013lguri[V\u2192V]":{"exp":"\u2013lguri[V\u2192V]","exp_display":"\u2013lguri","type":"VV","subj":"he","is":false,"has":false,"description":"became able to","gen_preverb":"became able to","gen_preverb_after":"i","was":false,"past_preverb":"had become able to","past_preverb_after":"i","inf_preverb":"have become able to","inf_preverb_after":"i","ger_preverb":"having become able to","ger_preverb_after":"i","match_case":false,"keylookup":["-lguri-",0]},"\u2013\u2013liyar[V\u2192V]":{"exp":"\u2013\u2013liyar[V\u2192V]","exp_display":"\u2013\u2013liyar","type":"VV","subj":"he","is":true,"has":false,"description":"going to participate in","gen_preverb":"going to participate in","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"go participate in","inf_preverb_after":"g","ger_preverb":"going to participate in","ger_preverb_after":"g","match_case":false,"keylookup":["-liyar-,-liar-",2]},"\u2013liar[V\u2192V]":{"exp":"\u2013liar[V\u2192V]","exp_display":"\u2013liar","type":"VV","subj":"he","is":true,"has":false,"description":"going to participate in","gen_preverb":"going to participate in","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"go participate in","inf_preverb_after":"g","ger_preverb":"going to participate in","ger_preverb_after":"g","match_case":false,"keylookup":["-liyar-,-liar-",3]},"\u2013lkia[V\u2192V]":{"exp":"\u2013lkia[V\u2192V]","exp_display":"\u2013lkia","type":"VV","subj":"he","is":true,"has":false,"description":"giving evidence of","gen_preverb":"giving evidence of","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"give evidence of","inf_preverb_after":"g","ger_preverb":"giving evidence of","ger_preverb_after":"g","match_case":false,"keylookup":["-lkia-",1]},"\u2013llag[V\u2192V]":{"exp":"\u2013llag[V\u2192V]","exp_display":"\u2013llag","type":"VV","description":"suddenly and surprisingly","postverb":"suddenly and surprisingly","match_case":true,"keylookup":["-llag-",0]},"\u2013llgu[V\u2192V]":{"exp":"\u2013llgu[V\u2192V]","exp_display":"\u2013llgu","type":"VV","subj":"he","is":true,"has":false,"description":"good at","gen_preverb":"good at","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"be good at","inf_preverb_after":"g","ger_preverb":"being good at","ger_preverb_after":"g","match_case":false,"keylookup":["-llgu-",0]},"\u2013lli[V\u2192V]":{"exp":"\u2013lli[V\u2192V]","exp_display":"\u2013lli","type":"VV","subj":"he","is":true,"has":false,"description":"maybe","gen_preverb":"maybe","past_preverb":"maybe","inf_preverb":"maybe","ger_preverb":"maybe","match_case":true,"gen_preverb_after":"g","keylookup":["-lli-",0]},"\u2013llini[V\u2192V]":{"exp":"\u2013llini[V\u2192V]","exp_display":"\u2013llini","type":"VV","description":"evidently","postverb":"evidently","match_case":true,"keylookup":["-llini-",0]},"\u2013llru\xB9[V\u2192V]":{"exp":"\u2013llru\xB9[V\u2192V]","exp_display":"\u2013llru","type":"VV","tense":"past","subj":"he","is":false,"has":false,"description":"","gen_preverb":"","gen_preverb_after":"p","was":false,"past_preverb":"","past_preverb_after":"p","inf_preverb":"(in the past)","inf_preverb_after":"i","ger_preverb":"(in the past)","ger_preverb_after":"g","match_case":false,"keylookup":["-llru\xB9-",0]},"\u2013llrunrite[V\u2192V]":{"exp":"\u2013llrunrite[V\u2192V]","exp_display":"\u2013llrunrite\xB0","type":"VV","tense":"past","neg":true,"subj":"he","is":false,"has":true,"description":"not","gen_preverb":"not","gen_preverb_after":"pp","was":false,"past_preverb":"had not","past_preverb_after":"pp","inf_preverb":"have not","inf_preverb_after":"pp","ger_preverb":"having not","ger_preverb_after":"pp","match_case":false,"keylookup":["-llrunrite-",0]},"\u2013llrurte[V\u2192V]":{"exp":"\u2013llrurte[V\u2192V]","exp_display":"\u2013llrurte","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"already","gen_preverb":"already","gen_preverb_after":"pp","was":false,"past_preverb":"had already","past_preverb_after":"pp","inf_preverb":"have already","inf_preverb_after":"pp","ger_preverb":"having already","ger_preverb_after":"pp","match_case":false,"keylookup":["-llrurte-",0]},"\u2013llugtur[V\u2192V]":{"exp":"\u2013llugtur[V\u2192V]","exp_display":"\u2013llugtur","type":"VV","description":"quickly","postverb":"quickly","match_case":true,"keylookup":["-llugtur-",0]},"\u2013lngu[V\u2192V]":{"exp":"\u2013lngu[V\u2192V]","exp_display":"\u2013lngu","type":"VV","subj":"he","is":true,"has":false,"description":"tired of","gen_preverb":"tired of","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"be tired of","inf_preverb_after":"g","ger_preverb":"being tired of","ger_preverb_after":"g","match_case":false,"keylookup":["-lngu-",0]},"\u2013luaqar[V\u2192V]":{"exp":"\u2013luaqar[V\u2192V]","exp_display":"\u2013luaqar","type":"VV","description":"well","postverb":"well","match_case":true,"keylookup":["-luaqar-",0]},":(u|i)ma[V\u2192V]":{"exp":"%:(u|i)ma[V\u2192V]","exp_display":"%:(u|i)ma","type":"VV","tense":"past","subj":"he","is":true,"has":false,"description":"in a state of having","gen_preverb":"in a state of having","gen_preverb_after":"p","was":true,"past_preverb":"","past_preverb_after":"p","inf_preverb":"be in a state of","inf_preverb_after":"g","ger_preverb":"being in a state of","ger_preverb_after":"g","match_case":false,"keylookup":[":(u|i)ma-",0]},":(u|i)maar[V\u2192V]":{"exp":"%:(u|i)maar[V\u2192V]","exp_display":"%:(u|i)maar","type":"VV","description":"for a short duration or without making a big deal of it","postverb":"for a short duration or without making a big deal of it","match_case":true,"keylookup":[":(u|i)maar-",0]},":(u|i)maar(ar)[V\u2192V]":{"exp":"%:(u|i)maar(ar)[V\u2192V]","exp_display":"%:(u|i)maar(ar)","type":"VV","description":"slowly","postverb":"slowly","match_case":true,"keylookup":[":(u|i)maar(ar)-",0]},":(u|i)mari[V\u2192V]":{"exp":"%:(u|i)mari[V\u2192V]","exp_display":"%:(u|i)mari","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"already","gen_preverb":"already","gen_preverb_after":"pp","was":false,"past_preverb":"had already","past_preverb_after":"pp","inf_preverb":"have already","inf_preverb_after":"pp","ger_preverb":"having already","ger_preverb_after":"pp","match_case":false,"keylookup":[":(u|i)mari-",0]},"\u2013mcaugar[V\u2192V]":{"exp":"\u2013mcaugar[V\u2192V]","exp_display":"\u2013mcaugar","type":"VV","description":"in a small way","postverb":"in a small way","match_case":true,"keylookup":["-mcaugar-",0]},"\u2013mciur(ar)[V\u2192V]":{"exp":"\u2013mciur(ar)[V\u2192V]","exp_display":"\u2013mciur(ar)","type":"VV","description":"a little at a time","postverb":"a little at a time","match_case":true,"keylookup":["-mciur(ar)-",0]},"\u2013mcuar(ar)[V\u2192V]":{"exp":"\u2013mcuar(ar)[V\u2192V]","exp_display":"\u2013mcuar(ar)","type":"VV","description":"a little","postverb":"a little","match_case":true,"keylookup":["-mcuar(ar)-",0]},"\u2013mcugte[V\u2192V]":{"exp":"\u2013mcugte[V\u2192V]","exp_display":"\u2013mcugte","type":"VV","description":"to a small degree","postverb":"to a small degree","match_case":true,"keylookup":["-mcugte-,-mssugte-,-myugte-",1]},"\u2013mssugte[V\u2192V]":{"exp":"\u2013mssugte[V\u2192V]","exp_display":"\u2013mssugte","type":"VV","description":"in a small way","postverb":"in a small way","match_case":true,"keylookup":["-mssugte-",1]},"@~+mi[V\u2192V]":{"exp":"@~+mi[V\u2192V]","exp_display":"@\xB2~+mi","type":"VV","description":"also","postverb":"also","match_case":true,"keylookup":["@~+mi-",0]},"+milli[V\u2192V]":{"exp":"+milli[V\u2192V]","exp_display":"+milli","type":"VV","subj":"he","is":true,"has":false,"description":"probably also","gen_preverb":"probably also","past_preverb":"probably also","inf_preverb":"probably also","ger_preverb":"probably also","match_case":true,"gen_preverb_after":"g","keylookup":["+milli-",0]},"\u2013mli[V\u2192V]":{"exp":"\u2013mli[V\u2192V]","exp_display":"\u2013mli","type":"VV","description":"casually","postverb":"casually","match_case":true,"keylookup":["-mli-",0]},"\u2013mssag[V\u2192V]":{"exp":"\u2013mssag[V\u2192V]","exp_display":"\u2013mssag","type":"VV","description":"in a small way","postverb":"in a small way","match_case":true,"keylookup":["-mssag-",0]},"\u2013myugte[V\u2192V]":{"exp":"\u2013myugte[V\u2192V]","exp_display":"\u2013myugte","type":"VV","description":"in a small way","postverb":"in a small way","match_case":true,"keylookup":["-myugte-",0]},"@~+naciar[V\u2192V]":{"exp":"@~+naciar[V\u2192V]","exp_display":"@\xB9~+naciar","type":"VV","description":"late","postverb":"late","match_case":true,"keylookup":["@~+naciar-",0]},"@~+nanrir[V\u2192V]":{"exp":"@~+nanrir[V\u2192V]","exp_display":"@\xB9~+nanrir","type":"VV","subj":"he","is":true,"has":false,"description":"ceasing","gen_preverb":"ceasing","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"cease","inf_preverb_after":"g","ger_preverb":"ceasing","ger_preverb_after":"g","match_case":false,"keylookup":["@~+nanrir-",0]},"@~+naqsaaqe[V\u2192V]":{"exp":"@~+naqsaaqe[V\u2192V]","exp_display":"@\xB9~+naqsaaqe","type":"VV","subj":"it","is":true,"has":false,"description":"now feasible to","gen_preverb":"now feasible to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be now feasible to","inf_preverb_after":"i","ger_preverb":"being now feasible to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+naqsaaqe-",0]},"@~+nari[V\u2192V]":{"exp":"@~+nari[V\u2192V]","exp_display":"@\xB9~+nari","type":"VV","subj":"it","is":true,"has":false,"description":"time to","gen_preverb":"time to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be time to","inf_preverb_after":"i","ger_preverb":"being time to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+nari-",0]},"@~+naur[V\u2192V]":{"exp":"@~+naur[V\u2192V]","exp_display":"@\xB9~+naur","type":"VV","subj":"he","is":true,"has":false,"description":"habitually","gen_preverb":"habitually","past_preverb":"habitually","inf_preverb":"habitually","ger_preverb":"habitually","match_case":true,"gen_preverb_after":"g","keylookup":["@~+naur-",0]},"@\u2013nerkite[V\u2192V]":{"exp":"@\u2013nerkite[V\u2192V]","exp_display":"@\xB9\u2013nerkite\xB0","type":"VV","subj":"he","is":true,"has":false,"description":"habitually (only a little bit)","gen_preverb":"habitually (only a little bit)","past_preverb":"habitually (only a little bit)","inf_preverb":"habitually (only a little bit)","ger_preverb":"habitually (only a little bit)","match_case":true,"gen_preverb_after":"g","keylookup":["@-nerkite-",0]},"\u2013nerrar[V\u2192V]":{"exp":"\u2013nerrar[V\u2192V]","exp_display":"\u2013nerrar","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"recently","gen_preverb":"recently","gen_preverb_after":"pp","was":false,"past_preverb":"had recently","past_preverb_after":"pp","inf_preverb":"have recently","inf_preverb_after":"pp","ger_preverb":"having recently","ger_preverb_after":"pp","match_case":false,"keylookup":["-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",3]},"\u2013nerrar(ar)[V\u2192V]":{"exp":"\u2013nerrar(ar)[V\u2192V]","exp_display":"\u2013nerrar(ar)","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"recently","gen_preverb":"recently","gen_preverb_after":"pp","was":false,"past_preverb":"had recently","past_preverb_after":"pp","inf_preverb":"have recently","inf_preverb_after":"pp","ger_preverb":"having recently","ger_preverb_after":"pp","match_case":false,"keylookup":["-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",4]},"\u2013nerar(ar)[V\u2192V]":{"exp":"\u2013nerar(ar)[V\u2192V]","exp_display":"\u2013nerar(ar)","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"recently","gen_preverb":"recently","gen_preverb_after":"pp","was":false,"past_preverb":"had recently","past_preverb_after":"pp","inf_preverb":"have recently","inf_preverb_after":"pp","ger_preverb":"having recently","ger_preverb_after":"pp","match_case":false,"keylookup":["-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",5]},"@\u2013nerrlugte[V\u2192V]":{"exp":"@\u2013nerrlugte[V\u2192V]","exp_display":"@\xB9\u2013nerrlugte","type":"VV","subj":"he","is":true,"has":false,"description":"having trouble with ^his^","gen_preverb":"having trouble with ^his^","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"have trouble with ^his^","inf_preverb_after":"g","ger_preverb":"having trouble with ^his^","ger_preverb_after":"g","match_case":false,"keylookup":["@-nerrlugte-",0]},"@\u2013nertu[V\u2192V]":{"exp":"@\u2013nertu[V\u2192V]","exp_display":"@\xB9\u2013nertu","type":"VV","subj":"he","is":true,"has":false,"description":"habitually (a lot)","gen_preverb":"habitually (a lot)","past_preverb":"habitually (a lot)","inf_preverb":"habitually (a lot)","ger_preverb":"habitually (a lot)","match_case":true,"gen_preverb_after":"g","keylookup":["@-nertu-",0]},"@nga[V\u2192V]":{"exp":"@nga[V\u2192V]","exp_display":"@nga","type":"VV","tense":"past","subj":"he","is":false,"has":true,"description":"been in a state of having","gen_preverb":"been in a state of having","gen_preverb_after":"pp","was":false,"past_preverb":"had been in a state of having","past_preverb_after":"pp","inf_preverb":"be in a state of having","inf_preverb_after":"pp","ger_preverb":"being in a state of having","ger_preverb_after":"pp","match_case":false,"keylookup":["@nga-",0]},"@~+ngair(ar)te[V\u2192V]":{"exp":"@~+ngair(ar)te[V\u2192V]","exp_display":"@\xB2~+ngair(ar)te","type":"VV","tense":"future","neg":true,"subj":"he","is":true,"has":false,"description":"no longer going to","gen_preverb":"no longer going to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be no longer going to","inf_preverb_after":"i","ger_preverb":"being no longer going to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+ngair(ar)te-",0]},"@~+ngairute[V\u2192V]":{"exp":"@~+ngairute[V\u2192V]","exp_display":"@\xB2~+ngairute","type":"VV","tense":"future","neg":true,"subj":"he","is":false,"has":false,"description":"will never again","gen_preverb":"will never again","gen_preverb_after":"i","was":false,"past_preverb":"won't (again)","past_preverb_after":"i","inf_preverb":"not (in the future ever)","inf_preverb_after":"i","ger_preverb":"not (in the future ever)","ger_preverb_after":"g","match_case":false,"keylookup":["@~+ngairute-",0]},"@~+ngaite[V\u2192V]":{"exp":"@~+ngaite[V\u2192V]","exp_display":"@\xB2~+ngaite\xB0","type":"VV","tense":"future","neg":true,"subj":"he","is":false,"has":false,"description":"will not","gen_preverb":"will not","gen_preverb_after":"i","was":false,"past_preverb":"won't","past_preverb_after":"i","inf_preverb":"not (in the future)","inf_preverb_after":"i","ger_preverb":"not (in the future)","ger_preverb_after":"g","match_case":false,"keylookup":["@~+ngaite-",0]},"@~+ngate[V\u2192V]":{"exp":"@~+ngate[V\u2192V]","exp_display":"@\xB2~+ngate\xB0","type":"VV","subj":"he","is":false,"has":false,"description":"seems to be","gen_preverb":"seems to be","gen_preverb_after":"g","was":false,"past_preverb":"seemed to be","past_preverb_after":"g","inf_preverb":"seem to be","inf_preverb_after":"g","ger_preverb":"seeming to be","ger_preverb_after":"g","match_case":false,"keylookup":["@~+ngate-,+ngate-",1]},"\u2013nge[V\u2192V]":{"exp":"\u2013nge[V\u2192V]","exp_display":"\u2013nge","type":"VV","subj":"he","is":true,"has":false,"description":"beginning to","gen_preverb":"beginning to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"begin to","inf_preverb_after":"i","ger_preverb":"beginning to","ger_preverb_after":"i","match_case":false,"keylookup":["-nge-",1]},"@~+ngiate[V\u2192V]":{"exp":"@~+ngiate[V\u2192V]","exp_display":"@\xB2~+ngiate\xB0","type":"VV","subj":"he","is":true,"has":false,"description":"inept at","gen_preverb":"inept at","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"be inept at","inf_preverb_after":"g","ger_preverb":"being inept at","ger_preverb_after":"g","match_case":false,"keylookup":["@~+ngiate-",0]},"@~+ngig[V\u2192V]":{"exp":"@~+ngig[V\u2192V]","exp_display":"@\xB2~+ngig","type":"VV","subj":"he","is":true,"has":false,"description":"adept at","gen_preverb":"adept at","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"be adept at","inf_preverb_after":"g","ger_preverb":"being adept at","ger_preverb_after":"g","match_case":false,"keylookup":["@~+ngig-",0]},"@~+nginar[V\u2192V]":{"exp":"@~+nginar[V\u2192V]","exp_display":"@\xB2~+nginar","type":"VV","subj":"he","is":true,"has":false,"description":"merely (with no attendant complications)","gen_preverb":"merely (with no attendant complications)","past_preverb":"merely (with no attendant complications)","inf_preverb":"merely (with no attendant complications)","ger_preverb":"merely (with no attendant complications)","match_case":true,"gen_preverb_after":"g","keylookup":["@~+nginar-",0]},"\u2013ngnagar[V\u2192V]":{"exp":"\u2013ngnagar[V\u2192V]","exp_display":"\u2013ngnagar","type":"VV","description":"in an irritating way","postverb":"in an irritating way","match_case":true,"keylookup":["-ngnagaq,-ngnagar-",1]},"\u2013ngnaqe[V\u2192V]":{"exp":"\u2013ngnaqe[V\u2192V]","exp_display":"\u2013ngnaqe","type":"VV","subj":"he","is":true,"has":false,"description":"trying to","gen_preverb":"trying to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"try to","inf_preverb_after":"i","ger_preverb":"trying to","ger_preverb_after":"i","match_case":false,"keylookup":["-ngnaqe-",0]},"\u2013ngnaqsaaqe[V\u2192V]":{"exp":"\u2013ngnaqsaaqe[V\u2192V]","exp_display":"\u2013ngnaqsaaqe","type":"VV","subj":"he","is":true,"has":false,"description":"trying unsuccessfully to","gen_preverb":"trying unsuccessfully to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"try unsuccessfully to","inf_preverb_after":"i","ger_preverb":"trying unsuccessfully to","ger_preverb_after":"i","match_case":false,"keylookup":["-ngnaqsaaqe-",0]},"\u2013ngnatug[V\u2192V]":{"exp":"\u2013ngnatug[V\u2192V]","exp_display":"\u2013ngnatug","type":"VV","subj":"he","is":true,"has":false,"description":"trying hard to","gen_preverb":"trying hard to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"try hard to","inf_preverb_after":"i","ger_preverb":"trying hard to","ger_preverb_after":"i","match_case":false,"keylookup":["-ngnatug-",0]},"@\u2013ngqa[V\u2192V]":{"exp":"@\u2013ngqa[V\u2192V]","exp_display":"@\u2075\u2013ngqa","type":"VV","tense":"past","subj":"he","is":true,"has":false,"description":"in a state of","gen_preverb":"in a state of","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"be in a state of","inf_preverb_after":"g","ger_preverb":"being in a state of","ger_preverb_after":"g","match_case":false,"keylookup":["@-ngqa-",2]},"\u2013ngssaar(ar)[V\u2192V]":{"exp":"\u2013ngssaar(ar)[V\u2192V]","exp_display":"\u2013ngssaar(ar)","type":"VV","description":"secretively, unnoticeably","postverb":"secretively, unnoticeably","match_case":true,"keylookup":["-ngssaar(aq*),-ngssaar(ar)-",1]},"\u2013ngssag[V\u2192V]":{"exp":"\u2013ngssag[V\u2192V]","exp_display":"\u2013ngssag","type":"VV","description":"to no particular end","postverb":"to no particular end","match_case":true,"keylookup":["-ngssak,-ngssag-",0]},"\u2013ngssi[V\u2192V]":{"exp":"\u2013ngssi[V\u2192V]","exp_display":"\u2013ngssi","type":"VV","description":"to no particular end","postverb":"to no particular end","match_case":true,"keylookup":["-ngssi-",0]},"@~\u2013nguar[V\u2192V]":{"exp":"@~\u2013nguar[V\u2192V]","exp_display":"@\xB2~\u2013nguar","type":"VV","subj":"he","is":true,"has":false,"description":"pretending to","gen_preverb":"pretending to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"pretend to","inf_preverb_after":"i","ger_preverb":"pretending to","ger_preverb_after":"i","match_case":false,"keylookup":["-nguaq,@~-nguar-",1]},"@~+niar[V\u2192V]":{"exp":"@~+niar[V\u2192V]","exp_display":"@\xB9~+niar","type":"VV","tense":"future","subj":"he","is":false,"has":false,"description":"will (suggestion)","gen_preverb":"will (suggestion)","gen_preverb_after":"i","was":false,"past_preverb":"","past_preverb_after":"i","inf_preverb":"(in the future, suggestion)","inf_preverb_after":"i","ger_preverb":"(in the future, suggestion)","ger_preverb_after":"g","match_case":false,"keylookup":["@~+niar-",0]},"@~+niarar[V\u2192V]":{"exp":"@~+niarar[V\u2192V]","exp_display":"@\xB9~+niarar","type":"VV","tense":"future","subj":"he","is":true,"has":false,"description":"soon going to","gen_preverb":"soon going to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"soon be going","inf_preverb_after":"g","ger_preverb":"soon being going","ger_preverb_after":"g","match_case":false,"keylookup":["@~+niarar-",0]},"\u2013nqegcaar(ar)[V\u2192V]":{"exp":"\u2013nqegcaar(ar)[V\u2192V]","exp_display":"\u2013nqegcaar(ar)","type":"VV","description":"completely, thoroughly","postverb":"completely, thoroughly","match_case":true,"keylookup":["-nqegcaar(aq*),-nqegcaar(ar)-",0]},"\u2013nqigte[V\u2192V]":{"exp":"\u2013nqigte[V\u2192V]","exp_display":"\u2013nqigte","type":"VV","description":"again","postverb":"again","match_case":true,"keylookup":["-nqigte-",0]},"\u2013nricen\u0304ar[V\u2192V]":{"exp":"\u2013nricen\u0304ar[V\u2192V]","exp_display":"\u2013nricen\u0304ar","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"not (having changed his mind)","gen_preverb":"not (having changed his mind)","past_preverb":"not (having changed his mind)","inf_preverb":"not (having changed his mind)","ger_preverb":"not (having changed his mind)","match_case":true,"gen_preverb_after":"g","keylookup":["-nricen\u0304ar-",0]},"\u2013nrilkurte[V\u2192V]":{"exp":"\u2013nrilkurte[V\u2192V]","exp_display":"\u2013nrilkurte","type":"VV","subj":"he","is":true,"has":false,"description":"keeping ^himself^ from","gen_preverb":"keeping ^himself^ from","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"keep ^himself^ from","inf_preverb_after":"g","ger_preverb":"keeping ^himself^ from","ger_preverb_after":"g","match_case":false,"keylookup":["-nrilkurte-",0]},"\u2013nrir[V\u2192V]":{"exp":"\u2013nrir[V\u2192V]","exp_display":"\u2013nrir","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"no longer","gen_preverb":"no longer","past_preverb":"no longer","inf_preverb":"no longer","ger_preverb":"no longer","match_case":true,"gen_preverb_after":"g","keylookup":["-nrir-",0]},"\u2013nritar(ar)[V\u2192V]":{"exp":"\u2013nritar(ar)[V\u2192V]","exp_display":"\u2013nritar(ar)","type":"VV","subj":"he","is":true,"has":false,"description":"almost","gen_preverb":"almost","past_preverb":"almost","inf_preverb":"almost","ger_preverb":"almost","match_case":true,"gen_preverb_after":"g","keylookup":["-nritar(ar)-",0]},"\u2013nrite[V\u2192V]":{"exp":"\u2013nrite[V\u2192V]","exp_display":"\u2013nrite\xB0","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"not","gen_preverb":"not","past_preverb":"not","inf_preverb":"not","ger_preverb":"not","match_case":true,"gen_preverb_after":"g","keylookup":["-nrite-",0]},"\u2013nru[V\u2192V]":{"exp":"\u2013nru[V\u2192V]","exp_display":"\u2013nru","type":"VV","description":"moreso","postverb":"moreso","match_case":true,"keylookup":["-nru-",0]},"@+paalug|~vaalug[V\u2192V]":{"exp":"@+paalug|~vaalug[V\u2192V]","exp_display":"@\u2075+p|~vaalug","type":"VV","description":"for the first time","postverb":"for the first time","match_case":true,"keylookup":["@+paalug-|~vaalug-,@+pailug-|~vailug-",0]},"@+pailug|~vailug[V\u2192V]":{"exp":"@+pailug|~vailug[V\u2192V]","exp_display":"@\u2075+p|~vailug","type":"VV","description":"for the first time","postverb":"for the first time","match_case":true,"keylookup":["@+paalug-|~vaalug-,@+pailug-|~vailug-",1]},"\u2013pacug[V\u2192V]":{"exp":"\u2013pacug[V\u2192V]","exp_display":"\u2013pacug","type":"VV","description":"poorly, dearly","postverb":"poorly, dearly","match_case":true,"keylookup":["-pacug-",0]},"@+pag|~vag\xB9[V\u2192V]":{"exp":"@+pag|~vag\xB9[V\u2192V]","exp_display":"@\u2075+p|~vag","type":"VV","description":"so well","postverb":"so well","match_case":true,"keylookup":["@+pag-|~vag\xB9-",0]},"@+pakar|~vakar[V\u2192V]":{"exp":"@+pakar|~vakar[V\u2192V]","exp_display":"@\u2075+p|~vakar","type":"VV","description":"so much","postverb":"so much","match_case":true,"keylookup":["@+pakar-|~vakar-,-qpakar-",0]},"\u2013qpakar[V\u2192V]":{"exp":"\u2013qpakar[V\u2192V]","exp_display":"\u2013qpakar","type":"VV","description":"so much","postverb":"so much","match_case":true,"keylookup":["@+pakar-|~vakar-,-qpakar-",1]},"@+pallag|~vallag[V\u2192V]":{"exp":"@+pallag|~vallag[V\u2192V]","exp_display":"@\u2075+p|~vallag","type":"VV","description":"intensely","postverb":"intensely","match_case":true,"keylookup":["@+pallag-|~vallag-",0]},"@+pallug|~vallug[V\u2192V]":{"exp":"@+pallug|~vallug[V\u2192V]","exp_display":"@\u2075+p|~vallug","type":"VV","description":"the most","postverb":"the most","match_case":true,"keylookup":["@+pallug-|~vallug-,@+pallur-|~vallur-",0]},"@+pallur|~vallur[V\u2192V]":{"exp":"@+pallur|~vallur[V\u2192V]","exp_display":"@\u2075+p|~vallur","type":"VV","description":"the most","postverb":"the most","match_case":true,"keylookup":["@+pallug-|~vallug-,@+pallur-|~vallur-",1]},"+peke|.vke[V\u2192V]":{"exp":"+peke|.vke[V\u2192V]","exp_display":"+p|.vke\xB0","type":"VV","neg":true,"subj":"he","is":false,"has":false,"description":"do not","gen_preverb":"do not","gen_preverb_after":"i","was":false,"past_preverb":"","past_preverb_after":"i","inf_preverb":"not","inf_preverb_after":"i","ger_preverb":"not","ger_preverb_after":"g","match_case":false,"keylookup":["+peke-|+vke-,+pege-|+vke-",0]},"+pege|.vke[V\u2192V]":{"exp":"+pege|.vke[V\u2192V]","exp_display":"+p|.vge\xB0","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"not","gen_preverb":"not","past_preverb":"not","inf_preverb":"not","ger_preverb":"not","match_case":true,"gen_preverb_after":"g","keylookup":["+peke-|+vke-,+pege-|+vke-",1]},"+pigainar[V\u2192V]":{"exp":"+pigainar[V\u2192V]","exp_display":"+pigainar","type":"VV","subj":"he","is":true,"has":false,"description":"actually (surprisingly)","gen_preverb":"actually (surprisingly)","past_preverb":"actually (surprisingly)","inf_preverb":"actually (surprisingly)","ger_preverb":"actually (surprisingly)","match_case":true,"gen_preverb_after":"g","keylookup":["+pigainar-,-pigainar-",0]},"\u2013pigainar[V\u2192V]":{"exp":"\u2013pigainar[V\u2192V]","exp_display":"\u2013pigainar","type":"VV","subj":"he","is":true,"has":false,"description":"actually (surprisingly)","gen_preverb":"actually (surprisingly)","past_preverb":"actually (surprisingly)","inf_preverb":"actually (surprisingly)","ger_preverb":"actually (surprisingly)","match_case":true,"gen_preverb_after":"g","keylookup":["+pigainar-,-pigainar-",1]},"\u2013pig[V\u2192V]":{"exp":"\u2013pig[V\u2192V]","exp_display":"\u2013pig","type":"VV","subj":"he","is":true,"has":false,"description":"really","gen_preverb":"really","past_preverb":"really","inf_preverb":"really","ger_preverb":"really","match_case":true,"gen_preverb_after":"g","keylookup":["-pik\xB9,-piaq,-pigaq,-pig-,-piar-,-pigar-",3]},"\u2013piar[V\u2192V]":{"exp":"\u2013piar[V\u2192V]","exp_display":"\u2013piar","type":"VV","subj":"he","is":true,"has":false,"description":"really","gen_preverb":"really","past_preverb":"really","inf_preverb":"really","ger_preverb":"really","match_case":true,"gen_preverb_after":"g","keylookup":["-pik\xB9,-piaq,-pigaq,-pig-,-piar-,-pigar-",4]},"\u2013pigar[V\u2192V]":{"exp":"\u2013pigar[V\u2192V]","exp_display":"\u2013pigar","type":"VV","description":"very much so","postverb":"very much so","match_case":true,"keylookup":["-pik\xB9,-piaq,-pigaq,-pig-,-piar-,-pigar-",5]},"\u2013qaci[V\u2192V]":{"exp":"\u2013qaci[V\u2192V]","exp_display":"\u2013q\u0332aci","type":"VV","description":"in a minor way","postverb":"in a minor way","match_case":true,"keylookup":["-qaci-",0]},"\u2013qainar[V\u2192V]":{"exp":"\u2013qainar[V\u2192V]","exp_display":"\u2013q\u0332ainar","type":"VV","subj":"he","is":true,"has":false,"description":"merely","gen_preverb":"merely","past_preverb":"merely","inf_preverb":"merely","ger_preverb":"merely","match_case":true,"gen_preverb_after":"g","keylookup":["-qainaq,-qainar-",1]},"\u2013qainaurte[V\u2192V]":{"exp":"\u2013qainaurte[V\u2192V]","exp_display":"\u2013q\u0332ainaurte","type":"VV","subj":"he","is":true,"has":false,"description":"ready to","gen_preverb":"ready to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be ready to","inf_preverb_after":"i","ger_preverb":"being ready to","ger_preverb_after":"i","match_case":false,"keylookup":["-qainaurte-",0]},"\u2013qapiar(ar)[V\u2192V]":{"exp":"\u2013qapiar(ar)[V\u2192V]","exp_display":"\u2013q\u0332apiar(ar)","type":"VV","description":"very much so","postverb":"very much so","match_case":true,"keylookup":["-qapiar(ar)-",0]},"\u2013qapigte[V\u2192V]":{"exp":"\u2013qapigte[V\u2192V]","exp_display":"\u2013q\u0332apigte","type":"VV","description":"very much so","postverb":"very much so","match_case":true,"keylookup":["-qapigte-",0]},"\u2013qaqe\xB9[V\u2192V]":{"exp":"\u2013qaqe\xB9[V\u2192V]","exp_display":"\u2013q\u0332araqe","type":"VV","description":"intermittently","postverb":"intermittently","match_case":true,"keylookup":["-qaqe\xB9-",0]},"@qaqe\xB2[V\u2192V]":{"exp":"@qaqe\xB2[V\u2192V]","exp_display":"@\u2075qaqe","type":"VV","description":"one after another","postverb":"one after another","match_case":true,"keylookup":["@qaqe\xB2-",0]},"\u2013qaqu[V\u2192V]":{"exp":"\u2013qaqu[V\u2192V]","exp_display":"\u2013q\u0332aqu","type":"VV","description":"now and then","postverb":"now and then","match_case":true,"keylookup":["-qaqur(ar)-,-qaqu-",0]},"\u2013qaqur(ar)[V\u2192V]":{"exp":"\u2013qaqur(ar)[V\u2192V]","exp_display":"\u2013q\u0332aqur(ar)","type":"VV","description":"now and then","postverb":"now and then","match_case":true,"keylookup":["-qaqur(ar)-,-qaqu-",1]},"\u2013qar[V\u2192V]":{"exp":"\u2013qar[V\u2192V]","exp_display":"\u2013q\u0332ar","type":"VV","description":"please","postverb":"please","match_case":true,"keylookup":["-qar-",0]},"\u2013qataar(ar)[V\u2192V]":{"exp":"\u2013qataar(ar)[V\u2192V]","exp_display":"\u2013q\u0332ataar(ar)","type":"VV","subj":"he","is":true,"has":false,"description":"slowly starting to","gen_preverb":"slowly starting to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"slowly start to","inf_preverb_after":"i","ger_preverb":"slowly starting to","ger_preverb_after":"i","match_case":false,"keylookup":["-qataar(ar)-",0]},"\u2013qatar[V\u2192V]":{"exp":"\u2013qatar[V\u2192V]","exp_display":"\u2013q\u0332atar","type":"VV","tense":"future","subj":"he","is":true,"has":false,"description":"about to","gen_preverb":"about to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be about to","inf_preverb_after":"i","ger_preverb":"being about to","ger_preverb_after":"i","match_case":false,"keylookup":["-qatar-",0]},"\u2013qcaar(ar)[V\u2192V]":{"exp":"\u2013qcaar(ar)[V\u2192V]","exp_display":"\u2013q\u0332caar(ar)","type":"VV","subj":"he","is":true,"has":false,"description":"trying (despite difficulties) to","gen_preverb":"trying (despite difficulties) to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"try (despite difficulties) to","inf_preverb_after":"i","ger_preverb":"trying (despite difficulties) to ","ger_preverb_after":"i","match_case":false,"keylookup":["-qcaar(ar)-",0]},"\u2013qerte[V\u2192V]":{"exp":"\u2013qerte[V\u2192V]","exp_display":"\u2013qerte","type":"VV","description":"suddenly, hurriedly","postverb":"suddenly, hurriedly","match_case":true,"keylookup":["-qerte-",0]},"\u2013qetaar[V\u2192V]":{"exp":"\u2013qetaar[V\u2192V]","exp_display":"\u2013q\u0332etaar","type":"VV","description":"repeatedly at intervals","postverb":"repeatedly at intervals","match_case":true,"keylookup":["-qetaaq,-qetaar-",0]},"@\u2013qtaar[V\u2192V]":{"exp":"@\u2013qtaar[V\u2192V]","exp_display":"@\u2013qtaar","type":"VV","description":"repeatedly at intervals","postverb":"repeatedly at intervals","match_case":true,"keylookup":["@-qtaar-",0]},"\u2013qtar[V\u2192V]":{"exp":"\u2013qtar[V\u2192V]","exp_display":"\u2013q\u0332tar","type":"VV","description":"weakly, helplessly, dearly","postverb":"weakly, helplessly, dearly","match_case":true,"keylookup":["-qtaq*,-qtar-",1]},"\u2013qtarar(ar)[V\u2192V]":{"exp":"\u2013qtarar(ar)[V\u2192V]","exp_display":"\u2013q\u0332tarar(ar)","type":"VV","description":"slowly and with difficulty because of disability","postverb":"slowly and with difficulty because of disability","match_case":true,"keylookup":["-qtarar(ar)-",0]},"\u2013qu\xB9[V\u2192V]":{"exp":"\u2013qu\xB9[V\u2192V]","exp_display":"\u2013q\u0332u","type":"VV","description":"one after another","postverb":"one after another","match_case":true,"keylookup":["-qu\xB9-",0]},"@\u2013qur[V\u2192V]":{"exp":"@\u2013qur[V\u2192V]","exp_display":"@\u2075\u2013qur","type":"VV","description":"using repeated action to accomplish the act","postverb":"using repeated action to accomplish the act","match_case":true,"keylookup":["@-qur-",0]},"\u2013rpaga[V\u2192V]":{"exp":"\u2013rpaga[V\u2192V]","exp_display":"\u2013r\u0332paga","type":"VV","description":"hard at intervals","postverb":"hard at intervals","match_case":true,"keylookup":["-rpaga-",0]},"\u2013rpag[V\u2192V]":{"exp":"\u2013rpag[V\u2192V]","exp_display":"\u2013r\u0332pag","type":"VV","description":"hard","postverb":"hard","match_case":true,"keylookup":["-rpak,-rpag-",1]},"\u2013rpakar[V\u2192V]":{"exp":"\u2013rpakar[V\u2192V]","exp_display":"\u2013r\u0332pakar","type":"VV","description":"so much, for so long","postverb":"so much, for so long","match_case":true,"keylookup":["-rpakar-",0]},"@\u2013rqe\xB9[V\u2192V]":{"exp":"@\u2013rqe\xB9[V\u2192V]","exp_display":"@\u2075\u2013rqe","type":"VV","description":"one after another","postverb":"one after another","match_case":true,"keylookup":["@-rqe\xB9-",0]},"\u2013rrar[V\u2192V]":{"exp":"\u2013rrar[V\u2192V]","exp_display":"\u2013r\u0332r\u0332ar","type":"VV","description":"just barely","postverb":"just barely","match_case":true,"keylookup":["-rraq*,-rrar-",1]},"\u2013rraar[V\u2192V]":{"exp":"\u2013rraar[V\u2192V]","exp_display":"\u2013r\u0332r\u0332aar","type":"VV","description":"first","postverb":"first","match_case":true,"keylookup":["-rraar-",0]},"\u2013rrlainar[V\u2192V]":{"exp":"\u2013rrlainar[V\u2192V]","exp_display":"\u2013r\u0332r\u0332lainar","type":"VV","subj":"he","is":true,"has":false,"description":"constantly","gen_preverb":"constantly","past_preverb":"constantly","inf_preverb":"constantly","ger_preverb":"constantly","match_case":true,"gen_preverb_after":"g","keylookup":["-rrlainaq*,-rrlainar-",1]},"\u2013rrluar(ar)[V\u2192V]":{"exp":"\u2013rrluar(ar)[V\u2192V]","exp_display":"\u2013r\u0332r\u0332luar(ar)","type":"VV","description":"a little bit","postverb":"a little bit","match_case":true,"keylookup":["-rrluar(ar)-",0]},"\u2013rrlug[V\u2192V]":{"exp":"\u2013rrlug[V\u2192V]","exp_display":"\u2013r\u0332r\u0332lug","type":"VV","subj":"he","is":true,"has":false,"description":"somewhat","gen_preverb":"somewhat","past_preverb":"somewhat","inf_preverb":"somewhat","ger_preverb":"somewhat","match_case":true,"gen_preverb_after":"g","keylookup":["-rrluk,-rrlug-,-rrlugte-",3]},"\u2013rrlugte[V\u2192V]":{"exp":"\u2013rrlugte[V\u2192V]","exp_display":"\u2013r\u0332r\u0332lugte","type":"VV","subj":"he","is":true,"has":false,"description":"somewhat","gen_preverb":"somewhat","past_preverb":"somewhat","inf_preverb":"somewhat","ger_preverb":"somewhat","match_case":true,"gen_preverb_after":"g","keylookup":["-rrluk,-rrlug-,-rrlugte-",4]},"\u2013q(ur)lur[V\u2192V]":{"exp":"\u2013q(ur)lur[V\u2192V]","exp_display":"\u2013r\u0332(ur)lur","type":"VV","description":"poorly, dearly","postverb":"poorly, dearly","match_case":true,"keylookup":["-r(ur)luq*,-q(ur)lur-",1]},"\u2013rvaar[V\u2192V]":{"exp":"\u2013rvaar[V\u2192V]","exp_display":"\u2013r\u0332vaar","type":"VV","description":"very much so","postverb":"very much so","match_case":true,"keylookup":["-rvaar-",0]},"\u2013rvag[V\u2192V]":{"exp":"\u2013rvag[V\u2192V]","exp_display":"\u2013r\u0332vag","type":"VV","description":"very much so","postverb":"very much so","match_case":true,"keylookup":["-rvag-",0]},"\u2013sciigate[V\u2192V]":{"exp":"\u2013sciigate[V\u2192V]","exp_display":"\u2013sciigate\xB0","type":"VV","subj":"he","is":true,"has":false,"description":"unable to","gen_preverb":"unable to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be unable to","inf_preverb_after":"i","ger_preverb":"being unable to","ger_preverb_after":"i","match_case":false,"keylookup":["-sciigate-",0]},"\u2013ssaag\xB9[V\u2192V]":{"exp":"\u2013ssaag\xB9[V\u2192V]","exp_display":"\u2013ssaag","type":"VV","subj":"he","is":true,"has":false,"description":"trying to","gen_preverb":"trying to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"try to","inf_preverb_after":"i","ger_preverb":"trying to","ger_preverb_after":"i","match_case":false,"keylookup":["-ssaag\xB9-",0]},"\u2013ssaag\xB3[V\u2192V]":{"exp":"\u2013ssaag\xB3[V\u2192V]","exp_display":"\u2013ssaag","type":"VV","description":"too much","postverb":"too much","match_case":true,"keylookup":["-ssaag\xB3-",0]},"\u2013ssiyaag[V\u2192V]":{"exp":"\u2013ssiyaag[V\u2192V]","exp_display":"\u2013ssiyaag","type":"VV","description":"too much","postverb":"too much","match_case":true,"keylookup":["-ssiyaag-",0]},"@+ta\xB2[V\u2192V]":{"exp":"@+ta\xB2[V\u2192V]","exp_display":"@\xB2+ta","type":"VV","description":"to a certain degree","postverb":"to a certain degree","match_case":true,"keylookup":["@+ta\xB2-",0]},"+taagute[V\u2192V]":{"exp":"+taagute[V\u2192V]","exp_display":"+taagute","type":"VV","description":"back and forth","postverb":"back and forth","match_case":true,"keylookup":["+taagute-",0]},"@+taar\xB9[V\u2192V]":{"exp":"@+taar\xB9[V\u2192V]","exp_display":"@\u2074+taar","type":"VV","subj":"he","is":true,"has":false,"description":"acting so as to try to make others feel that ^he^ is","gen_preverb":"acting so as to try to make others feel that ^he^ is","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"act so as to try to make others feel that ^he^ is","inf_preverb_after":"g","ger_preverb":"acting so as to try to make others feel that ^he^ is","ger_preverb_after":"g","match_case":false,"keylookup":["@+taar\xB9-",0]},"+tar\xB9[V\u2192V]":{"exp":"+tar\xB9[V\u2192V]","exp_display":"+tar","type":"VV","subj":"he","is":false,"has":false,"description":"tends to often","gen_preverb":"tends to often","gen_preverb_after":"i","was":false,"past_preverb":"tended to often","past_preverb_after":"i","inf_preverb":"tend to often","inf_preverb_after":"i","ger_preverb":"tending to often","ger_preverb_after":"i","match_case":false,"keylookup":["+tar\xB9-",1]},"+ter[V\u2192V]":{"exp":"+ter[V\u2192V]","exp_display":"+ter","type":"VV","description":"suddenly and willfully","postverb":"suddenly and willfully","match_case":true,"keylookup":["+ter-",0]},"\u2013tngurte[V\u2192V]":{"exp":"\u2013tngurte[V\u2192V]","exp_display":"\u2013tngurte","type":"VV","description":"unexpectedly","postverb":"unexpectedly","match_case":true,"keylookup":["-tngurte-,-tmurte\xB2-",0]},"\u2013tmurte\xB2[V\u2192V]":{"exp":"\u2013tmurte\xB2[V\u2192V]","exp_display":"\u2013tmurte","type":"VV","description":"unexpectedly","postverb":"unexpectedly","match_case":true,"keylookup":["-tngurte-,-tmurte\xB2-",1]},"\u2013tu[V\u2192V]":{"exp":"\u2013tu[V\u2192V]","exp_display":"\u2013tu","type":"VV","description":"customarily","postverb":"customarily","match_case":true,"keylookup":["+tu-,-tu-",1]},"+tuinar[V\u2192V]":{"exp":"+tuinar[V\u2192V]","exp_display":"+tuinar","type":"VV","subj":"it","is":true,"has":false,"description":"always","gen_preverb":"always","past_preverb":"always","inf_preverb":"always","ger_preverb":"always","match_case":true,"gen_preverb_after":"g","keylookup":["+tuinar-",0]},"\u2013turnir[V\u2192V]":{"exp":"\u2013turnir[V\u2192V]","exp_display":"\u2013turnir","type":"VV","subj":"it","is":true,"has":false,"description":"proficiently able to","gen_preverb":"proficiently able to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be proficiently able to","inf_preverb_after":"i","ger_preverb":"being proficiently able to","ger_preverb_after":"i","match_case":false,"keylookup":["-turnir-",0]},"@~+(ng)uar[V\u2192V]":{"exp":"@~+(ng)uar[V\u2192V]","exp_display":"@\xB2~+(ng)uar","type":"VV","subj":"it","is":true,"has":false,"description":"pretending to","gen_preverb":"pretending to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"pretend to","inf_preverb_after":"i","ger_preverb":"pretending to","ger_preverb_after":"i","match_case":false,"keylookup":["+(ng)uaq,@~+(ng)uar-",1]},"@+`(g|t)ur(ar)[V\u2192V]":{"exp":"@+`(g|t)ur(ar)[V\u2192V]","exp_display":"@\u02C1+`(g|t)ur(ar)","type":"VV","subj":"it","is":true,"has":false,"description":"continuing to","gen_preverb":"continuing to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"continue to","inf_preverb_after":"i","ger_preverb":"continuing to","ger_preverb_after":"i","match_case":false,"keylookup":["@+'(g|t)ur(ar)-",0]},"@+`(g|t)urainar[V\u2192V]":{"exp":"@+`(g|t)urainar[V\u2192V]","exp_display":"@\u02C1+`(g|t)urainar","type":"VV","subj":"it","is":true,"has":false,"description":"finally (after desiring to but not being able to)","gen_preverb":"finally (after desiring to but not being able to)","past_preverb":"finally (after desiring to but not being able to)","inf_preverb":"finally (after desiring to but not being able to)","ger_preverb":"finally (after desiring to but not being able to)","match_case":true,"gen_preverb_after":"g","keylookup":["@+'(g|t)urainar-",0]},"@+`(g|t)uralar[V\u2192V]":{"exp":"@+`(g|t)uralar[V\u2192V]","exp_display":"@\u02C1+`(g|t)uralar","type":"VV","subj":"it","is":true,"has":false,"description":"always","gen_preverb":"always","past_preverb":"always","inf_preverb":"always","ger_preverb":"always","match_case":true,"gen_preverb_after":"g","keylookup":["@+'(g|t)uralar-,@+'(g|t)ur(ar)lar-,@+'(g|t)uratu-",0]},"@+`(g|t)ur(ar)lar[V\u2192V]":{"exp":"@+`(g|t)ur(ar)lar[V\u2192V]","exp_display":"@\u02C1+`(g|t)ur(ar)lar","type":"VV","subj":"it","is":true,"has":false,"description":"always","gen_preverb":"always","past_preverb":"always","inf_preverb":"always","ger_preverb":"always","match_case":true,"gen_preverb_after":"g","keylookup":["@+'(g|t)uralar-,@+'(g|t)ur(ar)lar-,@+'(g|t)uratu-",1]},"@+`(g|t)uratu[V\u2192V]":{"exp":"@+`(g|t)uratu[V\u2192V]","exp_display":"@\u02C1+`(g|t)uratu","type":"VV","subj":"it","is":true,"has":false,"description":"always","gen_preverb":"always","past_preverb":"always","inf_preverb":"always","ger_preverb":"always","match_case":true,"gen_preverb_after":"g","keylookup":["@+'(g|t)uralar-,@+'(g|t)ur(ar)lar-,@+'(g|t)uratu-",2]},"\u2013vguar(ar)[V\u2192V]":{"exp":"\u2013vguar(ar)[V\u2192V]","exp_display":"\u2013vguar(ar)","type":"VV","description":"a little bit","postverb":"a little bit","match_case":true,"keylookup":["-vguar(ar)-",0]},"\u2013vialug[V\u2192V]":{"exp":"\u2013vialug[V\u2192V]","exp_display":"\u2013vialug","type":"VV","description":"clumsily","postverb":"clumsily","match_case":true,"keylookup":["-vialuk,-vialug-",1]},"\u2013viite[V\u2192V]":{"exp":"\u2013viite[V\u2192V]","exp_display":"\u2013viite","type":"VV","subj":"it","is":false,"has":false,"description":"leaves no room or place to","gen_preverb":"leaves no room or place to","gen_preverb_after":"i","was":false,"past_preverb":"left no room or place to","past_preverb_after":"i","inf_preverb":"leave no room or place to","inf_preverb_after":"i","ger_preverb":"leaving no room or place to","ger_preverb_after":"i","match_case":false,"keylookup":["-viite-",0]},"\u2013vlaag[V\u2192V]":{"exp":"\u2013vlaag[V\u2192V]","exp_display":"\u2013vlaag","type":"VV","description":"insufficiently","postverb":"insufficiently","match_case":true,"keylookup":["-vlaag-",0]},"\u2013vlugte[V\u2192V]":{"exp":"\u2013vlugte[V\u2192V]","exp_display":"\u2013vlugte","type":"VV","description":"sloppily","postverb":"sloppily","match_case":true,"keylookup":["-vlugte-",0]},"\u2013vsiar[V\u2192V]":{"exp":"\u2013vsiar[V\u2192V]","exp_display":"\u2013vsiar","type":"VV","description":"even more to completion","postverb":"even more to completion","match_case":true,"keylookup":["-vsiar-,-vyiar-",0]},"\u2013vyiar[V\u2192V]":{"exp":"\u2013vyiar[V\u2192V]","exp_display":"\u2013vyiar","type":"VV","description":"even more to completion","postverb":"even more to completion","match_case":true,"keylookup":["-vsiar-,-vyiar-",1]},"\u2013vyirte[V\u2192V]":{"exp":"\u2013vyirte[V\u2192V]","exp_display":"\u2013vyirte","type":"VV","description":"around here and there","postverb":"around here and there","match_case":true,"keylookup":["-vyirte-",0]},"@~+yaaqe[V\u2192V]":{"exp":"@~+yaaqe[V\u2192V]","exp_display":"@\u02B8~+yaaqe","type":"VV","description":"in vain (fruitlessly)","postverb":"in vain (fruitlessly)","match_case":true,"keylookup":["@~+yaaqe-",0]},"\u2013ya(g)ar[V\u2192V]":{"exp":"\u2013ya(g)ar[V\u2192V]","exp_display":"\u2013ya\u0121ar","type":"VV","subj":"it","is":true,"has":false,"description":"very cutely or dearly","gen_preverb":"very cutely or dearly","past_preverb":"very cutely or dearly","inf_preverb":"very cutely or dearly","ger_preverb":"very cutely or dearly","match_case":true,"gen_preverb_after":"g","keylookup":["-ya(g)aq*,-yagaq*,-ya(g)ar-,-yagar-",2]},"\u2013yagar[V\u2192V]":{"exp":"\u2013yagar[V\u2192V]","exp_display":"\u2013yagar","type":"VV","subj":"it","is":true,"has":false,"description":"very cutely or dearly","gen_preverb":"very cutely or dearly","past_preverb":"very cutely or dearly","inf_preverb":"very cutely or dearly","ger_preverb":"very cutely or dearly","match_case":true,"gen_preverb_after":"g","keylookup":["-ya(g)aq*,-yagaq*,-ya(g)ar-,-yagar-",3]},"@~+yalqar[V\u2192V]":{"exp":"@~+yalqar[V\u2192V]","exp_display":"@\u02B8~+yalqar","type":"VV","description":"without recompense","postverb":"without recompense","match_case":true,"keylookup":["@~+yalqar-",0]},"@~+yaqlir[V\u2192V]":{"exp":"@~+yaqlir[V\u2192V]","exp_display":"@\u02B8~+yaqlir","type":"VV","subj":"he","is":true,"has":false,"description":"finally","gen_preverb":"finally","past_preverb":"finally","inf_preverb":"finally","ger_preverb":"finally","match_case":true,"gen_preverb_after":"g","keylookup":["@~+yaqlir-",0]},"@~+yarar[V\u2192V]":{"exp":"@~+yarar[V\u2192V]","exp_display":"@\u02B8~+yarar","type":"VV","description":"early","postverb":"early","match_case":true,"keylookup":["@~+yarar-",0]},"@~+yarar(ar)[V\u2192V]":{"exp":"@~+yarar(ar)[V\u2192V]","exp_display":"@\u02B8~+yarar(ar)","type":"VV","description":"very early","postverb":"very early","match_case":true,"keylookup":["@~+yarar(ar)-",0]},"@~+yarpiar[V\u2192V]":{"exp":"@~+yarpiar[V\u2192V]","exp_display":"@\u02B8~+yarpiar","type":"VV","subj":"he","is":true,"has":false,"description":"almost","gen_preverb":"almost","past_preverb":"almost","inf_preverb":"almost","ger_preverb":"almost","match_case":true,"gen_preverb_after":"g","keylookup":["@~+yarpiar-,~+yarpigar-",0]},"~+yarpigar[V\u2192V]":{"exp":"~+yarpigar[V\u2192V]","exp_display":"~+yarpigar","type":"VV","subj":"he","is":true,"has":false,"description":"almost","gen_preverb":"almost","past_preverb":"almost","inf_preverb":"almost","ger_preverb":"almost","match_case":true,"gen_preverb_after":"g","keylookup":["@~+yarpiar-,~+yarpigar-",1]},"@~+yartur[V\u2192V]":{"exp":"@~+yartur[V\u2192V]","exp_display":"@\u02B8~+yartur","type":"VV","subj":"he","is":true,"has":false,"description":"going to","gen_preverb":"going to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"go","inf_preverb_after":"g","ger_preverb":"going","ger_preverb_after":"g","match_case":false,"keylookup":["@~+yartur-",0]},"@~+yaurciiqe[V\u2192V]":{"exp":"@~+yaurciiqe[V\u2192V]","exp_display":"@\u02B8~+yaurciiqe","type":"VV","subj":"he","is":true,"has":false,"description":"starting and continuing to","gen_preverb":"starting and continuing to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"start and continue to","inf_preverb_after":"i","ger_preverb":"starting and continuing to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yaurciiqe-",0]},"@~+yaurte[V\u2192V]":{"exp":"@~+yaurte[V\u2192V]","exp_display":"@\u02B8~+yaurte","type":"VV","subj":"he","is":true,"has":false,"description":"now able to","gen_preverb":"now able to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be now able to","inf_preverb_after":"i","ger_preverb":"being now able to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yaurte-",0]},"@~\u2013yu[V\u2192V]":{"exp":"@~\u2013yu[V\u2192V]","exp_display":"@\u02B8~\u2013yu","type":"VV","subj":"he","is":true,"has":false,"description":"well able to","gen_preverb":"well able to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be well able to","inf_preverb_after":"i","ger_preverb":"being well able to","ger_preverb_after":"i","match_case":false,"keylookup":["@~-yu-",0]},"@~+yuar[V\u2192V]":{"exp":"@~+yuar[V\u2192V]","exp_display":"@\u02B8~+yuar","type":"VV","subj":"","is":false,"has":false,"description":"","gen_preverb":"","gen_preverb_after":"","was":false,"past_preverb":"","past_preverb_after":"","inf_preverb":"","inf_preverb_after":"i","ger_preverb":"","ger_preverb_after":"g","match_case":false,"keylookup":["@~+yuar-",0]},"@~+yug[V\u2192V]":{"exp":"@~+yug[V\u2192V]","exp_display":"@\u02B8~+yug","type":"VV","subj":"he","is":false,"has":false,"description":"wants to","gen_preverb":"wants to","gen_preverb_after":"i","was":false,"past_preverb":"wanted to","past_preverb_after":"i","inf_preverb":"want to","inf_preverb_after":"i","ger_preverb":"wanting to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yug-,+(r)yug-",2]},"@~+yugar[V\u2192V]":{"exp":"@~+yugar[V\u2192V]","exp_display":"@\u02B8~+yugar","type":"VV","subj":"he","is":false,"has":false,"description":"enjoys ^his^","gen_preverb":"enjoys ^his^","gen_preverb_after":"g","was":false,"past_preverb":"enjoyed ^his^","past_preverb_after":"g","inf_preverb":"enjoy ^his^","inf_preverb_after":"g","ger_preverb":"enjoying ^his^","ger_preverb_after":"g","match_case":false,"keylookup":["@~+yugar-",0]},"@~+yugcali[V\u2192V]":{"exp":"@~+yugcali[V\u2192V]","exp_display":"@\u02B8~+yugcali","type":"VV","description":"heartily","postverb":"heartily","match_case":true,"keylookup":["@~+yugcali-",0]},"@~+yugnairute[V\u2192V]":{"exp":"@~+yugnairute[V\u2192V]","exp_display":"@\u02B8~+yugnairute","type":"VV","neg":true,"subj":"it","is":true,"has":false,"description":"definitely no longer going to","gen_preverb":"definitely no longer going to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be definitely no longer going to","inf_preverb_after":"i","ger_preverb":"being definitely no longer going to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yugnairute-",0]},"@~+yugnaite\xB9[V\u2192V]":{"exp":"@~+yugnaite\xB9[V\u2192V]","exp_display":"@\u02B8~+yugnaite\xB0","type":"VV","neg":true,"subj":"it","is":true,"has":false,"description":"definitely not going to ","gen_preverb":"definitely not going to ","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be definitely not going to ","inf_preverb_after":"i","ger_preverb":"being definitely not going to ","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yugnaite\xB9-",0]},"@~+yugnarqe\xB9[V\u2192V]":{"exp":"@~+yugnarqe\xB9[V\u2192V]","exp_display":"@\u02B8~+yugnarqe","type":"VV","description":"probably","postverb":"probably","match_case":true,"keylookup":["@~+yugnarqe\xB9-",0]},"@~+yugnarqe\xB2[V\u2192V]":{"exp":"@~+yugnarqe\xB2[V\u2192V]","exp_display":"@\u02B8~+yugnarqe","type":"VV","subj":"it","is":true,"has":false,"description":"such as to make one want to","gen_preverb":"such as to make one want to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be such as to make one want to","inf_preverb_after":"i","ger_preverb":"being such as to make one want to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yugnarqe\xB2-",0]},"@~+yugnga[V\u2192V]":{"exp":"@~+yugnga[V\u2192V]","exp_display":"@\u02B8~+yugnga","type":"VV","subj":"he","is":true,"has":false,"description":"able to","gen_preverb":"able to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be able to","inf_preverb_after":"i","ger_preverb":"being able to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yugnga-",0]},"@~+yugyaaqe[V\u2192V]":{"exp":"@~+yugyaaqe[V\u2192V]","exp_display":"@\u02B8~+yugyaaqe","type":"VV","subj":"he","is":false,"has":false,"description":"wants (provided it is all right) to","gen_preverb":"wants (provided it is all right) to","gen_preverb_after":"i","was":false,"past_preverb":"wanted (provided it was all right) to","past_preverb_after":"i","inf_preverb":"want (provided it is all right) to","inf_preverb_after":"i","ger_preverb":"wanting (provided it is all right) to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yugyaaqe-",0]},"@~\u2013yuirute[V\u2192V]":{"exp":"@~\u2013yuirute[V\u2192V]","exp_display":"@\u02B8~\u2013yuirute","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"no longer","gen_preverb":"no longer","gen_preverb_after":"g","was":true,"past_preverb":"","past_preverb_after":"g","inf_preverb":"be no longer","inf_preverb_after":"g","ger_preverb":"being no longer","ger_preverb_after":"g","match_case":false,"keylookup":["@~-yuirute-",0]},"@~\u2013yuite[V\u2192V]":{"exp":"@~\u2013yuite[V\u2192V]","exp_display":"@\u02B8~\u2013yuite\xB0","type":"VV","neg":true,"subj":"he","is":false,"has":false,"description":"never","gen_preverb":"never","past_preverb":"never","inf_preverb":"never","ger_preverb":"never","match_case":true,"gen_preverb_after":"g","keylookup":["@~-yuite-",0]},"@~+yukaar(ar)[V\u2192V]":{"exp":"@~+yukaar(ar)[V\u2192V]","exp_display":"@\u02B8~+yukaar(ar)","type":"VV","subj":"he","is":true,"has":false,"description":"ready to","gen_preverb":"ready to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be ready to","inf_preverb_after":"i","ger_preverb":"being ready to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yukaar(ar)-",0]},"@~\u2013yunaite[V\u2192V]":{"exp":"@~\u2013yunaite[V\u2192V]","exp_display":"@\u02B8~\u2013yunaite\xB0","type":"VV","subj":"it","is":true,"has":false,"description":"impossible to be","gen_preverb":"impossible to be","gen_preverb_after":"pp","was":true,"past_preverb":"","past_preverb_after":"pp","inf_preverb":"be impossible to be","inf_preverb_after":"pp","ger_preverb":"being impossible to be","ger_preverb_after":"pp","match_case":false,"keylookup":["@~-yunaite-",0]},"@~\u2013yunarqe[V\u2192V]":{"exp":"@~\u2013yunarqe[V\u2192V]","exp_display":"@\u02B8~\u2013yunarqe","type":"VV","subj":"it","is":true,"has":false,"description":"possible to","gen_preverb":"possible to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be possible to","inf_preverb_after":"i","ger_preverb":"being possible to","ger_preverb_after":"i","match_case":false,"keylookup":["@~-yunarqe-",0]},"@~+yunqegg[V\u2192V]":{"exp":"@~+yunqegg[V\u2192V]","exp_display":"@\u02B8~+yunqegg","type":"VV","subj":"he","is":false,"has":false,"description":"loves","gen_preverb":"loves","gen_preverb_after":"g","was":false,"past_preverb":"loved","past_preverb_after":"g","inf_preverb":"love","inf_preverb_after":"g","ger_preverb":"loving","ger_preverb_after":"g","match_case":false,"keylookup":["@~+yunqegg-",0]},"@~+yunrite[V\u2192V]":{"exp":"@~+yunrite[V\u2192V]","exp_display":"@\u02B8~+yunrite\xB0","type":"VV","neg":true,"subj":"he","is":true,"has":false,"description":"continuing not to","gen_preverb":"continuing not to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"continue not to","inf_preverb_after":"i","ger_preverb":"continuing not to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yunrite-",0]},"@~+yuuma[V\u2192V]":{"exp":"@~+yuuma[V\u2192V]","exp_display":"@\u02B8~+yuuma","type":"VV","subj":"he","is":true,"has":false,"description":"able to","gen_preverb":"able to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"be able to","inf_preverb_after":"i","ger_preverb":"being able to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yuuma-",0]},"@~+yuumiir(ar)te[V\u2192V]":{"exp":"@~+yuumiir(ar)te[V\u2192V]","exp_display":"@\u02B8~+yuumiir(ar)te","type":"VV","neg":true,"subj":"he","is":false,"has":false,"description":"no longer wants to","gen_preverb":"no longer wants to","gen_preverb_after":"i","was":false,"past_preverb":"no longer wanted to","past_preverb_after":"i","inf_preverb":"no longer want to","inf_preverb_after":"i","ger_preverb":"no longer wanting to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yuumiir(ar)te-",0]},"@~+yuumiite[V\u2192V]":{"exp":"@~+yuumiite[V\u2192V]","exp_display":"@\u02B8~+yuumiite\xB0","type":"VV","neg":true,"subj":"he","is":false,"has":false,"description":"not care to","gen_preverb":"not care to","gen_preverb_after":"i","was":false,"past_preverb":"","past_preverb_after":"i","inf_preverb":"not care to","inf_preverb_after":"i","ger_preverb":"not caring to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yuumiite-",0]},"@~+yuumir[V\u2192V]":{"exp":"@~+yuumir[V\u2192V]","exp_display":"@\u02B8~+yuumir","type":"VV","subj":"he","is":true,"has":false,"description":"yearning to","gen_preverb":"yearning to","gen_preverb_after":"i","was":true,"past_preverb":"","past_preverb_after":"i","inf_preverb":"yearn to","inf_preverb_after":"i","ger_preverb":"yearning to","ger_preverb_after":"i","match_case":false,"keylookup":["@~+yuumir-",0]},"\u2013lria|@ngur*[V\u2192N]":{"exp":"\u2013lria|@ngur*[V\u2192N]","exp_display":"\u2013lria|@\u2074+ngur*","description":"the one who is V-ing","singularDefinition":"who is","type":"VN","verbType":"g","pluralDefinition":"that are","match_case":false,"keylookup":["@nguq*",0]},"+`(g)ar\xB9[V\u2192N]":{"exp":"+`(g)ar\xB9[V\u2192N]","exp_display":"+`(g)ar","description":"that which has been V-ed","singularDefinition":"which has been","type":"VN","verbType":"past","pluralDefinition":"that have been","match_case":false,"keylookup":["+'(g)aq\xB9",0]},"+`(g)arkar[V\u2192N]":{"exp":"+`(g)arkar[V\u2192N]","exp_display":"+`(g)arkar","description":"that which is to be V-ed; that which will V","singularDefinition":"which is to be","type":"VN","verbType":"past","pluralDefinition":"that have to be","match_case":false,"keylookup":["+'(g)arkaq",0]},"+`(g)arkaqenrilke[V\u2192N]":{"exp":"+`(g)arkaqenrilke[V\u2192N]","exp_display":"+`(g)arkaqenrilke","description":"that which possessor must, should or would not V","singularDefinition":"which possessor must or should not","type":"VN","verbType":"i","pluralDefinition":"that possessor must or should not","match_case":false,"keylookup":["+'(g)arkaqenrilka\u1D49",0]},"@~+cetaar[V\u2192N]":{"exp":"@~+cetaar[V\u2192N]","exp_display":"@\u2075~+cetaar","description":"something used to cause one to V","singularDefinition":"used to cause one to","type":"VN","verbType":"i","match_case":false,"keylookup":["@~+cetaaq,@~+cetaar-",1]},"@:(u)cir[V\u2192N]":{"exp":"@%:(u)cir[V\u2192N]","exp_display":"@\xB3%:(u)cir|@\u2075cir","description":"condition of possessor with respect to V; incidence of V; occurrence of V","singularDefinition":"condition of possessor with respect to","type":"VN","verbType":"g","pluralDefinition":"conditions of possessor with respect to","match_case":false,"keylookup":["@:(u)ciq",0]},"@:(u)cirkar[V\u2192N]":{"exp":"@%:(u)cirkar[V\u2192N]","exp_display":"@\xB3%:(u)cirkar","description":"future condition of possessor with respect to V","singularDefinition":"future condition of possessor with respect to","type":"VN","verbType":"g","pluralDefinition":"future conditions of possessor with respect to","match_case":false,"keylookup":["@:(u)cirkaq",0]},"@~+citaar[V\u2192N]":{"exp":"@~+citaar[V\u2192N]","exp_display":"@\u2075~+citaar","description":"something used to cause one to V","singularDefinition":"used to cause one to","type":"VN","verbType":"i","match_case":false,"keylookup":["@~+citaaq,@~+citaar-",1]},"\u2013curlag[V\u2192N]":{"exp":"\u2013curlag[V\u2192N]","exp_display":"\u2013curlag","description":"misfortune in V-ing","singularDefinition":"misfortune in","type":"VN","verbType":"g","pluralDefinition":"misfortunes in","match_case":false,"keylookup":["-curlak,-curlag-",1]},"+cuute|+ssuute[V\u2192N]":{"exp":"+cuute|+ssuute[V\u2192N]","exp_display":"+c|.ssuute","description":"device for V-ing, device associated with N","singularDefinition":"device for","type":"VN","verbType":"g","pluralDefinition":"devices for","match_case":false,"keylookup":["+cuun|+ssuun",0]},"+(s)kar(ar*)\xB2[V\u2192N]":{"exp":"+(s)kar(ar*)\xB2[V\u2192N]","exp_display":"+(s)kar(ar*)","description":"one who Vs; the only one who Vs","singularDefinition":"only one who","type":"VN","verbType":"present","pluralDefinition":"only one who","match_case":false,"keylookup":["+(s)kar(aq*)\xB2",0]},"@~\u2013ke\xB9[V\u2192N]":{"exp":"@~\u2013ke\xB9[V\u2192N]","exp_display":"@\u2074~\u2013k\u0332e","description":"(@~-ke-1) the one or ones that the possessor is V-ing","singularDefinition":"which the possessor is","type":"VN","verbType":"g","pluralDefinition":"that the possessor is","match_case":false,"keylookup":["@~-ka\u1D49,@~-ke\xB9-",0]},"@~\u2013kengar[V\u2192N]":{"exp":"@~\u2013kengar[V\u2192N]","exp_display":"@\u2075~\u2013kengar","description":"one that is being V-ed","singularDefinition":"that is being","type":"VN","verbType":"past","pluralDefinition":"that are being","match_case":false,"keylookup":["@~-kengaq",0]},"+li\xB9[V\u2192N]":{"exp":"+li\xB9[V\u2192N]","exp_display":"+li","description":"one who is V; one who Vs; one having V; one similar to N","singularDefinition":"who","type":"VN","verbType":"present","pluralDefinition":"who","match_case":false,"keylookup":["+li\xB9,+liq",2]},"+lir[V\u2192N]":{"exp":"+lir[V\u2192N]","exp_display":"+lir","description":"one who is V; one who Vs; one having V; one similar to N","singularDefinition":"who","type":"VN","verbType":"present","pluralDefinition":"who","match_case":false,"keylookup":["+li\xB9,+liq",3]},"\u2013ller\xB9[V\u2192N]":{"exp":"\u2013ller\xB9[V\u2192N]","exp_display":"\u2013ller","description":"former N; one that V-ed or was V-ed; act or state of V-ing","singularDefinition":"act or state of","type":"VN","verbType":"g","pluralDefinition":"acts or states of","match_case":false,"keylookup":["-lleq\xB9",1]},"@ller\xB2[V\u2192N]":{"exp":"@ller\xB2[V\u2192N]","exp_display":"@\u2075ller","description":"one more V than possessor(s), the most V of the possessors","singularDefinition":"more (compared to possessor)","type":"VN","pluralDefinition":"more (compared to possessor)","match_case":false,"keylookup":["@lleq\xB2",0]},"\u2013llerkar[V\u2192N]":{"exp":"\u2013llerkar[V\u2192N]","exp_display":"\u2013llerkar","description":"future act of V-ing; unrealized act of V-ing","singularDefinition":"future act of","type":"VN","verbType":"g","pluralDefinition":"future acts of","match_case":false,"keylookup":["-llerkaq",0]},"\u2013llgute[V\u2192N]":{"exp":"\u2013llgute[V\u2192N]","exp_display":"\u2013llgute","description":"fellow V-er; V-ing partner","singularDefinition":"partner in","type":"VN","verbType":"g","pluralDefinition":"partners in","match_case":false,"keylookup":["-llgun",0]},"\u2013lqurrar*[V\u2192N]":{"exp":"\u2013lqurrar*[V\u2192N]","exp_display":"\u2013lqurrar*","description":"the one(s) most V","singularDefinition":"most","type":"VN","pluralDefinition":"most","match_case":false,"keylookup":["-lqurraq*",0]},"@:(u)te[V\u2192N]":{"exp":"@%:(u)te[V\u2192N]","exp_display":"@\xB3%:(u)te","description":"(also @\xB3(u)taq) instrument or device for V-ing; time of V-ing","singularDefinition":"instrument or device for","type":"VN","verbType":"g","pluralDefinition":"instruments or devices for","match_case":false,"keylookup":["@(u)n,@(u)taq",0]},"@~+natkar[V\u2192N]":{"exp":"@~+natkar[V\u2192N]","exp_display":"@\xB9~+natkar","description":"future time of V-ing","singularDefinition":"future time of","type":"VN","verbType":"g","pluralDefinition":"future times of","match_case":false,"keylookup":["@~+natkaq",0]},"@~+ner\xB9[V\u2192N]":{"exp":"@~+ner\xB9[V\u2192N]","exp_display":"@\u2075~+ner","description":"thing that results from V-ing","singularDefinition":"thing that results from","type":"VN","verbType":"g","pluralDefinition":"things that result from","match_case":false,"keylookup":["@~+neq\xB9",0]},"@\u2013ner\xB2[V\u2192N]":{"exp":"@\u2013ner\xB2[V\u2192N]","exp_display":"@\xB9\u2013ner","description":"the activity, art, or process of V-ing","singularDefinition":"activity, art, or process of","type":"VN","verbType":"g","pluralDefinition":"activities, arts, or processes of","match_case":false,"keylookup":["@-neq\xB2",0]},"\u2013ner\xB3[V\u2192N]":{"exp":"\u2013ner\xB3[V\u2192N]","exp_display":"\u2013ner","description":"one more V than possessor(s); the most V of possessors","singularDefinition":"more (compared to possessor)","type":"VN","pluralDefinition":"more (compared to possessor)","match_case":false,"keylookup":["-neq\xB3",0]},"\u2013nerrar*[V\u2192N]":{"exp":"\u2013nerrar*[V\u2192N]","exp_display":"\u2013nerrar*","description":"new N; one that has recently V-ed","singularDefinition":"who has recently","type":"VN","verbType":"past","pluralDefinition":"that have recently","match_case":false,"keylookup":["-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",6]},"\u2013nerrar(ar*)[V\u2192N]":{"exp":"\u2013nerrar(ar*)[V\u2192N]","exp_display":"\u2013nerrar(ar*)","description":"new N; one that has recently V-ed","singularDefinition":"who has recently","type":"VN","verbType":"past","pluralDefinition":"that have recently","match_case":false,"keylookup":["-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",7]},"\u2013nerar(ar*)[V\u2192N]":{"exp":"\u2013nerar(ar*)[V\u2192N]","exp_display":"\u2013nerar(ar*)","description":"(NUN form) new N; one that has recently V-ed","singularDefinition":"who has recently","type":"VN","verbType":"past","pluralDefinition":"that have recently","match_case":false,"keylookup":["-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",8]},"@~+ngalngur*[V\u2192N]":{"exp":"@~+ngalngur*[V\u2192N]","exp_display":"@\xB2~+ngalngur*","description":"one that seems to be V-ing","singularDefinition":"who seems to be","type":"VN","verbType":"g","pluralDefinition":"that seem to be","match_case":false,"keylookup":["@~+ngalnguq*,+ngalnguq*",0]},"\u2013ngssag[V\u2192N]":{"exp":"\u2013ngssag[V\u2192N]","exp_display":"\u2013ngssag","description":"small non-vital V-ing","singularDefinition":"small non-vital","type":"VN","verbType":"g","pluralDefinition":"small non-vital","match_case":false,"keylookup":["-ngssak,-ngssag-",1]},"\u2013nguar[V\u2192N]":{"exp":"\u2013nguar[V\u2192N]","exp_display":"\u2013nguar","description":"imitation N; inauthentic N; thing similar to or reminiscent of N; device for inauthentic V-ing","singularDefinition":"device for inauthentic","type":"VN","verbType":"g","pluralDefinition":"devices for inauthentic","match_case":false,"keylookup":["-nguaq,@~-nguar-",2]},"\u2013nqegcaar(ar*)[V\u2192N]":{"exp":"\u2013nqegcaar(ar*)[V\u2192N]","exp_display":"\u2013nqegcaar(ar*)","description":"one who Vs thoroughly","singularDefinition":"who thoroughly","type":"VN","verbType":"i","pluralDefinition":"that thoroughly","match_case":false,"keylookup":["-nqegcaar(aq*),-nqegcaar(ar)-",1]},"\u2013nqurrar*[V\u2192N]":{"exp":"\u2013nqurrar*[V\u2192N]","exp_display":"\u2013nqurrar*","description":"the one(s) most V","singularDefinition":"most","type":"VN","pluralDefinition":"most","match_case":false,"keylookup":["-nqurraq*",0]},"\u2013piar[V\u2192N]":{"exp":"\u2013piar[V\u2192N]","exp_display":"\u2013piar","description":"to be really V; to be very V (pg. 404 blue: TODO)","singularDefinition":"who is really","type":"VN","pluralDefinition":"that are really","match_case":false,"keylookup":["-pik\xB9,-piaq,-pigaq,-pig-,-piar-,-pigar-",6]},"@+piiner|~viiner[V\u2192N]":{"exp":"@+piiner|~viiner[V\u2192N]","exp_display":"@\u2075+p|~viiner","description":"incident of V-ing","singularDefinition":"incident of","type":"VN","verbType":"g","pluralDefinition":"incidents of","match_case":false,"keylookup":["@+piineq|~viineq",0]},"\u2013qetaar[V\u2192N]":{"exp":"\u2013qetaar[V\u2192N]","exp_display":"\u2013q\u0332etaar","description":"device that alternately Vs and does the reverse","singularDefinition":"device that alternately (and in reverse)","type":"VN","verbType":"present","pluralDefinition":"devices that alternately (and in reverse)","match_case":false,"keylookup":["-qetaaq,-qetaar-",1]},"\u2013rraaner[V\u2192N]":{"exp":"\u2013rraaner[V\u2192N]","exp_display":"\u2013r\u0332r\u0332aaner","description":"past time of V-ing","singularDefinition":"past time of","type":"VN","verbType":"g","pluralDefinition":"past times of","match_case":false,"keylookup":["-rraaneq",0]},"+ssuute[V\u2192N]":{"exp":"+ssuute[V\u2192N]","exp_display":"+ssuute","description":"device for V-ing; device associated with N","singularDefinition":"device for","type":"VN","verbType":"g","pluralDefinition":"devices for","match_case":false,"keylookup":["+ssuun",0]},"+(s)te[V\u2192N]":{"exp":"+(s)te[V\u2192N]","exp_display":"+(s)te","description":"V-er; one who Vs as an occupation (with unpossessed ending);","singularDefinition":"who (or by occupation)","type":"VN","verbType":"i","pluralDefinition":"that (or by occupation)","match_case":false,"keylookup":["+(s)ta",0]},"@+tacir[V\u2192N]":{"exp":"@+tacir[V\u2192N]","exp_display":"@\xB2+tacir","description":"extent of possessor\u02BCs V-ing","singularDefinition":"extent of possessor's","type":"VN","verbType":"g","pluralDefinition":"extents of possessor's","match_case":false,"keylookup":["@+taciq",0]},"@:(u)tar\xB9[V\u2192N]":{"exp":"@%:(u)tar\xB9[V\u2192N]","exp_display":"@\xB3%:(u)tar","description":"device for V-ing","singularDefinition":"device for","type":"VN","verbType":"g","pluralDefinition":"devices for","match_case":false,"keylookup":["@:(u)taq\xB9",0]},"@+tate[V\u2192N]":{"exp":"@+tate[V\u2192N]","exp_display":"@\xB2+tate","description":"one that is V to the same extent as possessor","singularDefinition":"who is (to the same extent as possessor)","type":"VN","pluralDefinition":"that are (to the same extent as possessor)","match_case":false,"keylookup":["@+tata\u1D49",0]},"@:(u)tiir[V\u2192N]":{"exp":"@%:(u)tiir[V\u2192N]","exp_display":"@\xB3%:(u)tiir","description":"celebration of V-ing","singularDefinition":"celebration of","type":"VN","verbType":"g","pluralDefinition":"celebrations of","match_case":false,"keylookup":["@:(u)tiiq",0]},"~:(u)tnguarkar[V\u2192N]":{"exp":"~%:(u)tnguarkar[V\u2192N]","exp_display":"~%:(u)tnguarkar","description":"potential/necessary aid to V-ing","singularDefinition":"potential or necessary aid to","type":"VN","verbType":"g","pluralDefinition":"potential or necessary aids to","match_case":false,"keylookup":["~:(u)tnguarkaq",0]},"\u2013tuke[V\u2192N]":{"exp":"\u2013tuke[V\u2192N]","exp_display":"\u2013tuke","description":"possessor\u02BCs normal, regular, or customary one to V","singularDefinition":"possessor's regular or customary thing to","type":"VN","verbType":"i","pluralDefinition":"possessor's regular or customary things to","match_case":false,"keylookup":["-tuka\u1D49",0]},"\u2013tuli[V\u2192N]":{"exp":"\u2013tuli[V\u2192N]","exp_display":"\u2013tuli","description":"one that customarily Vs; one that is fully capable of V-ing","singularDefinition":"who is fully capable of","type":"VN","verbType":"g","pluralDefinition":"that are fully capable of","match_case":false,"keylookup":["+tuli,-tuli",1]},"+(ng)uar[V\u2192N]":{"exp":"+(ng)uar[V\u2192N]","exp_display":"+(ng)uar","description":"imitation N; inauthentic N; thing similar to or reminiscent of N; device for inauthentic V-ing","singularDefinition":"device for inauthentic","type":"VN","verbType":"g","pluralDefinition":"devices for inauthentic","match_case":false,"keylookup":["+(ng)uaq,@~+(ng)uar-",2]},"@~+vig[V\u2192N]":{"exp":"@~+vig[V\u2192N]","exp_display":"@\xB2~+vig","description":"place to V; place or time of V-ing","singularDefinition":"place to","type":"VN","verbType":"i","pluralDefinition":"places to","match_case":false,"keylookup":["@~+vik,+(r)vik",0]},"+(r)vig[V\u2192N]":{"exp":"+(r)vig[V\u2192N]","exp_display":"+(r)vig","description":"place for N","singularDefinition":"place for","type":"VN","verbType":"g","pluralDefinition":"places for","match_case":false,"keylookup":["@~+vik,+(r)vik",1]},"@~+yailkutar[V\u2192N]":{"exp":"@~+yailkutar[V\u2192N]","exp_display":"@\u02B8~+yailkutar","description":"device to prevent V-ing","singularDefinition":"device for preventing","type":"VN","verbType":"g","pluralDefinition":"devices for preventing","match_case":false,"keylookup":["@~+yailkutaq,@~+yailkun",0]},"@~+yailkute[V\u2192N]":{"exp":"@~+yailkute[V\u2192N]","exp_display":"@\u02B8~+yailkute","description":"device to prevent V-ing","singularDefinition":"device for preventing","type":"VN","verbType":"g","pluralDefinition":"devices for preventing","match_case":false,"keylookup":["@~+yailkutaq,@~+yailkun",1]},"+yag[V\u2192N]":{"exp":"+yag[V\u2192N]","exp_display":"+yag","description":"thing similar to N; thing that acts as if it were V; small N","singularDefinition":"thing that act as if it were","type":"VN","verbType":"g","pluralDefinition":"things that act as if they were","match_case":false,"keylookup":["+yak",1]},"@~+yaller[V\u2192N]":{"exp":"@~+yaller[V\u2192N]","exp_display":"@\u02B8~+yaller","description":"during the period of time when possessor is V-ing","singularDefinition":"period of time when possessor is","type":"VN","verbType":"g","pluralDefinition":"periods of time when possessor is","match_case":false,"keylookup":["@~+yalleq",0]},"@~+yarar[V\u2192N]":{"exp":"@~+yarar[V\u2192N]","exp_display":"@\u02B8~+yarar","description":"way of V-ing; how to V; method of V-ing; device for V-ing; way of or device for dealing with N","singularDefinition":"way of","type":"VN","verbType":"g","pluralDefinition":"ways of","match_case":false,"keylookup":["@~+yaraq",1]},"@~\u2013yuli[V\u2192N]":{"exp":"@~\u2013yuli[V\u2192N]","exp_display":"@\u02B8~\u2013yuli","description":"one who is good at V-ing: a proficient V-er","singularDefinition":"who is good at","type":"VN","verbType":"g","pluralDefinition":"that are good at","match_case":false,"keylookup":["@~-yuli",0]},"@~+yunqeggli[V\u2192N]":{"exp":"@~+yunqeggli[V\u2192N]","exp_display":"@\u02B8~+yunqeggli","description":"one who loves to V; an avid V-er","singularDefinition":"who loves to","type":"VN","verbType":"i","pluralDefinition":"that love to","match_case":false,"keylookup":["@~+yunqeggli",0]},"\u2013ar(ar*)[N\u2192N]":{"exp":"\u2013ar(ar*)[N\u2192N]","exp_display":"\u2013ar(ar*)","type":"NN","require":"singularize","singularDefinition":"little piece of","pluralDefinition":"little pieces of","postDefinition":"","description":"little piece of","match_case":false,"keylookup":["-ar(aq*)",0]},"\u2013ciller[N\u2192N]":{"exp":"\u2013ciller[N\u2192N]","exp_display":"\u2013ciller","type":"NN","require":"","singularDefinition":"worthless","pluralDefinition":"worthless","postDefinition":"","description":"worthless","match_case":true,"keylookup":["-cilleq",0]},"\u2013cuar(ar*)[N\u2192N]":{"exp":"\u2013cuar(ar*)[N\u2192N]","exp_display":"\u2013cuar(ar*)","type":"NN","require":"","singularDefinition":"small","pluralDefinition":"small","postDefinition":"","description":"small","match_case":true,"keylookup":["-cuar(aq*)",0]},"\u2013cug[N\u2192N]":{"exp":"\u2013cug[N\u2192N]","exp_display":"\u2013cug","type":"NN","require":"","singularDefinition":"unpleasing","pluralDefinition":"unpleasing","postDefinition":"","description":"unpleasing","match_case":true,"keylookup":["-cuk",0]},"\u2013cungar[N\u2192N]":{"exp":"\u2013cungar[N\u2192N]","exp_display":"\u2013cungar","type":"NN","require":"","singularDefinition":"cute little","pluralDefinition":"cute little","postDefinition":"","description":"cute little","match_case":true,"keylookup":["-cungaq",0]},":(ng)inar*[N\u2192N]":{"exp":"%:(ng)inar*[N\u2192N]","exp_display":"%:(ng)inar*","type":"NN","require":"","singularDefinition":"mere (and nothing more)","pluralDefinition":"mere (and nothing more)","postDefinition":"","description":"mere (and nothing more)","match_case":true,"keylookup":[":(ng)inaq*",0]},":(ng)i:rute[N\u2192N]":{"exp":"%:(ng)i%:rute[N\u2192N]","exp_display":"%:(ng)i%:rute","type":"NN","require":"","singularDefinition":"late (deceased)","pluralDefinition":"late (deceased)","postDefinition":"","description":"late (deceased)","match_case":true,"keylookup":[":(ng)i:run",0]},"\u2013kainer[N\u2192N]":{"exp":"\u2013kainer[N\u2192N]","exp_display":"\u2013kainer","type":"NN","require":"","singularDefinition":"little bit of","pluralDefinition":"little bits of","postDefinition":"","description":"little bit of","match_case":false,"keylookup":["-kaineq",0]},"+kar[N\u2192N]":{"exp":"+kar[N\u2192N]","exp_display":"+kar","type":"NN","require":"","singularDefinition":"future","pluralDefinition":"future","postDefinition":"","description":"future","match_case":true,"keylookup":["+kaq",0]},"@kar(ar*)\xB9[N\u2192N]":{"exp":"@kar(ar*)\xB9[N\u2192N]","exp_display":"@\u2075kar(ar*)","type":"NN","require":"","singularDefinition":"small","pluralDefinition":"small","postDefinition":"","description":"small","match_case":true,"keylookup":["@kar(aq*)\xB9",0]},"\u2013kcag[N\u2192N]":{"exp":"\u2013kcag[N\u2192N]","exp_display":"\u2013kcag","type":"NN","require":"singularize","singularDefinition":"thing that looks like a","pluralDefinition":"things that looks like a","postDefinition":"","description":"thing that looks like a","match_case":false,"keylookup":["-kcak",0]},"\u2013kcuar(ar*)[N\u2192N]":{"exp":"\u2013kcuar(ar*)[N\u2192N]","exp_display":"\u2013kcuar(ar*)","type":"NN","require":"","singularDefinition":"small","pluralDefinition":"small","postDefinition":"","description":"small","match_case":true,"keylookup":["-kcuar(aq*)",0]},"\u2013kegtaar(ar*)[N\u2192N]":{"exp":"\u2013kegtaar(ar*)[N\u2192N]","exp_display":"\u2013kegtaar(ar*)","type":"NN","require":"","singularDefinition":"good","pluralDefinition":"good","postDefinition":"","description":"good","match_case":true,"keylookup":["-kegtaar(aq*)",1]},"@\u2013ksagar[N\u2192N]":{"exp":"@\u2013ksagar[N\u2192N]","exp_display":"@\u2075\u2013ksagar","type":"NN","require":"","singularDefinition":"very ugly","pluralDefinition":"very ugly","postDefinition":"","description":"very ugly","match_case":true,"keylookup":["@-ksagaq",0]},"@ksuar(ar*)[N\u2192N]":{"exp":"@ksuar(ar*)[N\u2192N]","exp_display":"@\u2075ksuar(ar*)","type":"NN","require":"","singularDefinition":"small","pluralDefinition":"small","postDefinition":"","description":"small","match_case":true,"keylookup":["@ksuar(aq*)",0]},"+kuar[N\u2192N]":{"exp":"+kuar[N\u2192N]","exp_display":"+kuar","type":"NN","require":"","singularDefinition":"leftover","pluralDefinition":"leftover","postDefinition":"","description":"leftover","match_case":true,"keylookup":["+kuaq",0]},"\u2013kucir[N\u2192N]":{"exp":"\u2013kucir[N\u2192N]","exp_display":"\u2013kucir","type":"NN","require":"pluralize","singularDefinition":"of the same kind as","pluralDefinition":"of the same kind as","postDefinition":"","description":"of the same kind as","match_case":false,"keylookup":["-kuciq",1]},"\u2013kuiner(ar*)[N\u2192N]":{"exp":"\u2013kuiner(ar*)[N\u2192N]","exp_display":"\u2013kuiner(ar*)","type":"NN","require":"singularize","singularDefinition":"small amount of","pluralDefinition":"small amounts of","postDefinition":"","description":"small amount of","match_case":false,"keylookup":["-kuiner(aq*),-kuinr(aq*),-kuineq",0]},"\u2013kuinr(ar*)[N\u2192N]":{"exp":"\u2013kuinr(ar*)[N\u2192N]","exp_display":"\u2013kuinr(ar*)","type":"NN","require":"singularize","singularDefinition":"small amount of","pluralDefinition":"small amounts of","postDefinition":"","description":"small amount of","match_case":false,"keylookup":["-kuiner(aq*),-kuinr(aq*),-kuineq",1]},"\u2013kuiner[N\u2192N]":{"exp":"\u2013kuiner[N\u2192N]","exp_display":"\u2013kuiner","type":"NN","require":"singularize","singularDefinition":"small amount of","pluralDefinition":"small amounts of","postDefinition":"","description":"small amount of","match_case":false,"keylookup":["-kuiner(aq*),-kuinr(aq*),-kuineq",2]},"\u2013kutar[N\u2192N]":{"exp":"\u2013kutar[N\u2192N]","exp_display":"\u2013k\u0332utar","type":"NN","require":"pluralize","singularDefinition":"thing to be used as one would with","pluralDefinition":"things to be used as one would with","postDefinition":"","description":"thing to be used as one would with","match_case":false,"keylookup":["-kutaq,-kun",0]},"\u2013kute[N\u2192N]":{"exp":"\u2013kute[N\u2192N]","exp_display":"\u2013kute","type":"NN","require":"pluralize","singularDefinition":"thing to be used as one would with","pluralDefinition":"things to be used as one would with","postDefinition":"","description":"thing to be used as one would with","match_case":false,"keylookup":["-kutaq,-kun",1]},"\u2013kuyug[N\u2192N]":{"exp":"\u2013kuyug[N\u2192N]","exp_display":"\u2013kuyug","type":"NN","require":"singularize","singularDefinition":"small bit of","pluralDefinition":"small bits of","postDefinition":"","description":"small bit of","match_case":false,"keylookup":["-kuyuk,-kuyugaq",0]},"\u2013kuyugar[N\u2192N]":{"exp":"\u2013kuyugar[N\u2192N]","exp_display":"\u2013kuyugar","type":"NN","require":"singularize","singularDefinition":"small bit of","pluralDefinition":"small bits of","postDefinition":"","description":"small bit of","match_case":false,"keylookup":["-kuyuk,-kuyugaq",1]},"\u2013leg[N\u2192N]":{"exp":"\u2013leg[N\u2192N]","exp_display":"\u2013leg","type":"NN","require":"pluralize","singularDefinition":"with","pluralDefinition":"with","postDefinition":"","description":"with","match_case":false,"keylookup":["-lek",0]},"\u2013lgute[N\u2192N]":{"exp":"\u2013lgute[N\u2192N]","exp_display":"\u2013lgute","type":"NN","require":"pluralize","singularDefinition":"sharer of","pluralDefinition":"sharers of","postDefinition":"","description":"sharer of","match_case":false,"keylookup":["-lgun",0]},"+li\xB9[N\u2192N]":{"exp":"+li\xB9[N\u2192N]","exp_display":"+li","type":"NN","require":"pluralize","singularDefinition":"similar to","pluralDefinition":"similar to","postDefinition":"","description":"similar to","match_case":true,"keylookup":["+li\xB9,+liq",0]},"+lir[N\u2192N]":{"exp":"+lir[N\u2192N]","exp_display":"+lir","type":"NN","require":"pluralize","singularDefinition":"similar to","pluralDefinition":"similar to","postDefinition":"","description":"similar to","match_case":true,"keylookup":["+li\xB9,+liq",1]},"\u2013\u2013liar[N\u2192N]":{"exp":"\u2013\u2013liar[N\u2192N]","exp_display":"\u2013\u2013liar","type":"NN","require":"","singularDefinition":"made","pluralDefinition":"made","postDefinition":"","description":"made","match_case":true,"keylookup":["-liaq",0]},"\u2013\u2013linrar*[N\u2192N]":{"exp":"\u2013\u2013linrar*[N\u2192N]","exp_display":"\u2013\u2013linrar*","type":"NN","require":"singularize","singularDefinition":"product of","pluralDefinition":"products of","postDefinition":"","description":"product of","match_case":false,"keylookup":["-linraq*,-linr(aq*)",0]},"\u2013\u2013linr(ar*)[N\u2192N]":{"exp":"\u2013\u2013linr(ar*)[N\u2192N]","exp_display":"\u2013\u2013linr(ar*)","type":"NN","require":"singularize","singularDefinition":"product of","pluralDefinition":"products of","postDefinition":"","description":"product of","match_case":false,"keylookup":["-linraq*,-linr(aq*)",1]},"\u2013lkug[N\u2192N]":{"exp":"\u2013lkug[N\u2192N]","exp_display":"\u2013lkug","type":"NN","require":"","singularDefinition":"no-good","pluralDefinition":"no-good","postDefinition":"","description":"no-good","match_case":true,"keylookup":["-lkuk,-lkug-",0]},"\u2013llar*[N\u2192N]":{"exp":"\u2013llar*[N\u2192N]","exp_display":"\u2013llar*","type":"NN","require":"","singularDefinition":"","pluralDefinition":"","postDefinition":"(with reference to the past)","description":"(with reference to the past)","match_case":false,"keylookup":["-llaq*",0]},"\u2013ller(ar*)[N\u2192N]":{"exp":"\u2013ller(ar*)[N\u2192N]","exp_display":"\u2013ller(ar*)","type":"NN","require":"","singularDefinition":"shabby old","pluralDefinition":"shabby old","postDefinition":"","description":"shabby old","match_case":true,"keylookup":["-ller(aq*)",0]},"@\u2013llug[N\u2192N]":{"exp":"@\u2013llug[N\u2192N]","exp_display":"@\u2075\u2013llug","type":"NN","require":"","singularDefinition":"bad","pluralDefinition":"bad","postDefinition":"","description":"bad","match_case":true,"keylookup":["@-lluk,-llug-,-llugte-",0]},"\u2013lqur[N\u2192N]":{"exp":"\u2013lqur[N\u2192N]","exp_display":"\u2013lqur","type":"NN","require":"singularize","singularDefinition":"old broken piece of","pluralDefinition":"old broken pieces of","postDefinition":"","description":"old broken piece of","match_case":false,"keylookup":["-lquq",0]},"\u2013luatar[N\u2192N]":{"exp":"\u2013luatar[N\u2192N]","exp_display":"\u2013luatar","type":"NN","require":"","singularDefinition":"good","pluralDefinition":"good","postDefinition":"","description":"good","match_case":true,"keylookup":["-luataq,-luatar-",0]},"\u2013lugpiar[N\u2192N]":{"exp":"\u2013lugpiar[N\u2192N]","exp_display":"\u2013lugpiar","type":"NN","require":"","singularDefinition":"original","pluralDefinition":"original","postDefinition":"","description":"original","match_case":true,"keylookup":["-lugpiaq",0]},"+mig[N\u2192N]":{"exp":"+mig[N\u2192N]","exp_display":"+mig","type":"NN","require":"singularize","singularDefinition":"thing held in ^one's^","pluralDefinition":"things held in ^one's^","postDefinition":"","description":"thing held in ^one's^","match_case":false,"keylookup":["+mik,+miaq,+mig-",0]},"+miar[N\u2192N]":{"exp":"+miar[N\u2192N]","exp_display":"+miar","type":"NN","require":"singularize","singularDefinition":"thing held in ^one's^","pluralDefinition":"things held in ^one's^","postDefinition":"","description":"thing held in ^one's^","match_case":false,"keylookup":["+mik,+miaq,+mig-",1]},"~+miu[N\u2192N]":{"exp":"~+miu[N\u2192N]","exp_display":"~+miu","type":"NN","require":"singularize","singularDefinition":"inhabitant of","pluralDefinition":"inhabitants of","postDefinition":"","description":"inhabitant of","match_case":false,"keylookup":["~+miu",0]},"~+miutar*[N\u2192N]":{"exp":"~+miutar*[N\u2192N]","exp_display":"~+miutar*","type":"NN","require":"singularize","singularDefinition":"whose place is","pluralDefinition":"whose place is","postDefinition":"","description":"whose place is","match_case":false,"keylookup":["~+miutaq*",0]},"+ner\u2074[N\u2192N]":{"exp":"+ner\u2074[N\u2192N]","exp_display":"+ner","type":"NN","require":"singularize","singularDefinition":"area of","pluralDefinition":"areas of","postDefinition":"","description":"area of","match_case":false,"keylookup":["+neq\u2074",0]},"\u2013nerrar*[N\u2192N]":{"exp":"\u2013nerrar*[N\u2192N]","exp_display":"\u2013nerrar*","type":"NN","require":"","singularDefinition":"new","pluralDefinition":"new","postDefinition":"","description":"new","match_case":true,"keylookup":["-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",0]},"\u2013nerrar(ar*)[N\u2192N]":{"exp":"\u2013nerrar(ar*)[N\u2192N]","exp_display":"\u2013nerrar(ar*)","type":"NN","require":"","singularDefinition":"new","pluralDefinition":"new","postDefinition":"","description":"new","match_case":true,"keylookup":["-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",1]},"\u2013nerar(ar*)[N\u2192N]":{"exp":"\u2013nerar(ar*)[N\u2192N]","exp_display":"\u2013nerar(ar*)","type":"NN","require":"","singularDefinition":"new","pluralDefinition":"new","postDefinition":"","description":"new","match_case":true,"keylookup":["-nerraq*,-nerrar(aq*),-nerar(aq*),-nerrar-,-nerrar(ar)-,-nerar(ar)-",2]},"\u2013ngirta'rrlugar*[N\u2192N]":{"exp":"\u2013ngirta'rrlugar*[N\u2192N]","exp_display":"\u2013ngirta'rrlugar*","type":"NN","require":"","singularDefinition":"good old (but perhaps decrepit)","pluralDefinition":"good old (but perhaps decrepit)","postDefinition":"","description":"good old (but perhaps decrepit)","match_case":true,"keylookup":["-ngirta'rrlugaq*",0]},"\u2013ngnagar[N\u2192N]":{"exp":"\u2013ngnagar[N\u2192N]","exp_display":"\u2013ngnagar","type":"NN","require":"","singularDefinition":"poor quality","pluralDefinition":"poor quality","postDefinition":"","description":"poor quality","match_case":true,"keylookup":["-ngnagaq,-ngnagar-",0]},"\u2013ngssaar(ar*)[N\u2192N]":{"exp":"\u2013ngssaar(ar*)[N\u2192N]","exp_display":"\u2013ngssaar(ar*)","type":"NN","require":"","singularDefinition":"secret","pluralDefinition":"secret","postDefinition":"","description":"secret","match_case":true,"keylookup":["-ngssaar(aq*),-ngssaar(ar)-",0]},"\u2013nguar[N\u2192N]":{"exp":"\u2013nguar[N\u2192N]","exp_display":"\u2013nguar","type":"NN","require":"","singularDefinition":"fake","pluralDefinition":"fake","postDefinition":"","description":"fake","match_case":true,"keylookup":["-nguaq,@~-nguar-",0]},"\u2013ngyaar(ar*)[N\u2192N]":{"exp":"\u2013ngyaar(ar*)[N\u2192N]","exp_display":"\u2013ngyaar(ar*)","type":"NN","require":"","singularDefinition":"old (person)","pluralDefinition":"old (person)","postDefinition":"","description":"old (person)","match_case":true,"keylookup":["-ngyaar(aq*),-ngiar(aq*)",0]},"\u2013ngiar(ar*)[N\u2192N]":{"exp":"\u2013ngiar(ar*)[N\u2192N]","exp_display":"\u2013ngiar(ar*)","type":"NN","require":"","singularDefinition":"old (person)","pluralDefinition":"old (person)","postDefinition":"","description":"old (person)","match_case":true,"keylookup":["-ngyaar(aq*),-ngiar(aq*)",1]},"+nir\xB2[N\u2192N]":{"exp":"+nir\xB2[N\u2192N]","exp_display":"+nir","type":"NN","require":"singularize","singularDefinition":"smell of","pluralDefinition":"smells of","postDefinition":"","description":"smell of","match_case":false,"keylookup":["+niq\xB2",0]},"\u2013paarrlug[N\u2192N]":{"exp":"\u2013paarrlug[N\u2192N]","exp_display":"\u2013paarrlug","type":"NN","require":"","singularDefinition":"big","pluralDefinition":"big","postDefinition":"","description":"big","match_case":true,"keylookup":["-paarrluk",0]},"\u2013pig\xB9[N\u2192N]":{"exp":"\u2013pig\xB9[N\u2192N]","exp_display":"\u2013pig","type":"NN","require":"","singularDefinition":"genuine","pluralDefinition":"genuine","postDefinition":"","description":"genuine","match_case":true,"keylookup":["-pik\xB9,-piaq,-pigaq,-pig-,-piar-,-pigar-",0]},"\u2013piar[N\u2192N]":{"exp":"\u2013piar[N\u2192N]","exp_display":"\u2013piar","type":"NN","require":"","singularDefinition":"genuine","pluralDefinition":"genuine","postDefinition":"","description":"genuine","match_case":true,"keylookup":["-pik\xB9,-piaq,-pigaq,-pig-,-piar-,-pigar-",1]},"\u2013pigar[N\u2192N]":{"exp":"\u2013pigar[N\u2192N]","exp_display":"\u2013pigar","type":"NN","require":"","singularDefinition":"genuine","pluralDefinition":"genuine","postDefinition":"","description":"genuine","match_case":true,"keylookup":["-pik\xB9,-piaq,-pigaq,-pig-,-piar-,-pigar-",2]},"\u2013qainar[N\u2192N]":{"exp":"\u2013qainar[N\u2192N]","exp_display":"\u2013q\u0332ainar","type":"NN","require":"","singularDefinition":"mere","pluralDefinition":"mere","postDefinition":"","description":"mere","match_case":true,"keylookup":["-qainaq,-qainar-",0]},"\u2013qtar*[N\u2192N]":{"exp":"\u2013qtar*[N\u2192N]","exp_display":"\u2013q\u0332tar*","type":"NN","require":"","singularDefinition":"weak helpless","pluralDefinition":"weak helpless","postDefinition":"","description":"weak helpless","match_case":true,"keylookup":["-qtaq*,-qtar-",0]},"\u2013qva[N\u2192N]":{"exp":"\u2013qva[N\u2192N]","exp_display":"\u2013q\u0332va","type":"NN","require":"singularize","singularDefinition":"area far in the direction of","pluralDefinition":"areas far in the direction of","postDefinition":"","description":"area far in the direction of","match_case":false,"keylookup":["-qva",2]},"\u2013qvaar*[N\u2192N]":{"exp":"\u2013qvaar*[N\u2192N]","exp_display":"\u2013q\u0332vaar*","type":"NN","require":"singularize","singularDefinition":"area far in the direction of","pluralDefinition":"areas far in the direction of","postDefinition":"","description":"area far in the direction of","match_case":false,"keylookup":["-qvaaq*",2]},"\u2013r'aya'ar[N\u2192N]":{"exp":"\u2013r'aya'ar[N\u2192N]","exp_display":"\u2013r\u0332'aya'ar","type":"NN","require":"pluralize","singularDefinition":"multitude of","pluralDefinition":"multitudes of","postDefinition":"","description":"multitude of","match_case":false,"keylookup":["-r'aya'aq",0]},"\u2013rpaa(ar*)[N\u2192N]":{"exp":"\u2013rpaa(ar*)[N\u2192N]","exp_display":"\u2013r\u0332paa(ar*)","type":"NN","require":"","singularDefinition":"great","pluralDefinition":"great","postDefinition":"","description":"great","match_case":true,"keylookup":["-rpaa(aq*)",0]},"\u2013rpag|@vag[N\u2192N]":{"exp":"\u2013rpag|@vag[N\u2192N]","exp_display":"\u2013r\u0332pag|@\xB2vag","type":"NN","require":"","singularDefinition":"large","pluralDefinition":"large","postDefinition":"","description":"large","match_case":true,"keylookup":["@vak|?vak",0]},"\u2013rpallr(ar*)[N\u2192N]":{"exp":"\u2013rpallr(ar*)[N\u2192N]","exp_display":"\u2013r\u0332pallr(ar*)","type":"NN","require":"","singularDefinition":"very large","pluralDefinition":"very large","postDefinition":"","description":"very large","match_case":true,"keylookup":["-rpallr(aq*)",0]},"\u2013rrar*[N\u2192N]":{"exp":"\u2013rrar*[N\u2192N]","exp_display":"\u2013r\u0332r\u0332ar*","type":"NN","require":"singularize","singularDefinition":"little bit of","pluralDefinition":"little bits of","postDefinition":"","description":"little bit of","match_case":false,"keylookup":["-rraq*,-rrar-",2]},"\u2013rrlainar*[N\u2192N]":{"exp":"\u2013rrlainar*[N\u2192N]","exp_display":"\u2013r\u0332r\u0332lainar*","type":"NN","require":"pluralize","singularDefinition":"area with nothing but","pluralDefinition":"areas with nothing but","postDefinition":"","description":"area with nothing but","match_case":false,"keylookup":["-rrlainaq*,-rrlainar-",0]},"\u2013rrlugar*[N\u2192N]":{"exp":"\u2013rrlugar*[N\u2192N]","exp_display":"\u2013r\u0332r\u0332lugar*","type":"NN","require":"","singularDefinition":"good old","pluralDefinition":"good old","postDefinition":"","description":"good old","match_case":true,"keylookup":["-rrlugaq*",0]},"\u2013rrlug[N\u2192N]":{"exp":"\u2013rrlug[N\u2192N]","exp_display":"\u2013r\u0332r\u0332lug","type":"NN","require":"","singularDefinition":"","pluralDefinition":"","postDefinition":"that departed from a natural state (often undesirably)","description":"that departed from a natural state (often undesirably)","match_case":false,"keylookup":["-rrluk,-rrlug-,-rrlugte-",0]},"\u2013rugar*[N\u2192N]":{"exp":"\u2013rugar*[N\u2192N]","exp_display":"\u2013r\u0332ugar*","type":"NN","require":"pluralize","singularDefinition":"multitudes of","pluralDefinition":"multitudes of","postDefinition":"","description":"multitudes of","match_case":false,"keylookup":["-rugaq*",0]},"\u2013r(ur)lur*[N\u2192N]":{"exp":"\u2013r(ur)lur*[N\u2192N]","exp_display":"\u2013r\u0332(ur)lur*","type":"NN","require":"","singularDefinition":"poor dear","pluralDefinition":"poor dear","postDefinition":"","description":"poor dear","match_case":true,"keylookup":["-r(ur)luq*,-q(ur)lur-",3]},"\u2013ssaarar[N\u2192N]":{"exp":"\u2013ssaarar[N\u2192N]","exp_display":"\u2013ssaarar","type":"NN","require":"","singularDefinition":"old","pluralDefinition":"old","postDefinition":"","description":"old","match_case":true,"keylookup":["-ssaaraq",0]},"+taleg[N\u2192N]":{"exp":"+taleg[N\u2192N]","exp_display":"+taleg","type":"NN","require":"pluralize","singularDefinition":"place having","pluralDefinition":"places having","postDefinition":"","description":"place having","match_case":false,"keylookup":["+talek",0]},"+tar\xB2[N\u2192N]":{"exp":"+tar\xB2[N\u2192N]","exp_display":"+tar","type":"NN","require":"pluralize","singularDefinition":"thing pertaining to","pluralDefinition":"things pertaining to","postDefinition":"","description":"thing pertaining to","match_case":false,"keylookup":["+taq\xB2",0]},"+tar\xB3[N\u2192N]":{"exp":"+tar\xB3[N\u2192N]","exp_display":"+tar","type":"NN","require":"","singularDefinition":"caught (game animal)","pluralDefinition":"caught (game animals)","postDefinition":"","description":"caught (game animal)","match_case":false,"keylookup":["+taq\xB3",0]},"+tar\u2075[N\u2192N]":{"exp":"+tar\u2075[N\u2192N]","exp_display":"+tar","type":"NN","require":"","singularDefinition":"","pluralDefinition":"","postDefinition":"specifically","description":"specifically","match_case":false,"keylookup":["+taq\u2075",0]},"+tuli[N\u2192N]":{"exp":"+tuli[N\u2192N]","exp_display":"+tuli","type":"NN","require":"pluralize","singularDefinition":"well endowed with","pluralDefinition":"well endowed with","postDefinition":"","description":"well endowed with","match_case":false,"keylookup":["+tuli,-tuli",0]},"+(ng)uar[N\u2192N]":{"exp":"+(ng)uar[N\u2192N]","exp_display":"+(ng)uar","type":"NN","require":"","singularDefinition":"imitation","pluralDefinition":"imitation","postDefinition":"","description":"imitation","match_case":true,"keylookup":["+(ng)uaq,@~+(ng)uar-",0]},":(ng)ute[N\u2192N]":{"exp":"%:(ng)ute[N\u2192N]","exp_display":"%:(ng)ute","type":"NN","require":"pluralize","singularDefinition":"supply of","pluralDefinition":"supplies of","postDefinition":"","description":"supply of","match_case":false,"keylookup":[":(ng)un,:~(ng)un",0]},":~(ng)ute[N\u2192N]":{"exp":"%:~(ng)ute[N\u2192N]","exp_display":"%:~(ng)ute","type":"NN","require":"pluralize","singularDefinition":"supply of","pluralDefinition":"supplies of","postDefinition":"","description":"supply of","match_case":false,"keylookup":[":(ng)un,:~(ng)un",1]},":(ng)uteller[N\u2192N]":{"exp":"%:(ng)uteller[N\u2192N]","exp_display":"%:(ng)uteller","type":"NN","require":"pluralize","singularDefinition":"empty container that held","pluralDefinition":"empty containers that held","postDefinition":"","description":"empty container that held","match_case":false,"keylookup":[":(ng)utelleq,:~(ng)utelleq",0]},":~(ng)uteller[N\u2192N]":{"exp":"%:~(ng)uteller[N\u2192N]","exp_display":"%:~(ng)uteller","type":"NN","require":"pluralize","singularDefinition":"empty container that held","pluralDefinition":"empty containers that held","postDefinition":"","description":"empty container that held","match_case":false,"keylookup":[":(ng)utelleq,:~(ng)utelleq",1]},"\u2013vaarrlug[N\u2192N]":{"exp":"\u2013vaarrlug[N\u2192N]","exp_display":"\u2013vaarrlug","type":"NN","require":"","singularDefinition":"big","pluralDefinition":"big","postDefinition":"","description":"big","match_case":true,"keylookup":["-vaarrluk",0]},"\u2013vialug[N\u2192N]":{"exp":"\u2013vialug[N\u2192N]","exp_display":"\u2013vialug","type":"NN","require":"","singularDefinition":"shabby","pluralDefinition":"shabby","postDefinition":"","description":"shabby","match_case":true,"keylookup":["-vialuk,-vialug-",0]},"@~+viutar[N\u2192N]":{"exp":"@~+viutar[N\u2192N]","exp_display":"@\xB2~+viutar","type":"NN","require":"pluralize","singularDefinition":"container for","pluralDefinition":"containers for","postDefinition":"","description":"container for","match_case":false,"keylookup":["@~+viutaq",0]},"\u2013ya(g)ar*[N\u2192N]":{"exp":"\u2013ya(g)ar*[N\u2192N]","exp_display":"\u2013ya\u0121ar*","type":"NN","require":"","singularDefinition":"baby or little","pluralDefinition":"baby or little","postDefinition":"","description":"baby or little","match_case":true,"keylookup":["-ya(g)aq*,-yagaq*,-ya(g)ar-,-yagar-",0]},"\u2013yagar*[N\u2192N]":{"exp":"\u2013yagar*[N\u2192N]","exp_display":"\u2013yagar*","type":"NN","require":"","singularDefinition":"baby or little","pluralDefinition":"baby or little","postDefinition":"","description":"baby or little","match_case":true,"keylookup":["-ya(g)aq*,-yagaq*,-ya(g)ar-,-yagar-",1]},"+yag[N\u2192N]":{"exp":"+yag[N\u2192N]","exp_display":"+yag","type":"NN","require":"pluralize","singularDefinition":"thing similar to","pluralDefinition":"things similar to","postDefinition":"","description":"thing similar to","match_case":false,"keylookup":["+yak",0]},"@~+yarar[N\u2192N]":{"exp":"@~+yarar[N\u2192N]","exp_display":"@\u02B8~+yarar","type":"NN","require":"pluralize","singularDefinition":"way of or device dealing with","pluralDefinition":"ways of or devices dealing with","postDefinition":"","description":"way of or device dealing with","match_case":false,"keylookup":["@~+yaraq",0]},"\u2013yaya(g)ar*[N\u2192N]":{"exp":"\u2013yaya(g)ar*[N\u2192N]","exp_display":"\u2013yaya\u0121ar*","type":"NN","require":"","singularDefinition":"little baby","pluralDefinition":"little baby","postDefinition":"","description":"little baby","match_case":true,"keylookup":["-yaya(g)aq*",0]},"@~+ngari[N\u2192V]":{"type":"NV","exp":"@~+ngari[N\u2192V]","exp_display":"@\xB2~+ngari","description":"to seem to be becoming V; to begin to be like N","subjectit":"it","is":true,"gen_prenoun":"beginning to be like","nounNum":"as","present":"begins to be like","was":false,"past":"began to be like","inf_prenoun":"begin to be like","ger_prenoun":"beginning to be like","match_case":false,"keylookup":["@~+ngari-",0]},"+`(g)ar(ar)[N\u2192V]":{"type":"NV","exp":"+`(g)ar(ar)[N\u2192V]","exp_display":"+`(g)ar(ar)","description":"to go only by V-ing or only with N (which is barely adequate for conditions)","subjectit":"it","is":true,"gen_prenoun":"going only with","nounNum":"p","present":"goes only with","was":false,"past":"went only with","inf_prenoun":"go only with","ger_prenoun":"going only with","match_case":false,"keylookup":["+'(g)ar(ar)-",0]},"+arar(ar)[N\u2192V]":{"type":"NV","exp":"+arar(ar)[N\u2192V]","exp_display":"+arar(ar)","description":"to go only by V-ing or only with N (which is barely adequate for conditions)","subjectit":"it","is":true,"gen_prenoun":"going only with","nounNum":"p","present":"goes only with","was":false,"past":"went only with","inf_prenoun":"go only with","ger_prenoun":"going only with","match_case":false,"keylookup":["+'(g)ar(ar)-",1]},":(ng)ar(ar)te\xB2[N\u2192V]":{"type":"NV","exp":"%:(ng)ar(ar)te\xB2[N\u2192V]","exp_display":"%:(ng)ar(ar)te","description":"to hit or get hit in or on one\u02BCs N","subjectit":"it","is":false,"gen_prenoun":"got hit on ^its^","nounNum":"p","present":"gets hit on ^its^","was":false,"past":"got hit on ^its^","inf_prenoun":"get hit on ^its^","ger_prenoun":"getting hit on ^its^","match_case":false,"keylookup":[":(ng)ar(ar)te\xB2-",0]},"\u2013car(ar)te[N\u2192V]":{"type":"NV","exp":"\u2013car(ar)te[N\u2192V]","exp_display":"\u2013car(ar)te","description":"to hit in or on the N, to hit right in or on the N","subjectit":"it","is":false,"gen_prenoun":"got hit on ^its^","nounNum":"p","present":"gets hit on ^its^","was":false,"past":"got hit on ^its^","inf_prenoun":"get hit on ^its^","ger_prenoun":"getting hit on ^its^","match_case":false,"keylookup":["-car(ar)te-",0]},"+ci[N\u2192V]":{"type":"NV","exp":"+ci[N\u2192V]","exp_display":"+ci","description":"to buy (some) N","subjectit":"it","is":true,"gen_prenoun":"buying some","nounNum":"p","present":"buys some","was":false,"past":"bought some","inf_prenoun":"buy some","ger_prenoun":"buying some","match_case":false,"keylookup":["+ci-",0]},"+cite\xB2[N\u2192V]":{"type":"NV","exp":"+cite\xB2[N\u2192V]","exp_display":"+cite\xB0","description":"to have the quality of V or N","subjectit":"it","is":false,"gen_prenoun":"has the quality of","nounNum":"p","present":"has the quality of","was":false,"past":"had the quality of","inf_prenoun":"have the quality of","ger_prenoun":"having the quality of","match_case":false,"keylookup":["+cite\xB2-",0]},"@\u2013ckegg[N\u2192V]":{"type":"NV","exp":"@\u2013ckegg[N\u2192V]","exp_display":"@\u2075\u2013ckegg","description":"to be very V, to have good N","subjectit":"it","is":false,"gen_prenoun":"has good","nounNum":"p","present":"has good","was":false,"past":"had good","inf_prenoun":"have good","ger_prenoun":"having good","match_case":false,"keylookup":["@-ckegg-",0]},"+cugninarqe[N\u2192V]":{"type":"NV","exp":"+cugninarqe[N\u2192V]","exp_display":"+cugninarqe","description":"(Y form) to smell or taste like N","subjectit":"it","is":false,"gen_prenoun":"smells or tastes like","nounNum":"p","present":"smells or tastes like","was":false,"past":"smelled or tasted like","inf_prenoun":"smell or taste like","ger_prenoun":"smelling or tasting like","match_case":false,"keylookup":["+cugninarqe-,+cugnilarqe-,-cugninarqe-",0]},"+cugnilarqe[N\u2192V]":{"type":"NV","exp":"+cugnilarqe[N\u2192V]","exp_display":"+cugnilarqe","description":"(NUN, NSU form) to smell or taste like N","subjectit":"it","is":false,"gen_prenoun":"smells or tastes like","nounNum":"p","present":"smells or tastes like","was":false,"past":"smelled or tasted like","inf_prenoun":"smell or taste like","ger_prenoun":"smelling or tasting like","match_case":false,"keylookup":["+cugninarqe-,+cugnilarqe-,-cugninarqe-",1]},"\u2013cugninarqe[N\u2192V]":{"type":"NV","exp":"\u2013cugninarqe[N\u2192V]","exp_display":"\u2013cugninarqe","description":"(K form) to smell or taste like N","subjectit":"it","is":false,"gen_prenoun":"smells or tastes like","nounNum":"p","present":"smells or tastes like","was":false,"past":"smelled or tasted like","inf_prenoun":"smell or taste like","ger_prenoun":"smelling or tasting like","match_case":false,"keylookup":["+cugninarqe-,+cugnilarqe-,-cugninarqe-",2]},"+cugnite[N\u2192V]":{"type":"NV","exp":"+cugnite[N\u2192V]","exp_display":"+cugnite\xB0","description":"to smell or taste like N","subjectit":"it","is":false,"gen_prenoun":"smells or tastes like","nounNum":"p","present":"smells or tastes like","was":false,"past":"smelled or tasted like","inf_prenoun":"smell or taste like","ger_prenoun":"smelling or tasting like","match_case":false,"keylookup":["+cugnite-",0]},"\u2013culngu[N\u2192V]":{"type":"NV","exp":"\u2013culngu[N\u2192V]","exp_display":"\u2013culngu","description":"to be indisposed with respect to one\u02BCs N; to have trouble V-ing","subjectit":"it","is":true,"gen_prenoun":"unwell or unwilling with respect to ^its^","nounNum":"p","present":"unwell or unwilling with respect to ^its^","was":true,"past":"unwell or unwilling with respect to ^its^","inf_prenoun":"be unwell or unwilling with respect to ^its^","ger_prenoun":"being unwell or unwilling with respect to ^its^","match_case":false,"keylookup":["-culngu-",0]},"+cur|+ssur[N\u2192V]":{"type":"NV","exp":"+cur|+ssur[N\u2192V]","exp_display":"+c|.ssur","description":"to hunt N; to seek N; to check N (game-catching implement)","subjectit":"it","is":true,"gen_prenoun":"hunting","nounNum":"p","present":"hunts","was":false,"past":"hunted","inf_prenoun":"hunt","ger_prenoun":"hunting","match_case":false,"keylookup":["+cur-|+ssur-",0]},":(ng)icag[N\u2192V]":{"type":"NV","exp":"%:(ng)icag[N\u2192V]","exp_display":"%:(ng)icag","description":"to be in need of N; to lack N","subjectit":"it","is":true,"gen_prenoun":"in need of","nounNum":"p","present":"in need of","was":true,"past":"in need of","inf_prenoun":"be in need of","ger_prenoun":"being in need of","match_case":false,"keylookup":[":(ng)icag-",0]},":(ng)illiqe[N\u2192V]":{"type":"NV","exp":"%:(ng)illiqe[N\u2192V]","exp_display":"%:(ng)illiqe","description":"to suffer from the lack of N or V","subjectit":"it","is":true,"gen_prenoun":"suffering from the lack of","nounNum":"p","present":"suffers from the lack of","was":false,"past":"suffered from the lack of","inf_prenoun":"suffer from the lack of","ger_prenoun":"suffering from the lack of","match_case":false,"keylookup":[":(ng)illiqe-",0]},"\u2013ir\xB9[N\u2192V]":{"type":"NV","exp":"\u2013ir\xB9[N\u2192V]","exp_display":"\u2013ir","description":"N (natural phenomenon) is occurring; to set N (game capturing device); to provide or be provided with N (but not in the sense of giving N to someone)","subjectit":"it","is":true,"gen_prenoun":"provided with","nounNum":"p","present":"provided with","was":true,"past":"provided with","inf_prenoun":"be provided with","ger_prenoun":"being provided with","match_case":false,"keylookup":["-ir\xB9-",0]},":(ng)ir\xB2[N\u2192V]":{"type":"NV","exp":"%:(ng)ir\xB2[N\u2192V]","exp_display":"%:(ng)ir","description":"to deprive or be deprived of N; to remove N from; to un-V; to pass through the N area of (it)","subjectit":"it","is":true,"gen_prenoun":"deprived of","nounNum":"s","present":"deprived of","was":true,"past":"deprived of","inf_prenoun":"be deprived of","ger_prenoun":"being deprived of","match_case":false,"keylookup":[":(ng)ir\xB2-",2]},":(ng)ir(ar)[N\u2192V]":{"type":"NV","exp":"%:(ng)ir(ar)[N\u2192V]","exp_display":"%:(ng)ir(ar)","description":"to have cold N","subjectit":"it","is":false,"gen_prenoun":"has cold","nounNum":"p","present":"has cold","was":false,"past":"had cold","inf_prenoun":"have cold","ger_prenoun":"having cold","match_case":false,"keylookup":[":(ng)ir(ar)-",0]},":(ng)ir(ar)te[N\u2192V]":{"type":"NV","exp":"%:(ng)ir(ar)te[N\u2192V]","exp_display":"%:(ng)ir(ar)te","description":"to injure or be injured in one\u02BCs N; to abrubtly cease V-ing","subjectit":"it","is":true,"gen_prenoun":"injured in ^its^","nounNum":"p","present":"injured in ^its^","was":true,"past":"injured in ^its^","inf_prenoun":"be injured in ^its^","ger_prenoun":"being injured in ^its^","match_case":false,"keylookup":[":(ng)ir(ar)te-",0]},":(ng)i:rute[N\u2192V]":{"type":"NV","exp":"%:(ng)i%:rute[N\u2192V]","exp_display":"%:(ng)i%:rute","description":"to not have N any more; to no longer be V (adjectival verbs only)","subjectit":"it","is":false,"gen_prenoun":"no longer has","nounNum":"p","present":"no longer has","was":false,"past":"no longer had","inf_prenoun":"no longer have","ger_prenoun":"no longer having","match_case":false,"keylookup":[":(ng)i:rute-",0]},":(ng)ite\xB9[N\u2192V]":{"type":"NV","exp":"%:(ng)ite\xB9[N\u2192V]","exp_display":"%:(ng)ite\xB0","description":"to lack N or V; to have no N or V","subjectit":"it","is":true,"gen_prenoun":"lacking","nounNum":"p","present":"lacks","was":false,"past":"lacked","inf_prenoun":"lack","ger_prenoun":"lacking","match_case":false,"keylookup":[":(ng)ite\xB9-",0]},"+karci[N\u2192V]":{"type":"NV","exp":"+karci[N\u2192V]","exp_display":"+karci","description":"to buy something to serve as one\u02BCs N","subjectit":"it","is":true,"gen_prenoun":"buying something to serve as ^its^","nounNum":"s","present":"buys something to serve as ^its^","was":false,"past":"bought something to serve as ^its^","inf_prenoun":"buy something to serve as ^its^","ger_prenoun":"buying something to serve as ^its^","match_case":false,"keylookup":["+karci-",0]},"\u2013kegci[N\u2192V]":{"type":"NV","exp":"\u2013kegci[N\u2192V]","exp_display":"\u2013kegci","description":"to have good N","subjectit":"it","is":false,"gen_prenoun":"has good","nounNum":"p","present":"has good","was":false,"past":"had good","inf_prenoun":"have good","ger_prenoun":"having good","match_case":false,"keylookup":["-kegci-",1]},"\u2013kegte[N\u2192V]":{"type":"NV","exp":"\u2013kegte[N\u2192V]","exp_display":"\u2013k\u0332egte","description":"to be good N; to have good N","subjectit":"it","is":false,"gen_prenoun":"has good","nounNum":"p","present":"has good","was":false,"past":"had good","inf_prenoun":"have good","ger_prenoun":"having good","match_case":false,"keylookup":["-kegte-",0]},"\u2013kiirar[N\u2192V]":{"type":"NV","exp":"\u2013kiirar[N\u2192V]","exp_display":"\u2013kiirar","description":"to be in (water, mud, tall grass, body part, etc.) up to one\u02BCs N","subjectit":"it","is":true,"gen_prenoun":"in (water, mud, tall grass, body part, etc.) up to ^its^","nounNum":"s","present":"in (water, mud, tall grass, body part, etc.) up to ^its^","was":true,"past":"in (water, mud, tall grass, body part, etc.) up to ^its^","inf_prenoun":"be in (water, mud, tall grass, body part, etc.) up to ^its^","ger_prenoun":"being in (water, mud, tall grass, body part, etc.) up to ^its^","match_case":false,"keylookup":["-kiirar-,-kiir(ar)-,-kaar-",0]},"\u2013kiir(ar)[N\u2192V]":{"type":"NV","exp":"\u2013kiir(ar)[N\u2192V]","exp_display":"\u2013kiir(ar)","description":"to be in (water, mud, tall grass, body part, etc.) up to one\u02BCs N","subjectit":"it","is":true,"gen_prenoun":"in (water, mud, tall grass, body part, etc.) up to ^its^","nounNum":"s","present":"in (water, mud, tall grass, body part, etc.) up to ^its^","was":true,"past":"in (water, mud, tall grass, body part, etc.) up to ^its^","inf_prenoun":"be in (water, mud, tall grass, body part, etc.) up to ^its^","ger_prenoun":"being in (water, mud, tall grass, body part, etc.) up to ^its^","match_case":false,"keylookup":["-kiirar-,-kiir(ar)-,-kaar-",1]},"\u2013kaar[N\u2192V]":{"type":"NV","exp":"\u2013kaar[N\u2192V]","exp_display":"\u2013kaar","description":"to be in (water, mud, tall grass, body part, etc.) up to one\u02BCs N","subjectit":"it","is":true,"gen_prenoun":"in (water, mud, tall grass, body part, etc.) up to ^its^","nounNum":"s","present":"in (water, mud, tall grass, body part, etc.) up to ^its^","was":true,"past":"in (water, mud, tall grass, body part, etc.) up to ^its^","inf_prenoun":"be in (water, mud, tall grass, body part, etc.) up to ^its^","ger_prenoun":"being in (water, mud, tall grass, body part, etc.) up to ^its^","match_case":false,"keylookup":["-kiirar-,-kiir(ar)-,-kaar-",2]},"+kiur[N\u2192V]":{"type":"NV","exp":"+kiur[N\u2192V]","exp_display":"+kiur","description":"to prepare something to be N","subjectit":"it","is":true,"gen_prenoun":"preparing something to be","nounNum":"s","present":"prepares something to be","was":false,"past":"prepared something to be","inf_prenoun":"prepare something to be","ger_prenoun":"preparing something to be","match_case":false,"keylookup":["+kiur-",0]},"\u2013knaggairute[N\u2192V]":{"type":"NV","exp":"\u2013knaggairute[N\u2192V]","exp_display":"\u2013knaggairute","description":"to have come to totally lack N","subjectit":"it","is":false,"gen_prenoun":"has come to totally lack","nounNum":"p","present":"has come to totally lack","was":false,"past":"had come to totally lack","inf_prenoun":"have come to totally lack","ger_prenoun":"having come to totally lack","match_case":false,"keylookup":["-knaggairute-",0]},"\u2013knaggaite[N\u2192V]":{"type":"NV","exp":"\u2013knaggaite[N\u2192V]","exp_display":"\u2013knaggaite","description":"to totally lack N","subjectit":"it","is":false,"gen_prenoun":"totally lacks","nounNum":"p","present":"totally lacks","was":false,"past":"totally lacked","inf_prenoun":"totally lack","ger_prenoun":"totally lacking","match_case":false,"keylookup":["-knaggaite-",0]},"%kuir[N\u2192V]":{"type":"NV","exp":"%%kuir[N\u2192V]","exp_display":"%%kuir","description":"to go along N; to go following N","subjectit":"it","is":true,"gen_prenoun":"going along","nounNum":"s","present":"goes along","was":false,"past":"went along","inf_prenoun":"go along","ger_prenoun":"going along","match_case":false,"keylookup":["%kuir-",0]},"\u2013laar(ar)[N\u2192V]":{"type":"NV","exp":"\u2013laar(ar)[N\u2192V]","exp_display":"\u2013laar(ar)","description":"to get a new N","subjectit":"it","is":true,"gen_prenoun":"getting new","nounNum":"p","present":"gets new","was":false,"past":"got new","inf_prenoun":"get new","ger_prenoun":"getting new","match_case":false,"keylookup":["-laar(ar)-",0]},"\u2013lgir[N\u2192V]":{"type":"NV","exp":"\u2013lgir[N\u2192V]","exp_display":"\u2013lgir","description":"to take along N","subjectit":"it","is":true,"gen_prenoun":"taking along","nounNum":"p","present":"takes along","was":false,"past":"took along","inf_prenoun":"take along","ger_prenoun":"taking along","match_case":false,"keylookup":["-lgir-",0]},"\u2013\u2013li\xB2[N\u2192V]":{"type":"NV","exp":"\u2013\u2013li\xB2[N\u2192V]","exp_display":"\u2013\u2013li","description":"to make N; to make N for (him); to make N out of (it)","subjectit":"it","is":true,"gen_prenoun":"making","nounNum":"as","present":"makes","was":false,"past":"made","inf_prenoun":"make","ger_prenoun":"making","match_case":false,"keylookup":["-li\xB2-",0]},"\u2013\u2013linqigte[N\u2192V]":{"type":"NV","exp":"\u2013\u2013linqigte[N\u2192V]","exp_display":"\u2013\u2013linqigte","description":"to change one\u02BCs N; to get another N","subjectit":"it","is":true,"gen_prenoun":"changing ^its^","nounNum":"p","present":"changes ^its^","was":false,"past":"changed ^its^","inf_prenoun":"change ^its^","ger_prenoun":"changing ^its^","match_case":false,"keylookup":["-linqigte-",0]},"\u2013\u2013liqe\xB9[N\u2192V]":{"type":"NV","exp":"\u2013\u2013liqe\xB9[N\u2192V]","exp_display":"\u2013\u2013liqe","description":"to catch a lot of N","subjectit":"it","is":true,"gen_prenoun":"catching a lot of","nounNum":"p","present":"catches a lot of","was":false,"past":"caught a lot of","inf_prenoun":"catch a lot of","ger_prenoun":"catching a lot of","match_case":false,"keylookup":["-liqe\xB9-",0]},"\u2013\u2013liqe\xB2[N\u2192V]":{"type":"NV","exp":"\u2013\u2013liqe\xB2[N\u2192V]","exp_display":"\u2013\u2013liqe","description":"to be afflicted in one\u02BCs N or with respect to N","subjectit":"it","is":true,"gen_prenoun":"afflicted in ^its^","nounNum":"s","present":"afflicted in ^its^","was":true,"past":"afflicted in ^its^","inf_prenoun":"be afflicted in ^its^","ger_prenoun":"being afflicted in ^its^","match_case":false,"keylookup":["-liqe\xB2-",0]},"\u2013\u2013lir[N\u2192V]":{"type":"NV","exp":"\u2013\u2013lir[N\u2192V]","exp_display":"\u2013\u2013lir","description":"to have lots of N; to provide with or be well provided with N; to add N to (it)","subjectit":"it","is":false,"gen_prenoun":"has lots of","nounNum":"p","present":"has lots of","was":false,"past":"had lots of","inf_prenoun":"have lots of","ger_prenoun":"having lots of","match_case":false,"keylookup":["-lir-",0]},"\u2013\u2013liur[N\u2192V]":{"type":"NV","exp":"\u2013\u2013liur[N\u2192V]","exp_display":"\u2013\u2013liur","description":"to be occupied with N; to work or play with N; to cook N (additional NUN meaning)","subjectit":"it","is":true,"gen_prenoun":"occupied with","nounNum":"p","present":"occupied with","was":true,"past":"occupied with","inf_prenoun":"be occupied with","ger_prenoun":"being occupied with","match_case":false,"keylookup":["-liur-",0]},"\u2013\u2013liyar[N\u2192V]":{"type":"NV","exp":"\u2013\u2013liyar[N\u2192V]","exp_display":"\u2013\u2013liyar","description":"to go to participate in N or V","subjectit":"it","is":true,"gen_prenoun":"going to participate in","nounNum":"s","present":"goes to participate in","was":false,"past":"went to participate in","inf_prenoun":"go to participate in","ger_prenoun":"going to participate in","match_case":false,"keylookup":["-liyar-,-liar-",0]},"\u2013liar[N\u2192V]":{"type":"NV","exp":"\u2013liar[N\u2192V]","exp_display":"\u2013liar","description":"to go to participate in N or V","subjectit":"it","is":true,"gen_prenoun":"going to participate in","nounNum":"s","present":"goes to participate in","was":false,"past":"went to participate in","inf_prenoun":"go to participate in","ger_prenoun":"going to participate in","match_case":false,"keylookup":["-liyar-,-liar-",1]},"\u2013lkia[N\u2192V]":{"type":"NV","exp":"\u2013lkia[N\u2192V]","exp_display":"\u2013lkia","description":"to give evidence or indication of N or V","subjectit":"it","is":true,"gen_prenoun":"giving evidence of","nounNum":"p","present":"gives evidence of","was":false,"past":"gave evidence of","inf_prenoun":"give evidence of","ger_prenoun":"giving evidence of","match_case":false,"keylookup":["-lkia-",0]},"\u2013lkite[N\u2192V]":{"type":"NV","exp":"\u2013lkite[N\u2192V]","exp_display":"\u2013lkite","description":"to make a noise or give other evidence of N","subjectit":"it","is":true,"gen_prenoun":"giving evidence of","nounNum":"p","present":"gives evidence of","was":false,"past":"gave evidence of","inf_prenoun":"give evidence of","ger_prenoun":"giving evidence of","match_case":false,"keylookup":["-lkite-",0]},"+lliqe[N\u2192V]":{"type":"NV","exp":"+lliqe[N\u2192V]","exp_display":"+lliqe","description":"to have N of poor quality","subjectit":"it","is":false,"gen_prenoun":"has poor quality","nounNum":"p","present":"has poor quality","was":false,"past":"had poor quality","inf_prenoun":"have poor quality","ger_prenoun":"having poor quality","match_case":false,"keylookup":["+lliqe-",0]},"\u2013llug[N\u2192V]":{"type":"NV","exp":"\u2013llug[N\u2192V]","exp_display":"\u2013llug","description":"to have bad N","subjectit":"it","is":false,"gen_prenoun":"has bad","nounNum":"p","present":"has bad","was":false,"past":"had bad","inf_prenoun":"have bad","ger_prenoun":"having bad","match_case":false,"keylookup":["@-lluk,-llug-,-llugte-",1]},"\u2013llugte[N\u2192V]":{"type":"NV","exp":"\u2013llugte[N\u2192V]","exp_display":"\u2013llugte","description":"to have bad N","subjectit":"it","is":false,"gen_prenoun":"has bad","nounNum":"p","present":"has bad","was":false,"past":"had bad","inf_prenoun":"have bad","ger_prenoun":"having bad","match_case":false,"keylookup":["@-lluk,-llug-,-llugte-",2]},"+mig[N\u2192V]":{"type":"NV","exp":"+mig[N\u2192V]","exp_display":"+mig","description":"to put in one\u02BCs N","subjectit":"it","is":true,"gen_prenoun":"putting something in ^its^","nounNum":"s","present":"puts something in ^its^","was":false,"past":"put something in ^its^","inf_prenoun":"put something in ^its^","ger_prenoun":"putting something in ^its^","match_case":false,"keylookup":["+mik,+miaq,+mig-",2]},"+miu[N\u2192V]":{"type":"NV","exp":"+miu[N\u2192V]","exp_display":"+miu","description":"to be at N; to stay at N","subjectit":"it","is":true,"gen_prenoun":"at","nounNum":"s","present":"at","was":true,"past":"at","inf_prenoun":"be at","ger_prenoun":"being at","match_case":false,"keylookup":["+miu-",0]},"+miuyaar[N\u2192V]":{"type":"NV","exp":"+miuyaar[N\u2192V]","exp_display":"+miuyaar","description":"to speak the language or dialect of the residents of N","subjectit":"it","is":false,"gen_prenoun":"speaks the language or dialect of the residents of","nounNum":"s","present":"speaks the language or dialect of the residents of","was":false,"past":"spoke the language or dialect of the residents of","inf_prenoun":"speak the language or dialect of the residents of","ger_prenoun":"speaking the language or dialect of the residents of","match_case":false,"keylookup":["+miuyaar-",0]},"+ngate[N\u2192V]":{"type":"NV","exp":"+ngate[N\u2192V]","exp_display":"+(r)ngate\xB0","description":"to seem like N","subjectit":"it","is":false,"gen_prenoun":"seems like","nounNum":"as","present":"seems like","was":false,"past":"seemed like","inf_prenoun":"seem like","ger_prenoun":"seeming like","match_case":false,"keylookup":["@~+ngate-,+ngate-",0]},"\u2013nge[N\u2192V]":{"type":"NV","exp":"\u2013nge[N\u2192V]","exp_display":"\u2013nge","description":"to acquire N; to begin to V","subjectit":"it","is":false,"gen_prenoun":"has acquired","nounNum":"as","present":"has acquired","was":false,"past":"had acquired","inf_prenoun":"have acquired","ger_prenoun":"having acquired","match_case":false,"keylookup":["-nge-",0]},"\u2013ngqerr[N\u2192V]":{"type":"NV","exp":"\u2013ngqerr[N\u2192V]","exp_display":"\u2013ngqerr","description":"to have N","subjectit":"it","is":false,"gen_prenoun":"has","nounNum":"as","present":"has","was":false,"past":"had","inf_prenoun":"have","ger_prenoun":"having","match_case":false,"keylookup":["-ngqerr-",1]},"@~+nialke[N\u2192V]":{"type":"NV","exp":"@~+nialke[N\u2192V]","exp_display":"@\xB9~+nialke","description":"to consider object to be unpleasant to V or to be an unpleasant N","subjectit":"it","is":false,"gen_prenoun":"considers it to be an unpleasant","nounNum":"s","present":"considers it to be an unpleasant","was":false,"past":"considered it to be an unpleasant","inf_prenoun":"consider it to be an unpleasant","ger_prenoun":"considering it to be an unpleasant","match_case":false,"keylookup":["@~+nialke-",0]},"@~+niate[N\u2192V]":{"type":"NV","exp":"@~+niate[N\u2192V]","exp_display":"@\xB9~+niate","description":"to be unpleasant to V; to be an unpleasant N","subjectit":"it","is":true,"gen_prenoun":"an unpleasant","nounNum":"s","present":"an unpleasant","was":true,"past":"an unpleasant","inf_prenoun":"be an unpleasant","ger_prenoun":"being an unpleasant","match_case":false,"keylookup":["@~+niate-",0]},"@~+niilke[N\u2192V]":{"type":"NV","exp":"@~+niilke[N\u2192V]","exp_display":"@\xB9~+niilke","description":"to consider object to be unpleasant to V or to be an unpleasant N","subjectit":"it","is":false,"gen_prenoun":"considers it to be an unpleasant","nounNum":"s","present":"considers it to be an unpleasant","was":false,"past":"considered it to be an unpleasant","inf_prenoun":"consider it to be an unpleasant","ger_prenoun":"considering it to be an unpleasant","match_case":false,"keylookup":["@~+niilke-",0]},"@~+niite[N\u2192V]":{"type":"NV","exp":"@~+niite[N\u2192V]","exp_display":"@\xB9~+niite","description":"to be unpleasant to V; to be an unpleasant N","subjectit":"it","is":true,"gen_prenoun":"an unpleasant","nounNum":"s","present":"an unpleasant","was":true,"past":"an unpleasant","inf_prenoun":"be an unpleasant","ger_prenoun":"being an unpleasant","match_case":false,"keylookup":["@~+niite-",0]},"@~+nike[N\u2192V]":{"type":"NV","exp":"@~+nike[N\u2192V]","exp_display":"@\xB9~+nike","description":"to consider object to be pleasant to V or to be a pleasant N","subjectit":"it","is":false,"gen_prenoun":"considers it to be an unpleasant","nounNum":"s","present":"considers it to be an unpleasant","was":false,"past":"considered it to be an unpleasant","inf_prenoun":"consider it to be an unpleasant","ger_prenoun":"considering it to be an unpleasant","match_case":false,"keylookup":["@~+nike-",0]},"~+ninarqe[N\u2192V]":{"type":"NV","exp":"~+ninarqe[N\u2192V]","exp_display":"~+ninarqe","description":"to smell or taste like N","subjectit":"it","is":false,"gen_prenoun":"smells or tastes like","nounNum":"s","present":"smells or tastes like","was":false,"past":"smelled or tasted like","inf_prenoun":"smell or taste like","ger_prenoun":"smelling or tasting like","match_case":false,"keylookup":["~+ninarqe-,~+nilarqe-",0]},"~+nilarqe[N\u2192V]":{"type":"NV","exp":"~+nilarqe[N\u2192V]","exp_display":"~+nilarqe","description":"(NUN, NSU form) to smell or taste like N","subjectit":"it","is":false,"gen_prenoun":"smells or tastes like","nounNum":"s","present":"smells or tastes like","was":false,"past":"smelled or tasted like","inf_prenoun":"smell or taste like","ger_prenoun":"smelling or tasting like","match_case":false,"keylookup":["~+ninarqe-,~+nilarqe-",1]},"@~+nirqe[N\u2192V]":{"type":"NV","exp":"@~+nirqe[N\u2192V]","exp_display":"@\xB9~+nirqe","description":"to be pleasant to V; to be a pleasant N","subjectit":"it","is":true,"gen_prenoun":"a pleasant","nounNum":"s","present":"a pleasant","was":true,"past":"a pleasant","inf_prenoun":"be a pleasant","ger_prenoun":"being a pleasant","match_case":false,"keylookup":["@~+nirqe-",0]},"+nite[N\u2192V]":{"type":"NV","exp":"+nite[N\u2192V]","exp_display":"+nite\xB0","description":"to smell or taste like N","subjectit":"it","is":false,"gen_prenoun":"smells or tastes like","nounNum":"s","present":"smells or tastes like","was":false,"past":"smelled or tasted like","inf_prenoun":"smell or taste like","ger_prenoun":"smelling or tasting like","match_case":false,"keylookup":["+nite-",0]},"\u2013qsig[N\u2192V]":{"type":"NV","exp":"\u2013qsig[N\u2192V]","exp_display":"\u2013q\u0332sig","description":"to be far in the direction denoted by N","subjectit":"it","is":true,"gen_prenoun":"far in the direction denoted by","nounNum":"s","present":"far in the direction denoted by","was":true,"past":"far in the direction denoted by","inf_prenoun":"be far in the direction denoted by","ger_prenoun":"being far in the direction denoted by","match_case":false,"keylookup":["-qsig-",2]},"\u2013qsigi[N\u2192V]":{"type":"NV","exp":"\u2013qsigi[N\u2192V]","exp_display":"\u2013q\u0332sigi","description":"to get farther into the area denoted by N","subjectit":"it","is":true,"gen_prenoun":"getting farther in the direction denoted by","nounNum":"s","present":"goes farther in the direction denoted by","was":false,"past":"went farther in the direction denoted by","inf_prenoun":"go farther in the direction denoted by","ger_prenoun":"going farther in the direction denoted by","match_case":false,"keylookup":["-qsigi-",2]},"\u2013qu\xB2[N\u2192V]":{"type":"NV","exp":"\u2013qu\xB2[N\u2192V]","exp_display":"\u2013qu","description":"to hunt with N or at N","subjectit":"it","is":true,"gen_prenoun":"hunting with or at","nounNum":"s","present":"hunts with or at","was":false,"past":"hunted with or at","inf_prenoun":"hunt with or at","ger_prenoun":"hunting with or at","match_case":false,"keylookup":["-qu\xB2-",0]},"\u2013rpagninarqe[N\u2192V]":{"type":"NV","exp":"\u2013rpagninarqe[N\u2192V]","exp_display":"\u2013r\u0332pagninarqe","description":"to smell strongly of N","subjectit":"it","is":false,"gen_prenoun":"smells strongly of","nounNum":"s","present":"smells strongly of","was":false,"past":"smelled strongly of","inf_prenoun":"smell strongly of","ger_prenoun":"smelling strongly of","match_case":false,"keylookup":["-rpagninarqe-",0]},"\u2013rpagnite[N\u2192V]":{"type":"NV","exp":"\u2013rpagnite[N\u2192V]","exp_display":"\u2013r\u0332pagnite","description":"to smell or taste strongly of N","subjectit":"it","is":false,"gen_prenoun":"smells or tastes strongly of","nounNum":"s","present":"smells or tastes strongly of","was":false,"past":"smelled or tasted strongly of","inf_prenoun":"smell or taste strongly of","ger_prenoun":"smelling or tasting strongly of","match_case":false,"keylookup":["-rpagnite-",0]},"\u2013rpau[N\u2192V]":{"type":"NV","exp":"\u2013rpau[N\u2192V]","exp_display":"\u2013r\u0332pau","description":"to be a large N; to have a large N","subjectit":"it","is":true,"gen_prenoun":"a large","nounNum":"s","present":"a large","was":true,"past":"a large","inf_prenoun":"be a large","ger_prenoun":"being a large","match_case":false,"keylookup":["-rpau-",0]},"\u2013rpi[N\u2192V]":{"type":"NV","exp":"\u2013rpi[N\u2192V]","exp_display":"\u2013r\u0332pi","description":"to have a large N","subjectit":"it","is":false,"gen_prenoun":"has a large","nounNum":"s","present":"has a large","was":false,"past":"had a large","inf_prenoun":"have a large","ger_prenoun":"having a large","match_case":false,"keylookup":["-rpi-",0]},"\u2013rrlug[N\u2192V]":{"type":"NV","exp":"\u2013rrlug[N\u2192V]","exp_display":"\u2013r\u0332r\u0332lug","description":"to be dirtied with N; to be somewhat V; to be afflicted in one\u02BCs N or in respect to N; to have bad N","subjectit":"it","is":true,"gen_prenoun":"dirtied with","nounNum":"p","present":"dirtied with","was":true,"past":"dirtied with","inf_prenoun":"be dirtied with","ger_prenoun":"being dirtied with","match_case":false,"keylookup":["-rrluk,-rrlug-,-rrlugte-",1]},"\u2013rrlugte[N\u2192V]":{"type":"NV","exp":"\u2013rrlugte[N\u2192V]","exp_display":"\u2013r\u0332r\u0332lugte","description":"to be dirtied with N; to be somewhat V; to be afflicted in one\u02BCs N or in respect to N; to have bad N","subjectit":"it","is":true,"gen_prenoun":"dirtied with","nounNum":"p","present":"dirtied with","was":true,"past":"dirtied with","inf_prenoun":"be dirtied with","ger_prenoun":"being dirtied with","match_case":false,"keylookup":["-rrluk,-rrlug-,-rrlugte-",2]},"\u2013(u)saar[N\u2192V]":{"type":"NV","exp":"\u2013(u)saar[N\u2192V]","exp_display":"\u2013(u)saar","description":"to speak the language of N","subjectit":"it","is":false,"gen_prenoun":"speaks the language of","nounNum":"s","present":"speaks the language of","was":false,"past":"spoke the language of","inf_prenoun":"speak the language of","ger_prenoun":"speaking the language of","match_case":false,"keylookup":["-(u)saar-",0]},"\u2013ssaag\xB2[N\u2192V]":{"type":"NV","exp":"\u2013ssaag\xB2[N\u2192V]","exp_display":"\u2013ssaag","description":"to fetch some N from an easily accessible place","subjectit":"it","is":false,"gen_prenoun":"fetched (from an easily accessible place) some","nounNum":"p","present":"fetches (from an easily accessible place) some","was":false,"past":"fetched (from an easily accessible place) some","inf_prenoun":"fetch (from an easily accessible place) some","ger_prenoun":"fetching (from an easily accessible place) some","match_case":false,"keylookup":["-ssaag\xB2-",0]},"\u2013ssaar[N\u2192V]":{"type":"NV","exp":"\u2013ssaar[N\u2192V]","exp_display":"\u2013ssaar","description":"to hunt N","subjectit":"it","is":true,"gen_prenoun":"hunting","nounNum":"p","present":"hunts","was":false,"past":"hunted","inf_prenoun":"hunt","ger_prenoun":"hunting","match_case":false,"keylookup":["-ssaar-",0]},"+ssur[N\u2192V]":{"type":"NV","exp":"+ssur[N\u2192V]","exp_display":"+ssur","description":"to hunt N; to seek N; to check N (game-capturing implement)","subjectit":"it","is":true,"gen_prenoun":"hunting","nounNum":"p","present":"hunts","was":false,"past":"hunted","inf_prenoun":"hunt","ger_prenoun":"hunting","match_case":false,"keylookup":["+ssur-",0]},"+tairute[N\u2192V]":{"type":"NV","exp":"+tairute[N\u2192V]","exp_display":"+tairute","description":"(for there) to be no more N","subjectit":"it","is":false,"gen_prenoun":"has no more","nounNum":"p","present":"has no more","was":false,"past":"had no more","inf_prenoun":"have no more","ger_prenoun":"having no more","match_case":false,"keylookup":["+tairute-",0]},"+taite\xB9[N\u2192V]":{"type":"NV","exp":"+taite\xB9[N\u2192V]","exp_display":"+taite\xB0","description":"(for there) to be no N","subjectit":"it","is":false,"gen_prenoun":"has no","nounNum":"p","present":"has no","was":false,"past":"had no","inf_prenoun":"have no","ger_prenoun":"having no","match_case":false,"keylookup":["+taite\xB9-",0]},"+taknaggaite[N\u2192V]":{"type":"NV","exp":"+taknaggaite[N\u2192V]","exp_display":"+taknaggaite","description":"for there to be absolutely no N","subjectit":"it","is":false,"gen_prenoun":"has absolutely no","nounNum":"p","present":"has absolutely no","was":false,"past":"had absolutely no","inf_prenoun":"have absolutely no","ger_prenoun":"having absolutely no","match_case":false,"keylookup":["+taknaggaite-",0]},"+tange[N\u2192V]":{"type":"NV","exp":"+tange[N\u2192V]","exp_display":"+tange","description":"(for there) to be N now","subjectit":"it","is":false,"gen_prenoun":"now has","nounNum":"as","present":"now has","was":false,"past":"now had","inf_prenoun":"now have","ger_prenoun":"now having","match_case":false,"keylookup":["+tange-",0]},"+tangqerr[N\u2192V]":{"type":"NV","exp":"+tangqerr[N\u2192V]","exp_display":"+tangqerr","description":"(for there) to be N","subjectit":"it","is":false,"gen_prenoun":"has","nounNum":"as","present":"has","was":false,"past":"had","inf_prenoun":"have","ger_prenoun":"having","match_case":false,"keylookup":["+tangqerr-",0]},"+tar\xB3[N\u2192V]":{"type":"NV","exp":"+tar\xB3[N\u2192V]","exp_display":"+tar","description":"(for there) to be N","subjectit":"it","is":false,"gen_prenoun":"has","nounNum":"as","present":"has","was":false,"past":"had","inf_prenoun":"have","ger_prenoun":"having","match_case":false,"keylookup":["+tar\xB3-",0]},"+te\xB9[N\u2192V]":{"type":"NV","exp":"+te\xB9[N\u2192V]","exp_display":"+te","description":"to catch N (game animal); to go to N (place); to obtain N; to spend the N (time); for N (time) to pass","subjectit":"it","is":false,"gen_prenoun":"caught, went to","nounNum":"as","present":"catches, goes to","was":false,"past":"caught, went to","inf_prenoun":"catch, go to","ger_prenoun":"catching, going to","match_case":false,"keylookup":["+te\xB9-",0]},"+te\u2076[N\u2192V]":{"type":"NV","exp":"+te\u2076[N\u2192V]","exp_display":"+te","description":"to make the N noise","subjectit":"it","is":true,"gen_prenoun":"making a noise like","nounNum":"as","present":"makes a noise like","was":false,"past":"made a noise like","inf_prenoun":"make a noise like","ger_prenoun":"making a noise like","match_case":false,"keylookup":["+te\u2076-",0]},"\u2013tmurte\xB9[N\u2192V]":{"type":"NV","exp":"\u2013tmurte\xB9[N\u2192V]","exp_display":"\u2013tmurte","description":"to go N-ward; to go in the area described by V","subjectit":"it","is":true,"gen_prenoun":"going toward the direction of","nounNum":"s","present":"goes toward the direction of","was":false,"past":"went toward the direction of","inf_prenoun":"go toward the direction of","ger_prenoun":"going toward the direction of","match_case":false,"keylookup":["-tmurte\xB9-",0]},"\u2013trute[N\u2192V]":{"type":"NV","exp":"\u2013trute[N\u2192V]","exp_display":"\u2013trute","description":"to miss by passing through the N area, or the N area of it","subjectit":"it","is":false,"gen_prenoun":"missed by passing through the area of","nounNum":"s","present":"misses by passing through the area of","was":false,"past":"missed by passing through the area of","inf_prenoun":"miss by passing through the area of","ger_prenoun":"missing by passing through the area of","match_case":false,"keylookup":["-trute-",0]},"+tu[N\u2192V]":{"type":"NV","exp":"+tu[N\u2192V]","exp_display":"+tu","description":"to be well endowed with N, to have N to a large extent","subjectit":"it","is":true,"gen_prenoun":"well endowed with","nounNum":"s","present":"well endowed with","was":true,"past":"well endowed with","inf_prenoun":"be well endowed with","ger_prenoun":"being well endowed with","match_case":false,"keylookup":["+tu-,-tu-",2]},"+tur\xB2[N\u2192V]":{"type":"NV","exp":"+tur\xB2[N\u2192V]","exp_display":"+tur","description":"to eat N (food); to wear N (clothing); to use N (limited usage with this meaning)","subjectit":"it","is":true,"gen_prenoun":"eating (food), wearing (clothing), using","nounNum":"s","present":"eats (food), wears (clothing), uses","was":false,"past":"ate (food), wore (clothing), used","inf_prenoun":"eat (food), wear (clothing), use","ger_prenoun":"eating (food), wearing (clothing), using","match_case":false,"keylookup":["+tur\xB2-",0]},"+(r)tuuma(r)[N\u2192V]":{"type":"NV","exp":"+(r)tuuma(r)[N\u2192V]","exp_display":"+(r)tuumar","description":"to act together with one\u02BCs N or Ns","subjectit":"it","is":true,"gen_prenoun":"acting together with ^its^","nounNum":"s","present":"acts together with ^its^","was":false,"past":"acted together with ^its^","inf_prenoun":"act together with ^its^","ger_prenoun":"acting together with ^its^","match_case":false,"keylookup":["+(r)tuuma(r)-",1]},":~(ng)u[N\u2192V]":{"type":"NV","exp":"%:~(ng)u[N\u2192V]","exp_display":"%:~(ng)u","description":"to be N","subjectit":"it","is":true,"gen_prenoun":"","nounNum":"as","present":"","was":true,"past":"","inf_prenoun":"be","ger_prenoun":"being","match_case":false,"keylookup":[":~(ng)u-",0]},":(ng)ucir[N\u2192V]":{"type":"NV","exp":"%:(ng)ucir[N\u2192V]","exp_display":"%:(ng)ucir","description":"to have lots of N","subjectit":"it","is":false,"gen_prenoun":"has lots of","nounNum":"s","present":"has lots of","was":false,"past":"had lots of","inf_prenoun":"have lots of","ger_prenoun":"having lots of","match_case":false,"keylookup":[":(ng)ucir-",0]},":~(ng)urte[N\u2192V]":{"type":"NV","exp":"%:~(ng)urte[N\u2192V]","exp_display":"%:~(ng)urte","description":"to become N; to expose the N of (it)","subjectit":"it","is":false,"gen_prenoun":"became","nounNum":"as","present":"becomes","was":false,"past":"became","inf_prenoun":"become","ger_prenoun":"becoming","match_case":false,"keylookup":[":~(ng)urte-",0]},"+yag[N\u2192V]":{"type":"NV","exp":"+yag[N\u2192V]","exp_display":"+yag","description":"(for there) to be much N, many N","subjectit":"it","is":false,"gen_prenoun":"has many","nounNum":"p","present":"has many","was":false,"past":"had many","inf_prenoun":"have many","ger_prenoun":"having many","match_case":false,"keylookup":["+yag-",0]},"+(r)yug[N\u2192V]":{"type":"NV","exp":"+(r)yug[N\u2192V]","exp_display":"+(r)yug","description":"to want N; to want to do the appropriate thing with N","subjectit":"it","is":true,"gen_prenoun":"wanting","nounNum":"p","present":"wants","was":false,"past":"wanted","inf_prenoun":"want","ger_prenoun":"wanting","match_case":false,"keylookup":["@~+yug-,+(r)yug-",0]}};

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_newconstants_js__ = __webpack_require__(79);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customFontFam="Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif";var accordionTitles=[{key:'noun phrase only',name:'Noun phrases',// examples:[['piipirpak','the one large baby'],['qimugteka','my one dog']],
examples:[['piipirpak','the one large baby']],values:[{key:'simple',values:['simple','possession','oblique nouns','descriptors']},{key:'postbases',values:['noun-noun postbases','verb-noun postbases']}]},{key:'verb (+ noun) statements',name:'Verb phrases',// examples:[["piipiq ner'uq",'the baby is eating'],['angyangqertuq','he has a boat']],
examples:[["piipiq ner'uq",'the baby is eating']],values:[{key:'statement sentence',values:['subject only','subject with object not marked on verb','subject and object marked on verb','verb + oblique noun']},{key:'postbases',values:['verb-verb postbases','noun-verb postbases']}]},{key:'verb (+ noun) questions',name:'Ask a question',// examples:[['kaigtuten-qaa?','are you hungry?'],['nani iqvallrusit?','where did you pick berries?']],
examples:[['kaigtuten-qaa?','are you hungry?']],values:[{key:'question sentence',values:['yes-no question','wh-question']}]},{key:'verb (+ noun) commands',name:'Make a command',// examples:[["taiteqerr'u",'you, bring it over (please)'],['aqumluten','you, sit down (polite)']],
examples:[["taiteqerru",'you, bring it over (please)']],values:[{key:'command sentence',values:['optative','subordinative','subject only','subject and object marked']}]},{key:'verb + verb phrase sentence',name:'Advanced verb phrases',// examples:[['kaigciquten nerenrilkuvet','you will be hungry if you do not eat'],['itellruunga tangerrsugluku','I came in wanting to see her']],
examples:[['kaigciquten nerenrilkuvet','you will be hungry if you do not eat']],values:[{key:'connective verb',values:['before...','because...','whenever...','even though...','if, when in the future...','when in the past...','while...']},{key:'subordinative verb',values:['adjectival']}]}];var SentenceTemplates=function(_PureComponent){_inherits(SentenceTemplates,_PureComponent);function SentenceTemplates(props){_classCallCheck(this,SentenceTemplates);var _this=_possibleConstructorReturn(this,(SentenceTemplates.__proto__||Object.getPrototypeOf(SentenceTemplates)).call(this,props));_this.handleClick=function(e,titleProps){// console.log(e,titleProps)
// this.setState({ loaderOn: true });
var index=titleProps.index;var activeIndexes=_this.state.activeIndexes;var newIndex=_this.state.activeIndexes.slice();// const newIndex = activeIndex === index ? -1 : index;
var currentIndexPosition=activeIndexes.indexOf(index);// console.log(currentIndexPosition, activeIndexes, index)
if(currentIndexPosition>-1){newIndex.splice(currentIndexPosition,1);}else{newIndex.push(index);}// console.log(newIndex)
// let mood = moods[index];
// if (newIndex !== -1) {   
// this.getEndings(this.state.parses[currentIndex], mood);
// }
_this.setState({activeIndexes:newIndex});};_this.randomizeSentence=function(direction){if(direction==='+'){if(_this.state.randomSentences.length-1===_this.state.randomSentenceIndex){_this.setState({randomSentences:_this.state.randomSentences.concat([Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */])[Math.floor(Math.random()*Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */]).length)]])});}_this.setState({randomSentenceIndex:_this.state.randomSentenceIndex+1});}else{_this.setState({randomSentenceIndex:_this.state.randomSentenceIndex-1});}};_this.state={// entries: props.entries,
// mood: props.mood,
activeIndexes:[],randomSentenceIndex:0,randomSentences:[Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */])[Math.floor(Math.random()*Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */]).length)]],seeMoreExamples:true};return _this;}_createClass(SentenceTemplates,[{key:'render',// getColor = (pos) => {
//   return colorsList[0][pos]  
// }
value:function render(){var _this2=this;// console.log(this.state)
var activeIndexes=this.state.activeIndexes;// <Link to={{pathname: "/sentencebuilder/0", state: { history:this.state.history }}} onClick={()=> {this.props.flipGlossary(true)}} >
//   <div style={{display:'flex',justifyContent:'center',margin:'15px'}}>
//   <Button basic>{'See Full Glossary of Examples'}<Icon style={{paddingLeft:10}} name='chevron right' /></Button>
//   </div>
// </Link>
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Or click on a random example')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',marginTop:'10px',height:120}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:4,display:'flex',alignItems:'center',justifyContent:window.innerWidth<480?'center':'flex-end'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:{pathname:'/sentencebuilder/2'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{marginLeft:'10px',borderRadius:'4rem',paddingBottom:'14px'},circular:true,onClick:function onClick(){_this2.props.backEndCall(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][_this2.state.randomSentences[_this2.state.randomSentenceIndex]][2],true);_this2.setState({activeIndexes:[]});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:window.innerWidth<480?'':'350px',textAlign:'center',fontSize:window.innerWidth<480?'18px':'20px',lineHeight:'20px',paddingTop:'2px',marginBottom:'10px',fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][this.state.randomSentences[this.state.randomSentenceIndex]][6][0].map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'black'}},t[0]);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:window.innerWidth<480?'':'350px',textAlign:'center',fontSize:window.innerWidth<480?'15px':'16px',fontWeight:'400',lineHeight:'18px',fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][this.state.randomSentences[this.state.randomSentenceIndex]][6][1].map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'black'}},(t[0]===', '||t[0].includes(", do")||t[0]=='?'?'':' ')+t[0]);}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:'center',flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){return _this2.randomizeSentence('+');},circular:true,style:{margin:0,marginLeft:5,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'shuffle'}))),this.state.seeMoreExamples?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',margin:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,onClick:function onClick(){_this2.setState({seeMoreExamples:!_this2.state.seeMoreExamples});}},'See Glossary of Examples',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{paddingLeft:10},name:'chevron down'}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',margin:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,onClick:function onClick(){_this2.setState({seeMoreExamples:!_this2.state.seeMoreExamples});}},'See Glossary of Examples',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{paddingLeft:10},name:'chevron up'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'More examples to try')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],{style:{fontSize:16,padding:15},fluid:true,styled:true},accordionTitles.map(function(p,pindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{style:{borderTop:pindex!==0?'1px solid #2224261a':'0px solid #2224261a'},active:activeIndexes.includes(pindex),index:pindex,onClick:_this2.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:window.innerWidth<480?'':'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,p.name)),p.examples.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1,marginTop:'3px',fontSize:'14px',marginLeft:window.innerWidth<480?'40px':'0px',fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'300',marginRight:'10px'}},"Example:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'400',marginRight:'10px'}},t[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontWeight:'400',marginLeft:'64px'}},t[1]));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{style:{paddingTop:0},active:activeIndexes.includes(pindex)},p.values.map(function(q,qindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontVariant:'small-caps',fontWeight:'500',fontSize:'20px',color:"#000000cc",marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,q.values.map(function(r,rindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',borderRadius:'3px',marginTop:'10px',fontVariant:'none',fontSize:'15px',padding:'5px',color:"#00000066"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'2px',fontWeight:'400'}},r)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object.keys(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */]).map(function(k,index){return __WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][3]===p.key&&__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][4]===q.key&&__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][5]===r?window.innerWidth<480?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:{pathname:'/sentencebuilder/2'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{marginTop:'-1px'},fluid:true,basic:true,onClick:function onClick(){_this2.props.backEndCall(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][2],true);_this2.setState({activeIndexes:[]});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1,display:'flex',flexDirection:'column',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontWeight:'500',fontSize:'16px',fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][6][0].map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this2.props.getColor(t[1],true,t[0],1),lineHeight:'18px'}},t[0]);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontWeight:'400',fontSize:'14px',paddingTop:'5px',paddingRight:0,fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][6][1].map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this2.props.getColor(t[1],true,t[0],1)}},(t[0]===', '||t[0].includes(", do")||t[0]=='?'?'':' ')+t[0]);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{marginRight:'-5px',paddingLeft:'10px'},name:'chevron right'})))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:{pathname:'/sentencebuilder/2'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{marginTop:'-1px'},fluid:true,basic:true,onClick:function onClick(){_this2.props.backEndCall(__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][2],true);_this2.setState({activeIndexes:[]});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{flex:1,textAlign:'left',fontSize:'16px',fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][6][0].map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this2.props.getColor(t[1],true,t[0],1)}},t[0]);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{flex:1,textAlign:'right',paddingRight:0,fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_5__constants_sentence_templates_js__["a" /* sentenceTemplates */][k][6][1].map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this2.props.getColor(t[1],true,t[0],1),lineHeight:'18px',fontSize:'16px'}},(t[0]===', '||t[0].includes(", do")||t[0]=='?'?'':' ')+t[0]);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{marginRight:'-5px',paddingLeft:'10px'},name:'chevron right'})))):null;})));})));})));}))));}}]);return SentenceTemplates;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* withRouter */])(SentenceTemplates));

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Popup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var useOnEscape = function useOnEscape(handler, active) {
  if (active === void 0) {
    active = true;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!active) return;

    var listener = function listener(event) {
      // check if key is an Escape
      if (event.key === 'Escape') handler(event);
    };

    document.addEventListener('keyup', listener);
    return function () {
      if (!active) return;
      document.removeEventListener('keyup', listener);
    };
  }, [handler, active]);
};
var useRepositionOnResize = function useRepositionOnResize(handler, active) {
  if (active === void 0) {
    active = true;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!active) return;

    var listener = function listener() {
      handler();
    };

    window.addEventListener('resize', listener);
    return function () {
      if (!active) return;
      window.removeEventListener('resize', listener);
    };
  }, [handler, active]);
};
var useOnClickOutside = function useOnClickOutside(ref, handler, active) {
  if (active === void 0) {
    active = true;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!active) return;

    var listener = function listener(event) {
      // Do nothing if clicking ref's element or descendent elements
      var refs = Array.isArray(ref) ? ref : [ref];
      var contains = false;
      refs.forEach(function (r) {
        if (!r.current || r.current.contains(event.target)) {
          contains = true;
          return;
        }
      });
      event.stopPropagation();
      if (!contains) handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      if (!active) return;
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, active]);
}; // Make sure that user is not able TAB out of the Modal content on Open

var useTabbing = function useTabbing(contentRef, active) {
  if (active === void 0) {
    active = true;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!active) return;

    var listener = function listener(event) {
      // check if key is an Tab
      if (event.keyCode === 9) {
        var _contentRef$current;

        var els = contentRef === null || contentRef === void 0 ? void 0 : (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
        var focusableEls = Array.prototype.slice.call(els);

        if (focusableEls.length === 1) {
          event.preventDefault();
          return;
        }

        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];

        if (event.shiftKey && document.activeElement === firstFocusableEl) {
          event.preventDefault();
          lastFocusableEl.focus();
        } else if (document.activeElement === lastFocusableEl) {
          event.preventDefault();
          firstFocusableEl.focus();
        }
      }
    };

    document.addEventListener('keydown', listener);
    return function () {
      if (!active) return;
      document.removeEventListener('keydown', listener);
    };
  }, [contentRef, active]);
};
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

var Style = {
  popupContent: {
    tooltip: {
      position: 'absolute',
      zIndex: 999
    },
    modal: {
      position: 'relative',
      margin: 'auto'
    }
  },
  popupArrow: {
    height: '8px',
    width: '16px',
    position: 'absolute',
    background: 'transparent',
    color: '#FFF',
    zIndex: -1
  },
  overlay: {
    tooltip: {
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      zIndex: 999
    },
    modal: {
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      display: 'flex',
      zIndex: 999
    }
  }
};

var POSITION_TYPES = ['top left', 'top center', 'top right', 'right top', 'right center', 'right bottom', 'bottom left', 'bottom center', 'bottom right', 'left top', 'left center', 'left bottom'];

var getCoordinatesForPosition = function getCoordinatesForPosition(triggerBounding, ContentBounding, position, //PopupPosition | PopupPosition[],
arrow, _ref) {
  var offsetX = _ref.offsetX,
      offsetY = _ref.offsetY;
  var margin = arrow ? 8 : 0;
  var args = position.split(' '); // the step N 1 : center the popup content => ok

  var CenterTop = triggerBounding.top + triggerBounding.height / 2;
  var CenterLeft = triggerBounding.left + triggerBounding.width / 2;
  var height = ContentBounding.height,
      width = ContentBounding.width;
  var top = CenterTop - height / 2;
  var left = CenterLeft - width / 2;
  var transform = '';
  var arrowTop = '0%';
  var arrowLeft = '0%'; // the  step N 2 : => ok

  switch (args[0]) {
    case 'top':
      top -= height / 2 + triggerBounding.height / 2 + margin;
      transform = "rotate(180deg)  translateX(50%)";
      arrowTop = '100%';
      arrowLeft = '50%';
      break;

    case 'bottom':
      top += height / 2 + triggerBounding.height / 2 + margin;
      transform = "rotate(0deg) translateY(-100%) translateX(-50%)";
      arrowLeft = '50%';
      break;

    case 'left':
      left -= width / 2 + triggerBounding.width / 2 + margin;
      transform = " rotate(90deg)  translateY(50%) translateX(-25%)";
      arrowLeft = '100%';
      arrowTop = '50%';
      break;

    case 'right':
      left += width / 2 + triggerBounding.width / 2 + margin;
      transform = "rotate(-90deg)  translateY(-150%) translateX(25%)";
      arrowTop = '50%';
      break;
  }

  switch (args[1]) {
    case 'top':
      top = triggerBounding.top;
      arrowTop = triggerBounding.height / 2 + "px";
      break;

    case 'bottom':
      top = triggerBounding.top - height + triggerBounding.height;
      arrowTop = height - triggerBounding.height / 2 + "px";
      break;

    case 'left':
      left = triggerBounding.left;
      arrowLeft = triggerBounding.width / 2 + "px";
      break;

    case 'right':
      left = triggerBounding.left - width + triggerBounding.width;
      arrowLeft = width - triggerBounding.width / 2 + "px";
      break;
  }

  top = args[0] === 'top' ? top - offsetY : top + offsetY;
  left = args[0] === 'left' ? left - offsetX : left + offsetX;
  return {
    top: top,
    left: left,
    transform: transform,
    arrowLeft: arrowLeft,
    arrowTop: arrowTop
  };
};

var getTooltipBoundary = function getTooltipBoundary(keepTooltipInside) {
  // add viewport
  var boundingBox = {
    top: 0,
    left: 0,

    /* eslint-disable-next-line no-undef */
    width: window.innerWidth,

    /* eslint-disable-next-line no-undef */
    height: window.innerHeight
  };

  if (typeof keepTooltipInside === 'string') {
    /* eslint-disable-next-line no-undef */
    var selector = document.querySelector(keepTooltipInside);

    if (false) {
      if (selector === null) throw new Error(keepTooltipInside + " selector does not exist : keepTooltipInside must be a valid html selector 'class' or 'Id'  or a boolean value");
    }

    if (selector !== null) boundingBox = selector.getBoundingClientRect();
  }

  return boundingBox;
};

var calculatePosition = function calculatePosition(triggerBounding, ContentBounding, position, arrow, _ref2, keepTooltipInside) {
  var offsetX = _ref2.offsetX,
      offsetY = _ref2.offsetY;
  var bestCoords = {
    arrowLeft: '0%',
    arrowTop: '0%',
    left: 0,
    top: 0,
    transform: 'rotate(135deg)'
  };
  var i = 0;
  var wrapperBox = getTooltipBoundary(keepTooltipInside);
  var positions = Array.isArray(position) ? position : [position]; // keepTooltipInside would be activated if the  keepTooltipInside exist or the position is Array

  if (keepTooltipInside || Array.isArray(position)) positions = [].concat(positions, POSITION_TYPES); // add viewPort for WarpperBox
  // wrapperBox.top = wrapperBox.top + window.scrollY;
  // wrapperBox.left = wrapperBox.left + window.scrollX;

  while (i < positions.length) {
    bestCoords = getCoordinatesForPosition(triggerBounding, ContentBounding, positions[i], arrow, {
      offsetX: offsetX,
      offsetY: offsetY
    });
    var contentBox = {
      top: bestCoords.top,
      left: bestCoords.left,
      width: ContentBounding.width,
      height: ContentBounding.height
    };

    if (contentBox.top <= wrapperBox.top || contentBox.left <= wrapperBox.left || contentBox.top + contentBox.height >= wrapperBox.top + wrapperBox.height || contentBox.left + contentBox.width >= wrapperBox.left + wrapperBox.width) {
      i++;
    } else {
      break;
    }
  }

  return bestCoords;
};

var popupIdCounter = 0;

var getRootPopup = function getRootPopup() {
  var PopupRoot = document.getElementById('popup-root');

  if (PopupRoot === null) {
    PopupRoot = document.createElement('div');
    PopupRoot.setAttribute('id', 'popup-root');
    document.body.appendChild(PopupRoot);
  }

  return PopupRoot;
};

var Popup = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_ref, ref) {
  var _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? null : _ref$trigger,
      _ref$onOpen = _ref.onOpen,
      onOpen = _ref$onOpen === void 0 ? function () {} : _ref$onOpen,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$defaultOpen = _ref.defaultOpen,
      defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? undefined : _ref$open,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$nested = _ref.nested,
      nested = _ref$nested === void 0 ? false : _ref$nested,
      _ref$closeOnDocumentC = _ref.closeOnDocumentClick,
      closeOnDocumentClick = _ref$closeOnDocumentC === void 0 ? true : _ref$closeOnDocumentC,
      _ref$repositionOnResi = _ref.repositionOnResize,
      repositionOnResize = _ref$repositionOnResi === void 0 ? true : _ref$repositionOnResi,
      _ref$closeOnEscape = _ref.closeOnEscape,
      closeOnEscape = _ref$closeOnEscape === void 0 ? true : _ref$closeOnEscape,
      _ref$on = _ref.on,
      on = _ref$on === void 0 ? ['click'] : _ref$on,
      _ref$contentStyle = _ref.contentStyle,
      contentStyle = _ref$contentStyle === void 0 ? {} : _ref$contentStyle,
      _ref$arrowStyle = _ref.arrowStyle,
      arrowStyle = _ref$arrowStyle === void 0 ? {} : _ref$arrowStyle,
      _ref$overlayStyle = _ref.overlayStyle,
      overlayStyle = _ref$overlayStyle === void 0 ? {} : _ref$overlayStyle,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottom center' : _ref$position,
      _ref$modal = _ref.modal,
      modal = _ref$modal === void 0 ? false : _ref$modal,
      _ref$lockScroll = _ref.lockScroll,
      lockScroll = _ref$lockScroll === void 0 ? false : _ref$lockScroll,
      _ref$arrow = _ref.arrow,
      arrow = _ref$arrow === void 0 ? true : _ref$arrow,
      _ref$offsetX = _ref.offsetX,
      offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX,
      _ref$offsetY = _ref.offsetY,
      offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY,
      _ref$mouseEnterDelay = _ref.mouseEnterDelay,
      mouseEnterDelay = _ref$mouseEnterDelay === void 0 ? 100 : _ref$mouseEnterDelay,
      _ref$mouseLeaveDelay = _ref.mouseLeaveDelay,
      mouseLeaveDelay = _ref$mouseLeaveDelay === void 0 ? 100 : _ref$mouseLeaveDelay,
      _ref$keepTooltipInsid = _ref.keepTooltipInside,
      keepTooltipInside = _ref$keepTooltipInsid === void 0 ? false : _ref$keepTooltipInsid,
      children = _ref.children;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(open || defaultOpen),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var triggerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var contentRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var arrowRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var focusedElBeforeOpen = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var popupId = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])("popup-" + ++popupIdCounter);
  var isModal = modal ? true : !trigger;
  var timeOut = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
  useIsomorphicLayoutEffect(function () {
    if (isOpen) {
      focusedElBeforeOpen.current = document.activeElement;
      setPosition();
      focusContentOnOpen(); // for accessibility

      lockScrolll();
    } else {
      resetScroll();
    }

    return function () {
      clearTimeout(timeOut.current);
    };
  }, [isOpen]); // for uncontrolled popup we need to sync isOpen with open prop

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (typeof open === 'boolean') {
      if (open) openPopup();else closePopup();
    }
  }, [open, disabled]);

  var openPopup = function openPopup(event) {
    if (isOpen || disabled) return;
    setIsOpen(true);
    setTimeout(function () {
      return onOpen(event);
    }, 0);
  };

  var closePopup = function closePopup(event) {
    var _focusedElBeforeOpen$;

    if (!isOpen || disabled) return;
    setIsOpen(false);
    if (isModal) (_focusedElBeforeOpen$ = focusedElBeforeOpen.current) === null || _focusedElBeforeOpen$ === void 0 ? void 0 : _focusedElBeforeOpen$.focus();
    setTimeout(function () {
      return onClose(event);
    }, 0);
  };

  var togglePopup = function togglePopup(event) {
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    if (!isOpen) openPopup(event);else closePopup(event);
  };

  var onMouseEnter = function onMouseEnter(event) {
    clearTimeout(timeOut.current);
    timeOut.current = setTimeout(function () {
      return openPopup(event);
    }, mouseEnterDelay);
  };

  var onContextMenu = function onContextMenu(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    togglePopup();
  };

  var onMouseLeave = function onMouseLeave(event) {
    clearTimeout(timeOut.current);
    timeOut.current = setTimeout(function () {
      return closePopup(event);
    }, mouseLeaveDelay);
  };

  var lockScrolll = function lockScrolll() {
    if (isModal && lockScroll) document.getElementsByTagName('body')[0].style.overflow = 'hidden'; // migrate to document.body
  };

  var resetScroll = function resetScroll() {
    if (isModal && lockScroll) document.getElementsByTagName('body')[0].style.overflow = 'auto';
  };

  var focusContentOnOpen = function focusContentOnOpen() {
    var _contentRef$current;

    var focusableEls = contentRef === null || contentRef === void 0 ? void 0 : (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    var firstEl = Array.prototype.slice.call(focusableEls)[0];
    firstEl === null || firstEl === void 0 ? void 0 : firstEl.focus();
  };

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(ref, function () {
    return {
      open: function open() {
        openPopup();
      },
      close: function close() {
        closePopup();
      },
      toggle: function toggle() {
        togglePopup();
      }
    };
  }); // set Position

  var setPosition = function setPosition() {
    if (isModal || !isOpen) return;
    if (!(triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) || !(triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current) || !(contentRef === null || contentRef === void 0 ? void 0 : contentRef.current)) return; /// show error as one of ref is undefined

    var trigger = triggerRef.current.getBoundingClientRect();
    var content = contentRef.current.getBoundingClientRect();
    var cords = calculatePosition(trigger, content, position, arrow, {
      offsetX: offsetX,
      offsetY: offsetY
    }, keepTooltipInside);
    contentRef.current.style.top = cords.top + window.scrollY + "px";
    contentRef.current.style.left = cords.left + window.scrollX + "px";

    if (arrow && !!arrowRef.current) {
      var _arrowStyle$top, _arrowStyle$left;

      arrowRef.current.style.transform = cords.transform;
      arrowRef.current.style.setProperty('-ms-transform', cords.transform);
      arrowRef.current.style.setProperty('-webkit-transform', cords.transform);
      arrowRef.current.style.top = ((_arrowStyle$top = arrowStyle.top) === null || _arrowStyle$top === void 0 ? void 0 : _arrowStyle$top.toString()) || cords.arrowTop;
      arrowRef.current.style.left = ((_arrowStyle$left = arrowStyle.left) === null || _arrowStyle$left === void 0 ? void 0 : _arrowStyle$left.toString()) || cords.arrowLeft;
    }
  }; // hooks


  useOnEscape(closePopup, closeOnEscape); // can be optimized if we disabled for hover

  useTabbing(contentRef, isOpen && isModal);
  useRepositionOnResize(setPosition, repositionOnResize);
  useOnClickOutside(!!trigger ? [contentRef, triggerRef] : [contentRef], closePopup, closeOnDocumentClick && !nested); // we need to add a ne
  // render the trigger element and add events

  var renderTrigger = function renderTrigger() {
    var triggerProps = {
      key: 'T',
      ref: triggerRef,
      'aria-describedby': popupId.current
    };
    var onAsArray = Array.isArray(on) ? on : [on];

    for (var i = 0, len = onAsArray.length; i < len; i++) {
      switch (onAsArray[i]) {
        case 'click':
          triggerProps.onClick = togglePopup;
          break;

        case 'right-click':
          triggerProps.onContextMenu = onContextMenu;
          break;

        case 'hover':
          triggerProps.onMouseEnter = onMouseEnter;
          triggerProps.onMouseLeave = onMouseLeave;
          break;

        case 'focus':
          triggerProps.onFocus = onMouseEnter;
          triggerProps.onBlur = onMouseLeave;
          break;
      }
    }

    if (typeof trigger === 'function') {
      var comp = trigger(isOpen);
      return !!trigger && __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(comp, triggerProps);
    }

    return !!trigger && __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(trigger, triggerProps);
  };

  var addWarperAction = function addWarperAction() {
    var popupContentStyle = isModal ? Style.popupContent.modal : Style.popupContent.tooltip;
    var childrenElementProps = {
      className: "popup-content " + (className !== '' ? className.split(' ').map(function (c) {
        return c + "-content";
      }).join(' ') : ''),
      style: _extends({}, popupContentStyle, contentStyle, {
        pointerEvents: 'auto'
      }),
      ref: contentRef,
      onClick: function onClick(e) {
        e.stopPropagation();
      }
    };

    if (!modal && on.indexOf('hover') >= 0) {
      childrenElementProps.onMouseEnter = onMouseEnter;
      childrenElementProps.onMouseLeave = onMouseLeave;
    }

    return childrenElementProps;
  };

  var renderContent = function renderContent() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", Object.assign({}, addWarperAction(), {
      key: "C",
      role: isModal ? 'dialog' : 'tooltip',
      id: popupId.current
    }), arrow && !isModal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      ref: arrowRef,
      style: Style.popupArrow
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
      "data-testid": "arrow",
      className: "popup-arrow " + (className !== '' ? className.split(' ').map(function (c) {
        return c + "-arrow";
      }).join(' ') : ''),
      viewBox: "0 0 32 16",
      style: _extends({
        position: 'absolute'
      }, arrowStyle)
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
      d: "M16 0l16 16H0z",
      fill: "currentcolor"
    }))), children && typeof children === 'function' ? children(closePopup, isOpen) : children);
  };

  var overlay = !(on.indexOf('hover') >= 0);
  var ovStyle = isModal ? Style.overlay.modal : Style.overlay.tooltip;
  var content = [overlay && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    key: "O",
    "data-testid": "overlay",
    "data-popup": isModal ? 'modal' : 'tooltip',
    className: "popup-overlay " + (className !== '' ? className.split(' ').map(function (c) {
      return c + "-overlay";
    }).join(' ') : ''),
    style: _extends({}, ovStyle, overlayStyle, {
      pointerEvents: closeOnDocumentClick && nested || isModal ? 'auto' : 'none'
    }),
    onClick: closeOnDocumentClick && nested ? closePopup : undefined,
    tabIndex: -1
  }, isModal && renderContent()), !isModal && renderContent()];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, renderTrigger(), isOpen && __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(content, getRootPopup()));
});

/* harmony default export */ __webpack_exports__["a"] = (Popup);

//# sourceMappingURL=reactjs-popup.esm.js.map


/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_ga4__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_3_react_ga4___default.a.initialize("G-WDEJDCK7QT");var About=function(_Component){_inherits(About,_Component);function About(props){_classCallCheck(this,About);var _this=_possibleConstructorReturn(this,(About.__proto__||Object.getPrototypeOf(About)).call(this,props));_this.state={show:false};return _this;}_createClass(About,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["e" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{justifyContent:'space-between',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){_this2.props.history.goBack();},circular:true,style:{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'chevron left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Header */],{as:'h1'},'About Us')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:36}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Quyana tailuci!'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,' Una yuarcuun website-aq computer science-aakun caliaqellruaput. Wangkuk Egalaaq Alaskuk-llu anglillruukuk Qusquqviim nuniini. Una caliaput piurtesciigacartuq ikayuqsaitellrukatkut amlleret yuut. Quyavikaput elitnauristeput, Yugtun igatulit, ilaput-llu tamalkuita.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We are proud to be a team of Yup\'ik developers. Current contributors are Christopher Egalaaq Liu, from Mamterilleq (Bethel, Alaska), ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://temigo.github.io/'},'Laura Domine'),' from Paris, and Lonny Alaskuk Strunk from Kuinerraq (Quinhagak, Alaska).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We would like to properly cite and express gratitude for grammar material from the following books, "',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'A Practical Grammar of the Central Alaskan Yup\'ik Eskimo Language'),'" and the "',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Yup\'ik Eskimo Dictionary'),'" compiled by Steve Jacobson, Anna Jacobson, and others. Their work made all of this possible. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,' Quyavikamceci. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The first release of this website (Oct 2018) was supported through the Yuarcuun Initiative and received financial sponsorship. At that time, the initiative was financially supported by the\xa0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{textDecoration:'underline'},onClick:function onClick(){_this2.setState({show:!_this2.state.show});}},'following entities'),'.'),this.state.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Bethel Native Corporation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Bering Straits Native Corporation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Donlin Gold'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Calista Corporation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Alaska Federation of Natives'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Alaska Native Heritage Center (Non-profit Sponsor)')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In the second update (Jan 2021), we integrated a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://digital.lib.washington.edu/researchworks/bitstream/handle/1773/46496/Strunk_washington_0250O_22260.pdf?sequence=1&isAllowed=y'},'Yugtun morphological parser'),' created by Lonny Alaskuk Strunk. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In the third update (Feb 2023), we added an advanced sentence builder, a Yugtun audio library, and a conversational module in partnership with the Native Village of Kwinhagak (NVK), Orutsararmiut Native Council (ONC), and KYUK. This update was made possible by Grant Number 90XN0110-01-00 from Administration for Native Americans. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please contact us at yuarcuun @ gmail dot com for questions about our projects or to discuss any new projects.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,' Quyana cakneq! '),' '));}}]);return About;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_qaneryaurci_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_dialogueListGenerator_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_sentenceTransitionTimings_js__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_scroll__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_ga4__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_9_react_ga4___default.a.initialize("G-WDEJDCK7QT");var scroll=__WEBPACK_IMPORTED_MODULE_8_react_scroll__["animateScroll"];var Dialogues=function(_Component){_inherits(Dialogues,_Component);function Dialogues(props){_classCallCheck(this,Dialogues);var _this=_possibleConstructorReturn(this,(Dialogues.__proto__||Object.getPrototypeOf(Dialogues)).call(this,props));_this.initializeMatrix=function(){_this.setState({exerciseNumberMatrix:[].concat(_toConsumableArray(Array(_this.state.lesson.dialogues.length))).map(function(x){return _this.state.exerciseNumber;})});console.log(_this.state.dialogues[_this.state.lesson.dialogues[0][0]]['audio']);fetch(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/audiolibrarydialogues/"+_this.state.dialogues[_this.state.lesson.dialogues[0][0]]['audio']).then(function(response){console.log('contains audio');}).catch(function(error){_this.setState({audioExists:false});});};_this.initialize=function(){_this.setState({record:{},currentCounter:0,showYupik:false,showEnglishMatrix:[]});_this.playNextSentence(0);};_this.inputtedWord=function(event){_this.setState({inputtedWords:event.target.value});};console.log(props);var currentLesson=decodeURI(props.match.params.num);var dialog_gen=Object(__WEBPACK_IMPORTED_MODULE_5__constants_dialogueListGenerator_js__["a" /* dialogueGenerator */])();var exercise_gen=Object(__WEBPACK_IMPORTED_MODULE_5__constants_dialogueListGenerator_js__["b" /* exerciseGenerator */])(dialog_gen.lessons[currentLesson],dialog_gen.dialogues,dialog_gen.bagOfWords);_this.state={show:false,currentLesson:currentLesson,exerciseNumber:props.location.state===undefined?-1:props.location.state.exerciseNumber,lessonIndex:props.location.state===undefined?-1:props.location.state.lessonIndex,exerciseNumberMatrix:[],currentCounter:-1,// questionMode:0,
showCurrent:false,correct:'assirpagta',inputtedWords:'',record:{},randomCounters:{},lesson:exercise_gen.lesson,dialogues:exercise_gen.dialogues,audioExists:true,visible:[true,true,true,true,true,true,true,true,true,true],playingAudio:false,showContinue:false,showAll:false,showEnglish:false,showEnglishMatrix:[],showAlternateList:[]};return _this;}_createClass(Dialogues,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.exerciseNumber!==this.state.exerciseNumber){this.initializeMatrix();}}},{key:'componentWillMount',value:function componentWillMount(){this.initializeMatrix();}},{key:'repeatAudio',value:function repeatAudio(audio,event,data){var sound=new Audio(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/audiolibrarydialogues/"+audio);sound.play();}},{key:'correctSound',value:function correctSound(event,data){// console.log(audio)
var sound=new Audio(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/audiolibrarydialogues/"+'correct_half.mp3');sound.play();}},{key:'incorrectSound',value:function incorrectSound(event,data){// console.log(audio)
var sound=new Audio(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/audiolibrarydialogues/"+'incorrect_half.mp3');sound.play();}// displayAlternates = (i, currentCounter, randomExerciseCounter, typeAttributes) => {
//   // console.log(i, currentCounter, randomExerciseCounter, currentCounter)
//   // console.log('currentCounter',currentCounter)
//   // console.log('i',i)
//   // console.log('randomExerciseCounter',randomExerciseCounter)
//   // console.log('typeAttributes',typeAttributes)
//   let showEnglishMatrix = this.state.showEnglishMatrix
//   return <span>{i.map((k,index)=> 
//     randomExerciseCounter !== index ?
//       <div style={{fontSize:'20px',textAlign:(this.state.dialogues[i[index]]['speaker']=='a'?'left':'right')}}>
//       <div style={{paddingBottom:'10px',fontSize:'18px',marginRight:'10px',marginLeft:'10px'}}>{"wall'u"}</div>
//       <div style={{display:'inline-block',border:(this.state.currentlyPlaying === currentCounter && this.state.currentlyPlayingIndex == index ? "1px solid #b0d1e7": "1px solid #d7d7d7"),borderRadius:'10px',padding:'10px',maxWidth:'80%',marginBottom:'10px'}}>
//       {this.state.dialogues[i[index]]['speaker']=='a' ?
//         null
//         :
//         <span style={{paddingRight:'5px', cursor:'pointer'}}><Icon name='volume up' color='black' onClick={()=>{this.playCurrentSentence(currentCounter, index)}} /></span>
//       }
//       {this.state.dialogues[i[index]]['yup'].split(" ").map((k,kindex)=>
//           <span style={{opacity:(this.state.visible[kindex] && this.state.currentlyPlaying == currentCounter && this.state.currentlyPlayingIndex == index ? 1.0 : 0.5),marginRight:'6px'}}>
//             {k}
//           </span>
//       )}
//       {this.state.dialogues[i[index]]['speaker']=='a' ? 
//         <span style={{paddingLeft:'5px', cursor:'pointer'}}><Icon name='volume up' color='black' onClick={()=>{this.playCurrentSentence(currentCounter, index)}} /></span>
//         :
//         null
//       }
//       {this.state.showEnglish ?
//         null
//         :
//         <Icon onClick={()=>{{this.state.showEnglishMatrix.includes(i[index]) ? showEnglishMatrix.splice(showEnglishMatrix.indexOf(i[index]),1) : showEnglishMatrix = showEnglishMatrix.concat(i[index])}; this.setState({showEnglishMatrix:showEnglishMatrix})}} style={{color:'#d4d4d4',width:'22px',paddingLeft:'5px'}} link name='comment alternate outline'>{'\n'}</Icon>
//       }
//       {this.state.showEnglishMatrix.includes(i[index]) ?
//         <div style={{color:'#b9b9b9',fontWeight:(window.innerWidth < 480 ? '400':'200'),marginTop:'5px'}}>{this.state.dialogues[i[index]]['eng']}</div>
//         :
//         null
//       }
//       </div>
//     </div>
//     :
//     null
//   )}</span>
// }
},{key:'normalize',value:function normalize(text){var newText=text.toLowerCase();newText=newText.replace(/[’ʼ]/,"'");newText=newText.replace(/[?!.,;:"]/,"");newText=newText.normalize();return newText;}},{key:'checkInputCorrect',value:function checkInputCorrect(match,index,dialogueInfo,language,event,data){console.log(dialogueInfo);if(this.normalize(this.state.inputtedWords)===this.normalize(match.toLowerCase())){this.correctSound.bind(this)();var record=this.state.record;record[index]={'userInput':this.state.inputtedWords,'correct':true};this.setState({record:record,currentScore:this.state.currentScore+1});if(language==='yupik'&&this.state.exerciseNumber!==5){setTimeout(function(){this.repeatAudio(dialogueInfo['audio']);}.bind(this),150);}}else{this.incorrectSound.bind(this)();var record=this.state.record;record[index]={'userInput':this.state.inputtedWords,'correct':false};if(language==='yupik'&&this.state.exerciseNumber!==5){setTimeout(function(){this.repeatAudio(dialogueInfo['audio']);}.bind(this),150);}}// this.iterateOne();
this.setState({record:record,showContinue:true,inputtedWords:''});}},{key:'checkSelectCorrect',value:function checkSelectCorrect(match,word,index,dialogueInfo,language,event,data){console.log(dialogueInfo);var optionsTried=[];var record=this.state.record;if(index in this.state.record){optionsTried=this.state.record[index]['optionsTried'];}if(!optionsTried.includes(word)&&!optionsTried.includes(match)){if(word===match){this.correctSound.bind(this)();optionsTried=optionsTried.concat([word]);this.setState({showContinue:true});if(language==='yupik'){setTimeout(function(){this.repeatAudio(dialogueInfo['audio']);}.bind(this),150);}record[index]={'optionsTried':optionsTried};}else{this.incorrectSound.bind(this)();optionsTried=optionsTried.concat([word]);if(optionsTried.length===3){optionsTried=optionsTried.concat([match]);this.setState({showContinue:true});// if (language === 'yupik') {
//   setTimeout(function() {this.repeatAudio(dialogueInfo['audio'])}.bind(this),150)
// }
}record[index]={'optionsTried':optionsTried};}this.setState({record:record});}}},{key:'playNextSentence',value:function playNextSentence(nextIndex){if(this.state.lesson.dialogues.length>nextIndex){if([-1,3,4,5].includes(this.state.exerciseNumberMatrix[nextIndex])){this.playCurrentSentence(nextIndex,this.state.lesson.dialogues[nextIndex][0]);}}}},{key:'playCurrentSentence',value:function playCurrentSentence(index,name){var _this2=this;console.log(name);if(!this.state.playingAudio){var audio=this.state.dialogues[name]['audio'];if(audio.length>0){fetch(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/audiolibrarydialogues/"+audio).then(function(response){_this2.setState({playingAudio:true,currentlyPlaying:name});var dialogueName=name;__WEBPACK_IMPORTED_MODULE_6__constants_sentenceTransitionTimings_js__["a" /* sentenceTransitionTimings */][dialogueName].map(function(j,jindex){_this2.setState({visible:[true,false,false,false,false,false,false,false,false,false]},function(){setTimeout(function(){var visible=_this2.state.visible;visible[jindex+1]=true;_this2.setState({visible:visible});if(jindex==__WEBPACK_IMPORTED_MODULE_6__constants_sentenceTransitionTimings_js__["a" /* sentenceTransitionTimings */][dialogueName].length-1){_this2.setState({visible:[true,true,true,true,true,true,true,true,true,true]});}},j);});});_this2.sound=new Audio(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+"/audiolibrarydialogues/"+audio);_this2.sound.play();_this2.sound.onended=function(){clearTimeout();_this2.setState({playingAudio:false,currentlyPlaying:-1});if([-1].includes(_this2.state.exerciseNumberMatrix[index])){_this2.setState({showContinue:true});}};}).catch(function(error){_this2.setState({audioExists:false,playingAudio:false,currentlyPlaying:-1});if([-1].includes(_this2.state.exerciseNumberMatrix[index])){_this2.setState({showContinue:true});}});}}}},{key:'stopCurrentSentence',value:function stopCurrentSentence(){clearTimeout();if(this.sound){this.sound.pause();}this.setState({playingAudio:false,currentlyPlaying:-1});}},{key:'returnBottomPart',value:function returnBottomPart(name,dialogueInfo,exerciseNum){if(exerciseNum==-1){return null;}else if(exerciseNum==0){}}},{key:'returnTopPart',value:function returnTopPart(index,name,dialogueInfo,exerciseNum,isCurrent){// console.log(dialogueInfo)
var customFont={fontSize:'20px',display:'inline-block',border:"1px solid #d7d7d7",borderRadius:'10px',padding:'10px',minWidth:'200px',maxWidth:'80%',marginTop:'5px',marginBottom:'5px'};var toptextStyle={color:'#000000DE'};var textStyle={color:'#000000DE',fontWeight:window.innerWidth<480?'400':'200'};if(exerciseNum==-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.returnContent('yupikReadOnly',dialogueInfo,name,index,textStyle));}else if(exerciseNum==0){if(isCurrent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:dialogueInfo['speaker']=='a'?'flex-start':'flex-end',lineHeight:'30px'}},this.returnContent('englishNotStyled',dialogueInfo,name,index,textStyle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'10px'}}),this.state.showYupik?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:dialogueInfo['speaker']=='a'?'flex-start':'flex-end',lineHeight:'31px'}},this.returnContent('yupikNotStyled',dialogueInfo,name,index,textStyle)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:dialogueInfo['speaker']=='a'?'flex-start':'flex-end',height:'30px',marginTop:'1px'}},this.returnContent('showYupikButton',dialogueInfo,name,index,textStyle)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:dialogueInfo['speaker']=='a'?'flex-start':'flex-end',lineHeight:'30px'}},this.returnContent('englishNotStyled',dialogueInfo,name,index,textStyle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'10px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:dialogueInfo['speaker']=='a'?'flex-start':'flex-end',lineHeight:'31px'}},this.returnContent('yupikNotStyled',dialogueInfo,name,index,textStyle)));}}else if(exerciseNum==1){if(isCurrent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},this.returnContent('englishUnderlined',dialogueInfo,name,index,toptextStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),index in this.state.record?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.returnContent('yupikUnderlined',dialogueInfo,name,index,textStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('userRegularInput',dialogueInfo,name,index,textStyle,'yupik')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.returnContent('selection',dialogueInfo,name,index,textStyle,'yupik'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('regularInput',dialogueInfo,name,index,textStyle,'yupik')));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},this.returnContent('englishUnderlined',dialogueInfo,name,index,toptextStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('yupikUnderlined',dialogueInfo,name,index,textStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('userRegularInput',dialogueInfo,name,index,textStyle,'yupik'));}}else if(exerciseNum==2){if(isCurrent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},this.returnContent('englishUnderlined',dialogueInfo,name,index,toptextStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),index in this.state.record?this.state.record[index]['optionsTried'].includes(dialogueInfo['yupikQuestionCorrect'])?this.returnContent('yupikUnderlined',dialogueInfo,name,index,textStyle):this.returnContent('selection',dialogueInfo,name,index,textStyle,'yupik'):this.returnContent('selection',dialogueInfo,name,index,textStyle,'yupik'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('options',dialogueInfo,name,index,textStyle,'yupik'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},this.returnContent('englishUnderlined',dialogueInfo,name,index,toptextStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('yupikUnderlined',dialogueInfo,name,index,textStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('options',dialogueInfo,name,index,textStyle,'yupik'));}}else if(exerciseNum==3){if(isCurrent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},this.returnContent('yupikUnderlined',dialogueInfo,name,index,toptextStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),index in this.state.record?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.returnContent('englishUnderlined',dialogueInfo,name,index,textStyle),this.returnContent('userRegularInput',dialogueInfo,name,index,textStyle,'english')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.returnContent('selection',dialogueInfo,name,index,textStyle,'english'),this.returnContent('regularInput',dialogueInfo,name,index,textStyle,'english')));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},this.returnContent('yupikUnderlined',dialogueInfo,name,index,toptextStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('englishUnderlined',dialogueInfo,name,index,textStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('userRegularInput',dialogueInfo,name,index,textStyle,'english'));}}else if(exerciseNum==4){if(isCurrent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},this.returnContent('yupikUnderlined',dialogueInfo,name,index,toptextStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),index in this.state.record?this.state.record[index]['optionsTried'].includes(dialogueInfo['englishQuestionCorrect'])?this.returnContent('englishUnderlined',dialogueInfo,name,index,textStyle):this.returnContent('selection',dialogueInfo,name,index,textStyle,'english'):this.returnContent('selection',dialogueInfo,name,index,textStyle,'english'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('options',dialogueInfo,name,index,textStyle,'english'));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},this.returnContent('yupikUnderlined',dialogueInfo,name,index,toptextStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('englishUnderlined',dialogueInfo,name,index,textStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('options',dialogueInfo,name,index,textStyle,'english'));}}else if(exerciseNum==5){if(isCurrent){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},index in this.state.record?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.returnContent('yupikUnderlined',dialogueInfo,name,index,textStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('userRegularInput',dialogueInfo,name,index,textStyle,'yupik')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.returnContent('listeningselection',dialogueInfo,name,index,textStyle,'yupik'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('regularInput',dialogueInfo,name,index,textStyle,'yupik')));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:customFont},this.returnContent('yupikUnderlined',dialogueInfo,name,index,textStyle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'5px'}}),this.returnContent('userRegularInput',dialogueInfo,name,index,textStyle,'yupik'));}}}},{key:'returnContent',value:function returnContent(type,dialogueInfo,name,index,textStyle,language){var _this3=this;var showEnglishMatrix=this.state.showEnglishMatrix;var correctColor='#6cb590';var incorrectColor="#ff5757";var parts=[0,0,0];console.log(type);if(type==='yupikNotStyled'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{lineHeight:'24px',textAlign:dialogueInfo['speaker']=='a'?'left':'right'}},dialogueInfo['speaker']=='a'?null:this.state.audioExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',height:'20px',fontSize:'19px',width:'35px',paddingRight:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',onClick:function onClick(){_this3.playCurrentSentence(index,name);}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,dialogueInfo['yupik']),dialogueInfo['speaker']=='a'&&this.state.audioExists?this.state.audioExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',height:'20px',fontSize:'19px',width:'35px',paddingLeft:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',onClick:function onClick(){_this3.playCurrentSentence(index,name);}})):null:null);}else if(type==='showYupikButton'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{size:'tiny',onClick:function onClick(){_this3.stopCurrentSentence();_this3.setState({showYupik:true,showContinue:true},function(){_this3.playCurrentSentence(index,name);});}},"Guess Yup'ik");}else if(type==='yupikUnderlined'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{lineHeight:'30px'}},dialogueInfo['speaker']=='a'&&this.state.audioExists?null:this.state.audioExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',fontSize:'21px',width:'35px',paddingRight:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',onClick:function onClick(){_this3.playCurrentSentence(index,name);}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:textStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:dialogueInfo['speaker']=='b'&&!this.state.audioExists?'35px':'0px'}},dialogueInfo['yupikQuestion'][0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{borderBottom:'1px solid #000000cc',paddingBottom:'1px'}},dialogueInfo['yupikQuestionCorrect']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:dialogueInfo['speaker']=='a'&&!this.state.audioExists?'35px':'0px'}},dialogueInfo['yupikQuestion'][2])),dialogueInfo['speaker']=='a'&&this.state.audioExists?this.state.audioExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',fontSize:'21px',width:'35px',paddingLeft:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',onClick:function onClick(){_this3.playCurrentSentence(index,name);}})):null:null);}else if(type==='englishUnderlined'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:Object.assign({lineHeight:'30px',textAlign:dialogueInfo['speaker']=='a'?'left':'right'},textStyle)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,dialogueInfo['englishQuestion'][0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{borderBottom:'1px solid #000000cc',paddingBottom:'1px'}},dialogueInfo['englishQuestionCorrect']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,dialogueInfo['englishQuestion'][2]));}else if(type==='regularInput'){if(language==='english'){parts=[dialogueInfo['englishQuestionCorrect']];}else if(language==='yupik'){parts=[dialogueInfo['yupikQuestionCorrect']];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'8px',fontSize:'20px',textAlign:dialogueInfo['speaker']=='a'?'left':'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:dialogueInfo['speaker']=='a'?'flex-start':'flex-end'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */],{autoComplete:'off',onSubmit:this.checkInputCorrect.bind(this,parts[0],index,dialogueInfo,language)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */].Input,{style:{fontSize:'16px'},autoFocus:'autoFocus',placeholder:'',value:this.state.inputtedWords,onChange:this.inputtedWord.bind(this)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('script',{type:'text/javascript'},'document.theFormID.theFieldID.focus();'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{disabled:this.state.inputtedWords.length==0,type:'submit',onClick:this.checkInputCorrect.bind(this,parts[0],index,dialogueInfo,language)},'Submit'));}else if(type==='userRegularInput'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'flex-end',marginBottom:'5px',fontWeight:window.innerWidth<480?'400':'200',height:'28px',justifyContent:dialogueInfo['speaker']=='a'?'left':'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:this.state.record[index]['correct']?correctColor:incorrectColor,fontWeight:window.innerWidth<480?'400':'200'}},this.state.record[index]['userInput']));}else if(type==='yupikSelection'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{lineHeight:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'20px',textAlign:dialogueInfo['speaker']=='a'?'left':'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:dialogueInfo['speaker']=='a'?'flex-start':'flex-end'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:textStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginLeft:dialogueInfo['speaker']=='a'?'0px':'35px'}},dialogueInfo['yupikQuestion'][0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{borderBottom:'1px solid #000000cc',color:'white',paddingBottom:'1px'}},dialogueInfo['yupikQuestionCorrect']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{marginRight:dialogueInfo['speaker']=='a'?'35px':'0px'}},dialogueInfo['yupikQuestion'][2])))));}else if(type==='selection'){if(language==='english'){parts=[dialogueInfo['englishQuestion'][0],dialogueInfo['englishQuestionCorrect'],dialogueInfo['englishQuestion'][2]];}else if(language==='yupik'){parts=[dialogueInfo['yupikQuestion'][0],dialogueInfo['yupikQuestionCorrect'],dialogueInfo['yupikQuestion'][2]];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{lineHeight:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'20px',textAlign:dialogueInfo['speaker']=='a'?'left':'right'}},dialogueInfo['speaker']=='a'&&this.state.audioExists?null:this.state.audioExists&&language==='yupik'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',fontSize:'21px',width:'35px',paddingRight:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',style:{color:'white'}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:textStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,parts[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{borderBottom:'1px solid #000000cc',color:'white',paddingBottom:'1px'}},parts[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,parts[2])),dialogueInfo['speaker']=='a'&&this.state.audioExists?this.state.audioExists&&language==='yupik'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',fontSize:'21px',width:'35px',paddingLeft:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',style:{color:'white'}})):null:null));}else if(type==='listeningselection'){parts=[dialogueInfo['yupikQuestion'][0],dialogueInfo['yupikQuestionCorrect'],dialogueInfo['yupikQuestion'][2]];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{lineHeight:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'20px',textAlign:dialogueInfo['speaker']=='a'?'left':'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:dialogueInfo['speaker']=='a'?'flex-start':'flex-end'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:textStyle},dialogueInfo['speaker']=='a'&&this.state.audioExists?null:this.state.audioExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',fontSize:'21px',width:'35px',paddingRight:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',onClick:function onClick(){_this3.playCurrentSentence(index,name);}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,parts[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{borderBottom:'1px solid #000000cc',color:'white',paddingBottom:'1px'}},parts[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,parts[2]),dialogueInfo['speaker']=='a'&&this.state.audioExists?this.state.audioExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{display:'inline-block',fontSize:'21px',width:'35px',paddingLeft:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',onClick:function onClick(){_this3.playCurrentSentence(index,name);}})):null:null))));}else if(type==='options'){if(language==='english'){parts=[dialogueInfo['englishQuestionOptions'],dialogueInfo['englishQuestionCorrect']];}else if(language==='yupik'){parts=[dialogueInfo['yupikQuestionOptions'],dialogueInfo['yupikQuestionCorrect']];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'10px',fontSize:'20px',textAlign:dialogueInfo['speaker']=='a'?'left':'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',alignItems:'flex-start',justifyContent:dialogueInfo['speaker']=='a'?'flex-start':'flex-end'}},parts[0].map(function(k,kindex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this3.checkSelectCorrect.bind(_this3,parts[1],k,index,dialogueInfo,language),'class':'grid-verticaloptioncenter',style:{cursor:'pointer',fontWeight:window.innerWidth<480?'400':'200',border:index in _this3.state.record?_this3.state.record[index]['optionsTried'].includes(k)?k===parts[1]?'1px solid #69cd6e':'1px solid #ffffff':null:null,color:index in _this3.state.record?_this3.state.record[index]['optionsTried'].includes(k)?k===parts[1]?'#32a038':'#d4d4d4':null:null}},k);})));}else if(type==='yupikUserInput'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontWeight:window.innerWidth<480?'400':'200'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#b9b9b9'}},dialogueInfo['yupikQuestion'][0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:this.state.record[index]['correct']?correctColor:incorrectColor,fontWeight:window.innerWidth<480?'400':'200'}},this.state.record[index]['userInput']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#b9b9b9'}},dialogueInfo['yupikQuestion'][2]));}else if(type==='yupikInputCorrect'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontWeight:window.innerWidth<480?'400':'200',marginBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#b9b9b9'}},dialogueInfo['yupikQuestion'][0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,dialogueInfo['yupikQuestionCorrect']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#b9b9b9'}},dialogueInfo['yupikQuestion'][2]));}else if(type==='englishNotStyled'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:Object.assign({lineHeight:'24px',textAlign:dialogueInfo['speaker']=='a'?'left':'right'},textStyle)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,dialogueInfo['english']));}else if(type==='yupikReadOnly'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'20px',textAlign:dialogueInfo['speaker']=='a'?'left':'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'inline-block',border:this.state.currentlyPlaying===name?"1px solid #b0d1e7":"1px solid #d7d7d7",borderRadius:'10px',padding:'10px',maxWidth:'80%',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'inline-block'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,dialogueInfo['speaker']=='a'&&this.state.audioExists?null:this.state.audioExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingRight:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',onClick:function onClick(){_this3.playCurrentSentence(index,name);}})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{lineHeight:'24px'}},dialogueInfo['yupik']),dialogueInfo['speaker']=='a'&&this.state.audioExists?this.state.audioExists?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{paddingLeft:'5px',cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',onClick:function onClick(){_this3.playCurrentSentence(index,name);}})):null:null),this.state.showEnglish?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){{_this3.state.showEnglishMatrix.includes(name)?showEnglishMatrix.splice(showEnglishMatrix.indexOf(name),1):showEnglishMatrix=showEnglishMatrix.concat(name);};_this3.setState({showEnglishMatrix:showEnglishMatrix});},style:{color:'#d4d4d4',width:'22px',paddingLeft:'5px',marginTop:'5px'},link:true,name:'comment alternate outline'},'\n')),this.state.showEnglishMatrix.includes(name)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#000000DE',fontWeight:window.innerWidth<480?'400':'200',marginTop:'5px',lineHeight:'24px'}},dialogueInfo['english']):null)));}}},{key:'showContinue',value:function showContinue(index){var _this4=this;if(this.state.showContinue){if(this.state.lesson.dialogues.length-1===this.state.currentCounter){this.props.updateCompleted(this.state.lessonIndex,this.state.exerciseNumber);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){_this4.initialize();}},'Redo'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'/dialogues'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],null,'Continue')));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{icon:true,circular:true,size:'huge',onClick:function onClick(){_this4.stopCurrentSentence();if(![-1].includes(_this4.state.exerciseNumberMatrix[index])){_this4.setState({showYupik:false});}_this4.setState({showContinue:false,currentCounter:_this4.state.currentCounter+1},function(){_this4.playNextSentence(index+1);});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'chevron down'}));}}if(window.innerWidth>=480){scroll.scrollToBottom();}}},{key:'render',value:function render(){var _this5=this;console.log(this.state);console.log(this.props);// let exerciseNum = this.state.exerciseNumber
// if (exerciseNum == '10') {
//   //alternate between exerciseNumbers
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:5,paddingLeft:5}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */],{textAlign:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Column,{style:{maxWidth:'800px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{justifyContent:'space-between',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{onClick:function onClick(){_this5.props.history.goBack();},circular:true,style:{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'chevron left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',fontWeight:'bold',fontSize:'14px'}},this.state.lesson.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',color:'grey',fontStyle:'italic'}},this.state.lesson.context)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:36}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.currentCounter==-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{style:{width:'200px'},onClick:function onClick(){_this5.setState({currentCounter:0},function(){_this5.playNextSentence(0);});}},'Ayagnia')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.lesson.dialogues.map(function(k,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,index<_this5.state.currentCounter?k.map(function(j,jindex){return jindex===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:_this5.state.dialogues[j]['speaker']=='a'?'left':'right'}},_this5.returnTopPart(index,j,_this5.state.dialogues[j],_this5.state.exerciseNumberMatrix[index],false)):null;}):null,index==_this5.state.currentCounter?k.map(function(j,jindex){return jindex===0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:_this5.state.dialogues[j]['speaker']=='a'?'left':'right'}},_this5.returnTopPart(index,j,_this5.state.dialogues[j],_this5.state.exerciseNumberMatrix[index],true),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',alignItems:'center',height:'80px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,_this5.showContinue(index)))):null;}):null);}))))));}}]);return Dialogues;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Dialogues);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dialogueList; });
var dialogueList=[[2,5,1,1,"a","Kaigtuten-qaa?","Are you hungry?","kaig-1.mp3",105,"Kaigtuten-qaa?: Are you hungry?","Host asking guest","<Kaig>tuten-qaa?","Kaig;Meqsug;Assir","Are you <hungry>?","hungry;thirsty;good","Kaig<tuten>-qaa?","tuten;tuci;tutek;tuq","<Are you> hungry?","Are you;Are you all;Are you two;Is he","<Kaigtuten>-qaa?","<Kaigtuten-qaa?>","ii-i;kaig-;akutaq;akutaryug-","yes;to be hungry;akutaq;to want akutaq","listenchoose-full","fillinblank1","","","v","JJ",""],[2,5,1,2,"b","Ii-i kaigtua.","Yes, I'm hungry.","kaig-2.mp3",,"","","Ii-i kaig<tua>.","kaig;meqsug;assir","Yes, <I'm> hungry.","hungry;thirsty;good","Ii-i kaig<tua>.","tua;tuci;tuq;tuten","Yes, <I'm> hungry.","I'm;You all are;He is;You are","","","","","chooseoption-endingEnglish","fillinblank2","","","e","",""],[2,5,1,3,"a","Akutaryugtuten-qaa?","Do you want some akutaq?","kaig-3.mp3",,"","","<Akutar>yugtuten-qaa?","Akutar;Mer;Assaliar","Do you want some <akutaq>?","akutaq;water;fry bread","Akutaryug<tuten>-qaa?","tuten;tuci;tutek;tuq","<Do you> want some akutaq?","Do you;Do you all;Do you two;Does he","","","","","chooseoption-baseEnglish","fillinblank-endingYupik","","","n","sg",""],[2,5,1,4,"b","Ii-i.","Yes, please.","kaig-4.mp3",,"","","<Ii-i>.","Ii-i;Qang-a","<Yes>, please.","Yes;No","<Ii-i>.","Ii-i;Qang-a","<Yes>, please.","Yes;No","","","","","listenchoose-endingYupik","fillinblank-baseYupik","","","p","",""],[2,8,1,1,"a","Yuurqeryugtuten-qaa?","Would you like something hot to drink (usually tea)?","yuurqar-1.mp3",106,"Yuurqeryugtuten-qaa?:Would you like a hot drink?","Host asking guest","<Yuurqer>yugtuten-qaa?","Yuurqer;Ner;Aqum","Would you like <something hot to drink (usually tea)>?","something hot to drink (usually tea);to eat;to sit","Yuurqeryug<tuten>-qaa?","tuten;tuci;tutek;tuq","Would <you> like something hot to drink (usually tea)?","you;you all;you two;she","","","yuurqar-;pi-;piyug-;ak'a","to have a hot drink;to do;to want to do;already","fillinblank-endingYupik","chooseoption-endingEnglish","","","v","NN",""],[2,8,1,2,"b","Ii-i yuurqeryugtua.","Yes, I would like some tea.","yuurqar-2.mp3",,"","","Ii-i <yuurqer>yugtua.","pi;ner;aqum","Yes, I would like <some tea>.","to;to eat;to sit","Ii-i piyug<tua>.","tua;tuci;tuq;tuten","Yes, <I> would.","I;you all;she;","","","","","chooseoption-full","listenchoose-full","","","v","DT",""],[2,8,1,2,"b","Ak'a yuurqallruunga.","I've already had tea.","yuurqar-2b.mp3",,"","","Ak'a <yuurqa>llruunga.","yuurqallru;nerellru;aqumellru","I've already <had tea>.","had tea;eaten;sat down","Ak'a yuurqallru<unga>.","unga;uci;ukut;uten","<I've> already had tea.","I've;You all have;You two have;You've","","","","","","","","","v","VBD",""],[3,4,1,1,"a","Ellami-lli assirpaa!","How nice it is outside!","ellami-1.mp3",601,"Ellami-lli assirpaa!: How nice it is outside!","","<Ella>mi-lli assirpaa!","","How nice it is <outside>!","","","","","","","","","","","","","","n","sg",""],[3,4,1,2,"b","Ii-i, ella assirtuq.","Yes, it really is nice out.","ellami-2.mp3",,"","","Ii-i, ella <assir>tuq.","","Yes, it really is <nice> out.","","","","","","","","","","","","","","v","JJ",""],[3,4,1,2,"b","Assiryaqlirtuq.","It's finally nice out.","ellami-2b.mp3",,"","","<Assir>yaqlirtuq.","","It's finally <nice> out.","","","","","","","","","","","","","","v","JJ",""],[3,4,4,1,"a","Cam ilakaten?","Who are you related to?","cam-1.mp3",104,"Cam ilakaten?: Who are you related to?","","Cam <ila>katen?","","Who are you <related> to?","","","","","","","","","","","","","","n","sg",""],[3,4,4,1,"a","Kia ilakaten?","Who are you related to?","cam-1b.mp3",,"","","Kia <ila>katen?","","Who are you <related> to?","","","","","","","","","","","","","","n","sg",""],[3,4,4,1,"a","Kia yuk'aten?","Whose offspring are you?","cam-1c.mp3",,"","","Kia <yuk>'aten?","","Whose <offspring> are you?","","","","","","","","","","","","","","n","sg",""],[3,4,4,2,"b","Nuk'am yukaanga.","I'm Nuk'aq's offspring.","cam-2.mp3",,"","","Nuk'am <yuk>aanga.","","I'm Nuk'aq's <offspring>.","","","","","","","","","","","","","","n","sg",""],[3,4,4,2,"b","Nuk'am tutgarqaanga.","I am Nuk'aq's grandchild.","cam-2b.mp3",,"","","Nuk'am <tutgar>qaanga.","","I am Nuk'aq's <grandchild>.","","","","","","","","","","","","","","n","sg",""],[3,4,5,1,"a","Camiungusit?","Where are you from?","camiu-1.mp3",203,"Camiungusit?: Where are you from?","","<Ca>miungusit?","","<Where> are you from?","","","","","","","","","","","","","","n","sg",""],[3,4,5,2,"b","Makumiunguunga.","I'm from here.","camiu-2.mp3",,"","","<Maku>miunguunga.","","I'm from <here>.","","","","","","","","","","","","","","n","sg",""],[3,4,5,2,"b","Kuigilngurmiunguunga.","I'm from Kwigillingok.","camiu-2b.mp3",,"","","<Kuigilngur>miunguunga.","","I'm from <Kwigillingok>.","","","","","","","","","","","","","","n","sg",""],[3,14,1,1,"a","Waqaa?","What's up?","waqaa-1.mp3",201,"Waqaa?: What's up?","","<Waqaa>?","","<What's up>?","","","","","","","","","","","","","","p","",""],[3,14,1,2,"b","Ellmikun.","Just visiting.","waqaa-2.mp3",,"","","<Ellmikun>.","","<Just visiting>.","","","","","","","","","","","","","","p","",""],[3,14,2,1,"a","Cangacit?","How are you?","iqvallruu-1.mp3",1,"Iqvallruuten-qaa?: Did you go berry picking?","Two friends see each other","Canga<cit>?","cit;sit","How are <you>?","","Canga<cit>?","cit;sit","How are <you>?","","","","","","1","","","","e","",""],[3,14,2,2,"b","Assirtua, elpet-mi?","I'm fine, and you?","iqvallruu-2.mp3",,"","","<Assir>tua, elpet-mi?","tua;tunga;tuten;tuq","I'm <fine>, and you?","","Assir<tua>, elpet-mi?","tua;tunga;tuten;tuq","<I'm> fine, and you?","","","","","","1","","","","v","NN",""],[3,14,2,2,"b","Cangatenritua, elpet-mi?","I'm fine, and you?","iqvallruu-2b.mp3",,"","","Cangatenrit<ua>, elpet-mi?","ua;unga;uten;uq","<I'm> fine, and you?","","Cangatenrit<ua>, elpet-mi?","ua;unga;uten;uq","<I'm> fine, and you?","","","","","","1","","","","e","",""],[3,14,2,3,"a","Wii-ll' assirtua. Iqvallruuten-qaa?","I'm fine also. Have you been picking berries?","iqvallruu-3.mp3",,"","","Wii-ll' assirtua. <Iqva>llruuten-qaa?","uten;uci;unga;uq","I'm fine also. Have you been <picking berries>?","","Wii-ll' assirtua. Iqvallru<uten>-qaa?","uten;uci;unga;uq","I'm fine also. Have <you> been picking berries?","","","","","","1","","","","v","VBG",""],[3,14,2,4,"b","Ii-i, iqvallruunga curanek.","Yes, I picked blueberries.","iqvallruu-4.mp3",,"","","Ii-i, iqvallruunga <cura>nek.","unga;ua;uten;ukut","Yes, I picked <blueberries>.","","Ii-i, iqvallru<unga> curanek.","unga;ua;uten;ukut","Yes, <I> picked blueberries.","","","","","","1","","","","n","pl",""],[3,14,2,5,"a","Qangvaq iqvallrusit?","When were you picking?","iqvallruu-5.mp3",,"","","Qangvaq iqvallru<sit>?","sit;cit","When were <you> picking?","","Qangvaq iqvallru<sit>?","sit;cit","When were <you> picking?","","","","","","1","","","","e","",""],[3,14,2,6,"b","Yaaliagni.","The day before yesterday.","iqvallruu-6.mp3",,"","","<Yaaliagni>.","","<The day before yesterday>.","","Yaaliagni.","","The day before yesterday.","","","","","","-1","","","","p","",""],[3,22,1,1,"a","Kipusvigciiquten-qaa?","Will you go to the store?","snuukuuq-1.mp3",5,"Snuukuuq: The Snow-go","","<Kipusvig>ciiquten-qaa?","","Will you go to the <store>?","","","","","","","","","","","","","","n","sg",""],[3,22,1,2,"b","Ii-i, piciqua. Snuukuuliurtua.","Yes, I will. I'm working on the snow-go.","snuukuuq-2.mp3",,"","","Ii-i, piciqua. <Snuukuu>liurtua.","","Yes, I will. I'm working on the <snow-go>.","","","","","","","","","","","","","","n","sg",""],[3,22,1,3,"a","Snuukuun-qaa assiituq?","Is something wrong with your snow-go?","snuukuuq-3.mp3",,"","","Snuukuun-qaa <assiit>uq?","","Is something <wrong> with your snow-go?","","","","","","","","","","","","","","v","JJ",""],[3,22,1,4,"b","Akwaugaq pissullemni kaviaq malirqallemku naqugutii navellruuq.","While I was hunting yesterday the belt broke when I raced after a fox.","snuukuuq-4.mp3",,"","","Akwaugaq pissullemni kaviaq malirqallemku naqugutii <nave>llruuq.","","While I was hunting yesterday the belt <broke> when I raced after a fox.","","","","","","","","","","","","","","v","VBD",""],[3,22,1,5,"a","Qaillun tua-ll' utercit?","How, then, did you return?","snuukuuq-5.mp3",,"","","Qaillun tua-ll' <uter>cit?","","How, then, did you <return>?","","","","","","","","","","","","","","v","NN",""],[3,22,1,6,"b","Naqugut'linqigqaarluku utertellruunga, tau͡gaam allakucim snuukuum pikaa. Allamek kipuciiqua kipusvigmek.","I came home after changing the belt, but they are of a different model. I'll buy a different kind from the store.","snuukuuq-6.mp3",,"","","Naqugut'linqigqaarluku utertellruunga, tau͡gaam allakucim snuukuum pikaa. Allamek kipuciiqua <kipusvig>mek.","","I came home after changing the belt, but they are of a different model. I'll buy a different kind from the <store>.","","","","","","","","","","","","","","n","sg",""],[4,2,1,1,"a","Calilartuten-qaa High School-ami?","Do you work at the high shcool?","elitnaurista-1.mp3",501,"Elitnaurista: The Teacher","","<Cali>lartuten-qaa High School-ami?","","Do you <work> at the high shcool?","","","","","","","","","","","","","","v","NN",""],[4,2,1,2,"b","Ii-i, elitnaurilartua Yugtun iganermek.","Yes, I teach Yup'ik writing.","elitnaurista-2.mp3",,"","","Ii-i, <elitnauri>lartua Yugtun iganermek.","","Yes, I <teach> Yup'ik writing.","","","","","","","","","","","","","","v","VB",""],[4,2,1,3,"a","Caperrnarquq-qaa elitnaurilleq High School-anek","Is it difficult teaching high school students?","elitnaurista-3.mp3",,"","","<Caperrnarq>uq-qaa elitnaurilleq High School-anek","","Is it <difficult> teaching high school students?","","","","","","","","","","","","","","v","JJ",""],[4,2,1,4,"b","Caperrnaituq. Qavarnilartut tau͡gaam unuakumi.","It's not difficult. But they are sleepy in the morning.","elitnaurista-4.mp3",,"","","<Caperrnait>uq. Qavarnilartut tau͡gaam unuakumi.","","It's <not difficult>. But they are sleepy in the morning.","","","","","","","","","","","","","","v","RB",""],[4,6,7,1,"a","Aptellruan-qaa?","Did you ask him?","aptellru-1.mp3",502,"Aptellruan-qaa?: Did you ask him?","","<Apte>llruan-qaa?","","Did you <ask> him?","","","","","","","","","","","","","","v","VB",""],[4,6,7,2,"b","Apcullruaqa tau͡gaam takaryullruunga.","I wanted to ask him, but I was shy.","aptellru-2.mp3",,"","","Apcullruaqa tau͡gaam <takaryu>llruunga.","","I wanted to ask him, but I was <shy>.","","","","","","","","","","","","","","v","VB",""],[4,6,7,3,"a","Ciin?","Why?","aptellru-3.mp3",,"","","<Ciin>?","","<Why>?","","","","","","","","","","","","","","p","",""],[4,6,7,4,"b","Naamell'.","I don't know.","aptellru-4.mp3",,"","","<Naamell'>.","","<I don't know>.","","","","","","","","","","","","","","p","",""],[4,6,7,4,"b","Takarnarquq.","He's the kind of person that makes people feel shy.","aptellru-4b.mp3",,"","","<Takarnarq>uq.","","He's <the kind of person that makes people feel shy>.","","","","","","","","","","","","","","v","DT",""],[4,6,8,1,"a","Aptellruan-qaa?","Did you ask her?","aptellruan-1.mp3",503,"Aptellruan-qaa?: Did you ask her?","","<Apte>llruan-qaa?","","Did you <ask> her?","","","","","","","","","","","","","","v","VB",""],[4,6,8,2,"b","Ii-i, aptellruyaaqaqa. Kiuksaitaanga tau͡gaam.","I asked her. But she hasn't replied yet.","aptellruan-2.mp3",,"","","Ii-i, aptellruyaaqaqa. Kiuksaitaanga <tau͡gaam>.","","I asked her. <But> she hasn't replied yet.","","","","","","","","","","","","","","p","",""],[4,6,8,3,"a","Qaku kiuciqa?","When is she going to reply?","aptellruan-3.mp3",,"","","<Qaku> kiuciqa?","","<When> is she going to reply?","","","","","","","","","","","","","","p","",""],[4,6,8,4,"b","Kiungaitaanga aipaagni.","Well, she probably won't answer me anyway. (Literally, this is something like 'On the other hand, she probably won't answer me.')","aptellruan-4.mp3",,"","","<Kiu>ngaitaanga aipaagni.","","Well, she probably won't <answer> me anyway. (Literally, this is something like 'On the other hand, she probably won't answer me.')","","","","","","","","","","","","","","v","NN",""],[4,6,9,1,"a","Pilugugyugtua.","I want some skin boots.","qavcitun-1.mp3",103,"Qavcitun akingqerta?: How much does it cost?","","<Pilugug>yugtua.","","I want some <skin boots>.","","","","","","","","","","","","","","n","sg",""],[4,6,9,2,"b","Tangellruunga pilugugnek kipusvigmi.","I saw a pair of skin boots at the store.","qavcitun-2.mp3",,"","","<Tange>llruunga pilugugnek kipusvigmi.","","I <saw> a pair of skin boots at the store.","","","","","","","","","","","","","","v","VBD",""],[4,6,9,3,"a","Qavcitun-kiq akingqertak?","I wonder how much they cost?","qavcitun-3.mp3",,"","","Qavcitun-kiq <akingqer>tak?","","I wonder how much they <cost>?","","","","","","","","","","","","","","v","NN",""],[4,6,9,4,"b","Akituyugnarquk.","I think they are expensive.","qavcitun-4.mp3",,"","","<Akitu>yugnarquk.","","I think they <are expensive>.","","","","","","","","","","","","","","v","VBP",""],[4,15,2,1,"a","Tangellruan-qaa imna elitnaurista?","Did you see that teacher?","imna-1.mp3",402,"Imna Elitnaurista: That Aformentioned Teacher","Two men talking","<Tange>llruan-qaa imna elitnaurista?","an;uten;aten;a","Did you <see> that teacher?","","Tangellru<an>-qaa imna elitnaurista?","an;uten;aten;a","Did <you> see <that> teacher?","","","","","","1","","","","v","UH",""],[4,15,2,2,"b","Kina?","Who?","imna-2.mp3",,"","","<Kina>?","Kina;Kia;Kitumek","<Who>?","","<Kina>?","Kina;Kia;Kitumek","<Who>?","","","","","","1","","","","p","",""],[4,15,2,3,"a","Imna-wa sugtulria high school-ami elitnaurituli.","You know that tall one that teaches at the high school.","imna-3.mp3",,"","","Imna-wa sugtu<lria> high school-ami elitnaurituli.","lria;lriit;nguq;lnguq","You know that tall <one that> teaches at the high school.","","Imna-wa sugtu<lria> high school-ami elitnaurituli.","lria;lriit;nguq;lnguq","You know that tall <one that> teaches at the high school.","","","","","","1","","","","e","",""],[4,15,2,4,"b","Ii-i nallunritaqa.","Yes, I know him.","imna-4.mp3",,"","","Ii-i <nallunrit>aqa.","aqa;anka;aanga;ua","Yes, I <know> him.","","Ii-i nallunrit<aqa>.","aqa;anka;aanga;ua","Yes, <I> know <him>.","","","","","","1","","","","v","VB",""],[4,15,2,5,"a","Qanrutellruanga pissurciquq-gguq Maqinermi.","He told me that he's going hunting on Saturday.","imna-5.mp3",,"","","<Qanrute>llruanga pissurciquq-gguq Maqinermi.","anga;aqa;uq;a","He <told> me that he's going hunting on Saturday.","","Qanrutellru<anga> pissurciquq-gguq Maqinermi.","anga;aqa;uq;a","<He> told <me> that he's going hunting on Saturday.","","","","","","1","","","","v","VBD",""],[4,15,2,6,"b","Nani-gguq pissurciqa?","Where did he say he's going to hunt?","imna-6.mp3",,"","","Nani-gguq pissurciq<a>?","a;sit;at;uq","Where did he say <he>'s going to hunt?","","Nani-gguq pissurciq<a>?","a;sit;at;uq","Where did he say he's going to hunt?","","","","","","1","","","","e","",""],[4,15,2,7,"a","Naamell', yaaqvanun ayagngaicugnarquq. Snuukuura-gguq assissiyaanrituq.","I don't know, he probably won't go very far. He said that his snow-go isn't working too well.","imna-7.mp3",,"","","Naamell', yaaqvanun ayagngaicugnarquq. Snuukuu<ra>-gguq assissiyaanrituq.","ra;qa;ri;put","I don't know, he probably won't go very far. He said that <his> snow-go isn't working too well.","","Naamell', yaaqvanun ayagngaicugnarquq. Snuukuu<ra>-gguq assissiyaanrituq.","ra;qa;ri;put","I don't know, he probably won't go very far. He said that <his> snow-go isn't working too well.","","","","","","1","","","","e","",""],[4,15,3,1,"a","Kusquqvagmiunguuq-qaa?","Is she from the Kuskokwim?","kuigpak-1.mp3",403,"Kuigpagmiunguuq: She's from the Yukon","","<Kusquqvag>miunguuq-qaa?","","Is she from the <Kuskokwim>?","","","","","","","","","","","","","","n","sg",""],[4,15,3,2,"b","Kuigpagmiunguuq.","She's from the Yukon.","kuigpak-2.mp3",,"","","<Kuigpag>miunguuq.","","She's from the <Yukon>.","","","","","","","","","","","","","","n","sg",""],[4,15,3,3,"a","Naken Kuigpagmi?","Where on the Yukon?","kuigpak-3.mp3",,"","","<Naken> Kuigpagmi?","","<Where> on the Yukon?","","","","","","","","","","","","","","p","",""],[4,15,3,4,"b","Alarnermek.","From Alakanuk.","kuigpak-4.mp3",,"","","<Alarner>mek.","","From <Alakanuk>.","","","","","","","","","","","","","","n","sg",""],[4,15,3,5,"a","Yuralartut-qaa Alarnermi?","Do they Eskimo dance in Alakanuk?","kuigpak-5.mp3",,"","","<Yura>lartut-qaa Alarnermi?","","Do they <Eskimo dance> in Alakanuk?","","","","","","","","","","","","","","v","NNP",""],[4,15,3,6,"b","Yuralaryugnarqut.","I think they Eskimo dance.","kuigpak-6.mp3",,"","","Yuralaryugnarq<ut>.","","I think <they> Eskimo dance.","","","","","","","","","","","","","","e","",""],[4,15,3,7,"a","Qasgirtangqertuq-qaa tamaani?","Is there a kashim there?","kuigpak-7.mp3",,"","","Qasgirtangqertuq-qaa <tamaa>ni?","","Is there a kashim <there>?","","","","","","","","","","","","","","n","sg",""],[4,15,3,8,"b","Qasgirtangqerrsugnarquq.","There probably is a kashim there.","kuigpak-8.mp3",,"","","<Qasgir>tangqerrsugnarquq.","","There probably is a <kashim> there.","","","","","","","","","","","","","","n","sg",""],[4,15,4,1,"a","Atkukan-qaa tauna?","Is that your parka?","atkuk-1.mp3",301,"Atkuk: The Parka","","Atkukan-qaa <tauna>?","Atku;Angya;Aana","Is <that> your parka?","","","","","","","","atkuk;kipute-;piliaq;pike-","parka;to buy;made thing;to have <it> as ones own","listenchoose-baseYupik","chooseoption-baseYupik","","","n","sg",""],[4,15,4,2,"b","Ii-i, atkukaqa.","Yes, it's my parka.","atkuk-2a.mp3",,"","","Ii-i, <atku>kaqa.","","Yes, it's my <parka>.","","","","","","","","","","listenchoose-full","chooseoption-full","","","n","sg",""],[4,15,4,2,"b","Atkukenritaqa.","It's not my parka.","atkuk-2b.mp3",,"","","<Atku>kenritaqa.","","It's not my <parka>.","","","","","","","","","","","","","","n","sg",""],[4,15,4,3,"a","Kia piliaqau?","Who made it?","atkuk-3a.mp3",,"","","<Kia> piliaqau?","","<Who> made it?","","","","","","","","","","listenchoose-full","chooseoption-full","","","p","",""],[4,15,4,3,"a","Kia pikau?","Whose is it?","atkuk-3b.mp3",,"","","Kia <pik>au?","","<Whose> is it?","","","","","","","","","","","","","","v","WP$",""],[4,15,4,4,"b","Pass'am piliaqaa.","Pass'aq made it.","atkuk-4a.mp3",,"","","Pass'am <pilia>qaa.","","Pass'aq <made> it.","","","","","","","","","","listenchoose-full","chooseoption-full","","","n","sg",""],[4,15,4,4,"b","Agayulirtem pikaa.","It belongs to the priest.","atkuk-4b.mp3",,"","","<Agayulirte>m pikaa.","","It belongs to the <priest>.","","","","","","","","","","","","","","n","sg",""],[4,15,4,5,"a","Kiputellruan-qaa?","Did you buy it?","atkuk-5.mp3",,"","","<Kipute>llruan-qaa?","an;aqa;anka;a","Did you <buy> it?","","Kiputellru<an>-qaa?","an;aqa;anka;a","Did <you> buy <it>?","","","","","","listenchoose-endingYupik","chooseoption-endingYupik","","","v","VB",""],[4,15,4,6,"b","Ii-i, kiputellruaqa.","Yes, I bought it.","atkuk-6.mp3",,"","","<Ii-i>, kiputellruaqa.","aqa;anka;a;an","<Yes>, I bought it.","","Ii-i, kiputellru<aqa>.","aqa;anka;a;an","Yes, <I> bought <it>.","","","","","","listenchoose-endingYupik","chooseoption-endingYupik","","","p","",""],[4,15,5,1,"a","Qaillun Kass'atun pilarta nanvaq?","How do you say nanvaq in English?","kassatun-1.mp3",101,"Qaillun Kass'atun pilarta ___?: How do you say __ in English? ","","Qaillun <Kass'atun> pilarta nanvaq?","","How do you say nanvaq <in English>?","","","","","","","","","","","","","","p","",""],[4,15,5,2,"b","Lake-amek.","A lake.","kassatun-2a.mp3",,"","","Lake-a<mek>.","","<A> lake.","","","","","","","","","","","","","","e","",""],[4,15,5,2,"b","Pond-amek.","A pond.","kassatun-2b.mp3",,"","","Pond-a<mek>.","","<A> pond.","","","","","","","","","","","","","","e","",""],[4,15,7,1,"a","Mingqelartuten-qaa?","Do you sew?","mingqe-1.mp3",302,"Mingqelartuten-qaa?: Do you sew?","","Mingqelar<tuten>-qaa?","","Do <you> sew?","","","","","","","","","","","","","","e","",""],[4,15,7,2,"b","Ii-i, mingqelartua.","Yes, I sew.","mingqe-2.mp3",,"","","Ii-i, <mingqe>lartua.","","Yes, I <sew>.","","","","","","","","","","","","","","v","VB",""],[4,15,7,2,"b","Mingqeksaitua. Nenglengkan atam tau͡gaam mingqengniartua.","I haven't sewn yet. I usually begin sewing when it gets cold.","mingqe-3.mp3",,"","","Mingqeksaitua. <Nengle>ngkan atam tau͡gaam mingqengniartua.","","I haven't sewn yet. I usually begin sewing when it gets <cold>.","","","","","","","","","","","","","","n","sg",""],[4,15,7,3,"a","Piluguliyugngaciqan-qaa aipaqa?","Will you be able to make mukluks for my spouse?","mingqe-4.mp3",,"","","Piluguliyugngaciqan-qaa <aipa>qa?","","Will you be able to make mukluks for my <spouse>?","","","","","","","","","","","","","","n","sg",""],[4,15,7,4,"b","Cakucignek?","What kind?","mingqe-5.mp3",,"","","<Cakuci>gnek?","","What <kind>?","","","","","","","","","","","","","","n","sg",""],[4,15,7,5,"a","Tuntum iruinek.","Caribou leggings.","mingqe-6.mp3",,"","","<Tuntu>m iruinek.","","<Caribou> leggings.","","","","","","","","","","","","","","n","sg",""],[4,15,9,1,"a","Qaillun pilarta Yugtun meat-aq?","How do you say meat in Yup'ik?","yugtun-1.mp3",102,"Qaillun pilarta Yugtun ___?: How do you say __ in Yup'ik?","","Qaillun pilarta <Yugtun> meat-aq?","","How do you say meat <in Yup'ik>?","","","","","","","","","","","","","","p","",""],[4,15,9,2,"b","Kemek.","Meat.","yugtun-2.mp3",,"","","<Kemek>.","","<Meat>.","","","","","","","","","","","","","","n","sg",""],[4,15,9,3,"a","Church-aq-mi?","What about church?","yugtun-3.mp3",,"","","Church-aq-<mi>?","","<What about> church?","","","","","","","","","","","","","","p","",""],[4,15,9,4,"b","Agayuvik.","Church.","yugtun-4.mp3",,"","","<Agayuvik>.","","<Church>.","","","","","","","","","","","","","","n","sg",""],[4,21,1,1,"a","Manalartuten-qaa?","Have you been jigging?","manalar-1.mp3",801,"Manalartuten-qaa?: Have you been jigging?","","<Mana>lartuten-qaa?","","Have you been <jigging>?","","","","","","","","","","","","","","v","JJ",""],[4,21,1,2,"b","Manaqsaitua. Manaryaryugyaaqua tau͡gaam Maqinermi ella assiqan. Elpet-qaa manalartuten?","I haven't been jigging yet, but I'd like to go on Saturday if the weather is good. How about you, have you been jigging?","manalar-2.mp3",,"","","Manaqsaitua. Manaryaryugyaaqua tau͡gaam <Maqiner>mi ella assiqan. Elpet-qaa manalartuten?","","I haven't been jigging yet, but I'd like to go on <Saturday> if the weather is good. How about you, have you been jigging?","","","","","","","","","","","","","","n","sg",""],[4,21,1,3,"a","Manaryallruyaaqua uumi cangellrunritua tau͡gaam.","I went jigging the other day, but I didn't catch anything.","manalar-3.mp3",,"","","Manaryallruyaaqua uumi <cange>llrunritua tau͡gaam.","","I went jigging the other day, but I didn't <catch> anything.","","","","","","","","","","","","","","v","VB",""],[4,21,1,4,"b","Nani manallrusit?","Where did you jig?","manalar-4.mp3",,"","","Nani <mana>llrusit?","","Where did you <jig>?","","","","","","","","","","","","","","v","NN",""],[4,21,1,5,"a","Kuigem paingani.","At the mouth of the river.","manalar-5.mp3",,"","","<Kuig>em paingani.","","At the mouth of the <river>.","","","","","","","","","","","","","","n","sg",""],[4,21,2,1,"a","Tuntutuliarmun-qaa ayallruuten?","Did you go to Tuntutuliak?","maqaruaq-1.mp3",701,"Maqaruanek: Rabbits","","Tuntutuliarmun-qaa <aya>llruuten?","","Did you <go> to Tuntutuliak?","","","","","","","","","","","","","","v","VB",""],[4,21,2,2,"b","Ii-i, pissullruunga maqaruanek Tuntutuliarmiut nuniitni.","Yes, I was hunting rabbits near Tuntutuliak. (lit., 'in the land of the people of Tuntutuliak')","maqaruaq-2.mp3",,"","","Ii-i, pissullruunga <maqarua>nek Tuntutuliarmiut nuniitni.","","Yes, I was hunting <rabbit>s near Tuntutuliak. (lit., 'in the land of the people of Tuntutuliak')","","","","","","","","","","","","","","n","sg",""],[4,21,2,3,"a","Nagg'un pissullrusit?","How are you hunting?","maqaruaq-3.mp3",,"","","Nagg'un <pissu>llrusit?","","How are you <hunting>?","","","","","","","","","","","","","","v","NN",""],[4,21,2,4,"b","Snuukuukun. Maqaruanek amllernek tangellruunga tau͡gaam nuyurtallruut.","By snow-machine. I saw lots of rabbits, but they were pretty shy.","maqaruaq-4.mp3",,"","","Snuukuukun. Maqaruanek amllernek tangellruunga tau͡gaam <nuyurta>llruut.","","By snow-machine. I saw lots of rabbits, but they were pretty <shy>.","","","","","","","","","","","","","","v","VB",""],[4,21,2,5,"a","Qavcinek pit'ellrusit?","How many did you catch?","maqaruaq-5.mp3",,"","","Qavcinek <pit'e>llrusit?","","How many did you <catch>?","","","","","","","","","","","","","","v","VB",""],[4,21,2,6,"b","Qulnek.","Ten.","maqaruaq-6.mp3",,"","","<Qul>nek.","","<Ten>.","","","","","","","","","","","","","","n","sg",""],[4,21,4,1,"a","Ac'aq qanellruuq agayulirta-gguq tekiciiquq.","Ac'aq said that the priest is going to arrive.","agayulirta-1.mp3",404,"Agayulirta: The Priest","","Ac'aq qanellruuq <agayulirta>-gguq tekiciiquq.","","Ac'aq said that the <priest> is going to arrive.","","","","","","","","","","","","","","n","sg",""],[4,21,4,2,"b","Caciqa?","What will he do?","agayulirta-2.mp3",,"","","Caciq<a>?","","What will <he> do?","","","","","","","","","","","","","","e","",""],[4,21,4,3,"a","Imna naulluulria tangerrsugaa.","He wants to see that sick person.","agayulirta-3.mp3",,"","","Imna naulluulria <tangerr>sugaa.","","He wants to <see> that sick person.","","","","","","","","","","","","","","v","UH",""],[4,21,4,4,"b","Agayuciqut-llu-qaa?","Will they hold church services also?","agayulirta-4.mp3",,"","","<Agayu>ciqut-llu-qaa?","","Will they <hold church services> also?","","","","","","","","","","","","","","v","VB",""],[4,21,4,5,"a","Ii-i, agayuyullruuq-llu.","Yes, he wants to hold church also.","agayulirta-5.mp3",,"","","Ii-i, agayuyullru<uq>-llu.","","Yes, <he> wants to hold church also.","","","","","","","","","","","","","","e","",""],[4,21,5,1,"a","Ikayuryugarpenga-qaa atata angyaqa aguskumku?","Do you want to help me later when I bring up my boat?","angyaqa-1.mp3",902,"Angyaqa: My Boat","On telephone or C-B radio.","<Ikayur>yugarpenga-qaa atata angyaqa aguskumku?","","Do you want to <help> me later when I bring up my boat?","","","","","","","","","","","","","","v","VB",""],[4,21,5,2,"b","Ii-i, trailer-aangqertuten-qaa?","Yes, do you have a trailer?","angyaqa-2.mp3",,"","","Ii-i, trailer-aangqer<tuten>-qaa?","","Yes, do <you> have a trailer?","","","","","","","","","","","","","","e","",""],[4,21,5,3,"a","Aptellruaqa Sak'aq trailer-aara aturyugluku.","I asked Sak'aq if I could use his trailer.","angyaqa-3.mp3",,"","","Aptellruaqa Sak'aq trailer-aara <atur>yugluku.","","I asked Sak'aq if I could <use> his trailer.","","","","","","","","","","","","","","v","NN",""],[4,21,5,4,"b","Yuurqerraarlua taiciqua. Maqiyugtuten-qaa angyaq tagqaarluku?","After I have tea I'll come. Do you want to steam after we move the boat?","angyaqa-4.mp3",,"","","<Yuurqe>rraarlua taiciqua. Maqiyugtuten-qaa angyaq tagqaarluku?","","After I <have tea> I'll come. Do you want to steam after we move the boat?","","","","","","","","","","","","","","v","VBP",""],[4,21,5,5,"a","Ii-i, maqiyugtua cakneq.","Yes, I really want to steam.","angyaqa-5.mp3",,"","","Ii-i, <maqi>yugtua cakneq.","","Yes, I really want to <steam>.","","","","","","","","","","","","","","v","NN",""],[4,21,5,6,"b","Tua-i.","That's all.","angyaqa-6.mp3",,"","","<Tua-i>.","","<That's all>.","","","","","","","","","","","","","","p","",""],[4,21,7,1,"a","Camek kiputellrusit kipusvigmek?","What did you buy from the store?","kipusvik-1.mp3",304,"Kipusvigmek: From The Store","At home","Camek <kipute>llrusit kipusvigmek?","","What did you <buy> from the store?","","","","","","","","","","","","","","v","VB",""],[4,21,7,2,"b","Kuuvviamek, saayumek, tuntum kemganek allanek-llu.","Some coffee, tea, caribou meat and other things.","kipusvik-2.mp3",,"","","Kuuvviamek, saayumek, tuntum kemganek <alla>nek-llu.","","Some coffee, tea, caribou meat and <other thing>s.","","","","","","","","","","","","","","n","sg",""],[4,21,7,3,"a","Tangellruan-qaa Ac'aq kipusvigmi?","Did you see Ac'aq at the store?","kipusvik-3.mp3",,"","","<Tange>llruan-qaa Ac'aq kipusvigmi?","","Did you <see> Ac'aq at the store?","","","","","","","","","","","","","","v","UH",""],[4,21,7,4,"b","Tangellrunritaqa. Calinrituq-gguq unuamek.","I didn't see her. They said that she's not working today.","kipusvik-4.mp3",,"","","Tangellrunritaqa. <Cali>nrituq-gguq unuamek.","","I didn't see her. They said that she's not <working> today.","","","","","","","","","","","","","","v","VBG",""],[4,21,7,5,"a","Ciin kiputenricit kuulicaanek?","Why didn't you buy some chicken?","kipusvik-5.mp3",,"","","Ciin kiputenricit <kuulicaa>nek?","","Why didn't you buy some <chicken>?","","","","","","","","","","","","","","n","sg",""],[4,21,7,6,"b","Akitussiyaagtut. Tuntum kemga akiitenrullruuq.","They were too expensive. The caribou meat was cheaper.","kipusvik-6.mp3",,"","","<Akitu>ssiyaagtut. Tuntum kemga akiitenrullruuq.","","They were too <expensive>. The caribou meat was cheaper.","","","","","","","","","","","","","","v","JJ",""],[4,21,7,7,"a","Canrituq. Ikayurciqamken keniquvgu.","It's ok. I'll help you when you cook it.","kipusvik-7.mp3",,"","","Canrituq. <Ikayur>ciqamken keniquvgu.","","It's ok. I'll <help> you when you cook it.","","","","","","","","","","","","","","v","VB",""],[4,21,8,1,"a","Yugtun qantulliniuten.","I see that you speak Yup'ik.","qantullini-1.mp3",405,"Yugtun qantulliniuten: I see that you speak Yup'ik","","Yugtun <qan>tulliniuten.","","I see that you <speak> Yup'ik.","","","","","","","","","","","","","","v","VB",""],[4,21,8,2,"b","Ellma qantuunga. Elitnaurtua KuC-mi.","I speak a little bit. I'm studying at KuC.","qantullini-2.mp3",,"","","Ellma qantuunga. <Elitnaur>tua KuC-mi.","","I speak a little bit. I'm <studying> at KuC.","","","","","","","","","","","","","","v","VBG",""],[4,21,8,3,"a","Yugtun qantulrianek quyalartua. Kass'at ilait uitamalartut maani tau͡gken Yugtun qanenermek nallulartut.","I appreciate people who speak Yup'ik. Some Kass'aqs stay here for a long time and yet they are unable to speak Yup'ik.","qantullini-3.mp3",,"","","Yugtun qantulrianek <quya>lartua. Kass'at ilait uitamalartut maani tau͡gken Yugtun qanenermek nallulartut.","","I <appreciate> people who speak Yup'ik. Some Kass'aqs stay here for a long time and yet they are unable to speak Yup'ik.","","","","","","","","","","","","","","v","VB",""],[4,21,8,4,"b","Taringamken, tau͡gaam yuk cukaunani qanraqan taringenrulartua.","I understand you, but I understand more when a person speaks slower.","qantullini-4.mp3",,"","","<Taring>amken, tau͡gaam yuk cukaunani qanraqan taringenrulartua.","","I <understand> you, but I understand more when a person speaks slower.","","","","","","","","","","","","","","v","VB",""],[5,2,1,1,"a","Callrusit?","What were you doing?","callullru-1.mp3",406,"Callullruunga: I was fighting","In the courtroom.","Callru<sit>?","","What were <you> doing?","","","","","","","","","","","","","","e","",""],[5,2,1,2,"b","Callullruunga.","I was fighting.","callullru-2.mp3",,"","","<Callu>llruunga.","","I was <fighting>.","","","","","","","","","","","","","","v","VBG",""],[5,2,1,3,"a","Nani callullrusit?","Where were you fighting?","callullru-3.mp3",,"","","<Nani> callullrusit?","","<Where> were you fighting?","","","","","","","","","","","","","","p","",""],[5,2,1,4,"b","Kuicuaraam ceńiini.","By the slough. (lit., by the shore of the small river)","callullru-4.mp3",,"","","Kuicuaraam <ceń>iini.","","By the slough. (lit., by the <shore> of the small river)","","","","","","","","","","","","","","n","sg",""],[5,2,1,5,"a","Kina ciumek callullrua?","Who started the fight? (lit., who fought first)","callullru-5.mp3",,"","","Kina <ciu>mek callullrua?","","Who started the fight? (lit., who fought <first>)","","","","","","","","","","","","","","n","sg",""],[5,2,1,6,"b","Ellii ciumek pillruuq.","He did first.","callullru-6.mp3",,"","","Ellii ciumek <pi>llruuq.","","He <did> first.","","","","","","","","","","","","","","v","VBD",""],[5,2,1,7,"a","Taangiqellruutek-qaa?","Were you (dual) drunk?","callullru-7.mp3",,"","","<Taangiqe>llruutek-qaa?","","Were you (dual) <drunk>?","","","","","","","","","","","","","","v","JJ",""],[5,2,1,8,"b","Wii ellma pillruunga. Ellii tau͡gaam cakneq taangiqellruuq.","I was a little bit, but he was very drunk.","callullru-8.mp3",,"","","Wii <ellma> pillruunga. Ellii tau͡gaam cakneq taangiqellruuq.","","I was <a little bit>, but he was very drunk.","","","","","","","","","","","","","","p","",""],[5,2,3,1,"a","Nuliangqertuten-qaa?","Do you have a wife?","nuliangqerr-1.mp3",204,"Nuliangqertuten-qaa?: Do you have a wife?","","<Nulia>ngqertuten-qaa?","","Do you have a <wife>?","","","","","","","","","","","","","","n","sg",""],[5,2,3,2,"b","Ii-i.","Yes.","nuliangqerr-2.mp3",,"","","<Ii-i>.","","<Yes>.","","","","","","","","","","","","","","p","",""],[5,2,3,2,"b","Nuliaritua.","I don't have a wife.","nuliangqerr-2b.mp3",,"","","Nuliarit<ua>.","","<I> don't have a wife.","","","","","","","","","","","","","","e","",""],[5,2,3,3,"a","Irniangqertuten-qaa?","Do you have children?","nuliangqerr-3.mp3",,"","","<Irnia>ngqertuten-qaa?","","Do you have <children>?","","","","","","","","","","","","","","n","pl",""],[5,2,3,4,"b","Qetunrangqertua ataucimek.","I have one son.","nuliangqerr-4.mp3",,"","","<Qetunra>ngqertua ataucimek.","","I have one <son>.","","","","","","","","","","","","","","n","sg",""],[5,2,3,4,"b","Irniaritua","I don't have any children.","nuliangqerr-4b.mp3",,"","","<Irniar>itua.","","I don't have any <children>.","","","","","","","","","","","","","","n","pl",""],[5,2,4,1,"a","Tangellruan-qaa aipaqa?","Have you seen my wife?","naulluu-1.mp3",407,"Naulluuvigmun: To The Hospital","Between friends, acquaintances, or relatives.","<Tange>llruan-qaa aipaqa?","","Have you <seen> my wife?","","","","","","","","","","","","","","v","VBN",""],[5,2,4,2,"b","Watua tangellruaqa naulluuvigmi. Taqellruyaaquq tau͡gaam paqteqatallrua iluraan imna, kituulria ima.","I just saw her at the hospital. She was finished, but she was about to visit your cousin, you know who - what's his name.","naulluu-2.mp3",,"","","Watua tangellruaqa naulluuvigmi. <Taqe>llruyaaquq tau͡gaam paqteqatallrua iluraan imna, kituulria ima.","","I just saw her at the hospital. She was <finished>, but she was about to visit your cousin, you know who - what's his name.","","","","","","","","","","","","","","v","VBD",""],[5,2,4,3,"a","Kina? Angivv'aq-qaa?","Who, Angivv'aq?","naulluu-3.mp3",,"","","<Kina>? Angivv'aq-qaa?","","<Who>, Angivv'aq?","","","","","","","","","","","","","","p","",""],[5,2,4,4,"b","Imna-wa iluraan Kuinerrarmiu.","You know, your cousin from Quinhagak.","naulluu-4.mp3",,"","","Imna-wa <ilura>an Kuinerrarmiu.","","You know, your <cousin> from Quinhagak.","","","","","","","","","","","","","","n","sg",""],[5,2,4,5,"a","Apassangayak-qaa?","Apassangayak?","naulluu-5.mp3",,"","","<Apassangayak>-qaa?","","<Apassangayak>?","","","","","","","","","","","","","","p","",""],[5,2,4,6,"b","Ii-i, tauna paqteqatallrua.","Yes, that's who she was going to check on.","naulluu-6.mp3",,"","","Ii-i, tauna <paqte>qatallrua.","","Yes, that's who she was going to <check on>.","","","","","","","","","","","","","","v","VB",""],[5,2,4,7,"a","Cau͡rlurta-kiq? Ilua-wam' assiitellilria.","I wonder what's wrong with the poor guy? It must be his stomach that's causing problems again.","naulluu-7.mp3",,"","","Cau͡rlurta-kiq? <Ilu>a-wam' assiitellilria.","","I wonder what's wrong with the poor guy? It must be his <stomach> that's causing problems again.","","","","","","","","","","","","","","n","sg",""],[5,2,4,8,"b","Ii-i, iluni-gguq emulluku itrallruuq.","Yes, they say he came up to have his stomach checked.","naulluu-8.mp3",,"","","Ii-i, iluni-gguq emulluku <itra>llruuq.","","Yes, they say he <came up> to have his stomach checked.","","","","","","","","","","","","","","v","VBD",""],[5,2,4,9,"a","Paqteu͡rlurciqaqa.","I'll check on the poor fellow.","naulluu-9.mp3",,"","","<Paqte>u͡rlurciqaqa.","","I'll <check on> the poor fellow.","","","","","","","","","","","","","","v","VB",""],[5,2,5,1,"a","Tekitelliniuten.","I see you've arrived.","tekite-1.mp3",408,"Tekitelliniuten: I see you've arrived","Between two acquaintances.","<Tekite>lliniuten.","Tekite;Aya;Ceńirte;Aqume","I see you've <arrived>.","","","","","","","","tekite-;tuntuvak;assike-;carayak;Mamteraq","to arrive;moose;to like it;bear;Goodnews Bay","listenchoose-baseYupik","chooseoption-baseYupik","","","v","VBD",""],[5,2,5,2,"b","Ii-i, tekitellruunga yaaliagni.","Yes, I arrived the day before yesterday.","tekite-2.mp3",,"","","Ii-i, tekitellruunga <yaaliagni>.","tekite;aya;ceńirte;aqume","Yes, I arrived <the day before yesterday>.","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","p","",""],[5,2,5,3,"a","Nunam-qaa Iquani cali elitnaurilartuten?","Are you still teaching at Sheldon's Point?","tekite-3.mp3",,"","","Nunam-qaa Iquani cali elitnaurilar<tuten>?","tuten;tuci;tua;tuq","<Are you> still teaching at Sheldon's Point?","","Nunam-qaa Iquani cali elitnaurilar<tuten>?","tuten;tuci;tua;tuq","<Are you> still teaching at Sheldon's Point?","","","","","","listenchoose-endingYupik","chooseoption-endingYupik","","","e","",""],[5,2,5,4,"b","Upallruunga Mamteranun kiak.","No, I moved to Goodnews Bay last summer.","tekite-4.mp3",,"","","<Upa>llruunga Mamteranun kiak.","unga;ukut;uten;uq","No, I <moved> to Goodnews Bay last summer.","","Upallru<unga> Mamteranun kiak.","unga;ukut;uten;uq","No, <I> moved to Goodnews Bay last summer.","","","","","","listenchoose-endingYupik","chooseoption-endingYupik","","","v","VBD",""],[5,2,5,5,"a","Assikan-qaa Mamteraq?","Do you like Goodnews Bay?","tekite-5.mp3",,"","","Assikan-qaa <Mamteraq>?","","Do you like <Goodnews Bay>?","like;hate;see;visit","","","","","","","","","listenchoose-baseEnglish","chooseoption-baseEnglish","","","n","pl",""],[5,2,5,6,"b","Ii-i, assikenruaqa. Kuvyalleq assinruuq tamaani, pissulleq-llu.","Yes, I like it better. The fishing and hunting is better there.","tekite-6.mp3",,"","","Ii-i, <assike>nruaqa. Kuvyalleq assinruuq tamaani, pissulleq-llu.","assike;assiilke;alike","Yes, I <like> it better. The fishing and hunting is better there.","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","v","IN",""],[5,2,5,7,"a","Niitelartua tuntuvangqerrniluku, carayangqerrniluku-llu ingrini Mamterat nuniitni.","That's what I've heard. They say that there are moose and bear in the mountains around Goodnews.","tekite-7.mp3",,"","","Niitelar<tua> tuntuvangqerrniluku, carayangqerrniluku-llu ingrini Mamterat nuniitni.","tua;tuten;tut;tuq","That's what <I've> heard. They say that there are moose and bear in the mountains around Goodnews.","","Niitelar<tua> tuntuvangqerrniluku, carayangqerrniluku-llu ingrini Mamterat nuniitni.","tua;tuten;tut;tuq","That's what <I've> heard. They say that there are moose and bear in the mountains around Goodnews.","","","","","","listenchoose-endingYupik","chooseoption-endingYupik","","","e","",""],[5,2,5,8,"b","Ii-i, pissullemteńi uksuaq tuntuvagtellruukut pingayunek carayaggluta-llu malrugnek.","Yes, when we were hunting last fall, we caught three moose, and two bears.","tekite-8.mp3",,"","","Ii-i, pissullemteńi uksuaq <tuntuvag>tellruukut pingayunek carayaggluta-llu malrugnek.","tuntuvag;taqukar;tuntu","Yes, when we were hunting last fall, we caught three <moose>, and two bears.","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","n","sg",""],[5,2,5,9,"a","Yuurqeryarturluk nemnun.","We should go to my house for tea.","tekite-9.mp3",,"","","<Yuurqer>yarturluk nemnun.","Yuurqer;Ner;Mer;Yuar","We should go to my house <for tea>.","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","v","IN",""],[5,2,5,10,"b","Ii-i.","Okay.","tekite-10.mp3",,"","","<Ii-i>.","","<Okay>.","","","","","","","","","","nothing","nothing","","","p","",""],[5,6,1,1,"a","Kassuuciiqua.","I'm going to get married.","iqlu-1.mp3",6,"Iqluuten: You're lying","","<Kassuu>ciiqua.","","I'm going to <get married>.","","","","","","","","","","","","","","v","VB",""],[5,6,1,2,"b","Iqluuten.","You're kidding. (lit., you're lying)","iqlu-2.mp3",,"","","<Iqlu>uten.","","You're <kidding>. (lit., you're lying)","","","","","","","","","","","","","","v","VBG",""],[5,6,1,3,"a","Iqlunritua.","I'm not kidding. (lit., I'm not lying)","iqlu-3.mp3",,"","","<Iqlu>nritua.","","I'm not <kidding>. (lit., I'm not lying)","","","","","","","","","","","","","","v","VBG",""],[5,6,1,4,"b","Qaku?","When?","iqlu-4.mp3",,"","","<Qaku>?","","<When>?","","","","","","","","","","","","","","p","",""],[5,6,1,5,"a","Maqinermi.","On Saturday.","iqlu-5.mp3",,"","","<Maqiner>mi.","","On <Saturday>.","","","","","","","","","","","","","","n","sg",""],[5,6,1,6,"b","Ukveqenritamken.","I don't believe you.","iqlu-6.mp3",,"","","<Ukveqe>nritamken.","","I don't <believe> you.","","","","","","","","","","","","","","v","VBP",""],[5,6,2,1,"a","Natmun?","Where to?","cikuci-1.mp3",603,"Cikuciqatartua: I'm going to get some ice","","<Na>tmun?","","<Where> to?","","","","","","","","","","","","","","n","sg",""],[5,6,2,2,"b","Cikuciqatartua.","I'm going to get some ice.","cikuci-2.mp3",,"","","<Ciku>ciqatartua.","","I'm going to <get some ice>.","","","","","","","","","","","","","","v","VB",""],[5,6,2,3,"a","Ikayurlaken. Allamek-qaa cikuliurutengqertuten?","I should help you. Do you have another ice chisel?","cikuci-3.mp3",,"","","<Ikayur>laken. Allamek-qaa cikuliurutengqertuten?","","I should <help> you. Do you have another ice chisel?","","","","","","","","","","","","","","v","VB",""],[5,6,2,4,"b","Piitua.","I don't have one.","cikuci-4.mp3",,"","","<Pi>itua.","","I don't have <one>.","","","","","","","","","","","","","","n","sg",""],[5,6,2,5,"a","Aqvaqataraqa cikuliurutput, utaqakia.","I'm going to go get our ice chisel, wait for me.","cikuci-5.mp3",,"","","<Aqva>qataraqa cikuliurutput, utaqakia.","","I'm going to <go get> our ice chisel, wait for me.","","","","","","","","","","","","","","v","VB",""],[5,6,3,1,"a","Nani tangellrua keglunermek?","Where did he see a wolf?","kegluneq-1.mp3",702,"Keglunermek: A Wolf","","Nani tangellrua <kegluner>mek?","","Where did he see a <wolf>?","","","","","","","","","","","","","","n","sg",""],[5,6,3,2,"b","Kina tangerta keglunermek?","Who saw a wolf?","kegluneq-2.mp3",,"","","Kina <tanger>ta keglunermek?","","Who <saw> a wolf?","","","","","","","","","","","","","","v","VBD",""],[5,6,3,3,"a","Angivv'aq. Kuigpiim nuniini tangllinia, tau͡gaam naniqapiar pillrucia nalluaqa.","Angivv'aq. He apparently saw one near the Yukon, but I don't know exactly where (he saw it).","kegluneq-3.mp3",,"","","Angivv'aq. Kuigpiim <nuni>ini tangllinia, tau͡gaam naniqapiar pillrucia nalluaqa.","","Angivv'aq. He apparently saw one <near> the Yukon, but I don't know exactly where (he saw it).","","","","","","","","","","","","","","n","sg",""],[5,6,3,4,"b","Paqcugan-qaa unuaqu?","Do you want to check on it tomorrow?","kegluneq-4.mp3",,"","","<Paq>cugan-qaa unuaqu?","","Do you want to <check on> it tomorrow?","","","","","","","","","","","","","","v","VB",""],[5,6,3,5,"a","Ii-i, paqeskilauk qaniqan ellma.","Yes, let's check it if it snows a little.","kegluneq-5.mp3",,"","","Ii-i, paqeskilauk <qani>qan ellma.","","Yes, let's check it if it <snows> a little.","","","","","","","","","","","","","","v","NNS",""],[5,6,4,1,"a","Taqsuqua.","I'm tired.","taqsuqe-1.mp3",903,"Taqsuqua: I'm tired","","<Taqsuq>ua.","","I'm <tired>.","","","","","","","","","","","","","","v","JJ",""],[5,6,4,2,"b","Ciin?","Why?","taqsuqe-2.mp3",,"","","<Ciin>?","","<Why>?","","","","","","","","","","","","","","p","",""],[5,6,4,3,"a","Nutaan anelrartua Tuulkessaamek. Snuukuuqa-am assiitellruuq anelrallemni.","I just came down from Tuluksak. When I was coming down I had problems with my snow-go.","taqsuqe-3.mp3",,"","","Nutaan <anelrar>tua Tuulkessaamek. Snuukuuqa-am assiitellruuq anelrallemni.","","I just <came down> from Tuluksak. When I was coming down I had problems with my snow-go.","","","","","","","","","","","","","","v","VBD",""],[5,6,4,4,"b","Qaill' pillrua?","What was wrong with it?","taqsuqe-4.mp3",,"","","Qaill' pillru<a>?","","What was wrong with <it>?","","","","","","","","","","","","","","e","",""],[5,6,4,5,"a","Carburetor-aara cikuyullruuq. Uqua mertangqellruyugnarquq.","The carburetor kept freezing. There must have been water in the gas.","taqsuqe-5.mp3",,"","","Carburetor-aara cikuyullruuq. Uqua <mer>tangqellruyugnarquq.","","The carburetor kept freezing. There must have been <water> in the gas.","","","","","","","","","","","","","","n","sg",""],[5,6,4,6,"b","Yuurqeryarturluk enemnun.","Let's go to my house and have some tea.","taqsuqe-6.mp3",,"","","<Yuurqer>yarturluk enemnun.","","Let's go to my house and <have some tea>.","","","","","","","","","","","","","","v","VBP",""],[5,6,4,7,"a","Ii-i.","Sounds good.","taqsuqe-7.mp3",,"","","<Ii-i>.","","<Sounds good>.","","","","","","","","","","","","","","p","",""],[5,6,5,1,"a","Assikan-qaa tauna?","Do you like that one?","qaspeq-1.mp3",4,"Qaspeq: The Qaspeq","","<Assik>an-qaa tauna?","","Do you <like> that one?","","","","","","","","","","","","","","v","IN",""],[5,6,5,2,"b","Ca?","Which?","qaspeq-2.mp3",,"","","<Ca>?","","<Which>?","","","","","","","","","","","","","","p","",""],[5,6,5,3,"a","Tauna qaspeq.","That kuspuk.","qaspeq-3.mp3",,"","","Tauna <qaspeq>.","","That <kuspuk>.","","","","","","","","","","","","","","n","sg",""],[5,6,5,4,"b","Assikaqa tau͡gaam akitussiyaagtuq.","I like it but it's too expensive.","qaspeq-4.mp3",,"","","Assikaqa tau͡gaam <akitu>ssiyaagtuq.","","I like it but it's too <expensive>.","","","","","","","","","","","","","","v","JJ",""],[5,6,5,5,"a","Akitussiyaanrituq. Caperrnarquq pilineq tamakunek. Kipusgu.","It's not too expensive. They're difficult to make. Buy it.","qaspeq-5.mp3",,"","","Akitussiyaanrituq. <Caperrnarq>uq pilineq tamakunek. Kipusgu.","","It's not too expensive. They're <difficult> to make. Buy it.","","","","","","","","","","","","","","v","JJ",""],[5,11,1,1,"a","Uluarpangqertuten-qaa?","Do you have a big uluaq?","ulligci-1.mp3",802,"Ulligciqatartua: I'm going to cut fish for drying","In the summer.","<Ulua>rpangqertuten-qaa?","","Do you have a big <uluaq>?","","","","","","","","","","","","","","n","sg",""],[5,11,1,2,"b","Ii-i. Caqatarcit?","Yes. What are you going to do?","ulligci-2.mp3",,"","","Ii-i. Caqatar<cit>?","","Yes. What are <you> going to do?","","","","","","","","","","","","","","e","",""],[5,11,1,3,"a","Ulligciqatartua iqallugnek.","I'm going to split some dog salmon (for drying).","ulligci-3.mp3",,"","","Ulligciqatartua <iqallug>nek.","","I'm going to split some <dog salmon> (for drying).","","","","","","","","","","","","","","n","sg",""],[5,11,1,4,"b","Amllertut-qaa ulligtarkaten?","Do you have a lot of them to split?","ulligci-4.mp3",,"","","Amllertut-qaa <ulligt>arkaten?","","Do you have a lot of them to <split>?","","","","","","","","","","","","","","v","NN",""],[5,11,1,5,"a","Amllessiyaanritut.","Not too many.","ulligci-5.mp3",,"","","<Amlle>ssiyaanritut.","","Not too <many>.","","","","","","","","","","","","","","v","JJ",""],[5,11,3,1,"a","Nani kuvyallrusit?","Where did you fish?","kuvyaq-1.mp3",803,"Kuvyalriik: The Two Drift Net Fishing","Waiting in line to sell fish after a commercial fishing period.","Nani <kuvya>llrusit?","","Where did you <fish>?","","","","","","","","","","","","","","v","NN",""],[5,11,3,2,"b","Un'gani Nalqiglim nuniini.","Downriver near Nalqigliq.","kuvyaq-2.mp3",,"","","Un'gani Nalqiglim <nuni>ini.","","Downriver <near> Nalqigliq.","","","","","","","","","","","","","","n","sg",""],[5,11,3,3,"a","Tangellruan-qaa Nagtaq?","Did you see Nagtaq?","kuvyaq-3.mp3",,"","","<Tange>llruan-qaa Nagtaq?","","Did you <see> Nagtaq?","","","","","","","","","","","","","","v","UH",""],[5,11,3,4,"b","Tangellrunritaqa. Niitellruaqa tau͡gaam C-B-tgun.","I didn't see him. But I heard him on the C-B.","kuvyaq-4.mp3",,"","","Tangellrunritaqa. <Niite>llruaqa tau͡gaam C-B-tgun.","","I didn't see him. But I <heard> him on the C-B.","","","","","","","","","","","","","","v","VBN",""],[5,11,3,5,"a","Niitellruaten-qaa C-B-tgun allat neqnek kiputellriit qavcitun iqalluut akiliuciitnek?","Did you hear over the C-B how much the other fish buyers are paying for dog salmon?","kuvyaq-5.mp3",,"","","Niitellruaten-qaa C-B-tgun allat neqnek kiputellriit qavcitun <iqallu>ut akiliuciitnek?","","Did you hear over the C-B how much the other fish buyers are paying for <dog salmon>?","","","","","","","","","","","","","","n","sg",""],[5,11,3,6,"b","Niiteksaitanka. Tamarmeng akikitsiyaagtut.","I haven't heard (about them). They are all too cheap.","kuvyaq-6.mp3",,"","","Niiteksaitanka. Tamarmeng <akikit>siyaagtut.","","I haven't heard (about them). They are all too <cheap>.","","","","","","","","","","","","","","v","JJ",""],[5,11,3,7,"a","Ilumun-wa. Iilgayarmi atam akituluki kiputelarait..., C-B-ten-qaa aturyugngaanka?","That's for sure. You know at Bristol Bay they buy them at a higher price..., can I use your C-B?","kuvyaq-7.mp3",,"","","Ilumun-wa. Iilgayarmi atam <akitu>luki kiputelarait..., C-B-ten-qaa aturyugngaanka?","","That's for sure. You know at Bristol Bay they buy them at a <higher price>..., can I use your C-B?","","","","","","","","","","","","","","v","JJR",""],[5,11,3,8,"b","Ii-i, aturyugngaan.","Yes, you can use it.","kuvyaq-8.mp3",,"","","Ii-i, <atur>yugngaan.","","Yes, you can <use> it.","","","","","","","","","","","","","","v","NN",""],[5,15,1,1,"a","Egturyirpaa!","Lots of mosquitos!","angyalriik-1.mp3",804,"Angyalriik: The Two Going by Boat","By the boats on the riverbank.","<Egtury>irpaa!","","Lots of <mosquitos>!","","","","","","","","","","","","","","n","pl",""],[5,15,1,2,"b","Ilumun. Mingungqertuten-qaa?","That's for sure. Do you have any bug dope?","angyalriik-2.mp3",,"","","Ilumun. <Mingu>ngqertuten-qaa?","","That's for sure. Do you have any <bug dope>?","","","","","","","","","","","","","","n","sg",""],[5,15,1,3,"a","Ii-i, waniwa. Natmurteqatarcit?","Sure, here. Where are you going?","angyalriik-3.mp3",,"","","Ii-i, waniwa. Natmurteqatar<cit>?","","Sure, here. Where are <you> going?","","","","","","","","","","","","","","e","",""],[5,15,1,4,"b","Kuvyaqa paqteqataraqa.","I'm going to check my net.","angyalriik-4.mp3",,"","","Kuvyaqa <paqte>qataraqa.","","I'm going to <check> my net.","","","","","","","","","","","","","","v","VB",""],[5,15,1,5,"a","Nani kuvangqercit?","Where do you have your net?","angyalriik-5.mp3",,"","","Nani <kuva>ngqercit?","","Where do you have your <net>?","","","","","","","","","","","","","","n","sg",""],[5,15,1,6,"b","Un'gani. Elpes-mi natmurteqatarcit?","Downriver. How about you? Where are you heading?","angyalriik-6.mp3",,"","","<Un'ga>ni. Elpes-mi natmurteqatarcit?","","<Downriver>. How about you? Where are <you> heading?","","","","","","","","","","","","","","n","sg",""],[5,15,1,7,"a","Anelraqatartua. Naparyarrarmun aqvaluku nuliaqa. Tua-i piuraa.","I'm going down to Napakiak to pick up my wife. I'll see you. (lit., that's it, goodbye)","angyalriik-7.mp3",,"","","<Anelra>qatartua. Naparyarrarmun aqvaluku nuliaqa. Tua-i piuraa.","","I'm <going down> to Napakiak to pick up my wife. I'll see you. (lit., that's it, goodbye)","","","","","","","","","","","","","","v","VBG",""],[5,15,1,8,"b","Ii-i.","Sounds good.","angyalriik-8.mp3",,"","","<Ii-i>.","","<Sounds good>.","","","","","","","","","","","","","","p","",""],[5,15,2,1,"a","Qangvaq tekicit? Tangerrsaqlirpaa!","When did you arrive? I haven't seen you in ages!","tangerr-1.mp3",3,"Tangerrsaqlirpaa!: I haven't seen you in ages!","Between two men or two women in Bethel.","<Qangvaq> tekicit? Tangerrsaqlirpaa!","Qangvaq;Qaku;Naken;Qaillun","<When> did you arrive? I haven't seen you in ages!","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","p","",""],[5,15,2,2,"b","Maani uitalartua. Makumiungurtellruunga.","I'm living here now. I've become a Bethel resident (lit., a person from here).","tangerr-2.mp3",,"","","<Maani> uitalartua. Makumiungurtellruunga.","Maani;Tamaani;Wani;Yaani","I'm living <here> now. I've become a Bethel resident (lit., a person from here).","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","p","",""],[5,15,2,3,"a","Qaa? Caliuten-qaa?","Really? Are you working?","tangerr-3.mp3",,"","","Qaa? <Cali>uten-qaa?","Cali;Maqi;Aqum;Elit","Really? Are you <working>?","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","v","VBG",""],[5,15,2,4,"b","Ii-i, caliunga AVCP housing-aami.","Yes, I'm working at AVCP housing.","tangerr-4.mp3",,"","","Ii-i, cali<unga> AVCP housing-aami.","unga;uten;ukut;anga","Yes, <I'm> working at AVCP housing.","","Ii-i, cali<unga> AVCP housing-aami.","unga;uten;ukut;anga","Yes, <I'm> working at AVCP housing.","","","","","","listenchoose-endingYupik","chooseoption-endingYupik","","","e","",""],[5,15,2,5,"a","Nani enen uitalarta, ceńirrniaramken?","Where exactly is your house, so that I can visit you?","tangerr-5.mp3",,"","","<Nani> enen uitalarta, ceńirrniaramken?","Nani;Naken;Ciin;Natmun","<Where> exactly is your house, so that I can visit you?","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","p","",""],[5,15,2,6,"b","Mission Road-ami kuigem ceńiini.","On Mission Road, by the river.","tangerr-6.mp3",,"","","Mission Road-ami <kuig>em ceńiini.","kuig;kaviar;qair;kiag","On Mission Road, by the <river>.","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","n","sg",""],[5,15,2,7,"a","Nampaa cauga? Taxi-kun tainiartua.","What's the number so that I can come by taxi?","tangerr-7.mp3",,"","","Nampaa cauga? Taxi-kun <tai>niartua.","tai;ayag;qia;cali","What's the number so that I can <come> by taxi?","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","v","VB",""],[5,15,2,8,"b","1221-aaruuq. Ataku ceńireskina maqiniartukuk.","It's 1221. You should visit tonight, so that we can take a steambath.","tangerr-8.mp3",,"","","1221-aaruuq. Ataku ceńireskina <maqi>niartukuk.","maqi;cali;tai;uita","It's 1221. You should visit tonight, so that we can <take a steambath>.","","","","","","","","","","listenchoose-baseYupik","chooseoption-baseYupik","","","v","VB",""],[5,15,2,9,"a","Ii-i.","Sounds good.","tangerr-9.mp3",,"","","<Ii-i>.","","<Sounds good>.","","","","","","","","","","nothing","nothing","","","p","",""],[5,15,3,1,"a","Taringesciigatua. Amllessiyaagtut elitnaulput.","I can't understand. There's too much for us to learn.","taringe-1.mp3",504,"Taringesciigatua: I can't understand","Between student and teacher.","<Taringe>sciigatua. Amllessiyaagtut elitnaulput.","","I can't <understand>. There's too much for us to learn.","","","","","","","","","","","","","","v","VB",""],[5,15,3,2,"b","Amllessiyaanritut. Caperrnarqenritut. Cukaunata piyaaqukut.","There's not too much. It's not that hard, and we're going slowly.","taringe-2.mp3",,"","","<Amlle>ssiyaanritut. Caperrnarqenritut. Cukaunata piyaaqukut.","","There's not too <much>. It's not that hard, and we're going slowly.","","","","","","","","","","","","","","v","JJ",""],[5,15,3,3,"a","Cukassiyaagtukut iliini taqsularyaaqua tau͡gaam elicugtua Yugtun qanenermek.","We're going too fast. Sometimes I think about quitting, but I want to learn Yup'ik.","taringe-3.mp3",,"","","<Cuka>ssiyaagtukut iliini taqsularyaaqua tau͡gaam elicugtua Yugtun qanenermek.","","We're going too <fast>. Sometimes I think about quitting, but I want to learn Yup'ik.","","","","","","","","","","","","","","v","RB",""],[5,15,3,4,"b","Aren! Qang'a taqsaqunak! Cukaiqanirciqukut.","Oh no! Don't quit. We'll go more slowly.","taringe-4.mp3",,"","","Aren! Qang'a <taq>saqunak! Cukaiqanirciqukut.","","Oh no! Don't <quit>. We'll go more slowly.","","","","","","","","","","","","","","v","VB",""],[5,15,3,5,"a","Kitak-wa taqngaitua tau͡gaam elitnaurumangerma amlleq taringesciigataqa.","Okay then I won't quit, even though I study for a long time there's a lot I don't understand.","taringe-5.mp3",,"","","Kitak-wa taqngaitua tau͡gaam <elitnaur>umangerma amlleq taringesciigataqa.","","Okay then I won't quit, even though I <study> for a long time there's a lot I don't understand.","","","","","","","","","","","","","","v","NN",""],[5,15,3,6,"b","Canrituq Yup'igtun elitnaulleq caperrnarquq. Eliciiquten cumigeskuvet. Wii-llu elitellemni Kass'atun caperrnarqellruuq.","It's okay, Yup'ik is difficult to learn, but you'll learn if you persevere. When I was learning English it was also very difficult.","taringe-6.mp3",,"","","Canrituq Yup'igtun elitnaulleq caperrnarquq. <Eli>ciiquten cumigeskuvet. Wii-llu elitellemni Kass'atun caperrnarqellruuq.","","It's okay, Yup'ik is difficult to learn, but you'll <learn> if you persevere. When I was learning English it was also very difficult.","","","","","","","","","","","","","","v","VB",""],[5,15,4,1,"a","Iqvallruuten-qaa akwaugaq?","Did you pick berries yesterday?","paqeskilauk-1.mp3",604,"Unuaqu paqeskilauk: Let's check tomorrow","Between two women in the fall season.","<Iqva>llruuten-qaa akwaugaq?","","Did you <pick berries> yesterday?","","","","","","","","","","","","","","v","VB",""],[5,15,4,2,"b","Iqvallruyaaqua tau͡gaam kavirlit amllessiyaallrunritut au͡g'umi nunapigmi paqtellemni.","Yes, I picked, but there weren't very many cranberries over there in the tundra where I checked.","paqeskilauk-2.mp3",,"","","Iqvallruyaaqua tau͡gaam kavirlit amllessiyaallrunritut au͡g'umi <nunapig>mi paqtellemni.","","Yes, I picked, but there weren't very many cranberries over there in the <tundra> where I checked.","","","","","","","","","","","","","","n","sg",""],[5,15,4,3,"a","Un'gani kavirliliryugnarquq. Unuaqu paqeskilauk.","There's probably lots of cranberries downriver. Let's check tomorrow.","paqeskilauk-3.mp3",,"","","Un'gani <kavirli>liryugnarquq. Unuaqu paqeskilauk.","","There's probably lots of <cranberries> downriver. Let's check tomorrow.","","","","","","","","","","","","","","n","pl",""],[5,15,4,4,"b","Naugg'un-mi ayagciqceńuk?","But how will we go?","paqeskilauk-4.mp3",,"","","Naugg'un-mi <ayag>ciqceńuk?","","But how will we <go>?","","","","","","","","","","","","","","v","VB",""],[5,15,4,5,"a","Qetunraqa apciiqaqa ayautesqellunuk. Yaqulegcurniartuq iqvainanmegni.","I'll ask my son if he can take us. He can hunt birds while we pick.","paqeskilauk-5.mp3",,"","","Qetunraqa <ap>ciiqaqa ayautesqellunuk. Yaqulegcurniartuq iqvainanmegni.","","I'll <ask> my son if he can take us. He can hunt birds while we pick.","","","","","","","","","","","","","","v","VB",""],[5,15,4,6,"b","Panika-llu malikciqaqa ikayurniaraanga.","I will also take my daughter along so that she can help me.","paqeskilauk-6.mp3",,"","","Panika-llu malikciqaqa <ikayur>niaraanga.","","I will also take my daughter along so that she can <help> me.","","","","","","","","","","","","","","v","VB",""],[6,2,1,1,"a","Waqaa?","What's up?","levaara-1.mp3",904,"Sak'am Levaara: Sak'aq's Motor","A woman comes into the house of a couple who are friends of hers. This is actually a trialogue.","<Waqaa>?","","<What's up>?","","","","","","","","","","","","","","p","",""],[6,2,1,2,"b","Ellmikun.","Just visiting.","levaara-2.mp3",,"","","<Ellmikun>.","","<Just visiting>.","","","","","","","","","","","","","","p","",""],[6,2,1,3,"a","Aqumqerluten, nerqatartukut. Neryulliuten?","Have a seat. We're just about to eat, would you care to join us? (lit., would you care to eat?)","levaara-3.mp3",,"","","<Aqum>qerluten, nerqatartukut. Neryulliuten?","","<Have a seat>. We're just about to eat, would you care to join us? (lit., would you care to eat?)","","","","","","","","","","","","","","v","VBP",""],[6,2,1,4,"b","Ii-i, nercuaqaqerlii-wa.","I'll have a little bit.","levaara-4.mp3",,"","","Ii-i, <ner>cuaqaqerlii-wa.","","I'll <have> a little bit.","","","","","","","","","","","","","","v","VBP",""],[6,2,1,5,"c","Tua-llu-qaa Sak'am levaara qaillun ayuqa? Assirillruuq-qaa?","So, anyway, how's Sak'aq's motor? Was it (working) better?","levaara-5.mp3",,"","","Tua-llu-qaa Sak'am <levaar>a qaillun ayuqa? Assirillruuq-qaa?","","So, anyway, how's Sak'aq's <motor>? Was it (working) better?","","","","","","","","","","","","","","n","sg",""],[6,2,1,6,"a","Caliaqsaaqellrua akwaugaq ernerpak, tau͡gaam cali ayagciigatuq. Kipucugyaaquq allamek levaamek tau͡gaam maa-i akikaituq.","He worked on it all day yesterday, but it still doesn't work. He'd like to buy another motor, but right now he just doesn't have the money.","levaara-6.mp3",,"","","<Cali>aqsaaqellrua akwaugaq ernerpak, tau͡gaam cali ayagciigatuq. Kipucugyaaquq allamek levaamek tau͡gaam maa-i akikaituq.","","He <worked> on it all day yesterday, but it still doesn't work. He'd like to buy another motor, but right now he just doesn't have the money.","","","","","","","","","","","","","","v","VBD",""],[6,2,1,7,"c","Akleng, apciiqaqa ilu'urqa Tun'aq ikayuusqelluku levaaliuyuuq.","That's really too bad. I'll ask my cousin Tun'aq to help him, he's really good at fixing motors.","levaara-7.mp3",,"","","Akleng, <ap>ciiqaqa ilu'urqa Tun'aq ikayuusqelluku levaaliuyuuq.","","That's really too bad. I'll <ask> my cousin Tun'aq to help him, he's really good at fixing motors.","","","","","","","","","","","","","","v","VB",""],[6,2,1,8,"a","Ii-i, quyaciquq.","He'd sure appreciate it.","levaara-8.mp3",,"","","Ii-i, <quya>ciquq.","","He'd sure <appreciate> it.","","","","","","","","","","","","","","v","VB",""],[6,2,2,1,"a","Qaill' pisit?","What's wrong with you?","uluaqa-1.mp3",805,"Uluaqa: My Uluaq","An exchange between two sisters or close friends.","Qaill' pi<sit>?","","What's wrong with <you>?","","","","","","","","","","","","","","e","",""],[6,2,2,2,"b","Umyuaqa assiituq.","I'm disgusted. (lit. My mind is bad.)","uluaqa-2.mp3",,"","","Umyuaqa <assiit>uq.","","I'm disgusted. (lit. My mind is <bad>.)","","","","","","","","","","","","","","v","JJ",""],[6,2,2,3,"a","Ciin?","How come?","uluaqa-3.mp3",,"","","<Ciin>?","","<How come>?","","","","","","","","","","","","","","p","",""],[6,2,2,4,"b","Nalluyagutelliniaqa-am uluaqa neqlillerni.","I left my ulu down at fish-camp.","uluaqa-4.mp3",,"","","Nalluyagutelliniaqa-am uluaqa <neqliller>ni.","","I left my ulu down at <fish-camp>.","","","","","","","","","","","","","","n","sg",""],[6,2,2,5,"a","Uuminaqvaa! Allamek uluangqertua. Aturyugan-qaa?","Well shucks... I have another ulu. Do you want to use it?","uluaqa-5.mp3",,"","","Uuminaqvaa! <Alla>mek uluangqertua. Aturyugan-qaa?","","Well shucks... I have <another> ulu. Do you want to use it?","","","","","","","","","","","","","","n","sg",""],[6,2,2,6,"b","Ii-i, kitak aturnaurqa.","Sure, I'd like to use it.","uluaqa-6.mp3",,"","","Ii-i, kitak <atur>naurqa.","","Sure, I'd like to <use> it.","","","","","","","","","","","","","","v","NN",""],[6,2,4,1,"a","Taumi-lli qaspermi iqavaa.","That qaspeq is filthy.","manallemni-1.mp3",2,"Manallemni: When I went jigging","An exchange between ilungaqs (female cross-cousins are usually close and informal with each other).","Taumi-lli qaspermi <iqa>vaa.","","That qaspeq is <filthy>.","","","","","","","","","","","","","","v","JJ",""],[6,2,4,2,"b","Akwaugaq manallemni atullruaqa. Cali unuaqu aturciqaqa.","I wore it jigging yesterday. I'll use it again tomorrow.","manallemni-2.mp3",,"","","Akwaugaq manallemni <atu>llruaqa. Cali unuaqu aturciqaqa.","","I <wore> it jigging yesterday. I'll use it again tomorrow.","","","","","","","","","","","","","","v","VBD",""],[6,2,4,3,"a","Nani manallrusit?","Where did you jig?","manallemni-3.mp3",,"","","Nani <mana>llrusit?","","Where did you <jig>?","","","","","","","","","","","","","","v","NN",""],[6,2,4,4,"b","An'arciim paingani.","At the mouth of the Johnson River.","manallemni-4.mp3",,"","","An'arciim <pai>ngani.","","At the <mouth> of the Johnson River.","","","","","","","","","","","","","","v","NN",""],[6,2,4,5,"a","Amllellruut-qaa manalriit?","Were there lots of people jigging?","manallemni-5.mp3",,"","","<Amlle>llruut-qaa manalriit?","","Were there <lots of> people jigging?","","","","","","","","","","","","","","v","NNS",""],[6,2,4,6,"b","Amllessiyaallrunritut. Akulmiunek-llu tangellruunga.","Not too many. I saw some people from the tundra villages also.","manallemni-6.mp3",,"","","Amllessiyaallrunritut. Akulmiunek-llu <tange>llruunga.","","Not too many. I <saw> some people from the tundra villages also.","","","","","","","","","","","","","","v","VBD",""],[6,2,4,7,"a","Qavcitellrusit?","How many did you catch?","manallemni-7.mp3",,"","","<Qavci>tellrusit?","","<How many> did you catch?","","","","","","","","","","","","","","n","sg",""],[6,2,4,8,"b","Naaqellrunritanka tau͡gaam cangliqellruunga.","I didn't count them, but I got quite a few.","manallemni-8.mp3",,"","","<Naaqe>llrunritanka tau͡gaam cangliqellruunga.","","I didn't <count> them, but I got quite a few.","","","","","","","","","","","","","","v","NN",""],[6,2,4,9,"a","Quyanaqvaa-ll'. Ak'a-qaa ulligtellruaten?","I'm very thankful. Did you already cut them for drying?","manallemni-9.mp3",,"","","<Quyanaq>vaa-ll'. Ak'a-qaa ulligtellruaten?","","I'm very <thankful>. Did you already cut them for drying?","","","","","","","","","","","","","","v","JJ",""],[6,2,4,10,"b","Ulligteksaitanka. Atata nererraarlua piciqanka.","I haven't cut them yet. I'll cut them later after I eat.","manallemni-10.mp3",,"","","<Ulligte>ksaitanka. Atata nererraarlua piciqanka.","","I haven't <cut> them yet. I'll cut them later after I eat.","","","","","","","","","","","","","","v","VB",""],[6,7,1,1,"a","Caqatarcit?","What are you going to do?","iqairi-1.mp3",305,"Iqairiqatartua: I'm going to wash clothes","Between two people who are relatives. One is staying at the other's house.","Caqatar<cit>?","","What are <you> going to do?","","","","","","","","","","","","","","e","",""],[6,7,1,2,"b","Iqairiqatartua.","I'm going to wash clothes.","iqairi-2.mp3",,"","","<Iqairi>qatartua.","","I'm going to <wash clothes>.","","","","","","","","","","","","","","v","VB",""],[6,7,1,3,"a","Imirli-qaa iqairissuun?","Should the washing machine be filled?","iqairi-3.mp3",,"","","Imirli-qaa <iqairissuun>?","","Should the <washing machine> be filled?","","","","","","","","","","","","","","n","sg",""],[6,7,1,4,"b","Imiryaqunaku. Aturngaitaqa. Calisciigatuq.","Don't fill it. I won't use it. It doesn't work.","iqairi-4.mp3",,"","","<Imir>yaqunaku. Aturngaitaqa. Calisciigatuq.","","Don't <fill> it. I won't use it. It doesn't work.","","","","","","","","","","","","","","v","VB",""],[6,7,1,5,"a","Nani-mi iqairiqatarcit?","Where will you wash them?","iqairi-5.mp3",,"","","<Nani>-mi iqairiqatarcit?","","<Where> will you wash them?","","","","","","","","","","","","","","p","",""],[6,7,1,6,"b","Panill'am eniini piciqua.","I'll do it at Panill'aq's house.","iqairi-6.mp3",,"","","Panill'am <eni>ini piciqua.","","I'll do it at Panill'aq's <house>.","","","","","","","","","","","","","","n","sg",""],[6,7,1,7,"a","Mer'a-qaa amllertuq?","Does she have lots of water?","iqairi-7.mp3",,"","","<Mer>'a-qaa amllertuq?","","Does she have lots of <water>?","","","","","","","","","","","","","","n","sg",""],[6,7,1,8,"b","Ii-i, C.B.-kun aptellemni qanrutellruanga nem'i amllerrniluku.","Yes, when I asked her over the C.B. she said there were lots in the house.","iqairi-8.mp3",,"","","Ii-i, C.B.-kun aptellemni <qanrute>llruanga nem'i amllerrniluku.","","Yes, when I asked her over the C.B. she <said> there were lots in the house.","","","","","","","","","","","","","","v","VBD",""],[6,7,1,9,"a","Uuminaqvaa-ll' iqairissuuten assiitelliniuq.","How frustrating that your washing machine is broken.","iqairi-9.mp3",,"","","<Uuminaq>vaa-ll' iqairissuuten assiitelliniuq.","","How <frustrating> that your washing machine is broken.","","","","","","","","","","","","","","v","JJ",""],[6,7,1,10,"b","Tua-i-wa ak'allaurcami. Uika kipucugtuq allamek kiaku kuvyarraarluni.","Oh well, it's because it's old. My husband wants to buy another one next summer after he fishes.","iqairi-10.mp3",,"","","Tua-i-wa <ak'alla>urcami. Uika kipucugtuq allamek kiaku kuvyarraarluni.","","Oh well, it's because it's <old>. My husband wants to buy another one next summer after he fishes.","","","","","","","","","","","","","","n","sg",""],[6,7,1,11,"a","Kenirciqua luqruuyagnek ut'reskuvet nerniartukuk.","I'll cook some pike and we'll eat when you return.","iqairi-11.mp3",,"","","Kenirciqua luqruuyagnek <ut'r>eskuvet nerniartukuk.","","I'll cook some pike and we'll eat when you <return>.","","","","","","","","","","","","","","v","NN",""],[6,7,1,12,"b","Ii-i, quyaciqua.","Good, I'll appreciate that.","iqairi-12.mp3",,"","","Ii-i, <quya>ciqua.","","Good, I'll <appreciate> that.","","","","","","","","","","","","","","v","VB",""],[6,7,2,1,"a","Enen-qaa kiircet'lartuq?","Is your house usally warm?","kaminiaq-1.mp3",306,"Kaminiaq: The Stove","In the winter between guest and host.","Enen-qaa <kiircet>'lartuq?","","Is your house usally <warm>?","","","","","","","","","","","","","","v","JJ",""],[6,7,2,2,"b","Ii-i, kaminiaqa tau͡gaam uqumek amllermek atussiyaalartuq.","Yes, but my stove is using too much oil.","kaminiaq-2.mp3",,"","","Ii-i, <kaminia>qa tau͡gaam uqumek amllermek atussiyaalartuq.","","Yes, but my <stove> is using too much oil.","","","","","","","","","","","","","","n","sg",""],[6,7,2,3,"a","Ilumun-wa. Kaminiam-llu uqua akitussiyaagluni.","That's for sure. Fuel oil is so expensive too.","kaminiaq-3.mp3",,"","","Ilumun-wa. Kaminiam-llu <uqu>a akitussiyaagluni.","","That's for sure. Fuel <oil> is so expensive too.","","","","","","","","","","","","","","n","sg",""],[6,7,2,4,"b","Muragcuutmek piciqua uksuqu.","I'm going to get a wood stove next summer.","kaminiaq-4.mp3",,"","","<Muragcuut>mek piciqua uksuqu.","","I'm going to get a <wood stove> next summer.","","","","","","","","","","","","","","n","sg",""],[6,7,2,5,"a","Wii-ll' piyugyaaqua.","I'd like to get one too.","kaminiaq-5.mp3",,"","","Wii-ll' <pi>yugyaaqua.","","I'd like to <get> one too.","","","","","","","","","","","","","","n","sg",""],[6,7,2,6,"b","Kiaku neqsurraarlua muragcurciqua kumakarrlua-llu.","Next summer after I fish, I'll get wood and some punk too.","kaminiaq-6.mp3",,"","","Kiaku <neqsu>rraarlua muragcurciqua kumakarrlua-llu.","","Next summer after I <fish>, I'll get wood and some punk too.","","","","","","","","","","","","","","v","NN",""],[6,7,3,1,"a","Qetunraan-qaa caliuq?","Is your son working?","qetunraan-1.mp3",905,"Qetunraan: Your Son","Between two men, probably neighbors.","<Qetunra>an-qaa caliuq?","","Is your <son> working?","","","","","","","","","","","","","","n","sg",""],[6,7,3,2,"b","Naamell’ tangeqsaitaqa unuamek. Unuaq nulirran qanrutellruanga levaaliurniluku.","I don’t know. I haven’t seen him today. His wife told me this morning that he was working on a motor.","qetunraan-2.mp3",,"","","Naamell’ tangeqsaitaqa unuamek. Unuaq <nulirr>an qanrutellruanga levaaliurniluku.","","I don’t know. I haven’t seen him today. His <wife> told me this morning that he was working on a motor.","","","","","","","","","","","","","","n","sg",""],[6,7,3,3,"a","Qaku-kiq taqciqa?","I wonder when he’ll be done?","qetunraan-3.mp3",,"","","Qaku-kiq <taq>ciqa?","","I wonder when he’ll <be done>?","","","","","","","","","","","","","","v","VB",""],[6,7,3,4,"b","Naamell’, levaau͡rlua ak'allaurtuq. Caliaqumaciqsugnarqaa. Ikayuryulliuten camek?","I don't know. His poor motor is gettting pretty old. He'll probably work on it for a long time. Perhaps you need help with something?","qetunraan-4.mp3",,"","","Naamell’, levaau͡rlua <ak'alla>urtuq. Caliaqumaciqsugnarqaa. Ikayuryulliuten camek?","","I don't know. His poor motor is gettting pretty <old>. He'll probably work on it for a long time. Perhaps you need help with something?","","","","","","","","","","","","","","n","sg",""],[6,7,3,5,"a","Apcugyaaqaqa weld-aritesqellua levaamnek.","I wanted to ask him to do some welding on my motor.","qetunraan-5.mp3",,"","","<Ap>cugyaaqaqa weld-aritesqellua levaamnek.","","I wanted to <ask> him to do some welding on my motor.","","","","","","","","","","","","","","v","VB",""],[6,7,4,1,"a","Natmurcit?","Where are you going?","pissuryar-1.mp3",703,"Pissuryarciqua: I'm going to go hunting","Between two young boys.","Natmur<cit>?","","Where are <you> going?","","","","","","","","","","","","","","e","",""],[6,7,4,2,"b","Payugteqatarqa maurluqa luqruuyagnek.","I'm going to take some pike to my grandmother.","pissuryar-2.mp3",,"","","<Payugte>qatarqa maurluqa luqruuyagnek.","","I'm going to <take> some pike to my grandmother.","","","","","","","","","","","","","","v","VB",""],[6,7,4,3,"a","Maligglaken. Nutarauguq-qaa nacan?","I'll go with you. Is your hat new?","pissuryar-3.mp3",,"","","<Maligg>laken. Nutarauguq-qaa nacan?","","I'll <go with> you. Is your hat new?","","","","","","","","","","","","","","v","VB",""],[6,7,4,4,"b","Ii-i, maurluma cikillruanga. Apa'urluqa-llu pissuryarciqukuk.","Yes, my grandmother gave it to me. My grandfather and I are going to go hunting.","pissuryar-4.mp3",,"","","Ii-i, maurluma <ciki>llruanga. Apa'urluqa-llu pissuryarciqukuk.","","Yes, my grandmother <gave> it to me. My grandfather and I are going to go hunting.","","","","","","","","","","","","","","v","VBD",""],[6,7,4,5,"a","Qaku?","When?","pissuryar-5.mp3",,"","","<Qaku>?","","<When>?","","","","","","","","","","","","","","p","",""],[6,7,4,6,"b","Unuaqu ella assiqan, qangqiircurciqukuk.","Tomorrow if the weather's good, we'll hunt ptarmigan.","pissuryar-6.mp3",,"","","Unuaqu ella assiqan, <qangqiir>curciqukuk.","","Tomorrow if the weather's good, we'll hunt <ptarmigan>.","","","","","","","","","","","","","","n","sg",""],[6,7,4,7,"a","Nutengqertuten-qaa?","Do you have a gun?","pissuryar-7.mp3",,"","","<Nute>ngqertuten-qaa?","","Do you have a <gun>?","","","","","","","","","","","","","","n","sg",""],[6,7,4,8,"b","Ii-i, aatama cikillruanga Alussistuami.","Yes, my father game me one at Christmas.","pissuryar-8.mp3",,"","","Ii-i, <aata>ma cikillruanga Alussistuami.","","Yes, my <father> game me one at Christmas.","","","","","","","","","","","","","","n","sg",""],[6,7,4,9,"a","Assirpaa! Cakuciuga?","That's great! What kind is it?","pissuryar-9.mp3",,"","","Assirpaa! <Cakuci>uga?","","That's great! <What kind> is it?","","","","","","","","","","","","","","n","sg",""],[6,7,4,10,"b","410-aaruuq.","It is a 410.","pissuryar-10.mp3",,"","","410-aaru<uq>.","","<It> is a 410.","","","","","","","","","","","","","","e","",""],[6,7,4,11,"a","Nutaan atam. Wii-llu-tuq nutengqerrlii.","That's really neat. I wish I had a gun too.","pissuryar-11.mp3",,"","","Nutaan atam. Wii-llu-tuq <nute>ngqerrlii.","","That's really neat. I wish I had a <gun> too.","","","","","","","","","","","","","","n","sg",""],[6,13,1,1,"a","Nunaciiqan-qaa aanan?","Are you going to visit your mother?","nunate-1.mp3",410,"Nunacugyaaqua: I'd like to visit in another village","Between two adults, probably relatives or close friends.","<Nuna>ciiqan-qaa aanan?","","Are you going to <visit> your mother?","","","","","","","","","","","","","","v","NN",""],[6,13,1,2,"b","Ii-i, nunacugyaaqaqa Agayunermi.","Yes, I'd like to visit her Sunday.","nunate-2.mp3",,"","","Ii-i, nunacugyaaqaqa <Agayuner>mi.","","Yes, I'd like to visit her <Sunday>.","","","","","","","","","","","","","","n","sg",""],[6,13,1,3,"a","Wii-llu nunacugyaaqua Naparyarrarmun tau͡gaam ilurama May'am aturyullrua angyaqa.","I'd also like to visit to Napakiak, but my cousin May'aq wanted to use my boat.","nunate-3.mp3",,"","","Wii-llu nunacugyaaqua Naparyarrarmun tau͡gaam ilurama May'am aturyullrua <angya>qa.","","I'd also like to visit to Napakiak, but my cousin May'aq wanted to use my <boat>.","","","","","","","","","","","","","","n","sg",""],[6,13,1,4,"b","May'aq caqatarta?","What is May'aq going to do?","nunate-4.mp3",,"","","May'aq <ca>qatarta?","","<What> is May'aq going to do?","","","","","","","","","","","","","","v","WP",""],[6,13,1,5,"a","Pissuryullruuq un'gani kuvyirluni-llu.","He wanted to do some hunting downriver and also set a net.","nunate-5.mp3",,"","","<Pissur>yullruuq un'gani kuvyirluni-llu.","","He wanted to do some <hunting> downriver and also set a net.","","","","","","","","","","","","","","v","NN",""],[6,13,1,6,"b","Tua-llu-qaa imna levaan Sak'am kiputellrua?","Well now, did Sak'aq ever buy your motor?","nunate-6.mp3",,"","","Tua-llu-qaa imna levaan Sak'am <kipute>llrua?","","Well now, did Sak'aq ever <buy> your motor?","","","","","","","","","","","","","","v","VB",""],[6,13,1,7,"a","Kiputeksaitaa, tau͡gaam piyullrua kuvyarraarluni taryaqvagnek.","He hasn't bought it yet, but he wants to after he fishes for king salmon.","nunate-7.mp3",,"","","Kiputeksaitaa, tau͡gaam piyullrua kuvyarraarluni <taryaqvag>nek.","","He hasn't bought it yet, but he wants to after he fishes for <king salmon>.","","","","","","","","","","","","","","n","sg",""],[6,13,1,8,"b","Allamek-qaa levaamek kipuciiquten?","Will you buy another motor then?","nunate-8.mp3",,"","","Allamek-qaa <levaa>mek kipuciiquten?","","Will you buy another <motor> then?","","","","","","","","","","","","","","n","sg",""],[6,13,1,9,"a","Ii-i, kipuciiqua mikcuarmek.","Yes, I'll buy a small one.","nunate-9.mp3",,"","","Ii-i, kipuciiqua <mikcuar>mek.","","Yes, I'll buy a <small> one.","","","","","","","","","","","","","","n","sg",""],[6,13,1,10,"b","Aa-a.","I see.","nunate-10.mp3",,"","","<Aa-a>.","","<I see>.","","","","","","","","","","","","","","p","",""],[6,13,2,1,"a","Neryulliuten?","Would you care for something to eat?","neryulli-1.mp3",307,"Neryulliuten?: Would you care for something to eat?","Between two adults.","Neryulli<uten>?","","Would <you> care for something to eat?","","","","","","","","","","","","","","e","",""],[6,13,2,2,"b","Qang'a, aqsissiyaagtua. Tau͡gaam saayungqerquvet yuurqacuaqaqerlii.","No thank you, I'm too full, but I'll have a little tea if you have some.","neryulli-2.mp3",,"","","Qang'a, <aqsi>ssiyaagtua. Tau͡gaam saayungqerquvet yuurqacuaqaqerlii.","","No thank you, I'm too <full>, but I'll have a little tea if you have some.","","","","","","","","","","","","","","v","JJ",""],[6,13,2,3,"a","Nerevkaraaten-qaa Nay'am?","Did you eat at Nay'aq's? (lit., Were you her guest?)","neryulli-3.mp3",,"","","<Nere>vkaraaten-qaa Nay'am?","","Did you <eat> at Nay'aq's? (lit., Were you her guest?)","","","","","","","","","","","","","","v","VB",""],[6,13,2,4,"b","Ii-i, ner'ukut luqruuyagnek, taryaqvagnek, akutamek-llu.","Yes, we had dried pike (with seal oil), king salmon, and akutaq.","neryulli-4.mp3",,"","","Ii-i, ner'ukut <luqruuyag>nek, taryaqvagnek, akutamek-llu.","","Yes, we had dried <pike> (with seal oil), king salmon, and akutaq.","","","","","","","","","","","","","","n","sg",""],[6,13,2,5,"a","Assirpaa-lli. Qangqiirnek kenirciqua ataku, neryugtuten-qaa maani?","Sounds wonderful. I'm going to cook some ptarmigan this evening, do you want to eat here?","neryulli-5.mp3",,"","","Assirpaa-lli. <Qangqiir>nek kenirciqua ataku, neryugtuten-qaa maani?","","Sounds wonderful. I'm going to cook some <ptarmigan> this evening, do you want to eat here?","","","","","","","","","","","","","","n","sg",""],[6,13,2,6,"b","Aqvayullruyaaqaanga Angivv'am ataku calirraarluni, ayanrilkuma taiciqua.","Angivv'aq wanted to pick me up this evening after he's through working, (but) if I don't go I'll come over.","neryulli-6.mp3",,"","","Aqvayullruyaaqaanga Angivv'am <ataku> calirraarluni, ayanrilkuma taiciqua.","","Angivv'aq wanted to pick me up <this evening> after he's through working, (but) if I don't go I'll come over.","","","","","","","","","","","","","","p","",""],[6,13,3,1,"a","Amiik ikirteqerru.","Please open the door?","amiik-1.mp3",7,"Amiik ikirteqerru: Please open the door","Between mother and teenage child.","Amiik <ikirte>qerru.","","Please <open> the door?","","","","","","","","","","","","","","v","JJ",""],[6,13,3,2,"b","Ciin? Ikirtenrilli, egturyalissiyaagtuq.","Why? It shouldn't be open, there's too many mosquitos.","amiik-2.mp3",,"","","Ciin? Ikirtenrilli, <egturya>lissiyaagtuq.","","Why? It shouldn't be open, there's too many <mosquitos>.","","","","","","","","","","","","","","n","pl",""],[6,13,3,3,"a","Kitak kaminiaq nipli.","Well then the stove should be turned off.","amiik-3.mp3",,"","","Kitak kaminiaq <nip>li.","","Well then the stove should be <turned off>.","","","","","","","","","","","","","","v","VBD",""],[6,13,3,4,"b","Ak'a niptellruaqa.","I turned it off a while ago.","amiik-4.mp3",,"","","<Ak'a> niptellruaqa.","","I turned it off <a while ago>.","","","","","","","","","","","","","","p","",""],[6,13,3,5,"a","Aren, nalluyagutelliniaqa Tut'am qaspera Panill'am eniini, aqvayugan-qaa?","Darn, I must've forgotten Tut'aq's kuspuk at Panill'aq's house, do you want to get it?","amiik-5.mp3",,"","","Aren, <nalluyagute>lliniaqa Tut'am qaspera Panill'am eniini, aqvayugan-qaa?","","Darn, I must've <forgotten> Tut'aq's kuspuk at Panill'aq's house, do you want to get it?","","","","","","","","","","","","","","v","VBN",""],[6,13,3,6,"b","Ii-i.","Sure.","amiik-6.mp3",,"","","<Ii-i>.","","<Sure>.","","","","","","","","","","","","","","p","",""],[6,13,3,7,"a","Egmian taikina.","Come straight back (immediately).","amiik-7.mp3",,"","","Egmian <tai>kina.","","<Come> straight back (immediately).","","","","","","","","","","","","","","v","VB",""],[6,13,4,1,"a","Nauwa-mi aanan?","Where's your mother?","akngirte-1.mp3",411,"Akngirtellruuq: He got hurt","Between two women.","Nauwa-mi <aana>n?","","Where's your <mother>?","","","","","","","","","","","","","","n","sg",""],[6,13,4,2,"b","Ivan'aaq emutaa. Egmian taiciquq.","She took Evon to the clinic. She'll come back right away.","akngirte-2.mp3",,"","","Ivan'aaq emutaa. <Egmian> taiciquq.","","She took Evon to the clinic. She'll come back <right away>.","","","","","","","","","","","","","","p","",""],[6,13,4,3,"a","Akleng Ivan'aurluq qaill' pia?","Oh what's wrong with poor Evon?","akngirte-3.mp3",,"","","<Akleng> Ivan'aurluq qaill' pia?","","<Oh> what's wrong with poor Evon?","","","","","","","","","","","","","","p","",""],[6,13,4,4,"b","Akwaugaq atakumi tallini akngirtellrua. Puv'ssiyaagan emutaa.","He hurt his arm last night. Because it was so swollen she took him to the clinic.","akngirte-4.mp3",,"","","Akwaugaq atakumi tallini <akngirte>llrua. Puv'ssiyaagan emutaa.","","He <hurt> his arm last night. Because it was so swollen she took him to the clinic.","","","","","","","","","","","","","","v","VBN",""],[6,13,4,5,"a","Uumi-llu irniaqa akngircaaquq tau͡gaam assirtuq.","The other day my child got hurt but she's okay now.","akngirte-5.mp3",,"","","Uumi-llu <irnia>qa akngircaaquq tau͡gaam assirtuq.","","The other day my <child> got hurt but she's okay now.","","","","","","","","","","","","","","n","sg",""],[6,13,4,6,"b","Natii akngircaaqa?","Where did she get hurt?","akngirte-6.mp3",,"","","Natii <akngir>caaqa?","","Where did she get <hurt>?","","","","","","","","","","","","","","v","VBN",""],[6,13,4,7,"a","Irua. Emutellrunritaqa tau͡gaam egmian assirillruuq.","On her leg, but I didn’t take her to the clinic because she got better right away.","akngirte-7.mp3",,"","","Irua. Emutellrunritaqa tau͡gaam egmian <assiri>llruuq.","","On her leg, but I didn’t take her to the clinic because she <got better> right away.","","","","","","","","","","","","","","v","VBD",""],[6,13,4,8,"b","Kuuvviaryugtuten-qaa?","Do you want some coffee?","akngirte-8.mp3",,"","","<Kuuvviar>yugtuten-qaa?","","Do you want some <coffee>?","","","","","","","","","","","","","","v","NN",""],[6,17,1,1,"a","Natmurteqatarcit?","Where are you going?","natmurte-1.mp3",8,"Natmurteqatarcit?: Where are you going?","","Natmurteqatar<cit>?","","Where are <you> going?","","","","","","","","","","","","","","e","",""],[6,17,1,2,"b","Nay'am maurlua payugteqataraqa luqruuyagnek uqumek-llu.","I'm going to take some pike and seal oil to Nay'aq's grandmother.","natmurte-2.mp3",,"","","Nay'am maurlua <payugte>qataraqa luqruuyagnek uqumek-llu.","","I'm going to <take> some pike and seal oil to Nay'aq's grandmother.","","","","","","","","","","","","","","v","VB",""],[6,17,1,3,"a","Tua-llu-qaa qaillun ayuqa?","How is she doing?","natmurte-3.mp3",,"","","Tua-llu-qaa qaillun <ayuq>a?","","How is she <doing>?","","","","","","","","","","","","","","v","VBG",""],[6,17,1,4,"b","Unuaq Panill'am qanrutellruanga cali-gguq naulluuguq.","Panill'aq told me this morning that she's still sick.","natmurte-4.mp3",,"","","Unuaq Panill'am qanrutellruanga cali-gguq <naulluu>guq.","","Panill'aq told me this morning that she's still <sick>.","","","","","","","","","","","","","","v","JJ",""],[6,17,1,5,"a","Akleng. Nererraarlua Tun'aq paqciiqaqa. Tangerrsugaqa nutaraq nutga.","I'm sorry. I'll go see Tun'aq after I eat. I want to see his new gun.","natmurte-5.mp3",,"","","Akleng. Nererraarlua Tun'aq <paq>ciiqaqa. Tangerrsugaqa nutaraq nutga.","","I'm sorry. I'll <go see> Tun'aq after I eat. I want to see his new gun.","","","","","","","","","","","","","","v","VB",""],[6,17,1,6,"b","Qangqiirmek suupalillruunga. Amllessiyaanrituq. Nangyaqunaku. Aatan tekiskuni kaigciquq.","I made some ptarmigan soup. There's not too much of it. Don't finish it. Your father will be hungry when he arrives.","natmurte-6.mp3",,"","","Qangqiirmek suupalillruunga. Amllessiyaanrituq. <Nang>yaqunaku. Aatan tekiskuni kaigciquq.","","I made some ptarmigan soup. There's not too much of it. Don't <finish> it. Your father will be hungry when he arrives.","","","","","","","","","","","","","","v","VB",""],[6,17,1,7,"a","Natmurtellrua?","Where did he go?","natmurte-7.mp3",,"","","Natmurtellru<a>?","","Where did <he> go?","","","","","","","","","","","","","","e","",""],[6,17,1,8,"b","Neqlillernun itrallruuq taryaqvagnek aqvalluni.","He went up to the fish camp to get some king salmon.","natmurte-8.mp3",,"","","Neqlillernun <itra>llruuq taryaqvagnek aqvalluni.","","He <went up> to the fish camp to get some king salmon.","","","","","","","","","","","","","","v","VBD",""],[6,17,2,1,"a","Qaku nunaciiqa maurlun?","When will your grandmother visit?","saayulriik-1.mp3",310,"Saayulriik: The Two Drinking Tea","Two people drinking tea.","Qaku <nuna>ciiqa maurlun?","","When will your grandmother <visit>?","","","","","","","","","","","","","","v","NN",""],[6,17,2,2,"b","Kiaku nunacullruyaaquq tau͡gaam pisciigaciiqsugnarquq.","She wanted to visit this summer but I don't think she'll be able to.","saayulriik-2.mp3",,"","","<Kiaku> nunacullruyaaquq tau͡gaam pisciigaciiqsugnarquq.","","She wanted to visit <this summer> but I don't think she'll be able to.","","","","","","","","","","","","","","p","",""],[6,17,2,3,"a","Ciin?","How come?","saayulriik-3.mp3",,"","","<Ciin>?","","<How come>?","","","","","","","","","","","","","","p","",""],[6,17,2,4,"b","Uinga-gguq caliciquq cannery-mi.","We heard that her husband will be working at the cannery.","saayulriik-4.mp3",,"","","<Ui>nga-gguq caliciquq cannery-mi.","","We heard that her <husband> will be working at the cannery.","","","","","","","","","","","","","","n","sg",""],[6,17,2,5,"a","Calinriqan-tuq nunalli.","I hope she visits when his job finishes.","saayulriik-5.mp3",,"","","<Cali>nriqan-tuq nunalli.","","I hope she visits when his <job> finishes.","","","","","","","","","","","","","","v","NN",""],[6,17,2,6,"b","Pili-tuq. Cali-qaa saayumek?","I hope so. Would you like more tea?","saayulriik-6.mp3",,"","","Pili-tuq. Cali-qaa <saayu>mek?","","I hope so. Would you like more <tea>?","","","","","","","","","","","","","","n","sg",""],[6,17,2,7,"a","Qang'a aqsissiyaagtua. Quyanaqvaa-ll' tua-i.","No thank you, I'm full. Thank you so much (for tea).","saayulriik-7.mp3",,"","","Qang'a <aqsi>ssiyaagtua. Quyanaqvaa-ll' tua-i.","","No thank you, I'm <full>. Thank you so much (for tea).","","","","","","","","","","","","","","v","JJ",""],[6,17,2,8,"b","Aa-ang. Cikirciqamken taryaqvagmek.","You're welcome. I'll give you some king salmon.","saayulriik-8.mp3",,"","","Aa-ang. <Cikir>ciqamken taryaqvagmek.","","You're welcome. I'll <give> you some king salmon.","","","","","","","","","","","","","","v","VB",""],[6,17,2,9,"a","Ala-i, quyana. Keniqsaitua taryaqvagmek ak'anek.","Oh, how nice. It's been a long time since I cooked some salmon.","saayulriik-9.mp3",,"","","Ala-i, quyana. <Keni>qsaitua taryaqvagmek ak'anek.","","Oh, how nice. It's been a long time since I <cook>ed some salmon.","","","","","","","","","","","","","","v","NN",""],[6,17,2,10,"b","Imna uika qasgim kaminiaranek caliyugnarquq.","I think my husband is working on the steambath's stove.","saayulriik-10.mp3",,"","","Imna uika <qasgi>m kaminiaranek caliyugnarquq.","","I think my husband is working on the <steambath>'s stove.","","","","","","","","","","","","","","n","sg",""],[6,17,2,11,"a","Qaill' kaminiara pia?","What's wrong with the stove (lit., its stove)?","saayulriik-11.mp3",,"","","Qaill' <kaminiar>a pia?","","What's wrong with the <stove> (lit., its stove)?","","","","","","","","","","","","","","n","sg",""],[6,17,2,12,"b","Assiitellruuq akwaugaq. Atam kaminiara ak'allauguq.","It wasn't working yesterday (lit., it wasn't good). You see, the stove is old.","saayulriik-12.mp3",,"","","<Assiite>llruuq akwaugaq. Atam kaminiara ak'allauguq.","","It <wasn't working> yesterday (lit., it wasn't good). You see, the stove is old.","","","","","","","","","","","","","","v","VBD",""],[6,17,2,13,"a","Tua-i, wii uterrlii.","I guess I'll go home.","saayulriik-13.mp3",,"","","Tua-i, wii <uterr>lii.","","I guess I'll <go home>.","","","","","","","","","","","","","","v","VB",""],[6,17,2,14,"b","Ii-i, quyana taiqerluten. Taryaqvak nalluyagucaqunaku.","Okay, thanks for dropping by. Don't forget the salmon.","saayulriik-14.mp3",,"","","Ii-i, quyana taiqerluten. Taryaqvak <nalluyagu>caqunaku.","","Okay, thanks for dropping by. Don't <forget> the salmon.","","","","","","","","","","","","","","v","VB",""],[6,17,2,15,"a","Teguciqaqa. Quyanaqvaa.","I'll take it. Thank you very much.","saayulriik-15.mp3",,"","","<Tegu>ciqaqa. Quyanaqvaa.","","I'll <take> it. Thank you very much.","","","","","","","","","","","","","","v","VB",""],[0,0,0,1,"a","Dummy","Dummy","dummy.mp3",,"","","<Dummy>","","<Dummy>","","","","","","","","","","","","","","p","",""]];

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sentenceTransitionTimings; });
var sentenceTransitionTimings={"qaneryaurci-2-5-1-1-a":[],"qaneryaurci-2-5-1-2-b":[1000],"qaneryaurci-2-5-1-3-a":[],"qaneryaurci-2-5-1-4-b":[],"qaneryaurci-2-5-2-1-a":[],"qaneryaurci-2-5-2-2-b":[],"qaneryaurci-2-5-2-3-a":[],"qaneryaurci-2-5-2-4-b":[],"qaneryaurci-2-8-1-1-a":[],"qaneryaurci-2-8-1-2-b":[],"qaneryaurci-2-8-1-2-b-2":[],"qaneryaurci-2-8-2-1-a":[],"qaneryaurci-2-8-2-2-b":[],"qaneryaurci-2-8-2-2-b-2":[],"qaneryaurci-2-8-2-3-a":[],"qaneryaurci-2-8-3-1-a":[],"qaneryaurci-2-8-3-2-b":[],"qaneryaurci-2-8-3-3-a":[],"qaneryaurci-2-8-3-4-b":[],"qaneryaurci-2-8-4-1-a":[],"qaneryaurci-2-8-4-2-b":[],"qaneryaurci-2-8-5-1-a":[],"qaneryaurci-2-8-5-2-b":[],"qaneryaurci-2-8-5-3-a":[],"qaneryaurci-2-8-5-4-b":[],"qaneryaurci-2-8-5-5-a":[],"qaneryaurci-2-14-1-1-a":[],"qaneryaurci-2-14-1-2-b":[],"qaneryaurci-2-14-1-2-b-2":[],"qaneryaurci-2-14-2-1-a":[],"qaneryaurci-2-14-2-2-b":[],"qaneryaurci-2-14-2-2-b-2":[],"qaneryaurci-2-14-3-1-a":[],"qaneryaurci-2-14-3-2-b":[],"qaneryaurci-2-14-3-3-a":[],"qaneryaurci-2-14-3-4-b":[],"qaneryaurci-2-14-4-1-a":[],"qaneryaurci-2-14-4-2-b":[],"qaneryaurci-2-14-4-3-a":[],"qaneryaurci-2-14-4-4-b":[],"qaneryaurci-2-14-5-1-a":[],"qaneryaurci-2-14-5-2-b":[],"qaneryaurci-2-14-5-3-a":[],"qaneryaurci-2-14-5-4-b":[],"qaneryaurci-2-14-6-1-a":[],"qaneryaurci-2-14-6-2-b":[],"qaneryaurci-2-14-6-3-a":[],"qaneryaurci-2-14-6-4-b":[],"qaneryaurci-2-14-6-5-a":[],"qaneryaurci-2-14-7-1-a":[],"qaneryaurci-2-14-7-2-b":[],"qaneryaurci-2-14-7-3-a":[],"qaneryaurci-2-14-7-4-b":[],"qaneryaurci-2-14-8-1-a":[],"qaneryaurci-2-14-8-2-b":[],"qaneryaurci-2-14-8-3-a":[],"qaneryaurci-2-14-8-4-b":[],"qaneryaurci-2-19-1-1-a":[],"qaneryaurci-2-19-1-2-b":[],"qaneryaurci-2-19-2-1-a":[],"qaneryaurci-2-19-2-2-b":[],"qaneryaurci-2-19-3-1-a":[],"qaneryaurci-2-19-3-2-b":[],"qaneryaurci-2-19-4-1-a":[],"qaneryaurci-2-19-4-2-b":[],"qaneryaurci-2-19-5-1-a":[],"qaneryaurci-2-19-5-2-b":[],"qaneryaurci-2-19-6-1-a":[],"qaneryaurci-2-19-6-2-b":[],"qaneryaurci-2-19-7-1-a":[],"qaneryaurci-2-19-7-2-b":[],"qaneryaurci-2-19-8-1-a":[],"qaneryaurci-2-19-8-2-b":[],"qaneryaurci-3-3-1-1-a":[],"qaneryaurci-3-3-1-2-b":[],"qaneryaurci-3-3-2-1-a":[],"qaneryaurci-3-3-2-2-b":[],"qaneryaurci-3-3-2-2-b-2":[],"qaneryaurci-3-3-3-1-a":[],"qaneryaurci-3-3-3-1-a-2":[],"qaneryaurci-3-3-3-2-b":[],"qaneryaurci-3-3-4-1-a":[],"qaneryaurci-3-3-4-2-b":[],"qaneryaurci-3-3-5-1-a":[],"qaneryaurci-3-3-5-2-b":[],"qaneryaurci-3-3-5-2-b-2":[],"qaneryaurci-3-3-6-1-a":[],"qaneryaurci-3-3-6-2-b":[],"qaneryaurci-3-3-7-1-a":[],"qaneryaurci-3-3-7-2-b":[],"qaneryaurci-3-3-7-2-b-2":[],"qaneryaurci-3-3-8-1-a":[],"qaneryaurci-3-3-8-2-b":[],"qaneryaurci-3-3-9-1-a":[],"qaneryaurci-3-3-9-2-b":[],"qaneryaurci-3-3-9-3-a":[],"qaneryaurci-3-3-9-4-b":[],"qaneryaurci-3-4-1-1-a":[],"qaneryaurci-3-4-1-2-b":[],"qaneryaurci-3-4-1-2-b-2":[],"qaneryaurci-3-4-2-1-a":[],"qaneryaurci-3-4-2-2-b":[],"qaneryaurci-3-4-3-1-a":[],"qaneryaurci-3-4-3-2-b":[],"qaneryaurci-3-4-4-1-a":[],"qaneryaurci-3-4-4-1-a-2":[],"qaneryaurci-3-4-4-1-a-3":[],"qaneryaurci-3-4-4-2-b":[],"qaneryaurci-3-4-4-2-b-2":[],"qaneryaurci-3-4-5-1-a":[],"qaneryaurci-3-4-5-2-b":[],"qaneryaurci-3-4-5-2-b-2":[],"qaneryaurci-3-4-6-1-a":[],"qaneryaurci-3-4-6-1-a-2":[],"qaneryaurci-3-4-6-2-b":[],"qaneryaurci-3-4-7-1-a":[],"qaneryaurci-3-4-7-2-b":[],"qaneryaurci-3-4-8-1-a":[],"qaneryaurci-3-4-8-2-b":[],"qaneryaurci-3-4-9-1-a":[],"qaneryaurci-3-4-9-2-b":[],"qaneryaurci-3-4-10-1-a":[],"qaneryaurci-3-4-10-1-a-2":[],"qaneryaurci-3-4-10-2-b":[],"qaneryaurci-3-4-11-1-a":[],"qaneryaurci-3-4-11-2-b":[],"qaneryaurci-3-4-12-1-a":[],"qaneryaurci-3-4-12-2-b":[],"qaneryaurci-3-4-13-1-a":[],"qaneryaurci-3-4-13-2-b":[],"qaneryaurci-3-4-14-1-a":[],"qaneryaurci-3-4-14-2-b":[],"qaneryaurci-3-4-15-1-a":[],"qaneryaurci-3-4-15-2-b":[],"qaneryaurci-3-4-16-1-a":[],"qaneryaurci-3-4-16-2-b":[],"qaneryaurci-3-4-17-1-a":[],"qaneryaurci-3-4-17-2-b":[],"qaneryaurci-3-4-18-1-a":[],"qaneryaurci-3-4-18-2-b":[],"qaneryaurci-3-4-19-1-a":[],"qaneryaurci-3-4-19-2-b":[],"qaneryaurci-3-4-20-1-a":[],"qaneryaurci-3-4-20-2-b":[],"qaneryaurci-3-4-21-1-a":[],"qaneryaurci-3-4-21-2-b":[],"qaneryaurci-3-4-22-1-a":[],"qaneryaurci-3-4-22-2-b":[],"qaneryaurci-3-8-1-1-a":[],"qaneryaurci-3-8-1-2-b":[],"qaneryaurci-3-8-1-2-b-2":[],"qaneryaurci-3-8-2-1-a":[],"qaneryaurci-3-8-2-2-b":[],"qaneryaurci-3-8-3-1-a":[],"qaneryaurci-3-8-3-2-b":[],"qaneryaurci-3-8-4-1-a":[],"qaneryaurci-3-8-4-2-b":[],"qaneryaurci-3-8-4-2-b-2":[],"qaneryaurci-3-8-5-1-a":[],"qaneryaurci-3-8-5-2-b":[],"qaneryaurci-3-8-6-1-a":[],"qaneryaurci-3-8-6-2-b":[],"qaneryaurci-3-14-1-1-a":[],"qaneryaurci-3-14-1-2-b":[],"qaneryaurci-3-14-2-1-a":[],"qaneryaurci-3-14-2-2-b":[],"qaneryaurci-3-14-2-2-b-2":[],"qaneryaurci-3-14-2-3-a":[],"qaneryaurci-3-14-2-4-b":[],"qaneryaurci-3-14-2-5-a":[],"qaneryaurci-3-14-2-6-b":[],"qaneryaurci-3-14-3-1-a":[],"qaneryaurci-3-14-3-2-b":[],"qaneryaurci-3-14-3-2-b-2":[],"qaneryaurci-3-14-4-1-a":[],"qaneryaurci-3-14-4-2-b":[],"qaneryaurci-3-14-5-1-a":[],"qaneryaurci-3-14-5-2-b":[],"qaneryaurci-3-14-6-1-a":[],"qaneryaurci-3-14-6-2-b":[],"qaneryaurci-3-14-6-2-b-2":[],"qaneryaurci-3-14-7-1-a":[],"qaneryaurci-3-14-7-2-b":[],"qaneryaurci-3-14-8-1-a":[],"qaneryaurci-3-14-8-2-b":[],"qaneryaurci-3-14-9-1-a":[],"qaneryaurci-3-14-9-2-b":[],"qaneryaurci-3-14-9-3-a":[],"qaneryaurci-3-14-9-4-b":[],"qaneryaurci-3-14-10-1-a":[],"qaneryaurci-3-14-10-2-b":[],"qaneryaurci-3-14-11-1-a":[],"qaneryaurci-3-14-11-2-b":[],"qaneryaurci-3-21-1-1-a":[],"qaneryaurci-3-21-1-2-b":[],"qaneryaurci-3-21-2-1-a":[],"qaneryaurci-3-21-2-2-b":[],"qaneryaurci-3-21-2-2-b-2":[],"qaneryaurci-3-21-3-1-a":[],"qaneryaurci-3-21-3-2-b":[],"qaneryaurci-3-21-3-2-b-2":[],"qaneryaurci-3-21-4-1-a":[],"qaneryaurci-3-21-4-2-b":[],"qaneryaurci-3-21-5-1-a":[],"qaneryaurci-3-21-5-2-b":[],"qaneryaurci-3-21-5-2-b-2":[],"qaneryaurci-3-21-6-1-a":[],"qaneryaurci-3-21-6-2-b":[],"qaneryaurci-3-21-6-2-b-2":[],"qaneryaurci-3-21-7-1-a":[],"qaneryaurci-3-21-7-2-b":[],"qaneryaurci-3-21-8-1-a":[],"qaneryaurci-3-21-8-2-b":[],"qaneryaurci-3-21-9-1-a":[],"qaneryaurci-3-21-9-2-b":[],"qaneryaurci-3-21-10-1-a":[],"qaneryaurci-3-21-10-2-b":[],"qaneryaurci-3-21-10-2-b-2":[],"qaneryaurci-3-22-1-1-a":[],"qaneryaurci-3-22-1-2-b":[],"qaneryaurci-3-22-1-3-a":[],"qaneryaurci-3-22-1-4-b":[],"qaneryaurci-3-22-1-5-a":[],"qaneryaurci-3-22-1-6-b":[],"qaneryaurci-4-2-1-1-a":[],"qaneryaurci-4-2-1-2-b":[],"qaneryaurci-4-2-1-3-a":[],"qaneryaurci-4-2-1-4-b":[],"qaneryaurci-4-2-2-1-a":[],"qaneryaurci-4-2-2-2-b":[],"qaneryaurci-4-2-2-3-a":[],"qaneryaurci-4-2-2-4-b":[],"qaneryaurci-4-2-3-1-a":[],"qaneryaurci-4-2-3-2-b":[],"qaneryaurci-4-2-3-3-a":[],"qaneryaurci-4-2-3-4-b":[],"qaneryaurci-4-2-4-1-a":[],"qaneryaurci-4-2-4-2-b":[],"qaneryaurci-4-2-4-3-a":[],"qaneryaurci-4-2-4-4-b":[],"qaneryaurci-4-6-1-1-a":[],"qaneryaurci-4-6-1-2-b":[],"qaneryaurci-4-6-1-2-b-2":[],"qaneryaurci-4-6-2-1-a":[],"qaneryaurci-4-6-2-2-b":[],"qaneryaurci-4-6-2-2-b-2":[],"qaneryaurci-4-6-3-1-a":[],"qaneryaurci-4-6-3-2-b":[],"qaneryaurci-4-6-4-1-a":[],"qaneryaurci-4-6-4-2-b":[],"qaneryaurci-4-6-5-1-a":[],"qaneryaurci-4-6-5-2-b":[],"qaneryaurci-4-6-6-1-a":[],"qaneryaurci-4-6-6-2-b":[],"qaneryaurci-4-6-6-2-b-2":[],"qaneryaurci-4-6-7-1-a":[],"qaneryaurci-4-6-7-2-b":[],"qaneryaurci-4-6-7-3-a":[],"qaneryaurci-4-6-7-4-b":[],"qaneryaurci-4-6-7-4-b-2":[],"qaneryaurci-4-6-8-1-a":[],"qaneryaurci-4-6-8-2-b":[],"qaneryaurci-4-6-8-3-a":[],"qaneryaurci-4-6-8-4-b":[],"qaneryaurci-4-6-9-1-a":[],"qaneryaurci-4-6-9-2-b":[],"qaneryaurci-4-6-9-3-a":[],"qaneryaurci-4-6-9-4-b":[],"qaneryaurci-4-6-10-1-a":[],"qaneryaurci-4-6-10-2-b":[],"qaneryaurci-4-6-11-1-a":[],"qaneryaurci-4-6-11-2-b":[],"qaneryaurci-4-6-11-3-a":[],"qaneryaurci-4-6-11-4-b":[],"qaneryaurci-4-6-12-1-a":[],"qaneryaurci-4-6-12-2-b":[],"qaneryaurci-4-6-12-2-b-2":[],"qaneryaurci-4-6-12-2-b-3":[],"qaneryaurci-4-6-12-3-a":[],"qaneryaurci-4-6-12-4-b":[],"qaneryaurci-4-6-12-4-b-2":[],"qaneryaurci-4-15-1-1-a":[],"qaneryaurci-4-15-1-2-b":[],"qaneryaurci-4-15-1-3-a":[],"qaneryaurci-4-15-2-1-a":[],"qaneryaurci-4-15-2-2-b":[],"qaneryaurci-4-15-2-3-a":[],"qaneryaurci-4-15-2-4-b":[],"qaneryaurci-4-15-2-5-a":[],"qaneryaurci-4-15-2-6-b":[],"qaneryaurci-4-15-2-7-a":[],"qaneryaurci-4-15-3-1-a":[],"qaneryaurci-4-15-3-2-b":[],"qaneryaurci-4-15-3-3-a":[],"qaneryaurci-4-15-3-4-b":[],"qaneryaurci-4-15-3-5-a":[],"qaneryaurci-4-15-3-6-b":[],"qaneryaurci-4-15-3-7-a":[],"qaneryaurci-4-15-3-8-b":[],"qaneryaurci-4-15-4-1-a":[1400],"qaneryaurci-4-15-4-2-b":[1100],"qaneryaurci-4-15-4-2-b-2":[],"qaneryaurci-4-15-4-3-a":[500],"qaneryaurci-4-15-4-3-a-2":[500],"qaneryaurci-4-15-4-4-b":[1200],"qaneryaurci-4-15-4-4-b-2":[1300],"qaneryaurci-4-15-4-5-a":[],"qaneryaurci-4-15-4-6-b":[800],"qaneryaurci-4-15-5-1-a":[],"qaneryaurci-4-15-5-2-b":[],"qaneryaurci-4-15-5-2-b-2":[],"qaneryaurci-4-15-6-1-a":[],"qaneryaurci-4-15-6-2-b":[],"qaneryaurci-4-15-6-3-a":[],"qaneryaurci-4-15-7-1-a":[],"qaneryaurci-4-15-7-2-b":[],"qaneryaurci-4-15-7-2-b-2":[],"qaneryaurci-4-15-7-3-a":[],"qaneryaurci-4-15-7-4-b":[],"qaneryaurci-4-15-7-5-a":[],"qaneryaurci-4-15-8-1-a":[],"qaneryaurci-4-15-8-2-b":[],"qaneryaurci-4-15-9-1-a":[],"qaneryaurci-4-15-9-2-b":[],"qaneryaurci-4-15-9-3-a":[],"qaneryaurci-4-15-9-4-b":[],"qaneryaurci-4-21-1-1-a":[],"qaneryaurci-4-21-1-2-b":[],"qaneryaurci-4-21-1-3-a":[],"qaneryaurci-4-21-1-4-b":[],"qaneryaurci-4-21-1-5-a":[],"qaneryaurci-4-21-2-1-a":[],"qaneryaurci-4-21-2-2-b":[],"qaneryaurci-4-21-2-3-a":[],"qaneryaurci-4-21-2-4-b":[],"qaneryaurci-4-21-2-5-a":[],"qaneryaurci-4-21-2-6-b":[],"qaneryaurci-4-21-3-1-a":[],"qaneryaurci-4-21-3-2-b":[],"qaneryaurci-4-21-3-3-a":[],"qaneryaurci-4-21-4-1-a":[],"qaneryaurci-4-21-4-2-b":[],"qaneryaurci-4-21-4-3-a":[],"qaneryaurci-4-21-4-4-b":[],"qaneryaurci-4-21-4-5-a":[],"qaneryaurci-4-21-5-1-a":[],"qaneryaurci-4-21-5-2-b":[],"qaneryaurci-4-21-5-3-a":[],"qaneryaurci-4-21-5-4-b":[],"qaneryaurci-4-21-5-5-a":[],"qaneryaurci-4-21-5-6-b":[],"qaneryaurci-4-21-6-1-a":[],"qaneryaurci-4-21-6-2-b":[],"qaneryaurci-4-21-6-3-a":[],"qaneryaurci-4-21-6-4-b":[],"qaneryaurci-4-21-7-1-a":[],"qaneryaurci-4-21-7-2-b":[],"qaneryaurci-4-21-7-3-a":[],"qaneryaurci-4-21-7-4-b":[],"qaneryaurci-4-21-7-5-a":[],"qaneryaurci-4-21-7-6-b":[],"qaneryaurci-4-21-7-7-a":[],"qaneryaurci-4-21-8-1-a":[],"qaneryaurci-4-21-8-2-b":[],"qaneryaurci-4-21-8-3-a":[],"qaneryaurci-4-21-8-4-b":[],"qaneryaurci-5-2-1-1-a":[],"qaneryaurci-5-2-1-2-b":[],"qaneryaurci-5-2-1-3-a":[],"qaneryaurci-5-2-1-4-b":[],"qaneryaurci-5-2-1-5-a":[],"qaneryaurci-5-2-1-6-b":[],"qaneryaurci-5-2-1-7-a":[],"qaneryaurci-5-2-1-8-b":[],"qaneryaurci-5-2-2-1-a":[],"qaneryaurci-5-2-2-2-b":[],"qaneryaurci-5-2-2-3-a":[],"qaneryaurci-5-2-2-4-b":[],"qaneryaurci-5-2-3-1-a":[],"qaneryaurci-5-2-3-2-b":[],"qaneryaurci-5-2-3-2-b-2":[],"qaneryaurci-5-2-3-3-a":[],"qaneryaurci-5-2-3-4-b":[],"qaneryaurci-5-2-3-4-b-2":[],"qaneryaurci-5-2-4-1-a":[],"qaneryaurci-5-2-4-2-b":[],"qaneryaurci-5-2-4-3-a":[],"qaneryaurci-5-2-4-4-b":[],"qaneryaurci-5-2-4-5-a":[],"qaneryaurci-5-2-4-6-b":[],"qaneryaurci-5-2-4-7-a":[],"qaneryaurci-5-2-4-8-b":[],"qaneryaurci-5-2-4-9-a":[],"qaneryaurci-5-2-5-1-a":[],"qaneryaurci-5-2-5-2-b":[],"qaneryaurci-5-2-5-3-a":[],"qaneryaurci-5-2-5-4-b":[],"qaneryaurci-5-2-5-5-a":[],"qaneryaurci-5-2-5-6-b":[],"qaneryaurci-5-2-5-7-a":[],"qaneryaurci-5-2-5-8-b":[],"qaneryaurci-5-2-5-9-a":[],"qaneryaurci-5-2-5-10-b":[],"qaneryaurci-5-6-1-1-a":[],"qaneryaurci-5-6-1-2-b":[],"qaneryaurci-5-6-1-3-a":[],"qaneryaurci-5-6-1-4-b":[],"qaneryaurci-5-6-1-5-a":[],"qaneryaurci-5-6-1-6-b":[],"qaneryaurci-5-6-2-1-a":[],"qaneryaurci-5-6-2-2-b":[],"qaneryaurci-5-6-2-3-a":[],"qaneryaurci-5-6-2-4-b":[],"qaneryaurci-5-6-2-5-a":[],"qaneryaurci-5-6-3-1-a":[],"qaneryaurci-5-6-3-2-b":[],"qaneryaurci-5-6-3-3-a":[],"qaneryaurci-5-6-3-4-b":[],"qaneryaurci-5-6-3-5-a":[],"qaneryaurci-5-6-4-1-a":[],"qaneryaurci-5-6-4-2-b":[],"qaneryaurci-5-6-4-3-a":[],"qaneryaurci-5-6-4-4-b":[],"qaneryaurci-5-6-4-5-a":[],"qaneryaurci-5-6-4-6-b":[],"qaneryaurci-5-6-4-7-a":[],"qaneryaurci-5-6-5-1-a":[],"qaneryaurci-5-6-5-2-b":[],"qaneryaurci-5-6-5-3-a":[],"qaneryaurci-5-6-5-4-b":[],"qaneryaurci-5-6-5-5-a":[],"qaneryaurci-5-11-1-1-a":[],"qaneryaurci-5-11-1-2-b":[],"qaneryaurci-5-11-1-3-a":[],"qaneryaurci-5-11-1-4-b":[],"qaneryaurci-5-11-1-5-a":[],"qaneryaurci-5-11-2-1-a":[],"qaneryaurci-5-11-2-2-b":[],"qaneryaurci-5-11-2-3-a":[],"qaneryaurci-5-11-2-4-b":[],"qaneryaurci-5-11-3-1-a":[],"qaneryaurci-5-11-3-2-b":[],"qaneryaurci-5-11-3-3-a":[],"qaneryaurci-5-11-3-4-b":[],"qaneryaurci-5-11-3-5-a":[],"qaneryaurci-5-11-3-6-b":[],"qaneryaurci-5-11-3-7-a":[],"qaneryaurci-5-11-3-8-b":[],"qaneryaurci-5-11-4-1-a":[],"qaneryaurci-5-11-4-2-b":[],"qaneryaurci-5-11-4-3-a":[],"qaneryaurci-5-11-4-4-b":[],"qaneryaurci-5-15-1-1-a":[],"qaneryaurci-5-15-1-2-b":[],"qaneryaurci-5-15-1-3-a":[],"qaneryaurci-5-15-1-4-b":[],"qaneryaurci-5-15-1-5-a":[],"qaneryaurci-5-15-1-6-b":[],"qaneryaurci-5-15-1-7-a":[],"qaneryaurci-5-15-1-8-b":[],"qaneryaurci-5-15-2-1-a":[500,1500],"qaneryaurci-5-15-2-2-b":[500,1800],"qaneryaurci-5-15-2-3-a":[1100],"qaneryaurci-5-15-2-4-b":[1000,1700,2500],"qaneryaurci-5-15-2-5-a":[500,900,2400],"qaneryaurci-5-15-2-6-b":[600,1300,1700],"qaneryaurci-5-15-2-7-a":[700,1800,2500],"qaneryaurci-5-15-2-8-b":[2700,3400,4200],"qaneryaurci-5-15-2-9-a":[],"qaneryaurci-5-15-3-1-a":[],"qaneryaurci-5-15-3-2-b":[],"qaneryaurci-5-15-3-3-a":[],"qaneryaurci-5-15-3-4-b":[],"qaneryaurci-5-15-3-5-a":[],"qaneryaurci-5-15-3-6-b":[],"qaneryaurci-5-15-4-1-a":[],"qaneryaurci-5-15-4-2-b":[],"qaneryaurci-5-15-4-3-a":[],"qaneryaurci-5-15-4-4-b":[],"qaneryaurci-5-15-4-5-a":[],"qaneryaurci-5-15-4-6-b":[],"qaneryaurci-6-2-1-1-a":[],"qaneryaurci-6-2-1-2-b":[],"qaneryaurci-6-2-1-3-a":[],"qaneryaurci-6-2-1-4-b":[],"qaneryaurci-6-2-1-5-c":[],"qaneryaurci-6-2-1-6-a":[],"qaneryaurci-6-2-1-7-c":[],"qaneryaurci-6-2-1-8-a":[],"qaneryaurci-6-2-2-1-a":[],"qaneryaurci-6-2-2-2-b":[],"qaneryaurci-6-2-2-3-a":[],"qaneryaurci-6-2-2-4-b":[],"qaneryaurci-6-2-2-5-a":[],"qaneryaurci-6-2-2-6-b":[],"qaneryaurci-6-2-3-1-a":[],"qaneryaurci-6-2-3-2-b":[],"qaneryaurci-6-2-3-3-a":[],"qaneryaurci-6-2-3-4-b":[],"qaneryaurci-6-2-4-1-a":[],"qaneryaurci-6-2-4-2-b":[],"qaneryaurci-6-2-4-3-a":[],"qaneryaurci-6-2-4-4-b":[],"qaneryaurci-6-2-4-5-a":[],"qaneryaurci-6-2-4-6-b":[],"qaneryaurci-6-2-4-7-a":[],"qaneryaurci-6-2-4-8-b":[],"qaneryaurci-6-2-4-9-a":[],"qaneryaurci-6-2-4-10-b":[],"qaneryaurci-6-2-5-1-a":[],"qaneryaurci-6-2-5-2-b":[],"qaneryaurci-6-2-5-3-a":[],"qaneryaurci-6-2-5-4-b":[],"qaneryaurci-6-7-1-1-a":[],"qaneryaurci-6-7-1-2-b":[],"qaneryaurci-6-7-1-3-a":[],"qaneryaurci-6-7-1-4-b":[],"qaneryaurci-6-7-1-5-a":[],"qaneryaurci-6-7-1-6-b":[],"qaneryaurci-6-7-1-7-a":[],"qaneryaurci-6-7-1-8-b":[],"qaneryaurci-6-7-1-9-a":[],"qaneryaurci-6-7-1-10-b":[],"qaneryaurci-6-7-1-11-a":[],"qaneryaurci-6-7-1-12-b":[],"qaneryaurci-6-7-2-1-a":[],"qaneryaurci-6-7-2-2-b":[],"qaneryaurci-6-7-2-3-a":[],"qaneryaurci-6-7-2-4-b":[],"qaneryaurci-6-7-2-5-a":[],"qaneryaurci-6-7-2-6-b":[],"qaneryaurci-6-7-3-1-a":[],"qaneryaurci-6-7-3-2-b":[],"qaneryaurci-6-7-3-3-a":[],"qaneryaurci-6-7-3-4-b":[],"qaneryaurci-6-7-3-5-a":[],"qaneryaurci-6-7-4-1-a":[],"qaneryaurci-6-7-4-2-b":[],"qaneryaurci-6-7-4-3-a":[],"qaneryaurci-6-7-4-4-b":[],"qaneryaurci-6-7-4-5-a":[],"qaneryaurci-6-7-4-6-b":[],"qaneryaurci-6-7-4-7-a":[],"qaneryaurci-6-7-4-8-b":[],"qaneryaurci-6-7-4-9-a":[],"qaneryaurci-6-7-4-10-b":[],"qaneryaurci-6-7-4-11-a":[],"qaneryaurci-6-13-1-1-a":[],"qaneryaurci-6-13-1-2-b":[],"qaneryaurci-6-13-1-3-a":[],"qaneryaurci-6-13-1-4-b":[],"qaneryaurci-6-13-1-5-a":[],"qaneryaurci-6-13-1-6-b":[],"qaneryaurci-6-13-1-7-a":[],"qaneryaurci-6-13-1-8-b":[],"qaneryaurci-6-13-1-9-a":[],"qaneryaurci-6-13-1-10-b":[],"qaneryaurci-6-13-2-1-a":[],"qaneryaurci-6-13-2-2-b":[],"qaneryaurci-6-13-2-3-a":[],"qaneryaurci-6-13-2-4-b":[],"qaneryaurci-6-13-2-5-a":[],"qaneryaurci-6-13-2-6-b":[],"qaneryaurci-6-13-3-1-a":[],"qaneryaurci-6-13-3-2-b":[],"qaneryaurci-6-13-3-3-a":[],"qaneryaurci-6-13-3-4-b":[],"qaneryaurci-6-13-3-5-a":[],"qaneryaurci-6-13-3-6-b":[],"qaneryaurci-6-13-3-7-a":[],"qaneryaurci-6-13-4-1-a":[],"qaneryaurci-6-13-4-2-b":[],"qaneryaurci-6-13-4-3-a":[],"qaneryaurci-6-13-4-4-b":[],"qaneryaurci-6-13-4-5-a":[],"qaneryaurci-6-13-4-6-b":[],"qaneryaurci-6-13-4-7-a":[],"qaneryaurci-6-13-4-8-b":[],"qaneryaurci-6-13-5-1-a":[],"qaneryaurci-6-13-5-2-b":[],"qaneryaurci-6-13-5-3-a":[],"qaneryaurci-6-13-5-4-b":[],"qaneryaurci-6-13-5-5-a":[],"qaneryaurci-6-17-1-1-a":[],"qaneryaurci-6-17-1-2-b":[],"qaneryaurci-6-17-1-3-a":[],"qaneryaurci-6-17-1-4-b":[],"qaneryaurci-6-17-1-5-a":[],"qaneryaurci-6-17-1-6-b":[],"qaneryaurci-6-17-1-7-a":[],"qaneryaurci-6-17-1-8-b":[],"qaneryaurci-6-17-2-1-a":[],"qaneryaurci-6-17-2-2-b":[],"qaneryaurci-6-17-2-3-a":[],"qaneryaurci-6-17-2-4-b":[],"qaneryaurci-6-17-2-5-a":[],"qaneryaurci-6-17-2-6-b":[],"qaneryaurci-6-17-2-7-a":[],"qaneryaurci-6-17-2-8-b":[],"qaneryaurci-6-17-2-9-a":[],"qaneryaurci-6-17-2-10-b":[],"qaneryaurci-6-17-2-11-a":[],"qaneryaurci-6-17-2-12-b":[],"qaneryaurci-6-17-2-13-a":[],"qaneryaurci-6-17-2-14-b":[],"qaneryaurci-6-17-2-15-a":[]};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(238);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(240);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(238);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(458);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(32);

var utils = __webpack_require__(149);
var scrollSpy = __webpack_require__(239);
var defaultScroller = __webpack_require__(148);
var PropTypes = __webpack_require__(1);
var scrollHash = __webpack_require__(457);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_qaneryaurci_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_dialogueListGenerator_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_scroll__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_ga4__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}__WEBPACK_IMPORTED_MODULE_8_react_ga4___default.a.initialize("G-WDEJDCK7QT");var scroll=__WEBPACK_IMPORTED_MODULE_7_react_scroll__["animateScroll"];var customFontFam="Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif";var iconStyle={paddingLeft:10,fontSize:12,color:'#2185d0'};var dialog_gen=Object(__WEBPACK_IMPORTED_MODULE_5__constants_dialogueListGenerator_js__["a" /* dialogueGenerator */])();var DialogueMenu=function(_Component){_inherits(DialogueMenu,_Component);function DialogueMenu(props){_classCallCheck(this,DialogueMenu);var _this=_possibleConstructorReturn(this,(DialogueMenu.__proto__||Object.getPrototypeOf(DialogueMenu)).call(this,props));_this.remove=function(array,element){var index=array.indexOf(element);array.splice(index,1);return array;};_this.toggleExercise=function(index){var showEx=_this.state.showExercise;if(showEx.includes(index)){_this.setState({showExercise:_this.remove(showEx,index)});}else{_this.setState({showExercise:[].concat(_toConsumableArray(showEx),[index])});}};console.log(props);_this.state={lessons:dialog_gen.lessons,// showExercise: [],
showExercise:_this.props.lessonsStarted===undefined?[]:_this.props.lessonsStarted};return _this;}_createClass(DialogueMenu,[{key:'render',value:function render(){var _this2=this;console.log(this.state);console.log(this.props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingRight:5,paddingLeft:5}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */],{textAlign:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Column,{style:{maxWidth:'800px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{justifyContent:'space-between',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:"/"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,style:{margin:0,marginLeft:5,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'chevron left'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Header */],{as:'h1'},'Dialogues')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:36}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{style:{marginBottom:'5px'}},this.state.lessons.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{style:{padding:0,borderBottom:index===60?'0px solid #E3E3E3':'1px solid #E3E3E3'}},i.context==="chunk"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},i.title)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingTop:'20px',paddingBottom:'10px',fontSize:'16px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontWeight:'bold'}},i.title.split(':')[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,i.title.split(':')[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'dialogues/'+index,state:{lessonIndex:index,exerciseNumber:-1}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{margin:'5px'}},'Listen Only',_this2.props.completedExercises.includes(index.toString()+'%-1')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:iconStyle,name:'check'}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{fontSize:'14px',fontWeight:'400'},onClick:function onClick(){_this2.toggleExercise(index);}},'Exercises',_this2.state.showExercise.includes(index)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{paddingLeft:10,fontSize:12},name:'chevron up'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{paddingLeft:10,fontSize:12},name:'chevron down'})),_this2.state.showExercise.includes(index)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',paddingTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'dialogues/'+index,state:{lessonIndex:index,exerciseNumber:0}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{margin:'5px'}},"Guess Yup'ik",_this2.props.completedExercises.includes(index.toString()+'%0')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:iconStyle,name:'check'}):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'dialogues/'+index,state:{lessonIndex:index,exerciseNumber:5}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{margin:'5px'}},"Listening Yup'ik",_this2.props.completedExercises.includes(index.toString()+'%5')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:iconStyle,name:'check'}):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'dialogues/'+index,state:{lessonIndex:index,exerciseNumber:1}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{margin:'5px'}},"Fill-In Yup'ik",_this2.props.completedExercises.includes(index.toString()+'%1')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:iconStyle,name:'check'}):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'dialogues/'+index,state:{lessonIndex:index,exerciseNumber:2}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{margin:'5px'}},"Select Yup'ik",_this2.props.completedExercises.includes(index.toString()+'%2')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:iconStyle,name:'check'}):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:'dialogues/'+index,state:{lessonIndex:index,exerciseNumber:4}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,compact:true,style:{margin:'5px'}},'Select English',_this2.props.completedExercises.includes(index.toString()+'%4')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:iconStyle,name:'check'}):null)))):null)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-evenly',alignItems:'center',height:60,paddingBottom:16,paddingTop:25}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.65},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column',justifyContent:'center',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'14px',color:'grey',padding:'15px',fontWeight:'400',lineHeight:'23px'}},'Website, audio library, and dialogue module production provided by ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{style:{color:'#306190'},href:'https://yuarcuun.github.io',target:'_blank'},'Yuarcuun Technologies'),' in partnership with Orutsararmiut Native Council (ONC). Dialogues from textbook Qaneryaurci Yup\'igtun (Hensel et al., 1983). Recordings done by Maklak Liu and Cikigaq John. This website was made possible by Grant Number 90XN0110-01-00 from Administration for Native Americans.')))));}}]);return DialogueMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DialogueMenu);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fuzzysort__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_fuzzysort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_fuzzysort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_performance_now__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_performance_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_performance_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_ga__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_github_fork_ribbon__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_github_fork_ribbon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_github_fork_ribbon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SearchPageHelpers_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TableEntry_js__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_StoriesRetrieved_js__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants_endingsConstants_js__ = __webpack_require__(438);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ReactPlayer from 'react-player'
// import Fuse from 'fuse.js';
// import {endingRules} from './constants/endingRules.js';
// Cache dictionary
var dictionary=[];var dictionary_dict={};// let dictionary_prepared = [];
// Search options
// let options = {
//   keys: ['yupik', 'english'],
//   minMatchCharLength: 3,
//   // includeScore: true,
//   distance: 10,
//   location: 2,
//   shouldSort: true,
//   //tokenize: true, // super slow!! 6x slower
//   // matchAllTokens: true,
//   threshold: 0.4,
//   findAllMatches: true,
// };
// let fuse = new Fuse([], options);
// let options1 = {
//   keys: ['yupik'],
//   // minMatchCharLength: 3,
//   // includeScore: true,
//   distance: 0,
//   // location: 2,
//   // shouldSort: true,
//   //tokenize: true, // super slow!! 6x slower
//   // matchAllTokens: true,
//   threshold: 0.0,
//   // findAllMatches: true,
// };
// let fuse1 = new Fuse([], options1);
// fuzzysort search
var optionsFuzzy={keys:['yupik','english'],limit:50,// don't return more results than you need!
threshold:-10000// don't return bad results
};var endingToEnglishTerms={"[Ind]":"Indicative (Statement Form)","[Intrg]":"Interrogative (Question Form)","[Opt]":"Optative (Command Form)","[Sbrd]":"Subordinative (Polite Command or -ing Form)","[Ptcp]":"Participial","[Prec]":"Precessive (before...)","[Cnsq]":"Consequential (because...)","[Cont]":"Contigent (whenever...)","[Conc]":"Concessive (although, even though, even if...)","[Cond]":"Conditional (if, when in the future...)","[CtmpI]":"Contemporative 1 (when in fthe past...)","[CtmpII]":"Contemporative 2 (while...)","[Abs]":"Absolutive","[Rel]":"Relative","[Abl_Mod]":"Ablative-Modalis (indirect object, from...)","[Loc]":"Localis (in, at...)","[Ter]":"Terminalis (toward...)","[Via]":"Vialis (through, using...)","[Equ]":"Equalis (like, similar to...)","[Quant_Qual]":"Quantifier/Qualifier Inflection","[S_3Sg]":"he,\xa0she,\xa0it","[S_3Du]":"they\xa0(2)","[S_3Pl]":"they\xa0all\xa0(3+)","[S_1Sg]":"I","[S_1Du]":"we\xa0(2)","[S_1Pl]":"we\xa0all\xa0(3+)","[S_2Sg]":"you","[S_2Du]":"you\xa0(2)","[S_2Pl]":"you\xa0all\xa0(3+)","[S_4Sg]":"he, she, it (itself)","[S_4Du]":"they (2) (themselves)","[S_4Pl]":"they all (3+) (themselves)","[A_3Sg]":"he,\xa0she,\xa0it","[A_3Du]":"they\xa0(2)","[A_3Pl]":"they\xa0all\xa0(3+)","[A_1Sg]":"I","[A_1Du]":"we\xa0(2)","[A_1Pl]":"we\xa0all\xa0(3+)","[A_2Sg]":"you","[A_2Du]":"you\xa0(2)","[A_2Pl]":"you\xa0all\xa0(3+)","[A_4Sg]":"he, she, it (itself)","[A_4Du]":"they (2) (themselves)","[A_4Pl]":"they all (3+) (themselves)",//   "[P_3Sg]":"her,\xa0him,\xa0it\xa0(other)",
//   "[P_3Du]":"the\xa0two\xa0of\xa0them\xa0(others)",
//   "[P_3Pl]":"them\xa0all\xa0(3+)\xa0(others)",
"[P_3Sg]":"another","[P_3Du]":"two others","[P_3Pl]":"3+ others","[P_1Sg]":"me","[P_1Du]":"the\xa0two\xa0of\xa0us","[P_1Pl]":"us\xa0all\xa0(3+)","[P_2Sg]":"you","[P_2Du]":"the\xa0two\xa0of\xa0you","[P_2Pl]":"you\xa0all\xa0(3+)","[P_4Sg]":"her,\xa0him,\xa0it\xa0(itself)","[P_4Du]":"the\xa0two\xa0of\xa0them\xa0(themselves)","[P_4Pl]":"them\xa0all\xa0(3+)\xa0(themselves)","[SgUnpd]":"the one","[DuUnpd]":"the two","[PlUnpd]":"the 3+","[SgPosd]":"one","[DuPosd]":"two","[PlPosd]":"three or more","[3SgPoss]":"his/her/its\xa0(other)","[3DuPoss]":"their\xa0(2)\xa0(other)","[3PlPoss]":"their\xa0(3+)\xa0(other)","[1SgPoss]":"my","[1DuPoss]":"our\xa0(2)","[1PlPoss]":"our\xa0(3+)","[2SgPoss]":"your\xa0(1)","[2DuPoss]":"your\xa0(2)","[2PlPoss]":"your\xa0(3+)","[4SgPoss]":"his/her/its\xa0own","[4DuPoss]":"their\xa0own\xa0(2)","[4PlPoss]":"their\xa0own\xa0(3+)","[3Sg]":"it\xa0(other)","[3Du]":"them\xa0(2)\xa0(other)","[3Pl]":"them\xa0(3+)\xa0(other)","[1Sg]":"me","[1Du]":"us\xa0(2)","[1Pl]":"us\xa0(3+)","[2Sg]":"you\xa0(1)","[2Du]":"you\xa0(2)","[2Pl]":"you\xa0(3+)","[4Sg]":"itself","[4Du]":"themselves\xa0(2)","[4Pl]":"themselves\xa0(3+)"};var endingEnglishDescriptions={"[Ind]":"(is, are, am)","[Intrg]":"(question)","[Opt]":"(do it!)","[Sbrd]":"(please do, being)","[Ptcp]":"(the one being, special case)","[Prec]":"(before)","[Cnsq]":"(because)","[Cont]":"(whenever)","[Conc]":"(although, even if)","[Cond]":"(if, when in future)","[CtmpI]":"(when in past)","[CtmpII]":"(while)","[Abs]":"the","[Rel]":"the","[Abl_Mod]":"[a, some, from]","[Loc]":"in or at","[Ter]":"toward","[Via]":"through or using","[Equ]":"like or similar to","[Quant_Qual]":"Quantifier/Qualifier Inflection"};var endingDescriptions=["1) statements; 2) “yes-no” questions, usually with enclitic =qaa","1) content questions; 2) exclamations with the postbase @5+pag- | ~vag-","1) commands, requests, suggestions; 2) statements in narrative with the postbase ki- and a third person ending","1) actions or states subordinate to that of the main verb and involving the same subject; 2) requests, commands, suggestions with a second person ending","1) exclamations, usually with tang; 2) certain special constructions (see maaten and =wa)","“before”","“because”","“whenever”","“although, even though, even if” ","“if, when (in the future)”","“when (in the past)” ","“while”","1) subject of an intransitive verb; 2) object of a transitive verb","1) subject of a transitive verb; 2) possessor; 3) “independent relative construction,” see section on roots in Generation Introduction, and Appendix 1, for further information","1) place from which, time from which; 2) indefinite object of an intransitive verb; 3) specifying information about a noun within a verb; 4) secondary object especially with verbs of speaking and giving; 5) instrument (only in some dialects)","1) place at which, time at which; 2) object of a comparison; 3) with postbase @+paa|~vaa and enclitic =lli in exclamations; 4) formal vocative","1) place to which, time to which; 2) subject of an embedded verb","1) route; 2) instrument; 3) part of a whole","1) comparison; 2) language specification; 3) price specification"];var exampleSentences=["1) Pissurtuq. - It is hunting. 2) Maqillruuk-qaa? - Did they two took a steambath?","1) Qangvaq ayallrua? - When did he go? Caqatarcit? - What will you do? 2) Caperrnaqvagta. - How difficult it is.","1) Neri. - Eat. Taisgu. - Bring it here. 2) Tan'gaurluq qanqili, 'Maurluuq!, naw'un iterciqsia?' - The boy said (literally: let the boy say), 'Grandmother!, through where will I get in?'","1) Cukaluni aqvaqurtuq. - She is running quickly. 2) Qantan painqegcaarluku. - Lick your plate clean, please.","1) Tang, qavalria. - Look, it's sleeping. 2) Maaten itertua anelria. - I came in; lo and behold, he went out.","Ayagpailgan payugeskiu. - Before he leaves, bring him food.","Ayaksaituq arenqiapakaan ellalluk. - He hasn’t gone because of this bad weather.","Ner'aqami tamuanqegcaalartuq. - Whenever she eats, she chews her food well.","Pingraan ayagyugtua. - Even though that's the case, I want to go.","Anglirikuni elitnauristen͞guyugtuq. - When he grows up, he wants to be a teacher.","Akngirtuq atrallermini. - He got hurt when he was coming down.","Ayainanermini igtellruuq. - While he was going, he fell.","1) Saskaq kuv'uq. - The glass spilled. 2) Maqaruaq pissullrua. - He hunted the rabbit.","1) Angutem quyavikaa. - The man was thankful to her. 2) Ciquyam pania cen̄irtuq. - Ciquyaq's daughter is visiting.","1) Elitnaurvigmek utertuq. - She's coming home from the school. 2) Ner'uq akutamek. - She is eating some akutaq. 3) Nutaramek qayaliuq. - He is making a new kayak. 4) Aanama kuuvviaryuucimnek aptaanga. - My mother is asking me whether I want coffee.","1) Mermi uitauq. - It is in the water. 2) Aatamni sugtunruunga. - I am taller than my dad. 3) Akertem̄i-lli puqlanirpaa! - How warm the sun is! 4) Elpet angutmi, niicugninga. - You man, listen to me.","1) Kipusvigmun piyuaguq. - He's walking to the store. 2) Arnam neresqaa neqa taqukamun. - The woman asks/tells the bear to eat the fish.","1) Tumyarakun ayallruuq. - He went by the path. 2) Angyakun ayagtut. - They are going by boat. 3) Qercuallruunga it'gamkun. - I got frostbitten on my feet.","1) Aatamegcetun yurartut. - They are dancing like their father. 2) Una Yugtun cauga? - What is this in Yup'ik? 3) Akingqertuq malrugtun. - It is two dollars."];var SearchPage=function(_Component){_inherits(SearchPage,_Component);function SearchPage(props){_classCallCheck(this,SearchPage);// console.log("SearchPage props: ", props);
var _this=_possibleConstructorReturn(this,(SearchPage.__proto__||Object.getPrototypeOf(SearchPage)).call(this,props));_this.handleRef=function(c){_this.inputRef=c;};_this.handleClick=function(e,titleProps){// console.log(e,titleProps)
_this.setState({loaderOn:true});var index=titleProps.index,currentIndex=titleProps.currentIndex;var activeIndex=_this.state.activeIndex;var newIndex=activeIndex===index?-1:index;var mood=_this.state.moods[index];_this.getEndings(_this.state.parses[currentIndex],mood);_this.setState({activeIndex:newIndex,mood:mood});};_this.handleClick2=function(e,titleProps){// console.log(e,titleProps)
var index=titleProps.index,currentIndex=titleProps.currentIndex;var activeIndex=_this.state.activeIndex;var newIndex=activeIndex===index?-1:index;console.log(index);var mood=_this.state.moods[index];// console.log(mood)
_this.setState({loaderOn:false,entries:mood==="[DemPro]"?__WEBPACK_IMPORTED_MODULE_15__constants_endingsConstants_js__["c" /* demPro */]:__WEBPACK_IMPORTED_MODULE_15__constants_endingsConstants_js__["l" /* perPro */],activeIndex:newIndex,mood:mood});};_this.retrieveStory=function(title){var items=Object(__WEBPACK_IMPORTED_MODULE_14__constants_StoriesRetrieved_js__["a" /* default */])(title);// console.log(items)
var search=items[0];// let video = items[1]
// let audio = items[2]
_this.setState({entries:undefined,activeIndex:-1,loaderOn:true,seeMoreActive:false,currentTableOpen:-1,yugtunAnalyzer:true,showMoreEnding:false});// console.log(search)
if(search===undefined||search===true){search=_this.state.search;}console.log(search);if(search.length>0){_this.setState({storyClicked:true,newSearchList:search.split(" "),activeSentenceIndex:0,searchWord:search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase(),getCall:true,notFirstParse:true,search:search,video:items[1],audio:items[2],source:items[3]});_this.getParse(search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase());}};_this.onKeyPress=function(e){if(e.key==='Enter'){//} && (this.state.activeTabIndex === 0 || this.state.search !== this.state.searchWord)){
// if (!this.state.yugtunAnalyzer && this.state.parses.length === 0) {this.setState({getCall:true})}
// this.setState({ yugtunAnalyzer: !this.state.yugtunAnalyzer}); 
// if (this.state.yugtunAnalyzer) {
// this.setState({activeTabsIndex:1})
_this.inputClicked(true);// }
}};_this.resetAll=function(e,data){_this.setState({search:'',newSearchList:[],parses:[],segments:[],searchWord:"",notFirstParse:false});};_this.handleTabChange=function(e,data){// console.log(data.activeIndex, this.state.activeIndex)
if(data.activeIndex===0&&_this.state.activeTabIndex!==0){_this.setState({yugtunAnalyzer:false,activeTabIndex:0,parses:[],segments:[],endingrule:[],newSearchList:[],notFirstParse:false,search:""});}else if(data.activeIndex===1&&_this.state.activeTabIndex!==1){// if (!this.state.yugtunAnalyzer) {
_this.setState({yugtunAnalyzer:true,activeTabIndex:1,parses:[],segments:[],endingrule:[],newSearchList:[],notFirstParse:false,search:""});// this.inputClicked()
// }
}};_this.state={video:'',audio:'',dictionary:[],dictionaryNouns:[],dictionaryVerbs:[],wordsList:[],yugtunAnalyzer:props.location.state===undefined?false:props.location.state.yugtunAnalyzer,search:props.location.state===undefined?'':props.location.state.search,currentWord:{},onlyCommon:false,startingSearch:true,source:'',// smallestParseIndex: -1,
parses:props.location.state===undefined?[]:props.location.state.parses,segments:props.location.state===undefined?[]:props.location.state.segments,endingrule:props.location.state===undefined?[]:props.location.state.endingrule,storyClicked:false,// parses:[],
// segments:[],
// endingrule:[],
currentTableOpen:-1,getCall:false,// notFirstParse: false,
// searchBarStuckTop: false,
searchBarStuckTop:props.location.state===undefined?false:props.location.state.searchBarStuckTop,notFirstParse:props.location.state===undefined?false:props.location.state.notFirstParse,searchWord:props.location.state===undefined?"":props.location.state.searchWord,activeSentenceIndex:props.location.state===undefined?0:props.location.state.activeSentenceIndex,// exampleSentenceSearch: false,
// smallestParse:[[],[]],
// segmentOutputList:[],
// searchWord:"",
// activeSentenceIndex: 0,
// activeTabIndex:0,
showMoreEnding:false,moreIndex:-1,updateSearchEntry:props.location.state===undefined?false:props.location.state.updateSearchEntry,activeTabIndex:props.location.state===undefined?0:props.location.state.activeTabIndex,// exampleSentenceSearch: props.location.state === undefined ? false : props.location.state.exampleSentenceSearch,
newSearchList:props.location.state===undefined?[]:props.location.state.newSearchList,activeIndex:-1,loaderOn:true,entries:undefined,hover:-1,seeMoreActive:false,segment:"",possibleDefinition:["","","","","","","","","",""],moods:["[Ind]","[Intrg]","[Opt]","[Sbrd]","[Ptcp]","[Prec]","[Cnsq]","[Cont]","[Conc]","[Cond]","[CtmpI]","[CtmpII]","[Abs]","[Rel]","[Abl_Mod]","[Loc]","[Ter]","[Via]","[Equ]","%5BQuant_Qual%5D","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[PerPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]","[DemPro]"]};_this.getParse=_this.getParse.bind(_this);_this.onChangeSearch=_this.onChangeSearch.bind(_this);_this.selectWord=_this.selectWord.bind(_this);_this.search_container=__WEBPACK_IMPORTED_MODULE_2_react___default.a.createRef();_this.getEndings=_this.getEndings.bind(_this);_this.getLinks=_this.getLinks.bind(_this);_this.inputClicked=_this.inputClicked.bind(_this);return _this;}_createClass(SearchPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var start=__WEBPACK_IMPORTED_MODULE_9_performance_now___default()();if(this.state.updateSearchEntry){this.inputClicked();this.setState({updateSearchEntry:false});}if(dictionary.length===0){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/word/all").then(function(response){var end=__WEBPACK_IMPORTED_MODULE_9_performance_now___default()();__WEBPACK_IMPORTED_MODULE_10_react_ga__["a" /* default */].timing({category:'Loading',variable:'dictionary',value:(end-start).toFixed(3),label:'Dictionary loading'});dictionary=response.data;// fuse.setCollection(dictionary);
// fuse1.setCollection(dictionary);
console.log('Fetched dictionary');dictionary.forEach(function(entry){return dictionary_dict[entry.yupik]=entry.english;});// create dictionary_dict dictionary
// dictionary_prepared = fuzzysort.prepare(dictionary)
_this2.setState({dictionary:dictionary});});}else{// fuse.setCollection(dictionary);
this.setState({dictionary:dictionary});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevState.dictionary.length!==this.state.dictionary.length){this.onChangeSearch(undefined,{value:this.state.search});}if(prevState.search!==this.state.search){this.setState({searchBarStuckTop:true});}if(prevState.startingSearch&&!this.state.startingSearch){if(navigator.userAgent.match(/(iPhone|iPod|iPad)/i)){var elts=__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(this).getElementsByClassName('search_container');if(elts.length>0){elts[0].scrollIntoView();}}}}},{key:'getParse',value:function getParse(word){var _this3=this;if(word===""){this.setState({parses:[],segments:[],endingrule:[],getCall:false});}else{__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/parse/"+word).then(function(response){// console.log(response)
//  var lowest = 0;
// var a = response.data.parses;
//  for (var i = 1; i < a.length; i++) {
//   if (a[i].length < a[lowest].length) 
//     lowest = i;
//  }
// console.log(a)
// let sortedParses = response.data.parses.sort(function(a,b){return a.length - b.length;}).slice(0, 5)
// console.log(sortedParses)
_this3.setState({parses:response.data.parses,segments:response.data.segments,endingrule:response.data.endingrule,getCall:false});// let segmentOutputList = [];
// sortedParses.map((i,index)=>
//   this.getSegment(i)
//   )
// console.log(segmentOutputList)
// if (a.length > 0) {
// 	this.setState({
//    smallestParseIndex: lowest,
//    smallestParse: response.data.parses[lowest].split('-'),
//  });
// this.getSegment(response.data.parses[lowest])
// }
});}}},{key:'getSegment',value:function getSegment(word){__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/segment/"+encodeURIComponent(word)).then(function(response){// return response.data.words[0]
console.log(response);// this.setState({
// segment: response.data.words[0],
// })
});}},{key:'getEndings',value:function getEndings(word,mood){var _this4=this;console.log("Word",word,mood);__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_7__App_js__["a" /* API_URL */]+"/mood?underlying_form="+encodeURIComponent(word)+"&mood="+mood).then(function(response){_this4.setState({entries:response.data.results});_this4.setState({loaderOn:false});});}},{key:'onChangeSearch',value:function onChangeSearch(event,data){// this.setState({entries:undefined, activeIndex:-1, loaderOn: true, seeMoreActive:false,currentTableOpen: -1,})
var newStartingSearch=event===undefined;var new_search=data.value.replace("’","'");// console.log(new_search)
// if (data.value === undefined) {new_search = this.state.search}
var wordsList=__WEBPACK_IMPORTED_MODULE_8_fuzzysort___default.a.go(new_search,dictionary,optionsFuzzy).map(function(_ref){var obj=_ref.obj;return obj;});this.setState({startingSearch:newStartingSearch,wordsList:wordsList,search:new_search});// if (new_search.length >= 4 && !this.state.yugtunAnalyzer) {
//   ReactGA.event({
//     category: 'User',
//     action: 'Search word',
//     label: new_search
//   });
//   let start = now();
//   let wordsList = fuse.search(new_search);
//   let end = now();
//   console.log('done! in ', (end-start).toFixed(3), 'ms');
//   ReactGA.timing({
//     category: 'Search',
//     variable: 'fuse.search',
//     value: (end-start).toFixed(3),
//     label:'Fuse.js search duration'
//   });
//   this.setState({ startingSearch: newStartingSearch, wordsList: wordsList, search: new_search });
// }
// else {
//   this.setState({ startingSearch: newStartingSearch, search: new_search });
// }
}},{key:'selectWord',value:function selectWord(word,event){this.setState({currentWord:word});}},{key:'resetCurrentWord',value:function resetCurrentWord(event,data){this.setState({currentWord:{}});}},{key:'inputClicked',value:function inputClicked(search){this.setState({entries:undefined,activeIndex:-1,loaderOn:true,seeMoreActive:false,currentTableOpen:-1,yugtunAnalyzer:true,showMoreEnding:false});// console.log(search)
if(search===undefined||search===true){search=this.state.search;}console.log(search);if(search.length>0){this.setState({newSearchList:search.split(" "),activeSentenceIndex:0,searchWord:search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase(),getCall:true,notFirstParse:true});this.getParse(search.split(" ")[0].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase());}//   this.inputRef.focus();
//   this.setState({
//     search: '', startingSearch: false
//   });
// }
}},{key:'endingToEnglish',value:function endingToEnglish(ending,index,qindex){var _this5=this;var tags=[].concat(_toConsumableArray(ending.matchAll(/\[.*?\]/g)));var english1="";var english2="";var english3="";var english4="";var before=true;// console.log(this.state,tags[1])
if(ending.includes('[V]')){if(this.state.parses[index].includes('[Ind]')||this.state.parses[index].includes('[Intrg]')||this.state.parses[index].includes('[Opt]')||this.state.parses[index].includes('[Sbrd]')){before=false;}english1+='Verb Ending';english2+=endingToEnglishTerms[tags[1]];english4+=endingEnglishDescriptions[tags[1]];if(ending.includes('[Trns]')){var subject=endingToEnglishTerms[tags[tags.length-2]];if(subject===undefined){subject='unspecified';}english3+=subject+" to "+endingToEnglishTerms[tags[tags.length-1]];}else if(ending.includes('[Intr]')){english3+=endingToEnglishTerms[tags[tags.length-1]];}}else if(ending.includes('[N]')){english1+='Noun Ending';english2+=endingToEnglishTerms[tags[1]];if(ending.includes('[Abs]')){english4="";}else{english4+=endingEnglishDescriptions[tags[1]];}if(ending.includes('Poss')){english3+=endingToEnglishTerms[tags[tags.length-2]]+"\xa0"+endingToEnglishTerms[tags[tags.length-1]];}else{english3+=endingToEnglishTerms[tags[tags.length-1]];}}else if(this.state.parses[index].includes('[D')){english1+='Demonstrative';english2+=endingToEnglishTerms[tags[0]];english4+=endingEnglishDescriptions[tags[0]];if(endingToEnglishTerms[tags[1]]!==undefined){english3+=endingToEnglishTerms[tags[1]];}}else if(this.state.parses[index].includes('[P')){english1+='Personal Pronoun';english2+=endingToEnglishTerms[tags[0]];english4+=endingEnglishDescriptions[tags[0]];english3+=endingToEnglishTerms[tags[1]];}else if(this.state.parses[index].includes('[Q')){english1='';english2+=endingToEnglishTerms[tags[0]];english4+=endingEnglishDescriptions[tags[0]];if(endingToEnglishTerms[tags[1]]!==undefined){english3+=endingToEnglishTerms[tags[1]];}}else{english1+=ending;english2+=endingToEnglishTerms[tags[0]];english4+=endingEnglishDescriptions[tags[0]];if(endingToEnglishTerms[tags[1]]!==undefined){english3+=endingToEnglishTerms[tags[1]];}}// var possibleDefinition = this.state.possibleDefinition
// var entry = possibleDefinition[index]
// entry = entry + '\xa0' + english3
// possibleDefinition[index] = entry
// this.setState({possibleDefinition:possibleDefinition})
return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{paddingTop:15,paddingLeft:20*qindex}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontWeight:'bold',fontSize:16,paddingBottom:'1px'}},this.state.endingrule[index][1].join(', ')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontSize:16}},before&&english4.length!==0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,english4+'\xa0'):null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,english3),!before?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,'\xa0'+english4):null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{onClick:function onClick(){return _this5.setState({showMoreEnding:_this5.state.moreIndex!==index||!_this5.state.showMoreEnding?true:false,moreIndex:index});},style:{color:'#bdbdbd',fontWeight:'100',paddingTop:10,paddingBottom:10,cursor:'pointer',fontSize:16}},'more',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["n" /* Icon */],{style:{paddingLeft:5,fontSize:12},name:this.state.showMoreEnding&&index===this.state.moreIndex?'chevron up':'chevron down'})),this.state.showMoreEnding&&index===this.state.moreIndex?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginLeft:15,fontSize:16}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,english2),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,english1),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{onClick:function onClick(){return window.open("http://www.yugtun.com/symbols");},style:{color:'#4183c4',fontWeight:'100',textDecoration:'underline',paddingTop:10,cursor:'pointer'}},'Translation and Symbols')):null);}},{key:'getLinks',value:function getLinks(index,parse){// console.log(parse)
if(index===0){// if base
if((parse[index].includes("[P")||parse[index].includes("[I"))&&parse.length===1){// if particle or ignorative
return parse[index].split("[")[0].replace(/=/g,"-");}else if(parse[index].includes("[PerPro]")){return parse[index].split("[")[0];}else if(parse[index].includes("[DemPro]")||parse[index].includes("[DemAdv]")){var dem=parse[index].replace("n[DemPro]","n'a");dem=dem.replace("[DemPro]","na");dem=dem.replace("[DemAdv]","(ni)");return dem;}else{var base=parse[0];base=base.split(/\[[^e]/)[0];// remove special tag
var dictionaryForm='';// console.log("getLinks:",base,index,parse)
if(parse[1].includes('[N')){// if Noun base:
dictionaryForm=base.replace(/([aeiu])te\b/,"$1n");// Vte -> n
dictionaryForm=dictionaryForm.replace(/([^\[])e\b/,"$1a");// e -> a
dictionaryForm=dictionaryForm.replace(/g\b/,"k");// g -> k
dictionaryForm=dictionaryForm.replace(/r(\*)?\b/,"q$1");// r(*) -> q(*)
}else if(parse[1].includes('[V')||parse[1].includes('[Q')){dictionaryForm=base+"-";// if Verb or Quant_Qual base 
}else{dictionaryForm=base;}return dictionaryForm.replace(/=/g,"-");}}else{if(parse[index].includes("ete[N→V]")){return"ete[N→V]";}}// else (["[N→N]","[N→V]","[V→V]","[V→N]","[Encl]"].some(v => parse[index].includes(v))) { //if postbase or enclitic
return parse[index];}},{key:'render',value:function render(){var _this6=this;console.log("SearchPage state: ",this.state);// console.log("dictionary: ",dictionary_dict);
// console.log("fuse.js: ",fuse.search('pissur'))
// console.log("Fuzzysort: ",fuzzysort.go('pissur', dictionary, optionsFuzzy));
// console.log("Fuzzysort_prepared: ",fuzzysort.go('pissur', dictionary_prepared, optionsFuzzy));
// console.log("pissur-[V][Ind][Intr][S_3Sg]=qaa[Encl]".split('-'))
var displayList=this.state.search.length>=2&&this.state.wordsList.length>0;var emptyList=this.state.search.length>=2&&this.state.wordsList.length===0&&!this.state.yugtunAnalyzer;var pressEnter=this.state.search.length>0&&this.state.yugtunAnalyzer&&this.state.newSearchList.length===0;var wordsList=this.state.wordsList;var activeIndex=this.state.activeIndex;var isCommonList=wordsList.map(function(word){return Object.keys(word).some(function(key){return word[key].properties&&word[key].properties.indexOf('common')>-1;});});if(this.state.onlyCommon){wordsList=wordsList.filter(function(word,i){return isCommonList[i];});}var displayCommonOption=this.state.onlyCommon||wordsList.some(function(word,i){return isCommonList[i];})&&wordsList.some(function(word,i){return!isCommonList[i];});var panes=[{menuItem:{content:'Dictionary',size:'massive'}},{menuItem:'Yugtun to English'}];var accordionTitlesVerbs=["Indicative (it is...)","Interrogative (question)","Optative (do it...)","Subordinative (please do or it being...)","Participial (exclamation or special case)","Precessive (before...)","Consequential (because...)","Contigent (whenever...)","Concessive (although, even though, even if...)","Conditional (if, when in the future...)","Contemporative 1 (when in the past...)","Contemporative 2 (while...)"];// const accordionTitlesVerbs = [
//   "it is... (indicative)",
//   "question (interrogative)",
//   "do it... (optative)",
//   "please do or it being...(subordinative))",
//   "exclamation or special case (participial)",
//   "before... (precessive)",
//   "because... (consequential)",
//   "whenever... (contingent)",
//   "although, even though, even if... (concessive)",
//   "if, when in the future... (conditional)",
//   "when in the past... (contemporative 1)",
//   "while... (contemporative 2)",
//   ];
// const accordionTitlesVerbs = [
//   "it is... (Indicative)",
//   "question (Interrogative)",
//   "do it... (Optative)",
//   "please do or it being... (Subordinative))",
//   "exclamation or special case (Participial)",
//   "before... (Precessive)",
//   "because... (Consequential)",
//   "whenever... (Contingent)",
//   "although, even though, even if... (Concessive)",
//   "if, when in the future... (Conditional)",
//   "when in the past... (Contemporative 1)",
//   "while... (Contemporative 2)",
//   ];
var accordionTitlesNouns=["Absolutive (the)","Relative (the)","Ablative-Modalis (a, some, from)","Localis (in, at)","Terminalis (toward)","Vialis (through, using)","Equalis (like, similar to)"];var accordionTitlesQuantQual=["Absolutive (the)","Relative (the possessor, owner)","Ablative-Modalis (a, some, from)","Localis (in, at)","Terminalis (toward)","Vialis (through, using)","Equalis (like, similar to)"];var persPronounLabels=["[Abs]","[Rel]","[Abl_Mod]","[Loc]","[Ter]","[Via]","[Equ]"];var persPronounSubjects=["[3Sg]","[3Du]","[3Pl]","[1Sg]","[1Du]","[1Pl]","[2Sg]","[2Du]","[2Pl]","[4Sg]","[4Du]","[4Pl]"];var persPronounsEnglish=["it\xa0(other)","them\xa0(2)\xa0(other)","them\xa0(3+)\xa0(other)","me","us\xa0(2)","us\xa0(3+)","you\xa0(1)","you\xa0(2)","you\xa0(3+)","itself","themselves\xa0(2)","themselves\xa0(3+)"];var demPronounTitles=["over there or going away","across there","up the slope","up above","inside, inland, or upriver","outside","down below or down the slope","downriver or near the exit","here, near speaker","there, near listener or in context","coming this way"];var demPronounSubjects=["[Abs][SgUnpd]","[Abs][DuUnpd]","[Abs][PlUnpd]","[Rel][SgUnpd]","[Rel][DuUnpd]","[Rel][PlUnpd]","[Abl_Mod][SgUnpd]","[Abl_Mod][DuUnpd]","[Abl_Mod][PlUnpd]","[Loc][SgUnpd]","[Loc][DuUnpd]","[Loc][PlUnpd]","[Ter][SgUnpd]","[Ter][DuUnpd]","[Ter][PlUnpd]","[Via][SgUnpd]","[Via][DuUnpd]","[Via][PlUnpd]","[Equ][SgUnpd]","[Equ][DuUnpd]","[Equ][PlUnpd]","[Voc][SgUnpd]","[Voc][DuUnpd]","[Voc][PlUnpd]","","[Loc]","[Ter]","[Sec_Ter]","[Abl]","[Via]","=i[Encl]"];var demPronounEnglish=["absolutive singular","absolutive dual","absolutive plural","relative singular","relative dual","relative plural","abl-modalis singular","abl-modalis dual","abl-modalis plural","localis singular","localis dual","localis plural","terminalis singular","terminalis dual","terminalis plural","vialis singular","vialis dual","vialis plural","equalis singular","equalis dual","equalis plural","vocative singular","vocative dual","vocative plural","","localis","terminalis","second terminalis","ablative","vialis","predicative"];return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SearchPageHelpers_js__["c" /* YugtunLoader */],{criteria:this.state.dictionary.length===0}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["u" /* Menu */],{fixed:'top',inverted:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["e" /* Container */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["u" /* Menu */].Item,{onClick:function onClick(){_this6.setState({search:'',storyClicked:false});},as:'a',header:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{borderRadius:'2px',height:'30px',marginRight:'1.5em'},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/logo.jpg'}),'Conversational Yup\'ik III'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */],{item:true,simple:true,text:'Materials'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Menu,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Header,null,'Weeks'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'dropdown icon'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'text'},'Processing Food & Prep'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Menu,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(0);}},'Week 1: Neqet Aklut-llu Auluklerkaat; Neqallret-gguq Akiinauyuut'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(1);}},'Week 2: Tepet'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(2);}},'Week 3: Yaqulegmek Uklilleq Nalugalria-llu'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(3);}},'Week 4: Uquucillret'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'dropdown icon'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'text'},'Celebrations & Ceremonies'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Menu,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(4);}},'Week 1: Yuralallrat'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(5);}},'Week 2: Yuram Arulaciit Kangiit'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(6);}},'Week 3: Arnaulriim Ciuniuryaraa Issurimuq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(7);}},'Week 4: Uqiqulleq'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'dropdown icon'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'text'},'Physical & Mental Health'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Menu,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(8);}},'Week 1: Aqumgaurpek\'nak'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(9);}},'Week 2: Ulu Mik\'lengermi Akngirnarquq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(10);}},'Week 3: Tatailnguq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(11);}},'Week 4: Ayagina\'ar - Prevention Video'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'dropdown icon'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'text'},'Survival Skills'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Menu,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(12);}},'Week 1: Ayaruicaqunak'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(13);}},'Week 2: Iqalluguat Negeqvam Taqellri Nallunailkutaugut'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(14);}},'Week 3: Agevkarluni Qanikcamun'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(15);}},'Week 4: Imarpigmi Augna Pilleq'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'dropdown icon'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'text'},'Kinship/Family Relations'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Menu,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(16);}},'Week 1: Irniaput ayuqucirtuagaqluki piarkauyaaqelliniukut'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(17);}},'Week 2: Tuqluuucaraq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(18);}},'Week 3: Ilakucaraq Atellgutkellriakun'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(19);}},'Week 4: Asmuuriyunaituq'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'dropdown icon'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'text'},'Yup\'ik Lore'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Menu,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(20);}},'Week 1: Saanigem Alangrua'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(21);}},'Week 2: Apanuugpak'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(22);}},'Week 3: Cetugpak'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(23);}},'Week 4: Uugnar Kaviaq-llu'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'dropdown icon'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'text'},'Our Environment'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Menu,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(24);}},'Week 1: Yup\'igtaat Ellangvikelput'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(25);}},'Week 2: C/Yuuyaraq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(26);}},'Week 3: Nunam Qigciksaraa'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(27);}},'Week 4: Nutemllaput'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i',{className:'dropdown icon'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'text'},'Seasonal Camps'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Menu,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(28);}},'Week 1: Up\'nerkillerni'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(29);}},'Week 2: Neqlilleq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(30);}},'Week 3: Uksuilleq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["h" /* Dropdown */].Item,{onClick:function onClick(){_this6.retrieveStory(31);}},'Week 4: Uksillernun Uterrluteng Pilallrat'))))))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */],{textAlign:'center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Row,{style:{paddingTop:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["l" /* Grid */].Column,{textAlign:'left'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["e" /* Container */],{style:{height:window.innerHeight},ref:this.search_container,className:'search_container'},this.state.search.length>0&&this.state.storyClicked?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{flex:2}},this.state.video.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('video',{key:this.state.video,style:{marginTop:'30px',marginBottom:'20px'},width:'600',controls:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('source',{src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/'+this.state.video,type:'video/mp4'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontStyle:'italic',marginBottom:'5px'}},'Source: '+this.state.source)):this.state.audio.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{flex:1,marginTop:40}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('audio',{key:this.state.audio,controls:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('source',{src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/'+this.state.audio,type:'audio/mpeg'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontStyle:'italic'}},'Source: '+this.state.source)):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginTop:'35px',fontStyle:'italic'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontStyle:'italic'}},'Source: '+this.state.source))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{flex:1,marginTop:40}},this.state.audio.length>0&&this.state.video.length>0?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('audio',{key:this.state.audio,controls:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('source',{src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/'+this.state.audio,type:'audio/mpeg'})):null)):null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{flex:2}},this.state.search.length>0&&this.state.storyClicked?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["z" /* Segment */],{vertical:true,style:{fontSize:22,padding:0,marginTop:20,maxHeight:500,overflow:'auto',borderBottom:0}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{flexWrap:'wrap'}},this.state.newSearchList.map(function(i,index){return i==='\r'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('br',null):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{onClick:function onClick(){if(index!==_this6.state.activeSentenceIndex){_this6.setState({getCall:true,activeSentenceIndex:index,searchWord:_this6.state.newSearchList[index].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase(),parses:[],segments:[],endingrule:[],entries:undefined,activeIndex:-1,loaderOn:true,seeMoreActive:false,currentTableOpen:-1});_this6.getParse(_this6.state.newSearchList[index].replace(/[^a-zA-Z\-̄͡͞ńḿ']/g,"").toLowerCase());}},onMouseEnter:function onMouseEnter(){_this6.setState({hover:index});},onMouseLeave:function onMouseLeave(){_this6.setState({hover:-1});},style:{display:'inline-block',marginTop:10,paddingBottom:_this6.state.activeSentenceIndex===index||_this6.state.hover===index?2:5,cursor:'pointer',marginRight:6,borderBottomColor:'red',borderBottom:_this6.state.activeSentenceIndex===index?'3px solid #000000DE':_this6.state.hover===index?'1px solid #000000DE':'0px solid #000000DE',color:'#000000DE'}},i);}))):null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["z" /* Segment */],{vertical:true,style:{fontSize:22,padding:0,marginTop:20,maxHeight:500,overflow:'auto',borderBottom:0}},this.state.getCall?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{paddingTop:20,paddingLeft:15}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["t" /* Loader */],{active:true,inline:true})):null,this.state.yugtunAnalyzer&&this.state.parses.length===0&&!this.state.getCall&&this.state.notFirstParse&&this.state.storyClicked?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{paddingTop:20,paddingLeft:15}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontStyle:'italic',marginTop:10}},'No results. Pisciigatuq.')):null,this.state.yugtunAnalyzer&&!this.state.getCall&&this.state.storyClicked&&(this.state.search.length>0||this.state.notFirstParse)?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{paddingTop:20,paddingLeft:15}},this.state.parses.map(function(i,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{paddingBottom:10}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["q" /* Label */],{circular:true,color:'#E5E5E5'},index+1))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{paddingLeft:25}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontSize:22}},_this6.state.segments[index].replace(/>/g,'·')),i.split('-').map(function(q,qindex){return qindex===_this6.state.endingrule[index][0]?_this6.endingToEnglish(q,index,qindex):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{paddingTop:15,paddingLeft:qindex*20,fontSize:'16px'}},_this6.getLinks(qindex,i.split('-'))in dictionary_dict?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontWeight:'bold',fontFamily:'Lato,Arial,Helvetica,sans-serif',textDecoration:'underline',paddingBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["a" /* Link */],{target:'_blank',to:{pathname:_this6.getLinks(qindex,i.split('-')),state:{word:_this6.getLinks(qindex,i.split('-')),search:_this6.state.search,newSearchList:_this6.state.newSearchList,wordsList:_this6.state.wordsList,yugtunAnalyzer:_this6.state.yugtunAnalyzer,parses:_this6.state.parses,segments:_this6.state.segments,endingrule:_this6.state.endingrule,searchBarStuckTop:_this6.state.searchBarStuckTop,notFirstParse:_this6.state.notFirstParse,searchWord:_this6.state.searchWord,activeSentenceIndex:_this6.state.activeSentenceIndex,activeTabIndex:_this6.state.activeTabIndex}}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',null,q))),dictionary_dict[_this6.getLinks(qindex,i.split('-'))]):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{fontWeight:'bold',fontFamily:'Lato,Arial,Helvetica,sans-serif',textDecoration:'underline'}},q));})));})):null))),!this.state.storyClicked?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginTop:30,fontSize:20,lineHeight:1.3,fontStyle:'italic'}},'This interactive reader was created for the Yup\'ik Conversation III course at the Lower Kuskokwim School District. It is designed for use on computer browsers. You can also use the Materials tab above.'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{marginTop:25,fontSize:20,fontWeight:'bold',textDecoration:'underline'}},'Table of Contents:'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */],{bulleted:true,style:{marginLeft:30}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,'Processing Food & Prep',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].List,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(0);}},'Week 1: Neqet Aklut-llu Auluklerkaat; Neqallret-gguq Akiinauyuut'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(1);}},'Week 2: Tepet'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(2);}},'Week 3: Yaqulegmek Uklilleq Nalugalria-llu'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(3);}},'Week 4: Uquucillret'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,'Celebrations & Ceremonies',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].List,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(4);}},'Week 1: Yuralallrat'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(5);}},'Week 2: Yuram Arulaciit Kangiit'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(6);}},'Week 3: Arnaulriim Ciuniuryaraa Issurimuq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(7);}},'Week 4: Uqiqulleq'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,'Physical & Mental Health',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].List,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(8);}},'Week 1: Aqumgaurpek\'nak'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(9);}},'Week 2: Ulu Mik\'lengermi Akngirnarquq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(10);}},'Week 3: Tatailnguq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(11);}},'Week 4: Ayagina\'ar - Prevention Video'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,'Survival Skills',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].List,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(12);}},'Week 1: Ayaruicaqunak'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(13);}},'Week 2: Iqalluguat Negeqvam Taqellri Nallunailkutaugut'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(14);}},'Week 3: Agevkarluni Qanikcamun'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(15);}},'Week 4: Imarpigmi Augna Pilleq'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,'Kinship/Family Relations',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].List,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(16);}},'Week 1: Irniaput ayuqucirtuagaqluki piarkauyaaqelliniukut'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(17);}},'Week 2: Tuqluuucaraq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(18);}},'Week 3: Ilakucaraq Atellgutkellriakun'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(19);}},'Week 4: Asmuuriyunaituq'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,'Yup\'ik Lore',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].List,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(20);}},'Week 1: Saanigem Alangrua'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(21);}},'Week 2: Apanuugpak'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(22);}},'Week 3: Cetugpak'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(23);}},'Week 4: Uugnar Kaviaq-llu'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,'Our Environment',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].List,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(24);}},'Week 1: Yup\'igtaat Ellangvikelput'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(25);}},'Week 2: C/Yuuyaraq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(26);}},'Week 3: Nunam Qigciksaraa'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(27);}},'Week 4: Nutemllaput'))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,null,'Seasonal Camps',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].List,null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(28);}},'Week 1: Up\'nerkillerni'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(29);}},'Week 2: Neqlilleq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(30);}},'Week 3: Uksuilleq'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["r" /* List */].Item,{href:'#',onClick:function onClick(){_this6.retrieveStory(31);}},'Week 4: Uksillernun Uterrluteng Pilallrat'))))):null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-evenly',alignItems:'center',height:60,paddingBottom:16,marginTop:30}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_semantic_ui_react__["o" /* Image */],{style:{height:'30px',opacity:0.7},src:'https://yupikmodulesweb.s3.amazonaws.com/static/exercise1/ellanguaq1.svg'}))))))));}}]);return SearchPage;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SearchPage);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(243);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  trackerNames: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});



/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["initialize"] = initialize;
/* harmony export (immutable) */ __webpack_exports__["ga"] = ga;
/* harmony export (immutable) */ __webpack_exports__["set"] = set;
/* harmony export (immutable) */ __webpack_exports__["send"] = send;
/* harmony export (immutable) */ __webpack_exports__["pageview"] = pageview;
/* harmony export (immutable) */ __webpack_exports__["modalview"] = modalview;
/* harmony export (immutable) */ __webpack_exports__["timing"] = timing;
/* harmony export (immutable) */ __webpack_exports__["event"] = event;
/* harmony export (immutable) */ __webpack_exports__["exception"] = exception;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return plugin; });
/* harmony export (immutable) */ __webpack_exports__["outboundLink"] = outboundLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "testModeAPI", function() { return testModeAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(935);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'arguments\');');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'set\', fieldsObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', fieldObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["default"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(243);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" /* default */])(s)) {
    Object(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  return s;
}

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(459);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ribbonStyle = __webpack_require__(937);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var positionMapping = {
  left: [_ribbonStyle.RibbonStyle.leftStyle, _ribbonStyle.RibbonStyleWrapper.leftStyle],
  right: [_ribbonStyle.RibbonStyle.rightStyle, _ribbonStyle.RibbonStyleWrapper.rightStyle],
  'left-bottom': [_ribbonStyle.RibbonStyle.leftBottomStyle, _ribbonStyle.RibbonStyleWrapper.leftBottomStyle],
  'right-bottom': [_ribbonStyle.RibbonStyle.rightBottomStyle, _ribbonStyle.RibbonStyleWrapper.rightBottomStyle]
};

var colorMapping = {
  red: _ribbonStyle.RibbonStyle.redColor,
  orange: _ribbonStyle.RibbonStyle.orangeColor,
  black: _ribbonStyle.RibbonStyle.blackColor,
  green: _ribbonStyle.RibbonStyle.greenColor
};

var GitHubForkRibbon = function GitHubForkRibbon(_ref) {
  var _ref$position = _ref.position,
      position = _ref$position === undefined ? 'right' : _ref$position,
      href = _ref.href,
      target = _ref.target,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'red' : _ref$color,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ['position', 'href', 'target', 'color', 'className', 'children']);

  var positionStyle = positionMapping[position] || [_ribbonStyle.RibbonStyle.rightStyle, _ribbonStyle.RibbonStyleWrapper.rightStyle];
  var colorStyle = colorMapping[color] || _ribbonStyle.RibbonStyle.redColor;

  if (positionStyle[0] === _ribbonStyle.RibbonStyle.rightStyle) {
    position = 'right';
  }

  var ribbonStyle = _extends({}, _ribbonStyle.RibbonStyle.baseStyle, positionStyle[0], colorStyle);

  var wrapperStyle = _extends({}, _ribbonStyle.RibbonStyleWrapper.baseStyle, positionStyle[1]);

  return _react2.default.createElement(
    'div',
    _extends({}, other, {
      className: 'github-fork-ribbon-wrapper ' + position + ' ' + className,
      style: wrapperStyle }),
    _react2.default.createElement(
      'div',
      { className: 'github-fork-ribbon',
        style: ribbonStyle },
      _react2.default.createElement(
        'a',
        { href: href,
          target: target,
          style: _ribbonStyle.RibbonStyle.urlStyle,
          rel: 'noopener' },
        children
      )
    )
  );
};

exports.default = global.RibbonStyle = GitHubForkRibbon;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* "Fork me on GitHub" CSS ribbon v0.1.1 | MIT License
* https://github.com/simonwhitaker/github-fork-ribbon-css
*
* 20150116 Lee: use css source for inline style react component.
*/
var RibbonStyle = exports.RibbonStyle = {

  baseStyle: {
    /* The right and left classes determine the side we attach our banner to */
    position: 'absolute',

    /* Add a bit of padding to give some substance outside the "stitching" */
    padding: '2px 0',

    /* Set the base colour */
    backgroundColor: '#a00',

    /* Set a gradient: transparent black at the top to almost-transparent black at the bottom */
    // backgroundImage: '-webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(0, 0, 0, 0.15)))',
    // backgroundImage: '-webkit-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',
    // backgroundImage: '-moz-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',
    // backgroundImage: '-ms-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',
    // backgroundImage: '-o-linear-gradient(top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',
    backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15))',

    /* Add a drop shadow */
    WebkitBoxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.5)',
    MozBoxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.5)',
    boxShadow: '0 2px 3px 0 rgba(0, 0, 0, 0.5)',

    /* Set the font */
    font: '700 13px "Helvetica Neue", Helvetica, Arial, sans-serif',

    zIndex: '9999',
    pointerEvents: 'auto'
  },

  urlStyle: {
    /* Set the text properties */
    color: '#fff',
    textDecoration: 'none',
    textShadow: '0 -1px rgba(0, 0, 0, 0.5)',
    textAlign: 'center',

    /* Set the geometry. If you fiddle with these you'll also need
       to tweak the top and right values in .github-fork-ribbon. */
    width: '200px',
    lineHeight: '20px',

    /* Set the layout properties */
    display: 'inline-block',
    padding: '2px 0',

    /* Add "stitching" effect */
    borderWidth: '1px 0',
    borderStyle: 'dashed',
    // borderColor: '#fff',
    borderColor: 'rgba(255, 255, 255, 0.7)'
  },

  redColor: {
    backgroundColor: '#a00'
  },

  orangeColor: {
    backgroundColor: '#f80'
  },

  blackColor: {
    backgroundColor: '#333'
  },

  greenColor: {
    backgroundColor: '#090'
  },

  leftStyle: {
    top: '42px',
    left: '-43px',

    WebkitTransform: 'rotate(-45deg)',
    MozTransform: 'rotate(-45deg)',
    msTransform: 'rotate(-45deg)',
    OTransform: 'rotate(-45deg)',
    transform: 'rotate(-45deg)'
  },

  rightStyle: {
    top: '42px',
    right: '-43px',

    WebkitTransform: 'rotate(45deg)',
    MozTransform: 'rotate(45deg)',
    msTransform: 'rotate(45deg)',
    OTransform: 'rotate(45deg)',
    transform: 'rotate(45deg)'
  },

  leftBottomStyle: {
    top: '80px',
    left: '-43px',

    WebkitTransform: 'rotate(45deg)',
    MozTransform: 'rotate(45deg)',
    msTransform: 'rotate(45deg)',
    OTransform: 'rotate(45deg)',
    transform: 'rotate(45deg)'
  },

  rightBottomStyle: {
    top: '80px',
    right: '-43px',

    WebkitTransform: 'rotate(-45deg)',
    MozTransform: 'rotate(-45deg)',
    msTransform: 'rotate(-45deg)',
    OTransform: 'rotate(-45deg)',
    transform: 'rotate(-45deg)'
  }
};

var RibbonStyleWrapper = exports.RibbonStyleWrapper = {

  baseStyle: {
    width: '150px',
    height: '150px',
    position: 'absolute',
    overflow: 'hidden',
    top: 0,
    zIndex: '9999',
    pointerEvents: 'none'
  },

  fixedStyle: {
    position: 'fixed'
  },

  leftStyle: {
    left: 0
  },

  rightStyle: {
    right: 0
  },

  leftBottomStyle: {
    position: 'fixed',
    top: 'inherit',
    bottom: 0,
    left: 0
  },

  rightBottomStyle: {
    position: 'fixed',
    top: 'inherit',
    bottom: 0,
    right: 0
  }
};

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = StoriesRetrieved;
function StoriesRetrieved(counter){var stories=['Neqet Aklut-llu Auluklerkaat \r \r Arnariaq (George): Yuilqumun ayangssiaqamta nerkuat tamatum nalliini nerkuarrateng taugaam kiingan trash-aqtullruit. Tua-i nunam qainganun pegcesqevkenaki, nuna-gguq tauna tuani nervilput ayuquciatun camek caarrlugmek unisvikevkenaku uniskilarput. Taugaam-gguq nerkuarraput nuna pakikarluku cali nunam akuliinun qemagarrluku. Nerestekaita-gguq ungungssiaraat tekitaqamegteki tamakut elakarluki nertuit. Sagtevkenateng. \r \r Tua-i-gguq skavcissiyaagpakalriit aklunek neqkameggnek-llu, Ellam Yuan-gguq anucimirqecetaatui tangniilkessagutaqamiki.  Piitnaq-llu tuavet nunamun tut\'evkarluku, piitnartelluku tamana nuniit. \r \r Cali-llu neqkanek neqkamtenek quyureskumta uksurpak-gguq nang\'arkamtenek yaavet up\'nerkamun kiingan pikilta. Tuaten ciqitarkaunrirluki uksum iquani nang\'arkamtenek pissulaasqelluta qanruartelallruakut cali maurluma. \r \r Neqallret-gguq Akiinauyuut \r \r Florence Jones: Niitelartukut-llu Agayutmek, canek pilillrinek. Kenciknaqsaaqluteng, qigcignaqsaaqluteng tamakut. Tayima tangerqiini tamakut-llu ciqitait qamiqut wall\'u neqerrlugkuat tangnirqenritut. \r \r Qalarutetullruanga-llu maurluma neqallernek sagcisqevkenata, qigcikluki taugaam. Tangniirutevkenaku cenaq sagcisqevkenaku inerquumalallruukut. Waten-llu qantullruuq maurluput neqallret-gguq akinauyuut. Maa-i cam iliini anucimircetaaquniki yuut, neqet nurnarqeciqut. Taumek murilkelluki makut neqet yaqulget-llu watua neqkat, neqkaulriit tamarmeng murilkelluki piyunarqaput murilkenrilnguareskevkenaku quyureskan neqkanek.','Tepet \r \r Tep\'ngaayagkiuraqameng neqkameggnek, muragnek qantameggnek pingqellermeggni, ekutullrukait, urunek-llu patuluki, tepengnercirluki. Tep\'ngata-llu tua-i nutaan kenirluki. Egarpagluki-gguq tepsariqercata. Makut aluminum-aat assinritut assigtauluki tepngaayalilrianun. \r \r Qakiiyarnek temtumaita tep\'litullruit. Iqalluut, taryaqviit-llu qamiqurritnek tep\'litullruut. Qaugkut-llu elaqliput iqalluarpagnek, nin\'amayugnek aterluteng, tepsaqkacagarnek neqengqetuut. Maani-llu qakiiyarnek tep\'liluteng uksurpak atu\'urkameggnek. Qavani-ll\' akulmi neqyaarnek qassayaalituluteng. \r \r Qakiiyaat uksuarmi nunamun tua-i elaulluki iraluni qavcini tayima, cetamani-ll\' pilallriut. Nenglenga\'artaqan man\'a aarnairtaqan, ikamratgun ayagluteng anciyartutullrulriit teq\'ameggnek qakiiyarnek. Tayima August, September, taukuk nuniigni. Makuit iluit imkunek keggagcetyaalrianek pingaartaqata, pupungluarluki-gguq, tamakunga\'artaqata nutaan nerngartaqluki. Taugaam tepet avurruyagluki pisqessuitait quunarqellrianek atsanek. \r \r Teq\'at canegnek wall\' urunek-llu inguqirluki piaqluki. Imna qikuyak, nunam mat\'um atlia tekitessiyaagluku piyunaituq mer\'urciiqngan teq\'aq. Maavet taugaam qulvanun nunaullranun naugiyugngalriim engeliinun assinruluni.','Yaqulegmek Uklilleq Nalugalria-llu. Suulillra Piiyuuk Qungurkaq-Shields-aam \r \r Yuut ayuqevkenateng yaqulegnek uklituut. Ilaten apqaurluki elitniartuten qaillun ellait yaquleliulallrit. Nallunrilkuvet elissaqiki ilaten qaillun elpet uklilaucirpenek yaqulegnek. \r \r Ciumek iruk uluarlukek irum kangiakun. Atam maliggluku irua. \r \r Napnera anlluku tua-llu uluakun ukliluku. Napnera qiyualuakun, tua-ll\' ulliggluku, tua-ll\' qacigmek anqerrluni, tua-ll\' uluarluku. \r \r Palurterraarluku keggasgan aciakun uluarluku. Tua-llu atam keggasgan aciakun uluarraarluku qacigmek-llu may\'uqerrluni. Takluku pilallrua qacigmek napnera nalkessugnganiaraa. \r \r Yaquan napnera anlluku tua-llu uluarluku augarluku. Yaqruak atam caperrnarqenrulartuk irumi. \r \r Aqsaan aciqliakun pilagluku uluakun, tua-llu unatevkun ikiqanirluku. Atam qilui uluanrilkurtengnaqluki. \r \r Caniqaanun inarrluku tulimaan qukaakun acitmun uluarluki. \r \r Manua tunua-llu avvlukek. Qacigmek-llu aug\'arciiqluni. \r \r Ircaqrua anrutaa-llu anllukek, tua-llu imangai eggluki. \r \r Yuut ilait taugaam pugtautet qilut-llu kenilarait. Tuaten piyukuvet elisngalriamun apertuutevkarniartuten. \r \r Ircaqrua ciumek, tua-i-llu tauna anrutaqaa. \r \r Tunua qukaakun tua-llu qupluku. \r \r Qat\'gaanek qutua avvluku. Una caperrnarqenrulartuq enra tamaani mamtunruan. \r \r Qat\'gaa naparrluku tua-llu qukaakun uluarluku. Mulngakniartuten waten pikuvet, nalluvni elpenek uluaryuartuten tua-ll\' kilip\'agluten. \r \r Tua-llu ceterluku malrugnek kemegtunra qatgaani. Wani taugaam inglua ataucirqumek cetellrua mamtuvakanrilan. Cet\'laraput assirluni keniryugnganiartuq. \r \r It\'gaak arivneragnekun asemqaarlukek uluarlukek. Ilini caperrnarqelartuq yuallerkaa nanlucia arivnera. Taugaam una iruan kangrani uitalria eneq mikpakaan, tuaten ayuqluku unitellrua. \r \r Ircaqrua augyanrirluku. Yuut tamarmeng waten piyuitut, taugaam waten ellii piyunqegtuq. Piiyuumiilkuvet-llu cangaunani. \r \r Anrutaani unaillrulria yuarluku. Elpeksugngalartuq atam caavtaaquvgu. \r \r Uluakun tua-llu cillarrluku. \r \r Anrutaan ilulirnera keligluku augarluku uluakun. Man\'a tekiskuvgu mulngakluten piniartuten, unaten aliimaten-llu uluanrilkurtengnaqluku. \r \r Carrinqegcaarluku piniaran neqnialngaitniartuq. \r \r Anrutaan avvnerak ceterlukek. Ilait yuut malrugnek cet\'laraat, taugaam elliin ataucirqumek ceteryunqelarai. \r \r Nalluyagucaqunaku erullerkaanek keni\'irkan kenirpailegpegu. \r \r Tua-i iquklituq. Quyana Naluk\'a! \r \r Qaillun yaqulget uklilarciki? Igausgu qaillun uklilaucin! \r \r Quyana tangvagluci!','Caqutet \r \r Tamakut nutaan arnat pinariata uqut uquutekanun, uquutekat uyalqurrit qillerqaarluki mermun akurrluki kenicirluki, melqurrit iluqliqluki. Tua-i-ll\' assiriata unailiata, nugcamegteki unatait anlluki, kankut-ll\' it\'gait, cetuit kepurluki. Kepurraarluki nutaan iterrluki, ngelaitgun-llu qillerrluki cagnilluki kankut. Nutaan uqut qaill\'\' iqtutaurluki pinevluki imarkiurluki uqunek egvailgata. Imirluki qertuniryaaqevkenaki. Melqurrit iluqliqluki muirrluki tua-i. Caknengan taugaam tua-i nutaan qillerrluku. \r \r Qertuniryaaqevkenaku. Nutaan qillerqaarluku, egcillerkaanun, inguqirluku muragnek pela\'atekat iluitnun, aciit agtuumavkenaki nunamun. Qerratarucirluku uqut nutaan tamakut imilteng elliurluku. Ella assiraqan patuirluku, pivkaraqluki. Mecungnariqertaqan patuaqluku. \r \r Uquucillret \r \r Tua-i-ll\' pinariata nutaan nunam iluanun elliluki. Qaill\' ilututalallruut waten (4 feet deep). Tamakut-llu poke-at (uquutekat) canirqurluki waten, kipulketaarturluki imituluki. Iquklican-llu ekiirraarluki muragnek ataam qallilirluku uquutekanek. \r \r Atam unkut imiqata\'arqamagteki qalurraarluki muragnek qupurranek inguqitengqelalriit. Tua-i-ll\' nutaan canegnek imirluku, curulirluki. Urunek-llu qallilirluki, puyaurtetulinek curulirluki, call\' qallilirluki urunek mecungengraata. Qaqican-llu uqut canirqurluki kipullgutaaruqu\'urluki, imirturluku urunek akulait, agtuusngavkarpek\'naki. Qaqican-llu muriignek cali waten pirraarluki qallilirluki urunek. Qallirkait elliurluki urunek. Arunaitut urut caqulek nunam iluani uitang\'ermi. Patuluki-ll\' tua-i nunamek. Kiagpak-llu tamaanlluteng nunam iluani uksurluni-llu. Kumlaneq mamturiqerpailgan ikirrluku, nuggluki cailkamun kumelqertelluki.','Ciin-gguq yuut maani yuranermek taqellruat? \r \r Yuranermek taqellruut 1939. Nangnerqukacaarmek tua-i maani yuranermek taqellruut naulluunarluteng, anqerriluteng. Yuut amlleret tuqualuteng mikelnguut-llu, tua-i-ll\' tuaken ayagluteng yuranermek taqluteng. Yurallermeng nalliini, tuaten tua-i mikelnguut angayuqat-llu temirtet tuquangata, tuaken ayagluteng taqellruut. Taugaam ma\u0165umek rally-ryaramek, Qaneryaraq pitekluku, quyurtaalrianek cimirluni. \r \r Ciin-gguq anqerrim taqevkartaki yurallrat? \r \r Augkut missionary-t wall\'u-q\' allat taqevkallruit. Quyurrluteng nunat qanellgutekluteng yuraq tua-i taqluku. Ma\u0165umek taugaam Agayutem Qaneryaraanek cimiryugluku. Tua-i-ll\', tuakenirnek yurayuirulluteng maani. Taukut tua-i tuaten tuqurpaggaartelluki. \r \r Agayumacimun tapqulluku taqevkallruyukluku. \r \r Agayumacimeggnun ma\u0165umun taman\' yuraryaraq cimiulluku. Tauna-wa tuqullrat pitekluku pillikiit. Tua-i taugaam waniwa amlleret yuut taqraarluteng ayanqigtaat. Kuigilnguq, Kangirnaq, Qipneq kiimeng tua-i yurayuunateng. Nunat qagkut negeqliput Agayutem Qaneryaraanun ukveqarraallermeggni Catholic-aat, yuraq taqellruyaaqaat, tua-i-ll\' maa-i kinguqvaggun ayagnirluku. Tayima tua-i wiinga qaillun nalluaqa maani pillerkaat, yuraryaurciiqut-qaa wall\'u-qaa yuraryaurtevkenateng. Qaill\' nalluaqa wii tamatum ayuqucia. \r \r Kia qanrutellruaten maani yuraryaramun anqerrillrat pivkallruniluku? \r \r Yuraryaramun pivkenaku anqerrillrat. Tua-i-w\' naulluutngullrulria tauna. Taugaam ellait yuut makumiut, Kuigilngurmiut-llu quyurrluteng qanellgutekluteng yuranermek taqluteng. Tuaten-llu tamana anqerriq pitkevkenaku, tuaken tua-i ayagluteng yuranermek taqellruut. \r \r Maa-i-qaa yuralangkuneng piyugngaut wall \'u-qaa pisciigatut? \r \r Wiinga qanerciigatua yuralangciqniluki. Taugaam ciuliqagteput augkut agayulirteput kiimeng atanruut. Tayima ellaita nallunrilucimegcetun kiuciqaiceci apeskuvceteng yuralangesqelluki wall\'u-qaa yuralangesqevkenaki. Wiinga waten qanerngaitua yuralangesqelluki. Wiinga waten qanerciigatua, "Yuralangciqut, yuralangkilit-gguq." Taugaam agayulirteput kiimeng atanruut ciuliqagtenguameng nunani ukuni, nepaitmek taugaam calilriaruameng. \r \r Missionary-t-qaa assiitnillruat yuraryaraq? \r \r Tekitellermeggni-gguq yuramek camek assiitniluku qanyuitellruut. Taugaam-gguq taum tua-i Maknerem-gguq uum, agayulirtem pilallrui makut cailngurnun ikayuutnguniluku canek aruqluki, aklumeggnek tuaten piilnguut cikirturluki. Tuaten-gguq Makneq tauna qanellruuq. Assiilnguuniluku-gguq qanellrunrituq, taugaam-gguq ilaitnun ikayuutek\'larniluku tuaten qanellruuq. Taugaam yuut makut ellait ukvengameng, Agayutmun, tua-i cimiulluku yuraryaraq rally-ryaramun. Tua-i-gguq yurami tamaani ikayuutngungraan, camek unangvikenrilamegteggu. Rally-mi taugaam nutaan elluarrluni yuullerkamek, qalarucilriit naken nunanek piciatun tekiqluteng, tamakut-gguq tamaa-i assikluki. Wangkuta yuk\'egtaaraullerkamtenek qalarucilriit. Tuaten-gguq qanrutkellruit.','Yuram Arulaciit Kangiit \r \r Tua-i-llu nunaniryukuni kina, nunaniryugluni waten. Nunaniryugluni, tua-i-ll\' aliayugluni. Ayuqluteng cali napat naukuneng, nauluteng, cat taperrnat nauluteng. Tua-i-llu aliayugluni, angnirluni, aliayugluni. Waten yagiracirluteng. \r \r Tua-i-llu quuyurnikuni kina, waten quuyurniluni. Aqumekuni aqumluni. Tua-i-llu pangalekuni waten pangalegluni. Tallirpik ciumek, tallirpik waten pian waten elaqliuluku. Ukatmun cali. \r \r Apyun: Tauna-qaa kangingqertuq tallirpik? \r \r Kiutii: Tua-i-w\' ukanirpak tallirpigglainaq alerquutekellrukiit. Camek-llu tua-i kangiliyuunaku wangnun. Taugaam tua-i yagteqataqumta tua-i yagparrlainarluta-llu. Waten-gguq yuralriani, taringnaitukut. Taugaam waten. Cali yageskuneng, waten maliggluku unan, tallini, yurararkaulliniluni. Waten yageskuni yagpagluni, iimikun maligcuarluku. Temput-llu coordinate-arluni ellminek. Waten pikuni, waten. Tamarmi tangvaurquvni ellminek, temen piciqluni. Cali waten augkut aperyarat waten ingayaralriani waten yura\'arqameng waten ingayaraalartut. \u2018Ingayaraa, ingayaraa\'. Agiiyaraa. Agiiyarauluni. \r \r Tua-i-ll\' elpenek qanemcikekuvet wiinga. Wiinga waniwa. Wiinga. Tua-i-ll\' iliini wangkuta waten. Wiing wangkuta. Wall\'u-qaa man\'a arulaciuyugngauq cali yuralrianek arulalrianek qanquvet. Arulaluni-gguq arulauq-gguq. Ilait-llu qaugkumiut waten arulaluteng. Arulalriaruuq yuraq. Arulayarat-llu ayuqevkenateng. Ilait waten arulaluteng. \r \r Tuamta-llu qayaqataquvet, anguaqataquvet tallirpik pagaanlan iqsulirnermun ciumek piarkauluten. Tua-i-wa una quyinruan. Angualria, ciumek waten anguarciquq. Tallirpilirnek pikaken. Tallirpik, tallirpik iqsulirneq. Anguarluten, anguarluten. Tua-ll\' cali waten anguarluten, ilait-llu tua-i waten. Ilait-llu waten. Ayuqevkanteng. \r \r Kiiryugluten, aqsiluten, nerluten, camek-llu? Arulalriit ilaini waten aru\u2026 Ca-llu tua-i pekeskan waten ukatmun pekluni, can\'get wall\'u meq, wall\'u anuqa. Tua-ll\' ca taikuni tailun waten. \r \r Taiguraa maavarraat, taiguraa maavarraat, ulevyugaa pagaarrani, yaqigaa-yi-yaa, Tengaurlun. Ayaruqa nauwa. \r \r Ayaruminek yuarluni tauna angulluarulliami. Tua-ll\' iquklilluteng waten, \u2018Yi-rri-i, i-rri-i\'. Coastline. Tua-i-llu Kuigpagmiut. Waten pirraarluteng, tua-i-gguq naulluteteng tamakut ayaggluki, quyurqaarluki, tua-i-ll\' ayaggluki. Agayuqluku, agayuciungan. Wangkuta-ll\' waten piluta, \u2018Yi-i-rri-i\' tua-i-ll\' atauciq, malruk. Taumek tangerquvet, tua-i-gguq yuarutem nangneqaa. Nallunailkutangqertut. \r \r Apyun: Neqsulriit-mi? Joe Asuluk iqvalriamek pillruuq waten. \r \r Kiutii: Ii-i, waten iqvalartut. Waten ca teguluku tua-ll\' iqvarluten. Tua-ll\' ayaruquvet kangaquvet ayaruturluten waten. Taugaam tallirpilirnerkun. Tua-ll\' neqlikuvet, neqlirraarluten, piirriluten, teguluki iniluki, pagaavet pagaavet tangerrluki iniaten. \r \r Cat cayarat im\'ungqertut. Mayuarluten, mayuarluten waten. Natmun mayuquvet, nem\'un mayuquvet nunamun mayuquvet. Mayuarluten quletmun. Tua-ll\' ellu\'urrluten. Ellu\'ureskuvet-llu waten. Wall\'u-qaa ingriq waten aarnaqluni pikan waten piluku. Ellu\'urrluni, wall\'u-qaa ingriq waten qacarnera, tua-i-ll\' qurrarvakuvet waten. \r \r Tua-i, quyaluten, kiiryugluten, aqvaqualuten, nalluluten. Tuaten tua\' cayaraq tamarmi yagiracirluni. Nunalget ayuqenricecuarturluteng. Aturluteng, yurarluteng, ilait waten yurarluteng. Ilait waten aturluteng. \r \r Aqvaqualuteng, nutegluteng, wall\'u-qaa pitgarluteng, pingayurqunek pituut, atauciq malruk pingayun pitgarqameng. Nut\'gaqameng cali, atauciq malruk pingayun. Aipaagni tuaten piciryaraqetullruit, piciatun piyuunateng. Ayalguluteng-llu, ayagluteng tua-i kiarrluteng. Takuyarluteng, merluteng. Tangerciqut ilait ama-i ca pugluni. Pugkan-llu tua-i nuqluku-llu pitaqekunegteggu, waten nuqtaqluteng. Pissu\'urqameng nuqcunqeggluteng waten.','Arnaulriim Ciuniuryaraa Issurimuq \r \r Arnam caarkaullra arcaqalriaruuq uini piissuryaqataqan wall\' pissu\'urqan, utrulluni-llu issurimek. \r \r Uinga itruskan issurimek, nuliaran ciuniurciqaa issuriq ipuun imirluku qanikcamek, wall\' mermek tua-i-gguq merr\'illuku qanerluni-llu, "Meqsuavet meq\'egtaarmek merr\'itamteggen. \r \r Qanikcamek kanveciqaa tamluan nuniikun, unatait-llu. Tua-i-llu arnaq ellimeriluni aqvacesqelluku qanikcamek wall\' mermek ipuun imirluku. Mingugciqaa mermek wall\' qanikcamek issurim qanra, arevneri, unatai-llu cetaman. Ilakuaq-llu meq ciqrulluku ellamun. Waten minguinanrani qanerciquq, "Tangrru maaken meq neqnirqenruuq." \r \r Una tallimanek mingugiyaaraq mermek wall\' qanikcamek apertuiguq qanemcimek umyuaqluku tan\'gaurluq uitallrani issurit ilakluki, elitellra tua-i-ll\' utertellermini elicarluki ilani mermek ciuniuryaramek.','Uqiqulleq \r \r Uliggaam anngaa Aparuk uumikuani amirkatenqigtuq. Tua-i-llu unuaquani Uliggaankuk aanani-llu kepuraak tauna amirkaq. Kepurinanermegni Uliggaam aanani aptaa, "Kia Aparuk uqiqurciqau?" Aaniin kiugaa elliinun uqiqurciqniluku. \r \r Tua-i Uliggaankuk aanani-llu kepuriuk amirkamek elatmeggni, taqucamek-llu mernuinercirlutek yuurqallinilutek yuurqallinilutek enemeggni. Uliggaq-gguq cakneq angnirluni uqiqurciqngamiu anngani. \r \r Yuurqanermek taqngamek Uliggaq aaniin pia kipusvigmun maligcesqelluni. Tua-i-llu kipusvigglutek Co-op-amun. \r \r Kipusvigmun iterngamek Uliggaq kiartuq canek uqiqurkanek. Aanani pinauraa ukunek pisqelluku. Kipuquk piciatun uqiqurkanek. Kipurqerraarlutek utertuk. Enemeggnun tekicamek aaniita Aparuunkuk Paayaq-llu piak, "Kipusvigmek kipukengalpuk aqvatki ikamrirlutek." \r \r Aparuunkuk Paayaq-llu tayima an\'uk kipukengat aqvaluki kipusvigmi. Taingagnek allakarakek uqiquutekat. Uliggaankuk aanani-llu \'lumarrarnek allguriuk irnerrlugnek-llu ilaluki. Taqucamek aaniita Aparuunkuk Paayaq-llu piak uqut kemget-llu elagyamek elaturramun itrucesqelluki. \r \r Tua-i upingariameng aaniita piak Uliggaankuk, Paayaq-llu kelguurisqellukek taugaam kelgesqevkenaki mallegluki ilakessiyaakekek. Uliggaq cakneq tengruluni egmian kelguuriuq enenun itqetaarluni, ilakutateng taugaam pivkenaki, piciryaraungan. \r \r Kelgarkatek qaqicata aqvaqurlutek utertuk. Enemeggnun tekicamek itqertuk. Aanasek-llu qanrutaak ak\'a kelginilutek. Qalutam quyaluni Uliggaq utaqauraasqaa elateteng yungnatkaanun. \r \r Uliggaq tua-i utaqasciiganani aanani ampiirangaa, ugaani uqiquryuum. Tua-i-ll\' aaniin pinqigtaa Uliggaq elaturramun anluku utaqauraasqelluku. \r \r Uliggaq elaturrami utaqaurtuq, kiituani elatiit yugyanguq arnanek. Itqerrluni aanani qanrutaa ayagniqatarniluni. Aaniin anluni ikayuryarturaa. \r \r Uligaam ciumek uqut, kemget-llu aruqutkai elaturramek anulluki. Aruqnermek taqngami nutaan taperkani uqiquutekai. Uliggaq anglaniuq uqiqullermini. Anglaningiinangqanrakun tapri nangqe\'rtut. Tua-i-llu uqiqunermek taqngameng Uliggaam aanani pia cali allamiku uqiquryugluni. Aaniin angraa.','Aqumgaurpek\'nak \r \r "Yuk-gguq uitaurmi cangyuituq." \u2014 Tarr\'aq, Kuinerraq \r \r Tarr\'aq, Kuinerraq: Wiinga miklemni-wa tua-i aanaka catairutellrungraan taugaam maurluma anglicallruanga. Tuaten canek pivkatullruanga. Ayuqucirturlua pilallrullinianga maurluma. Neqliaqameng-llu tuaten uqlang\'erma neq\'liurcetaqlua. Kenkumalua anglillruyaaqua taugaam wangnek pingama tamakut pingnaqu\'urluki pilallruunga. \r \r Irniaqa-llu augna panika yuurteqarraallranicali tuaten anglirian ciuqliq, taumek maurluma qanruyutek\'lallranek qanrut\'lallruaqa. Cali-llu neq\'liuraqamegnuk-wa tua-i neqliaqama ikayuturianga, atiin uqlarniluku pingraan wiinga piaqluku, "Wiinga maurluma tuaten qanrut\'lallruanga." \r \r Yuk-gguq uitaurmi cangyuituq. Cat-llu-gguq pitat uitaskumki assiiruciiqut paralurluki-llu. Neqngungaitut-gguq tuaten pimalriit. Assiinateng. \r \r "Neryunqelalriaten-llu. Assiilngurmek-llu neryuumiitelalriaten. Cat neqkat aipangkuvet-llu aiparpet pitai uitat\'laquvki caiciiquten. Kaigaqluten, wall\'u ilavnek nerrsaagaraqluten pituciquten." \r \r Amlleq-llu tauna maurluqa tangvallrunricaaqaqa, taugaam maa-i umyuaqelaranka, qanlallri. Irniangama-llu taukut tan\'gaurluungraata-llu ilait qanruyutek\'laranka. Cali-llu nasaurlurmek irniangama cali apertuataqluku. \r \r Quyalartua ilamnek-wa tua-i ilanka qalarutaqatki cali elitaqlua. Kitumek qanrutestailengerma murilkengnaqaqluki qalartellriit. Tamaaggun cali elitaqlua. \r \r Maa-i-llu three years-aurtuq neqliksailuciqa. Taukut taugaam panima neqlitaqlua. Quyaaqlua tua wii tamakunek teguteksailengerma pikaicuunii. Aiparma-llu ikayuatullruanga. Maa-i cali ikayuagaqlua. Cataitaqama-llu cat pitat elliin caliaqellininaurai maaten tekitnaurtua. Quyatekaqluku tamana.','Ulu Mik\'lengermi Akngirnarquq \r \r Cali aug\'na uum nuliacungama qanellra piciuqapiaralria ava-i aipam tungiinun ikia naluumasqevkenaku wall\'u unani uitavimini qanmiknun\'gguun nep\'ngevkarillerkaq. Tauna tua-i piciuqapiarluni maa-i taringumaluku ernerni atullra. Yuum iliin yuucia qinuitqapiararaqluni yuut ilami akuliitni. Camek aviranarqutkamek yuucia imangssagaunani, tangellra tua-i tunulluku unilluku pingermiu, qanemcikutekaunani. \r \r Qinuaraunani nunani taukuni uitaluni. Ilii taugken ilaminek apqiitnek uputaarilria, apqiitnek cagcingnaqelria nep\'ngutkamek, apqiitnek yuum caullni ulevlaulluku. \r \r Qanerkaitulria-am ulevlalriamek cali meaning-iirluku pilaamegteggu. Caullni tamalkuan apqiitnek ulevlaulluku, piciunrilnguq piciurrluku yuum umyugaan akngirutekaa nunaullermegteggun nep\'ngutkaat piciurrluku. Tuarpiaq ilumun nalugluku yuut quliitnun, nep\'ngutnguvkarluku. \r \r Tamaa-i tamana mulnganarqelria tua-i nunakenrilkemini uitaluni. Qanqatalriani  camek qanllerkani yuvriqerrlainarluku. Nep\'ngutkaunrilkan qanruteksuumaluku, nep\'ngutkauyugngakan taugken tua-i qanrutkeqataryaaqerraarluku taq\'icuumaluku. Wiinga ayagyuarlua nulirturpailegma-llu angutngurtellriim qanellra taringellrunricaaqekeka cunaw\' ava-i augna qanrutkek\'ngaqa. Angutem qanruskiinga, "Yuucuaqaurlullerpeni qanerpeggun ilaten ilakniteksaqunaki. Ulu mik\'lengermi akngirnarquq." Taringenritaqa. \r \r Maaten tua-i maa-i kinguqvani taringaqa qanqata\'arqama yuvriqaaqluku pisqellinikiinga, yuullgutemnun akngirnaqsugngakan nep\'ngutnguyugngakan-llu antenrilengraan qemangqaaqluku pisqelluku. \r \r Tua-i-llu tangvautelartukut atunem ilaput-llu, ilaput tangvagluki. Ava-i-am qanrraallrulrianga qinuarailngurmek yugmek ilani tangvagluki tuaten tangvalararput, tua-i camek aviranarqutaunani. Ilii taugken tangerrluku tua-i qaneryugtacimitun qanerluni. Ilani umyugait akngirrluki young-angraata, taqnerungraata, aliayullagavkarluki umyugait akngirqelluki. Tua-i tauna qanmikun yuum ilaknitkiyaraa. Tuaten ayuqekuni qanmikun ilani ilaknitekluki. Tua-i-ll\' augna ava-i qinuilnguq yuk qanmikun ilani ilaknitkevkenaki. Tuaten tua-i man\'a yuuguralleq ayuqsugngalliniluni.','Tatailnguq \r \r Tua-llu pinauraitkut, angutem-gguq iliin tan\'gaurluq yuk\'enrilngermiu ellimeqayunarqellra pitekluku irniaqelriatun ayuqliritua atangqengraan, yagiraurallra assilria pitekluku. Tua-llu makut qatellriit aipaiput tan\'gaurluum ilii nasaurluum-llu ilii assirluni calilria calisteksuumilaraat, assikluku calisteksugluku, cucukluku-llu. Cangallruvkenatek. Tamatum-gguq kiingan tuaten pingaitaa. Yuullgutain-gguq taugaam wall\'u ciulirneret-llu cucukeciqaat nasaurluq, nasaurluuli tan\'gaurluuli-llu. Ikayuacunqellrakun anyuqevkenaku, takaqelriatun ayuqevkenaku piqayunaqngalnguq pisciryiin. Tuaten-gguq ayuqelria atengqertuq tatailngurmek. \r \r Taringan tatailnguq? Uunguuq waten pikuma camek egmian nang\'erciiquten pinrilengramken. Taunguuq tatailnguq. Imna taugken niiteng\'ermi aqumgaluni tua-i uitalria tatervak-gguq tua-i tauna. Makut-llu ungungssit ilait tatervaugut. Tuntuviit-llu makut ping\'ermeng aqumgayugluteng nangertevkenateng. Ilait taugaam pitmeggni nangnerrluteng ayagarrluteng. Tamaa-i tuaten ayuquq yuk. Aug\'ukun ava-i qalarutketuat caarrluk; apquciarpek\'nani-gguq tuaten tamatumek atulria yuugarkaugut. Ilani apquciqetaangraata cakneq piyuunani ellii, apqucim tukniluku piyuunaku. Tuaten qalarutketuat.','Ayagina\'ar: Tua-i-gguq nakukumassiyakuni yuk umyuangeciquq, ellminek-llu wani piunrircugngaluni. Tuaten-gguq ilii ayuqelartuq. Taugaam-gguq tuaten ellilria angniyuirut\'lalliniuq. Wiinga tangvallruunga atauciurqunrilngurnek maa-i. Tuaten ukut wani, ilini-llu angayuqaita piaqluki, mat\'ukun waten akusrarcarakun yuugaqameng mikelnguut nasaurluut-llu iqlutun umyuangetulliniut. Wall\' ilameggnek tan\'gaurlullgutmeggnek-llu nakukumassiyagaqameng iqlutun umyuangaqluteng. Angniyuirut\'lalliniut. \r \r Tangvallruunga wii qavcinek augkunek nunalgutemnek maa-i. icugg\' tua-i angqangermeng-llu ilateng quyuarayuinateng-llu. Tuaten ellilalliniut. Tua-i-llu ilait ellmeggnek piunrirtaqluteng. Taugaam-gguq tuaten ayuqellria elliqan, wangkuta nalluniluku waten tamakucimek kitugciqataqumta tuaten ayuqellriamek. \r \r Augum waten apa\'urluma  qanrutkellrua, "Tamakuciqguq umyuangekuni tua-i tuaten ellirciquq angniyuirulluni. Amta-llu tua-i ilagautaqluteng angnilrianun." Quyuayuirut\'lalliniut ilumun. Taugaam waten qanrutkaa augum apa\'urluma, "Tamakucimek-gguq taringekumteggu apciiqerput, apciiqerput camek umyuarniuruterluku tuaten umyugaa ellillranek taringekumteggu pisqelluku. Egmian-gguq nalqiggngaituq, nalqiggngaituq-gguq tauna tuaten ayuqellria. Taugaam-gguq apcaaqerraarluku nalqigutenrilkan". \r \r Waten-am qanrutkaa, "Mikelnguull\' pillgutai angtatain, kelegluki waten tangvagtelluki taum takuani tamaanelkan qanemciskilaput canek temcinarqelrianek tua-i angnirnarqelrianek ngelallagavkarluki. Tua-i taun\' ilakluku waniugg\' uitaluni tauna niicugniluni-llu." Tuaten ayuqellriit, augumek ava-i apertuutellruanga, qanrutellruanga. \r \r Tua-i-gguq piqanrilnguum, tua-i-gguq nallunriquni taum\' tua-i ayuqellra yuk, tuaten qalarut\'laqilaki taunkunek ilaluki, ukut taisqelluki mikelngullraat tuanelkan tauna ilakluku niiscugnivkarluku. Qalarut\'laqilaput temcinarqellrianek mikelnguut angnirnarqelrianek ngelallagavkarluki. Tua-i-gguq pinricaaqeraarluni qavcilirikuuni pivakarluni, atam-gguq temciyullni niilluku pillilria quyuaralangelria tauna. Tua-i tuaten ellilliniluni. \r \r Egmian-llu taum\' pivkenaku taugaam nutaan ellminek qanqan tauna, pilliniuq taukunek qanemcit\'lallrinek imumek temcinarqellriamek qalamciqaasqelluku. Narurtevkenaku tua-i qanemcikliniluku. Tua-i ayagnirluni tauna, tuaken ayagnirluni. Tua-i-gguq tauna wani piiyaaqerraarluni uumikuaqan nutaan pikaniraqluku. Nutaan-gguq ngelalaangekan tauna, imna augna qanrutkesciigalnguq ayuqucimitun ayuqenrilria, nutaan-gguq qalangssauqaarluku apeskiliu camek umyuarniuruterluku tuaten elliucianek. Kiungaituq-gguq egmianun. Kiungaituq-gguq. Tuam-tall\' aipiriluku, nutaan-gguq pingaiyirikani qanruciqaa. Nutaan qanruciqaa. Tua-i-gguq tuaken tauna nutaan ayuqucini cimirciqaa tua-i, taumun tua-i qalarucestemikun,amaggun taringluku tamana iqlutun umyuangyaaqellni cimirluku mumiggluku. Assiriluni tua-i qanrucunariluni.','Ayaruicaqunak \r \r Ayagina\'ar: Alerquuterluta uksumi waten qamigaqumta cikumarikan tuangekan, tamana wiinga alerquuterlua, "Elliqauciqaku tamana tumkan yuvriqiu tauna." \r \r Negcignek pingqetuukut. Tua-i-llu atralallemni qayakun tua-i tamakut murilkaqluki wii pilaranka. Elliqautmun tekitaqama mamtulriamun wani, augkut negcit cingilengqertut tugruluteng. \r \r Tua-i-llu waten talliqa tua-i tamalkuan, piniqa aturluku wii, tamana taryuq, kapuskumku tamaavet elliqautmun anqerciiquq waten, tauna im\' qillrusngallri cingilgem wani pellugarrluku. Tuaten-gguq pikan, angu, inerquraanga taum ayaasqevkenii. \r \r Taugaam nutaan allami, waten tugqumku ukiarteng\'ermi akliskan wavet, tauna-gguq tua-i wiinga muscle-aaqa aturluku anqertenrilkan ugingayugngaciqua. Tuaten tua-i alerquuterluta imarpigmi wangkuta uani, pilallemni-ll\' tamaani. \r \r Ayaruq \r \r Kangrilnguq: Tua-i cali ava-i uum apaakengaa ayaruq, tua-i nanelviilkelluku apeqmeggnek uksuarmi. Ayagayugngalriamun tua-i tegumiarraqluku ayasqelluku. \r \r Yuk-gguq nangrrarmi ayagaqami tua-i pitsaqevkenani aarnarqelriamun tekiarrluni imuskuni cikumun ayaruni-gguq tamana cani\'irrluku tua-i pugumateksugngaa cikumi tuani kisvimini. Ayarum atuullra amllerrluni. \r \r Qaill\' pikuni tua-i ayaruq ikayuqluku tua-i qaill\' anangnaqsuumaluni. Cali tua-i makut cikumangraaki tugqerrlainarluki. Camun kuigmun nanvamun-llu ekqataquni mamtutaciit murilkerrlainarluki pisqumatuluk\' uksuarmi.','Iqalluguat Negeqvam Taqellri Nallunailkutaugut \r \r Civialnguq: Qanruyuteklalput ava-i augkut, ayagaaqamta tua-i nallunailkutarkaput apertualallinikait. Augkut-llu uksumi, cali ikamraralalriakut maa-i, iqalluguanek pilarait qanikcaat tengcimalriit nanvani nunam-llu qaingani. Cali negeqvam tamakut caliari tuaten taqellri ayuqelliniluteng. \r \r Waten-am pilaraitkut, ella-gguq assi\'irqan elitnaulararput tamakut qaill\' ayuqellrit assiilkan nallunritnauraput. Ellakeggmi taugaam tamakut nallunringnaqlerkaatnek naugg\'un-llu natmun-llu tamakut cuqekluki ayangnaqlerkarput nallunringnaqlerkaanek elitnauresqelluta. Ellarayagmi nutaan pikegciluta tamana elitnaullerput ellakellrani atullerkaa nallunritlerkaanek pilalliniluta. \r \r Nanvami tamakut amllermi nallunaitelalriit. Tamakut-gguq cali, cali guide-aqsunaqluteng naken anuqa pillrucianek ayuquciilkumta. Tamakut iqalluguat tangerrluki nanvam iluani wangkuta nallunricugngaluku tamakut iqalluguat natetmun caumaciat. Apertuulluta; towards the north tayima tamana caumallrat piluku pilalliniluteng.','Agevkarluni Qanikcamun \r \r Cali tua-i pitsaqa\'artevkenata pektauluta, ellaqerrulluta pikakut qanikcaam-gguq mamturillerkaanun aqumenrilkilta. Mamturillerkaa-am una cam uqinra qertulriim aperluku, uqinranun pisqevkenata, maavet taugaam kitureskiinun qanikcaam pisqelluta. \r \r Tua-i-gguq tuaten qanikcaam kitureskiinun pikumta, qanikcaam mamturitenrilkakut, agengraakut qanikcaam, agkakut avatvut man\'a cinguuraqluku qanikcaq agtuumasngairulluku aturamtenun. Tamatum-gguq tua-i tuaten anertevkallemta man\'a ilulirnera yukutangkani umcigiciquq. \r \r Una taugaam qulvut ciuqerput ukicissuutailkumta muraggarmek ayarumtenek wall\' nutemtenek ukicissuutailkumta, tua-i tallimtenek uumek naspaagaqluku. \r \r Mamturiinaqan pagna waten kanevvluku acimtenun elliluku wangkutnek qaivaqaniraqluta. Tuatnakumta-gguq tua-i ukimaurtelluku una kegginamta ciunra, epngaitukut-gguq. \r \r Qanikcaq-gguq ukinrunani umcigtuq. Yuk-gguq tua-i tuaten ukicissuutaunani ukinrunaku pikuni epsugngauq qanikcaam iluani. \r \r Cali-am naspiartellruaqa tuaten tua-i pinarqellra. Ilavut elluugtellriim pagken patukii. Tua-i tangviimteggu qanikciulaagluta waten yaaqliqluku, Yaaqliqluta. Wiinga tua-i nall\'ara\'arrluku. Tayima five feet mamtutalriim aciancugnarquq. Ten minutes tua-i cama\'ancaaquq tayima qanikcaam iluani, tua-lli-w\' antarput ak\'a tua-i elluatuunriryaaqellinill\' ayuqucini-ll\' kaumavkenaku. Ak\'a epsarpiaqalliuq. \r \r Taumek tua-i tamaa-i ukinricunaunaku qanikcaam agumakakut alerquutek\'lallrukvut waten yuilqumi pektauluta arenqiallugeskumta. \r \r Tamaa-i cali aturaput mamkunaki ayaasqenrilutiit, tuaten tua-i arenqiallugcaraq nani ayuqenritellra pitekluku. Cali-llu ella piciqngaiqaarluni ellarrlunga\'artelallra pitekluku umyuallgucirluku pisqumanrilutek\'lallrat tamaa-i yuilqurtellriani.','Imarpigmi Augna Pilleq \r \r Tua-i-llu wiinga nallunrilkengaangqertua cali imarpigmi aug\'umek Yuralqiq. Ava-i akwaugaq imna Qusaumek at\'lek, taum amaura. Imarpigmi unani wani, tauna qanemciknaurqa wii. Imarpigmi unani up\'nerkami ayallermini, tua-i waten urugyuggluarangluku yaani Qipnermiut ketiitni. Ayallermini tamaani waten pingnatugluni yuungnaqsaraq man\' aturluku imparpigmun, mayullrani waten nalluyaguarrluku. Mayuqata\'arqamta imna ciku pugtalria, augkunek negciutnek tugqalaraput. \r \r Cikum ngelii wani up\'nerkangaqan, qailiurtura\'arqami man\' avatii mayulartuq. Icinengluni-gguq tamaa-i. Icinermek taman\' ap\'laraat. Urugluku iluqvanun waten piluni. Tauna Yuralqiq, aug\'um amaura Ilallemta akwaugaq, qayarluni tua-i yuuqatallermini tauna nalluyagulluku, umyuaqenritqerluku. Wiinga-ll\' pillruunga. Usslluni. Yuuqatarluni qayani tua-i, ussucami-ll\' tua-i ussucan, qayaa ayagarrluni, tenglluku. Nurrluni tuaggun cikumun. Qayaa-ll\' tenglluku, tengtelliniluku. Tua-i tangvagluku. Yaaqsigivailgan pillrukuni qerrutessiyaagyallrunricaaqellinia. \r \r Tua-i tengtenglliniluku yaa-i yaatiinun anuqsaaran; anirta-gguq anuqlinrituq. Tua-i-llu tauna negcig\' augna, qayam negcia, wangkutnun alerquutngulartuq tua-i tauna pegingasqevkenaku imarpigmi. Tua-i imucetun cacetuqutngulriatun qayanun mat\'umi atuuluni. Ussutellermi tua-i qayaa tengtelliniluku, kiimenani-ll\' avatii-ll\' qayartaunani. Yaaqvaq man\'a tangellra qayartaunani. \r \r Atam tua-i, tep\'ngaku yaa-i ugayallinilria kuimaqatarluni. Augkut negciit, augkut, augkunek tuaten taprarrarnek waten, qaill\' taktaurluni negciit imkut. Tauna tua-i keggluku kuimellinilria tuavet ukaqlianun ugayarraarluni. Tekingnaqluku tua\' tekicamiu tamatumun tua-i nuggluni. Kankuk taugaam ipuugegni taugaam arcaqerlukek kumlatnillruak. Tua-i-gguq nutaan waniw\' cali qayaq tauna, qerruyingssiyaagpailgani, kuimluni cali ullagluku. Tekicamiu nutaan cali tua-i mayurqaarlukek-llu iluani urugciqarraarluni nutaan akluminun agluni anguarluni. \r \r Tuavet akluminun tekicami egmianun qayani mayurrluku, egmian\' qilirluni, kenircuutni kumartellinikii. Qerrutqapiarluku-gguq cakneq. Taryur\' atam kumlatuq. Taugaam iguugegminek kumlaskegnek taukugnek assiilliqlun\', arcaqerlun\' tua-i tauna qaini pingraan. Qerrutkacagarluku-gguq tua-i. Tua-i qilirluni pirraarluni kenircuutni kumarrluku. Utumariami tuani, kumarqaarluku nutaan uqumek saskakun mell\'iniuq uqumek. Merraarluni-ll\' cakaninrilami tuavet cal caskamun qurrliniluni. Qurrngami, taqngami merluku tauna, tuamta-llu aipiriluni merluku. Utumaqerluni tua-i nutaan. Utumaqaan uitaqarraarluni akluni tua-i ac\'amiki keluminek, nutaan kenircuutni kumavkarluku saaniini angengraan, imirluku muirluku. Kenircuutekun tuaggun urugcilliniuq saanililuku. Qerrulluku-gguq tua-i cakneq, tua-i avatii-llu qayartaunani. \r \r Nutaan tua-i taqngan, qallangan saayirraarluku ecurrluku yuurqallinia. Urunritaa-gguq tauna nangluku. Utumaqaami, tua-i pinirikaniami, cali imirluku. Imirluku tua-i cali urugcirluku saanililuni. Nutaan tua-i taqngami, qallangan yuurqalliniluku nutaan. Neqmek tua-i nerqerraarluni, nutaan qainga-gguq urugiinaarluk\' qerrutengraani. Tua-i nutaan uruvguaralliniluku. Tua-i-gguq qilillruuq. Atertengraani, tua-i ayuqluku elliin qiliumaluku, kenircuun kumaurtelluku qayami iluani. Yuurqalliniluku-am call\' tauna nangluku. Nutaan-gguq atam nangqanrakun, qainga man\'a urucuarqii. Uruaku tua-i nutaan man\'a qilirpeknan\' uitaurarraarluni ak\'anun umyuarteqluni tua-i tamaani atertengraani cavkenani.','Irniaput Ayuqucirtuagaqluki Piarkauyaaqelliniukut \r \r Tarr\'aq, Kuinerraq. Iluumun makut irniaput ayuqucirturaqluki unuakumi, niisngailengraata wall\' atakumi piarkaulalliniaput ciuliqagtengulliniamta irniamtenun. \r \r Yugnek taugaam ilamnek qanelrianek niicugniuratullruunga. Qanellrit wani ilait umyuaqengnaqaqluki irniangellemni, boys-aarrlainarnek irniangqerrama. Tua-i-ll\' tauna ciuqliq arnaullruuq. \r \r Tua-i-ll\' taukut wani boys-at, Louie-m-llu taum qanrutaqlua, yagiraluki-qquq pitukumki assirluteng pingaitut niicuiciiqut-gguq. Qatpagalluki-llu-gguq pilaqumki cali niicuitarkaugut. Taugaam-gguq qarulluki, qarulluki pitukumteng assirluteng-gguq atam piniartut. \r \r Ilamnek yugnek irniaritnek qalaruciaqata niicugniuraraqluki; tuacetun elitaqlua iliini ilama aanaitnek qalaruciaqata irniameggnek. \r \r Ici-w\' ayarinarquq waten aanam tangvanritellra ayagmek. Kiirrarma-ll\' waten yuungama. Taugaam allamek aataka aipangellrani angutmek aipangellruunga, brother-aanglua. \r \r Ilumun ilaput kenekluki-w\' tua-i piarkauyaaqelliniukut maa-i, irniaput ayaqucirtuagaqluki. Taugaam pilangramceteng ellmeggnek angliriaqameng avtetulliniut irniat. Inerquaqaqluki taugaam piyunaqluteng.','Tuqluuucaraq \r \r Taringnanrullrakun piciqaqa tuqluutem. Aipaqliuskunek ukuk nulirqellriik irniangekunek, tamalkukenka angayuqakek apa\'urluqlukek angutek, arnak-llu maurluqlukek. Tua-i-llu taukuk nulirqelriik anelgutengqerramek cali tayima, angutii tauna angutngullgutminek anelgutengqerqan, anelgutii cali angutiin taum irniangluni. Irniangekan angutngullgutekngamek irniakek anngaqluteng uyu\'uqulluteng-llu. Cali-llu nulirra arnaullgutminek anelgutengqerquni, cangallruvkenani irniakek cali anelgutni-llu uyu\'uqlutek. Tuaten tuqluuteput ayuqluteng.  \r \r Tua-i-llu taukuk irniakenka, taum aatami brother-aa tuqlutuluku ataataminek. Tuam-llu cali aaniin sister-aara tuqlutuluku anaanaminek. Tua-i-llu cali aatakek sister-aangqerquneng irniangluni nutaan tauna arnam irniaran tauna angun angakluku, tua-i-wa aanani arnaungan, brother-aarallu tauna angutnguami. \r \r Angutem irniaran sister-aara atami, acakluku, acacungaqluku tua-i acakluku. Tua-i-llu cali arnam, anngarmi irniara an\'ngaqluku, wall\'u uyu\'urmi angutngukan irniara an\'ngaqluku arnam. Anelgutmi irniara tua-i, angutem irniara an\'ngaqluku. Cali taugken arnallgutmi irniaqekaku nurr\'aqluku irniara. \r \r Tua-i-llu taukuk-am angayuqertuumiimek nulirqellriik irniarak irniangluni. Irniangekunek taukuk angayuqertuumiimek ava-i apellruyaaqengramku apa\'urluqlukek tua-i irniakenka. Tua-llu taukuk imkuk apa\'urluulriik tutgarakek irniangekunek, irniakenka taukuk amauqlukek. Tamarkenka nulirqellriik, arnak angun-llu atauciuluni tuqluutiik, amaurulutek tamarmek. \r \r Tua-i-llu taukuk tutgararkek cali unguvainanragni taukuk apa\'urluunkuk maurluq-llu irniangekagnek, tutgaragmek irniarit tuqlutuluki cali tamarmek taukuk maurluum apa\'urluum-llu iluperamegnek. Tua-i tutgarmek irniarit iluperaqluki. \r \r Tua-i-llam\' cali taukuk unguvainanragni iluperakek irniangluteng. Cali-am taukuk amauk iluperamek irniakek unguvainanermegni irniangagnek wagg\'uq maqamyuarutekluki, tua-llu neruvailitaq. \r \r Tua-i-llu tamakut tamaa-i tuqluutet cumikelriani tua-i tungelquni-llu nallunritarkauluki. Atami tuqluqaku tauna caminek, elliin-llu taringluku cakliniaqa wii una. Aanami-llu cali tuqluqaku caminek, cali taringnaqluni. Tua-i tamakut tuqluutet murilkelluki, niicugniluki taringumalriani, tungelqut tamakutgun tuqluutetgun tua-i nallunarqevkenateng, taringumanaqluteng.','Ilakucaraq Atellgutkellriakun \r \r Frank Andrew: Kangililuki, aciisqumaaqamegteki mikelnguut taumek kangiliisqelluki-am pitullruit aciisqelluku, kangilirluku-gguq. \r \r Alice Rearden: Kangililriamek-qaa tangerqallruuten? \r \r Frank Andrew: Pulengtaq-wa tua-i pitukait. Mik\'lengraata an\'aqata tua-i ciutaitnun pus\'arrluteng ilakutameggnek aterpaggluku. \u201CTaiguq tamarmi waniwa.\u201D Aterpagqaarluku tainiaqluku waniwa. Tuaten tua-i aciqengelrianek niiicugnilallruunga, ciutaitnun pus\'arrluteng. Mik\'naki tua-i. Kangilirluki-gguq. Ataucimek tua-i atermek aciyuitait, taugaam ilakutameggnek. Tua-i ilaita-llu ilakutameng ateqluku pingraata, atellgutkevkarluki tua-i kangilirluki. Maa-i nallunritaten atellgutkelartut. Miisaat-llu amllerrluteng, Avegyat-llu amllerrluteng atellgutkelriit. Tua-i ilakutaqelriit-gguq tamaa-i. Ciuliameggnek waten sagingang\'ermeng atellgutkelriit. Alqairutmeng atqestait al\'ameggnek tuqluraqluki. Wall\'u aanameng atranek atelget aanameggnek tuqluraqluki. Tamaa-i aterteggun tuqluuteteng aturluki cali. \r \r Alice Rearden: Angutngungraan-llu arnaungraan-llu. Angutmek atengqerrsugngaluni arnaq, angun-llu arnamek atengqerrsugngaluni. Tuaten-llu ayuqut? \r \r Frank Andrew: Tuaten ayuqut. Angutem atqellrungraaku unguvallermini aciryugngaluku arnaungraan una taum angutem atranek. Tua-i-llu angutem tauna ilu\'urqellrukuniu arnaungraan iluraminek tuqluraqluku, ilurapaminek. Atritgun maa-i makut tuqluutet amllerrluteng.','Asmuuriyunaituq - Qanrilaq Tununermiu \r \r 1 \r Kitaki elluarrluci yuungnaqu\'urqici! \r Aatavet \r Aanavet \r Qanellra \r tamalkuan maliggluku. \r Niitenriteksaunakek, \r niisngalukek \r tamarkegenka \r aanan \r aatan-llu. \r \r 2 \r Kacuuq-llu cali! \r Aug\'umek ava-i \r aatavet \r aanavet \r qanellrak \r tamalkuan maligeskiu! \r \r 3 \r Maligeskuvgu, \r elluarrluten \r ayagciquten. \r \r 4 \r Maligtenrilkuvgu, \r elluarrluten ayagngaituten. \r Nangteqluten taugaam yuuciquten. \r \r 5 \r Taugken maligeskuvkek qanellrak tamalkuan, \r cailkaungraan aanakenrilngerpegu, inerquasten alerquasten-llu \r maligtaquuralaquvgu, \r elluarrluten nutaan ayagciquten. \r Ilavnek-llu ayuqniarpeknak yuuciquten; \r yuut tamalkuita qanellrit ciulirnerpet maligtaquuralaquvki. \r \r  \r 6 \r Taugken maligtaquuranrilkuvki, \r asmuurluki niicuunaki, \r nangteqluten, inerquasteten-llu asmuuquvki, \r picurlagciquten tuquluten-llu. \r \r 7 \r Waten tang ayuqelria. \r \r 8 \r Taugaam qanellrat tamalkuan ciulirneret, \r aanam \r aatam \r qanellrat tamalkuan, maligtaquurluku yuukuvet \r angayuqaagpet, kenkeciqaagten \r qanllertek-wa tua maligtaquuraamiu, \r maligtaquuraavgu. \r maligtaquuraumanrilnguq, asmuurilria, angayuqaagken kenekngaitaak. \r kenekngaitaak asmuuriluni qanellrak, ilangcivkenaku piaqluku. \r \r 9 \r Elliin taugaam qanellni, \r umyuani assilria \r aturyaaqekuniu, \r alarciiquq. \r Alarteqapiarciquci, \r elpet umyuan atuquvgu  \r assilria, \r aanavet-llu waten pisqengraaten ilangcivkenaku, \r assiitniluku qanellra. \r Aatavet-llu cali qanellra, \r niiteng\'erpegu assiitniluku umyuarpet, elpet taugaam \r umyuan assirluni, \r alarciiquten ikiulria aturciqan, \r elpet umyuan aturturluku pikuvet. \r \r 10 \r Waten tang ayuqellriit: \r qanellra tamalkuan yuum \r maligtaqungnaqu\'urluku \r yuunarquq avani tan\'gurraulriani \r nasaurluulriani-llu.','Saanigem Alangrua \r \r Tua-ll\' qanemcimek niicugnipiallruunga aanama iluraan qanemcillranek. Aanaka unguvallrani. Iluraa qanemcillruuq alangrullerminek. Kass\'amek aiparluni ayallermegni Mamtrillermun. Tauna kass\'aq pektaulliniluni Mamteramek. Allam tuaken taitellrulliniluku Ekvicuarmun. \r \r Ayalliniuk Ekvicuarmek qimugtetgun. Ekvicuarmiut Mamterillermiut-llu akuliitni kuigtangqertuq linrayamek piaqluku. Tamatum kuigem nuniini nunallertangqelliniuq, ik\'iki-gguq qungurugaat, caniitni-wa-gguq cat aklut ellilallrit tuquaqata. \r \r Taukuk ayalliniuk cukaunatek, tuma assiilan. Ayainanermegni kaingelliniuk. Tuavet nunallernun tekicamek, enemun itliniuk, kiimi-ll\' nangengqaluni. Taukut nunat yuirutellrulliniameng ak\'a. Taugaam yuut nunaksugtaita nunaketullrulliniit uksuarmi. \r \r Tuall\' unuan tauna aipani kass\'aq pillinia tuani qavartaryuglutek, unuakuani tekivsiaryuglutek Mamterillermun. Tua-i aklutek itrutliniluki tuavet enemun. \r \r Maaten pilliniuq saaniigitlinilriik, saskangqeng\'ermek, neqauterlutek-llu. Saaniigtek nalluyagutellrullinikek. Aipani tauna kass\'aq pillinia tua-i neryuglutek, saskamegnek-llu qanikcamek urugciriyuglutek. Taugaam tauna kass\'aq qanIliniuq, saaniignek tangellruniluni pavani qunguni, aqvacugluni. Piyaaqellinia pisqevkenaku. Taugaam kass\'aq tauna kaggagtelliniuq, qang\'a-gguq! Carayagtaituq-gguq! Tuqumaut-gguq! Tainqiggngaitut-gguq! \r \r Tuaten qanerluni anlliniuq tayima. Ak\'anivkenani kiarrluku tangllinia, kangalria qungut nuniitni. Pia-i-llu-gguq tegulluni saaniigmek. Iterluni tua-i utaqallinia. Piqerluni itliniuq saaniigmek itrulluni, qanikcarmek imarluni. Agartellinia, ilavkugmek agaucirluku kenillrem quliinun saanililuni-llu. Saaniik taqngan tauna kass\'aq yuurqalliniuq, ellii taugaam pivkenani taugaam saskamikun qanikcarmek urugcirilliniluni. Kass\'am taum pulengtaarluku piyaaqellinia yuurqallguciisqelluni. Taugaam tua-i pinritliniuq. \r \r Wanikuqertelluku, kass\'aq tauna qavarninglliniuq, qavaqaquluni. Ena tamana kiirian keneq nipluku egalret patullinii. Unuurrluni tuani. Tuani cuucekaamek kenurrangqellinilutek, taum kass\'am pianek. Inartelliniuk cuucekaaq kumatuumaan. \r \r Tauna kass\'aq kalikarnek naaqiluni ellii-llu-gguq cali qavaqsaunani. Uitainanragni-gguq ca piciinaku alqunaq ena man\'a evcugkituq, tuar-gguq angyam iluanllutek angyaq puukalria. Arulallaglutek tamarmek. Kass\'am taum kalikani ellilerluki mak\'arrluni aptelliniuq, "Cauga augna?" Ellii tauna imna qanlleq carayagtaitniluku. \r \r Tua-llu pillinia taum yuum, "Anenaurtukuk. Carayiit pingaitaitkuk." Taugaam tauna kass\'aq qessalliniuq anyuumiinani, carayagmun tangerciqnilutek. Enemi tamaani uitauryuglutek. Ullagarrluku, tegularluku anutessaagyaaqellinia. Alingallagluni. \r \r Aipiriluni migpallartelliniuq maaken akertem pit\'ellran tunglirneranek. Umikuan kiaken enem egkuanek migpallartelliniuq. Tuamta-ll\' nangnermek uaken kangiramek migpallartelliniuq, nutaan tuknilriamek. Ena-llu-gguq man\'a qiivcillagluni. Tua-i-llu-gguq amiigmek, man\'a aurneq akagluni itqili. Enem ilua uivluku avatiikun, tekillukek-llu. Kumlatpiarluni. Tuarr-gguq elliini cikumun agtuutellria. \r \r Kass\'am taum amik kelluteqerluku, alingurtualuni qalrillagaluni ullagaa aipani. Ciunran pillinia, "Anucungramken qessallruuten, alingyaqunak." Tauna kass\'aq pilliniuq, alingengaitniluni amta-llu-gguq alingluni cakneq. Tua-i-gguq piqerluni imna tauna kass\'arpall\'er qalrillagnaurtuq. Taqesqelluku piaqani taq\'aqluni. \r \r Maaten amik tangerrluku pilliniuq yuk ugna igvalria. Kanaqlagnek atkugluni, akuruterluni, aliruterluni-llu terikaniamek. Negilirluni-llu keglunermek, nacarturluni. Nuna un\'a acia uivluni, tuarr-gguq qamaneq. Ullagturlukek-gguq cukaunani. \r \r Taum neq\'aqallinia aanami qanlallra. Uitaurquvet-gguq, carayagmek tangerquvet, ena ullelluku tuquciiqaaten. Tauna kass\'aq pillinia caugarrluni nangertesqelluku. Piluku-llu-gguq kingupiarluku, cukaunaku, ayasqelluku taum carayiim tungiinun. Kass\'am aptellinia, "Tuaten-qaa pituut?" Qanrutlinia, pituniluki. Maligarutuq-gguq tauna kass\'aq qanrucunaiqaarluni, niicugpeknani-llu anucullrani. \r \r Pillinia tangvagtiinun agturarkauniluku carayiim kemga uyaquakun. Agturraarluku-llu ellivikluku unatminek qamiquakun, acitmun-llu cingluku tallim taugaam uqamaltacianek. Tua-i tauna kass\'aq kingupialliniuq carayiim tungiinun. Yuum maligtaa kass\'aq carayak-llu caumalutek. Camek-gguq taum carayiim kegginaa patuluni. Mallgiamegnegu, taum yuum yaggluni, uyaqurrakun kemga agtullinia, natmi pinrilengraaku. Umyuaqurluku qaill\' pillerkani tuatnakuni.  \r \r Unatain-gguq agtullrani kemga tuar-gguq kumlatpiarluku-gguq cakneq. Unatni-gguq tuarr\' uuqitalriit ugaani-gguq kumlatem. Tuatnarraarluni kass\'aq takuvaasqellinia. Unatminek pategluku carayak qamiqurrakun, tallimi uqamaltacianek acitmun negtellinia. Tauna-gguq carayak yaatmun caumaluni elkek caumavkenakek. Negquraani imna tauna carayak acitmurtelliniuq, nunamun iterluni, nuna tamana cikusngangraaku. \r \r Tuall\' umyuarteqliniuq, "Atrallra cukarikanivkarluku negkaniqaqerlaku." Negkaniqaani-gguq carayak tauna mayuqaniqili. Cali ataam tallimi uqamaltacianek negqurallinia. Ayumian tua-i tamarmi catairutliniuq tayima. \r \r Kingunra-gguq taugaam uivluni tuarr-gguq qamaneq. Niitelaucirmitun tull\'uku aluminek manigtellinia. Arulairan-gguq ayuqucia man\'a qinuirtuq. Tuall\' kass\'aq pillinia anucugluku, qanerluni carayagmun pinqiggnaitnilutek. Anngamek ena uivelliniak, kassuamegnegu-llu iterlutek. \r \r Saanik-gguq enem iluani uitaluni kenillrem nuniini. Pillinia tauna kass\'aq utrutesqelluku enellranun. Taugaam kass\'aq tauna alingluni piyuumiitelliniuq. Elliin-llu utrucuumiitellinia, aqvallrunrilamiu. \r \r Utercunga\'artelliniuk Ekvicuarmun, Mamterillermi canimellruan. Uplutek tua-i ayalliniuk. Ayalnguuraqerlutek kass\'am taum talliakun enuurluku enirutellinia kingunermegnun. Kingyarluni tanglliniuq ca man\'a tuar-gguq angqaq, akalria kingunragnegun. Neqallinia-am niitelallni carayagnun saskut alikniluki. Uluani anlluku tumllertek cet\'rallinia. Tamatum-gguq maligcestiignek cet\'rallra tekicamiu arulaiqili tayima-llu tangrruunqigtevkenani. Taum kinguakun tamarmek naulluungelliniuk, miryaralutek. \r \r Nunanun tekicamek unayaqlinia tauna kass\'aq maligtesqelluni qasgim ciqitallrinun. Tua-i-gguq carayagmek tangrraarlutek tauna kass\'aq pisqellriani niiculuni. Tass\'uqlutek agkilik qasgim ciqitainun, tekicamegneki-llu akaguarlutek. Carayagmek-gguq tangellret tuaten akaguanritaqameng ciqitarni, naulluutmek ciunermeggnun tekiutetuut naulluuvkarluki. \r \r Tuall\' akaguarraarlutek tuani ciqitarni tuyum eniinun agglinilutek. Taum tua-i tuyum ciuniurlukek kaminiaq kumarrluku saanilitellinilukek. Taukuk tua-i naulluupiarlutek, miryaralutek. Qanemcitliniluku tauna tuyuq. Wanikuan inartelliniuk. Unuaquan naulluullrak utumartelliniuq. \r \r Assiriamek taugaam ayanqigtelliniuk Mamterillermun, tamana ciuqlirmi tumllertek tumkevkenaku. Qanemcilalliniuk taumek alangrullermegnek. Tamatum kinguani allam yuum tekitellriigni tuavet nunallernun, tauna saaniik tagutellinia tuavet qungunun. \r \r Tua-i iquklituq!','Apanuugpak \r \r Apanuugpiinkuk Tuqelani-llu alingellinilriik.  Anguyiik.  Alinglutek tua\' qayarlutek ava-i.  Anguallrak... niitarci ava-i anguallrak.  Atrartuk.  Yugugaat ketiitni anguyagugaat.  Quyurutqatarlukek waniw\' kassukatarlukek. \r \r Apanuugpak atam tua-i erinvaulliniuq taun\' Apanuugpak.  Cali tua-i anguyagcuutnun anguyaneq elisngaluku.  Tua-i-ll\' taumek partner-angqelliniuq Tuqelaminek-gguq pilaraa. \r \r Tuqelani tua-i tauna malikuralalliniamiu tuan\' quy\u2019uqrutliniaget anguyiit callukatarlukek tuani ellmeggni.  Qayarugaat quyurulluk\' tua-i kassuulluki.  Amllertut qayarugaat.  Arenqiatut amllerugaugut qayarugaat tamakut.  Maa-i tua-i amlleriluteng. \r \r Aipaan pillinia ava-i tua-i qayarugaat quyungqellratni, "Waqaa, Tuqelaa?  Casit? Alinguten-qaa?  Ciin tamaaken taryumek mengnaq\u2019larcit?  Erinan-ggem alikniluku qanlartuten.  Ciin aarpagyunricit?"  Aren tua-i Apanuugpak kiulliniuq, aren, ellii tua-i pillerkangeksaitniluni.  Waniw\' tua-i piyungyaaqniluni tau\u0361gaam. \r \r Tua-i-ll\' Apanuugpak anguaruterpangqelliniami-ll\' angurvagmek tamana atem tegullinikii anguarutlerani.  Apanuugpak ayakartuq ava-i anguarlun\' caqiqerrlun\' aarpagalun\' tuaten.  "Aa-aa-aa!".  Aaraluni tua-i uivqertelliniuq cukangnaqluni. \r \r Erinvaungan-llu tamakut iliin alingluteng caq\u2019iqrallermeggni tayima caq\'iqraluteng ayagartaallermegni kitngualuteng tamarmeng tua-i.  Malirqarallinikai Apanuugpiim anguarluni kitnguvkaraqluki.  Qimagaluteng tua\' aaraqainallrani erinami erinaanek alingluteng ayagaluteng.  Kiituan imkut nanglliut ataucirraq tau\u0361gaam kiimi. \r \r Yuarutii: \r \r Erina, erinaluryaka, erinarpaka. \r Apanuugpak. \r Erina, erinaluryaka. \r \r Alikaat, alikaat yuut tuquqcilartuq. \r Erinaka, erinaluryaka, erinarpaka. \r Erinaka alikaat. \r \r Erinaka cayunaituq. Erinaluryaka, erinaluryaka.','Cetugpak \r \r Atam-gguq taukuk maurlurluqellriik uitaaqellriik. Maurlurluan-gguq inerqurqekii tutgaraurluni cangraan pingraan kuigem akiani canegpagnun pulaqaasqevkenaku. \r \r Unuakut-gguq iliitni tutgarrluk iqvaryaqili kuigem  akianun. Iqvainanermini-gguq paqnayungekili catanggerrucianek canegpiit iluat. Iqvarluni-gguq canegpiit tungiitnun ayagturqili. \r \r Maaten-gguq tekitai makut tumyarat tayima canegnun pulamaluteng. Uitauraqeryaaqerraarluni-gguq umyuartequq pulaqerraarluni egmian uterrnaluni. Tua-i-ll\' tumyarat maligqurluki ayalliniluni. Ayainanrani-gguq can\'get angliriinarluteng. \r \r Tua-i-llu-gguq ciunranek aruvagtangkili, qulmun puyua ayagluni. Ciuneqluku-gguq puyug ayakili. Paqnayullermini-gguq utertellerkani nalluyagulluku ayakili puyum engelii tekilluku. \r \r Tekitaa-gguq maaten enecuar. Tua-i-llu-gguq piqataarturluni kiarqurluni mayulliniluni enecuarmun. Kangrani-gguq egalerkun uyangtuq maaten kan\'a arnassagaq aqumgalria, cetuminek naanguarluni. Cetui-gguq takpiat. \r \r Arnassagaam-gguq taum nepaitqapiarallrungraan qayagpakiliu atrarluku itresqelluku. Atrarluni-gguq tua-i tauna tutgarrluk itliniluni. \r \r Itran-gguq nerevkaqiliu egaamek. Nernginanrani-gguq tauna arnassagaq cetuminek naanguarturqili. Tua-i-llu-gguq tan\'gaurlurraq itqerreskili. Itrami-gguq qenreskili neryugyaaqluni. Pingraan taum arnassagaam qatpautaqluku nerngaitniluku. \r \r Tua-i-ll\' tan\'gaurluq tayima anqerreskili elaturrami neqmek nerqatarniluni. Anqercan-gguq arnassagaam malirqerluku tayima. Tua-i-llu-gguq cakma tan\'gaurluq nepairrluni. Arnassagaq itqili ataam-llu aqumluni. Tauna-gguq tutgarrluk alingengkili. \r \r Tua-i-llu-gguq yuqercuguaqili. Arnassagaam-gguq pia, "Ataki tumamnun qurri." Tutgarrluum kiugaa, "Aa-aa kiika-wa, tumagmun qurrneq nallukeka." Arnassagaam-gguq cali pia, "Ataki piluguma iluanun qurri." Tut\'garrluum kiugaa, "Aa-aa, kiika-wa, pilugumun qurrneq nallukeka." Arnassagaam-ggugq cali pia, "Ataki kenillermun qurri." Tua-i-llu ataam tutgarrluum kiugaa, "Aa-aa, kiika-wa, kenillermun qurrneq nallukeka." Arnassagaq-gguq taqsuqa\'arcami pia enem ciuqerranun yuqercesqelluku, egmian taugaam itresqelluku. \r \r Tutgarrluk-gguq an\'uq maaten elaturrami imna tan\'gaurlurraq tuqumaluni aluuyam iluani. Anngami-gguq naqugutni qilqanirluku qaltani-llu teguqerraarluku aqvaqulliniluni kinguneminun. \r \r Tua-i-llu-gguq aqvaquinanrani kingunranek kitngigtanglliniluni waten, tum, tum, tum. Maaten-gguq kingutmun cauqertuq imna arnassagaq. Arnassagaq-gguq qimugtetun pangalegluni, cetuni-gguq nengqertaqluki tutgarrluk tekicarpiaraqluku. \r \r Tua-i-llu-gguq tutgarrluk kuigem ce\xF1iinun tekiarrluni. Tekituq-gguq kuigem akiani ikna qangqiiq. Tua-i-llu-gguq qanrutliniluku arnassagarmun malirqerniluni. Qanggqiirem-gguq taum it\'gani nenglluki qerarcetliniluku. \r \r Akianun-gguq elliami qangqiiq qanrutaa arnassagaq qerarcecesqelluku, taugaam qanrulluku qukaanun elliqan igcecesqelluku. Arnassagaq-gguq tekicami qayagpagaluni maruaralliniluni qeraucesqelluni. \r \r Qangqiirem-gguq it\'gagni nengllukek qerarcetaa, qukamun-llu ellian irucualleraagni nucugarrlukek, arnassagaq-llu-gguq tayima kill\'uni. Tua-i-llu-gguq avelngaat puguraluteng mermi. Cuna-wa-gguq arnassagaam ungilai. Tutgarrluum-gguq taum kinguakun maurlurluum alerquutai niisngauranglliniluki.','Uugnar Kaviaq-llu \r \r Unuakut iliitni Uugnar tupagtuq tua-i-llu niicugniluku ellam ayuqucia. Maaten anluni piuq unugmi qanillrullinilria. Uugnaraam iigni ulugak qitngirnaqsiiyaagan. \r \r Qanertuq, "Unuamek anglaniciqua." \r \r Tangertuq canegnek qanikcam patuksailkainek. Qanertuq, "Ingkuni canegni aquiqatartua." \r \r Uugnaraam piyuanginanermini tumellni tangrrai qanikcami. Tua-i aqvaquaguq tumlialuni. \r \r Tua-i-llu Uugnar kitumek imumek niilluni qalartellriamek. Erina qanertuq, "Uugnaraaq, Uugnaraaq, ciin tua-i iigken miksiiyaagtak? Ciin iigken ikiussiiyaagtak?" \r \r Uugnarr\' qanertuq, "Kituuga? Kituuga?" Yuut nunarpagmi amllessiyaagata tua-i kituuciinaku. \r \r Tua-i erina qanertuq, "Uugnaraaq, Uugnaraaq, ciin tua-i melqun nanicessiyaagta? Tangniitkacagarluni tua-i. Uugnaraaq, Uugnaraaq, ciin tua-i unaceten miksiiyaagtat? Miksiiyaagameng tua-i camun atuuvkenateng!" \r \r Tua-i-llu piqerluni Uugnaraam tangerrluku kaviaq. Tua-i nallunriraa kitumun erina erinakucianek niitellni. Akinauryugaa kaviaq tau\u0361gaam mallguuryuumiinaku nerlerumaciqngami. Tua-i Uugnar igtemun ag\'uq. \r \r Uugnar aqevnginanermini qayagpagtuq, "Kaviaq, Kaviaq, ciin tua-i melqun taksiiyaagta mamtuluni-llu? Ciin tua-i pamyun angssiiyaagta? Ciin tua-i iigken angssiiyaagtak, kanarrlutek ikiulutek\u2014llu?" \r \r Tua-i kaviaq qennguq Uugnaraam cangakuullrani. Atam, ak\'a tamaani kaviat tamarmeng qatellriarullruut. Tau\u0361gaam una qatellria kaviaq kaviriuq qenngellermini. \r \r Kaviam malirqeraa Uugnarr\' pitaqsukapiarluku. Tau\u0361gaam kiingan Uugnaraam pamyua pitaqaa. Tuaken ayagluteng uugnaraat pamyuit nanitelartut. \r \r Tua-i kaviaq qenngengiinartuq Uugnar unuakutaqenrilamiu. Qenngumallerminek assirillrunrituq, tuaken-llu ayagluteng kaviat kavirliurrluteng.','Yup\'igtaat Ellangvikelput \r \r Akaarr\' ciuliaput ukvertarluteng yuutuullruut.  Nallunrilameng cat tamarmeng nunam qaingani ellami-llu elpengqellrit nunuliutengqellrit-llu. \r \r Qanruyun yuuyaramek maligtaqullerkaq takarnaqeqapiarallruuq nunani-llu tamaitni qanruyun taringumaluni cimiyunani. \r \r Ayuqucirtuutet elitnaurutkaqluki yuum elluarrluni yuullerkaanun.  Alerquutet-llu yuuluaqangnaqlerkamun arcaqakluki. \r \r Piarkaqenrilkengat-llu inerquutnguaqluteng.  Elucirtuutet yuum yuullran taktaciatun elitnaurutkumaaqluteng. \r \r Cat tamarmeng nunam qaingani ellami-llu murilketalriim elluarrluki aulukluki pikuniki maligtaquciiqelliniuq qanruyutmek narurtaarpeknaki.  Tuaten qinuitnaq ayuqluni nunuliutengqerrluni.','Yuuyaraq \r \r Wangkuta Yup\'igni qanruyuutet aturluki anglituukut. \r \r Ilakuyulluta, ukvertarluta, pingnatuuluta. \r \r Nallunrilamta yuuyaramteni piciryarangqerramta nutemllarmek.  \r \r Qigcikiyaram aturtai taringumaut ellam iluanelnguut elpengqellrit nunuliutengqellrit-llu. \r \r Qanruyutem aturtai umyuartuluteng, elluatuuluteng, nuuqitevkenateng yuuluaqerciqut.','Nunam Qigciksaraa \r \r Uyaquq, Akiacuaq. Tua-i-ll\' cali nunam qigcikiyaranek. Qanrumauq waten cali yuilqumi talluqiyaraq, pissurviim yua, pissurviit tamakut tamana qigcikluki uqlaasqevkenaki-llu makunek enerkuanek, enernek-llu. Atmagtengulallruama enernek nanvamun-llu eggluki. Nunam qigcikellra tamana tua-i tuaten ayuquq. Qigcikluku talluqluku. Nunat-llu uksuarmi pissurviit alla cali pissurvia cali qigcikluku taamani pissuraqluteng imarmiutarnek. Allanek-llu cali pissuqcaarluteng. Tamaa-i tamana. \r \r Tua-ll\' iliita-am angukaraurluq tauna qanertuq, tamakut enret sagteksaunaki pisqelluki yuilqumi, nunam-llu taqellra qigcignaqniluku. Kitaki iliita-am tauna-am qanertuq makcuirucami-llu, kingunertaa waten, nuna qigcikarkauniluku. Agayutem-gguq nuna pikaa tamatumelnguut-llu yuut nayuqiit nuna pikaat. Cunaw\' maavet anerteqellria nuna pissurviit-llu yuum-llu nayuqii kia-llu imum\' pissurvini qigcikluku tamakut cunaw\' piklinikiit.','Wiinga waniwa Paul John-augua kass\'atun Yugtun-llu Kangrilnguulua. Tua-i wiinga waniwa school-aqallemnek caitqapik ukanirpak neqanaitua. Tau\u0361gaam tamaani school-aqsailengramta-wa wangkuta mat\'um nutemllamta piciryaraakun eglertellruukut. \r \r Uum Agayutem ayuqenrilngurni ellam iluani camani-llu acimteni piciryararkillruyaaqelliniakut yuliaqellerminikut wangkuta nutemllaqluku tua-i ukanirpak ellam piunrirvianun piciryararkamtenek. Tua-i-llu cali elliin agayutem tua-i piciryararkaput wangkutnun nutemllaqluki pikarkauvkarluki piamiki ilamineg\' anerneminek anernirluta. Tamayunaitqapiaryaaqelliniarput. \r \r Man\'a nutem qaneryararput yuucimta piniqngaku. Tua-i maa-i watua avanirpak nutemllarput man\'a tamarivkenaku piurallrukumta kass\'am-llu makunek umyuarrlugutekiuteksaguskemtenek, wa-gguq law-nek, nunakenrilkiit-llu ataniuryanritliniakut. Wangkutnek ataniurluta piyalliniukut. Tau\u0361gaam tua-i man\'a iliini alarun igvalami kayuluni. Maa-i qatellriamta, wa-gguq law-tgun, apeqmikun law-tgun kayungqerrluni. Wangkuta yuucirleu\u0361rput imutun tua-i kayuilriatun tamalriatun ayuqlirivkaqii. \r \r Elpeci makunun qinguqlirpecenun elpeci iqugtangumayaaqerci waten pitalriani angayuqavcenek ciulirnerpecenek-llu niiteqaqustek\'lallrini iqugtangumayaaqerci. Makut tau\u0361gaam maa-i ayagmek kass\'artaryarakun irniamta ilai tutgaraput-llu ellangameng tua-i nanluciilngurtun watua ellirtut. Yupiucirteng niitelangermegteggu kass\'artaryarakun cal\' school-akun maaggun piameng nanluciilngurtun ayuqeu\u0361rlurluteng. Naliagnegun-kiq ayaqakatarcia. \r \r Tau\u0361gaam tuaten ellingraata wangkuta apa\'urlurni elpecil\' aanani atani-llu taringengluki maa-i pillerpeciuggun uterrvikluku yuucirput elpeci eglerucugngaaci. Pisciigatenritut una aturluk\' nutemllaq. Agayutem yuucirkiutellra wangkutnun anerneminek anernirluta tua-i pikamtenek yaavet iqungellemta engeliinun. Iqungelangramta-llu wangkuta ciulirnerpeceni elpeci nutemllar\' man\'a egmiulluku paiciutekngamteggu ciuliamtenek ayaucugngaluku elpeci aanaulriani aataulriani-llu.','Up\'nerkillerni \r \r Up\'nerkillerni tua-i pissurluteng.  Tua-i cali pitait arnat caliaqluki.  Tua-i-ll\' ukut cali uqut amiatnek aug\'aumakteng cali murilkelluki.  Egngarteqataata nutaan pinevvluki.  Ciuqliit au\u0361gkut pitaqerraallret nalluvkenaki cali.  Egnaciatuut nutarat makut kinguqliit.  Tuaten tua-i pinevvluki caqutnun ekurluki. \r \r Tangviarrlugnek atengqerrarkat allakaita qemaggluki.  Nayilinraat allakaita issurilinraat-llu.  Useqninraat nayirnun nayiit uquitnun auvukluki.  Maklaginraat-ll\' allakaita cali.  Maklinraat kavircet\'lartut uqut uquit kavircelameng.  Makut tau\u0361gaam maklagaat ecuillruluteng.  Nayilinraat, issurilinraat aspiat tua-i nutaan.  Uqukegcipiartut nayiit, issurit-llu uquit, maklagaat-llu.  Tamakut tau\u0361gaam makliit kavircecugluteng uquit.  Asvinraat tau\u0361gaam piiyuitait.  Ceciinraat-llu cali piiyuunaki.  Ilaita tua-i pituyaaqait uullauluki tau\u0361gaam pituit ceciinraat. Kenirluki uquit uullauluki-gguq.  Asveret tau\u0361gken uquit piiyuunaki tua-i. \r \r Tamakut up\'nerkami-ll\' makliit uquit kenirluki-am pitullruit pinuvnirluku.  Uullanek aterpagtaqluki.  Kenirluki caqutnun ek\'aqluki.  Egyuitut keniumalriit.  Tuaten amlleret pitullruit makliit uquit kenirluki uulliluki.','Neqlilleq \r \r Tua-i caarkairutaqameng nutaan neqliyarluteng.  Nunameggnek up\'nerkiyallret tamakut angyateng aqvauqurluki cali caarkairtaqameng.  Nutaan tua-i neqliyatuut tuaten piaqameng, caarkairutaqameng. \r \r Kiagpak-llu tua-i neqlillerni uitaluteng.  Tua-i-ll\' neqet makut qemagcamegteki uterqaqengluteng, qakiiyiarkat tau\u0361gaam unkarluteng qakiiyarnek piarkat. \r \r Neqtateng tau\u0361gaam qaniigaqluki uksillernun ut\'rulluki kinrumarilriit caqumarilriit.  Qakiiyiluteng tau\u0361gken tua-i qemagcamegteki-ll\' tua-i qemagqaarluki nutaan uterrluteng.  Uksillmeggnun tau\u0361gken piarkat engellicuunateng.','Uksuilleq \r \r Cali-am neqsurluteng tuani ceturrnanek Ilkivigmi.  Arnat tau\u0361gaam nallmegteggun neqsurluteng imkunek qalurpagnek uksuarmi aturluteng.  Tua-i ceturrnanek kinernernek amllernek ungangluteng.  Tua-i tuatnaaqameng nutaan uqumelnguucituut.  Nutaan-llu tua-i cikuviqungarcan uksuillemtenun tuavet asgurluta.  Catairulluku tua-i tauna. \r \r Tua-i uksuarpak tuani uksuillerni uitaluta.  Can\'giirnek tua-i neqsurluteng cali melqulegnek tuaten.  Uksuillerni kanaqlagnek imarmiutanek-llu atkugkanek naarqiluteng. Cuignilngurtaqluteng.  Paluqtaat piyuitellruut avani un\'gaani nunamteni. \r \r Cali uksuillerni ellivililuteng.  Nutaan can\'giirnek amllernek imirluk\' kumlaskainek muirluki kaceteqatarqameng uksillmegnun upakatarqameng.  Tua-i tau\u0361gken aqvauqurluki can\'giirutailnguut cikiraqluki avegvilegnek.  Nangkata umegluku nutaan unilluku. \r \r Imarmiutarnek tua-i atkungqetuut uksuillernek.  Utertaqameng arnat caliaqaqamegteki atkukellruit imarmiutaat cuignilnguut-llu nutaranek.','Uksillernun Uterrluteng Pilallrat \r \r Uksillernun utertaqameng tamarmirtaqameng nunameggni nanelngurtairutaqan kalukaqutullruut.  Tua-i nanelnguirucameng nutaan tamana aturluku.  Imkut unangkengateng up\'nerkamek ayagluku ilangarqurluki uksullran tuavet engeliinun.  Tamalkurmeng tua-i neqnek qasgimun nerevkariluteng.  Piciryaraqluku tuaten pinricuunateng. \r \r Nuna imarpik-llu aviukaqsaraq atunricuunaku.  Tua-i-ll\' nutaan au\u0361g\'um tuatnallermeng kinguani yuraryaraq nutaan yagulluku nerevkarillermeng kinguani ayagnirluku.  Quyurrluteng-am cali qasgimi anguterrlainaat.  Tua-i picirkaq-llu taqngan yuugnek malrugnek nunanun nutaan ayagceciluteng.  Tua-i-ll\' taukut kelegtemeng nuniitnun tailuteng. \r \r Tua-i-llu cali tamana ut\'raruciyaraq aturyukunegteggu taukut kelkengaita piiyuutekluku cali kelegtemeggnun.  Nunameggni yurarraarluteng ellait nuniitni nunameggnun agluki cali yuraasqelluki.  Ut\'raruciyaraq-gguq tamaa-i.  Amkut piiyuutektuluku caaqameng ukunun kelegtemeggnun.  Tua-i tuatnatuluteng iliini.  Atunrilatgu tau\u0361gken nunameggni tamarkenka yuraryaraq aturluku.  Allanret yurarluteng nunalget-llu yurarluteng cali.'];var video=['','','YaqulegmekUklilleqNalugaralriallu.mp4','','','ArulacitKangiitYuram.mp4','','','','','','10H2U1L3JohnPhillipsuicideprevention.mp4','','','','','','','','','','','','','YupikWorldview.mp4','','NunamQigciksaraa.mp4','PaulJohnNutemllaput.mp4','','','Uksuilleq.mp4','UksillernunUterrlutengPilallrat.mp4'];var audio=['','','YaqulegmekUklilleqNalugaralriallu.mp3','','','ArulacitKangiitYuram.mp3','','','','','','10H2U1L3JohnPhillipsuicideprevention.mp3','','','','','','','','','SaanigemAlangruacopy.mp3','03JoeJimPaulStoryofApanogpak.mp3','Cetugpak.mp3','Uugnarkaviaqllu.mp3','YupikWorldview.mp3','Yuuyaraq.mp3','NunamQigciksaraa.mp3','PaulJohnNutemllaput.mp3','Upnerkillerni.mp3','Neqlilleq.mp3','Uksuilleq.mp3','UksillernunUterrlutengPilallrat.mp3'];var citation=['Erinaput Unguvaniartut, pg. 15; pg. 107','Andrew, Frank - Caqutet/Uquucillret, From Paitarkiutenka: My Legacy to You, pg. 150','YouTube. Yaqulegmek Uklilleq Nalugalria-llu. Suulillra Piiyuuk Qungurkaq-Shields-aam','Paitarkiutenka pg. 82-84','Ik\'atiim, Julia K Paul, qalarucillra elitnauranun. Apyutaitnek-llu nalqigulluki yuraryaramek. (pg. 159-161)','Theresa John, Arulacit Kangiit, Video 3, Yuuyaraq Personal Life Skills','By Clara Agartak and Billy Lincoln (Translated from Boundaries & Passages: Rule and Ritual in Yup\'ik Eskimo Oral Tradition by A. Fienup-Riordan)','Uqiqulleq from Cali Allat Naaqerkat, by LKSD Curriculum, pg. 40)','Tarr\'aq. Kuinerraq. Health I, Unit 1, Lesson 3, pg. 29','Yuuyaraq Health 2, Unit 1, Lesson 1, pg. 127 (41) Paul John, April 2001:56-58','H.S. Yuuyaraq Health II Readings (Unit 1), pg. 121 (45) Frank Andrew, October 2001: 163','Ayagina\u2019ar - John Phillip, Prevention Video, Yuuyaraq Health 2, Unit 1 video','John Phillip and Paul John, Ciulirnerunak Yuuyaqunak pg. 162-167 adapted from Aarnarqellriit Uksuarmi Uksumi-llu','Erinaput Unguvaniartut pg. 183','Agevkarluni qanikcamun (Paul John, Taken from Ciulirnerunak Yuuyaqunak pg. 173-175)','Imarpigmi augna pilleq, Ayagina\u2019ar (Story of Yuralqiq by John Phillip, Taken from Yuuyaraq pg. 317-321)','Qanruyuteput Iinruugut, pg. 6','Paul and Martina John, Simeon Agnus, and Alice Rearden, June 11, 2000 (pg. 218) Adapted from Tuqluucaraq','Yuuyaraq Health I & II Readings pg. 67','Qanemcitkarluni Tekitnarqerlartuq, pg. 336-340','Minnie Carter-aam qanemcia Ekvicuarmium','Apanuugpak (Song and story by Joe Paul)','Cetugpak, LKSD Book, Told by Arnaq Marie Meade, Illustrated by Andrew Chikoyak','Uugnar Kaviaq-llu, LKSD Book','A Yupiaq Worldview by Dr. Oscar Kawagley','C/Yuuyaraq Pledge','Respecting the Land pg. 448 Qanruyuuteput Iinruugut (Joe Lomack)','Nutemllaput (Our very own) Video by Paul John','At Spring Camps. Paitarkiutenka by Miisaq Frank Andrew, Sr. pg. 9','Summer Fish Camp. Paitarkiutenka by Miisaq Frank Andrew, Sr. pg. 11','Fall Camp. Paitarkiutenka by Miisaq Frank Andrew, Sr. pg. 13','Return to the Winter Village. Paitarkiutenka by Miisaq Frank Andrew, Sr. pg. 15'];return[stories[counter],video[counter],audio[counter],citation[counter]];}// '10H2U1L3JohnPhillipsuicideprevention.mp3',
// 'ArulacitKangiitYuram.mp3',
// 'UksillernunUterrlutengPilallrat.mp3',
// 'Uksuilleq.mp3',
// 'YaqulegmekUklilleqNalugaralriallu.mp3',
// 'YupikWorldview.mp3',
// 'Upnerkillerni.mp3',
// '03JoeJimPaulStoryofApanogpak.mp3',
// 'Cetugpak.mp3',
// 'Neqlilleq.mp3',
// 'SaanigemAlangruacopy.mp3',
// 'Uugnarkaviaqllu.mp3',
// 'Yuuyaraq.mp3',
// '10H2U1L3JohnPhillipsuicideprevention.mp4',
// 'ArulacitKangiitYuram.mp4',
// 'UksillernunUterrlutengPilallrat.mp4',
// 'Uksuilleq.mp4',
// 'YaqulegmekUklilleqNalugaralriallu.mp4',
// 'YupikWorldview.mp4',
// '',
// '',
// '',
// '',
// '',
// '',
// '',

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var About=function(_Component){_inherits(About,_Component);function About(props){_classCallCheck(this,About);var _this=_possibleConstructorReturn(this,(About.__proto__||Object.getPrototypeOf(About)).call(this,props));_this.state={show:false};return _this;}_createClass(About,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["e" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{justifyContent:'space-between',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Header */],{as:'h1'},'Ikayungcaraq / Support')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:36}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' Apyutkangqerquvci e-mail-aryugngaavkut uuggun, yuarcuun@gmail.com. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' If you have any questions about LKSD apps or would like to share your experiences please send us an e-mail to yuarcuun@gmail.coms. If you have any technical issues with the app, please report them to us using the following Google Form ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:'https://forms.gle/pDJzVEE1eoefN9JR6'},'link'),'. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' LKSD apps are free and available for download on Android devices through the Google Play store, or on iOS (iPhone or iPad) devices through the Apple Store. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' Currently our LKSD apps include a library of children\'s books and language arts curriculum intended for students at the 2nd, 3rd and 4th grade level. '));}}]);return About;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var About=function(_Component){_inherits(About,_Component);function About(props){_classCallCheck(this,About);var _this=_possibleConstructorReturn(this,(About.__proto__||Object.getPrototypeOf(About)).call(this,props));_this.state={show:false};return _this;}_createClass(About,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["e" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{justifyContent:'space-between',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Header */],{as:'h1'},'Privacy Policy')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:36}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'PRIVACY NOTICE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Last updated June 06, 2021'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Thank you for choosing to be part of our community at Lower Kuskokwim School District ("Company", "we", "us", "our"). We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about this privacy notice, or our practices with regards to your personal information, please contact us at yuarcuun@gmail.com. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Yuarcuun '),'is the developer for LKSD.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When you use our mobile application, as the case may be ("Naaqerkat" and "Yugtun LKSD") and more generally, use any of our services ("Naaqerkat" and "Yugtun LKSD"), we appreciate that you are trusting us with your personal information. We take your privacy very seriously. In this privacy notice, we seek to explain to you in the clearest way possible what information we collect, how we use it and what rights you have in relation to it. We hope you take some time to read through it carefully, as it is important. If there are any terms in this privacy notice that you do not agree with, please discontinue use of our Services immediately.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This privacy notice applies to all information collected through our Services (which, as described above, includes "Naaqerkat" and "Yugtun LKSD"), as well as, any related services, sales, marketing or events.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Please read this privacy notice carefully as it will help you understand what we do with the information that we collect.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1. WHAT INFORMATION DO WE COLLECT?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'2. WILL YOUR INFORMATION BE SHARED WITH ANYONE?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'In Short:  We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We may process or share your data that we hold based on the following legal basis: Consent: We may process your data if you have given us specific consent to use your personal information for a specific purpose. Legitimate Interests: We may process your data when it is reasonably necessary to achieve our legitimate business interests. Performance of a Contract: Where we have entered into a contract with you, we may process your personal information to fulfill the terms of our contract. Legal Obligations: We may disclose your information where we are legally required to do so in order to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements). Vital Interests: We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved. More specifically, we may need to process your data or share your personal information in the following situations: Business Transfers. We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'3. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?     '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'In Short:  We may transfer, store, and process your information in countries other than your own.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Our servers are located in. If you are accessing "Naaqerkat" or "Yugtun LKSD" from outside, please be aware that your information may be transferred to, stored, and processed by us in our facilities and by those third parties with whom we may share your personal information (see "WILL YOUR INFORMATION BE SHARED WITH ANYONE?" above), in and other countries.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you are a resident in the European Economic Area (EEA) or United Kingdom (UK), then these countries may not necessarily have data protection laws or other similar laws as comprehensive as those in your country. We will however take all necessary measures to protect your personal information in accordance with this privacy notice and applicable law.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'4. HOW LONG DO WE KEEP YOUR INFORMATION?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'In Short:  We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless otherwise required by law.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting or other legal requirements). No purpose in this notice will require us keeping your personal information for longer than 2 years.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'5. HOW DO WE KEEP YOUR INFORMATION SAFE?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'In Short:  We aim to protect your personal information through a system of organizational and technical security measures.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorized third parties will not be able to defeat our security, and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our App is at your own risk. You should only access the App within a secure environment.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'6. WHAT ARE YOUR PRIVACY RIGHTS?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'In Short:  You may review, change, or terminate your account at any time.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you are a resident in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection supervisory authority. You can find their contact details here: http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you are a resident in Switzerland, the contact details for the data protection authorities are available here: https://www.edoeb.admin.ch/edoeb/en/home.html.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'7. CONTROLS FOR DO-NOT-TRACK FEATURES'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ("DNT") feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage no uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'8. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'In Short:  Yes, if you are a resident of California, you are granted specific rights regarding access to your personal information.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'California Civil Code Section 1798.83, also known as the "Shine The Light" law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you are under 18 years of age, reside in California, and have a registered account with "Naaqerkat" or "Yugtun LKSD", you have the right to request removal of unwanted data that you publicly post on the App. To request removal of such data, please contact us using the contact information provided below, and include the email address associated with your account and a statement that you reside in California. We will make sure the data is not publicly displayed on the App, but please be aware that the data may not be completely or comprehensively removed from all our systems (e.g. backups, etc.).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'9. DO WE MAKE UPDATES TO THIS NOTICE?     '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'In Short:  Yes, we will update this notice as necessary to stay compliant with relevant laws.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'We may update this privacy notice from time to time. The updated version will be indicated by an updated "Revised" date and the updated version will be effective as soon as it is accessible. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'10. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?     '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you have questions or comments about this notice, you may email us at yuarcuun@gmail.com or by post to:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Lower Kuskokwim School District'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'1004 Ron Edwards Memorial Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Bethel, AK 99559'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'United States'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This privacy policy was created using Termly\u2019s Privacy Policy Generator.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:'30px'}}));}}]);return About;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (About);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Symbols=function(_Component){_inherits(Symbols,_Component);function Symbols(props){_classCallCheck(this,Symbols);var _this=_possibleConstructorReturn(this,(Symbols.__proto__||Object.getPrototypeOf(Symbols)).call(this,props));_this.handleClick=function(e,titleProps){var index=titleProps.index;var activeIndex=_this.state.activeIndex;var newIndex=activeIndex===index?-1:index;_this.setState({activeIndex:newIndex});};_this.state={show:false,activeIndex:-1};return _this;}_createClass(Symbols,[{key:'render',value:function render(){var activeIndex=this.state.activeIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["e" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{justifyContent:'space-between',display:'flex'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{primary:true,icon:true,circular:true,onClick:this.props.history.goBack},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'chevron left'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["m" /* Header */],{as:'h1'},'Translation and Symbols')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:36}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Mumigtellra? Its translation?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Yugtun word order is often the reverse of English word order. Try reading the base English definitions in reverse to get a likely translation.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Caugat symbol-aat? What are these symbols?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'They are mathematical rules that outline how to attach postbases and endings. You can find more information about them in "A Practical Grammar of the Central Alaskan Yup\'ik Eskimo Language" by Steven A. Jacobson.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The suffixation symbols are as follows:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===0,index:0,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'+ (plus)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'+ indicates that the suffix keeps final consonants of bases (and if the base does not end in a consonant, the postbase merely affixes to the base without changing it).')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===1,index:1,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'\u2013 (minus)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2013 indicates that the suffix drops final consonants from bases.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===2,index:2,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'~ (tilde)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'~ indicates that the suffix drops final e from bases.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===3,index:3,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'% (percent)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'% indicates that the suffix keeps \u201Cstrong\u201D final consonants (every g, and any r that is preceded by e or that ends a base of the form CVVr- or that is marked with an asterisk), drops \u201Cweak\u201D final consonants. 730 Postbases')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===4,index:4,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),': (colon)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,': indicates that the suffix drops voiced velar continuants (fricatives and nasals, g, r, or ng) if they occur between single vowels of which at least the first is full.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===5,index:5,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'\u2019 (apostrophe)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'\u2019 indicates that the suffix causes gemination of the final consonant of a base of the form (C)VCe-.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===6,index:6,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'. (period)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'. indicates that the suffix is affixed with no change to either base or suffix at the juncture.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===7,index:7,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'@ (at-sign)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===7},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'@ indicates that with te ending bases, after the final e has been dropped (all @ type postbases are also ~ type), the suffix affects the t of the base in some way, depending on whether the te is preceded by a consonant or vowel, and if preceded by a vowel, whether the te is \u201Cspecial\u201D,1 and also on how the postbase itself begins. (See General Introduction concerning \u201Cspecial\u201D te.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If a @ type suffix begins with n, then base final t drops only when preceded by a fricative, which is then devoiced (as is the n, automatically), or by a nasal or stop and then the n is devoiced. Thus, affixing the postbase @~+ni- \u2018to say that one is V-ing\u2019 to kipute- \u2018to purchase\u2019, ce\xF7irte- \u2018to visit\u2019, nangte- \u2018to torment\u2019, and apte- \u2018to ask\u2019 yields kiputnia \u2018he says that she is purchasing\u2019, ce\xF7irrnia \u2018he says that she is visiting\u2019, nangn \u0301gnia \u2018he says that she is being tormented\u2019, and apnia \u2018he says that she asked\u2019. (Alternatively the last bases can be treated as being nangete- and apete-, yieldng nangetnia and apetnia, and similarly for others like them.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If a @ type postbase begins with ng, m, or v, then base final t preceded vowel and is the t of a nonspecial te changes to s (y in HBC and EG), but if it is of a \u201Cspecial\u201D te, it changes to l. If preceded by a fricative, the t is dropped and the fricative is devoiced (as is the ng, m, or v), if by a nasal or stop the t is dropped and the ng, m, or v devoiced. Thus affixing the postbase @~+ngaite- \u2018 to not be going to V\u2019 to kipute- \u2018to purchase\u2019, maan(e)te- \u2018to be here\u2019 (special te), ce\xF7irte- \u2018to visit\u2019, and nangte- \u2018to torment\u2019, gives kipusngaituq (kipuyngaituq for HBC and EG) \u2018he won\u2019t purchase\u2019, maanelngaituq \u2018he won\u2019t be here\u2019, ce\xF7irrngaituq \u2018he won\u2019t visit\u2019, nangn \u0301gaitaa \u2018he won\u2019t torment him\u2019, and apngaituq \u2018he won\u2019t ask\u2019. (Alternatively the last bases can be treated as being nangete- and apete-, yielding nangesngaitaa and apesngaitaa, and similarly for other like them.)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If a @ type postbase begins with y, then a resulting ty (hence ts) becomes c. Affixing the postbase @~+yug- \u2018to want to V\u2019 to kipute- \u2018to buy\u2019 gives *kiputyugaa (hence *kiputsugaa) hence kipucugaa \u2018he wants to buy it\u2019.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If a @ type postbase begins with (u) and if base final t is preceded by a vowel of a nonspecial te, then that t changes to y (to s if geminated on \u201Cshort\u201D base except in HBC and EG), but if is of a \u201Cspecial\u201D te, to l. If preceded by a fricative, the t is dropped and the fricative remains voiced. If the t is preceded by a nasal or stop, it is treated as though it had e preceding it. Thus, affixing the postbase @~:(u)ciq \u2018whether/how one is V\u2019 to kipute- \u2018to purchase\u2019, kit\u2019e- \u2018to sink\u2019, maan(e)te- \u2018to be here\u2019, ce\xF7irte- \u2018to visit\u2019, nangte- \u2018to abuse\u2019, and apte- \u2018to ask\u2019 gives kipuyucianek \u2018whether he is purchasing\u2019, kis\u2019ucianek (kiy\u2019ucianeng for HBC), maanelucianek, or more commonly, maanlucianek \u2018whether he is here\u2019, ce\xF7irucianek \u2018whether he is visiting\u2019, nangyucianek \u2018whether he is being tormented\u2019, and apyucianek \u2018whether he is asking\u2019.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If a @ type postbase begins with y, then any base final t combines with the y to yield c. Thus, affixing the postbase @~+yug- \u2018to want to V\u2019, to kipute-, kit\u2019e-, maan(e)te-, ce\xF7irte-, nangte-, and apte-, yields kipucugtuq \u2018he want to purchase\u2019, kic\u2019ugtuq, maancugtuq, ce\xF7ircugtuq, nangcugtuq, and apcugtuq.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Some patterns with @ apply only to endings (derivational suffixes).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If a @ type ending begins with l, then any base-final t combines with l to yield ll. Thus, affixing the ending @~+luk \u2018let\u2019s2 V\u2019 to the above set of sample bases yields kipulluk \u2018let\u2019s2 purchase\u2019; kill\u2019uk; maanlluk; *ce\xF7irlluk, which, in accordance with the orthographical rules, is respelled ce\xF7irrluk; nanglluk; and *aplluk, which is respelled apluk.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If a @ type ending begins with g, k, or ng, then any base-final t except one that is \u201Cspecial\u201D changes to s (to y in HBC and EG), inserting e before the s to prevent a three-consonant cluster if necessary. Thus, affixing the ending @~+ki \u2018(you1) V them\u2019 to kipute-, ce\xF7irte-, nangte-, and apte- yields kipuski \u2018buy them\u2019, ce\xF7ireski \u2018visit them\u2019, nangeski \u2018torment them\u2019, and apeski \u2018ask them\u2019. When affixing such endings where there is a base-final \u201Cspecial\u201D t, that t changes to l. Thus, with nerenrite- \u2018to not eat\u2019, where te is special being from a negative postbase, the result is nerenrilki \u2018don\u2019t eat them\u2019.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Postbases and endings marked with @ that affect t in ways other than those listed above are described at the entry for each such postbase.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===8,index:8,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'\u2013\u2013 (double minus)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'A long dash, \u2013\u2013, indicates that the base drops both the final consonant and the vowel preceding it. This applies only to shortened forms of consonant-dropping postbases beginning with li. For example, \u2013i- \u2018to make\u2019 and angyaq \u2018boat\u2019 yields angyi- \u2018to make a boat\u2019.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===9,index:9,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'? (question mark)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'An initial question mark, ?, indicates that the postbase affixes in an irregular way. This applies only to certain nonproductive postbases.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===10,index:10,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'q\u0332, k\u0332, r\u0332, g\u0332, r\u0332r\u0332, or g\u0332g\u0332 (velar underlined)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===10},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Some suffixes have initial q, k, r, g, rr, or gg. With these and with a base ending in the opposite type of velar (i.e., back as opposed to front, and conversely) the opposite type of velar to that underlined is used. Thus, given the postbase -qatar- \u2018to be about to V\u2019, when added to bases ending in a vowel or r, this postbase takes the form -qatar-, but when added to bases ending in g, it takes the form -katar-. Thus, from cali- \u2018to work\u2019, qavar- \u2018to sleep\u2019, and ayag- \u2018to go\u2019 arise caliqatartuq \u2018he is about to work\u2019, qavaqatartuq \u2018he is about to sleep\u2019, but ayakatartuq \u2018he is about to go\u2019. In the rare case in which a suffix has such an initial letter but does not change in this way, this fact is noted in words. Another process that applies in almost all cases where certain conditions hold and therefore is not specifically noted as such (but is noted in words when it does not happen) is the dropping of a \u201Csemi- final\u201D e (e followed by base-final g or r) by a suffix that begins with a vowel in the form which it is used on the base with the semi-final e. For example, when the ending %:(ng)it \u2018their Ns\u2019 is used with consonant- ending bases, it takes the form it. When used with bases of words such as yaqulek \u2018bird\u2019 and egaleq \u2018window\u2019, which have semi-final e, that e is dropped, yielding yaqulgit \u2018their birds\u2019 and egalrit \u2018their windows\u2019.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===11,index:11,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'(g), (ng), (r), (s), (t), or (u) (parentheses)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===11},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The letters in parentheses at the beginnings of postbases are generally used as follows:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(g) is used with bases ending in two vowels. (i) is used with bases ending in te.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(ng) is used with bases ending in a vowel.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(r) is used with bases ending in te, and by some speakers in e not preceded by t.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(s) is used with bases ending in a vowel.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(t) is used with bases ending in a consonant.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(u) is used with bases ending in a consonant or e.\xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The use of letters in parentheses in ways not conforming to these patterns is described under the relevant postbase entries.'),'  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===12,index:12,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'* (asterisk)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'* is used after q on a noun to indicate that the base for that noun ends in an (unpredictably) strong r, that is, in an r that is retained before so-called half-retaining endings (marked with %).18 Thus, the word maurluq* \u2018grandmother\u2019 has an asterisk indicating that when the half-retaining ending %mi is added to it, the result is maurlurmi \u2018at grandmother\u2019s\u2019. On the other hand, angyaq has no asterisk because the final r of its base is weak, so that when %mi is added, the result is angyami \u2018in the boat\u2019 with the r of the base dropped. Nouns ending in eq or k have no asterisks because all such nouns have a (predictably) strong final consonant on the base. Thus, even though qaneq \u2018mouth\u2019 and kanaqlak \u2018muskrat\u2019 do not have asterisks, one knows that the results of adding %mi are qanermi \u2018in the mouth\u2019 and kanaqlagmi \u2018on the muskrat\u2019. It should be understood that most of the words marked with asterisks are treated by some speakers as if they ended in weak rather than strong consonants. There is a great deal of individual variation in such words, but if a significant number of speakers treat the final consonant of a word as strong, we have marked it with an asterisk. ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===13,index:13,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'(aq*) and (ar) (ar-dropping)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===13},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'(aq*) or (ar)- indicates that this segment of the word or base is deleted if it occurs at the end of the word, or before a consonant-retaining suffix that starts with a consonant.19 Thus, the cited form qimugkauyar(aq*) \u2018puppy\u2019 will be realized in most dialect areas as qimugkauyar \u2018a puppy\u2019 with the final aq dropped and r not changed to q, and the underlying ar (equal to aq) dropped in such forms as qimugkauyartangqertuq \u2018there are puppies\u2019, from underlying qimugkauyarartangqertuq. However, the a of that aq will appear in such forms as qimugkauyaranguq \u2018he got a puppy\u2019, where the suffix added is not a consonant-retaining suffix that starts with a consonant.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===14,index:14,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'[e] (weak initial e)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===14},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Weak initial e: Some bases have an initial e that drops in some or all forms of the word. This is what Practical Grammar of ... Yup\u2019ik calls \u2018weak initial e\u2019.48 A weak initial e should not be written in a form in which it is not heard lest a misrepresentation of the pronunciation of the word be given. For example, the word for \u2018house\u2019 has a weak initial e, which is dropped in such forms as nerpak, i.e., [nerpak] \u2018big house\u2019, and nen\u2019i, i.e., [nen:i] \u2018his own house\u2019, which contrast with enerpak, i.e., [enerpak] \u2018big bone\u2019, and eneni, i.e., [enen:i] \u2018his own bone\u2019, from a base where the initial e is not weak.49 We know that the base for \u2018house\u2019 does have an initial e, albeit a weak initial e, because this e is preserved in forms of the word where the following consonant is in turn followed by a prime vowel, such as ena, i.e., [ena] \u2018a house\u2019, and enii, i.e., [en:i:] \u2018his (another\u2019s) house\u2019. The case of a word that has dropped a weak initial e differs from the case of a word that has an inaudible initial e that must still be written. Compare the discussion above of weak initial e in the word for \u2018house\u2019 with the earlier discussion of the initial e of the base emute- \u2018to seek medical aid\u2019; in words based on emute-, the initial e, though inaudible, must be written for the sake of rhythmic length in the word. Weak initial e occurs on some bases that have e as their second vowel. For some bases that have a weak initial e in General Central Yup\u2019ik (abbreviated GCY henceforth), HBC has an initial e that is not weak. In NUN, no initial e is weak.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Title,{active:activeIndex===15,index:15,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'[N\u2192V], [V\u2192N], [N\u2192N], [V\u2192V],'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["a" /* Accordion */].Content,{active:activeIndex===15},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'[N\u2192V] means it is a postbase that attaches to a noun base, changing it to a verb base.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'[V\u2192N] means it is a postbase that attaches to a verb base, changing it to a noun base.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'[N\u2192N] means it is a postbase that attaches to a noun base. It remains as a noun base.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'[V\u2192V] means it is a postbase that attaches to a verb base. It remains as a verb base.'))));}}]);return Symbols;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Symbols);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__semantic_dist_semantic_min_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Dropzone from 'react-dropzone';
var customFontFam="Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif";var styles={dropzoneBox:{border:'2px dashed #0087F7',borderRadius:'5px',padding:'30px',textAlign:'center',background:'#f9f9f9',cursor:'pointer'}};var Symbols=function(_Component){_inherits(Symbols,_Component);function Symbols(props){_classCallCheck(this,Symbols);var _this=_possibleConstructorReturn(this,(Symbols.__proto__||Object.getPrototypeOf(Symbols)).call(this,props));_this.handleOnDrop=function(acceptedFiles){var filesAccepted=true;if(filesAccepted){_this.setState({files:acceptedFiles,filesSubmittable:true});console.log('Uploaded files:',acceptedFiles);}};_this.submitAudio=function(){_this.setState({submittedAudio:true});};_this.submitAudioWithEmail=function(){_this.setState({submittedAudioWithEmail:true});};_this.state={// show: false,
// activeIndex: -1,
files:[],serverBusy:true,submittingAudio:false,submittedAudioWithEmail:false,filesSubmittable:false};return _this;}// handleClick = (e, titleProps) => {
//   const { index } = titleProps
//   const { activeIndex } = this.state
//   const newIndex = activeIndex === index ? -1 : index
//   this.setState({ activeIndex: newIndex })
// }
_createClass(Symbols,[{key:'render',value:function render(){var _this2=this;// const { activeIndex } = this.state
// <Dropzone onDrop={this.handleOnDrop}>
//   {({ getRootProps, getInputProps, isDragActive }) => (
//     <section className="container">
//       {/* Bind the root dropzone event handlers */}
//       <div {...getRootProps({ className: 'dropzone' })} style={styles.dropzoneBox}>
//         {/* Bind hidden native file selection inputs */}
//         <input {...getInputProps()} />
//         {isDragActive ? (
//           <p>Drop the files here ...</p>
//         ) : (
//           <p>Drag 'n' drop files here, or click to select files</p>
//         )}
//       </div>
//       {/* Displaying file details */}
//       <aside>
//         <h4>Files</h4>
//         <ul>
//           {this.state.files.map((file) => (
//             <li key={file.path || file.name}>
//               {file.name} - {file.size} bytes
//             </li>
//           ))}
//         </ul>
//       </aside>
//     </section>
//   )}
// </Dropzone>
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["e" /* Container */],{style:{margin:0,padding:0},text:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontFamily:customFontFam}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */],{textAlign:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Row,{style:{height:40,paddingBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Column,{style:{maxWidth:800,padding:0},textAlign:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:{pathname:"/"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,style:{margin:0,marginLeft:5,color:'#B1B1B1',cursor:'pointer',fontSize:'22px'},name:'chevron left'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{border:'1px solid #E3E3E3',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'hierarchymain'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'span1'},'Upload Yugtun Audio'))),this.state.filesSubmittable?!this.state.serverBusy?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{primary:true,disabled:this.state.submittedAudio,onClick:function onClick(){_this2.submitAudio();}},'Submit Audio')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'20px'}},'The server is busy processing several recordings, please include your email here and the transcript will be emailed to you.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'20px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["p" /* Input */],{disabled:this.state.submittedAudioWithEmail,placeholder:'example@domain.com'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{primary:true,disabled:this.state.submittedAudioWithEmail,onClick:function onClick(){_this2.submitAudioWithEmail();}},'Submit Audio')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{disabled:true},'Submit Audio'))))));}}]);return Symbols;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Symbols);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ga4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_ga4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_ga4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import {YouTubeLinks} from './info/YouTubeLinks.js';
// import {summaries} from './info/summaries.js';
// import {categories} from './info/categories.js';
// import { FeaturedVideos } from './Helpers.js';
// import RecordingStorageHook from './RecordingStorageHook.js';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
// import 'react-lazy-load-image-component/src/effects/blur.css';
// import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import { ReactMediaRecorder } from "react-media-recorder";
// import ReCAPTCHA from "react-google-recaptcha";
// import Mirt from 'react-mirt';
// import 'react-mirt/dist/css/react-mirt.css';
__WEBPACK_IMPORTED_MODULE_5_react_ga4___default.a.initialize("G-JZB9CXH4GJ");// const categories = _.times(6, (i) => (
//   <Grid.Column key={i}>
//   	<div>
// 	    <Image src='/images/categories1.jpg' />
// 	    <h3 className='yugtun'>Ellavut</h3>
// 	    Weather, Climate
// 	  </div>
//   </Grid.Column>
// ))
// const keywords = _.times(6, (i) => (
//   <Grid.Column key={i}>
//   	<Button basic color='blue' size='mini'>Yugtun<br /><em>inYup'ik</em></Button>
//   </Grid.Column>
// ))
// let customFontFam = customFontFam3
// let customTitleFontFam = customTitleFontFam3
// let customFontFam2 = {fontFamily:customTitleFontFam3}
// let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
// const isFirefox = typeof InstallTrigger !== 'undefined';
// if (isFirefox) {
//   customFontFam = customFirefoxTitleFontFam
//   customTitleFontFam = customFirefoxTitleFontFam
//   customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
//   letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
// }
var Validate=function(_Component){_inherits(Validate,_Component);function Validate(props){_classCallCheck(this,Validate);var _this=_possibleConstructorReturn(this,(Validate.__proto__||Object.getPrototypeOf(Validate)).call(this,props));_this.submitEdits=function(){__WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__App_js__["a" /* API_URL */]+"/yugtunCrowdsourceValidation",_this.state.validationEdit).then(function(response){console.log(response);_this.setState({validationData:response.data});});};_this.buttonClicked=function(d,status,currentstatus){var newvalidation=_this.state.validationEdit;console.log(d in newvalidation,newvalidation[d],currentstatus);if(d in newvalidation&&newvalidation[d]==status){console.log(newvalidation[d],currentstatus);delete newvalidation[d];}else{newvalidation[d]=status;}if(currentstatus!=status){_this.setState({validationEdit:newvalidation});}};_this.sendToCommonVoice=function(){console.log('starting send to common voice');__WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__App_js__["a" /* API_URL */]+"/yugtunSendToCommonVoice").then(function(response){// this.reloadDownloadedData()
console.log(response.data);console.log('finished sending to common voice');});};_this.checkPassword=function(){if(_this.state.passkey==_this.state.inputkey){_this.setState({visible:true});}};_this.state={// show: false,
// showAllElders: false,
// categoriesDisplayed: ['1','2','3','4','5','6'],
// featuredVideoIDs:['3TIkchKpXqY','F_bWrmqQB74',],
// featuredVideoIDs2:['XcMTNy-xdF4','E6h9Cryzk3M',],
// featuredZooms:['sS4vCvvOj8M','r78afbyVauw','kGCA7_Gc2ys','UbhmhRJClhg','NaYBwnGnA_0','tNLboGKVYhY'],
// // eldersList: [],
// showMoreVideos:false,
// recordedBlob:[],
// sending:false,
// retrievingRecording:false,
// // returnedTranscript:'',
// returnedTranscript:"",
// recaptchaAllowed:false,
// currentAudioFileToSave:[],
validationData:{},validationDataNew:{},validationEdit:{},passkey:'pissurtuq',inputkey:'',visible:false};return _this;}_createClass(Validate,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__App_js__["a" /* API_URL */]+"/yugtunCrowdsourceValidation",{}).then(function(response){console.log(response);_this2.setState({validationData:response.data});});}},{key:'repeatAudio',value:function repeatAudio(audio,event,data){var _this3=this;// console.log(audio)
if(!this.state.playingAudio){var sound=new Audio(__WEBPACK_IMPORTED_MODULE_4__App_js__["a" /* API_URL */]+"/yugtunCrowdsourceAudio/"+audio);this.setState({playingAudio:true});sound.play();sound.onended=function(){_this3.setState({playingAudio:false});};}}},{key:'render',value:function render(){var _this4=this;// console.log(this.state)
var showLargerTable=window.innerWidth>=480;var clipStatus=['new','accept','hold','reject'];var clipTitles=['New Clips','Accepted Clips','Held Clips','Rejected Clips'];var clipColors=['#E0E1E2','#a8e1af','#fee1a1','#f2a4a1'];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,!this.state.visible?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["p" /* Input */],{onChange:function onChange(data,entry){return _this4.setState({inputkey:entry.value});},placeholder:'Passkey'}),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){return _this4.checkPassword();}},'Submit')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,[0,1,2,3].map(function(k){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{margin:20,border:'10px solid '+clipColors[k]}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'center',fontWeight:'bold',fontSize:'24px',margin:40,textDecoration:'underline'}},clipTitles[k]),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */],{divided:'vertically'},Object.keys(_this4.state.validationData).map(function(d,dindex){if(_this4.state.validationData[d]['validation']==clipStatus[k]){if(showLargerTable){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,{columns:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{width:6,style:{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:"20px"}},_this4.state.validationData[d]['sentence']),window.innerWidth<900?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{circular:true,onClick:function onClick(){return _this4.repeatAudio(_this4.state.validationData[d]['filename']);},style:{fontSize:'20px',margin:10,color:'#8F8F8F',cursor:'pointer'},name:'volume up'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{controls:true,style:{height:40,margin:20},src:__WEBPACK_IMPORTED_MODULE_4__App_js__["a" /* API_URL */]+"/yugtunCrowdsourceAudio/"+_this4.state.validationData[d]['filename']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{width:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Age: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Gender: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Name: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Village: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Date: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'DonateCV: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'SentCV: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'SiteLoc: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Status: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'English: ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{width:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['age'].replace('do_not_wish_to_say',''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['gender'].replace('do_not_wish_to_say',''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['name'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['village'].replace('do_not_wish_to_say',''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['datetime'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['donate'].toString(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['sent'].toString(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['siteLocation'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['validation'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),'english'in _this4.state.validationData[d]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['english'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{width:3,style:{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{disabled:_this4.state.validationData[d]['validation']=='accept',style:{margin:3},onClick:function onClick(){return _this4.buttonClicked(d,'accept',_this4.state.validationData[d]['validation']);},color:_this4.state.validationData[d]['validation']=='accept'||d in _this4.state.validationEdit&&_this4.state.validationEdit[d]=='accept'?'green':''},'Accept'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{disabled:_this4.state.validationData[d]['validation']=='hold',style:{margin:3},onClick:function onClick(){return _this4.buttonClicked(d,'hold',_this4.state.validationData[d]['validation']);},color:_this4.state.validationData[d]['validation']=='hold'||d in _this4.state.validationEdit&&_this4.state.validationEdit[d]=='hold'?'yellow':''},'Hold'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{disabled:_this4.state.validationData[d]['validation']=='reject',style:{margin:3},onClick:function onClick(){return _this4.buttonClicked(d,'reject',_this4.state.validationData[d]['validation']);},color:_this4.state.validationData[d]['validation']=='reject'||d in _this4.state.validationEdit&&_this4.state.validationEdit[d]=='reject'?'red':''},'Reject')));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,{style:{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{fontSize:"20px"}},_this4.state.validationData[d]['sentence']),window.innerWidth<900?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{circular:true,onClick:function onClick(){return _this4.repeatAudio(_this4.state.validationData[d]['filename']);},style:{fontSize:'20px',margin:10,color:'#8F8F8F',cursor:'pointer'},name:'volume up'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('audio',{controls:true,style:{height:40,margin:20},src:__WEBPACK_IMPORTED_MODULE_4__App_js__["a" /* API_URL */]+"/yugtunCrowdsourceAudio/"+_this4.state.validationData[d]['filename']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,{columns:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{style:{textAlign:'right'},width:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Age: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Gender: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Name: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Village: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Date: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'DonateCV: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'SentCV: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'SiteLoc: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Status: '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'English: ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{width:10},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['age'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['gender'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['name'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['village'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['datetime'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['donate'].toString(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['sent'.toString()],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['siteLocation'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['validation'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')),'english'in _this4.state.validationData[d]?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this4.state.validationData[d]['english'],__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'white'}},'`')):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{style:{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{disabled:_this4.state.validationData[d]['validation']=='accept',style:{margin:3},onClick:function onClick(){return _this4.buttonClicked(d,'accept',_this4.state.validationData[d]['validation']);},color:_this4.state.validationData[d]['validation']=='accept'||d in _this4.state.validationEdit&&_this4.state.validationEdit[d]=='accept'?'green':''},'Accept'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{disabled:_this4.state.validationData[d]['validation']=='hold',style:{margin:3},onClick:function onClick(){return _this4.buttonClicked(d,'hold',_this4.state.validationData[d]['validation']);},color:_this4.state.validationData[d]['validation']=='hold'||d in _this4.state.validationEdit&&_this4.state.validationEdit[d]=='hold'?'yellow':''},'Hold'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{disabled:_this4.state.validationData[d]['validation']=='reject',style:{margin:3},onClick:function onClick(){return _this4.buttonClicked(d,'reject',_this4.state.validationData[d]['validation']);},color:_this4.state.validationData[d]['validation']=='reject'||d in _this4.state.validationEdit&&_this4.state.validationEdit[d]=='reject'?'red':''},'Reject'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["g" /* Divider */],null));}}})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{color:'blue',style:{margin:30},size:'large',onClick:function onClick(){return _this4.submitEdits();}},'Submit Changes')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{basic:true,style:{margin:30},size:'large',onClick:function onClick(){return _this4.sendToCommonVoice();}},'Submit Accepted to Common Voice'))));}}]);return Validate;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Validate);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_google_palette__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_google_palette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_google_palette__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shuffle_array__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shuffle_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shuffle_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__YupikModifyNoun_js__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__YupikModifyVerb_js__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_StickyMenu_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__yupikEnding_YupikEnding_js__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__yupikEnding_YupikEndingGroups_js__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__yupikPostbase_YupikPostbaseGroups_js__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__yupikPostbase_YupikPostbase_js__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__yupikPostbase_YupikAllPostbases_js__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__yupikNoun_YupikAllNounPostbases_js__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__yupikNoun_YupikNounDescriptors_js__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__yupikNoun_YupikNounPhrase_js__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__yupikNoun_YupikNounCombine_js__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants_constants_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modifyWord_modifyVerbOptions_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_Chip_js__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_redux__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__redux_actions__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modifyWord_ModifyWordVerb_js__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modifyWord_ModifyWordNoun_js__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modifyWord_processUsage_js__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modifyWord_removeCombos_js__ = __webpack_require__(960);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import nlp from 'compromise';
function getRandomArbitrary(min,max){return Math.floor(Math.random()*(max-min)+min);}var YupikModifyLayout=function(_Component){_inherits(YupikModifyLayout,_Component);function YupikModifyLayout(props){_classCallCheck(this,YupikModifyLayout);var _this=_possibleConstructorReturn(this,(YupikModifyLayout.__proto__||Object.getPrototypeOf(YupikModifyLayout)).call(this,props));console.log('YupikModifyLayout props',props);_this.verb=_this.props.location.pathname.includes('verb');_this.state={canTTS:true,// whether TTS is available for this word
loadingTTS:false,// whether we are loading the TTS for this word
headerFixed:false,usageId:_this.props.match.params.usage_id,entry:undefined,usage:undefined,properties:undefined,people:1,person:3,objectPeople:1,objectPerson:1,possessiveButton:false,possessorPerson:0,possessorPeople:0,value1:_this.verb?"":"31-1(1)",value2:"",value3:_this.verb?"":"11(3)",value4:1,text1after:'',text2after:'',text3tense:'',id1:"",addedWord:"",value1_text:"he",value2_text:"it",value3_text:"",allPostbasesMode:false,// whether the number of postbases is unlocked
completeSentence:"",allowable_next_ids:[],possessiveSubject:false,possessiveObject:false,objectExists:false,subjectExists:false,enclitic:'',alternateTense:'',nounEnding:'',verbEnding:false,encliticExpression:'',fullEnglish:'',tense:'present',text1:"",text2:"",adjectivesEnglish:[],nounEndingEnglish:[],verbEndingEnglish:[],mood:_this.verb?"indicative":"absolutive",moodSpecific:_this.verb?"indicative":"absolutive",postbasesEnglish:[],englishEnding:[],originalText2:"",originalText3:"",text3:"",transitive:true,postbasesList:[],colorsList:__WEBPACK_IMPORTED_MODULE_6_shuffle_array___default()(__WEBPACK_IMPORTED_MODULE_5_google_palette___default()('tol-rainbow',10).map(function(c){return'#'+c;})),// http://google.github.io/palette.js/
colorIndexes:[0],colorSeed:getRandomArbitrary(0,100),//usage: "[he] is hunting <it>",
currentPostbases:[],modifiedWord:'',//props.word.yupik,
currentWord:'',//props.word.yupik,
currentEnglish:"",//currentVerb,
modifiedEnglish:"",//props.word.english,//new Inflectors(currentVerb),
displayPostbases:false};_this.getWord=_this.getWord.bind(_this);_this.modifyWordVerb=_this.modifyWordVerb.bind(_this);_this.modifyWordNoun=_this.modifyWordNoun.bind(_this);_this.modifyWord=_this.verb?_this.modifyWordVerb:_this.modifyWordNoun;_this.setMood=_this.verb?_this.setMoodVerb:_this.setMoodNoun;_this.initialize=_this.initialize.bind(_this);_this.switchMode=_this.switchMode.bind(_this);if(props.location.state===undefined){// from search page
var word=props.match.params.word;_this.getWord(word);}else{_this.state=Object.assign({},_this.state,{currentWord:_this.props.location.state.word,modifiedWord:_this.props.location.state.word,entry:_this.props.location.state.entry,usage:_this.props.location.state.entry.usage[_this.props.match.params.usage_id][_this.verb?1:0],properties:_this.props.location.state.entry.properties});_this.initialize();}return _this;}_createClass(YupikModifyLayout,[{key:'componentDidMount',value:function componentDidMount(){this.switchMode();}},{key:'switchMode',value:function switchMode(){if(!this.props.advancedMode){this.props.history.push(this.verb?this.props.match.url+'/verb':this.props.match.url+'/noun');}else{this.props.history.push(this.verb?this.props.match.url+'/verb/all':this.props.match.url+'/noun/all');}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){if(prevProps.advancedMode!==this.props.advancedMode){this.switchMode();}}},{key:'setDisplayPostbases',value:function setDisplayPostbases(event,data){event.preventDefault();this.setState({displayPostbases:!this.state.displayPostbases});}},{key:'initialize',value:function initialize(){if(this.state.properties.includes('momentary')){this.state.alternateTense='present';this.state.tense='past';}else if(this.state.properties.includes('not_momentary')){this.state.alternateTense='recent past';}var new_state=Object(__WEBPACK_IMPORTED_MODULE_29__modifyWord_processUsage_js__["a" /* processUsage */])(this.state.usage);console.log('processed');this.state=Object.assign({},this.state,new_state);if(this.verb){if(this.state.objectExists){this.state.postbasesList=["+'(g)aa"];}else{this.state.postbasesList=["+'(g/t)uq"];}}if(this.verb){this.modifyWord(this.state.person,this.state.people,this.state.objectPerson,this.state.objectPeople,this.state.mood,this.state.moodSpecific,this.state.nounEnding,this.state.value1,this.state.currentWord,this.state.currentPostbases);}else{this.modifyWord(this.state.person,this.state.people,this.state.possessorPerson,this.state.possessorPeople,this.state.mood,this.state.moodSpecific,this.state.nounEnding,this.state.verbEnding,this.state.value4,this.state.currentWord,this.state.currentPostbases);}}},{key:'getWord',value:function getWord(word){var _this2=this;__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__App_js__["a" /* API_URL */]+"/word/"+word).then(function(response){_this2.setState({currentWord:response.data.yupik,modifiedWord:response.data.yupik,entry:response.data[_this2.props.match.params.entry_id],usage:response.data[_this2.props.match.params.entry_id].usage[_this2.props.match.params.usage_id][_this2.verb?1:0],properties:response.data[_this2.props.match.params.entry_id].properties});_this2.initialize();});}},{key:'componentWillUpdate',value:function componentWillUpdate(newProps,newState){if(this.verb){if(newState.encliticExpression!==this.state.encliticExpression||newState.value1!==this.state.value1||newState.people!==this.state.people||newState.person!==this.state.person||newState.objectPerson!==this.state.objectPerson||newState.objectPeople!==this.state.objectPeople||newState.moodSpecific!==this.state.moodSpecific||newState.nounEnding!==this.state.nounEnding){if(newState.mood!==this.state.mood){if(newState.mood!=='nounEnding'){newState.nounEnding='';this.setState({nounEnding:''});}if(newState.encliticExpression===this.state.encliticExpression){newState.enclitic='';newState.encliticExpression='';this.state.enclitic='';this.state.encliticExpression='';}if(newState.mood==='indicative'||newState.mood==='interrogative'){if(newState.value1[0]==='4'){// if 4th person subject, switch to 3rd person singular
this.setState({people:1,person:3,value1:'31-1(1)'});newState.person=3;newState.people=1;newState.value1='31-1(1)';}if(newState.value2[0]==='4'){// if 4th person object, switch to 3rd person singular
this.setState({objectPeople:1,objectPerson:3,value2:'31-1(2)'});newState.objectPerson=3;newState.objectPeople=1;newState.value2='31-1(2)';}if(newState.value3[0]==='4'){this.setState({objectPeople:1,objectPerson:3,value3:'31-1(3)'});newState.objectPerson=3;newState.objectPeople=1;newState.value3='31-1(3)';}if(newState.mood==='interrogative'){//moving into interrogative
if(newState.value1[0]==='1'){//if 1st person subject, switch to 'He'
this.setState({people:1,person:3,value1:'31-1(1)'});newState.person=3;newState.people=1;newState.value1='31-1(1)';}}var str=newState.value1;str=str.substring(0,str.length-2)+'1)';this.setState({value1:str});newState.value1=str;}else if(newState.mood==='subordinative'){if(this.state.value1[0]==='3'){//if 3rd person subject, switch to 4th person singular
this.setState({people:1,person:4,value1:'41(1)'});newState.person=4;newState.people=1;}if(this.state.value2[0]==='4'){// if 4th person object, switch to 3rd person singular
this.setState({objectPeople:1,objectPerson:3,value2:'31-1(2)'});newState.objectPerson=3;newState.objectPeople=1;}if(this.state.value3[0]==='4'){this.setState({objectPeople:1,objectPerson:3,value3:'31-1(3)'});newState.objectPerson=3;newState.objectPeople=1;}}else if(newState.mood==='optative'){this.setState({people:1,person:2,value1:'21(2)'});newState.person=2;newState.people=1;if(this.state.value2[0]==='2'){//if 2nd person object, use 3rd person singular instead
this.setState({objectPeople:1,objectPerson:3,value2:'31-1(2)'});newState.objectPerson=3;newState.objectPeople=1;}}else{var _str=this.state.value1;_str=_str.substring(0,_str.length-2)+'1)';this.setState({value1:_str});}}if(newState.moodSpecific==='when (future)...'||newState.moodSpecific==='when (past)...'||newState.mood==='optative'||newState.moodSpecific==='before...'){var array=this.state.currentPostbases;for(var i=array.length-1;i>=0;i--){if(array[i]===5||array[i]===6||array[i]===7||array[i]===8||array[i]===9||array[i]===22){array.splice(i,1);}}this.setState({currentPostbases:array});var array3=[5,6,7,8,9,22].concat(this.state.allowable_next_ids);array3=array3.sort().filter(function(item,pos,ary){return!pos||item!==ary[pos-1];});this.setState({allowable_next_ids:array3});}if(newState.mood!=='indicative'){var _array=this.state.currentPostbases;for(var i=_array.length-1;i>=0;i--){if(_array[i]===0){_array.splice(i,1);}}this.setState({currentPostbases:_array});var array3=[0].concat(this.state.allowable_next_ids);array3=array3.sort().filter(function(item,pos,ary){return!pos||item!==ary[pos-1];});this.setState({allowable_next_ids:array3});}if(newState.encliticExpression!==this.state.encliticExpression){if(newState.encliticExpression==='(yes or no?)'&&newState.mood==='interrogative'){newState.mood='indicative';this.state.mood='indicative';newState.moodSpecific='indicative';this.state.moodSpecific='indicative';}}this.modifyWord(newState.person,newState.people,newState.objectPerson,newState.objectPeople,newState.mood,newState.moodSpecific,newState.nounEnding,newState.value1,this.state.currentWord,this.state.currentPostbases);}}else{if(newState.people!==this.state.people||newState.value4!==this.state.value4||newState.person!==this.state.person||newState.possessorPerson!==this.state.possessorPerson||newState.possessorPeople!==this.state.possessorPeople||newState.mood!==this.state.mood||newState.nounEnding!==this.state.nounEnding||newState.verbEnding!==this.state.verbEnding){if(newState.nounEnding!==this.state.nounEnding){if(newState.nounEnding!==''){if(newState.nounEnding==='and others - only applies to people or animals'||newState.nounEnding==='and another - only applies to people or animals'){this.setState({value4:1});newState.value4=1;}else if(newState.nounEnding==='just a little'){this.setState({value4:1,nounEnding:'just a little'});newState.value4=1;}else if(newState.nounEnding==='many of them'){this.setState({value4:3,nounEnding:'many of them'});newState.value4=3;}this.setState({possessorPeople:0,possessorPerson:0});newState.possessorPeople=0;newState.possessorPerson=0;}}if(newState.possessorPeople!==this.state.possessorPeople){if(newState.possessorPeople!==0){if(newState.verbEnding||newState.nounEnding!==''){this.setState({currentPostbases:this.state.currentPostbases.slice(1)});}this.setState({verbEnding:false,nounEnding:''});newState.verbEnding=false;newState.nounEnding='';}}if(newState.verbEnding!==this.state.verbEnding){if(newState.verbEnding===true){this.setState({possessorPeople:0,possessorPerson:0});newState.possessorPeople=0;newState.possessorPerson=0;}}if(newState.verbEndingEnglish==="the place does not have"||newState.verbEndingEnglish==="the place has"){this.setState({people:1,person:3});newState.people=1;newState.person=3;}if(newState.mood!==this.state.mood){if(newState.mood!=='absolutive'){if(newState.nounEnding!==''||newState.verbEnding===true){this.setState({currentPostbases:this.state.currentPostbases.slice(1),nounEnding:'',verbEnding:false});newState.nounEnding='';newState.verbEnding=false;}}}this.modifyWord(newState.person,newState.people,newState.possessorPerson,newState.possessorPeople,newState.mood,newState.moodSpecific,newState.nounEnding,newState.verbEnding,newState.value4,this.state.currentWord,this.state.currentPostbases);}}}},{key:'setPeople',value:function setPeople(people,event,data){this.setState({people:this.state.people===people?0:people});}},{key:'setPerson',value:function setPerson(person,event,data){this.setState({person:this.state.person===person?0:person});}},{key:'setObjectPeople',value:function setObjectPeople(objectPeople,event,data){this.setState({objectPeople:this.state.objectPeople===objectPeople?0:objectPeople});}},{key:'setObjectPerson',value:function setObjectPerson(objectPerson,event,data){this.setState({objectExists:this.state.objectPerson===objectPerson?false:true});this.setState({objectPerson:this.state.objectPerson===objectPerson?0:objectPerson});}},{key:'setValue1',value:function setValue1(e,data){this.setState({value1:data.value,person:parseInt(data.value[0]),people:parseInt(data.value[1])});}},{key:'setValue2',value:function setValue2(e,data){this.setState({value2:data.value,objectPerson:parseInt(data.value[0]),objectPeople:parseInt(data.value[1])});}},{key:'setValue3',value:function setValue3(e,data){if(this.verb){this.setState({value3:data.value,objectPerson:parseInt(data.value[0]),objectPeople:parseInt(data.value[1])});}else{this.setState({value3:data.value,possessorPerson:parseInt(data.value[0]),possessorPeople:parseInt(data.value[1])});}}},{key:'setValue4',value:function setValue4(i,e,data){this.setState({value4:i});}},{key:'speak',value:function speak(event,data){var _this3=this;var addedbeginning='';var addedending='';if(this.state.mood==='interrogative'){addedbeginning=this.state.addedWord+this.state.enclitic+'^';}else{addedending=this.state.enclitic;}var audio=new Audio(__WEBPACK_IMPORTED_MODULE_8__App_js__["a" /* API_URL */]+"/tts/"+addedbeginning+this.state.modifiedWord.replace('*','')+addedending);this.setState({loadingTTS:true});audio.play().then(function(e){_this3.setState({loadingTTS:false});},function(error){_this3.setState({loadingTTS:false,canTTS:false});});}},{key:'allPostbasesMode',value:function allPostbasesMode(event,data){var _this4=this;this.setState({allPostbasesMode:!this.state.allPostbasesMode});var allowable=[];if(this.verb){//this could be sent to another function since it is repeated in setPostbase
if(this.state.allPostbasesMode){if(this.state.currentPostbases.length===0){// pass
}else if(this.state.currentPostbases.length===1){allowable=__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][this.state.currentPostbases[0]].allowable_next_ids;}else{allowable=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29];this.state.currentPostbases.forEach(function(i,index){allowable.splice(allowable.indexOf(_this4.state.currentPostbases[index]),1);});}}if(this.state.moodSpecific==='when (future)...'||this.state.moodSpecific==='when (past)...'||this.state.moodSpecific==='before...'){allowable.push(5);allowable.push(6);allowable.push(7);allowable.push(8);allowable.push(9);allowable.push(22);}this.setState({allowable_next_ids:allowable});this.modifyWord(this.state.person,this.state.people,this.state.objectPerson,this.state.objectPeople,this.state.mood,this.state.moodSpecific,this.state.nounEnding,this.state.value1,this.state.currentWord,this.state.currentPostbases);}else{var allremaining=[0,1,2,3,4,5,6];if(!this.state.allPostbasesMode){this.setState({allowable_next_ids:[]});}else{if(this.state.currentPostbases.length===0){this.setState({allowable_next_ids:[]});}else if(this.state.currentPostbases.length===1){if(this.state.currentPostbases[0]<7){this.setState({allowable_next_ids:__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][this.state.currentPostbases[0]].allowable_next_ids});}else{this.setState({allowable_next_ids:[]});}}else if(this.state.currentPostbases.length===2){if(this.state.currentPostbases[0]<7){allremaining.splice(allremaining.indexOf(this.state.currentPostbases[1]),1);allremaining.splice(allremaining.indexOf(this.state.currentPostbases[0]),1);this.setState({allowable_next_ids:allremaining});}else{this.setState({allowable_next_ids:__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][this.state.currentPostbases[1]].allowable_next_ids});}}else{this.state.currentPostbases.forEach(function(i,index){if(i<7){allremaining.splice(allremaining.indexOf(_this4.state.currentPostbases[index]),1);}});this.setState({allowable_next_ids:allremaining});}}this.modifyWord(this.state.person,this.state.people,this.state.objectPerson,this.state.objectPeople,this.state.mood,this.state.moodSpecific,this.state.nounEnding,this.state.value1,this.state.currentWord,this.state.currentPostbases);}}},{key:'setPostbase',value:function setPostbase(postbase_id,event,data){event.preventDefault();var index=this.state.currentPostbases.indexOf(postbase_id);var currentPostbases=this.state.currentPostbases;var allowable=[];if(this.verb){if(index>-1){currentPostbases.splice(index,1);}else{currentPostbases.push(postbase_id);}if(this.state.moodSpecific==='when (future)...'||this.state.moodSpecific==='when (past)...'||this.state.moodSpecific==='before...'){allowable.push(5);allowable.push(6);allowable.push(7);allowable.push(8);allowable.push(9);allowable.push(22);}if(this.state.mood!=='indicative'){allowable.push(0);}else{allowable.splice(allowable.indexOf(0),1);}if(!this.state.allPostbasesMode){if(currentPostbases.length===0){//pass
}else if(currentPostbases.length===1){// this.setState({allowable_next_ids: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]})
var array3=__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][currentPostbases[0]].allowable_next_ids.concat(this.state.allowable_next_ids);allowable=array3.sort().filter(function(item,pos,ary){return!pos||item!==ary[pos-1];});}else{allowable=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29];currentPostbases.forEach(function(i,index){allowable.splice(allowable.indexOf(currentPostbases[index]),1);});}}// console.log(allowable)
this.setState({allowable_next_ids:allowable});this.modifyWord(this.state.person,this.state.people,this.state.objectPerson,this.state.objectPeople,this.state.mood,this.state.moodSpecific,this.state.nounEnding,this.state.value1,this.state.currentWord,currentPostbases);}else{var verbEnding=this.state.verbEnding;var nounEnding=this.state.nounEnding;var moodEnding=this.state.mood;var value4=this.state.value4;if(index>-1){currentPostbases.splice(index,1);if(postbase_id>10){this.setState({verbEnding:false});verbEnding=false;}else if(postbase_id>6){this.setState({nounEnding:''});nounEnding='';}}else if(postbase_id>6&&postbase_id<11){for(var i=7;i<11;i++){if(currentPostbases.indexOf(i)>-1){currentPostbases.splice(currentPostbases.indexOf(i),1);}}if(verbEnding){currentPostbases=currentPostbases.slice(1);this.setState({verbEnding:false});verbEnding=false;}else if(this.state.mood!=='absolutive'){this.setState({mood:'absolutive'});moodEnding='absolutive';}if(nounEnding==='and others - only applies to people or animals'||nounEnding==='and another - only applies to people or animals'){this.setState({value4:1});value4=1;}else if(nounEnding==='just a little'){this.setState({value4:1});value4=1;}else if(nounEnding==='many of them'){this.setState({value4:3});value4=3;}currentPostbases.push(postbase_id);this.setState({nounEnding:__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][postbase_id].englishModifier('')});nounEnding=__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][postbase_id].englishModifier('');this.setState({possessiveButton:0,possessorPeople:0,possessorPerson:0});}else if(postbase_id>10){for(var i=11;i<22;i++){if(currentPostbases.indexOf(i)>-1){currentPostbases.splice(currentPostbases.indexOf(i),1);}}if(nounEnding!==''){currentPostbases=currentPostbases.slice(1);this.setState({nounEnding:''});nounEnding='';}else if(this.state.mood!=='absolutive'){this.setState({mood:'absolutive'});moodEnding='absolutive';}currentPostbases.push(postbase_id);this.setState({verbEnding:true});verbEnding=true;this.setState({possessiveButton:0,possessorPeople:0,possessorPerson:0});}else{currentPostbases.push(postbase_id);}var allremaining=[0,1,2,3,4,5,6];currentPostbases=currentPostbases.sort(function(p1,p2){return __WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p1].priority>__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p2].priority?1:__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p1].priority<__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p2].priority?-1:0;});if(this.state.allPostbasesMode){this.setState({allowable_next_ids:[]});}else{if(currentPostbases.length===0){this.setState({allowable_next_ids:[]});}else if(currentPostbases.length===1){if(currentPostbases[0]<7){this.setState({allowable_next_ids:__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][currentPostbases[0]].allowable_next_ids});}else{this.setState({allowable_next_ids:[]});}}else if(currentPostbases.length===2){if(currentPostbases[0]<7){allremaining.splice(allremaining.indexOf(currentPostbases[1]),1);allremaining.splice(allremaining.indexOf(currentPostbases[0]),1);this.setState({allowable_next_ids:allremaining});}else{this.setState({allowable_next_ids:__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][currentPostbases[1]].allowable_next_ids});}}else{currentPostbases.forEach(function(i,index){if(i<7){allremaining.splice(allremaining.indexOf(currentPostbases[index]),1);}});this.setState({allowable_next_ids:allremaining});}}this.modifyWord(this.state.person,this.state.people,this.state.possessorPerson,this.state.possessorPeople,moodEnding,this.state.moodSpecific,nounEnding,verbEnding,value4,this.state.currentWord,currentPostbases);}}},{key:'setMoodVerb',value:function setMoodVerb(newMood,moodSpecific,event,data){this.setState({mood:this.state.moodSpecific===moodSpecific?'indicative':newMood});this.setState({moodSpecific:this.state.moodSpecific===moodSpecific?'indicative':moodSpecific});}},{key:'setMoodNoun',value:function setMoodNoun(mood,event,data){this.setState({mood:this.state.mood===mood?'absolutive':mood});}},{key:'setEnclitic',value:function setEnclitic(enclitic,encliticExpression,event,data){this.setState({enclitic:this.state.enclitic===enclitic?'':enclitic});this.setState({encliticExpression:this.state.enclitic===enclitic?'':encliticExpression});if(this.state.mood!=='interrogative'){this.setState({mood:'indicative',moodSpecific:'indicative'});}}},{key:'setNounEnding',value:function setNounEnding(ending,event,data){this.setState({nounEnding:this.state.nounEnding===ending?'':ending});this.setState({mood:this.state.nounEnding===ending?'indicative':'nounEnding'});this.setState({moodSpecific:this.state.nounEnding===ending?'indicative':'nounEnding'});}},{key:'setPossessiveButton',value:function setPossessiveButton(num,event,data){if(this.state.possessiveButton===num){this.setState({possessiveButton:0,possessorPeople:0,possessorPerson:0});}else{this.setState({possessiveButton:num,possessorPeople:this.state.value3[1],possessorPerson:this.state.value3[0]});var currentPostbases=this.state.currentPostbases;for(var i=11;i<22;i++){if(currentPostbases.indexOf(i)>-1){currentPostbases.splice(currentPostbases.indexOf(i),1);}}this.setState({currentPostbases:currentPostbases});}}},{key:'modifyWordVerb',value:function modifyWordVerb(person,people,objectPerson,objectPeople,mood,moodSpecific,nounEnding,value1,word,currentPostbases){var _this5=this;// Restore TTS option if it was disabled for previous word
console.log(word);word=word.replace('\u0304','').replace('\u0361','');console.log(word);if(!this.state.canTTS){this.setState({canTTS:true});}var _state=this.state,newText2=_state.originalText2,newText3=_state.originalText3,newEnglish=_state.currentEnglish,tense=_state.tense;var newText1='';var newText1after='';var newText2after='';var newText3tense='';var englishEnding=[];currentPostbases=currentPostbases.reverse();var new_str='';var new_adj='';var be_adj='';var being_adj='';var nois=false;var does='';if(this.state.alternateTense==='present'&&person===1){tense='present';}if(newText2.includes('is ')){new_str=newText2.split("is ");console.log(new_str);if(new_str.length===2){new_adj=new_str[1].trim();}else if(new_str.length===3){new_adj=new_str[1]+'is '+new_str[2];}}else if(newText2.includes('was ')){new_str=newText2.split("was ");new_adj=new_str[1].trim();tense='past';}else{new_adj=newText2.trim();nois=true;}be_adj='be '+new_adj;being_adj='being '+new_adj;var addis=false;addis=false;var conditionalbe=' be ';var hasDesire=false;hasDesire=false;var postbasesEnglish=[];var test=new_adj;var originalverb=[];// let originalverb = nlp(test).verbs().out() //might not work if there are multiple verbs
if(originalverb.includes(' ')){}// originalverb = nlp(test).verbs().out().split(' ')[0]
// console.log(originalverb)
var verbtenses='';var gerund_new_adj='';var infinitive_new_adj='';if(this.state.properties.includes('adjectival')){gerund_new_adj=new_adj;infinitive_new_adj='be '+new_adj;}else if(originalverb){if(originalverb==='being'){gerund_new_adj=test.replace(originalverb,'');infinitive_new_adj=test.replace(originalverb,'');}else{// verbtenses = nlp(originalverb).verbs().conjugate()[0]
// console.log(verbtenses)
gerund_new_adj=test.replace(originalverb,verbtenses.Gerund);infinitive_new_adj=test.replace(originalverb,verbtenses.Infinitive);}}else{gerund_new_adj=new_adj;infinitive_new_adj='be '+new_adj;}var firstpass=true;// console.log(gerund_new_adj)
englishEnding=[];var postbase28=false;var inTheFutureFlag=false;var inThePastFlag=false;var place=[];var unmodifyingPostbases=[0,1,5,7,9,11,12,13,14,15,19,20,27];var A=[2,3,4,10,29];var B=[16,17,18];var C=[21,22,24,25,23];var D=[26];var E=[19,20,0,1,5,7,8,11,12,13,14,15,27];var F=[28];var G=[9];var H=[6];var firstP=0;var willbe='';var willMark='';var beMark='';var endingMood='';var nextIndexPostbase=0;var bebeing='';var subjectType='';var moodIndex=["g","g","i","i","i","g","g","g","g","g","i","g","g","g","g","g","i","i","i","g","g","i","i","i","i","i","g","g","g","i"];// console.log(currentPostbases)
currentPostbases=currentPostbases.reverse();// console.log(currentPostbases[0])
var pushEnding=__WEBPACK_IMPORTED_MODULE_27__modifyWord_ModifyWordVerb_js__["e" /* pushEnding */].bind(null,infinitive_new_adj,gerund_new_adj,new_adj,englishEnding);if(currentPostbases.length===0&&mood==='indicative'&&!this.state.properties.includes('not_momentary')){englishEnding.push(newText2);newText2='';}else{if(currentPostbases.length===0){if(endingMood==='infinitive'){englishEnding.push(infinitive_new_adj);}else{englishEnding.push(gerund_new_adj);}}if(moodSpecific==='You, stop!'||nounEnding!==''){endingMood='g';if(currentPostbases.includes(5)){newText3tense=' (in the past)';tense='past';}else if([7,8,9].some(function(r){return currentPostbases.includes(r);})){newText3tense=' (in the future)';tense='future';}if(currentPostbases.length>0){firstP=currentPostbases[0];if(place.concat(A,F,G,H).includes(firstP)){postbasesEnglish.push('being'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][firstP].englishModifier(''));}else if(C.includes(firstP)){postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][firstP].englishModifierGerund(''));}else{postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][firstP].englishModifier(''));}if(currentPostbases.length===1){if(place.concat(A,B,C).includes(firstP)){pushEnding('i',0);}else{pushEnding('g',0);}}}}else if(mood==='optative'){newText2='be';if(moodSpecific==='do (in the future)!'){newText3tense=' (in the future)';}endingMood='i';if(currentPostbases.includes(5)){newText3tense=' (in the past)';tense='past';}else if([7,8,9].some(function(r){return currentPostbases.includes(r);})){newText3tense=' (in the future)';tense='future';}if(currentPostbases.length>0){firstP=currentPostbases[0];if(place.concat(B,C,D).includes(firstP)){postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][firstP].englishModifierGerund(''));}else{postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][firstP].englishModifier(''));}if(currentPostbases.length===1){if(place.concat(A,B,C).includes(firstP)){pushEnding('i',0);}else{pushEnding('g',0);}}}}else{endingMood='g';if(currentPostbases.includes(5)){tense='past';}else if([7,8,9].some(function(r){return currentPostbases.includes(r);})){tense='future';}if(currentPostbases.length>0){firstP=currentPostbases[0];if(place.concat(B,C,D).includes(firstP)){if(firstP===23){does='does';postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][firstP].englishModifierInfinitive(''));}else{postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][firstP].englishModifierGerund(''));}}else{postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][firstP].englishModifier(''));}if(currentPostbases.length===1){if(place.concat(A,B,C).includes(firstP)){pushEnding('i',0);}else{pushEnding('g',0);}}}}if(currentPostbases.length>1){endingMood=moodIndex[currentPostbases[0]];currentPostbases.forEach(function(s,i){if(i!==currentPostbases.length-1){nextIndexPostbase=__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][currentPostbases[i+1]].id;// console.log(postbases[nextIndexPostbase].id)
if(place.concat(B,C,D).includes(nextIndexPostbase)){if(endingMood==='i'){if(place.concat(A,B,C).includes(s)&&A.includes(nextIndexPostbase)){postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierInfinitive(''));pushEnding('i',i);}else if(place.concat(A,B,C).includes(s)&&place.concat(F,G).includes(nextIndexPostbase)){postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierInfinitive(''));pushEnding('g',i);}else if(place.concat(D,E,F).includes(s)&&A.includes(nextIndexPostbase)){if(endingMood==='g'){postbasesEnglish.push('being'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierInfinitive(''));}else{postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierInfinitive(''));}pushEnding('i',i);}else if(place.concat(D,E,F).includes(s)&&place.concat(F,G).includes(nextIndexPostbase)){if(endingMood==='g'){postbasesEnglish.push('being'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierInfinitive(''));}else{postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierInfinitive(''));}pushEnding('g',i);}else{postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierInfinitive(''));if(nextIndexPostbase===26||nextIndexPostbase===28){pushEnding('g',i);}else if(place.concat(A,B,C).includes(nextIndexPostbase)){pushEnding('i',i);}else{pushEnding(endingMood,i);}}}else{//gerund
if(place.concat(A,B,C).includes(s)&&A.includes(nextIndexPostbase)){postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierGerund(''));pushEnding('i',i);}else if(place.concat(A,B,C).includes(s)&&place.concat(F,G).includes(nextIndexPostbase)){// console.log('called?')
postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierGerund(''));pushEnding('g',i);}else if(place.concat(D,E,F).includes(s)&&A.includes(nextIndexPostbase)){if(endingMood==='g'){postbasesEnglish.push('being'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierGerund(''));}else{postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierGerund(''));}pushEnding('i',i);}else if(place.concat(D,E,F).includes(s)&&place.concat(F,G).includes(nextIndexPostbase)){if(endingMood==='g'){postbasesEnglish.push('being'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierGerund(''));}else{postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierGerund(''));}pushEnding('g',i);}else{postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifierGerund(''));if(nextIndexPostbase===26||nextIndexPostbase===28){pushEnding('g',i);}else if(place.concat(A,B,C).includes(nextIndexPostbase)){pushEnding('i',i);}else{pushEnding(endingMood,i);}}}}else{if(place.concat(A,B,C).includes(s)&&A.includes(nextIndexPostbase)){postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifier(''));pushEnding('i',i);}else if(place.concat(A,B,C).includes(s)&&place.concat(F,G).includes(nextIndexPostbase)){postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifier(''));pushEnding('g',i);}else if(place.concat(D,E,F).includes(s)&&A.includes(nextIndexPostbase)){if(endingMood==='g'){postbasesEnglish.push('being'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifier(''));}else{postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifier(''));}pushEnding('i',i);}else if(place.concat(D,E,F).includes(s)&&place.concat(F,G).includes(nextIndexPostbase)){if(endingMood==='g'){postbasesEnglish.push('being'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifier(''));}else{postbasesEnglish.push('be'+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifier(''));}pushEnding('g',i);}else{postbasesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */][nextIndexPostbase].englishModifier(''));if(nextIndexPostbase===26||nextIndexPostbase===28){pushEnding('g',i);}else if(place.concat(A,B,C).includes(nextIndexPostbase)){pushEnding('i',i);}else{pushEnding(endingMood,i);}}}console.log(englishEnding);if(place.concat(E,G).includes(nextIndexPostbase)===false){endingMood=moodIndex[nextIndexPostbase];// console.log(endingMood)
// console.log(postbases[nextIndexPostbase].description)
}}});}var adjectivalbeing='';if(this.state.properties.includes('adjectival')){adjectivalbeing=' being';}var getsubjectis=__WEBPACK_IMPORTED_MODULE_27__modifyWord_ModifyWordVerb_js__["b" /* getsubjectis */].bind(null,currentPostbases,person);if(moodSpecific==='You, stop!'){if(person==='3'||person==='1'){newText1='let';newText2='stop ';// newText3 = newText3+'!'
}else{newText1='';newText2=', stop'+adjectivalbeing;// newText3 = newText3+'!'
}}else if(moodSpecific==='You, do not!'){newText1after='';newText2after='';if(person==='3'||person==='1'){newText1='let';newText2='not '+newText2;// newText3 = newText3+'!'
}else{newText1='';newText2=', do not '+newText2;// newText3 = newText3+'!'
}}else if(moodSpecific==='do!'){newText1after='';newText2after='';if(person==='3'||person==='1'){newText1='let';newText2=newText2+'';// newText3 = newText3+'!'
}else{newText1='';newText2=', '+newText2;// newText3 = newText3+'!'  for optative render it'll look like newText2 + object + newText3 + newText3tense + '!'
}}else if(moodSpecific==='do (in the future)!'){newText1after='';newText2after='';if(person==='3'||person==='1'){newText1='let';newText2=newText2+'';}else{newText1='';newText2=', '+newText2;}}else if(moodSpecific==='when (future)...'){newText1='when';newText1after='';newText2='';newText2after='will '+getsubjectis('future',people,person,'be');}else if(moodSpecific==='when (past)...'){newText1='when ';newText1after='';newText2='';newText2after=getsubjectis('past',people,person,does);}else if(moodSpecific==='who'&&this.state.objectExists){newText1='whom '+getsubjectis(tense,people,person,'prewho');newText1after='';newText2='';newText2after='';newText3=newText3+'?';}else if(moodSpecific==='who'){newText1='who '+getsubjectis(tense,people,person,'prewho');newText1after='';newText2=' who ';newText2after=getsubjectis(tense,people,person,does);newText3=newText3+'?';}else if(mood==='interrogative'){if(moodSpecific==='when (in past)'){tense='past';}else if(moodSpecific==='when (in future)'){tense='future';}newText1=__WEBPACK_IMPORTED_MODULE_22__modifyWord_modifyVerbOptions_js__["c" /* interrogative */].find(function(p){return p.mood===moodSpecific;}).text;newText1after=getsubjectis(tense,people,person,does);newText2='';newText2after=getsubjectis(tense,people,person,'be');newText3=newText3+'?';}else if(mood==='connective_precessive'||mood==='connective_consequential'||mood==='connective_contingent'||mood==='connective_concessive'||mood==='connective_conditional'||mood==='connective_first_contemporative'||mood==='connective_second_contemporative'||mood==='subordinative'){newText1=__WEBPACK_IMPORTED_MODULE_22__modifyWord_modifyVerbOptions_js__["a" /* dependent */].find(function(p){return p.mood===moodSpecific;}).text;newText1after='';newText2='';newText2after=getsubjectis(tense,people,person,does)+getsubjectis(tense,people,person,'be');}else if(nounEnding!==''){newText1='';newText1after='';newText2=__WEBPACK_IMPORTED_MODULE_22__modifyWord_modifyVerbOptions_js__["f" /* verb2noun */].find(function(p){return p.ending===nounEnding;}).text;newText2after=' ('+adjectivalbeing;newText3=newText3+')';}else{newText1='';newText1after='';newText2='';newText2after=getsubjectis(tense,people,person,does)+getsubjectis(tense,people,person,'be');}currentPostbases=currentPostbases.reverse();}var postbasesList=[];var base=word;postbasesList=Object(__WEBPACK_IMPORTED_MODULE_27__modifyWord_ModifyWordVerb_js__["c" /* processPostbases */])(currentPostbases,base,__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */],word);if(nounEnding!==''){if(nounEnding==='device for'){if(currentPostbases.length===0){if(base[base.length-2]==='a'||base[base.length-2]==='e'||base[base.length-2]==='i'||base[base.length-2]==='u'){postbasesList=postbasesList.concat('+3uun');}else{postbasesList=postbasesList.concat('+cuun');}}else{console.log(postbasesList[postbasesList.length-1]);console.log(postbasesList[postbasesList.length-1].length-2);if(postbasesList[postbasesList.length-1][postbasesList[postbasesList.length-1].length-2]==='a'||postbasesList[postbasesList.length-1][postbasesList[postbasesList.length-1].length-2]==='e'||postbasesList[postbasesList.length-1][postbasesList[postbasesList.length-1].length-2]==='i'||postbasesList[postbasesList.length-1][postbasesList[postbasesList.length-1].length-2]==='u'){postbasesList=postbasesList.concat('+3uun');}else{postbasesList=postbasesList.concat('+cuun');}}}else{postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["q" /* nounEndings */][nounEnding]]);}}else{if(this.state.objectExists){if(mood==='indicative'){postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["m" /* indicative_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(mood==='interrogative'){postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["o" /* interrogative_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(mood==='subordinative'){postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["v" /* subordinative_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(mood==='connective_precessive'){postbasesList=postbasesList.concat(['@~+(t)vaileg\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["f" /* connective_consonantEnd_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(mood==='connective_consequential'){postbasesList=postbasesList.concat(['@~:(6)a\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["j" /* connective_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(mood==='connective_contingent'){postbasesList=postbasesList.concat(['+\'(g)aqa\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["j" /* connective_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(mood==='connective_concessive'){if(person===2||person===1){postbasesList=postbasesList.concat(['@-6rar\\']);}else{postbasesList=postbasesList.concat(['@-6r\\']);}postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["f" /* connective_consonantEnd_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(mood==='connective_conditional'){postbasesList=postbasesList.concat(['@~-ku\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["d" /* connective_conditional_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(mood==='connective_first_contemporative'){postbasesList=postbasesList.concat(['-ller\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["h" /* connective_contemporative_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(mood==='connective_second_contemporative'){postbasesList=postbasesList.concat(['@:(6)inaner\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["h" /* connective_contemporative_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(moodSpecific==='do!'){postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["s" /* optative_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(moodSpecific==='do (in the future)!'){postbasesList=postbasesList.concat(['@~-ki\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["s" /* optative_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(moodSpecific==='You, stop!'){postbasesList=postbasesList.concat(['@~+(t)viiqna\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["s" /* optative_transitive_endings */][person][people][objectPerson][objectPeople]]);}else if(moodSpecific==='You, do not!'){if(person===2){postbasesList=postbasesList.concat(['@~+yaquna\\']);}else{postbasesList=postbasesList.concat(['-nrilki\\']);}postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["s" /* optative_transitive_endings */][person][people][objectPerson][objectPeople]]);}}else{if(mood==='indicative'){// console.log(indicative_intransitive_endings, person, people)
postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["l" /* indicative_intransitive_endings */][person][people]]);}else if(mood==='interrogative'){postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["n" /* interrogative_intransitive_endings */][person][people]]);}else if(mood==='subordinative'){postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["u" /* subordinative_intransitive_endings */][person][people]]);}else if(mood==='connective_precessive'){postbasesList=postbasesList.concat(['@~+(t)vaileg\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["e" /* connective_consonantEnd_intransitive_endings */][person][people]]);}else if(mood==='connective_consequential'){postbasesList=postbasesList.concat(['@~:(6)a\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["i" /* connective_intransitive_endings */][person][people]]);}else if(mood==='connective_contingent'){postbasesList=postbasesList.concat(['+\'(g)aqa\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["i" /* connective_intransitive_endings */][person][people]]);}else if(mood==='connective_concessive'){if(person===2||person===1&&people!==1){postbasesList=postbasesList.concat(['@-6rar\\']);}else{postbasesList=postbasesList.concat(['@-6r\\']);}postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["e" /* connective_consonantEnd_intransitive_endings */][person][people]]);}else if(mood==='connective_conditional'){postbasesList=postbasesList.concat(['@~-ku\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["c" /* connective_conditional_intransitive_endings */][person][people]]);}else if(mood==='connective_first_contemporative'){postbasesList=postbasesList.concat(['-ller\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["g" /* connective_contemporative_intransitive_endings */][person][people]]);}else if(mood==='connective_second_contemporative'){postbasesList=postbasesList.concat(['@:(6)inaner\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["g" /* connective_contemporative_intransitive_endings */][person][people]]);}else if(moodSpecific==='do!'){postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["r" /* optative_intransitive_endings */][person][people]]);}else if(moodSpecific==='do (in the future)!'){postbasesList=postbasesList.concat(['@~-ki\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["r" /* optative_intransitive_endings */][person][people]]);}else if(moodSpecific==='You, stop!'){postbasesList=postbasesList.concat(['@~+(t)viiqna\\']);postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["r" /* optative_intransitive_endings */][person][people]]);}else if(moodSpecific==='You, do not!'){if(person===2){postbasesList=postbasesList.concat(['@~+yaquna\\']);}else{postbasesList=postbasesList.concat(['-nrilki\\']);}postbasesList=postbasesList.concat([__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["r" /* optative_intransitive_endings */][person][people]]);}}}//post process  '+(t)vtek', => '+(t)vetek' if preceding postbase ends in consonant
if(moodSpecific==='do (in the future)!'&&this.state.objectExists===false&&person===2&&people===1){postbasesList[postbasesList.length-1]='+na';}if(moodSpecific==='do (in the future)!'&&postbasesList[postbasesList.length-1]==='@+nga'){postbasesList[postbasesList.length-1]='@+a';}if(moodSpecific==='You, do not!'&&this.state.objectExists===false&&person===2&&people===1){postbasesList[postbasesList.length-1]='@+k';}else if(moodSpecific==='You, stop!'&&this.state.objectExists===false&&person===2&&people===1){postbasesList[postbasesList.length-1]='@+k';}else if(moodSpecific==='You, do not!'&&this.state.objectExists===true&&person===2&&people===1&&objectPerson===3&&objectPeople===1){postbasesList[postbasesList.length-1]='@+ku';}else if(moodSpecific==='You, stop!'&&this.state.objectExists===true&&person===2&&people===1&&objectPerson===3&&objectPeople===1){postbasesList[postbasesList.length-1]='@+ku';}else if(moodSpecific==='You, do not!'&&this.state.objectExists===true&&person===2&&people===1&&objectPerson===1&&objectPeople===1){postbasesList[postbasesList.length-1]='@+:(6)a';}if(postbasesList[postbasesList.length-1]==='+(t)vtek'){var k=postbasesList[postbasesList.length-2];k=k[k.length-2];// console.log(k)
if(k!=='a'&&k!=='e'&&k!=='i'&&k!=='u'){postbasesList[postbasesList.length-1]='+(t)vetek';}}if(postbasesList[postbasesList.length-1]==='+(t)vci'){var _k=postbasesList[postbasesList.length-2];_k=_k[_k.length-2];if(_k!=='a'&&_k!=='e'&&_k!=='i'&&_k!=='u'){postbasesList[postbasesList.length-1]='+(t)veci';}}var added_word=Object(__WEBPACK_IMPORTED_MODULE_27__modifyWord_ModifyWordVerb_js__["a" /* addedWord */])(moodSpecific,this.state.objectExists,objectPeople,people);this.setState({postbasesList:postbasesList});var postbasesString="";postbasesList.forEach(function(e){postbasesString=postbasesString+"&postbase="+encodeURIComponent(e);});currentPostbases=currentPostbases.reverse();//process the ^himself^ ^his^ etc. cases
var betweencarrots=/\^([^\]]+)\^/;// regex to match (text)
var pronoun=newText3.match(betweencarrots);var pronountype='';if(pronoun){if(pronoun[0]==='^himself^'||pronoun[0]==='^herself^'||pronoun[0]==='^itself^'){pronountype='self';}else if(pronoun[0]==='^his^'||pronoun[0]==='^her^'||pronoun[0]==='^its^'){pronountype='possessive';}else{pronountype='asis';}if(pronountype==='self'||pronountype==='possessive'){newText3=newText3.replace(pronoun[0],Object(__WEBPACK_IMPORTED_MODULE_27__modifyWord_ModifyWordVerb_js__["d" /* pronounEnding */])(value1,pronountype));}else{newText3=newText3.replace(pronoun[0],pronoun[1]);}}pronoun=englishEnding[0].match(betweencarrots);if(pronoun){if(pronoun[0]==='^himself^'||pronoun[0]==='^herself^'||pronoun[0]==='^itself^'){pronountype='self';}else if(pronoun[0]==='^his^'||pronoun[0]==='^her^'||pronoun[0]==='^its^'){pronountype='possessive';}else{pronountype='asis';}if(pronountype==='self'||pronountype==='possessive'){englishEnding[0]=englishEnding[0].replace(pronoun[0],Object(__WEBPACK_IMPORTED_MODULE_27__modifyWord_ModifyWordVerb_js__["d" /* pronounEnding */])(value1,pronountype));}else{englishEnding[0]=englishEnding[0].replace(pronoun[0],Object(__WEBPACK_IMPORTED_MODULE_27__modifyWord_ModifyWordVerb_js__["d" /* pronounEnding */])(value1,pronountype));}}var postbasesEnglishPhrase=postbasesEnglish.join(' ');var SubjecT=__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["f" /* retrieveSubjectObject */][this.state.value1];var ObjecT=__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["f" /* retrieveSubjectObject */][this.state.value2];if(ObjecT){ObjecT=__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["f" /* retrieveSubjectObject */][this.state.value2];}else{ObjecT='';}this.setState({fullEnglish:newText1+' '+newText1after+' '+SubjecT+' '+newText2+' '+newText2after+' '+postbasesEnglishPhrase+' '+englishEnding[0]+' '+ObjecT+' '+newText3+' '+newText3tense});// it -> its
// it -> it
// it -> itself
// he -> himself
// he -> his
// she -> her
// she -> herself
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__App_js__["a" /* API_URL */]+"/concat?root="+word.replace('-','')+postbasesString).then(function(response){// console.log(response.data);
_this5.setState({addedWord:added_word,modifiedWord:response.data.concat,modifiedEnglish:newEnglish,currentPostbases:currentPostbases,text1after:newText1after,text2after:newText2after,text1:newText1,text2:newText2,text3:newText3,text3tense:newText3tense,postbasesEnglish:postbasesEnglish,englishEnding:englishEnding,colorIndexes:response.data.indexes});});}// end of ModifyWordVerb
},{key:'modifyWordNoun',value:function modifyWordNoun(person,people,possessorPerson,possessorPeople,mood,moodSpecific,nounEnding,verbEnding,value4,word,currentPostbases){var _this6=this;// console.log(word,word.includes('\u{304}'),word.replace('\u{304}',''))
// console.log(word)
if(value4!==1||possessorPeople!==0||mood!=='absolutive'||verbEnding===true||nounEnding===true||currentPostbases.length>0){word=this.state.usage;}word=word.replace('\u0304','').replace('\u0361','');currentPostbases=currentPostbases.sort(function(p1,p2){return __WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p1].priority>__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p2].priority?1:__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p1].priority<__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p2].priority?-1:0;});currentPostbases=currentPostbases.reverse();var newEnglish=this.state.entry.definition;var newText1='';var newText2=this.state.entry.definition;var newText3='';var postbasesList=[];var base='';if(currentPostbases.length===1||currentPostbases.length===0){base=word;}else{base=__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][currentPostbases[0]].expression_postbase;}console.log(currentPostbases);var processPostbases=__WEBPACK_IMPORTED_MODULE_28__modifyWord_ModifyWordNoun_js__["b" /* processPostbases */];var endingPostbase=[];if(possessorPerson>0){postbasesList=processPostbases(currentPostbases,base,__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */]);postbasesList=postbasesList.concat(Object(__WEBPACK_IMPORTED_MODULE_28__modifyWord_ModifyWordNoun_js__["c" /* returnEnding */])(postbasesList,value4,possessorPerson,possessorPeople,mood));}else if(verbEnding){postbasesList=processPostbases(currentPostbases,base,__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */]);postbasesList=postbasesList.concat(__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["l" /* indicative_intransitive_endings */][person][people]);}else if(value4!==1){postbasesList=processPostbases(currentPostbases,base,__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */]);postbasesList=postbasesList.concat(Object(__WEBPACK_IMPORTED_MODULE_28__modifyWord_ModifyWordNoun_js__["c" /* returnEnding */])(postbasesList,value4,possessorPerson,possessorPeople,mood));}else{if(currentPostbases.length>0&&verbEnding){postbasesList=processPostbases(currentPostbases,base,__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */]);postbasesList=postbasesList.concat(__WEBPACK_IMPORTED_MODULE_23__constants_constants_verbs_js__["l" /* indicative_intransitive_endings */][person][people]);}else if(currentPostbases.length>0&&mood==='absolutive'){var lastPostbase=currentPostbases[currentPostbases.length-1];var remainingPostbases=currentPostbases.slice(0,[currentPostbases.length-1]);postbasesList=processPostbases(remainingPostbases,base,__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */]);postbasesList=postbasesList.concat(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][lastPostbase].expression_end);//make smarter
}else{postbasesList=processPostbases(currentPostbases,base,__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */]);postbasesList=postbasesList.concat(Object(__WEBPACK_IMPORTED_MODULE_28__modifyWord_ModifyWordNoun_js__["c" /* returnEnding */])(postbasesList,value4,possessorPerson,possessorPeople,mood));}}console.log(currentPostbases);var added_word='';var adder='';var adjectivesEnglish=[];var nounEndingEnglish=[];var verbEndingEnglish=[];var getsubjectis=__WEBPACK_IMPORTED_MODULE_28__modifyWord_ModifyWordNoun_js__["a" /* getsubjectis */];if(currentPostbases.length>0){currentPostbases.forEach(function(p){adder='';if(p>-1&&p<7){adjectivesEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p].englishModifier(adder));}else if(p>6&&p<11){nounEndingEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p].englishModifier(adder));}else if(p===14||p===21||p===17){verbEndingEnglish.push(getsubjectis(true,people,person)+' '+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p].englishModifier(adder));}else if(p===18||p===19){verbEndingEnglish.push(__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p].englishModifier(adder));_this6.setState({value1:'31-3(1)',person:3,people:1});person=3;people=1;}else{verbEndingEnglish.push(getsubjectis(false,people,person)+' '+__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */][p].englishModifier(adder));}});}this.setState({postbasesList:postbasesList});var postbasesString="";postbasesList.forEach(function(e){postbasesString=postbasesString+"&postbase="+encodeURIComponent(e);});currentPostbases=currentPostbases.reverse();__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_8__App_js__["a" /* API_URL */]+"/concat?root="+word.replace('-','')+postbasesString).then(function(response){_this6.setState({modifiedWord:added_word+response.data.concat,modifiedEnglish:newEnglish,currentPostbases:currentPostbases,text1:newText1,text2:newText2,text3:newText3,adjectivesEnglish:adjectivesEnglish,nounEndingEnglish:nounEndingEnglish,verbEndingEnglish:verbEndingEnglish,colorIndexes:response.data.indexes});});}// end of ModifyWordNoun
},{key:'render',value:function render(){var _this7=this;console.log('YupikModifyLayout state',this.state);var dict1=[];var dict2=[];var dict3=[];var _state2=this.state,verb=_state2.verb,value1=_state2.value1,value2=_state2.value2,value3=_state2.value3,id1=_state2.id1,mood=_state2.mood,possessiveObject=_state2.possessiveObject,objectExists=_state2.objectExists;Object(__WEBPACK_IMPORTED_MODULE_30__modifyWord_removeCombos_js__["a" /* removeCombos */])(dict1,dict2,dict3,verb,value1,value2,mood,possessiveObject,objectExists);var countEndingPostbase=this.state.postbasesList.length-this.state.currentPostbases.length;var postbasesDisplay='';var wordDisplay='';var updatedPostbasesList=[];var nounType='';if(this.verb||!this.state.verbEnding){postbasesDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.currentWord),this.state.postbasesList.slice(0,this.state.postbasesList.length-countEndingPostbase).map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,style:{color:_this7.state.colorsList[2+_this7.state.postbasesList.length-countEndingPostbase-i]}},' '+p.replace('\\','-'));}),this.state.postbasesList.slice(this.state.postbasesList.length-countEndingPostbase).map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,style:{color:'#852828'}},' '+p);// change to 2-i for other color
}));wordDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.colorIndexes.map(function(index,i){if(i===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},_this7.state.modifiedWord.substring(_this7.state.colorIndexes[i],_this7.state.colorIndexes[i+1]));}else if(i<_this7.state.colorIndexes.length-countEndingPostbase){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,style:{color:_this7.state.colorsList[2+_this7.state.colorIndexes.length-countEndingPostbase-i]}},_this7.state.modifiedWord.substring(_this7.state.colorIndexes[i],_this7.state.colorIndexes[i+1]));}else if(i===_this7.state.colorIndexes.length-countEndingPostbase){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,style:{color:'#852828'}},_this7.state.modifiedWord.substring(_this7.state.colorIndexes[i]));}}));}else{postbasesDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.usage),this.state.postbasesList.slice(0,this.state.postbasesList.length-countEndingPostbase-1).map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this7.state.colorsList[2+_this7.state.postbasesList.length-countEndingPostbase-i]}},' '+p.replace('\\','-'));}),this.state.postbasesList.slice(this.state.postbasesList.length-countEndingPostbase-1).map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},' '+p);}));wordDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.colorIndexes.map(function(index,i){if(i===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,_this7.state.modifiedWord.substring(_this7.state.colorIndexes[i],_this7.state.colorIndexes[i+1]));}else if(i<_this7.state.colorIndexes.length-countEndingPostbase-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this7.state.colorsList[2+_this7.state.colorIndexes.length-countEndingPostbase-i]}},_this7.state.modifiedWord.substring(_this7.state.colorIndexes[i],_this7.state.colorIndexes[i+1]));}else if(i===_this7.state.colorIndexes.length-countEndingPostbase-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},_this7.state.modifiedWord.substring(_this7.state.colorIndexes[i]));}}));}//this.state.colorsList[2] changed to '#852828'
//MAKE MORE SUCCINCT, also assumes in the future only one time postbase at a time
var timeIndex='';console.log(this.state.currentPostbases);if(this.state.currentPostbases.includes(5)){timeIndex=this.state.currentPostbases.indexOf(5);}else if(this.state.currentPostbases.includes(7)){timeIndex=this.state.currentPostbases.indexOf(7);}else if(this.state.currentPostbases.includes(8)){timeIndex=this.state.currentPostbases.indexOf(8);}else if(this.state.currentPostbases.includes(9)){timeIndex=this.state.currentPostbases.indexOf(9);}// console.log(timeIndex)
var colorIndexMax=2+this.state.colorIndexes.length-this.state.postbasesList.length-this.state.currentPostbases.length;//
var nounEndingcounter=0;var verbEndingcounter=0;if(this.state.nounEndingEnglish!==''){nounEndingcounter=1;}if(this.state.verbEnding){verbEndingcounter=-1;}// console.log(this.state.adjectivesEnglish)
var yupikAllPostbasesProps={'mood':this.state.mood,'nounEnding':this.state.nounEnding,'moodSpecific':this.state.moodSpecific,'allowable_next_ids':this.state.allowable_next_ids,'currentPostbases':this.state.currentPostbases,'verbEnding':this.state.verbEnding,'value4':this.state.value4,'possessiveButton':this.state.possessiveButton,'setMood':this.setMood.bind(this),'setNounEnding':this.setNounEnding.bind(this),'setPostbase':this.setPostbase.bind(this),'setEnclitic':this.setEnclitic.bind(this),'setValue4':this.setValue4.bind(this),'setPossessiveButton':this.setPossessiveButton.bind(this),'enclitic':this.state.enclitic};var fixedStyle={position:'fixed',margin:'auto',top:'5.9em',zIndex:100,backgroundColor:'white',left:0,right:0,width:'100%'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_StickyMenu_js__["a" /* default */],Object.assign({displaySimple:false,word:this.state.currentWord,goBack:this.props.history.goBack,switchMode:this.switchMode},this.props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["e" /* Container */],{attached:'true',style:{paddingTop:'8em'},onClick:function onClick(){if(_this7.state.displayPostbases){_this7.setState({displayPostbases:false});}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["E" /* Visibility */],{onTopPassed:function onTopPassed(){console.log('top passed!');_this7.setState({headerFixed:true});},onTopPassedReverse:function onTopPassedReverse(){console.log('top reverse passed!');_this7.setState({headerFixed:false});},once:false,offset:[150,150]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */],{style:this.state.headerFixed?fixedStyle:{top:'1em'}},this.state.displayPostbases?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,{style:{padding:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["m" /* Header */],{as:'h5'},postbasesDisplay))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{verticalAlign:'middle',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["m" /* Header */],{textAlign:'center',as:'h1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{onClick:this.setDisplayPostbases.bind(this),style:{cursor:'pointer',backgroundColor:this.state.displayPostbases?'#b3c3db':'white'}},this.state.addedWord!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},this.state.addedWord):'',this.state.enclitic!==''&&this.state.mood==='interrogative'?this.state.enclitic+' ':' ',wordDisplay,this.state.enclitic!==''&&this.state.encliticExpression!=='(again)'&&this.state.mood==='indicative'?this.state.enclitic:'',this.state.enclitic==='-qaa'?'?':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},this.state.mood==='interrogative'?'?':'','',this.verb||this.state.currentPostbases.length===0&&this.state.mood==='absolutive'&&this.state.value4===1&&this.state.possessiveButton===0?this.state.loadingTTS?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["t" /* Loader */],{inline:true,active:true}):this.state.canTTS?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',size:'small',onClick:this.speak.bind(this),link:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */].Group,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'ban',color:'grey'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'volume up',color:'black',size:'tiny'})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://goo.gl/forms/be5L5cgSQmCJeVDl1',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{inverted:true,name:'exclamation circle',color:'grey',size:'small'})))))),this.verb?this.state.nounEnding!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{verticalAlign:'middle',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["m" /* Header */],{as:'h4',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},this.state.text2),' ',this.state.text2after,' ',this.state.postbasesEnglish.map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this7.state.colorsList[3+i]}},' '+p);}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.englishEnding[0]),' ',this.state.text3,' ',timeIndex!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:this.state.colorsList[3+timeIndex]}},this.state.text3tense):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},this.state.text3tense)))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{verticalAlign:'middle',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["m" /* Header */],{as:'h4',align:'center'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},this.state.text1),' ',timeIndex!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:this.state.colorsList[3+timeIndex]}},this.state.text1after):this.state.text1after,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828',background:'#e0e0e0',paddingLeft:2,paddingRight:0,paddingTop:5,paddingBottom:5,borderRadius:5,borderWidth:1,borderColor:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,options:dict1,onChange:this.setValue1.bind(this),value:value1})),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},this.state.text2),' ',timeIndex!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:this.state.colorsList[3+timeIndex]}},this.state.text2after):this.state.text2after,' ',this.state.postbasesEnglish.map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this7.state.colorsList[3+i]}},' '+p);}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.englishEnding[0]),' ',this.state.objectExists&&this.state.moodSpecific!=='who'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828',background:'#e0e0e0',paddingLeft:2,paddingRight:0,paddingTop:5,paddingBottom:5,borderRadius:5,borderWidth:1,borderColor:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,options:dict2,onChange:this.setValue2.bind(this),value:value2})):'',this.state.objectExists&&this.state.moodSpecific==='who'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},'(',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Dropdown */],{inline:true,scrolling:true,options:dict2,onChange:this.setValue2.bind(this),value:value2}),')'):'',' ',this.state.text3,' ',timeIndex!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:this.state.colorsList[3+timeIndex]}},this.state.text3tense):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},this.state.text3tense),this.state.encliticExpression!==''?this.state.encliticExpression:'',this.state.mood==='optative'?'!':''))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,{verticalAlign:'middle',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["m" /* Header */],{as:'h4',align:'center'},this.state.verbEnding?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Dropdown */],{scrolling:true,style:{color:'#852828',background:'#e0e0e0',paddingLeft:2,paddingRight:0,paddingTop:5,paddingBottom:5,borderRadius:5,borderWidth:1,borderColor:'#fff'},inline:true,options:dict1,onChange:this.setValue1.bind(this),value:value1})):'',' ',this.state.possessiveButton===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["h" /* Dropdown */],{scrolling:true,style:{color:'#852828',background:'#e0e0e0',paddingLeft:2,paddingRight:0,paddingTop:5,paddingBottom:5,borderRadius:5,borderWidth:1,borderColor:'#fff'},inline:true,options:dict3,onChange:this.setValue3.bind(this),value:value3})):'',this.state.verbEndingEnglish!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},this.state.verbEndingEnglish):'',this.state.adjectivesEnglish.reverse().map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:_this7.state.colorsList[3+i+nounEndingcounter-verbEndingcounter]}},' '+p);}),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.text2),' ',this.state.nounEndingEnglish!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:this.state.colorsList[3-verbEndingcounter]}},this.state.nounEndingEnglish):'',' ',this.state.verbEnding===false&&this.state.value4===1?'':'',this.state.verbEnding===false&&this.state.value4===2&&this.state.nounEnding!=='many of them'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},'(two of them)'):'',this.state.verbEnding===false&&this.state.value4===3&&this.state.nounEnding!=='many of them'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#852828'}},'(three or more)'):''))),this.verb&&this.state.alternateTense!==''&&this.state.mood==='indicative'&&this.state.currentPostbases.length===0&&this.state.person!==1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["m" /* Header */],{color:'grey',fontStyle:'italic',as:'h5',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,' also ',this.state.alternateTense,' tense ')))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,{textAlign:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,null,this.state.currentPostbases.length>0||this.verb&&this.state.mood!=='indicative'||this.verb===false&&this.state.mood!=='absolutive'||this.state.possessiveButton===1||this.state.enclitic!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */],{horizontal:true},this.state.mood!=='absolutive'&&this.verb===false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{onClick:function onClick(event){return _this7.setMoodNoun(_this7.state.mood,event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_Chip_js__["a" /* default */],{text:this.state.mood})):'',this.state.possessiveButton===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{onClick:function onClick(event){return _this7.setPossessiveButton(1,event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_Chip_js__["a" /* default */],{text:'possessive'})):'',this.state.mood==='optative'||this.state.mood==='interrogative'||this.state.mood==='connective_precessive'||this.state.mood==='connective_consequential'||this.state.mood==='connective_contingent'||this.state.mood==='connective_concessive'||this.state.mood==='connective_conditional'||this.state.mood==='connective_first_contemporative'||this.state.mood==='connective_second_contemporative'||this.state.mood==='subordinative'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{onClick:function onClick(event){return _this7.setMoodVerb(_this7.state.mood,_this7.state.moodSpecific,event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_Chip_js__["a" /* default */],{text:this.state.moodSpecific})):'',this.state.mood==='nounEnding'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{onClick:function onClick(event){return _this7.setNounEnding(_this7.state.nounEnding,event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_Chip_js__["a" /* default */],{text:this.state.nounEnding})):'',this.state.enclitic!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{onClick:function onClick(event){return _this7.setEnclitic(_this7.state.enclitic,_this7.state.encliticExpression,event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_Chip_js__["a" /* default */],{text:this.state.encliticExpression})):'',this.state.currentPostbases.map(function(index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{onClick:function onClick(event){return _this7.setPostbase(index,event);}},_this7.verb?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_Chip_js__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["e" /* postbases */].find(function(p){return p.id===index;}).description}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_Chip_js__["a" /* default */],{text:__WEBPACK_IMPORTED_MODULE_21__constants_constants_js__["a" /* nounPostbases */].find(function(p){return p.id===index;}).description}));}),this.state.allPostbasesMode===false&&this.verb&&this.state.currentPostbases.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Icon,{circular:true,name:'lock',onClick:this.allPostbasesMode.bind(this)})):'',this.state.allPostbasesMode===true&&this.verb&&this.state.currentPostbases.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Icon,{circular:true,name:'lock open',onClick:this.allPostbasesMode.bind(this)})):''):'')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["E" /* Visibility */],{onTopVisibleReverse:function onTopVisibleReverse(){console.log('top visible!');_this7.setState({headerFixed:false});},offset:this.state.headerFixed?[300,0]:[300,0]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.state.headerFixed?{paddingTop:this.state.displayPostbases?'15em':'12em'}:{paddingTop:'1.5em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/noun',component:__WEBPACK_IMPORTED_MODULE_9__YupikModifyNoun_js__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/noun/all',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__yupikNoun_YupikAllNounPostbases_js__["a" /* default */],Object.assign({},props,yupikAllPostbasesProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/noun/descriptors',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__yupikNoun_YupikNounDescriptors_js__["a" /* default */],Object.assign({},props,yupikAllPostbasesProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/noun/phrase',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__yupikNoun_YupikNounPhrase_js__["a" /* default */],Object.assign({},props,yupikAllPostbasesProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/noun/combine',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__yupikNoun_YupikNounCombine_js__["a" /* default */],Object.assign({},props,yupikAllPostbasesProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/verb',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__YupikModifyVerb_js__["a" /* default */],Object.assign({},props,{advancedMode:_this7.props.advancedMode},yupikAllPostbasesProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/verb/all',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__yupikPostbase_YupikAllPostbases_js__["a" /* default */],Object.assign({},props,yupikAllPostbasesProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/verb/ending',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__yupikEnding_YupikEndingGroups_js__["a" /* default */],Object.assign({},props,yupikAllPostbasesProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/verb/ending/:ending_group_id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__yupikEnding_YupikEnding_js__["a" /* default */],Object.assign({},props,yupikAllPostbasesProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/verb/ending/:ending_group_id/postbase',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__yupikPostbase_YupikPostbaseGroups_js__["a" /* default */],Object.assign({},props,yupikAllPostbasesProps));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Route */],{exact:true,path:this.props.match.path+'/verb/ending/:ending_group_id/postbase/:postbase_group_id',render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__yupikPostbase_YupikPostbase_js__["a" /* default */],Object.assign({},props,yupikAllPostbasesProps));}})))));}}]);return YupikModifyLayout;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{advancedMode:state.allPostbases.allPostbasesMode};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_25_react_redux__["b" /* connect */])(mapStateToProps,{toggleAllPostbases:__WEBPACK_IMPORTED_MODULE_26__redux_actions__["a" /* toggleAllPostbases */]})(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* withRouter */])(YupikModifyLayout)));

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikModifyNoun=function(_Component){_inherits(YupikModifyNoun,_Component);function YupikModifyNoun(){_classCallCheck(this,YupikModifyNoun);return _possibleConstructorReturn(this,(YupikModifyNoun.__proto__||Object.getPrototypeOf(YupikModifyNoun)).apply(this,arguments));}_createClass(YupikModifyNoun,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */],{divided:true,selection:true,size:'huge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{as:__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],to:this.props.match.url+'/descriptors'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'10px'},color:'teal',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,{verticalAlign:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,name:'book'}),'Add adjectives or descriptors')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{as:__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],to:this.props.match.url+'/phrase'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'10px'},color:'teal',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,{verticalAlign:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,name:'talk'}),'Use it in a verb phrase')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Item,{as:__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],to:this.props.match.url+'/combine'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'10px'},color:'teal',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["r" /* List */].Content,{verticalAlign:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{circular:true,name:'cogs'}),'Change noun ending to combine with other words')));}}]);return YupikModifyNoun;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (YupikModifyNoun);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_constants_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikModifyVerb=function(_Component){_inherits(YupikModifyVerb,_Component);function YupikModifyVerb(){_classCallCheck(this,YupikModifyVerb);return _possibleConstructorReturn(this,(YupikModifyVerb.__proto__||Object.getPrototypeOf(YupikModifyVerb)).apply(this,arguments));}_createClass(YupikModifyVerb,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["l" /* Grid */].Column,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Card */].Group,{itemsPerRow:3,stackable:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(event){return _this2.props.setPostbase(5,event);},toggle:true,disabled:this.props.currentPostbases.indexOf(7)>=0,active:this.props.currentPostbases.indexOf(5)>=0},__WEBPACK_IMPORTED_MODULE_4__constants_constants_js__["e" /* postbases */][5].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(event){return _this2.props.setPostbase(7,event);},toggle:true,disabled:this.props.currentPostbases.indexOf(5)>=0,active:this.props.currentPostbases.indexOf(7)>=0},__WEBPACK_IMPORTED_MODULE_4__constants_constants_js__["e" /* postbases */][7].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(event){return _this2.props.setPostbase(25,event);},toggle:true,active:this.props.currentPostbases.indexOf(25)>=0},__WEBPACK_IMPORTED_MODULE_4__constants_constants_js__["e" /* postbases */][25].description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{onClick:function onClick(event){return _this2.props.setPostbase(27,event);},toggle:true,active:this.props.currentPostbases.indexOf(27)>=0},__WEBPACK_IMPORTED_MODULE_4__constants_constants_js__["e" /* postbases */][27].description)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'1em'}},this.props.advancedMode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:this.props.match.url+'/all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{primary:true,fluid:true,attached:'bottom',icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'plus'}),'More')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:this.props.match.url+'/ending'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{primary:true,fluid:true,attached:'bottom',icon:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'plus'}),'More')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center',paddingTop:'20px','fontStyle':'italic',color:'gray'}},' Note: iliitni alartuq - sometimes there are mistakes ')));}}]);return YupikModifyVerb;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (YupikModifyVerb);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifyWord_modifyVerbOptions_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikEnding=function(_Component){_inherits(YupikEnding,_Component);function YupikEnding(){_classCallCheck(this,YupikEnding);return _possibleConstructorReturn(this,(YupikEnding.__proto__||Object.getPrototypeOf(YupikEnding)).apply(this,arguments));}_createClass(YupikEnding,[{key:'render',value:function render(){var _this2=this;var options={0:__WEBPACK_IMPORTED_MODULE_2__modifyWord_modifyVerbOptions_js__["c" /* interrogative */],1:__WEBPACK_IMPORTED_MODULE_2__modifyWord_modifyVerbOptions_js__["d" /* optative */],2:__WEBPACK_IMPORTED_MODULE_2__modifyWord_modifyVerbOptions_js__["a" /* dependent */],3:__WEBPACK_IMPORTED_MODULE_2__modifyWord_modifyVerbOptions_js__["f" /* verb2noun */]};var group_id=this.props.match.params.ending_group_id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Card */].Group,{stackable:true,itemsPerRow:3},options[group_id].map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["c" /* Card */],null,group_id===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){return _this2.props.setNounEnding(e.ending);},toggle:true,active:_this2.props.nounEnding===e.ending},e.text):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){group_id===3?_this2.props.setNounEnding(e.ending):_this2.props.setMood(e.group,e.mood);_this2.props.history.push(_this2.props.match.url+'/postbase');},toggle:true,active:group_id===3?_this2.props.nounEnding===e.ending:_this2.props.moodSpecific===e.mood},e.mood));})));}}]);return YupikEnding;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikEnding);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikEndingGroups=function(_Component){_inherits(YupikEndingGroups,_Component);function YupikEndingGroups(){_classCallCheck(this,YupikEndingGroups);return _possibleConstructorReturn(this,(YupikEndingGroups.__proto__||Object.getPrototypeOf(YupikEndingGroups)).apply(this,arguments));}_createClass(YupikEndingGroups,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["z" /* Segment */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */],{divided:true,selection:true,size:'huge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{as:__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],to:this.props.match.url+'/0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'10px'},color:'teal',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{verticalAlign:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{circular:true,name:'help'}),'Question form')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{as:__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],to:this.props.match.url+'/1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'10px'},color:'teal',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{verticalAlign:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{circular:true,name:'talk'}),'Make a command')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{as:__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],to:this.props.match.url+'/2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'10px'},color:'teal',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{verticalAlign:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{circular:true,name:'time'}),'Connective endings')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{as:__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],to:this.props.match.url+'/3'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'10px'},color:'teal',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{verticalAlign:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{circular:true,name:'clone'}),'Noun forms')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Item,{as:__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],to:this.props.match.url+'/4/postbase'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'10px'},color:'teal',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["r" /* List */].Content,{verticalAlign:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{circular:true,name:'map signs'}),'Postbases Only'))));}}]);return YupikEndingGroups;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikEndingGroups);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifyWord_modifyVerbOptions_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(16);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikPostbaseGroups=function(_Component){_inherits(YupikPostbaseGroups,_Component);function YupikPostbaseGroups(){_classCallCheck(this,YupikPostbaseGroups);return _possibleConstructorReturn(this,(YupikPostbaseGroups.__proto__||Object.getPrototypeOf(YupikPostbaseGroups)).apply(this,arguments));}_createClass(YupikPostbaseGroups,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["z" /* Segment */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["r" /* List */],{divided:true,selection:true,size:'huge'},__WEBPACK_IMPORTED_MODULE_2__modifyWord_modifyVerbOptions_js__["e" /* postbaseButtons */].map(function(group){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["r" /* List */].Item,{as:__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],to:_this2.props.match.url+'/'+group.activeIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["r" /* List */].Content,{floated:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{style:{paddingTop:'10px'},color:'teal',name:'chevron right'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["r" /* List */].Content,{verticalAlign:'middle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_semantic_ui_react__["n" /* Icon */],{circular:true,name:group.icon}),group.text));})));}}]);return YupikPostbaseGroups;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikPostbaseGroups);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_constants_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikPostbase=function(_Component){_inherits(YupikPostbase,_Component);function YupikPostbase(){_classCallCheck(this,YupikPostbase);return _possibleConstructorReturn(this,(YupikPostbase.__proto__||Object.getPrototypeOf(YupikPostbase)).apply(this,arguments));}_createClass(YupikPostbase,[{key:'render',value:function render(){var _this2=this;var group_id=this.props.match.params.postbase_group_id;// console.log(postbaseButtons, group_id);
// postbaseButtons.forEach((p) => { console.log(p, p.activeIndex, p.activeIndex == group_id, p.activeIndex == parseInt(group_id)); })
// console.log(postbaseButtons.filter((p) => { p.activeIndex == parseInt(group_id) }))
// console.log(postbaseButtons[0].activeIndex)
var group=void 0;for(var i=0;i<__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["e" /* postbaseButtons */].length;i++){if(__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["e" /* postbaseButtons */][i].activeIndex===parseInt(group_id)){group=__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["e" /* postbaseButtons */][i];}}// let group = postbaseButtons.find((p) => { return postbaseButtons.activeIndex === group_id });
// console.log(group)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{stackable:true,itemsPerRow:3},group.indexes.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:function onClick(event){_this2.props.setPostbase(e,event);},toggle:true,disabled:_this2.props.allowable_next_ids.indexOf(e)>=0,active:_this2.props.currentPostbases.indexOf(e)>=0},__WEBPACK_IMPORTED_MODULE_4__constants_constants_js__["e" /* postbases */][e].description));}));}}]);return YupikPostbase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikPostbase);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_constants_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikAllPostbases=function(_Component){_inherits(YupikAllPostbases,_Component);function YupikAllPostbases(props){_classCallCheck(this,YupikAllPostbases);var _this=_possibleConstructorReturn(this,(YupikAllPostbases.__proto__||Object.getPrototypeOf(YupikAllPostbases)).call(this,props));_this.state={};_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(YupikAllPostbases,[{key:'handleClick',value:function handleClick(e,titleProps){var index=titleProps.index;var activeIndex=this.state.activeIndex;var newIndex=activeIndex===index?-1:index;this.setState({activeIndex:newIndex});}},{key:'render',value:function render(){var _this2=this;var question_forms=this.state.activeIndex===0||this.props.mood==='interrogative';var make_a_command=this.state.activeIndex===1||this.props.mood==='optative';var connective_endings=this.state.activeIndex===2||this.props.mood[0]==='c'||this.props.mood[0]==='s';var noun_forms=this.state.activeIndex===3||this.props.nounEnding!=='';// let is_enclitics = true;
// console.log(enclitics)
// let is_enclitics = this.state.activeIndex === enclitics[this.props.mood].activeIndex;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{paddingBottom:'2em'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],{fluid:true,styled:true,exclusive:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:question_forms,index:0,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Question forms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:question_forms},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{itemsPerRow:3,stackable:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){return _this2.props.setEnclitic('-qaa','(yes or no?)');},toggle:true,active:this.props.enclitic==='-qaa'},'Yes or no?')),__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["c" /* interrogative */].map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{key:e.mood},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){return _this2.props.setMood(e.group,e.text);},toggle:true,active:_this2.props.moodSpecific===e.mood},e.mood));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:make_a_command,index:1,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Make a command'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:make_a_command},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{itemsPerRow:3,stackable:true},__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["d" /* optative */].map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{key:e.mood},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){return _this2.props.setMood(e.group,e.mood);},toggle:true,active:_this2.props.moodSpecific===e.mood},e.mood));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:connective_endings,index:2,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Connective endings'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:connective_endings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{itemsPerRow:3,stackable:true},__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["a" /* dependent */].map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{key:e.mood},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){return _this2.props.setMood(e.group,e.mood);},toggle:true,active:_this2.props.moodSpecific===e.mood},e.mood));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:noun_forms,index:3,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Noun forms'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:noun_forms},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{itemsPerRow:3,stackable:true},__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["f" /* verb2noun */].map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{key:e.text},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){return _this2.props.setNounEnding(e.ending);},toggle:true,active:_this2.props.nounEnding===e.ending},e.text));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{align:'center'},'Postbases:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["g" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],{styled:true},__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["e" /* postbaseButtons */].map(function(group){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:group.text},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:_this2.state.activeIndex===group.activeIndex,index:group.activeIndex,onClick:_this2.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),group.text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:_this2.state.activeIndex===group.activeIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{itemsPerRow:3,stackable:true},group.indexes.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{key:e},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:function onClick(event){return _this2.props.setPostbase(e,event);},disabled:_this2.props.allowable_next_ids.indexOf(e)>=0,toggle:true,active:_this2.props.currentPostbases.indexOf(e)>=0},__WEBPACK_IMPORTED_MODULE_4__constants_constants_js__["e" /* postbases */][e].description));}))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["g" /* Divider */],null),this.props.mood==='indicative'||this.props.mood==='interrogative'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */],{styled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Title,{active:this.state.activeIndex===__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["b" /* enclitics */][this.props.mood].activeIndex,index:__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["b" /* enclitics */][this.props.mood].activeIndex,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'dropdown'}),'Enclitics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["a" /* Accordion */].Content,{active:this.state.activeIndex===__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["b" /* enclitics */][this.props.mood].activeIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{itemsPerRow:3,stackable:true},__WEBPACK_IMPORTED_MODULE_3__modifyWord_modifyVerbOptions_js__["b" /* enclitics */][this.props.mood].items.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */],{key:e.text},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["b" /* Button */],{onClick:function onClick(){return _this2.props.setEnclitic(e.ending,e.meaning);},toggle:true,active:_this2.props.enclitic===e.ending},e.text));})))):'');}}]);return YupikAllPostbases;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikAllPostbases);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__YupikNounHowMany_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__YupikNounPossessor_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__YupikNounNounPostbases_js__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__YupikNounEndingMoods_js__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__YupikNounVerbPostbases_js__ = __webpack_require__(462);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikAllNounPostbases=function(_Component){_inherits(YupikAllNounPostbases,_Component);function YupikAllNounPostbases(){_classCallCheck(this,YupikAllNounPostbases);return _possibleConstructorReturn(this,(YupikAllNounPostbases.__proto__||Object.getPrototypeOf(YupikAllNounPostbases)).apply(this,arguments));}_createClass(YupikAllNounPostbases,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,null,this.props.verbEnding===false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__YupikNounHowMany_js__["a" /* default */],this.props):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__YupikNounPossessor_js__["a" /* default */],this.props))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__YupikNounNounPostbases_js__["a" /* default */],this.props))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Column,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__YupikNounEndingMoods_js__["a" /* default */],this.props))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["l" /* Grid */].Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__YupikNounVerbPostbases_js__["a" /* default */],this.props)));}}]);return YupikAllNounPostbases;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikAllNounPostbases);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__YupikNounHowMany_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__YupikNounPossessor_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__YupikNounNounPostbases_js__ = __webpack_require__(460);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikNounDescriptors=function(_Component){_inherits(YupikNounDescriptors,_Component);function YupikNounDescriptors(){_classCallCheck(this,YupikNounDescriptors);return _possibleConstructorReturn(this,(YupikNounDescriptors.__proto__||Object.getPrototypeOf(YupikNounDescriptors)).apply(this,arguments));}_createClass(YupikNounDescriptors,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{centered:true},this.props.verbEnding===false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__YupikNounHowMany_js__["a" /* default */],this.props):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__YupikNounPossessor_js__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__YupikNounNounPostbases_js__["a" /* default */],this.props));}}]);return YupikNounDescriptors;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikNounDescriptors);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__YupikNounVerbPostbases_js__ = __webpack_require__(462);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikNounPhrase=function(_Component){_inherits(YupikNounPhrase,_Component);function YupikNounPhrase(){_classCallCheck(this,YupikNounPhrase);return _possibleConstructorReturn(this,(YupikNounPhrase.__proto__||Object.getPrototypeOf(YupikNounPhrase)).apply(this,arguments));}_createClass(YupikNounPhrase,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__YupikNounVerbPostbases_js__["a" /* default */],this.props);}}]);return YupikNounPhrase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikNounPhrase);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__YupikNounHowMany_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__YupikNounPossessor_js__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__YupikNounEndingMoods_js__ = __webpack_require__(461);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YupikNounCombine=function(_Component){_inherits(YupikNounCombine,_Component);function YupikNounCombine(){_classCallCheck(this,YupikNounCombine);return _possibleConstructorReturn(this,(YupikNounCombine.__proto__||Object.getPrototypeOf(YupikNounCombine)).apply(this,arguments));}_createClass(YupikNounCombine,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["c" /* Card */].Group,{centered:true},this.props.verbEnding===false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__YupikNounHowMany_js__["a" /* default */],this.props):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__YupikNounPossessor_js__["a" /* default */],this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__YupikNounEndingMoods_js__["a" /* default */],this.props));}}]);return YupikNounCombine;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (YupikNounCombine);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__semantic_dist_semantic_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//       <Label style={{backgroundColor:this.props.color, color:'white'}} horizontal as='a'>{this.props.text}<Icon name='delete' /></Label>
var Chip=function(_Component){_inherits(Chip,_Component);function Chip(){_classCallCheck(this,Chip);return _possibleConstructorReturn(this,(Chip.__proto__||Object.getPrototypeOf(Chip)).apply(this,arguments));}_createClass(Chip,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["q" /* Label */],{horizontal:true,as:'a'},this.props.text,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_semantic_ui_react__["n" /* Icon */],{name:'delete'}));}}]);return Chip;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Chip);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pronounEnding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getsubjectis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return processPostbases; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pushEnding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addedWord; });
var pronounEnding=function pronounEnding(value1,pronountype){if(pronountype==='self'){if(value1==='31-1(1)'){return'himself';}else if(value1==='31-2(1)'){return'herself';}else if(value1==='31-3(1)'){return'itself';}else if(value1==='21(1)'){return'yourself';}else if(value1==='22(1)'||value1==='23(1)'){return'yourselves';}else if(value1==="32(1)"||value1==="33(1)"){return'themselves';}else if(value1==='11(1)'){return'myself';}else if(value1==='12(1)'||value1==='13(1)'){return'ourselves';}}else if(pronountype==='possessive'){if(value1==='31-1(1)'){return'his';}else if(value1==='31-2(1)'){return'her';}else if(value1==='31-3(1)'){return'its';}else if(value1==='21(1)'){return'your';}else if(value1==='22(1)'||value1==='23(1)'){return'your';}else if(value1==="32(1)"||value1==="33(1)"){return'their';}else if(value1==='11(1)'){return'my';}else if(value1==='12(1)'||value1==='13(1)'){return'our';}}else if(pronountype==='asis'){if(value1==='31-1(1)'){return'he';}else if(value1==='31-2(1)'){return'she';}else if(value1==='31-3(1)'){return'it';}else if(value1==='21(1)'){return'you';}else if(value1==='22(1)'||value1==='23(1)'){return'you all';}else if(value1==="32(1)"||value1==="33(1)"){return'they';}else if(value1==='11(1)'){return'I';}else if(value1==='12(1)'||value1==='13(1)'){return'we';}}};var getsubjectis=function getsubjectis(currentPostbases,person,tenseN,peopleN,personN,doesN){var subjectis='';if(doesN==='does'){if(peopleN===1&&personN===3){if(tenseN==='past'){subjectis='did';}else if(tenseN==='future'){subjectis='will';}else{subjectis='does';}}else{subjectis='do';}}else if(doesN==='had'&&tenseN!=='future'){if(peopleN===1&&personN===3){subjectis='had';}else{subjectis='have';}}else if(doesN==='has'){if(tenseN==='future'){subjectis='have';}else if(tenseN==='past'){subjectis='had';}else{subjectis='has';}}else if(doesN==='be'){if(tenseN==='future'&&currentPostbases[0]!==23){subjectis=' be';}else{subjectis='';}}else if(doesN==='prewho'){if(peopleN===1&&person===1){subjectis='am';}else if(peopleN===1&&personN===3){subjectis='is';}else{subjectis='are';}}else if(tenseN==='present'){if(peopleN===1&&personN===1){subjectis='am';}else if(peopleN===1&&personN===3){subjectis='is';}else{subjectis='are';}}else if(tenseN==='past'){if(peopleN===1&&personN===1){subjectis='was';}else if(peopleN===1&&personN===3){subjectis='was';}else{subjectis='were';}}else if(tenseN==='future'){subjectis='will';}return subjectis;};var processPostbases=function processPostbases(currentPostbases,base,postbases,word){return currentPostbases.map(function(p,i){if(postbases[p].conditional_rule==='attaching_to_te'){if(currentPostbases.length===1||currentPostbases.length===0){base=word;}else{if(i!==0){base=postbases[currentPostbases[i-1]].expression;}else{base=word;}}if(base.slice(base.length-3,base.length-1)==='te'){return postbases[p].expression_conditional;}else{return postbases[p].expression;}}else{return postbases[p].expression;};});};var pushEnding=function pushEnding(infinitive_new_adj,gerund_new_adj,new_adj,englishEnding,thisMood,index){if(index===0){///FIX THIS!!!
if(thisMood==='i'){englishEnding.push(infinitive_new_adj);}else if(thisMood==='g'){englishEnding.push(gerund_new_adj);}else{englishEnding.push(new_adj);}}};var addedWord=function addedWord(moodSpecific,objectExists,objectPeople,people){var added_word='';if(moodSpecific==='who'&&objectExists){if(objectPeople===1){added_word='kina';}else if(objectPeople===2){added_word='kinkuk';}else{added_word='kinkut';}}else if(moodSpecific==='who'){if(people===1){added_word='kina';}else if(people===2){added_word='kinkuk';}else{added_word='kinkut';}}else if(moodSpecific==='when (in past)'){added_word='qangvaq';// newText2 = nlp(newText2).sentences().toPastTense().out()
}else if(moodSpecific==='when (in future)'){added_word='qaku';// newText2 = nlp(newText2).sentences().toFutureTense().out()
}else if(moodSpecific==='at where'){added_word='nani';}else if(moodSpecific==='from where'){added_word='naken';}else if(moodSpecific==='toward where'){added_word='natmun';}else if(moodSpecific==='why'){added_word='ciin';}else if(moodSpecific==='how'){added_word='qaillun';}else{added_word='';}return added_word;};

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return processPostbases; });
/* unused harmony export isvowel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return returnEnding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getsubjectis; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__ = __webpack_require__(463);
var _this=this;var processPostbases=function processPostbases(currentPostbases,base,nounPostbases){return currentPostbases.map(function(p){if(nounPostbases[p].conditional_rule==='attaching_to_te'){if(base.slice(base.length-3,base.length-1)==='te'){return nounPostbases[p].expression_conditional_postbase;}else{return nounPostbases[p].expression_postbase;}}else{return nounPostbases[p].expression_postbase;};});};var isvowel=function isvowel(l){if(l==='a'||l==='e'||l==='i'||l==='u'){return true;}else{return false;}};var returnEnding=function returnEnding(postbasesList,value4,possessorPerson,possessorPeople,mood){if(mood==='absolutive'){return[__WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__["b" /* absolutive_endings */][value4][possessorPerson][possessorPeople]];}else if(mood==='localis'){return[__WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__["p" /* localis_endings */][value4][possessorPerson][possessorPeople]];}else if(mood==='terminalis'){return[__WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__["w" /* terminalis_endings */][value4][possessorPerson][possessorPeople]];}else if(mood==='relative'){return[__WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__["t" /* relative_endings */][value4][possessorPerson][possessorPeople]];}else if(mood==='equalis'){return[__WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__["k" /* equalis_endings */][value4][possessorPerson][possessorPeople]];}else if(mood==='vialis'){if(value4===1&&possessorPerson===2&&possessorPeople===1&&postbasesList.length>1){if(isvowel(postbasesList[postbasesList.length-1][postbasesList[postbasesList.length-1].length-2])){return['-vkun'];}else{return[__WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__["x" /* vialis_endings */][value4][possessorPerson][possessorPeople]];}}else if(value4===1&&possessorPerson===2&&possessorPeople===1&&postbasesList.length===0){if(isvowel(_this.state.currentWord[_this.state.currentWord.length-1])){return['-vkun'];}else{return[__WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__["x" /* vialis_endings */][value4][possessorPerson][possessorPeople]];}}else{return[__WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__["x" /* vialis_endings */][value4][possessorPerson][possessorPeople]];}}else if(mood==='ablative'){return[__WEBPACK_IMPORTED_MODULE_0__constants_constants_verbs_js__["a" /* ablative_endings */][value4][possessorPerson][possessorPeople]];}};var getsubjectis=function getsubjectis(does,people,person){var subjectis='';if(does){if(people===1&&person===3){subjectis='has';}else{subjectis='have';}}else{if(people===1&&person===1){subjectis='am';}else if(people===1&&person===3){subjectis='is';}else{subjectis='are';}}return subjectis;};

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return processUsage; });
var processUsage=function processUsage(usage,event,data){var new_state={};var res=usage;var rx1=/\[([^\]]+)]/;// regex to match [text]
var rx2=/<([^\]]+)>/;// regex to match (text)
var subject=usage.match(rx1);var object=usage.match(rx2);if(subject!==null){res=res.split(rx1);new_state=Object.assign({},new_state,{subjectExists:true});if(res[1]==='he'){new_state=Object.assign({},new_state,{value1:"31-1(1)",people:1,person:3,text1:res[0]});}else if(res[1]==='she'){new_state=Object.assign({},new_state,{value1:"31-2(1)",people:1,person:3,text1:res[0]});}else if(res[1]==='it'){new_state=Object.assign({},new_state,{value1:"31-3(1)",people:1,person:3,text1:res[0]});}else if(res[1]==='his'){new_state=Object.assign({},new_state,{value1:"31-1(3)",people:1,person:3,text1:res[0],possessiveSubject:true});}else if(res[1]==='they'){new_state=Object.assign({},new_state,{value1:"33(1)",people:3,person:3,text1:res[0]});}else if(res[1]==='they2'){new_state=Object.assign({},new_state,{value1:"32(1)",people:2,person:3,text1:res[0]});}else if(res[1]==='he or it'){new_state=Object.assign({},new_state,{value1:"31-3(1)",people:1,person:3,text1:res[0]});}res=res[2];}if(object!==null){res=res.split(rx2);new_state=Object.assign({},new_state,{objectExists:true});if(res[1]==='it'){new_state=Object.assign({},new_state,{value2_text:"it",value2:"31-3(2)",objectPeople:1,objectPerson:3,text2:res[0],originalText2:res[0],text3:res[2],originalText3:res[2]});}else if(res[1]==='her or it'){new_state=Object.assign({},new_state,{value2_text:"it",value2:"31-3(2)",objectPeople:1,objectPerson:3,text2:res[0],originalText2:res[0],text3:res[2],originalText3:res[2]});}else if(res[1]==='him or it'){new_state=Object.assign({},new_state,{value2_text:"it",value2:"31-3(2)",objectPeople:1,objectPerson:3,text2:res[0],originalText2:res[0],text3:res[2],originalText3:res[2]});}else if(res[1]==='them'){new_state=Object.assign({},new_state,{value2_text:"them all (3+)",value2:"33(2)",objectPeople:3,objectPerson:3,text2:res[0],originalText2:res[0],text3:res[2],originalText3:res[2]});}else if(res[1]==='him'){new_state=Object.assign({},new_state,{value2_text:"him",value2:"31-1(2)",objectPeople:1,objectPerson:3,possessiveObject:false,text2:res[0],originalText2:res[0],text3:res[2],originalText3:res[2]});}else if(res[1]==='her*'){new_state=Object.assign({},new_state,{value2_text:"her",value2:"31-2(2)",objectPeople:1,objectPerson:3,possessiveObject:false,text2:res[0],originalText2:res[0],text3:res[2],originalText3:res[2]});}else if(res[1]==='them'){new_state=Object.assign({},new_state,{value2_text:"them all (3+)",value2:'33(2)',objectPeople:3,objectPerson:3,possessiveObject:false,text2:res[0],originalText2:res[0],text3:res[2],originalText3:res[2]});}else if(res[1]==='its'){//possessive
new_state=Object.assign({},new_state,{value2_text:"its",value2:"31-3(3)",objectPeople:1,objectPerson:3,possessiveObject:true,text2:res[1],originalText2:res[0],text3:res[2],originalText3:res[2]});}else if(res[1]==='his'){//possessive
new_state=Object.assign({},new_state,{value2_text:"his",value2:"31-1(3)",objectPeople:1,objectPerson:3,possessiveObject:true,text2:res[1],originalText2:res[0],text3:res[2],originalText3:res[2]});}else if(res[1]==='her'){//possessive
new_state=Object.assign({},new_state,{value2_text:"her",value2:"31-2(3)",objectPeople:1,objectPerson:3,possessiveObject:true,text2:res[1],originalText2:res[0],text3:res[2],originalText3:res[2]});}}else{new_state=Object.assign({},new_state,{text2:res,originalText2:res});}return new_state;};

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return removeCombos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_constants_js__ = __webpack_require__(68);
var removeCombos=function removeCombos(dict1,dict2,dict3,verb,value1,value2,mood,possessiveObject,objectExists){for(var i=0;i<14;i++){// this portion of the code is meant to remove options that are not possible in subject/object combos
var flag1=false;var flag2=false;if(verb===false){if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]!=='4'){//subject 4th person not allowed
dict1.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].text,disabled:flag2});}dict3.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].text});}else if(mood==='indicative'||mood==='subordinative'){if(value1[0]==='1'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]==='1'||value1[0]==='2'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]==='2'){//process options2 and options3 first
flag1=true;}if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]!=='4'){//object 4th person not allowed
if(possessiveObject){dict2.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].text,disabled:flag1});}else{dict2.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].text,disabled:flag1});}}if(value2[0]==='1'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='1'||value2[0]==='2'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='2'){//process options1 next
flag2=true;}if(mood==='subordinative'){if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]!=='3'){//subject 3rd person not allowed
dict1.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].text,disabled:flag2});}}else{if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]!=='4'){//subject 4th person not allowed
dict1.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].text,disabled:flag2});}}}else if(mood==='optative'){if(value1[0]==='1'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]==='1'||value1[0]==='2'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]==='2'){//process options2 and options3 first
flag1=true;}if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]!=='4'){//object 4th person not allowed
if(possessiveObject){dict2.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].text,disabled:flag1});}else{dict2.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].text,disabled:flag1});}}if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value[0]!=='4'){//object 4th person not allowed for possessive form
dict3.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].text,disabled:flag1});}if(value2[0]==='1'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='1'||value2[0]==='2'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='2'){//process options1 next
flag2=true;}if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]!=='4'){//subject 4th person not allowed
dict1.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].text,disabled:flag2});}}else if(mood==='interrogative'){if(objectExists){if(value1[0]==='1'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]==='1'||value1[0]==='2'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]==='2'){//process options2 and options3 first
flag1=true;}if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]!=='4'){//object 4th person not allowed
if(possessiveObject){dict2.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].text,disabled:flag1});}else{dict2.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].text,disabled:flag1});}}if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value[0]!=='4'){//object 4th person not allowed for possessive form
dict3.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].text,disabled:flag1});}if(value2[0]==='1'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='1'||value2[0]==='2'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='2'||__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='1'){//process options1 next
flag2=true;}if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]!=='4'){//subject 4th person not allowed
dict1.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].text,disabled:flag2});}}else{if(__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]!=='4'){//subject 4th person not allowed
dict1.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].text,disabled:flag2});}}}else{//all connective moods
if(value1[0]==='1'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]==='1'||value1[0]==='2'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]==='2'||value1[0]==='4'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value[0]==='4'){//process options2 and options3 first
flag1=true;}if(possessiveObject){dict2.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].text,disabled:flag1});}else{dict2.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["c" /* options2 */][i].text,disabled:flag1});}dict3.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["d" /* options3 */][i].text,disabled:flag1});if(value2[0]==='1'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='1'||value2[0]==='2'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='2'||value2[0]==='4'&&__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value[0]==='4'){//process options1 next
flag2=true;}dict1.push({id:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].id,value:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].value,text:__WEBPACK_IMPORTED_MODULE_0__constants_constants_js__["b" /* options1 */][i].text,disabled:flag2});}}};

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioWaveform__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_js__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * TTSComponent.
 * Textarea + optional .txt upload -> POST API_URL/tts -> waveform player.
 */var TTSComponent=function(_React$Component){_inherits(TTSComponent,_React$Component);function TTSComponent(props){_classCallCheck(this,TTSComponent);var _this=_possibleConstructorReturn(this,(TTSComponent.__proto__||Object.getPrototypeOf(TTSComponent)).call(this,props));_this.state={text:'',audioUrl:null,loading:false,error:null};_this.fileInputRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.onTextChange=_this.onTextChange.bind(_this);_this.openFilePicker=_this.openFilePicker.bind(_this);_this.loadTextFile=_this.loadTextFile.bind(_this);_this.synthesize=_this.synthesize.bind(_this);return _this;}_createClass(TTSComponent,[{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.state.audioUrl)URL.revokeObjectURL(this.state.audioUrl);}},{key:'onTextChange',value:function onTextChange(e,data){this.setState({text:data.value});}},{key:'openFilePicker',value:function openFilePicker(){this.fileInputRef.current.click();}},{key:'loadTextFile',value:function loadTextFile(e){var _this2=this;var file=e.target.files&&e.target.files[0];if(!file)return;var reader=new FileReader();reader.onload=function(){return _this2.setState({text:String(reader.result)});};reader.onerror=function(){return _this2.setState({error:'Could not read the text file.'});};reader.readAsText(file,'utf-8');e.target.value='';// allow re-selecting the same file
}},{key:'synthesize',value:function synthesize(){var _this3=this;var trimmed=this.state.text.trim();if(!trimmed){this.setState({error:'Enter some text first.'});return;}this.setState({loading:true,error:null});fetch(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+'/tts',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({text:trimmed})}).then(function(r){if(!r.ok){return r.text().then(function(t){throw new Error(t||'Synthesis failed');});}return r.blob();}).then(function(blob){if(_this3.state.audioUrl)URL.revokeObjectURL(_this3.state.audioUrl);_this3.setState({audioUrl:URL.createObjectURL(blob)});}).catch(function(err){return _this3.setState({error:err.message});}).finally(function(){return _this3.setState({loading:false});});}},{key:'render',value:function render(){var _state=this.state,text=_state.text,audioUrl=_state.audioUrl,loading=_state.loading,error=_state.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */],{error:!!error},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["C" /* TextArea */],{value:text,onChange:this.onTextChange,placeholder:'Yugtun text',rows:4}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:12}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{primary:true,loading:loading,disabled:loading,onClick:this.synthesize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'sound'}),' Synthesize'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,onClick:this.openFilePicker},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'file text'}),' Load .txt file'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:this.fileInputRef,type:'file',accept:'.txt,text/plain',style:{display:'none'},onChange:this.loadTextFile})),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["v" /* Message */],{error:true,content:error})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AudioWaveform__["a" /* default */],{src:audioUrl,label:'Synthesized speech'}));}}]);return TTSComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TTSComponent);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioWaveform__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_js__ = __webpack_require__(18);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * ASRComponent.
 * Mic recording or audio file upload -> waveform preview ->
 * POST API_URL/asr -> confidence-colored transcript + downloads.
 *
 */var FORMATS={srt:{mime:'application/x-subrip',ext:'srt'},vtt:{mime:'text/vtt',ext:'vtt'},txt:{mime:'text/plain;charset=utf-8',ext:'txt'}};function confidenceColor(p){if(p==null)return'#999999';if(p>0.8)return'#1a7f37';// high
if(p>0.6)return'#9a6700';// medium
if(p>0.4)return'#bc4c00';// low
return'#cf222e';// very low
}function downloadBlob(content,filename,mime){var blob=new Blob([content],{type:mime});var url=URL.createObjectURL(blob);var a=document.createElement('a');a.href=url;a.download=filename;a.click();URL.revokeObjectURL(url);}function countCues(fmt,s){if(fmt==='srt')return(s.match(/^\d+$/gm)||[]).length;if(fmt==='vtt')return(s.match(/-->/g)||[]).length;return s.split('\n').filter(function(l){return l.trim();}).length;}/* Stateless helper; fine to keep as a function even in a class codebase. */function ConfidenceTranscript(_ref){var segments=_ref.segments;if(!segments||!segments.length)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{attached:'top'},'Transcription (color = confidence)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'1.1em',lineHeight:1.8,padding:8}},segments.map(function(seg,si){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:si,style:{marginBottom:6}},(seg.tokens||[]).map(function(tok,ti){var text=tok.text||'';if(text.indexOf('[_')===0&&text.charAt(text.length-1)===']'){return null;// skip whisper meta tokens like [_BEG_]
}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:ti,title:tok.p!=null?'p='+tok.p.toFixed(3):'',style:{color:confidenceColor(tok.p)}},text);}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'0.8em',color:'#666',padding:'4px 8px'}},'Confidence:',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#1a7f37'}},'\u25A0 high'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#9a6700'}},'\u25A0 medium'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#bc4c00'}},'\u25A0 low'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#cf222e'}},'\u25A0 very low')));}/* Tabbed preview of whichever subtitle formats the server returned. */function SubtitlePreview(_ref2){var outputs=_ref2.outputs,previewFmt=_ref2.previewFmt,onSelect=_ref2.onSelect;var present=Object.keys(FORMATS).filter(function(f){return typeof outputs[f]==='string';});if(!present.length)return null;var fmt=present.indexOf(previewFmt)!==-1?previewFmt:present[0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{attached:'top'},'Subtitle output'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */].Group,{size:'mini',style:{marginBottom:8}},present.map(function(f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{key:f,active:f===fmt,onClick:function onClick(){return onSelect(f);}},f.toUpperCase(),' (',countCues(f,outputs[f]),' ',f==='txt'?'lines':'cues',')');})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('pre',{style:{fontSize:'0.85em',maxHeight:320,overflow:'auto',whiteSpace:'pre-wrap',background:'#f6f8fa',padding:8,borderRadius:4,margin:0}},outputs[fmt]));}var ASRComponent=function(_React$Component){_inherits(ASRComponent,_React$Component);function ASRComponent(props){_classCallCheck(this,ASRComponent);var _this=_possibleConstructorReturn(this,(ASRComponent.__proto__||Object.getPrototypeOf(ASRComponent)).call(this,props));_this.state={recording:false,audioUrl:null,audioName:'recording.webm',segments:null,outputs:null,// full server response (text, segments, srt, vtt, txt)
previewFmt:'srt',loading:false,error:null,// Output options
wantSrt:true,wantVtt:false,wantTxt:false,useMaxLen:false,maxLen:42,splitOnWord:true};_this.audioBlob=null;// not needed for rendering -> not in state
_this.mediaRecorder=null;_this.chunks=[];_this.fileInputRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.startRecording=_this.startRecording.bind(_this);_this.stopRecording=_this.stopRecording.bind(_this);_this.openFilePicker=_this.openFilePicker.bind(_this);_this.onFileChosen=_this.onFileChosen.bind(_this);_this.transcribe=_this.transcribe.bind(_this);_this.downloadTranscript=_this.downloadTranscript.bind(_this);_this.downloadFormat=_this.downloadFormat.bind(_this);_this.toggle=_this.toggle.bind(_this);return _this;}_createClass(ASRComponent,[{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.state.audioUrl)URL.revokeObjectURL(this.state.audioUrl);if(this.mediaRecorder&&this.state.recording)this.mediaRecorder.stop();}},{key:'setAudio',value:function setAudio(blob,name){if(this.state.audioUrl)URL.revokeObjectURL(this.state.audioUrl);this.audioBlob=blob;this.setState({audioUrl:URL.createObjectURL(blob),audioName:name,segments:null,outputs:null,error:null});}},{key:'startRecording',value:function startRecording(){var _this2=this;this.setState({error:null});navigator.mediaDevices.getUserMedia({audio:true}).then(function(stream){var mr=new MediaRecorder(stream);_this2.chunks=[];mr.ondataavailable=function(e){return _this2.chunks.push(e.data);};mr.onstop=function(){stream.getTracks().forEach(function(t){return t.stop();});// release mic
var type=mr.mimeType||'audio/webm';var ext=type.indexOf('mp4')!==-1?'.m4a':'.webm';_this2.setAudio(new Blob(_this2.chunks,{type:type}),'recording'+ext);};mr.start();_this2.mediaRecorder=mr;_this2.setState({recording:true});}).catch(function(){return _this2.setState({error:'Microphone access was denied.'});});}},{key:'stopRecording',value:function stopRecording(){if(this.mediaRecorder)this.mediaRecorder.stop();this.setState({recording:false});}},{key:'openFilePicker',value:function openFilePicker(){this.fileInputRef.current.click();}},{key:'onFileChosen',value:function onFileChosen(e){var file=e.target.files&&e.target.files[0];if(file)this.setAudio(file,file.name);e.target.value='';}},{key:'toggle',value:function toggle(key){this.setState(function(s){return _defineProperty({},key,!s[key]);});}/* Query string for /asr. Returns '' when no options are set, so the
   * request is identical to the pre-v3 behavior. */},{key:'buildQuery',value:function buildQuery(){var _state=this.state,wantSrt=_state.wantSrt,wantVtt=_state.wantVtt,wantTxt=_state.wantTxt,useMaxLen=_state.useMaxLen,maxLen=_state.maxLen,splitOnWord=_state.splitOnWord;var formats=['json'];if(wantSrt)formats.push('srt');if(wantVtt)formats.push('vtt');if(wantTxt)formats.push('txt');var q=new URLSearchParams();if(formats.length>1)q.set('formats',formats.join(','));if(useMaxLen&&parseInt(maxLen,10)>0){q.set('max_line_length',String(parseInt(maxLen,10)));q.set('split_on_word',splitOnWord?'true':'false');}var s=q.toString();return s?'?'+s:'';}},{key:'transcribe',value:function transcribe(){var _this3=this;if(!this.audioBlob){this.setState({error:'Record or upload audio first.'});return;}this.setState({loading:true,error:null});var form=new FormData();form.append('audio',this.audioBlob,this.state.audioName);fetch(__WEBPACK_IMPORTED_MODULE_3__App_js__["a" /* API_URL */]+'/asr'+this.buildQuery(),{method:'POST',body:form}).then(function(r){if(!r.ok){return r.text().then(function(t){throw new Error(t||'Transcription failed');});}return r.json();}).then(function(data){return _this3.setState({segments:data.segments||[],outputs:data});}).catch(function(err){return _this3.setState({error:err.message});}).finally(function(){return _this3.setState({loading:false});});}},{key:'getPlainText',value:function getPlainText(){return(this.state.segments||[]).map(function(s){return s.text||'';}).join('').trim();}},{key:'baseName',value:function baseName(){return(this.state.audioName||'transcript').replace(/\.[^.]+$/,'')||'transcript';}/* Legacy button: unwrapped plain transcript, built client-side. */},{key:'downloadTranscript',value:function downloadTranscript(){downloadBlob(this.getPlainText()+'\n',this.baseName()+'.txt',FORMATS.txt.mime);}},{key:'downloadFormat',value:function downloadFormat(fmt){var content=this.state.outputs&&this.state.outputs[fmt];if(typeof content!=='string')return;downloadBlob(content,this.baseName()+'.'+FORMATS[fmt].ext,FORMATS[fmt].mime);}},{key:'renderOptions',value:function renderOptions(){var _this4=this;var _state2=this.state,wantSrt=_state2.wantSrt,wantVtt=_state2.wantVtt,wantTxt=_state2.wantTxt,useMaxLen=_state2.useMaxLen,maxLen=_state2.maxLen,splitOnWord=_state2.splitOnWord,loading=_state2.loading,recording=_state2.recording;var disabled=loading||recording;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["z" /* Segment */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["q" /* Label */],{attached:'top'},'Output options'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */],{size:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */].Group,{inline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Subtitle formats'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */].Field,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["d" /* Checkbox */],{label:'srt',checked:wantSrt,disabled:disabled,onChange:function onChange(){return _this4.toggle('wantSrt');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */].Field,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["d" /* Checkbox */],{label:'vtt',checked:wantVtt,disabled:disabled,onChange:function onChange(){return _this4.toggle('wantVtt');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */].Field,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["d" /* Checkbox */],{label:'txt',checked:wantTxt,disabled:disabled,onChange:function onChange(){return _this4.toggle('wantTxt');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */].Group,{inline:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */].Field,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["d" /* Checkbox */],{label:'Max line length',checked:useMaxLen,disabled:disabled,onChange:function onChange(){return _this4.toggle('useMaxLen');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */].Field,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["p" /* Input */],{type:'number',min:1,size:'mini',style:{width:80},value:maxLen,disabled:disabled||!useMaxLen,onChange:function onChange(e,_ref4){var value=_ref4.value;return _this4.setState({maxLen:value});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["i" /* Form */].Field,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["d" /* Checkbox */],{label:'Split on word',checked:splitOnWord,disabled:disabled||!useMaxLen,onChange:function onChange(){return _this4.toggle('splitOnWord');}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{fontSize:'0.8em',color:'#666'}},'Wrapping affects only the subtitle outputs; the colored transcript is never changed. Request: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('code',null,'POST /asr',this.buildQuery())));}},{key:'render',value:function render(){var _this5=this;var _state3=this.state,recording=_state3.recording,audioUrl=_state3.audioUrl,audioName=_state3.audioName,segments=_state3.segments,outputs=_state3.outputs,previewFmt=_state3.previewFmt,loading=_state3.loading,error=_state3.error;var present=outputs?Object.keys(FORMATS).filter(function(f){return typeof outputs[f]==='string';}):[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{color:recording?'red':'green',onClick:recording?this.stopRecording:this.startRecording,disabled:loading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:recording?'stop':'microphone'}),recording?'Stop recording':'Record'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,disabled:recording||loading,onClick:this.openFilePicker},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'upload'}),' Upload audio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:this.fileInputRef,type:'file',accept:'audio/*',style:{display:'none'},onChange:this.onFileChosen}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__AudioWaveform__["a" /* default */],{src:audioUrl,label:'Input: '+audioName}),this.renderOptions(),audioUrl&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{primary:true,loading:loading,disabled:loading||recording,onClick:this.transcribe},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'font'}),' Transcribe'),error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["v" /* Message */],{error:true,content:error}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ConfidenceTranscript,{segments:segments}),outputs&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubtitlePreview,{outputs:outputs,previewFmt:previewFmt,onSelect:function onSelect(f){return _this5.setState({previewFmt:f});}}),segments&&segments.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{basic:true,size:'small',onClick:this.downloadTranscript},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'download'}),' Transcript (.txt, unwrapped)'),present.map(function(f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["b" /* Button */],{key:f,basic:true,size:'small',onClick:function onClick(){return _this5.downloadFormat(f);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_semantic_ui_react__["n" /* Icon */],{name:'download'}),' .',FORMATS[f].ext);})));}}]);return ASRComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ASRComponent);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScrollToTop=function(_Component){_inherits(ScrollToTop,_Component);function ScrollToTop(){_classCallCheck(this,ScrollToTop);return _possibleConstructorReturn(this,(ScrollToTop.__proto__||Object.getPrototypeOf(ScrollToTop)).apply(this,arguments));}_createClass(ScrollToTop,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.location!==prevProps.location){window.scrollTo(0,0);}}},{key:'render',value:function render(){return this.props.children;}}]);return ScrollToTop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(ScrollToTop));

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers__ = __webpack_require__(966);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* createStore */])(__WEBPACK_IMPORTED_MODULE_1__reducers__["a" /* default */]));

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__allPostbases__ = __webpack_require__(967);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({allPostbases:__WEBPACK_IMPORTED_MODULE_1__allPostbases__["a" /* default */]}));

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(448);
var initialState={allPostbasesMode:false};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* TOGGLE_ALL_POSTBASES */]:return Object.assign({},state,{allPostbasesMode:!state.allPostbasesMode});default:return state;}});

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(969)('createBrowserHistory');
module.exports = __webpack_require__(970).createBrowserHistory;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(971);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(247)),valueEqual=_interopDefault(__webpack_require__(248));__webpack_require__(249);var invariant=_interopDefault(__webpack_require__(250));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.d4e26861.js